
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc44"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc44"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iBsb3", function(module, exports) {
// data can be any array-like object.  It just needs to support .length, .slice, and an element getter []
function $d8b18a1ad1eb95b5$var$parseMidi(data) {
    var p = new $d8b18a1ad1eb95b5$var$Parser(data);
    var headerChunk = p.readChunk();
    if (headerChunk.id != "MThd") throw "Bad MIDI file.  Expected 'MHdr', got: '" + headerChunk.id + "'";
    var header = $d8b18a1ad1eb95b5$var$parseHeader(headerChunk.data);
    var tracks = [];
    for(var i = 0; !p.eof() && i < header.numTracks; i++){
        var trackChunk = p.readChunk();
        if (trackChunk.id != "MTrk") throw "Bad MIDI file.  Expected 'MTrk', got: '" + trackChunk.id + "'";
        var track = $d8b18a1ad1eb95b5$var$parseTrack(trackChunk.data);
        tracks.push(track);
    }
    return {
        header: header,
        tracks: tracks
    };
}
function $d8b18a1ad1eb95b5$var$parseHeader(data) {
    var p = new $d8b18a1ad1eb95b5$var$Parser(data);
    var format = p.readUInt16();
    var numTracks = p.readUInt16();
    var result = {
        format: format,
        numTracks: numTracks
    };
    var timeDivision = p.readUInt16();
    if (timeDivision & 0x8000) {
        result.framesPerSecond = 0x100 - (timeDivision >> 8);
        result.ticksPerFrame = timeDivision & 0xFF;
    } else result.ticksPerBeat = timeDivision;
    return result;
}
function $d8b18a1ad1eb95b5$var$parseTrack(data) {
    var p = new $d8b18a1ad1eb95b5$var$Parser(data);
    var events = [];
    while(!p.eof()){
        var event = readEvent();
        events.push(event);
    }
    var lastEventTypeByte;
    return events;
    function readEvent() {
        var event = {};
        event.deltaTime = p.readVarInt();
        var eventTypeByte = p.readUInt8();
        if ((eventTypeByte & 0xf0) === 0xf0) {
            // system / meta event
            if (eventTypeByte === 0xff) {
                // meta event
                event.meta = true;
                var metatypeByte = p.readUInt8();
                var length = p.readVarInt();
                switch(metatypeByte){
                    case 0x00:
                        event.type = "sequenceNumber";
                        if (length !== 2) throw "Expected length for sequenceNumber event is 2, got " + length;
                        event.number = p.readUInt16();
                        return event;
                    case 0x01:
                        event.type = "text";
                        event.text = p.readString(length);
                        return event;
                    case 0x02:
                        event.type = "copyrightNotice";
                        event.text = p.readString(length);
                        return event;
                    case 0x03:
                        event.type = "trackName";
                        event.text = p.readString(length);
                        return event;
                    case 0x04:
                        event.type = "instrumentName";
                        event.text = p.readString(length);
                        return event;
                    case 0x05:
                        event.type = "lyrics";
                        event.text = p.readString(length);
                        return event;
                    case 0x06:
                        event.type = "marker";
                        event.text = p.readString(length);
                        return event;
                    case 0x07:
                        event.type = "cuePoint";
                        event.text = p.readString(length);
                        return event;
                    case 0x20:
                        event.type = "channelPrefix";
                        if (length != 1) throw "Expected length for channelPrefix event is 1, got " + length;
                        event.channel = p.readUInt8();
                        return event;
                    case 0x21:
                        event.type = "portPrefix";
                        if (length != 1) throw "Expected length for portPrefix event is 1, got " + length;
                        event.port = p.readUInt8();
                        return event;
                    case 0x2f:
                        event.type = "endOfTrack";
                        if (length != 0) throw "Expected length for endOfTrack event is 0, got " + length;
                        return event;
                    case 0x51:
                        event.type = "setTempo";
                        if (length != 3) throw "Expected length for setTempo event is 3, got " + length;
                        event.microsecondsPerBeat = p.readUInt24();
                        return event;
                    case 0x54:
                        event.type = "smpteOffset";
                        if (length != 5) throw "Expected length for smpteOffset event is 5, got " + length;
                        var hourByte = p.readUInt8();
                        var FRAME_RATES = {
                            0x00: 24,
                            0x20: 25,
                            0x40: 29,
                            0x60: 30
                        };
                        event.frameRate = FRAME_RATES[hourByte & 0x60];
                        event.hour = hourByte & 0x1f;
                        event.min = p.readUInt8();
                        event.sec = p.readUInt8();
                        event.frame = p.readUInt8();
                        event.subFrame = p.readUInt8();
                        return event;
                    case 0x58:
                        event.type = "timeSignature";
                        if (length != 2 && length != 4) throw "Expected length for timeSignature event is 4 or 2, got " + length;
                        event.numerator = p.readUInt8();
                        event.denominator = 1 << p.readUInt8();
                        if (length === 4) {
                            event.metronome = p.readUInt8();
                            event.thirtyseconds = p.readUInt8();
                        } else {
                            event.metronome = 0x24;
                            event.thirtyseconds = 0x08;
                        }
                        return event;
                    case 0x59:
                        event.type = "keySignature";
                        if (length != 2) throw "Expected length for keySignature event is 2, got " + length;
                        event.key = p.readInt8();
                        event.scale = p.readUInt8();
                        return event;
                    case 0x7f:
                        event.type = "sequencerSpecific";
                        event.data = p.readBytes(length);
                        return event;
                    default:
                        event.type = "unknownMeta";
                        event.data = p.readBytes(length);
                        event.metatypeByte = metatypeByte;
                        return event;
                }
            } else if (eventTypeByte == 0xf0) {
                event.type = "sysEx";
                var length = p.readVarInt();
                event.data = p.readBytes(length);
                return event;
            } else if (eventTypeByte == 0xf7) {
                event.type = "endSysEx";
                var length = p.readVarInt();
                event.data = p.readBytes(length);
                return event;
            } else throw "Unrecognised MIDI event type byte: " + eventTypeByte;
        } else {
            // channel event
            var param1;
            if ((eventTypeByte & 0x80) === 0) {
                // running status - reuse lastEventTypeByte as the event type.
                // eventTypeByte is actually the first parameter
                if (lastEventTypeByte === null) throw "Running status byte encountered before status byte";
                param1 = eventTypeByte;
                eventTypeByte = lastEventTypeByte;
                event.running = true;
            } else {
                param1 = p.readUInt8();
                lastEventTypeByte = eventTypeByte;
            }
            var eventType = eventTypeByte >> 4;
            event.channel = eventTypeByte & 0x0f;
            switch(eventType){
                case 0x08:
                    event.type = "noteOff";
                    event.noteNumber = param1;
                    event.velocity = p.readUInt8();
                    return event;
                case 0x09:
                    var velocity = p.readUInt8();
                    event.type = velocity === 0 ? "noteOff" : "noteOn";
                    event.noteNumber = param1;
                    event.velocity = velocity;
                    if (velocity === 0) event.byte9 = true;
                    return event;
                case 0x0a:
                    event.type = "noteAftertouch";
                    event.noteNumber = param1;
                    event.amount = p.readUInt8();
                    return event;
                case 0x0b:
                    event.type = "controller";
                    event.controllerType = param1;
                    event.value = p.readUInt8();
                    return event;
                case 0x0c:
                    event.type = "programChange";
                    event.programNumber = param1;
                    return event;
                case 0x0d:
                    event.type = "channelAftertouch";
                    event.amount = param1;
                    return event;
                case 0x0e:
                    event.type = "pitchBend";
                    event.value = param1 + (p.readUInt8() << 7) - 0x2000;
                    return event;
                default:
                    throw "Unrecognised MIDI event type: " + eventType;
            }
        }
    }
}
function $d8b18a1ad1eb95b5$var$Parser(data) {
    this.buffer = data;
    this.bufferLen = this.buffer.length;
    this.pos = 0;
}
$d8b18a1ad1eb95b5$var$Parser.prototype.eof = function() {
    return this.pos >= this.bufferLen;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readUInt8 = function() {
    var result = this.buffer[this.pos];
    this.pos += 1;
    return result;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readInt8 = function() {
    var u = this.readUInt8();
    if (u & 0x80) return u - 0x100;
    else return u;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readUInt16 = function() {
    var b0 = this.readUInt8(), b1 = this.readUInt8();
    return (b0 << 8) + b1;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readInt16 = function() {
    var u = this.readUInt16();
    if (u & 0x8000) return u - 0x10000;
    else return u;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readUInt24 = function() {
    var b0 = this.readUInt8(), b1 = this.readUInt8(), b2 = this.readUInt8();
    return (b0 << 16) + (b1 << 8) + b2;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readInt24 = function() {
    var u = this.readUInt24();
    if (u & 0x800000) return u - 0x1000000;
    else return u;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readUInt32 = function() {
    var b0 = this.readUInt8(), b1 = this.readUInt8(), b2 = this.readUInt8(), b3 = this.readUInt8();
    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readBytes = function(len) {
    var bytes = this.buffer.slice(this.pos, this.pos + len);
    this.pos += len;
    return bytes;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readString = function(len) {
    var bytes = this.readBytes(len);
    return String.fromCharCode.apply(null, bytes);
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readVarInt = function() {
    var result = 0;
    while(!this.eof()){
        var b = this.readUInt8();
        if (b & 0x80) {
            result += b & 0x7f;
            result <<= 7;
        } else // b is last byte
        return result + b;
    }
    // premature eof
    return result;
};
$d8b18a1ad1eb95b5$var$Parser.prototype.readChunk = function() {
    var id = this.readString(4);
    var length = this.readUInt32();
    var data = this.readBytes(length);
    return {
        id: id,
        length: length,
        data: data
    };
};
module.exports = $d8b18a1ad1eb95b5$var$parseMidi;

});

parcelRegister("ezd6o", function(module, exports) {
// data should be the same type of format returned by parseMidi
// for maximum compatibililty, returns an array of byte values, suitable for conversion to Buffer, Uint8Array, etc.
// opts:
// - running              reuse previous eventTypeByte when possible, to compress file
// - useByte9ForNoteOff   use 0x09 for noteOff when velocity is zero
function $a9ae7f5b8be739be$var$writeMidi(data, opts) {
    if (typeof data !== "object") throw "Invalid MIDI data";
    opts = opts || {};
    var header = data.header || {};
    var tracks = data.tracks || [];
    var i, len = tracks.length;
    var w = new $a9ae7f5b8be739be$var$Writer();
    $a9ae7f5b8be739be$var$writeHeader(w, header, len);
    for(i = 0; i < len; i++)$a9ae7f5b8be739be$var$writeTrack(w, tracks[i], opts);
    return w.buffer;
}
function $a9ae7f5b8be739be$var$writeHeader(w, header, numTracks) {
    var format = header.format == null ? 1 : header.format;
    var timeDivision = 128;
    if (header.timeDivision) timeDivision = header.timeDivision;
    else if (header.ticksPerFrame && header.framesPerSecond) timeDivision = -(header.framesPerSecond & 0xFF) << 8 | header.ticksPerFrame & 0xFF;
    else if (header.ticksPerBeat) timeDivision = header.ticksPerBeat & 0x7FFF;
    var h = new $a9ae7f5b8be739be$var$Writer();
    h.writeUInt16(format);
    h.writeUInt16(numTracks);
    h.writeUInt16(timeDivision);
    w.writeChunk("MThd", h.buffer);
}
function $a9ae7f5b8be739be$var$writeTrack(w, track, opts) {
    var t = new $a9ae7f5b8be739be$var$Writer();
    var i, len = track.length;
    var eventTypeByte = null;
    for(i = 0; i < len; i++){
        // Reuse last eventTypeByte when opts.running is set, or event.running is explicitly set on it.
        // parseMidi will set event.running for each event, so that we can get an exact copy by default.
        // Explicitly set opts.running to false, to override event.running and never reuse last eventTypeByte.
        if (opts.running === false || !opts.running && !track[i].running) eventTypeByte = null;
        eventTypeByte = $a9ae7f5b8be739be$var$writeEvent(t, track[i], eventTypeByte, opts.useByte9ForNoteOff);
    }
    w.writeChunk("MTrk", t.buffer);
}
function $a9ae7f5b8be739be$var$writeEvent(w, event, lastEventTypeByte, useByte9ForNoteOff) {
    var type = event.type;
    var deltaTime = event.deltaTime;
    var text = event.text || "";
    var data = event.data || [];
    var eventTypeByte = null;
    w.writeVarInt(deltaTime);
    switch(type){
        // meta events
        case "sequenceNumber":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x00);
            w.writeVarInt(2);
            w.writeUInt16(event.number);
            break;
        case "text":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x01);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case "copyrightNotice":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x02);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case "trackName":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x03);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case "instrumentName":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x04);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case "lyrics":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x05);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case "marker":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x06);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case "cuePoint":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x07);
            w.writeVarInt(text.length);
            w.writeString(text);
            break;
        case "channelPrefix":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x20);
            w.writeVarInt(1);
            w.writeUInt8(event.channel);
            break;
        case "portPrefix":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x21);
            w.writeVarInt(1);
            w.writeUInt8(event.port);
            break;
        case "endOfTrack":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x2F);
            w.writeVarInt(0);
            break;
        case "setTempo":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x51);
            w.writeVarInt(3);
            w.writeUInt24(event.microsecondsPerBeat);
            break;
        case "smpteOffset":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x54);
            w.writeVarInt(5);
            var FRAME_RATES = {
                24: 0x00,
                25: 0x20,
                29: 0x40,
                30: 0x60
            };
            var hourByte = event.hour & 0x1F | FRAME_RATES[event.frameRate];
            w.writeUInt8(hourByte);
            w.writeUInt8(event.min);
            w.writeUInt8(event.sec);
            w.writeUInt8(event.frame);
            w.writeUInt8(event.subFrame);
            break;
        case "timeSignature":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x58);
            w.writeVarInt(4);
            w.writeUInt8(event.numerator);
            var denominator = Math.floor(Math.log(event.denominator) / Math.LN2) & 0xFF;
            w.writeUInt8(denominator);
            w.writeUInt8(event.metronome);
            w.writeUInt8(event.thirtyseconds || 8);
            break;
        case "keySignature":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x59);
            w.writeVarInt(2);
            w.writeInt8(event.key);
            w.writeUInt8(event.scale);
            break;
        case "sequencerSpecific":
            w.writeUInt8(0xFF);
            w.writeUInt8(0x7F);
            w.writeVarInt(data.length);
            w.writeBytes(data);
            break;
        case "unknownMeta":
            if (event.metatypeByte != null) {
                w.writeUInt8(0xFF);
                w.writeUInt8(event.metatypeByte);
                w.writeVarInt(data.length);
                w.writeBytes(data);
            }
            break;
        // system-exclusive
        case "sysEx":
            w.writeUInt8(0xF0);
            w.writeVarInt(data.length);
            w.writeBytes(data);
            break;
        case "endSysEx":
            w.writeUInt8(0xF7);
            w.writeVarInt(data.length);
            w.writeBytes(data);
            break;
        // channel events
        case "noteOff":
            // Use 0x90 when opts.useByte9ForNoteOff is set and velocity is zero, or when event.byte9 is explicitly set on it.
            // parseMidi will set event.byte9 for each event, so that we can get an exact copy by default.
            // Explicitly set opts.useByte9ForNoteOff to false, to override event.byte9 and always use 0x80 for noteOff events.
            var noteByte = useByte9ForNoteOff !== false && event.byte9 || useByte9ForNoteOff && event.velocity == 0 ? 0x90 : 0x80;
            eventTypeByte = noteByte | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.noteNumber);
            w.writeUInt8(event.velocity);
            break;
        case "noteOn":
            eventTypeByte = 0x90 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.noteNumber);
            w.writeUInt8(event.velocity);
            break;
        case "noteAftertouch":
            eventTypeByte = 0xA0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.noteNumber);
            w.writeUInt8(event.amount);
            break;
        case "controller":
            eventTypeByte = 0xB0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.controllerType);
            w.writeUInt8(event.value);
            break;
        case "programChange":
            eventTypeByte = 0xC0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.programNumber);
            break;
        case "channelAftertouch":
            eventTypeByte = 0xD0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            w.writeUInt8(event.amount);
            break;
        case "pitchBend":
            eventTypeByte = 0xE0 | event.channel;
            if (eventTypeByte !== lastEventTypeByte) w.writeUInt8(eventTypeByte);
            var value14 = 0x2000 + event.value;
            var lsb14 = value14 & 0x7F;
            var msb14 = value14 >> 7 & 0x7F;
            w.writeUInt8(lsb14);
            w.writeUInt8(msb14);
            break;
        default:
            throw "Unrecognized event type: " + type;
    }
    return eventTypeByte;
}
function $a9ae7f5b8be739be$var$Writer() {
    this.buffer = [];
}
$a9ae7f5b8be739be$var$Writer.prototype.writeUInt8 = function(v) {
    this.buffer.push(v & 0xFF);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeInt8 = $a9ae7f5b8be739be$var$Writer.prototype.writeUInt8;
$a9ae7f5b8be739be$var$Writer.prototype.writeUInt16 = function(v) {
    var b0 = v >> 8 & 0xFF, b1 = v & 0xFF;
    this.writeUInt8(b0);
    this.writeUInt8(b1);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeInt16 = $a9ae7f5b8be739be$var$Writer.prototype.writeUInt16;
$a9ae7f5b8be739be$var$Writer.prototype.writeUInt24 = function(v) {
    var b0 = v >> 16 & 0xFF, b1 = v >> 8 & 0xFF, b2 = v & 0xFF;
    this.writeUInt8(b0);
    this.writeUInt8(b1);
    this.writeUInt8(b2);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeInt24 = $a9ae7f5b8be739be$var$Writer.prototype.writeUInt24;
$a9ae7f5b8be739be$var$Writer.prototype.writeUInt32 = function(v) {
    var b0 = v >> 24 & 0xFF, b1 = v >> 16 & 0xFF, b2 = v >> 8 & 0xFF, b3 = v & 0xFF;
    this.writeUInt8(b0);
    this.writeUInt8(b1);
    this.writeUInt8(b2);
    this.writeUInt8(b3);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeInt32 = $a9ae7f5b8be739be$var$Writer.prototype.writeUInt32;
$a9ae7f5b8be739be$var$Writer.prototype.writeBytes = function(arr) {
    this.buffer = this.buffer.concat(Array.prototype.slice.call(arr, 0));
};
$a9ae7f5b8be739be$var$Writer.prototype.writeString = function(str) {
    var i, len = str.length, arr = [];
    for(i = 0; i < len; i++)arr.push(str.codePointAt(i));
    this.writeBytes(arr);
};
$a9ae7f5b8be739be$var$Writer.prototype.writeVarInt = function(v) {
    if (v < 0) throw "Cannot write negative variable-length integer";
    if (v <= 0x7F) this.writeUInt8(v);
    else {
        var i = v;
        var bytes = [];
        bytes.push(i & 0x7F);
        i >>= 7;
        while(i){
            var b = i & 0x7F | 0x80;
            bytes.push(b);
            i >>= 7;
        }
        this.writeBytes(bytes.reverse());
    }
};
$a9ae7f5b8be739be$var$Writer.prototype.writeChunk = function(id, data) {
    this.writeString(id);
    this.writeUInt32(data.length);
    this.writeBytes(data);
};
module.exports = $a9ae7f5b8be739be$var$writeMidi;

});

parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("4oKKP", function(module, exports) {
/**
 * WEBMIDI.js v3.1.6
 * A JavaScript library to kickstart your MIDI projects
 * https://webmidijs.org
 * Build generated on June 4th, 2023.
 *
 * © Copyright 2015-2023, Jean-Philippe Côté.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
class EventEmitter {
    constructor(e11 = !1){
        this.eventMap = {}, this.eventsSuspended = 1 == e11;
    }
    addListener(e11, t11, n11 = {}) {
        if ("string" == typeof e11 && e11.length < 1 || e11 instanceof String && e11.length < 1 || "string" != typeof e11 && !(e11 instanceof String) && e11 !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if ("function" != typeof t11) throw new TypeError("The callback must be a function.");
        const r11 = new Listener(e11, this, t11, n11);
        return this.eventMap[e11] || (this.eventMap[e11] = []), n11.prepend ? this.eventMap[e11].unshift(r11) : this.eventMap[e11].push(r11), r11;
    }
    addOneTimeListener(e11, t11, n11 = {}) {
        n11.remaining = 1, this.addListener(e11, t11, n11);
    }
    static get ANY_EVENT() {
        return Symbol.for("Any event");
    }
    hasListener(e11, t11) {
        if (void 0 === e11) return !!(this.eventMap[EventEmitter.ANY_EVENT] && this.eventMap[EventEmitter.ANY_EVENT].length > 0) || Object.entries(this.eventMap).some(([, e11])=>e11.length > 0);
        if (this.eventMap[e11] && this.eventMap[e11].length > 0) {
            if (t11 instanceof Listener) return this.eventMap[e11].filter((e11)=>e11 === t11).length > 0;
            if ("function" == typeof t11) return this.eventMap[e11].filter((e11)=>e11.callback === t11).length > 0;
            return null == t11;
        }
        return !1;
    }
    get eventNames() {
        return Object.keys(this.eventMap);
    }
    getListeners(e11) {
        return this.eventMap[e11] || [];
    }
    suspendEvent(e11) {
        this.getListeners(e11).forEach((e11)=>{
            e11.suspended = !0;
        });
    }
    unsuspendEvent(e11) {
        this.getListeners(e11).forEach((e11)=>{
            e11.suspended = !1;
        });
    }
    getListenerCount(e11) {
        return this.getListeners(e11).length;
    }
    emit(e11, ...t11) {
        if ("string" != typeof e11 && !(e11 instanceof String)) throw new TypeError("The 'event' parameter must be a string.");
        if (this.eventsSuspended) return;
        let n11 = [], r11 = this.eventMap[EventEmitter.ANY_EVENT] || [];
        return this.eventMap[e11] && (r11 = r11.concat(this.eventMap[e11])), r11.forEach((e11)=>{
            if (e11.suspended) return;
            let r11 = [
                ...t11
            ];
            Array.isArray(e11.arguments) && (r11 = r11.concat(e11.arguments)), e11.remaining > 0 && (n11.push(e11.callback.apply(e11.context, r11)), e11.count++), --e11.remaining < 1 && e11.remove();
        }), n11;
    }
    removeListener(e11, t11, n11 = {}) {
        if (void 0 === e11) return void (this.eventMap = {});
        if (!this.eventMap[e11]) return;
        let r11 = this.eventMap[e11].filter((e11)=>t11 && e11.callback !== t11 || n11.remaining && n11.remaining !== e11.remaining || n11.context && n11.context !== e11.context);
        r11.length ? this.eventMap[e11] = r11 : delete this.eventMap[e11];
    }
    async waitFor(e11, t11 = {}) {
        return t11.duration = parseInt(t11.duration), (isNaN(t11.duration) || t11.duration <= 0) && (t11.duration = 1 / 0), new Promise((n11, r11)=>{
            let i11, s11 = this.addListener(e11, ()=>{
                clearTimeout(i11), n11();
            }, {
                remaining: 1
            });
            t11.duration !== 1 / 0 && (i11 = setTimeout(()=>{
                s11.remove(), r11("The duration expired before the event was emitted.");
            }, t11.duration));
        });
    }
    get eventCount() {
        return Object.keys(this.eventMap).length;
    }
}
class Listener {
    constructor(e11, t11, n11, r11 = {}){
        if ("string" != typeof e11 && !(e11 instanceof String) && e11 !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if (!t11) throw new ReferenceError("The 'target' parameter is mandatory.");
        if ("function" != typeof n11) throw new TypeError("The 'callback' must be a function.");
        void 0 === r11.arguments || Array.isArray(r11.arguments) || (r11.arguments = [
            r11.arguments
        ]), (r11 = Object.assign({
            context: t11,
            remaining: 1 / 0,
            arguments: void 0,
            duration: 1 / 0
        }, r11)).duration !== 1 / 0 && setTimeout(()=>this.remove(), r11.duration), this.arguments = r11.arguments, this.callback = n11, this.context = r11.context, this.count = 0, this.event = e11, this.remaining = parseInt(r11.remaining) >= 1 ? parseInt(r11.remaining) : 1 / 0, this.suspended = !1, this.target = t11;
    }
    remove() {
        this.target.removeListener(this.event, this.callback, {
            context: this.context,
            remaining: this.remaining
        });
    }
}
/**
 * The `Enumerations` class contains enumerations and arrays of elements used throughout the
 * library. All its properties are static and should be referenced using the class name. For
 * example: `Enumerations.CHANNEL_MESSAGES`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Enumerations {
    static get MIDI_CHANNEL_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MESSAGES enum instead."), Enumerations.CHANNEL_MESSAGES;
    }
    static get CHANNEL_MESSAGES() {
        return {
            noteoff: 8,
            noteon: 9,
            keyaftertouch: 10,
            controlchange: 11,
            programchange: 12,
            channelaftertouch: 13,
            pitchbend: 14
        };
    }
    static get CHANNEL_NUMBERS() {
        return [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get MIDI_CHANNEL_NUMBERS() {
        return this.validation && console.warn("The MIDI_CHANNEL_NUMBERS array has been deprecated. Use the Enumerations.CHANNEL_NUMBERS array instead."), [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get CHANNEL_MODE_MESSAGES() {
        return {
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MODE_MESSAGES enum instead."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    static get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been deprecated. Use the Enumerations.CONTROL_CHANGE_MESSAGES array instead."), {
            bankselectcoarse: 0,
            modulationwheelcoarse: 1,
            breathcontrollercoarse: 2,
            controller3: 3,
            footcontrollercoarse: 4,
            portamentotimecoarse: 5,
            dataentrycoarse: 6,
            volumecoarse: 7,
            balancecoarse: 8,
            controller9: 9,
            pancoarse: 10,
            expressioncoarse: 11,
            effectcontrol1coarse: 12,
            effectcontrol2coarse: 13,
            controller14: 14,
            controller15: 15,
            generalpurposeslider1: 16,
            generalpurposeslider2: 17,
            generalpurposeslider3: 18,
            generalpurposeslider4: 19,
            controller20: 20,
            controller21: 21,
            controller22: 22,
            controller23: 23,
            controller24: 24,
            controller25: 25,
            controller26: 26,
            controller27: 27,
            controller28: 28,
            controller29: 29,
            controller30: 30,
            controller31: 31,
            bankselectfine: 32,
            modulationwheelfine: 33,
            breathcontrollerfine: 34,
            controller35: 35,
            footcontrollerfine: 36,
            portamentotimefine: 37,
            dataentryfine: 38,
            volumefine: 39,
            balancefine: 40,
            controller41: 41,
            panfine: 42,
            expressionfine: 43,
            effectcontrol1fine: 44,
            effectcontrol2fine: 45,
            controller46: 46,
            controller47: 47,
            controller48: 48,
            controller49: 49,
            controller50: 50,
            controller51: 51,
            controller52: 52,
            controller53: 53,
            controller54: 54,
            controller55: 55,
            controller56: 56,
            controller57: 57,
            controller58: 58,
            controller59: 59,
            controller60: 60,
            controller61: 61,
            controller62: 62,
            controller63: 63,
            holdpedal: 64,
            portamento: 65,
            sustenutopedal: 66,
            softpedal: 67,
            legatopedal: 68,
            hold2pedal: 69,
            soundvariation: 70,
            resonance: 71,
            soundreleasetime: 72,
            soundattacktime: 73,
            brightness: 74,
            soundcontrol6: 75,
            soundcontrol7: 76,
            soundcontrol8: 77,
            soundcontrol9: 78,
            soundcontrol10: 79,
            generalpurposebutton1: 80,
            generalpurposebutton2: 81,
            generalpurposebutton3: 82,
            generalpurposebutton4: 83,
            controller84: 84,
            controller85: 85,
            controller86: 86,
            controller87: 87,
            controller88: 88,
            controller89: 89,
            controller90: 90,
            reverblevel: 91,
            tremololevel: 92,
            choruslevel: 93,
            celestelevel: 94,
            phaserlevel: 95,
            databuttonincrement: 96,
            databuttondecrement: 97,
            nonregisteredparametercoarse: 98,
            nonregisteredparameterfine: 99,
            registeredparametercoarse: 100,
            registeredparameterfine: 101,
            controller102: 102,
            controller103: 103,
            controller104: 104,
            controller105: 105,
            controller106: 106,
            controller107: 107,
            controller108: 108,
            controller109: 109,
            controller110: 110,
            controller111: 111,
            controller112: 112,
            controller113: 113,
            controller114: 114,
            controller115: 115,
            controller116: 116,
            controller117: 117,
            controller118: 118,
            controller119: 119,
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get CONTROL_CHANGE_MESSAGES() {
        return [
            {
                number: 0,
                name: "bankselectcoarse",
                description: "Bank Select (Coarse)",
                position: "msb"
            },
            {
                number: 1,
                name: "modulationwheelcoarse",
                description: "Modulation Wheel (Coarse)",
                position: "msb"
            },
            {
                number: 2,
                name: "breathcontrollercoarse",
                description: "Breath Controller (Coarse)",
                position: "msb"
            },
            {
                number: 3,
                name: "controller3",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 4,
                name: "footcontrollercoarse",
                description: "Foot Controller (Coarse)",
                position: "msb"
            },
            {
                number: 5,
                name: "portamentotimecoarse",
                description: "Portamento Time (Coarse)",
                position: "msb"
            },
            {
                number: 6,
                name: "dataentrycoarse",
                description: "Data Entry (Coarse)",
                position: "msb"
            },
            {
                number: 7,
                name: "volumecoarse",
                description: "Channel Volume (Coarse)",
                position: "msb"
            },
            {
                number: 8,
                name: "balancecoarse",
                description: "Balance (Coarse)",
                position: "msb"
            },
            {
                number: 9,
                name: "controller9",
                description: "Controller 9 (Coarse)",
                position: "msb"
            },
            {
                number: 10,
                name: "pancoarse",
                description: "Pan (Coarse)",
                position: "msb"
            },
            {
                number: 11,
                name: "expressioncoarse",
                description: "Expression Controller (Coarse)",
                position: "msb"
            },
            {
                number: 12,
                name: "effectcontrol1coarse",
                description: "Effect Control 1 (Coarse)",
                position: "msb"
            },
            {
                number: 13,
                name: "effectcontrol2coarse",
                description: "Effect Control 2 (Coarse)",
                position: "msb"
            },
            {
                number: 14,
                name: "controller14",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 15,
                name: "controller15",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 16,
                name: "generalpurposecontroller1",
                description: "General Purpose Controller 1 (Coarse)",
                position: "msb"
            },
            {
                number: 17,
                name: "generalpurposecontroller2",
                description: "General Purpose Controller 2 (Coarse)",
                position: "msb"
            },
            {
                number: 18,
                name: "generalpurposecontroller3",
                description: "General Purpose Controller 3 (Coarse)",
                position: "msb"
            },
            {
                number: 19,
                name: "generalpurposecontroller4",
                description: "General Purpose Controller 4 (Coarse)",
                position: "msb"
            },
            {
                number: 20,
                name: "controller20",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 21,
                name: "controller21",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 22,
                name: "controller22",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 23,
                name: "controller23",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 24,
                name: "controller24",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 25,
                name: "controller25",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 26,
                name: "controller26",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 27,
                name: "controller27",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 28,
                name: "controller28",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 29,
                name: "controller29",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 30,
                name: "controller30",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 31,
                name: "controller31",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 32,
                name: "bankselectfine",
                description: "Bank Select (Fine)",
                position: "lsb"
            },
            {
                number: 33,
                name: "modulationwheelfine",
                description: "Modulation Wheel (Fine)",
                position: "lsb"
            },
            {
                number: 34,
                name: "breathcontrollerfine",
                description: "Breath Controller (Fine)",
                position: "lsb"
            },
            {
                number: 35,
                name: "controller35",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 36,
                name: "footcontrollerfine",
                description: "Foot Controller (Fine)",
                position: "lsb"
            },
            {
                number: 37,
                name: "portamentotimefine",
                description: "Portamento Time (Fine)",
                position: "lsb"
            },
            {
                number: 38,
                name: "dataentryfine",
                description: "Data Entry (Fine)",
                position: "lsb"
            },
            {
                number: 39,
                name: "channelvolumefine",
                description: "Channel Volume (Fine)",
                position: "lsb"
            },
            {
                number: 40,
                name: "balancefine",
                description: "Balance (Fine)",
                position: "lsb"
            },
            {
                number: 41,
                name: "controller41",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 42,
                name: "panfine",
                description: "Pan (Fine)",
                position: "lsb"
            },
            {
                number: 43,
                name: "expressionfine",
                description: "Expression Controller (Fine)",
                position: "lsb"
            },
            {
                number: 44,
                name: "effectcontrol1fine",
                description: "Effect control 1 (Fine)",
                position: "lsb"
            },
            {
                number: 45,
                name: "effectcontrol2fine",
                description: "Effect control 2 (Fine)",
                position: "lsb"
            },
            {
                number: 46,
                name: "controller46",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 47,
                name: "controller47",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 48,
                name: "controller48",
                description: "General Purpose Controller 1 (Fine)",
                position: "lsb"
            },
            {
                number: 49,
                name: "controller49",
                description: "General Purpose Controller 2 (Fine)",
                position: "lsb"
            },
            {
                number: 50,
                name: "controller50",
                description: "General Purpose Controller 3 (Fine)",
                position: "lsb"
            },
            {
                number: 51,
                name: "controller51",
                description: "General Purpose Controller 4 (Fine)",
                position: "lsb"
            },
            {
                number: 52,
                name: "controller52",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 53,
                name: "controller53",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 54,
                name: "controller54",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 55,
                name: "controller55",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 56,
                name: "controller56",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 57,
                name: "controller57",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 58,
                name: "controller58",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 59,
                name: "controller59",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 60,
                name: "controller60",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 61,
                name: "controller61",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 62,
                name: "controller62",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 63,
                name: "controller63",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 64,
                name: "damperpedal",
                description: "Damper Pedal On/Off"
            },
            {
                number: 65,
                name: "portamento",
                description: "Portamento On/Off"
            },
            {
                number: 66,
                name: "sostenuto",
                description: "Sostenuto On/Off"
            },
            {
                number: 67,
                name: "softpedal",
                description: "Soft Pedal On/Off"
            },
            {
                number: 68,
                name: "legatopedal",
                description: "Legato Pedal On/Off"
            },
            {
                number: 69,
                name: "hold2",
                description: "Hold 2 On/Off"
            },
            {
                number: 70,
                name: "soundvariation",
                description: "Sound Variation",
                position: "lsb"
            },
            {
                number: 71,
                name: "resonance",
                description: "Resonance",
                position: "lsb"
            },
            {
                number: 72,
                name: "releasetime",
                description: "Release Time",
                position: "lsb"
            },
            {
                number: 73,
                name: "attacktime",
                description: "Attack Time",
                position: "lsb"
            },
            {
                number: 74,
                name: "brightness",
                description: "Brightness",
                position: "lsb"
            },
            {
                number: 75,
                name: "decaytime",
                description: "Decay Time",
                position: "lsb"
            },
            {
                number: 76,
                name: "vibratorate",
                description: "Vibrato Rate",
                position: "lsb"
            },
            {
                number: 77,
                name: "vibratodepth",
                description: "Vibrato Depth",
                position: "lsb"
            },
            {
                number: 78,
                name: "vibratodelay",
                description: "Vibrato Delay",
                position: "lsb"
            },
            {
                number: 79,
                name: "controller79",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 80,
                name: "generalpurposecontroller5",
                description: "General Purpose Controller 5",
                position: "lsb"
            },
            {
                number: 81,
                name: "generalpurposecontroller6",
                description: "General Purpose Controller 6",
                position: "lsb"
            },
            {
                number: 82,
                name: "generalpurposecontroller7",
                description: "General Purpose Controller 7",
                position: "lsb"
            },
            {
                number: 83,
                name: "generalpurposecontroller8",
                description: "General Purpose Controller 8",
                position: "lsb"
            },
            {
                number: 84,
                name: "portamentocontrol",
                description: "Portamento Control",
                position: "lsb"
            },
            {
                number: 85,
                name: "controller85",
                description: "Undefined"
            },
            {
                number: 86,
                name: "controller86",
                description: "Undefined"
            },
            {
                number: 87,
                name: "controller87",
                description: "Undefined"
            },
            {
                number: 88,
                name: "highresolutionvelocityprefix",
                description: "High Resolution Velocity Prefix",
                position: "lsb"
            },
            {
                number: 89,
                name: "controller89",
                description: "Undefined"
            },
            {
                number: 90,
                name: "controller90",
                description: "Undefined"
            },
            {
                number: 91,
                name: "effect1depth",
                description: "Effects 1 Depth (Reverb Send Level)"
            },
            {
                number: 92,
                name: "effect2depth",
                description: "Effects 2 Depth"
            },
            {
                number: 93,
                name: "effect3depth",
                description: "Effects 3 Depth (Chorus Send Level)"
            },
            {
                number: 94,
                name: "effect4depth",
                description: "Effects 4 Depth"
            },
            {
                number: 95,
                name: "effect5depth",
                description: "Effects 5 Depth"
            },
            {
                number: 96,
                name: "dataincrement",
                description: "Data Increment"
            },
            {
                number: 97,
                name: "datadecrement",
                description: "Data Decrement"
            },
            {
                number: 98,
                name: "nonregisteredparameterfine",
                description: "Non-Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 99,
                name: "nonregisteredparametercoarse",
                description: "Non-Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 100,
                name: "registeredparameterfine",
                description: "Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 101,
                name: "registeredparametercoarse",
                description: "Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 102,
                name: "controller102",
                description: "Undefined"
            },
            {
                number: 103,
                name: "controller103",
                description: "Undefined"
            },
            {
                number: 104,
                name: "controller104",
                description: "Undefined"
            },
            {
                number: 105,
                name: "controller105",
                description: "Undefined"
            },
            {
                number: 106,
                name: "controller106",
                description: "Undefined"
            },
            {
                number: 107,
                name: "controller107",
                description: "Undefined"
            },
            {
                number: 108,
                name: "controller108",
                description: "Undefined"
            },
            {
                number: 109,
                name: "controller109",
                description: "Undefined"
            },
            {
                number: 110,
                name: "controller110",
                description: "Undefined"
            },
            {
                number: 111,
                name: "controller111",
                description: "Undefined"
            },
            {
                number: 112,
                name: "controller112",
                description: "Undefined"
            },
            {
                number: 113,
                name: "controller113",
                description: "Undefined"
            },
            {
                number: 114,
                name: "controller114",
                description: "Undefined"
            },
            {
                number: 115,
                name: "controller115",
                description: "Undefined"
            },
            {
                number: 116,
                name: "controller116",
                description: "Undefined"
            },
            {
                number: 117,
                name: "controller117",
                description: "Undefined"
            },
            {
                number: 118,
                name: "controller118",
                description: "Undefined"
            },
            {
                number: 119,
                name: "controller119",
                description: "Undefined"
            },
            {
                number: 120,
                name: "allsoundoff",
                description: "All Sound Off"
            },
            {
                number: 121,
                name: "resetallcontrollers",
                description: "Reset All Controllers"
            },
            {
                number: 122,
                name: "localcontrol",
                description: "Local Control On/Off"
            },
            {
                number: 123,
                name: "allnotesoff",
                description: "All Notes Off"
            },
            {
                number: 124,
                name: "omnimodeoff",
                description: "Omni Mode Off"
            },
            {
                number: 125,
                name: "omnimodeon",
                description: "Omni Mode On"
            },
            {
                number: 126,
                name: "monomodeon",
                description: "Mono Mode On"
            },
            {
                number: 127,
                name: "polymodeon",
                description: "Poly Mode On"
            }
        ];
    }
    static get REGISTERED_PARAMETERS() {
        return {
            pitchbendrange: [
                0,
                0
            ],
            channelfinetuning: [
                0,
                1
            ],
            channelcoarsetuning: [
                0,
                2
            ],
            tuningprogram: [
                0,
                3
            ],
            tuningbank: [
                0,
                4
            ],
            modulationrange: [
                0,
                5
            ],
            azimuthangle: [
                61,
                0
            ],
            elevationangle: [
                61,
                1
            ],
            gain: [
                61,
                2
            ],
            distanceratio: [
                61,
                3
            ],
            maximumdistance: [
                61,
                4
            ],
            maximumdistancegain: [
                61,
                5
            ],
            referencedistanceratio: [
                61,
                6
            ],
            panspreadangle: [
                61,
                7
            ],
            rollangle: [
                61,
                8
            ]
        };
    }
    static get MIDI_REGISTERED_PARAMETERS() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETERS enum has been deprecated. Use the Enumerations.REGISTERED_PARAMETERS enum instead."), Enumerations.MIDI_REGISTERED_PARAMETERS;
    }
    static get SYSTEM_MESSAGES() {
        return {
            sysex: 240,
            timecode: 241,
            songposition: 242,
            songselect: 243,
            tunerequest: 246,
            tuningrequest: 246,
            sysexend: 247,
            clock: 248,
            start: 250,
            continue: 251,
            stop: 252,
            activesensing: 254,
            reset: 255,
            midimessage: 0,
            unknownsystemmessage: -1
        };
    }
    static get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been deprecated. Use the Enumerations.SYSTEM_MESSAGES enum instead."), Enumerations.SYSTEM_MESSAGES;
    }
    static get CHANNEL_EVENTS() {
        return [
            "noteoff",
            "controlchange",
            "noteon",
            "keyaftertouch",
            "programchange",
            "channelaftertouch",
            "pitchbend",
            "allnotesoff",
            "allsoundoff",
            "localcontrol",
            "monomode",
            "omnimode",
            "resetallcontrollers",
            "nrpn",
            "nrpn-dataentrycoarse",
            "nrpn-dataentryfine",
            "nrpn-dataincrement",
            "nrpn-datadecrement",
            "rpn",
            "rpn-dataentrycoarse",
            "rpn-dataentryfine",
            "rpn-dataincrement",
            "rpn-datadecrement",
            "nrpn-databuttonincrement",
            "nrpn-databuttondecrement",
            "rpn-databuttonincrement",
            "rpn-databuttondecrement"
        ];
    }
}
/**
 * The `Note` class represents a single musical note such as `"D3"`, `"G#4"`, `"F-1"`, `"Gb7"`, etc.
 *
 * `Note` objects can be played back on a single channel by calling
 * [`OutputChannel.playNote()`]{@link OutputChannel#playNote} or, on multiple channels of the same
 * output, by calling [`Output.playNote()`]{@link Output#playNote}.
 *
 * The note has [`attack`](#attack) and [`release`](#release) velocities set at `0.5` by default.
 * These can be changed by passing in the appropriate option. It is also possible to set a
 * system-wide default for attack and release velocities by using the
 * [`WebMidi.defaults`](WebMidi#defaults) property.
 *
 * If you prefer to work with raw MIDI values (`0` to `127`), you can use [`rawAttack`](#rawAttack) and
 * [`rawRelease`](#rawRelease) to both get and set the values.
 *
 * The note may have a [`duration`](#duration). If it does, playback will be automatically stopped
 * when the duration has elapsed by sending a `"noteoff"` event. By default, the duration is set to
 * `Infinity`. In this case, it will never stop playing unless explicitly stopped by calling a
 * method such as [`OutputChannel.stopNote()`]{@link OutputChannel#stopNote},
 * [`Output.stopNote()`]{@link Output#stopNote} or similar.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Note {
    constructor(e11, t11 = {}){
        this.duration = wm.defaults.note.duration, this.attack = wm.defaults.note.attack, this.release = wm.defaults.note.release, null != t11.duration && (this.duration = t11.duration), null != t11.attack && (this.attack = t11.attack), null != t11.rawAttack && (this.attack = Utilities.from7bitToFloat(t11.rawAttack)), null != t11.release && (this.release = t11.release), null != t11.rawRelease && (this.release = Utilities.from7bitToFloat(t11.rawRelease)), Number.isInteger(e11) ? this.identifier = Utilities.toNoteIdentifier(e11) : this.identifier = e11;
    }
    get identifier() {
        return this._name + (this._accidental || "") + this._octave;
    }
    set identifier(e11) {
        const t11 = Utilities.getNoteDetails(e11);
        if (wm.validation && !e11) throw new Error("Invalid note identifier");
        this._name = t11.name, this._accidental = t11.accidental, this._octave = t11.octave;
    }
    get name() {
        return this._name;
    }
    set name(e11) {
        if (wm.validation && (e11 = e11.toUpperCase(), ![
            "C",
            "D",
            "E",
            "F",
            "G",
            "A",
            "B"
        ].includes(e11))) throw new Error("Invalid name value");
        this._name = e11;
    }
    get accidental() {
        return this._accidental;
    }
    set accidental(e11) {
        if (wm.validation && (e11 = e11.toLowerCase(), ![
            "#",
            "##",
            "b",
            "bb"
        ].includes(e11))) throw new Error("Invalid accidental value");
        this._accidental = e11;
    }
    get octave() {
        return this._octave;
    }
    set octave(e11) {
        if (wm.validation && (e11 = parseInt(e11), isNaN(e11))) throw new Error("Invalid octave value");
        this._octave = e11;
    }
    get duration() {
        return this._duration;
    }
    set duration(e11) {
        if (wm.validation && (e11 = parseFloat(e11), isNaN(e11) || null === e11 || e11 < 0)) throw new RangeError("Invalid duration value.");
        this._duration = e11;
    }
    get attack() {
        return this._attack;
    }
    set attack(e11) {
        if (wm.validation && (e11 = parseFloat(e11), isNaN(e11) || !(e11 >= 0 && e11 <= 1))) throw new RangeError("Invalid attack value.");
        this._attack = e11;
    }
    get release() {
        return this._release;
    }
    set release(e11) {
        if (wm.validation && (e11 = parseFloat(e11), isNaN(e11) || !(e11 >= 0 && e11 <= 1))) throw new RangeError("Invalid release value.");
        this._release = e11;
    }
    get rawAttack() {
        return Utilities.fromFloatTo7Bit(this._attack);
    }
    set rawAttack(e11) {
        this._attack = Utilities.from7bitToFloat(e11);
    }
    get rawRelease() {
        return Utilities.fromFloatTo7Bit(this._release);
    }
    set rawRelease(e11) {
        this._release = Utilities.from7bitToFloat(e11);
    }
    get number() {
        return Utilities.toNoteNumber(this.identifier);
    }
    getOffsetNumber(e11 = 0, t11 = 0) {
        return wm.validation && (e11 = parseInt(e11) || 0, t11 = parseInt(t11) || 0), Math.min(Math.max(this.number + 12 * e11 + t11, 0), 127);
    }
}
/**
 * The `Utilities` class contains general-purpose utility methods. All methods are static and
 * should be called using the class name. For example: `Utilities.getNoteDetails("C4")`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Utilities {
    /**
   * Returns a MIDI note number matching the identifier passed in the form of a string. The
   * identifier must include the octave number. The identifier also optionally include a sharp (#),
   * a double sharp (##), a flat (b) or a double flat (bb) symbol. For example, these are all valid
   * identifiers: C5, G4, D#-1, F0, Gb7, Eb-1, Abb4, B##6, etc.
   *
   * When converting note identifiers to numbers, C4 is considered to be middle C (MIDI note number
   * 60) as per the scientific pitch notation standard.
   *
   * The resulting note number can be offset by using the `octaveOffset` parameter.
   *
   * @param identifier {string} The identifier in the form of a letter, followed by an optional "#",
   * "##", "b" or "bb" followed by the octave number. For exemple: C5, G4, D#-1, F0, Gb7, Eb-1,
   * Abb4, B##6, etc.
   *
   * @param {number} [octaveOffset=0] A integer to offset the octave by.
   *
   * @returns {number} The MIDI note number (an integer between 0 and 127).
   *
   * @throws RangeError Invalid 'octaveOffset' value
   *
   * @throws TypeError Invalid note identifier
   *
   * @license Apache-2.0
   * @since 3.0.0
   * @static
   */ static toNoteNumber(e11, t11 = 0) {
        if (t11 = null == t11 ? 0 : parseInt(t11), isNaN(t11)) throw new RangeError("Invalid 'octaveOffset' value");
        "string" != typeof e11 && (e11 = "");
        const n11 = this.getNoteDetails(e11);
        if (!n11) throw new TypeError("Invalid note identifier");
        let r11 = 12 * (n11.octave + 1 + t11);
        if (r11 += ({
            C: 0,
            D: 2,
            E: 4,
            F: 5,
            G: 7,
            A: 9,
            B: 11
        })[n11.name], n11.accidental && (n11.accidental.startsWith("b") ? r11 -= n11.accidental.length : r11 += n11.accidental.length), r11 < 0 || r11 > 127) throw new RangeError("Invalid octaveOffset value");
        return r11;
    }
    static getNoteDetails(e11) {
        Number.isInteger(e11) && (e11 = this.toNoteIdentifier(e11));
        const t11 = e11.match(/^([CDEFGAB])(#{0,2}|b{0,2})(-?\d+)$/i);
        if (!t11) throw new TypeError("Invalid note identifier");
        const n11 = t11[1].toUpperCase(), r11 = parseInt(t11[3]);
        let i11 = t11[2].toLowerCase();
        i11 = "" === i11 ? void 0 : i11;
        return {
            accidental: i11,
            identifier: n11 + (i11 || "") + r11,
            name: n11,
            octave: r11
        };
    }
    static sanitizeChannels(e11) {
        let t11;
        if (wm.validation) {
            if ("all" === e11) t11 = [
                "all"
            ];
            else if ("none" === e11) return [];
        }
        return t11 = Array.isArray(e11) ? e11 : [
            e11
        ], t11.indexOf("all") > -1 && (t11 = Enumerations.MIDI_CHANNEL_NUMBERS), t11.map(function(e11) {
            return parseInt(e11);
        }).filter(function(e11) {
            return e11 >= 1 && e11 <= 16;
        });
    }
    static toTimestamp(e11) {
        let t11 = !1;
        const n11 = parseFloat(e11);
        return !isNaN(n11) && ("string" == typeof e11 && "+" === e11.substring(0, 1) ? n11 >= 0 && (t11 = wm.time + n11) : n11 >= 0 && (t11 = n11), t11);
    }
    static guessNoteNumber(e11, t11) {
        t11 = parseInt(t11) || 0;
        let n11 = !1;
        if (Number.isInteger(e11) && e11 >= 0 && e11 <= 127) n11 = parseInt(e11);
        else if (parseInt(e11) >= 0 && parseInt(e11) <= 127) n11 = parseInt(e11);
        else if ("string" == typeof e11 || e11 instanceof String) try {
            n11 = this.toNoteNumber(e11.trim(), t11);
        } catch (e11) {
            return !1;
        }
        return n11;
    }
    static toNoteIdentifier(e11, t11) {
        if (e11 = parseInt(e11), isNaN(e11) || e11 < 0 || e11 > 127) throw new RangeError("Invalid note number");
        if (t11 = null == t11 ? 0 : parseInt(t11), isNaN(t11)) throw new RangeError("Invalid octaveOffset value");
        const n11 = Math.floor(e11 / 12 - 1) + t11;
        return [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ][e11 % 12] + n11.toString();
    }
    static buildNote(e11, t11 = {}) {
        if (t11.octaveOffset = parseInt(t11.octaveOffset) || 0, e11 instanceof Note) return e11;
        let n11 = this.guessNoteNumber(e11, t11.octaveOffset);
        if (!1 === n11) throw new TypeError(`The input could not be parsed as a note (${e11})`);
        return t11.octaveOffset = void 0, new Note(n11, t11);
    }
    static buildNoteArray(e11, t11 = {}) {
        let n11 = [];
        return Array.isArray(e11) || (e11 = [
            e11
        ]), e11.forEach((e11)=>{
            n11.push(this.buildNote(e11, t11));
        }), n11;
    }
    static from7bitToFloat(e11) {
        return e11 === 1 / 0 && (e11 = 127), e11 = parseInt(e11) || 0, Math.min(Math.max(e11 / 127, 0), 1);
    }
    static fromFloatTo7Bit(e11) {
        return e11 === 1 / 0 && (e11 = 1), e11 = parseFloat(e11) || 0, Math.min(Math.max(Math.round(127 * e11), 0), 127);
    }
    static fromMsbLsbToFloat(e11, t11 = 0) {
        wm.validation && (e11 = Math.min(Math.max(parseInt(e11) || 0, 0), 127), t11 = Math.min(Math.max(parseInt(t11) || 0, 0), 127));
        const n11 = ((e11 << 7) + t11) / 16383;
        return Math.min(Math.max(n11, 0), 1);
    }
    static fromFloatToMsbLsb(e11) {
        wm.validation && (e11 = Math.min(Math.max(parseFloat(e11) || 0, 0), 1));
        const t11 = Math.round(16383 * e11);
        return {
            msb: t11 >> 7,
            lsb: 127 & t11
        };
    }
    static offsetNumber(e11, t11 = 0, n11 = 0) {
        if (wm.validation) {
            if (e11 = parseInt(e11), isNaN(e11)) throw new Error("Invalid note number");
            t11 = parseInt(t11) || 0, n11 = parseInt(n11) || 0;
        }
        return Math.min(Math.max(e11 + 12 * t11 + n11, 0), 127);
    }
    static getPropertyByValue(e11, t11) {
        return Object.keys(e11).find((n11)=>e11[n11] === t11);
    }
    static getCcNameByNumber(e11) {
        if (!wm.validation || (e11 = parseInt(e11)) >= 0 && e11 <= 127) return Enumerations.CONTROL_CHANGE_MESSAGES[e11].name;
    }
    static getCcNumberByName(e11) {
        let t11 = Enumerations.CONTROL_CHANGE_MESSAGES.find((t11)=>t11.name === e11);
        return t11 ? t11.number : Enumerations.MIDI_CONTROL_CHANGE_MESSAGES[e11];
    }
    static getChannelModeByNumber(e11) {
        if (!(e11 >= 120 && e11 <= 127)) return !1;
        for(let t11 in Enumerations.CHANNEL_MODE_MESSAGES)if (Enumerations.CHANNEL_MODE_MESSAGES.hasOwnProperty(t11) && e11 === Enumerations.CHANNEL_MODE_MESSAGES[t11]) return t11;
        return !1;
    }
    static get isNode() {
        return "undefined" != typeof $hPtJY && null != $hPtJY.versions && null != $hPtJY.versions.node;
    }
    static get isBrowser() {
        return "undefined" != typeof window && void 0 !== window.document;
    }
}
/**
 * The `OutputChannel` class represents a single output MIDI channel. `OutputChannel` objects are
 * provided by an [`Output`](Output) port which, itself, is made available by a device. The
 * `OutputChannel` object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `OutputChannel` objects can be found inside the parent output's
 * [`channels`]{@link Output#channels} property.
 *
 * @param {Output} output The [`Output`](Output) this channel belongs to.
 * @param {number} number The MIDI channel number (`1` - `16`).
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class OutputChannel extends EventEmitter {
    constructor(e11, t11){
        super(), this._output = e11, this._number = t11, this._octaveOffset = 0;
    }
    destroy() {
        this._output = null, this._number = null, this._octaveOffset = 0, this.removeListener();
    }
    send(e11, t11 = {
        time: 0
    }) {
        return this.output.send(e11, t11), this;
    }
    sendKeyAftertouch(e11, t11, n11 = {}) {
        if (wm.validation) {
            if (n11.useRawValue && (n11.rawValue = n11.useRawValue), isNaN(parseFloat(t11))) throw new RangeError("Invalid key aftertouch value.");
            if (n11.rawValue) {
                if (!(t11 >= 0 && t11 <= 127 && Number.isInteger(t11))) throw new RangeError("Key aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(t11 >= 0 && t11 <= 1)) throw new RangeError("Key aftertouch value must be a float between 0 and 1.");
        }
        n11.rawValue || (t11 = Utilities.fromFloatTo7Bit(t11));
        const r11 = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Array.isArray(e11) || (e11 = [
            e11
        ]), Utilities.buildNoteArray(e11).forEach((e11)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.keyaftertouch << 4) + (this.number - 1),
                e11.getOffsetNumber(r11),
                t11
            ], {
                time: Utilities.toTimestamp(n11.time)
            });
        }), this;
    }
    /**
   * Sends a MIDI **control change** message to the channel at the scheduled time. The control
   * change message to send can be specified numerically (`0` to `127`) or by using one of the
   * following common names:
   *
   * | Number | Name                          |
   * |--------|-------------------------------|
   * | 0      |`bankselectcoarse`             |
   * | 1      |`modulationwheelcoarse`        |
   * | 2      |`breathcontrollercoarse`       |
   * | 4      |`footcontrollercoarse`         |
   * | 5      |`portamentotimecoarse`         |
   * | 6      |`dataentrycoarse`              |
   * | 7      |`volumecoarse`                 |
   * | 8      |`balancecoarse`                |
   * | 10     |`pancoarse`                    |
   * | 11     |`expressioncoarse`             |
   * | 12     |`effectcontrol1coarse`         |
   * | 13     |`effectcontrol2coarse`         |
   * | 18     |`generalpurposeslider3`        |
   * | 19     |`generalpurposeslider4`        |
   * | 32     |`bankselectfine`               |
   * | 33     |`modulationwheelfine`          |
   * | 34     |`breathcontrollerfine`         |
   * | 36     |`footcontrollerfine`           |
   * | 37     |`portamentotimefine`           |
   * | 38     |`dataentryfine`                |
   * | 39     |`volumefine`                   |
   * | 40     |`balancefine`                  |
   * | 42     |`panfine`                      |
   * | 43     |`expressionfine`               |
   * | 44     |`effectcontrol1fine`           |
   * | 45     |`effectcontrol2fine`           |
   * | 64     |`holdpedal`                    |
   * | 65     |`portamento`                   |
   * | 66     |`sustenutopedal`               |
   * | 67     |`softpedal`                    |
   * | 68     |`legatopedal`                  |
   * | 69     |`hold2pedal`                   |
   * | 70     |`soundvariation`               |
   * | 71     |`resonance`                    |
   * | 72     |`soundreleasetime`             |
   * | 73     |`soundattacktime`              |
   * | 74     |`brightness`                   |
   * | 75     |`soundcontrol6`                |
   * | 76     |`soundcontrol7`                |
   * | 77     |`soundcontrol8`                |
   * | 78     |`soundcontrol9`                |
   * | 79     |`soundcontrol10`               |
   * | 80     |`generalpurposebutton1`        |
   * | 81     |`generalpurposebutton2`        |
   * | 82     |`generalpurposebutton3`        |
   * | 83     |`generalpurposebutton4`        |
   * | 91     |`reverblevel`                  |
   * | 92     |`tremololevel`                 |
   * | 93     |`choruslevel`                  |
   * | 94     |`celestelevel`                 |
   * | 95     |`phaserlevel`                  |
   * | 96     |`dataincrement`                |
   * | 97     |`datadecrement`                |
   * | 98     |`nonregisteredparametercoarse` |
   * | 99     |`nonregisteredparameterfine`   |
   * | 100    |`registeredparametercoarse`    |
   * | 101    |`registeredparameterfine`      |
   * | 120    |`allsoundoff`                  |
   * | 121    |`resetallcontrollers`          |
   * | 122    |`localcontrol`                 |
   * | 123    |`allnotesoff`                  |
   * | 124    |`omnimodeoff`                  |
   * | 125    |`omnimodeon`                   |
   * | 126    |`monomodeon`                   |
   * | 127    |`polymodeon`                   |
   *
   * As you can see above, not all control change message have a matching name. This does not mean
   * you cannot use the others. It simply means you will need to use their number
   * (`0` to `127`) instead of their name. While you can still use them, numbers `120` to `127` are
   * usually reserved for *channel mode* messages. See
   * [`sendChannelMode()`]{@link OutputChannel#sendChannelMode} method for more info.
   *
   * To view a detailed list of all available **control change** messages, please consult "Table 3 -
   * Control Change Messages" from the [MIDI Messages](
   * https://www.midi.org/specifications/item/table-3-control-change-messages-data-bytes-2)
   * specification.
   *
   * **Note**: messages #0-31 (MSB) are paired with messages #32-63 (LSB). For example, message #1
   * (`modulationwheelcoarse`) can be accompanied by a second control change message for
   * `modulationwheelfine` to achieve a greater level of precision. if you want to specify both MSB
   * and LSB for messages between `0` and `31`, you can do so by passing a 2-value array as the
   * second parameter.
   *
   * @param {number|string} controller The MIDI controller name or number (`0` - `127`).
   *
   * @param {number|number[]} value The value to send (0-127). You can also use a two-position array
   * for controllers 0 to 31. In this scenario, the first value will be sent as usual and the second
   * value will be sent to the matching LSB controller (which is obtained by adding 32 to the first
   * controller)
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} Controller numbers must be between 0 and 127.
   * @throws {RangeError} Invalid controller name.
   * @throws {TypeError} The value array must have a length of 2.
   *
   * @returns {OutputChannel} Returns the `OutputChannel` object so methods can be chained.
   *
   * @license Apache-2.0
   * @since 3.0.0
   */ sendControlChange(e11, t11, n11 = {}) {
        if ("string" == typeof e11 && (e11 = Utilities.getCcNumberByName(e11)), Array.isArray(t11) || (t11 = [
            t11
        ]), wm.validation) {
            if (void 0 === e11) throw new TypeError("Control change must be identified with a valid name or an integer between 0 and 127.");
            if (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127)) throw new TypeError("Control change number must be an integer between 0 and 127.");
            if (2 === (t11 = t11.map((e11)=>{
                const t11 = Math.min(Math.max(parseInt(e11), 0), 127);
                if (isNaN(t11)) throw new TypeError("Values must be integers between 0 and 127");
                return t11;
            })).length && e11 >= 32) throw new TypeError("To use a value array, the controller must be between 0 and 31");
        }
        return t11.forEach((r11, i11)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
                e11 + 32 * i11,
                t11[i11]
            ], {
                time: Utilities.toTimestamp(n11.time)
            });
        }), this;
    }
    _selectNonRegisteredParameter(e11, t11 = {}) {
        return this.sendControlChange(99, e11[0], t11), this.sendControlChange(98, e11[1], t11), this;
    }
    _deselectRegisteredParameter(e11 = {}) {
        return this.sendControlChange(101, 127, e11), this.sendControlChange(100, 127, e11), this;
    }
    _deselectNonRegisteredParameter(e11 = {}) {
        return this.sendControlChange(101, 127, e11), this.sendControlChange(100, 127, e11), this;
    }
    _selectRegisteredParameter(e11, t11 = {}) {
        return this.sendControlChange(101, e11[0], t11), this.sendControlChange(100, e11[1], t11), this;
    }
    _setCurrentParameter(e11, t11 = {}) {
        return e11 = [].concat(e11), this.sendControlChange(6, e11[0], t11), e11.length < 2 || this.sendControlChange(38, e11[1], t11), this;
    }
    sendRpnDecrement(e11, t11 = {}) {
        if (Array.isArray(e11) || (e11 = Enumerations.REGISTERED_PARAMETERS[e11]), wm.validation) {
            if (void 0 === e11) throw new TypeError("The specified registered parameter is invalid.");
            let t11 = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n11)=>{
                Enumerations.REGISTERED_PARAMETERS[n11][0] === e11[0] && Enumerations.REGISTERED_PARAMETERS[n11][1] === e11[1] && (t11 = !0);
            }), !t11) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e11, t11), this.sendControlChange(97, 0, t11), this._deselectRegisteredParameter(t11), this;
    }
    sendRpnIncrement(e11, t11 = {}) {
        if (Array.isArray(e11) || (e11 = Enumerations.REGISTERED_PARAMETERS[e11]), wm.validation) {
            if (void 0 === e11) throw new TypeError("The specified registered parameter is invalid.");
            let t11 = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n11)=>{
                Enumerations.REGISTERED_PARAMETERS[n11][0] === e11[0] && Enumerations.REGISTERED_PARAMETERS[n11][1] === e11[1] && (t11 = !0);
            }), !t11) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e11, t11), this.sendControlChange(96, 0, t11), this._deselectRegisteredParameter(t11), this;
    }
    playNote(e11, t11 = {}) {
        this.sendNoteOn(e11, t11);
        const n11 = Array.isArray(e11) ? e11 : [
            e11
        ];
        for (let e11 of n11)if (parseInt(e11.duration) > 0) {
            const n11 = {
                time: (Utilities.toTimestamp(t11.time) || wm.time) + parseInt(e11.duration),
                release: e11.release,
                rawRelease: e11.rawRelease
            };
            this.sendNoteOff(e11, n11);
        } else if (parseInt(t11.duration) > 0) {
            const n11 = {
                time: (Utilities.toTimestamp(t11.time) || wm.time) + parseInt(t11.duration),
                release: t11.release,
                rawRelease: t11.rawRelease
            };
            this.sendNoteOff(e11, n11);
        }
        return this;
    }
    sendNoteOff(e11, t11 = {}) {
        if (wm.validation) {
            if (null != t11.rawRelease && !(t11.rawRelease >= 0 && t11.rawRelease <= 127)) throw new RangeError("The 'rawRelease' option must be an integer between 0 and 127");
            if (null != t11.release && !(t11.release >= 0 && t11.release <= 1)) throw new RangeError("The 'release' option must be an number between 0 and 1");
            t11.rawVelocity && (t11.rawRelease = t11.velocity, console.warn("The 'rawVelocity' option is deprecated. Use 'rawRelease' instead.")), t11.velocity && (t11.release = t11.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n11 = 64;
        null != t11.rawRelease ? n11 = t11.rawRelease : isNaN(t11.release) || (n11 = Math.round(127 * t11.release));
        const r11 = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e11, {
            rawRelease: parseInt(n11)
        }).forEach((e11)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteoff << 4) + (this.number - 1),
                e11.getOffsetNumber(r11),
                e11.rawRelease
            ], {
                time: Utilities.toTimestamp(t11.time)
            });
        }), this;
    }
    stopNote(e11, t11 = {}) {
        return this.sendNoteOff(e11, t11);
    }
    sendNoteOn(e11, t11 = {}) {
        if (wm.validation) {
            if (null != t11.rawAttack && !(t11.rawAttack >= 0 && t11.rawAttack <= 127)) throw new RangeError("The 'rawAttack' option must be an integer between 0 and 127");
            if (null != t11.attack && !(t11.attack >= 0 && t11.attack <= 1)) throw new RangeError("The 'attack' option must be an number between 0 and 1");
            t11.rawVelocity && (t11.rawAttack = t11.velocity, t11.rawRelease = t11.release, console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' or 'rawRelease'.")), t11.velocity && (t11.attack = t11.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n11 = 64;
        null != t11.rawAttack ? n11 = t11.rawAttack : isNaN(t11.attack) || (n11 = Math.round(127 * t11.attack));
        const r11 = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e11, {
            rawAttack: n11
        }).forEach((e11)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteon << 4) + (this.number - 1),
                e11.getOffsetNumber(r11),
                e11.rawAttack
            ], {
                time: Utilities.toTimestamp(t11.time)
            });
        }), this;
    }
    sendChannelMode(e11, t11 = 0, n11 = {}) {
        if ("string" == typeof e11 && (e11 = Enumerations.CHANNEL_MODE_MESSAGES[e11]), wm.validation) {
            if (void 0 === e11) throw new TypeError("Invalid channel mode message name or number.");
            if (isNaN(e11) || !(e11 >= 120 && e11 <= 127)) throw new TypeError("Invalid channel mode message number.");
            if (isNaN(parseInt(t11)) || t11 < 0 || t11 > 127) throw new RangeError("Value must be an integer between 0 and 127.");
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
            e11,
            t11
        ], {
            time: Utilities.toTimestamp(n11.time)
        }), this;
    }
    sendOmniMode(e11, t11 = {}) {
        return void 0 === e11 || e11 ? this.sendChannelMode("omnimodeon", 0, t11) : this.sendChannelMode("omnimodeoff", 0, t11), this;
    }
    sendChannelAftertouch(e11, t11 = {}) {
        if (wm.validation) {
            if (isNaN(parseFloat(e11))) throw new RangeError("Invalid channel aftertouch value.");
            if (t11.rawValue) {
                if (!(e11 >= 0 && e11 <= 127 && Number.isInteger(e11))) throw new RangeError("Channel aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(e11 >= 0 && e11 <= 1)) throw new RangeError("Channel aftertouch value must be a float between 0 and 1.");
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.channelaftertouch << 4) + (this.number - 1),
            Math.round(127 * e11)
        ], {
            time: Utilities.toTimestamp(t11.time)
        }), this;
    }
    sendMasterTuning(e11, t11 = {}) {
        if (e11 = parseFloat(e11) || 0, wm.validation && !(e11 > -65 && e11 < 64)) throw new RangeError("The value must be a decimal number larger than -65 and smaller than 64.");
        let n11 = Math.floor(e11) + 64, r11 = e11 - Math.floor(e11);
        r11 = Math.round((r11 + 1) / 2 * 16383);
        let i11 = r11 >> 7 & 127, s11 = 127 & r11;
        return this.sendRpnValue("channelcoarsetuning", n11, t11), this.sendRpnValue("channelfinetuning", [
            i11,
            s11
        ], t11), this;
    }
    sendModulationRange(e11, t11, n11 = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!(null == t11 || Number.isInteger(t11) && t11 >= 0 && t11 <= 127)) throw new RangeError("If specified, the cents value must be an integer between 0 and 127.");
        }
        return t11 >= 0 && t11 <= 127 || (t11 = 0), this.sendRpnValue("modulationrange", [
            e11,
            t11
        ], n11), this;
    }
    sendNrpnValue(e11, t11, n11 = {}) {
        if (t11 = [].concat(t11), wm.validation) {
            if (!Array.isArray(e11) || !Number.isInteger(e11[0]) || !Number.isInteger(e11[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e11[0] >= 0 && e11[0] <= 127)) throw new RangeError("The first byte of the NRPN must be between 0 and 127.");
            if (!(e11[1] >= 0 && e11[1] <= 127)) throw new RangeError("The second byte of the NRPN must be between 0 and 127.");
            t11.forEach((e11)=>{
                if (!(e11 >= 0 && e11 <= 127)) throw new RangeError("The data bytes of the NRPN must be between 0 and 127.");
            });
        }
        return this._selectNonRegisteredParameter(e11, n11), this._setCurrentParameter(t11, n11), this._deselectNonRegisteredParameter(n11), this;
    }
    sendPitchBend(e11, t11 = {}) {
        if (wm.validation) {
            if (t11.rawValue && Array.isArray(e11)) {
                if (!(e11[0] >= 0 && e11[0] <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
                if (!(e11[1] >= 0 && e11[1] <= 127)) throw new RangeError("The pitch bend LSB must be an integer between 0 and 127.");
            } else if (t11.rawValue && !Array.isArray(e11)) {
                if (!(e11 >= 0 && e11 <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
            } else {
                if (isNaN(e11) || null === e11) throw new RangeError("Invalid pitch bend value.");
                if (!(e11 >= -1 && e11 <= 1)) throw new RangeError("The pitch bend value must be a float between -1 and 1.");
            }
        }
        let n11 = 0, r11 = 0;
        if (t11.rawValue && Array.isArray(e11)) n11 = e11[0], r11 = e11[1];
        else if (t11.rawValue && !Array.isArray(e11)) n11 = e11;
        else {
            const t11 = Utilities.fromFloatToMsbLsb((e11 + 1) / 2);
            n11 = t11.msb, r11 = t11.lsb;
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.pitchbend << 4) + (this.number - 1),
            r11,
            n11
        ], {
            time: Utilities.toTimestamp(t11.time)
        }), this;
    }
    sendPitchBendRange(e11, t11, n11 = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!Number.isInteger(t11) || !(t11 >= 0 && t11 <= 127)) throw new RangeError("The cents value must be an integer between 0 and 127.");
        }
        return this.sendRpnValue("pitchbendrange", [
            e11,
            t11
        ], n11), this;
    }
    sendProgramChange(e11, t11 = {}) {
        if (e11 = parseInt(e11) || 0, wm.validation && !(e11 >= 0 && e11 <= 127)) throw new RangeError("The program number must be between 0 and 127.");
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.programchange << 4) + (this.number - 1),
            e11
        ], {
            time: Utilities.toTimestamp(t11.time)
        }), this;
    }
    sendRpnValue(e11, t11, n11 = {}) {
        if (Array.isArray(e11) || (e11 = Enumerations.REGISTERED_PARAMETERS[e11]), wm.validation) {
            if (!Number.isInteger(e11[0]) || !Number.isInteger(e11[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e11[0] >= 0 && e11[0] <= 127)) throw new RangeError("The first byte of the RPN must be between 0 and 127.");
            if (!(e11[1] >= 0 && e11[1] <= 127)) throw new RangeError("The second byte of the RPN must be between 0 and 127.");
            [].concat(t11).forEach((e11)=>{
                if (!(e11 >= 0 && e11 <= 127)) throw new RangeError("The data bytes of the RPN must be between 0 and 127.");
            });
        }
        return this._selectRegisteredParameter(e11, n11), this._setCurrentParameter(t11, n11), this._deselectRegisteredParameter(n11), this;
    }
    sendTuningBank(e11, t11 = {}) {
        if (wm.validation && (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127))) throw new RangeError("The tuning bank number must be between 0 and 127.");
        return this.sendRpnValue("tuningbank", e11, t11), this;
    }
    sendTuningProgram(e11, t11 = {}) {
        if (wm.validation && (!Number.isInteger(e11) || !(e11 >= 0 && e11 <= 127))) throw new RangeError("The tuning program number must be between 0 and 127.");
        return this.sendRpnValue("tuningprogram", e11, t11), this;
    }
    sendLocalControl(e11, t11 = {}) {
        return e11 ? this.sendChannelMode("localcontrol", 127, t11) : this.sendChannelMode("localcontrol", 0, t11);
    }
    sendAllNotesOff(e11 = {}) {
        return this.sendChannelMode("allnotesoff", 0, e11);
    }
    sendAllSoundOff(e11 = {}) {
        return this.sendChannelMode("allsoundoff", 0, e11);
    }
    sendResetAllControllers(e11 = {}) {
        return this.sendChannelMode("resetallcontrollers", 0, e11);
    }
    sendPolyphonicMode(e11, t11 = {}) {
        return "mono" === e11 ? this.sendChannelMode("monomodeon", 0, t11) : this.sendChannelMode("polymodeon", 0, t11);
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
    get output() {
        return this._output;
    }
    get number() {
        return this._number;
    }
}
/**
 * The `Output` class represents a single MIDI output port (not to be confused with a MIDI channel).
 * A port is made available by a MIDI device. A MIDI device can advertise several input and output
 * ports. Each port has 16 MIDI channels which can be accessed via the [`channels`](#channels)
 * property.
 *
 * The `Output` object is automatically instantiated by the library according to the host's MIDI
 * subsystem and should not be directly instantiated.
 *
 * You can access all available `Output` objects by referring to the
 * [`WebMidi.outputs`](WebMidi#outputs) array or by using methods such as
 * [`WebMidi.getOutputByName()`](WebMidi#getOutputByName) or
 * [`WebMidi.getOutputById()`](WebMidi#getOutputById).
 *
 * @fires Output#opened
 * @fires Output#disconnected
 * @fires Output#closed
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Output extends EventEmitter {
    constructor(e11){
        super(), this._midiOutput = e11, this._octaveOffset = 0, this.channels = [];
        for(let e11 = 1; e11 <= 16; e11++)this.channels[e11] = new OutputChannel(this, e11);
        this._midiOutput.onstatechange = this._onStateChange.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e11)=>e11.destroy()), this.channels = [], this._midiOutput && (this._midiOutput.onstatechange = null), await this.close(), this._midiOutput = null;
    }
    _onStateChange(e11) {
        let t11 = {
            timestamp: wm.time
        };
        "open" === e11.port.connection ? (t11.type = "opened", t11.target = this, t11.port = t11.target, this.emit("opened", t11)) : "closed" === e11.port.connection && "connected" === e11.port.state ? (t11.type = "closed", t11.target = this, t11.port = t11.target, this.emit("closed", t11)) : "closed" === e11.port.connection && "disconnected" === e11.port.state ? (t11.type = "disconnected", t11.port = {
            connection: e11.port.connection,
            id: e11.port.id,
            manufacturer: e11.port.manufacturer,
            name: e11.port.name,
            state: e11.port.state,
            type: e11.port.type
        }, this.emit("disconnected", t11)) : "pending" === e11.port.connection && "disconnected" === e11.port.state || console.warn("This statechange event was not caught:", e11.port.connection, e11.port.state);
    }
    async open() {
        try {
            return await this._midiOutput.open(), Promise.resolve(this);
        } catch (e11) {
            return Promise.reject(e11);
        }
    }
    async close() {
        this._midiOutput ? await this._midiOutput.close() : await Promise.resolve();
    }
    /**
   * Sends a MIDI message on the MIDI output port. If no time is specified, the message will be
   * sent immediately. The message should be an array of 8 bit unsigned integers (0-225), a
   * [`Uint8Array`]{@link https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array}
   * object or a [`Message`](Message) object.
   *
   * It is usually not necessary to use this method directly as you can use one of the simpler
   * helper methods such as [`playNote()`](#playNote), [`stopNote()`](#stopNote),
   * [`sendControlChange()`](#sendControlChange), etc.
   *
   * Details on the format of MIDI messages are available in the summary of
   * [MIDI messages]{@link https://www.midi.org/specifications-old/item/table-1-summary-of-midi-message}
   * from the MIDI Manufacturers Association.
   *
   * @param message {number[]|Uint8Array|Message} An array of 8bit unsigned integers, a `Uint8Array`
   * object (not available in Node.js) containing the message bytes or a `Message` object.
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} The first byte (status) must be an integer between 128 and 255.
   *
   * @returns {Output} Returns the `Output` object so methods can be chained.
   *
   * @license Apache-2.0
   */ send(e11, t11 = {
        time: 0
    }, n11 = 0) {
        if (e11 instanceof Message && (e11 = Utilities.isNode ? e11.data : e11.rawData), e11 instanceof Uint8Array && Utilities.isNode && (e11 = Array.from(e11)), wm.validation) {
            if (Array.isArray(e11) || e11 instanceof Uint8Array || (e11 = [
                e11
            ], Array.isArray(t11) && (e11 = e11.concat(t11)), t11 = isNaN(n11) ? {
                time: 0
            } : {
                time: n11
            }), !(parseInt(e11[0]) >= 128 && parseInt(e11[0]) <= 255)) throw new RangeError("The first byte (status) must be an integer between 128 and 255.");
            e11.slice(1).forEach((e11)=>{
                if (!((e11 = parseInt(e11)) >= 0 && e11 <= 255)) throw new RangeError("Data bytes must be integers between 0 and 255.");
            }), t11 || (t11 = {
                time: 0
            });
        }
        return this._midiOutput.send(e11, Utilities.toTimestamp(t11.time)), this;
    }
    sendSysex(e11, t11 = [], n11 = {}) {
        if (e11 = [].concat(e11), t11 instanceof Uint8Array) {
            const r11 = new Uint8Array(1 + e11.length + t11.length + 1);
            r11[0] = Enumerations.SYSTEM_MESSAGES.sysex, r11.set(Uint8Array.from(e11), 1), r11.set(t11, 1 + e11.length), r11[r11.length - 1] = Enumerations.SYSTEM_MESSAGES.sysexend, this.send(r11, {
                time: n11.time
            });
        } else {
            const r11 = e11.concat(t11, Enumerations.SYSTEM_MESSAGES.sysexend);
            this.send([
                Enumerations.SYSTEM_MESSAGES.sysex
            ].concat(r11), {
                time: n11.time
            });
        }
        return this;
    }
    clear() {
        return this._midiOutput.clear ? this._midiOutput.clear() : wm.validation && console.warn("The 'clear()' method has not yet been implemented in your environment."), this;
    }
    sendTimecodeQuarterFrame(e11, t11 = {}) {
        if (wm.validation && (e11 = parseInt(e11), isNaN(e11) || !(e11 >= 0 && e11 <= 127))) throw new RangeError("The value must be an integer between 0 and 127.");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.timecode,
            e11
        ], {
            time: t11.time
        }), this;
    }
    sendSongPosition(e11 = 0, t11 = {}) {
        var n11 = (e11 = Math.floor(e11) || 0) >> 7 & 127, r11 = 127 & e11;
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songposition,
            n11,
            r11
        ], {
            time: t11.time
        }), this;
    }
    sendSongSelect(e11 = 0, t11 = {}) {
        if (wm.validation && (e11 = parseInt(e11), isNaN(e11) || !(e11 >= 0 && e11 <= 127))) throw new RangeError("The program value must be between 0 and 127");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songselect,
            e11
        ], {
            time: t11.time
        }), this;
    }
    sendTuneRequest(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.tunerequest
        ], {
            time: e11.time
        }), this;
    }
    sendClock(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.clock
        ], {
            time: e11.time
        }), this;
    }
    sendStart(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.start
        ], {
            time: e11.time
        }), this;
    }
    sendContinue(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.continue
        ], {
            time: e11.time
        }), this;
    }
    sendStop(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.stop
        ], {
            time: e11.time
        }), this;
    }
    sendActiveSensing(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.activesensing
        ], {
            time: e11.time
        }), this;
    }
    sendReset(e11 = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.reset
        ], {
            time: e11.time
        }), this;
    }
    sendTuningRequest(e11 = {}) {
        return wm.validation && console.warn("The sendTuningRequest() method has been deprecated. Use sendTuningRequest() instead."), this.sendTuneRequest(e11);
    }
    sendKeyAftertouch(e11, t11, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendKeyAftertouch(e11, t11, n11);
        }), this;
    }
    sendControlChange(e11, t11, n11 = {}, r11 = {}) {
        if (wm.validation && (Array.isArray(n11) || Number.isInteger(n11) || "all" === n11)) {
            const e11 = n11;
            (n11 = r11).channels = e11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendControlChange(e11, t11, n11);
        }), this;
    }
    sendPitchBendRange(e11 = 0, t11 = 0, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendPitchBendRange(e11, t11, n11);
        }), this;
    }
    setPitchBendRange(e11 = 0, t11 = 0, n11 = "all", r11 = {}) {
        return wm.validation && (console.warn("The setPitchBendRange() method is deprecated. Use sendPitchBendRange() instead."), r11.channels = n11, "all" === r11.channels && (r11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendPitchBendRange(e11, t11, r11);
    }
    sendRpnValue(e11, t11, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendRpnValue(e11, t11, n11);
        }), this;
    }
    setRegisteredParameter(e11, t11 = [], n11 = "all", r11 = {}) {
        return wm.validation && (console.warn("The setRegisteredParameter() method is deprecated. Use sendRpnValue() instead."), r11.channels = n11, "all" === r11.channels && (r11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnValue(e11, t11, r11);
    }
    sendChannelAftertouch(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendChannelAftertouch(e11, t11);
        }), this;
    }
    sendPitchBend(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendPitchBend(e11, t11);
        }), this;
    }
    sendProgramChange(e11 = 0, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendProgramChange(e11, t11);
        }), this;
    }
    sendModulationRange(e11, t11, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendModulationRange(e11, t11, n11);
        }), this;
    }
    setModulationRange(e11 = 0, t11 = 0, n11 = "all", r11 = {}) {
        return wm.validation && (console.warn("The setModulationRange() method is deprecated. Use sendModulationRange() instead."), r11.channels = n11, "all" === r11.channels && (r11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendModulationRange(e11, t11, r11);
    }
    sendMasterTuning(e11, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendMasterTuning(e11, t11);
        }), this;
    }
    setMasterTuning(e11, t11 = {}, n11 = {}) {
        return wm.validation && (console.warn("The setMasterTuning() method is deprecated. Use sendMasterTuning() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendMasterTuning(e11, n11);
    }
    sendTuningProgram(e11, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendTuningProgram(e11, t11);
        }), this;
    }
    setTuningProgram(e11, t11 = "all", n11 = {}) {
        return wm.validation && (console.warn("The setTuningProgram() method is deprecated. Use sendTuningProgram() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningProgram(e11, n11);
    }
    sendTuningBank(e11 = 0, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendTuningBank(e11, t11);
        }), this;
    }
    setTuningBank(e11, t11 = "all", n11 = {}) {
        return wm.validation && (console.warn("The setTuningBank() method is deprecated. Use sendTuningBank() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningBank(e11, n11);
    }
    sendChannelMode(e11, t11 = 0, n11 = {}, r11 = {}) {
        if (wm.validation && (Array.isArray(n11) || Number.isInteger(n11) || "all" === n11)) {
            const e11 = n11;
            (n11 = r11).channels = e11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendChannelMode(e11, t11, n11);
        }), this;
    }
    sendAllSoundOff(e11 = {}) {
        return null == e11.channels && (e11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e11.channels).forEach((t11)=>{
            this.channels[t11].sendAllSoundOff(e11);
        }), this;
    }
    sendAllNotesOff(e11 = {}) {
        return null == e11.channels && (e11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e11.channels).forEach((t11)=>{
            this.channels[t11].sendAllNotesOff(e11);
        }), this;
    }
    sendResetAllControllers(e11 = {}, t11 = {}) {
        if (wm.validation && (Array.isArray(e11) || Number.isInteger(e11) || "all" === e11)) {
            const n11 = e11;
            (e11 = t11).channels = n11, "all" === e11.channels && (e11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == e11.channels && (e11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e11.channels).forEach((t11)=>{
            this.channels[t11].sendResetAllControllers(e11);
        }), this;
    }
    sendPolyphonicMode(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendPolyphonicMode(e11, t11);
        }), this;
    }
    sendLocalControl(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendLocalControl(e11, t11);
        }), this;
    }
    sendOmniMode(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendOmniMode(e11, t11);
        }), this;
    }
    sendNrpnValue(e11, t11, n11 = {}) {
        return null == n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].sendNrpnValue(e11, t11, n11);
        }), this;
    }
    setNonRegisteredParameter(e11, t11 = [], n11 = "all", r11 = {}) {
        return wm.validation && (console.warn("The setNonRegisteredParameter() method is deprecated. Use sendNrpnValue() instead."), r11.channels = n11, "all" === r11.channels && (r11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendNrpnValue(e11, t11, r11);
    }
    sendRpnIncrement(e11, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendRpnIncrement(e11, t11);
        }), this;
    }
    incrementRegisteredParameter(e11, t11 = "all", n11 = {}) {
        return wm.validation && (console.warn("The incrementRegisteredParameter() method is deprecated. Use sendRpnIncrement() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnIncrement(e11, n11);
    }
    sendRpnDecrement(e11, t11 = {}) {
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendRpnDecrement(e11, t11);
        }), this;
    }
    decrementRegisteredParameter(e11, t11 = "all", n11 = {}) {
        return wm.validation && (console.warn("The decrementRegisteredParameter() method is deprecated. Use sendRpnDecrement() instead."), n11.channels = t11, "all" === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnDecrement(e11, n11);
    }
    sendNoteOff(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendNoteOff(e11, t11);
        }), this;
    }
    stopNote(e11, t11) {
        return this.sendNoteOff(e11, t11);
    }
    playNote(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (t11.rawVelocity && console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' instead."), t11.velocity && console.warn("The 'velocity' option is deprecated. Use 'velocity' instead."), Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].playNote(e11, t11);
        }), this;
    }
    sendNoteOn(e11, t11 = {}, n11 = {}) {
        if (wm.validation && (Array.isArray(t11) || Number.isInteger(t11) || "all" === t11)) {
            const e11 = t11;
            (t11 = n11).channels = e11, "all" === t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t11.channels && (t11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t11.channels).forEach((n11)=>{
            this.channels[n11].sendNoteOn(e11, t11);
        }), this;
    }
    get name() {
        return this._midiOutput.name;
    }
    get id() {
        return this._midiOutput.id;
    }
    get connection() {
        return this._midiOutput.connection;
    }
    get manufacturer() {
        return this._midiOutput.manufacturer;
    }
    get state() {
        return this._midiOutput.state;
    }
    get type() {
        return this._midiOutput.type;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
}
/**
 * The `Forwarder` class allows the forwarding of MIDI messages to predetermined outputs. When you
 * call its [`forward()`](#forward) method, it will send the specified [`Message`](Message) object
 * to all the outputs listed in its [`destinations`](#destinations) property.
 *
 * If specific channels or message types have been defined in the [`channels`](#channels) or
 * [`types`](#types) properties, only messages matching the channels/types will be forwarded.
 *
 * While it can be manually instantiated, you are more likely to come across a `Forwarder` object as
 * the return value of the [`Input.addForwarder()`](Input#addForwarder) method.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Forwarder {
    constructor(e11 = [], t11 = {}){
        this.destinations = [], this.types = [
            ...Object.keys(Enumerations.SYSTEM_MESSAGES),
            ...Object.keys(Enumerations.CHANNEL_MESSAGES)
        ], this.channels = Enumerations.MIDI_CHANNEL_NUMBERS, this.suspended = !1, Array.isArray(e11) || (e11 = [
            e11
        ]), t11.types && !Array.isArray(t11.types) && (t11.types = [
            t11.types
        ]), t11.channels && !Array.isArray(t11.channels) && (t11.channels = [
            t11.channels
        ]), wm.validation && (e11.forEach((e11)=>{
            if (!(e11 instanceof Output)) throw new TypeError("Destinations must be of type 'Output'.");
        }), void 0 !== t11.types && t11.types.forEach((e11)=>{
            if (!Enumerations.SYSTEM_MESSAGES.hasOwnProperty(e11) && !Enumerations.CHANNEL_MESSAGES.hasOwnProperty(e11)) throw new TypeError("Type must be a valid message type.");
        }), void 0 !== t11.channels && t11.channels.forEach((e11)=>{
            if (!Enumerations.MIDI_CHANNEL_NUMBERS.includes(e11)) throw new TypeError("MIDI channel must be between 1 and 16.");
        })), this.destinations = e11, t11.types && (this.types = t11.types), t11.channels && (this.channels = t11.channels);
    }
    forward(e11) {
        this.suspended || this.types.includes(e11.type) && (e11.channel && !this.channels.includes(e11.channel) || this.destinations.forEach((t11)=>{
            (!wm.validation || t11 instanceof Output) && t11.send(e11);
        }));
    }
}
/**
 * The `InputChannel` class represents a single MIDI input channel (1-16) from a single input
 * device. This object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `InputChannel` objects can be found inside the input's [`channels`](Input#channels)
 * property.
 *
 * @fires InputChannel#midimessage
 * @fires InputChannel#unknownmessage
 *
 * @fires InputChannel#noteoff
 * @fires InputChannel#noteon
 * @fires InputChannel#keyaftertouch
 * @fires InputChannel#programchange
 * @fires InputChannel#channelaftertouch
 * @fires InputChannel#pitchbend
 *
 * @fires InputChannel#allnotesoff
 * @fires InputChannel#allsoundoff
 * @fires InputChannel#localcontrol
 * @fires InputChannel#monomode
 * @fires InputChannel#omnimode
 * @fires InputChannel#resetallcontrollers
 *
 * @fires InputChannel#event:nrpn
 * @fires InputChannel#event:nrpn-dataentrycoarse
 * @fires InputChannel#event:nrpn-dataentryfine
 * @fires InputChannel#event:nrpn-dataincrement
 * @fires InputChannel#event:nrpn-datadecrement
 * @fires InputChannel#event:rpn
 * @fires InputChannel#event:rpn-dataentrycoarse
 * @fires InputChannel#event:rpn-dataentryfine
 * @fires InputChannel#event:rpn-dataincrement
 * @fires InputChannel#event:rpn-datadecrement
 *
 * @fires InputChannel#controlchange
 * @fires InputChannel#event:controlchange-controllerxxx
 * @fires InputChannel#event:controlchange-bankselectcoarse
 * @fires InputChannel#event:controlchange-modulationwheelcoarse
 * @fires InputChannel#event:controlchange-breathcontrollercoarse
 * @fires InputChannel#event:controlchange-footcontrollercoarse
 * @fires InputChannel#event:controlchange-portamentotimecoarse
 * @fires InputChannel#event:controlchange-dataentrycoarse
 * @fires InputChannel#event:controlchange-volumecoarse
 * @fires InputChannel#event:controlchange-balancecoarse
 * @fires InputChannel#event:controlchange-pancoarse
 * @fires InputChannel#event:controlchange-expressioncoarse
 * @fires InputChannel#event:controlchange-effectcontrol1coarse
 * @fires InputChannel#event:controlchange-effectcontrol2coarse
 * @fires InputChannel#event:controlchange-generalpurposecontroller1
 * @fires InputChannel#event:controlchange-generalpurposecontroller2
 * @fires InputChannel#event:controlchange-generalpurposecontroller3
 * @fires InputChannel#event:controlchange-generalpurposecontroller4
 * @fires InputChannel#event:controlchange-bankselectfine
 * @fires InputChannel#event:controlchange-modulationwheelfine
 * @fires InputChannel#event:controlchange-breathcontrollerfine
 * @fires InputChannel#event:controlchange-footcontrollerfine
 * @fires InputChannel#event:controlchange-portamentotimefine
 * @fires InputChannel#event:controlchange-dataentryfine
 * @fires InputChannel#event:controlchange-channelvolumefine
 * @fires InputChannel#event:controlchange-balancefine
 * @fires InputChannel#event:controlchange-panfine
 * @fires InputChannel#event:controlchange-expressionfine
 * @fires InputChannel#event:controlchange-effectcontrol1fine
 * @fires InputChannel#event:controlchange-effectcontrol2fine
 * @fires InputChannel#event:controlchange-damperpedal
 * @fires InputChannel#event:controlchange-portamento
 * @fires InputChannel#event:controlchange-sostenuto
 * @fires InputChannel#event:controlchange-softpedal
 * @fires InputChannel#event:controlchange-legatopedal
 * @fires InputChannel#event:controlchange-hold2
 * @fires InputChannel#event:controlchange-soundvariation
 * @fires InputChannel#event:controlchange-resonance
 * @fires InputChannel#event:controlchange-releasetime
 * @fires InputChannel#event:controlchange-attacktime
 * @fires InputChannel#event:controlchange-brightness
 * @fires InputChannel#event:controlchange-decaytime
 * @fires InputChannel#event:controlchange-vibratorate
 * @fires InputChannel#event:controlchange-vibratodepth
 * @fires InputChannel#event:controlchange-vibratodelay
 * @fires InputChannel#event:controlchange-generalpurposecontroller5
 * @fires InputChannel#event:controlchange-generalpurposecontroller6
 * @fires InputChannel#event:controlchange-generalpurposecontroller7
 * @fires InputChannel#event:controlchange-generalpurposecontroller8
 * @fires InputChannel#event:controlchange-portamentocontrol
 * @fires InputChannel#event:controlchange-highresolutionvelocityprefix
 * @fires InputChannel#event:controlchange-effect1depth
 * @fires InputChannel#event:controlchange-effect2depth
 * @fires InputChannel#event:controlchange-effect3depth
 * @fires InputChannel#event:controlchange-effect4depth
 * @fires InputChannel#event:controlchange-effect5depth
 * @fires InputChannel#event:controlchange-dataincrement
 * @fires InputChannel#event:controlchange-datadecrement
 * @fires InputChannel#event:controlchange-nonregisteredparameterfine
 * @fires InputChannel#event:controlchange-nonregisteredparametercoarse
 * @fires InputChannel#event:controlchange-registeredparameterfine
 * @fires InputChannel#event:controlchange-registeredparametercoarse
 * @fires InputChannel#event:controlchange-allsoundoff
 * @fires InputChannel#event:controlchange-resetallcontrollers
 * @fires InputChannel#event:controlchange-localcontrol
 * @fires InputChannel#event:controlchange-allnotesoff
 * @fires InputChannel#event:controlchange-omnimodeoff
 * @fires InputChannel#event:controlchange-omnimodeon
 * @fires InputChannel#event:controlchange-monomodeon
 * @fires InputChannel#event:controlchange-polymodeon
 * @fires InputChannel#event:
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class InputChannel extends EventEmitter {
    constructor(e11, t11){
        super(), this._input = e11, this._number = t11, this._octaveOffset = 0, this._nrpnBuffer = [], this._rpnBuffer = [], this.parameterNumberEventsEnabled = !0, this.notesState = new Array(128).fill(!1);
    }
    destroy() {
        this._input = null, this._number = null, this._octaveOffset = 0, this._nrpnBuffer = [], this.notesState = new Array(128).fill(!1), this.parameterNumberEventsEnabled = !1, this.removeListener();
    }
    _processMidiMessageEvent(e11) {
        const t11 = Object.assign({}, e11);
        t11.port = this.input, t11.target = this, t11.type = "midimessage", this.emit(t11.type, t11), this._parseEventForStandardMessages(t11);
    }
    _parseEventForStandardMessages(e11) {
        const t11 = Object.assign({}, e11);
        t11.type = t11.message.type || "unknownmessage";
        const n11 = e11.message.dataBytes[0], r11 = e11.message.dataBytes[1];
        if ("noteoff" === t11.type || "noteon" === t11.type && 0 === r11) this.notesState[n11] = !1, t11.type = "noteoff", t11.note = new Note(Utilities.offsetNumber(n11, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: 0,
            rawRelease: r11
        }), t11.value = Utilities.from7bitToFloat(r11), t11.rawValue = r11, t11.velocity = t11.note.release, t11.rawVelocity = t11.note.rawRelease;
        else if ("noteon" === t11.type) this.notesState[n11] = !0, t11.note = new Note(Utilities.offsetNumber(n11, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: r11
        }), t11.value = Utilities.from7bitToFloat(r11), t11.rawValue = r11, t11.velocity = t11.note.attack, t11.rawVelocity = t11.note.rawAttack;
        else if ("keyaftertouch" === t11.type) t11.note = new Note(Utilities.offsetNumber(n11, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset)), t11.value = Utilities.from7bitToFloat(r11), t11.rawValue = r11, t11.identifier = t11.note.identifier, t11.key = t11.note.number, t11.rawKey = n11;
        else if ("controlchange" === t11.type) {
            t11.controller = {
                number: n11,
                name: Enumerations.CONTROL_CHANGE_MESSAGES[n11].name,
                description: Enumerations.CONTROL_CHANGE_MESSAGES[n11].description,
                position: Enumerations.CONTROL_CHANGE_MESSAGES[n11].position
            }, t11.subtype = t11.controller.name || "controller" + n11, t11.value = Utilities.from7bitToFloat(r11), t11.rawValue = r11;
            const e11 = Object.assign({}, t11);
            e11.type = `${t11.type}-controller${n11}`, delete e11.subtype, this.emit(e11.type, e11);
            const i11 = Object.assign({}, t11);
            i11.type = t11.type + "-" + Enumerations.CONTROL_CHANGE_MESSAGES[n11].name, delete i11.subtype, 0 !== i11.type.indexOf("controller") && this.emit(i11.type, i11), t11.message.dataBytes[0] >= 120 && this._parseChannelModeMessage(t11), this.parameterNumberEventsEnabled && this._isRpnOrNrpnController(t11.message.dataBytes[0]) && this._parseEventForParameterNumber(t11);
        } else "programchange" === t11.type ? (t11.value = n11, t11.rawValue = t11.value) : "channelaftertouch" === t11.type ? (t11.value = Utilities.from7bitToFloat(n11), t11.rawValue = n11) : "pitchbend" === t11.type ? (t11.value = ((r11 << 7) + n11 - 8192) / 8192, t11.rawValue = (r11 << 7) + n11) : t11.type = "unknownmessage";
        this.emit(t11.type, t11);
    }
    _parseChannelModeMessage(e11) {
        const t11 = Object.assign({}, e11);
        t11.type = t11.controller.name, "localcontrol" === t11.type && (t11.value = 127 === t11.message.data[2], t11.rawValue = t11.message.data[2]), "omnimodeon" === t11.type ? (t11.type = "omnimode", t11.value = !0, t11.rawValue = t11.message.data[2]) : "omnimodeoff" === t11.type && (t11.type = "omnimode", t11.value = !1, t11.rawValue = t11.message.data[2]), "monomodeon" === t11.type ? (t11.type = "monomode", t11.value = !0, t11.rawValue = t11.message.data[2]) : "polymodeon" === t11.type && (t11.type = "monomode", t11.value = !1, t11.rawValue = t11.message.data[2]), this.emit(t11.type, t11);
    }
    _parseEventForParameterNumber(e11) {
        const t11 = e11.message.dataBytes[0], n11 = e11.message.dataBytes[1];
        99 === t11 || 101 === t11 ? (this._nrpnBuffer = [], this._rpnBuffer = [], 99 === t11 ? this._nrpnBuffer = [
            e11.message
        ] : 127 !== n11 && (this._rpnBuffer = [
            e11.message
        ])) : 98 === t11 || 100 === t11 ? 98 === t11 ? (this._rpnBuffer = [], 1 === this._nrpnBuffer.length ? this._nrpnBuffer.push(e11.message) : this._nrpnBuffer = []) : (this._nrpnBuffer = [], 1 === this._rpnBuffer.length && 127 !== n11 ? this._rpnBuffer.push(e11.message) : this._rpnBuffer = []) : 6 !== t11 && 38 !== t11 && 96 !== t11 && 97 !== t11 || (2 === this._rpnBuffer.length ? this._dispatchParameterNumberEvent("rpn", this._rpnBuffer[0].dataBytes[1], this._rpnBuffer[1].dataBytes[1], e11) : 2 === this._nrpnBuffer.length ? this._dispatchParameterNumberEvent("nrpn", this._nrpnBuffer[0].dataBytes[1], this._nrpnBuffer[1].dataBytes[1], e11) : (this._nrpnBuffer = [], this._rpnBuffer = []));
    }
    _isRpnOrNrpnController(e11) {
        return 6 === e11 || 38 === e11 || 96 === e11 || 97 === e11 || 98 === e11 || 99 === e11 || 100 === e11 || 101 === e11;
    }
    _dispatchParameterNumberEvent(e11, t11, n11, r11) {
        e11 = "nrpn" === e11 ? "nrpn" : "rpn";
        const i11 = {
            target: r11.target,
            timestamp: r11.timestamp,
            message: r11.message,
            parameterMsb: t11,
            parameterLsb: n11,
            value: Utilities.from7bitToFloat(r11.message.dataBytes[1]),
            rawValue: r11.message.dataBytes[1]
        };
        i11.parameter = "rpn" === e11 ? Object.keys(Enumerations.REGISTERED_PARAMETERS).find((e11)=>Enumerations.REGISTERED_PARAMETERS[e11][0] === t11 && Enumerations.REGISTERED_PARAMETERS[e11][1] === n11) : (t11 << 7) + n11;
        const s11 = Enumerations.CONTROL_CHANGE_MESSAGES[r11.message.dataBytes[0]].name;
        i11.type = `${e11}-${s11}`, this.emit(i11.type, i11);
        const a11 = Object.assign({}, i11);
        "nrpn-dataincrement" === a11.type ? a11.type = "nrpn-databuttonincrement" : "nrpn-datadecrement" === a11.type ? a11.type = "nrpn-databuttondecrement" : "rpn-dataincrement" === a11.type ? a11.type = "rpn-databuttonincrement" : "rpn-datadecrement" === a11.type && (a11.type = "rpn-databuttondecrement"), this.emit(a11.type, a11), i11.type = e11, i11.subtype = s11, this.emit(i11.type, i11);
    }
    getChannelModeByNumber(e11) {
        return wm.validation && (console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class."), e11 = Math.floor(e11)), Utilities.getChannelModeByNumber(e11);
    }
    getCcNameByNumber(e11) {
        if (wm.validation && (console.warn("The 'getCcNameByNumber()' method has been moved to the 'Utilities' class."), !((e11 = parseInt(e11)) >= 0 && e11 <= 127))) throw new RangeError("Invalid control change number.");
        return Utilities.getCcNameByNumber(e11);
    }
    getNoteState(e11) {
        e11 instanceof Note && (e11 = e11.identifier);
        const t11 = Utilities.guessNoteNumber(e11, wm.octaveOffset + this.input.octaveOffset + this.octaveOffset);
        return this.notesState[t11];
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
    get input() {
        return this._input;
    }
    get number() {
        return this._number;
    }
    get nrpnEventsEnabled() {
        return this.parameterNumberEventsEnabled;
    }
    set nrpnEventsEnabled(e11) {
        this.validation && (e11 = !!e11), this.parameterNumberEventsEnabled = e11;
    }
}
/**
 * The `Message` class represents a single MIDI message. It has several properties that make it
 * easy to make sense of the binary data it contains.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Message {
    constructor(e11){
        this.rawData = e11, this.data = Array.from(this.rawData), this.statusByte = this.rawData[0], this.rawDataBytes = this.rawData.slice(1), this.dataBytes = this.data.slice(1), this.isChannelMessage = !1, this.isSystemMessage = !1, this.command = void 0, this.channel = void 0, this.manufacturerId = void 0, this.type = void 0, this.statusByte < 240 ? (this.isChannelMessage = !0, this.command = this.statusByte >> 4, this.channel = 1 + (15 & this.statusByte)) : (this.isSystemMessage = !0, this.command = this.statusByte), this.isChannelMessage ? this.type = Utilities.getPropertyByValue(Enumerations.CHANNEL_MESSAGES, this.command) : this.isSystemMessage && (this.type = Utilities.getPropertyByValue(Enumerations.SYSTEM_MESSAGES, this.command)), this.statusByte === Enumerations.SYSTEM_MESSAGES.sysex && (0 === this.dataBytes[0] ? (this.manufacturerId = this.dataBytes.slice(0, 3), this.dataBytes = this.dataBytes.slice(3, this.rawDataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(3, this.rawDataBytes.length - 1)) : (this.manufacturerId = [
            this.dataBytes[0]
        ], this.dataBytes = this.dataBytes.slice(1, this.dataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(1, this.rawDataBytes.length - 1)));
    }
}
/**
 * The `Input` class represents a single MIDI input port. This object is automatically instantiated
 * by the library according to the host's MIDI subsystem and does not need to be directly
 * instantiated. Instead, you can access all `Input` objects by referring to the
 * [`WebMidi.inputs`](WebMidi#inputs) array. You can also retrieve inputs by using methods such as
 * [`WebMidi.getInputByName()`](WebMidi#getInputByName) and
 * [`WebMidi.getInputById()`](WebMidi#getInputById).
 *
 * Note that a single MIDI device may expose several inputs and/or outputs.
 *
 * **Important**: the `Input` class does not directly fire channel-specific MIDI messages
 * (such as [`noteon`](InputChannel#event:noteon) or
 * [`controlchange`](InputChannel#event:controlchange), etc.). The [`InputChannel`](InputChannel)
 * object does that. However, you can still use the
 * [`Input.addListener()`](#addListener) method to listen to channel-specific events on multiple
 * [`InputChannel`](InputChannel) objects at once.
 *
 * @fires Input#opened
 * @fires Input#disconnected
 * @fires Input#closed
 * @fires Input#midimessage
 *
 * @fires Input#sysex
 * @fires Input#timecode
 * @fires Input#songposition
 * @fires Input#songselect
 * @fires Input#tunerequest
 * @fires Input#clock
 * @fires Input#start
 * @fires Input#continue
 * @fires Input#stop
 * @fires Input#activesensing
 * @fires Input#reset
 *
 * @fires Input#unknownmidimessage
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Input extends EventEmitter {
    constructor(e11){
        super(), this._midiInput = e11, this._octaveOffset = 0, this.channels = [];
        for(let e11 = 1; e11 <= 16; e11++)this.channels[e11] = new InputChannel(this, e11);
        this._forwarders = [], this._midiInput.onstatechange = this._onStateChange.bind(this), this._midiInput.onmidimessage = this._onMidiMessage.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e11)=>e11.destroy()), this.channels = [], this._forwarders = [], this._midiInput && (this._midiInput.onstatechange = null, this._midiInput.onmidimessage = null), await this.close(), this._midiInput = null;
    }
    _onStateChange(e11) {
        let t11 = {
            timestamp: wm.time,
            target: this,
            port: this
        };
        "open" === e11.port.connection ? (t11.type = "opened", this.emit("opened", t11)) : "closed" === e11.port.connection && "connected" === e11.port.state ? (t11.type = "closed", this.emit("closed", t11)) : "closed" === e11.port.connection && "disconnected" === e11.port.state ? (t11.type = "disconnected", t11.port = {
            connection: e11.port.connection,
            id: e11.port.id,
            manufacturer: e11.port.manufacturer,
            name: e11.port.name,
            state: e11.port.state,
            type: e11.port.type
        }, this.emit("disconnected", t11)) : "pending" === e11.port.connection && "disconnected" === e11.port.state || console.warn("This statechange event was not caught: ", e11.port.connection, e11.port.state);
    }
    _onMidiMessage(e11) {
        const t11 = new Message(e11.data), n11 = {
            port: this,
            target: this,
            message: t11,
            timestamp: e11.timeStamp,
            type: "midimessage",
            data: t11.data,
            rawData: t11.data,
            statusByte: t11.data[0],
            dataBytes: t11.dataBytes
        };
        this.emit("midimessage", n11), t11.isSystemMessage ? this._parseEvent(n11) : t11.isChannelMessage && this.channels[t11.channel]._processMidiMessageEvent(n11), this._forwarders.forEach((e11)=>e11.forward(t11));
    }
    _parseEvent(e11) {
        const t11 = Object.assign({}, e11);
        t11.type = t11.message.type || "unknownmidimessage", "songselect" === t11.type && (t11.song = e11.data[1] + 1, t11.value = e11.data[1], t11.rawValue = t11.value), this.emit(t11.type, t11);
    }
    async open() {
        try {
            await this._midiInput.open();
        } catch (e11) {
            return Promise.reject(e11);
        }
        return Promise.resolve(this);
    }
    async close() {
        if (!this._midiInput) return Promise.resolve(this);
        try {
            await this._midiInput.close();
        } catch (e11) {
            return Promise.reject(e11);
        }
        return Promise.resolve(this);
    }
    getChannelModeByNumber() {
        wm.validation && console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class.");
    }
    addListener(e11, t11, n11 = {}) {
        if (wm.validation && "function" == typeof n11) {
            let e11 = null != t11 ? [].concat(t11) : void 0;
            t11 = n11, n11 = {
                channels: e11
            };
        }
        if (Enumerations.CHANNEL_EVENTS.includes(e11)) {
            void 0 === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
            let r11 = [];
            return Utilities.sanitizeChannels(n11.channels).forEach((i11)=>{
                r11.push(this.channels[i11].addListener(e11, t11, n11));
            }), r11;
        }
        return super.addListener(e11, t11, n11);
    }
    addOneTimeListener(e11, t11, n11 = {}) {
        return n11.remaining = 1, this.addListener(e11, t11, n11);
    }
    on(e11, t11, n11, r11) {
        return this.addListener(e11, t11, n11, r11);
    }
    hasListener(e11, t11, n11 = {}) {
        if (wm.validation && "function" == typeof n11) {
            let e11 = [].concat(t11);
            t11 = n11, n11 = {
                channels: e11
            };
        }
        return Enumerations.CHANNEL_EVENTS.includes(e11) ? (void 0 === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n11.channels).every((n11)=>this.channels[n11].hasListener(e11, t11))) : super.hasListener(e11, t11);
    }
    removeListener(e11, t11, n11 = {}) {
        if (wm.validation && "function" == typeof n11) {
            let e11 = [].concat(t11);
            t11 = n11, n11 = {
                channels: e11
            };
        }
        if (void 0 === n11.channels && (n11.channels = Enumerations.MIDI_CHANNEL_NUMBERS), null == e11) return Utilities.sanitizeChannels(n11.channels).forEach((e11)=>{
            this.channels[e11] && this.channels[e11].removeListener();
        }), super.removeListener();
        Enumerations.CHANNEL_EVENTS.includes(e11) ? Utilities.sanitizeChannels(n11.channels).forEach((r11)=>{
            this.channels[r11].removeListener(e11, t11, n11);
        }) : super.removeListener(e11, t11, n11);
    }
    addForwarder(e11, t11 = {}) {
        let n11;
        return n11 = e11 instanceof Forwarder ? e11 : new Forwarder(e11, t11), this._forwarders.push(n11), n11;
    }
    removeForwarder(e11) {
        this._forwarders = this._forwarders.filter((t11)=>t11 !== e11);
    }
    hasForwarder(e11) {
        return this._forwarders.includes(e11);
    }
    get name() {
        return this._midiInput.name;
    }
    get id() {
        return this._midiInput.id;
    }
    get connection() {
        return this._midiInput.connection;
    }
    get manufacturer() {
        return this._midiInput.manufacturer;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
    get state() {
        return this._midiInput.state;
    }
    get type() {
        return this._midiInput.type;
    }
    get nrpnEventsEnabled() {
        return wm.validation && console.warn("The 'nrpnEventsEnabled' property has been moved to the 'InputChannel' class."), !1;
    }
}
if (Utilities.isNode) {
    try {
        window.navigator;
    } catch (err) {
        let jzz;
        eval('jzz = require("jzz")'), $parcel$global.navigator = jzz;
    }
    try {
        performance;
    } catch (err) {
        let performance;
        eval('performance = require("perf_hooks").performance'), $parcel$global.performance = performance;
    }
}
/**
 * The `WebMidi` object makes it easier to work with the low-level Web MIDI API. Basically, it
 * simplifies sending outgoing MIDI messages and reacting to incoming MIDI messages.
 *
 * When using the WebMidi.js library, you should know that the `WebMidi` class has already been
 * instantiated. You cannot instantiate it yourself. If you use the **IIFE** version, you should
 * simply use the global object called `WebMidi`. If you use the **CJS** (CommonJS) or **ESM** (ES6
 * module) version, you get an already-instantiated object when you import the module.
 *
 * @fires WebMidi#connected
 * @fires WebMidi#disabled
 * @fires WebMidi#disconnected
 * @fires WebMidi#enabled
 * @fires WebMidi#error
 * @fires WebMidi#midiaccessgranted
 * @fires WebMidi#portschanged
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class WebMidi extends EventEmitter {
    constructor(){
        super(), this.defaults = {
            note: {
                attack: Utilities.from7bitToFloat(64),
                release: Utilities.from7bitToFloat(64),
                duration: 1 / 0
            }
        }, this.interface = null, this.validation = !0, this._inputs = [], this._disconnectedInputs = [], this._outputs = [], this._disconnectedOutputs = [], this._stateChangeQueue = [], this._octaveOffset = 0;
    }
    async enable(e11 = {}, t11 = !1) {
        if (this.validation = !1 !== e11.validation, this.validation && ("function" == typeof e11 && (e11 = {
            callback: e11,
            sysex: t11
        }), t11 && (e11.sysex = !0)), this.enabled) return "function" == typeof e11.callback && e11.callback(), Promise.resolve();
        const n11 = {
            timestamp: this.time,
            target: this,
            type: "error",
            error: void 0
        }, r11 = {
            timestamp: this.time,
            target: this,
            type: "midiaccessgranted"
        }, i11 = {
            timestamp: this.time,
            target: this,
            type: "enabled"
        };
        try {
            "function" == typeof e11.requestMIDIAccessFunction ? this.interface = await e11.requestMIDIAccessFunction({
                sysex: e11.sysex,
                software: e11.software
            }) : this.interface = await navigator.requestMIDIAccess({
                sysex: e11.sysex,
                software: e11.software
            });
        } catch (t11) {
            return n11.error = t11, this.emit("error", n11), "function" == typeof e11.callback && e11.callback(t11), Promise.reject(t11);
        }
        this.emit("midiaccessgranted", r11), this.interface.onstatechange = this._onInterfaceStateChange.bind(this);
        try {
            await this._updateInputsAndOutputs();
        } catch (t11) {
            return n11.error = t11, this.emit("error", n11), "function" == typeof e11.callback && e11.callback(t11), Promise.reject(t11);
        }
        return this.emit("enabled", i11), "function" == typeof e11.callback && e11.callback(), Promise.resolve(this);
    }
    async disable() {
        return this.interface && (this.interface.onstatechange = void 0), this._destroyInputsAndOutputs().then(()=>{
            navigator && "function" == typeof navigator.close && navigator.close(), this.interface = null;
            let e11 = {
                timestamp: this.time,
                target: this,
                type: "disabled"
            };
            this.emit("disabled", e11), this.removeListener();
        });
    }
    getInputById(e11, t11 = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e11) return;
        }
        if (t11.disconnected) {
            for(let t11 = 0; t11 < this._disconnectedInputs.length; t11++)if (this._disconnectedInputs[t11].id === e11.toString()) return this._disconnectedInputs[t11];
        } else for(let t11 = 0; t11 < this.inputs.length; t11++)if (this.inputs[t11].id === e11.toString()) return this.inputs[t11];
    }
    getInputByName(e11, t11 = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e11) return;
            e11 = e11.toString();
        }
        if (t11.disconnected) {
            for(let t11 = 0; t11 < this._disconnectedInputs.length; t11++)if (~this._disconnectedInputs[t11].name.indexOf(e11)) return this._disconnectedInputs[t11];
        } else for(let t11 = 0; t11 < this.inputs.length; t11++)if (~this.inputs[t11].name.indexOf(e11)) return this.inputs[t11];
    }
    getOutputByName(e11, t11 = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e11) return;
            e11 = e11.toString();
        }
        if (t11.disconnected) {
            for(let t11 = 0; t11 < this._disconnectedOutputs.length; t11++)if (~this._disconnectedOutputs[t11].name.indexOf(e11)) return this._disconnectedOutputs[t11];
        } else for(let t11 = 0; t11 < this.outputs.length; t11++)if (~this.outputs[t11].name.indexOf(e11)) return this.outputs[t11];
    }
    getOutputById(e11, t11 = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e11) return;
        }
        if (t11.disconnected) {
            for(let t11 = 0; t11 < this._disconnectedOutputs.length; t11++)if (this._disconnectedOutputs[t11].id === e11.toString()) return this._disconnectedOutputs[t11];
        } else for(let t11 = 0; t11 < this.outputs.length; t11++)if (this.outputs[t11].id === e11.toString()) return this.outputs[t11];
    }
    noteNameToNumber(e11) {
        return this.validation && console.warn("The noteNameToNumber() method is deprecated. Use Utilities.toNoteNumber() instead."), Utilities.toNoteNumber(e11, this.octaveOffset);
    }
    getOctave(e11) {
        return this.validation && (console.warn("The getOctave()is deprecated. Use Utilities.getNoteDetails() instead"), e11 = parseInt(e11)), !isNaN(e11) && e11 >= 0 && e11 <= 127 && Utilities.getNoteDetails(Utilities.offsetNumber(e11, this.octaveOffset)).octave;
    }
    sanitizeChannels(e11) {
        return this.validation && console.warn("The sanitizeChannels() method has been moved to the utilities class."), Utilities.sanitizeChannels(e11);
    }
    toMIDIChannels(e11) {
        return this.validation && console.warn("The toMIDIChannels() method has been deprecated. Use Utilities.sanitizeChannels() instead."), Utilities.sanitizeChannels(e11);
    }
    guessNoteNumber(e11) {
        return this.validation && console.warn("The guessNoteNumber() method has been deprecated. Use Utilities.guessNoteNumber() instead."), Utilities.guessNoteNumber(e11, this.octaveOffset);
    }
    getValidNoteArray(e11, t11 = {}) {
        return this.validation && console.warn("The getValidNoteArray() method has been moved to the Utilities.buildNoteArray()"), Utilities.buildNoteArray(e11, t11);
    }
    convertToTimestamp(e11) {
        return this.validation && console.warn("The convertToTimestamp() method has been moved to Utilities.toTimestamp()."), Utilities.toTimestamp(e11);
    }
    async _destroyInputsAndOutputs() {
        let e11 = [];
        return this.inputs.forEach((t11)=>e11.push(t11.destroy())), this.outputs.forEach((t11)=>e11.push(t11.destroy())), Promise.all(e11).then(()=>{
            this._inputs = [], this._outputs = [];
        });
    }
    _onInterfaceStateChange(e11) {
        this._updateInputsAndOutputs();
        let t11 = {
            timestamp: e11.timeStamp,
            type: e11.port.state,
            target: this
        };
        if ("connected" === e11.port.state && "open" === e11.port.connection) {
            "output" === e11.port.type ? t11.port = this.getOutputById(e11.port.id) : "input" === e11.port.type && (t11.port = this.getInputById(e11.port.id)), this.emit(e11.port.state, t11);
            const n11 = Object.assign({}, t11);
            n11.type = "portschanged", this.emit(n11.type, n11);
        } else if ("disconnected" === e11.port.state && "pending" === e11.port.connection) {
            "input" === e11.port.type ? t11.port = this.getInputById(e11.port.id, {
                disconnected: !0
            }) : "output" === e11.port.type && (t11.port = this.getOutputById(e11.port.id, {
                disconnected: !0
            })), this.emit(e11.port.state, t11);
            const n11 = Object.assign({}, t11);
            n11.type = "portschanged", this.emit(n11.type, n11);
        }
    }
    async _updateInputsAndOutputs() {
        return Promise.all([
            this._updateInputs(),
            this._updateOutputs()
        ]);
    }
    async _updateInputs() {
        if (!this.interface) return;
        for(let e11 = this._inputs.length - 1; e11 >= 0; e11--){
            const t11 = this._inputs[e11];
            Array.from(this.interface.inputs.values()).find((e11)=>e11 === t11._midiInput) || (this._disconnectedInputs.push(t11), this._inputs.splice(e11, 1));
        }
        let e11 = [];
        return this.interface.inputs.forEach((t11)=>{
            if (!this._inputs.find((e11)=>e11._midiInput === t11)) {
                let n11 = this._disconnectedInputs.find((e11)=>e11._midiInput === t11);
                n11 || (n11 = new Input(t11)), this._inputs.push(n11), e11.push(n11.open());
            }
        }), Promise.all(e11);
    }
    async _updateOutputs() {
        if (!this.interface) return;
        for(let e11 = this._outputs.length - 1; e11 >= 0; e11--){
            const t11 = this._outputs[e11];
            Array.from(this.interface.outputs.values()).find((e11)=>e11 === t11._midiOutput) || (this._disconnectedOutputs.push(t11), this._outputs.splice(e11, 1));
        }
        let e11 = [];
        return this.interface.outputs.forEach((t11)=>{
            if (!this._outputs.find((e11)=>e11._midiOutput === t11)) {
                let n11 = this._disconnectedOutputs.find((e11)=>e11._midiOutput === t11);
                n11 || (n11 = new Output(t11)), this._outputs.push(n11), e11.push(n11.open());
            }
        }), Promise.all(e11);
    }
    get enabled() {
        return null !== this.interface;
    }
    get inputs() {
        return this._inputs;
    }
    get isNode() {
        return this.validation && console.warn("WebMidi.isNode has been deprecated. Use Utilities.isNode instead."), Utilities.isNode;
    }
    get isBrowser() {
        return this.validation && console.warn("WebMidi.isBrowser has been deprecated. Use Utilities.isBrowser instead."), Utilities.isBrowser;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e11) {
        if (this.validation && (e11 = parseInt(e11), isNaN(e11))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e11;
    }
    get outputs() {
        return this._outputs;
    }
    get supported() {
        return "undefined" != typeof navigator && navigator.requestMIDIAccess;
    }
    get sysexEnabled() {
        return !(!this.interface || !this.interface.sysexEnabled);
    }
    get time() {
        return performance.now();
    }
    get version() {
        return "3.1.6";
    }
    get flavour() {
        return "cjs";
    }
    get CHANNEL_EVENTS() {
        return this.validation && console.warn("The CHANNEL_EVENTS enum has been moved to Enumerations.CHANNEL_EVENTS."), Enumerations.CHANNEL_EVENTS;
    }
    get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been moved to Enumerations.SYSTEM_MESSAGES."), Enumerations.SYSTEM_MESSAGES;
    }
    get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been moved to Enumerations.CHANNEL_MODE_MESSAGES."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been replaced by the Enumerations.CONTROL_CHANGE_MESSAGES array."), Enumerations.MIDI_CONTROL_CHANGE_MESSAGES;
    }
    get MIDI_REGISTERED_PARAMETER() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETER enum has been moved to Enumerations.REGISTERED_PARAMETERS."), Enumerations.REGISTERED_PARAMETERS;
    }
    get NOTES() {
        return this.validation && console.warn("The NOTES enum has been deprecated."), [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ];
    }
}
const wm = new WebMidi;
wm.constructor = null, exports.Enumerations = Enumerations, exports.Forwarder = Forwarder, exports.Input = Input, exports.InputChannel = InputChannel, exports.Message = Message, exports.Note = Note, exports.Output = Output, exports.OutputChannel = OutputChannel, exports.Utilities = Utilities, exports.WebMidi = wm;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("lw8Mu", function(module, exports) {
module.exports = new URL("closed-hihat_1.c3598e64.mp3", import.meta.url).toString();

});

parcelRegister("1NuFb", function(module, exports) {
module.exports = new URL("closed-hihat_2.df9c6d68.mp3", import.meta.url).toString();

});

parcelRegister("e3CPn", function(module, exports) {
module.exports = new URL("closed-hihat_3.2e25a9fb.mp3", import.meta.url).toString();

});

parcelRegister("j8xcP", function(module, exports) {
module.exports = new URL("closed-hihat_4.546f9296.mp3", import.meta.url).toString();

});

parcelRegister("dfk0E", function(module, exports) {
module.exports = new URL("closed-hihat_5.84f49b25.mp3", import.meta.url).toString();

});

parcelRegister("1WnZU", function(module, exports) {
module.exports = new URL("closed-hihat_6.583c3a3d.mp3", import.meta.url).toString();

});

parcelRegister("1ITJB", function(module, exports) {
module.exports = new URL("closed-hihat_7.769c6d06.mp3", import.meta.url).toString();

});

parcelRegister("570Mo", function(module, exports) {
module.exports = new URL("closed-hihat_8.6911f924.mp3", import.meta.url).toString();

});

parcelRegister("amPri", function(module, exports) {
module.exports = new URL("closed-hihat_9.8e0b0ab6.mp3", import.meta.url).toString();

});

parcelRegister("fAaYz", function(module, exports) {
module.exports = new URL("closed-hihat_10.51d068e3.mp3", import.meta.url).toString();

});

parcelRegister("fPRLW", function(module, exports) {
module.exports = new URL("closed-hihat_11.8cabb786.mp3", import.meta.url).toString();

});

parcelRegister("kwhgF", function(module, exports) {
module.exports = new URL("closed-hihat_12.b1e4a2bf.mp3", import.meta.url).toString();

});

parcelRegister("e0iWv", function(module, exports) {
module.exports = new URL("open-hihat_1.1fa9c461.mp3", import.meta.url).toString();

});

parcelRegister("l6Y43", function(module, exports) {
module.exports = new URL("open-hihat_2.2f935a0f.mp3", import.meta.url).toString();

});

parcelRegister("fBSj4", function(module, exports) {
module.exports = new URL("open-hihat_3.ed4ec909.mp3", import.meta.url).toString();

});

parcelRegister("ajKwd", function(module, exports) {
module.exports = new URL("open-hihat_4.5364cb46.mp3", import.meta.url).toString();

});

parcelRegister("ck7JE", function(module, exports) {
module.exports = new URL("open-hihat_5.14edd338.mp3", import.meta.url).toString();

});

parcelRegister("hnHVd", function(module, exports) {
module.exports = new URL("open-hihat_6.0efdc832.mp3", import.meta.url).toString();

});

parcelRegister("aA3m4", function(module, exports) {
module.exports = new URL("open-hihat_7.f7c80852.mp3", import.meta.url).toString();

});

parcelRegister("8a69x", function(module, exports) {
module.exports = new URL("open-hihat_8.e6bbdeff.mp3", import.meta.url).toString();

});

parcelRegister("dqHjm", function(module, exports) {
module.exports = new URL("open-hihat_9.ce51d058.mp3", import.meta.url).toString();

});

parcelRegister("jnTsG", function(module, exports) {
module.exports = new URL("open-hihat_10.4ec7a4eb.mp3", import.meta.url).toString();

});

parcelRegister("c1zb3", function(module, exports) {
module.exports = new URL("open-hihat_11.0bc90e96.mp3", import.meta.url).toString();

});

parcelRegister("26IF6", function(module, exports) {
module.exports = new URL("open-hihat_12.a95c984b.mp3", import.meta.url).toString();

});

parcelRegister("lbiIu", function(module, exports) {
module.exports = new URL("crash_1.6aa3010b.mp3", import.meta.url).toString();

});

parcelRegister("2NGyf", function(module, exports) {
module.exports = new URL("crash_2.ad19f12b.mp3", import.meta.url).toString();

});

parcelRegister("lABIk", function(module, exports) {
module.exports = new URL("crash_3.8ba5b29e.mp3", import.meta.url).toString();

});

parcelRegister("3iUw5", function(module, exports) {
module.exports = new URL("crash_4.a17a8a67.mp3", import.meta.url).toString();

});

parcelRegister("274PA", function(module, exports) {
module.exports = new URL("crash_5.8b1d5604.mp3", import.meta.url).toString();

});

parcelRegister("7ehjG", function(module, exports) {
module.exports = new URL("crash_6.9dcf9ed6.mp3", import.meta.url).toString();

});

parcelRegister("9N1z7", function(module, exports) {
module.exports = new URL("crash_7.6a40b51c.mp3", import.meta.url).toString();

});

parcelRegister("71k2j", function(module, exports) {
module.exports = new URL("crash_8.99d0fd8d.mp3", import.meta.url).toString();

});

parcelRegister("5Pvi2", function(module, exports) {
module.exports = new URL("crash_9.4b8594d9.mp3", import.meta.url).toString();

});

parcelRegister("2RFd4", function(module, exports) {
module.exports = new URL("crash_10.0d7efbff.mp3", import.meta.url).toString();

});

parcelRegister("1eKy2", function(module, exports) {
module.exports = new URL("crash_11.cd2e80a9.mp3", import.meta.url).toString();

});

parcelRegister("8YECZ", function(module, exports) {
module.exports = new URL("crash_12.4ad8210f.mp3", import.meta.url).toString();

});

parcelRegister("5SxuK", function(module, exports) {
module.exports = new URL("ride_1.b04f8857.mp3", import.meta.url).toString();

});

parcelRegister("ldQTA", function(module, exports) {
module.exports = new URL("ride_2.1e254981.mp3", import.meta.url).toString();

});

parcelRegister("f6Cx3", function(module, exports) {
module.exports = new URL("ride_3.506fe573.mp3", import.meta.url).toString();

});

parcelRegister("dWpbb", function(module, exports) {
module.exports = new URL("ride_4.f8c46940.mp3", import.meta.url).toString();

});

parcelRegister("hhn9f", function(module, exports) {
module.exports = new URL("ride_5.9eedc3c5.mp3", import.meta.url).toString();

});

parcelRegister("ZdGiJ", function(module, exports) {
module.exports = new URL("ride_6.6119b558.mp3", import.meta.url).toString();

});

parcelRegister("j9z4h", function(module, exports) {
module.exports = new URL("ride_7.05f04bb8.mp3", import.meta.url).toString();

});

parcelRegister("kiJCK", function(module, exports) {
module.exports = new URL("ride_8.e0a39ea5.mp3", import.meta.url).toString();

});

parcelRegister("272cE", function(module, exports) {
module.exports = new URL("ride_9.b606a5a3.mp3", import.meta.url).toString();

});

parcelRegister("bTlbG", function(module, exports) {
module.exports = new URL("ride_10.c4914e82.mp3", import.meta.url).toString();

});

parcelRegister("6CR9H", function(module, exports) {
module.exports = new URL("ride_11.657bdea3.mp3", import.meta.url).toString();

});

parcelRegister("1Ltew", function(module, exports) {
module.exports = new URL("ride_12.b86f4115.mp3", import.meta.url).toString();

});

parcelRegister("6bXMG", function(module, exports) {
module.exports = new URL("kick_1.6d75be8e.mp3", import.meta.url).toString();

});

parcelRegister("1v8uQ", function(module, exports) {
module.exports = new URL("kick_2.eef489eb.mp3", import.meta.url).toString();

});

parcelRegister("1gWYQ", function(module, exports) {
module.exports = new URL("kick_3.d59afb9a.mp3", import.meta.url).toString();

});

parcelRegister("7GIzt", function(module, exports) {
module.exports = new URL("kick_4.b6aa1d5a.mp3", import.meta.url).toString();

});

parcelRegister("46MCu", function(module, exports) {
module.exports = new URL("kick_5.5a4a1577.mp3", import.meta.url).toString();

});

parcelRegister("56E5k", function(module, exports) {
module.exports = new URL("kick_6.1b1aa317.mp3", import.meta.url).toString();

});

parcelRegister("2nfIT", function(module, exports) {
module.exports = new URL("kick_7.0e6a60bd.mp3", import.meta.url).toString();

});

parcelRegister("1vINS", function(module, exports) {
module.exports = new URL("kick_8.a6e6cb22.mp3", import.meta.url).toString();

});

parcelRegister("feiA7", function(module, exports) {
module.exports = new URL("kick_9.e90f0f7b.mp3", import.meta.url).toString();

});

parcelRegister("aQbil", function(module, exports) {
module.exports = new URL("kick_10.2508647b.mp3", import.meta.url).toString();

});

parcelRegister("624Hq", function(module, exports) {
module.exports = new URL("kick_11.ca60b639.mp3", import.meta.url).toString();

});

parcelRegister("fYSwK", function(module, exports) {
module.exports = new URL("kick_12.183b69d7.mp3", import.meta.url).toString();

});

parcelRegister("awcGy", function(module, exports) {
module.exports = new URL("snare_1.5e9b43b5.mp3", import.meta.url).toString();

});

parcelRegister("3sfcn", function(module, exports) {
module.exports = new URL("snare_2.673c28c6.mp3", import.meta.url).toString();

});

parcelRegister("9KbLN", function(module, exports) {
module.exports = new URL("snare_3.3b5c10f7.mp3", import.meta.url).toString();

});

parcelRegister("bSyUS", function(module, exports) {
module.exports = new URL("snare_4.54b1f023.mp3", import.meta.url).toString();

});

parcelRegister("8KIwk", function(module, exports) {
module.exports = new URL("snare_5.81e6e076.mp3", import.meta.url).toString();

});

parcelRegister("kdpRC", function(module, exports) {
module.exports = new URL("snare_6.109bef8f.mp3", import.meta.url).toString();

});

parcelRegister("hjY08", function(module, exports) {
module.exports = new URL("snare_7.a258b319.mp3", import.meta.url).toString();

});

parcelRegister("eM6M7", function(module, exports) {
module.exports = new URL("snare_8.57c5e497.mp3", import.meta.url).toString();

});

parcelRegister("1SKcy", function(module, exports) {
module.exports = new URL("snare_9.3d8c9482.mp3", import.meta.url).toString();

});

parcelRegister("j9hxR", function(module, exports) {
module.exports = new URL("snare_10.b2b762b9.mp3", import.meta.url).toString();

});

parcelRegister("2NXPr", function(module, exports) {
module.exports = new URL("snare_11.64dc3f03.mp3", import.meta.url).toString();

});

parcelRegister("gAz4G", function(module, exports) {
module.exports = new URL("snare_12.7da1f5d8.mp3", import.meta.url).toString();

});

parcelRegister("aD9Um", function(module, exports) {
module.exports = new URL("hi-tom_1.ded5f514.mp3", import.meta.url).toString();

});

parcelRegister("7IHL8", function(module, exports) {
module.exports = new URL("hi-tom_2.8574ea96.mp3", import.meta.url).toString();

});

parcelRegister("lhP3B", function(module, exports) {
module.exports = new URL("hi-tom_3.9438c9df.mp3", import.meta.url).toString();

});

parcelRegister("kqdlv", function(module, exports) {
module.exports = new URL("hi-tom_4.928d7f59.mp3", import.meta.url).toString();

});

parcelRegister("5YpTq", function(module, exports) {
module.exports = new URL("hi-tom_5.a339ccb1.mp3", import.meta.url).toString();

});

parcelRegister("9d0yB", function(module, exports) {
module.exports = new URL("hi-tom_6.94994fbe.mp3", import.meta.url).toString();

});

parcelRegister("d38YH", function(module, exports) {
module.exports = new URL("hi-tom_7.ee3ea907.mp3", import.meta.url).toString();

});

parcelRegister("hF6rJ", function(module, exports) {
module.exports = new URL("hi-tom_8.38b2f80d.mp3", import.meta.url).toString();

});

parcelRegister("iQi5z", function(module, exports) {
module.exports = new URL("hi-tom_9.5a2cd443.mp3", import.meta.url).toString();

});

parcelRegister("ifCLN", function(module, exports) {
module.exports = new URL("hi-tom_10.dba10a8d.mp3", import.meta.url).toString();

});

parcelRegister("iRvZv", function(module, exports) {
module.exports = new URL("hi-tom_11.de67cef1.mp3", import.meta.url).toString();

});

parcelRegister("75iiO", function(module, exports) {
module.exports = new URL("hi-tom_12.f5d60938.mp3", import.meta.url).toString();

});

parcelRegister("6kBfN", function(module, exports) {
module.exports = new URL("mid-tom_1.3fc809be.mp3", import.meta.url).toString();

});

parcelRegister("8hpbe", function(module, exports) {
module.exports = new URL("mid-tom_2.6b59b8f0.mp3", import.meta.url).toString();

});

parcelRegister("iuitn", function(module, exports) {
module.exports = new URL("mid-tom_3.17f1cc7f.mp3", import.meta.url).toString();

});

parcelRegister("ekqSg", function(module, exports) {
module.exports = new URL("mid-tom_4.72bb4506.mp3", import.meta.url).toString();

});

parcelRegister("iULhj", function(module, exports) {
module.exports = new URL("mid-tom_5.c1baf999.mp3", import.meta.url).toString();

});

parcelRegister("5iX8l", function(module, exports) {
module.exports = new URL("mid-tom_6.f2fc805f.mp3", import.meta.url).toString();

});

parcelRegister("8itDX", function(module, exports) {
module.exports = new URL("mid-tom_7.970248d0.mp3", import.meta.url).toString();

});

parcelRegister("2eaI0", function(module, exports) {
module.exports = new URL("mid-tom_8.73bfd563.mp3", import.meta.url).toString();

});

parcelRegister("ls98q", function(module, exports) {
module.exports = new URL("mid-tom_9.211b9f20.mp3", import.meta.url).toString();

});

parcelRegister("euiK4", function(module, exports) {
module.exports = new URL("mid-tom_10.6a403e17.mp3", import.meta.url).toString();

});

parcelRegister("9HaM0", function(module, exports) {
module.exports = new URL("mid-tom_11.58388abe.mp3", import.meta.url).toString();

});

parcelRegister("ge5lW", function(module, exports) {
module.exports = new URL("mid-tom_12.bcd70088.mp3", import.meta.url).toString();

});

parcelRegister("4OwOj", function(module, exports) {
module.exports = new URL("floor-tom_1.12e2e635.mp3", import.meta.url).toString();

});

parcelRegister("c29E2", function(module, exports) {
module.exports = new URL("floor-tom_2.e6e78471.mp3", import.meta.url).toString();

});

parcelRegister("aq3tN", function(module, exports) {
module.exports = new URL("floor-tom_3.49806c39.mp3", import.meta.url).toString();

});

parcelRegister("brntc", function(module, exports) {
module.exports = new URL("floor-tom_4.a291815e.mp3", import.meta.url).toString();

});

parcelRegister("gUGe5", function(module, exports) {
module.exports = new URL("floor-tom_5.090c6c58.mp3", import.meta.url).toString();

});

parcelRegister("awWFT", function(module, exports) {
module.exports = new URL("floor-tom_6.e90de229.mp3", import.meta.url).toString();

});

parcelRegister("ftxH4", function(module, exports) {
module.exports = new URL("floor-tom_7.68418ad4.mp3", import.meta.url).toString();

});

parcelRegister("3yq6D", function(module, exports) {
module.exports = new URL("floor-tom_8.20433cf0.mp3", import.meta.url).toString();

});

parcelRegister("cwkqo", function(module, exports) {
module.exports = new URL("floor-tom_9.f95e6621.mp3", import.meta.url).toString();

});

parcelRegister("7lfO5", function(module, exports) {
module.exports = new URL("floor-tom_10.8525c2e8.mp3", import.meta.url).toString();

});

parcelRegister("8ab0Q", function(module, exports) {
module.exports = new URL("floor-tom_11.58d9143f.mp3", import.meta.url).toString();

});

parcelRegister("6sqLW", function(module, exports) {
module.exports = new URL("floor-tom_12.24ed6b48.mp3", import.meta.url).toString();

});

parcelRegister("6Yrql", function(module, exports) {

$parcel$export(module.exports, "FaceLandmarker", () => FaceLandmarker_1);
$parcel$export(module.exports, "FilesetResolver", () => FilesetResolver_1);
$parcel$export(module.exports, "DrawingUtils", () => DrawingUtils_1);
/**
 * Skipped minification because the original files appears to be already minified.
 * Original file: /npm/@mediapipe/tasks-vision@0.10.0/vision_bundle.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */ var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, vision = {}, fileset_resolver = {};
let supportsSimd;
Object.defineProperty(fileset_resolver, "__esModule", {
    value: !0
}), fileset_resolver.FilesetResolver = void 0;
const WASM_SIMD_CHECK = new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    5,
    1,
    96,
    0,
    1,
    123,
    3,
    2,
    1,
    0,
    10,
    10,
    1,
    8,
    0,
    65,
    0,
    253,
    15,
    253,
    98,
    11
]);
async function isSimdSupported() {
    if (void 0 === supportsSimd) try {
        await WebAssembly.instantiate(WASM_SIMD_CHECK), supportsSimd = !0;
    } catch (e11) {
        supportsSimd = !1;
    }
    return supportsSimd;
}
async function createFileset(e11, t11 = "") {
    const r11 = await isSimdSupported() ? "wasm_internal" : "wasm_nosimd_internal";
    return {
        wasmLoaderPath: `${t11}/${e11}_${r11}.js`,
        wasmBinaryPath: `${t11}/${e11}_${r11}.wasm`
    };
}
class FilesetResolver$1 {
    static isSimdSupported() {
        return isSimdSupported();
    }
    static forAudioTasks(e11) {
        return createFileset("audio", e11);
    }
    static forTextTasks(e11) {
        return createFileset("text", e11);
    }
    static forVisionTasks(e11) {
        return createFileset("vision", e11);
    }
}
fileset_resolver.FilesetResolver = FilesetResolver$1;
var drawing_utils = {};
Object.defineProperty(drawing_utils, "__esModule", {
    value: !0
}), drawing_utils.DrawingUtils = void 0;
const DEFAULT_OPTIONS = {
    color: "white",
    lineWidth: 4,
    radius: 6
};
function addDefaultOptions(e11) {
    return e11 = e11 || {}, Object.assign(Object.assign(Object.assign({}, DEFAULT_OPTIONS), {
        fillColor: e11.color
    }), e11);
}
function resolve(e11, t11) {
    return e11 instanceof Function ? e11(t11) : e11;
}
class DrawingUtils$1 {
    constructor(e11){
        this.ctx = e11;
    }
    static clamp(e11, t11, r11) {
        const o11 = Math.min(t11, r11), i11 = Math.max(t11, r11);
        return Math.max(o11, Math.min(i11, e11));
    }
    static lerp(e11, t11, r11, o11, i11) {
        const a11 = o11 * (1 - (e11 - t11) / (r11 - t11)) + i11 * (1 - (r11 - e11) / (r11 - t11));
        return DrawingUtils$1.clamp(a11, o11, i11);
    }
    drawLandmarks(e11, t11) {
        if (!e11) return;
        const r11 = this.ctx, o11 = addDefaultOptions(t11);
        r11.save();
        const i11 = r11.canvas;
        let a11 = 0;
        for (const t11 of e11){
            r11.fillStyle = resolve(o11.fillColor, {
                index: a11,
                from: t11
            }), r11.strokeStyle = resolve(o11.color, {
                index: a11,
                from: t11
            }), r11.lineWidth = resolve(o11.lineWidth, {
                index: a11,
                from: t11
            });
            const e11 = new Path2D;
            e11.arc(t11.x * i11.width, t11.y * i11.height, resolve(o11.radius, {
                index: a11,
                from: t11
            }), 0, 2 * Math.PI), r11.fill(e11), r11.stroke(e11), ++a11;
        }
        r11.restore();
    }
    drawConnectors(e11, t11, r11) {
        if (!e11 || !t11) return;
        const o11 = this.ctx, i11 = addDefaultOptions(r11);
        o11.save();
        const a11 = o11.canvas;
        let n11 = 0;
        for (const r11 of t11){
            o11.beginPath();
            const t11 = e11[r11.start], s11 = e11[r11.end];
            t11 && s11 && (o11.strokeStyle = resolve(i11.color, {
                index: n11,
                from: t11,
                to: s11
            }), o11.lineWidth = resolve(i11.lineWidth, {
                index: n11,
                from: t11,
                to: s11
            }), o11.moveTo(t11.x * a11.width, t11.y * a11.height), o11.lineTo(s11.x * a11.width, s11.y * a11.height)), ++n11, o11.stroke();
        }
        o11.restore();
    }
    drawBoundingBox(e11, t11) {
        const r11 = this.ctx, o11 = addDefaultOptions(t11);
        r11.save(), r11.beginPath(), r11.lineWidth = resolve(o11.lineWidth, {}), r11.strokeStyle = resolve(o11.color, {}), r11.fillStyle = resolve(o11.fillColor, {}), r11.moveTo(e11.originX, e11.originY), r11.lineTo(e11.originX + e11.width, e11.originY), r11.lineTo(e11.originX + e11.width, e11.originY + e11.height), r11.lineTo(e11.originX, e11.originY + e11.height), r11.lineTo(e11.originX, e11.originY), r11.stroke(), r11.fill(), r11.restore();
    }
}
drawing_utils.DrawingUtils = DrawingUtils$1;
var image = {}, image_shader_context = {};
Object.defineProperty(image_shader_context, "__esModule", {
    value: !0
}), image_shader_context.MPImageShaderContext = image_shader_context.assertNotNull = void 0;
const VERTEX_SHADER = "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", FRAGMENT_SHADER = "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D inputTexture;\n   void main() {\n     gl_FragColor = texture2D(inputTexture, vTex);\n   }\n ";
function assertNotNull(e11, t11) {
    if (null === e11) throw new Error(`Unable to obtain required WebGL resource: ${t11}`);
    return e11;
}
image_shader_context.assertNotNull = assertNotNull;
class MPImageShaderBuffers {
    constructor(e11, t11, r11, o11){
        this.gl = e11, this.vertexArrayObject = t11, this.vertexBuffer = r11, this.textureBuffer = o11;
    }
    bind() {
        this.gl.bindVertexArray(this.vertexArrayObject);
    }
    unbind() {
        this.gl.bindVertexArray(null);
    }
    close() {
        this.gl.deleteVertexArray(this.vertexArrayObject), this.gl.deleteBuffer(this.vertexBuffer), this.gl.deleteBuffer(this.textureBuffer);
    }
}
class MPImageShaderContext {
    compileShader(e11, t11) {
        const r11 = this.gl, o11 = assertNotNull(r11.createShader(t11), "Failed to create WebGL shader");
        if (r11.shaderSource(o11, e11), r11.compileShader(o11), !r11.getShaderParameter(o11, r11.COMPILE_STATUS)) {
            const e11 = r11.getShaderInfoLog(o11);
            throw new Error(`Could not compile WebGL shader: ${e11}`);
        }
        return r11.attachShader(this.program, o11), o11;
    }
    setupShaders() {
        const e11 = this.gl;
        this.program = assertNotNull(e11.createProgram(), "Failed to create WebGL program"), this.vertexShader = this.compileShader(VERTEX_SHADER, e11.VERTEX_SHADER), this.fragmentShader = this.compileShader(FRAGMENT_SHADER, e11.FRAGMENT_SHADER), e11.linkProgram(this.program);
        if (!e11.getProgramParameter(this.program, e11.LINK_STATUS)) {
            const t11 = e11.getProgramInfoLog(this.program);
            throw new Error(`Error during program linking: ${t11}`);
        }
        this.aVertex = e11.getAttribLocation(this.program, "aVertex"), this.aTex = e11.getAttribLocation(this.program, "aTex");
    }
    createBuffers(e11) {
        const t11 = this.gl, r11 = assertNotNull(t11.createVertexArray(), "Failed to create vertex array");
        t11.bindVertexArray(r11);
        const o11 = assertNotNull(t11.createBuffer(), "Failed to create buffer");
        t11.bindBuffer(t11.ARRAY_BUFFER, o11), t11.enableVertexAttribArray(this.aVertex), t11.vertexAttribPointer(this.aVertex, 2, t11.FLOAT, !1, 0, 0), t11.bufferData(t11.ARRAY_BUFFER, new Float32Array([
            -1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1
        ]), t11.STATIC_DRAW);
        const i11 = assertNotNull(t11.createBuffer(), "Failed to create buffer");
        t11.bindBuffer(t11.ARRAY_BUFFER, i11), t11.enableVertexAttribArray(this.aTex), t11.vertexAttribPointer(this.aTex, 2, t11.FLOAT, !1, 0, 0);
        const a11 = e11 ? [
            0,
            1,
            0,
            0,
            1,
            0,
            1,
            1
        ] : [
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            0
        ];
        return t11.bufferData(t11.ARRAY_BUFFER, new Float32Array(a11), t11.STATIC_DRAW), t11.bindBuffer(t11.ARRAY_BUFFER, null), t11.bindVertexArray(null), new MPImageShaderBuffers(t11, r11, o11, i11);
    }
    getShaderBuffers(e11) {
        return e11 ? (this.shaderBuffersFlipVertically || (this.shaderBuffersFlipVertically = this.createBuffers(!0)), this.shaderBuffersFlipVertically) : (this.shaderBuffersPassthrough || (this.shaderBuffersPassthrough = this.createBuffers(!1)), this.shaderBuffersPassthrough);
    }
    maybeInitGL(e11) {
        if (this.gl) {
            if (e11 !== this.gl) throw new Error("Cannot change GL context once initialized");
        } else this.gl = e11;
    }
    run(e11, t11, r11) {
        this.maybeInitGL(e11), this.program || this.setupShaders();
        const o11 = this.getShaderBuffers(t11);
        e11.useProgram(this.program), o11.bind();
        const i11 = r11();
        return o11.unbind(), i11;
    }
    bindFramebuffer(e11, t11) {
        this.maybeInitGL(e11), this.framebuffer || (this.framebuffer = assertNotNull(e11.createFramebuffer(), "Failed to create framebuffe.")), e11.bindFramebuffer(e11.FRAMEBUFFER, this.framebuffer), e11.framebufferTexture2D(e11.FRAMEBUFFER, e11.COLOR_ATTACHMENT0, e11.TEXTURE_2D, t11, 0);
    }
    unbindFramebuffer() {
        var e11;
        null === (e11 = this.gl) || void 0 === e11 || e11.bindFramebuffer(this.gl.FRAMEBUFFER, null);
    }
    close() {
        if (this.program) {
            const e11 = this.gl;
            e11.deleteProgram(this.program), e11.deleteShader(this.vertexShader), e11.deleteShader(this.fragmentShader);
        }
        this.framebuffer && this.gl.deleteFramebuffer(this.framebuffer), this.shaderBuffersPassthrough && this.shaderBuffersPassthrough.close(), this.shaderBuffersFlipVertically && this.shaderBuffersFlipVertically.close();
    }
}
image_shader_context.MPImageShaderContext = MPImageShaderContext, Object.defineProperty(image, "__esModule", {
    value: !0
}), image.MPImage = void 0;
const image_shader_context_1$2 = image_shader_context;
var MPImageType;
!function(e11) {
    e11[e11.IMAGE_DATA = 0] = "IMAGE_DATA", e11[e11.IMAGE_BITMAP = 1] = "IMAGE_BITMAP", e11[e11.WEBGL_TEXTURE = 2] = "WEBGL_TEXTURE";
}(MPImageType || (MPImageType = {}));
class MPImage$1 {
    constructor(e11, t11, r11, o11, i11, a11, n11){
        this.containers = e11, this.ownsImageBitmap = t11, this.ownsWebGLTexture = r11, this.canvas = o11, this.shaderContext = i11, this.width = a11, this.height = n11;
    }
    hasImageData() {
        return !!this.getContainer(MPImageType.IMAGE_DATA);
    }
    hasImageBitmap() {
        return !!this.getContainer(MPImageType.IMAGE_BITMAP);
    }
    hasWebGLTexture() {
        return !!this.getContainer(MPImageType.WEBGL_TEXTURE);
    }
    getAsImageData() {
        return this.convertToImageData();
    }
    getAsImageBitmap() {
        return this.convertToImageBitmap();
    }
    getAsWebGLTexture() {
        return this.convertToWebGLTexture();
    }
    getContainer(e11) {
        switch(e11){
            case MPImageType.IMAGE_DATA:
                return this.containers.find((e11)=>e11 instanceof ImageData);
            case MPImageType.IMAGE_BITMAP:
                return this.containers.find((e11)=>"undefined" != typeof ImageBitmap && e11 instanceof ImageBitmap);
            case MPImageType.WEBGL_TEXTURE:
                return this.containers.find((e11)=>"undefined" != typeof WebGLTexture && e11 instanceof WebGLTexture);
            default:
                throw new Error(`Type is not supported: ${e11}`);
        }
    }
    clone() {
        const e11 = [];
        for (const t11 of this.containers){
            let r11;
            if (t11 instanceof ImageData) r11 = new ImageData(t11.data, this.width, this.height);
            else if (t11 instanceof WebGLTexture) {
                const e11 = this.getGL(), t11 = this.getShaderContext();
                e11.activeTexture(e11.TEXTURE1), r11 = (0, image_shader_context_1$2.assertNotNull)(e11.createTexture(), "Failed to create texture"), e11.bindTexture(e11.TEXTURE_2D, r11), e11.texImage2D(e11.TEXTURE_2D, 0, e11.RGBA, this.width, this.height, 0, e11.RGBA, e11.UNSIGNED_BYTE, null), t11.bindFramebuffer(e11, r11), t11.run(e11, !1, ()=>{
                    this.bindTexture(), e11.clearColor(0, 0, 0, 0), e11.clear(e11.COLOR_BUFFER_BIT), e11.drawArrays(e11.TRIANGLE_FAN, 0, 4), this.unbindTexture();
                }), t11.unbindFramebuffer(), this.unbindTexture();
            } else {
                if (!(t11 instanceof ImageBitmap)) throw new Error(`Type is not supported: ${t11}`);
                this.convertToWebGLTexture(), this.bindTexture(), r11 = this.copyTextureToBitmap(), this.unbindTexture();
            }
            e11.push(r11);
        }
        return new MPImage$1(e11, this.hasImageBitmap(), this.hasWebGLTexture(), this.canvas, this.shaderContext, this.width, this.height);
    }
    getOffscreenCanvas() {
        if (!(this.canvas instanceof OffscreenCanvas)) throw new Error("Conversion to ImageBitmap requires that the MediaPipe Tasks is initialized with an OffscreenCanvas");
        return this.canvas;
    }
    getGL() {
        if (!this.canvas) throw new Error("Conversion to different image formats require that a canvas is passed when iniitializing the image.");
        return this.gl || (this.gl = (0, image_shader_context_1$2.assertNotNull)(this.canvas.getContext("webgl2"), "You cannot use a canvas that is already bound to a different type of rendering context.")), this.gl;
    }
    getShaderContext() {
        return this.shaderContext || (this.shaderContext = new image_shader_context_1$2.MPImageShaderContext), this.shaderContext;
    }
    convertToImageBitmap() {
        let e11 = this.getContainer(MPImageType.IMAGE_BITMAP);
        return e11 || (this.convertToWebGLTexture(), e11 = this.convertWebGLTextureToImageBitmap(), this.containers.push(e11), this.ownsImageBitmap = !0), e11;
    }
    convertToImageData() {
        let e11 = this.getContainer(MPImageType.IMAGE_DATA);
        if (!e11) {
            const t11 = this.getGL(), r11 = this.getShaderContext(), o11 = new Uint8Array(this.width * this.height * 4), i11 = this.convertToWebGLTexture();
            r11.bindFramebuffer(t11, i11), t11.readPixels(0, 0, this.width, this.height, t11.RGBA, t11.UNSIGNED_BYTE, o11), r11.unbindFramebuffer(), e11 = new ImageData(new Uint8ClampedArray(o11.buffer), this.width, this.height), this.containers.push(e11);
        }
        return e11;
    }
    convertToWebGLTexture() {
        let e11 = this.getContainer(MPImageType.WEBGL_TEXTURE);
        if (!e11) {
            const t11 = this.getGL();
            e11 = this.bindTexture();
            const r11 = this.getContainer(MPImageType.IMAGE_BITMAP) || this.convertToImageData();
            t11.texImage2D(t11.TEXTURE_2D, 0, t11.RGBA, t11.RGBA, t11.UNSIGNED_BYTE, r11), this.unbindTexture();
        }
        return e11;
    }
    bindTexture() {
        const e11 = this.getGL();
        e11.viewport(0, 0, this.width, this.height), e11.activeTexture(e11.TEXTURE0);
        let t11 = this.getContainer(MPImageType.WEBGL_TEXTURE);
        return t11 || (t11 = (0, image_shader_context_1$2.assertNotNull)(e11.createTexture(), "Failed to create texture"), this.containers.push(t11), this.ownsWebGLTexture = !0), e11.bindTexture(e11.TEXTURE_2D, t11), e11.texParameteri(e11.TEXTURE_2D, e11.TEXTURE_WRAP_S, e11.CLAMP_TO_EDGE), e11.texParameteri(e11.TEXTURE_2D, e11.TEXTURE_WRAP_T, e11.CLAMP_TO_EDGE), e11.texParameteri(e11.TEXTURE_2D, e11.TEXTURE_MIN_FILTER, e11.LINEAR), e11.texParameteri(e11.TEXTURE_2D, e11.TEXTURE_MAG_FILTER, e11.LINEAR), t11;
    }
    unbindTexture() {
        this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    }
    copyTextureToBitmap() {
        const e11 = this.getGL();
        return this.getShaderContext().run(e11, !0, ()=>this.runWithResizedCanvas(()=>(e11.bindFramebuffer(e11.FRAMEBUFFER, null), e11.clearColor(0, 0, 0, 0), e11.clear(e11.COLOR_BUFFER_BIT), e11.drawArrays(e11.TRIANGLE_FAN, 0, 4), this.getOffscreenCanvas().transferToImageBitmap())));
    }
    convertWebGLTextureToImageBitmap() {
        this.bindTexture();
        const e11 = this.copyTextureToBitmap();
        return this.unbindTexture(), e11;
    }
    runWithResizedCanvas(e11) {
        const t11 = this.canvas;
        if (t11.width === this.width && t11.height === this.height) return e11();
        const r11 = t11.width, o11 = t11.height;
        t11.width = this.width, t11.height = this.height;
        const i11 = e11();
        return t11.width = r11, t11.height = o11, i11;
    }
    close() {
        if (this.ownsImageBitmap && this.getContainer(MPImageType.IMAGE_BITMAP).close(), this.ownsWebGLTexture) this.getGL().deleteTexture(this.getContainer(MPImageType.WEBGL_TEXTURE));
    }
}
image.MPImage = MPImage$1;
var mask = {};
Object.defineProperty(mask, "__esModule", {
    value: !0
}), mask.MPMask = void 0;
const image_shader_context_1$1 = image_shader_context;
var MPMaskType;
!function(e11) {
    e11[e11.UINT8_ARRAY = 0] = "UINT8_ARRAY", e11[e11.FLOAT32_ARRAY = 1] = "FLOAT32_ARRAY", e11[e11.WEBGL_TEXTURE = 2] = "WEBGL_TEXTURE";
}(MPMaskType || (MPMaskType = {}));
class MPMask$1 {
    constructor(e11, t11, r11, o11, i11, a11){
        this.containers = e11, this.ownsWebGLTexture = t11, this.canvas = r11, this.shaderContext = o11, this.width = i11, this.height = a11;
    }
    hasUint8Array() {
        return !!this.getContainer(MPMaskType.UINT8_ARRAY);
    }
    hasFloat32Array() {
        return !!this.getContainer(MPMaskType.FLOAT32_ARRAY);
    }
    hasWebGLTexture() {
        return !!this.getContainer(MPMaskType.WEBGL_TEXTURE);
    }
    getAsUint8Array() {
        return this.convertToUint8Array();
    }
    getAsFloat32Array() {
        return this.convertToFloat32Array();
    }
    getAsWebGLTexture() {
        return this.convertToWebGLTexture();
    }
    getContainer(e11) {
        switch(e11){
            case MPMaskType.UINT8_ARRAY:
                return this.containers.find((e11)=>e11 instanceof Uint8Array);
            case MPMaskType.FLOAT32_ARRAY:
                return this.containers.find((e11)=>e11 instanceof Float32Array);
            case MPMaskType.WEBGL_TEXTURE:
                return this.containers.find((e11)=>"undefined" != typeof WebGLTexture && e11 instanceof WebGLTexture);
            default:
                throw new Error(`Type is not supported: ${e11}`);
        }
    }
    clone() {
        const e11 = [];
        for (const t11 of this.containers){
            let r11;
            if (t11 instanceof Uint8Array) r11 = new Uint8Array(t11);
            else if (t11 instanceof Float32Array) r11 = new Float32Array(t11);
            else {
                if (!(t11 instanceof WebGLTexture)) throw new Error(`Type is not supported: ${t11}`);
                {
                    const e11 = this.getGL(), t11 = this.getShaderContext();
                    e11.activeTexture(e11.TEXTURE1), r11 = (0, image_shader_context_1$1.assertNotNull)(e11.createTexture(), "Failed to create texture"), e11.bindTexture(e11.TEXTURE_2D, r11), e11.texImage2D(e11.TEXTURE_2D, 0, e11.R32F, this.width, this.height, 0, e11.RED, e11.FLOAT, null), e11.bindTexture(e11.TEXTURE_2D, null), t11.bindFramebuffer(e11, r11), t11.run(e11, !1, ()=>{
                        this.bindTexture(), e11.clearColor(0, 0, 0, 0), e11.clear(e11.COLOR_BUFFER_BIT), e11.drawArrays(e11.TRIANGLE_FAN, 0, 4), this.unbindTexture();
                    }), t11.unbindFramebuffer(), this.unbindTexture();
                }
            }
            e11.push(r11);
        }
        return new MPMask$1(e11, this.hasWebGLTexture(), this.canvas, this.shaderContext, this.width, this.height);
    }
    getGL() {
        if (!this.canvas) throw new Error("Conversion to different image formats require that a canvas is passed when iniitializing the image.");
        this.gl || (this.gl = (0, image_shader_context_1$1.assertNotNull)(this.canvas.getContext("webgl2"), "You cannot use a canvas that is already bound to a different type of rendering context."));
        if (!this.gl.getExtension("EXT_color_buffer_float")) throw new Error("Missing required EXT_color_buffer_float extension");
        return this.gl;
    }
    getShaderContext() {
        return this.shaderContext || (this.shaderContext = new image_shader_context_1$1.MPImageShaderContext), this.shaderContext;
    }
    convertToFloat32Array() {
        let e11 = this.getContainer(MPMaskType.FLOAT32_ARRAY);
        if (!e11) {
            const t11 = this.getContainer(MPMaskType.UINT8_ARRAY);
            if (t11) e11 = new Float32Array(t11).map((e11)=>e11 / 255);
            else {
                const t11 = this.getGL(), r11 = this.getShaderContext();
                e11 = new Float32Array(this.width * this.height);
                const o11 = this.convertToWebGLTexture();
                r11.bindFramebuffer(t11, o11), t11.readPixels(0, 0, this.width, this.height, t11.RED, t11.FLOAT, e11), r11.unbindFramebuffer();
            }
            this.containers.push(e11);
        }
        return e11;
    }
    convertToUint8Array() {
        let e11 = this.getContainer(MPMaskType.UINT8_ARRAY);
        if (!e11) {
            const t11 = this.convertToFloat32Array();
            e11 = new Uint8Array(t11.map((e11)=>255 * e11)), this.containers.push(e11);
        }
        return e11;
    }
    convertToWebGLTexture() {
        let e11 = this.getContainer(MPMaskType.WEBGL_TEXTURE);
        if (!e11) {
            const t11 = this.getGL();
            e11 = this.bindTexture();
            const r11 = this.convertToFloat32Array();
            t11.texImage2D(t11.TEXTURE_2D, 0, t11.R32F, this.width, this.height, 0, t11.RED, t11.FLOAT, r11), this.unbindTexture();
        }
        return e11;
    }
    bindTexture() {
        const e11 = this.getGL();
        e11.viewport(0, 0, this.width, this.height), e11.activeTexture(e11.TEXTURE0);
        let t11 = this.getContainer(MPMaskType.WEBGL_TEXTURE);
        return t11 || (t11 = (0, image_shader_context_1$1.assertNotNull)(e11.createTexture(), "Failed to create texture"), this.containers.push(t11), this.ownsWebGLTexture = !0), e11.bindTexture(e11.TEXTURE_2D, t11), e11.texParameteri(e11.TEXTURE_2D, e11.TEXTURE_WRAP_S, e11.CLAMP_TO_EDGE), e11.texParameteri(e11.TEXTURE_2D, e11.TEXTURE_WRAP_T, e11.CLAMP_TO_EDGE), e11.texParameteri(e11.TEXTURE_2D, e11.TEXTURE_MIN_FILTER, e11.NEAREST), e11.texParameteri(e11.TEXTURE_2D, e11.TEXTURE_MAG_FILTER, e11.NEAREST), t11;
    }
    unbindTexture() {
        this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    }
    close() {
        if (this.ownsWebGLTexture) this.getGL().deleteTexture(this.getContainer(MPMaskType.WEBGL_TEXTURE));
    }
}
mask.MPMask = MPMask$1;
var face_detector = {}, calculator_pb = {}, googleProtobuf = {};
(function(exports) {
    var $jscomp = $jscomp || {};
    $jscomp.scope = {}, $jscomp.findInternal = function(e11, t11, r11) {
        e11 instanceof String && (e11 = String(e11));
        for(var o11 = e11.length, i11 = 0; i11 < o11; i11++){
            var a11 = e11[i11];
            if (t11.call(r11, a11, i11, e11)) return {
                i: i11,
                v: a11
            };
        }
        return {
            i: -1,
            v: void 0
        };
    }, $jscomp.ASSUME_ES5 = !1, $jscomp.ASSUME_NO_NATIVE_MAP = !1, $jscomp.ASSUME_NO_NATIVE_SET = !1, $jscomp.SIMPLE_FROUND_POLYFILL = !1, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(e11, t11, r11) {
        e11 != Array.prototype && e11 != Object.prototype && (e11[t11] = r11.value);
    }, $jscomp.getGlobal = function(e11) {
        return "undefined" != typeof window && window === e11 ? e11 : void 0 !== commonjsGlobal && null != commonjsGlobal ? commonjsGlobal : e11;
    }, $jscomp.global = $jscomp.getGlobal(commonjsGlobal), $jscomp.polyfill = function(e11, t11, r11, o11) {
        if (t11) {
            for(r11 = $jscomp.global, e11 = e11.split("."), o11 = 0; o11 < e11.length - 1; o11++){
                var i11 = e11[o11];
                i11 in r11 || (r11[i11] = {}), r11 = r11[i11];
            }
            (t11 = t11(o11 = r11[e11 = e11[e11.length - 1]])) != o11 && null != t11 && $jscomp.defineProperty(r11, e11, {
                configurable: !0,
                writable: !0,
                value: t11
            });
        }
    }, $jscomp.polyfill("Array.prototype.findIndex", function(e11) {
        return e11 || function(e11, t11) {
            return $jscomp.findInternal(this, e11, t11).i;
        };
    }, "es6", "es3"), $jscomp.checkStringArgs = function(e11, t11, r11) {
        if (null == e11) throw new TypeError("The 'this' value for String.prototype." + r11 + " must not be null or undefined");
        if (t11 instanceof RegExp) throw new TypeError("First argument to String.prototype." + r11 + " must not be a regular expression");
        return e11 + "";
    }, $jscomp.polyfill("String.prototype.endsWith", function(e11) {
        return e11 || function(e11, t11) {
            var r11 = $jscomp.checkStringArgs(this, e11, "endsWith");
            e11 += "", void 0 === t11 && (t11 = r11.length), t11 = Math.max(0, Math.min(0 | t11, r11.length));
            for(var o11 = e11.length; 0 < o11 && 0 < t11;)if (r11[--t11] != e11[--o11]) return !1;
            return 0 >= o11;
        };
    }, "es6", "es3"), $jscomp.polyfill("Array.prototype.find", function(e11) {
        return e11 || function(e11, t11) {
            return $jscomp.findInternal(this, e11, t11).v;
        };
    }, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function(e11) {
        return e11 || function(e11, t11) {
            var r11 = $jscomp.checkStringArgs(this, e11, "startsWith");
            e11 += "";
            var o11 = r11.length, i11 = e11.length;
            t11 = Math.max(0, Math.min(0 | t11, r11.length));
            for(var a11 = 0; a11 < i11 && t11 < o11;)if (r11[t11++] != e11[a11++]) return !1;
            return a11 >= i11;
        };
    }, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function(e11) {
        return e11 || function(e11) {
            var t11 = $jscomp.checkStringArgs(this, null, "repeat");
            if (0 > e11 || 1342177279 < e11) throw new RangeError("Invalid count value");
            e11 |= 0;
            for(var r11 = ""; e11;)1 & e11 && (r11 += t11), (e11 >>>= 1) && (t11 += t11);
            return r11;
        };
    }, "es6", "es3");
    var COMPILED = !0, goog = goog || {};
    goog.global = commonjsGlobal || self, goog.exportPath_ = function(e11, t11, r11) {
        e11 = e11.split("."), r11 = r11 || goog.global, e11[0] in r11 || void 0 === r11.execScript || r11.execScript("var " + e11[0]);
        for(var o11; e11.length && (o11 = e11.shift());)e11.length || void 0 === t11 ? r11 = r11[o11] && r11[o11] !== Object.prototype[o11] ? r11[o11] : r11[o11] = {} : r11[o11] = t11;
    }, goog.define = function(e11, t11) {
        return t11;
    }, goog.FEATURESET_YEAR = 2012, goog.DEBUG = !0, goog.LOCALE = "en", goog.TRUSTED_SITE = !0, goog.STRICT_MODE_COMPATIBLE = !1, goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1, goog.provide = function(e11) {
        if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
        goog.constructNamespace_(e11);
    }, goog.constructNamespace_ = function(e11, t11) {
        goog.exportPath_(e11, t11);
    }, goog.getScriptNonce = function(e11) {
        return e11 && e11 != goog.global ? goog.getScriptNonce_(e11.document) : (null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
    }, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function(e11) {
        return (e11 = e11.querySelector && e11.querySelector("script[nonce]")) && (e11 = e11.nonce || e11.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(e11) ? e11 : "";
    }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function(e11) {
        if ("string" != typeof e11 || !e11 || -1 == e11.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
        if (!goog.isInGoogModuleLoader_()) throw Error("Module " + e11 + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
        if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
        goog.moduleLoaderState_.moduleName = e11;
    }, goog.module.get = function(e11) {
        return goog.module.getInternal_(e11);
    }, goog.module.getInternal_ = function(e11) {
        return null;
    }, goog.ModuleType = {
        ES6: "es6",
        GOOG: "goog"
    }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function() {
        return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
    }, goog.isInGoogModuleLoader_ = function() {
        return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
    }, goog.isInEs6ModuleLoader_ = function() {
        if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
        var e11 = goog.global.$jscomp;
        return !!e11 && "function" == typeof e11.getCurrentModulePath && !!e11.getCurrentModulePath();
    }, goog.module.declareLegacyNamespace = function() {
        goog.moduleLoaderState_.declareLegacyNamespace = !0;
    }, goog.declareModuleId = function(e11) {
        if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = e11;
        else {
            var t11 = goog.global.$jscomp;
            if (!t11 || "function" != typeof t11.getCurrentModulePath) throw Error('Module with namespace "' + e11 + '" has been loaded incorrectly.');
            t11 = t11.require(t11.getCurrentModulePath()), goog.loadedModules_[e11] = {
                exports: t11,
                type: goog.ModuleType.ES6,
                moduleId: e11
            };
        }
    }, goog.setTestOnly = function(e11) {
        if (goog.DISALLOW_TEST_ONLY_CODE) throw e11 = e11 || "", Error("Importing test-only code into non-debug environment" + (e11 ? ": " + e11 : "."));
    }, goog.forwardDeclare = function(e11) {}, goog.getObjectByName = function(e11, t11) {
        e11 = e11.split("."), t11 = t11 || goog.global;
        for(var r11 = 0; r11 < e11.length; r11++)if (null == (t11 = t11[e11[r11]])) return null;
        return t11;
    }, goog.globalize = function(e11, t11) {
        for(var r11 in t11 = t11 || goog.global, e11)t11[r11] = e11[r11];
    }, goog.addDependency = function(e11, t11, r11, o11) {}, goog.ENABLE_DEBUG_LOADER = !0, goog.logToConsole_ = function(e11) {
        goog.global.console && goog.global.console.error(e11);
    }, goog.require = function(e11) {}, goog.requireType = function(e11) {
        return {};
    }, goog.basePath = "", goog.nullFunction = function() {}, goog.abstractMethod = function() {
        throw Error("unimplemented abstract method");
    }, goog.addSingletonGetter = function(e11) {
        e11.instance_ = void 0, e11.getInstance = function() {
            return e11.instance_ ? e11.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = e11), e11.instance_ = new e11);
        };
    }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = !0, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !COMPILED, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = !1, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function() {
        if (null == goog.hasBadLetScoping) {
            try {
                var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
            } catch (e) {
                a = !1;
            }
            goog.hasBadLetScoping = a;
        }
        return goog.hasBadLetScoping;
    }, goog.workaroundSafari10EvalBug = function(e11) {
        return "(function(){" + e11 + "\n;})();\n";
    }, goog.loadModule = function(e11) {
        var t11 = goog.moduleLoaderState_;
        try {
            if (goog.moduleLoaderState_ = {
                moduleName: "",
                declareLegacyNamespace: !1,
                type: goog.ModuleType.GOOG
            }, goog.isFunction(e11)) var r11 = e11.call(void 0, {});
            else {
                if ("string" != typeof e11) throw Error("Invalid module definition");
                goog.useSafari10Workaround() && (e11 = goog.workaroundSafari10EvalBug(e11)), r11 = goog.loadModuleFromSource_.call(void 0, e11);
            }
            var o11 = goog.moduleLoaderState_.moduleName;
            if ("string" != typeof o11 || !o11) throw Error('Invalid module name "' + o11 + '"');
            goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(o11, r11) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof r11 && null != r11 && Object.seal(r11), goog.loadedModules_[o11] = {
                exports: r11,
                type: goog.ModuleType.GOOG,
                moduleId: goog.moduleLoaderState_.moduleName
            };
        } finally{
            goog.moduleLoaderState_ = t11;
        }
    }, goog.loadModuleFromSource_ = function(a) {
        return eval(a), {};
    }, goog.normalizePath_ = function(e11) {
        e11 = e11.split("/");
        for(var t11 = 0; t11 < e11.length;)"." == e11[t11] ? e11.splice(t11, 1) : t11 && ".." == e11[t11] && e11[t11 - 1] && ".." != e11[t11 - 1] ? e11.splice(--t11, 2) : t11++;
        return e11.join("/");
    }, goog.loadFileSync_ = function(e11) {
        if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(e11);
        try {
            var t11 = new goog.global.XMLHttpRequest;
            return t11.open("get", e11, !1), t11.send(), 0 == t11.status || 200 == t11.status ? t11.responseText : null;
        } catch (e11) {
            return null;
        }
    }, goog.transpile_ = function(e11, t11, r11) {
        var o11 = goog.global.$jscomp;
        o11 || (goog.global.$jscomp = o11 = {});
        var i11 = o11.transpile;
        if (!i11) {
            var a11 = goog.basePath + goog.TRANSPILER, n11 = goog.loadFileSync_(a11);
            if (n11) {
                if ((function() {
                    (0, eval)(n11 + "\n//# sourceURL=" + a11);
                }).call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
                goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, i11 = (o11 = goog.global.$jscomp).transpile;
            }
        }
        return i11 || (i11 = o11.transpile = function(e11, t11) {
            return goog.logToConsole_(t11 + " requires transpilation but no transpiler was found."), e11;
        }), i11(e11, t11, r11);
    }, goog.typeOf = function(e11) {
        var t11 = typeof e11;
        if ("object" == t11) {
            if (!e11) return "null";
            if (e11 instanceof Array) return "array";
            if (e11 instanceof Object) return t11;
            var r11 = Object.prototype.toString.call(e11);
            if ("[object Window]" == r11) return "object";
            if ("[object Array]" == r11 || "number" == typeof e11.length && void 0 !== e11.splice && void 0 !== e11.propertyIsEnumerable && !e11.propertyIsEnumerable("splice")) return "array";
            if ("[object Function]" == r11 || void 0 !== e11.call && void 0 !== e11.propertyIsEnumerable && !e11.propertyIsEnumerable("call")) return "function";
        } else if ("function" == t11 && void 0 === e11.call) return "object";
        return t11;
    }, goog.isArray = function(e11) {
        return "array" == goog.typeOf(e11);
    }, goog.isArrayLike = function(e11) {
        var t11 = goog.typeOf(e11);
        return "array" == t11 || "object" == t11 && "number" == typeof e11.length;
    }, goog.isDateLike = function(e11) {
        return goog.isObject(e11) && "function" == typeof e11.getFullYear;
    }, goog.isFunction = function(e11) {
        return "function" == goog.typeOf(e11);
    }, goog.isObject = function(e11) {
        var t11 = typeof e11;
        return "object" == t11 && null != e11 || "function" == t11;
    }, goog.getUid = function(e11) {
        return Object.prototype.hasOwnProperty.call(e11, goog.UID_PROPERTY_) && e11[goog.UID_PROPERTY_] || (e11[goog.UID_PROPERTY_] = ++goog.uidCounter_);
    }, goog.hasUid = function(e11) {
        return !!e11[goog.UID_PROPERTY_];
    }, goog.removeUid = function(e11) {
        null !== e11 && "removeAttribute" in e11 && e11.removeAttribute(goog.UID_PROPERTY_);
        try {
            delete e11[goog.UID_PROPERTY_];
        } catch (e11) {}
    }, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.getHashCode = goog.getUid, goog.removeHashCode = goog.removeUid, goog.cloneObject = function(e11) {
        var t11 = goog.typeOf(e11);
        if ("object" == t11 || "array" == t11) {
            if ("function" == typeof e11.clone) return e11.clone();
            for(var r11 in t11 = "array" == t11 ? [] : {}, e11)t11[r11] = goog.cloneObject(e11[r11]);
            return t11;
        }
        return e11;
    }, goog.bindNative_ = function(e11, t11, r11) {
        return e11.call.apply(e11.bind, arguments);
    }, goog.bindJs_ = function(e11, t11, r11) {
        if (!e11) throw Error();
        if (2 < arguments.length) {
            var o11 = Array.prototype.slice.call(arguments, 2);
            return function() {
                var r11 = Array.prototype.slice.call(arguments);
                return Array.prototype.unshift.apply(r11, o11), e11.apply(t11, r11);
            };
        }
        return function() {
            return e11.apply(t11, arguments);
        };
    }, goog.bind = function(e11, t11, r11) {
        return Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
    }, goog.partial = function(e11, t11) {
        var r11 = Array.prototype.slice.call(arguments, 1);
        return function() {
            var t11 = r11.slice();
            return t11.push.apply(t11, arguments), e11.apply(this, t11);
        };
    }, goog.mixin = function(e11, t11) {
        for(var r11 in t11)e11[r11] = t11[r11];
    }, goog.now = goog.TRUSTED_SITE && Date.now || function() {
        return +new Date;
    }, goog.globalEval = function(e11) {
        if (goog.global.execScript) goog.global.execScript(e11, "JavaScript");
        else {
            if (!goog.global.eval) throw Error("goog.globalEval not available");
            if (null == goog.evalWorksForGlobals_) {
                try {
                    goog.global.eval("var _evalTest_ = 1;");
                } catch (e11) {}
                if (void 0 !== goog.global._evalTest_) {
                    try {
                        delete goog.global._evalTest_;
                    } catch (e11) {}
                    goog.evalWorksForGlobals_ = !0;
                } else goog.evalWorksForGlobals_ = !1;
            }
            if (goog.evalWorksForGlobals_) goog.global.eval(e11);
            else {
                var t11 = goog.global.document, r11 = t11.createElement("script");
                r11.type = "text/javascript", r11.defer = !1, r11.appendChild(t11.createTextNode(e11)), t11.head.appendChild(r11), t11.head.removeChild(r11);
            }
        }
    }, goog.evalWorksForGlobals_ = null, goog.getCssName = function(e11, t11) {
        if ("." == String(e11).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + e11);
        var r11 = function(e11) {
            return goog.cssNameMapping_[e11] || e11;
        }, o11 = function(e11) {
            e11 = e11.split("-");
            for(var t11 = [], o11 = 0; o11 < e11.length; o11++)t11.push(r11(e11[o11]));
            return t11.join("-");
        };
        return o11 = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? r11 : o11 : function(e11) {
            return e11;
        }, e11 = t11 ? e11 + "-" + o11(t11) : o11(e11), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(e11) : e11;
    }, goog.setCssNameMapping = function(e11, t11) {
        goog.cssNameMapping_ = e11, goog.cssNameMappingStyle_ = t11;
    }, goog.getMsg = function(e11, t11, r11) {
        return r11 && r11.html && (e11 = e11.replace(/</g, "&lt;")), t11 && (e11 = e11.replace(/\{\$([^}]+)}/g, function(e11, r11) {
            return null != t11 && r11 in t11 ? t11[r11] : e11;
        })), e11;
    }, goog.getMsgWithFallback = function(e11, t11) {
        return e11;
    }, goog.exportSymbol = function(e11, t11, r11) {
        goog.exportPath_(e11, t11, r11);
    }, goog.exportProperty = function(e11, t11, r11) {
        e11[t11] = r11;
    }, goog.inherits = function(e11, t11) {
        function r11() {}
        r11.prototype = t11.prototype, e11.superClass_ = t11.prototype, e11.prototype = new r11, e11.prototype.constructor = e11, e11.base = function(e11, r11, o11) {
            for(var i11 = Array(arguments.length - 2), a11 = 2; a11 < arguments.length; a11++)i11[a11 - 2] = arguments[a11];
            return t11.prototype[r11].apply(e11, i11);
        };
    }, goog.scope = function(e11) {
        if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
        e11.call(goog.global);
    }, goog.defineClass = function(e11, t11) {
        var r11 = t11.constructor, o11 = t11.statics;
        return r11 && r11 != Object.prototype.constructor || (r11 = function() {
            throw Error("cannot instantiate an interface (no constructor defined).");
        }), r11 = goog.defineClass.createSealingConstructor_(r11, e11), e11 && goog.inherits(r11, e11), delete t11.constructor, delete t11.statics, goog.defineClass.applyProperties_(r11.prototype, t11), null != o11 && (o11 instanceof Function ? o11(r11) : goog.defineClass.applyProperties_(r11, o11)), r11;
    }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function(e11, t11) {
        if (!goog.defineClass.SEAL_CLASS_INSTANCES) return e11;
        var r11 = !goog.defineClass.isUnsealable_(t11), o11 = function() {
            var t11 = e11.apply(this, arguments) || this;
            return t11[goog.UID_PROPERTY_] = t11[goog.UID_PROPERTY_], this.constructor === o11 && r11 && Object.seal instanceof Function && Object.seal(t11), t11;
        };
        return o11;
    }, goog.defineClass.isUnsealable_ = function(e11) {
        return e11 && e11.prototype && e11.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
    }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function(e11, t11) {
        for(var r11 in t11)Object.prototype.hasOwnProperty.call(t11, r11) && (e11[r11] = t11[r11]);
        for(var o11 = 0; o11 < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; o11++)r11 = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[o11], Object.prototype.hasOwnProperty.call(t11, r11) && (e11[r11] = t11[r11]);
    }, goog.tagUnsealableClass = function(e11) {}, goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable", goog.TRUSTED_TYPES_POLICY_NAME = "", goog.identity_ = function(e11) {
        return e11;
    }, goog.createTrustedTypesPolicy = function(e11) {
        var t11 = null, r11 = goog.global.trustedTypes || goog.global.TrustedTypes;
        if (!r11 || !r11.createPolicy) return t11;
        try {
            t11 = r11.createPolicy(e11, {
                createHTML: goog.identity_,
                createScript: goog.identity_,
                createScriptURL: goog.identity_,
                createURL: goog.identity_
            });
        } catch (e11) {
            goog.logToConsole_(e11.message);
        }
        return t11;
    }, goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null, goog.object = {}, goog.object.is = function(e11, t11) {
        return e11 === t11 ? 0 !== e11 || 1 / e11 == 1 / t11 : e11 != e11 && t11 != t11;
    }, goog.object.forEach = function(e11, t11, r11) {
        for(var o11 in e11)t11.call(r11, e11[o11], o11, e11);
    }, goog.object.filter = function(e11, t11, r11) {
        var o11, i11 = {};
        for(o11 in e11)t11.call(r11, e11[o11], o11, e11) && (i11[o11] = e11[o11]);
        return i11;
    }, goog.object.map = function(e11, t11, r11) {
        var o11, i11 = {};
        for(o11 in e11)i11[o11] = t11.call(r11, e11[o11], o11, e11);
        return i11;
    }, goog.object.some = function(e11, t11, r11) {
        for(var o11 in e11)if (t11.call(r11, e11[o11], o11, e11)) return !0;
        return !1;
    }, goog.object.every = function(e11, t11, r11) {
        for(var o11 in e11)if (!t11.call(r11, e11[o11], o11, e11)) return !1;
        return !0;
    }, goog.object.getCount = function(e11) {
        var t11, r11 = 0;
        for(t11 in e11)r11++;
        return r11;
    }, goog.object.getAnyKey = function(e11) {
        for(var t11 in e11)return t11;
    }, goog.object.getAnyValue = function(e11) {
        for(var t11 in e11)return e11[t11];
    }, goog.object.contains = function(e11, t11) {
        return goog.object.containsValue(e11, t11);
    }, goog.object.getValues = function(e11) {
        var t11, r11 = [], o11 = 0;
        for(t11 in e11)r11[o11++] = e11[t11];
        return r11;
    }, goog.object.getKeys = function(e11) {
        var t11, r11 = [], o11 = 0;
        for(t11 in e11)r11[o11++] = t11;
        return r11;
    }, goog.object.getValueByKeys = function(e11, t11) {
        var r11 = goog.isArrayLike(t11), o11 = r11 ? t11 : arguments;
        for(r11 = r11 ? 0 : 1; r11 < o11.length; r11++){
            if (null == e11) return;
            e11 = e11[o11[r11]];
        }
        return e11;
    }, goog.object.containsKey = function(e11, t11) {
        return null !== e11 && t11 in e11;
    }, goog.object.containsValue = function(e11, t11) {
        for(var r11 in e11)if (e11[r11] == t11) return !0;
        return !1;
    }, goog.object.findKey = function(e11, t11, r11) {
        for(var o11 in e11)if (t11.call(r11, e11[o11], o11, e11)) return o11;
    }, goog.object.findValue = function(e11, t11, r11) {
        return (t11 = goog.object.findKey(e11, t11, r11)) && e11[t11];
    }, goog.object.isEmpty = function(e11) {
        for(var t11 in e11)return !1;
        return !0;
    }, goog.object.clear = function(e11) {
        for(var t11 in e11)delete e11[t11];
    }, goog.object.remove = function(e11, t11) {
        var r11;
        return (r11 = t11 in e11) && delete e11[t11], r11;
    }, goog.object.add = function(e11, t11, r11) {
        if (null !== e11 && t11 in e11) throw Error('The object already contains the key "' + t11 + '"');
        goog.object.set(e11, t11, r11);
    }, goog.object.get = function(e11, t11, r11) {
        return null !== e11 && t11 in e11 ? e11[t11] : r11;
    }, goog.object.set = function(e11, t11, r11) {
        e11[t11] = r11;
    }, goog.object.setIfUndefined = function(e11, t11, r11) {
        return t11 in e11 ? e11[t11] : e11[t11] = r11;
    }, goog.object.setWithReturnValueIfNotSet = function(e11, t11, r11) {
        return t11 in e11 ? e11[t11] : (r11 = r11(), e11[t11] = r11);
    }, goog.object.equals = function(e11, t11) {
        for(var r11 in e11)if (!(r11 in t11) || e11[r11] !== t11[r11]) return !1;
        for(var o11 in t11)if (!(o11 in e11)) return !1;
        return !0;
    }, goog.object.clone = function(e11) {
        var t11, r11 = {};
        for(t11 in e11)r11[t11] = e11[t11];
        return r11;
    }, goog.object.unsafeClone = function(e11) {
        var t11 = goog.typeOf(e11);
        if ("object" == t11 || "array" == t11) {
            if (goog.isFunction(e11.clone)) return e11.clone();
            for(var r11 in t11 = "array" == t11 ? [] : {}, e11)t11[r11] = goog.object.unsafeClone(e11[r11]);
            return t11;
        }
        return e11;
    }, goog.object.transpose = function(e11) {
        var t11, r11 = {};
        for(t11 in e11)r11[e11[t11]] = t11;
        return r11;
    }, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function(e11, t11) {
        for(var r11, o11, i11 = 1; i11 < arguments.length; i11++){
            for(r11 in o11 = arguments[i11])e11[r11] = o11[r11];
            for(var a11 = 0; a11 < goog.object.PROTOTYPE_FIELDS_.length; a11++)r11 = goog.object.PROTOTYPE_FIELDS_[a11], Object.prototype.hasOwnProperty.call(o11, r11) && (e11[r11] = o11[r11]);
        }
    }, goog.object.create = function(e11) {
        var t11 = arguments.length;
        if (1 == t11 && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
        if (t11 % 2) throw Error("Uneven number of arguments");
        for(var r11 = {}, o11 = 0; o11 < t11; o11 += 2)r11[arguments[o11]] = arguments[o11 + 1];
        return r11;
    }, goog.object.createSet = function(e11) {
        var t11 = arguments.length;
        if (1 == t11 && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
        for(var r11 = {}, o11 = 0; o11 < t11; o11++)r11[arguments[o11]] = !0;
        return r11;
    }, goog.object.createImmutableView = function(e11) {
        var t11 = e11;
        return Object.isFrozen && !Object.isFrozen(e11) && (t11 = Object.create(e11), Object.freeze(t11)), t11;
    }, goog.object.isImmutableView = function(e11) {
        return !!Object.isFrozen && Object.isFrozen(e11);
    }, goog.object.getAllPropertyNames = function(e11, t11, r11) {
        if (!e11) return [];
        if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(e11);
        for(var o11 = {}; e11 && (e11 !== Object.prototype || t11) && (e11 !== Function.prototype || r11);){
            for(var i11 = Object.getOwnPropertyNames(e11), a11 = 0; a11 < i11.length; a11++)o11[i11[a11]] = !0;
            e11 = Object.getPrototypeOf(e11);
        }
        return goog.object.getKeys(o11);
    }, goog.object.getSuperClass = function(e11) {
        return (e11 = Object.getPrototypeOf(e11.prototype)) && e11.constructor;
    };
    var jspb = {
        asserts: {}
    };
    jspb.asserts.doAssertFailure = function(e11, t11, r11, o11) {
        var i11 = "Assertion failed";
        if (r11) {
            i11 += ": " + r11;
            var a11 = o11;
        } else e11 && (i11 += ": " + e11, a11 = t11);
        throw Error("" + i11, a11 || []);
    }, jspb.asserts.assert = function(e11, t11, r11) {
        for(var o11 = [], i11 = 2; i11 < arguments.length; ++i11)o11[i11 - 2] = arguments[i11];
        return e11 || jspb.asserts.doAssertFailure("", null, t11, o11), e11;
    }, jspb.asserts.assertString = function(e11, t11, r11) {
        for(var o11 = [], i11 = 2; i11 < arguments.length; ++i11)o11[i11 - 2] = arguments[i11];
        return "string" != typeof e11 && jspb.asserts.doAssertFailure("Expected string but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, o11), e11;
    }, jspb.asserts.assertArray = function(e11, t11, r11) {
        for(var o11 = [], i11 = 2; i11 < arguments.length; ++i11)o11[i11 - 2] = arguments[i11];
        return Array.isArray(e11) || jspb.asserts.doAssertFailure("Expected array but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, o11), e11;
    }, jspb.asserts.fail = function(e11, t11) {
        for(var r11 = [], o11 = 1; o11 < arguments.length; ++o11)r11[o11 - 1] = arguments[o11];
        throw Error("Failure" + (e11 ? ": " + e11 : ""), r11);
    }, jspb.asserts.assertInstanceof = function(e11, t11, r11, o11) {
        for(var i11 = [], a11 = 3; a11 < arguments.length; ++a11)i11[a11 - 3] = arguments[a11];
        return e11 instanceof t11 || jspb.asserts.doAssertFailure("Expected instanceof %s but got %s.", [
            jspb.asserts.getType(t11),
            jspb.asserts.getType(e11)
        ], r11, i11), e11;
    }, jspb.asserts.getType = function(e11) {
        return e11 instanceof Function ? e11.displayName || e11.name || "unknown type name" : e11 instanceof Object ? e11.constructor.displayName || e11.constructor.name || Object.prototype.toString.call(e11) : null === e11 ? "null" : typeof e11;
    }, jspb.BinaryConstants = {}, jspb.ConstBinaryMessage = function() {}, jspb.BinaryMessage = function() {}, jspb.BinaryConstants.FieldType = {
        INVALID: -1,
        DOUBLE: 1,
        FLOAT: 2,
        INT64: 3,
        UINT64: 4,
        INT32: 5,
        FIXED64: 6,
        FIXED32: 7,
        BOOL: 8,
        STRING: 9,
        GROUP: 10,
        MESSAGE: 11,
        BYTES: 12,
        UINT32: 13,
        ENUM: 14,
        SFIXED32: 15,
        SFIXED64: 16,
        SINT32: 17,
        SINT64: 18,
        FHASH64: 30,
        VHASH64: 31
    }, jspb.BinaryConstants.WireType = {
        INVALID: -1,
        VARINT: 0,
        FIXED64: 1,
        DELIMITED: 2,
        START_GROUP: 3,
        END_GROUP: 4,
        FIXED32: 5
    }, jspb.BinaryConstants.FieldTypeToWireType = function(e11) {
        var t11 = jspb.BinaryConstants.FieldType, r11 = jspb.BinaryConstants.WireType;
        switch(e11){
            case t11.INT32:
            case t11.INT64:
            case t11.UINT32:
            case t11.UINT64:
            case t11.SINT32:
            case t11.SINT64:
            case t11.BOOL:
            case t11.ENUM:
            case t11.VHASH64:
                return r11.VARINT;
            case t11.DOUBLE:
            case t11.FIXED64:
            case t11.SFIXED64:
            case t11.FHASH64:
                return r11.FIXED64;
            case t11.STRING:
            case t11.MESSAGE:
            case t11.BYTES:
                return r11.DELIMITED;
            case t11.FLOAT:
            case t11.FIXED32:
            case t11.SFIXED32:
                return r11.FIXED32;
            default:
                return r11.INVALID;
        }
    }, jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1, jspb.BinaryConstants.FLOAT32_EPS = 1401298464324817e-60, jspb.BinaryConstants.FLOAT32_MIN = 11754943508222875e-54, jspb.BinaryConstants.FLOAT32_MAX = 34028234663852886e22, jspb.BinaryConstants.FLOAT64_EPS = 5e-324, jspb.BinaryConstants.FLOAT64_MIN = 22250738585072014e-324, jspb.BinaryConstants.FLOAT64_MAX = 17976931348623157e292, jspb.BinaryConstants.TWO_TO_20 = 1048576, jspb.BinaryConstants.TWO_TO_23 = 8388608, jspb.BinaryConstants.TWO_TO_31 = 2147483648, jspb.BinaryConstants.TWO_TO_32 = 4294967296, jspb.BinaryConstants.TWO_TO_52 = 4503599627370496, jspb.BinaryConstants.TWO_TO_63 = 0x8000000000000000, jspb.BinaryConstants.TWO_TO_64 = 0x10000000000000000, jspb.BinaryConstants.ZERO_HASH = "\x00\x00\x00\x00\x00\x00\x00\x00", goog.debug = {}, goog.debug.Error = function(e11) {
        if (Error.captureStackTrace) Error.captureStackTrace(this, goog.debug.Error);
        else {
            var t11 = Error().stack;
            t11 && (this.stack = t11);
        }
        e11 && (this.message = String(e11)), this.reportErrorToServer = !0;
    }, goog.inherits(goog.debug.Error, Error), goog.debug.Error.prototype.name = "CustomError", goog.dom = {}, goog.dom.NodeType = {
        ELEMENT: 1,
        ATTRIBUTE: 2,
        TEXT: 3,
        CDATA_SECTION: 4,
        ENTITY_REFERENCE: 5,
        ENTITY: 6,
        PROCESSING_INSTRUCTION: 7,
        COMMENT: 8,
        DOCUMENT: 9,
        DOCUMENT_TYPE: 10,
        DOCUMENT_FRAGMENT: 11,
        NOTATION: 12
    }, goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function(e11, t11) {
        goog.debug.Error.call(this, goog.asserts.subs_(e11, t11)), this.messagePattern = e11;
    }, goog.inherits(goog.asserts.AssertionError, goog.debug.Error), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function(e11) {
        throw e11;
    }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function(e11, t11) {
        for(var r11 = "", o11 = (e11 = e11.split("%s")).length - 1, i11 = 0; i11 < o11; i11++)r11 += e11[i11] + (i11 < t11.length ? t11[i11] : "%s");
        return r11 + e11[o11];
    }, goog.asserts.doAssertFailure_ = function(e11, t11, r11, o11) {
        var i11 = "Assertion failed";
        if (r11) {
            i11 += ": " + r11;
            var a11 = o11;
        } else e11 && (i11 += ": " + e11, a11 = t11);
        e11 = new goog.asserts.AssertionError("" + i11, a11 || []), goog.asserts.errorHandler_(e11);
    }, goog.asserts.setErrorHandler = function(e11) {
        goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = e11);
    }, goog.asserts.assert = function(e11, t11, r11) {
        return goog.asserts.ENABLE_ASSERTS && !e11 && goog.asserts.doAssertFailure_("", null, t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertExists = function(e11, t11, r11) {
        return goog.asserts.ENABLE_ASSERTS && null == e11 && goog.asserts.doAssertFailure_("Expected to exist: %s.", [
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.fail = function(e11, t11) {
        goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (e11 ? ": " + e11 : ""), Array.prototype.slice.call(arguments, 1)));
    }, goog.asserts.assertNumber = function(e11, t11, r11) {
        return goog.asserts.ENABLE_ASSERTS && "number" != typeof e11 && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertString = function(e11, t11, r11) {
        return goog.asserts.ENABLE_ASSERTS && "string" != typeof e11 && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertFunction = function(e11, t11, r11) {
        return goog.asserts.ENABLE_ASSERTS && !goog.isFunction(e11) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertObject = function(e11, t11, r11) {
        return goog.asserts.ENABLE_ASSERTS && !goog.isObject(e11) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertArray = function(e11, t11, r11) {
        return goog.asserts.ENABLE_ASSERTS && !Array.isArray(e11) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertBoolean = function(e11, t11, r11) {
        return goog.asserts.ENABLE_ASSERTS && "boolean" != typeof e11 && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertElement = function(e11, t11, r11) {
        return !goog.asserts.ENABLE_ASSERTS || goog.isObject(e11) && e11.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [
            goog.typeOf(e11),
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertInstanceof = function(e11, t11, r11, o11) {
        return !goog.asserts.ENABLE_ASSERTS || e11 instanceof t11 || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [
            goog.asserts.getType_(t11),
            goog.asserts.getType_(e11)
        ], r11, Array.prototype.slice.call(arguments, 3)), e11;
    }, goog.asserts.assertFinite = function(e11, t11, r11) {
        return !goog.asserts.ENABLE_ASSERTS || "number" == typeof e11 && isFinite(e11) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [
            e11
        ], t11, Array.prototype.slice.call(arguments, 2)), e11;
    }, goog.asserts.assertObjectPrototypeIsIntact = function() {
        for(var e11 in Object.prototype)goog.asserts.fail(e11 + " should not be enumerable in Object.prototype.");
    }, goog.asserts.getType_ = function(e11) {
        return e11 instanceof Function ? e11.displayName || e11.name || "unknown type name" : e11 instanceof Object ? e11.constructor.displayName || e11.constructor.name || Object.prototype.toString.call(e11) : null === e11 ? "null" : typeof e11;
    }, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE, goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR, goog.array.peek = function(e11) {
        return e11[e11.length - 1];
    }, goog.array.last = goog.array.peek, goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(e11, t11, r11) {
        return goog.asserts.assert(null != e11.length), Array.prototype.indexOf.call(e11, t11, r11);
    } : function(e11, t11, r11) {
        if (r11 = null == r11 ? 0 : 0 > r11 ? Math.max(0, e11.length + r11) : r11, "string" == typeof e11) return "string" != typeof t11 || 1 != t11.length ? -1 : e11.indexOf(t11, r11);
        for(; r11 < e11.length; r11++)if (r11 in e11 && e11[r11] === t11) return r11;
        return -1;
    }, goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(e11, t11, r11) {
        return goog.asserts.assert(null != e11.length), Array.prototype.lastIndexOf.call(e11, t11, null == r11 ? e11.length - 1 : r11);
    } : function(e11, t11, r11) {
        if (0 > (r11 = null == r11 ? e11.length - 1 : r11) && (r11 = Math.max(0, e11.length + r11)), "string" == typeof e11) return "string" != typeof t11 || 1 != t11.length ? -1 : e11.lastIndexOf(t11, r11);
        for(; 0 <= r11; r11--)if (r11 in e11 && e11[r11] === t11) return r11;
        return -1;
    }, goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(e11, t11, r11) {
        goog.asserts.assert(null != e11.length), Array.prototype.forEach.call(e11, t11, r11);
    } : function(e11, t11, r11) {
        for(var o11 = e11.length, i11 = "string" == typeof e11 ? e11.split("") : e11, a11 = 0; a11 < o11; a11++)a11 in i11 && t11.call(r11, i11[a11], a11, e11);
    }, goog.array.forEachRight = function(e11, t11, r11) {
        var o11 = e11.length, i11 = "string" == typeof e11 ? e11.split("") : e11;
        for(--o11; 0 <= o11; --o11)o11 in i11 && t11.call(r11, i11[o11], o11, e11);
    }, goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(e11, t11, r11) {
        return goog.asserts.assert(null != e11.length), Array.prototype.filter.call(e11, t11, r11);
    } : function(e11, t11, r11) {
        for(var o11 = e11.length, i11 = [], a11 = 0, n11 = "string" == typeof e11 ? e11.split("") : e11, s11 = 0; s11 < o11; s11++)if (s11 in n11) {
            var p11 = n11[s11];
            t11.call(r11, p11, s11, e11) && (i11[a11++] = p11);
        }
        return i11;
    }, goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(e11, t11, r11) {
        return goog.asserts.assert(null != e11.length), Array.prototype.map.call(e11, t11, r11);
    } : function(e11, t11, r11) {
        for(var o11 = e11.length, i11 = Array(o11), a11 = "string" == typeof e11 ? e11.split("") : e11, n11 = 0; n11 < o11; n11++)n11 in a11 && (i11[n11] = t11.call(r11, a11[n11], n11, e11));
        return i11;
    }, goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(e11, t11, r11, o11) {
        return goog.asserts.assert(null != e11.length), o11 && (t11 = goog.bind(t11, o11)), Array.prototype.reduce.call(e11, t11, r11);
    } : function(e11, t11, r11, o11) {
        var i11 = r11;
        return goog.array.forEach(e11, function(r11, a11) {
            i11 = t11.call(o11, i11, r11, a11, e11);
        }), i11;
    }, goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(e11, t11, r11, o11) {
        return goog.asserts.assert(null != e11.length), goog.asserts.assert(null != t11), o11 && (t11 = goog.bind(t11, o11)), Array.prototype.reduceRight.call(e11, t11, r11);
    } : function(e11, t11, r11, o11) {
        var i11 = r11;
        return goog.array.forEachRight(e11, function(r11, a11) {
            i11 = t11.call(o11, i11, r11, a11, e11);
        }), i11;
    }, goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(e11, t11, r11) {
        return goog.asserts.assert(null != e11.length), Array.prototype.some.call(e11, t11, r11);
    } : function(e11, t11, r11) {
        for(var o11 = e11.length, i11 = "string" == typeof e11 ? e11.split("") : e11, a11 = 0; a11 < o11; a11++)if (a11 in i11 && t11.call(r11, i11[a11], a11, e11)) return !0;
        return !1;
    }, goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(e11, t11, r11) {
        return goog.asserts.assert(null != e11.length), Array.prototype.every.call(e11, t11, r11);
    } : function(e11, t11, r11) {
        for(var o11 = e11.length, i11 = "string" == typeof e11 ? e11.split("") : e11, a11 = 0; a11 < o11; a11++)if (a11 in i11 && !t11.call(r11, i11[a11], a11, e11)) return !1;
        return !0;
    }, goog.array.count = function(e11, t11, r11) {
        var o11 = 0;
        return goog.array.forEach(e11, function(e11, i11, a11) {
            t11.call(r11, e11, i11, a11) && ++o11;
        }, r11), o11;
    }, goog.array.find = function(e11, t11, r11) {
        return 0 > (t11 = goog.array.findIndex(e11, t11, r11)) ? null : "string" == typeof e11 ? e11.charAt(t11) : e11[t11];
    }, goog.array.findIndex = function(e11, t11, r11) {
        for(var o11 = e11.length, i11 = "string" == typeof e11 ? e11.split("") : e11, a11 = 0; a11 < o11; a11++)if (a11 in i11 && t11.call(r11, i11[a11], a11, e11)) return a11;
        return -1;
    }, goog.array.findRight = function(e11, t11, r11) {
        return 0 > (t11 = goog.array.findIndexRight(e11, t11, r11)) ? null : "string" == typeof e11 ? e11.charAt(t11) : e11[t11];
    }, goog.array.findIndexRight = function(e11, t11, r11) {
        var o11 = e11.length, i11 = "string" == typeof e11 ? e11.split("") : e11;
        for(--o11; 0 <= o11; o11--)if (o11 in i11 && t11.call(r11, i11[o11], o11, e11)) return o11;
        return -1;
    }, goog.array.contains = function(e11, t11) {
        return 0 <= goog.array.indexOf(e11, t11);
    }, goog.array.isEmpty = function(e11) {
        return 0 == e11.length;
    }, goog.array.clear = function(e11) {
        if (!Array.isArray(e11)) for(var t11 = e11.length - 1; 0 <= t11; t11--)delete e11[t11];
        e11.length = 0;
    }, goog.array.insert = function(e11, t11) {
        goog.array.contains(e11, t11) || e11.push(t11);
    }, goog.array.insertAt = function(e11, t11, r11) {
        goog.array.splice(e11, r11, 0, t11);
    }, goog.array.insertArrayAt = function(e11, t11, r11) {
        goog.partial(goog.array.splice, e11, r11, 0).apply(null, t11);
    }, goog.array.insertBefore = function(e11, t11, r11) {
        var o11;
        2 == arguments.length || 0 > (o11 = goog.array.indexOf(e11, r11)) ? e11.push(t11) : goog.array.insertAt(e11, t11, o11);
    }, goog.array.remove = function(e11, t11) {
        var r11;
        return (r11 = 0 <= (t11 = goog.array.indexOf(e11, t11))) && goog.array.removeAt(e11, t11), r11;
    }, goog.array.removeLast = function(e11, t11) {
        return 0 <= (t11 = goog.array.lastIndexOf(e11, t11)) && (goog.array.removeAt(e11, t11), !0);
    }, goog.array.removeAt = function(e11, t11) {
        return goog.asserts.assert(null != e11.length), 1 == Array.prototype.splice.call(e11, t11, 1).length;
    }, goog.array.removeIf = function(e11, t11, r11) {
        return 0 <= (t11 = goog.array.findIndex(e11, t11, r11)) && (goog.array.removeAt(e11, t11), !0);
    }, goog.array.removeAllIf = function(e11, t11, r11) {
        var o11 = 0;
        return goog.array.forEachRight(e11, function(i11, a11) {
            t11.call(r11, i11, a11, e11) && goog.array.removeAt(e11, a11) && o11++;
        }), o11;
    }, goog.array.concat = function(e11) {
        return Array.prototype.concat.apply([], arguments);
    }, goog.array.join = function(e11) {
        return Array.prototype.concat.apply([], arguments);
    }, goog.array.toArray = function(e11) {
        var t11 = e11.length;
        if (0 < t11) {
            for(var r11 = Array(t11), o11 = 0; o11 < t11; o11++)r11[o11] = e11[o11];
            return r11;
        }
        return [];
    }, goog.array.clone = goog.array.toArray, goog.array.extend = function(e11, t11) {
        for(var r11 = 1; r11 < arguments.length; r11++){
            var o11 = arguments[r11];
            if (goog.isArrayLike(o11)) {
                var i11 = e11.length || 0, a11 = o11.length || 0;
                e11.length = i11 + a11;
                for(var n11 = 0; n11 < a11; n11++)e11[i11 + n11] = o11[n11];
            } else e11.push(o11);
        }
    }, goog.array.splice = function(e11, t11, r11, o11) {
        return goog.asserts.assert(null != e11.length), Array.prototype.splice.apply(e11, goog.array.slice(arguments, 1));
    }, goog.array.slice = function(e11, t11, r11) {
        return goog.asserts.assert(null != e11.length), 2 >= arguments.length ? Array.prototype.slice.call(e11, t11) : Array.prototype.slice.call(e11, t11, r11);
    }, goog.array.removeDuplicates = function(e11, t11, r11) {
        t11 = t11 || e11;
        var o11 = function(e11) {
            return goog.isObject(e11) ? "o" + goog.getUid(e11) : (typeof e11).charAt(0) + e11;
        };
        r11 = r11 || o11, o11 = {};
        for(var i11 = 0, a11 = 0; a11 < e11.length;){
            var n11 = e11[a11++], s11 = r11(n11);
            Object.prototype.hasOwnProperty.call(o11, s11) || (o11[s11] = !0, t11[i11++] = n11);
        }
        t11.length = i11;
    }, goog.array.binarySearch = function(e11, t11, r11) {
        return goog.array.binarySearch_(e11, r11 || goog.array.defaultCompare, !1, t11);
    }, goog.array.binarySelect = function(e11, t11, r11) {
        return goog.array.binarySearch_(e11, t11, !0, void 0, r11);
    }, goog.array.binarySearch_ = function(e11, t11, r11, o11, i11) {
        for(var a11, n11 = 0, s11 = e11.length; n11 < s11;){
            var p11 = n11 + (s11 - n11 >>> 1), d11 = r11 ? t11.call(i11, e11[p11], p11, e11) : t11(o11, e11[p11]);
            0 < d11 ? n11 = p11 + 1 : (s11 = p11, a11 = !d11);
        }
        return a11 ? n11 : -n11 - 1;
    }, goog.array.sort = function(e11, t11) {
        e11.sort(t11 || goog.array.defaultCompare);
    }, goog.array.stableSort = function(e11, t11) {
        for(var r11 = Array(e11.length), o11 = 0; o11 < e11.length; o11++)r11[o11] = {
            index: o11,
            value: e11[o11]
        };
        var i11 = t11 || goog.array.defaultCompare;
        for(goog.array.sort(r11, function(e11, t11) {
            return i11(e11.value, t11.value) || e11.index - t11.index;
        }), o11 = 0; o11 < e11.length; o11++)e11[o11] = r11[o11].value;
    }, goog.array.sortByKey = function(e11, t11, r11) {
        var o11 = r11 || goog.array.defaultCompare;
        goog.array.sort(e11, function(e11, r11) {
            return o11(t11(e11), t11(r11));
        });
    }, goog.array.sortObjectsByKey = function(e11, t11, r11) {
        goog.array.sortByKey(e11, function(e11) {
            return e11[t11];
        }, r11);
    }, goog.array.isSorted = function(e11, t11, r11) {
        t11 = t11 || goog.array.defaultCompare;
        for(var o11 = 1; o11 < e11.length; o11++){
            var i11 = t11(e11[o11 - 1], e11[o11]);
            if (0 < i11 || 0 == i11 && r11) return !1;
        }
        return !0;
    }, goog.array.equals = function(e11, t11, r11) {
        if (!goog.isArrayLike(e11) || !goog.isArrayLike(t11) || e11.length != t11.length) return !1;
        var o11 = e11.length;
        r11 = r11 || goog.array.defaultCompareEquality;
        for(var i11 = 0; i11 < o11; i11++)if (!r11(e11[i11], t11[i11])) return !1;
        return !0;
    }, goog.array.compare3 = function(e11, t11, r11) {
        r11 = r11 || goog.array.defaultCompare;
        for(var o11 = Math.min(e11.length, t11.length), i11 = 0; i11 < o11; i11++){
            var a11 = r11(e11[i11], t11[i11]);
            if (0 != a11) return a11;
        }
        return goog.array.defaultCompare(e11.length, t11.length);
    }, goog.array.defaultCompare = function(e11, t11) {
        return e11 > t11 ? 1 : e11 < t11 ? -1 : 0;
    }, goog.array.inverseDefaultCompare = function(e11, t11) {
        return -goog.array.defaultCompare(e11, t11);
    }, goog.array.defaultCompareEquality = function(e11, t11) {
        return e11 === t11;
    }, goog.array.binaryInsert = function(e11, t11, r11) {
        return 0 > (r11 = goog.array.binarySearch(e11, t11, r11)) && (goog.array.insertAt(e11, t11, -(r11 + 1)), !0);
    }, goog.array.binaryRemove = function(e11, t11, r11) {
        return 0 <= (t11 = goog.array.binarySearch(e11, t11, r11)) && goog.array.removeAt(e11, t11);
    }, goog.array.bucket = function(e11, t11, r11) {
        for(var o11 = {}, i11 = 0; i11 < e11.length; i11++){
            var a11 = e11[i11], n11 = t11.call(r11, a11, i11, e11);
            void 0 !== n11 && (o11[n11] || (o11[n11] = [])).push(a11);
        }
        return o11;
    }, goog.array.toObject = function(e11, t11, r11) {
        var o11 = {};
        return goog.array.forEach(e11, function(i11, a11) {
            o11[t11.call(r11, i11, a11, e11)] = i11;
        }), o11;
    }, goog.array.range = function(e11, t11, r11) {
        var o11 = [], i11 = 0, a11 = e11;
        if (void 0 !== t11 && (i11 = e11, a11 = t11), 0 > (r11 = r11 || 1) * (a11 - i11)) return [];
        if (0 < r11) for(e11 = i11; e11 < a11; e11 += r11)o11.push(e11);
        else for(e11 = i11; e11 > a11; e11 += r11)o11.push(e11);
        return o11;
    }, goog.array.repeat = function(e11, t11) {
        for(var r11 = [], o11 = 0; o11 < t11; o11++)r11[o11] = e11;
        return r11;
    }, goog.array.flatten = function(e11) {
        for(var t11 = [], r11 = 0; r11 < arguments.length; r11++){
            var o11 = arguments[r11];
            if (Array.isArray(o11)) for(var i11 = 0; i11 < o11.length; i11 += 8192){
                var a11 = goog.array.slice(o11, i11, i11 + 8192);
                a11 = goog.array.flatten.apply(null, a11);
                for(var n11 = 0; n11 < a11.length; n11++)t11.push(a11[n11]);
            }
            else t11.push(o11);
        }
        return t11;
    }, goog.array.rotate = function(e11, t11) {
        return goog.asserts.assert(null != e11.length), e11.length && (0 < (t11 %= e11.length) ? Array.prototype.unshift.apply(e11, e11.splice(-t11, t11)) : 0 > t11 && Array.prototype.push.apply(e11, e11.splice(0, -t11))), e11;
    }, goog.array.moveItem = function(e11, t11, r11) {
        goog.asserts.assert(0 <= t11 && t11 < e11.length), goog.asserts.assert(0 <= r11 && r11 < e11.length), t11 = Array.prototype.splice.call(e11, t11, 1), Array.prototype.splice.call(e11, r11, 0, t11[0]);
    }, goog.array.zip = function(e11) {
        if (!arguments.length) return [];
        for(var t11 = [], r11 = arguments[0].length, o11 = 1; o11 < arguments.length; o11++)arguments[o11].length < r11 && (r11 = arguments[o11].length);
        for(o11 = 0; o11 < r11; o11++){
            for(var i11 = [], a11 = 0; a11 < arguments.length; a11++)i11.push(arguments[a11][o11]);
            t11.push(i11);
        }
        return t11;
    }, goog.array.shuffle = function(e11, t11) {
        t11 = t11 || Math.random;
        for(var r11 = e11.length - 1; 0 < r11; r11--){
            var o11 = Math.floor(t11() * (r11 + 1)), i11 = e11[r11];
            e11[r11] = e11[o11], e11[o11] = i11;
        }
    }, goog.array.copyByIndex = function(e11, t11) {
        var r11 = [];
        return goog.array.forEach(t11, function(t11) {
            r11.push(e11[t11]);
        }), r11;
    }, goog.array.concatMap = function(e11, t11, r11) {
        return goog.array.concat.apply([], goog.array.map(e11, t11, r11));
    }, goog.crypt = {}, goog.crypt.stringToByteArray = function(e11) {
        for(var t11 = [], r11 = 0, o11 = 0; o11 < e11.length; o11++){
            var i11 = e11.charCodeAt(o11);
            255 < i11 && (t11[r11++] = 255 & i11, i11 >>= 8), t11[r11++] = i11;
        }
        return t11;
    }, goog.crypt.byteArrayToString = function(e11) {
        if (8192 >= e11.length) return String.fromCharCode.apply(null, e11);
        for(var t11 = "", r11 = 0; r11 < e11.length; r11 += 8192){
            var o11 = goog.array.slice(e11, r11, r11 + 8192);
            t11 += String.fromCharCode.apply(null, o11);
        }
        return t11;
    }, goog.crypt.byteArrayToHex = function(e11, t11) {
        return goog.array.map(e11, function(e11) {
            return 1 < (e11 = e11.toString(16)).length ? e11 : "0" + e11;
        }).join(t11 || "");
    }, goog.crypt.hexToByteArray = function(e11) {
        goog.asserts.assert(0 == e11.length % 2, "Key string length must be multiple of 2");
        for(var t11 = [], r11 = 0; r11 < e11.length; r11 += 2)t11.push(parseInt(e11.substring(r11, r11 + 2), 16));
        return t11;
    }, goog.crypt.stringToUtf8ByteArray = function(e11) {
        for(var t11 = [], r11 = 0, o11 = 0; o11 < e11.length; o11++){
            var i11 = e11.charCodeAt(o11);
            128 > i11 ? t11[r11++] = i11 : (2048 > i11 ? t11[r11++] = i11 >> 6 | 192 : (55296 == (64512 & i11) && o11 + 1 < e11.length && 56320 == (64512 & e11.charCodeAt(o11 + 1)) ? (i11 = 65536 + ((1023 & i11) << 10) + (1023 & e11.charCodeAt(++o11)), t11[r11++] = i11 >> 18 | 240, t11[r11++] = i11 >> 12 & 63 | 128) : t11[r11++] = i11 >> 12 | 224, t11[r11++] = i11 >> 6 & 63 | 128), t11[r11++] = 63 & i11 | 128);
        }
        return t11;
    }, goog.crypt.utf8ByteArrayToString = function(e11) {
        for(var t11 = [], r11 = 0, o11 = 0; r11 < e11.length;){
            var i11 = e11[r11++];
            if (128 > i11) t11[o11++] = String.fromCharCode(i11);
            else if (191 < i11 && 224 > i11) {
                var a11 = e11[r11++];
                t11[o11++] = String.fromCharCode((31 & i11) << 6 | 63 & a11);
            } else if (239 < i11 && 365 > i11) {
                a11 = e11[r11++];
                var n11 = e11[r11++];
                i11 = ((7 & i11) << 18 | (63 & a11) << 12 | (63 & n11) << 6 | 63 & e11[r11++]) - 65536, t11[o11++] = String.fromCharCode(55296 + (i11 >> 10)), t11[o11++] = String.fromCharCode(56320 + (1023 & i11));
            } else a11 = e11[r11++], n11 = e11[r11++], t11[o11++] = String.fromCharCode((15 & i11) << 12 | (63 & a11) << 6 | 63 & n11);
        }
        return t11.join("");
    }, goog.crypt.xorByteArray = function(e11, t11) {
        goog.asserts.assert(e11.length == t11.length, "XOR array lengths must match");
        for(var r11 = [], o11 = 0; o11 < e11.length; o11++)r11.push(e11[o11] ^ t11[o11]);
        return r11;
    }, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function(e11) {
        if (goog.asserts.ENABLE_ASSERTS) {
            var t11 = goog.dom.asserts.getWindow_(e11);
            t11 && (!e11 || !(e11 instanceof t11.Location) && e11 instanceof t11.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(e11));
        }
        return e11;
    }, goog.dom.asserts.assertIsElementType_ = function(e11, t11) {
        if (goog.asserts.ENABLE_ASSERTS) {
            var r11 = goog.dom.asserts.getWindow_(e11);
            r11 && void 0 !== r11[t11] && (e11 && (e11 instanceof r11[t11] || !(e11 instanceof r11.Location || e11 instanceof r11.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", t11, goog.dom.asserts.debugStringForType_(e11)));
        }
        return e11;
    }, goog.dom.asserts.assertIsHTMLAnchorElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLAnchorElement");
    }, goog.dom.asserts.assertIsHTMLButtonElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLButtonElement");
    }, goog.dom.asserts.assertIsHTMLLinkElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLLinkElement");
    }, goog.dom.asserts.assertIsHTMLImageElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLImageElement");
    }, goog.dom.asserts.assertIsHTMLAudioElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLAudioElement");
    }, goog.dom.asserts.assertIsHTMLVideoElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLVideoElement");
    }, goog.dom.asserts.assertIsHTMLInputElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLInputElement");
    }, goog.dom.asserts.assertIsHTMLTextAreaElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLTextAreaElement");
    }, goog.dom.asserts.assertIsHTMLCanvasElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLCanvasElement");
    }, goog.dom.asserts.assertIsHTMLEmbedElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLEmbedElement");
    }, goog.dom.asserts.assertIsHTMLFormElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLFormElement");
    }, goog.dom.asserts.assertIsHTMLFrameElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLFrameElement");
    }, goog.dom.asserts.assertIsHTMLIFrameElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLIFrameElement");
    }, goog.dom.asserts.assertIsHTMLObjectElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLObjectElement");
    }, goog.dom.asserts.assertIsHTMLScriptElement = function(e11) {
        return goog.dom.asserts.assertIsElementType_(e11, "HTMLScriptElement");
    }, goog.dom.asserts.debugStringForType_ = function(e11) {
        if (!goog.isObject(e11)) return void 0 === e11 ? "undefined" : null === e11 ? "null" : typeof e11;
        try {
            return e11.constructor.displayName || e11.constructor.name || Object.prototype.toString.call(e11);
        } catch (e11) {
            return "<object could not be stringified>";
        }
    }, goog.dom.asserts.getWindow_ = function(e11) {
        try {
            var t11 = e11 && e11.ownerDocument, r11 = t11 && (t11.defaultView || t11.parentWindow);
            if ((r11 = r11 || goog.global).Element && r11.Location) return r11;
        } catch (e11) {}
        return null;
    }, goog.functions = {}, goog.functions.constant = function(e11) {
        return function() {
            return e11;
        };
    }, goog.functions.FALSE = function() {
        return !1;
    }, goog.functions.TRUE = function() {
        return !0;
    }, goog.functions.NULL = function() {
        return null;
    }, goog.functions.identity = function(e11, t11) {
        return e11;
    }, goog.functions.error = function(e11) {
        return function() {
            throw Error(e11);
        };
    }, goog.functions.fail = function(e11) {
        return function() {
            throw e11;
        };
    }, goog.functions.lock = function(e11, t11) {
        return t11 = t11 || 0, function() {
            return e11.apply(this, Array.prototype.slice.call(arguments, 0, t11));
        };
    }, goog.functions.nth = function(e11) {
        return function() {
            return arguments[e11];
        };
    }, goog.functions.partialRight = function(e11, t11) {
        var r11 = Array.prototype.slice.call(arguments, 1);
        return function() {
            var t11 = Array.prototype.slice.call(arguments);
            return t11.push.apply(t11, r11), e11.apply(this, t11);
        };
    }, goog.functions.withReturnValue = function(e11, t11) {
        return goog.functions.sequence(e11, goog.functions.constant(t11));
    }, goog.functions.equalTo = function(e11, t11) {
        return function(r11) {
            return t11 ? e11 == r11 : e11 === r11;
        };
    }, goog.functions.compose = function(e11, t11) {
        var r11 = arguments, o11 = r11.length;
        return function() {
            var e11;
            o11 && (e11 = r11[o11 - 1].apply(this, arguments));
            for(var t11 = o11 - 2; 0 <= t11; t11--)e11 = r11[t11].call(this, e11);
            return e11;
        };
    }, goog.functions.sequence = function(e11) {
        var t11 = arguments, r11 = t11.length;
        return function() {
            for(var e11, o11 = 0; o11 < r11; o11++)e11 = t11[o11].apply(this, arguments);
            return e11;
        };
    }, goog.functions.and = function(e11) {
        var t11 = arguments, r11 = t11.length;
        return function() {
            for(var e11 = 0; e11 < r11; e11++)if (!t11[e11].apply(this, arguments)) return !1;
            return !0;
        };
    }, goog.functions.or = function(e11) {
        var t11 = arguments, r11 = t11.length;
        return function() {
            for(var e11 = 0; e11 < r11; e11++)if (t11[e11].apply(this, arguments)) return !0;
            return !1;
        };
    }, goog.functions.not = function(e11) {
        return function() {
            return !e11.apply(this, arguments);
        };
    }, goog.functions.create = function(e11, t11) {
        var r11 = function() {};
        return r11.prototype = e11.prototype, r11 = new r11, e11.apply(r11, Array.prototype.slice.call(arguments, 1)), r11;
    }, goog.functions.CACHE_RETURN_VALUE = !0, goog.functions.cacheReturnValue = function(e11) {
        var t11, r11 = !1;
        return function() {
            return goog.functions.CACHE_RETURN_VALUE ? (r11 || (t11 = e11(), r11 = !0), t11) : e11();
        };
    }, goog.functions.once = function(e11) {
        var t11 = e11;
        return function() {
            if (t11) {
                var e11 = t11;
                t11 = null, e11();
            }
        };
    }, goog.functions.debounce = function(e11, t11, r11) {
        var o11 = 0;
        return function(i11) {
            goog.global.clearTimeout(o11);
            var a11 = arguments;
            o11 = goog.global.setTimeout(function() {
                e11.apply(r11, a11);
            }, t11);
        };
    }, goog.functions.throttle = function(e11, t11, r11) {
        var o11 = 0, i11 = !1, a11 = [], n11 = function() {
            o11 = 0, i11 && (i11 = !1, s11());
        }, s11 = function() {
            o11 = goog.global.setTimeout(n11, t11), e11.apply(r11, a11);
        };
        return function(e11) {
            a11 = arguments, o11 ? i11 = !0 : s11();
        };
    }, goog.functions.rateLimit = function(e11, t11, r11) {
        var o11 = 0, i11 = function() {
            o11 = 0;
        };
        return function(a11) {
            o11 || (o11 = goog.global.setTimeout(i11, t11), e11.apply(r11, arguments));
        };
    }, goog.dom.HtmlElement = function() {}, goog.dom.TagName = function(e11) {
        this.tagName_ = e11;
    }, goog.dom.TagName.prototype.toString = function() {
        return this.tagName_;
    }, goog.dom.TagName.A = new goog.dom.TagName("A"), goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR"), goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM"), goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS"), goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET"), goog.dom.TagName.AREA = new goog.dom.TagName("AREA"), goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE"), goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE"), goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO"), goog.dom.TagName.B = new goog.dom.TagName("B"), goog.dom.TagName.BASE = new goog.dom.TagName("BASE"), goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT"), goog.dom.TagName.BDI = new goog.dom.TagName("BDI"), goog.dom.TagName.BDO = new goog.dom.TagName("BDO"), goog.dom.TagName.BIG = new goog.dom.TagName("BIG"), goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE"), goog.dom.TagName.BODY = new goog.dom.TagName("BODY"), goog.dom.TagName.BR = new goog.dom.TagName("BR"), goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON"), goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS"), goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION"), goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER"), goog.dom.TagName.CITE = new goog.dom.TagName("CITE"), goog.dom.TagName.CODE = new goog.dom.TagName("CODE"), goog.dom.TagName.COL = new goog.dom.TagName("COL"), goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP"), goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND"), goog.dom.TagName.DATA = new goog.dom.TagName("DATA"), goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST"), goog.dom.TagName.DD = new goog.dom.TagName("DD"), goog.dom.TagName.DEL = new goog.dom.TagName("DEL"), goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS"), goog.dom.TagName.DFN = new goog.dom.TagName("DFN"), goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG"), goog.dom.TagName.DIR = new goog.dom.TagName("DIR"), goog.dom.TagName.DIV = new goog.dom.TagName("DIV"), goog.dom.TagName.DL = new goog.dom.TagName("DL"), goog.dom.TagName.DT = new goog.dom.TagName("DT"), goog.dom.TagName.EM = new goog.dom.TagName("EM"), goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED"), goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET"), goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION"), goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE"), goog.dom.TagName.FONT = new goog.dom.TagName("FONT"), goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER"), goog.dom.TagName.FORM = new goog.dom.TagName("FORM"), goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME"), goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET"), goog.dom.TagName.H1 = new goog.dom.TagName("H1"), goog.dom.TagName.H2 = new goog.dom.TagName("H2"), goog.dom.TagName.H3 = new goog.dom.TagName("H3"), goog.dom.TagName.H4 = new goog.dom.TagName("H4"), goog.dom.TagName.H5 = new goog.dom.TagName("H5"), goog.dom.TagName.H6 = new goog.dom.TagName("H6"), goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD"), goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER"), goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP"), goog.dom.TagName.HR = new goog.dom.TagName("HR"), goog.dom.TagName.HTML = new goog.dom.TagName("HTML"), goog.dom.TagName.I = new goog.dom.TagName("I"), goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME"), goog.dom.TagName.IMG = new goog.dom.TagName("IMG"), goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT"), goog.dom.TagName.INS = new goog.dom.TagName("INS"), goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX"), goog.dom.TagName.KBD = new goog.dom.TagName("KBD"), goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN"), goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL"), goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND"), goog.dom.TagName.LI = new goog.dom.TagName("LI"), goog.dom.TagName.LINK = new goog.dom.TagName("LINK"), goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN"), goog.dom.TagName.MAP = new goog.dom.TagName("MAP"), goog.dom.TagName.MARK = new goog.dom.TagName("MARK"), goog.dom.TagName.MATH = new goog.dom.TagName("MATH"), goog.dom.TagName.MENU = new goog.dom.TagName("MENU"), goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM"), goog.dom.TagName.META = new goog.dom.TagName("META"), goog.dom.TagName.METER = new goog.dom.TagName("METER"), goog.dom.TagName.NAV = new goog.dom.TagName("NAV"), goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES"), goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT"), goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT"), goog.dom.TagName.OL = new goog.dom.TagName("OL"), goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP"), goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION"), goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT"), goog.dom.TagName.P = new goog.dom.TagName("P"), goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM"), goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE"), goog.dom.TagName.PRE = new goog.dom.TagName("PRE"), goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS"), goog.dom.TagName.Q = new goog.dom.TagName("Q"), goog.dom.TagName.RP = new goog.dom.TagName("RP"), goog.dom.TagName.RT = new goog.dom.TagName("RT"), goog.dom.TagName.RTC = new goog.dom.TagName("RTC"), goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY"), goog.dom.TagName.S = new goog.dom.TagName("S"), goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP"), goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT"), goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION"), goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT"), goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL"), goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE"), goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN"), goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE"), goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG"), goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE"), goog.dom.TagName.SUB = new goog.dom.TagName("SUB"), goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY"), goog.dom.TagName.SUP = new goog.dom.TagName("SUP"), goog.dom.TagName.SVG = new goog.dom.TagName("SVG"), goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE"), goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY"), goog.dom.TagName.TD = new goog.dom.TagName("TD"), goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE"), goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA"), goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT"), goog.dom.TagName.TH = new goog.dom.TagName("TH"), goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD"), goog.dom.TagName.TIME = new goog.dom.TagName("TIME"), goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE"), goog.dom.TagName.TR = new goog.dom.TagName("TR"), goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK"), goog.dom.TagName.TT = new goog.dom.TagName("TT"), goog.dom.TagName.U = new goog.dom.TagName("U"), goog.dom.TagName.UL = new goog.dom.TagName("UL"), goog.dom.TagName.VAR = new goog.dom.TagName("VAR"), goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO"), goog.dom.TagName.WBR = new goog.dom.TagName("WBR"), goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        command: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
    }, goog.dom.tags.isVoidTag = function(e11) {
        return !0 === goog.dom.tags.VOID_TAGS_[e11];
    }, goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null, goog.string = {}, goog.string.TypedString = function() {}, goog.string.Const = function(e11, t11) {
        this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = e11 === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && t11 || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
    }, goog.string.Const.prototype.implementsGoogStringTypedString = !0, goog.string.Const.prototype.getTypedStringValue = function() {
        return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
    }, goog.DEBUG && (goog.string.Const.prototype.toString = function() {
        return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
    }), goog.string.Const.unwrap = function(e11) {
        return e11 instanceof goog.string.Const && e11.constructor === goog.string.Const && e11.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? e11.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + e11 + "'"), "type_error:Const");
    }, goog.string.Const.from = function(e11) {
        return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, e11);
    }, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.html.SafeScript = function() {
        this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "", this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    }, goog.html.SafeScript.prototype.implementsGoogStringTypedString = !0, goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeScript.fromConstant = function(e11) {
        return 0 === (e11 = goog.string.Const.unwrap(e11)).length ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SafeScript.fromConstantAndArgs = function(e11, t11) {
        for(var r11 = [], o11 = 1; o11 < arguments.length; o11++)r11.push(goog.html.SafeScript.stringify_(arguments[o11]));
        return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(e11) + ")(" + r11.join(", ") + ");");
    }, goog.html.SafeScript.fromJson = function(e11) {
        return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(e11));
    }, goog.html.SafeScript.prototype.getTypedStringValue = function() {
        return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
    }, goog.DEBUG && (goog.html.SafeScript.prototype.toString = function() {
        return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
    }), goog.html.SafeScript.unwrap = function(e11) {
        return goog.html.SafeScript.unwrapTrustedScript(e11).toString();
    }, goog.html.SafeScript.unwrapTrustedScript = function(e11) {
        return e11 instanceof goog.html.SafeScript && e11.constructor === goog.html.SafeScript && e11.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e11.privateDoNotAccessOrElseSafeScriptWrappedValue_ : (goog.asserts.fail("expected object of type SafeScript, got '" + e11 + "' of type " + goog.typeOf(e11)), "type_error:SafeScript");
    }, goog.html.SafeScript.stringify_ = function(e11) {
        return JSON.stringify(e11).replace(/</g, "\\x3c");
    }, goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(e11) {
        return (new goog.html.SafeScript).initSecurityPrivateDoNotAccessOrElse_(e11);
    }, goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(e11) {
        return this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(e11) : e11, this;
    }, goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(""), goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function(e11) {
        return goog.fs.url.getUrlObject_().createObjectURL(e11);
    }, goog.fs.url.revokeObjectUrl = function(e11) {
        goog.fs.url.getUrlObject_().revokeObjectURL(e11);
    }, goog.fs.url.UrlObject_ = function() {}, goog.fs.url.UrlObject_.prototype.createObjectURL = function(e11) {}, goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(e11) {}, goog.fs.url.getUrlObject_ = function() {
        var e11 = goog.fs.url.findUrlObject_();
        if (null != e11) return e11;
        throw Error("This browser doesn't seem to support blob URLs");
    }, goog.fs.url.findUrlObject_ = function() {
        return void 0 !== goog.global.URL && void 0 !== goog.global.URL.createObjectURL ? goog.global.URL : void 0 !== goog.global.webkitURL && void 0 !== goog.global.webkitURL.createObjectURL ? goog.global.webkitURL : void 0 !== goog.global.createObjectURL ? goog.global : null;
    }, goog.fs.url.browserSupportsObjectUrls = function() {
        return null != goog.fs.url.findUrlObject_();
    }, goog.fs.blob = {}, goog.fs.blob.getBlob = function(e11) {
        var t11 = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
        if (void 0 !== t11) {
            t11 = new t11;
            for(var r11 = 0; r11 < arguments.length; r11++)t11.append(arguments[r11]);
            return t11.getBlob();
        }
        return goog.fs.blob.getBlobWithProperties(goog.array.toArray(arguments));
    }, goog.fs.blob.getBlobWithProperties = function(e11, t11, r11) {
        var o11 = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
        if (void 0 !== o11) {
            o11 = new o11;
            for(var i11 = 0; i11 < e11.length; i11++)o11.append(e11[i11], r11);
            return o11.getBlob(t11);
        }
        if (void 0 !== goog.global.Blob) return o11 = {}, t11 && (o11.type = t11), r11 && (o11.endings = r11), new Blob(e11, o11);
        throw Error("This browser doesn't seem to support creating Blobs");
    }, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = !1, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase()), goog.i18n.bidi.Format = {
        LRE: "\u202A",
        RLE: "\u202B",
        PDF: "\u202C",
        LRM: "\u200E",
        RLM: "\u200F"
    }, goog.i18n.bidi.Dir = {
        LTR: 1,
        RTL: -1,
        NEUTRAL: 0
    }, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function(e11, t11) {
        return "number" == typeof e11 ? 0 < e11 ? goog.i18n.bidi.Dir.LTR : 0 > e11 ? goog.i18n.bidi.Dir.RTL : t11 ? null : goog.i18n.bidi.Dir.NEUTRAL : null == e11 ? null : e11 ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
    }, goog.i18n.bidi.ltrChars_ = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\ud801\ud804-\ud839\ud83c-\udbff\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF", goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\ud802-\ud803\ud83a-\ud83b\uFB1D-\uFDFF\uFE70-\uFEFC", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function(e11, t11) {
        return t11 ? e11.replace(goog.i18n.bidi.htmlSkipReg_, "") : e11;
    }, goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function(e11, t11) {
        return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e11, t11));
    }, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function(e11, t11) {
        return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e11, t11));
    }, goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function(e11) {
        return goog.i18n.bidi.rtlRe_.test(e11);
    }, goog.i18n.bidi.isLtrChar = function(e11) {
        return goog.i18n.bidi.ltrRe_.test(e11);
    }, goog.i18n.bidi.isNeutralChar = function(e11) {
        return !goog.i18n.bidi.isLtrChar(e11) && !goog.i18n.bidi.isRtlChar(e11);
    }, goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function(e11, t11) {
        return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e11, t11));
    }, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function(e11, t11) {
        return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e11, t11));
    }, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function(e11, t11) {
        return e11 = goog.i18n.bidi.stripHtmlIfNeeded_(e11, t11), goog.i18n.bidi.isRequiredLtrRe_.test(e11) || !goog.i18n.bidi.hasAnyLtr(e11) && !goog.i18n.bidi.hasAnyRtl(e11);
    }, goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function(e11, t11) {
        return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e11, t11));
    }, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function(e11, t11) {
        return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e11, t11));
    }, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function(e11) {
        return goog.i18n.bidi.rtlLocalesRe_.test(e11);
    }, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function(e11, t11) {
        return t11 = (void 0 === t11 ? goog.i18n.bidi.hasAnyRtl(e11) : t11) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, e11.replace(goog.i18n.bidi.bracketGuardTextRe_, t11 + "$&" + t11);
    }, goog.i18n.bidi.enforceRtlInHtml = function(e11) {
        return "<" == e11.charAt(0) ? e11.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + e11 + "</span>";
    }, goog.i18n.bidi.enforceRtlInText = function(e11) {
        return goog.i18n.bidi.Format.RLE + e11 + goog.i18n.bidi.Format.PDF;
    }, goog.i18n.bidi.enforceLtrInHtml = function(e11) {
        return "<" == e11.charAt(0) ? e11.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + e11 + "</span>";
    }, goog.i18n.bidi.enforceLtrInText = function(e11) {
        return goog.i18n.bidi.Format.LRE + e11 + goog.i18n.bidi.Format.PDF;
    }, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function(e11) {
        return e11.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
    }, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function(e11) {
        return e11.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05F3");
    }, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = .4, goog.i18n.bidi.estimateDirection = function(e11, t11) {
        var r11 = 0, o11 = 0, i11 = !1;
        for(e11 = goog.i18n.bidi.stripHtmlIfNeeded_(e11, t11).split(goog.i18n.bidi.wordSeparatorRe_), t11 = 0; t11 < e11.length; t11++){
            var a11 = e11[t11];
            goog.i18n.bidi.startsWithRtl(a11) ? (r11++, o11++) : goog.i18n.bidi.isRequiredLtrRe_.test(a11) ? i11 = !0 : goog.i18n.bidi.hasAnyLtr(a11) ? o11++ : goog.i18n.bidi.hasNumeralsRe_.test(a11) && (i11 = !0);
        }
        return 0 == o11 ? i11 ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : r11 / o11 > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
    }, goog.i18n.bidi.detectRtlDirectionality = function(e11, t11) {
        return goog.i18n.bidi.estimateDirection(e11, t11) == goog.i18n.bidi.Dir.RTL;
    }, goog.i18n.bidi.setElementDirAndAlign = function(e11, t11) {
        e11 && (t11 = goog.i18n.bidi.toDir(t11)) && (e11.style.textAlign = t11 == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, e11.dir = t11 == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
    }, goog.i18n.bidi.setElementDirByTextDirectionality = function(e11, t11) {
        switch(goog.i18n.bidi.estimateDirection(t11)){
            case goog.i18n.bidi.Dir.LTR:
                e11.dir = "ltr";
                break;
            case goog.i18n.bidi.Dir.RTL:
                e11.dir = "rtl";
                break;
            default:
                e11.removeAttribute("dir");
        }
    }, goog.i18n.bidi.DirectionalString = function() {}, goog.html.TrustedResourceUrl = function(e11, t11) {
        this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = e11 === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && t11 || "", this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    }, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
        return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
    }, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.TrustedResourceUrl.prototype.getDirection = function() {
        return goog.i18n.bidi.Dir.LTR;
    }, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(e11, t11) {
        var r11 = goog.html.TrustedResourceUrl.unwrap(this), o11 = (r11 = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(r11))[3] || "";
        return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(r11[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", r11[2] || "", e11) + goog.html.TrustedResourceUrl.stringifyParams_("#", o11, t11));
    }, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
        return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
    }), goog.html.TrustedResourceUrl.unwrap = function(e11) {
        return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(e11).toString();
    }, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(e11) {
        return e11 instanceof goog.html.TrustedResourceUrl && e11.constructor === goog.html.TrustedResourceUrl && e11.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e11.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + e11 + "' of type " + goog.typeOf(e11)), "type_error:TrustedResourceUrl");
    }, goog.html.TrustedResourceUrl.format = function(e11, t11) {
        var r11 = goog.string.Const.unwrap(e11);
        if (!goog.html.TrustedResourceUrl.BASE_URL_.test(r11)) throw Error("Invalid TrustedResourceUrl format: " + r11);
        return e11 = r11.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(e11, o11) {
            if (!Object.prototype.hasOwnProperty.call(t11, o11)) throw Error('Found marker, "' + o11 + '", in format string, "' + r11 + '", but no valid label mapping found in args: ' + JSON.stringify(t11));
            return (e11 = t11[o11]) instanceof goog.string.Const ? goog.string.Const.unwrap(e11) : encodeURIComponent(String(e11));
        }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function(e11, t11, r11, o11) {
        return goog.html.TrustedResourceUrl.format(e11, t11).cloneWithParams(r11, o11);
    }, goog.html.TrustedResourceUrl.fromConstant = function(e11) {
        return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e11));
    }, goog.html.TrustedResourceUrl.fromConstants = function(e11) {
        for(var t11 = "", r11 = 0; r11 < e11.length; r11++)t11 += goog.string.Const.unwrap(e11[r11]);
        return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t11);
    }, goog.html.TrustedResourceUrl.fromSafeScript = function(e11) {
        return e11 = goog.fs.blob.getBlobWithProperties([
            goog.html.SafeScript.unwrap(e11)
        ], "text/javascript"), e11 = goog.fs.url.createObjectUrl(e11), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(e11) {
        return e11 = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(e11) : e11, new goog.html.TrustedResourceUrl(goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_, e11);
    }, goog.html.TrustedResourceUrl.stringifyParams_ = function(e11, t11, r11) {
        if (null == r11) return t11;
        if ("string" == typeof r11) return r11 ? e11 + encodeURIComponent(r11) : "";
        for(var o11 in r11){
            var i11 = r11[o11];
            i11 = Array.isArray(i11) ? i11 : [
                i11
            ];
            for(var a11 = 0; a11 < i11.length; a11++){
                var n11 = i11[a11];
                null != n11 && (t11 || (t11 = e11), t11 += (t11.length > e11.length ? "&" : "") + encodeURIComponent(o11) + "=" + encodeURIComponent(String(n11)));
            }
        }
        return t11;
    }, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.internal = {}, goog.string.internal.startsWith = function(e11, t11) {
        return 0 == e11.lastIndexOf(t11, 0);
    }, goog.string.internal.endsWith = function(e11, t11) {
        var r11 = e11.length - t11.length;
        return 0 <= r11 && e11.indexOf(t11, r11) == r11;
    }, goog.string.internal.caseInsensitiveStartsWith = function(e11, t11) {
        return 0 == goog.string.internal.caseInsensitiveCompare(t11, e11.substr(0, t11.length));
    }, goog.string.internal.caseInsensitiveEndsWith = function(e11, t11) {
        return 0 == goog.string.internal.caseInsensitiveCompare(t11, e11.substr(e11.length - t11.length, t11.length));
    }, goog.string.internal.caseInsensitiveEquals = function(e11, t11) {
        return e11.toLowerCase() == t11.toLowerCase();
    }, goog.string.internal.isEmptyOrWhitespace = function(e11) {
        return /^[\s\xa0]*$/.test(e11);
    }, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(e11) {
        return e11.trim();
    } : function(e11) {
        return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e11)[1];
    }, goog.string.internal.caseInsensitiveCompare = function(e11, t11) {
        return (e11 = String(e11).toLowerCase()) < (t11 = String(t11).toLowerCase()) ? -1 : e11 == t11 ? 0 : 1;
    }, goog.string.internal.newLineToBr = function(e11, t11) {
        return e11.replace(/(\r\n|\r|\n)/g, t11 ? "<br />" : "<br>");
    }, goog.string.internal.htmlEscape = function(e11, t11) {
        if (t11) e11 = e11.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
        else {
            if (!goog.string.internal.ALL_RE_.test(e11)) return e11;
            -1 != e11.indexOf("&") && (e11 = e11.replace(goog.string.internal.AMP_RE_, "&amp;")), -1 != e11.indexOf("<") && (e11 = e11.replace(goog.string.internal.LT_RE_, "&lt;")), -1 != e11.indexOf(">") && (e11 = e11.replace(goog.string.internal.GT_RE_, "&gt;")), -1 != e11.indexOf('"') && (e11 = e11.replace(goog.string.internal.QUOT_RE_, "&quot;")), -1 != e11.indexOf("'") && (e11 = e11.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), -1 != e11.indexOf("\x00") && (e11 = e11.replace(goog.string.internal.NULL_RE_, "&#0;"));
        }
        return e11;
    }, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function(e11, t11) {
        return goog.string.internal.newLineToBr(e11.replace(/  /g, " &#160;"), t11);
    }, goog.string.internal.contains = function(e11, t11) {
        return -1 != e11.indexOf(t11);
    }, goog.string.internal.caseInsensitiveContains = function(e11, t11) {
        return goog.string.internal.contains(e11.toLowerCase(), t11.toLowerCase());
    }, goog.string.internal.compareVersions = function(e11, t11) {
        var r11 = 0;
        e11 = goog.string.internal.trim(String(e11)).split("."), t11 = goog.string.internal.trim(String(t11)).split(".");
        for(var o11 = Math.max(e11.length, t11.length), i11 = 0; 0 == r11 && i11 < o11; i11++){
            var a11 = e11[i11] || "", n11 = t11[i11] || "";
            do {
                if (a11 = /(\d*)(\D*)(.*)/.exec(a11) || [
                    "",
                    "",
                    "",
                    ""
                ], n11 = /(\d*)(\D*)(.*)/.exec(n11) || [
                    "",
                    "",
                    "",
                    ""
                ], 0 == a11[0].length && 0 == n11[0].length) break;
                r11 = 0 == a11[1].length ? 0 : parseInt(a11[1], 10);
                var s11 = 0 == n11[1].length ? 0 : parseInt(n11[1], 10);
                r11 = goog.string.internal.compareElements_(r11, s11) || goog.string.internal.compareElements_(0 == a11[2].length, 0 == n11[2].length) || goog.string.internal.compareElements_(a11[2], n11[2]), a11 = a11[3], n11 = n11[3];
            }while (0 == r11);
        }
        return r11;
    }, goog.string.internal.compareElements_ = function(e11, t11) {
        return e11 < t11 ? -1 : e11 > t11 ? 1 : 0;
    }, goog.html.SafeUrl = function(e11, t11) {
        this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = e11 === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ && t11 || "", this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    }, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0, goog.html.SafeUrl.prototype.getTypedStringValue = function() {
        return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
    }, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeUrl.prototype.getDirection = function() {
        return goog.i18n.bidi.Dir.LTR;
    }, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
        return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
    }), goog.html.SafeUrl.unwrap = function(e11) {
        return e11 instanceof goog.html.SafeUrl && e11.constructor === goog.html.SafeUrl && e11.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e11.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + e11 + "' of type " + goog.typeOf(e11)), "type_error:SafeUrl");
    }, goog.html.SafeUrl.fromConstant = function(e11) {
        return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e11));
    }, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function(e11) {
        return goog.html.SAFE_MIME_TYPE_PATTERN_.test(e11);
    }, goog.html.SafeUrl.fromBlob = function(e11) {
        return e11 = goog.html.SafeUrl.isSafeMimeType(e11.type) ? goog.fs.url.createObjectUrl(e11) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SafeUrl.fromMediaSource = function(e11) {
        return goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource"), e11 = e11 instanceof MediaSource ? goog.fs.url.createObjectUrl(e11) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.fromDataUrl = function(e11) {
        var t11 = (e11 = e11.replace(/(%0A|%0D)/g, "")).match(goog.html.DATA_URL_PATTERN_);
        return t11 = t11 && goog.html.SafeUrl.isSafeMimeType(t11[1]), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t11 ? e11 : goog.html.SafeUrl.INNOCUOUS_STRING);
    }, goog.html.SafeUrl.fromTelUrl = function(e11) {
        return goog.string.internal.caseInsensitiveStartsWith(e11, "tel:") || (e11 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function(e11) {
        return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(e11)) || (e11 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SafeUrl.fromFacebookMessengerUrl = function(e11) {
        return goog.string.internal.caseInsensitiveStartsWith(e11, "fb-messenger://share") || (e11 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SafeUrl.fromWhatsAppUrl = function(e11) {
        return goog.string.internal.caseInsensitiveStartsWith(e11, "whatsapp://send") || (e11 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SafeUrl.fromSmsUrl = function(e11) {
        return goog.string.internal.caseInsensitiveStartsWith(e11, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(e11) || (e11 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SafeUrl.isSmsUrlBodyValid_ = function(e11) {
        var t11 = e11.indexOf("#");
        if (0 < t11 && (e11 = e11.substring(0, t11)), !(t11 = e11.match(/[?&]body=/gi))) return !0;
        if (1 < t11.length) return !1;
        if (!(e11 = e11.match(/[?&]body=([^&]*)/)[1])) return !0;
        try {
            decodeURIComponent(e11);
        } catch (e11) {
            return !1;
        }
        return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(e11);
    }, goog.html.SafeUrl.fromSshUrl = function(e11) {
        return goog.string.internal.caseInsensitiveStartsWith(e11, "ssh://") || (e11 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(e11, t11) {
        return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, e11, t11);
    }, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(e11, t11) {
        return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, e11, t11);
    }, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(e11, t11) {
        return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, e11, t11);
    }, goog.html.SafeUrl.sanitizeExtensionUrl_ = function(e11, t11, r11) {
        return (e11 = e11.exec(t11)) ? (e11 = e11[1], -1 == (r11 instanceof goog.string.Const ? [
            goog.string.Const.unwrap(r11)
        ] : r11.map(function(e11) {
            return goog.string.Const.unwrap(e11);
        })).indexOf(e11) && (t11 = goog.html.SafeUrl.INNOCUOUS_STRING)) : t11 = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t11);
    }, goog.html.SafeUrl.fromTrustedResourceUrl = function(e11) {
        return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(e11));
    }, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.sanitize = function(e11) {
        return e11 instanceof goog.html.SafeUrl ? e11 : (e11 = "object" == typeof e11 && e11.implementsGoogStringTypedString ? e11.getTypedStringValue() : String(e11), goog.html.SAFE_URL_PATTERN_.test(e11) || (e11 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11));
    }, goog.html.SafeUrl.sanitizeAssertUnchanged = function(e11, t11) {
        return e11 instanceof goog.html.SafeUrl ? e11 : (e11 = "object" == typeof e11 && e11.implementsGoogStringTypedString ? e11.getTypedStringValue() : String(e11), t11 && /^data:/i.test(e11) && (t11 = goog.html.SafeUrl.fromDataUrl(e11)).getTypedStringValue() == e11 ? t11 : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(e11), "%s does not match the safe URL pattern", e11) || (e11 = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e11)));
    }, goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(e11) {
        return new goog.html.SafeUrl(goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_, e11);
    }, goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeStyle = function() {
        this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "", this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    }, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyle.fromConstant = function(e11) {
        return 0 === (e11 = goog.string.Const.unwrap(e11)).length ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(e11, ";"), "Last character of style string is not ';': " + e11), goog.asserts.assert(goog.string.internal.contains(e11, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + e11), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(e11));
    }, goog.html.SafeStyle.prototype.getTypedStringValue = function() {
        return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
    }, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
        return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
    }), goog.html.SafeStyle.unwrap = function(e11) {
        return e11 instanceof goog.html.SafeStyle && e11.constructor === goog.html.SafeStyle && e11.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e11.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + e11 + "' of type " + goog.typeOf(e11)), "type_error:SafeStyle");
    }, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(e11) {
        return (new goog.html.SafeStyle).initSecurityPrivateDoNotAccessOrElse_(e11);
    }, goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(e11) {
        return this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = e11, this;
    }, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function(e11) {
        var t11, r11 = "";
        for(t11 in e11){
            if (!/^[-_a-zA-Z0-9]+$/.test(t11)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + t11);
            var o11 = e11[t11];
            null != o11 && (r11 += t11 + ":" + (o11 = Array.isArray(o11) ? goog.array.map(o11, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(o11)) + ";");
        }
        return r11 ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(r11) : goog.html.SafeStyle.EMPTY;
    }, goog.html.SafeStyle.sanitizePropertyValue_ = function(e11) {
        if (e11 instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(e11).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
        if (e11 = e11 instanceof goog.string.Const ? goog.string.Const.unwrap(e11) : goog.html.SafeStyle.sanitizePropertyValueString_(String(e11)), /[{;}]/.test(e11)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [
            e11
        ]);
        return e11;
    }, goog.html.SafeStyle.sanitizePropertyValueString_ = function(e11) {
        var t11 = e11.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
        return goog.html.SafeStyle.VALUE_RE_.test(t11) ? goog.html.SafeStyle.COMMENT_RE_.test(e11) ? (goog.asserts.fail("String value disallows comments, got: " + e11), goog.html.SafeStyle.INNOCUOUS_STRING) : goog.html.SafeStyle.hasBalancedQuotes_(e11) ? goog.html.SafeStyle.hasBalancedSquareBrackets_(e11) ? goog.html.SafeStyle.sanitizeUrl_(e11) : (goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + e11), goog.html.SafeStyle.INNOCUOUS_STRING) : (goog.asserts.fail("String value requires balanced quotes, got: " + e11), goog.html.SafeStyle.INNOCUOUS_STRING) : (goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + e11), goog.html.SafeStyle.INNOCUOUS_STRING);
    }, goog.html.SafeStyle.hasBalancedQuotes_ = function(e11) {
        for(var t11 = !0, r11 = !0, o11 = 0; o11 < e11.length; o11++){
            var i11 = e11.charAt(o11);
            "'" == i11 && r11 ? t11 = !t11 : '"' == i11 && t11 && (r11 = !r11);
        }
        return t11 && r11;
    }, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(e11) {
        for(var t11 = !0, r11 = /^[-_a-zA-Z0-9]$/, o11 = 0; o11 < e11.length; o11++){
            var i11 = e11.charAt(o11);
            if ("]" == i11) {
                if (t11) return !1;
                t11 = !0;
            } else if ("[" == i11) {
                if (!t11) return !1;
                t11 = !1;
            } else if (!t11 && !r11.test(i11)) return !1;
        }
        return t11;
    }, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]", goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" "), goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g"), goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function(e11) {
        return e11.replace(goog.html.SafeStyle.URL_RE_, function(e11, t11, r11, o11) {
            var i11 = "";
            return r11 = r11.replace(/^(['"])(.*)\1$/, function(e11, t11, r11) {
                return i11 = t11, r11;
            }), e11 = goog.html.SafeUrl.sanitize(r11).getTypedStringValue(), t11 + i11 + e11 + i11 + o11;
        });
    }, goog.html.SafeStyle.concat = function(e11) {
        var t11 = "", r11 = function(e11) {
            Array.isArray(e11) ? goog.array.forEach(e11, r11) : t11 += goog.html.SafeStyle.unwrap(e11);
        };
        return goog.array.forEach(arguments, r11), t11 ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t11) : goog.html.SafeStyle.EMPTY;
    }, goog.html.SafeStyleSheet = function() {
        this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "", this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    }, goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeStyleSheet.createRule = function(e11, t11) {
        if (goog.string.internal.contains(e11, "<")) throw Error("Selector does not allow '<', got: " + e11);
        var r11 = e11.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
        if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(r11)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + e11);
        if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(r11)) throw Error("() and [] in selector must be balanced, got: " + e11);
        return t11 instanceof goog.html.SafeStyle || (t11 = goog.html.SafeStyle.create(t11)), e11 = e11 + "{" + goog.html.SafeStyle.unwrap(t11).replace(/</g, "\\3C ") + "}", goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e11);
    }, goog.html.SafeStyleSheet.hasBalancedBrackets_ = function(e11) {
        for(var t11 = {
            "(": ")",
            "[": "]"
        }, r11 = [], o11 = 0; o11 < e11.length; o11++){
            var i11 = e11[o11];
            if (t11[i11]) r11.push(t11[i11]);
            else if (goog.object.contains(t11, i11) && r11.pop() != i11) return !1;
        }
        return 0 == r11.length;
    }, goog.html.SafeStyleSheet.concat = function(e11) {
        var t11 = "", r11 = function(e11) {
            Array.isArray(e11) ? goog.array.forEach(e11, r11) : t11 += goog.html.SafeStyleSheet.unwrap(e11);
        };
        return goog.array.forEach(arguments, r11), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t11);
    }, goog.html.SafeStyleSheet.fromConstant = function(e11) {
        return 0 === (e11 = goog.string.Const.unwrap(e11)).length ? goog.html.SafeStyleSheet.EMPTY : (goog.asserts.assert(!goog.string.internal.contains(e11, "<"), "Forbidden '<' character in style sheet string: " + e11), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e11));
    }, goog.html.SafeStyleSheet.prototype.getTypedStringValue = function() {
        return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
    }, goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function() {
        return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
    }), goog.html.SafeStyleSheet.unwrap = function(e11) {
        return e11 instanceof goog.html.SafeStyleSheet && e11.constructor === goog.html.SafeStyleSheet && e11.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e11.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyleSheet, got '" + e11 + "' of type " + goog.typeOf(e11)), "type_error:SafeStyleSheet");
    }, goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(e11) {
        return (new goog.html.SafeStyleSheet).initSecurityPrivateDoNotAccessOrElse_(e11);
    }, goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(e11) {
        return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = e11, this;
    }, goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
        var e11 = goog.labs.userAgent.util.getNavigator_();
        return e11 && (e11 = e11.userAgent) ? e11 : "";
    }, goog.labs.userAgent.util.getNavigator_ = function() {
        return goog.global.navigator;
    }, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function(e11) {
        goog.labs.userAgent.util.userAgent_ = e11 || goog.labs.userAgent.util.getNativeUserAgentString_();
    }, goog.labs.userAgent.util.getUserAgent = function() {
        return goog.labs.userAgent.util.userAgent_;
    }, goog.labs.userAgent.util.matchUserAgent = function(e11) {
        var t11 = goog.labs.userAgent.util.getUserAgent();
        return goog.string.internal.contains(t11, e11);
    }, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(e11) {
        var t11 = goog.labs.userAgent.util.getUserAgent();
        return goog.string.internal.caseInsensitiveContains(t11, e11);
    }, goog.labs.userAgent.util.extractVersionTuples = function(e11) {
        for(var t11, r11 = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, o11 = []; t11 = r11.exec(e11);)o11.push([
            t11[1],
            t11[2],
            t11[3] || void 0
        ]);
        return o11;
    }, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("Opera");
    }, goog.labs.userAgent.browser.matchIE_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
    }, goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("Edge");
    }, goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("Edg/");
    }, goog.labs.userAgent.browser.matchOperaChromium_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("OPR");
    }, goog.labs.userAgent.browser.matchFirefox_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
    }, goog.labs.userAgent.browser.matchSafari_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
    }, goog.labs.userAgent.browser.matchCoast_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("Coast");
    }, goog.labs.userAgent.browser.matchIosWebview_ = function() {
        return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
    }, goog.labs.userAgent.browser.matchChrome_ = function() {
        return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
    }, goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
        return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
    }, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function() {
        return goog.labs.userAgent.util.matchUserAgent("Silk");
    }, goog.labs.userAgent.browser.getVersion = function() {
        function e11(e11) {
            return e11 = goog.array.find(e11, o11), r11[e11] || "";
        }
        var t11 = goog.labs.userAgent.util.getUserAgent();
        if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(t11);
        t11 = goog.labs.userAgent.util.extractVersionTuples(t11);
        var r11 = {};
        goog.array.forEach(t11, function(e11) {
            r11[e11[0]] = e11[1];
        });
        var o11 = goog.partial(goog.object.containsKey, r11);
        return goog.labs.userAgent.browser.isOpera() ? e11([
            "Version",
            "Opera"
        ]) : goog.labs.userAgent.browser.isEdge() ? e11([
            "Edge"
        ]) : goog.labs.userAgent.browser.isEdgeChromium() ? e11([
            "Edg"
        ]) : goog.labs.userAgent.browser.isChrome() ? e11([
            "Chrome",
            "CriOS",
            "HeadlessChrome"
        ]) : (t11 = t11[2]) && t11[1] || "";
    }, goog.labs.userAgent.browser.isVersionOrHigher = function(e11) {
        return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), e11);
    }, goog.labs.userAgent.browser.getIEVersion_ = function(e11) {
        var t11 = /rv: *([\d\.]*)/.exec(e11);
        if (t11 && t11[1]) return t11[1];
        t11 = "";
        var r11 = /MSIE +([\d\.]+)/.exec(e11);
        if (r11 && r11[1]) {
            if (e11 = /Trident\/(\d.\d)/.exec(e11), "7.0" == r11[1]) {
                if (e11 && e11[1]) switch(e11[1]){
                    case "4.0":
                        t11 = "8.0";
                        break;
                    case "5.0":
                        t11 = "9.0";
                        break;
                    case "6.0":
                        t11 = "10.0";
                        break;
                    case "7.0":
                        t11 = "11.0";
                }
                else t11 = "7.0";
            } else t11 = r11[1];
        }
        return t11;
    }, goog.html.SafeHtml = function() {
        this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "", this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_, this.dir_ = null;
    }, goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG, goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeHtml.prototype.getDirection = function() {
        return this.dir_;
    }, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0, goog.html.SafeHtml.prototype.getTypedStringValue = function() {
        return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
    }, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
        return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
    }), goog.html.SafeHtml.unwrap = function(e11) {
        return goog.html.SafeHtml.unwrapTrustedHTML(e11).toString();
    }, goog.html.SafeHtml.unwrapTrustedHTML = function(e11) {
        return e11 instanceof goog.html.SafeHtml && e11.constructor === goog.html.SafeHtml && e11.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ ? e11.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + e11 + "' of type " + goog.typeOf(e11)), "type_error:SafeHtml");
    }, goog.html.SafeHtml.htmlEscape = function(e11) {
        if (e11 instanceof goog.html.SafeHtml) return e11;
        var t11 = "object" == typeof e11, r11 = null;
        return t11 && e11.implementsGoogI18nBidiDirectionalString && (r11 = e11.getDirection()), e11 = t11 && e11.implementsGoogStringTypedString ? e11.getTypedStringValue() : String(e11), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(e11), r11);
    }, goog.html.SafeHtml.htmlEscapePreservingNewlines = function(e11) {
        return e11 instanceof goog.html.SafeHtml ? e11 : (e11 = goog.html.SafeHtml.htmlEscape(e11), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(e11)), e11.getDirection()));
    }, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(e11) {
        return e11 instanceof goog.html.SafeHtml ? e11 : (e11 = goog.html.SafeHtml.htmlEscape(e11), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(e11)), e11.getDirection()));
    }, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.comment = function(e11) {
        return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!--" + goog.string.internal.htmlEscape(e11) + "-->", null);
    }, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = {
        action: !0,
        cite: !0,
        data: !0,
        formaction: !0,
        href: !0,
        manifest: !0,
        poster: !0,
        src: !0
    }, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = {
        APPLET: !0,
        BASE: !0,
        EMBED: !0,
        IFRAME: !0,
        LINK: !0,
        MATH: !0,
        META: !0,
        OBJECT: !0,
        SCRIPT: !0,
        STYLE: !0,
        SVG: !0,
        TEMPLATE: !0
    }, goog.html.SafeHtml.create = function(e11, t11, r11) {
        return goog.html.SafeHtml.verifyTagName(String(e11)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(e11), t11, r11);
    }, goog.html.SafeHtml.verifyTagName = function(e11) {
        if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(e11)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + e11 + ">." : "");
        if (e11.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + e11 + "> is not allowed for SafeHtml." : "");
    }, goog.html.SafeHtml.createIframe = function(e11, t11, r11, o11) {
        e11 && goog.html.TrustedResourceUrl.unwrap(e11);
        var i11 = {};
        return i11.src = e11 || null, i11.srcdoc = t11 && goog.html.SafeHtml.unwrap(t11), e11 = goog.html.SafeHtml.combineAttributes(i11, {
            sandbox: ""
        }, r11), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e11, o11);
    }, goog.html.SafeHtml.createSandboxIframe = function(e11, t11, r11, o11) {
        if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
        var i11 = {};
        return i11.src = e11 ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e11)) : null, i11.srcdoc = t11 || null, i11.sandbox = "", e11 = goog.html.SafeHtml.combineAttributes(i11, {}, r11), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e11, o11);
    }, goog.html.SafeHtml.canUseSandboxIframe = function() {
        return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
    }, goog.html.SafeHtml.createScriptSrc = function(e11, t11) {
        return goog.html.TrustedResourceUrl.unwrap(e11), e11 = goog.html.SafeHtml.combineAttributes({
            src: e11
        }, {}, t11), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", e11);
    }, goog.html.SafeHtml.createScript = function(e11, t11) {
        for(var r11 in t11){
            var o11 = r11.toLowerCase();
            if ("language" == o11 || "src" == o11 || "text" == o11 || "type" == o11) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + o11 + '" attribute' : "");
        }
        for(r11 = "", e11 = goog.array.concat(e11), o11 = 0; o11 < e11.length; o11++)r11 += goog.html.SafeScript.unwrap(e11[o11]);
        return e11 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r11, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", t11, e11);
    }, goog.html.SafeHtml.createStyle = function(e11, t11) {
        t11 = goog.html.SafeHtml.combineAttributes({
            type: "text/css"
        }, {}, t11);
        var r11 = "";
        e11 = goog.array.concat(e11);
        for(var o11 = 0; o11 < e11.length; o11++)r11 += goog.html.SafeStyleSheet.unwrap(e11[o11]);
        return e11 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(r11, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", t11, e11);
    }, goog.html.SafeHtml.createMetaRefresh = function(e11, t11) {
        return e11 = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e11)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(e11, ";") && (e11 = "'" + e11.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
            "http-equiv": "refresh",
            content: (t11 || 0) + "; url=" + e11
        });
    }, goog.html.SafeHtml.getAttrNameAndValue_ = function(e11, t11, r11) {
        if (r11 instanceof goog.string.Const) r11 = goog.string.Const.unwrap(r11);
        else if ("style" == t11.toLowerCase()) {
            if (!goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
            r11 = goog.html.SafeHtml.getStyleValue_(r11);
        } else {
            if (/^on/i.test(t11)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + t11 + '" requires goog.string.Const value, "' + r11 + '" given.' : "");
            if (t11.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) {
                if (r11 instanceof goog.html.TrustedResourceUrl) r11 = goog.html.TrustedResourceUrl.unwrap(r11);
                else if (r11 instanceof goog.html.SafeUrl) r11 = goog.html.SafeUrl.unwrap(r11);
                else {
                    if ("string" != typeof r11) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + t11 + '" on tag "' + e11 + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + r11 + '" given.' : "");
                    r11 = goog.html.SafeUrl.sanitize(r11).getTypedStringValue();
                }
            }
        }
        return r11.implementsGoogStringTypedString && (r11 = r11.getTypedStringValue()), goog.asserts.assert("string" == typeof r11 || "number" == typeof r11, "String or number value expected, got " + typeof r11 + " with value: " + r11), t11 + '="' + goog.string.internal.htmlEscape(String(r11)) + '"';
    }, goog.html.SafeHtml.getStyleValue_ = function(e11) {
        if (!goog.isObject(e11)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof e11 + " given: " + e11 : "");
        return e11 instanceof goog.html.SafeStyle || (e11 = goog.html.SafeStyle.create(e11)), goog.html.SafeStyle.unwrap(e11);
    }, goog.html.SafeHtml.createWithDir = function(e11, t11, r11, o11) {
        return (t11 = goog.html.SafeHtml.create(t11, r11, o11)).dir_ = e11, t11;
    }, goog.html.SafeHtml.join = function(e11, t11) {
        var r11 = (e11 = goog.html.SafeHtml.htmlEscape(e11)).getDirection(), o11 = [], i11 = function(e11) {
            Array.isArray(e11) ? goog.array.forEach(e11, i11) : (e11 = goog.html.SafeHtml.htmlEscape(e11), o11.push(goog.html.SafeHtml.unwrap(e11)), e11 = e11.getDirection(), r11 == goog.i18n.bidi.Dir.NEUTRAL ? r11 = e11 : e11 != goog.i18n.bidi.Dir.NEUTRAL && r11 != e11 && (r11 = null));
        };
        return goog.array.forEach(t11, i11), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o11.join(goog.html.SafeHtml.unwrap(e11)), r11);
    }, goog.html.SafeHtml.concat = function(e11) {
        return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
    }, goog.html.SafeHtml.concatWithDir = function(e11, t11) {
        var r11 = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
        return r11.dir_ = e11, r11;
    }, goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(e11, t11) {
        return (new goog.html.SafeHtml).initSecurityPrivateDoNotAccessOrElse_(e11, t11);
    }, goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(e11, t11) {
        return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(e11) : e11, this.dir_ = t11, this;
    }, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(e11, t11, r11) {
        var o11 = null, i11 = "<" + e11 + goog.html.SafeHtml.stringifyAttributes(e11, t11);
        return null == r11 ? r11 = [] : Array.isArray(r11) || (r11 = [
            r11
        ]), goog.dom.tags.isVoidTag(e11.toLowerCase()) ? (goog.asserts.assert(!r11.length, "Void tag <" + e11 + "> does not allow content."), i11 += ">") : (o11 = goog.html.SafeHtml.concat(r11), i11 += ">" + goog.html.SafeHtml.unwrap(o11) + "</" + e11 + ">", o11 = o11.getDirection()), (e11 = t11 && t11.dir) && (o11 = /^(ltr|rtl|auto)$/i.test(e11) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(i11, o11);
    }, goog.html.SafeHtml.stringifyAttributes = function(e11, t11) {
        var r11 = "";
        if (t11) for(var o11 in t11){
            if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(o11)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + o11 + '".' : "");
            var i11 = t11[o11];
            null != i11 && (r11 += " " + goog.html.SafeHtml.getAttrNameAndValue_(e11, o11, i11));
        }
        return r11;
    }, goog.html.SafeHtml.combineAttributes = function(e11, t11, r11) {
        var o11, i11 = {};
        for(o11 in e11)goog.asserts.assert(o11.toLowerCase() == o11, "Must be lower case"), i11[o11] = e11[o11];
        for(o11 in t11)goog.asserts.assert(o11.toLowerCase() == o11, "Must be lower case"), i11[o11] = t11[o11];
        if (r11) for(o11 in r11){
            var a11 = o11.toLowerCase();
            if (a11 in e11) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + a11 + '" attribute, got "' + o11 + '" with value "' + r11[o11] + '"' : "");
            a11 in t11 && delete i11[a11], i11[o11] = r11[o11];
        }
        return i11;
    }, goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(e11, t11, r11) {
        return goog.asserts.assertString(goog.string.Const.unwrap(e11), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e11)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(t11, r11 || null);
    }, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(e11, t11) {
        return goog.asserts.assertString(goog.string.Const.unwrap(e11), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e11)), "must provide non-empty justification"), goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(t11);
    }, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(e11, t11) {
        return goog.asserts.assertString(goog.string.Const.unwrap(e11), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e11)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t11);
    }, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(e11, t11) {
        return goog.asserts.assertString(goog.string.Const.unwrap(e11), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e11)), "must provide non-empty justification"), goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t11);
    }, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(e11, t11) {
        return goog.asserts.assertString(goog.string.Const.unwrap(e11), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e11)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t11);
    }, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(e11, t11) {
        return goog.asserts.assertString(goog.string.Const.unwrap(e11), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e11)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t11);
    }, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = {
        AFTERBEGIN: "afterbegin",
        AFTEREND: "afterend",
        BEFOREBEGIN: "beforebegin",
        BEFOREEND: "beforeend"
    }, goog.dom.safe.insertAdjacentHtml = function(e11, t11, r11) {
        e11.insertAdjacentHTML(t11, goog.html.SafeHtml.unwrapTrustedHTML(r11));
    }, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
        MATH: !0,
        SCRIPT: !0,
        STYLE: !0,
        SVG: !0,
        TEMPLATE: !0
    }, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
        if (goog.DEBUG && "undefined" == typeof document) return !1;
        var e11 = document.createElement("div"), t11 = document.createElement("div");
        return t11.appendChild(document.createElement("div")), e11.appendChild(t11), !(goog.DEBUG && !e11.firstChild) && (t11 = e11.firstChild.firstChild, e11.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !t11.parentElement);
    }), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(e11, t11) {
        if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for(; e11.lastChild;)e11.removeChild(e11.lastChild);
        e11.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t11);
    }, goog.dom.safe.setInnerHtml = function(e11, t11) {
        if (goog.asserts.ENABLE_ASSERTS) {
            var r11 = e11.tagName.toUpperCase();
            if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[r11]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + e11.tagName + ".");
        }
        goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(e11, t11);
    }, goog.dom.safe.setOuterHtml = function(e11, t11) {
        e11.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t11);
    }, goog.dom.safe.setFormElementAction = function(e11, t11) {
        t11 = t11 instanceof goog.html.SafeUrl ? t11 : goog.html.SafeUrl.sanitizeAssertUnchanged(t11), goog.dom.asserts.assertIsHTMLFormElement(e11).action = goog.html.SafeUrl.unwrap(t11);
    }, goog.dom.safe.setButtonFormAction = function(e11, t11) {
        t11 = t11 instanceof goog.html.SafeUrl ? t11 : goog.html.SafeUrl.sanitizeAssertUnchanged(t11), goog.dom.asserts.assertIsHTMLButtonElement(e11).formAction = goog.html.SafeUrl.unwrap(t11);
    }, goog.dom.safe.setInputFormAction = function(e11, t11) {
        t11 = t11 instanceof goog.html.SafeUrl ? t11 : goog.html.SafeUrl.sanitizeAssertUnchanged(t11), goog.dom.asserts.assertIsHTMLInputElement(e11).formAction = goog.html.SafeUrl.unwrap(t11);
    }, goog.dom.safe.setStyle = function(e11, t11) {
        e11.style.cssText = goog.html.SafeStyle.unwrap(t11);
    }, goog.dom.safe.documentWrite = function(e11, t11) {
        e11.write(goog.html.SafeHtml.unwrapTrustedHTML(t11));
    }, goog.dom.safe.setAnchorHref = function(e11, t11) {
        goog.dom.asserts.assertIsHTMLAnchorElement(e11), t11 = t11 instanceof goog.html.SafeUrl ? t11 : goog.html.SafeUrl.sanitizeAssertUnchanged(t11), e11.href = goog.html.SafeUrl.unwrap(t11);
    }, goog.dom.safe.setImageSrc = function(e11, t11) {
        if (goog.dom.asserts.assertIsHTMLImageElement(e11), !(t11 instanceof goog.html.SafeUrl)) {
            var r11 = /^data:image\//i.test(t11);
            t11 = goog.html.SafeUrl.sanitizeAssertUnchanged(t11, r11);
        }
        e11.src = goog.html.SafeUrl.unwrap(t11);
    }, goog.dom.safe.setAudioSrc = function(e11, t11) {
        if (goog.dom.asserts.assertIsHTMLAudioElement(e11), !(t11 instanceof goog.html.SafeUrl)) {
            var r11 = /^data:audio\//i.test(t11);
            t11 = goog.html.SafeUrl.sanitizeAssertUnchanged(t11, r11);
        }
        e11.src = goog.html.SafeUrl.unwrap(t11);
    }, goog.dom.safe.setVideoSrc = function(e11, t11) {
        if (goog.dom.asserts.assertIsHTMLVideoElement(e11), !(t11 instanceof goog.html.SafeUrl)) {
            var r11 = /^data:video\//i.test(t11);
            t11 = goog.html.SafeUrl.sanitizeAssertUnchanged(t11, r11);
        }
        e11.src = goog.html.SafeUrl.unwrap(t11);
    }, goog.dom.safe.setEmbedSrc = function(e11, t11) {
        goog.dom.asserts.assertIsHTMLEmbedElement(e11), e11.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t11);
    }, goog.dom.safe.setFrameSrc = function(e11, t11) {
        goog.dom.asserts.assertIsHTMLFrameElement(e11), e11.src = goog.html.TrustedResourceUrl.unwrap(t11);
    }, goog.dom.safe.setIframeSrc = function(e11, t11) {
        goog.dom.asserts.assertIsHTMLIFrameElement(e11), e11.src = goog.html.TrustedResourceUrl.unwrap(t11);
    }, goog.dom.safe.setIframeSrcdoc = function(e11, t11) {
        goog.dom.asserts.assertIsHTMLIFrameElement(e11), e11.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(t11);
    }, goog.dom.safe.setLinkHrefAndRel = function(e11, t11, r11) {
        goog.dom.asserts.assertIsHTMLLinkElement(e11), e11.rel = r11, goog.string.internal.caseInsensitiveContains(r11, "stylesheet") ? (goog.asserts.assert(t11 instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), e11.href = goog.html.TrustedResourceUrl.unwrap(t11)) : e11.href = t11 instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(t11) : t11 instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(t11) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(t11));
    }, goog.dom.safe.setObjectData = function(e11, t11) {
        goog.dom.asserts.assertIsHTMLObjectElement(e11), e11.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t11);
    }, goog.dom.safe.setScriptSrc = function(e11, t11) {
        goog.dom.asserts.assertIsHTMLScriptElement(e11), e11.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t11), (t11 = goog.getScriptNonce()) && e11.setAttribute("nonce", t11);
    }, goog.dom.safe.setScriptContent = function(e11, t11) {
        goog.dom.asserts.assertIsHTMLScriptElement(e11), e11.text = goog.html.SafeScript.unwrapTrustedScript(t11), (t11 = goog.getScriptNonce()) && e11.setAttribute("nonce", t11);
    }, goog.dom.safe.setLocationHref = function(e11, t11) {
        goog.dom.asserts.assertIsLocation(e11), t11 = t11 instanceof goog.html.SafeUrl ? t11 : goog.html.SafeUrl.sanitizeAssertUnchanged(t11), e11.href = goog.html.SafeUrl.unwrap(t11);
    }, goog.dom.safe.assignLocation = function(e11, t11) {
        goog.dom.asserts.assertIsLocation(e11), t11 = t11 instanceof goog.html.SafeUrl ? t11 : goog.html.SafeUrl.sanitizeAssertUnchanged(t11), e11.assign(goog.html.SafeUrl.unwrap(t11));
    }, goog.dom.safe.replaceLocation = function(e11, t11) {
        t11 = t11 instanceof goog.html.SafeUrl ? t11 : goog.html.SafeUrl.sanitizeAssertUnchanged(t11), e11.replace(goog.html.SafeUrl.unwrap(t11));
    }, goog.dom.safe.openInWindow = function(e11, t11, r11, o11, i11) {
        return e11 = e11 instanceof goog.html.SafeUrl ? e11 : goog.html.SafeUrl.sanitizeAssertUnchanged(e11), t11 = t11 || goog.global, r11 = r11 instanceof goog.string.Const ? goog.string.Const.unwrap(r11) : r11 || "", t11.open(goog.html.SafeUrl.unwrap(e11), r11, o11, i11);
    }, goog.dom.safe.parseFromStringHtml = function(e11, t11) {
        return goog.dom.safe.parseFromString(e11, t11, "text/html");
    }, goog.dom.safe.parseFromString = function(e11, t11, r11) {
        return e11.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(t11), r11);
    }, goog.dom.safe.createImageFromBlob = function(e11) {
        if (!/^image\/.*/g.test(e11.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
        var t11 = goog.global.URL.createObjectURL(e11);
        return (e11 = new goog.global.Image).onload = function() {
            goog.global.URL.revokeObjectURL(t11);
        }, goog.dom.safe.setImageSrc(e11, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), t11)), e11;
    }, goog.string.DETECT_DOUBLE_ESCAPING = !1, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1, goog.string.Unicode = {
        NBSP: "\xa0"
    }, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function(e11, t11) {
        for(var r11 = e11.split("%s"), o11 = "", i11 = Array.prototype.slice.call(arguments, 1); i11.length && 1 < r11.length;)o11 += r11.shift() + i11.shift();
        return o11 + r11.join("%s");
    }, goog.string.collapseWhitespace = function(e11) {
        return e11.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
    }, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function(e11) {
        return 0 == e11.length;
    }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function(e11) {
        return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(e11));
    }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function(e11) {
        return !/[^\t\n\r ]/.test(e11);
    }, goog.string.isAlpha = function(e11) {
        return !/[^a-zA-Z]/.test(e11);
    }, goog.string.isNumeric = function(e11) {
        return !/[^0-9]/.test(e11);
    }, goog.string.isAlphaNumeric = function(e11) {
        return !/[^a-zA-Z0-9]/.test(e11);
    }, goog.string.isSpace = function(e11) {
        return " " == e11;
    }, goog.string.isUnicodeChar = function(e11) {
        return 1 == e11.length && " " <= e11 && "~" >= e11 || "\x80" <= e11 && "\uFFFD" >= e11;
    }, goog.string.stripNewlines = function(e11) {
        return e11.replace(/(\r\n|\r|\n)+/g, " ");
    }, goog.string.canonicalizeNewlines = function(e11) {
        return e11.replace(/(\r\n|\r|\n)/g, "\n");
    }, goog.string.normalizeWhitespace = function(e11) {
        return e11.replace(/\xa0|\s/g, " ");
    }, goog.string.normalizeSpaces = function(e11) {
        return e11.replace(/\xa0|[ \t]+/g, " ");
    }, goog.string.collapseBreakingSpaces = function(e11) {
        return e11.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
    }, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function(e11) {
        return e11.replace(/^[\s\xa0]+/, "");
    }, goog.string.trimRight = function(e11) {
        return e11.replace(/[\s\xa0]+$/, "");
    }, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function(e11, t11, r11) {
        if (e11 == t11) return 0;
        if (!e11) return -1;
        if (!t11) return 1;
        for(var o11 = e11.toLowerCase().match(r11), i11 = t11.toLowerCase().match(r11), a11 = Math.min(o11.length, i11.length), n11 = 0; n11 < a11; n11++){
            r11 = o11[n11];
            var s11 = i11[n11];
            if (r11 != s11) return e11 = parseInt(r11, 10), !isNaN(e11) && (t11 = parseInt(s11, 10), !isNaN(t11) && e11 - t11) ? e11 - t11 : r11 < s11 ? -1 : 1;
        }
        return o11.length != i11.length ? o11.length - i11.length : e11 < t11 ? -1 : 1;
    }, goog.string.intAwareCompare = function(e11, t11) {
        return goog.string.numberAwareCompare_(e11, t11, /\d+|\D+/g);
    }, goog.string.floatAwareCompare = function(e11, t11) {
        return goog.string.numberAwareCompare_(e11, t11, /\d+|\.\d+|\D+/g);
    }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function(e11) {
        return encodeURIComponent(String(e11));
    }, goog.string.urlDecode = function(e11) {
        return decodeURIComponent(e11.replace(/\+/g, " "));
    }, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function(e11, t11) {
        return e11 = goog.string.internal.htmlEscape(e11, t11), goog.string.DETECT_DOUBLE_ESCAPING && (e11 = e11.replace(goog.string.E_RE_, "&#101;")), e11;
    }, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function(e11) {
        return goog.string.contains(e11, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(e11) : goog.string.unescapePureXmlEntities_(e11) : e11;
    }, goog.string.unescapeEntitiesWithDocument = function(e11, t11) {
        return goog.string.contains(e11, "&") ? goog.string.unescapeEntitiesUsingDom_(e11, t11) : e11;
    }, goog.string.unescapeEntitiesUsingDom_ = function(e11, t11) {
        var r11 = {
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"'
        }, o11 = t11 ? t11.createElement("div") : goog.global.document.createElement("div");
        return e11.replace(goog.string.HTML_ENTITY_PATTERN_, function(e11, t11) {
            var i11 = r11[e11];
            return i11 || ("#" == t11.charAt(0) && (t11 = Number("0" + t11.substr(1)), isNaN(t11) || (i11 = String.fromCharCode(t11))), i11 || (goog.dom.safe.setInnerHtml(o11, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), e11 + " ")), i11 = o11.firstChild.nodeValue.slice(0, -1)), r11[e11] = i11);
        });
    }, goog.string.unescapePureXmlEntities_ = function(e11) {
        return e11.replace(/&([^;]+);/g, function(e11, t11) {
            switch(t11){
                case "amp":
                    return "&";
                case "lt":
                    return "<";
                case "gt":
                    return ">";
                case "quot":
                    return '"';
                default:
                    return "#" != t11.charAt(0) || (t11 = Number("0" + t11.substr(1)), isNaN(t11)) ? e11 : String.fromCharCode(t11);
            }
        });
    }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function(e11, t11) {
        return goog.string.newLineToBr(e11.replace(/  /g, " &#160;"), t11);
    }, goog.string.preserveSpaces = function(e11) {
        return e11.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
    }, goog.string.stripQuotes = function(e11, t11) {
        for(var r11 = t11.length, o11 = 0; o11 < r11; o11++){
            var i11 = 1 == r11 ? t11 : t11.charAt(o11);
            if (e11.charAt(0) == i11 && e11.charAt(e11.length - 1) == i11) return e11.substring(1, e11.length - 1);
        }
        return e11;
    }, goog.string.truncate = function(e11, t11, r11) {
        return r11 && (e11 = goog.string.unescapeEntities(e11)), e11.length > t11 && (e11 = e11.substring(0, t11 - 3) + "..."), r11 && (e11 = goog.string.htmlEscape(e11)), e11;
    }, goog.string.truncateMiddle = function(e11, t11, r11, o11) {
        if (r11 && (e11 = goog.string.unescapeEntities(e11)), o11 && e11.length > t11) {
            o11 > t11 && (o11 = t11);
            var i11 = e11.length - o11;
            e11 = e11.substring(0, t11 - o11) + "..." + e11.substring(i11);
        } else e11.length > t11 && (o11 = Math.floor(t11 / 2), i11 = e11.length - o11, e11 = e11.substring(0, o11 + t11 % 2) + "..." + e11.substring(i11));
        return r11 && (e11 = goog.string.htmlEscape(e11)), e11;
    }, goog.string.specialEscapeChars_ = {
        "\x00": "\\0",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "	": "\\t",
        "\v": "\\x0B",
        '"': '\\"',
        "\\": "\\\\",
        "<": "\\u003C"
    }, goog.string.jsEscapeCache_ = {
        "'": "\\'"
    }, goog.string.quote = function(e11) {
        e11 = String(e11);
        for(var t11 = [
            '"'
        ], r11 = 0; r11 < e11.length; r11++){
            var o11 = e11.charAt(r11), i11 = o11.charCodeAt(0);
            t11[r11 + 1] = goog.string.specialEscapeChars_[o11] || (31 < i11 && 127 > i11 ? o11 : goog.string.escapeChar(o11));
        }
        return t11.push('"'), t11.join("");
    }, goog.string.escapeString = function(e11) {
        for(var t11 = [], r11 = 0; r11 < e11.length; r11++)t11[r11] = goog.string.escapeChar(e11.charAt(r11));
        return t11.join("");
    }, goog.string.escapeChar = function(e11) {
        if (e11 in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[e11];
        if (e11 in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[e11] = goog.string.specialEscapeChars_[e11];
        var t11 = e11.charCodeAt(0);
        if (31 < t11 && 127 > t11) var r11 = e11;
        else 256 > t11 ? (r11 = "\\x", (16 > t11 || 256 < t11) && (r11 += "0")) : (r11 = "\\u", 4096 > t11 && (r11 += "0")), r11 += t11.toString(16).toUpperCase();
        return goog.string.jsEscapeCache_[e11] = r11;
    }, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function(e11, t11) {
        return e11 && t11 ? e11.split(t11).length - 1 : 0;
    }, goog.string.removeAt = function(e11, t11, r11) {
        var o11 = e11;
        return 0 <= t11 && t11 < e11.length && 0 < r11 && (o11 = e11.substr(0, t11) + e11.substr(t11 + r11, e11.length - t11 - r11)), o11;
    }, goog.string.remove = function(e11, t11) {
        return e11.replace(t11, "");
    }, goog.string.removeAll = function(e11, t11) {
        return t11 = new RegExp(goog.string.regExpEscape(t11), "g"), e11.replace(t11, "");
    }, goog.string.replaceAll = function(e11, t11, r11) {
        return t11 = new RegExp(goog.string.regExpEscape(t11), "g"), e11.replace(t11, r11.replace(/\$/g, "$$$$"));
    }, goog.string.regExpEscape = function(e11) {
        return String(e11).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
    }, goog.string.repeat = String.prototype.repeat ? function(e11, t11) {
        return e11.repeat(t11);
    } : function(e11, t11) {
        return Array(t11 + 1).join(e11);
    }, goog.string.padNumber = function(e11, t11, r11) {
        return -1 == (r11 = (e11 = void 0 !== r11 ? e11.toFixed(r11) : String(e11)).indexOf(".")) && (r11 = e11.length), goog.string.repeat("0", Math.max(0, t11 - r11)) + e11;
    }, goog.string.makeSafe = function(e11) {
        return null == e11 ? "" : String(e11);
    }, goog.string.buildString = function(e11) {
        return Array.prototype.join.call(arguments, "");
    }, goog.string.getRandomString = function() {
        return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
    }, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function(e11) {
        for(var t11 = 0, r11 = 0; r11 < e11.length; ++r11)t11 = 31 * t11 + e11.charCodeAt(r11) >>> 0;
        return t11;
    }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function() {
        return "goog_" + goog.string.uniqueStringCounter_++;
    }, goog.string.toNumber = function(e11) {
        var t11 = Number(e11);
        return 0 == t11 && goog.string.isEmptyOrWhitespace(e11) ? NaN : t11;
    }, goog.string.isLowerCamelCase = function(e11) {
        return /^[a-z]+([A-Z][a-z]*)*$/.test(e11);
    }, goog.string.isUpperCamelCase = function(e11) {
        return /^([A-Z][a-z]*)+$/.test(e11);
    }, goog.string.toCamelCase = function(e11) {
        return String(e11).replace(/\-([a-z])/g, function(e11, t11) {
            return t11.toUpperCase();
        });
    }, goog.string.toSelectorCase = function(e11) {
        return String(e11).replace(/([A-Z])/g, "-$1").toLowerCase();
    }, goog.string.toTitleCase = function(e11, t11) {
        return t11 = "string" == typeof t11 ? goog.string.regExpEscape(t11) : "\\s", e11.replace(new RegExp("(^" + (t11 ? "|[" + t11 + "]+" : "") + ")([a-z])", "g"), function(e11, t11, r11) {
            return t11 + r11.toUpperCase();
        });
    }, goog.string.capitalize = function(e11) {
        return String(e11.charAt(0)).toUpperCase() + String(e11.substr(1)).toLowerCase();
    }, goog.string.parseInt = function(e11) {
        return isFinite(e11) && (e11 = String(e11)), "string" == typeof e11 ? /^\s*-?0x/i.test(e11) ? parseInt(e11, 16) : parseInt(e11, 10) : NaN;
    }, goog.string.splitLimit = function(e11, t11, r11) {
        e11 = e11.split(t11);
        for(var o11 = []; 0 < r11 && e11.length;)o11.push(e11.shift()), r11--;
        return e11.length && o11.push(e11.join(t11)), o11;
    }, goog.string.lastComponent = function(e11, t11) {
        if (!t11) return e11;
        "string" == typeof t11 && (t11 = [
            t11
        ]);
        for(var r11 = -1, o11 = 0; o11 < t11.length; o11++)if ("" != t11[o11]) {
            var i11 = e11.lastIndexOf(t11[o11]);
            i11 > r11 && (r11 = i11);
        }
        return -1 == r11 ? e11 : e11.slice(r11 + 1);
    }, goog.string.editDistance = function(e11, t11) {
        var r11 = [], o11 = [];
        if (e11 == t11) return 0;
        if (!e11.length || !t11.length) return Math.max(e11.length, t11.length);
        for(var i11 = 0; i11 < t11.length + 1; i11++)r11[i11] = i11;
        for(i11 = 0; i11 < e11.length; i11++){
            o11[0] = i11 + 1;
            for(var a11 = 0; a11 < t11.length; a11++)o11[a11 + 1] = Math.min(o11[a11] + 1, r11[a11 + 1] + 1, r11[a11] + Number(e11[i11] != t11[a11]));
            for(a11 = 0; a11 < r11.length; a11++)r11[a11] = o11[a11];
        }
        return o11[t11.length];
    }, goog.labs.userAgent.engine = {}, goog.labs.userAgent.engine.isPresto = function() {
        return goog.labs.userAgent.util.matchUserAgent("Presto");
    }, goog.labs.userAgent.engine.isTrident = function() {
        return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
    }, goog.labs.userAgent.engine.isEdge = function() {
        return goog.labs.userAgent.util.matchUserAgent("Edge");
    }, goog.labs.userAgent.engine.isWebKit = function() {
        return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
    }, goog.labs.userAgent.engine.isGecko = function() {
        return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
    }, goog.labs.userAgent.engine.getVersion = function() {
        var e11 = goog.labs.userAgent.util.getUserAgent();
        if (e11) {
            e11 = goog.labs.userAgent.util.extractVersionTuples(e11);
            var t11, r11 = goog.labs.userAgent.engine.getEngineTuple_(e11);
            if (r11) return "Gecko" == r11[0] ? goog.labs.userAgent.engine.getVersionForKey_(e11, "Firefox") : r11[1];
            if ((e11 = e11[0]) && (t11 = e11[2]) && (t11 = /Trident\/([^\s;]+)/.exec(t11))) return t11[1];
        }
        return "";
    }, goog.labs.userAgent.engine.getEngineTuple_ = function(e11) {
        if (!goog.labs.userAgent.engine.isEdge()) return e11[1];
        for(var t11 = 0; t11 < e11.length; t11++){
            var r11 = e11[t11];
            if ("Edge" == r11[0]) return r11;
        }
    }, goog.labs.userAgent.engine.isVersionOrHigher = function(e11) {
        return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), e11);
    }, goog.labs.userAgent.engine.getVersionForKey_ = function(e11, t11) {
        return (e11 = goog.array.find(e11, function(e11) {
            return t11 == e11[0];
        })) && e11[1] || "";
    }, goog.labs.userAgent.platform = {}, goog.labs.userAgent.platform.isAndroid = function() {
        return goog.labs.userAgent.util.matchUserAgent("Android");
    }, goog.labs.userAgent.platform.isIpod = function() {
        return goog.labs.userAgent.util.matchUserAgent("iPod");
    }, goog.labs.userAgent.platform.isIphone = function() {
        return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
    }, goog.labs.userAgent.platform.isIpad = function() {
        return goog.labs.userAgent.util.matchUserAgent("iPad");
    }, goog.labs.userAgent.platform.isIos = function() {
        return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
    }, goog.labs.userAgent.platform.isMacintosh = function() {
        return goog.labs.userAgent.util.matchUserAgent("Macintosh");
    }, goog.labs.userAgent.platform.isLinux = function() {
        return goog.labs.userAgent.util.matchUserAgent("Linux");
    }, goog.labs.userAgent.platform.isWindows = function() {
        return goog.labs.userAgent.util.matchUserAgent("Windows");
    }, goog.labs.userAgent.platform.isChromeOS = function() {
        return goog.labs.userAgent.util.matchUserAgent("CrOS");
    }, goog.labs.userAgent.platform.isChromecast = function() {
        return goog.labs.userAgent.util.matchUserAgent("CrKey");
    }, goog.labs.userAgent.platform.isKaiOS = function() {
        return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
    }, goog.labs.userAgent.platform.getVersion = function() {
        var e11 = goog.labs.userAgent.util.getUserAgent(), t11 = "";
        return goog.labs.userAgent.platform.isWindows() ? t11 = (e11 = (t11 = /Windows (?:NT|Phone) ([0-9.]+)/).exec(e11)) ? e11[1] : "0.0" : goog.labs.userAgent.platform.isIos() ? t11 = (e11 = (t11 = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/).exec(e11)) && e11[1].replace(/_/g, ".") : goog.labs.userAgent.platform.isMacintosh() ? t11 = (e11 = (t11 = /Mac OS X ([0-9_.]+)/).exec(e11)) ? e11[1].replace(/_/g, ".") : "10" : goog.labs.userAgent.platform.isKaiOS() ? t11 = (e11 = (t11 = /(?:KaiOS)\/(\S+)/i).exec(e11)) && e11[1] : goog.labs.userAgent.platform.isAndroid() ? t11 = (e11 = (t11 = /Android\s+([^\);]+)(\)|;)/).exec(e11)) && e11[1] : goog.labs.userAgent.platform.isChromeOS() && (t11 = (e11 = (t11 = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/).exec(e11)) && e11[1]), t11 || "";
    }, goog.labs.userAgent.platform.isVersionOrHigher = function(e11) {
        return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), e11);
    }, goog.reflect = {}, goog.reflect.object = function(e11, t11) {
        return t11;
    }, goog.reflect.objectProperty = function(e11, t11) {
        return e11;
    }, goog.reflect.sinkValue = function(e11) {
        return goog.reflect.sinkValue[" "](e11), e11;
    }, goog.reflect.sinkValue[" "] = goog.nullFunction, goog.reflect.canAccessProperty = function(e11, t11) {
        try {
            return goog.reflect.sinkValue(e11[t11]), !0;
        } catch (e11) {}
        return !1;
    }, goog.reflect.cache = function(e11, t11, r11, o11) {
        return o11 = o11 ? o11(t11) : t11, Object.prototype.hasOwnProperty.call(e11, o11) ? e11[o11] : e11[o11] = r11(t11);
    }, goog.userAgent = {}, goog.userAgent.ASSUME_IE = !1, goog.userAgent.ASSUME_EDGE = !1, goog.userAgent.ASSUME_GECKO = !1, goog.userAgent.ASSUME_WEBKIT = !1, goog.userAgent.ASSUME_MOBILE_WEBKIT = !1, goog.userAgent.ASSUME_OPERA = !1, goog.userAgent.ASSUME_ANY_VERSION = !1, goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA, goog.userAgent.getUserAgentString = function() {
        return goog.labs.userAgent.util.getUserAgent();
    }, goog.userAgent.getNavigatorTyped = function() {
        return goog.global.navigator || null;
    }, goog.userAgent.getNavigator = function() {
        return goog.userAgent.getNavigatorTyped();
    }, goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera(), goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE(), goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge(), goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE, goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko(), goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit(), goog.userAgent.isMobile_ = function() {
        return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
    }, goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_(), goog.userAgent.SAFARI = goog.userAgent.WEBKIT, goog.userAgent.determinePlatform_ = function() {
        var e11 = goog.userAgent.getNavigatorTyped();
        return e11 && e11.platform || "";
    }, goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_(), goog.userAgent.ASSUME_MAC = !1, goog.userAgent.ASSUME_WINDOWS = !1, goog.userAgent.ASSUME_LINUX = !1, goog.userAgent.ASSUME_X11 = !1, goog.userAgent.ASSUME_ANDROID = !1, goog.userAgent.ASSUME_IPHONE = !1, goog.userAgent.ASSUME_IPAD = !1, goog.userAgent.ASSUME_IPOD = !1, goog.userAgent.ASSUME_KAIOS = !1, goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD, goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh();
    goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows(), goog.userAgent.isLegacyLinux_ = function() {
        return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
    }, goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_(), goog.userAgent.isX11_ = function() {
        var e11 = goog.userAgent.getNavigatorTyped();
        return !!e11 && goog.string.contains(e11.appVersion || "", "X11");
    }, goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_(), goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid(), goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone(), goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod(), goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos(), goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS(), goog.userAgent.determineVersion_ = function() {
        var e11 = "", t11 = goog.userAgent.getVersionRegexResult_();
        return t11 && (e11 = t11 ? t11[1] : ""), goog.userAgent.IE && null != (t11 = goog.userAgent.getDocumentMode_()) && t11 > parseFloat(e11) ? String(t11) : e11;
    }, goog.userAgent.getVersionRegexResult_ = function() {
        var e11 = goog.userAgent.getUserAgentString();
        return goog.userAgent.GECKO ? /rv:([^\);]+)(\)|;)/.exec(e11) : goog.userAgent.EDGE ? /Edge\/([\d\.]+)/.exec(e11) : goog.userAgent.IE ? /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(e11) : goog.userAgent.WEBKIT ? /WebKit\/(\S+)/.exec(e11) : goog.userAgent.OPERA ? /(?:Version)[ \/]?(\S+)/.exec(e11) : void 0;
    }, goog.userAgent.getDocumentMode_ = function() {
        var e11 = goog.global.document;
        return e11 ? e11.documentMode : void 0;
    }, goog.userAgent.VERSION = goog.userAgent.determineVersion_(), goog.userAgent.compare = function(e11, t11) {
        return goog.string.compareVersions(e11, t11);
    }, goog.userAgent.isVersionOrHigherCache_ = {}, goog.userAgent.isVersionOrHigher = function(e11) {
        return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, e11, function() {
            return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, e11);
        });
    }, goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher, goog.userAgent.isDocumentModeOrHigher = function(e11) {
        return Number(goog.userAgent.DOCUMENT_MODE) >= e11;
    }, goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher, goog.userAgent.DOCUMENT_MODE = function() {
        if (goog.global.document && goog.userAgent.IE) {
            var e11 = goog.userAgent.getDocumentMode_();
            return e11 || parseInt(goog.userAgent.VERSION, 10) || void 0;
        }
    }(), goog.userAgent.product = {}, goog.userAgent.product.ASSUME_FIREFOX = !1, goog.userAgent.product.ASSUME_IPHONE = !1, goog.userAgent.product.ASSUME_IPAD = !1, goog.userAgent.product.ASSUME_ANDROID = !1, goog.userAgent.product.ASSUME_CHROME = !1, goog.userAgent.product.ASSUME_SAFARI = !1, goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI, goog.userAgent.product.OPERA = goog.userAgent.OPERA, goog.userAgent.product.IE = goog.userAgent.IE, goog.userAgent.product.EDGE = goog.userAgent.EDGE, goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox(), goog.userAgent.product.isIphoneOrIpod_ = function() {
        return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
    }, goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_(), goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad(), goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser(), goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome(), goog.userAgent.product.isSafariDesktop_ = function() {
        return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
    }, goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_(), goog.crypt.base64 = {}, goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=", goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.", goog.crypt.base64.Alphabet = {
        DEFAULT: 0,
        NO_PADDING: 1,
        WEBSAFE: 2,
        WEBSAFE_DOT_PADDING: 3,
        WEBSAFE_NO_PADDING: 4
    }, goog.crypt.base64.paddingChars_ = "=.", goog.crypt.base64.isPadding_ = function(e11) {
        return goog.string.contains(goog.crypt.base64.paddingChars_, e11);
    }, goog.crypt.base64.byteToCharMaps_ = {}, goog.crypt.base64.charToByteMap_ = null, goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA, goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || "function" == typeof goog.global.btoa, goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && "function" == typeof goog.global.atob, goog.crypt.base64.encodeByteArray = function(e11, t11) {
        goog.asserts.assert(goog.isArrayLike(e11), "encodeByteArray takes an array as a parameter"), void 0 === t11 && (t11 = goog.crypt.base64.Alphabet.DEFAULT), goog.crypt.base64.init_(), t11 = goog.crypt.base64.byteToCharMaps_[t11];
        for(var r11 = [], o11 = 0; o11 < e11.length; o11 += 3){
            var i11 = e11[o11], a11 = o11 + 1 < e11.length, n11 = a11 ? e11[o11 + 1] : 0, s11 = o11 + 2 < e11.length, p11 = s11 ? e11[o11 + 2] : 0, d11 = i11 >> 2;
            i11 = (3 & i11) << 4 | n11 >> 4, n11 = (15 & n11) << 2 | p11 >> 6, p11 &= 63, s11 || (p11 = 64, a11 || (n11 = 64)), r11.push(t11[d11], t11[i11], t11[n11] || "", t11[p11] || "");
        }
        return r11.join("");
    }, goog.crypt.base64.encodeString = function(e11, t11) {
        return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !t11 ? goog.global.btoa(e11) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(e11), t11);
    }, goog.crypt.base64.decodeString = function(e11, t11) {
        if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !t11) return goog.global.atob(e11);
        var r11 = "";
        return goog.crypt.base64.decodeStringInternal_(e11, function(e11) {
            r11 += String.fromCharCode(e11);
        }), r11;
    }, goog.crypt.base64.decodeStringToByteArray = function(e11, t11) {
        var r11 = [];
        return goog.crypt.base64.decodeStringInternal_(e11, function(e11) {
            r11.push(e11);
        }), r11;
    }, goog.crypt.base64.decodeStringToUint8Array = function(e11) {
        goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
        var t11 = e11.length, r11 = 3 * t11 / 4;
        r11 % 3 ? r11 = Math.floor(r11) : goog.crypt.base64.isPadding_(e11[t11 - 1]) && (r11 = goog.crypt.base64.isPadding_(e11[t11 - 2]) ? r11 - 2 : r11 - 1);
        var o11 = new Uint8Array(r11), i11 = 0;
        return goog.crypt.base64.decodeStringInternal_(e11, function(e11) {
            o11[i11++] = e11;
        }), o11.subarray(0, i11);
    }, goog.crypt.base64.decodeStringInternal_ = function(e11, t11) {
        function r11(t11) {
            for(; o11 < e11.length;){
                var r11 = e11.charAt(o11++), i11 = goog.crypt.base64.charToByteMap_[r11];
                if (null != i11) return i11;
                if (!goog.string.isEmptyOrWhitespace(r11)) throw Error("Unknown base64 encoding at char: " + r11);
            }
            return t11;
        }
        goog.crypt.base64.init_();
        for(var o11 = 0;;){
            var i11 = r11(-1), a11 = r11(0), n11 = r11(64), s11 = r11(64);
            if (64 === s11 && -1 === i11) break;
            t11(i11 << 2 | a11 >> 4), 64 != n11 && (t11(a11 << 4 & 240 | n11 >> 2), 64 != s11 && t11(n11 << 6 & 192 | s11));
        }
    }, goog.crypt.base64.init_ = function() {
        if (!goog.crypt.base64.charToByteMap_) {
            goog.crypt.base64.charToByteMap_ = {};
            for(var e11 = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), t11 = [
                "+/=",
                "+/",
                "-_=",
                "-_.",
                "-_"
            ], r11 = 0; 5 > r11; r11++){
                var o11 = e11.concat(t11[r11].split(""));
                goog.crypt.base64.byteToCharMaps_[r11] = o11;
                for(var i11 = 0; i11 < o11.length; i11++){
                    var a11 = o11[i11], n11 = goog.crypt.base64.charToByteMap_[a11];
                    void 0 === n11 ? goog.crypt.base64.charToByteMap_[a11] = i11 : goog.asserts.assert(n11 === i11);
                }
            }
        }
    }, jspb.utils = {}, jspb.utils.split64Low = 0, jspb.utils.split64High = 0, jspb.utils.splitUint64 = function(e11) {
        var t11 = e11 >>> 0;
        e11 = Math.floor((e11 - t11) / jspb.BinaryConstants.TWO_TO_32) >>> 0, jspb.utils.split64Low = t11, jspb.utils.split64High = e11;
    }, jspb.utils.splitInt64 = function(e11) {
        var t11 = 0 > e11, r11 = (e11 = Math.abs(e11)) >>> 0;
        e11 = Math.floor((e11 - r11) / jspb.BinaryConstants.TWO_TO_32), e11 >>>= 0, t11 && (e11 = ~e11 >>> 0, 4294967295 < (r11 = 1 + (~r11 >>> 0)) && (r11 = 0, 4294967295 < ++e11 && (e11 = 0))), jspb.utils.split64Low = r11, jspb.utils.split64High = e11;
    }, jspb.utils.splitZigzag64 = function(e11) {
        var t11 = 0 > e11;
        e11 = 2 * Math.abs(e11), jspb.utils.splitUint64(e11), e11 = jspb.utils.split64Low;
        var r11 = jspb.utils.split64High;
        t11 && (0 == e11 ? 0 == r11 ? r11 = e11 = 4294967295 : (r11--, e11 = 4294967295) : e11--), jspb.utils.split64Low = e11, jspb.utils.split64High = r11;
    }, jspb.utils.splitFloat32 = function(e11) {
        var t11 = 0 > e11 ? 1 : 0;
        if (0 === (e11 = t11 ? -e11 : e11)) 0 < 1 / e11 ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);
        else if (isNaN(e11)) jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;
        else if (e11 > jspb.BinaryConstants.FLOAT32_MAX) jspb.utils.split64High = 0, jspb.utils.split64Low = (t11 << 31 | 2139095040) >>> 0;
        else if (e11 < jspb.BinaryConstants.FLOAT32_MIN) e11 = Math.round(e11 / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (t11 << 31 | e11) >>> 0;
        else {
            var r11 = Math.floor(Math.log(e11) / Math.LN2);
            e11 *= Math.pow(2, -r11), 16777216 <= (e11 = Math.round(e11 * jspb.BinaryConstants.TWO_TO_23)) && ++r11, jspb.utils.split64High = 0, jspb.utils.split64Low = (t11 << 31 | r11 + 127 << 23 | 8388607 & e11) >>> 0;
        }
    }, jspb.utils.splitFloat64 = function(e11) {
        var t11 = 0 > e11 ? 1 : 0;
        if (0 === (e11 = t11 ? -e11 : e11)) jspb.utils.split64High = 0 < 1 / e11 ? 0 : 2147483648, jspb.utils.split64Low = 0;
        else if (isNaN(e11)) jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;
        else if (e11 > jspb.BinaryConstants.FLOAT64_MAX) jspb.utils.split64High = (t11 << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;
        else if (e11 < jspb.BinaryConstants.FLOAT64_MIN) {
            var r11 = e11 / Math.pow(2, -1074);
            e11 = r11 / jspb.BinaryConstants.TWO_TO_32, jspb.utils.split64High = (t11 << 31 | e11) >>> 0, jspb.utils.split64Low = r11 >>> 0;
        } else {
            var o11 = 0;
            if (2 <= (r11 = e11)) for(; 2 <= r11 && 1023 > o11;)o11++, r11 /= 2;
            else for(; 1 > r11 && -1022 < o11;)r11 *= 2, o11--;
            e11 = (r11 = e11 * Math.pow(2, -o11)) * jspb.BinaryConstants.TWO_TO_20 & 1048575, r11 = r11 * jspb.BinaryConstants.TWO_TO_52 >>> 0, jspb.utils.split64High = (t11 << 31 | o11 + 1023 << 20 | e11) >>> 0, jspb.utils.split64Low = r11;
        }
    }, jspb.utils.splitHash64 = function(e11) {
        var t11 = e11.charCodeAt(0), r11 = e11.charCodeAt(1), o11 = e11.charCodeAt(2), i11 = e11.charCodeAt(3), a11 = e11.charCodeAt(4), n11 = e11.charCodeAt(5), s11 = e11.charCodeAt(6);
        e11 = e11.charCodeAt(7), jspb.utils.split64Low = t11 + (r11 << 8) + (o11 << 16) + (i11 << 24) >>> 0, jspb.utils.split64High = a11 + (n11 << 8) + (s11 << 16) + (e11 << 24) >>> 0;
    }, jspb.utils.joinUint64 = function(e11, t11) {
        return t11 * jspb.BinaryConstants.TWO_TO_32 + (e11 >>> 0);
    }, jspb.utils.joinInt64 = function(e11, t11) {
        var r11 = 2147483648 & t11;
        return r11 && (t11 = ~t11 >>> 0, 0 == (e11 = 1 + ~e11 >>> 0) && (t11 = t11 + 1 >>> 0)), e11 = jspb.utils.joinUint64(e11, t11), r11 ? -e11 : e11;
    }, jspb.utils.toZigzag64 = function(e11, t11, r11) {
        var o11 = t11 >> 31;
        return r11(e11 << 1 ^ o11, (t11 << 1 | e11 >>> 31) ^ o11);
    }, jspb.utils.joinZigzag64 = function(e11, t11) {
        return jspb.utils.fromZigzag64(e11, t11, jspb.utils.joinInt64);
    }, jspb.utils.fromZigzag64 = function(e11, t11, r11) {
        var o11 = -(1 & e11);
        return r11((e11 >>> 1 | t11 << 31) ^ o11, t11 >>> 1 ^ o11);
    }, jspb.utils.joinFloat32 = function(e11, t11) {
        t11 = 2 * (e11 >> 31) + 1;
        var r11 = e11 >>> 23 & 255;
        return e11 &= 8388607, 255 == r11 ? e11 ? NaN : 1 / 0 * t11 : 0 == r11 ? t11 * Math.pow(2, -149) * e11 : t11 * Math.pow(2, r11 - 150) * (e11 + Math.pow(2, 23));
    }, jspb.utils.joinFloat64 = function(e11, t11) {
        var r11 = 2 * (t11 >> 31) + 1, o11 = t11 >>> 20 & 2047;
        return e11 = jspb.BinaryConstants.TWO_TO_32 * (1048575 & t11) + e11, 2047 == o11 ? e11 ? NaN : 1 / 0 * r11 : 0 == o11 ? r11 * Math.pow(2, -1074) * e11 : r11 * Math.pow(2, o11 - 1075) * (e11 + jspb.BinaryConstants.TWO_TO_52);
    }, jspb.utils.joinHash64 = function(e11, t11) {
        return String.fromCharCode(e11 >>> 0 & 255, e11 >>> 8 & 255, e11 >>> 16 & 255, e11 >>> 24 & 255, t11 >>> 0 & 255, t11 >>> 8 & 255, t11 >>> 16 & 255, t11 >>> 24 & 255);
    }, jspb.utils.DIGITS = "0123456789abcdef".split(""), jspb.utils.ZERO_CHAR_CODE_ = 48, jspb.utils.A_CHAR_CODE_ = 97, jspb.utils.joinUnsignedDecimalString = function(e11, t11) {
        function r11(e11, t11) {
            return e11 = e11 ? String(e11) : "", t11 ? "0000000".slice(e11.length) + e11 : e11;
        }
        if (2097151 >= t11) return "" + jspb.utils.joinUint64(e11, t11);
        var o11 = (e11 >>> 24 | t11 << 8) >>> 0 & 16777215;
        return e11 = (16777215 & e11) + 6777216 * o11 + 6710656 * (t11 = t11 >> 16 & 65535), o11 += 8147497 * t11, t11 *= 2, 1e7 <= e11 && (o11 += Math.floor(e11 / 1e7), e11 %= 1e7), 1e7 <= o11 && (t11 += Math.floor(o11 / 1e7), o11 %= 1e7), r11(t11, 0) + r11(o11, t11) + r11(e11, 1);
    }, jspb.utils.joinSignedDecimalString = function(e11, t11) {
        var r11 = 2147483648 & t11;
        return r11 && (t11 = ~t11 + (0 == (e11 = 1 + ~e11 >>> 0) ? 1 : 0) >>> 0), e11 = jspb.utils.joinUnsignedDecimalString(e11, t11), r11 ? "-" + e11 : e11;
    }, jspb.utils.hash64ToDecimalString = function(e11, t11) {
        jspb.utils.splitHash64(e11), e11 = jspb.utils.split64Low;
        var r11 = jspb.utils.split64High;
        return t11 ? jspb.utils.joinSignedDecimalString(e11, r11) : jspb.utils.joinUnsignedDecimalString(e11, r11);
    }, jspb.utils.hash64ArrayToDecimalStrings = function(e11, t11) {
        for(var r11 = Array(e11.length), o11 = 0; o11 < e11.length; o11++)r11[o11] = jspb.utils.hash64ToDecimalString(e11[o11], t11);
        return r11;
    }, jspb.utils.decimalStringToHash64 = function(e11) {
        function t11(e11, t11) {
            for(var r11 = 0; 8 > r11 && (1 !== e11 || 0 < t11); r11++)t11 = e11 * o11[r11] + t11, o11[r11] = 255 & t11, t11 >>>= 8;
        }
        jspb.asserts.assert(0 < e11.length);
        var r11 = !1;
        "-" === e11[0] && (r11 = !0, e11 = e11.slice(1));
        for(var o11 = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i11 = 0; i11 < e11.length; i11++)t11(10, e11.charCodeAt(i11) - jspb.utils.ZERO_CHAR_CODE_);
        return r11 && (function() {
            for(var e11 = 0; 8 > e11; e11++)o11[e11] = 255 & ~o11[e11];
        }(), t11(1, 1)), goog.crypt.byteArrayToString(o11);
    }, jspb.utils.splitDecimalString = function(e11) {
        jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e11));
    }, jspb.utils.toHexDigit_ = function(e11) {
        return String.fromCharCode(10 > e11 ? jspb.utils.ZERO_CHAR_CODE_ + e11 : jspb.utils.A_CHAR_CODE_ - 10 + e11);
    }, jspb.utils.fromHexCharCode_ = function(e11) {
        return e11 >= jspb.utils.A_CHAR_CODE_ ? e11 - jspb.utils.A_CHAR_CODE_ + 10 : e11 - jspb.utils.ZERO_CHAR_CODE_;
    }, jspb.utils.hash64ToHexString = function(e11) {
        var t11 = Array(18);
        t11[0] = "0", t11[1] = "x";
        for(var r11 = 0; 8 > r11; r11++){
            var o11 = e11.charCodeAt(7 - r11);
            t11[2 * r11 + 2] = jspb.utils.toHexDigit_(o11 >> 4), t11[2 * r11 + 3] = jspb.utils.toHexDigit_(15 & o11);
        }
        return t11.join("");
    }, jspb.utils.hexStringToHash64 = function(e11) {
        e11 = e11.toLowerCase(), jspb.asserts.assert(18 == e11.length), jspb.asserts.assert("0" == e11[0]), jspb.asserts.assert("x" == e11[1]);
        for(var t11 = "", r11 = 0; 8 > r11; r11++){
            var o11 = jspb.utils.fromHexCharCode_(e11.charCodeAt(2 * r11 + 2)), i11 = jspb.utils.fromHexCharCode_(e11.charCodeAt(2 * r11 + 3));
            t11 = String.fromCharCode(16 * o11 + i11) + t11;
        }
        return t11;
    }, jspb.utils.hash64ToNumber = function(e11, t11) {
        jspb.utils.splitHash64(e11), e11 = jspb.utils.split64Low;
        var r11 = jspb.utils.split64High;
        return t11 ? jspb.utils.joinInt64(e11, r11) : jspb.utils.joinUint64(e11, r11);
    }, jspb.utils.numberToHash64 = function(e11) {
        return jspb.utils.splitInt64(e11), jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
    }, jspb.utils.countVarints = function(e11, t11, r11) {
        for(var o11 = 0, i11 = t11; i11 < r11; i11++)o11 += e11[i11] >> 7;
        return r11 - t11 - o11;
    }, jspb.utils.countVarintFields = function(e11, t11, r11, o11) {
        var i11 = 0;
        if (128 > (o11 = 8 * o11 + jspb.BinaryConstants.WireType.VARINT)) for(; t11 < r11 && e11[t11++] == o11;)for(i11++;;){
            var a11 = e11[t11++];
            if (0 == (128 & a11)) break;
        }
        else for(; t11 < r11;){
            for(a11 = o11; 128 < a11;){
                if (e11[t11] != (127 & a11 | 128)) return i11;
                t11++, a11 >>= 7;
            }
            if (e11[t11++] != a11) break;
            for(i11++; 0 != (128 & (a11 = e11[t11++])););
        }
        return i11;
    }, jspb.utils.countFixedFields_ = function(e11, t11, r11, o11, i11) {
        var a11 = 0;
        if (128 > o11) for(; t11 < r11 && e11[t11++] == o11;)a11++, t11 += i11;
        else for(; t11 < r11;){
            for(var n11 = o11; 128 < n11;){
                if (e11[t11++] != (127 & n11 | 128)) return a11;
                n11 >>= 7;
            }
            if (e11[t11++] != n11) break;
            a11++, t11 += i11;
        }
        return a11;
    }, jspb.utils.countFixed32Fields = function(e11, t11, r11, o11) {
        return jspb.utils.countFixedFields_(e11, t11, r11, 8 * o11 + jspb.BinaryConstants.WireType.FIXED32, 4);
    }, jspb.utils.countFixed64Fields = function(e11, t11, r11, o11) {
        return jspb.utils.countFixedFields_(e11, t11, r11, 8 * o11 + jspb.BinaryConstants.WireType.FIXED64, 8);
    }, jspb.utils.countDelimitedFields = function(e11, t11, r11, o11) {
        var i11 = 0;
        for(o11 = 8 * o11 + jspb.BinaryConstants.WireType.DELIMITED; t11 < r11;){
            for(var a11 = o11; 128 < a11;){
                if (e11[t11++] != (127 & a11 | 128)) return i11;
                a11 >>= 7;
            }
            if (e11[t11++] != a11) break;
            i11++;
            for(var n11 = 0, s11 = 1; n11 += (127 & (a11 = e11[t11++])) * s11, s11 *= 128, 0 != (128 & a11););
            t11 += n11;
        }
        return i11;
    }, jspb.utils.debugBytesToTextFormat = function(e11) {
        var t11 = '"';
        if (e11) {
            e11 = jspb.utils.byteSourceToUint8Array(e11);
            for(var r11 = 0; r11 < e11.length; r11++)t11 += "\\x", 16 > e11[r11] && (t11 += "0"), t11 += e11[r11].toString(16);
        }
        return t11 + '"';
    }, jspb.utils.debugScalarToTextFormat = function(e11) {
        return "string" == typeof e11 ? goog.string.quote(e11) : e11.toString();
    }, jspb.utils.stringToByteArray = function(e11) {
        for(var t11 = new Uint8Array(e11.length), r11 = 0; r11 < e11.length; r11++){
            var o11 = e11.charCodeAt(r11);
            if (255 < o11) throw Error("Conversion error: string contains codepoint outside of byte range");
            t11[r11] = o11;
        }
        return t11;
    }, jspb.utils.byteSourceToUint8Array = function(e11) {
        return e11.constructor === Uint8Array ? e11 : e11.constructor === ArrayBuffer || e11.constructor === Array ? new Uint8Array(e11) : e11.constructor === String ? goog.crypt.base64.decodeStringToUint8Array(e11) : e11 instanceof Uint8Array ? new Uint8Array(e11.buffer, e11.byteOffset, e11.byteLength) : (jspb.asserts.fail("Type not convertible to Uint8Array."), new Uint8Array(0));
    }, jspb.BinaryDecoder = function(e11, t11, r11) {
        this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1, e11 && this.setBlock(e11, t11, r11);
    }, jspb.BinaryDecoder.instanceCache_ = [], jspb.BinaryDecoder.alloc = function(e11, t11, r11) {
        if (jspb.BinaryDecoder.instanceCache_.length) {
            var o11 = jspb.BinaryDecoder.instanceCache_.pop();
            return e11 && o11.setBlock(e11, t11, r11), o11;
        }
        return new jspb.BinaryDecoder(e11, t11, r11);
    }, jspb.BinaryDecoder.prototype.free = function() {
        this.clear(), 100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
    }, jspb.BinaryDecoder.prototype.clone = function() {
        return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
    }, jspb.BinaryDecoder.prototype.clear = function() {
        this.bytes_ = null, this.cursor_ = this.end_ = this.start_ = 0, this.error_ = !1;
    }, jspb.BinaryDecoder.prototype.getBuffer = function() {
        return this.bytes_;
    }, jspb.BinaryDecoder.prototype.setBlock = function(e11, t11, r11) {
        this.bytes_ = jspb.utils.byteSourceToUint8Array(e11), this.start_ = void 0 !== t11 ? t11 : 0, this.end_ = void 0 !== r11 ? this.start_ + r11 : this.bytes_.length, this.cursor_ = this.start_;
    }, jspb.BinaryDecoder.prototype.getEnd = function() {
        return this.end_;
    }, jspb.BinaryDecoder.prototype.setEnd = function(e11) {
        this.end_ = e11;
    }, jspb.BinaryDecoder.prototype.reset = function() {
        this.cursor_ = this.start_;
    }, jspb.BinaryDecoder.prototype.getCursor = function() {
        return this.cursor_;
    }, jspb.BinaryDecoder.prototype.setCursor = function(e11) {
        this.cursor_ = e11;
    }, jspb.BinaryDecoder.prototype.advance = function(e11) {
        this.cursor_ += e11, jspb.asserts.assert(this.cursor_ <= this.end_);
    }, jspb.BinaryDecoder.prototype.atEnd = function() {
        return this.cursor_ == this.end_;
    }, jspb.BinaryDecoder.prototype.pastEnd = function() {
        return this.cursor_ > this.end_;
    }, jspb.BinaryDecoder.prototype.getError = function() {
        return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
    }, jspb.BinaryDecoder.prototype.readSplitVarint64 = function(e11) {
        for(var t11 = 128, r11 = 0, o11 = 0, i11 = 0; 4 > i11 && 128 <= t11; i11++)r11 |= (127 & (t11 = this.bytes_[this.cursor_++])) << 7 * i11;
        if (128 <= t11 && (r11 |= (127 & (t11 = this.bytes_[this.cursor_++])) << 28, o11 |= (127 & t11) >> 4), 128 <= t11) for(i11 = 0; 5 > i11 && 128 <= t11; i11++)o11 |= (127 & (t11 = this.bytes_[this.cursor_++])) << 7 * i11 + 3;
        if (128 > t11) return e11(r11 >>> 0, o11 >>> 0);
        jspb.asserts.fail("Failed to read varint, encoding is invalid."), this.error_ = !0;
    }, jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function(e11) {
        return this.readSplitVarint64(function(t11, r11) {
            return jspb.utils.fromZigzag64(t11, r11, e11);
        });
    }, jspb.BinaryDecoder.prototype.readSplitFixed64 = function(e11) {
        var t11 = this.bytes_, r11 = this.cursor_;
        this.cursor_ += 8;
        for(var o11 = 0, i11 = 0, a11 = r11 + 7; a11 >= r11; a11--)o11 = o11 << 8 | t11[a11], i11 = i11 << 8 | t11[a11 + 4];
        return e11(o11, i11);
    }, jspb.BinaryDecoder.prototype.skipVarint = function() {
        for(; 128 & this.bytes_[this.cursor_];)this.cursor_++;
        this.cursor_++;
    }, jspb.BinaryDecoder.prototype.unskipVarint = function(e11) {
        for(; 128 < e11;)this.cursor_--, e11 >>>= 7;
        this.cursor_--;
    }, jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function() {
        var e11 = this.bytes_, t11 = e11[this.cursor_ + 0], r11 = 127 & t11;
        return 128 > t11 ? (this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), r11) : (r11 |= (127 & (t11 = e11[this.cursor_ + 1])) << 7, 128 > t11 ? (this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), r11) : (r11 |= (127 & (t11 = e11[this.cursor_ + 2])) << 14, 128 > t11 ? (this.cursor_ += 3, jspb.asserts.assert(this.cursor_ <= this.end_), r11) : (r11 |= (127 & (t11 = e11[this.cursor_ + 3])) << 21, 128 > t11 ? (this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), r11) : (r11 |= (15 & (t11 = e11[this.cursor_ + 4])) << 28, 128 > t11 ? (this.cursor_ += 5, jspb.asserts.assert(this.cursor_ <= this.end_), r11 >>> 0) : (this.cursor_ += 5, 128 <= e11[this.cursor_++] && 128 <= e11[this.cursor_++] && 128 <= e11[this.cursor_++] && 128 <= e11[this.cursor_++] && 128 <= e11[this.cursor_++] && jspb.asserts.assert(!1), jspb.asserts.assert(this.cursor_ <= this.end_), r11)))));
    }, jspb.BinaryDecoder.prototype.readSignedVarint32 = function() {
        return ~~this.readUnsignedVarint32();
    }, jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function() {
        return this.readUnsignedVarint32().toString();
    }, jspb.BinaryDecoder.prototype.readSignedVarint32String = function() {
        return this.readSignedVarint32().toString();
    }, jspb.BinaryDecoder.prototype.readZigzagVarint32 = function() {
        var e11 = this.readUnsignedVarint32();
        return e11 >>> 1 ^ -(1 & e11);
    }, jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function() {
        return this.readSplitVarint64(jspb.utils.joinUint64);
    }, jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function() {
        return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
    }, jspb.BinaryDecoder.prototype.readSignedVarint64 = function() {
        return this.readSplitVarint64(jspb.utils.joinInt64);
    }, jspb.BinaryDecoder.prototype.readSignedVarint64String = function() {
        return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
    }, jspb.BinaryDecoder.prototype.readZigzagVarint64 = function() {
        return this.readSplitVarint64(jspb.utils.joinZigzag64);
    }, jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function() {
        return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
    }, jspb.BinaryDecoder.prototype.readZigzagVarint64String = function() {
        return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
    }, jspb.BinaryDecoder.prototype.readUint8 = function() {
        var e11 = this.bytes_[this.cursor_ + 0];
        return this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), e11;
    }, jspb.BinaryDecoder.prototype.readUint16 = function() {
        var e11 = this.bytes_[this.cursor_ + 0], t11 = this.bytes_[this.cursor_ + 1];
        return this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), e11 << 0 | t11 << 8;
    }, jspb.BinaryDecoder.prototype.readUint32 = function() {
        var e11 = this.bytes_[this.cursor_ + 0], t11 = this.bytes_[this.cursor_ + 1], r11 = this.bytes_[this.cursor_ + 2], o11 = this.bytes_[this.cursor_ + 3];
        return this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), (e11 << 0 | t11 << 8 | r11 << 16 | o11 << 24) >>> 0;
    }, jspb.BinaryDecoder.prototype.readUint64 = function() {
        var e11 = this.readUint32(), t11 = this.readUint32();
        return jspb.utils.joinUint64(e11, t11);
    }, jspb.BinaryDecoder.prototype.readUint64String = function() {
        var e11 = this.readUint32(), t11 = this.readUint32();
        return jspb.utils.joinUnsignedDecimalString(e11, t11);
    }, jspb.BinaryDecoder.prototype.readInt8 = function() {
        var e11 = this.bytes_[this.cursor_ + 0];
        return this.cursor_ += 1, jspb.asserts.assert(this.cursor_ <= this.end_), e11 << 24 >> 24;
    }, jspb.BinaryDecoder.prototype.readInt16 = function() {
        var e11 = this.bytes_[this.cursor_ + 0], t11 = this.bytes_[this.cursor_ + 1];
        return this.cursor_ += 2, jspb.asserts.assert(this.cursor_ <= this.end_), (e11 << 0 | t11 << 8) << 16 >> 16;
    }, jspb.BinaryDecoder.prototype.readInt32 = function() {
        var e11 = this.bytes_[this.cursor_ + 0], t11 = this.bytes_[this.cursor_ + 1], r11 = this.bytes_[this.cursor_ + 2], o11 = this.bytes_[this.cursor_ + 3];
        return this.cursor_ += 4, jspb.asserts.assert(this.cursor_ <= this.end_), e11 << 0 | t11 << 8 | r11 << 16 | o11 << 24;
    }, jspb.BinaryDecoder.prototype.readInt64 = function() {
        var e11 = this.readUint32(), t11 = this.readUint32();
        return jspb.utils.joinInt64(e11, t11);
    }, jspb.BinaryDecoder.prototype.readInt64String = function() {
        var e11 = this.readUint32(), t11 = this.readUint32();
        return jspb.utils.joinSignedDecimalString(e11, t11);
    }, jspb.BinaryDecoder.prototype.readFloat = function() {
        var e11 = this.readUint32();
        return jspb.utils.joinFloat32(e11, 0);
    }, jspb.BinaryDecoder.prototype.readDouble = function() {
        var e11 = this.readUint32(), t11 = this.readUint32();
        return jspb.utils.joinFloat64(e11, t11);
    }, jspb.BinaryDecoder.prototype.readBool = function() {
        return !!this.bytes_[this.cursor_++];
    }, jspb.BinaryDecoder.prototype.readEnum = function() {
        return this.readSignedVarint32();
    }, jspb.BinaryDecoder.prototype.readString = function(e11) {
        var t11 = this.bytes_, r11 = this.cursor_;
        e11 = r11 + e11;
        for(var o11 = [], i11 = ""; r11 < e11;){
            var a11 = t11[r11++];
            if (128 > a11) o11.push(a11);
            else {
                if (192 > a11) continue;
                if (224 > a11) {
                    var n11 = t11[r11++];
                    o11.push((31 & a11) << 6 | 63 & n11);
                } else if (240 > a11) {
                    n11 = t11[r11++];
                    var s11 = t11[r11++];
                    o11.push((15 & a11) << 12 | (63 & n11) << 6 | 63 & s11);
                } else if (248 > a11) a11 = (7 & a11) << 18 | (63 & (n11 = t11[r11++])) << 12 | (63 & (s11 = t11[r11++])) << 6 | 63 & t11[r11++], a11 -= 65536, o11.push(55296 + (a11 >> 10 & 1023), 56320 + (1023 & a11));
            }
            8192 <= o11.length && (i11 += String.fromCharCode.apply(null, o11), o11.length = 0);
        }
        return i11 += goog.crypt.byteArrayToString(o11), this.cursor_ = r11, i11;
    }, jspb.BinaryDecoder.prototype.readStringWithLength = function() {
        var e11 = this.readUnsignedVarint32();
        return this.readString(e11);
    }, jspb.BinaryDecoder.prototype.readBytes = function(e11) {
        if (0 > e11 || this.cursor_ + e11 > this.bytes_.length) return this.error_ = !0, jspb.asserts.fail("Invalid byte length!"), new Uint8Array(0);
        var t11 = this.bytes_.subarray(this.cursor_, this.cursor_ + e11);
        return this.cursor_ += e11, jspb.asserts.assert(this.cursor_ <= this.end_), t11;
    }, jspb.BinaryDecoder.prototype.readVarintHash64 = function() {
        return this.readSplitVarint64(jspb.utils.joinHash64);
    }, jspb.BinaryDecoder.prototype.readFixedHash64 = function() {
        var e11 = this.bytes_, t11 = this.cursor_, r11 = e11[t11 + 0], o11 = e11[t11 + 1], i11 = e11[t11 + 2], a11 = e11[t11 + 3], n11 = e11[t11 + 4], s11 = e11[t11 + 5], p11 = e11[t11 + 6];
        return e11 = e11[t11 + 7], this.cursor_ += 8, String.fromCharCode(r11, o11, i11, a11, n11, s11, p11, e11);
    }, jspb.BinaryReader = function(e11, t11, r11) {
        this.decoder_ = jspb.BinaryDecoder.alloc(e11, t11, r11), this.fieldCursor_ = this.decoder_.getCursor(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null;
    }, jspb.BinaryReader.instanceCache_ = [], jspb.BinaryReader.alloc = function(e11, t11, r11) {
        if (jspb.BinaryReader.instanceCache_.length) {
            var o11 = jspb.BinaryReader.instanceCache_.pop();
            return e11 && o11.decoder_.setBlock(e11, t11, r11), o11;
        }
        return new jspb.BinaryReader(e11, t11, r11);
    }, jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc, jspb.BinaryReader.prototype.free = function() {
        this.decoder_.clear(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID, this.error_ = !1, this.readCallbacks_ = null, 100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
    }, jspb.BinaryReader.prototype.getFieldCursor = function() {
        return this.fieldCursor_;
    }, jspb.BinaryReader.prototype.getCursor = function() {
        return this.decoder_.getCursor();
    }, jspb.BinaryReader.prototype.getBuffer = function() {
        return this.decoder_.getBuffer();
    }, jspb.BinaryReader.prototype.getFieldNumber = function() {
        return this.nextField_;
    }, goog.exportProperty(jspb.BinaryReader.prototype, "getFieldNumber", jspb.BinaryReader.prototype.getFieldNumber), jspb.BinaryReader.prototype.getWireType = function() {
        return this.nextWireType_;
    }, jspb.BinaryReader.prototype.isDelimited = function() {
        return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
    }, goog.exportProperty(jspb.BinaryReader.prototype, "isDelimited", jspb.BinaryReader.prototype.isDelimited), jspb.BinaryReader.prototype.isEndGroup = function() {
        return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
    }, goog.exportProperty(jspb.BinaryReader.prototype, "isEndGroup", jspb.BinaryReader.prototype.isEndGroup), jspb.BinaryReader.prototype.getError = function() {
        return this.error_ || this.decoder_.getError();
    }, jspb.BinaryReader.prototype.setBlock = function(e11, t11, r11) {
        this.decoder_.setBlock(e11, t11, r11), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    }, jspb.BinaryReader.prototype.reset = function() {
        this.decoder_.reset(), this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER, this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    }, jspb.BinaryReader.prototype.advance = function(e11) {
        this.decoder_.advance(e11);
    }, jspb.BinaryReader.prototype.nextField = function() {
        if (this.decoder_.atEnd()) return !1;
        if (this.getError()) return jspb.asserts.fail("Decoder hit an error"), !1;
        this.fieldCursor_ = this.decoder_.getCursor();
        var e11 = this.decoder_.readUnsignedVarint32(), t11 = e11 >>> 3;
        return (e11 &= 7) != jspb.BinaryConstants.WireType.VARINT && e11 != jspb.BinaryConstants.WireType.FIXED32 && e11 != jspb.BinaryConstants.WireType.FIXED64 && e11 != jspb.BinaryConstants.WireType.DELIMITED && e11 != jspb.BinaryConstants.WireType.START_GROUP && e11 != jspb.BinaryConstants.WireType.END_GROUP ? (jspb.asserts.fail("Invalid wire type: %s (at position %s)", e11, this.fieldCursor_), this.error_ = !0, !1) : (this.nextField_ = t11, this.nextWireType_ = e11, !0);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "nextField", jspb.BinaryReader.prototype.nextField), jspb.BinaryReader.prototype.unskipHeader = function() {
        this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
    }, jspb.BinaryReader.prototype.skipMatchingFields = function() {
        var e11 = this.nextField_;
        for(this.unskipHeader(); this.nextField() && this.getFieldNumber() == e11;)this.skipField();
        this.decoder_.atEnd() || this.unskipHeader();
    }, jspb.BinaryReader.prototype.skipVarintField = function() {
        this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (jspb.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
    }, jspb.BinaryReader.prototype.skipDelimitedField = function() {
        if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED) jspb.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();
        else {
            var e11 = this.decoder_.readUnsignedVarint32();
            this.decoder_.advance(e11);
        }
    }, jspb.BinaryReader.prototype.skipFixed32Field = function() {
        this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (jspb.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
    }, jspb.BinaryReader.prototype.skipFixed64Field = function() {
        this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (jspb.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
    }, jspb.BinaryReader.prototype.skipGroup = function() {
        for(var e11 = this.nextField_;;){
            if (!this.nextField()) {
                jspb.asserts.fail("Unmatched start-group tag: stream EOF"), this.error_ = !0;
                break;
            }
            if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
                this.nextField_ != e11 && (jspb.asserts.fail("Unmatched end-group tag"), this.error_ = !0);
                break;
            }
            this.skipField();
        }
    }, jspb.BinaryReader.prototype.skipField = function() {
        switch(this.nextWireType_){
            case jspb.BinaryConstants.WireType.VARINT:
                this.skipVarintField();
                break;
            case jspb.BinaryConstants.WireType.FIXED64:
                this.skipFixed64Field();
                break;
            case jspb.BinaryConstants.WireType.DELIMITED:
                this.skipDelimitedField();
                break;
            case jspb.BinaryConstants.WireType.FIXED32:
                this.skipFixed32Field();
                break;
            case jspb.BinaryConstants.WireType.START_GROUP:
                this.skipGroup();
                break;
            default:
                jspb.asserts.fail("Invalid wire encoding for field.");
        }
    }, jspb.BinaryReader.prototype.registerReadCallback = function(e11, t11) {
        null === this.readCallbacks_ && (this.readCallbacks_ = {}), jspb.asserts.assert(!this.readCallbacks_[e11]), this.readCallbacks_[e11] = t11;
    }, jspb.BinaryReader.prototype.runReadCallback = function(e11) {
        return jspb.asserts.assert(null !== this.readCallbacks_), e11 = this.readCallbacks_[e11], jspb.asserts.assert(e11), e11(this);
    }, jspb.BinaryReader.prototype.readAny = function(e11) {
        this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(e11);
        var t11 = jspb.BinaryConstants.FieldType;
        switch(e11){
            case t11.DOUBLE:
                return this.readDouble();
            case t11.FLOAT:
                return this.readFloat();
            case t11.INT64:
                return this.readInt64();
            case t11.UINT64:
                return this.readUint64();
            case t11.INT32:
                return this.readInt32();
            case t11.FIXED64:
                return this.readFixed64();
            case t11.FIXED32:
                return this.readFixed32();
            case t11.BOOL:
                return this.readBool();
            case t11.STRING:
                return this.readString();
            case t11.GROUP:
                jspb.asserts.fail("Group field type not supported in readAny()");
            case t11.MESSAGE:
                jspb.asserts.fail("Message field type not supported in readAny()");
            case t11.BYTES:
                return this.readBytes();
            case t11.UINT32:
                return this.readUint32();
            case t11.ENUM:
                return this.readEnum();
            case t11.SFIXED32:
                return this.readSfixed32();
            case t11.SFIXED64:
                return this.readSfixed64();
            case t11.SINT32:
                return this.readSint32();
            case t11.SINT64:
                return this.readSint64();
            case t11.FHASH64:
                return this.readFixedHash64();
            case t11.VHASH64:
                return this.readVarintHash64();
            default:
                jspb.asserts.fail("Invalid field type in readAny()");
        }
        return 0;
    }, jspb.BinaryReader.prototype.readMessage = function(e11, t11) {
        jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
        var r11 = this.decoder_.getEnd(), o11 = this.decoder_.readUnsignedVarint32();
        o11 = this.decoder_.getCursor() + o11, this.decoder_.setEnd(o11), t11(e11, this), this.decoder_.setCursor(o11), this.decoder_.setEnd(r11);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readMessage", jspb.BinaryReader.prototype.readMessage), jspb.BinaryReader.prototype.readGroup = function(e11, t11, r11) {
        jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP), jspb.asserts.assert(this.nextField_ == e11), r11(t11, this), this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (jspb.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = !0);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readGroup", jspb.BinaryReader.prototype.readGroup), jspb.BinaryReader.prototype.getFieldDecoder = function() {
        jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
        var e11 = this.decoder_.readUnsignedVarint32(), t11 = this.decoder_.getCursor(), r11 = t11 + e11;
        return e11 = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), t11, e11), this.decoder_.setCursor(r11), e11;
    }, jspb.BinaryReader.prototype.readInt32 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readInt32", jspb.BinaryReader.prototype.readInt32), jspb.BinaryReader.prototype.readInt32String = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint32String();
    }, jspb.BinaryReader.prototype.readInt64 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readInt64", jspb.BinaryReader.prototype.readInt64), jspb.BinaryReader.prototype.readInt64String = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64String();
    }, jspb.BinaryReader.prototype.readUint32 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readUint32", jspb.BinaryReader.prototype.readUint32), jspb.BinaryReader.prototype.readUint32String = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint32String();
    }, jspb.BinaryReader.prototype.readUint64 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readUint64", jspb.BinaryReader.prototype.readUint64), jspb.BinaryReader.prototype.readUint64String = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readUnsignedVarint64String();
    }, jspb.BinaryReader.prototype.readSint32 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint32();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readSint32", jspb.BinaryReader.prototype.readSint32), jspb.BinaryReader.prototype.readSint64 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readSint64", jspb.BinaryReader.prototype.readSint64), jspb.BinaryReader.prototype.readSint64String = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarint64String();
    }, jspb.BinaryReader.prototype.readFixed32 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readUint32();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readFixed32", jspb.BinaryReader.prototype.readFixed32), jspb.BinaryReader.prototype.readFixed64 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readFixed64", jspb.BinaryReader.prototype.readFixed64), jspb.BinaryReader.prototype.readFixed64String = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readUint64String();
    }, jspb.BinaryReader.prototype.readSfixed32 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readSfixed32", jspb.BinaryReader.prototype.readSfixed32), jspb.BinaryReader.prototype.readSfixed32String = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readInt32().toString();
    }, jspb.BinaryReader.prototype.readSfixed64 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readSfixed64", jspb.BinaryReader.prototype.readSfixed64), jspb.BinaryReader.prototype.readSfixed64String = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readInt64String();
    }, jspb.BinaryReader.prototype.readFloat = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32), this.decoder_.readFloat();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readFloat", jspb.BinaryReader.prototype.readFloat), jspb.BinaryReader.prototype.readDouble = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readDouble();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readDouble", jspb.BinaryReader.prototype.readDouble), jspb.BinaryReader.prototype.readBool = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), !!this.decoder_.readUnsignedVarint32();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readBool", jspb.BinaryReader.prototype.readBool), jspb.BinaryReader.prototype.readEnum = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSignedVarint64();
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readEnum", jspb.BinaryReader.prototype.readEnum), jspb.BinaryReader.prototype.readString = function() {
        jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
        var e11 = this.decoder_.readUnsignedVarint32();
        return this.decoder_.readString(e11);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readString", jspb.BinaryReader.prototype.readString), jspb.BinaryReader.prototype.readBytes = function() {
        jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
        var e11 = this.decoder_.readUnsignedVarint32();
        return this.decoder_.readBytes(e11);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readBytes", jspb.BinaryReader.prototype.readBytes), jspb.BinaryReader.prototype.readVarintHash64 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readVarintHash64();
    }, jspb.BinaryReader.prototype.readSintHash64 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readZigzagVarintHash64();
    }, jspb.BinaryReader.prototype.readSplitVarint64 = function(e11) {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(e11);
    }, jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function(e11) {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT), this.decoder_.readSplitVarint64(function(t11, r11) {
            return jspb.utils.fromZigzag64(t11, r11, e11);
        });
    }, jspb.BinaryReader.prototype.readFixedHash64 = function() {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readFixedHash64();
    }, jspb.BinaryReader.prototype.readSplitFixed64 = function(e11) {
        return jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64), this.decoder_.readSplitFixed64(e11);
    }, jspb.BinaryReader.prototype.readPackedField_ = function(e11) {
        jspb.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
        var t11 = this.decoder_.readUnsignedVarint32();
        t11 = this.decoder_.getCursor() + t11;
        for(var r11 = []; this.decoder_.getCursor() < t11;)r11.push(e11.call(this.decoder_));
        return r11;
    }, jspb.BinaryReader.prototype.readPackedInt32 = function() {
        return this.readPackedField_(this.decoder_.readSignedVarint32);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedInt32", jspb.BinaryReader.prototype.readPackedInt32), jspb.BinaryReader.prototype.readPackedInt32String = function() {
        return this.readPackedField_(this.decoder_.readSignedVarint32String);
    }, jspb.BinaryReader.prototype.readPackedInt64 = function() {
        return this.readPackedField_(this.decoder_.readSignedVarint64);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedInt64", jspb.BinaryReader.prototype.readPackedInt64), jspb.BinaryReader.prototype.readPackedInt64String = function() {
        return this.readPackedField_(this.decoder_.readSignedVarint64String);
    }, jspb.BinaryReader.prototype.readPackedUint32 = function() {
        return this.readPackedField_(this.decoder_.readUnsignedVarint32);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedUint32", jspb.BinaryReader.prototype.readPackedUint32), jspb.BinaryReader.prototype.readPackedUint32String = function() {
        return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
    }, jspb.BinaryReader.prototype.readPackedUint64 = function() {
        return this.readPackedField_(this.decoder_.readUnsignedVarint64);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedUint64", jspb.BinaryReader.prototype.readPackedUint64), jspb.BinaryReader.prototype.readPackedUint64String = function() {
        return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
    }, jspb.BinaryReader.prototype.readPackedSint32 = function() {
        return this.readPackedField_(this.decoder_.readZigzagVarint32);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSint32", jspb.BinaryReader.prototype.readPackedSint32), jspb.BinaryReader.prototype.readPackedSint64 = function() {
        return this.readPackedField_(this.decoder_.readZigzagVarint64);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSint64", jspb.BinaryReader.prototype.readPackedSint64), jspb.BinaryReader.prototype.readPackedSint64String = function() {
        return this.readPackedField_(this.decoder_.readZigzagVarint64String);
    }, jspb.BinaryReader.prototype.readPackedFixed32 = function() {
        return this.readPackedField_(this.decoder_.readUint32);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFixed32", jspb.BinaryReader.prototype.readPackedFixed32), jspb.BinaryReader.prototype.readPackedFixed64 = function() {
        return this.readPackedField_(this.decoder_.readUint64);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFixed64", jspb.BinaryReader.prototype.readPackedFixed64), jspb.BinaryReader.prototype.readPackedFixed64String = function() {
        return this.readPackedField_(this.decoder_.readUint64String);
    }, jspb.BinaryReader.prototype.readPackedSfixed32 = function() {
        return this.readPackedField_(this.decoder_.readInt32);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSfixed32", jspb.BinaryReader.prototype.readPackedSfixed32), jspb.BinaryReader.prototype.readPackedSfixed64 = function() {
        return this.readPackedField_(this.decoder_.readInt64);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedSfixed64", jspb.BinaryReader.prototype.readPackedSfixed64), jspb.BinaryReader.prototype.readPackedSfixed64String = function() {
        return this.readPackedField_(this.decoder_.readInt64String);
    }, jspb.BinaryReader.prototype.readPackedFloat = function() {
        return this.readPackedField_(this.decoder_.readFloat);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedFloat", jspb.BinaryReader.prototype.readPackedFloat), jspb.BinaryReader.prototype.readPackedDouble = function() {
        return this.readPackedField_(this.decoder_.readDouble);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedDouble", jspb.BinaryReader.prototype.readPackedDouble), jspb.BinaryReader.prototype.readPackedBool = function() {
        return this.readPackedField_(this.decoder_.readBool);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedBool", jspb.BinaryReader.prototype.readPackedBool), jspb.BinaryReader.prototype.readPackedEnum = function() {
        return this.readPackedField_(this.decoder_.readEnum);
    }, goog.exportProperty(jspb.BinaryReader.prototype, "readPackedEnum", jspb.BinaryReader.prototype.readPackedEnum), jspb.BinaryReader.prototype.readPackedVarintHash64 = function() {
        return this.readPackedField_(this.decoder_.readVarintHash64);
    }, jspb.BinaryReader.prototype.readPackedFixedHash64 = function() {
        return this.readPackedField_(this.decoder_.readFixedHash64);
    }, jspb.BinaryEncoder = function() {
        this.buffer_ = [];
    }, jspb.BinaryEncoder.prototype.length = function() {
        return this.buffer_.length;
    }, jspb.BinaryEncoder.prototype.end = function() {
        var e11 = this.buffer_;
        return this.buffer_ = [], e11;
    }, jspb.BinaryEncoder.prototype.writeSplitVarint64 = function(e11, t11) {
        for(jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(t11 == Math.floor(t11)), jspb.asserts.assert(0 <= e11 && e11 < jspb.BinaryConstants.TWO_TO_32), jspb.asserts.assert(0 <= t11 && t11 < jspb.BinaryConstants.TWO_TO_32); 0 < t11 || 127 < e11;)this.buffer_.push(127 & e11 | 128), e11 = (e11 >>> 7 | t11 << 25) >>> 0, t11 >>>= 7;
        this.buffer_.push(e11);
    }, jspb.BinaryEncoder.prototype.writeSplitFixed64 = function(e11, t11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(t11 == Math.floor(t11)), jspb.asserts.assert(0 <= e11 && e11 < jspb.BinaryConstants.TWO_TO_32), jspb.asserts.assert(0 <= t11 && t11 < jspb.BinaryConstants.TWO_TO_32), this.writeUint32(e11), this.writeUint32(t11);
    }, jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function(e11) {
        for(jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(0 <= e11 && e11 < jspb.BinaryConstants.TWO_TO_32); 127 < e11;)this.buffer_.push(127 & e11 | 128), e11 >>>= 7;
        this.buffer_.push(e11);
    }, jspb.BinaryEncoder.prototype.writeSignedVarint32 = function(e11) {
        if (jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(e11 >= -jspb.BinaryConstants.TWO_TO_31 && e11 < jspb.BinaryConstants.TWO_TO_31), 0 <= e11) this.writeUnsignedVarint32(e11);
        else {
            for(var t11 = 0; 9 > t11; t11++)this.buffer_.push(127 & e11 | 128), e11 >>= 7;
            this.buffer_.push(1);
        }
    }, jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(0 <= e11 && e11 < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitInt64(e11), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeSignedVarint64 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(e11 >= -jspb.BinaryConstants.TWO_TO_63 && e11 < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e11), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(e11 >= -jspb.BinaryConstants.TWO_TO_31 && e11 < jspb.BinaryConstants.TWO_TO_31), this.writeUnsignedVarint32((e11 << 1 ^ e11 >> 31) >>> 0);
    }, jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(e11 >= -jspb.BinaryConstants.TWO_TO_63 && e11 < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitZigzag64(e11), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function(e11) {
        this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(e11));
    }, jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function(e11) {
        var t11 = this;
        jspb.utils.splitHash64(e11), jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function(e11, r11) {
            t11.writeSplitVarint64(e11 >>> 0, r11 >>> 0);
        });
    }, jspb.BinaryEncoder.prototype.writeUint8 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(0 <= e11 && 256 > e11), this.buffer_.push(e11 >>> 0 & 255);
    }, jspb.BinaryEncoder.prototype.writeUint16 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(0 <= e11 && 65536 > e11), this.buffer_.push(e11 >>> 0 & 255), this.buffer_.push(e11 >>> 8 & 255);
    }, jspb.BinaryEncoder.prototype.writeUint32 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(0 <= e11 && e11 < jspb.BinaryConstants.TWO_TO_32), this.buffer_.push(e11 >>> 0 & 255), this.buffer_.push(e11 >>> 8 & 255), this.buffer_.push(e11 >>> 16 & 255), this.buffer_.push(e11 >>> 24 & 255);
    }, jspb.BinaryEncoder.prototype.writeUint64 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(0 <= e11 && e11 < jspb.BinaryConstants.TWO_TO_64), jspb.utils.splitUint64(e11), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeInt8 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(-128 <= e11 && 128 > e11), this.buffer_.push(e11 >>> 0 & 255);
    }, jspb.BinaryEncoder.prototype.writeInt16 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(-32768 <= e11 && 32768 > e11), this.buffer_.push(e11 >>> 0 & 255), this.buffer_.push(e11 >>> 8 & 255);
    }, jspb.BinaryEncoder.prototype.writeInt32 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(e11 >= -jspb.BinaryConstants.TWO_TO_31 && e11 < jspb.BinaryConstants.TWO_TO_31), this.buffer_.push(e11 >>> 0 & 255), this.buffer_.push(e11 >>> 8 & 255), this.buffer_.push(e11 >>> 16 & 255), this.buffer_.push(e11 >>> 24 & 255);
    }, jspb.BinaryEncoder.prototype.writeInt64 = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(e11 >= -jspb.BinaryConstants.TWO_TO_63 && e11 < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitInt64(e11), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeInt64String = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(+e11 >= -jspb.BinaryConstants.TWO_TO_63 && +e11 < jspb.BinaryConstants.TWO_TO_63), jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(e11)), this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeFloat = function(e11) {
        jspb.asserts.assert(1 / 0 === e11 || -1 / 0 === e11 || isNaN(e11) || e11 >= -jspb.BinaryConstants.FLOAT32_MAX && e11 <= jspb.BinaryConstants.FLOAT32_MAX), jspb.utils.splitFloat32(e11), this.writeUint32(jspb.utils.split64Low);
    }, jspb.BinaryEncoder.prototype.writeDouble = function(e11) {
        jspb.asserts.assert(1 / 0 === e11 || -1 / 0 === e11 || isNaN(e11) || e11 >= -jspb.BinaryConstants.FLOAT64_MAX && e11 <= jspb.BinaryConstants.FLOAT64_MAX), jspb.utils.splitFloat64(e11), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeBool = function(e11) {
        jspb.asserts.assert("boolean" == typeof e11 || "number" == typeof e11), this.buffer_.push(e11 ? 1 : 0);
    }, jspb.BinaryEncoder.prototype.writeEnum = function(e11) {
        jspb.asserts.assert(e11 == Math.floor(e11)), jspb.asserts.assert(e11 >= -jspb.BinaryConstants.TWO_TO_31 && e11 < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32(e11);
    }, jspb.BinaryEncoder.prototype.writeBytes = function(e11) {
        this.buffer_.push.apply(this.buffer_, e11);
    }, jspb.BinaryEncoder.prototype.writeVarintHash64 = function(e11) {
        jspb.utils.splitHash64(e11), this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeFixedHash64 = function(e11) {
        jspb.utils.splitHash64(e11), this.writeUint32(jspb.utils.split64Low), this.writeUint32(jspb.utils.split64High);
    }, jspb.BinaryEncoder.prototype.writeString = function(e11) {
        var t11 = this.buffer_.length;
        jspb.asserts.assertString(e11);
        for(var r11 = 0; r11 < e11.length; r11++){
            var o11 = e11.charCodeAt(r11);
            if (128 > o11) this.buffer_.push(o11);
            else if (2048 > o11) this.buffer_.push(o11 >> 6 | 192), this.buffer_.push(63 & o11 | 128);
            else if (65536 > o11) {
                if (55296 <= o11 && 56319 >= o11 && r11 + 1 < e11.length) {
                    var i11 = e11.charCodeAt(r11 + 1);
                    56320 <= i11 && 57343 >= i11 && (o11 = 1024 * (o11 - 55296) + i11 - 56320 + 65536, this.buffer_.push(o11 >> 18 | 240), this.buffer_.push(o11 >> 12 & 63 | 128), this.buffer_.push(o11 >> 6 & 63 | 128), this.buffer_.push(63 & o11 | 128), r11++);
                } else this.buffer_.push(o11 >> 12 | 224), this.buffer_.push(o11 >> 6 & 63 | 128), this.buffer_.push(63 & o11 | 128);
            }
        }
        return this.buffer_.length - t11;
    }, jspb.arith = {}, jspb.arith.UInt64 = function(e11, t11) {
        this.lo = e11, this.hi = t11;
    }, jspb.arith.UInt64.prototype.cmp = function(e11) {
        return this.hi < e11.hi || this.hi == e11.hi && this.lo < e11.lo ? -1 : this.hi == e11.hi && this.lo == e11.lo ? 0 : 1;
    }, jspb.arith.UInt64.prototype.rightShift = function() {
        return new jspb.arith.UInt64((this.lo >>> 1 | (1 & this.hi) << 31) >>> 0, this.hi >>> 1 >>> 0);
    }, jspb.arith.UInt64.prototype.leftShift = function() {
        return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
    }, jspb.arith.UInt64.prototype.msb = function() {
        return !!(2147483648 & this.hi);
    }, jspb.arith.UInt64.prototype.lsb = function() {
        return !!(1 & this.lo);
    }, jspb.arith.UInt64.prototype.zero = function() {
        return 0 == this.lo && 0 == this.hi;
    }, jspb.arith.UInt64.prototype.add = function(e11) {
        return new jspb.arith.UInt64((this.lo + e11.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e11.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e11.lo ? 1 : 0) >>> 0);
    }, jspb.arith.UInt64.prototype.sub = function(e11) {
        return new jspb.arith.UInt64((this.lo - e11.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e11.hi & 4294967295) >>> 0) - (0 > this.lo - e11.lo ? 1 : 0) >>> 0);
    }, jspb.arith.UInt64.mul32x32 = function(e11, t11) {
        var r11 = 65535 & e11, o11 = 65535 & t11, i11 = t11 >>> 16;
        for(t11 = r11 * o11 + 65536 * (r11 * i11 & 65535) + 65536 * ((e11 >>>= 16) * o11 & 65535), r11 = e11 * i11 + (r11 * i11 >>> 16) + (e11 * o11 >>> 16); 4294967296 <= t11;)t11 -= 4294967296, r11 += 1;
        return new jspb.arith.UInt64(t11 >>> 0, r11 >>> 0);
    }, jspb.arith.UInt64.prototype.mul = function(e11) {
        var t11 = jspb.arith.UInt64.mul32x32(this.lo, e11);
        return (e11 = jspb.arith.UInt64.mul32x32(this.hi, e11)).hi = e11.lo, e11.lo = 0, t11.add(e11);
    }, jspb.arith.UInt64.prototype.div = function(e11) {
        if (0 == e11) return [];
        var t11 = new jspb.arith.UInt64(0, 0), r11 = new jspb.arith.UInt64(this.lo, this.hi);
        e11 = new jspb.arith.UInt64(e11, 0);
        for(var o11 = new jspb.arith.UInt64(1, 0); !e11.msb();)e11 = e11.leftShift(), o11 = o11.leftShift();
        for(; !o11.zero();)0 >= e11.cmp(r11) && (t11 = t11.add(o11), r11 = r11.sub(e11)), e11 = e11.rightShift(), o11 = o11.rightShift();
        return [
            t11,
            r11
        ];
    }, jspb.arith.UInt64.prototype.toString = function() {
        for(var e11 = "", t11 = this; !t11.zero();){
            var r11 = (t11 = t11.div(10))[0];
            e11 = t11[1].lo + e11, t11 = r11;
        }
        return "" == e11 && (e11 = "0"), e11;
    }, jspb.arith.UInt64.fromString = function(e11) {
        for(var t11 = new jspb.arith.UInt64(0, 0), r11 = new jspb.arith.UInt64(0, 0), o11 = 0; o11 < e11.length; o11++){
            if ("0" > e11[o11] || "9" < e11[o11]) return null;
            var i11 = parseInt(e11[o11], 10);
            r11.lo = i11, t11 = t11.mul(10).add(r11);
        }
        return t11;
    }, jspb.arith.UInt64.prototype.clone = function() {
        return new jspb.arith.UInt64(this.lo, this.hi);
    }, jspb.arith.Int64 = function(e11, t11) {
        this.lo = e11, this.hi = t11;
    }, jspb.arith.Int64.prototype.add = function(e11) {
        return new jspb.arith.Int64((this.lo + e11.lo & 4294967295) >>> 0 >>> 0, ((this.hi + e11.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + e11.lo ? 1 : 0) >>> 0);
    }, jspb.arith.Int64.prototype.sub = function(e11) {
        return new jspb.arith.Int64((this.lo - e11.lo & 4294967295) >>> 0 >>> 0, ((this.hi - e11.hi & 4294967295) >>> 0) - (0 > this.lo - e11.lo ? 1 : 0) >>> 0);
    }, jspb.arith.Int64.prototype.clone = function() {
        return new jspb.arith.Int64(this.lo, this.hi);
    }, jspb.arith.Int64.prototype.toString = function() {
        var e11 = 0 != (2147483648 & this.hi), t11 = new jspb.arith.UInt64(this.lo, this.hi);
        return e11 && (t11 = new jspb.arith.UInt64(0, 0).sub(t11)), (e11 ? "-" : "") + t11.toString();
    }, jspb.arith.Int64.fromString = function(e11) {
        var t11 = 0 < e11.length && "-" == e11[0];
        return t11 && (e11 = e11.substring(1)), null === (e11 = jspb.arith.UInt64.fromString(e11)) ? null : (t11 && (e11 = new jspb.arith.UInt64(0, 0).sub(e11)), new jspb.arith.Int64(e11.lo, e11.hi));
    }, jspb.BinaryWriter = function() {
        this.blocks_ = [], this.totalLength_ = 0, this.encoder_ = new jspb.BinaryEncoder, this.bookmarks_ = [];
    }, jspb.BinaryWriter.prototype.appendUint8Array_ = function(e11) {
        var t11 = this.encoder_.end();
        this.blocks_.push(t11), this.blocks_.push(e11), this.totalLength_ += t11.length + e11.length;
    }, jspb.BinaryWriter.prototype.beginDelimited_ = function(e11) {
        return this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), e11 = this.encoder_.end(), this.blocks_.push(e11), this.totalLength_ += e11.length, e11.push(this.totalLength_), e11;
    }, jspb.BinaryWriter.prototype.endDelimited_ = function(e11) {
        var t11 = e11.pop();
        for(t11 = this.totalLength_ + this.encoder_.length() - t11, jspb.asserts.assert(0 <= t11); 127 < t11;)e11.push(127 & t11 | 128), t11 >>>= 7, this.totalLength_++;
        e11.push(t11), this.totalLength_++;
    }, jspb.BinaryWriter.prototype.writeSerializedMessage = function(e11, t11, r11) {
        this.appendUint8Array_(e11.subarray(t11, r11));
    }, jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function(e11, t11, r11) {
        null != e11 && null != t11 && null != r11 && this.writeSerializedMessage(e11, t11, r11);
    }, jspb.BinaryWriter.prototype.reset = function() {
        this.blocks_ = [], this.encoder_.end(), this.totalLength_ = 0, this.bookmarks_ = [];
    }, jspb.BinaryWriter.prototype.getResultBuffer = function() {
        jspb.asserts.assert(0 == this.bookmarks_.length);
        for(var e11 = new Uint8Array(this.totalLength_ + this.encoder_.length()), t11 = this.blocks_, r11 = t11.length, o11 = 0, i11 = 0; i11 < r11; i11++){
            var a11 = t11[i11];
            e11.set(a11, o11), o11 += a11.length;
        }
        return t11 = this.encoder_.end(), e11.set(t11, o11), o11 += t11.length, jspb.asserts.assert(o11 == e11.length), this.blocks_ = [
            e11
        ], e11;
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "getResultBuffer", jspb.BinaryWriter.prototype.getResultBuffer), jspb.BinaryWriter.prototype.getResultBase64String = function(e11) {
        return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), e11);
    }, jspb.BinaryWriter.prototype.beginSubMessage = function(e11) {
        this.bookmarks_.push(this.beginDelimited_(e11));
    }, jspb.BinaryWriter.prototype.endSubMessage = function() {
        jspb.asserts.assert(0 <= this.bookmarks_.length), this.endDelimited_(this.bookmarks_.pop());
    }, jspb.BinaryWriter.prototype.writeFieldHeader_ = function(e11, t11) {
        jspb.asserts.assert(1 <= e11 && e11 == Math.floor(e11)), this.encoder_.writeUnsignedVarint32(8 * e11 + t11);
    }, jspb.BinaryWriter.prototype.writeAny = function(e11, t11, r11) {
        var o11 = jspb.BinaryConstants.FieldType;
        switch(e11){
            case o11.DOUBLE:
                this.writeDouble(t11, r11);
                break;
            case o11.FLOAT:
                this.writeFloat(t11, r11);
                break;
            case o11.INT64:
                this.writeInt64(t11, r11);
                break;
            case o11.UINT64:
                this.writeUint64(t11, r11);
                break;
            case o11.INT32:
                this.writeInt32(t11, r11);
                break;
            case o11.FIXED64:
                this.writeFixed64(t11, r11);
                break;
            case o11.FIXED32:
                this.writeFixed32(t11, r11);
                break;
            case o11.BOOL:
                this.writeBool(t11, r11);
                break;
            case o11.STRING:
                this.writeString(t11, r11);
                break;
            case o11.GROUP:
                jspb.asserts.fail("Group field type not supported in writeAny()");
                break;
            case o11.MESSAGE:
                jspb.asserts.fail("Message field type not supported in writeAny()");
                break;
            case o11.BYTES:
                this.writeBytes(t11, r11);
                break;
            case o11.UINT32:
                this.writeUint32(t11, r11);
                break;
            case o11.ENUM:
                this.writeEnum(t11, r11);
                break;
            case o11.SFIXED32:
                this.writeSfixed32(t11, r11);
                break;
            case o11.SFIXED64:
                this.writeSfixed64(t11, r11);
                break;
            case o11.SINT32:
                this.writeSint32(t11, r11);
                break;
            case o11.SINT64:
                this.writeSint64(t11, r11);
                break;
            case o11.FHASH64:
                this.writeFixedHash64(t11, r11);
                break;
            case o11.VHASH64:
                this.writeVarintHash64(t11, r11);
                break;
            default:
                jspb.asserts.fail("Invalid field type in writeAny()");
        }
    }, jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(t11));
    }, jspb.BinaryWriter.prototype.writeSignedVarint32_ = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(t11));
    }, jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(t11));
    }, jspb.BinaryWriter.prototype.writeSignedVarint64_ = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(t11));
    }, jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(t11));
    }, jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(t11));
    }, jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(t11));
    }, jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(t11));
    }, jspb.BinaryWriter.prototype.writeInt32 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(t11 >= -jspb.BinaryConstants.TWO_TO_31 && t11 < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e11, t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeInt32", jspb.BinaryWriter.prototype.writeInt32), jspb.BinaryWriter.prototype.writeInt32String = function(e11, t11) {
        null != t11 && (t11 = parseInt(t11, 10), jspb.asserts.assert(t11 >= -jspb.BinaryConstants.TWO_TO_31 && t11 < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(e11, t11));
    }, jspb.BinaryWriter.prototype.writeInt64 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(t11 >= -jspb.BinaryConstants.TWO_TO_63 && t11 < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(e11, t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeInt64", jspb.BinaryWriter.prototype.writeInt64), jspb.BinaryWriter.prototype.writeInt64String = function(e11, t11) {
        null != t11 && (t11 = jspb.arith.Int64.fromString(t11), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t11.lo, t11.hi));
    }, jspb.BinaryWriter.prototype.writeUint32 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(0 <= t11 && t11 < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e11, t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeUint32", jspb.BinaryWriter.prototype.writeUint32), jspb.BinaryWriter.prototype.writeUint32String = function(e11, t11) {
        null != t11 && (t11 = parseInt(t11, 10), jspb.asserts.assert(0 <= t11 && t11 < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(e11, t11));
    }, jspb.BinaryWriter.prototype.writeUint64 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(0 <= t11 && t11 < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(e11, t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeUint64", jspb.BinaryWriter.prototype.writeUint64), jspb.BinaryWriter.prototype.writeUint64String = function(e11, t11) {
        null != t11 && (t11 = jspb.arith.UInt64.fromString(t11), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t11.lo, t11.hi));
    }, jspb.BinaryWriter.prototype.writeSint32 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(t11 >= -jspb.BinaryConstants.TWO_TO_31 && t11 < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(e11, t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSint32", jspb.BinaryWriter.prototype.writeSint32), jspb.BinaryWriter.prototype.writeSint64 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(t11 >= -jspb.BinaryConstants.TWO_TO_63 && t11 < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(e11, t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSint64", jspb.BinaryWriter.prototype.writeSint64), jspb.BinaryWriter.prototype.writeSintHash64 = function(e11, t11) {
        null != t11 && this.writeZigzagVarintHash64_(e11, t11);
    }, jspb.BinaryWriter.prototype.writeSint64String = function(e11, t11) {
        null != t11 && this.writeZigzagVarint64String_(e11, t11);
    }, jspb.BinaryWriter.prototype.writeFixed32 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(0 <= t11 && t11 < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFixed32", jspb.BinaryWriter.prototype.writeFixed32), jspb.BinaryWriter.prototype.writeFixed64 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(0 <= t11 && t11 < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFixed64", jspb.BinaryWriter.prototype.writeFixed64), jspb.BinaryWriter.prototype.writeFixed64String = function(e11, t11) {
        null != t11 && (t11 = jspb.arith.UInt64.fromString(t11), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t11.lo, t11.hi));
    }, jspb.BinaryWriter.prototype.writeSfixed32 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(t11 >= -jspb.BinaryConstants.TWO_TO_31 && t11 < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSfixed32", jspb.BinaryWriter.prototype.writeSfixed32), jspb.BinaryWriter.prototype.writeSfixed64 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(t11 >= -jspb.BinaryConstants.TWO_TO_63 && t11 < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeSfixed64", jspb.BinaryWriter.prototype.writeSfixed64), jspb.BinaryWriter.prototype.writeSfixed64String = function(e11, t11) {
        null != t11 && (t11 = jspb.arith.Int64.fromString(t11), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t11.lo, t11.hi));
    }, jspb.BinaryWriter.prototype.writeFloat = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeFloat", jspb.BinaryWriter.prototype.writeFloat), jspb.BinaryWriter.prototype.writeDouble = function(e11, t11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeDouble", jspb.BinaryWriter.prototype.writeDouble), jspb.BinaryWriter.prototype.writeBool = function(e11, t11) {
        null != t11 && (jspb.asserts.assert("boolean" == typeof t11 || "number" == typeof t11), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeBool", jspb.BinaryWriter.prototype.writeBool), jspb.BinaryWriter.prototype.writeEnum = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(t11 >= -jspb.BinaryConstants.TWO_TO_31 && t11 < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeEnum", jspb.BinaryWriter.prototype.writeEnum), jspb.BinaryWriter.prototype.writeString = function(e11, t11) {
        null != t11 && (e11 = this.beginDelimited_(e11), this.encoder_.writeString(t11), this.endDelimited_(e11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeString", jspb.BinaryWriter.prototype.writeString), jspb.BinaryWriter.prototype.writeBytes = function(e11, t11) {
        null != t11 && (t11 = jspb.utils.byteSourceToUint8Array(t11), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(t11.length), this.appendUint8Array_(t11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeBytes", jspb.BinaryWriter.prototype.writeBytes), jspb.BinaryWriter.prototype.writeMessage = function(e11, t11, r11) {
        null != t11 && (e11 = this.beginDelimited_(e11), r11(t11, this), this.endDelimited_(e11));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeMessage", jspb.BinaryWriter.prototype.writeMessage), jspb.BinaryWriter.prototype.writeMessageSet = function(e11, t11, r11) {
        null != t11 && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(e11), e11 = this.beginDelimited_(3), r11(t11, this), this.endDelimited_(e11), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
    }, jspb.BinaryWriter.prototype.writeGroup = function(e11, t11, r11) {
        null != t11 && (this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.START_GROUP), r11(t11, this), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.END_GROUP));
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeGroup", jspb.BinaryWriter.prototype.writeGroup), jspb.BinaryWriter.prototype.writeFixedHash64 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(8 == t11.length), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(t11));
    }, jspb.BinaryWriter.prototype.writeVarintHash64 = function(e11, t11) {
        null != t11 && (jspb.asserts.assert(8 == t11.length), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(t11));
    }, jspb.BinaryWriter.prototype.writeSplitFixed64 = function(e11, t11, r11) {
        this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(t11, r11);
    }, jspb.BinaryWriter.prototype.writeSplitVarint64 = function(e11, t11, r11) {
        this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(t11, r11);
    }, jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function(e11, t11, r11) {
        this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.VARINT);
        var o11 = this.encoder_;
        jspb.utils.toZigzag64(t11, r11, function(e11, t11) {
            o11.writeSplitVarint64(e11 >>> 0, t11 >>> 0);
        });
    }, jspb.BinaryWriter.prototype.writeRepeatedInt32 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeSignedVarint32_(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedInt32", jspb.BinaryWriter.prototype.writeRepeatedInt32), jspb.BinaryWriter.prototype.writeRepeatedInt32String = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeInt32String(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writeRepeatedInt64 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeSignedVarint64_(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedInt64", jspb.BinaryWriter.prototype.writeRepeatedInt64), jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function(e11, t11, r11, o11) {
        if (null != t11) for(var i11 = 0; i11 < t11.length; i11++)this.writeSplitFixed64(e11, r11(t11[i11]), o11(t11[i11]));
    }, jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function(e11, t11, r11, o11) {
        if (null != t11) for(var i11 = 0; i11 < t11.length; i11++)this.writeSplitVarint64(e11, r11(t11[i11]), o11(t11[i11]));
    }, jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function(e11, t11, r11, o11) {
        if (null != t11) for(var i11 = 0; i11 < t11.length; i11++)this.writeSplitZigzagVarint64(e11, r11(t11[i11]), o11(t11[i11]));
    }, jspb.BinaryWriter.prototype.writeRepeatedInt64String = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeInt64String(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writeRepeatedUint32 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeUnsignedVarint32_(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedUint32", jspb.BinaryWriter.prototype.writeRepeatedUint32), jspb.BinaryWriter.prototype.writeRepeatedUint32String = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeUint32String(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writeRepeatedUint64 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeUnsignedVarint64_(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedUint64", jspb.BinaryWriter.prototype.writeRepeatedUint64), jspb.BinaryWriter.prototype.writeRepeatedUint64String = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeUint64String(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writeRepeatedSint32 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeZigzagVarint32_(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSint32", jspb.BinaryWriter.prototype.writeRepeatedSint32), jspb.BinaryWriter.prototype.writeRepeatedSint64 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeZigzagVarint64_(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSint64", jspb.BinaryWriter.prototype.writeRepeatedSint64), jspb.BinaryWriter.prototype.writeRepeatedSint64String = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeZigzagVarint64String_(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeZigzagVarintHash64_(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeFixed32(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed32", jspb.BinaryWriter.prototype.writeRepeatedFixed32), jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeFixed64(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed64", jspb.BinaryWriter.prototype.writeRepeatedFixed64), jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeFixed64String(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFixed64String", jspb.BinaryWriter.prototype.writeRepeatedFixed64String), jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeSfixed32(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSfixed32", jspb.BinaryWriter.prototype.writeRepeatedSfixed32), jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeSfixed64(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedSfixed64", jspb.BinaryWriter.prototype.writeRepeatedSfixed64), jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeSfixed64String(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writeRepeatedFloat = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeFloat(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedFloat", jspb.BinaryWriter.prototype.writeRepeatedFloat), jspb.BinaryWriter.prototype.writeRepeatedDouble = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeDouble(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedDouble", jspb.BinaryWriter.prototype.writeRepeatedDouble), jspb.BinaryWriter.prototype.writeRepeatedBool = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeBool(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedBool", jspb.BinaryWriter.prototype.writeRepeatedBool), jspb.BinaryWriter.prototype.writeRepeatedEnum = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeEnum(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedEnum", jspb.BinaryWriter.prototype.writeRepeatedEnum), jspb.BinaryWriter.prototype.writeRepeatedString = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeString(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedString", jspb.BinaryWriter.prototype.writeRepeatedString), jspb.BinaryWriter.prototype.writeRepeatedBytes = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeBytes(e11, t11[r11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedBytes", jspb.BinaryWriter.prototype.writeRepeatedBytes), jspb.BinaryWriter.prototype.writeRepeatedMessage = function(e11, t11, r11) {
        if (null != t11) for(var o11 = 0; o11 < t11.length; o11++){
            var i11 = this.beginDelimited_(e11);
            r11(t11[o11], this), this.endDelimited_(i11);
        }
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedMessage", jspb.BinaryWriter.prototype.writeRepeatedMessage), jspb.BinaryWriter.prototype.writeRepeatedGroup = function(e11, t11, r11) {
        if (null != t11) for(var o11 = 0; o11 < t11.length; o11++)this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.START_GROUP), r11(t11[o11], this), this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.END_GROUP);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writeRepeatedGroup", jspb.BinaryWriter.prototype.writeRepeatedGroup), jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeFixedHash64(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function(e11, t11) {
        if (null != t11) for(var r11 = 0; r11 < t11.length; r11++)this.writeVarintHash64(e11, t11[r11]);
    }, jspb.BinaryWriter.prototype.writePackedInt32 = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeSignedVarint32(t11[r11]);
            this.endDelimited_(e11);
        }
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedInt32", jspb.BinaryWriter.prototype.writePackedInt32), jspb.BinaryWriter.prototype.writePackedInt32String = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeSignedVarint32(parseInt(t11[r11], 10));
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedInt64 = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeSignedVarint64(t11[r11]);
            this.endDelimited_(e11);
        }
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedInt64", jspb.BinaryWriter.prototype.writePackedInt64), jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function(e11, t11, r11, o11) {
        if (null != t11) {
            e11 = this.beginDelimited_(e11);
            for(var i11 = 0; i11 < t11.length; i11++)this.encoder_.writeSplitFixed64(r11(t11[i11]), o11(t11[i11]));
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function(e11, t11, r11, o11) {
        if (null != t11) {
            e11 = this.beginDelimited_(e11);
            for(var i11 = 0; i11 < t11.length; i11++)this.encoder_.writeSplitVarint64(r11(t11[i11]), o11(t11[i11]));
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function(e11, t11, r11, o11) {
        if (null != t11) {
            e11 = this.beginDelimited_(e11);
            for(var i11 = this.encoder_, a11 = 0; a11 < t11.length; a11++)jspb.utils.toZigzag64(r11(t11[a11]), o11(t11[a11]), function(e11, t11) {
                i11.writeSplitVarint64(e11 >>> 0, t11 >>> 0);
            });
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedInt64String = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++){
                var o11 = jspb.arith.Int64.fromString(t11[r11]);
                this.encoder_.writeSplitVarint64(o11.lo, o11.hi);
            }
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedUint32 = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeUnsignedVarint32(t11[r11]);
            this.endDelimited_(e11);
        }
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedUint32", jspb.BinaryWriter.prototype.writePackedUint32), jspb.BinaryWriter.prototype.writePackedUint32String = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeUnsignedVarint32(parseInt(t11[r11], 10));
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedUint64 = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeUnsignedVarint64(t11[r11]);
            this.endDelimited_(e11);
        }
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedUint64", jspb.BinaryWriter.prototype.writePackedUint64), jspb.BinaryWriter.prototype.writePackedUint64String = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++){
                var o11 = jspb.arith.UInt64.fromString(t11[r11]);
                this.encoder_.writeSplitVarint64(o11.lo, o11.hi);
            }
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedSint32 = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeZigzagVarint32(t11[r11]);
            this.endDelimited_(e11);
        }
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSint32", jspb.BinaryWriter.prototype.writePackedSint32), jspb.BinaryWriter.prototype.writePackedSint64 = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeZigzagVarint64(t11[r11]);
            this.endDelimited_(e11);
        }
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSint64", jspb.BinaryWriter.prototype.writePackedSint64), jspb.BinaryWriter.prototype.writePackedSint64String = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(t11[r11]));
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedSintHash64 = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeZigzagVarintHash64(t11[r11]);
            this.endDelimited_(e11);
        }
    }, jspb.BinaryWriter.prototype.writePackedFixed32 = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeUint32(t11[e11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFixed32", jspb.BinaryWriter.prototype.writePackedFixed32), jspb.BinaryWriter.prototype.writePackedFixed64 = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeUint64(t11[e11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFixed64", jspb.BinaryWriter.prototype.writePackedFixed64), jspb.BinaryWriter.prototype.writePackedFixed64String = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t11.length), e11 = 0; e11 < t11.length; e11++){
            var r11 = jspb.arith.UInt64.fromString(t11[e11]);
            this.encoder_.writeSplitFixed64(r11.lo, r11.hi);
        }
    }, jspb.BinaryWriter.prototype.writePackedSfixed32 = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeInt32(t11[e11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSfixed32", jspb.BinaryWriter.prototype.writePackedSfixed32), jspb.BinaryWriter.prototype.writePackedSfixed64 = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeInt64(t11[e11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedSfixed64", jspb.BinaryWriter.prototype.writePackedSfixed64), jspb.BinaryWriter.prototype.writePackedSfixed64String = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeInt64String(t11[e11]);
    }, jspb.BinaryWriter.prototype.writePackedFloat = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeFloat(t11[e11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedFloat", jspb.BinaryWriter.prototype.writePackedFloat), jspb.BinaryWriter.prototype.writePackedDouble = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeDouble(t11[e11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedDouble", jspb.BinaryWriter.prototype.writePackedDouble), jspb.BinaryWriter.prototype.writePackedBool = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeBool(t11[e11]);
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedBool", jspb.BinaryWriter.prototype.writePackedBool), jspb.BinaryWriter.prototype.writePackedEnum = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeEnum(t11[r11]);
            this.endDelimited_(e11);
        }
    }, goog.exportProperty(jspb.BinaryWriter.prototype, "writePackedEnum", jspb.BinaryWriter.prototype.writePackedEnum), jspb.BinaryWriter.prototype.writePackedFixedHash64 = function(e11, t11) {
        if (null != t11 && t11.length) for(this.writeFieldHeader_(e11, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * t11.length), e11 = 0; e11 < t11.length; e11++)this.encoder_.writeFixedHash64(t11[e11]);
    }, jspb.BinaryWriter.prototype.writePackedVarintHash64 = function(e11, t11) {
        if (null != t11 && t11.length) {
            e11 = this.beginDelimited_(e11);
            for(var r11 = 0; r11 < t11.length; r11++)this.encoder_.writeVarintHash64(t11[r11]);
            this.endDelimited_(e11);
        }
    }, jspb.Map = function(e11, t11) {
        this.arr_ = e11, this.valueCtor_ = t11, this.map_ = {}, this.arrClean = !0, 0 < this.arr_.length && this.loadFromArray_();
    }, goog.exportSymbol("jspb.Map", jspb.Map), jspb.Map.prototype.loadFromArray_ = function() {
        for(var e11 = 0; e11 < this.arr_.length; e11++){
            var t11 = this.arr_[e11], r11 = t11[0];
            this.map_[r11.toString()] = new jspb.Map.Entry_(r11, t11[1]);
        }
        this.arrClean = !0;
    }, jspb.Map.prototype.toArray = function() {
        if (this.arrClean) {
            if (this.valueCtor_) {
                var e11, t11 = this.map_;
                for(e11 in t11)if (Object.prototype.hasOwnProperty.call(t11, e11)) {
                    var r11 = t11[e11].valueWrapper;
                    r11 && r11.toArray();
                }
            }
        } else {
            for(this.arr_.length = 0, (t11 = this.stringKeys_()).sort(), e11 = 0; e11 < t11.length; e11++){
                var o11 = this.map_[t11[e11]];
                (r11 = o11.valueWrapper) && r11.toArray(), this.arr_.push([
                    o11.key,
                    o11.value
                ]);
            }
            this.arrClean = !0;
        }
        return this.arr_;
    }, goog.exportProperty(jspb.Map.prototype, "toArray", jspb.Map.prototype.toArray), jspb.Map.prototype.toObject = function(e11, t11) {
        for(var r11 = this.toArray(), o11 = [], i11 = 0; i11 < r11.length; i11++){
            var a11 = this.map_[r11[i11][0].toString()];
            this.wrapEntry_(a11);
            var n11 = a11.valueWrapper;
            n11 ? (jspb.asserts.assert(t11), o11.push([
                a11.key,
                t11(e11, n11)
            ])) : o11.push([
                a11.key,
                a11.value
            ]);
        }
        return o11;
    }, goog.exportProperty(jspb.Map.prototype, "toObject", jspb.Map.prototype.toObject), jspb.Map.fromObject = function(e11, t11, r11) {
        t11 = new jspb.Map([], t11);
        for(var o11 = 0; o11 < e11.length; o11++){
            var i11 = e11[o11][0], a11 = r11(e11[o11][1]);
            t11.set(i11, a11);
        }
        return t11;
    }, goog.exportProperty(jspb.Map, "fromObject", jspb.Map.fromObject), jspb.Map.ArrayIteratorIterable_ = function(e11) {
        this.idx_ = 0, this.arr_ = e11;
    }, jspb.Map.ArrayIteratorIterable_.prototype.next = function() {
        return this.idx_ < this.arr_.length ? {
            done: !1,
            value: this.arr_[this.idx_++]
        } : {
            done: !0,
            value: void 0
        };
    }, "undefined" != typeof Symbol && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function() {
        return this;
    }), jspb.Map.prototype.getLength = function() {
        return this.stringKeys_().length;
    }, goog.exportProperty(jspb.Map.prototype, "getLength", jspb.Map.prototype.getLength), jspb.Map.prototype.clear = function() {
        this.map_ = {}, this.arrClean = !1;
    }, goog.exportProperty(jspb.Map.prototype, "clear", jspb.Map.prototype.clear), jspb.Map.prototype.del = function(e11) {
        e11 = e11.toString();
        var t11 = this.map_.hasOwnProperty(e11);
        return delete this.map_[e11], this.arrClean = !1, t11;
    }, goog.exportProperty(jspb.Map.prototype, "del", jspb.Map.prototype.del), jspb.Map.prototype.getEntryList = function() {
        var e11 = [], t11 = this.stringKeys_();
        t11.sort();
        for(var r11 = 0; r11 < t11.length; r11++){
            var o11 = this.map_[t11[r11]];
            e11.push([
                o11.key,
                o11.value
            ]);
        }
        return e11;
    }, goog.exportProperty(jspb.Map.prototype, "getEntryList", jspb.Map.prototype.getEntryList), jspb.Map.prototype.entries = function() {
        var e11 = [], t11 = this.stringKeys_();
        t11.sort();
        for(var r11 = 0; r11 < t11.length; r11++){
            var o11 = this.map_[t11[r11]];
            e11.push([
                o11.key,
                this.wrapEntry_(o11)
            ]);
        }
        return new jspb.Map.ArrayIteratorIterable_(e11);
    }, goog.exportProperty(jspb.Map.prototype, "entries", jspb.Map.prototype.entries), jspb.Map.prototype.keys = function() {
        var e11 = [], t11 = this.stringKeys_();
        t11.sort();
        for(var r11 = 0; r11 < t11.length; r11++)e11.push(this.map_[t11[r11]].key);
        return new jspb.Map.ArrayIteratorIterable_(e11);
    }, goog.exportProperty(jspb.Map.prototype, "keys", jspb.Map.prototype.keys), jspb.Map.prototype.values = function() {
        var e11 = [], t11 = this.stringKeys_();
        t11.sort();
        for(var r11 = 0; r11 < t11.length; r11++)e11.push(this.wrapEntry_(this.map_[t11[r11]]));
        return new jspb.Map.ArrayIteratorIterable_(e11);
    }, goog.exportProperty(jspb.Map.prototype, "values", jspb.Map.prototype.values), jspb.Map.prototype.forEach = function(e11, t11) {
        var r11 = this.stringKeys_();
        r11.sort();
        for(var o11 = 0; o11 < r11.length; o11++){
            var i11 = this.map_[r11[o11]];
            e11.call(t11, this.wrapEntry_(i11), i11.key, this);
        }
    }, goog.exportProperty(jspb.Map.prototype, "forEach", jspb.Map.prototype.forEach), jspb.Map.prototype.set = function(e11, t11) {
        var r11 = new jspb.Map.Entry_(e11);
        return this.valueCtor_ ? (r11.valueWrapper = t11, r11.value = t11.toArray()) : r11.value = t11, this.map_[e11.toString()] = r11, this.arrClean = !1, this;
    }, goog.exportProperty(jspb.Map.prototype, "set", jspb.Map.prototype.set), jspb.Map.prototype.wrapEntry_ = function(e11) {
        return this.valueCtor_ ? (e11.valueWrapper || (e11.valueWrapper = new this.valueCtor_(e11.value)), e11.valueWrapper) : e11.value;
    }, jspb.Map.prototype.get = function(e11) {
        if (e11 = this.map_[e11.toString()]) return this.wrapEntry_(e11);
    }, goog.exportProperty(jspb.Map.prototype, "get", jspb.Map.prototype.get), jspb.Map.prototype.has = function(e11) {
        return e11.toString() in this.map_;
    }, goog.exportProperty(jspb.Map.prototype, "has", jspb.Map.prototype.has), jspb.Map.prototype.serializeBinary = function(e11, t11, r11, o11, i11) {
        var a11 = this.stringKeys_();
        a11.sort();
        for(var n11 = 0; n11 < a11.length; n11++){
            var s11 = this.map_[a11[n11]];
            t11.beginSubMessage(e11), r11.call(t11, 1, s11.key), this.valueCtor_ ? o11.call(t11, 2, this.wrapEntry_(s11), i11) : o11.call(t11, 2, s11.value), t11.endSubMessage();
        }
    }, goog.exportProperty(jspb.Map.prototype, "serializeBinary", jspb.Map.prototype.serializeBinary), jspb.Map.deserializeBinary = function(e11, t11, r11, o11, i11, a11, n11) {
        for(; t11.nextField() && !t11.isEndGroup();){
            var s11 = t11.getFieldNumber();
            1 == s11 ? a11 = r11.call(t11) : 2 == s11 && (e11.valueCtor_ ? (jspb.asserts.assert(i11), n11 || (n11 = new e11.valueCtor_), o11.call(t11, n11, i11)) : n11 = o11.call(t11));
        }
        jspb.asserts.assert(null != a11), jspb.asserts.assert(null != n11), e11.set(a11, n11);
    }, goog.exportProperty(jspb.Map, "deserializeBinary", jspb.Map.deserializeBinary), jspb.Map.prototype.stringKeys_ = function() {
        var e11, t11 = this.map_, r11 = [];
        for(e11 in t11)Object.prototype.hasOwnProperty.call(t11, e11) && r11.push(e11);
        return r11;
    }, jspb.Map.Entry_ = function(e11, t11) {
        this.key = e11, this.value = t11, this.valueWrapper = void 0;
    }, jspb.ExtensionFieldInfo = function(e11, t11, r11, o11, i11) {
        this.fieldIndex = e11, this.fieldName = t11, this.ctor = r11, this.toObjectFn = o11, this.isRepeated = i11;
    }, goog.exportSymbol("jspb.ExtensionFieldInfo", jspb.ExtensionFieldInfo), jspb.ExtensionFieldBinaryInfo = function(e11, t11, r11, o11, i11, a11) {
        this.fieldInfo = e11, this.binaryReaderFn = t11, this.binaryWriterFn = r11, this.binaryMessageSerializeFn = o11, this.binaryMessageDeserializeFn = i11, this.isPacked = a11;
    }, goog.exportSymbol("jspb.ExtensionFieldBinaryInfo", jspb.ExtensionFieldBinaryInfo), jspb.ExtensionFieldInfo.prototype.isMessageType = function() {
        return !!this.ctor;
    }, goog.exportProperty(jspb.ExtensionFieldInfo.prototype, "isMessageType", jspb.ExtensionFieldInfo.prototype.isMessageType), jspb.Message = function() {}, goog.exportSymbol("jspb.Message", jspb.Message), jspb.Message.GENERATE_TO_OBJECT = !0, goog.exportProperty(jspb.Message, "GENERATE_TO_OBJECT", jspb.Message.GENERATE_TO_OBJECT), jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE, goog.exportProperty(jspb.Message, "GENERATE_FROM_OBJECT", jspb.Message.GENERATE_FROM_OBJECT), jspb.Message.GENERATE_TO_STRING = !0, jspb.Message.ASSUME_LOCAL_ARRAYS = !1, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = !0, jspb.Message.SUPPORTS_UINT8ARRAY_ = "function" == typeof Uint8Array, jspb.Message.prototype.getJsPbMessageId = function() {
        return this.messageId_;
    }, goog.exportProperty(jspb.Message.prototype, "getJsPbMessageId", jspb.Message.prototype.getJsPbMessageId), jspb.Message.getIndex_ = function(e11, t11) {
        return t11 + e11.arrayIndexOffset_;
    }, jspb.Message.hiddenES6Property_ = function() {}, jspb.Message.getFieldNumber_ = function(e11, t11) {
        return t11 - e11.arrayIndexOffset_;
    }, jspb.Message.initialize = function(e11, t11, r11, o11, i11, a11) {
        if (e11.wrappers_ = null, t11 || (t11 = r11 ? [
            r11
        ] : []), e11.messageId_ = r11 ? String(r11) : void 0, e11.arrayIndexOffset_ = 0 === r11 ? -1 : 0, e11.array = t11, jspb.Message.initPivotAndExtensionObject_(e11, o11), e11.convertedPrimitiveFields_ = {}, jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (e11.repeatedFields = i11), i11) for(t11 = 0; t11 < i11.length; t11++)(r11 = i11[t11]) < e11.pivot_ ? (r11 = jspb.Message.getIndex_(e11, r11), e11.array[r11] = e11.array[r11] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(e11), e11.extensionObject_[r11] = e11.extensionObject_[r11] || jspb.Message.EMPTY_LIST_SENTINEL_);
        if (a11 && a11.length) for(t11 = 0; t11 < a11.length; t11++)jspb.Message.computeOneofCase(e11, a11[t11]);
    }, goog.exportProperty(jspb.Message, "initialize", jspb.Message.initialize), jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [], jspb.Message.isArray_ = function(e11) {
        return jspb.Message.ASSUME_LOCAL_ARRAYS ? e11 instanceof Array : Array.isArray(e11);
    }, jspb.Message.isExtensionObject_ = function(e11) {
        return !(null === e11 || "object" != typeof e11 || jspb.Message.isArray_(e11) || jspb.Message.SUPPORTS_UINT8ARRAY_ && e11 instanceof Uint8Array);
    }, jspb.Message.initPivotAndExtensionObject_ = function(e11, t11) {
        var r11 = e11.array.length, o11 = -1;
        if (r11 && (o11 = r11 - 1, r11 = e11.array[o11], jspb.Message.isExtensionObject_(r11))) return e11.pivot_ = jspb.Message.getFieldNumber_(e11, o11), void (e11.extensionObject_ = r11);
        -1 < t11 ? (e11.pivot_ = Math.max(t11, jspb.Message.getFieldNumber_(e11, o11 + 1)), e11.extensionObject_ = null) : e11.pivot_ = Number.MAX_VALUE;
    }, jspb.Message.maybeInitEmptyExtensionObject_ = function(e11) {
        var t11 = jspb.Message.getIndex_(e11, e11.pivot_);
        e11.array[t11] || (e11.extensionObject_ = e11.array[t11] = {});
    }, jspb.Message.toObjectList = function(e11, t11, r11) {
        for(var o11 = [], i11 = 0; i11 < e11.length; i11++)o11[i11] = t11.call(e11[i11], r11, e11[i11]);
        return o11;
    }, goog.exportProperty(jspb.Message, "toObjectList", jspb.Message.toObjectList), jspb.Message.toObjectExtension = function(e11, t11, r11, o11, i11) {
        for(var a11 in r11){
            var n11 = r11[a11], s11 = o11.call(e11, n11);
            if (null != s11) {
                for(var p11 in n11.fieldName)if (n11.fieldName.hasOwnProperty(p11)) break;
                t11[p11] = n11.toObjectFn ? n11.isRepeated ? jspb.Message.toObjectList(s11, n11.toObjectFn, i11) : n11.toObjectFn(i11, s11) : s11;
            }
        }
    }, goog.exportProperty(jspb.Message, "toObjectExtension", jspb.Message.toObjectExtension), jspb.Message.serializeBinaryExtensions = function(e11, t11, r11, o11) {
        for(var i11 in r11){
            var a11 = r11[i11], n11 = a11.fieldInfo;
            if (!a11.binaryWriterFn) throw Error("Message extension present that was generated without binary serialization support");
            var s11 = o11.call(e11, n11);
            if (null != s11) {
                if (n11.isMessageType()) {
                    if (!a11.binaryMessageSerializeFn) throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
                    a11.binaryWriterFn.call(t11, n11.fieldIndex, s11, a11.binaryMessageSerializeFn);
                } else a11.binaryWriterFn.call(t11, n11.fieldIndex, s11);
            }
        }
    }, goog.exportProperty(jspb.Message, "serializeBinaryExtensions", jspb.Message.serializeBinaryExtensions), jspb.Message.readBinaryExtension = function(e11, t11, r11, o11, i11) {
        var a11 = r11[t11.getFieldNumber()];
        if (a11) {
            if (r11 = a11.fieldInfo, !a11.binaryReaderFn) throw Error("Deserializing extension whose generated code does not support binary format");
            if (r11.isMessageType()) {
                var n11 = new r11.ctor;
                a11.binaryReaderFn.call(t11, n11, a11.binaryMessageDeserializeFn);
            } else n11 = a11.binaryReaderFn.call(t11);
            r11.isRepeated && !a11.isPacked ? (t11 = o11.call(e11, r11)) ? t11.push(n11) : i11.call(e11, r11, [
                n11
            ]) : i11.call(e11, r11, n11);
        } else t11.skipField();
    }, goog.exportProperty(jspb.Message, "readBinaryExtension", jspb.Message.readBinaryExtension), jspb.Message.getField = function(e11, t11) {
        if (t11 < e11.pivot_) {
            t11 = jspb.Message.getIndex_(e11, t11);
            var r11 = e11.array[t11];
            return r11 === jspb.Message.EMPTY_LIST_SENTINEL_ ? e11.array[t11] = [] : r11;
        }
        if (e11.extensionObject_) return (r11 = e11.extensionObject_[t11]) === jspb.Message.EMPTY_LIST_SENTINEL_ ? e11.extensionObject_[t11] = [] : r11;
    }, goog.exportProperty(jspb.Message, "getField", jspb.Message.getField), jspb.Message.getRepeatedField = function(e11, t11) {
        return jspb.Message.getField(e11, t11);
    }, goog.exportProperty(jspb.Message, "getRepeatedField", jspb.Message.getRepeatedField), jspb.Message.getOptionalFloatingPointField = function(e11, t11) {
        return null == (e11 = jspb.Message.getField(e11, t11)) ? e11 : +e11;
    }, goog.exportProperty(jspb.Message, "getOptionalFloatingPointField", jspb.Message.getOptionalFloatingPointField), jspb.Message.getBooleanField = function(e11, t11) {
        return null == (e11 = jspb.Message.getField(e11, t11)) ? e11 : !!e11;
    }, goog.exportProperty(jspb.Message, "getBooleanField", jspb.Message.getBooleanField), jspb.Message.getRepeatedFloatingPointField = function(e11, t11) {
        var r11 = jspb.Message.getRepeatedField(e11, t11);
        if (e11.convertedPrimitiveFields_ || (e11.convertedPrimitiveFields_ = {}), !e11.convertedPrimitiveFields_[t11]) {
            for(var o11 = 0; o11 < r11.length; o11++)r11[o11] = +r11[o11];
            e11.convertedPrimitiveFields_[t11] = !0;
        }
        return r11;
    }, goog.exportProperty(jspb.Message, "getRepeatedFloatingPointField", jspb.Message.getRepeatedFloatingPointField), jspb.Message.getRepeatedBooleanField = function(e11, t11) {
        var r11 = jspb.Message.getRepeatedField(e11, t11);
        if (e11.convertedPrimitiveFields_ || (e11.convertedPrimitiveFields_ = {}), !e11.convertedPrimitiveFields_[t11]) {
            for(var o11 = 0; o11 < r11.length; o11++)r11[o11] = !!r11[o11];
            e11.convertedPrimitiveFields_[t11] = !0;
        }
        return r11;
    }, goog.exportProperty(jspb.Message, "getRepeatedBooleanField", jspb.Message.getRepeatedBooleanField), jspb.Message.bytesAsB64 = function(e11) {
        return null == e11 || "string" == typeof e11 ? e11 : jspb.Message.SUPPORTS_UINT8ARRAY_ && e11 instanceof Uint8Array ? goog.crypt.base64.encodeByteArray(e11) : (jspb.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(e11)), null);
    }, goog.exportProperty(jspb.Message, "bytesAsB64", jspb.Message.bytesAsB64), jspb.Message.bytesAsU8 = function(e11) {
        return null == e11 || e11 instanceof Uint8Array ? e11 : "string" == typeof e11 ? goog.crypt.base64.decodeStringToUint8Array(e11) : (jspb.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(e11)), null);
    }, goog.exportProperty(jspb.Message, "bytesAsU8", jspb.Message.bytesAsU8), jspb.Message.bytesListAsB64 = function(e11) {
        return jspb.Message.assertConsistentTypes_(e11), e11.length && "string" != typeof e11[0] ? goog.array.map(e11, jspb.Message.bytesAsB64) : e11;
    }, goog.exportProperty(jspb.Message, "bytesListAsB64", jspb.Message.bytesListAsB64), jspb.Message.bytesListAsU8 = function(e11) {
        return jspb.Message.assertConsistentTypes_(e11), !e11.length || e11[0] instanceof Uint8Array ? e11 : goog.array.map(e11, jspb.Message.bytesAsU8);
    }, goog.exportProperty(jspb.Message, "bytesListAsU8", jspb.Message.bytesListAsU8), jspb.Message.assertConsistentTypes_ = function(e11) {
        if (goog.DEBUG && e11 && 1 < e11.length) {
            var t11 = goog.typeOf(e11[0]);
            goog.array.forEach(e11, function(e11) {
                goog.typeOf(e11) != t11 && jspb.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(e11) + " expected " + t11);
            });
        }
    }, jspb.Message.getFieldWithDefault = function(e11, t11, r11) {
        return null == (e11 = jspb.Message.getField(e11, t11)) ? r11 : e11;
    }, goog.exportProperty(jspb.Message, "getFieldWithDefault", jspb.Message.getFieldWithDefault), jspb.Message.getBooleanFieldWithDefault = function(e11, t11, r11) {
        return null == (e11 = jspb.Message.getBooleanField(e11, t11)) ? r11 : e11;
    }, goog.exportProperty(jspb.Message, "getBooleanFieldWithDefault", jspb.Message.getBooleanFieldWithDefault), jspb.Message.getFloatingPointFieldWithDefault = function(e11, t11, r11) {
        return null == (e11 = jspb.Message.getOptionalFloatingPointField(e11, t11)) ? r11 : e11;
    }, goog.exportProperty(jspb.Message, "getFloatingPointFieldWithDefault", jspb.Message.getFloatingPointFieldWithDefault), jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault, goog.exportProperty(jspb.Message, "getFieldProto3", jspb.Message.getFieldProto3), jspb.Message.getMapField = function(e11, t11, r11, o11) {
        if (e11.wrappers_ || (e11.wrappers_ = {}), t11 in e11.wrappers_) return e11.wrappers_[t11];
        var i11 = jspb.Message.getField(e11, t11);
        if (!i11) {
            if (r11) return;
            i11 = [], jspb.Message.setField(e11, t11, i11);
        }
        return e11.wrappers_[t11] = new jspb.Map(i11, o11);
    }, goog.exportProperty(jspb.Message, "getMapField", jspb.Message.getMapField), jspb.Message.setField = function(e11, t11, r11) {
        return jspb.asserts.assertInstanceof(e11, jspb.Message), t11 < e11.pivot_ ? e11.array[jspb.Message.getIndex_(e11, t11)] = r11 : (jspb.Message.maybeInitEmptyExtensionObject_(e11), e11.extensionObject_[t11] = r11), e11;
    }, goog.exportProperty(jspb.Message, "setField", jspb.Message.setField), jspb.Message.setProto3IntField = function(e11, t11, r11) {
        return jspb.Message.setFieldIgnoringDefault_(e11, t11, r11, 0);
    }, goog.exportProperty(jspb.Message, "setProto3IntField", jspb.Message.setProto3IntField), jspb.Message.setProto3FloatField = function(e11, t11, r11) {
        return jspb.Message.setFieldIgnoringDefault_(e11, t11, r11, 0);
    }, goog.exportProperty(jspb.Message, "setProto3FloatField", jspb.Message.setProto3FloatField), jspb.Message.setProto3BooleanField = function(e11, t11, r11) {
        return jspb.Message.setFieldIgnoringDefault_(e11, t11, r11, !1);
    }, goog.exportProperty(jspb.Message, "setProto3BooleanField", jspb.Message.setProto3BooleanField), jspb.Message.setProto3StringField = function(e11, t11, r11) {
        return jspb.Message.setFieldIgnoringDefault_(e11, t11, r11, "");
    }, goog.exportProperty(jspb.Message, "setProto3StringField", jspb.Message.setProto3StringField), jspb.Message.setProto3BytesField = function(e11, t11, r11) {
        return jspb.Message.setFieldIgnoringDefault_(e11, t11, r11, "");
    }, goog.exportProperty(jspb.Message, "setProto3BytesField", jspb.Message.setProto3BytesField), jspb.Message.setProto3EnumField = function(e11, t11, r11) {
        return jspb.Message.setFieldIgnoringDefault_(e11, t11, r11, 0);
    }, goog.exportProperty(jspb.Message, "setProto3EnumField", jspb.Message.setProto3EnumField), jspb.Message.setProto3StringIntField = function(e11, t11, r11) {
        return jspb.Message.setFieldIgnoringDefault_(e11, t11, r11, "0");
    }, goog.exportProperty(jspb.Message, "setProto3StringIntField", jspb.Message.setProto3StringIntField), jspb.Message.setFieldIgnoringDefault_ = function(e11, t11, r11, o11) {
        return jspb.asserts.assertInstanceof(e11, jspb.Message), r11 !== o11 ? jspb.Message.setField(e11, t11, r11) : t11 < e11.pivot_ ? e11.array[jspb.Message.getIndex_(e11, t11)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(e11), delete e11.extensionObject_[t11]), e11;
    }, jspb.Message.addToRepeatedField = function(e11, t11, r11, o11) {
        return jspb.asserts.assertInstanceof(e11, jspb.Message), t11 = jspb.Message.getRepeatedField(e11, t11), null != o11 ? t11.splice(o11, 0, r11) : t11.push(r11), e11;
    }, goog.exportProperty(jspb.Message, "addToRepeatedField", jspb.Message.addToRepeatedField), jspb.Message.setOneofField = function(e11, t11, r11, o11) {
        return jspb.asserts.assertInstanceof(e11, jspb.Message), (r11 = jspb.Message.computeOneofCase(e11, r11)) && r11 !== t11 && void 0 !== o11 && (e11.wrappers_ && r11 in e11.wrappers_ && (e11.wrappers_[r11] = void 0), jspb.Message.setField(e11, r11, void 0)), jspb.Message.setField(e11, t11, o11);
    }, goog.exportProperty(jspb.Message, "setOneofField", jspb.Message.setOneofField), jspb.Message.computeOneofCase = function(e11, t11) {
        for(var r11, o11, i11 = 0; i11 < t11.length; i11++){
            var a11 = t11[i11], n11 = jspb.Message.getField(e11, a11);
            null != n11 && (r11 = a11, o11 = n11, jspb.Message.setField(e11, a11, void 0));
        }
        return r11 ? (jspb.Message.setField(e11, r11, o11), r11) : 0;
    }, goog.exportProperty(jspb.Message, "computeOneofCase", jspb.Message.computeOneofCase), jspb.Message.getWrapperField = function(e11, t11, r11, o11) {
        if (e11.wrappers_ || (e11.wrappers_ = {}), !e11.wrappers_[r11]) {
            var i11 = jspb.Message.getField(e11, r11);
            (o11 || i11) && (e11.wrappers_[r11] = new t11(i11));
        }
        return e11.wrappers_[r11];
    }, goog.exportProperty(jspb.Message, "getWrapperField", jspb.Message.getWrapperField), jspb.Message.getRepeatedWrapperField = function(e11, t11, r11) {
        return jspb.Message.wrapRepeatedField_(e11, t11, r11), (t11 = e11.wrappers_[r11]) == jspb.Message.EMPTY_LIST_SENTINEL_ && (t11 = e11.wrappers_[r11] = []), t11;
    }, goog.exportProperty(jspb.Message, "getRepeatedWrapperField", jspb.Message.getRepeatedWrapperField), jspb.Message.wrapRepeatedField_ = function(e11, t11, r11) {
        if (e11.wrappers_ || (e11.wrappers_ = {}), !e11.wrappers_[r11]) {
            for(var o11 = jspb.Message.getRepeatedField(e11, r11), i11 = [], a11 = 0; a11 < o11.length; a11++)i11[a11] = new t11(o11[a11]);
            e11.wrappers_[r11] = i11;
        }
    }, jspb.Message.setWrapperField = function(e11, t11, r11) {
        jspb.asserts.assertInstanceof(e11, jspb.Message), e11.wrappers_ || (e11.wrappers_ = {});
        var o11 = r11 ? r11.toArray() : r11;
        return e11.wrappers_[t11] = r11, jspb.Message.setField(e11, t11, o11);
    }, goog.exportProperty(jspb.Message, "setWrapperField", jspb.Message.setWrapperField), jspb.Message.setOneofWrapperField = function(e11, t11, r11, o11) {
        jspb.asserts.assertInstanceof(e11, jspb.Message), e11.wrappers_ || (e11.wrappers_ = {});
        var i11 = o11 ? o11.toArray() : o11;
        return e11.wrappers_[t11] = o11, jspb.Message.setOneofField(e11, t11, r11, i11);
    }, goog.exportProperty(jspb.Message, "setOneofWrapperField", jspb.Message.setOneofWrapperField), jspb.Message.setRepeatedWrapperField = function(e11, t11, r11) {
        jspb.asserts.assertInstanceof(e11, jspb.Message), e11.wrappers_ || (e11.wrappers_ = {}), r11 = r11 || [];
        for(var o11 = [], i11 = 0; i11 < r11.length; i11++)o11[i11] = r11[i11].toArray();
        return e11.wrappers_[t11] = r11, jspb.Message.setField(e11, t11, o11);
    }, goog.exportProperty(jspb.Message, "setRepeatedWrapperField", jspb.Message.setRepeatedWrapperField), jspb.Message.addToRepeatedWrapperField = function(e11, t11, r11, o11, i11) {
        jspb.Message.wrapRepeatedField_(e11, o11, t11);
        var a11 = e11.wrappers_[t11];
        return a11 || (a11 = e11.wrappers_[t11] = []), r11 = r11 || new o11, e11 = jspb.Message.getRepeatedField(e11, t11), null != i11 ? (a11.splice(i11, 0, r11), e11.splice(i11, 0, r11.toArray())) : (a11.push(r11), e11.push(r11.toArray())), r11;
    }, goog.exportProperty(jspb.Message, "addToRepeatedWrapperField", jspb.Message.addToRepeatedWrapperField), jspb.Message.toMap = function(e11, t11, r11, o11) {
        for(var i11 = {}, a11 = 0; a11 < e11.length; a11++)i11[t11.call(e11[a11])] = r11 ? r11.call(e11[a11], o11, e11[a11]) : e11[a11];
        return i11;
    }, goog.exportProperty(jspb.Message, "toMap", jspb.Message.toMap), jspb.Message.prototype.syncMapFields_ = function() {
        if (this.wrappers_) for(var e11 in this.wrappers_){
            var t11 = this.wrappers_[e11];
            if (Array.isArray(t11)) for(var r11 = 0; r11 < t11.length; r11++)t11[r11] && t11[r11].toArray();
            else t11 && t11.toArray();
        }
    }, jspb.Message.prototype.toArray = function() {
        return this.syncMapFields_(), this.array;
    }, goog.exportProperty(jspb.Message.prototype, "toArray", jspb.Message.prototype.toArray), jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function() {
        return this.syncMapFields_(), this.array.toString();
    }), jspb.Message.prototype.getExtension = function(e11) {
        if (this.extensionObject_) {
            this.wrappers_ || (this.wrappers_ = {});
            var t11 = e11.fieldIndex;
            if (e11.isRepeated) {
                if (e11.isMessageType()) return this.wrappers_[t11] || (this.wrappers_[t11] = goog.array.map(this.extensionObject_[t11] || [], function(t11) {
                    return new e11.ctor(t11);
                })), this.wrappers_[t11];
            } else if (e11.isMessageType()) return !this.wrappers_[t11] && this.extensionObject_[t11] && (this.wrappers_[t11] = new e11.ctor(this.extensionObject_[t11])), this.wrappers_[t11];
            return this.extensionObject_[t11];
        }
    }, goog.exportProperty(jspb.Message.prototype, "getExtension", jspb.Message.prototype.getExtension), jspb.Message.prototype.setExtension = function(e11, t11) {
        this.wrappers_ || (this.wrappers_ = {}), jspb.Message.maybeInitEmptyExtensionObject_(this);
        var r11 = e11.fieldIndex;
        return e11.isRepeated ? (t11 = t11 || [], e11.isMessageType() ? (this.wrappers_[r11] = t11, this.extensionObject_[r11] = goog.array.map(t11, function(e11) {
            return e11.toArray();
        })) : this.extensionObject_[r11] = t11) : e11.isMessageType() ? (this.wrappers_[r11] = t11, this.extensionObject_[r11] = t11 ? t11.toArray() : t11) : this.extensionObject_[r11] = t11, this;
    }, goog.exportProperty(jspb.Message.prototype, "setExtension", jspb.Message.prototype.setExtension), jspb.Message.difference = function(e11, t11) {
        if (!(e11 instanceof t11.constructor)) throw Error("Messages have different types.");
        var r11 = e11.toArray();
        t11 = t11.toArray();
        var o11 = [], i11 = 0, a11 = r11.length > t11.length ? r11.length : t11.length;
        for(e11.getJsPbMessageId() && (o11[0] = e11.getJsPbMessageId(), i11 = 1); i11 < a11; i11++)jspb.Message.compareFields(r11[i11], t11[i11]) || (o11[i11] = t11[i11]);
        return new e11.constructor(o11);
    }, goog.exportProperty(jspb.Message, "difference", jspb.Message.difference), jspb.Message.equals = function(e11, t11) {
        return e11 == t11 || !(!e11 || !t11) && e11 instanceof t11.constructor && jspb.Message.compareFields(e11.toArray(), t11.toArray());
    }, goog.exportProperty(jspb.Message, "equals", jspb.Message.equals), jspb.Message.compareExtensions = function(e11, t11) {
        e11 = e11 || {}, t11 = t11 || {};
        var r11, o11 = {};
        for(r11 in e11)o11[r11] = 0;
        for(r11 in t11)o11[r11] = 0;
        for(r11 in o11)if (!jspb.Message.compareFields(e11[r11], t11[r11])) return !1;
        return !0;
    }, goog.exportProperty(jspb.Message, "compareExtensions", jspb.Message.compareExtensions), jspb.Message.compareFields = function(e11, t11) {
        if (e11 == t11) return !0;
        if (!goog.isObject(e11) || !goog.isObject(t11)) return !!("number" == typeof e11 && isNaN(e11) || "number" == typeof t11 && isNaN(t11)) && String(e11) == String(t11);
        if (e11.constructor != t11.constructor) return !1;
        if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e11.constructor === Uint8Array) {
            if (e11.length != t11.length) return !1;
            for(var r11 = 0; r11 < e11.length; r11++)if (e11[r11] != t11[r11]) return !1;
            return !0;
        }
        if (e11.constructor === Array) {
            var o11 = void 0, i11 = void 0, a11 = Math.max(e11.length, t11.length);
            for(r11 = 0; r11 < a11; r11++){
                var n11 = e11[r11], s11 = t11[r11];
                if (n11 && n11.constructor == Object && (jspb.asserts.assert(void 0 === o11), jspb.asserts.assert(r11 === e11.length - 1), o11 = n11, n11 = void 0), s11 && s11.constructor == Object && (jspb.asserts.assert(void 0 === i11), jspb.asserts.assert(r11 === t11.length - 1), i11 = s11, s11 = void 0), !jspb.Message.compareFields(n11, s11)) return !1;
            }
            return !o11 && !i11 || (o11 = o11 || {}, i11 = i11 || {}, jspb.Message.compareExtensions(o11, i11));
        }
        if (e11.constructor === Object) return jspb.Message.compareExtensions(e11, t11);
        throw Error("Invalid type in JSPB array");
    }, goog.exportProperty(jspb.Message, "compareFields", jspb.Message.compareFields), jspb.Message.prototype.cloneMessage = function() {
        return jspb.Message.cloneMessage(this);
    }, goog.exportProperty(jspb.Message.prototype, "cloneMessage", jspb.Message.prototype.cloneMessage), jspb.Message.prototype.clone = function() {
        return jspb.Message.cloneMessage(this);
    }, goog.exportProperty(jspb.Message.prototype, "clone", jspb.Message.prototype.clone), jspb.Message.clone = function(e11) {
        return jspb.Message.cloneMessage(e11);
    }, goog.exportProperty(jspb.Message, "clone", jspb.Message.clone), jspb.Message.cloneMessage = function(e11) {
        return new e11.constructor(jspb.Message.clone_(e11.toArray()));
    }, jspb.Message.copyInto = function(e11, t11) {
        jspb.asserts.assertInstanceof(e11, jspb.Message), jspb.asserts.assertInstanceof(t11, jspb.Message), jspb.asserts.assert(e11.constructor == t11.constructor, "Copy source and target message should have the same type."), e11 = jspb.Message.clone(e11);
        for(var r11 = t11.toArray(), o11 = e11.toArray(), i11 = r11.length = 0; i11 < o11.length; i11++)r11[i11] = o11[i11];
        t11.wrappers_ = e11.wrappers_, t11.extensionObject_ = e11.extensionObject_;
    }, goog.exportProperty(jspb.Message, "copyInto", jspb.Message.copyInto), jspb.Message.clone_ = function(e11) {
        if (Array.isArray(e11)) {
            for(var t11 = Array(e11.length), r11 = 0; r11 < e11.length; r11++){
                var o11 = e11[r11];
                null != o11 && (t11[r11] = "object" == typeof o11 ? jspb.Message.clone_(jspb.asserts.assert(o11)) : o11);
            }
            return t11;
        }
        if (jspb.Message.SUPPORTS_UINT8ARRAY_ && e11 instanceof Uint8Array) return new Uint8Array(e11);
        for(r11 in t11 = {}, e11)null != (o11 = e11[r11]) && (t11[r11] = "object" == typeof o11 ? jspb.Message.clone_(jspb.asserts.assert(o11)) : o11);
        return t11;
    }, jspb.Message.registerMessageType = function(e11, t11) {
        t11.messageId = e11;
    }, goog.exportProperty(jspb.Message, "registerMessageType", jspb.Message.registerMessageType), jspb.Message.messageSetExtensions = {}, jspb.Message.messageSetExtensionsBinary = {}, jspb.Export = {}, exports.Map = jspb.Map, exports.Message = jspb.Message, exports.BinaryReader = jspb.BinaryReader, exports.BinaryWriter = jspb.BinaryWriter, exports.ExtensionFieldInfo = jspb.ExtensionFieldInfo, exports.ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo, exports.exportSymbol = goog.exportSymbol, exports.inherits = goog.inherits, exports.object = {
        extend: goog.object.extend
    }, exports.typeOf = goog.typeOf;
})(googleProtobuf);
var calculator_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.CalculatorOptions", null, o11), proto.mediapipe.CalculatorOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, 2, null, null);
    }, r11.inherits(proto.mediapipe.CalculatorOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.CalculatorOptions.displayName = "proto.mediapipe.CalculatorOptions"), proto.mediapipe.CalculatorOptions.extensions = {}, proto.mediapipe.CalculatorOptions.extensionsBinary = {}, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.CalculatorOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.CalculatorOptions.toObject(e11, this);
    }, proto.mediapipe.CalculatorOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            mergeFields: null == (o11 = t11.Message.getBooleanField(r11, 1)) ? void 0 : o11
        };
        return t11.Message.toObjectExtension(r11, i11, proto.mediapipe.CalculatorOptions.extensions, proto.mediapipe.CalculatorOptions.prototype.getExtension, e11), e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.CalculatorOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.CalculatorOptions;
        return proto.mediapipe.CalculatorOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.CalculatorOptions.deserializeBinaryFromReader = function(e11, r11) {
        for(; r11.nextField() && !r11.isEndGroup();)if (1 === r11.getFieldNumber()) {
            var o11 = r11.readBool();
            e11.setMergeFields(o11);
        } else t11.Message.readBinaryExtension(e11, r11, proto.mediapipe.CalculatorOptions.extensionsBinary, proto.mediapipe.CalculatorOptions.prototype.getExtension, proto.mediapipe.CalculatorOptions.prototype.setExtension);
        return e11;
    }, proto.mediapipe.CalculatorOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.CalculatorOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.CalculatorOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeBool(1, o11), t11.Message.serializeBinaryExtensions(e11, r11, proto.mediapipe.CalculatorOptions.extensionsBinary, proto.mediapipe.CalculatorOptions.prototype.getExtension);
    }, proto.mediapipe.CalculatorOptions.prototype.getMergeFields = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 1, !1);
    }, proto.mediapipe.CalculatorOptions.prototype.setMergeFields = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.CalculatorOptions.prototype.clearMergeFields = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.CalculatorOptions.prototype.hasMergeFields = function() {
        return null != t11.Message.getField(this, 1);
    }, r11.object.extend(e11, proto.mediapipe);
}(calculator_options_pb);
var any_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.google.protobuf.Any", null, o11), proto.google.protobuf.Any = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.google.protobuf.Any, t11.Message), r11.DEBUG && !COMPILED && (proto.google.protobuf.Any.displayName = "proto.google.protobuf.Any"), t11.Message.GENERATE_TO_OBJECT && (proto.google.protobuf.Any.prototype.toObject = function(e11) {
        return proto.google.protobuf.Any.toObject(e11, this);
    }, proto.google.protobuf.Any.toObject = function(e11, r11) {
        var o11 = {
            typeUrl: t11.Message.getFieldWithDefault(r11, 1, ""),
            value: r11.getValue_asB64()
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.google.protobuf.Any.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.google.protobuf.Any;
        return proto.google.protobuf.Any.deserializeBinaryFromReader(o11, r11);
    }, proto.google.protobuf.Any.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setTypeUrl(r11);
                break;
            case 2:
                r11 = t11.readBytes();
                e11.setValue(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.google.protobuf.Any.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.google.protobuf.Any.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.google.protobuf.Any.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        (r11 = e11.getTypeUrl()).length > 0 && t11.writeString(1, r11), (r11 = e11.getValue_asU8()).length > 0 && t11.writeBytes(2, r11);
    }, proto.google.protobuf.Any.prototype.getTypeUrl = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.google.protobuf.Any.prototype.setTypeUrl = function(e11) {
        return t11.Message.setProto3StringField(this, 1, e11);
    }, proto.google.protobuf.Any.prototype.getValue = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.google.protobuf.Any.prototype.getValue_asB64 = function() {
        return t11.Message.bytesAsB64(this.getValue());
    }, proto.google.protobuf.Any.prototype.getValue_asU8 = function() {
        return t11.Message.bytesAsU8(this.getValue());
    }, proto.google.protobuf.Any.prototype.setValue = function(e11) {
        return t11.Message.setProto3BytesField(this, 2, e11);
    }, r11.object.extend(e11, proto.google.protobuf), proto.google.protobuf.Any.prototype.getTypeName = function() {
        return this.getTypeUrl().split("/").pop();
    }, proto.google.protobuf.Any.prototype.pack = function(e11, t11, r11) {
        r11 || (r11 = "type.googleapis.com/"), "/" != r11.substr(-1) ? this.setTypeUrl(r11 + "/" + t11) : this.setTypeUrl(r11 + t11), this.setValue(e11);
    }, proto.google.protobuf.Any.prototype.unpack = function(e11, t11) {
        return this.getTypeName() == t11 ? e11(this.getValue_asU8()) : null;
    };
}(any_pb);
var mediapipe_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.MediaPipeOptions", null, o11), proto.mediapipe.MediaPipeOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, 1, null, null);
    }, r11.inherits(proto.mediapipe.MediaPipeOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.MediaPipeOptions.displayName = "proto.mediapipe.MediaPipeOptions"), proto.mediapipe.MediaPipeOptions.extensions = {}, proto.mediapipe.MediaPipeOptions.extensionsBinary = {}, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.MediaPipeOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.MediaPipeOptions.toObject(e11, this);
    }, proto.mediapipe.MediaPipeOptions.toObject = function(e11, r11) {
        var o11 = {};
        return t11.Message.toObjectExtension(r11, o11, proto.mediapipe.MediaPipeOptions.extensions, proto.mediapipe.MediaPipeOptions.prototype.getExtension, e11), e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.MediaPipeOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.MediaPipeOptions;
        return proto.mediapipe.MediaPipeOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.MediaPipeOptions.deserializeBinaryFromReader = function(e11, r11) {
        for(; r11.nextField() && !r11.isEndGroup();){
            r11.getFieldNumber();
            t11.Message.readBinaryExtension(e11, r11, proto.mediapipe.MediaPipeOptions.extensionsBinary, proto.mediapipe.MediaPipeOptions.prototype.getExtension, proto.mediapipe.MediaPipeOptions.prototype.setExtension);
        }
        return e11;
    }, proto.mediapipe.MediaPipeOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.MediaPipeOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.MediaPipeOptions.serializeBinaryToWriter = function(e11, r11) {
        t11.Message.serializeBinaryExtensions(e11, r11, proto.mediapipe.MediaPipeOptions.extensionsBinary, proto.mediapipe.MediaPipeOptions.prototype.getExtension);
    }, r11.object.extend(e11, proto.mediapipe);
}(mediapipe_options_pb);
var packet_factory_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.PacketFactoryConfig", null, o11), r11.exportSymbol("proto.mediapipe.PacketFactoryOptions", null, o11), r11.exportSymbol("proto.mediapipe.PacketManagerConfig", null, o11), proto.mediapipe.PacketFactoryOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, 1, null, null);
    }, r11.inherits(proto.mediapipe.PacketFactoryOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.PacketFactoryOptions.displayName = "proto.mediapipe.PacketFactoryOptions"), proto.mediapipe.PacketFactoryOptions.extensions = {}, proto.mediapipe.PacketFactoryOptions.extensionsBinary = {}, proto.mediapipe.PacketFactoryConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, 500, null, null);
    }, r11.inherits(proto.mediapipe.PacketFactoryConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.PacketFactoryConfig.displayName = "proto.mediapipe.PacketFactoryConfig"), proto.mediapipe.PacketManagerConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.PacketManagerConfig.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.PacketManagerConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.PacketManagerConfig.displayName = "proto.mediapipe.PacketManagerConfig"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.PacketFactoryOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.PacketFactoryOptions.toObject(e11, this);
    }, proto.mediapipe.PacketFactoryOptions.toObject = function(e11, r11) {
        var o11 = {};
        return t11.Message.toObjectExtension(r11, o11, proto.mediapipe.PacketFactoryOptions.extensions, proto.mediapipe.PacketFactoryOptions.prototype.getExtension, e11), e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.PacketFactoryOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.PacketFactoryOptions;
        return proto.mediapipe.PacketFactoryOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.PacketFactoryOptions.deserializeBinaryFromReader = function(e11, r11) {
        for(; r11.nextField() && !r11.isEndGroup();){
            r11.getFieldNumber();
            t11.Message.readBinaryExtension(e11, r11, proto.mediapipe.PacketFactoryOptions.extensionsBinary, proto.mediapipe.PacketFactoryOptions.prototype.getExtension, proto.mediapipe.PacketFactoryOptions.prototype.setExtension);
        }
        return e11;
    }, proto.mediapipe.PacketFactoryOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.PacketFactoryOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.PacketFactoryOptions.serializeBinaryToWriter = function(e11, r11) {
        t11.Message.serializeBinaryExtensions(e11, r11, proto.mediapipe.PacketFactoryOptions.extensionsBinary, proto.mediapipe.PacketFactoryOptions.prototype.getExtension);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.PacketFactoryConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.PacketFactoryConfig.toObject(e11, this);
    }, proto.mediapipe.PacketFactoryConfig.toObject = function(e11, r11) {
        var o11, i11 = {
            packetFactory: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            outputSidePacket: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            externalOutput: null == (o11 = t11.Message.getField(r11, 1002)) ? void 0 : o11,
            options: (o11 = r11.getOptions()) && proto.mediapipe.PacketFactoryOptions.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.PacketFactoryConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.PacketFactoryConfig;
        return proto.mediapipe.PacketFactoryConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.PacketFactoryConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setPacketFactory(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setOutputSidePacket(r11);
                break;
            case 1002:
                r11 = t11.readString();
                e11.setExternalOutput(r11);
                break;
            case 3:
                r11 = new proto.mediapipe.PacketFactoryOptions;
                t11.readMessage(r11, proto.mediapipe.PacketFactoryOptions.deserializeBinaryFromReader), e11.setOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.PacketFactoryConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.PacketFactoryConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.PacketFactoryConfig.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeString(2, o11), null != (o11 = t11.Message.getField(e11, 1002)) && r11.writeString(1002, o11), null != (o11 = e11.getOptions()) && r11.writeMessage(3, o11, proto.mediapipe.PacketFactoryOptions.serializeBinaryToWriter);
    }, proto.mediapipe.PacketFactoryConfig.prototype.getPacketFactory = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.PacketFactoryConfig.prototype.setPacketFactory = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.PacketFactoryConfig.prototype.clearPacketFactory = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.PacketFactoryConfig.prototype.hasPacketFactory = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.PacketFactoryConfig.prototype.getOutputSidePacket = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.mediapipe.PacketFactoryConfig.prototype.setOutputSidePacket = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.PacketFactoryConfig.prototype.clearOutputSidePacket = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.PacketFactoryConfig.prototype.hasOutputSidePacket = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.PacketFactoryConfig.prototype.getExternalOutput = function() {
        return t11.Message.getFieldWithDefault(this, 1002, "");
    }, proto.mediapipe.PacketFactoryConfig.prototype.setExternalOutput = function(e11) {
        return t11.Message.setField(this, 1002, e11);
    }, proto.mediapipe.PacketFactoryConfig.prototype.clearExternalOutput = function() {
        return t11.Message.setField(this, 1002, void 0);
    }, proto.mediapipe.PacketFactoryConfig.prototype.hasExternalOutput = function() {
        return null != t11.Message.getField(this, 1002);
    }, proto.mediapipe.PacketFactoryConfig.prototype.getOptions = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.PacketFactoryOptions, 3);
    }, proto.mediapipe.PacketFactoryConfig.prototype.setOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.PacketFactoryConfig.prototype.clearOptions = function() {
        return this.setOptions(void 0);
    }, proto.mediapipe.PacketFactoryConfig.prototype.hasOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.PacketManagerConfig.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.PacketManagerConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.PacketManagerConfig.toObject(e11, this);
    }, proto.mediapipe.PacketManagerConfig.toObject = function(e11, r11) {
        var o11 = {
            packetList: t11.Message.toObjectList(r11.getPacketList(), proto.mediapipe.PacketFactoryConfig.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.PacketManagerConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.PacketManagerConfig;
        return proto.mediapipe.PacketManagerConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.PacketManagerConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.PacketFactoryConfig;
            t11.readMessage(r11, proto.mediapipe.PacketFactoryConfig.deserializeBinaryFromReader), e11.addPacket(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.PacketManagerConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.PacketManagerConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.PacketManagerConfig.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getPacketList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.PacketFactoryConfig.serializeBinaryToWriter);
    }, proto.mediapipe.PacketManagerConfig.prototype.getPacketList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.PacketFactoryConfig, 1);
    }, proto.mediapipe.PacketManagerConfig.prototype.setPacketList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.PacketManagerConfig.prototype.addPacket = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.PacketFactoryConfig, r11);
    }, proto.mediapipe.PacketManagerConfig.prototype.clearPacketList = function() {
        return this.setPacketList([]);
    }, r11.object.extend(e11, proto.mediapipe);
}(packet_factory_pb);
var packet_generator_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.PacketGeneratorConfig", null, o11), r11.exportSymbol("proto.mediapipe.PacketGeneratorOptions", null, o11), proto.mediapipe.PacketGeneratorOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, 2, null, null);
    }, r11.inherits(proto.mediapipe.PacketGeneratorOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.PacketGeneratorOptions.displayName = "proto.mediapipe.PacketGeneratorOptions"), proto.mediapipe.PacketGeneratorOptions.extensions = {}, proto.mediapipe.PacketGeneratorOptions.extensionsBinary = {}, proto.mediapipe.PacketGeneratorConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, 500, proto.mediapipe.PacketGeneratorConfig.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.PacketGeneratorConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.PacketGeneratorConfig.displayName = "proto.mediapipe.PacketGeneratorConfig"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.PacketGeneratorOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.PacketGeneratorOptions.toObject(e11, this);
    }, proto.mediapipe.PacketGeneratorOptions.toObject = function(e11, r11) {
        var o11 = {
            mergeFields: t11.Message.getBooleanFieldWithDefault(r11, 1, !0)
        };
        return t11.Message.toObjectExtension(r11, o11, proto.mediapipe.PacketGeneratorOptions.extensions, proto.mediapipe.PacketGeneratorOptions.prototype.getExtension, e11), e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.PacketGeneratorOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.PacketGeneratorOptions;
        return proto.mediapipe.PacketGeneratorOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.PacketGeneratorOptions.deserializeBinaryFromReader = function(e11, r11) {
        for(; r11.nextField() && !r11.isEndGroup();)if (1 === r11.getFieldNumber()) {
            var o11 = r11.readBool();
            e11.setMergeFields(o11);
        } else t11.Message.readBinaryExtension(e11, r11, proto.mediapipe.PacketGeneratorOptions.extensionsBinary, proto.mediapipe.PacketGeneratorOptions.prototype.getExtension, proto.mediapipe.PacketGeneratorOptions.prototype.setExtension);
        return e11;
    }, proto.mediapipe.PacketGeneratorOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.PacketGeneratorOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.PacketGeneratorOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeBool(1, o11), t11.Message.serializeBinaryExtensions(e11, r11, proto.mediapipe.PacketGeneratorOptions.extensionsBinary, proto.mediapipe.PacketGeneratorOptions.prototype.getExtension);
    }, proto.mediapipe.PacketGeneratorOptions.prototype.getMergeFields = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 1, !0);
    }, proto.mediapipe.PacketGeneratorOptions.prototype.setMergeFields = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.PacketGeneratorOptions.prototype.clearMergeFields = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.PacketGeneratorOptions.prototype.hasMergeFields = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.PacketGeneratorConfig.repeatedFields_ = [
        2,
        1002,
        3,
        1003
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.PacketGeneratorConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.PacketGeneratorConfig.toObject(e11, this);
    }, proto.mediapipe.PacketGeneratorConfig.toObject = function(e11, r11) {
        var o11, i11 = {
            packetGenerator: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            inputSidePacketList: null == (o11 = t11.Message.getRepeatedField(r11, 2)) ? void 0 : o11,
            externalInputList: null == (o11 = t11.Message.getRepeatedField(r11, 1002)) ? void 0 : o11,
            outputSidePacketList: null == (o11 = t11.Message.getRepeatedField(r11, 3)) ? void 0 : o11,
            externalOutputList: null == (o11 = t11.Message.getRepeatedField(r11, 1003)) ? void 0 : o11,
            options: (o11 = r11.getOptions()) && proto.mediapipe.PacketGeneratorOptions.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.PacketGeneratorConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.PacketGeneratorConfig;
        return proto.mediapipe.PacketGeneratorConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.PacketGeneratorConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setPacketGenerator(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.addInputSidePacket(r11);
                break;
            case 1002:
                r11 = t11.readString();
                e11.addExternalInput(r11);
                break;
            case 3:
                r11 = t11.readString();
                e11.addOutputSidePacket(r11);
                break;
            case 1003:
                r11 = t11.readString();
                e11.addExternalOutput(r11);
                break;
            case 4:
                r11 = new proto.mediapipe.PacketGeneratorOptions;
                t11.readMessage(r11, proto.mediapipe.PacketGeneratorOptions.deserializeBinaryFromReader), e11.setOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.PacketGeneratorConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.PacketGeneratorConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.PacketGeneratorConfig.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), (o11 = e11.getInputSidePacketList()).length > 0 && r11.writeRepeatedString(2, o11), (o11 = e11.getExternalInputList()).length > 0 && r11.writeRepeatedString(1002, o11), (o11 = e11.getOutputSidePacketList()).length > 0 && r11.writeRepeatedString(3, o11), (o11 = e11.getExternalOutputList()).length > 0 && r11.writeRepeatedString(1003, o11), null != (o11 = e11.getOptions()) && r11.writeMessage(4, o11, proto.mediapipe.PacketGeneratorOptions.serializeBinaryToWriter);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.getPacketGenerator = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.PacketGeneratorConfig.prototype.setPacketGenerator = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.clearPacketGenerator = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.hasPacketGenerator = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.getInputSidePacketList = function() {
        return t11.Message.getRepeatedField(this, 2);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.setInputSidePacketList = function(e11) {
        return t11.Message.setField(this, 2, e11 || []);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.addInputSidePacket = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 2, e11, r11);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.clearInputSidePacketList = function() {
        return this.setInputSidePacketList([]);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.getExternalInputList = function() {
        return t11.Message.getRepeatedField(this, 1002);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.setExternalInputList = function(e11) {
        return t11.Message.setField(this, 1002, e11 || []);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.addExternalInput = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 1002, e11, r11);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.clearExternalInputList = function() {
        return this.setExternalInputList([]);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.getOutputSidePacketList = function() {
        return t11.Message.getRepeatedField(this, 3);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.setOutputSidePacketList = function(e11) {
        return t11.Message.setField(this, 3, e11 || []);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.addOutputSidePacket = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 3, e11, r11);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.clearOutputSidePacketList = function() {
        return this.setOutputSidePacketList([]);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.getExternalOutputList = function() {
        return t11.Message.getRepeatedField(this, 1003);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.setExternalOutputList = function(e11) {
        return t11.Message.setField(this, 1003, e11 || []);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.addExternalOutput = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 1003, e11, r11);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.clearExternalOutputList = function() {
        return this.setExternalOutputList([]);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.getOptions = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.PacketGeneratorOptions, 4);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.setOptions = function(e11) {
        return t11.Message.setWrapperField(this, 4, e11);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.clearOptions = function() {
        return this.setOptions(void 0);
    }, proto.mediapipe.PacketGeneratorConfig.prototype.hasOptions = function() {
        return null != t11.Message.getField(this, 4);
    }, r11.object.extend(e11, proto.mediapipe);
}(packet_generator_pb);
var status_handler_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = mediapipe_options_pb;
    r11.object.extend(proto, i11), r11.exportSymbol("proto.mediapipe.StatusHandlerConfig", null, o11), proto.mediapipe.StatusHandlerConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, 500, proto.mediapipe.StatusHandlerConfig.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.StatusHandlerConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.StatusHandlerConfig.displayName = "proto.mediapipe.StatusHandlerConfig"), proto.mediapipe.StatusHandlerConfig.repeatedFields_ = [
        2,
        1002
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.StatusHandlerConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.StatusHandlerConfig.toObject(e11, this);
    }, proto.mediapipe.StatusHandlerConfig.toObject = function(e11, r11) {
        var o11, a11 = {
            statusHandler: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            inputSidePacketList: null == (o11 = t11.Message.getRepeatedField(r11, 2)) ? void 0 : o11,
            externalInputList: null == (o11 = t11.Message.getRepeatedField(r11, 1002)) ? void 0 : o11,
            options: (o11 = r11.getOptions()) && i11.MediaPipeOptions.toObject(e11, o11)
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.StatusHandlerConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.StatusHandlerConfig;
        return proto.mediapipe.StatusHandlerConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.StatusHandlerConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setStatusHandler(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.addInputSidePacket(r11);
                break;
            case 1002:
                r11 = t11.readString();
                e11.addExternalInput(r11);
                break;
            case 3:
                r11 = new i11.MediaPipeOptions;
                t11.readMessage(r11, i11.MediaPipeOptions.deserializeBinaryFromReader), e11.setOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.StatusHandlerConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.StatusHandlerConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.StatusHandlerConfig.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), (o11 = e11.getInputSidePacketList()).length > 0 && r11.writeRepeatedString(2, o11), (o11 = e11.getExternalInputList()).length > 0 && r11.writeRepeatedString(1002, o11), null != (o11 = e11.getOptions()) && r11.writeMessage(3, o11, i11.MediaPipeOptions.serializeBinaryToWriter);
    }, proto.mediapipe.StatusHandlerConfig.prototype.getStatusHandler = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.StatusHandlerConfig.prototype.setStatusHandler = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.StatusHandlerConfig.prototype.clearStatusHandler = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.StatusHandlerConfig.prototype.hasStatusHandler = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.StatusHandlerConfig.prototype.getInputSidePacketList = function() {
        return t11.Message.getRepeatedField(this, 2);
    }, proto.mediapipe.StatusHandlerConfig.prototype.setInputSidePacketList = function(e11) {
        return t11.Message.setField(this, 2, e11 || []);
    }, proto.mediapipe.StatusHandlerConfig.prototype.addInputSidePacket = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 2, e11, r11);
    }, proto.mediapipe.StatusHandlerConfig.prototype.clearInputSidePacketList = function() {
        return this.setInputSidePacketList([]);
    }, proto.mediapipe.StatusHandlerConfig.prototype.getExternalInputList = function() {
        return t11.Message.getRepeatedField(this, 1002);
    }, proto.mediapipe.StatusHandlerConfig.prototype.setExternalInputList = function(e11) {
        return t11.Message.setField(this, 1002, e11 || []);
    }, proto.mediapipe.StatusHandlerConfig.prototype.addExternalInput = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 1002, e11, r11);
    }, proto.mediapipe.StatusHandlerConfig.prototype.clearExternalInputList = function() {
        return this.setExternalInputList([]);
    }, proto.mediapipe.StatusHandlerConfig.prototype.getOptions = function() {
        return t11.Message.getWrapperField(this, i11.MediaPipeOptions, 3);
    }, proto.mediapipe.StatusHandlerConfig.prototype.setOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.StatusHandlerConfig.prototype.clearOptions = function() {
        return this.setOptions(void 0);
    }, proto.mediapipe.StatusHandlerConfig.prototype.hasOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, r11.object.extend(e11, proto.mediapipe);
}(status_handler_pb);
var stream_handler_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = mediapipe_options_pb;
    r11.object.extend(proto, i11), r11.exportSymbol("proto.mediapipe.InputStreamHandlerConfig", null, o11), r11.exportSymbol("proto.mediapipe.OutputStreamHandlerConfig", null, o11), proto.mediapipe.InputStreamHandlerConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.InputStreamHandlerConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InputStreamHandlerConfig.displayName = "proto.mediapipe.InputStreamHandlerConfig"), proto.mediapipe.OutputStreamHandlerConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.OutputStreamHandlerConfig.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.OutputStreamHandlerConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.OutputStreamHandlerConfig.displayName = "proto.mediapipe.OutputStreamHandlerConfig"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InputStreamHandlerConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.InputStreamHandlerConfig.toObject(e11, this);
    }, proto.mediapipe.InputStreamHandlerConfig.toObject = function(e11, r11) {
        var o11, a11 = {
            inputStreamHandler: t11.Message.getFieldWithDefault(r11, 1, "DefaultInputStreamHandler"),
            options: (o11 = r11.getOptions()) && i11.MediaPipeOptions.toObject(e11, o11)
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.InputStreamHandlerConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InputStreamHandlerConfig;
        return proto.mediapipe.InputStreamHandlerConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InputStreamHandlerConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setInputStreamHandler(r11);
                break;
            case 3:
                r11 = new i11.MediaPipeOptions;
                t11.readMessage(r11, i11.MediaPipeOptions.deserializeBinaryFromReader), e11.setOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InputStreamHandlerConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InputStreamHandlerConfig.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), null != (o11 = e11.getOptions()) && r11.writeMessage(3, o11, i11.MediaPipeOptions.serializeBinaryToWriter);
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.getInputStreamHandler = function() {
        return t11.Message.getFieldWithDefault(this, 1, "DefaultInputStreamHandler");
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.setInputStreamHandler = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.clearInputStreamHandler = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.hasInputStreamHandler = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.getOptions = function() {
        return t11.Message.getWrapperField(this, i11.MediaPipeOptions, 3);
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.setOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.clearOptions = function() {
        return this.setOptions(void 0);
    }, proto.mediapipe.InputStreamHandlerConfig.prototype.hasOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.OutputStreamHandlerConfig.repeatedFields_ = [
        2
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.OutputStreamHandlerConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.OutputStreamHandlerConfig.toObject(e11, this);
    }, proto.mediapipe.OutputStreamHandlerConfig.toObject = function(e11, r11) {
        var o11, a11 = {
            outputStreamHandler: t11.Message.getFieldWithDefault(r11, 1, "InOrderOutputStreamHandler"),
            inputSidePacketList: null == (o11 = t11.Message.getRepeatedField(r11, 2)) ? void 0 : o11,
            options: (o11 = r11.getOptions()) && i11.MediaPipeOptions.toObject(e11, o11)
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.OutputStreamHandlerConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.OutputStreamHandlerConfig;
        return proto.mediapipe.OutputStreamHandlerConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.OutputStreamHandlerConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setOutputStreamHandler(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.addInputSidePacket(r11);
                break;
            case 3:
                r11 = new i11.MediaPipeOptions;
                t11.readMessage(r11, i11.MediaPipeOptions.deserializeBinaryFromReader), e11.setOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.OutputStreamHandlerConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.OutputStreamHandlerConfig.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), (o11 = e11.getInputSidePacketList()).length > 0 && r11.writeRepeatedString(2, o11), null != (o11 = e11.getOptions()) && r11.writeMessage(3, o11, i11.MediaPipeOptions.serializeBinaryToWriter);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.getOutputStreamHandler = function() {
        return t11.Message.getFieldWithDefault(this, 1, "InOrderOutputStreamHandler");
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.setOutputStreamHandler = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.clearOutputStreamHandler = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.hasOutputStreamHandler = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.getInputSidePacketList = function() {
        return t11.Message.getRepeatedField(this, 2);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.setInputSidePacketList = function(e11) {
        return t11.Message.setField(this, 2, e11 || []);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.addInputSidePacket = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 2, e11, r11);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.clearInputSidePacketList = function() {
        return this.setInputSidePacketList([]);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.getOptions = function() {
        return t11.Message.getWrapperField(this, i11.MediaPipeOptions, 3);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.setOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.clearOptions = function() {
        return this.setOptions(void 0);
    }, proto.mediapipe.OutputStreamHandlerConfig.prototype.hasOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, r11.object.extend(e11, proto.mediapipe);
}(stream_handler_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_options_pb;
    r11.object.extend(proto, i11);
    var a11 = any_pb;
    r11.object.extend(proto, a11);
    var n11 = mediapipe_options_pb;
    r11.object.extend(proto, n11);
    var s11 = packet_factory_pb;
    r11.object.extend(proto, s11);
    var p11 = packet_generator_pb;
    r11.object.extend(proto, p11);
    var d11 = status_handler_pb;
    r11.object.extend(proto, d11);
    var l11 = stream_handler_pb;
    r11.object.extend(proto, l11), r11.exportSymbol("proto.mediapipe.CalculatorGraphConfig", null, o11), r11.exportSymbol("proto.mediapipe.CalculatorGraphConfig.Node", null, o11), r11.exportSymbol("proto.mediapipe.ExecutorConfig", null, o11), r11.exportSymbol("proto.mediapipe.InputCollection", null, o11), r11.exportSymbol("proto.mediapipe.InputCollection.InputType", null, o11), r11.exportSymbol("proto.mediapipe.InputCollectionSet", null, o11), r11.exportSymbol("proto.mediapipe.InputStreamInfo", null, o11), r11.exportSymbol("proto.mediapipe.ProfilerConfig", null, o11), proto.mediapipe.ExecutorConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.ExecutorConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.ExecutorConfig.displayName = "proto.mediapipe.ExecutorConfig"), proto.mediapipe.InputCollection = function(e11) {
        t11.Message.initialize(this, e11, 0, 500, proto.mediapipe.InputCollection.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.InputCollection, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InputCollection.displayName = "proto.mediapipe.InputCollection"), proto.mediapipe.InputCollectionSet = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.InputCollectionSet.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.InputCollectionSet, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InputCollectionSet.displayName = "proto.mediapipe.InputCollectionSet"), proto.mediapipe.InputStreamInfo = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.InputStreamInfo, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InputStreamInfo.displayName = "proto.mediapipe.InputStreamInfo"), proto.mediapipe.ProfilerConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.ProfilerConfig.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.ProfilerConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.ProfilerConfig.displayName = "proto.mediapipe.ProfilerConfig"), proto.mediapipe.CalculatorGraphConfig = function(e11) {
        t11.Message.initialize(this, e11, 0, 500, proto.mediapipe.CalculatorGraphConfig.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.CalculatorGraphConfig, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.CalculatorGraphConfig.displayName = "proto.mediapipe.CalculatorGraphConfig"), proto.mediapipe.CalculatorGraphConfig.Node = function(e11) {
        t11.Message.initialize(this, e11, 0, 500, proto.mediapipe.CalculatorGraphConfig.Node.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.CalculatorGraphConfig.Node, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.CalculatorGraphConfig.Node.displayName = "proto.mediapipe.CalculatorGraphConfig.Node"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.ExecutorConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.ExecutorConfig.toObject(e11, this);
    }, proto.mediapipe.ExecutorConfig.toObject = function(e11, r11) {
        var o11, i11 = {
            name: t11.Message.getFieldWithDefault(r11, 1, ""),
            type: t11.Message.getFieldWithDefault(r11, 2, ""),
            options: (o11 = r11.getOptions()) && n11.MediaPipeOptions.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.ExecutorConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.ExecutorConfig;
        return proto.mediapipe.ExecutorConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.ExecutorConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setName(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setType(r11);
                break;
            case 3:
                r11 = new n11.MediaPipeOptions;
                t11.readMessage(r11, n11.MediaPipeOptions.deserializeBinaryFromReader), e11.setOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.ExecutorConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.ExecutorConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.ExecutorConfig.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        (r11 = e11.getName()).length > 0 && t11.writeString(1, r11), (r11 = e11.getType()).length > 0 && t11.writeString(2, r11), null != (r11 = e11.getOptions()) && t11.writeMessage(3, r11, n11.MediaPipeOptions.serializeBinaryToWriter);
    }, proto.mediapipe.ExecutorConfig.prototype.getName = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.ExecutorConfig.prototype.setName = function(e11) {
        return t11.Message.setProto3StringField(this, 1, e11);
    }, proto.mediapipe.ExecutorConfig.prototype.getType = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.mediapipe.ExecutorConfig.prototype.setType = function(e11) {
        return t11.Message.setProto3StringField(this, 2, e11);
    }, proto.mediapipe.ExecutorConfig.prototype.getOptions = function() {
        return t11.Message.getWrapperField(this, n11.MediaPipeOptions, 3);
    }, proto.mediapipe.ExecutorConfig.prototype.setOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.ExecutorConfig.prototype.clearOptions = function() {
        return this.setOptions(void 0);
    }, proto.mediapipe.ExecutorConfig.prototype.hasOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.InputCollection.repeatedFields_ = [
        2,
        1002
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InputCollection.prototype.toObject = function(e11) {
        return proto.mediapipe.InputCollection.toObject(e11, this);
    }, proto.mediapipe.InputCollection.toObject = function(e11, r11) {
        var o11, i11 = {
            name: t11.Message.getFieldWithDefault(r11, 1, ""),
            sidePacketNameList: null == (o11 = t11.Message.getRepeatedField(r11, 2)) ? void 0 : o11,
            externalInputNameList: null == (o11 = t11.Message.getRepeatedField(r11, 1002)) ? void 0 : o11,
            inputType: t11.Message.getFieldWithDefault(r11, 3, 0),
            fileName: t11.Message.getFieldWithDefault(r11, 4, "")
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.InputCollection.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InputCollection;
        return proto.mediapipe.InputCollection.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InputCollection.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setName(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.addSidePacketName(r11);
                break;
            case 1002:
                r11 = t11.readString();
                e11.addExternalInputName(r11);
                break;
            case 3:
                r11 = t11.readEnum();
                e11.setInputType(r11);
                break;
            case 4:
                r11 = t11.readString();
                e11.setFileName(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.InputCollection.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InputCollection.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InputCollection.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        (r11 = e11.getName()).length > 0 && t11.writeString(1, r11), (r11 = e11.getSidePacketNameList()).length > 0 && t11.writeRepeatedString(2, r11), (r11 = e11.getExternalInputNameList()).length > 0 && t11.writeRepeatedString(1002, r11), 0 !== (r11 = e11.getInputType()) && t11.writeEnum(3, r11), (r11 = e11.getFileName()).length > 0 && t11.writeString(4, r11);
    }, proto.mediapipe.InputCollection.InputType = {
        UNKNOWN: 0,
        RECORDIO: 1,
        FOREIGN_RECORDIO: 2,
        FOREIGN_CSV_TEXT: 3,
        INVALID_UPPER_BOUND: 4
    }, proto.mediapipe.InputCollection.prototype.getName = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.InputCollection.prototype.setName = function(e11) {
        return t11.Message.setProto3StringField(this, 1, e11);
    }, proto.mediapipe.InputCollection.prototype.getSidePacketNameList = function() {
        return t11.Message.getRepeatedField(this, 2);
    }, proto.mediapipe.InputCollection.prototype.setSidePacketNameList = function(e11) {
        return t11.Message.setField(this, 2, e11 || []);
    }, proto.mediapipe.InputCollection.prototype.addSidePacketName = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 2, e11, r11);
    }, proto.mediapipe.InputCollection.prototype.clearSidePacketNameList = function() {
        return this.setSidePacketNameList([]);
    }, proto.mediapipe.InputCollection.prototype.getExternalInputNameList = function() {
        return t11.Message.getRepeatedField(this, 1002);
    }, proto.mediapipe.InputCollection.prototype.setExternalInputNameList = function(e11) {
        return t11.Message.setField(this, 1002, e11 || []);
    }, proto.mediapipe.InputCollection.prototype.addExternalInputName = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 1002, e11, r11);
    }, proto.mediapipe.InputCollection.prototype.clearExternalInputNameList = function() {
        return this.setExternalInputNameList([]);
    }, proto.mediapipe.InputCollection.prototype.getInputType = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.InputCollection.prototype.setInputType = function(e11) {
        return t11.Message.setProto3EnumField(this, 3, e11);
    }, proto.mediapipe.InputCollection.prototype.getFileName = function() {
        return t11.Message.getFieldWithDefault(this, 4, "");
    }, proto.mediapipe.InputCollection.prototype.setFileName = function(e11) {
        return t11.Message.setProto3StringField(this, 4, e11);
    }, proto.mediapipe.InputCollectionSet.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InputCollectionSet.prototype.toObject = function(e11) {
        return proto.mediapipe.InputCollectionSet.toObject(e11, this);
    }, proto.mediapipe.InputCollectionSet.toObject = function(e11, r11) {
        var o11 = {
            inputCollectionList: t11.Message.toObjectList(r11.getInputCollectionList(), proto.mediapipe.InputCollection.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.InputCollectionSet.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InputCollectionSet;
        return proto.mediapipe.InputCollectionSet.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InputCollectionSet.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.InputCollection;
            t11.readMessage(r11, proto.mediapipe.InputCollection.deserializeBinaryFromReader), e11.addInputCollection(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.InputCollectionSet.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InputCollectionSet.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InputCollectionSet.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getInputCollectionList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.InputCollection.serializeBinaryToWriter);
    }, proto.mediapipe.InputCollectionSet.prototype.getInputCollectionList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.InputCollection, 1);
    }, proto.mediapipe.InputCollectionSet.prototype.setInputCollectionList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.InputCollectionSet.prototype.addInputCollection = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.InputCollection, r11);
    }, proto.mediapipe.InputCollectionSet.prototype.clearInputCollectionList = function() {
        return this.setInputCollectionList([]);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InputStreamInfo.prototype.toObject = function(e11) {
        return proto.mediapipe.InputStreamInfo.toObject(e11, this);
    }, proto.mediapipe.InputStreamInfo.toObject = function(e11, r11) {
        var o11 = {
            tagIndex: t11.Message.getFieldWithDefault(r11, 1, ""),
            backEdge: t11.Message.getBooleanFieldWithDefault(r11, 2, !1)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.InputStreamInfo.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InputStreamInfo;
        return proto.mediapipe.InputStreamInfo.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InputStreamInfo.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setTagIndex(r11);
                break;
            case 2:
                r11 = t11.readBool();
                e11.setBackEdge(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.InputStreamInfo.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InputStreamInfo.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InputStreamInfo.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        (r11 = e11.getTagIndex()).length > 0 && t11.writeString(1, r11), (r11 = e11.getBackEdge()) && t11.writeBool(2, r11);
    }, proto.mediapipe.InputStreamInfo.prototype.getTagIndex = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.InputStreamInfo.prototype.setTagIndex = function(e11) {
        return t11.Message.setProto3StringField(this, 1, e11);
    }, proto.mediapipe.InputStreamInfo.prototype.getBackEdge = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 2, !1);
    }, proto.mediapipe.InputStreamInfo.prototype.setBackEdge = function(e11) {
        return t11.Message.setProto3BooleanField(this, 2, e11);
    }, proto.mediapipe.ProfilerConfig.repeatedFields_ = [
        8
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.ProfilerConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.ProfilerConfig.toObject(e11, this);
    }, proto.mediapipe.ProfilerConfig.toObject = function(e11, r11) {
        var o11, i11 = {
            histogramIntervalSizeUsec: t11.Message.getFieldWithDefault(r11, 1, 0),
            numHistogramIntervals: t11.Message.getFieldWithDefault(r11, 2, 0),
            enableInputOutputLatency: t11.Message.getBooleanFieldWithDefault(r11, 3, !1),
            enableProfiler: t11.Message.getBooleanFieldWithDefault(r11, 4, !1),
            enableStreamLatency: t11.Message.getBooleanFieldWithDefault(r11, 5, !1),
            usePacketTimestampForAddedPacket: t11.Message.getBooleanFieldWithDefault(r11, 6, !1),
            traceLogCapacity: t11.Message.getFieldWithDefault(r11, 7, 0),
            traceEventTypesDisabledList: null == (o11 = t11.Message.getRepeatedField(r11, 8)) ? void 0 : o11,
            traceLogPath: t11.Message.getFieldWithDefault(r11, 9, ""),
            traceLogCount: t11.Message.getFieldWithDefault(r11, 10, 0),
            traceLogIntervalUsec: t11.Message.getFieldWithDefault(r11, 11, 0),
            traceLogMarginUsec: t11.Message.getFieldWithDefault(r11, 12, 0),
            traceLogDurationEvents: t11.Message.getBooleanFieldWithDefault(r11, 13, !1),
            traceLogIntervalCount: t11.Message.getFieldWithDefault(r11, 14, 0),
            traceLogDisabled: t11.Message.getBooleanFieldWithDefault(r11, 15, !1),
            traceEnabled: t11.Message.getBooleanFieldWithDefault(r11, 16, !1),
            traceLogInstantEvents: t11.Message.getBooleanFieldWithDefault(r11, 17, !1),
            calculatorFilter: t11.Message.getFieldWithDefault(r11, 18, "")
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.ProfilerConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.ProfilerConfig;
        return proto.mediapipe.ProfilerConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.ProfilerConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt64();
                e11.setHistogramIntervalSizeUsec(r11);
                break;
            case 2:
                r11 = t11.readInt64();
                e11.setNumHistogramIntervals(r11);
                break;
            case 3:
                r11 = t11.readBool();
                e11.setEnableInputOutputLatency(r11);
                break;
            case 4:
                r11 = t11.readBool();
                e11.setEnableProfiler(r11);
                break;
            case 5:
                r11 = t11.readBool();
                e11.setEnableStreamLatency(r11);
                break;
            case 6:
                r11 = t11.readBool();
                e11.setUsePacketTimestampForAddedPacket(r11);
                break;
            case 7:
                r11 = t11.readInt64();
                e11.setTraceLogCapacity(r11);
                break;
            case 8:
                for(var o11 = t11.isDelimited() ? t11.readPackedInt32() : [
                    t11.readInt32()
                ], i11 = 0; i11 < o11.length; i11++)e11.addTraceEventTypesDisabled(o11[i11]);
                break;
            case 9:
                r11 = t11.readString();
                e11.setTraceLogPath(r11);
                break;
            case 10:
                r11 = t11.readInt32();
                e11.setTraceLogCount(r11);
                break;
            case 11:
                r11 = t11.readInt64();
                e11.setTraceLogIntervalUsec(r11);
                break;
            case 12:
                r11 = t11.readInt64();
                e11.setTraceLogMarginUsec(r11);
                break;
            case 13:
                r11 = t11.readBool();
                e11.setTraceLogDurationEvents(r11);
                break;
            case 14:
                r11 = t11.readInt32();
                e11.setTraceLogIntervalCount(r11);
                break;
            case 15:
                r11 = t11.readBool();
                e11.setTraceLogDisabled(r11);
                break;
            case 16:
                r11 = t11.readBool();
                e11.setTraceEnabled(r11);
                break;
            case 17:
                r11 = t11.readBool();
                e11.setTraceLogInstantEvents(r11);
                break;
            case 18:
                r11 = t11.readString();
                e11.setCalculatorFilter(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.ProfilerConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.ProfilerConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.ProfilerConfig.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        0 !== (r11 = e11.getHistogramIntervalSizeUsec()) && t11.writeInt64(1, r11), 0 !== (r11 = e11.getNumHistogramIntervals()) && t11.writeInt64(2, r11), (r11 = e11.getEnableInputOutputLatency()) && t11.writeBool(3, r11), (r11 = e11.getEnableProfiler()) && t11.writeBool(4, r11), (r11 = e11.getEnableStreamLatency()) && t11.writeBool(5, r11), (r11 = e11.getUsePacketTimestampForAddedPacket()) && t11.writeBool(6, r11), 0 !== (r11 = e11.getTraceLogCapacity()) && t11.writeInt64(7, r11), (r11 = e11.getTraceEventTypesDisabledList()).length > 0 && t11.writePackedInt32(8, r11), (r11 = e11.getTraceLogPath()).length > 0 && t11.writeString(9, r11), 0 !== (r11 = e11.getTraceLogCount()) && t11.writeInt32(10, r11), 0 !== (r11 = e11.getTraceLogIntervalUsec()) && t11.writeInt64(11, r11), 0 !== (r11 = e11.getTraceLogMarginUsec()) && t11.writeInt64(12, r11), (r11 = e11.getTraceLogDurationEvents()) && t11.writeBool(13, r11), 0 !== (r11 = e11.getTraceLogIntervalCount()) && t11.writeInt32(14, r11), (r11 = e11.getTraceLogDisabled()) && t11.writeBool(15, r11), (r11 = e11.getTraceEnabled()) && t11.writeBool(16, r11), (r11 = e11.getTraceLogInstantEvents()) && t11.writeBool(17, r11), (r11 = e11.getCalculatorFilter()).length > 0 && t11.writeString(18, r11);
    }, proto.mediapipe.ProfilerConfig.prototype.getHistogramIntervalSizeUsec = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.ProfilerConfig.prototype.setHistogramIntervalSizeUsec = function(e11) {
        return t11.Message.setProto3IntField(this, 1, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getNumHistogramIntervals = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.ProfilerConfig.prototype.setNumHistogramIntervals = function(e11) {
        return t11.Message.setProto3IntField(this, 2, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getEnableInputOutputLatency = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 3, !1);
    }, proto.mediapipe.ProfilerConfig.prototype.setEnableInputOutputLatency = function(e11) {
        return t11.Message.setProto3BooleanField(this, 3, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getEnableProfiler = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 4, !1);
    }, proto.mediapipe.ProfilerConfig.prototype.setEnableProfiler = function(e11) {
        return t11.Message.setProto3BooleanField(this, 4, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getEnableStreamLatency = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 5, !1);
    }, proto.mediapipe.ProfilerConfig.prototype.setEnableStreamLatency = function(e11) {
        return t11.Message.setProto3BooleanField(this, 5, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getUsePacketTimestampForAddedPacket = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 6, !1);
    }, proto.mediapipe.ProfilerConfig.prototype.setUsePacketTimestampForAddedPacket = function(e11) {
        return t11.Message.setProto3BooleanField(this, 6, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogCapacity = function() {
        return t11.Message.getFieldWithDefault(this, 7, 0);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogCapacity = function(e11) {
        return t11.Message.setProto3IntField(this, 7, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceEventTypesDisabledList = function() {
        return t11.Message.getRepeatedField(this, 8);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceEventTypesDisabledList = function(e11) {
        return t11.Message.setField(this, 8, e11 || []);
    }, proto.mediapipe.ProfilerConfig.prototype.addTraceEventTypesDisabled = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 8, e11, r11);
    }, proto.mediapipe.ProfilerConfig.prototype.clearTraceEventTypesDisabledList = function() {
        return this.setTraceEventTypesDisabledList([]);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogPath = function() {
        return t11.Message.getFieldWithDefault(this, 9, "");
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogPath = function(e11) {
        return t11.Message.setProto3StringField(this, 9, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogCount = function() {
        return t11.Message.getFieldWithDefault(this, 10, 0);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogCount = function(e11) {
        return t11.Message.setProto3IntField(this, 10, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogIntervalUsec = function() {
        return t11.Message.getFieldWithDefault(this, 11, 0);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogIntervalUsec = function(e11) {
        return t11.Message.setProto3IntField(this, 11, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogMarginUsec = function() {
        return t11.Message.getFieldWithDefault(this, 12, 0);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogMarginUsec = function(e11) {
        return t11.Message.setProto3IntField(this, 12, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogDurationEvents = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 13, !1);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogDurationEvents = function(e11) {
        return t11.Message.setProto3BooleanField(this, 13, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogIntervalCount = function() {
        return t11.Message.getFieldWithDefault(this, 14, 0);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogIntervalCount = function(e11) {
        return t11.Message.setProto3IntField(this, 14, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogDisabled = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 15, !1);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogDisabled = function(e11) {
        return t11.Message.setProto3BooleanField(this, 15, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceEnabled = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 16, !1);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceEnabled = function(e11) {
        return t11.Message.setProto3BooleanField(this, 16, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getTraceLogInstantEvents = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 17, !1);
    }, proto.mediapipe.ProfilerConfig.prototype.setTraceLogInstantEvents = function(e11) {
        return t11.Message.setProto3BooleanField(this, 17, e11);
    }, proto.mediapipe.ProfilerConfig.prototype.getCalculatorFilter = function() {
        return t11.Message.getFieldWithDefault(this, 18, "");
    }, proto.mediapipe.ProfilerConfig.prototype.setCalculatorFilter = function(e11) {
        return t11.Message.setProto3StringField(this, 18, e11);
    }, proto.mediapipe.CalculatorGraphConfig.repeatedFields_ = [
        1,
        6,
        7,
        9,
        10,
        15,
        16,
        17,
        14,
        1002
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.CalculatorGraphConfig.prototype.toObject = function(e11) {
        return proto.mediapipe.CalculatorGraphConfig.toObject(e11, this);
    }, proto.mediapipe.CalculatorGraphConfig.toObject = function(e11, r11) {
        var o11, i11 = {
            nodeList: t11.Message.toObjectList(r11.getNodeList(), proto.mediapipe.CalculatorGraphConfig.Node.toObject, e11),
            packetFactoryList: t11.Message.toObjectList(r11.getPacketFactoryList(), s11.PacketFactoryConfig.toObject, e11),
            packetGeneratorList: t11.Message.toObjectList(r11.getPacketGeneratorList(), p11.PacketGeneratorConfig.toObject, e11),
            numThreads: t11.Message.getFieldWithDefault(r11, 8, 0),
            statusHandlerList: t11.Message.toObjectList(r11.getStatusHandlerList(), d11.StatusHandlerConfig.toObject, e11),
            inputStreamList: null == (o11 = t11.Message.getRepeatedField(r11, 10)) ? void 0 : o11,
            outputStreamList: null == (o11 = t11.Message.getRepeatedField(r11, 15)) ? void 0 : o11,
            inputSidePacketList: null == (o11 = t11.Message.getRepeatedField(r11, 16)) ? void 0 : o11,
            outputSidePacketList: null == (o11 = t11.Message.getRepeatedField(r11, 17)) ? void 0 : o11,
            maxQueueSize: t11.Message.getFieldWithDefault(r11, 11, 0),
            reportDeadlock: t11.Message.getBooleanFieldWithDefault(r11, 21, !1),
            inputStreamHandler: (o11 = r11.getInputStreamHandler()) && l11.InputStreamHandlerConfig.toObject(e11, o11),
            outputStreamHandler: (o11 = r11.getOutputStreamHandler()) && l11.OutputStreamHandlerConfig.toObject(e11, o11),
            executorList: t11.Message.toObjectList(r11.getExecutorList(), proto.mediapipe.ExecutorConfig.toObject, e11),
            profilerConfig: (o11 = r11.getProfilerConfig()) && proto.mediapipe.ProfilerConfig.toObject(e11, o11),
            pb_package: t11.Message.getFieldWithDefault(r11, 19, ""),
            type: t11.Message.getFieldWithDefault(r11, 20, ""),
            options: (o11 = r11.getOptions()) && n11.MediaPipeOptions.toObject(e11, o11),
            graphOptionsList: t11.Message.toObjectList(r11.getGraphOptionsList(), a11.Any.toObject, e11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.CalculatorGraphConfig.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.CalculatorGraphConfig;
        return proto.mediapipe.CalculatorGraphConfig.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.CalculatorGraphConfig.Node;
                t11.readMessage(r11, proto.mediapipe.CalculatorGraphConfig.Node.deserializeBinaryFromReader), e11.addNode(r11);
                break;
            case 6:
                r11 = new s11.PacketFactoryConfig;
                t11.readMessage(r11, s11.PacketFactoryConfig.deserializeBinaryFromReader), e11.addPacketFactory(r11);
                break;
            case 7:
                r11 = new p11.PacketGeneratorConfig;
                t11.readMessage(r11, p11.PacketGeneratorConfig.deserializeBinaryFromReader), e11.addPacketGenerator(r11);
                break;
            case 8:
                r11 = t11.readInt32();
                e11.setNumThreads(r11);
                break;
            case 9:
                r11 = new d11.StatusHandlerConfig;
                t11.readMessage(r11, d11.StatusHandlerConfig.deserializeBinaryFromReader), e11.addStatusHandler(r11);
                break;
            case 10:
                r11 = t11.readString();
                e11.addInputStream(r11);
                break;
            case 15:
                r11 = t11.readString();
                e11.addOutputStream(r11);
                break;
            case 16:
                r11 = t11.readString();
                e11.addInputSidePacket(r11);
                break;
            case 17:
                r11 = t11.readString();
                e11.addOutputSidePacket(r11);
                break;
            case 11:
                r11 = t11.readInt32();
                e11.setMaxQueueSize(r11);
                break;
            case 21:
                r11 = t11.readBool();
                e11.setReportDeadlock(r11);
                break;
            case 12:
                r11 = new l11.InputStreamHandlerConfig;
                t11.readMessage(r11, l11.InputStreamHandlerConfig.deserializeBinaryFromReader), e11.setInputStreamHandler(r11);
                break;
            case 13:
                r11 = new l11.OutputStreamHandlerConfig;
                t11.readMessage(r11, l11.OutputStreamHandlerConfig.deserializeBinaryFromReader), e11.setOutputStreamHandler(r11);
                break;
            case 14:
                r11 = new proto.mediapipe.ExecutorConfig;
                t11.readMessage(r11, proto.mediapipe.ExecutorConfig.deserializeBinaryFromReader), e11.addExecutor(r11);
                break;
            case 18:
                r11 = new proto.mediapipe.ProfilerConfig;
                t11.readMessage(r11, proto.mediapipe.ProfilerConfig.deserializeBinaryFromReader), e11.setProfilerConfig(r11);
                break;
            case 19:
                r11 = t11.readString();
                e11.setPackage(r11);
                break;
            case 20:
                r11 = t11.readString();
                e11.setType(r11);
                break;
            case 1001:
                r11 = new n11.MediaPipeOptions;
                t11.readMessage(r11, n11.MediaPipeOptions.deserializeBinaryFromReader), e11.setOptions(r11);
                break;
            case 1002:
                r11 = new a11.Any;
                t11.readMessage(r11, a11.Any.deserializeBinaryFromReader), e11.addGraphOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.CalculatorGraphConfig.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.CalculatorGraphConfig.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.CalculatorGraphConfig.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        (r11 = e11.getNodeList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.CalculatorGraphConfig.Node.serializeBinaryToWriter), (r11 = e11.getPacketFactoryList()).length > 0 && t11.writeRepeatedMessage(6, r11, s11.PacketFactoryConfig.serializeBinaryToWriter), (r11 = e11.getPacketGeneratorList()).length > 0 && t11.writeRepeatedMessage(7, r11, p11.PacketGeneratorConfig.serializeBinaryToWriter), 0 !== (r11 = e11.getNumThreads()) && t11.writeInt32(8, r11), (r11 = e11.getStatusHandlerList()).length > 0 && t11.writeRepeatedMessage(9, r11, d11.StatusHandlerConfig.serializeBinaryToWriter), (r11 = e11.getInputStreamList()).length > 0 && t11.writeRepeatedString(10, r11), (r11 = e11.getOutputStreamList()).length > 0 && t11.writeRepeatedString(15, r11), (r11 = e11.getInputSidePacketList()).length > 0 && t11.writeRepeatedString(16, r11), (r11 = e11.getOutputSidePacketList()).length > 0 && t11.writeRepeatedString(17, r11), 0 !== (r11 = e11.getMaxQueueSize()) && t11.writeInt32(11, r11), (r11 = e11.getReportDeadlock()) && t11.writeBool(21, r11), null != (r11 = e11.getInputStreamHandler()) && t11.writeMessage(12, r11, l11.InputStreamHandlerConfig.serializeBinaryToWriter), null != (r11 = e11.getOutputStreamHandler()) && t11.writeMessage(13, r11, l11.OutputStreamHandlerConfig.serializeBinaryToWriter), (r11 = e11.getExecutorList()).length > 0 && t11.writeRepeatedMessage(14, r11, proto.mediapipe.ExecutorConfig.serializeBinaryToWriter), null != (r11 = e11.getProfilerConfig()) && t11.writeMessage(18, r11, proto.mediapipe.ProfilerConfig.serializeBinaryToWriter), (r11 = e11.getPackage()).length > 0 && t11.writeString(19, r11), (r11 = e11.getType()).length > 0 && t11.writeString(20, r11), null != (r11 = e11.getOptions()) && t11.writeMessage(1001, r11, n11.MediaPipeOptions.serializeBinaryToWriter), (r11 = e11.getGraphOptionsList()).length > 0 && t11.writeRepeatedMessage(1002, r11, a11.Any.serializeBinaryToWriter);
    }, proto.mediapipe.CalculatorGraphConfig.Node.repeatedFields_ = [
        3,
        4,
        5,
        6,
        8,
        13,
        17,
        1005
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.CalculatorGraphConfig.Node.prototype.toObject = function(e11) {
        return proto.mediapipe.CalculatorGraphConfig.Node.toObject(e11, this);
    }, proto.mediapipe.CalculatorGraphConfig.Node.toObject = function(e11, r11) {
        var o11, n11 = {
            name: t11.Message.getFieldWithDefault(r11, 1, ""),
            calculator: t11.Message.getFieldWithDefault(r11, 2, ""),
            inputStreamList: null == (o11 = t11.Message.getRepeatedField(r11, 3)) ? void 0 : o11,
            outputStreamList: null == (o11 = t11.Message.getRepeatedField(r11, 4)) ? void 0 : o11,
            inputSidePacketList: null == (o11 = t11.Message.getRepeatedField(r11, 5)) ? void 0 : o11,
            outputSidePacketList: null == (o11 = t11.Message.getRepeatedField(r11, 6)) ? void 0 : o11,
            options: (o11 = r11.getOptions()) && i11.CalculatorOptions.toObject(e11, o11),
            nodeOptionsList: t11.Message.toObjectList(r11.getNodeOptionsList(), a11.Any.toObject, e11),
            sourceLayer: t11.Message.getFieldWithDefault(r11, 9, 0),
            bufferSizeHint: t11.Message.getFieldWithDefault(r11, 10, 0),
            inputStreamHandler: (o11 = r11.getInputStreamHandler()) && l11.InputStreamHandlerConfig.toObject(e11, o11),
            outputStreamHandler: (o11 = r11.getOutputStreamHandler()) && l11.OutputStreamHandlerConfig.toObject(e11, o11),
            inputStreamInfoList: t11.Message.toObjectList(r11.getInputStreamInfoList(), proto.mediapipe.InputStreamInfo.toObject, e11),
            executor: t11.Message.getFieldWithDefault(r11, 14, ""),
            profilerConfig: (o11 = r11.getProfilerConfig()) && proto.mediapipe.ProfilerConfig.toObject(e11, o11),
            maxInFlight: t11.Message.getFieldWithDefault(r11, 16, 0),
            optionValueList: null == (o11 = t11.Message.getRepeatedField(r11, 17)) ? void 0 : o11,
            externalInputList: null == (o11 = t11.Message.getRepeatedField(r11, 1005)) ? void 0 : o11
        };
        return e11 && (n11.$jspbMessageInstance = r11), n11;
    }), proto.mediapipe.CalculatorGraphConfig.Node.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.CalculatorGraphConfig.Node;
        return proto.mediapipe.CalculatorGraphConfig.Node.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setName(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setCalculator(r11);
                break;
            case 3:
                r11 = t11.readString();
                e11.addInputStream(r11);
                break;
            case 4:
                r11 = t11.readString();
                e11.addOutputStream(r11);
                break;
            case 5:
                r11 = t11.readString();
                e11.addInputSidePacket(r11);
                break;
            case 6:
                r11 = t11.readString();
                e11.addOutputSidePacket(r11);
                break;
            case 7:
                r11 = new i11.CalculatorOptions;
                t11.readMessage(r11, i11.CalculatorOptions.deserializeBinaryFromReader), e11.setOptions(r11);
                break;
            case 8:
                r11 = new a11.Any;
                t11.readMessage(r11, a11.Any.deserializeBinaryFromReader), e11.addNodeOptions(r11);
                break;
            case 9:
                r11 = t11.readInt32();
                e11.setSourceLayer(r11);
                break;
            case 10:
                r11 = t11.readInt32();
                e11.setBufferSizeHint(r11);
                break;
            case 11:
                r11 = new l11.InputStreamHandlerConfig;
                t11.readMessage(r11, l11.InputStreamHandlerConfig.deserializeBinaryFromReader), e11.setInputStreamHandler(r11);
                break;
            case 12:
                r11 = new l11.OutputStreamHandlerConfig;
                t11.readMessage(r11, l11.OutputStreamHandlerConfig.deserializeBinaryFromReader), e11.setOutputStreamHandler(r11);
                break;
            case 13:
                r11 = new proto.mediapipe.InputStreamInfo;
                t11.readMessage(r11, proto.mediapipe.InputStreamInfo.deserializeBinaryFromReader), e11.addInputStreamInfo(r11);
                break;
            case 14:
                r11 = t11.readString();
                e11.setExecutor(r11);
                break;
            case 15:
                r11 = new proto.mediapipe.ProfilerConfig;
                t11.readMessage(r11, proto.mediapipe.ProfilerConfig.deserializeBinaryFromReader), e11.setProfilerConfig(r11);
                break;
            case 16:
                r11 = t11.readInt32();
                e11.setMaxInFlight(r11);
                break;
            case 17:
                r11 = t11.readString();
                e11.addOptionValue(r11);
                break;
            case 1005:
                r11 = t11.readString();
                e11.addExternalInput(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.CalculatorGraphConfig.Node.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.CalculatorGraphConfig.Node.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        (r11 = e11.getName()).length > 0 && t11.writeString(1, r11), (r11 = e11.getCalculator()).length > 0 && t11.writeString(2, r11), (r11 = e11.getInputStreamList()).length > 0 && t11.writeRepeatedString(3, r11), (r11 = e11.getOutputStreamList()).length > 0 && t11.writeRepeatedString(4, r11), (r11 = e11.getInputSidePacketList()).length > 0 && t11.writeRepeatedString(5, r11), (r11 = e11.getOutputSidePacketList()).length > 0 && t11.writeRepeatedString(6, r11), null != (r11 = e11.getOptions()) && t11.writeMessage(7, r11, i11.CalculatorOptions.serializeBinaryToWriter), (r11 = e11.getNodeOptionsList()).length > 0 && t11.writeRepeatedMessage(8, r11, a11.Any.serializeBinaryToWriter), 0 !== (r11 = e11.getSourceLayer()) && t11.writeInt32(9, r11), 0 !== (r11 = e11.getBufferSizeHint()) && t11.writeInt32(10, r11), null != (r11 = e11.getInputStreamHandler()) && t11.writeMessage(11, r11, l11.InputStreamHandlerConfig.serializeBinaryToWriter), null != (r11 = e11.getOutputStreamHandler()) && t11.writeMessage(12, r11, l11.OutputStreamHandlerConfig.serializeBinaryToWriter), (r11 = e11.getInputStreamInfoList()).length > 0 && t11.writeRepeatedMessage(13, r11, proto.mediapipe.InputStreamInfo.serializeBinaryToWriter), (r11 = e11.getExecutor()).length > 0 && t11.writeString(14, r11), null != (r11 = e11.getProfilerConfig()) && t11.writeMessage(15, r11, proto.mediapipe.ProfilerConfig.serializeBinaryToWriter), 0 !== (r11 = e11.getMaxInFlight()) && t11.writeInt32(16, r11), (r11 = e11.getOptionValueList()).length > 0 && t11.writeRepeatedString(17, r11), (r11 = e11.getExternalInputList()).length > 0 && t11.writeRepeatedString(1005, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getName = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setName = function(e11) {
        return t11.Message.setProto3StringField(this, 1, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getCalculator = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setCalculator = function(e11) {
        return t11.Message.setProto3StringField(this, 2, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getInputStreamList = function() {
        return t11.Message.getRepeatedField(this, 3);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setInputStreamList = function(e11) {
        return t11.Message.setField(this, 3, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.addInputStream = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 3, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearInputStreamList = function() {
        return this.setInputStreamList([]);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getOutputStreamList = function() {
        return t11.Message.getRepeatedField(this, 4);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setOutputStreamList = function(e11) {
        return t11.Message.setField(this, 4, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.addOutputStream = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 4, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearOutputStreamList = function() {
        return this.setOutputStreamList([]);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getInputSidePacketList = function() {
        return t11.Message.getRepeatedField(this, 5);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setInputSidePacketList = function(e11) {
        return t11.Message.setField(this, 5, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.addInputSidePacket = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 5, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearInputSidePacketList = function() {
        return this.setInputSidePacketList([]);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getOutputSidePacketList = function() {
        return t11.Message.getRepeatedField(this, 6);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setOutputSidePacketList = function(e11) {
        return t11.Message.setField(this, 6, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.addOutputSidePacket = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 6, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearOutputSidePacketList = function() {
        return this.setOutputSidePacketList([]);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getOptions = function() {
        return t11.Message.getWrapperField(this, i11.CalculatorOptions, 7);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setOptions = function(e11) {
        return t11.Message.setWrapperField(this, 7, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearOptions = function() {
        return this.setOptions(void 0);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.hasOptions = function() {
        return null != t11.Message.getField(this, 7);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getNodeOptionsList = function() {
        return t11.Message.getRepeatedWrapperField(this, a11.Any, 8);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setNodeOptionsList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 8, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.addNodeOptions = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 8, e11, proto.google.protobuf.Any, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearNodeOptionsList = function() {
        return this.setNodeOptionsList([]);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getSourceLayer = function() {
        return t11.Message.getFieldWithDefault(this, 9, 0);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setSourceLayer = function(e11) {
        return t11.Message.setProto3IntField(this, 9, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getBufferSizeHint = function() {
        return t11.Message.getFieldWithDefault(this, 10, 0);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setBufferSizeHint = function(e11) {
        return t11.Message.setProto3IntField(this, 10, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getInputStreamHandler = function() {
        return t11.Message.getWrapperField(this, l11.InputStreamHandlerConfig, 11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setInputStreamHandler = function(e11) {
        return t11.Message.setWrapperField(this, 11, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearInputStreamHandler = function() {
        return this.setInputStreamHandler(void 0);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.hasInputStreamHandler = function() {
        return null != t11.Message.getField(this, 11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getOutputStreamHandler = function() {
        return t11.Message.getWrapperField(this, l11.OutputStreamHandlerConfig, 12);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setOutputStreamHandler = function(e11) {
        return t11.Message.setWrapperField(this, 12, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearOutputStreamHandler = function() {
        return this.setOutputStreamHandler(void 0);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.hasOutputStreamHandler = function() {
        return null != t11.Message.getField(this, 12);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getInputStreamInfoList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.InputStreamInfo, 13);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setInputStreamInfoList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 13, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.addInputStreamInfo = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 13, e11, proto.mediapipe.InputStreamInfo, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearInputStreamInfoList = function() {
        return this.setInputStreamInfoList([]);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getExecutor = function() {
        return t11.Message.getFieldWithDefault(this, 14, "");
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setExecutor = function(e11) {
        return t11.Message.setProto3StringField(this, 14, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getProfilerConfig = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.ProfilerConfig, 15);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setProfilerConfig = function(e11) {
        return t11.Message.setWrapperField(this, 15, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearProfilerConfig = function() {
        return this.setProfilerConfig(void 0);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.hasProfilerConfig = function() {
        return null != t11.Message.getField(this, 15);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getMaxInFlight = function() {
        return t11.Message.getFieldWithDefault(this, 16, 0);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setMaxInFlight = function(e11) {
        return t11.Message.setProto3IntField(this, 16, e11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getOptionValueList = function() {
        return t11.Message.getRepeatedField(this, 17);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setOptionValueList = function(e11) {
        return t11.Message.setField(this, 17, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.addOptionValue = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 17, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearOptionValueList = function() {
        return this.setOptionValueList([]);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.getExternalInputList = function() {
        return t11.Message.getRepeatedField(this, 1005);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.setExternalInputList = function(e11) {
        return t11.Message.setField(this, 1005, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.addExternalInput = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 1005, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.Node.prototype.clearExternalInputList = function() {
        return this.setExternalInputList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getNodeList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.CalculatorGraphConfig.Node, 1);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setNodeList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addNode = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.CalculatorGraphConfig.Node, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearNodeList = function() {
        return this.setNodeList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getPacketFactoryList = function() {
        return t11.Message.getRepeatedWrapperField(this, s11.PacketFactoryConfig, 6);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setPacketFactoryList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 6, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addPacketFactory = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 6, e11, proto.mediapipe.PacketFactoryConfig, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearPacketFactoryList = function() {
        return this.setPacketFactoryList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getPacketGeneratorList = function() {
        return t11.Message.getRepeatedWrapperField(this, p11.PacketGeneratorConfig, 7);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setPacketGeneratorList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 7, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addPacketGenerator = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 7, e11, proto.mediapipe.PacketGeneratorConfig, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearPacketGeneratorList = function() {
        return this.setPacketGeneratorList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getNumThreads = function() {
        return t11.Message.getFieldWithDefault(this, 8, 0);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setNumThreads = function(e11) {
        return t11.Message.setProto3IntField(this, 8, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getStatusHandlerList = function() {
        return t11.Message.getRepeatedWrapperField(this, d11.StatusHandlerConfig, 9);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setStatusHandlerList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 9, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addStatusHandler = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 9, e11, proto.mediapipe.StatusHandlerConfig, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearStatusHandlerList = function() {
        return this.setStatusHandlerList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getInputStreamList = function() {
        return t11.Message.getRepeatedField(this, 10);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setInputStreamList = function(e11) {
        return t11.Message.setField(this, 10, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addInputStream = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 10, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearInputStreamList = function() {
        return this.setInputStreamList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getOutputStreamList = function() {
        return t11.Message.getRepeatedField(this, 15);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setOutputStreamList = function(e11) {
        return t11.Message.setField(this, 15, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addOutputStream = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 15, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearOutputStreamList = function() {
        return this.setOutputStreamList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getInputSidePacketList = function() {
        return t11.Message.getRepeatedField(this, 16);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setInputSidePacketList = function(e11) {
        return t11.Message.setField(this, 16, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addInputSidePacket = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 16, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearInputSidePacketList = function() {
        return this.setInputSidePacketList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getOutputSidePacketList = function() {
        return t11.Message.getRepeatedField(this, 17);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setOutputSidePacketList = function(e11) {
        return t11.Message.setField(this, 17, e11 || []);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addOutputSidePacket = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 17, e11, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearOutputSidePacketList = function() {
        return this.setOutputSidePacketList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getMaxQueueSize = function() {
        return t11.Message.getFieldWithDefault(this, 11, 0);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setMaxQueueSize = function(e11) {
        return t11.Message.setProto3IntField(this, 11, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getReportDeadlock = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 21, !1);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setReportDeadlock = function(e11) {
        return t11.Message.setProto3BooleanField(this, 21, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getInputStreamHandler = function() {
        return t11.Message.getWrapperField(this, l11.InputStreamHandlerConfig, 12);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setInputStreamHandler = function(e11) {
        return t11.Message.setWrapperField(this, 12, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearInputStreamHandler = function() {
        return this.setInputStreamHandler(void 0);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.hasInputStreamHandler = function() {
        return null != t11.Message.getField(this, 12);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getOutputStreamHandler = function() {
        return t11.Message.getWrapperField(this, l11.OutputStreamHandlerConfig, 13);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setOutputStreamHandler = function(e11) {
        return t11.Message.setWrapperField(this, 13, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearOutputStreamHandler = function() {
        return this.setOutputStreamHandler(void 0);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.hasOutputStreamHandler = function() {
        return null != t11.Message.getField(this, 13);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getExecutorList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.ExecutorConfig, 14);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setExecutorList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 14, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addExecutor = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 14, e11, proto.mediapipe.ExecutorConfig, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearExecutorList = function() {
        return this.setExecutorList([]);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getProfilerConfig = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.ProfilerConfig, 18);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setProfilerConfig = function(e11) {
        return t11.Message.setWrapperField(this, 18, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearProfilerConfig = function() {
        return this.setProfilerConfig(void 0);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.hasProfilerConfig = function() {
        return null != t11.Message.getField(this, 18);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getPackage = function() {
        return t11.Message.getFieldWithDefault(this, 19, "");
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setPackage = function(e11) {
        return t11.Message.setProto3StringField(this, 19, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getType = function() {
        return t11.Message.getFieldWithDefault(this, 20, "");
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setType = function(e11) {
        return t11.Message.setProto3StringField(this, 20, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getOptions = function() {
        return t11.Message.getWrapperField(this, n11.MediaPipeOptions, 1001);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1001, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearOptions = function() {
        return this.setOptions(void 0);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.hasOptions = function() {
        return null != t11.Message.getField(this, 1001);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.getGraphOptionsList = function() {
        return t11.Message.getRepeatedWrapperField(this, a11.Any, 1002);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.setGraphOptionsList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1002, e11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.addGraphOptions = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1002, e11, proto.google.protobuf.Any, r11);
    }, proto.mediapipe.CalculatorGraphConfig.prototype.clearGraphOptionsList = function() {
        return this.setGraphOptionsList([]);
    }, r11.object.extend(e11, proto.mediapipe);
}(calculator_pb);
var detection_pb = {}, location_data_pb = {}, rasterization_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.Rasterization", null, o11), r11.exportSymbol("proto.mediapipe.Rasterization.Interval", null, o11), proto.mediapipe.Rasterization = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.Rasterization.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.Rasterization, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.Rasterization.displayName = "proto.mediapipe.Rasterization"), proto.mediapipe.Rasterization.Interval = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.Rasterization.Interval, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.Rasterization.Interval.displayName = "proto.mediapipe.Rasterization.Interval"), proto.mediapipe.Rasterization.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.Rasterization.prototype.toObject = function(e11) {
        return proto.mediapipe.Rasterization.toObject(e11, this);
    }, proto.mediapipe.Rasterization.toObject = function(e11, r11) {
        var o11 = {
            intervalList: t11.Message.toObjectList(r11.getIntervalList(), proto.mediapipe.Rasterization.Interval.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.Rasterization.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.Rasterization;
        return proto.mediapipe.Rasterization.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.Rasterization.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.Rasterization.Interval;
            t11.readMessage(r11, proto.mediapipe.Rasterization.Interval.deserializeBinaryFromReader), e11.addInterval(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.Rasterization.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.Rasterization.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.Rasterization.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getIntervalList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.Rasterization.Interval.serializeBinaryToWriter);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.Rasterization.Interval.prototype.toObject = function(e11) {
        return proto.mediapipe.Rasterization.Interval.toObject(e11, this);
    }, proto.mediapipe.Rasterization.Interval.toObject = function(e11, r11) {
        var o11, i11 = {
            y: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            leftX: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            rightX: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.Rasterization.Interval.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.Rasterization.Interval;
        return proto.mediapipe.Rasterization.Interval.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.Rasterization.Interval.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setY(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setLeftX(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setRightX(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.Rasterization.Interval.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.Rasterization.Interval.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.Rasterization.Interval.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11);
    }, proto.mediapipe.Rasterization.Interval.prototype.getY = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.Rasterization.Interval.prototype.setY = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.Rasterization.Interval.prototype.clearY = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.Rasterization.Interval.prototype.hasY = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.Rasterization.Interval.prototype.getLeftX = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.Rasterization.Interval.prototype.setLeftX = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.Rasterization.Interval.prototype.clearLeftX = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.Rasterization.Interval.prototype.hasLeftX = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.Rasterization.Interval.prototype.getRightX = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.Rasterization.Interval.prototype.setRightX = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.Rasterization.Interval.prototype.clearRightX = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.Rasterization.Interval.prototype.hasRightX = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.Rasterization.prototype.getIntervalList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.Rasterization.Interval, 1);
    }, proto.mediapipe.Rasterization.prototype.setIntervalList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.Rasterization.prototype.addInterval = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.Rasterization.Interval, r11);
    }, proto.mediapipe.Rasterization.prototype.clearIntervalList = function() {
        return this.setIntervalList([]);
    }, r11.object.extend(e11, proto.mediapipe);
}(rasterization_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = rasterization_pb;
    r11.object.extend(proto, i11), r11.exportSymbol("proto.mediapipe.LocationData", null, o11), r11.exportSymbol("proto.mediapipe.LocationData.BinaryMask", null, o11), r11.exportSymbol("proto.mediapipe.LocationData.BoundingBox", null, o11), r11.exportSymbol("proto.mediapipe.LocationData.Format", null, o11), r11.exportSymbol("proto.mediapipe.LocationData.RelativeBoundingBox", null, o11), r11.exportSymbol("proto.mediapipe.LocationData.RelativeKeypoint", null, o11), proto.mediapipe.LocationData = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.LocationData.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.LocationData, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.LocationData.displayName = "proto.mediapipe.LocationData"), proto.mediapipe.LocationData.BoundingBox = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.LocationData.BoundingBox, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.LocationData.BoundingBox.displayName = "proto.mediapipe.LocationData.BoundingBox"), proto.mediapipe.LocationData.RelativeBoundingBox = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.LocationData.RelativeBoundingBox, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.LocationData.RelativeBoundingBox.displayName = "proto.mediapipe.LocationData.RelativeBoundingBox"), proto.mediapipe.LocationData.BinaryMask = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.LocationData.BinaryMask, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.LocationData.BinaryMask.displayName = "proto.mediapipe.LocationData.BinaryMask"), proto.mediapipe.LocationData.RelativeKeypoint = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.LocationData.RelativeKeypoint, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.LocationData.RelativeKeypoint.displayName = "proto.mediapipe.LocationData.RelativeKeypoint"), proto.mediapipe.LocationData.repeatedFields_ = [
        5
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.LocationData.prototype.toObject = function(e11) {
        return proto.mediapipe.LocationData.toObject(e11, this);
    }, proto.mediapipe.LocationData.toObject = function(e11, r11) {
        var o11, i11 = {
            format: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            boundingBox: (o11 = r11.getBoundingBox()) && proto.mediapipe.LocationData.BoundingBox.toObject(e11, o11),
            relativeBoundingBox: (o11 = r11.getRelativeBoundingBox()) && proto.mediapipe.LocationData.RelativeBoundingBox.toObject(e11, o11),
            mask: (o11 = r11.getMask()) && proto.mediapipe.LocationData.BinaryMask.toObject(e11, o11),
            relativeKeypointsList: t11.Message.toObjectList(r11.getRelativeKeypointsList(), proto.mediapipe.LocationData.RelativeKeypoint.toObject, e11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.LocationData.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.LocationData;
        return proto.mediapipe.LocationData.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.LocationData.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readEnum();
                e11.setFormat(r11);
                break;
            case 2:
                r11 = new proto.mediapipe.LocationData.BoundingBox;
                t11.readMessage(r11, proto.mediapipe.LocationData.BoundingBox.deserializeBinaryFromReader), e11.setBoundingBox(r11);
                break;
            case 3:
                r11 = new proto.mediapipe.LocationData.RelativeBoundingBox;
                t11.readMessage(r11, proto.mediapipe.LocationData.RelativeBoundingBox.deserializeBinaryFromReader), e11.setRelativeBoundingBox(r11);
                break;
            case 4:
                r11 = new proto.mediapipe.LocationData.BinaryMask;
                t11.readMessage(r11, proto.mediapipe.LocationData.BinaryMask.deserializeBinaryFromReader), e11.setMask(r11);
                break;
            case 5:
                r11 = new proto.mediapipe.LocationData.RelativeKeypoint;
                t11.readMessage(r11, proto.mediapipe.LocationData.RelativeKeypoint.deserializeBinaryFromReader), e11.addRelativeKeypoints(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.LocationData.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.LocationData.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.LocationData.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeEnum(1, o11), null != (o11 = e11.getBoundingBox()) && r11.writeMessage(2, o11, proto.mediapipe.LocationData.BoundingBox.serializeBinaryToWriter), null != (o11 = e11.getRelativeBoundingBox()) && r11.writeMessage(3, o11, proto.mediapipe.LocationData.RelativeBoundingBox.serializeBinaryToWriter), null != (o11 = e11.getMask()) && r11.writeMessage(4, o11, proto.mediapipe.LocationData.BinaryMask.serializeBinaryToWriter), (o11 = e11.getRelativeKeypointsList()).length > 0 && r11.writeRepeatedMessage(5, o11, proto.mediapipe.LocationData.RelativeKeypoint.serializeBinaryToWriter);
    }, proto.mediapipe.LocationData.Format = {
        GLOBAL: 0,
        BOUNDING_BOX: 1,
        RELATIVE_BOUNDING_BOX: 2,
        MASK: 3
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.LocationData.BoundingBox.prototype.toObject = function(e11) {
        return proto.mediapipe.LocationData.BoundingBox.toObject(e11, this);
    }, proto.mediapipe.LocationData.BoundingBox.toObject = function(e11, r11) {
        var o11, i11 = {
            xmin: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            ymin: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            width: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11,
            height: null == (o11 = t11.Message.getField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.LocationData.BoundingBox.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.LocationData.BoundingBox;
        return proto.mediapipe.LocationData.BoundingBox.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.LocationData.BoundingBox.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setXmin(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setYmin(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setWidth(r11);
                break;
            case 4:
                r11 = t11.readInt32();
                e11.setHeight(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.LocationData.BoundingBox.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.LocationData.BoundingBox.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.LocationData.BoundingBox.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeInt32(4, o11);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.getXmin = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.setXmin = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.clearXmin = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.hasXmin = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.getYmin = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.setYmin = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.clearYmin = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.hasYmin = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.getWidth = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.setWidth = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.clearWidth = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.hasWidth = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.getHeight = function() {
        return t11.Message.getFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.setHeight = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.clearHeight = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.LocationData.BoundingBox.prototype.hasHeight = function() {
        return null != t11.Message.getField(this, 4);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.LocationData.RelativeBoundingBox.prototype.toObject = function(e11) {
        return proto.mediapipe.LocationData.RelativeBoundingBox.toObject(e11, this);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.toObject = function(e11, r11) {
        var o11, i11 = {
            xmin: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            ymin: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            width: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            height: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.LocationData.RelativeBoundingBox.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.LocationData.RelativeBoundingBox;
        return proto.mediapipe.LocationData.RelativeBoundingBox.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readFloat();
                e11.setXmin(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setYmin(r11);
                break;
            case 3:
                r11 = t11.readFloat();
                e11.setWidth(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setHeight(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.LocationData.RelativeBoundingBox.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.LocationData.RelativeBoundingBox.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeFloat(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeFloat(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.getXmin = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.setXmin = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.clearXmin = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.hasXmin = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.getYmin = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.setYmin = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.clearYmin = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.hasYmin = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.getWidth = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.setWidth = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.clearWidth = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.hasWidth = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.getHeight = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.setHeight = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.clearHeight = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.LocationData.RelativeBoundingBox.prototype.hasHeight = function() {
        return null != t11.Message.getField(this, 4);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.LocationData.BinaryMask.prototype.toObject = function(e11) {
        return proto.mediapipe.LocationData.BinaryMask.toObject(e11, this);
    }, proto.mediapipe.LocationData.BinaryMask.toObject = function(e11, r11) {
        var o11, a11 = {
            width: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            height: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            rasterization: (o11 = r11.getRasterization()) && i11.Rasterization.toObject(e11, o11)
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.LocationData.BinaryMask.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.LocationData.BinaryMask;
        return proto.mediapipe.LocationData.BinaryMask.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.LocationData.BinaryMask.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setWidth(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setHeight(r11);
                break;
            case 3:
                r11 = new i11.Rasterization;
                t11.readMessage(r11, i11.Rasterization.deserializeBinaryFromReader), e11.setRasterization(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.LocationData.BinaryMask.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.LocationData.BinaryMask.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.LocationData.BinaryMask.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = e11.getRasterization()) && r11.writeMessage(3, o11, i11.Rasterization.serializeBinaryToWriter);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.getWidth = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.setWidth = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.clearWidth = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.hasWidth = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.getHeight = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.setHeight = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.clearHeight = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.hasHeight = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.getRasterization = function() {
        return t11.Message.getWrapperField(this, i11.Rasterization, 3);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.setRasterization = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.clearRasterization = function() {
        return this.setRasterization(void 0);
    }, proto.mediapipe.LocationData.BinaryMask.prototype.hasRasterization = function() {
        return null != t11.Message.getField(this, 3);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.LocationData.RelativeKeypoint.prototype.toObject = function(e11) {
        return proto.mediapipe.LocationData.RelativeKeypoint.toObject(e11, this);
    }, proto.mediapipe.LocationData.RelativeKeypoint.toObject = function(e11, r11) {
        var o11, i11 = {
            x: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            y: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            keypointLabel: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11,
            score: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.LocationData.RelativeKeypoint.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.LocationData.RelativeKeypoint;
        return proto.mediapipe.LocationData.RelativeKeypoint.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.LocationData.RelativeKeypoint.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readFloat();
                e11.setX(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setY(r11);
                break;
            case 3:
                r11 = t11.readString();
                e11.setKeypointLabel(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setScore(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.LocationData.RelativeKeypoint.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.LocationData.RelativeKeypoint.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeFloat(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeString(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.getX = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.setX = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.clearX = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.hasX = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.getY = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.setY = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.clearY = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.hasY = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.getKeypointLabel = function() {
        return t11.Message.getFieldWithDefault(this, 3, "");
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.setKeypointLabel = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.clearKeypointLabel = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.hasKeypointLabel = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.getScore = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.setScore = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.clearScore = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.LocationData.RelativeKeypoint.prototype.hasScore = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.LocationData.prototype.getFormat = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.LocationData.prototype.setFormat = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.LocationData.prototype.clearFormat = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.LocationData.prototype.hasFormat = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.LocationData.prototype.getBoundingBox = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.LocationData.BoundingBox, 2);
    }, proto.mediapipe.LocationData.prototype.setBoundingBox = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.LocationData.prototype.clearBoundingBox = function() {
        return this.setBoundingBox(void 0);
    }, proto.mediapipe.LocationData.prototype.hasBoundingBox = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.LocationData.prototype.getRelativeBoundingBox = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.LocationData.RelativeBoundingBox, 3);
    }, proto.mediapipe.LocationData.prototype.setRelativeBoundingBox = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.LocationData.prototype.clearRelativeBoundingBox = function() {
        return this.setRelativeBoundingBox(void 0);
    }, proto.mediapipe.LocationData.prototype.hasRelativeBoundingBox = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.LocationData.prototype.getMask = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.LocationData.BinaryMask, 4);
    }, proto.mediapipe.LocationData.prototype.setMask = function(e11) {
        return t11.Message.setWrapperField(this, 4, e11);
    }, proto.mediapipe.LocationData.prototype.clearMask = function() {
        return this.setMask(void 0);
    }, proto.mediapipe.LocationData.prototype.hasMask = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.LocationData.prototype.getRelativeKeypointsList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.LocationData.RelativeKeypoint, 5);
    }, proto.mediapipe.LocationData.prototype.setRelativeKeypointsList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 5, e11);
    }, proto.mediapipe.LocationData.prototype.addRelativeKeypoints = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 5, e11, proto.mediapipe.LocationData.RelativeKeypoint, r11);
    }, proto.mediapipe.LocationData.prototype.clearRelativeKeypointsList = function() {
        return this.setRelativeKeypointsList([]);
    }, r11.object.extend(e11, proto.mediapipe);
}(location_data_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = location_data_pb;
    r11.object.extend(proto, i11), r11.exportSymbol("proto.mediapipe.Detection", null, o11), r11.exportSymbol("proto.mediapipe.Detection.AssociatedDetection", null, o11), r11.exportSymbol("proto.mediapipe.DetectionList", null, o11), proto.mediapipe.Detection = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.Detection.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.Detection, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.Detection.displayName = "proto.mediapipe.Detection"), proto.mediapipe.Detection.AssociatedDetection = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.Detection.AssociatedDetection, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.Detection.AssociatedDetection.displayName = "proto.mediapipe.Detection.AssociatedDetection"), proto.mediapipe.DetectionList = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.DetectionList.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.DetectionList, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.DetectionList.displayName = "proto.mediapipe.DetectionList"), proto.mediapipe.Detection.repeatedFields_ = [
        1,
        2,
        3,
        8,
        9
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.Detection.prototype.toObject = function(e11) {
        return proto.mediapipe.Detection.toObject(e11, this);
    }, proto.mediapipe.Detection.toObject = function(e11, r11) {
        var o11, a11 = {
            labelList: null == (o11 = t11.Message.getRepeatedField(r11, 1)) ? void 0 : o11,
            labelIdList: null == (o11 = t11.Message.getRepeatedField(r11, 2)) ? void 0 : o11,
            scoreList: null == (o11 = t11.Message.getRepeatedFloatingPointField(r11, 3)) ? void 0 : o11,
            locationData: (o11 = r11.getLocationData()) && i11.LocationData.toObject(e11, o11),
            featureTag: null == (o11 = t11.Message.getField(r11, 5)) ? void 0 : o11,
            trackId: null == (o11 = t11.Message.getField(r11, 6)) ? void 0 : o11,
            detectionId: null == (o11 = t11.Message.getField(r11, 7)) ? void 0 : o11,
            associatedDetectionsList: t11.Message.toObjectList(r11.getAssociatedDetectionsList(), proto.mediapipe.Detection.AssociatedDetection.toObject, e11),
            displayNameList: null == (o11 = t11.Message.getRepeatedField(r11, 9)) ? void 0 : o11,
            timestampUsec: null == (o11 = t11.Message.getField(r11, 10)) ? void 0 : o11
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.Detection.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.Detection;
        return proto.mediapipe.Detection.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.Detection.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.addLabel(r11);
                break;
            case 2:
                for(var o11 = t11.isDelimited() ? t11.readPackedInt32() : [
                    t11.readInt32()
                ], a11 = 0; a11 < o11.length; a11++)e11.addLabelId(o11[a11]);
                break;
            case 3:
                for(o11 = t11.isDelimited() ? t11.readPackedFloat() : [
                    t11.readFloat()
                ], a11 = 0; a11 < o11.length; a11++)e11.addScore(o11[a11]);
                break;
            case 4:
                r11 = new i11.LocationData;
                t11.readMessage(r11, i11.LocationData.deserializeBinaryFromReader), e11.setLocationData(r11);
                break;
            case 5:
                r11 = t11.readString();
                e11.setFeatureTag(r11);
                break;
            case 6:
                r11 = t11.readString();
                e11.setTrackId(r11);
                break;
            case 7:
                r11 = t11.readInt64();
                e11.setDetectionId(r11);
                break;
            case 8:
                r11 = new proto.mediapipe.Detection.AssociatedDetection;
                t11.readMessage(r11, proto.mediapipe.Detection.AssociatedDetection.deserializeBinaryFromReader), e11.addAssociatedDetections(r11);
                break;
            case 9:
                r11 = t11.readString();
                e11.addDisplayName(r11);
                break;
            case 10:
                r11 = t11.readInt64();
                e11.setTimestampUsec(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.Detection.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.Detection.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.Detection.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        (o11 = e11.getLabelList()).length > 0 && r11.writeRepeatedString(1, o11), (o11 = e11.getLabelIdList()).length > 0 && r11.writePackedInt32(2, o11), (o11 = e11.getScoreList()).length > 0 && r11.writePackedFloat(3, o11), null != (o11 = e11.getLocationData()) && r11.writeMessage(4, o11, i11.LocationData.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeString(5, o11), null != (o11 = t11.Message.getField(e11, 6)) && r11.writeString(6, o11), null != (o11 = t11.Message.getField(e11, 7)) && r11.writeInt64(7, o11), (o11 = e11.getAssociatedDetectionsList()).length > 0 && r11.writeRepeatedMessage(8, o11, proto.mediapipe.Detection.AssociatedDetection.serializeBinaryToWriter), (o11 = e11.getDisplayNameList()).length > 0 && r11.writeRepeatedString(9, o11), null != (o11 = t11.Message.getField(e11, 10)) && r11.writeInt64(10, o11);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.Detection.AssociatedDetection.prototype.toObject = function(e11) {
        return proto.mediapipe.Detection.AssociatedDetection.toObject(e11, this);
    }, proto.mediapipe.Detection.AssociatedDetection.toObject = function(e11, r11) {
        var o11, i11 = {
            id: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            confidence: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.Detection.AssociatedDetection.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.Detection.AssociatedDetection;
        return proto.mediapipe.Detection.AssociatedDetection.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.Detection.AssociatedDetection.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setId(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setConfidence(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.Detection.AssociatedDetection.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.Detection.AssociatedDetection.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11);
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.getId = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.setId = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.clearId = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.hasId = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.getConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.setConfidence = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.clearConfidence = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.Detection.AssociatedDetection.prototype.hasConfidence = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.Detection.prototype.getLabelList = function() {
        return t11.Message.getRepeatedField(this, 1);
    }, proto.mediapipe.Detection.prototype.setLabelList = function(e11) {
        return t11.Message.setField(this, 1, e11 || []);
    }, proto.mediapipe.Detection.prototype.addLabel = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 1, e11, r11);
    }, proto.mediapipe.Detection.prototype.clearLabelList = function() {
        return this.setLabelList([]);
    }, proto.mediapipe.Detection.prototype.getLabelIdList = function() {
        return t11.Message.getRepeatedField(this, 2);
    }, proto.mediapipe.Detection.prototype.setLabelIdList = function(e11) {
        return t11.Message.setField(this, 2, e11 || []);
    }, proto.mediapipe.Detection.prototype.addLabelId = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 2, e11, r11);
    }, proto.mediapipe.Detection.prototype.clearLabelIdList = function() {
        return this.setLabelIdList([]);
    }, proto.mediapipe.Detection.prototype.getScoreList = function() {
        return t11.Message.getRepeatedFloatingPointField(this, 3);
    }, proto.mediapipe.Detection.prototype.setScoreList = function(e11) {
        return t11.Message.setField(this, 3, e11 || []);
    }, proto.mediapipe.Detection.prototype.addScore = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 3, e11, r11);
    }, proto.mediapipe.Detection.prototype.clearScoreList = function() {
        return this.setScoreList([]);
    }, proto.mediapipe.Detection.prototype.getLocationData = function() {
        return t11.Message.getWrapperField(this, i11.LocationData, 4);
    }, proto.mediapipe.Detection.prototype.setLocationData = function(e11) {
        return t11.Message.setWrapperField(this, 4, e11);
    }, proto.mediapipe.Detection.prototype.clearLocationData = function() {
        return this.setLocationData(void 0);
    }, proto.mediapipe.Detection.prototype.hasLocationData = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.Detection.prototype.getFeatureTag = function() {
        return t11.Message.getFieldWithDefault(this, 5, "");
    }, proto.mediapipe.Detection.prototype.setFeatureTag = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.Detection.prototype.clearFeatureTag = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.Detection.prototype.hasFeatureTag = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.Detection.prototype.getTrackId = function() {
        return t11.Message.getFieldWithDefault(this, 6, "");
    }, proto.mediapipe.Detection.prototype.setTrackId = function(e11) {
        return t11.Message.setField(this, 6, e11);
    }, proto.mediapipe.Detection.prototype.clearTrackId = function() {
        return t11.Message.setField(this, 6, void 0);
    }, proto.mediapipe.Detection.prototype.hasTrackId = function() {
        return null != t11.Message.getField(this, 6);
    }, proto.mediapipe.Detection.prototype.getDetectionId = function() {
        return t11.Message.getFieldWithDefault(this, 7, 0);
    }, proto.mediapipe.Detection.prototype.setDetectionId = function(e11) {
        return t11.Message.setField(this, 7, e11);
    }, proto.mediapipe.Detection.prototype.clearDetectionId = function() {
        return t11.Message.setField(this, 7, void 0);
    }, proto.mediapipe.Detection.prototype.hasDetectionId = function() {
        return null != t11.Message.getField(this, 7);
    }, proto.mediapipe.Detection.prototype.getAssociatedDetectionsList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.Detection.AssociatedDetection, 8);
    }, proto.mediapipe.Detection.prototype.setAssociatedDetectionsList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 8, e11);
    }, proto.mediapipe.Detection.prototype.addAssociatedDetections = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 8, e11, proto.mediapipe.Detection.AssociatedDetection, r11);
    }, proto.mediapipe.Detection.prototype.clearAssociatedDetectionsList = function() {
        return this.setAssociatedDetectionsList([]);
    }, proto.mediapipe.Detection.prototype.getDisplayNameList = function() {
        return t11.Message.getRepeatedField(this, 9);
    }, proto.mediapipe.Detection.prototype.setDisplayNameList = function(e11) {
        return t11.Message.setField(this, 9, e11 || []);
    }, proto.mediapipe.Detection.prototype.addDisplayName = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 9, e11, r11);
    }, proto.mediapipe.Detection.prototype.clearDisplayNameList = function() {
        return this.setDisplayNameList([]);
    }, proto.mediapipe.Detection.prototype.getTimestampUsec = function() {
        return t11.Message.getFieldWithDefault(this, 10, 0);
    }, proto.mediapipe.Detection.prototype.setTimestampUsec = function(e11) {
        return t11.Message.setField(this, 10, e11);
    }, proto.mediapipe.Detection.prototype.clearTimestampUsec = function() {
        return t11.Message.setField(this, 10, void 0);
    }, proto.mediapipe.Detection.prototype.hasTimestampUsec = function() {
        return null != t11.Message.getField(this, 10);
    }, proto.mediapipe.DetectionList.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.DetectionList.prototype.toObject = function(e11) {
        return proto.mediapipe.DetectionList.toObject(e11, this);
    }, proto.mediapipe.DetectionList.toObject = function(e11, r11) {
        var o11 = {
            detectionList: t11.Message.toObjectList(r11.getDetectionList(), proto.mediapipe.Detection.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.DetectionList.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.DetectionList;
        return proto.mediapipe.DetectionList.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.DetectionList.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.Detection;
            t11.readMessage(r11, proto.mediapipe.Detection.deserializeBinaryFromReader), e11.addDetection(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.DetectionList.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.DetectionList.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.DetectionList.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getDetectionList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.Detection.serializeBinaryToWriter);
    }, proto.mediapipe.DetectionList.prototype.getDetectionList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.Detection, 1);
    }, proto.mediapipe.DetectionList.prototype.setDetectionList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.DetectionList.prototype.addDetection = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.Detection, r11);
    }, proto.mediapipe.DetectionList.prototype.clearDetectionList = function() {
        return this.setDetectionList([]);
    }, r11.object.extend(e11, proto.mediapipe);
}(detection_pb);
var base_options_pb = {}, acceleration_pb = {}, inference_calculator_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions", null, o11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions.Delegate", null, o11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions.Delegate.DelegateCase", null, o11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu", null, o11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.Api", null, o11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.InferenceUsage", null, o11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi", null, o11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite", null, o11), r11.exportSymbol("proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack", null, o11), proto.mediapipe.InferenceCalculatorOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.InferenceCalculatorOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InferenceCalculatorOptions.displayName = "proto.mediapipe.InferenceCalculatorOptions"), proto.mediapipe.InferenceCalculatorOptions.Delegate = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, proto.mediapipe.InferenceCalculatorOptions.Delegate.oneofGroups_);
    }, r11.inherits(proto.mediapipe.InferenceCalculatorOptions.Delegate, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InferenceCalculatorOptions.Delegate.displayName = "proto.mediapipe.InferenceCalculatorOptions.Delegate"), proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.displayName = "proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite"), proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.displayName = "proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu"), proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.displayName = "proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi"), proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.displayName = "proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InferenceCalculatorOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.InferenceCalculatorOptions.toObject(e11, this);
    }, proto.mediapipe.InferenceCalculatorOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            modelPath: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            useGpu: t11.Message.getBooleanFieldWithDefault(r11, 2, !1),
            useNnapi: t11.Message.getBooleanFieldWithDefault(r11, 3, !1),
            cpuNumThread: t11.Message.getFieldWithDefault(r11, 4, -1),
            delegate: (o11 = r11.getDelegate()) && proto.mediapipe.InferenceCalculatorOptions.Delegate.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.InferenceCalculatorOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InferenceCalculatorOptions;
        return proto.mediapipe.InferenceCalculatorOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InferenceCalculatorOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setModelPath(r11);
                break;
            case 2:
                r11 = t11.readBool();
                e11.setUseGpu(r11);
                break;
            case 3:
                r11 = t11.readBool();
                e11.setUseNnapi(r11);
                break;
            case 4:
                r11 = t11.readInt32();
                e11.setCpuNumThread(r11);
                break;
            case 5:
                r11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate;
                t11.readMessage(r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.deserializeBinaryFromReader), e11.setDelegate(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InferenceCalculatorOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InferenceCalculatorOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeBool(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeBool(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeInt32(4, o11), null != (o11 = e11.getDelegate()) && r11.writeMessage(5, o11, proto.mediapipe.InferenceCalculatorOptions.Delegate.serializeBinaryToWriter);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.oneofGroups_ = [
        [
            1,
            2,
            3,
            4
        ]
    ], proto.mediapipe.InferenceCalculatorOptions.Delegate.DelegateCase = {
        DELEGATE_NOT_SET: 0,
        TFLITE: 1,
        GPU: 2,
        NNAPI: 3,
        XNNPACK: 4
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.getDelegateCase = function() {
        return t11.Message.computeOneofCase(this, proto.mediapipe.InferenceCalculatorOptions.Delegate.oneofGroups_[0]);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.toObject = function(e11) {
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.toObject(e11, this);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.toObject = function(e11, t11) {
        var r11, o11 = {
            tflite: (r11 = t11.getTflite()) && proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.toObject(e11, r11),
            gpu: (r11 = t11.getGpu()) && proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.toObject(e11, r11),
            nnapi: (r11 = t11.getNnapi()) && proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.toObject(e11, r11),
            xnnpack: (r11 = t11.getXnnpack()) && proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.InferenceCalculatorOptions.Delegate.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite;
                t11.readMessage(r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.deserializeBinaryFromReader), e11.setTflite(r11);
                break;
            case 2:
                r11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu;
                t11.readMessage(r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.deserializeBinaryFromReader), e11.setGpu(r11);
                break;
            case 3:
                r11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi;
                t11.readMessage(r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.deserializeBinaryFromReader), e11.setNnapi(r11);
                break;
            case 4:
                r11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack;
                t11.readMessage(r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.deserializeBinaryFromReader), e11.setXnnpack(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getTflite()) && t11.writeMessage(1, r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.serializeBinaryToWriter), null != (r11 = e11.getGpu()) && t11.writeMessage(2, r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.serializeBinaryToWriter), null != (r11 = e11.getNnapi()) && t11.writeMessage(3, r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.serializeBinaryToWriter), null != (r11 = e11.getXnnpack()) && t11.writeMessage(4, r11, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.serializeBinaryToWriter);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.prototype.toObject = function(e11) {
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.toObject(e11, this);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.toObject = function(e11, t11) {
        var r11 = {};
        return e11 && (r11.$jspbMessageInstance = t11), r11;
    }), proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();){
            t11.getFieldNumber();
            t11.skipField();
        }
        return e11;
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite.serializeBinaryToWriter = function(e11, t11) {}, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.toObject = function(e11) {
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.toObject(e11, this);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.toObject = function(e11, r11) {
        var o11, i11 = {
            useAdvancedGpuApi: t11.Message.getBooleanFieldWithDefault(r11, 1, !1),
            api: t11.Message.getFieldWithDefault(r11, 4, 0),
            allowPrecisionLoss: t11.Message.getBooleanFieldWithDefault(r11, 3, !0),
            cachedKernelPath: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            serializedModelDir: null == (o11 = t11.Message.getField(r11, 7)) ? void 0 : o11,
            modelToken: null == (o11 = t11.Message.getField(r11, 8)) ? void 0 : o11,
            usage: t11.Message.getFieldWithDefault(r11, 5, 2)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readBool();
                e11.setUseAdvancedGpuApi(r11);
                break;
            case 4:
                r11 = t11.readEnum();
                e11.setApi(r11);
                break;
            case 3:
                r11 = t11.readBool();
                e11.setAllowPrecisionLoss(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setCachedKernelPath(r11);
                break;
            case 7:
                r11 = t11.readString();
                e11.setSerializedModelDir(r11);
                break;
            case 8:
                r11 = t11.readString();
                e11.setModelToken(r11);
                break;
            case 5:
                r11 = t11.readEnum();
                e11.setUsage(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeBool(1, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeEnum(4, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeBool(3, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeString(2, o11), null != (o11 = t11.Message.getField(e11, 7)) && r11.writeString(7, o11), null != (o11 = t11.Message.getField(e11, 8)) && r11.writeString(8, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeEnum(5, o11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.Api = {
        ANY: 0,
        OPENGL: 1,
        OPENCL: 2
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.InferenceUsage = {
        UNSPECIFIED: 0,
        FAST_SINGLE_ANSWER: 1,
        SUSTAINED_SPEED: 2
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.getUseAdvancedGpuApi = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 1, !1);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.setUseAdvancedGpuApi = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.clearUseAdvancedGpuApi = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.hasUseAdvancedGpuApi = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.getApi = function() {
        return t11.Message.getFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.setApi = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.clearApi = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.hasApi = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.getAllowPrecisionLoss = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 3, !0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.setAllowPrecisionLoss = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.clearAllowPrecisionLoss = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.hasAllowPrecisionLoss = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.getCachedKernelPath = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.setCachedKernelPath = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.clearCachedKernelPath = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.hasCachedKernelPath = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.getSerializedModelDir = function() {
        return t11.Message.getFieldWithDefault(this, 7, "");
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.setSerializedModelDir = function(e11) {
        return t11.Message.setField(this, 7, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.clearSerializedModelDir = function() {
        return t11.Message.setField(this, 7, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.hasSerializedModelDir = function() {
        return null != t11.Message.getField(this, 7);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.getModelToken = function() {
        return t11.Message.getFieldWithDefault(this, 8, "");
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.setModelToken = function(e11) {
        return t11.Message.setField(this, 8, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.clearModelToken = function() {
        return t11.Message.setField(this, 8, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.hasModelToken = function() {
        return null != t11.Message.getField(this, 8);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.getUsage = function() {
        return t11.Message.getFieldWithDefault(this, 5, 2);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.setUsage = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.clearUsage = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu.prototype.hasUsage = function() {
        return null != t11.Message.getField(this, 5);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.toObject = function(e11) {
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.toObject(e11, this);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.toObject = function(e11, r11) {
        var o11, i11 = {
            cacheDir: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            modelToken: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            acceleratorName: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setCacheDir(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setModelToken(r11);
                break;
            case 3:
                r11 = t11.readString();
                e11.setAcceleratorName(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeString(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeString(3, o11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.getCacheDir = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.setCacheDir = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.clearCacheDir = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.hasCacheDir = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.getModelToken = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.setModelToken = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.clearModelToken = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.hasModelToken = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.getAcceleratorName = function() {
        return t11.Message.getFieldWithDefault(this, 3, "");
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.setAcceleratorName = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.clearAcceleratorName = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi.prototype.hasAcceleratorName = function() {
        return null != t11.Message.getField(this, 3);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.prototype.toObject = function(e11) {
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.toObject(e11, this);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.toObject = function(e11, r11) {
        var o11 = {
            numThreads: t11.Message.getFieldWithDefault(r11, 1, -1)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = t11.readInt32();
            e11.setNumThreads(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.serializeBinaryToWriter = function(e11, r11) {
        var o11;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.prototype.getNumThreads = function() {
        return t11.Message.getFieldWithDefault(this, 1, -1);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.prototype.setNumThreads = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.prototype.clearNumThreads = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack.prototype.hasNumThreads = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.getTflite = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.InferenceCalculatorOptions.Delegate.TfLite, 1);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.setTflite = function(e11) {
        return t11.Message.setOneofWrapperField(this, 1, proto.mediapipe.InferenceCalculatorOptions.Delegate.oneofGroups_[0], e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.clearTflite = function() {
        return this.setTflite(void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.hasTflite = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.getGpu = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.InferenceCalculatorOptions.Delegate.Gpu, 2);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.setGpu = function(e11) {
        return t11.Message.setOneofWrapperField(this, 2, proto.mediapipe.InferenceCalculatorOptions.Delegate.oneofGroups_[0], e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.clearGpu = function() {
        return this.setGpu(void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.hasGpu = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.getNnapi = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.InferenceCalculatorOptions.Delegate.Nnapi, 3);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.setNnapi = function(e11) {
        return t11.Message.setOneofWrapperField(this, 3, proto.mediapipe.InferenceCalculatorOptions.Delegate.oneofGroups_[0], e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.clearNnapi = function() {
        return this.setNnapi(void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.hasNnapi = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.getXnnpack = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.InferenceCalculatorOptions.Delegate.Xnnpack, 4);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.setXnnpack = function(e11) {
        return t11.Message.setOneofWrapperField(this, 4, proto.mediapipe.InferenceCalculatorOptions.Delegate.oneofGroups_[0], e11);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.clearXnnpack = function() {
        return this.setXnnpack(void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.Delegate.prototype.hasXnnpack = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.InferenceCalculatorOptions.ext = new t11.ExtensionFieldInfo(336783863, {
        ext: 0
    }, proto.mediapipe.InferenceCalculatorOptions, proto.mediapipe.InferenceCalculatorOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[336783863] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.InferenceCalculatorOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.InferenceCalculatorOptions.serializeBinaryToWriter, proto.mediapipe.InferenceCalculatorOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[336783863] = proto.mediapipe.InferenceCalculatorOptions.ext, proto.mediapipe.InferenceCalculatorOptions.prototype.getModelPath = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.setModelPath = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.clearModelPath = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.hasModelPath = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.getUseGpu = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 2, !1);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.setUseGpu = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.clearUseGpu = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.hasUseGpu = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.getUseNnapi = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 3, !1);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.setUseNnapi = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.clearUseNnapi = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.hasUseNnapi = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.getCpuNumThread = function() {
        return t11.Message.getFieldWithDefault(this, 4, -1);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.setCpuNumThread = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.clearCpuNumThread = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.hasCpuNumThread = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.getDelegate = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.InferenceCalculatorOptions.Delegate, 5);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.setDelegate = function(e11) {
        return t11.Message.setWrapperField(this, 5, e11);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.clearDelegate = function() {
        return this.setDelegate(void 0);
    }, proto.mediapipe.InferenceCalculatorOptions.prototype.hasDelegate = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.InferenceCalculatorOptions.ext = new t11.ExtensionFieldInfo(336783863, {
        ext: 0
    }, proto.mediapipe.InferenceCalculatorOptions, proto.mediapipe.InferenceCalculatorOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[336783863] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.InferenceCalculatorOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.InferenceCalculatorOptions.serializeBinaryToWriter, proto.mediapipe.InferenceCalculatorOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[336783863] = proto.mediapipe.InferenceCalculatorOptions.ext, r11.object.extend(e11, proto.mediapipe);
}(inference_calculator_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = inference_calculator_pb;
    r11.object.extend(proto, i11), r11.exportSymbol("proto.mediapipe.tasks.core.proto.Acceleration", null, o11), r11.exportSymbol("proto.mediapipe.tasks.core.proto.Acceleration.DelegateCase", null, o11), proto.mediapipe.tasks.core.proto.Acceleration = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, proto.mediapipe.tasks.core.proto.Acceleration.oneofGroups_);
    }, r11.inherits(proto.mediapipe.tasks.core.proto.Acceleration, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.core.proto.Acceleration.displayName = "proto.mediapipe.tasks.core.proto.Acceleration"), proto.mediapipe.tasks.core.proto.Acceleration.oneofGroups_ = [
        [
            1,
            2,
            4,
            5
        ]
    ], proto.mediapipe.tasks.core.proto.Acceleration.DelegateCase = {
        DELEGATE_NOT_SET: 0,
        XNNPACK: 1,
        GPU: 2,
        TFLITE: 4,
        NNAPI: 5
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.getDelegateCase = function() {
        return t11.Message.computeOneofCase(this, proto.mediapipe.tasks.core.proto.Acceleration.oneofGroups_[0]);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.core.proto.Acceleration.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.core.proto.Acceleration.toObject(e11, this);
    }, proto.mediapipe.tasks.core.proto.Acceleration.toObject = function(e11, t11) {
        var r11, o11 = {
            xnnpack: (r11 = t11.getXnnpack()) && i11.InferenceCalculatorOptions.Delegate.Xnnpack.toObject(e11, r11),
            gpu: (r11 = t11.getGpu()) && i11.InferenceCalculatorOptions.Delegate.Gpu.toObject(e11, r11),
            tflite: (r11 = t11.getTflite()) && i11.InferenceCalculatorOptions.Delegate.TfLite.toObject(e11, r11),
            nnapi: (r11 = t11.getNnapi()) && i11.InferenceCalculatorOptions.Delegate.Nnapi.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.core.proto.Acceleration.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.core.proto.Acceleration;
        return proto.mediapipe.tasks.core.proto.Acceleration.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.core.proto.Acceleration.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new i11.InferenceCalculatorOptions.Delegate.Xnnpack;
                t11.readMessage(r11, i11.InferenceCalculatorOptions.Delegate.Xnnpack.deserializeBinaryFromReader), e11.setXnnpack(r11);
                break;
            case 2:
                r11 = new i11.InferenceCalculatorOptions.Delegate.Gpu;
                t11.readMessage(r11, i11.InferenceCalculatorOptions.Delegate.Gpu.deserializeBinaryFromReader), e11.setGpu(r11);
                break;
            case 4:
                r11 = new i11.InferenceCalculatorOptions.Delegate.TfLite;
                t11.readMessage(r11, i11.InferenceCalculatorOptions.Delegate.TfLite.deserializeBinaryFromReader), e11.setTflite(r11);
                break;
            case 5:
                r11 = new i11.InferenceCalculatorOptions.Delegate.Nnapi;
                t11.readMessage(r11, i11.InferenceCalculatorOptions.Delegate.Nnapi.deserializeBinaryFromReader), e11.setNnapi(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.core.proto.Acceleration.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.core.proto.Acceleration.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getXnnpack()) && t11.writeMessage(1, r11, i11.InferenceCalculatorOptions.Delegate.Xnnpack.serializeBinaryToWriter), null != (r11 = e11.getGpu()) && t11.writeMessage(2, r11, i11.InferenceCalculatorOptions.Delegate.Gpu.serializeBinaryToWriter), null != (r11 = e11.getTflite()) && t11.writeMessage(4, r11, i11.InferenceCalculatorOptions.Delegate.TfLite.serializeBinaryToWriter), null != (r11 = e11.getNnapi()) && t11.writeMessage(5, r11, i11.InferenceCalculatorOptions.Delegate.Nnapi.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.getXnnpack = function() {
        return t11.Message.getWrapperField(this, i11.InferenceCalculatorOptions.Delegate.Xnnpack, 1);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.setXnnpack = function(e11) {
        return t11.Message.setOneofWrapperField(this, 1, proto.mediapipe.tasks.core.proto.Acceleration.oneofGroups_[0], e11);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.clearXnnpack = function() {
        return this.setXnnpack(void 0);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.hasXnnpack = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.getGpu = function() {
        return t11.Message.getWrapperField(this, i11.InferenceCalculatorOptions.Delegate.Gpu, 2);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.setGpu = function(e11) {
        return t11.Message.setOneofWrapperField(this, 2, proto.mediapipe.tasks.core.proto.Acceleration.oneofGroups_[0], e11);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.clearGpu = function() {
        return this.setGpu(void 0);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.hasGpu = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.getTflite = function() {
        return t11.Message.getWrapperField(this, i11.InferenceCalculatorOptions.Delegate.TfLite, 4);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.setTflite = function(e11) {
        return t11.Message.setOneofWrapperField(this, 4, proto.mediapipe.tasks.core.proto.Acceleration.oneofGroups_[0], e11);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.clearTflite = function() {
        return this.setTflite(void 0);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.hasTflite = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.getNnapi = function() {
        return t11.Message.getWrapperField(this, i11.InferenceCalculatorOptions.Delegate.Nnapi, 5);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.setNnapi = function(e11) {
        return t11.Message.setOneofWrapperField(this, 5, proto.mediapipe.tasks.core.proto.Acceleration.oneofGroups_[0], e11);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.clearNnapi = function() {
        return this.setNnapi(void 0);
    }, proto.mediapipe.tasks.core.proto.Acceleration.prototype.hasNnapi = function() {
        return null != t11.Message.getField(this, 5);
    }, r11.object.extend(e11, proto.mediapipe.tasks.core.proto);
}(acceleration_pb);
var external_file_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.tasks.core.proto.ExternalFile", null, o11), r11.exportSymbol("proto.mediapipe.tasks.core.proto.FileDescriptorMeta", null, o11), r11.exportSymbol("proto.mediapipe.tasks.core.proto.FilePointerMeta", null, o11), proto.mediapipe.tasks.core.proto.ExternalFile = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.core.proto.ExternalFile, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.core.proto.ExternalFile.displayName = "proto.mediapipe.tasks.core.proto.ExternalFile"), proto.mediapipe.tasks.core.proto.FileDescriptorMeta = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.core.proto.FileDescriptorMeta, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.core.proto.FileDescriptorMeta.displayName = "proto.mediapipe.tasks.core.proto.FileDescriptorMeta"), proto.mediapipe.tasks.core.proto.FilePointerMeta = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.core.proto.FilePointerMeta, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.core.proto.FilePointerMeta.displayName = "proto.mediapipe.tasks.core.proto.FilePointerMeta"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.core.proto.ExternalFile.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.core.proto.ExternalFile.toObject(e11, this);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.toObject = function(e11, r11) {
        var o11, i11 = {
            fileContent: r11.getFileContent_asB64(),
            fileName: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            fileDescriptorMeta: (o11 = r11.getFileDescriptorMeta()) && proto.mediapipe.tasks.core.proto.FileDescriptorMeta.toObject(e11, o11),
            filePointerMeta: (o11 = r11.getFilePointerMeta()) && proto.mediapipe.tasks.core.proto.FilePointerMeta.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.core.proto.ExternalFile.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.core.proto.ExternalFile;
        return proto.mediapipe.tasks.core.proto.ExternalFile.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readBytes();
                e11.setFileContent(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setFileName(r11);
                break;
            case 3:
                r11 = new proto.mediapipe.tasks.core.proto.FileDescriptorMeta;
                t11.readMessage(r11, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.deserializeBinaryFromReader), e11.setFileDescriptorMeta(r11);
                break;
            case 4:
                r11 = new proto.mediapipe.tasks.core.proto.FilePointerMeta;
                t11.readMessage(r11, proto.mediapipe.tasks.core.proto.FilePointerMeta.deserializeBinaryFromReader), e11.setFilePointerMeta(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.core.proto.ExternalFile.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.core.proto.ExternalFile.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeBytes(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeString(2, o11), null != (o11 = e11.getFileDescriptorMeta()) && r11.writeMessage(3, o11, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.serializeBinaryToWriter), null != (o11 = e11.getFilePointerMeta()) && r11.writeMessage(4, o11, proto.mediapipe.tasks.core.proto.FilePointerMeta.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.getFileContent = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.getFileContent_asB64 = function() {
        return t11.Message.bytesAsB64(this.getFileContent());
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.getFileContent_asU8 = function() {
        return t11.Message.bytesAsU8(this.getFileContent());
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.setFileContent = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.clearFileContent = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.hasFileContent = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.getFileName = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.setFileName = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.clearFileName = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.hasFileName = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.getFileDescriptorMeta = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.tasks.core.proto.FileDescriptorMeta, 3);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.setFileDescriptorMeta = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.clearFileDescriptorMeta = function() {
        return this.setFileDescriptorMeta(void 0);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.hasFileDescriptorMeta = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.getFilePointerMeta = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.tasks.core.proto.FilePointerMeta, 4);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.setFilePointerMeta = function(e11) {
        return t11.Message.setWrapperField(this, 4, e11);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.clearFilePointerMeta = function() {
        return this.setFilePointerMeta(void 0);
    }, proto.mediapipe.tasks.core.proto.ExternalFile.prototype.hasFilePointerMeta = function() {
        return null != t11.Message.getField(this, 4);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.core.proto.FileDescriptorMeta.toObject(e11, this);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.toObject = function(e11, r11) {
        var o11, i11 = {
            fd: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            length: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            offset: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.core.proto.FileDescriptorMeta.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.core.proto.FileDescriptorMeta;
        return proto.mediapipe.tasks.core.proto.FileDescriptorMeta.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setFd(r11);
                break;
            case 2:
                r11 = t11.readInt64();
                e11.setLength(r11);
                break;
            case 3:
                r11 = t11.readInt64();
                e11.setOffset(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.core.proto.FileDescriptorMeta.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt64(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt64(3, o11);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.getFd = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.setFd = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.clearFd = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.hasFd = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.getLength = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.setLength = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.clearLength = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.hasLength = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.getOffset = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.setOffset = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.clearOffset = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.tasks.core.proto.FileDescriptorMeta.prototype.hasOffset = function() {
        return null != t11.Message.getField(this, 3);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.core.proto.FilePointerMeta.toObject(e11, this);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.toObject = function(e11, r11) {
        var o11, i11 = {
            pointer: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            length: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.core.proto.FilePointerMeta.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.core.proto.FilePointerMeta;
        return proto.mediapipe.tasks.core.proto.FilePointerMeta.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readUint64();
                e11.setPointer(r11);
                break;
            case 2:
                r11 = t11.readInt64();
                e11.setLength(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.core.proto.FilePointerMeta.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeUint64(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt64(2, o11);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.getPointer = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.setPointer = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.clearPointer = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.hasPointer = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.getLength = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.setLength = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.clearLength = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.core.proto.FilePointerMeta.prototype.hasLength = function() {
        return null != t11.Message.getField(this, 2);
    }, r11.object.extend(e11, proto.mediapipe.tasks.core.proto);
}(external_file_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = acceleration_pb;
    r11.object.extend(proto, i11);
    var a11 = external_file_pb;
    r11.object.extend(proto, a11), r11.exportSymbol("proto.mediapipe.tasks.core.proto.BaseOptions", null, o11), proto.mediapipe.tasks.core.proto.BaseOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.core.proto.BaseOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.core.proto.BaseOptions.displayName = "proto.mediapipe.tasks.core.proto.BaseOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.core.proto.BaseOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.core.proto.BaseOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.toObject = function(e11, r11) {
        var o11, n11 = {
            modelAsset: (o11 = r11.getModelAsset()) && a11.ExternalFile.toObject(e11, o11),
            useStreamMode: t11.Message.getBooleanFieldWithDefault(r11, 2, !1),
            acceleration: (o11 = r11.getAcceleration()) && i11.Acceleration.toObject(e11, o11)
        };
        return e11 && (n11.$jspbMessageInstance = r11), n11;
    }), proto.mediapipe.tasks.core.proto.BaseOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.core.proto.BaseOptions;
        return proto.mediapipe.tasks.core.proto.BaseOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new a11.ExternalFile;
                t11.readMessage(r11, a11.ExternalFile.deserializeBinaryFromReader), e11.setModelAsset(r11);
                break;
            case 2:
                r11 = t11.readBool();
                e11.setUseStreamMode(r11);
                break;
            case 3:
                r11 = new i11.Acceleration;
                t11.readMessage(r11, i11.Acceleration.deserializeBinaryFromReader), e11.setAcceleration(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.core.proto.BaseOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.core.proto.BaseOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getModelAsset()) && r11.writeMessage(1, o11, a11.ExternalFile.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeBool(2, o11), null != (o11 = e11.getAcceleration()) && r11.writeMessage(3, o11, i11.Acceleration.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.getModelAsset = function() {
        return t11.Message.getWrapperField(this, a11.ExternalFile, 1);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.setModelAsset = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.clearModelAsset = function() {
        return this.setModelAsset(void 0);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.hasModelAsset = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.getUseStreamMode = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 2, !1);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.setUseStreamMode = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.clearUseStreamMode = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.hasUseStreamMode = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.getAcceleration = function() {
        return t11.Message.getWrapperField(this, i11.Acceleration, 3);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.setAcceleration = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.clearAcceleration = function() {
        return this.setAcceleration(void 0);
    }, proto.mediapipe.tasks.core.proto.BaseOptions.prototype.hasAcceleration = function() {
        return null != t11.Message.getField(this, 3);
    }, r11.object.extend(e11, proto.mediapipe.tasks.core.proto);
}(base_options_pb);
var face_detector_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions", null, o11), proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.displayName = "proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            minDetectionConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 2, .5),
            minSuppressionThreshold: t11.Message.getFloatingPointFieldWithDefault(r11, 3, .5),
            numFaces: null == (o11 = t11.Message.getField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions;
        return proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setMinDetectionConfidence(r11);
                break;
            case 3:
                r11 = t11.readFloat();
                e11.setMinSuppressionThreshold(r11);
                break;
            case 4:
                r11 = t11.readInt32();
                e11.setNumFaces(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeFloat(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeInt32(4, o11);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(502141897, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[502141897] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[502141897] = proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.ext, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.getMinDetectionConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, .5);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.setMinDetectionConfidence = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.clearMinDetectionConfidence = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.hasMinDetectionConfidence = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.getMinSuppressionThreshold = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, .5);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.setMinSuppressionThreshold = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.clearMinSuppressionThreshold = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.hasMinSuppressionThreshold = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.getNumFaces = function() {
        return t11.Message.getFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.setNumFaces = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.clearNumFaces = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.prototype.hasNumFaces = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(502141897, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[502141897] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[502141897] = proto.mediapipe.tasks.vision.face_detector.proto.FaceDetectorGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_detector.proto);
}(face_detector_graph_options_pb);
var detection_result = {};
Object.defineProperty(detection_result, "__esModule", {
    value: !0
}), detection_result.convertFromDetectionProto = void 0;
const DEFAULT_CATEGORY_INDEX = -1;
function convertFromDetectionProto(e11) {
    var t11, r11, o11, i11, a11, n11, s11, p11, d11, l11, g11, c11, u11;
    const m11 = e11.getScoreList(), f11 = e11.getLabelIdList(), h11 = e11.getLabelList(), y11 = e11.getDisplayNameList(), b11 = {
        categories: []
    };
    for(let e11 = 0; e11 < m11.length; e11++)b11.categories.push({
        score: m11[e11],
        index: null !== (t11 = f11[e11]) && void 0 !== t11 ? t11 : DEFAULT_CATEGORY_INDEX,
        categoryName: null !== (r11 = h11[e11]) && void 0 !== r11 ? r11 : "",
        displayName: null !== (o11 = y11[e11]) && void 0 !== o11 ? o11 : ""
    });
    const _11 = null === (i11 = e11.getLocationData()) || void 0 === i11 ? void 0 : i11.getBoundingBox();
    if (_11 && (b11.boundingBox = {
        originX: null !== (a11 = _11.getXmin()) && void 0 !== a11 ? a11 : 0,
        originY: null !== (n11 = _11.getYmin()) && void 0 !== n11 ? n11 : 0,
        width: null !== (s11 = _11.getWidth()) && void 0 !== s11 ? s11 : 0,
        height: null !== (p11 = _11.getHeight()) && void 0 !== p11 ? p11 : 0
    }), null === (d11 = e11.getLocationData()) || void 0 === d11 ? void 0 : d11.getRelativeKeypointsList().length) {
        b11.keypoints = [];
        for (const t11 of e11.getLocationData().getRelativeKeypointsList())b11.keypoints.push({
            x: null !== (l11 = t11.getX()) && void 0 !== l11 ? l11 : 0,
            y: null !== (g11 = t11.getY()) && void 0 !== g11 ? g11 : 0,
            score: null !== (c11 = t11.getScore()) && void 0 !== c11 ? c11 : 0,
            label: null !== (u11 = t11.getKeypointLabel()) && void 0 !== u11 ? u11 : ""
        });
    }
    return b11;
}
detection_result.convertFromDetectionProto = convertFromDetectionProto;
var vision_task_runner = {}, rect_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.NormalizedRect", null, o11), r11.exportSymbol("proto.mediapipe.Rect", null, o11), proto.mediapipe.Rect = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.Rect, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.Rect.displayName = "proto.mediapipe.Rect"), proto.mediapipe.NormalizedRect = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.NormalizedRect, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.NormalizedRect.displayName = "proto.mediapipe.NormalizedRect"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.Rect.prototype.toObject = function(e11) {
        return proto.mediapipe.Rect.toObject(e11, this);
    }, proto.mediapipe.Rect.toObject = function(e11, r11) {
        var o11, i11 = {
            xCenter: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            yCenter: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            height: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11,
            width: null == (o11 = t11.Message.getField(r11, 4)) ? void 0 : o11,
            rotation: t11.Message.getFloatingPointFieldWithDefault(r11, 5, 0),
            rectId: null == (o11 = t11.Message.getField(r11, 6)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.Rect.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.Rect;
        return proto.mediapipe.Rect.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.Rect.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setXCenter(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setYCenter(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setHeight(r11);
                break;
            case 4:
                r11 = t11.readInt32();
                e11.setWidth(r11);
                break;
            case 5:
                r11 = t11.readFloat();
                e11.setRotation(r11);
                break;
            case 6:
                r11 = t11.readInt64();
                e11.setRectId(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.Rect.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.Rect.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.Rect.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeInt32(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeFloat(5, o11), null != (o11 = t11.Message.getField(e11, 6)) && r11.writeInt64(6, o11);
    }, proto.mediapipe.Rect.prototype.getXCenter = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.Rect.prototype.setXCenter = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.Rect.prototype.clearXCenter = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.Rect.prototype.hasXCenter = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.Rect.prototype.getYCenter = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.Rect.prototype.setYCenter = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.Rect.prototype.clearYCenter = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.Rect.prototype.hasYCenter = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.Rect.prototype.getHeight = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.Rect.prototype.setHeight = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.Rect.prototype.clearHeight = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.Rect.prototype.hasHeight = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.Rect.prototype.getWidth = function() {
        return t11.Message.getFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.Rect.prototype.setWidth = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.Rect.prototype.clearWidth = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.Rect.prototype.hasWidth = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.Rect.prototype.getRotation = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 5, 0);
    }, proto.mediapipe.Rect.prototype.setRotation = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.Rect.prototype.clearRotation = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.Rect.prototype.hasRotation = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.Rect.prototype.getRectId = function() {
        return t11.Message.getFieldWithDefault(this, 6, 0);
    }, proto.mediapipe.Rect.prototype.setRectId = function(e11) {
        return t11.Message.setField(this, 6, e11);
    }, proto.mediapipe.Rect.prototype.clearRectId = function() {
        return t11.Message.setField(this, 6, void 0);
    }, proto.mediapipe.Rect.prototype.hasRectId = function() {
        return null != t11.Message.getField(this, 6);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.NormalizedRect.prototype.toObject = function(e11) {
        return proto.mediapipe.NormalizedRect.toObject(e11, this);
    }, proto.mediapipe.NormalizedRect.toObject = function(e11, r11) {
        var o11, i11 = {
            xCenter: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            yCenter: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            height: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            width: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11,
            rotation: t11.Message.getFloatingPointFieldWithDefault(r11, 5, 0),
            rectId: null == (o11 = t11.Message.getField(r11, 6)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.NormalizedRect.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.NormalizedRect;
        return proto.mediapipe.NormalizedRect.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.NormalizedRect.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readFloat();
                e11.setXCenter(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setYCenter(r11);
                break;
            case 3:
                r11 = t11.readFloat();
                e11.setHeight(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setWidth(r11);
                break;
            case 5:
                r11 = t11.readFloat();
                e11.setRotation(r11);
                break;
            case 6:
                r11 = t11.readInt64();
                e11.setRectId(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.NormalizedRect.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.NormalizedRect.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.NormalizedRect.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeFloat(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeFloat(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeFloat(5, o11), null != (o11 = t11.Message.getField(e11, 6)) && r11.writeInt64(6, o11);
    }, proto.mediapipe.NormalizedRect.prototype.getXCenter = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.NormalizedRect.prototype.setXCenter = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.NormalizedRect.prototype.clearXCenter = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.NormalizedRect.prototype.hasXCenter = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.NormalizedRect.prototype.getYCenter = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.NormalizedRect.prototype.setYCenter = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.NormalizedRect.prototype.clearYCenter = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.NormalizedRect.prototype.hasYCenter = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.NormalizedRect.prototype.getHeight = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.NormalizedRect.prototype.setHeight = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.NormalizedRect.prototype.clearHeight = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.NormalizedRect.prototype.hasHeight = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.NormalizedRect.prototype.getWidth = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.NormalizedRect.prototype.setWidth = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.NormalizedRect.prototype.clearWidth = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.NormalizedRect.prototype.hasWidth = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.NormalizedRect.prototype.getRotation = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 5, 0);
    }, proto.mediapipe.NormalizedRect.prototype.setRotation = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.NormalizedRect.prototype.clearRotation = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.NormalizedRect.prototype.hasRotation = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.NormalizedRect.prototype.getRectId = function() {
        return t11.Message.getFieldWithDefault(this, 6, 0);
    }, proto.mediapipe.NormalizedRect.prototype.setRectId = function(e11) {
        return t11.Message.setField(this, 6, e11);
    }, proto.mediapipe.NormalizedRect.prototype.clearRectId = function() {
        return t11.Message.setField(this, 6, void 0);
    }, proto.mediapipe.NormalizedRect.prototype.hasRectId = function() {
        return null != t11.Message.getField(this, 6);
    }, r11.object.extend(e11, proto.mediapipe);
}(rect_pb);
var task_runner = {}, graph_runner = {}, platform_utils = {};
function isWebKit(e11 = navigator) {
    const t11 = e11.userAgent;
    return t11.includes("Safari") && !t11.includes("Chrome");
}
Object.defineProperty(platform_utils, "__esModule", {
    value: !0
}), platform_utils.isWebKit = void 0, platform_utils.isWebKit = isWebKit, function(e11) {
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.createGraphRunner = e11.createMediaPipeLib = e11.GraphRunner = e11.CALCULATOR_GRAPH_CONFIG_LISTENER_NAME = void 0;
    const t11 = platform_utils;
    e11.CALCULATOR_GRAPH_CONFIG_LISTENER_NAME = "__graph_config__";
    class r11 {
        constructor(e11, r11){
            this.autoResizeCanvas = !0, this.wasmModule = e11, this.audioPtr = null, this.audioSize = 0, this.hasMultiStreamSupport = "function" == typeof this.wasmModule._addIntToInputStream, void 0 !== r11 ? this.wasmModule.canvas = r11 : "undefined" == typeof OffscreenCanvas || (0, t11.isWebKit)() ? (console.warn("OffscreenCanvas not supported and GraphRunner constructor glCanvas parameter is undefined. Creating backup canvas."), this.wasmModule.canvas = document.createElement("canvas")) : this.wasmModule.canvas = new OffscreenCanvas(1, 1);
        }
        async initializeGraph(e11) {
            const t11 = await fetch(e11), r11 = await t11.arrayBuffer(), o11 = !(e11.endsWith(".pbtxt") || e11.endsWith(".textproto"));
            this.setGraph(new Uint8Array(r11), o11);
        }
        setGraphFromString(e11) {
            this.setGraph((new TextEncoder).encode(e11), !1);
        }
        setGraph(e11, t11) {
            const r11 = e11.length, o11 = this.wasmModule._malloc(r11);
            this.wasmModule.HEAPU8.set(e11, o11), t11 ? this.wasmModule._changeBinaryGraph(r11, o11) : this.wasmModule._changeTextGraph(r11, o11), this.wasmModule._free(o11);
        }
        configureAudio(e11, t11, r11, o11, i11) {
            this.wasmModule._configureAudio || console.warn('Attempting to use configureAudio without support for input audio. Is build dep ":gl_graph_runner_audio" missing?'), o11 = o11 || "input_audio", this.wrapStringPtr(o11, (o11)=>{
                i11 = i11 || "audio_header", this.wrapStringPtr(i11, (i11)=>{
                    this.wasmModule._configureAudio(o11, i11, e11, t11, r11);
                });
            });
        }
        setAutoResizeCanvas(e11) {
            this.autoResizeCanvas = e11;
        }
        setAutoRenderToScreen(e11) {
            this.wasmModule._setAutoRenderToScreen(e11);
        }
        bindTextureToStream(e11, t11) {
            if (!this.wasmModule.canvas) throw new Error("No OpenGL canvas configured.");
            t11 ? this.wasmModule._bindTextureToStream(t11) : console.assert(this.wasmModule._bindTextureToCanvas());
            const r11 = this.wasmModule.canvas.getContext("webgl2") || this.wasmModule.canvas.getContext("webgl");
            if (!r11) throw new Error("Failed to obtain WebGL context from the provided canvas. `getContext()` should only be invoked with `webgl` or `webgl2`.");
            let o11, i11;
            return r11.texImage2D(r11.TEXTURE_2D, 0, r11.RGBA, r11.RGBA, r11.UNSIGNED_BYTE, e11), e11.videoWidth ? (o11 = e11.videoWidth, i11 = e11.videoHeight) : e11.naturalWidth ? (o11 = e11.naturalWidth, i11 = e11.naturalHeight) : (o11 = e11.width, i11 = e11.height), !this.autoResizeCanvas || o11 === this.wasmModule.canvas.width && i11 === this.wasmModule.canvas.height || (this.wasmModule.canvas.width = o11, this.wasmModule.canvas.height = i11), [
                o11,
                i11
            ];
        }
        processGl(e11, t11) {
            const [r11, o11] = this.bindTextureToStream(e11), i11 = this.wasmModule._malloc(16);
            this.wasmModule.HEAPU32[i11 / 4] = r11, this.wasmModule.HEAPU32[i11 / 4 + 1] = o11, this.wasmModule.HEAPF64[i11 / 8 + 1] = t11, this.wasmModule._processGl(i11), this.wasmModule._free(i11);
        }
        wrapStringPtr(e11, t11) {
            this.hasMultiStreamSupport || console.error("No wasm multistream support detected: ensure dependency inclusion of :gl_graph_runner_internal_multi_input target");
            const r11 = this.wasmModule.stringToNewUTF8(e11);
            t11(r11), this.wasmModule._free(r11);
        }
        wrapStringPtrPtr(e11, t11) {
            this.hasMultiStreamSupport || console.error("No wasm multistream support detected: ensure dependency inclusion of :gl_graph_runner_internal_multi_input target");
            const r11 = new Uint32Array(e11.length);
            for(let t11 = 0; t11 < e11.length; t11++)r11[t11] = this.wasmModule.stringToNewUTF8(e11[t11]);
            const o11 = this.wasmModule._malloc(4 * r11.length);
            this.wasmModule.HEAPU32.set(r11, o11 >> 2), t11(o11);
            for (const e11 of r11)this.wasmModule._free(e11);
            this.wasmModule._free(o11);
        }
        getCalculatorGraphConfig(t11, r11) {
            const o11 = e11.CALCULATOR_GRAPH_CONFIG_LISTENER_NAME;
            this.setListener(o11, (e11)=>{
                t11(e11);
            }), this.wrapStringPtr(o11, (e11)=>{
                this.wasmModule._getGraphConfig(e11, r11);
            }), delete this.wasmModule.simpleListeners[o11];
        }
        setListener(e11, t11) {
            this.wasmModule.simpleListeners = this.wasmModule.simpleListeners || {}, this.wasmModule.simpleListeners[e11] = t11;
        }
        setVectorListener(e11, t11) {
            let r11 = [];
            this.wasmModule.simpleListeners = this.wasmModule.simpleListeners || {}, this.wasmModule.simpleListeners[e11] = (e11, o11, i11)=>{
                o11 ? (t11(r11, i11), r11 = []) : r11.push(e11);
            };
        }
        attachErrorListener(e11) {
            this.wasmModule.errorListener = e11;
        }
        attachEmptyPacketListener(e11, t11) {
            this.wasmModule.emptyPacketListeners = this.wasmModule.emptyPacketListeners || {}, this.wasmModule.emptyPacketListeners[e11] = t11;
        }
        addAudioToStream(e11, t11, r11) {
            this.addAudioToStreamWithShape(e11, 0, 0, t11, r11);
        }
        addAudioToStreamWithShape(e11, t11, r11, o11, i11) {
            const a11 = 4 * e11.length;
            this.audioSize !== a11 && (this.audioPtr && this.wasmModule._free(this.audioPtr), this.audioPtr = this.wasmModule._malloc(a11), this.audioSize = a11), this.wasmModule.HEAPF32.set(e11, this.audioPtr / 4), this.wrapStringPtr(o11, (e11)=>{
                this.wasmModule._addAudioToInputStream(this.audioPtr, t11, r11, e11, i11);
            });
        }
        addGpuBufferToStream(e11, t11, r11) {
            this.wrapStringPtr(t11, (t11)=>{
                const [o11, i11] = this.bindTextureToStream(e11, t11);
                this.wasmModule._addBoundTextureToStream(t11, o11, i11, r11);
            });
        }
        addBoolToStream(e11, t11, r11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wasmModule._addBoolToInputStream(e11, t11, r11);
            });
        }
        addDoubleToStream(e11, t11, r11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wasmModule._addDoubleToInputStream(e11, t11, r11);
            });
        }
        addFloatToStream(e11, t11, r11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wasmModule._addFloatToInputStream(e11, t11, r11);
            });
        }
        addIntToStream(e11, t11, r11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wasmModule._addIntToInputStream(e11, t11, r11);
            });
        }
        addStringToStream(e11, t11, r11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wrapStringPtr(e11, (e11)=>{
                    this.wasmModule._addStringToInputStream(e11, t11, r11);
                });
            });
        }
        addStringRecordToStream(e11, t11, r11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wrapStringPtrPtr(Object.keys(e11), (o11)=>{
                    this.wrapStringPtrPtr(Object.values(e11), (i11)=>{
                        this.wasmModule._addFlatHashMapToInputStream(o11, i11, Object.keys(e11).length, t11, r11);
                    });
                });
            });
        }
        addProtoToStream(e11, t11, r11, o11) {
            this.wrapStringPtr(r11, (r11)=>{
                this.wrapStringPtr(t11, (t11)=>{
                    const i11 = this.wasmModule._malloc(e11.length);
                    this.wasmModule.HEAPU8.set(e11, i11), this.wasmModule._addProtoToInputStream(i11, e11.length, t11, r11, o11), this.wasmModule._free(i11);
                });
            });
        }
        addEmptyPacketToStream(e11, t11) {
            this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._addEmptyPacketToInputStream(e11, t11);
            });
        }
        addBoolToInputSidePacket(e11, t11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wasmModule._addBoolToInputSidePacket(e11, t11);
            });
        }
        addDoubleToInputSidePacket(e11, t11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wasmModule._addDoubleToInputSidePacket(e11, t11);
            });
        }
        addFloatToInputSidePacket(e11, t11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wasmModule._addFloatToInputSidePacket(e11, t11);
            });
        }
        addIntToInputSidePacket(e11, t11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wasmModule._addIntToInputSidePacket(e11, t11);
            });
        }
        addStringToInputSidePacket(e11, t11) {
            this.wrapStringPtr(t11, (t11)=>{
                this.wrapStringPtr(e11, (e11)=>{
                    this.wasmModule._addStringToInputSidePacket(e11, t11);
                });
            });
        }
        addProtoToInputSidePacket(e11, t11, r11) {
            this.wrapStringPtr(r11, (r11)=>{
                this.wrapStringPtr(t11, (t11)=>{
                    const o11 = this.wasmModule._malloc(e11.length);
                    this.wasmModule.HEAPU8.set(e11, o11), this.wasmModule._addProtoToInputSidePacket(o11, e11.length, t11, r11), this.wasmModule._free(o11);
                });
            });
        }
        attachBoolListener(e11, t11) {
            this.setListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachBoolListener(e11);
            });
        }
        attachBoolVectorListener(e11, t11) {
            this.setVectorListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachBoolVectorListener(e11);
            });
        }
        attachIntListener(e11, t11) {
            this.setListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachIntListener(e11);
            });
        }
        attachIntVectorListener(e11, t11) {
            this.setVectorListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachIntVectorListener(e11);
            });
        }
        attachDoubleListener(e11, t11) {
            this.setListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachDoubleListener(e11);
            });
        }
        attachDoubleVectorListener(e11, t11) {
            this.setVectorListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachDoubleVectorListener(e11);
            });
        }
        attachFloatListener(e11, t11) {
            this.setListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachFloatListener(e11);
            });
        }
        attachFloatVectorListener(e11, t11) {
            this.setVectorListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachFloatVectorListener(e11);
            });
        }
        attachStringListener(e11, t11) {
            this.setListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachStringListener(e11);
            });
        }
        attachStringVectorListener(e11, t11) {
            this.setVectorListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachStringVectorListener(e11);
            });
        }
        attachProtoListener(e11, t11, r11) {
            this.setListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachProtoListener(e11, r11 || !1);
            });
        }
        attachProtoVectorListener(e11, t11, r11) {
            this.setVectorListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachProtoVectorListener(e11, r11 || !1);
            });
        }
        attachAudioListener(e11, t11, r11) {
            this.wasmModule._attachAudioListener || console.warn('Attempting to use attachAudioListener without support for output audio. Is build dep ":gl_graph_runner_audio_out" missing?'), this.setListener(e11, (e11, r11)=>{
                const o11 = new Float32Array(e11.buffer, e11.byteOffset, e11.length / 4);
                t11(o11, r11);
            }), this.wrapStringPtr(e11, (e11)=>{
                this.wasmModule._attachAudioListener(e11, r11 || !1);
            });
        }
        finishProcessing() {
            this.wasmModule._waitUntilIdle();
        }
        closeGraph() {
            this.wasmModule._closeGraph(), this.wasmModule.simpleListeners = void 0, this.wasmModule.emptyPacketListeners = void 0;
        }
    }
    async function o11(e11) {
        if ("function" != typeof importScripts) {
            const t11 = document.createElement("script");
            return t11.setAttribute("src", e11), t11.setAttribute("crossorigin", "anonymous"), new Promise((e11)=>{
                t11.addEventListener("load", ()=>{
                    e11();
                }, !1), t11.addEventListener("error", ()=>{
                    e11();
                }, !1), document.body.appendChild(t11);
            });
        }
        importScripts(e11.toString());
    }
    async function i11(e11, t11, r11, i11, a11) {
        const n11 = [];
        if (t11 && n11.push(t11), r11 && n11.push(r11), n11.length && await Promise.all(n11.map(o11)), !self.ModuleFactory) throw new Error("ModuleFactory not set.");
        if (self.Module && a11) {
            const e11 = self.Module;
            e11.locateFile = a11.locateFile, a11.mainScriptUrlOrBlob && (e11.mainScriptUrlOrBlob = a11.mainScriptUrlOrBlob);
        }
        const s11 = await self.ModuleFactory(self.Module || a11);
        return self.ModuleFactory = self.Module = void 0, new e11(s11, i11);
    }
    e11.GraphRunner = r11, e11.createMediaPipeLib = i11, e11.createGraphRunner = async function(e11, t11, o11, a11) {
        return i11(r11, e11, t11, o11, a11);
    };
}(graph_runner);
var register_model_resources_graph_service = {};
function SupportModelResourcesGraphService(e11) {
    return class extends e11 {
        registerModelResourcesGraphService() {
            this.wasmModule._registerModelResourcesGraphService();
        }
    };
}
Object.defineProperty(register_model_resources_graph_service, "__esModule", {
    value: !0
}), register_model_resources_graph_service.SupportModelResourcesGraphService = void 0, register_model_resources_graph_service.SupportModelResourcesGraphService = SupportModelResourcesGraphService, Object.defineProperty(task_runner, "__esModule", {
    value: !0
}), task_runner.TaskRunner = task_runner.createTaskRunner = task_runner.CachedGraphRunner = void 0;
const inference_calculator_pb_1 = inference_calculator_pb, calculator_pb_1 = calculator_pb, acceleration_pb_1 = acceleration_pb, external_file_pb_1 = external_file_pb, graph_runner_1$1 = graph_runner, register_model_resources_graph_service_1$1 = register_model_resources_graph_service, NO_ASSETS = void 0, FREE_MEMORY_STREAM = "free_memory", UNUSED_STREAM_SUFFIX = "_unused_out", CachedGraphRunnerType = (0, register_model_resources_graph_service_1$1.SupportModelResourcesGraphService)(graph_runner_1$1.GraphRunner);
class CachedGraphRunner extends CachedGraphRunnerType {
}
async function createTaskRunner(e11, t11, r11, o11) {
    const i11 = {
        locateFile: ()=>r11.wasmBinaryPath.toString()
    }, a11 = await (0, graph_runner_1$1.createMediaPipeLib)(e11, r11.wasmLoaderPath, NO_ASSETS, t11, i11);
    return await a11.setOptions(o11), a11;
}
task_runner.CachedGraphRunner = CachedGraphRunner, task_runner.createTaskRunner = createTaskRunner;
class TaskRunner {
    static async createInstance(e11, t11, r11, o11) {
        return createTaskRunner(e11, t11, r11, o11);
    }
    constructor(e11){
        this.graphRunner = e11, this.processingErrors = [], this.latestOutputTimestamp = 0, this.graphRunner.setAutoRenderToScreen(!1);
    }
    applyOptions(e11) {
        var t11, r11, o11, i11, a11;
        const n11 = e11.baseOptions || {};
        if ((null === (t11 = e11.baseOptions) || void 0 === t11 ? void 0 : t11.modelAssetBuffer) && (null === (r11 = e11.baseOptions) || void 0 === r11 ? void 0 : r11.modelAssetPath)) throw new Error("Cannot set both baseOptions.modelAssetPath and baseOptions.modelAssetBuffer");
        if (!((null === (o11 = this.baseOptions.getModelAsset()) || void 0 === o11 ? void 0 : o11.hasFileContent()) || (null === (i11 = e11.baseOptions) || void 0 === i11 ? void 0 : i11.modelAssetBuffer) || (null === (a11 = e11.baseOptions) || void 0 === a11 ? void 0 : a11.modelAssetPath))) throw new Error("Either baseOptions.modelAssetPath or baseOptions.modelAssetBuffer must be set");
        return this.setAcceleration(n11), n11.modelAssetPath ? fetch(n11.modelAssetPath.toString()).then((e11)=>{
            if (e11.ok) return e11.arrayBuffer();
            throw new Error(`Failed to fetch model: ${n11.modelAssetPath} (${e11.status})`);
        }).then((e11)=>{
            this.setExternalFile(new Uint8Array(e11)), this.refreshGraph(), this.onGraphRefreshed();
        }) : (this.setExternalFile(n11.modelAssetBuffer), this.refreshGraph(), this.onGraphRefreshed(), Promise.resolve());
    }
    onGraphRefreshed() {}
    getCalculatorGraphConfig() {
        let e11;
        if (this.graphRunner.getCalculatorGraphConfig((t11)=>{
            e11 = calculator_pb_1.CalculatorGraphConfig.deserializeBinary(t11);
        }), !e11) throw new Error("Failed to retrieve CalculatorGraphConfig");
        return e11;
    }
    setGraph(e11, t11) {
        this.graphRunner.attachErrorListener((e11, t11)=>{
            this.processingErrors.push(new Error(t11));
        }), this.graphRunner.registerModelResourcesGraphService(), this.graphRunner.setGraph(e11, t11), this.keepaliveNode = void 0, this.handleErrors();
    }
    finishProcessing() {
        this.graphRunner.finishProcessing(), this.handleErrors();
    }
    setLatestOutputTimestamp(e11) {
        this.latestOutputTimestamp = Math.max(this.latestOutputTimestamp, e11);
    }
    getSynctheticTimestamp() {
        return this.latestOutputTimestamp + 1;
    }
    handleErrors() {
        try {
            const e11 = this.processingErrors.length;
            if (1 === e11) throw new Error(this.processingErrors[0].message);
            if (e11 > 1) throw new Error("Encountered multiple errors: " + this.processingErrors.map((e11)=>e11.message).join(", "));
        } finally{
            this.processingErrors = [];
        }
    }
    setExternalFile(e11) {
        const t11 = this.baseOptions.getModelAsset() || new external_file_pb_1.ExternalFile;
        e11 && t11.setFileContent(e11), this.baseOptions.setModelAsset(t11);
    }
    setAcceleration(e11) {
        let t11 = this.baseOptions.getAcceleration();
        t11 || (t11 = new acceleration_pb_1.Acceleration, t11.setTflite(new inference_calculator_pb_1.InferenceCalculatorOptions.Delegate.TfLite)), "delegate" in e11 && ("GPU" === e11.delegate ? t11.setGpu(new inference_calculator_pb_1.InferenceCalculatorOptions.Delegate.Gpu) : t11.setTflite(new inference_calculator_pb_1.InferenceCalculatorOptions.Delegate.TfLite)), this.baseOptions.setAcceleration(t11);
    }
    addKeepaliveNode(e11) {
        this.keepaliveNode = new calculator_pb_1.CalculatorGraphConfig.Node, this.keepaliveNode.setCalculator("PassThroughCalculator"), this.keepaliveNode.addInputStream(FREE_MEMORY_STREAM), this.keepaliveNode.addOutputStream(FREE_MEMORY_STREAM + UNUSED_STREAM_SUFFIX), e11.addInputStream(FREE_MEMORY_STREAM), e11.addNode(this.keepaliveNode);
    }
    keepStreamAlive(e11) {
        this.keepaliveNode.addInputStream(e11), this.keepaliveNode.addOutputStream(e11 + UNUSED_STREAM_SUFFIX);
    }
    freeKeepaliveStreams() {
        this.graphRunner.addBoolToStream(!0, FREE_MEMORY_STREAM, this.latestOutputTimestamp);
    }
    close() {
        this.keepaliveNode = void 0, this.graphRunner.closeGraph();
    }
}
task_runner.TaskRunner = TaskRunner;
var graph_runner_image_lib = {};
function SupportImage(e11) {
    return class extends e11 {
        get wasmImageModule() {
            return this.wasmModule;
        }
        addGpuBufferAsImageToStream(e11, t11, r11) {
            this.wrapStringPtr(t11, (t11)=>{
                const [o11, i11] = this.bindTextureToStream(e11, t11);
                this.wasmImageModule._addBoundTextureAsImageToStream(t11, o11, i11, r11);
            });
        }
        attachImageListener(e11, t11) {
            this.setListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmImageModule._attachImageListener(e11);
            });
        }
        attachImageVectorListener(e11, t11) {
            this.setVectorListener(e11, t11), this.wrapStringPtr(e11, (e11)=>{
                this.wasmImageModule._attachImageVectorListener(e11);
            });
        }
    };
}
Object.defineProperty(graph_runner_image_lib, "__esModule", {
    value: !0
}), graph_runner_image_lib.SupportImage = void 0, graph_runner_image_lib.SupportImage = SupportImage, Object.defineProperty(vision_task_runner, "__esModule", {
    value: !0
}), vision_task_runner.VisionTaskRunner = vision_task_runner.VisionGraphRunner = void 0;
const rect_pb_1 = rect_pb, task_runner_1 = task_runner, image_1$1 = image, image_shader_context_1 = image_shader_context, mask_1$1 = mask, graph_runner_1 = graph_runner, graph_runner_image_lib_1 = graph_runner_image_lib, platform_utils_1 = platform_utils, register_model_resources_graph_service_1 = register_model_resources_graph_service, GraphRunnerVisionType = (0, register_model_resources_graph_service_1.SupportModelResourcesGraphService)((0, graph_runner_image_lib_1.SupportImage)(graph_runner_1.GraphRunner));
class VisionGraphRunner extends GraphRunnerVisionType {
}
function createCanvas() {
    return "undefined" != typeof OffscreenCanvas && !(0, platform_utils_1.isWebKit)() ? void 0 : document.createElement("canvas");
}
vision_task_runner.VisionGraphRunner = VisionGraphRunner;
class VisionTaskRunner extends task_runner_1.TaskRunner {
    static async createVisionInstance(e11, t11, r11) {
        var o11;
        const i11 = null !== (o11 = r11.canvas) && void 0 !== o11 ? o11 : createCanvas();
        return task_runner_1.TaskRunner.createInstance(e11, i11, t11, r11);
    }
    constructor(e11, t11, r11, o11){
        super(e11), this.graphRunner = e11, this.imageStreamName = t11, this.normRectStreamName = r11, this.roiAllowed = o11, this.shaderContext = new image_shader_context_1.MPImageShaderContext;
    }
    applyOptions(e11) {
        if ("runningMode" in e11) {
            const t11 = !!e11.runningMode && "IMAGE" !== e11.runningMode;
            this.baseOptions.setUseStreamMode(t11);
        }
        if (void 0 !== e11.canvas && this.graphRunner.wasmModule.canvas !== e11.canvas) throw new Error("You must create a new task to reset the canvas.");
        return super.applyOptions(e11);
    }
    processImageData(e11, t11) {
        var r11;
        if (null === (r11 = this.baseOptions) || void 0 === r11 ? void 0 : r11.getUseStreamMode()) throw new Error("Task is not initialized with image mode. 'runningMode' must be set to 'IMAGE'.");
        this.process(e11, t11, this.getSynctheticTimestamp());
    }
    processVideoData(e11, t11, r11) {
        var o11;
        if (!(null === (o11 = this.baseOptions) || void 0 === o11 ? void 0 : o11.getUseStreamMode())) throw new Error("Task is not initialized with video mode. 'runningMode' must be set to 'VIDEO'.");
        this.process(e11, t11, r11);
    }
    getImageSourceSize(e11) {
        return void 0 !== e11.videoWidth ? [
            e11.videoWidth,
            e11.videoHeight
        ] : void 0 !== e11.naturalWidth ? [
            e11.naturalWidth,
            e11.naturalHeight
        ] : [
            e11.width,
            e11.height
        ];
    }
    convertToNormalizedRect(e11, t11) {
        const r11 = new rect_pb_1.NormalizedRect;
        if (null == t11 ? void 0 : t11.regionOfInterest) {
            if (!this.roiAllowed) throw new Error("This task doesn't support region-of-interest.");
            const e11 = t11.regionOfInterest;
            if (e11.left >= e11.right || e11.top >= e11.bottom) throw new Error("Expected RectF with left < right and top < bottom.");
            if (e11.left < 0 || e11.top < 0 || e11.right > 1 || e11.bottom > 1) throw new Error("Expected RectF values to be in [0,1].");
            r11.setXCenter((e11.left + e11.right) / 2), r11.setYCenter((e11.top + e11.bottom) / 2), r11.setWidth(e11.right - e11.left), r11.setHeight(e11.bottom - e11.top);
        } else r11.setXCenter(.5), r11.setYCenter(.5), r11.setWidth(1), r11.setHeight(1);
        if (null == t11 ? void 0 : t11.rotationDegrees) {
            if ((null == t11 ? void 0 : t11.rotationDegrees) % 90 != 0) throw new Error("Expected rotation to be a multiple of 90\xb0.");
            if (r11.setRotation(-Math.PI * t11.rotationDegrees / 180), (null == t11 ? void 0 : t11.rotationDegrees) % 180 != 0) {
                const [t11, o11] = this.getImageSourceSize(e11), i11 = r11.getHeight() * o11 / t11, a11 = r11.getWidth() * t11 / o11;
                r11.setWidth(i11), r11.setHeight(a11);
            }
        }
        return r11;
    }
    process(e11, t11, r11) {
        const o11 = this.convertToNormalizedRect(e11, t11);
        this.graphRunner.addProtoToStream(o11.serializeBinary(), "mediapipe.NormalizedRect", this.normRectStreamName, r11), this.graphRunner.addGpuBufferAsImageToStream(e11, this.imageStreamName, null != r11 ? r11 : performance.now()), this.finishProcessing();
    }
    convertToMPImage(e11, t11) {
        const { data: r11, width: o11, height: i11 } = e11, a11 = o11 * i11;
        let n11;
        if (r11 instanceof Uint8Array) {
            if (r11.length === 3 * a11) {
                const e11 = new Uint8ClampedArray(4 * a11);
                for(let t11 = 0; t11 < a11; ++t11)e11[4 * t11] = r11[3 * t11], e11[4 * t11 + 1] = r11[3 * t11 + 1], e11[4 * t11 + 2] = r11[3 * t11 + 2], e11[4 * t11 + 3] = 255;
                n11 = new ImageData(e11, o11, i11);
            } else {
                if (r11.length !== 4 * a11) throw new Error("Unsupported channel count: " + r11.length / a11);
                n11 = new ImageData(new Uint8ClampedArray(r11.buffer, r11.byteOffset, r11.length), o11, i11);
            }
        } else {
            if (!(r11 instanceof WebGLTexture)) throw new Error(`Unsupported format: ${r11.constructor.name}`);
            n11 = r11;
        }
        const s11 = new image_1$1.MPImage([
            n11
        ], !1, !1, this.graphRunner.wasmModule.canvas, this.shaderContext, o11, i11);
        return t11 ? s11.clone() : s11;
    }
    convertToMPMask(e11, t11) {
        const { data: r11, width: o11, height: i11 } = e11, a11 = o11 * i11;
        let n11;
        if (r11 instanceof Uint8Array || r11 instanceof Float32Array) {
            if (r11.length !== a11) throw new Error("Unsupported channel count: " + r11.length / a11);
            n11 = r11;
        } else n11 = r11;
        const s11 = new mask_1$1.MPMask([
            n11
        ], !1, this.graphRunner.wasmModule.canvas, this.shaderContext, o11, i11);
        return t11 ? s11.clone() : s11;
    }
    close() {
        this.shaderContext.close(), super.close();
    }
}
vision_task_runner.VisionTaskRunner = VisionTaskRunner;
var face_detector_options = {};
Object.defineProperty(face_detector_options, "__esModule", {
    value: !0
});
var face_detector_result = {};
Object.defineProperty(face_detector_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.FaceDetector = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = detection_pb, n11 = base_options_pb, s11 = face_detector_graph_options_pb, p11 = detection_result, d11 = vision_task_runner, l11 = "image_in", g11 = "norm_rect_in", c11 = "detections";
    r11(face_detector_options, e11), r11(face_detector_result, e11);
    class u11 extends d11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(u11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(u11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static async createFromModelPath(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(u11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new d11.VisionGraphRunner(e11, t11), l11, g11, !1), this.result = {
                detections: []
            }, this.options = new s11.FaceDetectorGraphOptions, this.options.setBaseOptions(new n11.BaseOptions), this.options.setMinDetectionConfidence(.5), this.options.setMinSuppressionThreshold(.3);
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            var t11, r11;
            return "minDetectionConfidence" in e11 && this.options.setMinDetectionConfidence(null !== (t11 = e11.minDetectionConfidence) && void 0 !== t11 ? t11 : .5), "minSuppressionThreshold" in e11 && this.options.setMinSuppressionThreshold(null !== (r11 = e11.minSuppressionThreshold) && void 0 !== r11 ? r11 : .3), this.applyOptions(e11);
        }
        detect(e11, t11) {
            return this.result = {
                detections: []
            }, this.processImageData(e11, t11), this.result;
        }
        detectForVideo(e11, t11, r11) {
            return this.result = {
                detections: []
            }, this.processVideoData(e11, r11, t11), this.result;
        }
        addJsFaceDetections(e11) {
            for (const t11 of e11){
                const e11 = a11.Detection.deserializeBinary(t11);
                this.result.detections.push((0, p11.convertFromDetectionProto)(e11));
            }
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(l11), e11.addInputStream(g11), e11.addOutputStream(c11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(s11.FaceDetectorGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.face_detector.FaceDetectorGraph"), r11.addInputStream("IMAGE:" + l11), r11.addInputStream("NORM_RECT:" + g11), r11.addOutputStream("DETECTIONS:" + c11), r11.setOptions(t11), e11.addNode(r11), this.graphRunner.attachProtoVectorListener(c11, (e11, t11)=>{
                this.addJsFaceDetections(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(c11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            });
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.FaceDetector = u11;
}(face_detector);
var face_landmarker = {}, classification_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.Classification", null, o11), r11.exportSymbol("proto.mediapipe.ClassificationList", null, o11), r11.exportSymbol("proto.mediapipe.ClassificationListCollection", null, o11), proto.mediapipe.Classification = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.Classification, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.Classification.displayName = "proto.mediapipe.Classification"), proto.mediapipe.ClassificationList = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.ClassificationList.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.ClassificationList, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.ClassificationList.displayName = "proto.mediapipe.ClassificationList"), proto.mediapipe.ClassificationListCollection = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.ClassificationListCollection.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.ClassificationListCollection, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.ClassificationListCollection.displayName = "proto.mediapipe.ClassificationListCollection"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.Classification.prototype.toObject = function(e11) {
        return proto.mediapipe.Classification.toObject(e11, this);
    }, proto.mediapipe.Classification.toObject = function(e11, r11) {
        var o11, i11 = {
            index: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            score: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            label: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11,
            displayName: null == (o11 = t11.Message.getField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.Classification.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.Classification;
        return proto.mediapipe.Classification.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.Classification.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setIndex(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setScore(r11);
                break;
            case 3:
                r11 = t11.readString();
                e11.setLabel(r11);
                break;
            case 4:
                r11 = t11.readString();
                e11.setDisplayName(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.Classification.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.Classification.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.Classification.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeString(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeString(4, o11);
    }, proto.mediapipe.Classification.prototype.getIndex = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.Classification.prototype.setIndex = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.Classification.prototype.clearIndex = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.Classification.prototype.hasIndex = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.Classification.prototype.getScore = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.Classification.prototype.setScore = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.Classification.prototype.clearScore = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.Classification.prototype.hasScore = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.Classification.prototype.getLabel = function() {
        return t11.Message.getFieldWithDefault(this, 3, "");
    }, proto.mediapipe.Classification.prototype.setLabel = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.Classification.prototype.clearLabel = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.Classification.prototype.hasLabel = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.Classification.prototype.getDisplayName = function() {
        return t11.Message.getFieldWithDefault(this, 4, "");
    }, proto.mediapipe.Classification.prototype.setDisplayName = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.Classification.prototype.clearDisplayName = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.Classification.prototype.hasDisplayName = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.ClassificationList.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.ClassificationList.prototype.toObject = function(e11) {
        return proto.mediapipe.ClassificationList.toObject(e11, this);
    }, proto.mediapipe.ClassificationList.toObject = function(e11, r11) {
        var o11 = {
            classificationList: t11.Message.toObjectList(r11.getClassificationList(), proto.mediapipe.Classification.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.ClassificationList.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.ClassificationList;
        return proto.mediapipe.ClassificationList.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.ClassificationList.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.Classification;
            t11.readMessage(r11, proto.mediapipe.Classification.deserializeBinaryFromReader), e11.addClassification(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.ClassificationList.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.ClassificationList.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.ClassificationList.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getClassificationList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.Classification.serializeBinaryToWriter);
    }, proto.mediapipe.ClassificationList.prototype.getClassificationList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.Classification, 1);
    }, proto.mediapipe.ClassificationList.prototype.setClassificationList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.ClassificationList.prototype.addClassification = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.Classification, r11);
    }, proto.mediapipe.ClassificationList.prototype.clearClassificationList = function() {
        return this.setClassificationList([]);
    }, proto.mediapipe.ClassificationListCollection.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.ClassificationListCollection.prototype.toObject = function(e11) {
        return proto.mediapipe.ClassificationListCollection.toObject(e11, this);
    }, proto.mediapipe.ClassificationListCollection.toObject = function(e11, r11) {
        var o11 = {
            classificationListList: t11.Message.toObjectList(r11.getClassificationListList(), proto.mediapipe.ClassificationList.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.ClassificationListCollection.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.ClassificationListCollection;
        return proto.mediapipe.ClassificationListCollection.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.ClassificationListCollection.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.ClassificationList;
            t11.readMessage(r11, proto.mediapipe.ClassificationList.deserializeBinaryFromReader), e11.addClassificationList(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.ClassificationListCollection.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.ClassificationListCollection.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.ClassificationListCollection.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getClassificationListList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.ClassificationList.serializeBinaryToWriter);
    }, proto.mediapipe.ClassificationListCollection.prototype.getClassificationListList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.ClassificationList, 1);
    }, proto.mediapipe.ClassificationListCollection.prototype.setClassificationListList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.ClassificationListCollection.prototype.addClassificationList = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.ClassificationList, r11);
    }, proto.mediapipe.ClassificationListCollection.prototype.clearClassificationListList = function() {
        return this.setClassificationListList([]);
    }, r11.object.extend(e11, proto.mediapipe);
}(classification_pb);
var landmark_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.Landmark", null, o11), r11.exportSymbol("proto.mediapipe.LandmarkList", null, o11), r11.exportSymbol("proto.mediapipe.LandmarkListCollection", null, o11), r11.exportSymbol("proto.mediapipe.NormalizedLandmark", null, o11), r11.exportSymbol("proto.mediapipe.NormalizedLandmarkList", null, o11), r11.exportSymbol("proto.mediapipe.NormalizedLandmarkListCollection", null, o11), proto.mediapipe.Landmark = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.Landmark, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.Landmark.displayName = "proto.mediapipe.Landmark"), proto.mediapipe.LandmarkList = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.LandmarkList.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.LandmarkList, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.LandmarkList.displayName = "proto.mediapipe.LandmarkList"), proto.mediapipe.LandmarkListCollection = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.LandmarkListCollection.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.LandmarkListCollection, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.LandmarkListCollection.displayName = "proto.mediapipe.LandmarkListCollection"), proto.mediapipe.NormalizedLandmark = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.NormalizedLandmark, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.NormalizedLandmark.displayName = "proto.mediapipe.NormalizedLandmark"), proto.mediapipe.NormalizedLandmarkList = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.NormalizedLandmarkList.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.NormalizedLandmarkList, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.NormalizedLandmarkList.displayName = "proto.mediapipe.NormalizedLandmarkList"), proto.mediapipe.NormalizedLandmarkListCollection = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.NormalizedLandmarkListCollection.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.NormalizedLandmarkListCollection, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.NormalizedLandmarkListCollection.displayName = "proto.mediapipe.NormalizedLandmarkListCollection"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.Landmark.prototype.toObject = function(e11) {
        return proto.mediapipe.Landmark.toObject(e11, this);
    }, proto.mediapipe.Landmark.toObject = function(e11, r11) {
        var o11, i11 = {
            x: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            y: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            z: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            visibility: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11,
            presence: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 5)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.Landmark.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.Landmark;
        return proto.mediapipe.Landmark.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.Landmark.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readFloat();
                e11.setX(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setY(r11);
                break;
            case 3:
                r11 = t11.readFloat();
                e11.setZ(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setVisibility(r11);
                break;
            case 5:
                r11 = t11.readFloat();
                e11.setPresence(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.Landmark.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.Landmark.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.Landmark.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeFloat(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeFloat(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeFloat(5, o11);
    }, proto.mediapipe.Landmark.prototype.getX = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.Landmark.prototype.setX = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.Landmark.prototype.clearX = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.Landmark.prototype.hasX = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.Landmark.prototype.getY = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.Landmark.prototype.setY = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.Landmark.prototype.clearY = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.Landmark.prototype.hasY = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.Landmark.prototype.getZ = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.Landmark.prototype.setZ = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.Landmark.prototype.clearZ = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.Landmark.prototype.hasZ = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.Landmark.prototype.getVisibility = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.Landmark.prototype.setVisibility = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.Landmark.prototype.clearVisibility = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.Landmark.prototype.hasVisibility = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.Landmark.prototype.getPresence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 5, 0);
    }, proto.mediapipe.Landmark.prototype.setPresence = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.Landmark.prototype.clearPresence = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.Landmark.prototype.hasPresence = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.LandmarkList.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.LandmarkList.prototype.toObject = function(e11) {
        return proto.mediapipe.LandmarkList.toObject(e11, this);
    }, proto.mediapipe.LandmarkList.toObject = function(e11, r11) {
        var o11 = {
            landmarkList: t11.Message.toObjectList(r11.getLandmarkList(), proto.mediapipe.Landmark.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.LandmarkList.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.LandmarkList;
        return proto.mediapipe.LandmarkList.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.LandmarkList.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.Landmark;
            t11.readMessage(r11, proto.mediapipe.Landmark.deserializeBinaryFromReader), e11.addLandmark(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.LandmarkList.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.LandmarkList.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.LandmarkList.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getLandmarkList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.Landmark.serializeBinaryToWriter);
    }, proto.mediapipe.LandmarkList.prototype.getLandmarkList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.Landmark, 1);
    }, proto.mediapipe.LandmarkList.prototype.setLandmarkList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.LandmarkList.prototype.addLandmark = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.Landmark, r11);
    }, proto.mediapipe.LandmarkList.prototype.clearLandmarkList = function() {
        return this.setLandmarkList([]);
    }, proto.mediapipe.LandmarkListCollection.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.LandmarkListCollection.prototype.toObject = function(e11) {
        return proto.mediapipe.LandmarkListCollection.toObject(e11, this);
    }, proto.mediapipe.LandmarkListCollection.toObject = function(e11, r11) {
        var o11 = {
            landmarkListList: t11.Message.toObjectList(r11.getLandmarkListList(), proto.mediapipe.LandmarkList.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.LandmarkListCollection.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.LandmarkListCollection;
        return proto.mediapipe.LandmarkListCollection.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.LandmarkListCollection.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.LandmarkList;
            t11.readMessage(r11, proto.mediapipe.LandmarkList.deserializeBinaryFromReader), e11.addLandmarkList(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.LandmarkListCollection.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.LandmarkListCollection.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.LandmarkListCollection.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getLandmarkListList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.LandmarkList.serializeBinaryToWriter);
    }, proto.mediapipe.LandmarkListCollection.prototype.getLandmarkListList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.LandmarkList, 1);
    }, proto.mediapipe.LandmarkListCollection.prototype.setLandmarkListList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.LandmarkListCollection.prototype.addLandmarkList = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.LandmarkList, r11);
    }, proto.mediapipe.LandmarkListCollection.prototype.clearLandmarkListList = function() {
        return this.setLandmarkListList([]);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.NormalizedLandmark.prototype.toObject = function(e11) {
        return proto.mediapipe.NormalizedLandmark.toObject(e11, this);
    }, proto.mediapipe.NormalizedLandmark.toObject = function(e11, r11) {
        var o11, i11 = {
            x: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            y: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            z: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            visibility: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11,
            presence: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 5)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.NormalizedLandmark.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.NormalizedLandmark;
        return proto.mediapipe.NormalizedLandmark.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.NormalizedLandmark.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readFloat();
                e11.setX(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setY(r11);
                break;
            case 3:
                r11 = t11.readFloat();
                e11.setZ(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setVisibility(r11);
                break;
            case 5:
                r11 = t11.readFloat();
                e11.setPresence(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.NormalizedLandmark.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.NormalizedLandmark.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.NormalizedLandmark.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeFloat(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeFloat(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeFloat(5, o11);
    }, proto.mediapipe.NormalizedLandmark.prototype.getX = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.setX = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.NormalizedLandmark.prototype.clearX = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.hasX = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.NormalizedLandmark.prototype.getY = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.setY = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.NormalizedLandmark.prototype.clearY = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.hasY = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.NormalizedLandmark.prototype.getZ = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.setZ = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.NormalizedLandmark.prototype.clearZ = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.hasZ = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.NormalizedLandmark.prototype.getVisibility = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.setVisibility = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.NormalizedLandmark.prototype.clearVisibility = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.hasVisibility = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.NormalizedLandmark.prototype.getPresence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 5, 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.setPresence = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.NormalizedLandmark.prototype.clearPresence = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.NormalizedLandmark.prototype.hasPresence = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.NormalizedLandmarkList.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.NormalizedLandmarkList.prototype.toObject = function(e11) {
        return proto.mediapipe.NormalizedLandmarkList.toObject(e11, this);
    }, proto.mediapipe.NormalizedLandmarkList.toObject = function(e11, r11) {
        var o11 = {
            landmarkList: t11.Message.toObjectList(r11.getLandmarkList(), proto.mediapipe.NormalizedLandmark.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.NormalizedLandmarkList.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.NormalizedLandmarkList;
        return proto.mediapipe.NormalizedLandmarkList.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.NormalizedLandmarkList.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.NormalizedLandmark;
            t11.readMessage(r11, proto.mediapipe.NormalizedLandmark.deserializeBinaryFromReader), e11.addLandmark(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.NormalizedLandmarkList.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.NormalizedLandmarkList.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.NormalizedLandmarkList.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getLandmarkList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.NormalizedLandmark.serializeBinaryToWriter);
    }, proto.mediapipe.NormalizedLandmarkList.prototype.getLandmarkList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.NormalizedLandmark, 1);
    }, proto.mediapipe.NormalizedLandmarkList.prototype.setLandmarkList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.NormalizedLandmarkList.prototype.addLandmark = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.NormalizedLandmark, r11);
    }, proto.mediapipe.NormalizedLandmarkList.prototype.clearLandmarkList = function() {
        return this.setLandmarkList([]);
    }, proto.mediapipe.NormalizedLandmarkListCollection.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.NormalizedLandmarkListCollection.prototype.toObject = function(e11) {
        return proto.mediapipe.NormalizedLandmarkListCollection.toObject(e11, this);
    }, proto.mediapipe.NormalizedLandmarkListCollection.toObject = function(e11, r11) {
        var o11 = {
            landmarkListList: t11.Message.toObjectList(r11.getLandmarkListList(), proto.mediapipe.NormalizedLandmarkList.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.NormalizedLandmarkListCollection.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.NormalizedLandmarkListCollection;
        return proto.mediapipe.NormalizedLandmarkListCollection.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.NormalizedLandmarkListCollection.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.NormalizedLandmarkList;
            t11.readMessage(r11, proto.mediapipe.NormalizedLandmarkList.deserializeBinaryFromReader), e11.addLandmarkList(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.NormalizedLandmarkListCollection.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.NormalizedLandmarkListCollection.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.NormalizedLandmarkListCollection.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getLandmarkListList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.NormalizedLandmarkList.serializeBinaryToWriter);
    }, proto.mediapipe.NormalizedLandmarkListCollection.prototype.getLandmarkListList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.NormalizedLandmarkList, 1);
    }, proto.mediapipe.NormalizedLandmarkListCollection.prototype.setLandmarkListList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.NormalizedLandmarkListCollection.prototype.addLandmarkList = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.NormalizedLandmarkList, r11);
    }, proto.mediapipe.NormalizedLandmarkListCollection.prototype.clearLandmarkListList = function() {
        return this.setLandmarkListList([]);
    }, r11.object.extend(e11, proto.mediapipe);
}(landmark_pb);
var face_geometry_pb = {}, matrix_data_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.MatrixData", null, o11), r11.exportSymbol("proto.mediapipe.MatrixData.Layout", null, o11), proto.mediapipe.MatrixData = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.MatrixData.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.MatrixData, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.MatrixData.displayName = "proto.mediapipe.MatrixData"), proto.mediapipe.MatrixData.repeatedFields_ = [
        3
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.MatrixData.prototype.toObject = function(e11) {
        return proto.mediapipe.MatrixData.toObject(e11, this);
    }, proto.mediapipe.MatrixData.toObject = function(e11, r11) {
        var o11, i11 = {
            rows: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            cols: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            packedDataList: null == (o11 = t11.Message.getRepeatedFloatingPointField(r11, 3)) ? void 0 : o11,
            layout: t11.Message.getFieldWithDefault(r11, 4, 0)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.MatrixData.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.MatrixData;
        return proto.mediapipe.MatrixData.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.MatrixData.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setRows(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setCols(r11);
                break;
            case 3:
                for(var o11 = t11.isDelimited() ? t11.readPackedFloat() : [
                    t11.readFloat()
                ], i11 = 0; i11 < o11.length; i11++)e11.addPackedData(o11[i11]);
                break;
            case 4:
                r11 = t11.readEnum();
                e11.setLayout(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.MatrixData.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.MatrixData.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.MatrixData.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), (o11 = e11.getPackedDataList()).length > 0 && r11.writePackedFloat(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeEnum(4, o11);
    }, proto.mediapipe.MatrixData.Layout = {
        COLUMN_MAJOR: 0,
        ROW_MAJOR: 1
    }, proto.mediapipe.MatrixData.prototype.getRows = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.MatrixData.prototype.setRows = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.MatrixData.prototype.clearRows = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.MatrixData.prototype.hasRows = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.MatrixData.prototype.getCols = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.MatrixData.prototype.setCols = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.MatrixData.prototype.clearCols = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.MatrixData.prototype.hasCols = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.MatrixData.prototype.getPackedDataList = function() {
        return t11.Message.getRepeatedFloatingPointField(this, 3);
    }, proto.mediapipe.MatrixData.prototype.setPackedDataList = function(e11) {
        return t11.Message.setField(this, 3, e11 || []);
    }, proto.mediapipe.MatrixData.prototype.addPackedData = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 3, e11, r11);
    }, proto.mediapipe.MatrixData.prototype.clearPackedDataList = function() {
        return this.setPackedDataList([]);
    }, proto.mediapipe.MatrixData.prototype.getLayout = function() {
        return t11.Message.getFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.MatrixData.prototype.setLayout = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.MatrixData.prototype.clearLayout = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.MatrixData.prototype.hasLayout = function() {
        return null != t11.Message.getField(this, 4);
    }, r11.object.extend(e11, proto.mediapipe);
}(matrix_data_pb);
var mesh_3d_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d", null, o11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.PrimitiveType", null, o11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.VertexType", null, o11), proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.displayName = "proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d"), proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.repeatedFields_ = [
        3,
        4
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.toObject = function(e11, r11) {
        var o11, i11 = {
            vertexType: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            primitiveType: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            vertexBufferList: null == (o11 = t11.Message.getRepeatedFloatingPointField(r11, 3)) ? void 0 : o11,
            indexBufferList: null == (o11 = t11.Message.getRepeatedField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d;
        return proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readEnum();
                e11.setVertexType(r11);
                break;
            case 2:
                r11 = t11.readEnum();
                e11.setPrimitiveType(r11);
                break;
            case 3:
                for(var o11 = t11.isDelimited() ? t11.readPackedFloat() : [
                    t11.readFloat()
                ], i11 = 0; i11 < o11.length; i11++)e11.addVertexBuffer(o11[i11]);
                break;
            case 4:
                for(o11 = t11.isDelimited() ? t11.readPackedUint32() : [
                    t11.readUint32()
                ], i11 = 0; i11 < o11.length; i11++)e11.addIndexBuffer(o11[i11]);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeEnum(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeEnum(2, o11), (o11 = e11.getVertexBufferList()).length > 0 && r11.writeRepeatedFloat(3, o11), (o11 = e11.getIndexBufferList()).length > 0 && r11.writeRepeatedUint32(4, o11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.VertexType = {
        VERTEX_PT: 0
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.PrimitiveType = {
        TRIANGLE: 0
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.getVertexType = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.setVertexType = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.clearVertexType = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.hasVertexType = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.getPrimitiveType = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.setPrimitiveType = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.clearPrimitiveType = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.hasPrimitiveType = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.getVertexBufferList = function() {
        return t11.Message.getRepeatedFloatingPointField(this, 3);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.setVertexBufferList = function(e11) {
        return t11.Message.setField(this, 3, e11 || []);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.addVertexBuffer = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 3, e11, r11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.clearVertexBufferList = function() {
        return this.setVertexBufferList([]);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.getIndexBufferList = function() {
        return t11.Message.getRepeatedField(this, 4);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.setIndexBufferList = function(e11) {
        return t11.Message.setField(this, 4, e11 || []);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.addIndexBuffer = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 4, e11, r11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.Mesh3d.prototype.clearIndexBufferList = function() {
        return this.setIndexBufferList([]);
    }, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_geometry.proto);
}(mesh_3d_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = matrix_data_pb;
    r11.object.extend(proto, i11);
    var a11 = mesh_3d_pb;
    r11.object.extend(proto, a11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry", null, o11), proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.displayName = "proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.toObject = function(e11, t11) {
        var r11, o11 = {
            mesh: (r11 = t11.getMesh()) && a11.Mesh3d.toObject(e11, r11),
            poseTransformMatrix: (r11 = t11.getPoseTransformMatrix()) && i11.MatrixData.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry;
        return proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new a11.Mesh3d;
                t11.readMessage(r11, a11.Mesh3d.deserializeBinaryFromReader), e11.setMesh(r11);
                break;
            case 2:
                r11 = new i11.MatrixData;
                t11.readMessage(r11, i11.MatrixData.deserializeBinaryFromReader), e11.setPoseTransformMatrix(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getMesh()) && t11.writeMessage(1, r11, a11.Mesh3d.serializeBinaryToWriter), null != (r11 = e11.getPoseTransformMatrix()) && t11.writeMessage(2, r11, i11.MatrixData.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.getMesh = function() {
        return t11.Message.getWrapperField(this, a11.Mesh3d, 1);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.setMesh = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.clearMesh = function() {
        return this.setMesh(void 0);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.hasMesh = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.getPoseTransformMatrix = function() {
        return t11.Message.getWrapperField(this, i11.MatrixData, 2);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.setPoseTransformMatrix = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.clearPoseTransformMatrix = function() {
        return this.setPoseTransformMatrix(void 0);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometry.prototype.hasPoseTransformMatrix = function() {
        return null != t11.Message.getField(this, 2);
    }, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_geometry.proto);
}(face_geometry_pb);
var face_landmarker_graph_options_pb = {}, face_geometry_graph_options_pb = {}, geometry_pipeline_calculator_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_options_pb;
    r11.object.extend(proto, i11);
    var a11 = external_file_pb;
    r11.object.extend(proto, a11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions", null, o11), proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.displayName = "proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            metadataFile: (r11 = t11.getMetadataFile()) && a11.ExternalFile.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions;
        return proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new a11.ExternalFile;
            t11.readMessage(r11, a11.ExternalFile.deserializeBinaryFromReader), e11.setMetadataFile(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        null != (r11 = e11.getMetadataFile()) && t11.writeMessage(1, r11, a11.ExternalFile.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.ext = new t11.ExtensionFieldInfo(512499200, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.toObject, 0), i11.CalculatorOptions.extensionsBinary[512499200] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.deserializeBinaryFromReader, !1), i11.CalculatorOptions.extensions[512499200] = proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.ext, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.prototype.getMetadataFile = function() {
        return t11.Message.getWrapperField(this, a11.ExternalFile, 1);
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.prototype.setMetadataFile = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.prototype.clearMetadataFile = function() {
        return this.setMetadataFile(void 0);
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.prototype.hasMetadataFile = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.ext = new t11.ExtensionFieldInfo(512499200, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.toObject, 0), i11.CalculatorOptions.extensionsBinary[512499200] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.deserializeBinaryFromReader, !1), i11.CalculatorOptions.extensions[512499200] = proto.mediapipe.tasks.vision.face_geometry.FaceGeometryPipelineCalculatorOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_geometry);
}(geometry_pipeline_calculator_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_options_pb;
    r11.object.extend(proto, i11);
    var a11 = geometry_pipeline_calculator_pb;
    r11.object.extend(proto, a11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions", null, o11), proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.displayName = "proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            geometryPipelineOptions: (r11 = t11.getGeometryPipelineOptions()) && a11.FaceGeometryPipelineCalculatorOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions;
        return proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new a11.FaceGeometryPipelineCalculatorOptions;
            t11.readMessage(r11, a11.FaceGeometryPipelineCalculatorOptions.deserializeBinaryFromReader), e11.setGeometryPipelineOptions(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        null != (r11 = e11.getGeometryPipelineOptions()) && t11.writeMessage(1, r11, a11.FaceGeometryPipelineCalculatorOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.ext = new t11.ExtensionFieldInfo(515723506, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.toObject, 0), i11.CalculatorOptions.extensionsBinary[515723506] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.deserializeBinaryFromReader, !1), i11.CalculatorOptions.extensions[515723506] = proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.ext, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.prototype.getGeometryPipelineOptions = function() {
        return t11.Message.getWrapperField(this, a11.FaceGeometryPipelineCalculatorOptions, 1);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.prototype.setGeometryPipelineOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.prototype.clearGeometryPipelineOptions = function() {
        return this.setGeometryPipelineOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.prototype.hasGeometryPipelineOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.ext = new t11.ExtensionFieldInfo(515723506, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.toObject, 0), i11.CalculatorOptions.extensionsBinary[515723506] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.deserializeBinaryFromReader, !1), i11.CalculatorOptions.extensions[515723506] = proto.mediapipe.tasks.vision.face_geometry.proto.FaceGeometryGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_geometry.proto);
}(face_geometry_graph_options_pb);
var face_landmarks_detector_graph_options_pb = {}, face_blendshapes_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions", null, o11), proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.displayName = "proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            baseOptions: (r11 = t11.getBaseOptions()) && n11.BaseOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions;
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new n11.BaseOptions;
            t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        null != (r11 = e11.getBaseOptions()) && t11.writeMessage(1, r11, n11.BaseOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.ext = new t11.ExtensionFieldInfo(508981768, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[508981768] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[508981768] = proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.ext, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.ext = new t11.ExtensionFieldInfo(508981768, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[508981768] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[508981768] = proto.mediapipe.tasks.vision.face_landmarker.proto.FaceBlendshapesGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_landmarker.proto);
}(face_blendshapes_graph_options_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11);
    var s11 = face_blendshapes_graph_options_pb;
    r11.object.extend(proto, s11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions", null, o11), proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.displayName = "proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            minDetectionConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 2, .5),
            smoothLandmarks: null == (o11 = t11.Message.getBooleanField(r11, 4)) ? void 0 : o11,
            faceBlendshapesGraphOptions: (o11 = r11.getFaceBlendshapesGraphOptions()) && s11.FaceBlendshapesGraphOptions.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions;
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setMinDetectionConfidence(r11);
                break;
            case 4:
                r11 = t11.readBool();
                e11.setSmoothLandmarks(r11);
                break;
            case 3:
                r11 = new s11.FaceBlendshapesGraphOptions;
                t11.readMessage(r11, s11.FaceBlendshapesGraphOptions.deserializeBinaryFromReader), e11.setFaceBlendshapesGraphOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeBool(4, o11), null != (o11 = e11.getFaceBlendshapesGraphOptions()) && r11.writeMessage(3, o11, s11.FaceBlendshapesGraphOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(508968149, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[508968149] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[508968149] = proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.ext, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.getMinDetectionConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, .5);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.setMinDetectionConfidence = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.clearMinDetectionConfidence = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.hasMinDetectionConfidence = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.getSmoothLandmarks = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 4, !1);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.setSmoothLandmarks = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.clearSmoothLandmarks = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.hasSmoothLandmarks = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.getFaceBlendshapesGraphOptions = function() {
        return t11.Message.getWrapperField(this, s11.FaceBlendshapesGraphOptions, 3);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.setFaceBlendshapesGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.clearFaceBlendshapesGraphOptions = function() {
        return this.setFaceBlendshapesGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.prototype.hasFaceBlendshapesGraphOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(508968149, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[508968149] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[508968149] = proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarksDetectorGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_landmarker.proto);
}(face_landmarks_detector_graph_options_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11);
    var s11 = face_detector_graph_options_pb;
    r11.object.extend(proto, s11);
    var p11 = face_geometry_graph_options_pb;
    r11.object.extend(proto, p11);
    var d11 = face_landmarks_detector_graph_options_pb;
    r11.object.extend(proto, d11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions", null, o11), proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.displayName = "proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            faceDetectorGraphOptions: (o11 = r11.getFaceDetectorGraphOptions()) && s11.FaceDetectorGraphOptions.toObject(e11, o11),
            faceLandmarksDetectorGraphOptions: (o11 = r11.getFaceLandmarksDetectorGraphOptions()) && d11.FaceLandmarksDetectorGraphOptions.toObject(e11, o11),
            minTrackingConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 4, .5),
            faceGeometryGraphOptions: (o11 = r11.getFaceGeometryGraphOptions()) && p11.FaceGeometryGraphOptions.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions;
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new s11.FaceDetectorGraphOptions;
                t11.readMessage(r11, s11.FaceDetectorGraphOptions.deserializeBinaryFromReader), e11.setFaceDetectorGraphOptions(r11);
                break;
            case 3:
                r11 = new d11.FaceLandmarksDetectorGraphOptions;
                t11.readMessage(r11, d11.FaceLandmarksDetectorGraphOptions.deserializeBinaryFromReader), e11.setFaceLandmarksDetectorGraphOptions(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setMinTrackingConfidence(r11);
                break;
            case 5:
                r11 = new p11.FaceGeometryGraphOptions;
                t11.readMessage(r11, p11.FaceGeometryGraphOptions.deserializeBinaryFromReader), e11.setFaceGeometryGraphOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = e11.getFaceDetectorGraphOptions()) && r11.writeMessage(2, o11, s11.FaceDetectorGraphOptions.serializeBinaryToWriter), null != (o11 = e11.getFaceLandmarksDetectorGraphOptions()) && r11.writeMessage(3, o11, d11.FaceLandmarksDetectorGraphOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11), null != (o11 = e11.getFaceGeometryGraphOptions()) && r11.writeMessage(5, o11, p11.FaceGeometryGraphOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.ext = new t11.ExtensionFieldInfo(508968150, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[508968150] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[508968150] = proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.ext, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.getFaceDetectorGraphOptions = function() {
        return t11.Message.getWrapperField(this, s11.FaceDetectorGraphOptions, 2);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.setFaceDetectorGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.clearFaceDetectorGraphOptions = function() {
        return this.setFaceDetectorGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.hasFaceDetectorGraphOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.getFaceLandmarksDetectorGraphOptions = function() {
        return t11.Message.getWrapperField(this, d11.FaceLandmarksDetectorGraphOptions, 3);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.setFaceLandmarksDetectorGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.clearFaceLandmarksDetectorGraphOptions = function() {
        return this.setFaceLandmarksDetectorGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.hasFaceLandmarksDetectorGraphOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.getMinTrackingConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, .5);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.setMinTrackingConfidence = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.clearMinTrackingConfidence = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.hasMinTrackingConfidence = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.getFaceGeometryGraphOptions = function() {
        return t11.Message.getWrapperField(this, p11.FaceGeometryGraphOptions, 5);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.setFaceGeometryGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 5, e11);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.clearFaceGeometryGraphOptions = function() {
        return this.setFaceGeometryGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.prototype.hasFaceGeometryGraphOptions = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.ext = new t11.ExtensionFieldInfo(508968150, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[508968150] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[508968150] = proto.mediapipe.tasks.vision.face_landmarker.proto.FaceLandmarkerGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_landmarker.proto);
}(face_landmarker_graph_options_pb);
var classifier_result = {};
Object.defineProperty(classifier_result, "__esModule", {
    value: !0
}), classifier_result.convertFromClassificationResultProto = classifier_result.convertFromClassifications = void 0;
const DEFAULT_INDEX$1 = -1, DEFAULT_SCORE = 0;
function convertFromClassifications(e11, t11 = DEFAULT_INDEX$1, r11 = "") {
    return {
        categories: e11.map((e11)=>{
            var t11, r11, o11, i11;
            return {
                index: null !== (t11 = e11.getIndex()) && void 0 !== t11 ? t11 : DEFAULT_INDEX$1,
                score: null !== (r11 = e11.getScore()) && void 0 !== r11 ? r11 : DEFAULT_SCORE,
                categoryName: null !== (o11 = e11.getLabel()) && void 0 !== o11 ? o11 : "",
                displayName: null !== (i11 = e11.getDisplayName()) && void 0 !== i11 ? i11 : ""
            };
        }),
        headIndex: t11,
        headName: r11
    };
}
function convertFromClassificationsProto(e11) {
    var t11, r11;
    return convertFromClassifications(null !== (r11 = null === (t11 = e11.getClassificationList()) || void 0 === t11 ? void 0 : t11.getClassificationList()) && void 0 !== r11 ? r11 : [], e11.getHeadIndex(), e11.getHeadName());
}
function convertFromClassificationResultProto(e11) {
    const t11 = {
        classifications: e11.getClassificationsList().map((e11)=>convertFromClassificationsProto(e11))
    };
    return e11.hasTimestampMs() && (t11.timestampMs = e11.getTimestampMs()), t11;
}
classifier_result.convertFromClassifications = convertFromClassifications, classifier_result.convertFromClassificationResultProto = convertFromClassificationResultProto;
var landmark_result = {};
function convertToLandmarks(e11) {
    var t11, r11, o11;
    const i11 = [];
    for (const a11 of e11.getLandmarkList())i11.push({
        x: null !== (t11 = a11.getX()) && void 0 !== t11 ? t11 : 0,
        y: null !== (r11 = a11.getY()) && void 0 !== r11 ? r11 : 0,
        z: null !== (o11 = a11.getZ()) && void 0 !== o11 ? o11 : 0
    });
    return i11;
}
function convertToWorldLandmarks(e11) {
    var t11, r11, o11;
    const i11 = [];
    for (const a11 of e11.getLandmarkList())i11.push({
        x: null !== (t11 = a11.getX()) && void 0 !== t11 ? t11 : 0,
        y: null !== (r11 = a11.getY()) && void 0 !== r11 ? r11 : 0,
        z: null !== (o11 = a11.getZ()) && void 0 !== o11 ? o11 : 0
    });
    return i11;
}
Object.defineProperty(landmark_result, "__esModule", {
    value: !0
}), landmark_result.convertToWorldLandmarks = landmark_result.convertToLandmarks = void 0, landmark_result.convertToLandmarks = convertToLandmarks, landmark_result.convertToWorldLandmarks = convertToWorldLandmarks;
var face_landmarks_connections = {}, exports;
exports = face_landmarks_connections, Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports.FACE_LANDMARKS_TESSELATION = exports.FACE_LANDMARKS_CONTOURS = exports.FACE_LANDMARKS_FACE_OVAL = exports.FACE_LANDMARKS_RIGHT_IRIS = exports.FACE_LANDMARKS_RIGHT_EYEBROW = exports.FACE_LANDMARKS_RIGHT_EYE = exports.FACE_LANDMARKS_LEFT_IRIS = exports.FACE_LANDMARKS_LEFT_EYEBROW = exports.FACE_LANDMARKS_LEFT_EYE = exports.FACE_LANDMARKS_LIPS = void 0, exports.FACE_LANDMARKS_LIPS = [
    {
        start: 61,
        end: 146
    },
    {
        start: 146,
        end: 91
    },
    {
        start: 91,
        end: 181
    },
    {
        start: 181,
        end: 84
    },
    {
        start: 84,
        end: 17
    },
    {
        start: 17,
        end: 314
    },
    {
        start: 314,
        end: 405
    },
    {
        start: 405,
        end: 321
    },
    {
        start: 321,
        end: 375
    },
    {
        start: 375,
        end: 291
    },
    {
        start: 61,
        end: 185
    },
    {
        start: 185,
        end: 40
    },
    {
        start: 40,
        end: 39
    },
    {
        start: 39,
        end: 37
    },
    {
        start: 37,
        end: 0
    },
    {
        start: 0,
        end: 267
    },
    {
        start: 267,
        end: 269
    },
    {
        start: 269,
        end: 270
    },
    {
        start: 270,
        end: 409
    },
    {
        start: 409,
        end: 291
    },
    {
        start: 78,
        end: 95
    },
    {
        start: 95,
        end: 88
    },
    {
        start: 88,
        end: 178
    },
    {
        start: 178,
        end: 87
    },
    {
        start: 87,
        end: 14
    },
    {
        start: 14,
        end: 317
    },
    {
        start: 317,
        end: 402
    },
    {
        start: 402,
        end: 318
    },
    {
        start: 318,
        end: 324
    },
    {
        start: 324,
        end: 308
    },
    {
        start: 78,
        end: 191
    },
    {
        start: 191,
        end: 80
    },
    {
        start: 80,
        end: 81
    },
    {
        start: 81,
        end: 82
    },
    {
        start: 82,
        end: 13
    },
    {
        start: 13,
        end: 312
    },
    {
        start: 312,
        end: 311
    },
    {
        start: 311,
        end: 310
    },
    {
        start: 310,
        end: 415
    },
    {
        start: 415,
        end: 308
    }
], exports.FACE_LANDMARKS_LEFT_EYE = [
    {
        start: 263,
        end: 249
    },
    {
        start: 249,
        end: 390
    },
    {
        start: 390,
        end: 373
    },
    {
        start: 373,
        end: 374
    },
    {
        start: 374,
        end: 380
    },
    {
        start: 380,
        end: 381
    },
    {
        start: 381,
        end: 382
    },
    {
        start: 382,
        end: 362
    },
    {
        start: 263,
        end: 466
    },
    {
        start: 466,
        end: 388
    },
    {
        start: 388,
        end: 387
    },
    {
        start: 387,
        end: 386
    },
    {
        start: 386,
        end: 385
    },
    {
        start: 385,
        end: 384
    },
    {
        start: 384,
        end: 398
    },
    {
        start: 398,
        end: 362
    }
], exports.FACE_LANDMARKS_LEFT_EYEBROW = [
    {
        start: 276,
        end: 283
    },
    {
        start: 283,
        end: 282
    },
    {
        start: 282,
        end: 295
    },
    {
        start: 295,
        end: 285
    },
    {
        start: 300,
        end: 293
    },
    {
        start: 293,
        end: 334
    },
    {
        start: 334,
        end: 296
    },
    {
        start: 296,
        end: 336
    }
], exports.FACE_LANDMARKS_LEFT_IRIS = [
    {
        start: 474,
        end: 475
    },
    {
        start: 475,
        end: 476
    },
    {
        start: 476,
        end: 477
    },
    {
        start: 477,
        end: 474
    }
], exports.FACE_LANDMARKS_RIGHT_EYE = [
    {
        start: 33,
        end: 7
    },
    {
        start: 7,
        end: 163
    },
    {
        start: 163,
        end: 144
    },
    {
        start: 144,
        end: 145
    },
    {
        start: 145,
        end: 153
    },
    {
        start: 153,
        end: 154
    },
    {
        start: 154,
        end: 155
    },
    {
        start: 155,
        end: 133
    },
    {
        start: 33,
        end: 246
    },
    {
        start: 246,
        end: 161
    },
    {
        start: 161,
        end: 160
    },
    {
        start: 160,
        end: 159
    },
    {
        start: 159,
        end: 158
    },
    {
        start: 158,
        end: 157
    },
    {
        start: 157,
        end: 173
    },
    {
        start: 173,
        end: 133
    }
], exports.FACE_LANDMARKS_RIGHT_EYEBROW = [
    {
        start: 46,
        end: 53
    },
    {
        start: 53,
        end: 52
    },
    {
        start: 52,
        end: 65
    },
    {
        start: 65,
        end: 55
    },
    {
        start: 70,
        end: 63
    },
    {
        start: 63,
        end: 105
    },
    {
        start: 105,
        end: 66
    },
    {
        start: 66,
        end: 107
    }
], exports.FACE_LANDMARKS_RIGHT_IRIS = [
    {
        start: 469,
        end: 470
    },
    {
        start: 470,
        end: 471
    },
    {
        start: 471,
        end: 472
    },
    {
        start: 472,
        end: 469
    }
], exports.FACE_LANDMARKS_FACE_OVAL = [
    {
        start: 10,
        end: 338
    },
    {
        start: 338,
        end: 297
    },
    {
        start: 297,
        end: 332
    },
    {
        start: 332,
        end: 284
    },
    {
        start: 284,
        end: 251
    },
    {
        start: 251,
        end: 389
    },
    {
        start: 389,
        end: 356
    },
    {
        start: 356,
        end: 454
    },
    {
        start: 454,
        end: 323
    },
    {
        start: 323,
        end: 361
    },
    {
        start: 361,
        end: 288
    },
    {
        start: 288,
        end: 397
    },
    {
        start: 397,
        end: 365
    },
    {
        start: 365,
        end: 379
    },
    {
        start: 379,
        end: 378
    },
    {
        start: 378,
        end: 400
    },
    {
        start: 400,
        end: 377
    },
    {
        start: 377,
        end: 152
    },
    {
        start: 152,
        end: 148
    },
    {
        start: 148,
        end: 176
    },
    {
        start: 176,
        end: 149
    },
    {
        start: 149,
        end: 150
    },
    {
        start: 150,
        end: 136
    },
    {
        start: 136,
        end: 172
    },
    {
        start: 172,
        end: 58
    },
    {
        start: 58,
        end: 132
    },
    {
        start: 132,
        end: 93
    },
    {
        start: 93,
        end: 234
    },
    {
        start: 234,
        end: 127
    },
    {
        start: 127,
        end: 162
    },
    {
        start: 162,
        end: 21
    },
    {
        start: 21,
        end: 54
    },
    {
        start: 54,
        end: 103
    },
    {
        start: 103,
        end: 67
    },
    {
        start: 67,
        end: 109
    },
    {
        start: 109,
        end: 10
    }
], exports.FACE_LANDMARKS_CONTOURS = [
    ...exports.FACE_LANDMARKS_LIPS,
    ...exports.FACE_LANDMARKS_LEFT_EYE,
    ...exports.FACE_LANDMARKS_LEFT_EYEBROW,
    ...exports.FACE_LANDMARKS_RIGHT_EYE,
    ...exports.FACE_LANDMARKS_RIGHT_EYEBROW,
    ...exports.FACE_LANDMARKS_FACE_OVAL
], exports.FACE_LANDMARKS_TESSELATION = [
    {
        start: 127,
        end: 34
    },
    {
        start: 34,
        end: 139
    },
    {
        start: 139,
        end: 127
    },
    {
        start: 11,
        end: 0
    },
    {
        start: 0,
        end: 37
    },
    {
        start: 37,
        end: 11
    },
    {
        start: 232,
        end: 231
    },
    {
        start: 231,
        end: 120
    },
    {
        start: 120,
        end: 232
    },
    {
        start: 72,
        end: 37
    },
    {
        start: 37,
        end: 39
    },
    {
        start: 39,
        end: 72
    },
    {
        start: 128,
        end: 121
    },
    {
        start: 121,
        end: 47
    },
    {
        start: 47,
        end: 128
    },
    {
        start: 232,
        end: 121
    },
    {
        start: 121,
        end: 128
    },
    {
        start: 128,
        end: 232
    },
    {
        start: 104,
        end: 69
    },
    {
        start: 69,
        end: 67
    },
    {
        start: 67,
        end: 104
    },
    {
        start: 175,
        end: 171
    },
    {
        start: 171,
        end: 148
    },
    {
        start: 148,
        end: 175
    },
    {
        start: 118,
        end: 50
    },
    {
        start: 50,
        end: 101
    },
    {
        start: 101,
        end: 118
    },
    {
        start: 73,
        end: 39
    },
    {
        start: 39,
        end: 40
    },
    {
        start: 40,
        end: 73
    },
    {
        start: 9,
        end: 151
    },
    {
        start: 151,
        end: 108
    },
    {
        start: 108,
        end: 9
    },
    {
        start: 48,
        end: 115
    },
    {
        start: 115,
        end: 131
    },
    {
        start: 131,
        end: 48
    },
    {
        start: 194,
        end: 204
    },
    {
        start: 204,
        end: 211
    },
    {
        start: 211,
        end: 194
    },
    {
        start: 74,
        end: 40
    },
    {
        start: 40,
        end: 185
    },
    {
        start: 185,
        end: 74
    },
    {
        start: 80,
        end: 42
    },
    {
        start: 42,
        end: 183
    },
    {
        start: 183,
        end: 80
    },
    {
        start: 40,
        end: 92
    },
    {
        start: 92,
        end: 186
    },
    {
        start: 186,
        end: 40
    },
    {
        start: 230,
        end: 229
    },
    {
        start: 229,
        end: 118
    },
    {
        start: 118,
        end: 230
    },
    {
        start: 202,
        end: 212
    },
    {
        start: 212,
        end: 214
    },
    {
        start: 214,
        end: 202
    },
    {
        start: 83,
        end: 18
    },
    {
        start: 18,
        end: 17
    },
    {
        start: 17,
        end: 83
    },
    {
        start: 76,
        end: 61
    },
    {
        start: 61,
        end: 146
    },
    {
        start: 146,
        end: 76
    },
    {
        start: 160,
        end: 29
    },
    {
        start: 29,
        end: 30
    },
    {
        start: 30,
        end: 160
    },
    {
        start: 56,
        end: 157
    },
    {
        start: 157,
        end: 173
    },
    {
        start: 173,
        end: 56
    },
    {
        start: 106,
        end: 204
    },
    {
        start: 204,
        end: 194
    },
    {
        start: 194,
        end: 106
    },
    {
        start: 135,
        end: 214
    },
    {
        start: 214,
        end: 192
    },
    {
        start: 192,
        end: 135
    },
    {
        start: 203,
        end: 165
    },
    {
        start: 165,
        end: 98
    },
    {
        start: 98,
        end: 203
    },
    {
        start: 21,
        end: 71
    },
    {
        start: 71,
        end: 68
    },
    {
        start: 68,
        end: 21
    },
    {
        start: 51,
        end: 45
    },
    {
        start: 45,
        end: 4
    },
    {
        start: 4,
        end: 51
    },
    {
        start: 144,
        end: 24
    },
    {
        start: 24,
        end: 23
    },
    {
        start: 23,
        end: 144
    },
    {
        start: 77,
        end: 146
    },
    {
        start: 146,
        end: 91
    },
    {
        start: 91,
        end: 77
    },
    {
        start: 205,
        end: 50
    },
    {
        start: 50,
        end: 187
    },
    {
        start: 187,
        end: 205
    },
    {
        start: 201,
        end: 200
    },
    {
        start: 200,
        end: 18
    },
    {
        start: 18,
        end: 201
    },
    {
        start: 91,
        end: 106
    },
    {
        start: 106,
        end: 182
    },
    {
        start: 182,
        end: 91
    },
    {
        start: 90,
        end: 91
    },
    {
        start: 91,
        end: 181
    },
    {
        start: 181,
        end: 90
    },
    {
        start: 85,
        end: 84
    },
    {
        start: 84,
        end: 17
    },
    {
        start: 17,
        end: 85
    },
    {
        start: 206,
        end: 203
    },
    {
        start: 203,
        end: 36
    },
    {
        start: 36,
        end: 206
    },
    {
        start: 148,
        end: 171
    },
    {
        start: 171,
        end: 140
    },
    {
        start: 140,
        end: 148
    },
    {
        start: 92,
        end: 40
    },
    {
        start: 40,
        end: 39
    },
    {
        start: 39,
        end: 92
    },
    {
        start: 193,
        end: 189
    },
    {
        start: 189,
        end: 244
    },
    {
        start: 244,
        end: 193
    },
    {
        start: 159,
        end: 158
    },
    {
        start: 158,
        end: 28
    },
    {
        start: 28,
        end: 159
    },
    {
        start: 247,
        end: 246
    },
    {
        start: 246,
        end: 161
    },
    {
        start: 161,
        end: 247
    },
    {
        start: 236,
        end: 3
    },
    {
        start: 3,
        end: 196
    },
    {
        start: 196,
        end: 236
    },
    {
        start: 54,
        end: 68
    },
    {
        start: 68,
        end: 104
    },
    {
        start: 104,
        end: 54
    },
    {
        start: 193,
        end: 168
    },
    {
        start: 168,
        end: 8
    },
    {
        start: 8,
        end: 193
    },
    {
        start: 117,
        end: 228
    },
    {
        start: 228,
        end: 31
    },
    {
        start: 31,
        end: 117
    },
    {
        start: 189,
        end: 193
    },
    {
        start: 193,
        end: 55
    },
    {
        start: 55,
        end: 189
    },
    {
        start: 98,
        end: 97
    },
    {
        start: 97,
        end: 99
    },
    {
        start: 99,
        end: 98
    },
    {
        start: 126,
        end: 47
    },
    {
        start: 47,
        end: 100
    },
    {
        start: 100,
        end: 126
    },
    {
        start: 166,
        end: 79
    },
    {
        start: 79,
        end: 218
    },
    {
        start: 218,
        end: 166
    },
    {
        start: 155,
        end: 154
    },
    {
        start: 154,
        end: 26
    },
    {
        start: 26,
        end: 155
    },
    {
        start: 209,
        end: 49
    },
    {
        start: 49,
        end: 131
    },
    {
        start: 131,
        end: 209
    },
    {
        start: 135,
        end: 136
    },
    {
        start: 136,
        end: 150
    },
    {
        start: 150,
        end: 135
    },
    {
        start: 47,
        end: 126
    },
    {
        start: 126,
        end: 217
    },
    {
        start: 217,
        end: 47
    },
    {
        start: 223,
        end: 52
    },
    {
        start: 52,
        end: 53
    },
    {
        start: 53,
        end: 223
    },
    {
        start: 45,
        end: 51
    },
    {
        start: 51,
        end: 134
    },
    {
        start: 134,
        end: 45
    },
    {
        start: 211,
        end: 170
    },
    {
        start: 170,
        end: 140
    },
    {
        start: 140,
        end: 211
    },
    {
        start: 67,
        end: 69
    },
    {
        start: 69,
        end: 108
    },
    {
        start: 108,
        end: 67
    },
    {
        start: 43,
        end: 106
    },
    {
        start: 106,
        end: 91
    },
    {
        start: 91,
        end: 43
    },
    {
        start: 230,
        end: 119
    },
    {
        start: 119,
        end: 120
    },
    {
        start: 120,
        end: 230
    },
    {
        start: 226,
        end: 130
    },
    {
        start: 130,
        end: 247
    },
    {
        start: 247,
        end: 226
    },
    {
        start: 63,
        end: 53
    },
    {
        start: 53,
        end: 52
    },
    {
        start: 52,
        end: 63
    },
    {
        start: 238,
        end: 20
    },
    {
        start: 20,
        end: 242
    },
    {
        start: 242,
        end: 238
    },
    {
        start: 46,
        end: 70
    },
    {
        start: 70,
        end: 156
    },
    {
        start: 156,
        end: 46
    },
    {
        start: 78,
        end: 62
    },
    {
        start: 62,
        end: 96
    },
    {
        start: 96,
        end: 78
    },
    {
        start: 46,
        end: 53
    },
    {
        start: 53,
        end: 63
    },
    {
        start: 63,
        end: 46
    },
    {
        start: 143,
        end: 34
    },
    {
        start: 34,
        end: 227
    },
    {
        start: 227,
        end: 143
    },
    {
        start: 123,
        end: 117
    },
    {
        start: 117,
        end: 111
    },
    {
        start: 111,
        end: 123
    },
    {
        start: 44,
        end: 125
    },
    {
        start: 125,
        end: 19
    },
    {
        start: 19,
        end: 44
    },
    {
        start: 236,
        end: 134
    },
    {
        start: 134,
        end: 51
    },
    {
        start: 51,
        end: 236
    },
    {
        start: 216,
        end: 206
    },
    {
        start: 206,
        end: 205
    },
    {
        start: 205,
        end: 216
    },
    {
        start: 154,
        end: 153
    },
    {
        start: 153,
        end: 22
    },
    {
        start: 22,
        end: 154
    },
    {
        start: 39,
        end: 37
    },
    {
        start: 37,
        end: 167
    },
    {
        start: 167,
        end: 39
    },
    {
        start: 200,
        end: 201
    },
    {
        start: 201,
        end: 208
    },
    {
        start: 208,
        end: 200
    },
    {
        start: 36,
        end: 142
    },
    {
        start: 142,
        end: 100
    },
    {
        start: 100,
        end: 36
    },
    {
        start: 57,
        end: 212
    },
    {
        start: 212,
        end: 202
    },
    {
        start: 202,
        end: 57
    },
    {
        start: 20,
        end: 60
    },
    {
        start: 60,
        end: 99
    },
    {
        start: 99,
        end: 20
    },
    {
        start: 28,
        end: 158
    },
    {
        start: 158,
        end: 157
    },
    {
        start: 157,
        end: 28
    },
    {
        start: 35,
        end: 226
    },
    {
        start: 226,
        end: 113
    },
    {
        start: 113,
        end: 35
    },
    {
        start: 160,
        end: 159
    },
    {
        start: 159,
        end: 27
    },
    {
        start: 27,
        end: 160
    },
    {
        start: 204,
        end: 202
    },
    {
        start: 202,
        end: 210
    },
    {
        start: 210,
        end: 204
    },
    {
        start: 113,
        end: 225
    },
    {
        start: 225,
        end: 46
    },
    {
        start: 46,
        end: 113
    },
    {
        start: 43,
        end: 202
    },
    {
        start: 202,
        end: 204
    },
    {
        start: 204,
        end: 43
    },
    {
        start: 62,
        end: 76
    },
    {
        start: 76,
        end: 77
    },
    {
        start: 77,
        end: 62
    },
    {
        start: 137,
        end: 123
    },
    {
        start: 123,
        end: 116
    },
    {
        start: 116,
        end: 137
    },
    {
        start: 41,
        end: 38
    },
    {
        start: 38,
        end: 72
    },
    {
        start: 72,
        end: 41
    },
    {
        start: 203,
        end: 129
    },
    {
        start: 129,
        end: 142
    },
    {
        start: 142,
        end: 203
    },
    {
        start: 64,
        end: 98
    },
    {
        start: 98,
        end: 240
    },
    {
        start: 240,
        end: 64
    },
    {
        start: 49,
        end: 102
    },
    {
        start: 102,
        end: 64
    },
    {
        start: 64,
        end: 49
    },
    {
        start: 41,
        end: 73
    },
    {
        start: 73,
        end: 74
    },
    {
        start: 74,
        end: 41
    },
    {
        start: 212,
        end: 216
    },
    {
        start: 216,
        end: 207
    },
    {
        start: 207,
        end: 212
    },
    {
        start: 42,
        end: 74
    },
    {
        start: 74,
        end: 184
    },
    {
        start: 184,
        end: 42
    },
    {
        start: 169,
        end: 170
    },
    {
        start: 170,
        end: 211
    },
    {
        start: 211,
        end: 169
    },
    {
        start: 170,
        end: 149
    },
    {
        start: 149,
        end: 176
    },
    {
        start: 176,
        end: 170
    },
    {
        start: 105,
        end: 66
    },
    {
        start: 66,
        end: 69
    },
    {
        start: 69,
        end: 105
    },
    {
        start: 122,
        end: 6
    },
    {
        start: 6,
        end: 168
    },
    {
        start: 168,
        end: 122
    },
    {
        start: 123,
        end: 147
    },
    {
        start: 147,
        end: 187
    },
    {
        start: 187,
        end: 123
    },
    {
        start: 96,
        end: 77
    },
    {
        start: 77,
        end: 90
    },
    {
        start: 90,
        end: 96
    },
    {
        start: 65,
        end: 55
    },
    {
        start: 55,
        end: 107
    },
    {
        start: 107,
        end: 65
    },
    {
        start: 89,
        end: 90
    },
    {
        start: 90,
        end: 180
    },
    {
        start: 180,
        end: 89
    },
    {
        start: 101,
        end: 100
    },
    {
        start: 100,
        end: 120
    },
    {
        start: 120,
        end: 101
    },
    {
        start: 63,
        end: 105
    },
    {
        start: 105,
        end: 104
    },
    {
        start: 104,
        end: 63
    },
    {
        start: 93,
        end: 137
    },
    {
        start: 137,
        end: 227
    },
    {
        start: 227,
        end: 93
    },
    {
        start: 15,
        end: 86
    },
    {
        start: 86,
        end: 85
    },
    {
        start: 85,
        end: 15
    },
    {
        start: 129,
        end: 102
    },
    {
        start: 102,
        end: 49
    },
    {
        start: 49,
        end: 129
    },
    {
        start: 14,
        end: 87
    },
    {
        start: 87,
        end: 86
    },
    {
        start: 86,
        end: 14
    },
    {
        start: 55,
        end: 8
    },
    {
        start: 8,
        end: 9
    },
    {
        start: 9,
        end: 55
    },
    {
        start: 100,
        end: 47
    },
    {
        start: 47,
        end: 121
    },
    {
        start: 121,
        end: 100
    },
    {
        start: 145,
        end: 23
    },
    {
        start: 23,
        end: 22
    },
    {
        start: 22,
        end: 145
    },
    {
        start: 88,
        end: 89
    },
    {
        start: 89,
        end: 179
    },
    {
        start: 179,
        end: 88
    },
    {
        start: 6,
        end: 122
    },
    {
        start: 122,
        end: 196
    },
    {
        start: 196,
        end: 6
    },
    {
        start: 88,
        end: 95
    },
    {
        start: 95,
        end: 96
    },
    {
        start: 96,
        end: 88
    },
    {
        start: 138,
        end: 172
    },
    {
        start: 172,
        end: 136
    },
    {
        start: 136,
        end: 138
    },
    {
        start: 215,
        end: 58
    },
    {
        start: 58,
        end: 172
    },
    {
        start: 172,
        end: 215
    },
    {
        start: 115,
        end: 48
    },
    {
        start: 48,
        end: 219
    },
    {
        start: 219,
        end: 115
    },
    {
        start: 42,
        end: 80
    },
    {
        start: 80,
        end: 81
    },
    {
        start: 81,
        end: 42
    },
    {
        start: 195,
        end: 3
    },
    {
        start: 3,
        end: 51
    },
    {
        start: 51,
        end: 195
    },
    {
        start: 43,
        end: 146
    },
    {
        start: 146,
        end: 61
    },
    {
        start: 61,
        end: 43
    },
    {
        start: 171,
        end: 175
    },
    {
        start: 175,
        end: 199
    },
    {
        start: 199,
        end: 171
    },
    {
        start: 81,
        end: 82
    },
    {
        start: 82,
        end: 38
    },
    {
        start: 38,
        end: 81
    },
    {
        start: 53,
        end: 46
    },
    {
        start: 46,
        end: 225
    },
    {
        start: 225,
        end: 53
    },
    {
        start: 144,
        end: 163
    },
    {
        start: 163,
        end: 110
    },
    {
        start: 110,
        end: 144
    },
    {
        start: 52,
        end: 65
    },
    {
        start: 65,
        end: 66
    },
    {
        start: 66,
        end: 52
    },
    {
        start: 229,
        end: 228
    },
    {
        start: 228,
        end: 117
    },
    {
        start: 117,
        end: 229
    },
    {
        start: 34,
        end: 127
    },
    {
        start: 127,
        end: 234
    },
    {
        start: 234,
        end: 34
    },
    {
        start: 107,
        end: 108
    },
    {
        start: 108,
        end: 69
    },
    {
        start: 69,
        end: 107
    },
    {
        start: 109,
        end: 108
    },
    {
        start: 108,
        end: 151
    },
    {
        start: 151,
        end: 109
    },
    {
        start: 48,
        end: 64
    },
    {
        start: 64,
        end: 235
    },
    {
        start: 235,
        end: 48
    },
    {
        start: 62,
        end: 78
    },
    {
        start: 78,
        end: 191
    },
    {
        start: 191,
        end: 62
    },
    {
        start: 129,
        end: 209
    },
    {
        start: 209,
        end: 126
    },
    {
        start: 126,
        end: 129
    },
    {
        start: 111,
        end: 35
    },
    {
        start: 35,
        end: 143
    },
    {
        start: 143,
        end: 111
    },
    {
        start: 117,
        end: 123
    },
    {
        start: 123,
        end: 50
    },
    {
        start: 50,
        end: 117
    },
    {
        start: 222,
        end: 65
    },
    {
        start: 65,
        end: 52
    },
    {
        start: 52,
        end: 222
    },
    {
        start: 19,
        end: 125
    },
    {
        start: 125,
        end: 141
    },
    {
        start: 141,
        end: 19
    },
    {
        start: 221,
        end: 55
    },
    {
        start: 55,
        end: 65
    },
    {
        start: 65,
        end: 221
    },
    {
        start: 3,
        end: 195
    },
    {
        start: 195,
        end: 197
    },
    {
        start: 197,
        end: 3
    },
    {
        start: 25,
        end: 7
    },
    {
        start: 7,
        end: 33
    },
    {
        start: 33,
        end: 25
    },
    {
        start: 220,
        end: 237
    },
    {
        start: 237,
        end: 44
    },
    {
        start: 44,
        end: 220
    },
    {
        start: 70,
        end: 71
    },
    {
        start: 71,
        end: 139
    },
    {
        start: 139,
        end: 70
    },
    {
        start: 122,
        end: 193
    },
    {
        start: 193,
        end: 245
    },
    {
        start: 245,
        end: 122
    },
    {
        start: 247,
        end: 130
    },
    {
        start: 130,
        end: 33
    },
    {
        start: 33,
        end: 247
    },
    {
        start: 71,
        end: 21
    },
    {
        start: 21,
        end: 162
    },
    {
        start: 162,
        end: 71
    },
    {
        start: 170,
        end: 169
    },
    {
        start: 169,
        end: 150
    },
    {
        start: 150,
        end: 170
    },
    {
        start: 188,
        end: 174
    },
    {
        start: 174,
        end: 196
    },
    {
        start: 196,
        end: 188
    },
    {
        start: 216,
        end: 186
    },
    {
        start: 186,
        end: 92
    },
    {
        start: 92,
        end: 216
    },
    {
        start: 2,
        end: 97
    },
    {
        start: 97,
        end: 167
    },
    {
        start: 167,
        end: 2
    },
    {
        start: 141,
        end: 125
    },
    {
        start: 125,
        end: 241
    },
    {
        start: 241,
        end: 141
    },
    {
        start: 164,
        end: 167
    },
    {
        start: 167,
        end: 37
    },
    {
        start: 37,
        end: 164
    },
    {
        start: 72,
        end: 38
    },
    {
        start: 38,
        end: 12
    },
    {
        start: 12,
        end: 72
    },
    {
        start: 38,
        end: 82
    },
    {
        start: 82,
        end: 13
    },
    {
        start: 13,
        end: 38
    },
    {
        start: 63,
        end: 68
    },
    {
        start: 68,
        end: 71
    },
    {
        start: 71,
        end: 63
    },
    {
        start: 226,
        end: 35
    },
    {
        start: 35,
        end: 111
    },
    {
        start: 111,
        end: 226
    },
    {
        start: 101,
        end: 50
    },
    {
        start: 50,
        end: 205
    },
    {
        start: 205,
        end: 101
    },
    {
        start: 206,
        end: 92
    },
    {
        start: 92,
        end: 165
    },
    {
        start: 165,
        end: 206
    },
    {
        start: 209,
        end: 198
    },
    {
        start: 198,
        end: 217
    },
    {
        start: 217,
        end: 209
    },
    {
        start: 165,
        end: 167
    },
    {
        start: 167,
        end: 97
    },
    {
        start: 97,
        end: 165
    },
    {
        start: 220,
        end: 115
    },
    {
        start: 115,
        end: 218
    },
    {
        start: 218,
        end: 220
    },
    {
        start: 133,
        end: 112
    },
    {
        start: 112,
        end: 243
    },
    {
        start: 243,
        end: 133
    },
    {
        start: 239,
        end: 238
    },
    {
        start: 238,
        end: 241
    },
    {
        start: 241,
        end: 239
    },
    {
        start: 214,
        end: 135
    },
    {
        start: 135,
        end: 169
    },
    {
        start: 169,
        end: 214
    },
    {
        start: 190,
        end: 173
    },
    {
        start: 173,
        end: 133
    },
    {
        start: 133,
        end: 190
    },
    {
        start: 171,
        end: 208
    },
    {
        start: 208,
        end: 32
    },
    {
        start: 32,
        end: 171
    },
    {
        start: 125,
        end: 44
    },
    {
        start: 44,
        end: 237
    },
    {
        start: 237,
        end: 125
    },
    {
        start: 86,
        end: 87
    },
    {
        start: 87,
        end: 178
    },
    {
        start: 178,
        end: 86
    },
    {
        start: 85,
        end: 86
    },
    {
        start: 86,
        end: 179
    },
    {
        start: 179,
        end: 85
    },
    {
        start: 84,
        end: 85
    },
    {
        start: 85,
        end: 180
    },
    {
        start: 180,
        end: 84
    },
    {
        start: 83,
        end: 84
    },
    {
        start: 84,
        end: 181
    },
    {
        start: 181,
        end: 83
    },
    {
        start: 201,
        end: 83
    },
    {
        start: 83,
        end: 182
    },
    {
        start: 182,
        end: 201
    },
    {
        start: 137,
        end: 93
    },
    {
        start: 93,
        end: 132
    },
    {
        start: 132,
        end: 137
    },
    {
        start: 76,
        end: 62
    },
    {
        start: 62,
        end: 183
    },
    {
        start: 183,
        end: 76
    },
    {
        start: 61,
        end: 76
    },
    {
        start: 76,
        end: 184
    },
    {
        start: 184,
        end: 61
    },
    {
        start: 57,
        end: 61
    },
    {
        start: 61,
        end: 185
    },
    {
        start: 185,
        end: 57
    },
    {
        start: 212,
        end: 57
    },
    {
        start: 57,
        end: 186
    },
    {
        start: 186,
        end: 212
    },
    {
        start: 214,
        end: 207
    },
    {
        start: 207,
        end: 187
    },
    {
        start: 187,
        end: 214
    },
    {
        start: 34,
        end: 143
    },
    {
        start: 143,
        end: 156
    },
    {
        start: 156,
        end: 34
    },
    {
        start: 79,
        end: 239
    },
    {
        start: 239,
        end: 237
    },
    {
        start: 237,
        end: 79
    },
    {
        start: 123,
        end: 137
    },
    {
        start: 137,
        end: 177
    },
    {
        start: 177,
        end: 123
    },
    {
        start: 44,
        end: 1
    },
    {
        start: 1,
        end: 4
    },
    {
        start: 4,
        end: 44
    },
    {
        start: 201,
        end: 194
    },
    {
        start: 194,
        end: 32
    },
    {
        start: 32,
        end: 201
    },
    {
        start: 64,
        end: 102
    },
    {
        start: 102,
        end: 129
    },
    {
        start: 129,
        end: 64
    },
    {
        start: 213,
        end: 215
    },
    {
        start: 215,
        end: 138
    },
    {
        start: 138,
        end: 213
    },
    {
        start: 59,
        end: 166
    },
    {
        start: 166,
        end: 219
    },
    {
        start: 219,
        end: 59
    },
    {
        start: 242,
        end: 99
    },
    {
        start: 99,
        end: 97
    },
    {
        start: 97,
        end: 242
    },
    {
        start: 2,
        end: 94
    },
    {
        start: 94,
        end: 141
    },
    {
        start: 141,
        end: 2
    },
    {
        start: 75,
        end: 59
    },
    {
        start: 59,
        end: 235
    },
    {
        start: 235,
        end: 75
    },
    {
        start: 24,
        end: 110
    },
    {
        start: 110,
        end: 228
    },
    {
        start: 228,
        end: 24
    },
    {
        start: 25,
        end: 130
    },
    {
        start: 130,
        end: 226
    },
    {
        start: 226,
        end: 25
    },
    {
        start: 23,
        end: 24
    },
    {
        start: 24,
        end: 229
    },
    {
        start: 229,
        end: 23
    },
    {
        start: 22,
        end: 23
    },
    {
        start: 23,
        end: 230
    },
    {
        start: 230,
        end: 22
    },
    {
        start: 26,
        end: 22
    },
    {
        start: 22,
        end: 231
    },
    {
        start: 231,
        end: 26
    },
    {
        start: 112,
        end: 26
    },
    {
        start: 26,
        end: 232
    },
    {
        start: 232,
        end: 112
    },
    {
        start: 189,
        end: 190
    },
    {
        start: 190,
        end: 243
    },
    {
        start: 243,
        end: 189
    },
    {
        start: 221,
        end: 56
    },
    {
        start: 56,
        end: 190
    },
    {
        start: 190,
        end: 221
    },
    {
        start: 28,
        end: 56
    },
    {
        start: 56,
        end: 221
    },
    {
        start: 221,
        end: 28
    },
    {
        start: 27,
        end: 28
    },
    {
        start: 28,
        end: 222
    },
    {
        start: 222,
        end: 27
    },
    {
        start: 29,
        end: 27
    },
    {
        start: 27,
        end: 223
    },
    {
        start: 223,
        end: 29
    },
    {
        start: 30,
        end: 29
    },
    {
        start: 29,
        end: 224
    },
    {
        start: 224,
        end: 30
    },
    {
        start: 247,
        end: 30
    },
    {
        start: 30,
        end: 225
    },
    {
        start: 225,
        end: 247
    },
    {
        start: 238,
        end: 79
    },
    {
        start: 79,
        end: 20
    },
    {
        start: 20,
        end: 238
    },
    {
        start: 166,
        end: 59
    },
    {
        start: 59,
        end: 75
    },
    {
        start: 75,
        end: 166
    },
    {
        start: 60,
        end: 75
    },
    {
        start: 75,
        end: 240
    },
    {
        start: 240,
        end: 60
    },
    {
        start: 147,
        end: 177
    },
    {
        start: 177,
        end: 215
    },
    {
        start: 215,
        end: 147
    },
    {
        start: 20,
        end: 79
    },
    {
        start: 79,
        end: 166
    },
    {
        start: 166,
        end: 20
    },
    {
        start: 187,
        end: 147
    },
    {
        start: 147,
        end: 213
    },
    {
        start: 213,
        end: 187
    },
    {
        start: 112,
        end: 233
    },
    {
        start: 233,
        end: 244
    },
    {
        start: 244,
        end: 112
    },
    {
        start: 233,
        end: 128
    },
    {
        start: 128,
        end: 245
    },
    {
        start: 245,
        end: 233
    },
    {
        start: 128,
        end: 114
    },
    {
        start: 114,
        end: 188
    },
    {
        start: 188,
        end: 128
    },
    {
        start: 114,
        end: 217
    },
    {
        start: 217,
        end: 174
    },
    {
        start: 174,
        end: 114
    },
    {
        start: 131,
        end: 115
    },
    {
        start: 115,
        end: 220
    },
    {
        start: 220,
        end: 131
    },
    {
        start: 217,
        end: 198
    },
    {
        start: 198,
        end: 236
    },
    {
        start: 236,
        end: 217
    },
    {
        start: 198,
        end: 131
    },
    {
        start: 131,
        end: 134
    },
    {
        start: 134,
        end: 198
    },
    {
        start: 177,
        end: 132
    },
    {
        start: 132,
        end: 58
    },
    {
        start: 58,
        end: 177
    },
    {
        start: 143,
        end: 35
    },
    {
        start: 35,
        end: 124
    },
    {
        start: 124,
        end: 143
    },
    {
        start: 110,
        end: 163
    },
    {
        start: 163,
        end: 7
    },
    {
        start: 7,
        end: 110
    },
    {
        start: 228,
        end: 110
    },
    {
        start: 110,
        end: 25
    },
    {
        start: 25,
        end: 228
    },
    {
        start: 356,
        end: 389
    },
    {
        start: 389,
        end: 368
    },
    {
        start: 368,
        end: 356
    },
    {
        start: 11,
        end: 302
    },
    {
        start: 302,
        end: 267
    },
    {
        start: 267,
        end: 11
    },
    {
        start: 452,
        end: 350
    },
    {
        start: 350,
        end: 349
    },
    {
        start: 349,
        end: 452
    },
    {
        start: 302,
        end: 303
    },
    {
        start: 303,
        end: 269
    },
    {
        start: 269,
        end: 302
    },
    {
        start: 357,
        end: 343
    },
    {
        start: 343,
        end: 277
    },
    {
        start: 277,
        end: 357
    },
    {
        start: 452,
        end: 453
    },
    {
        start: 453,
        end: 357
    },
    {
        start: 357,
        end: 452
    },
    {
        start: 333,
        end: 332
    },
    {
        start: 332,
        end: 297
    },
    {
        start: 297,
        end: 333
    },
    {
        start: 175,
        end: 152
    },
    {
        start: 152,
        end: 377
    },
    {
        start: 377,
        end: 175
    },
    {
        start: 347,
        end: 348
    },
    {
        start: 348,
        end: 330
    },
    {
        start: 330,
        end: 347
    },
    {
        start: 303,
        end: 304
    },
    {
        start: 304,
        end: 270
    },
    {
        start: 270,
        end: 303
    },
    {
        start: 9,
        end: 336
    },
    {
        start: 336,
        end: 337
    },
    {
        start: 337,
        end: 9
    },
    {
        start: 278,
        end: 279
    },
    {
        start: 279,
        end: 360
    },
    {
        start: 360,
        end: 278
    },
    {
        start: 418,
        end: 262
    },
    {
        start: 262,
        end: 431
    },
    {
        start: 431,
        end: 418
    },
    {
        start: 304,
        end: 408
    },
    {
        start: 408,
        end: 409
    },
    {
        start: 409,
        end: 304
    },
    {
        start: 310,
        end: 415
    },
    {
        start: 415,
        end: 407
    },
    {
        start: 407,
        end: 310
    },
    {
        start: 270,
        end: 409
    },
    {
        start: 409,
        end: 410
    },
    {
        start: 410,
        end: 270
    },
    {
        start: 450,
        end: 348
    },
    {
        start: 348,
        end: 347
    },
    {
        start: 347,
        end: 450
    },
    {
        start: 422,
        end: 430
    },
    {
        start: 430,
        end: 434
    },
    {
        start: 434,
        end: 422
    },
    {
        start: 313,
        end: 314
    },
    {
        start: 314,
        end: 17
    },
    {
        start: 17,
        end: 313
    },
    {
        start: 306,
        end: 307
    },
    {
        start: 307,
        end: 375
    },
    {
        start: 375,
        end: 306
    },
    {
        start: 387,
        end: 388
    },
    {
        start: 388,
        end: 260
    },
    {
        start: 260,
        end: 387
    },
    {
        start: 286,
        end: 414
    },
    {
        start: 414,
        end: 398
    },
    {
        start: 398,
        end: 286
    },
    {
        start: 335,
        end: 406
    },
    {
        start: 406,
        end: 418
    },
    {
        start: 418,
        end: 335
    },
    {
        start: 364,
        end: 367
    },
    {
        start: 367,
        end: 416
    },
    {
        start: 416,
        end: 364
    },
    {
        start: 423,
        end: 358
    },
    {
        start: 358,
        end: 327
    },
    {
        start: 327,
        end: 423
    },
    {
        start: 251,
        end: 284
    },
    {
        start: 284,
        end: 298
    },
    {
        start: 298,
        end: 251
    },
    {
        start: 281,
        end: 5
    },
    {
        start: 5,
        end: 4
    },
    {
        start: 4,
        end: 281
    },
    {
        start: 373,
        end: 374
    },
    {
        start: 374,
        end: 253
    },
    {
        start: 253,
        end: 373
    },
    {
        start: 307,
        end: 320
    },
    {
        start: 320,
        end: 321
    },
    {
        start: 321,
        end: 307
    },
    {
        start: 425,
        end: 427
    },
    {
        start: 427,
        end: 411
    },
    {
        start: 411,
        end: 425
    },
    {
        start: 421,
        end: 313
    },
    {
        start: 313,
        end: 18
    },
    {
        start: 18,
        end: 421
    },
    {
        start: 321,
        end: 405
    },
    {
        start: 405,
        end: 406
    },
    {
        start: 406,
        end: 321
    },
    {
        start: 320,
        end: 404
    },
    {
        start: 404,
        end: 405
    },
    {
        start: 405,
        end: 320
    },
    {
        start: 315,
        end: 16
    },
    {
        start: 16,
        end: 17
    },
    {
        start: 17,
        end: 315
    },
    {
        start: 426,
        end: 425
    },
    {
        start: 425,
        end: 266
    },
    {
        start: 266,
        end: 426
    },
    {
        start: 377,
        end: 400
    },
    {
        start: 400,
        end: 369
    },
    {
        start: 369,
        end: 377
    },
    {
        start: 322,
        end: 391
    },
    {
        start: 391,
        end: 269
    },
    {
        start: 269,
        end: 322
    },
    {
        start: 417,
        end: 465
    },
    {
        start: 465,
        end: 464
    },
    {
        start: 464,
        end: 417
    },
    {
        start: 386,
        end: 257
    },
    {
        start: 257,
        end: 258
    },
    {
        start: 258,
        end: 386
    },
    {
        start: 466,
        end: 260
    },
    {
        start: 260,
        end: 388
    },
    {
        start: 388,
        end: 466
    },
    {
        start: 456,
        end: 399
    },
    {
        start: 399,
        end: 419
    },
    {
        start: 419,
        end: 456
    },
    {
        start: 284,
        end: 332
    },
    {
        start: 332,
        end: 333
    },
    {
        start: 333,
        end: 284
    },
    {
        start: 417,
        end: 285
    },
    {
        start: 285,
        end: 8
    },
    {
        start: 8,
        end: 417
    },
    {
        start: 346,
        end: 340
    },
    {
        start: 340,
        end: 261
    },
    {
        start: 261,
        end: 346
    },
    {
        start: 413,
        end: 441
    },
    {
        start: 441,
        end: 285
    },
    {
        start: 285,
        end: 413
    },
    {
        start: 327,
        end: 460
    },
    {
        start: 460,
        end: 328
    },
    {
        start: 328,
        end: 327
    },
    {
        start: 355,
        end: 371
    },
    {
        start: 371,
        end: 329
    },
    {
        start: 329,
        end: 355
    },
    {
        start: 392,
        end: 439
    },
    {
        start: 439,
        end: 438
    },
    {
        start: 438,
        end: 392
    },
    {
        start: 382,
        end: 341
    },
    {
        start: 341,
        end: 256
    },
    {
        start: 256,
        end: 382
    },
    {
        start: 429,
        end: 420
    },
    {
        start: 420,
        end: 360
    },
    {
        start: 360,
        end: 429
    },
    {
        start: 364,
        end: 394
    },
    {
        start: 394,
        end: 379
    },
    {
        start: 379,
        end: 364
    },
    {
        start: 277,
        end: 343
    },
    {
        start: 343,
        end: 437
    },
    {
        start: 437,
        end: 277
    },
    {
        start: 443,
        end: 444
    },
    {
        start: 444,
        end: 283
    },
    {
        start: 283,
        end: 443
    },
    {
        start: 275,
        end: 440
    },
    {
        start: 440,
        end: 363
    },
    {
        start: 363,
        end: 275
    },
    {
        start: 431,
        end: 262
    },
    {
        start: 262,
        end: 369
    },
    {
        start: 369,
        end: 431
    },
    {
        start: 297,
        end: 338
    },
    {
        start: 338,
        end: 337
    },
    {
        start: 337,
        end: 297
    },
    {
        start: 273,
        end: 375
    },
    {
        start: 375,
        end: 321
    },
    {
        start: 321,
        end: 273
    },
    {
        start: 450,
        end: 451
    },
    {
        start: 451,
        end: 349
    },
    {
        start: 349,
        end: 450
    },
    {
        start: 446,
        end: 342
    },
    {
        start: 342,
        end: 467
    },
    {
        start: 467,
        end: 446
    },
    {
        start: 293,
        end: 334
    },
    {
        start: 334,
        end: 282
    },
    {
        start: 282,
        end: 293
    },
    {
        start: 458,
        end: 461
    },
    {
        start: 461,
        end: 462
    },
    {
        start: 462,
        end: 458
    },
    {
        start: 276,
        end: 353
    },
    {
        start: 353,
        end: 383
    },
    {
        start: 383,
        end: 276
    },
    {
        start: 308,
        end: 324
    },
    {
        start: 324,
        end: 325
    },
    {
        start: 325,
        end: 308
    },
    {
        start: 276,
        end: 300
    },
    {
        start: 300,
        end: 293
    },
    {
        start: 293,
        end: 276
    },
    {
        start: 372,
        end: 345
    },
    {
        start: 345,
        end: 447
    },
    {
        start: 447,
        end: 372
    },
    {
        start: 352,
        end: 345
    },
    {
        start: 345,
        end: 340
    },
    {
        start: 340,
        end: 352
    },
    {
        start: 274,
        end: 1
    },
    {
        start: 1,
        end: 19
    },
    {
        start: 19,
        end: 274
    },
    {
        start: 456,
        end: 248
    },
    {
        start: 248,
        end: 281
    },
    {
        start: 281,
        end: 456
    },
    {
        start: 436,
        end: 427
    },
    {
        start: 427,
        end: 425
    },
    {
        start: 425,
        end: 436
    },
    {
        start: 381,
        end: 256
    },
    {
        start: 256,
        end: 252
    },
    {
        start: 252,
        end: 381
    },
    {
        start: 269,
        end: 391
    },
    {
        start: 391,
        end: 393
    },
    {
        start: 393,
        end: 269
    },
    {
        start: 200,
        end: 199
    },
    {
        start: 199,
        end: 428
    },
    {
        start: 428,
        end: 200
    },
    {
        start: 266,
        end: 330
    },
    {
        start: 330,
        end: 329
    },
    {
        start: 329,
        end: 266
    },
    {
        start: 287,
        end: 273
    },
    {
        start: 273,
        end: 422
    },
    {
        start: 422,
        end: 287
    },
    {
        start: 250,
        end: 462
    },
    {
        start: 462,
        end: 328
    },
    {
        start: 328,
        end: 250
    },
    {
        start: 258,
        end: 286
    },
    {
        start: 286,
        end: 384
    },
    {
        start: 384,
        end: 258
    },
    {
        start: 265,
        end: 353
    },
    {
        start: 353,
        end: 342
    },
    {
        start: 342,
        end: 265
    },
    {
        start: 387,
        end: 259
    },
    {
        start: 259,
        end: 257
    },
    {
        start: 257,
        end: 387
    },
    {
        start: 424,
        end: 431
    },
    {
        start: 431,
        end: 430
    },
    {
        start: 430,
        end: 424
    },
    {
        start: 342,
        end: 353
    },
    {
        start: 353,
        end: 276
    },
    {
        start: 276,
        end: 342
    },
    {
        start: 273,
        end: 335
    },
    {
        start: 335,
        end: 424
    },
    {
        start: 424,
        end: 273
    },
    {
        start: 292,
        end: 325
    },
    {
        start: 325,
        end: 307
    },
    {
        start: 307,
        end: 292
    },
    {
        start: 366,
        end: 447
    },
    {
        start: 447,
        end: 345
    },
    {
        start: 345,
        end: 366
    },
    {
        start: 271,
        end: 303
    },
    {
        start: 303,
        end: 302
    },
    {
        start: 302,
        end: 271
    },
    {
        start: 423,
        end: 266
    },
    {
        start: 266,
        end: 371
    },
    {
        start: 371,
        end: 423
    },
    {
        start: 294,
        end: 455
    },
    {
        start: 455,
        end: 460
    },
    {
        start: 460,
        end: 294
    },
    {
        start: 279,
        end: 278
    },
    {
        start: 278,
        end: 294
    },
    {
        start: 294,
        end: 279
    },
    {
        start: 271,
        end: 272
    },
    {
        start: 272,
        end: 304
    },
    {
        start: 304,
        end: 271
    },
    {
        start: 432,
        end: 434
    },
    {
        start: 434,
        end: 427
    },
    {
        start: 427,
        end: 432
    },
    {
        start: 272,
        end: 407
    },
    {
        start: 407,
        end: 408
    },
    {
        start: 408,
        end: 272
    },
    {
        start: 394,
        end: 430
    },
    {
        start: 430,
        end: 431
    },
    {
        start: 431,
        end: 394
    },
    {
        start: 395,
        end: 369
    },
    {
        start: 369,
        end: 400
    },
    {
        start: 400,
        end: 395
    },
    {
        start: 334,
        end: 333
    },
    {
        start: 333,
        end: 299
    },
    {
        start: 299,
        end: 334
    },
    {
        start: 351,
        end: 417
    },
    {
        start: 417,
        end: 168
    },
    {
        start: 168,
        end: 351
    },
    {
        start: 352,
        end: 280
    },
    {
        start: 280,
        end: 411
    },
    {
        start: 411,
        end: 352
    },
    {
        start: 325,
        end: 319
    },
    {
        start: 319,
        end: 320
    },
    {
        start: 320,
        end: 325
    },
    {
        start: 295,
        end: 296
    },
    {
        start: 296,
        end: 336
    },
    {
        start: 336,
        end: 295
    },
    {
        start: 319,
        end: 403
    },
    {
        start: 403,
        end: 404
    },
    {
        start: 404,
        end: 319
    },
    {
        start: 330,
        end: 348
    },
    {
        start: 348,
        end: 349
    },
    {
        start: 349,
        end: 330
    },
    {
        start: 293,
        end: 298
    },
    {
        start: 298,
        end: 333
    },
    {
        start: 333,
        end: 293
    },
    {
        start: 323,
        end: 454
    },
    {
        start: 454,
        end: 447
    },
    {
        start: 447,
        end: 323
    },
    {
        start: 15,
        end: 16
    },
    {
        start: 16,
        end: 315
    },
    {
        start: 315,
        end: 15
    },
    {
        start: 358,
        end: 429
    },
    {
        start: 429,
        end: 279
    },
    {
        start: 279,
        end: 358
    },
    {
        start: 14,
        end: 15
    },
    {
        start: 15,
        end: 316
    },
    {
        start: 316,
        end: 14
    },
    {
        start: 285,
        end: 336
    },
    {
        start: 336,
        end: 9
    },
    {
        start: 9,
        end: 285
    },
    {
        start: 329,
        end: 349
    },
    {
        start: 349,
        end: 350
    },
    {
        start: 350,
        end: 329
    },
    {
        start: 374,
        end: 380
    },
    {
        start: 380,
        end: 252
    },
    {
        start: 252,
        end: 374
    },
    {
        start: 318,
        end: 402
    },
    {
        start: 402,
        end: 403
    },
    {
        start: 403,
        end: 318
    },
    {
        start: 6,
        end: 197
    },
    {
        start: 197,
        end: 419
    },
    {
        start: 419,
        end: 6
    },
    {
        start: 318,
        end: 319
    },
    {
        start: 319,
        end: 325
    },
    {
        start: 325,
        end: 318
    },
    {
        start: 367,
        end: 364
    },
    {
        start: 364,
        end: 365
    },
    {
        start: 365,
        end: 367
    },
    {
        start: 435,
        end: 367
    },
    {
        start: 367,
        end: 397
    },
    {
        start: 397,
        end: 435
    },
    {
        start: 344,
        end: 438
    },
    {
        start: 438,
        end: 439
    },
    {
        start: 439,
        end: 344
    },
    {
        start: 272,
        end: 271
    },
    {
        start: 271,
        end: 311
    },
    {
        start: 311,
        end: 272
    },
    {
        start: 195,
        end: 5
    },
    {
        start: 5,
        end: 281
    },
    {
        start: 281,
        end: 195
    },
    {
        start: 273,
        end: 287
    },
    {
        start: 287,
        end: 291
    },
    {
        start: 291,
        end: 273
    },
    {
        start: 396,
        end: 428
    },
    {
        start: 428,
        end: 199
    },
    {
        start: 199,
        end: 396
    },
    {
        start: 311,
        end: 271
    },
    {
        start: 271,
        end: 268
    },
    {
        start: 268,
        end: 311
    },
    {
        start: 283,
        end: 444
    },
    {
        start: 444,
        end: 445
    },
    {
        start: 445,
        end: 283
    },
    {
        start: 373,
        end: 254
    },
    {
        start: 254,
        end: 339
    },
    {
        start: 339,
        end: 373
    },
    {
        start: 282,
        end: 334
    },
    {
        start: 334,
        end: 296
    },
    {
        start: 296,
        end: 282
    },
    {
        start: 449,
        end: 347
    },
    {
        start: 347,
        end: 346
    },
    {
        start: 346,
        end: 449
    },
    {
        start: 264,
        end: 447
    },
    {
        start: 447,
        end: 454
    },
    {
        start: 454,
        end: 264
    },
    {
        start: 336,
        end: 296
    },
    {
        start: 296,
        end: 299
    },
    {
        start: 299,
        end: 336
    },
    {
        start: 338,
        end: 10
    },
    {
        start: 10,
        end: 151
    },
    {
        start: 151,
        end: 338
    },
    {
        start: 278,
        end: 439
    },
    {
        start: 439,
        end: 455
    },
    {
        start: 455,
        end: 278
    },
    {
        start: 292,
        end: 407
    },
    {
        start: 407,
        end: 415
    },
    {
        start: 415,
        end: 292
    },
    {
        start: 358,
        end: 371
    },
    {
        start: 371,
        end: 355
    },
    {
        start: 355,
        end: 358
    },
    {
        start: 340,
        end: 345
    },
    {
        start: 345,
        end: 372
    },
    {
        start: 372,
        end: 340
    },
    {
        start: 346,
        end: 347
    },
    {
        start: 347,
        end: 280
    },
    {
        start: 280,
        end: 346
    },
    {
        start: 442,
        end: 443
    },
    {
        start: 443,
        end: 282
    },
    {
        start: 282,
        end: 442
    },
    {
        start: 19,
        end: 94
    },
    {
        start: 94,
        end: 370
    },
    {
        start: 370,
        end: 19
    },
    {
        start: 441,
        end: 442
    },
    {
        start: 442,
        end: 295
    },
    {
        start: 295,
        end: 441
    },
    {
        start: 248,
        end: 419
    },
    {
        start: 419,
        end: 197
    },
    {
        start: 197,
        end: 248
    },
    {
        start: 263,
        end: 255
    },
    {
        start: 255,
        end: 359
    },
    {
        start: 359,
        end: 263
    },
    {
        start: 440,
        end: 275
    },
    {
        start: 275,
        end: 274
    },
    {
        start: 274,
        end: 440
    },
    {
        start: 300,
        end: 383
    },
    {
        start: 383,
        end: 368
    },
    {
        start: 368,
        end: 300
    },
    {
        start: 351,
        end: 412
    },
    {
        start: 412,
        end: 465
    },
    {
        start: 465,
        end: 351
    },
    {
        start: 263,
        end: 467
    },
    {
        start: 467,
        end: 466
    },
    {
        start: 466,
        end: 263
    },
    {
        start: 301,
        end: 368
    },
    {
        start: 368,
        end: 389
    },
    {
        start: 389,
        end: 301
    },
    {
        start: 395,
        end: 378
    },
    {
        start: 378,
        end: 379
    },
    {
        start: 379,
        end: 395
    },
    {
        start: 412,
        end: 351
    },
    {
        start: 351,
        end: 419
    },
    {
        start: 419,
        end: 412
    },
    {
        start: 436,
        end: 426
    },
    {
        start: 426,
        end: 322
    },
    {
        start: 322,
        end: 436
    },
    {
        start: 2,
        end: 164
    },
    {
        start: 164,
        end: 393
    },
    {
        start: 393,
        end: 2
    },
    {
        start: 370,
        end: 462
    },
    {
        start: 462,
        end: 461
    },
    {
        start: 461,
        end: 370
    },
    {
        start: 164,
        end: 0
    },
    {
        start: 0,
        end: 267
    },
    {
        start: 267,
        end: 164
    },
    {
        start: 302,
        end: 11
    },
    {
        start: 11,
        end: 12
    },
    {
        start: 12,
        end: 302
    },
    {
        start: 268,
        end: 12
    },
    {
        start: 12,
        end: 13
    },
    {
        start: 13,
        end: 268
    },
    {
        start: 293,
        end: 300
    },
    {
        start: 300,
        end: 301
    },
    {
        start: 301,
        end: 293
    },
    {
        start: 446,
        end: 261
    },
    {
        start: 261,
        end: 340
    },
    {
        start: 340,
        end: 446
    },
    {
        start: 330,
        end: 266
    },
    {
        start: 266,
        end: 425
    },
    {
        start: 425,
        end: 330
    },
    {
        start: 426,
        end: 423
    },
    {
        start: 423,
        end: 391
    },
    {
        start: 391,
        end: 426
    },
    {
        start: 429,
        end: 355
    },
    {
        start: 355,
        end: 437
    },
    {
        start: 437,
        end: 429
    },
    {
        start: 391,
        end: 327
    },
    {
        start: 327,
        end: 326
    },
    {
        start: 326,
        end: 391
    },
    {
        start: 440,
        end: 457
    },
    {
        start: 457,
        end: 438
    },
    {
        start: 438,
        end: 440
    },
    {
        start: 341,
        end: 382
    },
    {
        start: 382,
        end: 362
    },
    {
        start: 362,
        end: 341
    },
    {
        start: 459,
        end: 457
    },
    {
        start: 457,
        end: 461
    },
    {
        start: 461,
        end: 459
    },
    {
        start: 434,
        end: 430
    },
    {
        start: 430,
        end: 394
    },
    {
        start: 394,
        end: 434
    },
    {
        start: 414,
        end: 463
    },
    {
        start: 463,
        end: 362
    },
    {
        start: 362,
        end: 414
    },
    {
        start: 396,
        end: 369
    },
    {
        start: 369,
        end: 262
    },
    {
        start: 262,
        end: 396
    },
    {
        start: 354,
        end: 461
    },
    {
        start: 461,
        end: 457
    },
    {
        start: 457,
        end: 354
    },
    {
        start: 316,
        end: 403
    },
    {
        start: 403,
        end: 402
    },
    {
        start: 402,
        end: 316
    },
    {
        start: 315,
        end: 404
    },
    {
        start: 404,
        end: 403
    },
    {
        start: 403,
        end: 315
    },
    {
        start: 314,
        end: 405
    },
    {
        start: 405,
        end: 404
    },
    {
        start: 404,
        end: 314
    },
    {
        start: 313,
        end: 406
    },
    {
        start: 406,
        end: 405
    },
    {
        start: 405,
        end: 313
    },
    {
        start: 421,
        end: 418
    },
    {
        start: 418,
        end: 406
    },
    {
        start: 406,
        end: 421
    },
    {
        start: 366,
        end: 401
    },
    {
        start: 401,
        end: 361
    },
    {
        start: 361,
        end: 366
    },
    {
        start: 306,
        end: 408
    },
    {
        start: 408,
        end: 407
    },
    {
        start: 407,
        end: 306
    },
    {
        start: 291,
        end: 409
    },
    {
        start: 409,
        end: 408
    },
    {
        start: 408,
        end: 291
    },
    {
        start: 287,
        end: 410
    },
    {
        start: 410,
        end: 409
    },
    {
        start: 409,
        end: 287
    },
    {
        start: 432,
        end: 436
    },
    {
        start: 436,
        end: 410
    },
    {
        start: 410,
        end: 432
    },
    {
        start: 434,
        end: 416
    },
    {
        start: 416,
        end: 411
    },
    {
        start: 411,
        end: 434
    },
    {
        start: 264,
        end: 368
    },
    {
        start: 368,
        end: 383
    },
    {
        start: 383,
        end: 264
    },
    {
        start: 309,
        end: 438
    },
    {
        start: 438,
        end: 457
    },
    {
        start: 457,
        end: 309
    },
    {
        start: 352,
        end: 376
    },
    {
        start: 376,
        end: 401
    },
    {
        start: 401,
        end: 352
    },
    {
        start: 274,
        end: 275
    },
    {
        start: 275,
        end: 4
    },
    {
        start: 4,
        end: 274
    },
    {
        start: 421,
        end: 428
    },
    {
        start: 428,
        end: 262
    },
    {
        start: 262,
        end: 421
    },
    {
        start: 294,
        end: 327
    },
    {
        start: 327,
        end: 358
    },
    {
        start: 358,
        end: 294
    },
    {
        start: 433,
        end: 416
    },
    {
        start: 416,
        end: 367
    },
    {
        start: 367,
        end: 433
    },
    {
        start: 289,
        end: 455
    },
    {
        start: 455,
        end: 439
    },
    {
        start: 439,
        end: 289
    },
    {
        start: 462,
        end: 370
    },
    {
        start: 370,
        end: 326
    },
    {
        start: 326,
        end: 462
    },
    {
        start: 2,
        end: 326
    },
    {
        start: 326,
        end: 370
    },
    {
        start: 370,
        end: 2
    },
    {
        start: 305,
        end: 460
    },
    {
        start: 460,
        end: 455
    },
    {
        start: 455,
        end: 305
    },
    {
        start: 254,
        end: 449
    },
    {
        start: 449,
        end: 448
    },
    {
        start: 448,
        end: 254
    },
    {
        start: 255,
        end: 261
    },
    {
        start: 261,
        end: 446
    },
    {
        start: 446,
        end: 255
    },
    {
        start: 253,
        end: 450
    },
    {
        start: 450,
        end: 449
    },
    {
        start: 449,
        end: 253
    },
    {
        start: 252,
        end: 451
    },
    {
        start: 451,
        end: 450
    },
    {
        start: 450,
        end: 252
    },
    {
        start: 256,
        end: 452
    },
    {
        start: 452,
        end: 451
    },
    {
        start: 451,
        end: 256
    },
    {
        start: 341,
        end: 453
    },
    {
        start: 453,
        end: 452
    },
    {
        start: 452,
        end: 341
    },
    {
        start: 413,
        end: 464
    },
    {
        start: 464,
        end: 463
    },
    {
        start: 463,
        end: 413
    },
    {
        start: 441,
        end: 413
    },
    {
        start: 413,
        end: 414
    },
    {
        start: 414,
        end: 441
    },
    {
        start: 258,
        end: 442
    },
    {
        start: 442,
        end: 441
    },
    {
        start: 441,
        end: 258
    },
    {
        start: 257,
        end: 443
    },
    {
        start: 443,
        end: 442
    },
    {
        start: 442,
        end: 257
    },
    {
        start: 259,
        end: 444
    },
    {
        start: 444,
        end: 443
    },
    {
        start: 443,
        end: 259
    },
    {
        start: 260,
        end: 445
    },
    {
        start: 445,
        end: 444
    },
    {
        start: 444,
        end: 260
    },
    {
        start: 467,
        end: 342
    },
    {
        start: 342,
        end: 445
    },
    {
        start: 445,
        end: 467
    },
    {
        start: 459,
        end: 458
    },
    {
        start: 458,
        end: 250
    },
    {
        start: 250,
        end: 459
    },
    {
        start: 289,
        end: 392
    },
    {
        start: 392,
        end: 290
    },
    {
        start: 290,
        end: 289
    },
    {
        start: 290,
        end: 328
    },
    {
        start: 328,
        end: 460
    },
    {
        start: 460,
        end: 290
    },
    {
        start: 376,
        end: 433
    },
    {
        start: 433,
        end: 435
    },
    {
        start: 435,
        end: 376
    },
    {
        start: 250,
        end: 290
    },
    {
        start: 290,
        end: 392
    },
    {
        start: 392,
        end: 250
    },
    {
        start: 411,
        end: 416
    },
    {
        start: 416,
        end: 433
    },
    {
        start: 433,
        end: 411
    },
    {
        start: 341,
        end: 463
    },
    {
        start: 463,
        end: 464
    },
    {
        start: 464,
        end: 341
    },
    {
        start: 453,
        end: 464
    },
    {
        start: 464,
        end: 465
    },
    {
        start: 465,
        end: 453
    },
    {
        start: 357,
        end: 465
    },
    {
        start: 465,
        end: 412
    },
    {
        start: 412,
        end: 357
    },
    {
        start: 343,
        end: 412
    },
    {
        start: 412,
        end: 399
    },
    {
        start: 399,
        end: 343
    },
    {
        start: 360,
        end: 363
    },
    {
        start: 363,
        end: 440
    },
    {
        start: 440,
        end: 360
    },
    {
        start: 437,
        end: 399
    },
    {
        start: 399,
        end: 456
    },
    {
        start: 456,
        end: 437
    },
    {
        start: 420,
        end: 456
    },
    {
        start: 456,
        end: 363
    },
    {
        start: 363,
        end: 420
    },
    {
        start: 401,
        end: 435
    },
    {
        start: 435,
        end: 288
    },
    {
        start: 288,
        end: 401
    },
    {
        start: 372,
        end: 383
    },
    {
        start: 383,
        end: 353
    },
    {
        start: 353,
        end: 372
    },
    {
        start: 339,
        end: 255
    },
    {
        start: 255,
        end: 249
    },
    {
        start: 249,
        end: 339
    },
    {
        start: 448,
        end: 261
    },
    {
        start: 261,
        end: 255
    },
    {
        start: 255,
        end: 448
    },
    {
        start: 133,
        end: 243
    },
    {
        start: 243,
        end: 190
    },
    {
        start: 190,
        end: 133
    },
    {
        start: 133,
        end: 155
    },
    {
        start: 155,
        end: 112
    },
    {
        start: 112,
        end: 133
    },
    {
        start: 33,
        end: 246
    },
    {
        start: 246,
        end: 247
    },
    {
        start: 247,
        end: 33
    },
    {
        start: 33,
        end: 130
    },
    {
        start: 130,
        end: 25
    },
    {
        start: 25,
        end: 33
    },
    {
        start: 398,
        end: 384
    },
    {
        start: 384,
        end: 286
    },
    {
        start: 286,
        end: 398
    },
    {
        start: 362,
        end: 398
    },
    {
        start: 398,
        end: 414
    },
    {
        start: 414,
        end: 362
    },
    {
        start: 362,
        end: 463
    },
    {
        start: 463,
        end: 341
    },
    {
        start: 341,
        end: 362
    },
    {
        start: 263,
        end: 359
    },
    {
        start: 359,
        end: 467
    },
    {
        start: 467,
        end: 263
    },
    {
        start: 263,
        end: 249
    },
    {
        start: 249,
        end: 255
    },
    {
        start: 255,
        end: 263
    },
    {
        start: 466,
        end: 467
    },
    {
        start: 467,
        end: 260
    },
    {
        start: 260,
        end: 466
    },
    {
        start: 75,
        end: 60
    },
    {
        start: 60,
        end: 166
    },
    {
        start: 166,
        end: 75
    },
    {
        start: 238,
        end: 239
    },
    {
        start: 239,
        end: 79
    },
    {
        start: 79,
        end: 238
    },
    {
        start: 162,
        end: 127
    },
    {
        start: 127,
        end: 139
    },
    {
        start: 139,
        end: 162
    },
    {
        start: 72,
        end: 11
    },
    {
        start: 11,
        end: 37
    },
    {
        start: 37,
        end: 72
    },
    {
        start: 121,
        end: 232
    },
    {
        start: 232,
        end: 120
    },
    {
        start: 120,
        end: 121
    },
    {
        start: 73,
        end: 72
    },
    {
        start: 72,
        end: 39
    },
    {
        start: 39,
        end: 73
    },
    {
        start: 114,
        end: 128
    },
    {
        start: 128,
        end: 47
    },
    {
        start: 47,
        end: 114
    },
    {
        start: 233,
        end: 232
    },
    {
        start: 232,
        end: 128
    },
    {
        start: 128,
        end: 233
    },
    {
        start: 103,
        end: 104
    },
    {
        start: 104,
        end: 67
    },
    {
        start: 67,
        end: 103
    },
    {
        start: 152,
        end: 175
    },
    {
        start: 175,
        end: 148
    },
    {
        start: 148,
        end: 152
    },
    {
        start: 119,
        end: 118
    },
    {
        start: 118,
        end: 101
    },
    {
        start: 101,
        end: 119
    },
    {
        start: 74,
        end: 73
    },
    {
        start: 73,
        end: 40
    },
    {
        start: 40,
        end: 74
    },
    {
        start: 107,
        end: 9
    },
    {
        start: 9,
        end: 108
    },
    {
        start: 108,
        end: 107
    },
    {
        start: 49,
        end: 48
    },
    {
        start: 48,
        end: 131
    },
    {
        start: 131,
        end: 49
    },
    {
        start: 32,
        end: 194
    },
    {
        start: 194,
        end: 211
    },
    {
        start: 211,
        end: 32
    },
    {
        start: 184,
        end: 74
    },
    {
        start: 74,
        end: 185
    },
    {
        start: 185,
        end: 184
    },
    {
        start: 191,
        end: 80
    },
    {
        start: 80,
        end: 183
    },
    {
        start: 183,
        end: 191
    },
    {
        start: 185,
        end: 40
    },
    {
        start: 40,
        end: 186
    },
    {
        start: 186,
        end: 185
    },
    {
        start: 119,
        end: 230
    },
    {
        start: 230,
        end: 118
    },
    {
        start: 118,
        end: 119
    },
    {
        start: 210,
        end: 202
    },
    {
        start: 202,
        end: 214
    },
    {
        start: 214,
        end: 210
    },
    {
        start: 84,
        end: 83
    },
    {
        start: 83,
        end: 17
    },
    {
        start: 17,
        end: 84
    },
    {
        start: 77,
        end: 76
    },
    {
        start: 76,
        end: 146
    },
    {
        start: 146,
        end: 77
    },
    {
        start: 161,
        end: 160
    },
    {
        start: 160,
        end: 30
    },
    {
        start: 30,
        end: 161
    },
    {
        start: 190,
        end: 56
    },
    {
        start: 56,
        end: 173
    },
    {
        start: 173,
        end: 190
    },
    {
        start: 182,
        end: 106
    },
    {
        start: 106,
        end: 194
    },
    {
        start: 194,
        end: 182
    },
    {
        start: 138,
        end: 135
    },
    {
        start: 135,
        end: 192
    },
    {
        start: 192,
        end: 138
    },
    {
        start: 129,
        end: 203
    },
    {
        start: 203,
        end: 98
    },
    {
        start: 98,
        end: 129
    },
    {
        start: 54,
        end: 21
    },
    {
        start: 21,
        end: 68
    },
    {
        start: 68,
        end: 54
    },
    {
        start: 5,
        end: 51
    },
    {
        start: 51,
        end: 4
    },
    {
        start: 4,
        end: 5
    },
    {
        start: 145,
        end: 144
    },
    {
        start: 144,
        end: 23
    },
    {
        start: 23,
        end: 145
    },
    {
        start: 90,
        end: 77
    },
    {
        start: 77,
        end: 91
    },
    {
        start: 91,
        end: 90
    },
    {
        start: 207,
        end: 205
    },
    {
        start: 205,
        end: 187
    },
    {
        start: 187,
        end: 207
    },
    {
        start: 83,
        end: 201
    },
    {
        start: 201,
        end: 18
    },
    {
        start: 18,
        end: 83
    },
    {
        start: 181,
        end: 91
    },
    {
        start: 91,
        end: 182
    },
    {
        start: 182,
        end: 181
    },
    {
        start: 180,
        end: 90
    },
    {
        start: 90,
        end: 181
    },
    {
        start: 181,
        end: 180
    },
    {
        start: 16,
        end: 85
    },
    {
        start: 85,
        end: 17
    },
    {
        start: 17,
        end: 16
    },
    {
        start: 205,
        end: 206
    },
    {
        start: 206,
        end: 36
    },
    {
        start: 36,
        end: 205
    },
    {
        start: 176,
        end: 148
    },
    {
        start: 148,
        end: 140
    },
    {
        start: 140,
        end: 176
    },
    {
        start: 165,
        end: 92
    },
    {
        start: 92,
        end: 39
    },
    {
        start: 39,
        end: 165
    },
    {
        start: 245,
        end: 193
    },
    {
        start: 193,
        end: 244
    },
    {
        start: 244,
        end: 245
    },
    {
        start: 27,
        end: 159
    },
    {
        start: 159,
        end: 28
    },
    {
        start: 28,
        end: 27
    },
    {
        start: 30,
        end: 247
    },
    {
        start: 247,
        end: 161
    },
    {
        start: 161,
        end: 30
    },
    {
        start: 174,
        end: 236
    },
    {
        start: 236,
        end: 196
    },
    {
        start: 196,
        end: 174
    },
    {
        start: 103,
        end: 54
    },
    {
        start: 54,
        end: 104
    },
    {
        start: 104,
        end: 103
    },
    {
        start: 55,
        end: 193
    },
    {
        start: 193,
        end: 8
    },
    {
        start: 8,
        end: 55
    },
    {
        start: 111,
        end: 117
    },
    {
        start: 117,
        end: 31
    },
    {
        start: 31,
        end: 111
    },
    {
        start: 221,
        end: 189
    },
    {
        start: 189,
        end: 55
    },
    {
        start: 55,
        end: 221
    },
    {
        start: 240,
        end: 98
    },
    {
        start: 98,
        end: 99
    },
    {
        start: 99,
        end: 240
    },
    {
        start: 142,
        end: 126
    },
    {
        start: 126,
        end: 100
    },
    {
        start: 100,
        end: 142
    },
    {
        start: 219,
        end: 166
    },
    {
        start: 166,
        end: 218
    },
    {
        start: 218,
        end: 219
    },
    {
        start: 112,
        end: 155
    },
    {
        start: 155,
        end: 26
    },
    {
        start: 26,
        end: 112
    },
    {
        start: 198,
        end: 209
    },
    {
        start: 209,
        end: 131
    },
    {
        start: 131,
        end: 198
    },
    {
        start: 169,
        end: 135
    },
    {
        start: 135,
        end: 150
    },
    {
        start: 150,
        end: 169
    },
    {
        start: 114,
        end: 47
    },
    {
        start: 47,
        end: 217
    },
    {
        start: 217,
        end: 114
    },
    {
        start: 224,
        end: 223
    },
    {
        start: 223,
        end: 53
    },
    {
        start: 53,
        end: 224
    },
    {
        start: 220,
        end: 45
    },
    {
        start: 45,
        end: 134
    },
    {
        start: 134,
        end: 220
    },
    {
        start: 32,
        end: 211
    },
    {
        start: 211,
        end: 140
    },
    {
        start: 140,
        end: 32
    },
    {
        start: 109,
        end: 67
    },
    {
        start: 67,
        end: 108
    },
    {
        start: 108,
        end: 109
    },
    {
        start: 146,
        end: 43
    },
    {
        start: 43,
        end: 91
    },
    {
        start: 91,
        end: 146
    },
    {
        start: 231,
        end: 230
    },
    {
        start: 230,
        end: 120
    },
    {
        start: 120,
        end: 231
    },
    {
        start: 113,
        end: 226
    },
    {
        start: 226,
        end: 247
    },
    {
        start: 247,
        end: 113
    },
    {
        start: 105,
        end: 63
    },
    {
        start: 63,
        end: 52
    },
    {
        start: 52,
        end: 105
    },
    {
        start: 241,
        end: 238
    },
    {
        start: 238,
        end: 242
    },
    {
        start: 242,
        end: 241
    },
    {
        start: 124,
        end: 46
    },
    {
        start: 46,
        end: 156
    },
    {
        start: 156,
        end: 124
    },
    {
        start: 95,
        end: 78
    },
    {
        start: 78,
        end: 96
    },
    {
        start: 96,
        end: 95
    },
    {
        start: 70,
        end: 46
    },
    {
        start: 46,
        end: 63
    },
    {
        start: 63,
        end: 70
    },
    {
        start: 116,
        end: 143
    },
    {
        start: 143,
        end: 227
    },
    {
        start: 227,
        end: 116
    },
    {
        start: 116,
        end: 123
    },
    {
        start: 123,
        end: 111
    },
    {
        start: 111,
        end: 116
    },
    {
        start: 1,
        end: 44
    },
    {
        start: 44,
        end: 19
    },
    {
        start: 19,
        end: 1
    },
    {
        start: 3,
        end: 236
    },
    {
        start: 236,
        end: 51
    },
    {
        start: 51,
        end: 3
    },
    {
        start: 207,
        end: 216
    },
    {
        start: 216,
        end: 205
    },
    {
        start: 205,
        end: 207
    },
    {
        start: 26,
        end: 154
    },
    {
        start: 154,
        end: 22
    },
    {
        start: 22,
        end: 26
    },
    {
        start: 165,
        end: 39
    },
    {
        start: 39,
        end: 167
    },
    {
        start: 167,
        end: 165
    },
    {
        start: 199,
        end: 200
    },
    {
        start: 200,
        end: 208
    },
    {
        start: 208,
        end: 199
    },
    {
        start: 101,
        end: 36
    },
    {
        start: 36,
        end: 100
    },
    {
        start: 100,
        end: 101
    },
    {
        start: 43,
        end: 57
    },
    {
        start: 57,
        end: 202
    },
    {
        start: 202,
        end: 43
    },
    {
        start: 242,
        end: 20
    },
    {
        start: 20,
        end: 99
    },
    {
        start: 99,
        end: 242
    },
    {
        start: 56,
        end: 28
    },
    {
        start: 28,
        end: 157
    },
    {
        start: 157,
        end: 56
    },
    {
        start: 124,
        end: 35
    },
    {
        start: 35,
        end: 113
    },
    {
        start: 113,
        end: 124
    },
    {
        start: 29,
        end: 160
    },
    {
        start: 160,
        end: 27
    },
    {
        start: 27,
        end: 29
    },
    {
        start: 211,
        end: 204
    },
    {
        start: 204,
        end: 210
    },
    {
        start: 210,
        end: 211
    },
    {
        start: 124,
        end: 113
    },
    {
        start: 113,
        end: 46
    },
    {
        start: 46,
        end: 124
    },
    {
        start: 106,
        end: 43
    },
    {
        start: 43,
        end: 204
    },
    {
        start: 204,
        end: 106
    },
    {
        start: 96,
        end: 62
    },
    {
        start: 62,
        end: 77
    },
    {
        start: 77,
        end: 96
    },
    {
        start: 227,
        end: 137
    },
    {
        start: 137,
        end: 116
    },
    {
        start: 116,
        end: 227
    },
    {
        start: 73,
        end: 41
    },
    {
        start: 41,
        end: 72
    },
    {
        start: 72,
        end: 73
    },
    {
        start: 36,
        end: 203
    },
    {
        start: 203,
        end: 142
    },
    {
        start: 142,
        end: 36
    },
    {
        start: 235,
        end: 64
    },
    {
        start: 64,
        end: 240
    },
    {
        start: 240,
        end: 235
    },
    {
        start: 48,
        end: 49
    },
    {
        start: 49,
        end: 64
    },
    {
        start: 64,
        end: 48
    },
    {
        start: 42,
        end: 41
    },
    {
        start: 41,
        end: 74
    },
    {
        start: 74,
        end: 42
    },
    {
        start: 214,
        end: 212
    },
    {
        start: 212,
        end: 207
    },
    {
        start: 207,
        end: 214
    },
    {
        start: 183,
        end: 42
    },
    {
        start: 42,
        end: 184
    },
    {
        start: 184,
        end: 183
    },
    {
        start: 210,
        end: 169
    },
    {
        start: 169,
        end: 211
    },
    {
        start: 211,
        end: 210
    },
    {
        start: 140,
        end: 170
    },
    {
        start: 170,
        end: 176
    },
    {
        start: 176,
        end: 140
    },
    {
        start: 104,
        end: 105
    },
    {
        start: 105,
        end: 69
    },
    {
        start: 69,
        end: 104
    },
    {
        start: 193,
        end: 122
    },
    {
        start: 122,
        end: 168
    },
    {
        start: 168,
        end: 193
    },
    {
        start: 50,
        end: 123
    },
    {
        start: 123,
        end: 187
    },
    {
        start: 187,
        end: 50
    },
    {
        start: 89,
        end: 96
    },
    {
        start: 96,
        end: 90
    },
    {
        start: 90,
        end: 89
    },
    {
        start: 66,
        end: 65
    },
    {
        start: 65,
        end: 107
    },
    {
        start: 107,
        end: 66
    },
    {
        start: 179,
        end: 89
    },
    {
        start: 89,
        end: 180
    },
    {
        start: 180,
        end: 179
    },
    {
        start: 119,
        end: 101
    },
    {
        start: 101,
        end: 120
    },
    {
        start: 120,
        end: 119
    },
    {
        start: 68,
        end: 63
    },
    {
        start: 63,
        end: 104
    },
    {
        start: 104,
        end: 68
    },
    {
        start: 234,
        end: 93
    },
    {
        start: 93,
        end: 227
    },
    {
        start: 227,
        end: 234
    },
    {
        start: 16,
        end: 15
    },
    {
        start: 15,
        end: 85
    },
    {
        start: 85,
        end: 16
    },
    {
        start: 209,
        end: 129
    },
    {
        start: 129,
        end: 49
    },
    {
        start: 49,
        end: 209
    },
    {
        start: 15,
        end: 14
    },
    {
        start: 14,
        end: 86
    },
    {
        start: 86,
        end: 15
    },
    {
        start: 107,
        end: 55
    },
    {
        start: 55,
        end: 9
    },
    {
        start: 9,
        end: 107
    },
    {
        start: 120,
        end: 100
    },
    {
        start: 100,
        end: 121
    },
    {
        start: 121,
        end: 120
    },
    {
        start: 153,
        end: 145
    },
    {
        start: 145,
        end: 22
    },
    {
        start: 22,
        end: 153
    },
    {
        start: 178,
        end: 88
    },
    {
        start: 88,
        end: 179
    },
    {
        start: 179,
        end: 178
    },
    {
        start: 197,
        end: 6
    },
    {
        start: 6,
        end: 196
    },
    {
        start: 196,
        end: 197
    },
    {
        start: 89,
        end: 88
    },
    {
        start: 88,
        end: 96
    },
    {
        start: 96,
        end: 89
    },
    {
        start: 135,
        end: 138
    },
    {
        start: 138,
        end: 136
    },
    {
        start: 136,
        end: 135
    },
    {
        start: 138,
        end: 215
    },
    {
        start: 215,
        end: 172
    },
    {
        start: 172,
        end: 138
    },
    {
        start: 218,
        end: 115
    },
    {
        start: 115,
        end: 219
    },
    {
        start: 219,
        end: 218
    },
    {
        start: 41,
        end: 42
    },
    {
        start: 42,
        end: 81
    },
    {
        start: 81,
        end: 41
    },
    {
        start: 5,
        end: 195
    },
    {
        start: 195,
        end: 51
    },
    {
        start: 51,
        end: 5
    },
    {
        start: 57,
        end: 43
    },
    {
        start: 43,
        end: 61
    },
    {
        start: 61,
        end: 57
    },
    {
        start: 208,
        end: 171
    },
    {
        start: 171,
        end: 199
    },
    {
        start: 199,
        end: 208
    },
    {
        start: 41,
        end: 81
    },
    {
        start: 81,
        end: 38
    },
    {
        start: 38,
        end: 41
    },
    {
        start: 224,
        end: 53
    },
    {
        start: 53,
        end: 225
    },
    {
        start: 225,
        end: 224
    },
    {
        start: 24,
        end: 144
    },
    {
        start: 144,
        end: 110
    },
    {
        start: 110,
        end: 24
    },
    {
        start: 105,
        end: 52
    },
    {
        start: 52,
        end: 66
    },
    {
        start: 66,
        end: 105
    },
    {
        start: 118,
        end: 229
    },
    {
        start: 229,
        end: 117
    },
    {
        start: 117,
        end: 118
    },
    {
        start: 227,
        end: 34
    },
    {
        start: 34,
        end: 234
    },
    {
        start: 234,
        end: 227
    },
    {
        start: 66,
        end: 107
    },
    {
        start: 107,
        end: 69
    },
    {
        start: 69,
        end: 66
    },
    {
        start: 10,
        end: 109
    },
    {
        start: 109,
        end: 151
    },
    {
        start: 151,
        end: 10
    },
    {
        start: 219,
        end: 48
    },
    {
        start: 48,
        end: 235
    },
    {
        start: 235,
        end: 219
    },
    {
        start: 183,
        end: 62
    },
    {
        start: 62,
        end: 191
    },
    {
        start: 191,
        end: 183
    },
    {
        start: 142,
        end: 129
    },
    {
        start: 129,
        end: 126
    },
    {
        start: 126,
        end: 142
    },
    {
        start: 116,
        end: 111
    },
    {
        start: 111,
        end: 143
    },
    {
        start: 143,
        end: 116
    },
    {
        start: 118,
        end: 117
    },
    {
        start: 117,
        end: 50
    },
    {
        start: 50,
        end: 118
    },
    {
        start: 223,
        end: 222
    },
    {
        start: 222,
        end: 52
    },
    {
        start: 52,
        end: 223
    },
    {
        start: 94,
        end: 19
    },
    {
        start: 19,
        end: 141
    },
    {
        start: 141,
        end: 94
    },
    {
        start: 222,
        end: 221
    },
    {
        start: 221,
        end: 65
    },
    {
        start: 65,
        end: 222
    },
    {
        start: 196,
        end: 3
    },
    {
        start: 3,
        end: 197
    },
    {
        start: 197,
        end: 196
    },
    {
        start: 45,
        end: 220
    },
    {
        start: 220,
        end: 44
    },
    {
        start: 44,
        end: 45
    },
    {
        start: 156,
        end: 70
    },
    {
        start: 70,
        end: 139
    },
    {
        start: 139,
        end: 156
    },
    {
        start: 188,
        end: 122
    },
    {
        start: 122,
        end: 245
    },
    {
        start: 245,
        end: 188
    },
    {
        start: 139,
        end: 71
    },
    {
        start: 71,
        end: 162
    },
    {
        start: 162,
        end: 139
    },
    {
        start: 149,
        end: 170
    },
    {
        start: 170,
        end: 150
    },
    {
        start: 150,
        end: 149
    },
    {
        start: 122,
        end: 188
    },
    {
        start: 188,
        end: 196
    },
    {
        start: 196,
        end: 122
    },
    {
        start: 206,
        end: 216
    },
    {
        start: 216,
        end: 92
    },
    {
        start: 92,
        end: 206
    },
    {
        start: 164,
        end: 2
    },
    {
        start: 2,
        end: 167
    },
    {
        start: 167,
        end: 164
    },
    {
        start: 242,
        end: 141
    },
    {
        start: 141,
        end: 241
    },
    {
        start: 241,
        end: 242
    },
    {
        start: 0,
        end: 164
    },
    {
        start: 164,
        end: 37
    },
    {
        start: 37,
        end: 0
    },
    {
        start: 11,
        end: 72
    },
    {
        start: 72,
        end: 12
    },
    {
        start: 12,
        end: 11
    },
    {
        start: 12,
        end: 38
    },
    {
        start: 38,
        end: 13
    },
    {
        start: 13,
        end: 12
    },
    {
        start: 70,
        end: 63
    },
    {
        start: 63,
        end: 71
    },
    {
        start: 71,
        end: 70
    },
    {
        start: 31,
        end: 226
    },
    {
        start: 226,
        end: 111
    },
    {
        start: 111,
        end: 31
    },
    {
        start: 36,
        end: 101
    },
    {
        start: 101,
        end: 205
    },
    {
        start: 205,
        end: 36
    },
    {
        start: 203,
        end: 206
    },
    {
        start: 206,
        end: 165
    },
    {
        start: 165,
        end: 203
    },
    {
        start: 126,
        end: 209
    },
    {
        start: 209,
        end: 217
    },
    {
        start: 217,
        end: 126
    },
    {
        start: 98,
        end: 165
    },
    {
        start: 165,
        end: 97
    },
    {
        start: 97,
        end: 98
    },
    {
        start: 237,
        end: 220
    },
    {
        start: 220,
        end: 218
    },
    {
        start: 218,
        end: 237
    },
    {
        start: 237,
        end: 239
    },
    {
        start: 239,
        end: 241
    },
    {
        start: 241,
        end: 237
    },
    {
        start: 210,
        end: 214
    },
    {
        start: 214,
        end: 169
    },
    {
        start: 169,
        end: 210
    },
    {
        start: 140,
        end: 171
    },
    {
        start: 171,
        end: 32
    },
    {
        start: 32,
        end: 140
    },
    {
        start: 241,
        end: 125
    },
    {
        start: 125,
        end: 237
    },
    {
        start: 237,
        end: 241
    },
    {
        start: 179,
        end: 86
    },
    {
        start: 86,
        end: 178
    },
    {
        start: 178,
        end: 179
    },
    {
        start: 180,
        end: 85
    },
    {
        start: 85,
        end: 179
    },
    {
        start: 179,
        end: 180
    },
    {
        start: 181,
        end: 84
    },
    {
        start: 84,
        end: 180
    },
    {
        start: 180,
        end: 181
    },
    {
        start: 182,
        end: 83
    },
    {
        start: 83,
        end: 181
    },
    {
        start: 181,
        end: 182
    },
    {
        start: 194,
        end: 201
    },
    {
        start: 201,
        end: 182
    },
    {
        start: 182,
        end: 194
    },
    {
        start: 177,
        end: 137
    },
    {
        start: 137,
        end: 132
    },
    {
        start: 132,
        end: 177
    },
    {
        start: 184,
        end: 76
    },
    {
        start: 76,
        end: 183
    },
    {
        start: 183,
        end: 184
    },
    {
        start: 185,
        end: 61
    },
    {
        start: 61,
        end: 184
    },
    {
        start: 184,
        end: 185
    },
    {
        start: 186,
        end: 57
    },
    {
        start: 57,
        end: 185
    },
    {
        start: 185,
        end: 186
    },
    {
        start: 216,
        end: 212
    },
    {
        start: 212,
        end: 186
    },
    {
        start: 186,
        end: 216
    },
    {
        start: 192,
        end: 214
    },
    {
        start: 214,
        end: 187
    },
    {
        start: 187,
        end: 192
    },
    {
        start: 139,
        end: 34
    },
    {
        start: 34,
        end: 156
    },
    {
        start: 156,
        end: 139
    },
    {
        start: 218,
        end: 79
    },
    {
        start: 79,
        end: 237
    },
    {
        start: 237,
        end: 218
    },
    {
        start: 147,
        end: 123
    },
    {
        start: 123,
        end: 177
    },
    {
        start: 177,
        end: 147
    },
    {
        start: 45,
        end: 44
    },
    {
        start: 44,
        end: 4
    },
    {
        start: 4,
        end: 45
    },
    {
        start: 208,
        end: 201
    },
    {
        start: 201,
        end: 32
    },
    {
        start: 32,
        end: 208
    },
    {
        start: 98,
        end: 64
    },
    {
        start: 64,
        end: 129
    },
    {
        start: 129,
        end: 98
    },
    {
        start: 192,
        end: 213
    },
    {
        start: 213,
        end: 138
    },
    {
        start: 138,
        end: 192
    },
    {
        start: 235,
        end: 59
    },
    {
        start: 59,
        end: 219
    },
    {
        start: 219,
        end: 235
    },
    {
        start: 141,
        end: 242
    },
    {
        start: 242,
        end: 97
    },
    {
        start: 97,
        end: 141
    },
    {
        start: 97,
        end: 2
    },
    {
        start: 2,
        end: 141
    },
    {
        start: 141,
        end: 97
    },
    {
        start: 240,
        end: 75
    },
    {
        start: 75,
        end: 235
    },
    {
        start: 235,
        end: 240
    },
    {
        start: 229,
        end: 24
    },
    {
        start: 24,
        end: 228
    },
    {
        start: 228,
        end: 229
    },
    {
        start: 31,
        end: 25
    },
    {
        start: 25,
        end: 226
    },
    {
        start: 226,
        end: 31
    },
    {
        start: 230,
        end: 23
    },
    {
        start: 23,
        end: 229
    },
    {
        start: 229,
        end: 230
    },
    {
        start: 231,
        end: 22
    },
    {
        start: 22,
        end: 230
    },
    {
        start: 230,
        end: 231
    },
    {
        start: 232,
        end: 26
    },
    {
        start: 26,
        end: 231
    },
    {
        start: 231,
        end: 232
    },
    {
        start: 233,
        end: 112
    },
    {
        start: 112,
        end: 232
    },
    {
        start: 232,
        end: 233
    },
    {
        start: 244,
        end: 189
    },
    {
        start: 189,
        end: 243
    },
    {
        start: 243,
        end: 244
    },
    {
        start: 189,
        end: 221
    },
    {
        start: 221,
        end: 190
    },
    {
        start: 190,
        end: 189
    },
    {
        start: 222,
        end: 28
    },
    {
        start: 28,
        end: 221
    },
    {
        start: 221,
        end: 222
    },
    {
        start: 223,
        end: 27
    },
    {
        start: 27,
        end: 222
    },
    {
        start: 222,
        end: 223
    },
    {
        start: 224,
        end: 29
    },
    {
        start: 29,
        end: 223
    },
    {
        start: 223,
        end: 224
    },
    {
        start: 225,
        end: 30
    },
    {
        start: 30,
        end: 224
    },
    {
        start: 224,
        end: 225
    },
    {
        start: 113,
        end: 247
    },
    {
        start: 247,
        end: 225
    },
    {
        start: 225,
        end: 113
    },
    {
        start: 99,
        end: 60
    },
    {
        start: 60,
        end: 240
    },
    {
        start: 240,
        end: 99
    },
    {
        start: 213,
        end: 147
    },
    {
        start: 147,
        end: 215
    },
    {
        start: 215,
        end: 213
    },
    {
        start: 60,
        end: 20
    },
    {
        start: 20,
        end: 166
    },
    {
        start: 166,
        end: 60
    },
    {
        start: 192,
        end: 187
    },
    {
        start: 187,
        end: 213
    },
    {
        start: 213,
        end: 192
    },
    {
        start: 243,
        end: 112
    },
    {
        start: 112,
        end: 244
    },
    {
        start: 244,
        end: 243
    },
    {
        start: 244,
        end: 233
    },
    {
        start: 233,
        end: 245
    },
    {
        start: 245,
        end: 244
    },
    {
        start: 245,
        end: 128
    },
    {
        start: 128,
        end: 188
    },
    {
        start: 188,
        end: 245
    },
    {
        start: 188,
        end: 114
    },
    {
        start: 114,
        end: 174
    },
    {
        start: 174,
        end: 188
    },
    {
        start: 134,
        end: 131
    },
    {
        start: 131,
        end: 220
    },
    {
        start: 220,
        end: 134
    },
    {
        start: 174,
        end: 217
    },
    {
        start: 217,
        end: 236
    },
    {
        start: 236,
        end: 174
    },
    {
        start: 236,
        end: 198
    },
    {
        start: 198,
        end: 134
    },
    {
        start: 134,
        end: 236
    },
    {
        start: 215,
        end: 177
    },
    {
        start: 177,
        end: 58
    },
    {
        start: 58,
        end: 215
    },
    {
        start: 156,
        end: 143
    },
    {
        start: 143,
        end: 124
    },
    {
        start: 124,
        end: 156
    },
    {
        start: 25,
        end: 110
    },
    {
        start: 110,
        end: 7
    },
    {
        start: 7,
        end: 25
    },
    {
        start: 31,
        end: 228
    },
    {
        start: 228,
        end: 25
    },
    {
        start: 25,
        end: 31
    },
    {
        start: 264,
        end: 356
    },
    {
        start: 356,
        end: 368
    },
    {
        start: 368,
        end: 264
    },
    {
        start: 0,
        end: 11
    },
    {
        start: 11,
        end: 267
    },
    {
        start: 267,
        end: 0
    },
    {
        start: 451,
        end: 452
    },
    {
        start: 452,
        end: 349
    },
    {
        start: 349,
        end: 451
    },
    {
        start: 267,
        end: 302
    },
    {
        start: 302,
        end: 269
    },
    {
        start: 269,
        end: 267
    },
    {
        start: 350,
        end: 357
    },
    {
        start: 357,
        end: 277
    },
    {
        start: 277,
        end: 350
    },
    {
        start: 350,
        end: 452
    },
    {
        start: 452,
        end: 357
    },
    {
        start: 357,
        end: 350
    },
    {
        start: 299,
        end: 333
    },
    {
        start: 333,
        end: 297
    },
    {
        start: 297,
        end: 299
    },
    {
        start: 396,
        end: 175
    },
    {
        start: 175,
        end: 377
    },
    {
        start: 377,
        end: 396
    },
    {
        start: 280,
        end: 347
    },
    {
        start: 347,
        end: 330
    },
    {
        start: 330,
        end: 280
    },
    {
        start: 269,
        end: 303
    },
    {
        start: 303,
        end: 270
    },
    {
        start: 270,
        end: 269
    },
    {
        start: 151,
        end: 9
    },
    {
        start: 9,
        end: 337
    },
    {
        start: 337,
        end: 151
    },
    {
        start: 344,
        end: 278
    },
    {
        start: 278,
        end: 360
    },
    {
        start: 360,
        end: 344
    },
    {
        start: 424,
        end: 418
    },
    {
        start: 418,
        end: 431
    },
    {
        start: 431,
        end: 424
    },
    {
        start: 270,
        end: 304
    },
    {
        start: 304,
        end: 409
    },
    {
        start: 409,
        end: 270
    },
    {
        start: 272,
        end: 310
    },
    {
        start: 310,
        end: 407
    },
    {
        start: 407,
        end: 272
    },
    {
        start: 322,
        end: 270
    },
    {
        start: 270,
        end: 410
    },
    {
        start: 410,
        end: 322
    },
    {
        start: 449,
        end: 450
    },
    {
        start: 450,
        end: 347
    },
    {
        start: 347,
        end: 449
    },
    {
        start: 432,
        end: 422
    },
    {
        start: 422,
        end: 434
    },
    {
        start: 434,
        end: 432
    },
    {
        start: 18,
        end: 313
    },
    {
        start: 313,
        end: 17
    },
    {
        start: 17,
        end: 18
    },
    {
        start: 291,
        end: 306
    },
    {
        start: 306,
        end: 375
    },
    {
        start: 375,
        end: 291
    },
    {
        start: 259,
        end: 387
    },
    {
        start: 387,
        end: 260
    },
    {
        start: 260,
        end: 259
    },
    {
        start: 424,
        end: 335
    },
    {
        start: 335,
        end: 418
    },
    {
        start: 418,
        end: 424
    },
    {
        start: 434,
        end: 364
    },
    {
        start: 364,
        end: 416
    },
    {
        start: 416,
        end: 434
    },
    {
        start: 391,
        end: 423
    },
    {
        start: 423,
        end: 327
    },
    {
        start: 327,
        end: 391
    },
    {
        start: 301,
        end: 251
    },
    {
        start: 251,
        end: 298
    },
    {
        start: 298,
        end: 301
    },
    {
        start: 275,
        end: 281
    },
    {
        start: 281,
        end: 4
    },
    {
        start: 4,
        end: 275
    },
    {
        start: 254,
        end: 373
    },
    {
        start: 373,
        end: 253
    },
    {
        start: 253,
        end: 254
    },
    {
        start: 375,
        end: 307
    },
    {
        start: 307,
        end: 321
    },
    {
        start: 321,
        end: 375
    },
    {
        start: 280,
        end: 425
    },
    {
        start: 425,
        end: 411
    },
    {
        start: 411,
        end: 280
    },
    {
        start: 200,
        end: 421
    },
    {
        start: 421,
        end: 18
    },
    {
        start: 18,
        end: 200
    },
    {
        start: 335,
        end: 321
    },
    {
        start: 321,
        end: 406
    },
    {
        start: 406,
        end: 335
    },
    {
        start: 321,
        end: 320
    },
    {
        start: 320,
        end: 405
    },
    {
        start: 405,
        end: 321
    },
    {
        start: 314,
        end: 315
    },
    {
        start: 315,
        end: 17
    },
    {
        start: 17,
        end: 314
    },
    {
        start: 423,
        end: 426
    },
    {
        start: 426,
        end: 266
    },
    {
        start: 266,
        end: 423
    },
    {
        start: 396,
        end: 377
    },
    {
        start: 377,
        end: 369
    },
    {
        start: 369,
        end: 396
    },
    {
        start: 270,
        end: 322
    },
    {
        start: 322,
        end: 269
    },
    {
        start: 269,
        end: 270
    },
    {
        start: 413,
        end: 417
    },
    {
        start: 417,
        end: 464
    },
    {
        start: 464,
        end: 413
    },
    {
        start: 385,
        end: 386
    },
    {
        start: 386,
        end: 258
    },
    {
        start: 258,
        end: 385
    },
    {
        start: 248,
        end: 456
    },
    {
        start: 456,
        end: 419
    },
    {
        start: 419,
        end: 248
    },
    {
        start: 298,
        end: 284
    },
    {
        start: 284,
        end: 333
    },
    {
        start: 333,
        end: 298
    },
    {
        start: 168,
        end: 417
    },
    {
        start: 417,
        end: 8
    },
    {
        start: 8,
        end: 168
    },
    {
        start: 448,
        end: 346
    },
    {
        start: 346,
        end: 261
    },
    {
        start: 261,
        end: 448
    },
    {
        start: 417,
        end: 413
    },
    {
        start: 413,
        end: 285
    },
    {
        start: 285,
        end: 417
    },
    {
        start: 326,
        end: 327
    },
    {
        start: 327,
        end: 328
    },
    {
        start: 328,
        end: 326
    },
    {
        start: 277,
        end: 355
    },
    {
        start: 355,
        end: 329
    },
    {
        start: 329,
        end: 277
    },
    {
        start: 309,
        end: 392
    },
    {
        start: 392,
        end: 438
    },
    {
        start: 438,
        end: 309
    },
    {
        start: 381,
        end: 382
    },
    {
        start: 382,
        end: 256
    },
    {
        start: 256,
        end: 381
    },
    {
        start: 279,
        end: 429
    },
    {
        start: 429,
        end: 360
    },
    {
        start: 360,
        end: 279
    },
    {
        start: 365,
        end: 364
    },
    {
        start: 364,
        end: 379
    },
    {
        start: 379,
        end: 365
    },
    {
        start: 355,
        end: 277
    },
    {
        start: 277,
        end: 437
    },
    {
        start: 437,
        end: 355
    },
    {
        start: 282,
        end: 443
    },
    {
        start: 443,
        end: 283
    },
    {
        start: 283,
        end: 282
    },
    {
        start: 281,
        end: 275
    },
    {
        start: 275,
        end: 363
    },
    {
        start: 363,
        end: 281
    },
    {
        start: 395,
        end: 431
    },
    {
        start: 431,
        end: 369
    },
    {
        start: 369,
        end: 395
    },
    {
        start: 299,
        end: 297
    },
    {
        start: 297,
        end: 337
    },
    {
        start: 337,
        end: 299
    },
    {
        start: 335,
        end: 273
    },
    {
        start: 273,
        end: 321
    },
    {
        start: 321,
        end: 335
    },
    {
        start: 348,
        end: 450
    },
    {
        start: 450,
        end: 349
    },
    {
        start: 349,
        end: 348
    },
    {
        start: 359,
        end: 446
    },
    {
        start: 446,
        end: 467
    },
    {
        start: 467,
        end: 359
    },
    {
        start: 283,
        end: 293
    },
    {
        start: 293,
        end: 282
    },
    {
        start: 282,
        end: 283
    },
    {
        start: 250,
        end: 458
    },
    {
        start: 458,
        end: 462
    },
    {
        start: 462,
        end: 250
    },
    {
        start: 300,
        end: 276
    },
    {
        start: 276,
        end: 383
    },
    {
        start: 383,
        end: 300
    },
    {
        start: 292,
        end: 308
    },
    {
        start: 308,
        end: 325
    },
    {
        start: 325,
        end: 292
    },
    {
        start: 283,
        end: 276
    },
    {
        start: 276,
        end: 293
    },
    {
        start: 293,
        end: 283
    },
    {
        start: 264,
        end: 372
    },
    {
        start: 372,
        end: 447
    },
    {
        start: 447,
        end: 264
    },
    {
        start: 346,
        end: 352
    },
    {
        start: 352,
        end: 340
    },
    {
        start: 340,
        end: 346
    },
    {
        start: 354,
        end: 274
    },
    {
        start: 274,
        end: 19
    },
    {
        start: 19,
        end: 354
    },
    {
        start: 363,
        end: 456
    },
    {
        start: 456,
        end: 281
    },
    {
        start: 281,
        end: 363
    },
    {
        start: 426,
        end: 436
    },
    {
        start: 436,
        end: 425
    },
    {
        start: 425,
        end: 426
    },
    {
        start: 380,
        end: 381
    },
    {
        start: 381,
        end: 252
    },
    {
        start: 252,
        end: 380
    },
    {
        start: 267,
        end: 269
    },
    {
        start: 269,
        end: 393
    },
    {
        start: 393,
        end: 267
    },
    {
        start: 421,
        end: 200
    },
    {
        start: 200,
        end: 428
    },
    {
        start: 428,
        end: 421
    },
    {
        start: 371,
        end: 266
    },
    {
        start: 266,
        end: 329
    },
    {
        start: 329,
        end: 371
    },
    {
        start: 432,
        end: 287
    },
    {
        start: 287,
        end: 422
    },
    {
        start: 422,
        end: 432
    },
    {
        start: 290,
        end: 250
    },
    {
        start: 250,
        end: 328
    },
    {
        start: 328,
        end: 290
    },
    {
        start: 385,
        end: 258
    },
    {
        start: 258,
        end: 384
    },
    {
        start: 384,
        end: 385
    },
    {
        start: 446,
        end: 265
    },
    {
        start: 265,
        end: 342
    },
    {
        start: 342,
        end: 446
    },
    {
        start: 386,
        end: 387
    },
    {
        start: 387,
        end: 257
    },
    {
        start: 257,
        end: 386
    },
    {
        start: 422,
        end: 424
    },
    {
        start: 424,
        end: 430
    },
    {
        start: 430,
        end: 422
    },
    {
        start: 445,
        end: 342
    },
    {
        start: 342,
        end: 276
    },
    {
        start: 276,
        end: 445
    },
    {
        start: 422,
        end: 273
    },
    {
        start: 273,
        end: 424
    },
    {
        start: 424,
        end: 422
    },
    {
        start: 306,
        end: 292
    },
    {
        start: 292,
        end: 307
    },
    {
        start: 307,
        end: 306
    },
    {
        start: 352,
        end: 366
    },
    {
        start: 366,
        end: 345
    },
    {
        start: 345,
        end: 352
    },
    {
        start: 268,
        end: 271
    },
    {
        start: 271,
        end: 302
    },
    {
        start: 302,
        end: 268
    },
    {
        start: 358,
        end: 423
    },
    {
        start: 423,
        end: 371
    },
    {
        start: 371,
        end: 358
    },
    {
        start: 327,
        end: 294
    },
    {
        start: 294,
        end: 460
    },
    {
        start: 460,
        end: 327
    },
    {
        start: 331,
        end: 279
    },
    {
        start: 279,
        end: 294
    },
    {
        start: 294,
        end: 331
    },
    {
        start: 303,
        end: 271
    },
    {
        start: 271,
        end: 304
    },
    {
        start: 304,
        end: 303
    },
    {
        start: 436,
        end: 432
    },
    {
        start: 432,
        end: 427
    },
    {
        start: 427,
        end: 436
    },
    {
        start: 304,
        end: 272
    },
    {
        start: 272,
        end: 408
    },
    {
        start: 408,
        end: 304
    },
    {
        start: 395,
        end: 394
    },
    {
        start: 394,
        end: 431
    },
    {
        start: 431,
        end: 395
    },
    {
        start: 378,
        end: 395
    },
    {
        start: 395,
        end: 400
    },
    {
        start: 400,
        end: 378
    },
    {
        start: 296,
        end: 334
    },
    {
        start: 334,
        end: 299
    },
    {
        start: 299,
        end: 296
    },
    {
        start: 6,
        end: 351
    },
    {
        start: 351,
        end: 168
    },
    {
        start: 168,
        end: 6
    },
    {
        start: 376,
        end: 352
    },
    {
        start: 352,
        end: 411
    },
    {
        start: 411,
        end: 376
    },
    {
        start: 307,
        end: 325
    },
    {
        start: 325,
        end: 320
    },
    {
        start: 320,
        end: 307
    },
    {
        start: 285,
        end: 295
    },
    {
        start: 295,
        end: 336
    },
    {
        start: 336,
        end: 285
    },
    {
        start: 320,
        end: 319
    },
    {
        start: 319,
        end: 404
    },
    {
        start: 404,
        end: 320
    },
    {
        start: 329,
        end: 330
    },
    {
        start: 330,
        end: 349
    },
    {
        start: 349,
        end: 329
    },
    {
        start: 334,
        end: 293
    },
    {
        start: 293,
        end: 333
    },
    {
        start: 333,
        end: 334
    },
    {
        start: 366,
        end: 323
    },
    {
        start: 323,
        end: 447
    },
    {
        start: 447,
        end: 366
    },
    {
        start: 316,
        end: 15
    },
    {
        start: 15,
        end: 315
    },
    {
        start: 315,
        end: 316
    },
    {
        start: 331,
        end: 358
    },
    {
        start: 358,
        end: 279
    },
    {
        start: 279,
        end: 331
    },
    {
        start: 317,
        end: 14
    },
    {
        start: 14,
        end: 316
    },
    {
        start: 316,
        end: 317
    },
    {
        start: 8,
        end: 285
    },
    {
        start: 285,
        end: 9
    },
    {
        start: 9,
        end: 8
    },
    {
        start: 277,
        end: 329
    },
    {
        start: 329,
        end: 350
    },
    {
        start: 350,
        end: 277
    },
    {
        start: 253,
        end: 374
    },
    {
        start: 374,
        end: 252
    },
    {
        start: 252,
        end: 253
    },
    {
        start: 319,
        end: 318
    },
    {
        start: 318,
        end: 403
    },
    {
        start: 403,
        end: 319
    },
    {
        start: 351,
        end: 6
    },
    {
        start: 6,
        end: 419
    },
    {
        start: 419,
        end: 351
    },
    {
        start: 324,
        end: 318
    },
    {
        start: 318,
        end: 325
    },
    {
        start: 325,
        end: 324
    },
    {
        start: 397,
        end: 367
    },
    {
        start: 367,
        end: 365
    },
    {
        start: 365,
        end: 397
    },
    {
        start: 288,
        end: 435
    },
    {
        start: 435,
        end: 397
    },
    {
        start: 397,
        end: 288
    },
    {
        start: 278,
        end: 344
    },
    {
        start: 344,
        end: 439
    },
    {
        start: 439,
        end: 278
    },
    {
        start: 310,
        end: 272
    },
    {
        start: 272,
        end: 311
    },
    {
        start: 311,
        end: 310
    },
    {
        start: 248,
        end: 195
    },
    {
        start: 195,
        end: 281
    },
    {
        start: 281,
        end: 248
    },
    {
        start: 375,
        end: 273
    },
    {
        start: 273,
        end: 291
    },
    {
        start: 291,
        end: 375
    },
    {
        start: 175,
        end: 396
    },
    {
        start: 396,
        end: 199
    },
    {
        start: 199,
        end: 175
    },
    {
        start: 312,
        end: 311
    },
    {
        start: 311,
        end: 268
    },
    {
        start: 268,
        end: 312
    },
    {
        start: 276,
        end: 283
    },
    {
        start: 283,
        end: 445
    },
    {
        start: 445,
        end: 276
    },
    {
        start: 390,
        end: 373
    },
    {
        start: 373,
        end: 339
    },
    {
        start: 339,
        end: 390
    },
    {
        start: 295,
        end: 282
    },
    {
        start: 282,
        end: 296
    },
    {
        start: 296,
        end: 295
    },
    {
        start: 448,
        end: 449
    },
    {
        start: 449,
        end: 346
    },
    {
        start: 346,
        end: 448
    },
    {
        start: 356,
        end: 264
    },
    {
        start: 264,
        end: 454
    },
    {
        start: 454,
        end: 356
    },
    {
        start: 337,
        end: 336
    },
    {
        start: 336,
        end: 299
    },
    {
        start: 299,
        end: 337
    },
    {
        start: 337,
        end: 338
    },
    {
        start: 338,
        end: 151
    },
    {
        start: 151,
        end: 337
    },
    {
        start: 294,
        end: 278
    },
    {
        start: 278,
        end: 455
    },
    {
        start: 455,
        end: 294
    },
    {
        start: 308,
        end: 292
    },
    {
        start: 292,
        end: 415
    },
    {
        start: 415,
        end: 308
    },
    {
        start: 429,
        end: 358
    },
    {
        start: 358,
        end: 355
    },
    {
        start: 355,
        end: 429
    },
    {
        start: 265,
        end: 340
    },
    {
        start: 340,
        end: 372
    },
    {
        start: 372,
        end: 265
    },
    {
        start: 352,
        end: 346
    },
    {
        start: 346,
        end: 280
    },
    {
        start: 280,
        end: 352
    },
    {
        start: 295,
        end: 442
    },
    {
        start: 442,
        end: 282
    },
    {
        start: 282,
        end: 295
    },
    {
        start: 354,
        end: 19
    },
    {
        start: 19,
        end: 370
    },
    {
        start: 370,
        end: 354
    },
    {
        start: 285,
        end: 441
    },
    {
        start: 441,
        end: 295
    },
    {
        start: 295,
        end: 285
    },
    {
        start: 195,
        end: 248
    },
    {
        start: 248,
        end: 197
    },
    {
        start: 197,
        end: 195
    },
    {
        start: 457,
        end: 440
    },
    {
        start: 440,
        end: 274
    },
    {
        start: 274,
        end: 457
    },
    {
        start: 301,
        end: 300
    },
    {
        start: 300,
        end: 368
    },
    {
        start: 368,
        end: 301
    },
    {
        start: 417,
        end: 351
    },
    {
        start: 351,
        end: 465
    },
    {
        start: 465,
        end: 417
    },
    {
        start: 251,
        end: 301
    },
    {
        start: 301,
        end: 389
    },
    {
        start: 389,
        end: 251
    },
    {
        start: 394,
        end: 395
    },
    {
        start: 395,
        end: 379
    },
    {
        start: 379,
        end: 394
    },
    {
        start: 399,
        end: 412
    },
    {
        start: 412,
        end: 419
    },
    {
        start: 419,
        end: 399
    },
    {
        start: 410,
        end: 436
    },
    {
        start: 436,
        end: 322
    },
    {
        start: 322,
        end: 410
    },
    {
        start: 326,
        end: 2
    },
    {
        start: 2,
        end: 393
    },
    {
        start: 393,
        end: 326
    },
    {
        start: 354,
        end: 370
    },
    {
        start: 370,
        end: 461
    },
    {
        start: 461,
        end: 354
    },
    {
        start: 393,
        end: 164
    },
    {
        start: 164,
        end: 267
    },
    {
        start: 267,
        end: 393
    },
    {
        start: 268,
        end: 302
    },
    {
        start: 302,
        end: 12
    },
    {
        start: 12,
        end: 268
    },
    {
        start: 312,
        end: 268
    },
    {
        start: 268,
        end: 13
    },
    {
        start: 13,
        end: 312
    },
    {
        start: 298,
        end: 293
    },
    {
        start: 293,
        end: 301
    },
    {
        start: 301,
        end: 298
    },
    {
        start: 265,
        end: 446
    },
    {
        start: 446,
        end: 340
    },
    {
        start: 340,
        end: 265
    },
    {
        start: 280,
        end: 330
    },
    {
        start: 330,
        end: 425
    },
    {
        start: 425,
        end: 280
    },
    {
        start: 322,
        end: 426
    },
    {
        start: 426,
        end: 391
    },
    {
        start: 391,
        end: 322
    },
    {
        start: 420,
        end: 429
    },
    {
        start: 429,
        end: 437
    },
    {
        start: 437,
        end: 420
    },
    {
        start: 393,
        end: 391
    },
    {
        start: 391,
        end: 326
    },
    {
        start: 326,
        end: 393
    },
    {
        start: 344,
        end: 440
    },
    {
        start: 440,
        end: 438
    },
    {
        start: 438,
        end: 344
    },
    {
        start: 458,
        end: 459
    },
    {
        start: 459,
        end: 461
    },
    {
        start: 461,
        end: 458
    },
    {
        start: 364,
        end: 434
    },
    {
        start: 434,
        end: 394
    },
    {
        start: 394,
        end: 364
    },
    {
        start: 428,
        end: 396
    },
    {
        start: 396,
        end: 262
    },
    {
        start: 262,
        end: 428
    },
    {
        start: 274,
        end: 354
    },
    {
        start: 354,
        end: 457
    },
    {
        start: 457,
        end: 274
    },
    {
        start: 317,
        end: 316
    },
    {
        start: 316,
        end: 402
    },
    {
        start: 402,
        end: 317
    },
    {
        start: 316,
        end: 315
    },
    {
        start: 315,
        end: 403
    },
    {
        start: 403,
        end: 316
    },
    {
        start: 315,
        end: 314
    },
    {
        start: 314,
        end: 404
    },
    {
        start: 404,
        end: 315
    },
    {
        start: 314,
        end: 313
    },
    {
        start: 313,
        end: 405
    },
    {
        start: 405,
        end: 314
    },
    {
        start: 313,
        end: 421
    },
    {
        start: 421,
        end: 406
    },
    {
        start: 406,
        end: 313
    },
    {
        start: 323,
        end: 366
    },
    {
        start: 366,
        end: 361
    },
    {
        start: 361,
        end: 323
    },
    {
        start: 292,
        end: 306
    },
    {
        start: 306,
        end: 407
    },
    {
        start: 407,
        end: 292
    },
    {
        start: 306,
        end: 291
    },
    {
        start: 291,
        end: 408
    },
    {
        start: 408,
        end: 306
    },
    {
        start: 291,
        end: 287
    },
    {
        start: 287,
        end: 409
    },
    {
        start: 409,
        end: 291
    },
    {
        start: 287,
        end: 432
    },
    {
        start: 432,
        end: 410
    },
    {
        start: 410,
        end: 287
    },
    {
        start: 427,
        end: 434
    },
    {
        start: 434,
        end: 411
    },
    {
        start: 411,
        end: 427
    },
    {
        start: 372,
        end: 264
    },
    {
        start: 264,
        end: 383
    },
    {
        start: 383,
        end: 372
    },
    {
        start: 459,
        end: 309
    },
    {
        start: 309,
        end: 457
    },
    {
        start: 457,
        end: 459
    },
    {
        start: 366,
        end: 352
    },
    {
        start: 352,
        end: 401
    },
    {
        start: 401,
        end: 366
    },
    {
        start: 1,
        end: 274
    },
    {
        start: 274,
        end: 4
    },
    {
        start: 4,
        end: 1
    },
    {
        start: 418,
        end: 421
    },
    {
        start: 421,
        end: 262
    },
    {
        start: 262,
        end: 418
    },
    {
        start: 331,
        end: 294
    },
    {
        start: 294,
        end: 358
    },
    {
        start: 358,
        end: 331
    },
    {
        start: 435,
        end: 433
    },
    {
        start: 433,
        end: 367
    },
    {
        start: 367,
        end: 435
    },
    {
        start: 392,
        end: 289
    },
    {
        start: 289,
        end: 439
    },
    {
        start: 439,
        end: 392
    },
    {
        start: 328,
        end: 462
    },
    {
        start: 462,
        end: 326
    },
    {
        start: 326,
        end: 328
    },
    {
        start: 94,
        end: 2
    },
    {
        start: 2,
        end: 370
    },
    {
        start: 370,
        end: 94
    },
    {
        start: 289,
        end: 305
    },
    {
        start: 305,
        end: 455
    },
    {
        start: 455,
        end: 289
    },
    {
        start: 339,
        end: 254
    },
    {
        start: 254,
        end: 448
    },
    {
        start: 448,
        end: 339
    },
    {
        start: 359,
        end: 255
    },
    {
        start: 255,
        end: 446
    },
    {
        start: 446,
        end: 359
    },
    {
        start: 254,
        end: 253
    },
    {
        start: 253,
        end: 449
    },
    {
        start: 449,
        end: 254
    },
    {
        start: 253,
        end: 252
    },
    {
        start: 252,
        end: 450
    },
    {
        start: 450,
        end: 253
    },
    {
        start: 252,
        end: 256
    },
    {
        start: 256,
        end: 451
    },
    {
        start: 451,
        end: 252
    },
    {
        start: 256,
        end: 341
    },
    {
        start: 341,
        end: 452
    },
    {
        start: 452,
        end: 256
    },
    {
        start: 414,
        end: 413
    },
    {
        start: 413,
        end: 463
    },
    {
        start: 463,
        end: 414
    },
    {
        start: 286,
        end: 441
    },
    {
        start: 441,
        end: 414
    },
    {
        start: 414,
        end: 286
    },
    {
        start: 286,
        end: 258
    },
    {
        start: 258,
        end: 441
    },
    {
        start: 441,
        end: 286
    },
    {
        start: 258,
        end: 257
    },
    {
        start: 257,
        end: 442
    },
    {
        start: 442,
        end: 258
    },
    {
        start: 257,
        end: 259
    },
    {
        start: 259,
        end: 443
    },
    {
        start: 443,
        end: 257
    },
    {
        start: 259,
        end: 260
    },
    {
        start: 260,
        end: 444
    },
    {
        start: 444,
        end: 259
    },
    {
        start: 260,
        end: 467
    },
    {
        start: 467,
        end: 445
    },
    {
        start: 445,
        end: 260
    },
    {
        start: 309,
        end: 459
    },
    {
        start: 459,
        end: 250
    },
    {
        start: 250,
        end: 309
    },
    {
        start: 305,
        end: 289
    },
    {
        start: 289,
        end: 290
    },
    {
        start: 290,
        end: 305
    },
    {
        start: 305,
        end: 290
    },
    {
        start: 290,
        end: 460
    },
    {
        start: 460,
        end: 305
    },
    {
        start: 401,
        end: 376
    },
    {
        start: 376,
        end: 435
    },
    {
        start: 435,
        end: 401
    },
    {
        start: 309,
        end: 250
    },
    {
        start: 250,
        end: 392
    },
    {
        start: 392,
        end: 309
    },
    {
        start: 376,
        end: 411
    },
    {
        start: 411,
        end: 433
    },
    {
        start: 433,
        end: 376
    },
    {
        start: 453,
        end: 341
    },
    {
        start: 341,
        end: 464
    },
    {
        start: 464,
        end: 453
    },
    {
        start: 357,
        end: 453
    },
    {
        start: 453,
        end: 465
    },
    {
        start: 465,
        end: 357
    },
    {
        start: 343,
        end: 357
    },
    {
        start: 357,
        end: 412
    },
    {
        start: 412,
        end: 343
    },
    {
        start: 437,
        end: 343
    },
    {
        start: 343,
        end: 399
    },
    {
        start: 399,
        end: 437
    },
    {
        start: 344,
        end: 360
    },
    {
        start: 360,
        end: 440
    },
    {
        start: 440,
        end: 344
    },
    {
        start: 420,
        end: 437
    },
    {
        start: 437,
        end: 456
    },
    {
        start: 456,
        end: 420
    },
    {
        start: 360,
        end: 420
    },
    {
        start: 420,
        end: 363
    },
    {
        start: 363,
        end: 360
    },
    {
        start: 361,
        end: 401
    },
    {
        start: 401,
        end: 288
    },
    {
        start: 288,
        end: 361
    },
    {
        start: 265,
        end: 372
    },
    {
        start: 372,
        end: 353
    },
    {
        start: 353,
        end: 265
    },
    {
        start: 390,
        end: 339
    },
    {
        start: 339,
        end: 249
    },
    {
        start: 249,
        end: 390
    },
    {
        start: 339,
        end: 448
    },
    {
        start: 448,
        end: 255
    },
    {
        start: 255,
        end: 339
    }
];
var face_landmarker_options = {};
Object.defineProperty(face_landmarker_options, "__esModule", {
    value: !0
});
var face_landmarker_result = {};
Object.defineProperty(face_landmarker_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.FaceLandmarker = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = classification_pb, n11 = landmark_pb, s11 = base_options_pb, p11 = face_detector_graph_options_pb, d11 = face_geometry_pb, l11 = face_landmarker_graph_options_pb, g11 = face_landmarks_detector_graph_options_pb, c11 = classifier_result, u11 = landmark_result, m11 = vision_task_runner, f11 = face_landmarks_connections;
    r11(face_landmarker_options, e11), r11(face_landmarker_result, e11);
    const h11 = "image_in", y11 = "norm_rect", b11 = "face_landmarks", _11 = "blendshapes", O11 = "face_geometry", F11 = .5;
    class M11 extends m11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return m11.VisionTaskRunner.createVisionInstance(M11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return m11.VisionTaskRunner.createVisionInstance(M11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return m11.VisionTaskRunner.createVisionInstance(M11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new m11.VisionGraphRunner(e11, t11), h11, y11, !1), this.result = {
                faceLandmarks: []
            }, this.outputFaceBlendshapes = !1, this.outputFacialTransformationMatrixes = !1, this.options = new l11.FaceLandmarkerGraphOptions, this.options.setBaseOptions(new s11.BaseOptions), this.faceLandmarksDetectorGraphOptions = new g11.FaceLandmarksDetectorGraphOptions, this.options.setFaceLandmarksDetectorGraphOptions(this.faceLandmarksDetectorGraphOptions), this.faceDetectorGraphOptions = new p11.FaceDetectorGraphOptions, this.options.setFaceDetectorGraphOptions(this.faceDetectorGraphOptions), this.initDefaults();
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            var t11, r11, o11, i11;
            return "numFaces" in e11 && this.faceDetectorGraphOptions.setNumFaces(null !== (t11 = e11.numFaces) && void 0 !== t11 ? t11 : 1), "minFaceDetectionConfidence" in e11 && this.faceDetectorGraphOptions.setMinDetectionConfidence(null !== (r11 = e11.minFaceDetectionConfidence) && void 0 !== r11 ? r11 : F11), "minTrackingConfidence" in e11 && this.options.setMinTrackingConfidence(null !== (o11 = e11.minTrackingConfidence) && void 0 !== o11 ? o11 : F11), "minFacePresenceConfidence" in e11 && this.faceLandmarksDetectorGraphOptions.setMinDetectionConfidence(null !== (i11 = e11.minFacePresenceConfidence) && void 0 !== i11 ? i11 : F11), "outputFaceBlendshapes" in e11 && (this.outputFaceBlendshapes = !!e11.outputFaceBlendshapes), "outputFacialTransformationMatrixes" in e11 && (this.outputFacialTransformationMatrixes = !!e11.outputFacialTransformationMatrixes), this.applyOptions(e11);
        }
        detect(e11, t11) {
            return this.resetResults(), this.processImageData(e11, t11), this.result;
        }
        detectForVideo(e11, t11, r11) {
            return this.resetResults(), this.processVideoData(e11, r11, t11), this.result;
        }
        resetResults() {
            this.result = {
                faceLandmarks: []
            }, this.outputFaceBlendshapes && (this.result.faceBlendshapes = []), this.outputFacialTransformationMatrixes && (this.result.facialTransformationMatrixes = []);
        }
        initDefaults() {
            this.faceDetectorGraphOptions.setNumFaces(1), this.faceDetectorGraphOptions.setMinDetectionConfidence(F11), this.faceLandmarksDetectorGraphOptions.setMinDetectionConfidence(F11), this.options.setMinTrackingConfidence(F11);
        }
        addJsLandmarks(e11) {
            for (const t11 of e11){
                const e11 = n11.NormalizedLandmarkList.deserializeBinary(t11);
                this.result.faceLandmarks.push((0, u11.convertToLandmarks)(e11));
            }
        }
        addBlenshape(e11) {
            var t11;
            if (this.result.faceBlendshapes) for (const r11 of e11){
                const e11 = a11.ClassificationList.deserializeBinary(r11);
                this.result.faceBlendshapes.push((0, c11.convertFromClassifications)(null !== (t11 = e11.getClassificationList()) && void 0 !== t11 ? t11 : []));
            }
        }
        addFacialTransformationMatrixes(e11) {
            var t11, r11, o11;
            if (this.result.facialTransformationMatrixes) for (const i11 of e11){
                const e11 = d11.FaceGeometry.deserializeBinary(i11).getPoseTransformMatrix();
                e11 && this.result.facialTransformationMatrixes.push({
                    rows: null !== (t11 = e11.getRows()) && void 0 !== t11 ? t11 : 0,
                    columns: null !== (r11 = e11.getCols()) && void 0 !== r11 ? r11 : 0,
                    data: null !== (o11 = e11.getPackedDataList()) && void 0 !== o11 ? o11 : []
                });
            }
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(h11), e11.addInputStream(y11), e11.addOutputStream(b11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(l11.FaceLandmarkerGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.face_landmarker.FaceLandmarkerGraph"), r11.addInputStream("IMAGE:" + h11), r11.addInputStream("NORM_RECT:" + y11), r11.addOutputStream("NORM_LANDMARKS:" + b11), r11.setOptions(t11), e11.addNode(r11), this.graphRunner.attachProtoVectorListener(b11, (e11, t11)=>{
                this.addJsLandmarks(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(b11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            }), this.outputFaceBlendshapes && (e11.addOutputStream(_11), r11.addOutputStream("BLENDSHAPES:" + _11), this.graphRunner.attachProtoVectorListener(_11, (e11, t11)=>{
                this.addBlenshape(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(_11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            })), this.outputFacialTransformationMatrixes && (e11.addOutputStream(O11), r11.addOutputStream("FACE_GEOMETRY:" + O11), this.graphRunner.attachProtoVectorListener(O11, (e11, t11)=>{
                this.addFacialTransformationMatrixes(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(O11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            }));
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.FaceLandmarker = M11, M11.FACE_LANDMARKS_LIPS = f11.FACE_LANDMARKS_LIPS, M11.FACE_LANDMARKS_LEFT_EYE = f11.FACE_LANDMARKS_LEFT_EYE, M11.FACE_LANDMARKS_LEFT_EYEBROW = f11.FACE_LANDMARKS_LEFT_EYEBROW, M11.FACE_LANDMARKS_LEFT_IRIS = f11.FACE_LANDMARKS_LEFT_IRIS, M11.FACE_LANDMARKS_RIGHT_EYE = f11.FACE_LANDMARKS_RIGHT_EYE, M11.FACE_LANDMARKS_RIGHT_EYEBROW = f11.FACE_LANDMARKS_RIGHT_EYEBROW, M11.FACE_LANDMARKS_RIGHT_IRIS = f11.FACE_LANDMARKS_RIGHT_IRIS, M11.FACE_LANDMARKS_FACE_OVAL = f11.FACE_LANDMARKS_FACE_OVAL, M11.FACE_LANDMARKS_CONTOURS = f11.FACE_LANDMARKS_CONTOURS, M11.FACE_LANDMARKS_TESSELATION = f11.FACE_LANDMARKS_TESSELATION;
}(face_landmarker);
var face_stylizer = {}, face_stylizer_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11);
    var s11 = face_landmarker_graph_options_pb;
    r11.object.extend(proto, s11), r11.exportSymbol("proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions", null, o11), proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.displayName = "proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            baseOptions: (r11 = t11.getBaseOptions()) && n11.BaseOptions.toObject(e11, r11),
            faceLandmarkerGraphOptions: (r11 = t11.getFaceLandmarkerGraphOptions()) && s11.FaceLandmarkerGraphOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions;
        return proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new s11.FaceLandmarkerGraphOptions;
                t11.readMessage(r11, s11.FaceLandmarkerGraphOptions.deserializeBinaryFromReader), e11.setFaceLandmarkerGraphOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getBaseOptions()) && t11.writeMessage(1, r11, n11.BaseOptions.serializeBinaryToWriter), null != (r11 = e11.getFaceLandmarkerGraphOptions()) && t11.writeMessage(2, r11, s11.FaceLandmarkerGraphOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.ext = new t11.ExtensionFieldInfo(513916220, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[513916220] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[513916220] = proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.ext, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.getFaceLandmarkerGraphOptions = function() {
        return t11.Message.getWrapperField(this, s11.FaceLandmarkerGraphOptions, 2);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.setFaceLandmarkerGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.clearFaceLandmarkerGraphOptions = function() {
        return this.setFaceLandmarkerGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.prototype.hasFaceLandmarkerGraphOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.ext = new t11.ExtensionFieldInfo(513916220, {
        ext: 0
    }, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[513916220] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[513916220] = proto.mediapipe.tasks.vision.face_stylizer.proto.FaceStylizerGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.face_stylizer.proto);
}(face_stylizer_graph_options_pb);
var face_stylizer_options = {};
Object.defineProperty(face_stylizer_options, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.FaceStylizer = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = base_options_pb, n11 = face_stylizer_graph_options_pb, s11 = vision_task_runner;
    r11(face_stylizer_options, e11);
    const p11 = "image_in", d11 = "norm_rect", l11 = "stylized_image";
    class g11 extends s11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return s11.VisionTaskRunner.createVisionInstance(g11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return s11.VisionTaskRunner.createVisionInstance(g11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return s11.VisionTaskRunner.createVisionInstance(g11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new s11.VisionGraphRunner(e11, t11), p11, d11, !0), this.options = new n11.FaceStylizerGraphOptions, this.options.setBaseOptions(new a11.BaseOptions);
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            return super.applyOptions(e11);
        }
        stylize(e11, t11, r11) {
            const o11 = "function" != typeof t11 ? t11 : {};
            if (this.userCallback = "function" == typeof t11 ? t11 : r11, this.processImageData(e11, null != o11 ? o11 : {}), !this.userCallback) return this.result;
        }
        stylizeForVideo(e11, t11, r11, o11) {
            const i11 = "function" != typeof r11 ? r11 : {};
            if (this.userCallback = "function" == typeof r11 ? r11 : o11, this.processVideoData(e11, i11, t11), this.userCallback = void 0, !this.userCallback) return this.result;
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(p11), e11.addInputStream(d11), e11.addOutputStream(l11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(n11.FaceStylizerGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.face_stylizer.FaceStylizerGraph"), r11.addInputStream("IMAGE:" + p11), r11.addInputStream("NORM_RECT:" + d11), r11.addOutputStream("STYLIZED_IMAGE:" + l11), r11.setOptions(t11), e11.addNode(r11), this.graphRunner.attachImageListener(l11, (e11, t11)=>{
                const r11 = this.convertToMPImage(e11, !this.userCallback);
                this.result = r11, this.userCallback && this.userCallback(r11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(l11, (e11)=>{
                this.result = null, this.userCallback && this.userCallback(null), this.setLatestOutputTimestamp(e11);
            });
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.FaceStylizer = g11;
}(face_stylizer);
var gesture_recognizer = {}, gesture_classifier_graph_options_pb = {}, classifier_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.tasks.components.processors.proto.ClassifierOptions", null, o11), proto.mediapipe.tasks.components.processors.proto.ClassifierOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.tasks.components.processors.proto.ClassifierOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.displayName = "proto.mediapipe.tasks.components.processors.proto.ClassifierOptions"), proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.repeatedFields_ = [
        4,
        5
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            displayNamesLocale: t11.Message.getFieldWithDefault(r11, 1, "en"),
            maxResults: t11.Message.getFieldWithDefault(r11, 2, -1),
            scoreThreshold: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            categoryAllowlistList: null == (o11 = t11.Message.getRepeatedField(r11, 4)) ? void 0 : o11,
            categoryDenylistList: null == (o11 = t11.Message.getRepeatedField(r11, 5)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.components.processors.proto.ClassifierOptions;
        return proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setDisplayNamesLocale(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setMaxResults(r11);
                break;
            case 3:
                r11 = t11.readFloat();
                e11.setScoreThreshold(r11);
                break;
            case 4:
                r11 = t11.readString();
                e11.addCategoryAllowlist(r11);
                break;
            case 5:
                r11 = t11.readString();
                e11.addCategoryDenylist(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeFloat(3, o11), (o11 = e11.getCategoryAllowlistList()).length > 0 && r11.writeRepeatedString(4, o11), (o11 = e11.getCategoryDenylistList()).length > 0 && r11.writeRepeatedString(5, o11);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.getDisplayNamesLocale = function() {
        return t11.Message.getFieldWithDefault(this, 1, "en");
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.setDisplayNamesLocale = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.clearDisplayNamesLocale = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.hasDisplayNamesLocale = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.getMaxResults = function() {
        return t11.Message.getFieldWithDefault(this, 2, -1);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.setMaxResults = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.clearMaxResults = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.hasMaxResults = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.getScoreThreshold = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.setScoreThreshold = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.clearScoreThreshold = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.hasScoreThreshold = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.getCategoryAllowlistList = function() {
        return t11.Message.getRepeatedField(this, 4);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.setCategoryAllowlistList = function(e11) {
        return t11.Message.setField(this, 4, e11 || []);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.addCategoryAllowlist = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 4, e11, r11);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.clearCategoryAllowlistList = function() {
        return this.setCategoryAllowlistList([]);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.getCategoryDenylistList = function() {
        return t11.Message.getRepeatedField(this, 5);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.setCategoryDenylistList = function(e11) {
        return t11.Message.setField(this, 5, e11 || []);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.addCategoryDenylist = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 5, e11, r11);
    }, proto.mediapipe.tasks.components.processors.proto.ClassifierOptions.prototype.clearCategoryDenylistList = function() {
        return this.setCategoryDenylistList([]);
    }, r11.object.extend(e11, proto.mediapipe.tasks.components.processors.proto);
}(classifier_options_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = classifier_options_pb;
    r11.object.extend(proto, n11);
    var s11 = base_options_pb;
    r11.object.extend(proto, s11), r11.exportSymbol("proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions", null, o11), proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.displayName = "proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            baseOptions: (r11 = t11.getBaseOptions()) && s11.BaseOptions.toObject(e11, r11),
            classifierOptions: (r11 = t11.getClassifierOptions()) && n11.ClassifierOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions;
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new s11.BaseOptions;
                t11.readMessage(r11, s11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new n11.ClassifierOptions;
                t11.readMessage(r11, n11.ClassifierOptions.deserializeBinaryFromReader), e11.setClassifierOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getBaseOptions()) && t11.writeMessage(1, r11, s11.BaseOptions.serializeBinaryToWriter), null != (r11 = e11.getClassifierOptions()) && t11.writeMessage(2, r11, n11.ClassifierOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.ext = new t11.ExtensionFieldInfo(478825465, {
        ext: 0
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[478825465] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[478825465] = proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.ext, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, s11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.getClassifierOptions = function() {
        return t11.Message.getWrapperField(this, n11.ClassifierOptions, 2);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.setClassifierOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.clearClassifierOptions = function() {
        return this.setClassifierOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.prototype.hasClassifierOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.ext = new t11.ExtensionFieldInfo(478825465, {
        ext: 0
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[478825465] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[478825465] = proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureClassifierGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.gesture_recognizer.proto);
}(gesture_classifier_graph_options_pb);
var gesture_recognizer_graph_options_pb = {}, hand_gesture_recognizer_graph_options_pb = {}, gesture_embedder_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions", null, o11), proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.displayName = "proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            baseOptions: (r11 = t11.getBaseOptions()) && n11.BaseOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions;
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new n11.BaseOptions;
            t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        null != (r11 = e11.getBaseOptions()) && t11.writeMessage(1, r11, n11.BaseOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.ext = new t11.ExtensionFieldInfo(478825422, {
        ext: 0
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[478825422] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[478825422] = proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.ext, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.ext = new t11.ExtensionFieldInfo(478825422, {
        ext: 0
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[478825422] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[478825422] = proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureEmbedderGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.gesture_recognizer.proto);
}(gesture_embedder_graph_options_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11);
    var s11 = gesture_classifier_graph_options_pb;
    r11.object.extend(proto, s11);
    var p11 = gesture_embedder_graph_options_pb;
    r11.object.extend(proto, p11), r11.exportSymbol("proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions", null, o11), proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.displayName = "proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            baseOptions: (r11 = t11.getBaseOptions()) && n11.BaseOptions.toObject(e11, r11),
            gestureEmbedderGraphOptions: (r11 = t11.getGestureEmbedderGraphOptions()) && p11.GestureEmbedderGraphOptions.toObject(e11, r11),
            cannedGestureClassifierGraphOptions: (r11 = t11.getCannedGestureClassifierGraphOptions()) && s11.GestureClassifierGraphOptions.toObject(e11, r11),
            customGestureClassifierGraphOptions: (r11 = t11.getCustomGestureClassifierGraphOptions()) && s11.GestureClassifierGraphOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions;
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new p11.GestureEmbedderGraphOptions;
                t11.readMessage(r11, p11.GestureEmbedderGraphOptions.deserializeBinaryFromReader), e11.setGestureEmbedderGraphOptions(r11);
                break;
            case 3:
                r11 = new s11.GestureClassifierGraphOptions;
                t11.readMessage(r11, s11.GestureClassifierGraphOptions.deserializeBinaryFromReader), e11.setCannedGestureClassifierGraphOptions(r11);
                break;
            case 4:
                r11 = new s11.GestureClassifierGraphOptions;
                t11.readMessage(r11, s11.GestureClassifierGraphOptions.deserializeBinaryFromReader), e11.setCustomGestureClassifierGraphOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getBaseOptions()) && t11.writeMessage(1, r11, n11.BaseOptions.serializeBinaryToWriter), null != (r11 = e11.getGestureEmbedderGraphOptions()) && t11.writeMessage(2, r11, p11.GestureEmbedderGraphOptions.serializeBinaryToWriter), null != (r11 = e11.getCannedGestureClassifierGraphOptions()) && t11.writeMessage(3, r11, s11.GestureClassifierGraphOptions.serializeBinaryToWriter), null != (r11 = e11.getCustomGestureClassifierGraphOptions()) && t11.writeMessage(4, r11, s11.GestureClassifierGraphOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.ext = new t11.ExtensionFieldInfo(463370452, {
        ext: 0
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[463370452] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[463370452] = proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.ext, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.getGestureEmbedderGraphOptions = function() {
        return t11.Message.getWrapperField(this, p11.GestureEmbedderGraphOptions, 2);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.setGestureEmbedderGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.clearGestureEmbedderGraphOptions = function() {
        return this.setGestureEmbedderGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.hasGestureEmbedderGraphOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.getCannedGestureClassifierGraphOptions = function() {
        return t11.Message.getWrapperField(this, s11.GestureClassifierGraphOptions, 3);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.setCannedGestureClassifierGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.clearCannedGestureClassifierGraphOptions = function() {
        return this.setCannedGestureClassifierGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.hasCannedGestureClassifierGraphOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.getCustomGestureClassifierGraphOptions = function() {
        return t11.Message.getWrapperField(this, s11.GestureClassifierGraphOptions, 4);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.setCustomGestureClassifierGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 4, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.clearCustomGestureClassifierGraphOptions = function() {
        return this.setCustomGestureClassifierGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.prototype.hasCustomGestureClassifierGraphOptions = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.ext = new t11.ExtensionFieldInfo(463370452, {
        ext: 0
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[463370452] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[463370452] = proto.mediapipe.tasks.vision.gesture_recognizer.proto.HandGestureRecognizerGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.gesture_recognizer.proto);
}(hand_gesture_recognizer_graph_options_pb);
var hand_landmarker_graph_options_pb = {}, hand_detector_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions", null, o11), proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.displayName = "proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            minDetectionConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 2, .5),
            numHands: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions;
        return proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setMinDetectionConfidence(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setNumHands(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(464864288, {
        ext: 0
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[464864288] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[464864288] = proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.ext, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.getMinDetectionConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, .5);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.setMinDetectionConfidence = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.clearMinDetectionConfidence = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.hasMinDetectionConfidence = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.getNumHands = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.setNumHands = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.clearNumHands = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.prototype.hasNumHands = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(464864288, {
        ext: 0
    }, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[464864288] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[464864288] = proto.mediapipe.tasks.vision.hand_detector.proto.HandDetectorGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.hand_detector.proto);
}(hand_detector_graph_options_pb);
var hand_landmarks_detector_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions", null, o11), proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.displayName = "proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            minDetectionConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 2, .5)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions;
        return proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setMinDetectionConfidence(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(474472470, {
        ext: 0
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[474472470] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[474472470] = proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.ext, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.getMinDetectionConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, .5);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.setMinDetectionConfidence = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.clearMinDetectionConfidence = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.prototype.hasMinDetectionConfidence = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(474472470, {
        ext: 0
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[474472470] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[474472470] = proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarksDetectorGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.hand_landmarker.proto);
}(hand_landmarks_detector_graph_options_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11);
    var s11 = hand_detector_graph_options_pb;
    r11.object.extend(proto, s11);
    var p11 = hand_landmarks_detector_graph_options_pb;
    r11.object.extend(proto, p11), r11.exportSymbol("proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions", null, o11), proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.displayName = "proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            handDetectorGraphOptions: (o11 = r11.getHandDetectorGraphOptions()) && s11.HandDetectorGraphOptions.toObject(e11, o11),
            handLandmarksDetectorGraphOptions: (o11 = r11.getHandLandmarksDetectorGraphOptions()) && p11.HandLandmarksDetectorGraphOptions.toObject(e11, o11),
            minTrackingConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 4, .5)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions;
        return proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new s11.HandDetectorGraphOptions;
                t11.readMessage(r11, s11.HandDetectorGraphOptions.deserializeBinaryFromReader), e11.setHandDetectorGraphOptions(r11);
                break;
            case 3:
                r11 = new p11.HandLandmarksDetectorGraphOptions;
                t11.readMessage(r11, p11.HandLandmarksDetectorGraphOptions.deserializeBinaryFromReader), e11.setHandLandmarksDetectorGraphOptions(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setMinTrackingConfidence(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = e11.getHandDetectorGraphOptions()) && r11.writeMessage(2, o11, s11.HandDetectorGraphOptions.serializeBinaryToWriter), null != (o11 = e11.getHandLandmarksDetectorGraphOptions()) && r11.writeMessage(3, o11, p11.HandLandmarksDetectorGraphOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.ext = new t11.ExtensionFieldInfo(462713202, {
        ext: 0
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[462713202] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[462713202] = proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.ext, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.getHandDetectorGraphOptions = function() {
        return t11.Message.getWrapperField(this, s11.HandDetectorGraphOptions, 2);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.setHandDetectorGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.clearHandDetectorGraphOptions = function() {
        return this.setHandDetectorGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.hasHandDetectorGraphOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.getHandLandmarksDetectorGraphOptions = function() {
        return t11.Message.getWrapperField(this, p11.HandLandmarksDetectorGraphOptions, 3);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.setHandLandmarksDetectorGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.clearHandLandmarksDetectorGraphOptions = function() {
        return this.setHandLandmarksDetectorGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.hasHandLandmarksDetectorGraphOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.getMinTrackingConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, .5);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.setMinTrackingConfidence = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.clearMinTrackingConfidence = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.prototype.hasMinTrackingConfidence = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.ext = new t11.ExtensionFieldInfo(462713202, {
        ext: 0
    }, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[462713202] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[462713202] = proto.mediapipe.tasks.vision.hand_landmarker.proto.HandLandmarkerGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.hand_landmarker.proto);
}(hand_landmarker_graph_options_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11);
    var s11 = hand_gesture_recognizer_graph_options_pb;
    r11.object.extend(proto, s11);
    var p11 = hand_landmarker_graph_options_pb;
    r11.object.extend(proto, p11), r11.exportSymbol("proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions", null, o11), proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.displayName = "proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            baseOptions: (r11 = t11.getBaseOptions()) && n11.BaseOptions.toObject(e11, r11),
            handLandmarkerGraphOptions: (r11 = t11.getHandLandmarkerGraphOptions()) && p11.HandLandmarkerGraphOptions.toObject(e11, r11),
            handGestureRecognizerGraphOptions: (r11 = t11.getHandGestureRecognizerGraphOptions()) && s11.HandGestureRecognizerGraphOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions;
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new p11.HandLandmarkerGraphOptions;
                t11.readMessage(r11, p11.HandLandmarkerGraphOptions.deserializeBinaryFromReader), e11.setHandLandmarkerGraphOptions(r11);
                break;
            case 3:
                r11 = new s11.HandGestureRecognizerGraphOptions;
                t11.readMessage(r11, s11.HandGestureRecognizerGraphOptions.deserializeBinaryFromReader), e11.setHandGestureRecognizerGraphOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getBaseOptions()) && t11.writeMessage(1, r11, n11.BaseOptions.serializeBinaryToWriter), null != (r11 = e11.getHandLandmarkerGraphOptions()) && t11.writeMessage(2, r11, p11.HandLandmarkerGraphOptions.serializeBinaryToWriter), null != (r11 = e11.getHandGestureRecognizerGraphOptions()) && t11.writeMessage(3, r11, s11.HandGestureRecognizerGraphOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.ext = new t11.ExtensionFieldInfo(479097054, {
        ext: 0
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[479097054] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[479097054] = proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.ext, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.getHandLandmarkerGraphOptions = function() {
        return t11.Message.getWrapperField(this, p11.HandLandmarkerGraphOptions, 2);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.setHandLandmarkerGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.clearHandLandmarkerGraphOptions = function() {
        return this.setHandLandmarkerGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.hasHandLandmarkerGraphOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.getHandGestureRecognizerGraphOptions = function() {
        return t11.Message.getWrapperField(this, s11.HandGestureRecognizerGraphOptions, 3);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.setHandGestureRecognizerGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.clearHandGestureRecognizerGraphOptions = function() {
        return this.setHandGestureRecognizerGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.prototype.hasHandGestureRecognizerGraphOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.ext = new t11.ExtensionFieldInfo(479097054, {
        ext: 0
    }, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[479097054] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[479097054] = proto.mediapipe.tasks.vision.gesture_recognizer.proto.GestureRecognizerGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.gesture_recognizer.proto);
}(gesture_recognizer_graph_options_pb);
var classifier_options = {};
Object.defineProperty(classifier_options, "__esModule", {
    value: !0
}), classifier_options.convertClassifierOptionsToProto = void 0;
const classifier_options_pb_1 = classifier_options_pb;
function convertClassifierOptionsToProto(e11, t11) {
    const r11 = t11 ? t11.clone() : new classifier_options_pb_1.ClassifierOptions;
    return void 0 !== e11.displayNamesLocale ? r11.setDisplayNamesLocale(e11.displayNamesLocale) : void 0 === e11.displayNamesLocale && r11.clearDisplayNamesLocale(), void 0 !== e11.maxResults ? r11.setMaxResults(e11.maxResults) : "maxResults" in e11 && r11.clearMaxResults(), void 0 !== e11.scoreThreshold ? r11.setScoreThreshold(e11.scoreThreshold) : "scoreThreshold" in e11 && r11.clearScoreThreshold(), void 0 !== e11.categoryAllowlist ? r11.setCategoryAllowlistList(e11.categoryAllowlist) : "categoryAllowlist" in e11 && r11.clearCategoryAllowlistList(), void 0 !== e11.categoryDenylist ? r11.setCategoryDenylistList(e11.categoryDenylist) : "categoryDenylist" in e11 && r11.clearCategoryDenylistList(), r11;
}
classifier_options.convertClassifierOptionsToProto = convertClassifierOptionsToProto;
var hand_landmarks_connections = {};
Object.defineProperty(hand_landmarks_connections, "__esModule", {
    value: !0
}), hand_landmarks_connections.HAND_CONNECTIONS = void 0, hand_landmarks_connections.HAND_CONNECTIONS = [
    {
        start: 0,
        end: 1
    },
    {
        start: 1,
        end: 2
    },
    {
        start: 2,
        end: 3
    },
    {
        start: 3,
        end: 4
    },
    {
        start: 0,
        end: 5
    },
    {
        start: 5,
        end: 6
    },
    {
        start: 6,
        end: 7
    },
    {
        start: 7,
        end: 8
    },
    {
        start: 5,
        end: 9
    },
    {
        start: 9,
        end: 10
    },
    {
        start: 10,
        end: 11
    },
    {
        start: 11,
        end: 12
    },
    {
        start: 9,
        end: 13
    },
    {
        start: 13,
        end: 14
    },
    {
        start: 14,
        end: 15
    },
    {
        start: 15,
        end: 16
    },
    {
        start: 13,
        end: 17
    },
    {
        start: 0,
        end: 17
    },
    {
        start: 17,
        end: 18
    },
    {
        start: 18,
        end: 19
    },
    {
        start: 19,
        end: 20
    }
];
var gesture_recognizer_options = {};
Object.defineProperty(gesture_recognizer_options, "__esModule", {
    value: !0
});
var gesture_recognizer_result = {};
Object.defineProperty(gesture_recognizer_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.GestureRecognizer = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = classification_pb, n11 = landmark_pb, s11 = base_options_pb, p11 = gesture_classifier_graph_options_pb, d11 = gesture_recognizer_graph_options_pb, l11 = hand_gesture_recognizer_graph_options_pb, g11 = hand_detector_graph_options_pb, c11 = hand_landmarker_graph_options_pb, u11 = hand_landmarks_detector_graph_options_pb, m11 = classifier_options, f11 = vision_task_runner, h11 = hand_landmarks_connections;
    r11(gesture_recognizer_options, e11), r11(gesture_recognizer_result, e11);
    const y11 = "image_in", b11 = "norm_rect", _11 = "hand_gestures", O11 = "hand_landmarks", F11 = "world_hand_landmarks", M11 = "handedness", R11 = .5;
    class k11 extends f11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return f11.VisionTaskRunner.createVisionInstance(k11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return f11.VisionTaskRunner.createVisionInstance(k11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return f11.VisionTaskRunner.createVisionInstance(k11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new f11.VisionGraphRunner(e11, t11), y11, b11, !1), this.gestures = [], this.landmarks = [], this.worldLandmarks = [], this.handednesses = [], this.options = new d11.GestureRecognizerGraphOptions, this.options.setBaseOptions(new s11.BaseOptions), this.handLandmarkerGraphOptions = new c11.HandLandmarkerGraphOptions, this.options.setHandLandmarkerGraphOptions(this.handLandmarkerGraphOptions), this.handLandmarksDetectorGraphOptions = new u11.HandLandmarksDetectorGraphOptions, this.handLandmarkerGraphOptions.setHandLandmarksDetectorGraphOptions(this.handLandmarksDetectorGraphOptions), this.handDetectorGraphOptions = new g11.HandDetectorGraphOptions, this.handLandmarkerGraphOptions.setHandDetectorGraphOptions(this.handDetectorGraphOptions), this.handGestureRecognizerGraphOptions = new l11.HandGestureRecognizerGraphOptions, this.options.setHandGestureRecognizerGraphOptions(this.handGestureRecognizerGraphOptions), this.handDetectorGraphOptions.setMinDetectionConfidence(R11), this.handLandmarkerGraphOptions.setMinTrackingConfidence(R11), this.handLandmarksDetectorGraphOptions.setMinDetectionConfidence(R11);
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            var t11, r11, o11, i11, a11, n11, s11, d11;
            if (this.handDetectorGraphOptions.setNumHands(null !== (t11 = e11.numHands) && void 0 !== t11 ? t11 : 1), "minHandDetectionConfidence" in e11 && this.handDetectorGraphOptions.setMinDetectionConfidence(null !== (r11 = e11.minHandDetectionConfidence) && void 0 !== r11 ? r11 : R11), "minTrackingConfidence" in e11 && this.handLandmarkerGraphOptions.setMinTrackingConfidence(null !== (o11 = e11.minTrackingConfidence) && void 0 !== o11 ? o11 : R11), "minHandPresenceConfidence" in e11 && this.handLandmarksDetectorGraphOptions.setMinDetectionConfidence(null !== (i11 = e11.minHandPresenceConfidence) && void 0 !== i11 ? i11 : R11), e11.cannedGesturesClassifierOptions) {
                const t11 = new p11.GestureClassifierGraphOptions;
                t11.setClassifierOptions((0, m11.convertClassifierOptionsToProto)(e11.cannedGesturesClassifierOptions, null === (a11 = this.handGestureRecognizerGraphOptions.getCannedGestureClassifierGraphOptions()) || void 0 === a11 ? void 0 : a11.getClassifierOptions())), this.handGestureRecognizerGraphOptions.setCannedGestureClassifierGraphOptions(t11);
            } else void 0 === e11.cannedGesturesClassifierOptions && (null === (n11 = this.handGestureRecognizerGraphOptions.getCannedGestureClassifierGraphOptions()) || void 0 === n11 || n11.clearClassifierOptions());
            if (e11.customGesturesClassifierOptions) {
                const t11 = new p11.GestureClassifierGraphOptions;
                t11.setClassifierOptions((0, m11.convertClassifierOptionsToProto)(e11.customGesturesClassifierOptions, null === (s11 = this.handGestureRecognizerGraphOptions.getCustomGestureClassifierGraphOptions()) || void 0 === s11 ? void 0 : s11.getClassifierOptions())), this.handGestureRecognizerGraphOptions.setCustomGestureClassifierGraphOptions(t11);
            } else void 0 === e11.customGesturesClassifierOptions && (null === (d11 = this.handGestureRecognizerGraphOptions.getCustomGestureClassifierGraphOptions()) || void 0 === d11 || d11.clearClassifierOptions());
            return this.applyOptions(e11);
        }
        recognize(e11, t11) {
            return this.resetResults(), this.processImageData(e11, t11), this.processResults();
        }
        recognizeForVideo(e11, t11, r11) {
            return this.resetResults(), this.processVideoData(e11, r11, t11), this.processResults();
        }
        resetResults() {
            this.gestures = [], this.landmarks = [], this.worldLandmarks = [], this.handednesses = [];
        }
        processResults() {
            return 0 === this.gestures.length ? {
                gestures: [],
                landmarks: [],
                worldLandmarks: [],
                handednesses: []
            } : {
                gestures: this.gestures,
                landmarks: this.landmarks,
                worldLandmarks: this.worldLandmarks,
                handednesses: this.handednesses
            };
        }
        toJsCategories(e11, t11 = !0) {
            var r11, o11, i11;
            const n11 = [];
            for (const s11 of e11){
                const e11 = a11.ClassificationList.deserializeBinary(s11), p11 = [];
                for (const a11 of e11.getClassificationList()){
                    const e11 = t11 && a11.hasIndex() ? a11.getIndex() : -1;
                    p11.push({
                        score: null !== (r11 = a11.getScore()) && void 0 !== r11 ? r11 : 0,
                        index: e11,
                        categoryName: null !== (o11 = a11.getLabel()) && void 0 !== o11 ? o11 : "",
                        displayName: null !== (i11 = a11.getDisplayName()) && void 0 !== i11 ? i11 : ""
                    });
                }
                n11.push(p11);
            }
            return n11;
        }
        addJsLandmarks(e11) {
            var t11, r11, o11;
            for (const i11 of e11){
                const e11 = n11.NormalizedLandmarkList.deserializeBinary(i11), a11 = [];
                for (const i11 of e11.getLandmarkList())a11.push({
                    x: null !== (t11 = i11.getX()) && void 0 !== t11 ? t11 : 0,
                    y: null !== (r11 = i11.getY()) && void 0 !== r11 ? r11 : 0,
                    z: null !== (o11 = i11.getZ()) && void 0 !== o11 ? o11 : 0
                });
                this.landmarks.push(a11);
            }
        }
        adddJsWorldLandmarks(e11) {
            var t11, r11, o11;
            for (const i11 of e11){
                const e11 = n11.LandmarkList.deserializeBinary(i11), a11 = [];
                for (const i11 of e11.getLandmarkList())a11.push({
                    x: null !== (t11 = i11.getX()) && void 0 !== t11 ? t11 : 0,
                    y: null !== (r11 = i11.getY()) && void 0 !== r11 ? r11 : 0,
                    z: null !== (o11 = i11.getZ()) && void 0 !== o11 ? o11 : 0
                });
                this.worldLandmarks.push(a11);
            }
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(y11), e11.addInputStream(b11), e11.addOutputStream(_11), e11.addOutputStream(O11), e11.addOutputStream(F11), e11.addOutputStream(M11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(d11.GestureRecognizerGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.gesture_recognizer.GestureRecognizerGraph"), r11.addInputStream("IMAGE:" + y11), r11.addInputStream("NORM_RECT:" + b11), r11.addOutputStream("HAND_GESTURES:" + _11), r11.addOutputStream("LANDMARKS:" + O11), r11.addOutputStream("WORLD_LANDMARKS:" + F11), r11.addOutputStream("HANDEDNESS:" + M11), r11.setOptions(t11), e11.addNode(r11), this.graphRunner.attachProtoVectorListener(O11, (e11, t11)=>{
                this.addJsLandmarks(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(O11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            }), this.graphRunner.attachProtoVectorListener(F11, (e11, t11)=>{
                this.adddJsWorldLandmarks(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(F11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            }), this.graphRunner.attachProtoVectorListener(_11, (e11, t11)=>{
                this.gestures.push(...this.toJsCategories(e11, !1)), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(_11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            }), this.graphRunner.attachProtoVectorListener(M11, (e11, t11)=>{
                this.handednesses.push(...this.toJsCategories(e11)), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(M11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            });
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.GestureRecognizer = k11, k11.HAND_CONNECTIONS = h11.HAND_CONNECTIONS;
}(gesture_recognizer);
var hand_landmarker = {}, hand_landmarker_options = {};
Object.defineProperty(hand_landmarker_options, "__esModule", {
    value: !0
});
var hand_landmarker_result = {};
Object.defineProperty(hand_landmarker_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.HandLandmarker = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = classification_pb, n11 = landmark_pb, s11 = base_options_pb, p11 = hand_detector_graph_options_pb, d11 = hand_landmarker_graph_options_pb, l11 = hand_landmarks_detector_graph_options_pb, g11 = landmark_result, c11 = vision_task_runner, u11 = hand_landmarks_connections;
    r11(hand_landmarker_options, e11), r11(hand_landmarker_result, e11);
    const m11 = "image_in", f11 = "norm_rect", h11 = "hand_landmarks", y11 = "world_hand_landmarks", b11 = "handedness", _11 = .5;
    class O11 extends c11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return c11.VisionTaskRunner.createVisionInstance(O11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return c11.VisionTaskRunner.createVisionInstance(O11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return c11.VisionTaskRunner.createVisionInstance(O11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new c11.VisionGraphRunner(e11, t11), m11, f11, !1), this.landmarks = [], this.worldLandmarks = [], this.handednesses = [], this.options = new d11.HandLandmarkerGraphOptions, this.options.setBaseOptions(new s11.BaseOptions), this.handLandmarksDetectorGraphOptions = new l11.HandLandmarksDetectorGraphOptions, this.options.setHandLandmarksDetectorGraphOptions(this.handLandmarksDetectorGraphOptions), this.handDetectorGraphOptions = new p11.HandDetectorGraphOptions, this.options.setHandDetectorGraphOptions(this.handDetectorGraphOptions), this.initDefaults();
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            var t11, r11, o11, i11;
            return "numHands" in e11 && this.handDetectorGraphOptions.setNumHands(null !== (t11 = e11.numHands) && void 0 !== t11 ? t11 : 1), "minHandDetectionConfidence" in e11 && this.handDetectorGraphOptions.setMinDetectionConfidence(null !== (r11 = e11.minHandDetectionConfidence) && void 0 !== r11 ? r11 : _11), "minTrackingConfidence" in e11 && this.options.setMinTrackingConfidence(null !== (o11 = e11.minTrackingConfidence) && void 0 !== o11 ? o11 : _11), "minHandPresenceConfidence" in e11 && this.handLandmarksDetectorGraphOptions.setMinDetectionConfidence(null !== (i11 = e11.minHandPresenceConfidence) && void 0 !== i11 ? i11 : _11), this.applyOptions(e11);
        }
        detect(e11, t11) {
            return this.resetResults(), this.processImageData(e11, t11), this.processResults();
        }
        detectForVideo(e11, t11, r11) {
            return this.resetResults(), this.processVideoData(e11, r11, t11), this.processResults();
        }
        resetResults() {
            this.landmarks = [], this.worldLandmarks = [], this.handednesses = [];
        }
        processResults() {
            return {
                landmarks: this.landmarks,
                worldLandmarks: this.worldLandmarks,
                handednesses: this.handednesses
            };
        }
        initDefaults() {
            this.handDetectorGraphOptions.setNumHands(1), this.handDetectorGraphOptions.setMinDetectionConfidence(_11), this.handLandmarksDetectorGraphOptions.setMinDetectionConfidence(_11), this.options.setMinTrackingConfidence(_11);
        }
        toJsCategories(e11) {
            var t11, r11, o11, i11;
            const n11 = [];
            for (const s11 of e11){
                const e11 = a11.ClassificationList.deserializeBinary(s11), p11 = [];
                for (const a11 of e11.getClassificationList())p11.push({
                    score: null !== (t11 = a11.getScore()) && void 0 !== t11 ? t11 : 0,
                    index: null !== (r11 = a11.getIndex()) && void 0 !== r11 ? r11 : -1,
                    categoryName: null !== (o11 = a11.getLabel()) && void 0 !== o11 ? o11 : "",
                    displayName: null !== (i11 = a11.getDisplayName()) && void 0 !== i11 ? i11 : ""
                });
                n11.push(p11);
            }
            return n11;
        }
        addJsLandmarks(e11) {
            for (const t11 of e11){
                const e11 = n11.NormalizedLandmarkList.deserializeBinary(t11);
                this.landmarks.push((0, g11.convertToLandmarks)(e11));
            }
        }
        adddJsWorldLandmarks(e11) {
            for (const t11 of e11){
                const e11 = n11.LandmarkList.deserializeBinary(t11);
                this.worldLandmarks.push((0, g11.convertToWorldLandmarks)(e11));
            }
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(m11), e11.addInputStream(f11), e11.addOutputStream(h11), e11.addOutputStream(y11), e11.addOutputStream(b11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(d11.HandLandmarkerGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.hand_landmarker.HandLandmarkerGraph"), r11.addInputStream("IMAGE:" + m11), r11.addInputStream("NORM_RECT:" + f11), r11.addOutputStream("LANDMARKS:" + h11), r11.addOutputStream("WORLD_LANDMARKS:" + y11), r11.addOutputStream("HANDEDNESS:" + b11), r11.setOptions(t11), e11.addNode(r11), this.graphRunner.attachProtoVectorListener(h11, (e11, t11)=>{
                this.addJsLandmarks(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(h11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            }), this.graphRunner.attachProtoVectorListener(y11, (e11, t11)=>{
                this.adddJsWorldLandmarks(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(y11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            }), this.graphRunner.attachProtoVectorListener(b11, (e11, t11)=>{
                this.handednesses.push(...this.toJsCategories(e11)), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(b11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            });
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.HandLandmarker = O11, O11.HAND_CONNECTIONS = u11.HAND_CONNECTIONS;
}(hand_landmarker);
var image_classifier = {}, classifications_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = classification_pb;
    r11.object.extend(proto, i11), r11.exportSymbol("proto.mediapipe.tasks.components.containers.proto.ClassificationResult", null, o11), r11.exportSymbol("proto.mediapipe.tasks.components.containers.proto.Classifications", null, o11), proto.mediapipe.tasks.components.containers.proto.Classifications = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.components.containers.proto.Classifications, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.components.containers.proto.Classifications.displayName = "proto.mediapipe.tasks.components.containers.proto.Classifications"), proto.mediapipe.tasks.components.containers.proto.ClassificationResult = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.tasks.components.containers.proto.ClassificationResult, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.components.containers.proto.ClassificationResult.displayName = "proto.mediapipe.tasks.components.containers.proto.ClassificationResult"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.components.containers.proto.Classifications.toObject(e11, this);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.toObject = function(e11, r11) {
        var o11, a11 = {
            classificationList: (o11 = r11.getClassificationList()) && i11.ClassificationList.toObject(e11, o11),
            headIndex: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            headName: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.tasks.components.containers.proto.Classifications.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.components.containers.proto.Classifications;
        return proto.mediapipe.tasks.components.containers.proto.Classifications.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 4:
                var r11 = new i11.ClassificationList;
                t11.readMessage(r11, i11.ClassificationList.deserializeBinaryFromReader), e11.setClassificationList(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setHeadIndex(r11);
                break;
            case 3:
                r11 = t11.readString();
                e11.setHeadName(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.components.containers.proto.Classifications.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getClassificationList()) && r11.writeMessage(4, o11, i11.ClassificationList.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeString(3, o11);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.getClassificationList = function() {
        return t11.Message.getWrapperField(this, i11.ClassificationList, 4);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.setClassificationList = function(e11) {
        return t11.Message.setWrapperField(this, 4, e11);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.clearClassificationList = function() {
        return this.setClassificationList(void 0);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.hasClassificationList = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.getHeadIndex = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.setHeadIndex = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.clearHeadIndex = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.hasHeadIndex = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.getHeadName = function() {
        return t11.Message.getFieldWithDefault(this, 3, "");
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.setHeadName = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.clearHeadName = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.tasks.components.containers.proto.Classifications.prototype.hasHeadName = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.components.containers.proto.ClassificationResult.toObject(e11, this);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.toObject = function(e11, r11) {
        var o11, i11 = {
            classificationsList: t11.Message.toObjectList(r11.getClassificationsList(), proto.mediapipe.tasks.components.containers.proto.Classifications.toObject, e11),
            timestampMs: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.components.containers.proto.ClassificationResult.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.components.containers.proto.ClassificationResult;
        return proto.mediapipe.tasks.components.containers.proto.ClassificationResult.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.tasks.components.containers.proto.Classifications;
                t11.readMessage(r11, proto.mediapipe.tasks.components.containers.proto.Classifications.deserializeBinaryFromReader), e11.addClassifications(r11);
                break;
            case 2:
                r11 = t11.readInt64();
                e11.setTimestampMs(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.components.containers.proto.ClassificationResult.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        (o11 = e11.getClassificationsList()).length > 0 && r11.writeRepeatedMessage(1, o11, proto.mediapipe.tasks.components.containers.proto.Classifications.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt64(2, o11);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.getClassificationsList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.tasks.components.containers.proto.Classifications, 1);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.setClassificationsList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.addClassifications = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.tasks.components.containers.proto.Classifications, r11);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.clearClassificationsList = function() {
        return this.setClassificationsList([]);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.getTimestampMs = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.setTimestampMs = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.clearTimestampMs = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.components.containers.proto.ClassificationResult.prototype.hasTimestampMs = function() {
        return null != t11.Message.getField(this, 2);
    }, r11.object.extend(e11, proto.mediapipe.tasks.components.containers.proto);
}(classifications_pb);
var image_classifier_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = classifier_options_pb;
    r11.object.extend(proto, n11);
    var s11 = base_options_pb;
    r11.object.extend(proto, s11), r11.exportSymbol("proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions", null, o11), proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.displayName = "proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            baseOptions: (r11 = t11.getBaseOptions()) && s11.BaseOptions.toObject(e11, r11),
            classifierOptions: (r11 = t11.getClassifierOptions()) && n11.ClassifierOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions;
        return proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new s11.BaseOptions;
                t11.readMessage(r11, s11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new n11.ClassifierOptions;
                t11.readMessage(r11, n11.ClassifierOptions.deserializeBinaryFromReader), e11.setClassifierOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getBaseOptions()) && t11.writeMessage(1, r11, s11.BaseOptions.serializeBinaryToWriter), null != (r11 = e11.getClassifierOptions()) && t11.writeMessage(2, r11, n11.ClassifierOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.ext = new t11.ExtensionFieldInfo(456383383, {
        ext: 0
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[456383383] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[456383383] = proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.ext, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, s11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.getClassifierOptions = function() {
        return t11.Message.getWrapperField(this, n11.ClassifierOptions, 2);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.setClassifierOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.clearClassifierOptions = function() {
        return this.setClassifierOptions(void 0);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.prototype.hasClassifierOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.ext = new t11.ExtensionFieldInfo(456383383, {
        ext: 0
    }, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[456383383] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[456383383] = proto.mediapipe.tasks.vision.image_classifier.proto.ImageClassifierGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.image_classifier.proto);
}(image_classifier_graph_options_pb);
var image_classifier_options = {};
Object.defineProperty(image_classifier_options, "__esModule", {
    value: !0
});
var image_classifier_result = {};
Object.defineProperty(image_classifier_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.ImageClassifier = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = classifications_pb, n11 = base_options_pb, s11 = image_classifier_graph_options_pb, p11 = classifier_options, d11 = classifier_result, l11 = vision_task_runner, g11 = "input_image", c11 = "norm_rect", u11 = "classifications";
    r11(image_classifier_options, e11), r11(image_classifier_result, e11);
    class m11 extends l11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return l11.VisionTaskRunner.createVisionInstance(m11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return l11.VisionTaskRunner.createVisionInstance(m11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return l11.VisionTaskRunner.createVisionInstance(m11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new l11.VisionGraphRunner(e11, t11), g11, c11, !0), this.classificationResult = {
                classifications: []
            }, this.options = new s11.ImageClassifierGraphOptions, this.options.setBaseOptions(new n11.BaseOptions);
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            return this.options.setClassifierOptions((0, p11.convertClassifierOptionsToProto)(e11, this.options.getClassifierOptions())), this.applyOptions(e11);
        }
        classify(e11, t11) {
            return this.classificationResult = {
                classifications: []
            }, this.processImageData(e11, t11), this.classificationResult;
        }
        classifyForVideo(e11, t11, r11) {
            return this.classificationResult = {
                classifications: []
            }, this.processVideoData(e11, r11, t11), this.classificationResult;
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(g11), e11.addInputStream(c11), e11.addOutputStream(u11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(s11.ImageClassifierGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.image_classifier.ImageClassifierGraph"), r11.addInputStream("IMAGE:" + g11), r11.addInputStream("NORM_RECT:" + c11), r11.addOutputStream("CLASSIFICATIONS:" + u11), r11.setOptions(t11), e11.addNode(r11), this.graphRunner.attachProtoListener(u11, (e11, t11)=>{
                this.classificationResult = (0, d11.convertFromClassificationResultProto)(a11.ClassificationResult.deserializeBinary(e11)), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(u11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            });
            const n11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(n11), !0);
        }
    }
    e11.ImageClassifier = m11;
}(image_classifier);
var image_embedder = {}, embeddings_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.tasks.components.containers.proto.Embedding", null, o11), r11.exportSymbol("proto.mediapipe.tasks.components.containers.proto.Embedding.EmbeddingCase", null, o11), r11.exportSymbol("proto.mediapipe.tasks.components.containers.proto.EmbeddingResult", null, o11), r11.exportSymbol("proto.mediapipe.tasks.components.containers.proto.FloatEmbedding", null, o11), r11.exportSymbol("proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding", null, o11), proto.mediapipe.tasks.components.containers.proto.FloatEmbedding = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.tasks.components.containers.proto.FloatEmbedding, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.displayName = "proto.mediapipe.tasks.components.containers.proto.FloatEmbedding"), proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.displayName = "proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding"), proto.mediapipe.tasks.components.containers.proto.Embedding = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, proto.mediapipe.tasks.components.containers.proto.Embedding.oneofGroups_);
    }, r11.inherits(proto.mediapipe.tasks.components.containers.proto.Embedding, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.components.containers.proto.Embedding.displayName = "proto.mediapipe.tasks.components.containers.proto.Embedding"), proto.mediapipe.tasks.components.containers.proto.EmbeddingResult = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.tasks.components.containers.proto.EmbeddingResult, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.displayName = "proto.mediapipe.tasks.components.containers.proto.EmbeddingResult"), proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.toObject(e11, this);
    }, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.toObject = function(e11, r11) {
        var o11, i11 = {
            valuesList: null == (o11 = t11.Message.getRepeatedFloatingPointField(r11, 1)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.components.containers.proto.FloatEmbedding;
        return proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();){
            if (1 === t11.getFieldNumber()) for(var r11 = t11.isDelimited() ? t11.readPackedFloat() : [
                t11.readFloat()
            ], o11 = 0; o11 < r11.length; o11++)e11.addValues(r11[o11]);
            else t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getValuesList()).length > 0 && t11.writePackedFloat(1, r11);
    }, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.prototype.getValuesList = function() {
        return t11.Message.getRepeatedFloatingPointField(this, 1);
    }, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.prototype.setValuesList = function(e11) {
        return t11.Message.setField(this, 1, e11 || []);
    }, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.prototype.addValues = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 1, e11, r11);
    }, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.prototype.clearValuesList = function() {
        return this.setValuesList([]);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.toObject(e11, this);
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.toObject = function(e11, t11) {
        var r11 = {
            values: t11.getValues_asB64()
        };
        return e11 && (r11.$jspbMessageInstance = t11), r11;
    }), proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding;
        return proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = t11.readBytes();
            e11.setValues(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.serializeBinaryToWriter = function(e11, r11) {
        var o11;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeBytes(1, o11);
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.prototype.getValues = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.prototype.getValues_asB64 = function() {
        return t11.Message.bytesAsB64(this.getValues());
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.prototype.getValues_asU8 = function() {
        return t11.Message.bytesAsU8(this.getValues());
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.prototype.setValues = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.prototype.clearValues = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.prototype.hasValues = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.oneofGroups_ = [
        [
            1,
            2
        ]
    ], proto.mediapipe.tasks.components.containers.proto.Embedding.EmbeddingCase = {
        EMBEDDING_NOT_SET: 0,
        FLOAT_EMBEDDING: 1,
        QUANTIZED_EMBEDDING: 2
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.getEmbeddingCase = function() {
        return t11.Message.computeOneofCase(this, proto.mediapipe.tasks.components.containers.proto.Embedding.oneofGroups_[0]);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.components.containers.proto.Embedding.toObject(e11, this);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.toObject = function(e11, r11) {
        var o11, i11 = {
            floatEmbedding: (o11 = r11.getFloatEmbedding()) && proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.toObject(e11, o11),
            quantizedEmbedding: (o11 = r11.getQuantizedEmbedding()) && proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.toObject(e11, o11),
            headIndex: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11,
            headName: null == (o11 = t11.Message.getField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.components.containers.proto.Embedding.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.components.containers.proto.Embedding;
        return proto.mediapipe.tasks.components.containers.proto.Embedding.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.tasks.components.containers.proto.FloatEmbedding;
                t11.readMessage(r11, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.deserializeBinaryFromReader), e11.setFloatEmbedding(r11);
                break;
            case 2:
                r11 = new proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding;
                t11.readMessage(r11, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.deserializeBinaryFromReader), e11.setQuantizedEmbedding(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setHeadIndex(r11);
                break;
            case 4:
                r11 = t11.readString();
                e11.setHeadName(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.components.containers.proto.Embedding.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getFloatEmbedding()) && r11.writeMessage(1, o11, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding.serializeBinaryToWriter), null != (o11 = e11.getQuantizedEmbedding()) && r11.writeMessage(2, o11, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeString(4, o11);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.getFloatEmbedding = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.tasks.components.containers.proto.FloatEmbedding, 1);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.setFloatEmbedding = function(e11) {
        return t11.Message.setOneofWrapperField(this, 1, proto.mediapipe.tasks.components.containers.proto.Embedding.oneofGroups_[0], e11);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.clearFloatEmbedding = function() {
        return this.setFloatEmbedding(void 0);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.hasFloatEmbedding = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.getQuantizedEmbedding = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.tasks.components.containers.proto.QuantizedEmbedding, 2);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.setQuantizedEmbedding = function(e11) {
        return t11.Message.setOneofWrapperField(this, 2, proto.mediapipe.tasks.components.containers.proto.Embedding.oneofGroups_[0], e11);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.clearQuantizedEmbedding = function() {
        return this.setQuantizedEmbedding(void 0);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.hasQuantizedEmbedding = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.getHeadIndex = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.setHeadIndex = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.clearHeadIndex = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.hasHeadIndex = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.getHeadName = function() {
        return t11.Message.getFieldWithDefault(this, 4, "");
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.setHeadName = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.clearHeadName = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.tasks.components.containers.proto.Embedding.prototype.hasHeadName = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.toObject(e11, this);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.toObject = function(e11, r11) {
        var o11, i11 = {
            embeddingsList: t11.Message.toObjectList(r11.getEmbeddingsList(), proto.mediapipe.tasks.components.containers.proto.Embedding.toObject, e11),
            timestampMs: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.components.containers.proto.EmbeddingResult;
        return proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.tasks.components.containers.proto.Embedding;
                t11.readMessage(r11, proto.mediapipe.tasks.components.containers.proto.Embedding.deserializeBinaryFromReader), e11.addEmbeddings(r11);
                break;
            case 2:
                r11 = t11.readInt64();
                e11.setTimestampMs(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        (o11 = e11.getEmbeddingsList()).length > 0 && r11.writeRepeatedMessage(1, o11, proto.mediapipe.tasks.components.containers.proto.Embedding.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt64(2, o11);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.getEmbeddingsList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.tasks.components.containers.proto.Embedding, 1);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.setEmbeddingsList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.addEmbeddings = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.tasks.components.containers.proto.Embedding, r11);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.clearEmbeddingsList = function() {
        return this.setEmbeddingsList([]);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.getTimestampMs = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.setTimestampMs = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.clearTimestampMs = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.components.containers.proto.EmbeddingResult.prototype.hasTimestampMs = function() {
        return null != t11.Message.getField(this, 2);
    }, r11.object.extend(e11, proto.mediapipe.tasks.components.containers.proto);
}(embeddings_pb);
var image_embedder_graph_options_pb = {}, embedder_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.tasks.components.processors.proto.EmbedderOptions", null, o11), proto.mediapipe.tasks.components.processors.proto.EmbedderOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.components.processors.proto.EmbedderOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.displayName = "proto.mediapipe.tasks.components.processors.proto.EmbedderOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            l2Normalize: null == (o11 = t11.Message.getBooleanField(r11, 1)) ? void 0 : o11,
            quantize: null == (o11 = t11.Message.getBooleanField(r11, 2)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.components.processors.proto.EmbedderOptions;
        return proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readBool();
                e11.setL2Normalize(r11);
                break;
            case 2:
                r11 = t11.readBool();
                e11.setQuantize(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeBool(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeBool(2, o11);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.getL2Normalize = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 1, !1);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.setL2Normalize = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.clearL2Normalize = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.hasL2Normalize = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.getQuantize = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 2, !1);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.setQuantize = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.clearQuantize = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.components.processors.proto.EmbedderOptions.prototype.hasQuantize = function() {
        return null != t11.Message.getField(this, 2);
    }, r11.object.extend(e11, proto.mediapipe.tasks.components.processors.proto);
}(embedder_options_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = embedder_options_pb;
    r11.object.extend(proto, n11);
    var s11 = base_options_pb;
    r11.object.extend(proto, s11), r11.exportSymbol("proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions", null, o11), proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.displayName = "proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            baseOptions: (r11 = t11.getBaseOptions()) && s11.BaseOptions.toObject(e11, r11),
            embedderOptions: (r11 = t11.getEmbedderOptions()) && n11.EmbedderOptions.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions;
        return proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new s11.BaseOptions;
                t11.readMessage(r11, s11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new n11.EmbedderOptions;
                t11.readMessage(r11, n11.EmbedderOptions.deserializeBinaryFromReader), e11.setEmbedderOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getBaseOptions()) && t11.writeMessage(1, r11, s11.BaseOptions.serializeBinaryToWriter), null != (r11 = e11.getEmbedderOptions()) && t11.writeMessage(2, r11, n11.EmbedderOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.ext = new t11.ExtensionFieldInfo(476348187, {
        ext: 0
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[476348187] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[476348187] = proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.ext, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, s11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.getEmbedderOptions = function() {
        return t11.Message.getWrapperField(this, n11.EmbedderOptions, 2);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.setEmbedderOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.clearEmbedderOptions = function() {
        return this.setEmbedderOptions(void 0);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.prototype.hasEmbedderOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.ext = new t11.ExtensionFieldInfo(476348187, {
        ext: 0
    }, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[476348187] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[476348187] = proto.mediapipe.tasks.vision.image_embedder.proto.ImageEmbedderGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.image_embedder.proto);
}(image_embedder_graph_options_pb);
var embedder_options = {};
Object.defineProperty(embedder_options, "__esModule", {
    value: !0
}), embedder_options.convertEmbedderOptionsToProto = void 0;
const embedder_options_pb_1 = embedder_options_pb;
function convertEmbedderOptionsToProto(e11, t11) {
    const r11 = t11 ? t11.clone() : new embedder_options_pb_1.EmbedderOptions;
    return void 0 !== e11.l2Normalize ? r11.setL2Normalize(e11.l2Normalize) : "l2Normalize" in e11 && r11.clearL2Normalize(), void 0 !== e11.quantize ? r11.setQuantize(e11.quantize) : "quantize" in e11 && r11.clearQuantize(), r11;
}
embedder_options.convertEmbedderOptionsToProto = convertEmbedderOptionsToProto;
var embedder_result = {};
Object.defineProperty(embedder_result, "__esModule", {
    value: !0
}), embedder_result.convertFromEmbeddingResultProto = void 0;
const DEFAULT_INDEX = -1;
function convertFromEmbeddingsProto(e11) {
    var t11, r11, o11, i11;
    const a11 = {
        headIndex: null !== (t11 = e11.getHeadIndex()) && void 0 !== t11 ? t11 : DEFAULT_INDEX,
        headName: null !== (r11 = e11.getHeadName()) && void 0 !== r11 ? r11 : ""
    };
    if (e11.hasFloatEmbedding()) a11.floatEmbedding = e11.getFloatEmbedding().getValuesList();
    else {
        const t11 = null !== (i11 = null === (o11 = e11.getQuantizedEmbedding()) || void 0 === o11 ? void 0 : o11.getValues()) && void 0 !== i11 ? i11 : "";
        a11.quantizedEmbedding = "string" == typeof t11 ? Uint8Array.from(atob(t11), (e11)=>e11.charCodeAt(0)) : t11;
    }
    return a11;
}
function convertFromEmbeddingResultProto(e11) {
    return {
        embeddings: e11.getEmbeddingsList().map((e11)=>convertFromEmbeddingsProto(e11)),
        timestampMs: e11.getTimestampMs()
    };
}
embedder_result.convertFromEmbeddingResultProto = convertFromEmbeddingResultProto;
var cosine_similarity = {};
function computeCosineSimilarity(e11, t11) {
    if (e11.floatEmbedding && t11.floatEmbedding) return compute(e11.floatEmbedding, t11.floatEmbedding);
    if (e11.quantizedEmbedding && t11.quantizedEmbedding) return compute(convertToBytes(e11.quantizedEmbedding), convertToBytes(t11.quantizedEmbedding));
    throw new Error("Cannot compute cosine similarity between quantized and float embeddings.");
}
function convertToBytes(e11) {
    return Array.from(e11, (e11)=>e11 > 127 ? e11 - 256 : e11);
}
function compute(e11, t11) {
    if (e11.length !== t11.length) throw new Error(`Cannot compute cosine similarity between embeddings of different sizes (${e11.length} vs. ${t11.length}).`);
    let r11 = 0, o11 = 0, i11 = 0;
    for(let a11 = 0; a11 < e11.length; a11++)r11 += e11[a11] * t11[a11], o11 += e11[a11] * e11[a11], i11 += t11[a11] * t11[a11];
    if (o11 <= 0 || i11 <= 0) throw new Error("Cannot compute cosine similarity on embedding with 0 norm.");
    return r11 / Math.sqrt(o11 * i11);
}
Object.defineProperty(cosine_similarity, "__esModule", {
    value: !0
}), cosine_similarity.computeCosineSimilarity = void 0, cosine_similarity.computeCosineSimilarity = computeCosineSimilarity;
var image_embedder_options = {};
Object.defineProperty(image_embedder_options, "__esModule", {
    value: !0
});
var image_embedder_result = {};
Object.defineProperty(image_embedder_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.ImageEmbedder = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = embeddings_pb, n11 = base_options_pb, s11 = image_embedder_graph_options_pb, p11 = embedder_options, d11 = embedder_result, l11 = cosine_similarity, g11 = vision_task_runner, c11 = "image_in", u11 = "norm_rect", m11 = "embeddings_out";
    r11(image_embedder_options, e11), r11(image_embedder_result, e11);
    class f11 extends g11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return g11.VisionTaskRunner.createVisionInstance(f11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return g11.VisionTaskRunner.createVisionInstance(f11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return g11.VisionTaskRunner.createVisionInstance(f11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new g11.VisionGraphRunner(e11, t11), c11, u11, !0), this.options = new s11.ImageEmbedderGraphOptions, this.embeddings = {
                embeddings: []
            }, this.options.setBaseOptions(new n11.BaseOptions);
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            return this.options.setEmbedderOptions((0, p11.convertEmbedderOptionsToProto)(e11, this.options.getEmbedderOptions())), this.applyOptions(e11);
        }
        embed(e11, t11) {
            return this.processImageData(e11, t11), this.embeddings;
        }
        embedForVideo(e11, t11, r11) {
            return this.processVideoData(e11, r11, t11), this.embeddings;
        }
        static cosineSimilarity(e11, t11) {
            return (0, l11.computeCosineSimilarity)(e11, t11);
        }
        addJsImageEmdedding(e11) {
            const t11 = a11.EmbeddingResult.deserializeBinary(e11);
            this.embeddings = (0, d11.convertFromEmbeddingResultProto)(t11);
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(c11), e11.addInputStream(u11), e11.addOutputStream(m11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(s11.ImageEmbedderGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.image_embedder.ImageEmbedderGraph"), r11.addInputStream("IMAGE:" + c11), r11.addInputStream("NORM_RECT:" + u11), r11.addOutputStream("EMBEDDINGS:" + m11), r11.setOptions(t11), e11.addNode(r11), this.graphRunner.attachProtoListener(m11, (e11, t11)=>{
                this.addJsImageEmdedding(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(m11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            });
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.ImageEmbedder = f11;
}(image_embedder);
var image_segmenter = {}, tensors_to_segmentation_calculator_pb = {}, segmenter_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions", null, o11), r11.exportSymbol("proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.Activation", null, o11), r11.exportSymbol("proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.OutputType", null, o11), proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.displayName = "proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            outputType: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            activation: t11.Message.getFieldWithDefault(r11, 2, 0)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions;
        return proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readEnum();
                e11.setOutputType(r11);
                break;
            case 2:
                r11 = t11.readEnum();
                e11.setActivation(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeEnum(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeEnum(2, o11);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.OutputType = {
        UNSPECIFIED: 0,
        CATEGORY_MASK: 1,
        CONFIDENCE_MASK: 2
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.Activation = {
        NONE: 0,
        SIGMOID: 1,
        SOFTMAX: 2
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.getOutputType = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.setOutputType = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.clearOutputType = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.hasOutputType = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.getActivation = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.setActivation = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.clearActivation = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.SegmenterOptions.prototype.hasActivation = function() {
        return null != t11.Message.getField(this, 2);
    }, r11.object.extend(e11, proto.mediapipe.tasks.vision.image_segmenter.proto);
}(segmenter_options_pb);
var label_map_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.LabelMapItem", null, o11), proto.mediapipe.LabelMapItem = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.LabelMapItem.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.LabelMapItem, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.LabelMapItem.displayName = "proto.mediapipe.LabelMapItem"), proto.mediapipe.LabelMapItem.repeatedFields_ = [
        3
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.LabelMapItem.prototype.toObject = function(e11) {
        return proto.mediapipe.LabelMapItem.toObject(e11, this);
    }, proto.mediapipe.LabelMapItem.toObject = function(e11, r11) {
        var o11, i11 = {
            name: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            displayName: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            childNameList: null == (o11 = t11.Message.getRepeatedField(r11, 3)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.LabelMapItem.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.LabelMapItem;
        return proto.mediapipe.LabelMapItem.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.LabelMapItem.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setName(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setDisplayName(r11);
                break;
            case 3:
                r11 = t11.readString();
                e11.addChildName(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.LabelMapItem.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.LabelMapItem.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.LabelMapItem.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeString(2, o11), (o11 = e11.getChildNameList()).length > 0 && r11.writeRepeatedString(3, o11);
    }, proto.mediapipe.LabelMapItem.prototype.getName = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.LabelMapItem.prototype.setName = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.LabelMapItem.prototype.clearName = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.LabelMapItem.prototype.hasName = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.LabelMapItem.prototype.getDisplayName = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.mediapipe.LabelMapItem.prototype.setDisplayName = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.LabelMapItem.prototype.clearDisplayName = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.LabelMapItem.prototype.hasDisplayName = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.LabelMapItem.prototype.getChildNameList = function() {
        return t11.Message.getRepeatedField(this, 3);
    }, proto.mediapipe.LabelMapItem.prototype.setChildNameList = function(e11) {
        return t11.Message.setField(this, 3, e11 || []);
    }, proto.mediapipe.LabelMapItem.prototype.addChildName = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 3, e11, r11);
    }, proto.mediapipe.LabelMapItem.prototype.clearChildNameList = function() {
        return this.setChildNameList([]);
    }, r11.object.extend(e11, proto.mediapipe);
}(label_map_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_options_pb;
    r11.object.extend(proto, i11);
    var a11 = segmenter_options_pb;
    r11.object.extend(proto, a11);
    var n11 = label_map_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions", null, o11), proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.displayName = "proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.toObject = function(e11, t11) {
        var r11, o11 = {
            segmenterOptions: (r11 = t11.getSegmenterOptions()) && a11.SegmenterOptions.toObject(e11, r11),
            labelItemsMap: (r11 = t11.getLabelItemsMap()) ? r11.toObject(e11, proto.mediapipe.LabelMapItem.toObject) : []
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions;
        return proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.deserializeBinaryFromReader = function(e11, r11) {
        for(; r11.nextField() && !r11.isEndGroup();)switch(r11.getFieldNumber()){
            case 1:
                var o11 = new a11.SegmenterOptions;
                r11.readMessage(o11, a11.SegmenterOptions.deserializeBinaryFromReader), e11.setSegmenterOptions(o11);
                break;
            case 2:
                o11 = e11.getLabelItemsMap();
                r11.readMessage(o11, function(e11, r11) {
                    t11.Map.deserializeBinary(e11, r11, t11.BinaryReader.prototype.readInt64, t11.BinaryReader.prototype.readMessage, proto.mediapipe.LabelMapItem.deserializeBinaryFromReader, 0, new proto.mediapipe.LabelMapItem);
                });
                break;
            default:
                r11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getSegmenterOptions()) && r11.writeMessage(1, o11, a11.SegmenterOptions.serializeBinaryToWriter), (o11 = e11.getLabelItemsMap(!0)) && o11.getLength() > 0 && o11.serializeBinary(2, r11, t11.BinaryWriter.prototype.writeInt64, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.LabelMapItem.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.ext = new t11.ExtensionFieldInfo(458105876, {
        ext: 0
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.toObject, 0), i11.CalculatorOptions.extensionsBinary[458105876] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.serializeBinaryToWriter, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.deserializeBinaryFromReader, !1), i11.CalculatorOptions.extensions[458105876] = proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.ext, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.prototype.getSegmenterOptions = function() {
        return t11.Message.getWrapperField(this, a11.SegmenterOptions, 1);
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.prototype.setSegmenterOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.prototype.clearSegmenterOptions = function() {
        return this.setSegmenterOptions(void 0);
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.prototype.hasSegmenterOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.prototype.getLabelItemsMap = function(e11) {
        return t11.Message.getMapField(this, 2, e11, proto.mediapipe.LabelMapItem);
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.prototype.clearLabelItemsMap = function() {
        return this.getLabelItemsMap().clear(), this;
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.ext = new t11.ExtensionFieldInfo(458105876, {
        ext: 0
    }, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.toObject, 0), i11.CalculatorOptions.extensionsBinary[458105876] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.serializeBinaryToWriter, proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.deserializeBinaryFromReader, !1), i11.CalculatorOptions.extensions[458105876] = proto.mediapipe.tasks.TensorsToSegmentationCalculatorOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks);
}(tensors_to_segmentation_calculator_pb);
var image_segmenter_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11);
    var s11 = segmenter_options_pb;
    r11.object.extend(proto, s11), r11.exportSymbol("proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions", null, o11), proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.displayName = "proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            displayNamesLocale: t11.Message.getFieldWithDefault(r11, 2, "en"),
            segmenterOptions: (o11 = r11.getSegmenterOptions()) && s11.SegmenterOptions.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions;
        return proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setDisplayNamesLocale(r11);
                break;
            case 3:
                r11 = new s11.SegmenterOptions;
                t11.readMessage(r11, s11.SegmenterOptions.deserializeBinaryFromReader), e11.setSegmenterOptions(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeString(2, o11), null != (o11 = e11.getSegmenterOptions()) && r11.writeMessage(3, o11, s11.SegmenterOptions.serializeBinaryToWriter);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.ext = new t11.ExtensionFieldInfo(458105758, {
        ext: 0
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[458105758] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[458105758] = proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.ext, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.getDisplayNamesLocale = function() {
        return t11.Message.getFieldWithDefault(this, 2, "en");
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.setDisplayNamesLocale = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.clearDisplayNamesLocale = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.hasDisplayNamesLocale = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.getSegmenterOptions = function() {
        return t11.Message.getWrapperField(this, s11.SegmenterOptions, 3);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.setSegmenterOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.clearSegmenterOptions = function() {
        return this.setSegmenterOptions(void 0);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.prototype.hasSegmenterOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.ext = new t11.ExtensionFieldInfo(458105758, {
        ext: 0
    }, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[458105758] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[458105758] = proto.mediapipe.tasks.vision.image_segmenter.proto.ImageSegmenterGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.image_segmenter.proto);
}(image_segmenter_graph_options_pb);
var image_segmenter_options = {};
Object.defineProperty(image_segmenter_options, "__esModule", {
    value: !0
});
var image_segmenter_result = {};
Object.defineProperty(image_segmenter_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.ImageSegmenter = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = base_options_pb, n11 = tensors_to_segmentation_calculator_pb, s11 = image_segmenter_graph_options_pb, p11 = segmenter_options_pb, d11 = vision_task_runner;
    r11(image_segmenter_options, e11), r11(image_segmenter_result, e11);
    const l11 = "image_in", g11 = "norm_rect", c11 = "confidence_masks", u11 = "category_mask", m11 = "mediapipe.tasks.TensorsToSegmentationCalculator";
    class f11 extends d11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(f11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(f11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(f11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new d11.VisionGraphRunner(e11, t11), l11, g11, !1), this.result = {}, this.labels = [], this.outputCategoryMask = false, this.outputConfidenceMasks = true, this.options = new s11.ImageSegmenterGraphOptions, this.segmenterOptions = new p11.SegmenterOptions, this.options.setSegmenterOptions(this.segmenterOptions), this.options.setBaseOptions(new a11.BaseOptions);
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            var t11, r11;
            return void 0 !== e11.displayNamesLocale ? this.options.setDisplayNamesLocale(e11.displayNamesLocale) : "displayNamesLocale" in e11 && this.options.clearDisplayNamesLocale(), "outputCategoryMask" in e11 && (this.outputCategoryMask = null !== (t11 = e11.outputCategoryMask) && void 0 !== t11 && t11), "outputConfidenceMasks" in e11 && (this.outputConfidenceMasks = null === (r11 = e11.outputConfidenceMasks) || void 0 === r11 || r11), super.applyOptions(e11);
        }
        onGraphRefreshed() {
            this.populateLabels();
        }
        populateLabels() {
            var e11, t11, r11;
            const o11 = this.getCalculatorGraphConfig().getNodeList().filter((e11)=>e11.getName().includes(m11));
            if (this.labels = [], o11.length > 1) throw new Error(`The graph has more than one ${m11}.`);
            if (1 === o11.length) (null !== (r11 = null === (t11 = null === (e11 = o11[0].getOptions()) || void 0 === e11 ? void 0 : e11.getExtension(n11.TensorsToSegmentationCalculatorOptions.ext)) || void 0 === t11 ? void 0 : t11.getLabelItemsMap()) && void 0 !== r11 ? r11 : new Map).forEach((e11, t11)=>{
                this.labels[Number(t11)] = e11.getName();
            });
        }
        segment(e11, t11, r11) {
            const o11 = "function" != typeof t11 ? t11 : {};
            if (this.userCallback = "function" == typeof t11 ? t11 : r11, this.reset(), this.processImageData(e11, o11), !this.userCallback) return this.result;
        }
        segmentForVideo(e11, t11, r11, o11) {
            const i11 = "function" != typeof r11 ? r11 : {};
            if (this.userCallback = "function" == typeof r11 ? r11 : o11, this.reset(), this.processVideoData(e11, i11, t11), !this.userCallback) return this.result;
        }
        getLabels() {
            return this.labels;
        }
        reset() {
            this.result = {};
        }
        maybeInvokeCallback() {
            this.outputConfidenceMasks && !("confidenceMasks" in this.result) || this.outputCategoryMask && !("categoryMask" in this.result) || this.userCallback && (this.userCallback(this.result), this.freeKeepaliveStreams());
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(l11), e11.addInputStream(g11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(s11.ImageSegmenterGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.image_segmenter.ImageSegmenterGraph"), r11.addInputStream("IMAGE:" + l11), r11.addInputStream("NORM_RECT:" + g11), r11.setOptions(t11), e11.addNode(r11), this.addKeepaliveNode(e11), this.outputConfidenceMasks && (e11.addOutputStream(c11), r11.addOutputStream("CONFIDENCE_MASKS:" + c11), this.keepStreamAlive(c11), this.graphRunner.attachImageVectorListener(c11, (e11, t11)=>{
                this.result.confidenceMasks = e11.map((e11)=>this.convertToMPMask(e11, !this.userCallback)), this.setLatestOutputTimestamp(t11), this.maybeInvokeCallback();
            }), this.graphRunner.attachEmptyPacketListener(c11, (e11)=>{
                this.result.confidenceMasks = void 0, this.setLatestOutputTimestamp(e11), this.maybeInvokeCallback();
            })), this.outputCategoryMask && (e11.addOutputStream(u11), r11.addOutputStream("CATEGORY_MASK:" + u11), this.keepStreamAlive(u11), this.graphRunner.attachImageListener(u11, (e11, t11)=>{
                this.result.categoryMask = this.convertToMPMask(e11, !this.userCallback), this.setLatestOutputTimestamp(t11), this.maybeInvokeCallback();
            }), this.graphRunner.attachEmptyPacketListener(u11, (e11)=>{
                this.result.categoryMask = void 0, this.setLatestOutputTimestamp(e11), this.maybeInvokeCallback();
            }));
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.ImageSegmenter = f11;
}(image_segmenter);
var interactive_segmenter = {}, color_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")();
    r11.exportSymbol("proto.mediapipe.Color", null, o11), r11.exportSymbol("proto.mediapipe.ColorMap", null, o11), proto.mediapipe.Color = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.Color, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.Color.displayName = "proto.mediapipe.Color"), proto.mediapipe.ColorMap = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.ColorMap, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.ColorMap.displayName = "proto.mediapipe.ColorMap"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.Color.prototype.toObject = function(e11) {
        return proto.mediapipe.Color.toObject(e11, this);
    }, proto.mediapipe.Color.toObject = function(e11, r11) {
        var o11, i11 = {
            r: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            g: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            b: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.Color.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.Color;
        return proto.mediapipe.Color.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.Color.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readInt32();
                e11.setR(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setG(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setB(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.Color.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.Color.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.Color.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeInt32(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11);
    }, proto.mediapipe.Color.prototype.getR = function() {
        return t11.Message.getFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.Color.prototype.setR = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.Color.prototype.clearR = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.Color.prototype.hasR = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.Color.prototype.getG = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.Color.prototype.setG = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.Color.prototype.clearG = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.Color.prototype.hasG = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.Color.prototype.getB = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.Color.prototype.setB = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.Color.prototype.clearB = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.Color.prototype.hasB = function() {
        return null != t11.Message.getField(this, 3);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.ColorMap.prototype.toObject = function(e11) {
        return proto.mediapipe.ColorMap.toObject(e11, this);
    }, proto.mediapipe.ColorMap.toObject = function(e11, t11) {
        var r11, o11 = {
            labelToColorMap: (r11 = t11.getLabelToColorMap()) ? r11.toObject(e11, proto.mediapipe.Color.toObject) : []
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.ColorMap.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.ColorMap;
        return proto.mediapipe.ColorMap.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.ColorMap.deserializeBinaryFromReader = function(e11, r11) {
        for(; r11.nextField() && !r11.isEndGroup();)if (1 === r11.getFieldNumber()) {
            var o11 = e11.getLabelToColorMap();
            r11.readMessage(o11, function(e11, r11) {
                t11.Map.deserializeBinary(e11, r11, t11.BinaryReader.prototype.readString, t11.BinaryReader.prototype.readMessage, proto.mediapipe.Color.deserializeBinaryFromReader, "", new proto.mediapipe.Color);
            });
        } else r11.skipField();
        return e11;
    }, proto.mediapipe.ColorMap.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.ColorMap.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.ColorMap.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        (o11 = e11.getLabelToColorMap(!0)) && o11.getLength() > 0 && o11.serializeBinary(1, r11, t11.BinaryWriter.prototype.writeString, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.Color.serializeBinaryToWriter);
    }, proto.mediapipe.ColorMap.prototype.getLabelToColorMap = function(e11) {
        return t11.Message.getMapField(this, 1, e11, proto.mediapipe.Color);
    }, proto.mediapipe.ColorMap.prototype.clearLabelToColorMap = function() {
        return this.getLabelToColorMap().clear(), this;
    }, r11.object.extend(e11, proto.mediapipe);
}(color_pb);
var render_data_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = color_pb;
    r11.object.extend(proto, i11), r11.exportSymbol("proto.mediapipe.RenderAnnotation", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.Arrow", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.DataCase", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.FilledOval", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.FilledRectangle", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.FilledRoundedRectangle", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.GradientLine", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.Line", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.Line.LineType", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.Oval", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.Point", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.Rectangle", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.RoundedRectangle", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.Scribble", null, o11), r11.exportSymbol("proto.mediapipe.RenderAnnotation.Text", null, o11), r11.exportSymbol("proto.mediapipe.RenderData", null, o11), r11.exportSymbol("proto.mediapipe.RenderViewport", null, o11), proto.mediapipe.RenderData = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.RenderData.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.RenderData, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderData.displayName = "proto.mediapipe.RenderData"), proto.mediapipe.RenderAnnotation = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, proto.mediapipe.RenderAnnotation.oneofGroups_);
    }, r11.inherits(proto.mediapipe.RenderAnnotation, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.displayName = "proto.mediapipe.RenderAnnotation"), proto.mediapipe.RenderAnnotation.Rectangle = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.Rectangle, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.Rectangle.displayName = "proto.mediapipe.RenderAnnotation.Rectangle"), proto.mediapipe.RenderAnnotation.FilledRectangle = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.FilledRectangle, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.FilledRectangle.displayName = "proto.mediapipe.RenderAnnotation.FilledRectangle"), proto.mediapipe.RenderAnnotation.RoundedRectangle = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.RoundedRectangle, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.RoundedRectangle.displayName = "proto.mediapipe.RenderAnnotation.RoundedRectangle"), proto.mediapipe.RenderAnnotation.FilledRoundedRectangle = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.FilledRoundedRectangle, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.displayName = "proto.mediapipe.RenderAnnotation.FilledRoundedRectangle"), proto.mediapipe.RenderAnnotation.Oval = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.Oval, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.Oval.displayName = "proto.mediapipe.RenderAnnotation.Oval"), proto.mediapipe.RenderAnnotation.FilledOval = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.FilledOval, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.FilledOval.displayName = "proto.mediapipe.RenderAnnotation.FilledOval"), proto.mediapipe.RenderAnnotation.Point = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.Point, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.Point.displayName = "proto.mediapipe.RenderAnnotation.Point"), proto.mediapipe.RenderAnnotation.Line = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.Line, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.Line.displayName = "proto.mediapipe.RenderAnnotation.Line"), proto.mediapipe.RenderAnnotation.GradientLine = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.GradientLine, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.GradientLine.displayName = "proto.mediapipe.RenderAnnotation.GradientLine"), proto.mediapipe.RenderAnnotation.Scribble = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.RenderAnnotation.Scribble.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.Scribble, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.Scribble.displayName = "proto.mediapipe.RenderAnnotation.Scribble"), proto.mediapipe.RenderAnnotation.Arrow = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.Arrow, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.Arrow.displayName = "proto.mediapipe.RenderAnnotation.Arrow"), proto.mediapipe.RenderAnnotation.Text = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderAnnotation.Text, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderAnnotation.Text.displayName = "proto.mediapipe.RenderAnnotation.Text"), proto.mediapipe.RenderViewport = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.RenderViewport, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.RenderViewport.displayName = "proto.mediapipe.RenderViewport"), proto.mediapipe.RenderData.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderData.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderData.toObject(e11, this);
    }, proto.mediapipe.RenderData.toObject = function(e11, r11) {
        var o11, i11 = {
            renderAnnotationsList: t11.Message.toObjectList(r11.getRenderAnnotationsList(), proto.mediapipe.RenderAnnotation.toObject, e11),
            sceneClass: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            sceneViewport: (o11 = r11.getSceneViewport()) && proto.mediapipe.RenderViewport.toObject(e11, o11)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.RenderData.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderData;
        return proto.mediapipe.RenderData.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderData.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.RenderAnnotation;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.deserializeBinaryFromReader), e11.addRenderAnnotations(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setSceneClass(r11);
                break;
            case 3:
                r11 = new proto.mediapipe.RenderViewport;
                t11.readMessage(r11, proto.mediapipe.RenderViewport.deserializeBinaryFromReader), e11.setSceneViewport(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderData.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderData.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderData.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        (o11 = e11.getRenderAnnotationsList()).length > 0 && r11.writeRepeatedMessage(1, o11, proto.mediapipe.RenderAnnotation.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeString(2, o11), null != (o11 = e11.getSceneViewport()) && r11.writeMessage(3, o11, proto.mediapipe.RenderViewport.serializeBinaryToWriter);
    }, proto.mediapipe.RenderData.prototype.getRenderAnnotationsList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.RenderAnnotation, 1);
    }, proto.mediapipe.RenderData.prototype.setRenderAnnotationsList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.RenderData.prototype.addRenderAnnotations = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.RenderAnnotation, r11);
    }, proto.mediapipe.RenderData.prototype.clearRenderAnnotationsList = function() {
        return this.setRenderAnnotationsList([]);
    }, proto.mediapipe.RenderData.prototype.getSceneClass = function() {
        return t11.Message.getFieldWithDefault(this, 2, "");
    }, proto.mediapipe.RenderData.prototype.setSceneClass = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderData.prototype.clearSceneClass = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderData.prototype.hasSceneClass = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderData.prototype.getSceneViewport = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderViewport, 3);
    }, proto.mediapipe.RenderData.prototype.setSceneViewport = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.RenderData.prototype.clearSceneViewport = function() {
        return this.setSceneViewport(void 0);
    }, proto.mediapipe.RenderData.prototype.hasSceneViewport = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.RenderAnnotation.oneofGroups_ = [
        [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            14,
            15
        ]
    ], proto.mediapipe.RenderAnnotation.DataCase = {
        DATA_NOT_SET: 0,
        RECTANGLE: 1,
        FILLED_RECTANGLE: 2,
        OVAL: 3,
        FILLED_OVAL: 4,
        POINT: 5,
        LINE: 6,
        ARROW: 7,
        TEXT: 8,
        ROUNDED_RECTANGLE: 9,
        FILLED_ROUNDED_RECTANGLE: 10,
        GRADIENT_LINE: 14,
        SCRIBBLE: 15
    }, proto.mediapipe.RenderAnnotation.prototype.getDataCase = function() {
        return t11.Message.computeOneofCase(this, proto.mediapipe.RenderAnnotation.oneofGroups_[0]);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.toObject = function(e11, r11) {
        var o11, a11 = {
            rectangle: (o11 = r11.getRectangle()) && proto.mediapipe.RenderAnnotation.Rectangle.toObject(e11, o11),
            filledRectangle: (o11 = r11.getFilledRectangle()) && proto.mediapipe.RenderAnnotation.FilledRectangle.toObject(e11, o11),
            oval: (o11 = r11.getOval()) && proto.mediapipe.RenderAnnotation.Oval.toObject(e11, o11),
            filledOval: (o11 = r11.getFilledOval()) && proto.mediapipe.RenderAnnotation.FilledOval.toObject(e11, o11),
            point: (o11 = r11.getPoint()) && proto.mediapipe.RenderAnnotation.Point.toObject(e11, o11),
            line: (o11 = r11.getLine()) && proto.mediapipe.RenderAnnotation.Line.toObject(e11, o11),
            arrow: (o11 = r11.getArrow()) && proto.mediapipe.RenderAnnotation.Arrow.toObject(e11, o11),
            text: (o11 = r11.getText()) && proto.mediapipe.RenderAnnotation.Text.toObject(e11, o11),
            roundedRectangle: (o11 = r11.getRoundedRectangle()) && proto.mediapipe.RenderAnnotation.RoundedRectangle.toObject(e11, o11),
            filledRoundedRectangle: (o11 = r11.getFilledRoundedRectangle()) && proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.toObject(e11, o11),
            gradientLine: (o11 = r11.getGradientLine()) && proto.mediapipe.RenderAnnotation.GradientLine.toObject(e11, o11),
            scribble: (o11 = r11.getScribble()) && proto.mediapipe.RenderAnnotation.Scribble.toObject(e11, o11),
            thickness: t11.Message.getFloatingPointFieldWithDefault(r11, 11, 1),
            color: (o11 = r11.getColor()) && i11.Color.toObject(e11, o11),
            sceneTag: null == (o11 = t11.Message.getField(r11, 13)) ? void 0 : o11
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.RenderAnnotation.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation;
        return proto.mediapipe.RenderAnnotation.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.RenderAnnotation.Rectangle;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Rectangle.deserializeBinaryFromReader), e11.setRectangle(r11);
                break;
            case 2:
                r11 = new proto.mediapipe.RenderAnnotation.FilledRectangle;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.FilledRectangle.deserializeBinaryFromReader), e11.setFilledRectangle(r11);
                break;
            case 3:
                r11 = new proto.mediapipe.RenderAnnotation.Oval;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Oval.deserializeBinaryFromReader), e11.setOval(r11);
                break;
            case 4:
                r11 = new proto.mediapipe.RenderAnnotation.FilledOval;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.FilledOval.deserializeBinaryFromReader), e11.setFilledOval(r11);
                break;
            case 5:
                r11 = new proto.mediapipe.RenderAnnotation.Point;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Point.deserializeBinaryFromReader), e11.setPoint(r11);
                break;
            case 6:
                r11 = new proto.mediapipe.RenderAnnotation.Line;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Line.deserializeBinaryFromReader), e11.setLine(r11);
                break;
            case 7:
                r11 = new proto.mediapipe.RenderAnnotation.Arrow;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Arrow.deserializeBinaryFromReader), e11.setArrow(r11);
                break;
            case 8:
                r11 = new proto.mediapipe.RenderAnnotation.Text;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Text.deserializeBinaryFromReader), e11.setText(r11);
                break;
            case 9:
                r11 = new proto.mediapipe.RenderAnnotation.RoundedRectangle;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.RoundedRectangle.deserializeBinaryFromReader), e11.setRoundedRectangle(r11);
                break;
            case 10:
                r11 = new proto.mediapipe.RenderAnnotation.FilledRoundedRectangle;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.deserializeBinaryFromReader), e11.setFilledRoundedRectangle(r11);
                break;
            case 14:
                r11 = new proto.mediapipe.RenderAnnotation.GradientLine;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.GradientLine.deserializeBinaryFromReader), e11.setGradientLine(r11);
                break;
            case 15:
                r11 = new proto.mediapipe.RenderAnnotation.Scribble;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Scribble.deserializeBinaryFromReader), e11.setScribble(r11);
                break;
            case 11:
                r11 = t11.readDouble();
                e11.setThickness(r11);
                break;
            case 12:
                r11 = new i11.Color;
                t11.readMessage(r11, i11.Color.deserializeBinaryFromReader), e11.setColor(r11);
                break;
            case 13:
                r11 = t11.readString();
                e11.setSceneTag(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getRectangle()) && r11.writeMessage(1, o11, proto.mediapipe.RenderAnnotation.Rectangle.serializeBinaryToWriter), null != (o11 = e11.getFilledRectangle()) && r11.writeMessage(2, o11, proto.mediapipe.RenderAnnotation.FilledRectangle.serializeBinaryToWriter), null != (o11 = e11.getOval()) && r11.writeMessage(3, o11, proto.mediapipe.RenderAnnotation.Oval.serializeBinaryToWriter), null != (o11 = e11.getFilledOval()) && r11.writeMessage(4, o11, proto.mediapipe.RenderAnnotation.FilledOval.serializeBinaryToWriter), null != (o11 = e11.getPoint()) && r11.writeMessage(5, o11, proto.mediapipe.RenderAnnotation.Point.serializeBinaryToWriter), null != (o11 = e11.getLine()) && r11.writeMessage(6, o11, proto.mediapipe.RenderAnnotation.Line.serializeBinaryToWriter), null != (o11 = e11.getArrow()) && r11.writeMessage(7, o11, proto.mediapipe.RenderAnnotation.Arrow.serializeBinaryToWriter), null != (o11 = e11.getText()) && r11.writeMessage(8, o11, proto.mediapipe.RenderAnnotation.Text.serializeBinaryToWriter), null != (o11 = e11.getRoundedRectangle()) && r11.writeMessage(9, o11, proto.mediapipe.RenderAnnotation.RoundedRectangle.serializeBinaryToWriter), null != (o11 = e11.getFilledRoundedRectangle()) && r11.writeMessage(10, o11, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.serializeBinaryToWriter), null != (o11 = e11.getGradientLine()) && r11.writeMessage(14, o11, proto.mediapipe.RenderAnnotation.GradientLine.serializeBinaryToWriter), null != (o11 = e11.getScribble()) && r11.writeMessage(15, o11, proto.mediapipe.RenderAnnotation.Scribble.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 11)) && r11.writeDouble(11, o11), null != (o11 = e11.getColor()) && r11.writeMessage(12, o11, i11.Color.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 13)) && r11.writeString(13, o11);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.Rectangle.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.Rectangle.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.Rectangle.toObject = function(e11, r11) {
        var o11, i11 = {
            left: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            top: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            right: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            bottom: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11,
            normalized: t11.Message.getBooleanFieldWithDefault(r11, 5, !1),
            rotation: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 6)) ? void 0 : o11,
            topLeftThickness: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 7)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.RenderAnnotation.Rectangle.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.Rectangle;
        return proto.mediapipe.RenderAnnotation.Rectangle.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readDouble();
                e11.setLeft(r11);
                break;
            case 2:
                r11 = t11.readDouble();
                e11.setTop(r11);
                break;
            case 3:
                r11 = t11.readDouble();
                e11.setRight(r11);
                break;
            case 4:
                r11 = t11.readDouble();
                e11.setBottom(r11);
                break;
            case 5:
                r11 = t11.readBool();
                e11.setNormalized(r11);
                break;
            case 6:
                r11 = t11.readDouble();
                e11.setRotation(r11);
                break;
            case 7:
                r11 = t11.readDouble();
                e11.setTopLeftThickness(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.Rectangle.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.Rectangle.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeDouble(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeDouble(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeDouble(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeDouble(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeBool(5, o11), null != (o11 = t11.Message.getField(e11, 6)) && r11.writeDouble(6, o11), null != (o11 = t11.Message.getField(e11, 7)) && r11.writeDouble(7, o11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.getLeft = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.setLeft = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.clearLeft = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.hasLeft = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.getTop = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.setTop = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.clearTop = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.hasTop = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.getRight = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.setRight = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.clearRight = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.hasRight = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.getBottom = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.setBottom = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.clearBottom = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.hasBottom = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.getNormalized = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 5, !1);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.setNormalized = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.clearNormalized = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.hasNormalized = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.getRotation = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 6, 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.setRotation = function(e11) {
        return t11.Message.setField(this, 6, e11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.clearRotation = function() {
        return t11.Message.setField(this, 6, void 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.hasRotation = function() {
        return null != t11.Message.getField(this, 6);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.getTopLeftThickness = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 7, 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.setTopLeftThickness = function(e11) {
        return t11.Message.setField(this, 7, e11);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.clearTopLeftThickness = function() {
        return t11.Message.setField(this, 7, void 0);
    }, proto.mediapipe.RenderAnnotation.Rectangle.prototype.hasTopLeftThickness = function() {
        return null != t11.Message.getField(this, 7);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.FilledRectangle.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.toObject = function(e11, t11) {
        var r11, o11 = {
            rectangle: (r11 = t11.getRectangle()) && proto.mediapipe.RenderAnnotation.Rectangle.toObject(e11, r11),
            fillColor: (r11 = t11.getFillColor()) && i11.Color.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.RenderAnnotation.FilledRectangle.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.FilledRectangle;
        return proto.mediapipe.RenderAnnotation.FilledRectangle.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.RenderAnnotation.Rectangle;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Rectangle.deserializeBinaryFromReader), e11.setRectangle(r11);
                break;
            case 2:
                r11 = new i11.Color;
                t11.readMessage(r11, i11.Color.deserializeBinaryFromReader), e11.setFillColor(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.FilledRectangle.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getRectangle()) && t11.writeMessage(1, r11, proto.mediapipe.RenderAnnotation.Rectangle.serializeBinaryToWriter), null != (r11 = e11.getFillColor()) && t11.writeMessage(2, r11, i11.Color.serializeBinaryToWriter);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.getRectangle = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Rectangle, 1);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.setRectangle = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.clearRectangle = function() {
        return this.setRectangle(void 0);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.hasRectangle = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.getFillColor = function() {
        return t11.Message.getWrapperField(this, i11.Color, 2);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.setFillColor = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.clearFillColor = function() {
        return this.setFillColor(void 0);
    }, proto.mediapipe.RenderAnnotation.FilledRectangle.prototype.hasFillColor = function() {
        return null != t11.Message.getField(this, 2);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.RoundedRectangle.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.toObject = function(e11, r11) {
        var o11, i11 = {
            rectangle: (o11 = r11.getRectangle()) && proto.mediapipe.RenderAnnotation.Rectangle.toObject(e11, o11),
            cornerRadius: t11.Message.getFieldWithDefault(r11, 2, 0),
            lineType: t11.Message.getFieldWithDefault(r11, 3, 4)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.RenderAnnotation.RoundedRectangle.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.RoundedRectangle;
        return proto.mediapipe.RenderAnnotation.RoundedRectangle.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.RenderAnnotation.Rectangle;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Rectangle.deserializeBinaryFromReader), e11.setRectangle(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setCornerRadius(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setLineType(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.RoundedRectangle.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getRectangle()) && r11.writeMessage(1, o11, proto.mediapipe.RenderAnnotation.Rectangle.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.getRectangle = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Rectangle, 1);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.setRectangle = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.clearRectangle = function() {
        return this.setRectangle(void 0);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.hasRectangle = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.getCornerRadius = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.setCornerRadius = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.clearCornerRadius = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.hasCornerRadius = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.getLineType = function() {
        return t11.Message.getFieldWithDefault(this, 3, 4);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.setLineType = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.clearLineType = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.RenderAnnotation.RoundedRectangle.prototype.hasLineType = function() {
        return null != t11.Message.getField(this, 3);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.toObject = function(e11, t11) {
        var r11, o11 = {
            roundedRectangle: (r11 = t11.getRoundedRectangle()) && proto.mediapipe.RenderAnnotation.RoundedRectangle.toObject(e11, r11),
            fillColor: (r11 = t11.getFillColor()) && i11.Color.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.FilledRoundedRectangle;
        return proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.RenderAnnotation.RoundedRectangle;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.RoundedRectangle.deserializeBinaryFromReader), e11.setRoundedRectangle(r11);
                break;
            case 2:
                r11 = new i11.Color;
                t11.readMessage(r11, i11.Color.deserializeBinaryFromReader), e11.setFillColor(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getRoundedRectangle()) && t11.writeMessage(1, r11, proto.mediapipe.RenderAnnotation.RoundedRectangle.serializeBinaryToWriter), null != (r11 = e11.getFillColor()) && t11.writeMessage(2, r11, i11.Color.serializeBinaryToWriter);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.getRoundedRectangle = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.RoundedRectangle, 1);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.setRoundedRectangle = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.clearRoundedRectangle = function() {
        return this.setRoundedRectangle(void 0);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.hasRoundedRectangle = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.getFillColor = function() {
        return t11.Message.getWrapperField(this, i11.Color, 2);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.setFillColor = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.clearFillColor = function() {
        return this.setFillColor(void 0);
    }, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle.prototype.hasFillColor = function() {
        return null != t11.Message.getField(this, 2);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.Oval.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.Oval.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.Oval.toObject = function(e11, t11) {
        var r11, o11 = {
            rectangle: (r11 = t11.getRectangle()) && proto.mediapipe.RenderAnnotation.Rectangle.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.RenderAnnotation.Oval.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.Oval;
        return proto.mediapipe.RenderAnnotation.Oval.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.Oval.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.RenderAnnotation.Rectangle;
            t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Rectangle.deserializeBinaryFromReader), e11.setRectangle(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.RenderAnnotation.Oval.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.Oval.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.Oval.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        null != (r11 = e11.getRectangle()) && t11.writeMessage(1, r11, proto.mediapipe.RenderAnnotation.Rectangle.serializeBinaryToWriter);
    }, proto.mediapipe.RenderAnnotation.Oval.prototype.getRectangle = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Rectangle, 1);
    }, proto.mediapipe.RenderAnnotation.Oval.prototype.setRectangle = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.Oval.prototype.clearRectangle = function() {
        return this.setRectangle(void 0);
    }, proto.mediapipe.RenderAnnotation.Oval.prototype.hasRectangle = function() {
        return null != t11.Message.getField(this, 1);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.FilledOval.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.FilledOval.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.FilledOval.toObject = function(e11, t11) {
        var r11, o11 = {
            oval: (r11 = t11.getOval()) && proto.mediapipe.RenderAnnotation.Oval.toObject(e11, r11),
            fillColor: (r11 = t11.getFillColor()) && i11.Color.toObject(e11, r11)
        };
        return e11 && (o11.$jspbMessageInstance = t11), o11;
    }), proto.mediapipe.RenderAnnotation.FilledOval.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.FilledOval;
        return proto.mediapipe.RenderAnnotation.FilledOval.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.FilledOval.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new proto.mediapipe.RenderAnnotation.Oval;
                t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Oval.deserializeBinaryFromReader), e11.setOval(r11);
                break;
            case 2:
                r11 = new i11.Color;
                t11.readMessage(r11, i11.Color.deserializeBinaryFromReader), e11.setFillColor(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.FilledOval.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.FilledOval.serializeBinaryToWriter = function(e11, t11) {
        var r11 = void 0;
        null != (r11 = e11.getOval()) && t11.writeMessage(1, r11, proto.mediapipe.RenderAnnotation.Oval.serializeBinaryToWriter), null != (r11 = e11.getFillColor()) && t11.writeMessage(2, r11, i11.Color.serializeBinaryToWriter);
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.getOval = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Oval, 1);
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.setOval = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.clearOval = function() {
        return this.setOval(void 0);
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.hasOval = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.getFillColor = function() {
        return t11.Message.getWrapperField(this, i11.Color, 2);
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.setFillColor = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.clearFillColor = function() {
        return this.setFillColor(void 0);
    }, proto.mediapipe.RenderAnnotation.FilledOval.prototype.hasFillColor = function() {
        return null != t11.Message.getField(this, 2);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.Point.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.Point.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.Point.toObject = function(e11, r11) {
        var o11, i11 = {
            x: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            y: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            normalized: t11.Message.getBooleanFieldWithDefault(r11, 3, !1)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.RenderAnnotation.Point.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.Point;
        return proto.mediapipe.RenderAnnotation.Point.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.Point.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readDouble();
                e11.setX(r11);
                break;
            case 2:
                r11 = t11.readDouble();
                e11.setY(r11);
                break;
            case 3:
                r11 = t11.readBool();
                e11.setNormalized(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.Point.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.Point.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.Point.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeDouble(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeDouble(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeBool(3, o11);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.getX = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.setX = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.clearX = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.hasX = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.getY = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.setY = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.clearY = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.hasY = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.getNormalized = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 3, !1);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.setNormalized = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.clearNormalized = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.RenderAnnotation.Point.prototype.hasNormalized = function() {
        return null != t11.Message.getField(this, 3);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.Line.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.Line.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.Line.toObject = function(e11, r11) {
        var o11, i11 = {
            xStart: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            yStart: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            xEnd: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            yEnd: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11,
            normalized: t11.Message.getBooleanFieldWithDefault(r11, 5, !1),
            lineType: t11.Message.getFieldWithDefault(r11, 6, 1)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.RenderAnnotation.Line.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.Line;
        return proto.mediapipe.RenderAnnotation.Line.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.Line.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readDouble();
                e11.setXStart(r11);
                break;
            case 2:
                r11 = t11.readDouble();
                e11.setYStart(r11);
                break;
            case 3:
                r11 = t11.readDouble();
                e11.setXEnd(r11);
                break;
            case 4:
                r11 = t11.readDouble();
                e11.setYEnd(r11);
                break;
            case 5:
                r11 = t11.readBool();
                e11.setNormalized(r11);
                break;
            case 6:
                r11 = t11.readEnum();
                e11.setLineType(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.Line.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.Line.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.Line.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeDouble(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeDouble(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeDouble(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeDouble(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeBool(5, o11), null != (o11 = t11.Message.getField(e11, 6)) && r11.writeEnum(6, o11);
    }, proto.mediapipe.RenderAnnotation.Line.LineType = {
        UNKNOWN: 0,
        SOLID: 1,
        DASHED: 2
    }, proto.mediapipe.RenderAnnotation.Line.prototype.getXStart = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.setXStart = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.clearXStart = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.hasXStart = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.getYStart = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.setYStart = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.clearYStart = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.hasYStart = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.getXEnd = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.setXEnd = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.clearXEnd = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.hasXEnd = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.getYEnd = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.setYEnd = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.clearYEnd = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.hasYEnd = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.getNormalized = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 5, !1);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.setNormalized = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.clearNormalized = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.hasNormalized = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.getLineType = function() {
        return t11.Message.getFieldWithDefault(this, 6, 1);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.setLineType = function(e11) {
        return t11.Message.setField(this, 6, e11);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.clearLineType = function() {
        return t11.Message.setField(this, 6, void 0);
    }, proto.mediapipe.RenderAnnotation.Line.prototype.hasLineType = function() {
        return null != t11.Message.getField(this, 6);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.GradientLine.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.GradientLine.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.GradientLine.toObject = function(e11, r11) {
        var o11, a11 = {
            xStart: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            yStart: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            xEnd: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            yEnd: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11,
            normalized: t11.Message.getBooleanFieldWithDefault(r11, 5, !1),
            color1: (o11 = r11.getColor1()) && i11.Color.toObject(e11, o11),
            color2: (o11 = r11.getColor2()) && i11.Color.toObject(e11, o11)
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.RenderAnnotation.GradientLine.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.GradientLine;
        return proto.mediapipe.RenderAnnotation.GradientLine.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.GradientLine.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readDouble();
                e11.setXStart(r11);
                break;
            case 2:
                r11 = t11.readDouble();
                e11.setYStart(r11);
                break;
            case 3:
                r11 = t11.readDouble();
                e11.setXEnd(r11);
                break;
            case 4:
                r11 = t11.readDouble();
                e11.setYEnd(r11);
                break;
            case 5:
                r11 = t11.readBool();
                e11.setNormalized(r11);
                break;
            case 6:
                r11 = new i11.Color;
                t11.readMessage(r11, i11.Color.deserializeBinaryFromReader), e11.setColor1(r11);
                break;
            case 7:
                r11 = new i11.Color;
                t11.readMessage(r11, i11.Color.deserializeBinaryFromReader), e11.setColor2(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.GradientLine.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.GradientLine.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeDouble(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeDouble(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeDouble(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeDouble(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeBool(5, o11), null != (o11 = e11.getColor1()) && r11.writeMessage(6, o11, i11.Color.serializeBinaryToWriter), null != (o11 = e11.getColor2()) && r11.writeMessage(7, o11, i11.Color.serializeBinaryToWriter);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.getXStart = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.setXStart = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.clearXStart = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.hasXStart = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.getYStart = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.setYStart = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.clearYStart = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.hasYStart = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.getXEnd = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.setXEnd = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.clearXEnd = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.hasXEnd = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.getYEnd = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.setYEnd = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.clearYEnd = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.hasYEnd = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.getNormalized = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 5, !1);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.setNormalized = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.clearNormalized = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.hasNormalized = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.getColor1 = function() {
        return t11.Message.getWrapperField(this, i11.Color, 6);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.setColor1 = function(e11) {
        return t11.Message.setWrapperField(this, 6, e11);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.clearColor1 = function() {
        return this.setColor1(void 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.hasColor1 = function() {
        return null != t11.Message.getField(this, 6);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.getColor2 = function() {
        return t11.Message.getWrapperField(this, i11.Color, 7);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.setColor2 = function(e11) {
        return t11.Message.setWrapperField(this, 7, e11);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.clearColor2 = function() {
        return this.setColor2(void 0);
    }, proto.mediapipe.RenderAnnotation.GradientLine.prototype.hasColor2 = function() {
        return null != t11.Message.getField(this, 7);
    }, proto.mediapipe.RenderAnnotation.Scribble.repeatedFields_ = [
        1
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.Scribble.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.Scribble.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.Scribble.toObject = function(e11, r11) {
        var o11 = {
            pointList: t11.Message.toObjectList(r11.getPointList(), proto.mediapipe.RenderAnnotation.Point.toObject, e11)
        };
        return e11 && (o11.$jspbMessageInstance = r11), o11;
    }), proto.mediapipe.RenderAnnotation.Scribble.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.Scribble;
        return proto.mediapipe.RenderAnnotation.Scribble.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.Scribble.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)if (1 === t11.getFieldNumber()) {
            var r11 = new proto.mediapipe.RenderAnnotation.Point;
            t11.readMessage(r11, proto.mediapipe.RenderAnnotation.Point.deserializeBinaryFromReader), e11.addPoint(r11);
        } else t11.skipField();
        return e11;
    }, proto.mediapipe.RenderAnnotation.Scribble.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.Scribble.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.Scribble.serializeBinaryToWriter = function(e11, t11) {
        var r11;
        (r11 = e11.getPointList()).length > 0 && t11.writeRepeatedMessage(1, r11, proto.mediapipe.RenderAnnotation.Point.serializeBinaryToWriter);
    }, proto.mediapipe.RenderAnnotation.Scribble.prototype.getPointList = function() {
        return t11.Message.getRepeatedWrapperField(this, proto.mediapipe.RenderAnnotation.Point, 1);
    }, proto.mediapipe.RenderAnnotation.Scribble.prototype.setPointList = function(e11) {
        return t11.Message.setRepeatedWrapperField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.Scribble.prototype.addPoint = function(e11, r11) {
        return t11.Message.addToRepeatedWrapperField(this, 1, e11, proto.mediapipe.RenderAnnotation.Point, r11);
    }, proto.mediapipe.RenderAnnotation.Scribble.prototype.clearPointList = function() {
        return this.setPointList([]);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.Arrow.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.Arrow.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.Arrow.toObject = function(e11, r11) {
        var o11, i11 = {
            xStart: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 1)) ? void 0 : o11,
            yStart: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            xEnd: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            yEnd: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11,
            normalized: t11.Message.getBooleanFieldWithDefault(r11, 5, !1)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.RenderAnnotation.Arrow.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.Arrow;
        return proto.mediapipe.RenderAnnotation.Arrow.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.Arrow.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readDouble();
                e11.setXStart(r11);
                break;
            case 2:
                r11 = t11.readDouble();
                e11.setYStart(r11);
                break;
            case 3:
                r11 = t11.readDouble();
                e11.setXEnd(r11);
                break;
            case 4:
                r11 = t11.readDouble();
                e11.setYEnd(r11);
                break;
            case 5:
                r11 = t11.readBool();
                e11.setNormalized(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.Arrow.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.Arrow.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeDouble(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeDouble(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeDouble(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeDouble(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeBool(5, o11);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.getXStart = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 1, 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.setXStart = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.clearXStart = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.hasXStart = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.getYStart = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.setYStart = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.clearYStart = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.hasYStart = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.getXEnd = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.setXEnd = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.clearXEnd = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.hasXEnd = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.getYEnd = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.setYEnd = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.clearYEnd = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.hasYEnd = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.getNormalized = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 5, !1);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.setNormalized = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.clearNormalized = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.RenderAnnotation.Arrow.prototype.hasNormalized = function() {
        return null != t11.Message.getField(this, 5);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderAnnotation.Text.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderAnnotation.Text.toObject(e11, this);
    }, proto.mediapipe.RenderAnnotation.Text.toObject = function(e11, r11) {
        var o11, a11 = {
            displayText: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            left: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 2)) ? void 0 : o11,
            baseline: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 3)) ? void 0 : o11,
            fontHeight: t11.Message.getFloatingPointFieldWithDefault(r11, 4, 8),
            normalized: t11.Message.getBooleanFieldWithDefault(r11, 5, !1),
            fontFace: t11.Message.getFieldWithDefault(r11, 6, 0),
            centerHorizontally: t11.Message.getBooleanFieldWithDefault(r11, 7, !1),
            centerVertically: t11.Message.getBooleanFieldWithDefault(r11, 8, !1),
            outlineThickness: t11.Message.getFloatingPointFieldWithDefault(r11, 11, 0),
            outlineColor: (o11 = r11.getOutlineColor()) && i11.Color.toObject(e11, o11)
        };
        return e11 && (a11.$jspbMessageInstance = r11), a11;
    }), proto.mediapipe.RenderAnnotation.Text.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderAnnotation.Text;
        return proto.mediapipe.RenderAnnotation.Text.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderAnnotation.Text.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setDisplayText(r11);
                break;
            case 2:
                r11 = t11.readDouble();
                e11.setLeft(r11);
                break;
            case 3:
                r11 = t11.readDouble();
                e11.setBaseline(r11);
                break;
            case 4:
                r11 = t11.readDouble();
                e11.setFontHeight(r11);
                break;
            case 5:
                r11 = t11.readBool();
                e11.setNormalized(r11);
                break;
            case 6:
                r11 = t11.readInt32();
                e11.setFontFace(r11);
                break;
            case 7:
                r11 = t11.readBool();
                e11.setCenterHorizontally(r11);
                break;
            case 8:
                r11 = t11.readBool();
                e11.setCenterVertically(r11);
                break;
            case 11:
                r11 = t11.readDouble();
                e11.setOutlineThickness(r11);
                break;
            case 12:
                r11 = new i11.Color;
                t11.readMessage(r11, i11.Color.deserializeBinaryFromReader), e11.setOutlineColor(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderAnnotation.Text.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderAnnotation.Text.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderAnnotation.Text.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeDouble(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeDouble(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeDouble(4, o11), null != (o11 = t11.Message.getField(e11, 5)) && r11.writeBool(5, o11), null != (o11 = t11.Message.getField(e11, 6)) && r11.writeInt32(6, o11), null != (o11 = t11.Message.getField(e11, 7)) && r11.writeBool(7, o11), null != (o11 = t11.Message.getField(e11, 8)) && r11.writeBool(8, o11), null != (o11 = t11.Message.getField(e11, 11)) && r11.writeDouble(11, o11), null != (o11 = e11.getOutlineColor()) && r11.writeMessage(12, o11, i11.Color.serializeBinaryToWriter);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getDisplayText = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setDisplayText = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearDisplayText = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasDisplayText = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getLeft = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setLeft = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearLeft = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasLeft = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getBaseline = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setBaseline = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearBaseline = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasBaseline = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getFontHeight = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 8);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setFontHeight = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearFontHeight = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasFontHeight = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getNormalized = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 5, !1);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setNormalized = function(e11) {
        return t11.Message.setField(this, 5, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearNormalized = function() {
        return t11.Message.setField(this, 5, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasNormalized = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getFontFace = function() {
        return t11.Message.getFieldWithDefault(this, 6, 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setFontFace = function(e11) {
        return t11.Message.setField(this, 6, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearFontFace = function() {
        return t11.Message.setField(this, 6, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasFontFace = function() {
        return null != t11.Message.getField(this, 6);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getCenterHorizontally = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 7, !1);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setCenterHorizontally = function(e11) {
        return t11.Message.setField(this, 7, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearCenterHorizontally = function() {
        return t11.Message.setField(this, 7, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasCenterHorizontally = function() {
        return null != t11.Message.getField(this, 7);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getCenterVertically = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 8, !1);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setCenterVertically = function(e11) {
        return t11.Message.setField(this, 8, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearCenterVertically = function() {
        return t11.Message.setField(this, 8, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasCenterVertically = function() {
        return null != t11.Message.getField(this, 8);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getOutlineThickness = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 11, 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setOutlineThickness = function(e11) {
        return t11.Message.setField(this, 11, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearOutlineThickness = function() {
        return t11.Message.setField(this, 11, void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasOutlineThickness = function() {
        return null != t11.Message.getField(this, 11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.getOutlineColor = function() {
        return t11.Message.getWrapperField(this, i11.Color, 12);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.setOutlineColor = function(e11) {
        return t11.Message.setWrapperField(this, 12, e11);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.clearOutlineColor = function() {
        return this.setOutlineColor(void 0);
    }, proto.mediapipe.RenderAnnotation.Text.prototype.hasOutlineColor = function() {
        return null != t11.Message.getField(this, 12);
    }, proto.mediapipe.RenderAnnotation.prototype.getRectangle = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Rectangle, 1);
    }, proto.mediapipe.RenderAnnotation.prototype.setRectangle = function(e11) {
        return t11.Message.setOneofWrapperField(this, 1, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearRectangle = function() {
        return this.setRectangle(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasRectangle = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderAnnotation.prototype.getFilledRectangle = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.FilledRectangle, 2);
    }, proto.mediapipe.RenderAnnotation.prototype.setFilledRectangle = function(e11) {
        return t11.Message.setOneofWrapperField(this, 2, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearFilledRectangle = function() {
        return this.setFilledRectangle(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasFilledRectangle = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderAnnotation.prototype.getOval = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Oval, 3);
    }, proto.mediapipe.RenderAnnotation.prototype.setOval = function(e11) {
        return t11.Message.setOneofWrapperField(this, 3, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearOval = function() {
        return this.setOval(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasOval = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.RenderAnnotation.prototype.getFilledOval = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.FilledOval, 4);
    }, proto.mediapipe.RenderAnnotation.prototype.setFilledOval = function(e11) {
        return t11.Message.setOneofWrapperField(this, 4, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearFilledOval = function() {
        return this.setFilledOval(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasFilledOval = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.RenderAnnotation.prototype.getPoint = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Point, 5);
    }, proto.mediapipe.RenderAnnotation.prototype.setPoint = function(e11) {
        return t11.Message.setOneofWrapperField(this, 5, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearPoint = function() {
        return this.setPoint(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasPoint = function() {
        return null != t11.Message.getField(this, 5);
    }, proto.mediapipe.RenderAnnotation.prototype.getLine = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Line, 6);
    }, proto.mediapipe.RenderAnnotation.prototype.setLine = function(e11) {
        return t11.Message.setOneofWrapperField(this, 6, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearLine = function() {
        return this.setLine(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasLine = function() {
        return null != t11.Message.getField(this, 6);
    }, proto.mediapipe.RenderAnnotation.prototype.getArrow = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Arrow, 7);
    }, proto.mediapipe.RenderAnnotation.prototype.setArrow = function(e11) {
        return t11.Message.setOneofWrapperField(this, 7, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearArrow = function() {
        return this.setArrow(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasArrow = function() {
        return null != t11.Message.getField(this, 7);
    }, proto.mediapipe.RenderAnnotation.prototype.getText = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Text, 8);
    }, proto.mediapipe.RenderAnnotation.prototype.setText = function(e11) {
        return t11.Message.setOneofWrapperField(this, 8, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearText = function() {
        return this.setText(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasText = function() {
        return null != t11.Message.getField(this, 8);
    }, proto.mediapipe.RenderAnnotation.prototype.getRoundedRectangle = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.RoundedRectangle, 9);
    }, proto.mediapipe.RenderAnnotation.prototype.setRoundedRectangle = function(e11) {
        return t11.Message.setOneofWrapperField(this, 9, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearRoundedRectangle = function() {
        return this.setRoundedRectangle(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasRoundedRectangle = function() {
        return null != t11.Message.getField(this, 9);
    }, proto.mediapipe.RenderAnnotation.prototype.getFilledRoundedRectangle = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.FilledRoundedRectangle, 10);
    }, proto.mediapipe.RenderAnnotation.prototype.setFilledRoundedRectangle = function(e11) {
        return t11.Message.setOneofWrapperField(this, 10, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearFilledRoundedRectangle = function() {
        return this.setFilledRoundedRectangle(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasFilledRoundedRectangle = function() {
        return null != t11.Message.getField(this, 10);
    }, proto.mediapipe.RenderAnnotation.prototype.getGradientLine = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.GradientLine, 14);
    }, proto.mediapipe.RenderAnnotation.prototype.setGradientLine = function(e11) {
        return t11.Message.setOneofWrapperField(this, 14, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearGradientLine = function() {
        return this.setGradientLine(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasGradientLine = function() {
        return null != t11.Message.getField(this, 14);
    }, proto.mediapipe.RenderAnnotation.prototype.getScribble = function() {
        return t11.Message.getWrapperField(this, proto.mediapipe.RenderAnnotation.Scribble, 15);
    }, proto.mediapipe.RenderAnnotation.prototype.setScribble = function(e11) {
        return t11.Message.setOneofWrapperField(this, 15, proto.mediapipe.RenderAnnotation.oneofGroups_[0], e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearScribble = function() {
        return this.setScribble(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasScribble = function() {
        return null != t11.Message.getField(this, 15);
    }, proto.mediapipe.RenderAnnotation.prototype.getThickness = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 11, 1);
    }, proto.mediapipe.RenderAnnotation.prototype.setThickness = function(e11) {
        return t11.Message.setField(this, 11, e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearThickness = function() {
        return t11.Message.setField(this, 11, void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasThickness = function() {
        return null != t11.Message.getField(this, 11);
    }, proto.mediapipe.RenderAnnotation.prototype.getColor = function() {
        return t11.Message.getWrapperField(this, i11.Color, 12);
    }, proto.mediapipe.RenderAnnotation.prototype.setColor = function(e11) {
        return t11.Message.setWrapperField(this, 12, e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearColor = function() {
        return this.setColor(void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasColor = function() {
        return null != t11.Message.getField(this, 12);
    }, proto.mediapipe.RenderAnnotation.prototype.getSceneTag = function() {
        return t11.Message.getFieldWithDefault(this, 13, "");
    }, proto.mediapipe.RenderAnnotation.prototype.setSceneTag = function(e11) {
        return t11.Message.setField(this, 13, e11);
    }, proto.mediapipe.RenderAnnotation.prototype.clearSceneTag = function() {
        return t11.Message.setField(this, 13, void 0);
    }, proto.mediapipe.RenderAnnotation.prototype.hasSceneTag = function() {
        return null != t11.Message.getField(this, 13);
    }, t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.RenderViewport.prototype.toObject = function(e11) {
        return proto.mediapipe.RenderViewport.toObject(e11, this);
    }, proto.mediapipe.RenderViewport.toObject = function(e11, r11) {
        var o11, i11 = {
            id: null == (o11 = t11.Message.getField(r11, 1)) ? void 0 : o11,
            widthPx: null == (o11 = t11.Message.getField(r11, 2)) ? void 0 : o11,
            heightPx: null == (o11 = t11.Message.getField(r11, 3)) ? void 0 : o11,
            composeOnVideo: null == (o11 = t11.Message.getBooleanField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.RenderViewport.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.RenderViewport;
        return proto.mediapipe.RenderViewport.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.RenderViewport.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = t11.readString();
                e11.setId(r11);
                break;
            case 2:
                r11 = t11.readInt32();
                e11.setWidthPx(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setHeightPx(r11);
                break;
            case 4:
                r11 = t11.readBool();
                e11.setComposeOnVideo(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.RenderViewport.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.RenderViewport.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.RenderViewport.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = t11.Message.getField(e11, 1)) && r11.writeString(1, o11), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeInt32(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeBool(4, o11);
    }, proto.mediapipe.RenderViewport.prototype.getId = function() {
        return t11.Message.getFieldWithDefault(this, 1, "");
    }, proto.mediapipe.RenderViewport.prototype.setId = function(e11) {
        return t11.Message.setField(this, 1, e11);
    }, proto.mediapipe.RenderViewport.prototype.clearId = function() {
        return t11.Message.setField(this, 1, void 0);
    }, proto.mediapipe.RenderViewport.prototype.hasId = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.RenderViewport.prototype.getWidthPx = function() {
        return t11.Message.getFieldWithDefault(this, 2, 0);
    }, proto.mediapipe.RenderViewport.prototype.setWidthPx = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.RenderViewport.prototype.clearWidthPx = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.RenderViewport.prototype.hasWidthPx = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.RenderViewport.prototype.getHeightPx = function() {
        return t11.Message.getFieldWithDefault(this, 3, 0);
    }, proto.mediapipe.RenderViewport.prototype.setHeightPx = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.RenderViewport.prototype.clearHeightPx = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.RenderViewport.prototype.hasHeightPx = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.RenderViewport.prototype.getComposeOnVideo = function() {
        return t11.Message.getBooleanFieldWithDefault(this, 4, !1);
    }, proto.mediapipe.RenderViewport.prototype.setComposeOnVideo = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.RenderViewport.prototype.clearComposeOnVideo = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.RenderViewport.prototype.hasComposeOnVideo = function() {
        return null != t11.Message.getField(this, 4);
    }, r11.object.extend(e11, proto.mediapipe);
}(render_data_pb);
var interactive_segmenter_options = {};
Object.defineProperty(interactive_segmenter_options, "__esModule", {
    value: !0
});
var interactive_segmenter_result = {};
Object.defineProperty(interactive_segmenter_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.InteractiveSegmenter = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = base_options_pb, n11 = image_segmenter_graph_options_pb, s11 = segmenter_options_pb, p11 = vision_task_runner, d11 = color_pb, l11 = render_data_pb;
    r11(interactive_segmenter_options, e11), r11(interactive_segmenter_result, e11);
    const g11 = "image_in", c11 = "norm_rect_in", u11 = "roi_in", m11 = "confidence_masks", f11 = "category_mask";
    class h11 extends p11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return p11.VisionTaskRunner.createVisionInstance(h11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return p11.VisionTaskRunner.createVisionInstance(h11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return p11.VisionTaskRunner.createVisionInstance(h11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new p11.VisionGraphRunner(e11, t11), g11, c11, !1), this.result = {}, this.outputCategoryMask = false, this.outputConfidenceMasks = true, this.options = new n11.ImageSegmenterGraphOptions, this.segmenterOptions = new s11.SegmenterOptions, this.options.setSegmenterOptions(this.segmenterOptions), this.options.setBaseOptions(new a11.BaseOptions);
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            var t11, r11;
            return "outputCategoryMask" in e11 && (this.outputCategoryMask = null !== (t11 = e11.outputCategoryMask) && void 0 !== t11 && t11), "outputConfidenceMasks" in e11 && (this.outputConfidenceMasks = null === (r11 = e11.outputConfidenceMasks) || void 0 === r11 || r11), super.applyOptions(e11);
        }
        segment(e11, t11, r11, o11) {
            const i11 = "function" != typeof r11 ? r11 : {};
            if (this.userCallback = "function" == typeof r11 ? r11 : o11, this.reset(), this.processRenderData(t11, this.getSynctheticTimestamp()), this.processImageData(e11, i11), !this.userCallback) return this.result;
        }
        reset() {
            this.result = {};
        }
        maybeInvokeCallback() {
            this.outputConfidenceMasks && !("confidenceMasks" in this.result) || this.outputCategoryMask && !("categoryMask" in this.result) || this.userCallback && (this.userCallback(this.result), this.freeKeepaliveStreams());
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(g11), e11.addInputStream(u11), e11.addInputStream(c11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(n11.ImageSegmenterGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.interactive_segmenter.InteractiveSegmenterGraph"), r11.addInputStream("IMAGE:" + g11), r11.addInputStream("ROI:" + u11), r11.addInputStream("NORM_RECT:" + c11), r11.setOptions(t11), e11.addNode(r11), this.addKeepaliveNode(e11), this.outputConfidenceMasks && (e11.addOutputStream(m11), r11.addOutputStream("CONFIDENCE_MASKS:" + m11), this.keepStreamAlive(m11), this.graphRunner.attachImageVectorListener(m11, (e11, t11)=>{
                this.result.confidenceMasks = e11.map((e11)=>this.convertToMPMask(e11, !this.userCallback)), this.setLatestOutputTimestamp(t11), this.maybeInvokeCallback();
            }), this.graphRunner.attachEmptyPacketListener(m11, (e11)=>{
                this.result.confidenceMasks = void 0, this.setLatestOutputTimestamp(e11), this.maybeInvokeCallback();
            })), this.outputCategoryMask && (e11.addOutputStream(f11), r11.addOutputStream("CATEGORY_MASK:" + f11), this.keepStreamAlive(f11), this.graphRunner.attachImageListener(f11, (e11, t11)=>{
                this.result.categoryMask = this.convertToMPMask(e11, !this.userCallback), this.setLatestOutputTimestamp(t11), this.maybeInvokeCallback();
            }), this.graphRunner.attachEmptyPacketListener(f11, (e11)=>{
                this.result.categoryMask = void 0, this.setLatestOutputTimestamp(e11), this.maybeInvokeCallback();
            }));
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
        processRenderData(e11, t11) {
            const r11 = new l11.RenderData, o11 = new l11.RenderAnnotation, i11 = new d11.Color;
            if (i11.setR(255), o11.setColor(i11), e11.keypoint && e11.scribble) throw new Error("Cannot provide both keypoint and scribble.");
            if (e11.keypoint) {
                const t11 = new l11.RenderAnnotation.Point;
                t11.setNormalized(!0), t11.setX(e11.keypoint.x), t11.setY(e11.keypoint.y), o11.setPoint(t11);
            } else {
                if (!e11.scribble) throw new Error("Must provide either a keypoint or a scribble.");
                {
                    const t11 = new l11.RenderAnnotation.Scribble;
                    for (const r11 of e11.scribble){
                        const e11 = new l11.RenderAnnotation.Point;
                        e11.setNormalized(!0), e11.setX(r11.x), e11.setY(r11.y), t11.addPoint(e11);
                    }
                    o11.setScribble(t11);
                }
            }
            r11.addRenderAnnotations(o11), this.graphRunner.addProtoToStream(r11.serializeBinary(), "drishti.RenderData", u11, t11);
        }
    }
    e11.InteractiveSegmenter = h11;
}(interactive_segmenter);
var object_detector = {}, object_detector_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions", null, o11), proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.repeatedFields_, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.displayName = "proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions"), proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.repeatedFields_ = [
        5,
        6
    ], t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            displayNamesLocale: t11.Message.getFieldWithDefault(r11, 2, "en"),
            maxResults: t11.Message.getFieldWithDefault(r11, 3, -1),
            scoreThreshold: null == (o11 = t11.Message.getOptionalFloatingPointField(r11, 4)) ? void 0 : o11,
            categoryAllowlistList: null == (o11 = t11.Message.getRepeatedField(r11, 5)) ? void 0 : o11,
            categoryDenylistList: null == (o11 = t11.Message.getRepeatedField(r11, 6)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions;
        return proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = t11.readString();
                e11.setDisplayNamesLocale(r11);
                break;
            case 3:
                r11 = t11.readInt32();
                e11.setMaxResults(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setScoreThreshold(r11);
                break;
            case 5:
                r11 = t11.readString();
                e11.addCategoryAllowlist(r11);
                break;
            case 6:
                r11 = t11.readString();
                e11.addCategoryDenylist(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeString(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeInt32(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11), (o11 = e11.getCategoryAllowlistList()).length > 0 && r11.writeRepeatedString(5, o11), (o11 = e11.getCategoryDenylistList()).length > 0 && r11.writeRepeatedString(6, o11);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.ext = new t11.ExtensionFieldInfo(443442058, {
        ext: 0
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[443442058] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[443442058] = proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.ext, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.getDisplayNamesLocale = function() {
        return t11.Message.getFieldWithDefault(this, 2, "en");
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.setDisplayNamesLocale = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.clearDisplayNamesLocale = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.hasDisplayNamesLocale = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.getMaxResults = function() {
        return t11.Message.getFieldWithDefault(this, 3, -1);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.setMaxResults = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.clearMaxResults = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.hasMaxResults = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.getScoreThreshold = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.setScoreThreshold = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.clearScoreThreshold = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.hasScoreThreshold = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.getCategoryAllowlistList = function() {
        return t11.Message.getRepeatedField(this, 5);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.setCategoryAllowlistList = function(e11) {
        return t11.Message.setField(this, 5, e11 || []);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.addCategoryAllowlist = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 5, e11, r11);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.clearCategoryAllowlistList = function() {
        return this.setCategoryAllowlistList([]);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.getCategoryDenylistList = function() {
        return t11.Message.getRepeatedField(this, 6);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.setCategoryDenylistList = function(e11) {
        return t11.Message.setField(this, 6, e11 || []);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.addCategoryDenylist = function(e11, r11) {
        return t11.Message.addToRepeatedField(this, 6, e11, r11);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.prototype.clearCategoryDenylistList = function() {
        return this.setCategoryDenylistList([]);
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.ext = new t11.ExtensionFieldInfo(443442058, {
        ext: 0
    }, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[443442058] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[443442058] = proto.mediapipe.tasks.vision.object_detector.proto.ObjectDetectorOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.object_detector.proto);
}(object_detector_options_pb);
var object_detector_options = {};
Object.defineProperty(object_detector_options, "__esModule", {
    value: !0
});
var object_detector_result = {};
Object.defineProperty(object_detector_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.ObjectDetector = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = detection_pb, n11 = base_options_pb, s11 = object_detector_options_pb, p11 = detection_result, d11 = vision_task_runner, l11 = "input_frame_gpu", g11 = "norm_rect", c11 = "detections";
    r11(object_detector_options, e11), r11(object_detector_result, e11);
    class u11 extends d11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(u11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(u11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static async createFromModelPath(e11, t11) {
            return d11.VisionTaskRunner.createVisionInstance(u11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new d11.VisionGraphRunner(e11, t11), l11, g11, !1), this.result = {
                detections: []
            }, this.options = new s11.ObjectDetectorOptions, this.options.setBaseOptions(new n11.BaseOptions);
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            return void 0 !== e11.displayNamesLocale ? this.options.setDisplayNamesLocale(e11.displayNamesLocale) : "displayNamesLocale" in e11 && this.options.clearDisplayNamesLocale(), void 0 !== e11.maxResults ? this.options.setMaxResults(e11.maxResults) : "maxResults" in e11 && this.options.clearMaxResults(), void 0 !== e11.scoreThreshold ? this.options.setScoreThreshold(e11.scoreThreshold) : "scoreThreshold" in e11 && this.options.clearScoreThreshold(), void 0 !== e11.categoryAllowlist ? this.options.setCategoryAllowlistList(e11.categoryAllowlist) : "categoryAllowlist" in e11 && this.options.clearCategoryAllowlistList(), void 0 !== e11.categoryDenylist ? this.options.setCategoryDenylistList(e11.categoryDenylist) : "categoryDenylist" in e11 && this.options.clearCategoryDenylistList(), this.applyOptions(e11);
        }
        detect(e11, t11) {
            return this.result = {
                detections: []
            }, this.processImageData(e11, t11), this.result;
        }
        detectForVideo(e11, t11, r11) {
            return this.result = {
                detections: []
            }, this.processVideoData(e11, r11, t11), this.result;
        }
        addJsObjectDetections(e11) {
            for (const t11 of e11){
                const e11 = a11.Detection.deserializeBinary(t11);
                this.result.detections.push((0, p11.convertFromDetectionProto)(e11));
            }
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(l11), e11.addInputStream(g11), e11.addOutputStream(c11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(s11.ObjectDetectorOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.ObjectDetectorGraph"), r11.addInputStream("IMAGE:" + l11), r11.addInputStream("NORM_RECT:" + g11), r11.addOutputStream("DETECTIONS:" + c11), r11.setOptions(t11), e11.addNode(r11), this.graphRunner.attachProtoVectorListener(c11, (e11, t11)=>{
                this.addJsObjectDetections(e11), this.setLatestOutputTimestamp(t11);
            }), this.graphRunner.attachEmptyPacketListener(c11, (e11)=>{
                this.setLatestOutputTimestamp(e11);
            });
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.ObjectDetector = u11;
}(object_detector);
var pose_landmarker = {}, pose_detector_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions", null, o11), proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.displayName = "proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            minDetectionConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 2, .5),
            minSuppressionThreshold: t11.Message.getFloatingPointFieldWithDefault(r11, 3, .5),
            numPoses: null == (o11 = t11.Message.getField(r11, 4)) ? void 0 : o11
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions;
        return proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setMinDetectionConfidence(r11);
                break;
            case 3:
                r11 = t11.readFloat();
                e11.setMinSuppressionThreshold(r11);
                break;
            case 4:
                r11 = t11.readInt32();
                e11.setNumPoses(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11), null != (o11 = t11.Message.getField(e11, 3)) && r11.writeFloat(3, o11), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeInt32(4, o11);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(514774813, {
        ext: 0
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[514774813] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[514774813] = proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.ext, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.getMinDetectionConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, .5);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.setMinDetectionConfidence = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.clearMinDetectionConfidence = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.hasMinDetectionConfidence = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.getMinSuppressionThreshold = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 3, .5);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.setMinSuppressionThreshold = function(e11) {
        return t11.Message.setField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.clearMinSuppressionThreshold = function() {
        return t11.Message.setField(this, 3, void 0);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.hasMinSuppressionThreshold = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.getNumPoses = function() {
        return t11.Message.getFieldWithDefault(this, 4, 0);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.setNumPoses = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.clearNumPoses = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.prototype.hasNumPoses = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(514774813, {
        ext: 0
    }, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[514774813] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[514774813] = proto.mediapipe.tasks.vision.pose_detector.proto.PoseDetectorGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.pose_detector.proto);
}(pose_detector_graph_options_pb);
var pose_landmarker_graph_options_pb = {}, pose_landmarks_detector_graph_options_pb = {};
!function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11), r11.exportSymbol("proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions", null, o11), proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.displayName = "proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            minDetectionConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 2, .5)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions;
        return proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = t11.readFloat();
                e11.setMinDetectionConfidence(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 2)) && r11.writeFloat(2, o11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(518928384, {
        ext: 0
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[518928384] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[518928384] = proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.ext, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.getMinDetectionConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 2, .5);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.setMinDetectionConfidence = function(e11) {
        return t11.Message.setField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.clearMinDetectionConfidence = function() {
        return t11.Message.setField(this, 2, void 0);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.prototype.hasMinDetectionConfidence = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.ext = new t11.ExtensionFieldInfo(518928384, {
        ext: 0
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[518928384] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[518928384] = proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarksDetectorGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.pose_landmarker.proto);
}(pose_landmarks_detector_graph_options_pb), function(e11) {
    var t11 = googleProtobuf, r11 = t11, o11 = "undefined" != typeof globalThis && globalThis || "undefined" != typeof window && window || void 0 !== o11 && o11 || "undefined" != typeof self && self || (function() {
        return this;
    }).call(null) || Function("return this")(), i11 = calculator_pb;
    r11.object.extend(proto, i11);
    var a11 = calculator_options_pb;
    r11.object.extend(proto, a11);
    var n11 = base_options_pb;
    r11.object.extend(proto, n11);
    var s11 = pose_detector_graph_options_pb;
    r11.object.extend(proto, s11);
    var p11 = pose_landmarks_detector_graph_options_pb;
    r11.object.extend(proto, p11), r11.exportSymbol("proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions", null, o11), proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions = function(e11) {
        t11.Message.initialize(this, e11, 0, -1, null, null);
    }, r11.inherits(proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions, t11.Message), r11.DEBUG && !COMPILED && (proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.displayName = "proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions"), t11.Message.GENERATE_TO_OBJECT && (proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.toObject = function(e11) {
        return proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.toObject(e11, this);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.toObject = function(e11, r11) {
        var o11, i11 = {
            baseOptions: (o11 = r11.getBaseOptions()) && n11.BaseOptions.toObject(e11, o11),
            poseDetectorGraphOptions: (o11 = r11.getPoseDetectorGraphOptions()) && s11.PoseDetectorGraphOptions.toObject(e11, o11),
            poseLandmarksDetectorGraphOptions: (o11 = r11.getPoseLandmarksDetectorGraphOptions()) && p11.PoseLandmarksDetectorGraphOptions.toObject(e11, o11),
            minTrackingConfidence: t11.Message.getFloatingPointFieldWithDefault(r11, 4, .5)
        };
        return e11 && (i11.$jspbMessageInstance = r11), i11;
    }), proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.deserializeBinary = function(e11) {
        var r11 = new t11.BinaryReader(e11), o11 = new proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions;
        return proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.deserializeBinaryFromReader(o11, r11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.deserializeBinaryFromReader = function(e11, t11) {
        for(; t11.nextField() && !t11.isEndGroup();)switch(t11.getFieldNumber()){
            case 1:
                var r11 = new n11.BaseOptions;
                t11.readMessage(r11, n11.BaseOptions.deserializeBinaryFromReader), e11.setBaseOptions(r11);
                break;
            case 2:
                r11 = new s11.PoseDetectorGraphOptions;
                t11.readMessage(r11, s11.PoseDetectorGraphOptions.deserializeBinaryFromReader), e11.setPoseDetectorGraphOptions(r11);
                break;
            case 3:
                r11 = new p11.PoseLandmarksDetectorGraphOptions;
                t11.readMessage(r11, p11.PoseLandmarksDetectorGraphOptions.deserializeBinaryFromReader), e11.setPoseLandmarksDetectorGraphOptions(r11);
                break;
            case 4:
                r11 = t11.readFloat();
                e11.setMinTrackingConfidence(r11);
                break;
            default:
                t11.skipField();
        }
        return e11;
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.serializeBinary = function() {
        var e11 = new t11.BinaryWriter;
        return proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.serializeBinaryToWriter(this, e11), e11.getResultBuffer();
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.serializeBinaryToWriter = function(e11, r11) {
        var o11 = void 0;
        null != (o11 = e11.getBaseOptions()) && r11.writeMessage(1, o11, n11.BaseOptions.serializeBinaryToWriter), null != (o11 = e11.getPoseDetectorGraphOptions()) && r11.writeMessage(2, o11, s11.PoseDetectorGraphOptions.serializeBinaryToWriter), null != (o11 = e11.getPoseLandmarksDetectorGraphOptions()) && r11.writeMessage(3, o11, p11.PoseLandmarksDetectorGraphOptions.serializeBinaryToWriter), null != (o11 = t11.Message.getField(e11, 4)) && r11.writeFloat(4, o11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.ext = new t11.ExtensionFieldInfo(516587230, {
        ext: 0
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[516587230] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[516587230] = proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.ext, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.getBaseOptions = function() {
        return t11.Message.getWrapperField(this, n11.BaseOptions, 1);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.setBaseOptions = function(e11) {
        return t11.Message.setWrapperField(this, 1, e11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.clearBaseOptions = function() {
        return this.setBaseOptions(void 0);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.hasBaseOptions = function() {
        return null != t11.Message.getField(this, 1);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.getPoseDetectorGraphOptions = function() {
        return t11.Message.getWrapperField(this, s11.PoseDetectorGraphOptions, 2);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.setPoseDetectorGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 2, e11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.clearPoseDetectorGraphOptions = function() {
        return this.setPoseDetectorGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.hasPoseDetectorGraphOptions = function() {
        return null != t11.Message.getField(this, 2);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.getPoseLandmarksDetectorGraphOptions = function() {
        return t11.Message.getWrapperField(this, p11.PoseLandmarksDetectorGraphOptions, 3);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.setPoseLandmarksDetectorGraphOptions = function(e11) {
        return t11.Message.setWrapperField(this, 3, e11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.clearPoseLandmarksDetectorGraphOptions = function() {
        return this.setPoseLandmarksDetectorGraphOptions(void 0);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.hasPoseLandmarksDetectorGraphOptions = function() {
        return null != t11.Message.getField(this, 3);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.getMinTrackingConfidence = function() {
        return t11.Message.getFloatingPointFieldWithDefault(this, 4, .5);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.setMinTrackingConfidence = function(e11) {
        return t11.Message.setField(this, 4, e11);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.clearMinTrackingConfidence = function() {
        return t11.Message.setField(this, 4, void 0);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.prototype.hasMinTrackingConfidence = function() {
        return null != t11.Message.getField(this, 4);
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.ext = new t11.ExtensionFieldInfo(516587230, {
        ext: 0
    }, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.toObject, 0), a11.CalculatorOptions.extensionsBinary[516587230] = new t11.ExtensionFieldBinaryInfo(proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.ext, t11.BinaryReader.prototype.readMessage, t11.BinaryWriter.prototype.writeMessage, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.serializeBinaryToWriter, proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.deserializeBinaryFromReader, !1), a11.CalculatorOptions.extensions[516587230] = proto.mediapipe.tasks.vision.pose_landmarker.proto.PoseLandmarkerGraphOptions.ext, r11.object.extend(e11, proto.mediapipe.tasks.vision.pose_landmarker.proto);
}(pose_landmarker_graph_options_pb);
var pose_landmarker_options = {};
Object.defineProperty(pose_landmarker_options, "__esModule", {
    value: !0
});
var pose_landmarker_result = {};
Object.defineProperty(pose_landmarker_result, "__esModule", {
    value: !0
}), function(e11) {
    var t11 = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11);
        var i11 = Object.getOwnPropertyDescriptor(t11, r11);
        i11 && !("get" in i11 ? !t11.__esModule : i11.writable || i11.configurable) || (i11 = {
            enumerable: !0,
            get: function() {
                return t11[r11];
            }
        }), Object.defineProperty(e11, o11, i11);
    } : function(e11, t11, r11, o11) {
        void 0 === o11 && (o11 = r11), e11[o11] = t11[r11];
    }), r11 = commonjsGlobal && commonjsGlobal.__exportStar || function(e11, r11) {
        for(var o11 in e11)"default" === o11 || Object.prototype.hasOwnProperty.call(r11, o11) || t11(r11, e11, o11);
    };
    Object.defineProperty(e11, "__esModule", {
        value: !0
    }), e11.PoseLandmarker = void 0;
    const o11 = calculator_pb, i11 = calculator_options_pb, a11 = landmark_pb, n11 = base_options_pb, s11 = pose_detector_graph_options_pb, p11 = pose_landmarker_graph_options_pb, d11 = pose_landmarks_detector_graph_options_pb, l11 = landmark_result, g11 = vision_task_runner;
    r11(pose_landmarker_options, e11), r11(pose_landmarker_result, e11);
    const c11 = "image_in", u11 = "norm_rect", m11 = "normalized_landmarks", f11 = "world_landmarks", h11 = "segmentation_masks", y11 = .5;
    class b11 extends g11.VisionTaskRunner {
        static createFromOptions(e11, t11) {
            return g11.VisionTaskRunner.createVisionInstance(b11, e11, t11);
        }
        static createFromModelBuffer(e11, t11) {
            return g11.VisionTaskRunner.createVisionInstance(b11, e11, {
                baseOptions: {
                    modelAssetBuffer: t11
                }
            });
        }
        static createFromModelPath(e11, t11) {
            return g11.VisionTaskRunner.createVisionInstance(b11, e11, {
                baseOptions: {
                    modelAssetPath: t11
                }
            });
        }
        constructor(e11, t11){
            super(new g11.VisionGraphRunner(e11, t11), c11, u11, !1), this.result = {}, this.outputSegmentationMasks = !1, this.options = new p11.PoseLandmarkerGraphOptions, this.options.setBaseOptions(new n11.BaseOptions), this.poseLandmarksDetectorGraphOptions = new d11.PoseLandmarksDetectorGraphOptions, this.options.setPoseLandmarksDetectorGraphOptions(this.poseLandmarksDetectorGraphOptions), this.poseDetectorGraphOptions = new s11.PoseDetectorGraphOptions, this.options.setPoseDetectorGraphOptions(this.poseDetectorGraphOptions), this.initDefaults();
        }
        get baseOptions() {
            return this.options.getBaseOptions();
        }
        set baseOptions(e11) {
            this.options.setBaseOptions(e11);
        }
        setOptions(e11) {
            var t11, r11, o11, i11, a11;
            return "numPoses" in e11 && this.poseDetectorGraphOptions.setNumPoses(null !== (t11 = e11.numPoses) && void 0 !== t11 ? t11 : 1), "minPoseDetectionConfidence" in e11 && this.poseDetectorGraphOptions.setMinDetectionConfidence(null !== (r11 = e11.minPoseDetectionConfidence) && void 0 !== r11 ? r11 : y11), "minTrackingConfidence" in e11 && this.options.setMinTrackingConfidence(null !== (o11 = e11.minTrackingConfidence) && void 0 !== o11 ? o11 : y11), "minPosePresenceConfidence" in e11 && this.poseLandmarksDetectorGraphOptions.setMinDetectionConfidence(null !== (i11 = e11.minPosePresenceConfidence) && void 0 !== i11 ? i11 : y11), "outputSegmentationMasks" in e11 && (this.outputSegmentationMasks = null !== (a11 = e11.outputSegmentationMasks) && void 0 !== a11 && a11), this.applyOptions(e11);
        }
        detect(e11, t11, r11) {
            const o11 = "function" != typeof t11 ? t11 : {};
            if (this.userCallback = "function" == typeof t11 ? t11 : r11, this.resetResults(), this.processImageData(e11, o11), !this.userCallback) return this.result;
        }
        detectForVideo(e11, t11, r11, o11) {
            const i11 = "function" != typeof r11 ? r11 : {};
            if (this.userCallback = "function" == typeof r11 ? r11 : o11, this.resetResults(), this.processVideoData(e11, i11, t11), !this.userCallback) return this.result;
        }
        resetResults() {
            this.result = {};
        }
        maybeInvokeCallback() {
            "landmarks" in this.result && "worldLandmarks" in this.result && (this.outputSegmentationMasks && !("segmentationMasks" in this.result) || this.userCallback && (this.userCallback(this.result), this.freeKeepaliveStreams()));
        }
        initDefaults() {
            this.poseDetectorGraphOptions.setNumPoses(1), this.poseDetectorGraphOptions.setMinDetectionConfidence(y11), this.poseLandmarksDetectorGraphOptions.setMinDetectionConfidence(y11), this.options.setMinTrackingConfidence(y11);
        }
        addJsLandmarks(e11) {
            this.result.landmarks = [];
            for (const t11 of e11){
                const e11 = a11.NormalizedLandmarkList.deserializeBinary(t11);
                this.result.landmarks.push((0, l11.convertToLandmarks)(e11));
            }
        }
        adddJsWorldLandmarks(e11) {
            this.result.worldLandmarks = [];
            for (const t11 of e11){
                const e11 = a11.LandmarkList.deserializeBinary(t11);
                this.result.worldLandmarks.push((0, l11.convertToWorldLandmarks)(e11));
            }
        }
        refreshGraph() {
            const e11 = new o11.CalculatorGraphConfig;
            e11.addInputStream(c11), e11.addInputStream(u11), e11.addOutputStream(m11), e11.addOutputStream(f11), e11.addOutputStream(h11);
            const t11 = new i11.CalculatorOptions;
            t11.setExtension(p11.PoseLandmarkerGraphOptions.ext, this.options);
            const r11 = new o11.CalculatorGraphConfig.Node;
            r11.setCalculator("mediapipe.tasks.vision.pose_landmarker.PoseLandmarkerGraph"), r11.addInputStream("IMAGE:" + c11), r11.addInputStream("NORM_RECT:" + u11), r11.addOutputStream("NORM_LANDMARKS:" + m11), r11.addOutputStream("WORLD_LANDMARKS:" + f11), r11.setOptions(t11), e11.addNode(r11), this.addKeepaliveNode(e11), this.graphRunner.attachProtoVectorListener(m11, (e11, t11)=>{
                this.addJsLandmarks(e11), this.setLatestOutputTimestamp(t11), this.maybeInvokeCallback();
            }), this.graphRunner.attachEmptyPacketListener(m11, (e11)=>{
                this.result.landmarks = [], this.setLatestOutputTimestamp(e11), this.maybeInvokeCallback();
            }), this.graphRunner.attachProtoVectorListener(f11, (e11, t11)=>{
                this.adddJsWorldLandmarks(e11), this.setLatestOutputTimestamp(t11), this.maybeInvokeCallback();
            }), this.graphRunner.attachEmptyPacketListener(f11, (e11)=>{
                this.result.worldLandmarks = [], this.setLatestOutputTimestamp(e11), this.maybeInvokeCallback();
            }), this.outputSegmentationMasks && (r11.addOutputStream("SEGMENTATION_MASK:" + h11), this.keepStreamAlive(h11), this.graphRunner.attachImageVectorListener(h11, (e11, t11)=>{
                this.result.segmentationMasks = e11.map((e11)=>this.convertToMPMask(e11, !this.userCallback)), this.setLatestOutputTimestamp(t11), this.maybeInvokeCallback();
            }), this.graphRunner.attachEmptyPacketListener(h11, (e11)=>{
                this.result.segmentationMasks = [], this.setLatestOutputTimestamp(e11), this.maybeInvokeCallback();
            }));
            const a11 = e11.serializeBinary();
            this.setGraph(new Uint8Array(a11), !0);
        }
    }
    e11.PoseLandmarker = b11, b11.POSE_CONNECTIONS = [
        {
            start: 0,
            end: 1
        },
        {
            start: 1,
            end: 2
        },
        {
            start: 2,
            end: 3
        },
        {
            start: 3,
            end: 7
        },
        {
            start: 0,
            end: 4
        },
        {
            start: 4,
            end: 5
        },
        {
            start: 5,
            end: 6
        },
        {
            start: 6,
            end: 8
        },
        {
            start: 9,
            end: 10
        },
        {
            start: 11,
            end: 12
        },
        {
            start: 11,
            end: 13
        },
        {
            start: 13,
            end: 15
        },
        {
            start: 15,
            end: 17
        },
        {
            start: 15,
            end: 19
        },
        {
            start: 15,
            end: 21
        },
        {
            start: 17,
            end: 19
        },
        {
            start: 12,
            end: 14
        },
        {
            start: 14,
            end: 16
        },
        {
            start: 16,
            end: 18
        },
        {
            start: 16,
            end: 20
        },
        {
            start: 16,
            end: 22
        },
        {
            start: 18,
            end: 20
        },
        {
            start: 11,
            end: 23
        },
        {
            start: 12,
            end: 24
        },
        {
            start: 23,
            end: 24
        },
        {
            start: 23,
            end: 25
        },
        {
            start: 24,
            end: 26
        },
        {
            start: 25,
            end: 27
        },
        {
            start: 26,
            end: 28
        },
        {
            start: 27,
            end: 29
        },
        {
            start: 28,
            end: 30
        },
        {
            start: 29,
            end: 31
        },
        {
            start: 30,
            end: 32
        },
        {
            start: 27,
            end: 31
        },
        {
            start: 28,
            end: 32
        }
    ];
}(pose_landmarker), Object.defineProperty(vision, "__esModule", {
    value: !0
});
var PoseLandmarker_1 = vision.PoseLandmarker = ObjectDetector_1 = vision.ObjectDetector = InteractiveSegmenter_1 = vision.InteractiveSegmenter = ImageSegmenter_1 = vision.ImageSegmenter = ImageEmbedder_1 = vision.ImageEmbedder = ImageClassifier_1 = vision.ImageClassifier = HandLandmarker_1 = vision.HandLandmarker = GestureRecognizer_1 = vision.GestureRecognizer = FaceStylizer_1 = vision.FaceStylizer = FaceLandmarker_1 = vision.FaceLandmarker = FaceDetector_1 = vision.FaceDetector = MPMask_1 = vision.MPMask = MPImage_1 = vision.MPImage = FilesetResolver_1 = vision.FilesetResolver = DrawingUtils_1 = vision.DrawingUtils = void 0;
const fileset_resolver_1 = fileset_resolver, drawing_utils_1 = drawing_utils, image_1 = image, mask_1 = mask, face_detector_1 = face_detector, face_landmarker_1 = face_landmarker, face_stylizer_1 = face_stylizer, gesture_recognizer_1 = gesture_recognizer, hand_landmarker_1 = hand_landmarker, image_classifier_1 = image_classifier, image_embedder_1 = image_embedder, image_segmenter_1 = image_segmenter, interactive_segmenter_1 = interactive_segmenter, object_detector_1 = object_detector, pose_landmarker_1 = pose_landmarker, DrawingUtils = drawing_utils_1.DrawingUtils;
var DrawingUtils_1 = vision.DrawingUtils = DrawingUtils;
const FilesetResolver = fileset_resolver_1.FilesetResolver;
var FilesetResolver_1 = vision.FilesetResolver = FilesetResolver;
const MPImage = image_1.MPImage;
var MPImage_1 = vision.MPImage = MPImage;
const MPMask = mask_1.MPMask;
var MPMask_1 = vision.MPMask = MPMask;
const FaceDetector = face_detector_1.FaceDetector;
var FaceDetector_1 = vision.FaceDetector = FaceDetector;
const FaceLandmarker = face_landmarker_1.FaceLandmarker;
var FaceLandmarker_1 = vision.FaceLandmarker = FaceLandmarker;
const FaceStylizer = face_stylizer_1.FaceStylizer;
var FaceStylizer_1 = vision.FaceStylizer = FaceStylizer;
const GestureRecognizer = gesture_recognizer_1.GestureRecognizer;
var GestureRecognizer_1 = vision.GestureRecognizer = GestureRecognizer;
const HandLandmarker = hand_landmarker_1.HandLandmarker;
var HandLandmarker_1 = vision.HandLandmarker = HandLandmarker;
const ImageClassifier = image_classifier_1.ImageClassifier;
var ImageClassifier_1 = vision.ImageClassifier = ImageClassifier;
const ImageEmbedder = image_embedder_1.ImageEmbedder;
var ImageEmbedder_1 = vision.ImageEmbedder = ImageEmbedder;
const ImageSegmenter = image_segmenter_1.ImageSegmenter;
var ImageSegmenter_1 = vision.ImageSegmenter = ImageSegmenter;
const InteractiveSegmenter = interactive_segmenter_1.InteractiveSegmenter;
var InteractiveSegmenter_1 = vision.InteractiveSegmenter = InteractiveSegmenter;
const ObjectDetector = object_detector_1.ObjectDetector;
var ObjectDetector_1 = vision.ObjectDetector = ObjectDetector;
const PoseLandmarker = pose_landmarker_1.PoseLandmarker;
PoseLandmarker_1 = vision.PoseLandmarker = PoseLandmarker;

});

// Author: Çağrı Erdem, 2023
// Description: Main bundler script for 2groove web app.
// Importing packages
var $28735cb37928c976$exports = {};
"use strict";
var $28735cb37928c976$var$__awaiter = $28735cb37928c976$exports && $28735cb37928c976$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $28735cb37928c976$var$__generator = $28735cb37928c976$exports && $28735cb37928c976$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($28735cb37928c976$exports, "__esModule", {
    value: true
});
$28735cb37928c976$exports.Header = $28735cb37928c976$exports.Track = $28735cb37928c976$exports.Midi = void 0;
var $f4610896fa898662$export$2b5b68a498cfe902;
var $f4610896fa898662$export$77fcca795c2a5d6c;

$f4610896fa898662$export$2b5b68a498cfe902 = (parcelRequire("iBsb3"));

$f4610896fa898662$export$77fcca795c2a5d6c = (parcelRequire("ezd6o"));


var $ae5327bd0dc5627f$exports = {};
"use strict";
Object.defineProperty($ae5327bd0dc5627f$exports, "__esModule", {
    value: true
});
$ae5327bd0dc5627f$exports.Header = $ae5327bd0dc5627f$exports.keySignatureKeys = void 0;
var $43b0fba3852e64e0$exports = {};
"use strict";
Object.defineProperty($43b0fba3852e64e0$exports, "__esModule", {
    value: true
});
$43b0fba3852e64e0$exports.insert = $43b0fba3852e64e0$exports.search = void 0;
/**
 * Return the index of the element at or before the given property
 * @hidden
 */ function $43b0fba3852e64e0$var$search(array, value, prop) {
    if (prop === void 0) prop = "ticks";
    var beginning = 0;
    var len = array.length;
    var end = len;
    if (len > 0 && array[len - 1][prop] <= value) return len - 1;
    while(beginning < end){
        // calculate the midpoint for roughly equal partition
        var midPoint = Math.floor(beginning + (end - beginning) / 2);
        var event_1 = array[midPoint];
        var nextEvent = array[midPoint + 1];
        if (event_1[prop] === value) {
            // choose the last one that has the same value
            for(var i = midPoint; i < array.length; i++){
                var testEvent = array[i];
                if (testEvent[prop] === value) midPoint = i;
            }
            return midPoint;
        } else if (event_1[prop] < value && nextEvent[prop] > value) return midPoint;
        else if (event_1[prop] > value) // search lower
        end = midPoint;
        else if (event_1[prop] < value) // search upper
        beginning = midPoint + 1;
    }
    return -1;
}
$43b0fba3852e64e0$exports.search = $43b0fba3852e64e0$var$search;
/**
 * Does a binary search to insert the note
 * in the correct spot in the array
 * @hidden
 */ function $43b0fba3852e64e0$var$insert(array, event, prop) {
    if (prop === void 0) prop = "ticks";
    if (array.length) {
        var index = $43b0fba3852e64e0$var$search(array, event[prop], prop);
        array.splice(index + 1, 0, event);
    } else array.push(event);
}
$43b0fba3852e64e0$exports.insert = $43b0fba3852e64e0$var$insert;


var $ae5327bd0dc5627f$var$privatePPQMap = new WeakMap();
/**
 * @hidden
 */ $ae5327bd0dc5627f$exports.keySignatureKeys = [
    "Cb",
    "Gb",
    "Db",
    "Ab",
    "Eb",
    "Bb",
    "F",
    "C",
    "G",
    "D",
    "A",
    "E",
    "B",
    "F#",
    "C#"
];
/**
 * The parsed MIDI file header.
 */ var $ae5327bd0dc5627f$var$Header = /** @class */ function() {
    function Header(midiData) {
        var _this = this;
        /**
         * The array of all the tempo events.
         */ this.tempos = [];
        /**
         * The time signatures.
         */ this.timeSignatures = [];
        /**
         * The time signatures.
         */ this.keySignatures = [];
        /**
         * Additional meta events.
         */ this.meta = [];
        /**
         * The name of the MIDI file;
         */ this.name = "";
        // Look through all the tracks for tempo changes.
        $ae5327bd0dc5627f$var$privatePPQMap.set(this, 480);
        if (midiData) {
            $ae5327bd0dc5627f$var$privatePPQMap.set(this, midiData.header.ticksPerBeat);
            // Check time signature and tempo events from all of the tracks.
            midiData.tracks.forEach(function(track) {
                track.forEach(function(event) {
                    if (event.meta) {
                        if (event.type === "timeSignature") _this.timeSignatures.push({
                            ticks: event.absoluteTime,
                            timeSignature: [
                                event.numerator,
                                event.denominator
                            ]
                        });
                        else if (event.type === "setTempo") _this.tempos.push({
                            bpm: 60000000 / event.microsecondsPerBeat,
                            ticks: event.absoluteTime
                        });
                        else if (event.type === "keySignature") _this.keySignatures.push({
                            key: $ae5327bd0dc5627f$exports.keySignatureKeys[event.key + 7],
                            scale: event.scale === 0 ? "major" : "minor",
                            ticks: event.absoluteTime
                        });
                    }
                });
            });
            // Check the first track for other relevant data.
            var firstTrackCurrentTicks_1 = 0; // Used for absolute times.
            midiData.tracks[0].forEach(function(event) {
                firstTrackCurrentTicks_1 += event.deltaTime;
                if (event.meta) {
                    if (event.type === "trackName") _this.name = event.text;
                    else if (event.type === "text" || event.type === "cuePoint" || event.type === "marker" || event.type === "lyrics") _this.meta.push({
                        text: event.text,
                        ticks: firstTrackCurrentTicks_1,
                        type: event.type
                    });
                }
            });
            this.update();
        }
    }
    /**
     * This must be invoked after any changes are made to the tempo array
     * or the timeSignature array for the updated values to be reflected.
     */ Header.prototype.update = function() {
        var _this = this;
        var currentTime = 0;
        var lastEventBeats = 0;
        // Make sure it's sorted;
        this.tempos.sort(function(a, b) {
            return a.ticks - b.ticks;
        });
        this.tempos.forEach(function(event, index) {
            var lastBPM = index > 0 ? _this.tempos[index - 1].bpm : _this.tempos[0].bpm;
            var beats = event.ticks / _this.ppq - lastEventBeats;
            var elapsedSeconds = 60 / lastBPM * beats;
            event.time = elapsedSeconds + currentTime;
            currentTime = event.time;
            lastEventBeats += beats;
        });
        this.timeSignatures.sort(function(a, b) {
            return a.ticks - b.ticks;
        });
        this.timeSignatures.forEach(function(event, index) {
            var lastEvent = index > 0 ? _this.timeSignatures[index - 1] : _this.timeSignatures[0];
            var elapsedBeats = (event.ticks - lastEvent.ticks) / _this.ppq;
            var elapsedMeasures = elapsedBeats / lastEvent.timeSignature[0] / (lastEvent.timeSignature[1] / 4);
            lastEvent.measures = lastEvent.measures || 0;
            event.measures = elapsedMeasures + lastEvent.measures;
        });
    };
    /**
     * Convert ticks into seconds based on the tempo changes.
     */ Header.prototype.ticksToSeconds = function(ticks) {
        // Find the relevant position.
        var index = (0, $43b0fba3852e64e0$exports.search)(this.tempos, ticks);
        if (index !== -1) {
            var tempo = this.tempos[index];
            var tempoTime = tempo.time;
            var elapsedBeats = (ticks - tempo.ticks) / this.ppq;
            return tempoTime + 60 / tempo.bpm * elapsedBeats;
        } else {
            // Assume 120.
            var beats = ticks / this.ppq;
            return 0.5 * beats;
        }
    };
    /**
     * Convert ticks into measures based off of the time signatures.
     */ Header.prototype.ticksToMeasures = function(ticks) {
        var index = (0, $43b0fba3852e64e0$exports.search)(this.timeSignatures, ticks);
        if (index !== -1) {
            var timeSigEvent = this.timeSignatures[index];
            var elapsedBeats = (ticks - timeSigEvent.ticks) / this.ppq;
            return timeSigEvent.measures + elapsedBeats / (timeSigEvent.timeSignature[0] / timeSigEvent.timeSignature[1]) / 4;
        } else return ticks / this.ppq / 4;
    };
    Object.defineProperty(Header.prototype, "ppq", {
        /**
         * The number of ticks per quarter note.
         */ get: function() {
            return $ae5327bd0dc5627f$var$privatePPQMap.get(this);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Convert seconds to ticks based on the tempo events.
     */ Header.prototype.secondsToTicks = function(seconds) {
        // Find the relevant position.
        var index = (0, $43b0fba3852e64e0$exports.search)(this.tempos, seconds, "time");
        if (index !== -1) {
            var tempo = this.tempos[index];
            var tempoTime = tempo.time;
            var elapsedTime = seconds - tempoTime;
            var elapsedBeats = elapsedTime / (60 / tempo.bpm);
            return Math.round(tempo.ticks + elapsedBeats * this.ppq);
        } else {
            // Assume 120.
            var beats = seconds / 0.5;
            return Math.round(beats * this.ppq);
        }
    };
    /**
     * Convert the header into an object.
     */ Header.prototype.toJSON = function() {
        return {
            keySignatures: this.keySignatures,
            meta: this.meta,
            name: this.name,
            ppq: this.ppq,
            tempos: this.tempos.map(function(t) {
                return {
                    bpm: t.bpm,
                    ticks: t.ticks
                };
            }),
            timeSignatures: this.timeSignatures
        };
    };
    /**
     * Parse a header json object.
     */ Header.prototype.fromJSON = function(json) {
        this.name = json.name;
        // Clone all the attributes.
        this.tempos = json.tempos.map(function(t) {
            return Object.assign({}, t);
        });
        this.timeSignatures = json.timeSignatures.map(function(t) {
            return Object.assign({}, t);
        });
        this.keySignatures = json.keySignatures.map(function(t) {
            return Object.assign({}, t);
        });
        this.meta = json.meta.map(function(t) {
            return Object.assign({}, t);
        });
        $ae5327bd0dc5627f$var$privatePPQMap.set(this, json.ppq);
        this.update();
    };
    /**
     * Update the tempo of the midi to a single tempo. Will remove and replace
     * any other tempos currently set and update all of the event timing.
     * @param bpm The tempo in beats per second.
     */ Header.prototype.setTempo = function(bpm) {
        this.tempos = [
            {
                bpm: bpm,
                ticks: 0
            }
        ];
        this.update();
    };
    return Header;
}();
$ae5327bd0dc5627f$exports.Header = $ae5327bd0dc5627f$var$Header;


var $40651e7dcdad1bee$exports = {};
"use strict";
Object.defineProperty($40651e7dcdad1bee$exports, "__esModule", {
    value: true
});
$40651e7dcdad1bee$exports.Track = void 0;

var $5c2a91a28bf6dfbb$exports = {};
"use strict";
Object.defineProperty($5c2a91a28bf6dfbb$exports, "__esModule", {
    value: true
});
$5c2a91a28bf6dfbb$exports.ControlChange = $5c2a91a28bf6dfbb$exports.controlChangeIds = $5c2a91a28bf6dfbb$exports.controlChangeNames = void 0;
/**
 * A map of values to control change names
 * @hidden
 */ $5c2a91a28bf6dfbb$exports.controlChangeNames = {
    1: "modulationWheel",
    2: "breath",
    4: "footController",
    5: "portamentoTime",
    7: "volume",
    8: "balance",
    10: "pan",
    64: "sustain",
    65: "portamentoTime",
    66: "sostenuto",
    67: "softPedal",
    68: "legatoFootswitch",
    84: "portamentoControl"
};
/**
 * swap the keys and values
 * @hidden
 */ $5c2a91a28bf6dfbb$exports.controlChangeIds = Object.keys($5c2a91a28bf6dfbb$exports.controlChangeNames).reduce(function(obj, key) {
    obj[$5c2a91a28bf6dfbb$exports.controlChangeNames[key]] = key;
    return obj;
}, {});
var $5c2a91a28bf6dfbb$var$privateHeaderMap = new WeakMap();
var $5c2a91a28bf6dfbb$var$privateCCNumberMap = new WeakMap();
/**
 * Represents a control change event
 */ var $5c2a91a28bf6dfbb$var$ControlChange = /** @class */ function() {
    /**
     * @param event
     * @param header
     */ function ControlChange(event, header) {
        $5c2a91a28bf6dfbb$var$privateHeaderMap.set(this, header);
        $5c2a91a28bf6dfbb$var$privateCCNumberMap.set(this, event.controllerType);
        this.ticks = event.absoluteTime;
        this.value = event.value;
    }
    Object.defineProperty(ControlChange.prototype, "number", {
        /**
         * The controller number
         */ get: function() {
            return $5c2a91a28bf6dfbb$var$privateCCNumberMap.get(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlChange.prototype, "name", {
        /**
         * return the common name of the control number if it exists
         */ get: function() {
            if ($5c2a91a28bf6dfbb$exports.controlChangeNames[this.number]) return $5c2a91a28bf6dfbb$exports.controlChangeNames[this.number];
            else return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ControlChange.prototype, "time", {
        /**
         * The time of the event in seconds
         */ get: function() {
            var header = $5c2a91a28bf6dfbb$var$privateHeaderMap.get(this);
            return header.ticksToSeconds(this.ticks);
        },
        set: function(t) {
            var header = $5c2a91a28bf6dfbb$var$privateHeaderMap.get(this);
            this.ticks = header.secondsToTicks(t);
        },
        enumerable: false,
        configurable: true
    });
    ControlChange.prototype.toJSON = function() {
        return {
            number: this.number,
            ticks: this.ticks,
            time: this.time,
            value: this.value
        };
    };
    return ControlChange;
}();
$5c2a91a28bf6dfbb$exports.ControlChange = $5c2a91a28bf6dfbb$var$ControlChange;


var $0da2b741b9a6b187$exports = {};
"use strict";
Object.defineProperty($0da2b741b9a6b187$exports, "__esModule", {
    value: true
});
$0da2b741b9a6b187$exports.createControlChanges = void 0;

/**
 * Automatically creates an alias for named control values using Proxies
 * @hidden
 */ function $0da2b741b9a6b187$var$createControlChanges() {
    return new Proxy({}, {
        // tslint:disable-next-line: typedef
        get: function(target, handler) {
            if (target[handler]) return target[handler];
            else if ($5c2a91a28bf6dfbb$exports.controlChangeIds.hasOwnProperty(handler)) return target[$5c2a91a28bf6dfbb$exports.controlChangeIds[handler]];
        },
        // tslint:disable-next-line: typedef
        set: function(target, handler, value) {
            if ($5c2a91a28bf6dfbb$exports.controlChangeIds.hasOwnProperty(handler)) target[$5c2a91a28bf6dfbb$exports.controlChangeIds[handler]] = value;
            else target[handler] = value;
            return true;
        }
    });
}
$0da2b741b9a6b187$exports.createControlChanges = $0da2b741b9a6b187$var$createControlChanges;


var $14f891a148a8e503$exports = {};
"use strict";
Object.defineProperty($14f891a148a8e503$exports, "__esModule", {
    value: true
});
$14f891a148a8e503$exports.PitchBend = void 0;
var $14f891a148a8e503$var$privateHeaderMap = new WeakMap();
/**
 * Represents a pitch bend event.
 */ var $14f891a148a8e503$var$PitchBend = /** @class */ function() {
    /**
     * @param event
     * @param header
     */ function PitchBend(event, header) {
        $14f891a148a8e503$var$privateHeaderMap.set(this, header);
        this.ticks = event.absoluteTime;
        this.value = event.value;
    }
    Object.defineProperty(PitchBend.prototype, "time", {
        /**
         * The time of the event in seconds
         */ get: function() {
            var header = $14f891a148a8e503$var$privateHeaderMap.get(this);
            return header.ticksToSeconds(this.ticks);
        },
        set: function(t) {
            var header = $14f891a148a8e503$var$privateHeaderMap.get(this);
            this.ticks = header.secondsToTicks(t);
        },
        enumerable: false,
        configurable: true
    });
    PitchBend.prototype.toJSON = function() {
        return {
            ticks: this.ticks,
            time: this.time,
            value: this.value
        };
    };
    return PitchBend;
}();
$14f891a148a8e503$exports.PitchBend = $14f891a148a8e503$var$PitchBend;


var $30a9506e114bbf2a$exports = {};
"use strict";
Object.defineProperty($30a9506e114bbf2a$exports, "__esModule", {
    value: true
});
$30a9506e114bbf2a$exports.Instrument = void 0;
var $c35949daea318c57$exports = {};
"use strict";
Object.defineProperty($c35949daea318c57$exports, "__esModule", {
    value: true
});
$c35949daea318c57$exports.DrumKitByPatchID = $c35949daea318c57$exports.InstrumentFamilyByID = $c35949daea318c57$exports.instrumentByPatchID = void 0;
$c35949daea318c57$exports.instrumentByPatchID = [
    "acoustic grand piano",
    "bright acoustic piano",
    "electric grand piano",
    "honky-tonk piano",
    "electric piano 1",
    "electric piano 2",
    "harpsichord",
    "clavi",
    "celesta",
    "glockenspiel",
    "music box",
    "vibraphone",
    "marimba",
    "xylophone",
    "tubular bells",
    "dulcimer",
    "drawbar organ",
    "percussive organ",
    "rock organ",
    "church organ",
    "reed organ",
    "accordion",
    "harmonica",
    "tango accordion",
    "acoustic guitar (nylon)",
    "acoustic guitar (steel)",
    "electric guitar (jazz)",
    "electric guitar (clean)",
    "electric guitar (muted)",
    "overdriven guitar",
    "distortion guitar",
    "guitar harmonics",
    "acoustic bass",
    "electric bass (finger)",
    "electric bass (pick)",
    "fretless bass",
    "slap bass 1",
    "slap bass 2",
    "synth bass 1",
    "synth bass 2",
    "violin",
    "viola",
    "cello",
    "contrabass",
    "tremolo strings",
    "pizzicato strings",
    "orchestral harp",
    "timpani",
    "string ensemble 1",
    "string ensemble 2",
    "synthstrings 1",
    "synthstrings 2",
    "choir aahs",
    "voice oohs",
    "synth voice",
    "orchestra hit",
    "trumpet",
    "trombone",
    "tuba",
    "muted trumpet",
    "french horn",
    "brass section",
    "synthbrass 1",
    "synthbrass 2",
    "soprano sax",
    "alto sax",
    "tenor sax",
    "baritone sax",
    "oboe",
    "english horn",
    "bassoon",
    "clarinet",
    "piccolo",
    "flute",
    "recorder",
    "pan flute",
    "blown bottle",
    "shakuhachi",
    "whistle",
    "ocarina",
    "lead 1 (square)",
    "lead 2 (sawtooth)",
    "lead 3 (calliope)",
    "lead 4 (chiff)",
    "lead 5 (charang)",
    "lead 6 (voice)",
    "lead 7 (fifths)",
    "lead 8 (bass + lead)",
    "pad 1 (new age)",
    "pad 2 (warm)",
    "pad 3 (polysynth)",
    "pad 4 (choir)",
    "pad 5 (bowed)",
    "pad 6 (metallic)",
    "pad 7 (halo)",
    "pad 8 (sweep)",
    "fx 1 (rain)",
    "fx 2 (soundtrack)",
    "fx 3 (crystal)",
    "fx 4 (atmosphere)",
    "fx 5 (brightness)",
    "fx 6 (goblins)",
    "fx 7 (echoes)",
    "fx 8 (sci-fi)",
    "sitar",
    "banjo",
    "shamisen",
    "koto",
    "kalimba",
    "bag pipe",
    "fiddle",
    "shanai",
    "tinkle bell",
    "agogo",
    "steel drums",
    "woodblock",
    "taiko drum",
    "melodic tom",
    "synth drum",
    "reverse cymbal",
    "guitar fret noise",
    "breath noise",
    "seashore",
    "bird tweet",
    "telephone ring",
    "helicopter",
    "applause",
    "gunshot"
];
$c35949daea318c57$exports.InstrumentFamilyByID = [
    "piano",
    "chromatic percussion",
    "organ",
    "guitar",
    "bass",
    "strings",
    "ensemble",
    "brass",
    "reed",
    "pipe",
    "synth lead",
    "synth pad",
    "synth effects",
    "world",
    "percussive",
    "sound effects"
];
$c35949daea318c57$exports.DrumKitByPatchID = {
    0: "standard kit",
    8: "room kit",
    16: "power kit",
    24: "electronic kit",
    25: "tr-808 kit",
    32: "jazz kit",
    40: "brush kit",
    48: "orchestra kit",
    56: "sound fx kit"
};


/**
 * @hidden
 */ var $30a9506e114bbf2a$var$privateTrackMap = new WeakMap();
/**
 * Describes the MIDI instrument of a track.
 */ var $30a9506e114bbf2a$var$Instrument = /** @class */ function() {
    /**
     * @param trackData
     * @param track
     */ function Instrument(trackData, track) {
        /**
         * The instrument number. Defaults to 0.
         */ this.number = 0;
        $30a9506e114bbf2a$var$privateTrackMap.set(this, track);
        this.number = 0;
        if (trackData) {
            var programChange = trackData.find(function(e) {
                return e.type === "programChange";
            });
            // Set 'number' from 'programNumber' if exists.
            if (programChange) this.number = programChange.programNumber;
        }
    }
    Object.defineProperty(Instrument.prototype, "name", {
        /**
         * The common name of the instrument.
         */ get: function() {
            if (this.percussion) return $c35949daea318c57$exports.DrumKitByPatchID[this.number];
            else return $c35949daea318c57$exports.instrumentByPatchID[this.number];
        },
        set: function(n) {
            var patchNumber = $c35949daea318c57$exports.instrumentByPatchID.indexOf(n);
            if (patchNumber !== -1) this.number = patchNumber;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Instrument.prototype, "family", {
        /**
         * The instrument family, e.g. "piano".
         */ get: function() {
            if (this.percussion) return "drums";
            else return $c35949daea318c57$exports.InstrumentFamilyByID[Math.floor(this.number / 8)];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Instrument.prototype, "percussion", {
        /**
         * If the instrument is a percussion instrument.
         */ get: function() {
            var track = $30a9506e114bbf2a$var$privateTrackMap.get(this);
            return track.channel === 9;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Convert it to JSON form.
     */ Instrument.prototype.toJSON = function() {
        return {
            family: this.family,
            number: this.number,
            name: this.name
        };
    };
    /**
     * Convert from JSON form.
     */ Instrument.prototype.fromJSON = function(json) {
        this.number = json.number;
    };
    return Instrument;
}();
$30a9506e114bbf2a$exports.Instrument = $30a9506e114bbf2a$var$Instrument;


var $27d9bef3f137e052$exports = {};
"use strict";
Object.defineProperty($27d9bef3f137e052$exports, "__esModule", {
    value: true
});
$27d9bef3f137e052$exports.Note = void 0;
/**
 * Convert a MIDI note into a pitch.
 */ function $27d9bef3f137e052$var$midiToPitch(midi) {
    var octave = Math.floor(midi / 12) - 1;
    return $27d9bef3f137e052$var$midiToPitchClass(midi) + octave.toString();
}
/**
 * Convert a MIDI note to a pitch class (just the pitch no octave).
 */ function $27d9bef3f137e052$var$midiToPitchClass(midi) {
    var scaleIndexToNote = [
        "C",
        "C#",
        "D",
        "D#",
        "E",
        "F",
        "F#",
        "G",
        "G#",
        "A",
        "A#",
        "B"
    ];
    var note = midi % 12;
    return scaleIndexToNote[note];
}
/**
 * Convert a pitch class to a MIDI note.
 */ function $27d9bef3f137e052$var$pitchClassToMidi(pitch) {
    var scaleIndexToNote = [
        "C",
        "C#",
        "D",
        "D#",
        "E",
        "F",
        "F#",
        "G",
        "G#",
        "A",
        "A#",
        "B"
    ];
    return scaleIndexToNote.indexOf(pitch);
}
/**
 * Convert a pitch to a MIDI number.
 */ // tslint:disable-next-line: only-arrow-functions typedef
var $27d9bef3f137e052$var$pitchToMidi = function() {
    var regexp = /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i;
    var noteToScaleIndex = {
        // tslint:disable-next-line: object-literal-sort-keys
        cbb: -2,
        cb: -1,
        c: 0,
        "c#": 1,
        cx: 2,
        dbb: 0,
        db: 1,
        d: 2,
        "d#": 3,
        dx: 4,
        ebb: 2,
        eb: 3,
        e: 4,
        "e#": 5,
        ex: 6,
        fbb: 3,
        fb: 4,
        f: 5,
        "f#": 6,
        fx: 7,
        gbb: 5,
        gb: 6,
        g: 7,
        "g#": 8,
        gx: 9,
        abb: 7,
        ab: 8,
        a: 9,
        "a#": 10,
        ax: 11,
        bbb: 9,
        bb: 10,
        b: 11,
        "b#": 12,
        bx: 13
    };
    return function(note) {
        var split = regexp.exec(note);
        var pitch = split[1];
        var octave = split[2];
        var index = noteToScaleIndex[pitch.toLowerCase()];
        return index + (parseInt(octave, 10) + 1) * 12;
    };
}();
var $27d9bef3f137e052$var$privateHeaderMap = new WeakMap();
/**
 * A Note consists of a `noteOn` and `noteOff` event.
 */ var $27d9bef3f137e052$var$Note = /** @class */ function() {
    function Note(noteOn, noteOff, header) {
        $27d9bef3f137e052$var$privateHeaderMap.set(this, header);
        this.midi = noteOn.midi;
        this.velocity = noteOn.velocity;
        this.noteOffVelocity = noteOff.velocity;
        this.ticks = noteOn.ticks;
        this.durationTicks = noteOff.ticks - noteOn.ticks;
    }
    Object.defineProperty(Note.prototype, "name", {
        /**
         * The note name and octave in scientific pitch notation, e.g. "C4".
         */ get: function() {
            return $27d9bef3f137e052$var$midiToPitch(this.midi);
        },
        set: function(n) {
            this.midi = $27d9bef3f137e052$var$pitchToMidi(n);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "octave", {
        /**
         * The notes octave number.
         */ get: function() {
            return Math.floor(this.midi / 12) - 1;
        },
        set: function(o) {
            var diff = o - this.octave;
            this.midi += diff * 12;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "pitch", {
        /**
         * The pitch class name. e.g. "A".
         */ get: function() {
            return $27d9bef3f137e052$var$midiToPitchClass(this.midi);
        },
        set: function(p) {
            this.midi = 12 * (this.octave + 1) + $27d9bef3f137e052$var$pitchClassToMidi(p);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "duration", {
        /**
         * The duration of the segment in seconds.
         */ get: function() {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            return header.ticksToSeconds(this.ticks + this.durationTicks) - header.ticksToSeconds(this.ticks);
        },
        set: function(d) {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            var noteEndTicks = header.secondsToTicks(this.time + d);
            this.durationTicks = noteEndTicks - this.ticks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "time", {
        /**
         * The time of the event in seconds.
         */ get: function() {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            return header.ticksToSeconds(this.ticks);
        },
        set: function(t) {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            this.ticks = header.secondsToTicks(t);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Note.prototype, "bars", {
        /**
         * The number of measures (and partial measures) to this beat.
         * Takes into account time signature changes.
         * @readonly
         */ get: function() {
            var header = $27d9bef3f137e052$var$privateHeaderMap.get(this);
            return header.ticksToMeasures(this.ticks);
        },
        enumerable: false,
        configurable: true
    });
    Note.prototype.toJSON = function() {
        return {
            duration: this.duration,
            durationTicks: this.durationTicks,
            midi: this.midi,
            name: this.name,
            ticks: this.ticks,
            time: this.time,
            velocity: this.velocity
        };
    };
    return Note;
}();
$27d9bef3f137e052$exports.Note = $27d9bef3f137e052$var$Note;


var $40651e7dcdad1bee$var$privateHeaderMap = new WeakMap();
/**
 * A Track is a collection of 'notes' and 'controlChanges'.
 */ var $40651e7dcdad1bee$var$Track = /** @class */ function() {
    function Track(trackData, header) {
        var _this = this;
        /**
         * The name of the track.
         */ this.name = "";
        /**
         * The track's note events.
         */ this.notes = [];
        /**
         * The control change events.
         */ this.controlChanges = (0, $0da2b741b9a6b187$exports.createControlChanges)();
        /**
         * The pitch bend events.
         */ this.pitchBends = [];
        $40651e7dcdad1bee$var$privateHeaderMap.set(this, header);
        if (trackData) {
            // Get the name of the track.
            var nameEvent = trackData.find(function(e) {
                return e.type === "trackName";
            });
            // Set empty name if 'trackName' event isn't found.
            this.name = nameEvent ? nameEvent.text : "";
        }
        this.instrument = new $30a9506e114bbf2a$exports.Instrument(trackData, this);
        // Defaults to 0.
        this.channel = 0;
        if (trackData) {
            var noteOns = trackData.filter(function(event) {
                return event.type === "noteOn";
            });
            var noteOffs = trackData.filter(function(event) {
                return event.type === "noteOff";
            });
            var _loop_1 = function() {
                var currentNote = noteOns.shift();
                // Set the channel based on the note.
                this_1.channel = currentNote.channel;
                // Find the corresponding note off.
                var offIndex = noteOffs.findIndex(function(note) {
                    return note.noteNumber === currentNote.noteNumber && note.absoluteTime >= currentNote.absoluteTime;
                });
                if (offIndex !== -1) {
                    // Once it's got the note off, add it.
                    var noteOff = noteOffs.splice(offIndex, 1)[0];
                    this_1.addNote({
                        durationTicks: noteOff.absoluteTime - currentNote.absoluteTime,
                        midi: currentNote.noteNumber,
                        noteOffVelocity: noteOff.velocity / 127,
                        ticks: currentNote.absoluteTime,
                        velocity: currentNote.velocity / 127
                    });
                }
            };
            var this_1 = this;
            while(noteOns.length)_loop_1();
            var controlChanges = trackData.filter(function(event) {
                return event.type === "controller";
            });
            controlChanges.forEach(function(event) {
                _this.addCC({
                    number: event.controllerType,
                    ticks: event.absoluteTime,
                    value: event.value / 127
                });
            });
            var pitchBends = trackData.filter(function(event) {
                return event.type === "pitchBend";
            });
            pitchBends.forEach(function(event) {
                _this.addPitchBend({
                    ticks: event.absoluteTime,
                    // Scale the value between -2^13 to 2^13 to -2 to 2.
                    value: event.value / Math.pow(2, 13)
                });
            });
            var endOfTrackEvent = trackData.find(function(event) {
                return event.type === "endOfTrack";
            });
            this.endOfTrackTicks = endOfTrackEvent !== undefined ? endOfTrackEvent.absoluteTime : undefined;
        }
    }
    /**
     * Add a note to the notes array.
     * @param props The note properties to add.
     */ Track.prototype.addNote = function(props) {
        var header = $40651e7dcdad1bee$var$privateHeaderMap.get(this);
        var note = new $27d9bef3f137e052$exports.Note({
            midi: 0,
            ticks: 0,
            velocity: 1
        }, {
            ticks: 0,
            velocity: 0
        }, header);
        Object.assign(note, props);
        (0, $43b0fba3852e64e0$exports.insert)(this.notes, note, "ticks");
        return this;
    };
    /**
     * Add a control change to the track.
     * @param props
     */ Track.prototype.addCC = function(props) {
        var header = $40651e7dcdad1bee$var$privateHeaderMap.get(this);
        var cc = new $5c2a91a28bf6dfbb$exports.ControlChange({
            controllerType: props.number
        }, header);
        delete props.number;
        Object.assign(cc, props);
        if (!Array.isArray(this.controlChanges[cc.number])) this.controlChanges[cc.number] = [];
        (0, $43b0fba3852e64e0$exports.insert)(this.controlChanges[cc.number], cc, "ticks");
        return this;
    };
    /**
     * Add a control change to the track.
     */ Track.prototype.addPitchBend = function(props) {
        var header = $40651e7dcdad1bee$var$privateHeaderMap.get(this);
        var pb = new $14f891a148a8e503$exports.PitchBend({}, header);
        Object.assign(pb, props);
        (0, $43b0fba3852e64e0$exports.insert)(this.pitchBends, pb, "ticks");
        return this;
    };
    Object.defineProperty(Track.prototype, "duration", {
        /**
         * The end time of the last event in the track.
         */ get: function() {
            if (!this.notes.length) return 0;
            var maxDuration = this.notes[this.notes.length - 1].time + this.notes[this.notes.length - 1].duration;
            for(var i = 0; i < this.notes.length - 1; i++){
                var duration = this.notes[i].time + this.notes[i].duration;
                if (maxDuration < duration) maxDuration = duration;
            }
            return maxDuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Track.prototype, "durationTicks", {
        /**
         * The end time of the last event in the track in ticks.
         */ get: function() {
            if (!this.notes.length) return 0;
            var maxDuration = this.notes[this.notes.length - 1].ticks + this.notes[this.notes.length - 1].durationTicks;
            for(var i = 0; i < this.notes.length - 1; i++){
                var duration = this.notes[i].ticks + this.notes[i].durationTicks;
                if (maxDuration < duration) maxDuration = duration;
            }
            return maxDuration;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Assign the JSON values to this track.
     */ Track.prototype.fromJSON = function(json) {
        var _this = this;
        this.name = json.name;
        this.channel = json.channel;
        this.instrument = new $30a9506e114bbf2a$exports.Instrument(undefined, this);
        this.instrument.fromJSON(json.instrument);
        if (json.endOfTrackTicks !== undefined) this.endOfTrackTicks = json.endOfTrackTicks;
        for(var number in json.controlChanges)if (json.controlChanges[number]) json.controlChanges[number].forEach(function(cc) {
            _this.addCC({
                number: cc.number,
                ticks: cc.ticks,
                value: cc.value
            });
        });
        json.notes.forEach(function(n) {
            _this.addNote({
                durationTicks: n.durationTicks,
                midi: n.midi,
                ticks: n.ticks,
                velocity: n.velocity
            });
        });
    };
    /**
     * Convert the track into a JSON format.
     */ Track.prototype.toJSON = function() {
        // Convert all the CCs to JSON.
        var controlChanges = {};
        for(var i = 0; i < 127; i++)if (this.controlChanges.hasOwnProperty(i)) controlChanges[i] = this.controlChanges[i].map(function(c) {
            return c.toJSON();
        });
        var json = {
            channel: this.channel,
            controlChanges: controlChanges,
            pitchBends: this.pitchBends.map(function(pb) {
                return pb.toJSON();
            }),
            instrument: this.instrument.toJSON(),
            name: this.name,
            notes: this.notes.map(function(n) {
                return n.toJSON();
            })
        };
        if (this.endOfTrackTicks !== undefined) json.endOfTrackTicks = this.endOfTrackTicks;
        return json;
    };
    return Track;
}();
$40651e7dcdad1bee$exports.Track = $40651e7dcdad1bee$var$Track;


var $5a327199cea97b55$exports = {};
"use strict";
var $5a327199cea97b55$var$__spreadArray = $5a327199cea97b55$exports && $5a327199cea97b55$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($5a327199cea97b55$exports, "__esModule", {
    value: true
});
$5a327199cea97b55$exports.encode = void 0;


/**
 * Flatten an array indefinitely.
 */ function $6270266de553c402$export$bffa455ba8c619a6(array) {
    var result = [];
    $6270266de553c402$var$$flatten(array, result);
    return result;
}
/**
 * Internal flatten function recursively passes `result`.
 */ function $6270266de553c402$var$$flatten(array, result) {
    for(var i = 0; i < array.length; i++){
        var value = array[i];
        if (Array.isArray(value)) $6270266de553c402$var$$flatten(value, result);
        else result.push(value);
    }
}


function $5a327199cea97b55$var$encodeNote(note, channel) {
    return [
        {
            absoluteTime: note.ticks,
            channel: channel,
            deltaTime: 0,
            noteNumber: note.midi,
            type: "noteOn",
            velocity: Math.floor(note.velocity * 127)
        },
        {
            absoluteTime: note.ticks + note.durationTicks,
            channel: channel,
            deltaTime: 0,
            noteNumber: note.midi,
            type: "noteOff",
            velocity: Math.floor(note.noteOffVelocity * 127)
        }
    ];
}
function $5a327199cea97b55$var$encodeNotes(track) {
    return (0, $6270266de553c402$export$bffa455ba8c619a6)(track.notes.map(function(note) {
        return $5a327199cea97b55$var$encodeNote(note, track.channel);
    }));
}
function $5a327199cea97b55$var$encodeControlChange(cc, channel) {
    return {
        absoluteTime: cc.ticks,
        channel: channel,
        controllerType: cc.number,
        deltaTime: 0,
        type: "controller",
        value: Math.floor(cc.value * 127)
    };
}
function $5a327199cea97b55$var$encodeControlChanges(track) {
    var controlChanges = [];
    for(var i = 0; i < 127; i++)if (track.controlChanges.hasOwnProperty(i)) track.controlChanges[i].forEach(function(cc) {
        controlChanges.push($5a327199cea97b55$var$encodeControlChange(cc, track.channel));
    });
    return controlChanges;
}
function $5a327199cea97b55$var$encodePitchBend(pb, channel) {
    return {
        absoluteTime: pb.ticks,
        channel: channel,
        deltaTime: 0,
        type: "pitchBend",
        value: pb.value
    };
}
function $5a327199cea97b55$var$encodePitchBends(track) {
    var pitchBends = [];
    track.pitchBends.forEach(function(pb) {
        pitchBends.push($5a327199cea97b55$var$encodePitchBend(pb, track.channel));
    });
    return pitchBends;
}
function $5a327199cea97b55$var$encodeInstrument(track) {
    return {
        absoluteTime: 0,
        channel: track.channel,
        deltaTime: 0,
        programNumber: track.instrument.number,
        type: "programChange"
    };
}
function $5a327199cea97b55$var$encodeTrackName(name) {
    return {
        absoluteTime: 0,
        deltaTime: 0,
        meta: true,
        text: name,
        type: "trackName"
    };
}
function $5a327199cea97b55$var$encodeTempo(tempo) {
    return {
        absoluteTime: tempo.ticks,
        deltaTime: 0,
        meta: true,
        microsecondsPerBeat: Math.floor(60000000 / tempo.bpm),
        type: "setTempo"
    };
}
function $5a327199cea97b55$var$encodeTimeSignature(timeSig) {
    return {
        absoluteTime: timeSig.ticks,
        deltaTime: 0,
        denominator: timeSig.timeSignature[1],
        meta: true,
        metronome: 24,
        numerator: timeSig.timeSignature[0],
        thirtyseconds: 8,
        type: "timeSignature"
    };
}
// function encodeMeta(event: )
function $5a327199cea97b55$var$encodeKeySignature(keySig) {
    var keyIndex = $ae5327bd0dc5627f$exports.keySignatureKeys.indexOf(keySig.key);
    return {
        absoluteTime: keySig.ticks,
        deltaTime: 0,
        key: keyIndex + 7,
        meta: true,
        scale: keySig.scale === "major" ? 0 : 1,
        type: "keySignature"
    };
}
function $5a327199cea97b55$var$encodeText(textEvent) {
    return {
        absoluteTime: textEvent.ticks,
        deltaTime: 0,
        meta: true,
        text: textEvent.text,
        type: textEvent.type
    };
}
/**
 * Convert the MIDI object to an array.
 */ function $5a327199cea97b55$var$encode(midi) {
    var midiData = {
        header: {
            format: 1,
            numTracks: midi.tracks.length + 1,
            ticksPerBeat: midi.header.ppq
        },
        tracks: $5a327199cea97b55$var$__spreadArray([
            $5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray([
                // The name data.
                {
                    absoluteTime: 0,
                    deltaTime: 0,
                    meta: true,
                    text: midi.header.name,
                    type: "trackName"
                }
            ], midi.header.keySignatures.map(function(keySig) {
                return $5a327199cea97b55$var$encodeKeySignature(keySig);
            }), true), midi.header.meta.map(function(e) {
                return $5a327199cea97b55$var$encodeText(e);
            }), true), midi.header.tempos.map(function(tempo) {
                return $5a327199cea97b55$var$encodeTempo(tempo);
            }), true), midi.header.timeSignatures.map(function(timeSig) {
                return $5a327199cea97b55$var$encodeTimeSignature(timeSig);
            }), true)
        ], midi.tracks.map(function(track) {
            return $5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray($5a327199cea97b55$var$__spreadArray([
                // Add the name
                $5a327199cea97b55$var$encodeTrackName(track.name),
                // the instrument
                $5a327199cea97b55$var$encodeInstrument(track)
            ], $5a327199cea97b55$var$encodeNotes(track), true), $5a327199cea97b55$var$encodeControlChanges(track), true), $5a327199cea97b55$var$encodePitchBends(track), true);
        }), true)
    };
    // Sort and set `deltaTime` of all of the tracks.
    midiData.tracks = midiData.tracks.map(function(track) {
        track = track.sort(function(a, b) {
            return a.absoluteTime - b.absoluteTime;
        });
        var lastTime = 0;
        track.forEach(function(note) {
            note.deltaTime = note.absoluteTime - lastTime;
            lastTime = note.absoluteTime;
            delete note.absoluteTime;
        });
        // End of track.
        track.push({
            deltaTime: 0,
            meta: true,
            type: "endOfTrack"
        });
        return track;
    });
    // Rreturn `midiData`.
    return new Uint8Array((0, $f4610896fa898662$export$77fcca795c2a5d6c)(midiData));
}
$5a327199cea97b55$exports.encode = $5a327199cea97b55$var$encode;


/**
 * The main midi parsing class.
 */ var $28735cb37928c976$var$Midi = /** @class */ function() {
    /**
     * Parse the midi data
     */ function Midi(midiArray) {
        var _this = this;
        // Parse the MIDI data if there is any.
        var midiData = null;
        if (midiArray) {
            // Transform midiArray to ArrayLike<number>
            // only if it's an ArrayBuffer.
            var midiArrayLike = midiArray instanceof ArrayBuffer ? new Uint8Array(midiArray) : midiArray;
            // Parse MIDI data.
            midiData = (0, $f4610896fa898662$export$2b5b68a498cfe902)(midiArrayLike);
            // Add the absolute times to each of the tracks.
            midiData.tracks.forEach(function(track) {
                var currentTicks = 0;
                track.forEach(function(event) {
                    currentTicks += event.deltaTime;
                    event.absoluteTime = currentTicks;
                });
            });
            // Ensure at most one instrument per track.
            midiData.tracks = $28735cb37928c976$var$splitTracks(midiData.tracks);
        }
        this.header = new $ae5327bd0dc5627f$exports.Header(midiData);
        this.tracks = [];
        // Parse MIDI data.
        if (midiArray) {
            // Format 0, everything is on the same track.
            this.tracks = midiData.tracks.map(function(trackData) {
                return new $40651e7dcdad1bee$exports.Track(trackData, _this.header);
            });
            // If it's format 1 and there are no notes on the first track, remove it.
            if (midiData.header.format === 1 && this.tracks[0].duration === 0) this.tracks.shift();
        }
    }
    /**
     * Download and parse the MIDI file. Returns a promise
     * which resolves to the generated MIDI file.
     * @param url The URL to fetch.
     */ Midi.fromUrl = function(url) {
        return $28735cb37928c976$var$__awaiter(this, void 0, void 0, function() {
            var response, arrayBuffer;
            return $28735cb37928c976$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetch(url)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            response.arrayBuffer()
                        ];
                    case 2:
                        arrayBuffer = _a.sent();
                        return [
                            2 /*return*/ ,
                            new Midi(arrayBuffer)
                        ];
                    case 3:
                        throw new Error("Could not load '".concat(url, "'"));
                }
            });
        });
    };
    Object.defineProperty(Midi.prototype, "name", {
        /**
         * The name of the midi file, taken from the first track.
         */ get: function() {
            return this.header.name;
        },
        set: function(n) {
            this.header.name = n;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Midi.prototype, "duration", {
        /**
         * The total length of the file in seconds.
         */ get: function() {
            // Get the max of the last note of all the tracks.
            var durations = this.tracks.map(function(t) {
                return t.duration;
            });
            return Math.max.apply(Math, durations);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Midi.prototype, "durationTicks", {
        /**
         * The total length of the file in ticks.
         */ get: function() {
            // Get the max of the last note of all the tracks.
            var durationTicks = this.tracks.map(function(t) {
                return t.durationTicks;
            });
            return Math.max.apply(Math, durationTicks);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add a track to the MIDI file.
     */ Midi.prototype.addTrack = function() {
        var track = new $40651e7dcdad1bee$exports.Track(undefined, this.header);
        this.tracks.push(track);
        return track;
    };
    /**
     * Encode the MIDI as a Uint8Array.
     */ Midi.prototype.toArray = function() {
        return (0, $5a327199cea97b55$exports.encode)(this);
    };
    /**
     * Convert the MIDI object to JSON.
     */ Midi.prototype.toJSON = function() {
        return {
            header: this.header.toJSON(),
            tracks: this.tracks.map(function(track) {
                return track.toJSON();
            })
        };
    };
    /**
     * Parse a JSON representation of the object. Will overwrite the current
     * tracks and header.
     */ Midi.prototype.fromJSON = function(json) {
        var _this = this;
        this.header = new $ae5327bd0dc5627f$exports.Header();
        this.header.fromJSON(json.header);
        this.tracks = json.tracks.map(function(trackJSON) {
            var track = new $40651e7dcdad1bee$exports.Track(undefined, _this.header);
            track.fromJSON(trackJSON);
            return track;
        });
    };
    /**
     * Clone the entire object MIDI object.
     */ Midi.prototype.clone = function() {
        var midi = new Midi();
        midi.fromJSON(this.toJSON());
        return midi;
    };
    return Midi;
}();
$28735cb37928c976$exports.Midi = $28735cb37928c976$var$Midi;

Object.defineProperty($28735cb37928c976$exports, "Track", {
    enumerable: true,
    get: function() {
        return $40651e7dcdad1bee$exports.Track;
    }
});

Object.defineProperty($28735cb37928c976$exports, "Header", {
    enumerable: true,
    get: function() {
        return $ae5327bd0dc5627f$exports.Header;
    }
});
/**
 * Given a list of MIDI tracks, make sure that each channel corresponds to at
 * most one channel and at most one instrument. This means splitting up tracks
 * that contain more than one channel or instrument.
 */ function $28735cb37928c976$var$splitTracks(tracks) {
    var newTracks = [];
    for(var i = 0; i < tracks.length; i++){
        var defaultTrack = newTracks.length;
        // a map from [program, channel] tuples to new track numbers
        var trackMap = new Map();
        // a map from channel numbers to current program numbers
        var currentProgram = Array(16).fill(0);
        for(var _i = 0, _a = tracks[i]; _i < _a.length; _i++){
            var event_1 = _a[_i];
            var targetTrack = defaultTrack;
            // If the event has a channel, we need to find that channel's current
            // program number and the appropriate track for this [program, channel]
            // pair.
            var channel = event_1.channel;
            if (channel !== undefined) {
                if (event_1.type === "programChange") currentProgram[channel] = event_1.programNumber;
                var program = currentProgram[channel];
                var trackKey = "".concat(program, " ").concat(channel);
                if (trackMap.has(trackKey)) targetTrack = trackMap.get(trackKey);
                else {
                    targetTrack = defaultTrack + trackMap.size;
                    trackMap.set(trackKey, targetTrack);
                }
            }
            if (!newTracks[targetTrack]) newTracks.push([]);
            newTracks[targetTrack].push(event_1);
        }
    }
    return newTracks;
}


var $5b38727783012434$exports = {};
/*! p5.js v1.7.0 July 10, 2023 */ !function(e1) {
    $5b38727783012434$exports = e1();
}(function() {
    var s, t, r;
    return (function o(n, s, i) {
        function a(t, e1) {
            if (!s[t]) {
                if (!n[t]) {
                    var r = undefined;
                    if (!e1 && r) return r(t, !0);
                    if (l) return l(t, !0);
                    throw (e1 = new Error("Cannot find module '" + t + "'")).code = "MODULE_NOT_FOUND", e1;
                }
                r = s[t] = {
                    exports: {}
                }, n[t][0].call(r.exports, function(e1) {
                    return a(n[t][1][e1] || e1);
                }, r, r.exports, o, n, s, i);
            }
            return s[t].exports;
        }
        for(var l = undefined, e1 = 0; e1 < i.length; e1++)a(i[e1]);
        return a;
    })({
        1: [
            function(e1, t, r) {
                "use strict";
                r.byteLength = function(e1) {
                    var e1 = c(e1), t = e1[0], e1 = e1[1];
                    return 3 * (t + e1) / 4 - e1;
                }, r.toByteArray = function(e1) {
                    var t, r, o = c(e1), n = o[0], o = o[1], s = new u(function(e1, t) {
                        return 3 * (e1 + t) / 4 - t;
                    }(n, o)), i = 0, a = 0 < o ? n - 4 : n;
                    for(r = 0; r < a; r += 4)t = l[e1.charCodeAt(r)] << 18 | l[e1.charCodeAt(r + 1)] << 12 | l[e1.charCodeAt(r + 2)] << 6 | l[e1.charCodeAt(r + 3)], s[i++] = t >> 16 & 255, s[i++] = t >> 8 & 255, s[i++] = 255 & t;
                    2 === o && (t = l[e1.charCodeAt(r)] << 2 | l[e1.charCodeAt(r + 1)] >> 4, s[i++] = 255 & t);
                    1 === o && (t = l[e1.charCodeAt(r)] << 10 | l[e1.charCodeAt(r + 1)] << 4 | l[e1.charCodeAt(r + 2)] >> 2, s[i++] = t >> 8 & 255, s[i++] = 255 & t);
                    return s;
                }, r.fromByteArray = function(e1) {
                    for(var t, r = e1.length, o = r % 3, n = [], s = 0, i = r - o; s < i; s += 16383)n.push(function(e1, t, r) {
                        for(var o, n = [], s = t; s < r; s += 3)o = (e1[s] << 16 & 16711680) + (e1[s + 1] << 8 & 65280) + (255 & e1[s + 2]), n.push(function(e1) {
                            return a[e1 >> 18 & 63] + a[e1 >> 12 & 63] + a[e1 >> 6 & 63] + a[63 & e1];
                        }(o));
                        return n.join("");
                    }(e1, s, i < s + 16383 ? i : s + 16383));
                    1 == o ? (t = e1[r - 1], n.push(a[t >> 2] + a[t << 4 & 63] + "==")) : 2 == o && (t = (e1[r - 2] << 8) + e1[r - 1], n.push(a[t >> 10] + a[t >> 4 & 63] + a[t << 2 & 63] + "="));
                    return n.join("");
                };
                for(var a = [], l = [], u = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, s = o.length; n < s; ++n)a[n] = o[n], l[o.charCodeAt(n)] = n;
                function c(e1) {
                    var t = e1.length;
                    if (0 < t % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    e1 = e1.indexOf("="), t = (e1 = -1 === e1 ? t : e1) === t ? 0 : 4 - e1 % 4;
                    return [
                        e1,
                        t
                    ];
                }
                l["-".charCodeAt(0)] = 62, l["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        2: [
            function(e1, t, r) {},
            {}
        ],
        3: [
            function(e1, t, r) {
                arguments[4][2][0].apply(r, arguments);
            },
            {
                dup: 2
            }
        ],
        4: [
            function(P, e1, L) {
                (function(d) {
                    "use strict";
                    var S = P("base64-js"), s = P("ieee754"), e1 = "function" == typeof Symbol && "function" == typeof Symbol.for ? Symbol.for("nodejs.util.inspect.custom") : null, t = (L.Buffer = d, L.SlowBuffer = function(e1) {
                        +e1 != e1 && (e1 = 0);
                        return d.alloc(+e1);
                    }, L.INSPECT_MAX_BYTES = 50, 2147483647);
                    function l(e1) {
                        if (t < e1) throw new RangeError('The value "' + e1 + '" is invalid for option "size"');
                        e1 = new Uint8Array(e1);
                        return Object.setPrototypeOf(e1, d.prototype), e1;
                    }
                    function d(e1, t, r) {
                        if ("number" != typeof e1) return o(e1, t, r);
                        if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                        return i(e1);
                    }
                    function o(e1, t, r) {
                        if ("string" == typeof e1) {
                            var o = e1, n = t;
                            if (d.isEncoding(n = "string" == typeof n && "" !== n ? n : "utf8")) return s = 0 | f(o, n), i = l(s), i = (o = i.write(o, n)) !== s ? i.slice(0, o) : i;
                            throw new TypeError("Unknown encoding: " + n);
                        }
                        if (ArrayBuffer.isView(e1)) return u(e1);
                        if (null != e1) {
                            if (O(e1, ArrayBuffer) || e1 && O(e1.buffer, ArrayBuffer)) {
                                var s = e1, o = t, i = r;
                                if (o < 0 || s.byteLength < o) throw new RangeError('"offset" is outside of buffer bounds');
                                if (s.byteLength < o + (i || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                return s = void 0 === o && void 0 === i ? new Uint8Array(s) : void 0 === i ? new Uint8Array(s, o) : new Uint8Array(s, o, i), Object.setPrototypeOf(s, d.prototype), s;
                            }
                            if ("number" == typeof e1) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            n = e1.valueOf && e1.valueOf();
                            if (null != n && n !== e1) return d.from(n, t, r);
                            var a = function(e1) {
                                var t, r;
                                if (d.isBuffer(e1)) return t = 0 | c(e1.length), 0 !== (r = l(t)).length && e1.copy(r, 0, 0, t), r;
                                if (void 0 !== e1.length) return "number" != typeof e1.length || C(e1.length) ? l(0) : u(e1);
                                if ("Buffer" === e1.type && Array.isArray(e1.data)) return u(e1.data);
                            }(e1);
                            if (a) return a;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e1[Symbol.toPrimitive]) return d.from(e1[Symbol.toPrimitive]("string"), t, r);
                        }
                        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e1);
                    }
                    function n(e1) {
                        if ("number" != typeof e1) throw new TypeError('"size" argument must be of type number');
                        if (e1 < 0) throw new RangeError('The value "' + e1 + '" is invalid for option "size"');
                    }
                    function i(e1) {
                        return n(e1), l(e1 < 0 ? 0 : 0 | c(e1));
                    }
                    function u(e1) {
                        for(var t = e1.length < 0 ? 0 : 0 | c(e1.length), r = l(t), o = 0; o < t; o += 1)r[o] = 255 & e1[o];
                        return r;
                    }
                    function c(e1) {
                        if (t <= e1) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + t.toString(16) + " bytes");
                        return 0 | e1;
                    }
                    function f(e1, t) {
                        if (d.isBuffer(e1)) return e1.length;
                        if (ArrayBuffer.isView(e1) || O(e1, ArrayBuffer)) return e1.byteLength;
                        if ("string" != typeof e1) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e1);
                        var r = e1.length, o = 2 < arguments.length && !0 === arguments[2];
                        if (!o && 0 === r) return 0;
                        for(var n = !1;;)switch(t){
                            case "ascii":
                            case "latin1":
                            case "binary":
                                return r;
                            case "utf8":
                            case "utf-8":
                                return M(e1).length;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return 2 * r;
                            case "hex":
                                return r >>> 1;
                            case "base64":
                                return T(e1).length;
                            default:
                                if (n) return o ? -1 : M(e1).length;
                                t = ("" + t).toLowerCase(), n = !0;
                        }
                    }
                    function r(e1, t, r) {
                        var o, n = !1;
                        if ((t = void 0 === t || t < 0 ? 0 : t) > this.length) return "";
                        if ((r = void 0 === r || r > this.length ? this.length : r) <= 0) return "";
                        if ((r >>>= 0) <= (t >>>= 0)) return "";
                        for(e1 = e1 || "utf8";;)switch(e1){
                            case "hex":
                                var s = this, i = t, a = r, l = s.length;
                                (!a || a < 0 || l < a) && (a = l);
                                for(var u = "", c = i = !i || i < 0 ? 0 : i; c < a; ++c)u += A[s[c]];
                                return u;
                            case "utf8":
                            case "utf-8":
                                return E(this, t, r);
                            case "ascii":
                                var d = this, l = t, f = r, h = "";
                                f = Math.min(d.length, f);
                                for(var p = l; p < f; ++p)h += String.fromCharCode(127 & d[p]);
                                return h;
                            case "latin1":
                            case "binary":
                                var m = this, i = t, y = r, g = "";
                                y = Math.min(m.length, y);
                                for(var v = i; v < y; ++v)g += String.fromCharCode(m[v]);
                                return g;
                            case "base64":
                                return b = this, o = r, 0 === (j = t) && o === b.length ? S.fromByteArray(b) : S.fromByteArray(b.slice(j, o));
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                for(var b = t, j = r, _ = this.slice(b, j), x = "", w = 0; w < _.length; w += 2)x += String.fromCharCode(_[w] + 256 * _[w + 1]);
                                return x;
                            default:
                                if (n) throw new TypeError("Unknown encoding: " + e1);
                                e1 = (e1 + "").toLowerCase(), n = !0;
                        }
                    }
                    function a(e1, t, r) {
                        var o = e1[t];
                        e1[t] = e1[r], e1[r] = o;
                    }
                    function h(e1, t, r, o, n) {
                        if (0 === e1.length) return -1;
                        if ("string" == typeof r ? (o = r, r = 0) : 2147483647 < r ? r = 2147483647 : r < -2147483648 && (r = -2147483648), (r = (r = C(r = +r) ? n ? 0 : e1.length - 1 : r) < 0 ? e1.length + r : r) >= e1.length) {
                            if (n) return -1;
                            r = e1.length - 1;
                        } else if (r < 0) {
                            if (!n) return -1;
                            r = 0;
                        }
                        if ("string" == typeof t && (t = d.from(t, o)), d.isBuffer(t)) return 0 === t.length ? -1 : p(e1, t, r, o, n);
                        if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? (n ? Uint8Array.prototype.indexOf : Uint8Array.prototype.lastIndexOf).call(e1, t, r) : p(e1, [
                            t
                        ], r, o, n);
                        throw new TypeError("val must be string, number or Buffer");
                    }
                    function p(e1, t, r, o, n) {
                        var s = 1, i = e1.length, a = t.length;
                        if (void 0 !== o && ("ucs2" === (o = String(o).toLowerCase()) || "ucs-2" === o || "utf16le" === o || "utf-16le" === o)) {
                            if (e1.length < 2 || t.length < 2) return -1;
                            i /= s = 2, a /= 2, r /= 2;
                        }
                        function l(e1, t) {
                            return 1 === s ? e1[t] : e1.readUInt16BE(t * s);
                        }
                        if (n) for(var u = -1, c = r; c < i; c++)if (l(e1, c) === l(t, -1 === u ? 0 : c - u)) {
                            if (c - (u = -1 === u ? c : u) + 1 === a) return u * s;
                        } else -1 !== u && (c -= c - u), u = -1;
                        else for(c = r = i < r + a ? i - a : r; 0 <= c; c--){
                            for(var d = !0, f = 0; f < a; f++)if (l(e1, c + f) !== l(t, f)) {
                                d = !1;
                                break;
                            }
                            if (d) return c;
                        }
                        return -1;
                    }
                    function y(e1, t, r, o) {
                        return k(function(e1) {
                            for(var t = [], r = 0; r < e1.length; ++r)t.push(255 & e1.charCodeAt(r));
                            return t;
                        }(t), e1, r, o);
                    }
                    function g(e1, t, r, o) {
                        return k(function(e1, t) {
                            for(var r, o, n = [], s = 0; s < e1.length && !((t -= 2) < 0); ++s)o = e1.charCodeAt(s), r = o >> 8, o = o % 256, n.push(o), n.push(r);
                            return n;
                        }(t, e1.length - r), e1, r, o);
                    }
                    function E(e1, t, r) {
                        r = Math.min(e1.length, r);
                        for(var o = [], n = t; n < r;){
                            var s, i, a, l, u = e1[n], c = null, d = 239 < u ? 4 : 223 < u ? 3 : 191 < u ? 2 : 1;
                            if (n + d <= r) switch(d){
                                case 1:
                                    u < 128 && (c = u);
                                    break;
                                case 2:
                                    128 == (192 & (s = e1[n + 1])) && 127 < (l = (31 & u) << 6 | 63 & s) && (c = l);
                                    break;
                                case 3:
                                    s = e1[n + 1], i = e1[n + 2], 128 == (192 & s) && 128 == (192 & i) && 2047 < (l = (15 & u) << 12 | (63 & s) << 6 | 63 & i) && (l < 55296 || 57343 < l) && (c = l);
                                    break;
                                case 4:
                                    s = e1[n + 1], i = e1[n + 2], a = e1[n + 3], 128 == (192 & s) && 128 == (192 & i) && 128 == (192 & a) && 65535 < (l = (15 & u) << 18 | (63 & s) << 12 | (63 & i) << 6 | 63 & a) && l < 1114112 && (c = l);
                            }
                            null === c ? (c = 65533, d = 1) : 65535 < c && (c -= 65536, o.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), o.push(c), n += d;
                        }
                        var f = o, h = f.length;
                        if (h <= v) return String.fromCharCode.apply(String, f);
                        for(var p = "", m = 0; m < h;)p += String.fromCharCode.apply(String, f.slice(m, m += v));
                        return p;
                    }
                    L.kMaxLength = t, (d.TYPED_ARRAY_SUPPORT = function() {
                        try {
                            var e1 = new Uint8Array(1), t = {
                                foo: function() {
                                    return 42;
                                }
                            };
                            return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e1, t), 42 === e1.foo();
                        } catch (e1) {
                            return !1;
                        }
                    }()) || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(d.prototype, "parent", {
                        enumerable: !0,
                        get: function() {
                            if (d.isBuffer(this)) return this.buffer;
                        }
                    }), Object.defineProperty(d.prototype, "offset", {
                        enumerable: !0,
                        get: function() {
                            if (d.isBuffer(this)) return this.byteOffset;
                        }
                    }), "undefined" != typeof Symbol && null != Symbol.species && d[Symbol.species] === d && Object.defineProperty(d, Symbol.species, {
                        value: null,
                        configurable: !0,
                        enumerable: !1,
                        writable: !1
                    }), d.poolSize = 8192, d.from = o, Object.setPrototypeOf(d.prototype, Uint8Array.prototype), Object.setPrototypeOf(d, Uint8Array), d.alloc = function(e1, t, r) {
                        return t, r, n(e1), !(e1 <= 0) && void 0 !== t ? "string" == typeof r ? l(e1).fill(t, r) : l(e1).fill(t) : l(e1);
                    }, d.allocUnsafe = i, d.allocUnsafeSlow = i, d.isBuffer = function(e1) {
                        return null != e1 && !0 === e1._isBuffer && e1 !== d.prototype;
                    }, d.compare = function(e1, t) {
                        if (O(e1, Uint8Array) && (e1 = d.from(e1, e1.offset, e1.byteLength)), O(t, Uint8Array) && (t = d.from(t, t.offset, t.byteLength)), !d.isBuffer(e1) || !d.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                        if (e1 === t) return 0;
                        for(var r = e1.length, o = t.length, n = 0, s = Math.min(r, o); n < s; ++n)if (e1[n] !== t[n]) {
                            r = e1[n], o = t[n];
                            break;
                        }
                        return r < o ? -1 : o < r ? 1 : 0;
                    }, d.isEncoding = function(e1) {
                        switch(String(e1).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "latin1":
                            case "binary":
                            case "base64":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, d.concat = function(e1, t) {
                        if (!Array.isArray(e1)) throw new TypeError('"list" argument must be an Array of Buffers');
                        if (0 === e1.length) return d.alloc(0);
                        if (void 0 === t) for(n = t = 0; n < e1.length; ++n)t += e1[n].length;
                        for(var r = d.allocUnsafe(t), o = 0, n = 0; n < e1.length; ++n){
                            var s = e1[n];
                            if (O(s, Uint8Array) && (s = d.from(s)), !d.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
                            s.copy(r, o), o += s.length;
                        }
                        return r;
                    }, d.byteLength = f, d.prototype._isBuffer = !0, d.prototype.swap16 = function() {
                        var e1 = this.length;
                        if (e1 % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                        for(var t = 0; t < e1; t += 2)a(this, t, t + 1);
                        return this;
                    }, d.prototype.swap32 = function() {
                        var e1 = this.length;
                        if (e1 % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                        for(var t = 0; t < e1; t += 4)a(this, t, t + 3), a(this, t + 1, t + 2);
                        return this;
                    }, d.prototype.swap64 = function() {
                        var e1 = this.length;
                        if (e1 % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                        for(var t = 0; t < e1; t += 8)a(this, t, t + 7), a(this, t + 1, t + 6), a(this, t + 2, t + 5), a(this, t + 3, t + 4);
                        return this;
                    }, d.prototype.toLocaleString = d.prototype.toString = function() {
                        var e1 = this.length;
                        return 0 === e1 ? "" : 0 === arguments.length ? E(this, 0, e1) : r.apply(this, arguments);
                    }, d.prototype.equals = function(e1) {
                        if (d.isBuffer(e1)) return this === e1 || 0 === d.compare(this, e1);
                        throw new TypeError("Argument must be a Buffer");
                    }, d.prototype.inspect = function() {
                        var e1 = "", t = L.INSPECT_MAX_BYTES, e1 = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim();
                        return this.length > t && (e1 += " ... "), "<Buffer " + e1 + ">";
                    }, e1 && (d.prototype[e1] = d.prototype.inspect), d.prototype.compare = function(e1, t, r, o, n) {
                        if (O(e1, Uint8Array) && (e1 = d.from(e1, e1.offset, e1.byteLength)), !d.isBuffer(e1)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e1);
                        if (void 0 === r && (r = e1 ? e1.length : 0), void 0 === o && (o = 0), void 0 === n && (n = this.length), (t = void 0 === t ? 0 : t) < 0 || r > e1.length || o < 0 || n > this.length) throw new RangeError("out of range index");
                        if (n <= o && r <= t) return 0;
                        if (n <= o) return -1;
                        if (r <= t) return 1;
                        if (this === e1) return 0;
                        for(var s = (n >>>= 0) - (o >>>= 0), i = (r >>>= 0) - (t >>>= 0), a = Math.min(s, i), l = this.slice(o, n), u = e1.slice(t, r), c = 0; c < a; ++c)if (l[c] !== u[c]) {
                            s = l[c], i = u[c];
                            break;
                        }
                        return s < i ? -1 : i < s ? 1 : 0;
                    }, d.prototype.includes = function(e1, t, r) {
                        return -1 !== this.indexOf(e1, t, r);
                    }, d.prototype.indexOf = function(e1, t, r) {
                        return h(this, e1, t, r, !0);
                    }, d.prototype.lastIndexOf = function(e1, t, r) {
                        return h(this, e1, t, r, !1);
                    }, d.prototype.write = function(e1, t, r, o) {
                        if (void 0 === t) o = "utf8", r = this.length, t = 0;
                        else if (void 0 === r && "string" == typeof t) o = t, r = this.length, t = 0;
                        else {
                            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                            t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === o && (o = "utf8")) : (o = r, r = void 0);
                        }
                        var n = this.length - t;
                        if ((void 0 === r || n < r) && (r = n), 0 < e1.length && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                        o = o || "utf8";
                        for(var s, i, a, l = !1;;)switch(o){
                            case "hex":
                                var u = this, c = e1, d = t, f = r, h = (d = Number(d) || 0, u.length - d);
                                (!f || h < (f = Number(f))) && (f = h), (h = c.length) / 2 < f && (f = h / 2);
                                for(var p = 0; p < f; ++p){
                                    var m = parseInt(c.substr(2 * p, 2), 16);
                                    if (C(m)) return p;
                                    u[d + p] = m;
                                }
                                return p;
                            case "utf8":
                            case "utf-8":
                                return h = t, a = r, k(M(e1, (i = this).length - h), i, h, a);
                            case "ascii":
                                return y(this, e1, t, r);
                            case "latin1":
                            case "binary":
                                return y(this, e1, t, r);
                            case "base64":
                                return i = this, a = t, s = r, k(T(e1), i, a, s);
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return g(this, e1, t, r);
                            default:
                                if (l) throw new TypeError("Unknown encoding: " + o);
                                o = ("" + o).toLowerCase(), l = !0;
                        }
                    }, d.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    };
                    var v = 4096;
                    function m(e1, t, r) {
                        if (e1 % 1 != 0 || e1 < 0) throw new RangeError("offset is not uint");
                        if (r < e1 + t) throw new RangeError("Trying to access beyond buffer length");
                    }
                    function b(e1, t, r, o, n, s) {
                        if (!d.isBuffer(e1)) throw new TypeError('"buffer" argument must be a Buffer instance');
                        if (n < t || t < s) throw new RangeError('"value" argument is out of bounds');
                        if (r + o > e1.length) throw new RangeError("Index out of range");
                    }
                    function j(e1, t, r, o) {
                        if (r + o > e1.length) throw new RangeError("Index out of range");
                        if (r < 0) throw new RangeError("Index out of range");
                    }
                    function _(e1, t, r, o, n) {
                        return t = +t, r >>>= 0, n || j(e1, 0, r, 4), s.write(e1, t, r, o, 23, 4), r + 4;
                    }
                    function x(e1, t, r, o, n) {
                        return t = +t, r >>>= 0, n || j(e1, 0, r, 8), s.write(e1, t, r, o, 52, 8), r + 8;
                    }
                    d.prototype.slice = function(e1, t) {
                        var r = this.length, r = ((e1 = ~~e1) < 0 ? (e1 += r) < 0 && (e1 = 0) : r < e1 && (e1 = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : r < t && (t = r), t < e1 && (t = e1), this.subarray(e1, t));
                        return Object.setPrototypeOf(r, d.prototype), r;
                    }, d.prototype.readUIntLE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1], n = 1, s = 0; ++s < t && (n *= 256);)o += this[e1 + s] * n;
                        return o;
                    }, d.prototype.readUIntBE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1 + --t], n = 1; 0 < t && (n *= 256);)o += this[e1 + --t] * n;
                        return o;
                    }, d.prototype.readUInt8 = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 1, this.length), this[e1];
                    }, d.prototype.readUInt16LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 2, this.length), this[e1] | this[e1 + 1] << 8;
                    }, d.prototype.readUInt16BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 2, this.length), this[e1] << 8 | this[e1 + 1];
                    }, d.prototype.readUInt32LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), (this[e1] | this[e1 + 1] << 8 | this[e1 + 2] << 16) + 16777216 * this[e1 + 3];
                    }, d.prototype.readUInt32BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), 16777216 * this[e1] + (this[e1 + 1] << 16 | this[e1 + 2] << 8 | this[e1 + 3]);
                    }, d.prototype.readIntLE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = this[e1], n = 1, s = 0; ++s < t && (n *= 256);)o += this[e1 + s] * n;
                        return (n *= 128) <= o && (o -= Math.pow(2, 8 * t)), o;
                    }, d.prototype.readIntBE = function(e1, t, r) {
                        e1 >>>= 0, t >>>= 0, r || m(e1, t, this.length);
                        for(var o = t, n = 1, s = this[e1 + --o]; 0 < o && (n *= 256);)s += this[e1 + --o] * n;
                        return (n *= 128) <= s && (s -= Math.pow(2, 8 * t)), s;
                    }, d.prototype.readInt8 = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 1, this.length), 128 & this[e1] ? -1 * (255 - this[e1] + 1) : this[e1];
                    }, d.prototype.readInt16LE = function(e1, t) {
                        e1 >>>= 0, t || m(e1, 2, this.length);
                        t = this[e1] | this[e1 + 1] << 8;
                        return 32768 & t ? 4294901760 | t : t;
                    }, d.prototype.readInt16BE = function(e1, t) {
                        e1 >>>= 0, t || m(e1, 2, this.length);
                        t = this[e1 + 1] | this[e1] << 8;
                        return 32768 & t ? 4294901760 | t : t;
                    }, d.prototype.readInt32LE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), this[e1] | this[e1 + 1] << 8 | this[e1 + 2] << 16 | this[e1 + 3] << 24;
                    }, d.prototype.readInt32BE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), this[e1] << 24 | this[e1 + 1] << 16 | this[e1 + 2] << 8 | this[e1 + 3];
                    }, d.prototype.readFloatLE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), s.read(this, e1, !0, 23, 4);
                    }, d.prototype.readFloatBE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 4, this.length), s.read(this, e1, !1, 23, 4);
                    }, d.prototype.readDoubleLE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 8, this.length), s.read(this, e1, !0, 52, 8);
                    }, d.prototype.readDoubleBE = function(e1, t) {
                        return e1 >>>= 0, t || m(e1, 8, this.length), s.read(this, e1, !1, 52, 8);
                    }, d.prototype.writeUIntLE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, r >>>= 0, o || b(this, e1, t, r, Math.pow(2, 8 * r) - 1, 0);
                        var n = 1, s = 0;
                        for(this[t] = 255 & e1; ++s < r && (n *= 256);)this[t + s] = e1 / n & 255;
                        return t + r;
                    }, d.prototype.writeUIntBE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, r >>>= 0, o || b(this, e1, t, r, Math.pow(2, 8 * r) - 1, 0);
                        var n = r - 1, s = 1;
                        for(this[t + n] = 255 & e1; 0 <= --n && (s *= 256);)this[t + n] = e1 / s & 255;
                        return t + r;
                    }, d.prototype.writeUInt8 = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 1, 255, 0), this[t] = 255 & e1, t + 1;
                    }, d.prototype.writeUInt16LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 65535, 0), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, t + 2;
                    }, d.prototype.writeUInt16BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 65535, 0), this[t] = e1 >>> 8, this[t + 1] = 255 & e1, t + 2;
                    }, d.prototype.writeUInt32LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 4294967295, 0), this[t + 3] = e1 >>> 24, this[t + 2] = e1 >>> 16, this[t + 1] = e1 >>> 8, this[t] = 255 & e1, t + 4;
                    }, d.prototype.writeUInt32BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 4294967295, 0), this[t] = e1 >>> 24, this[t + 1] = e1 >>> 16, this[t + 2] = e1 >>> 8, this[t + 3] = 255 & e1, t + 4;
                    }, d.prototype.writeIntLE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, o || b(this, e1, t, r, (o = Math.pow(2, 8 * r - 1)) - 1, -o);
                        var n = 0, s = 1, i = 0;
                        for(this[t] = 255 & e1; ++n < r && (s *= 256);)e1 < 0 && 0 === i && 0 !== this[t + n - 1] && (i = 1), this[t + n] = (e1 / s >> 0) - i & 255;
                        return t + r;
                    }, d.prototype.writeIntBE = function(e1, t, r, o) {
                        e1 = +e1, t >>>= 0, o || b(this, e1, t, r, (o = Math.pow(2, 8 * r - 1)) - 1, -o);
                        var n = r - 1, s = 1, i = 0;
                        for(this[t + n] = 255 & e1; 0 <= --n && (s *= 256);)e1 < 0 && 0 === i && 0 !== this[t + n + 1] && (i = 1), this[t + n] = (e1 / s >> 0) - i & 255;
                        return t + r;
                    }, d.prototype.writeInt8 = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 1, 127, -128), this[t] = 255 & (e1 = e1 < 0 ? 255 + e1 + 1 : e1), t + 1;
                    }, d.prototype.writeInt16LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 32767, -32768), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, t + 2;
                    }, d.prototype.writeInt16BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 2, 32767, -32768), this[t] = e1 >>> 8, this[t + 1] = 255 & e1, t + 2;
                    }, d.prototype.writeInt32LE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 2147483647, -2147483648), this[t] = 255 & e1, this[t + 1] = e1 >>> 8, this[t + 2] = e1 >>> 16, this[t + 3] = e1 >>> 24, t + 4;
                    }, d.prototype.writeInt32BE = function(e1, t, r) {
                        return e1 = +e1, t >>>= 0, r || b(this, e1, t, 4, 2147483647, -2147483648), this[t] = (e1 = e1 < 0 ? 4294967295 + e1 + 1 : e1) >>> 24, this[t + 1] = e1 >>> 16, this[t + 2] = e1 >>> 8, this[t + 3] = 255 & e1, t + 4;
                    }, d.prototype.writeFloatLE = function(e1, t, r) {
                        return _(this, e1, t, !0, r);
                    }, d.prototype.writeFloatBE = function(e1, t, r) {
                        return _(this, e1, t, !1, r);
                    }, d.prototype.writeDoubleLE = function(e1, t, r) {
                        return x(this, e1, t, !0, r);
                    }, d.prototype.writeDoubleBE = function(e1, t, r) {
                        return x(this, e1, t, !1, r);
                    }, d.prototype.copy = function(e1, t, r, o) {
                        if (!d.isBuffer(e1)) throw new TypeError("argument should be a Buffer");
                        if (r = r || 0, o || 0 === o || (o = this.length), t >= e1.length && (t = e1.length), (o = 0 < o && o < r ? r : o) === r) return 0;
                        if (0 === e1.length || 0 === this.length) return 0;
                        if ((t = t || 0) < 0) throw new RangeError("targetStart out of bounds");
                        if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                        if (o < 0) throw new RangeError("sourceEnd out of bounds");
                        o > this.length && (o = this.length);
                        var n = (o = e1.length - t < o - r ? e1.length - t + r : o) - r;
                        if (this === e1 && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, o);
                        else if (this === e1 && r < t && t < o) for(var s = n - 1; 0 <= s; --s)e1[s + t] = this[s + r];
                        else Uint8Array.prototype.set.call(e1, this.subarray(r, o), t);
                        return n;
                    }, d.prototype.fill = function(e1, t, r, o) {
                        if ("string" == typeof e1) {
                            if ("string" == typeof t ? (o = t, t = 0, r = this.length) : "string" == typeof r && (o = r, r = this.length), void 0 !== o && "string" != typeof o) throw new TypeError("encoding must be a string");
                            if ("string" == typeof o && !d.isEncoding(o)) throw new TypeError("Unknown encoding: " + o);
                            var n;
                            1 === e1.length && (n = e1.charCodeAt(0), ("utf8" === o && n < 128 || "latin1" === o) && (e1 = n));
                        } else "number" == typeof e1 ? e1 &= 255 : "boolean" == typeof e1 && (e1 = Number(e1));
                        if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                        var s;
                        if (!(r <= t)) {
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, "number" == typeof (e1 = e1 || 0)) for(s = t; s < r; ++s)this[s] = e1;
                            else {
                                var i = d.isBuffer(e1) ? e1 : d.from(e1, o), a = i.length;
                                if (0 === a) throw new TypeError('The value "' + e1 + '" is invalid for argument "value"');
                                for(s = 0; s < r - t; ++s)this[s + t] = i[s % a];
                            }
                        }
                        return this;
                    };
                    var w = /[^+/0-9A-Za-z-_]/g;
                    function M(e1, t) {
                        t = t || 1 / 0;
                        for(var r, o = e1.length, n = null, s = [], i = 0; i < o; ++i){
                            if (55295 < (r = e1.charCodeAt(i)) && r < 57344) {
                                if (!n) {
                                    if (56319 < r) {
                                        -1 < (t -= 3) && s.push(239, 191, 189);
                                        continue;
                                    }
                                    if (i + 1 === o) {
                                        -1 < (t -= 3) && s.push(239, 191, 189);
                                        continue;
                                    }
                                    n = r;
                                    continue;
                                }
                                if (r < 56320) {
                                    -1 < (t -= 3) && s.push(239, 191, 189), n = r;
                                    continue;
                                }
                                r = 65536 + (n - 55296 << 10 | r - 56320);
                            } else n && -1 < (t -= 3) && s.push(239, 191, 189);
                            if (n = null, r < 128) {
                                if (--t < 0) break;
                                s.push(r);
                            } else if (r < 2048) {
                                if ((t -= 2) < 0) break;
                                s.push(r >> 6 | 192, 63 & r | 128);
                            } else if (r < 65536) {
                                if ((t -= 3) < 0) break;
                                s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                            } else {
                                if (!(r < 1114112)) throw new Error("Invalid code point");
                                if ((t -= 4) < 0) break;
                                s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                            }
                        }
                        return s;
                    }
                    function T(e1) {
                        return S.toByteArray(function(e1) {
                            if ((e1 = (e1 = e1.split("=")[0]).trim().replace(w, "")).length < 2) return "";
                            for(; e1.length % 4 != 0;)e1 += "=";
                            return e1;
                        }(e1));
                    }
                    function k(e1, t, r, o) {
                        for(var n = 0; n < o && !(n + r >= t.length || n >= e1.length); ++n)t[n + r] = e1[n];
                        return n;
                    }
                    function O(e1, t) {
                        return e1 instanceof t || null != e1 && null != e1.constructor && null != e1.constructor.name && e1.constructor.name === t.name;
                    }
                    function C(e1) {
                        return e1 != e1;
                    }
                    var A = function() {
                        for(var e1 = "0123456789abcdef", t = new Array(256), r = 0; r < 16; ++r)for(var o = 16 * r, n = 0; n < 16; ++n)t[o + n] = e1[r] + e1[n];
                        return t;
                    }();
                }).call(this, P("buffer").Buffer);
            },
            {
                "base64-js": 1,
                buffer: 4,
                ieee754: 244
            }
        ],
        5: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    if ("function" != typeof e1) throw TypeError(String(e1) + " is not a function");
                    return e1;
                };
            },
            {}
        ],
        6: [
            function(e1, t, r) {
                var o = e1("../internals/is-object");
                t.exports = function(e1) {
                    if (o(e1) || null === e1) return e1;
                    throw TypeError("Can't set " + String(e1) + " as a prototype");
                };
            },
            {
                "../internals/is-object": 74
            }
        ],
        7: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol"), n = e1("../internals/object-create"), e1 = e1("../internals/object-define-property"), s = o("unscopables"), i = Array.prototype;
                null == i[s] && e1.f(i, s, {
                    configurable: !0,
                    value: n(null)
                }), t.exports = function(e1) {
                    i[s][e1] = !0;
                };
            },
            {
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/well-known-symbol": 148
            }
        ],
        8: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/string-multibyte").charAt;
                t.exports = function(e1, t, r) {
                    return t + (r ? o(e1, t).length : 1);
                };
            },
            {
                "../internals/string-multibyte": 123
            }
        ],
        9: [
            function(e1, t, r) {
                t.exports = function(e1, t, r) {
                    if (e1 instanceof t) return e1;
                    throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
                };
            },
            {}
        ],
        10: [
            function(e1, t, r) {
                var o = e1("../internals/is-object");
                t.exports = function(e1) {
                    if (o(e1)) return e1;
                    throw TypeError(String(e1) + " is not an object");
                };
            },
            {
                "../internals/is-object": 74
            }
        ],
        11: [
            function(e1, t, r) {
                t.exports = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
            },
            {}
        ],
        12: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return l(e1) && u(M, c(e1));
                }
                var n, s = e1("../internals/array-buffer-native"), i = e1("../internals/descriptors"), a = e1("../internals/global"), l = e1("../internals/is-object"), u = e1("../internals/has"), c = e1("../internals/classof"), d = e1("../internals/create-non-enumerable-property"), f = e1("../internals/redefine"), h = e1("../internals/object-define-property").f, p = e1("../internals/object-get-prototype-of"), m = e1("../internals/object-set-prototype-of"), y = e1("../internals/well-known-symbol"), e1 = e1("../internals/uid"), g = a.Int8Array, v = g && g.prototype, b = a.Uint8ClampedArray, b = b && b.prototype, j = g && p(g), _ = v && p(v), x = Object.prototype, w = x.isPrototypeOf, y = y("toStringTag"), S = e1("TYPED_ARRAY_TAG"), E = s && !!m && "Opera" !== c(a.opera), e1 = !1, M = {
                    Int8Array: 1,
                    Uint8Array: 1,
                    Uint8ClampedArray: 1,
                    Int16Array: 2,
                    Uint16Array: 2,
                    Int32Array: 4,
                    Uint32Array: 4,
                    Float32Array: 4,
                    Float64Array: 8
                };
                for(n in M)a[n] || (E = !1);
                if ((!E || "function" != typeof j || j === Function.prototype) && (j = function() {
                    throw TypeError("Incorrect invocation");
                }, E)) for(n in M)a[n] && m(a[n], j);
                if ((!E || !_ || _ === x) && (_ = j.prototype, E)) for(n in M)a[n] && m(a[n].prototype, _);
                if (E && p(b) !== _ && m(b, _), i && !u(_, y)) for(n in e1 = !0, h(_, y, {
                    get: function() {
                        return l(this) ? this[S] : void 0;
                    }
                }), M)a[n] && d(a[n], S, n);
                t.exports = {
                    NATIVE_ARRAY_BUFFER_VIEWS: E,
                    TYPED_ARRAY_TAG: e1 && S,
                    aTypedArray: function(e1) {
                        if (o(e1)) return e1;
                        throw TypeError("Target is not a typed array");
                    },
                    aTypedArrayConstructor: function(e1) {
                        if (m) {
                            if (w.call(j, e1)) return e1;
                        } else for(var t in M)if (u(M, n)) {
                            t = a[t];
                            if (t && (e1 === t || w.call(t, e1))) return e1;
                        }
                        throw TypeError("Target is not a typed array constructor");
                    },
                    exportTypedArrayMethod: function(e1, t, r) {
                        if (i) {
                            if (r) for(var o in M){
                                o = a[o];
                                o && u(o.prototype, e1) && delete o.prototype[e1];
                            }
                            _[e1] && !r || f(_, e1, !r && E && v[e1] || t);
                        }
                    },
                    exportTypedArrayStaticMethod: function(e1, t, r) {
                        var o, n;
                        if (i) {
                            if (m) {
                                if (r) for(o in M)(n = a[o]) && u(n, e1) && delete n[e1];
                                if (j[e1] && !r) return;
                                try {
                                    return f(j, e1, !r && E && g[e1] || t);
                                } catch (e1) {}
                            }
                            for(o in M)!(n = a[o]) || n[e1] && !r || f(n, e1, t);
                        }
                    },
                    isView: function(e1) {
                        e1 = c(e1);
                        return "DataView" === e1 || u(M, e1);
                    },
                    isTypedArray: o,
                    TypedArray: j,
                    TypedArrayPrototype: _
                };
            },
            {
                "../internals/array-buffer-native": 11,
                "../internals/classof": 29,
                "../internals/create-non-enumerable-property": 38,
                "../internals/descriptors": 43,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/is-object": 74,
                "../internals/object-define-property": 92,
                "../internals/object-get-prototype-of": 97,
                "../internals/object-set-prototype-of": 101,
                "../internals/redefine": 108,
                "../internals/uid": 145,
                "../internals/well-known-symbol": 148
            }
        ],
        13: [
            function(e1, t, D) {
                "use strict";
                function r(e1) {
                    return [
                        255 & e1
                    ];
                }
                function o(e1) {
                    return [
                        255 & e1,
                        e1 >> 8 & 255
                    ];
                }
                function n(e1) {
                    return [
                        255 & e1,
                        e1 >> 8 & 255,
                        e1 >> 16 & 255,
                        e1 >> 24 & 255
                    ];
                }
                function s(e1) {
                    return e1[3] << 24 | e1[2] << 16 | e1[1] << 8 | e1[0];
                }
                function i(e1) {
                    return C(e1, 23, 4);
                }
                function F(e1) {
                    return C(e1, 52, 8);
                }
                function a(e1, t) {
                    H(e1[w], t, {
                        get: function() {
                            return b(this)[t];
                        }
                    });
                }
                function l(e1, t, r, o) {
                    if (r = m(r), e1 = b(e1), r + t > e1.byteLength) throw O(S);
                    var n = b(e1.buffer).bytes, r = r + e1.byteOffset, e1 = n.slice(r, r + t);
                    return o ? e1 : e1.reverse();
                }
                function u(e1, t, r, o, n, s) {
                    if (r = m(r), e1 = b(e1), r + t > e1.byteLength) throw O(S);
                    for(var i = b(e1.buffer).bytes, a = r + e1.byteOffset, l = o(+n), u = 0; u < t; u++)i[a + u] = l[s ? u : t - u - 1];
                }
                var c = e1("../internals/global"), d = e1("../internals/descriptors"), U = e1("../internals/array-buffer-native"), N = e1("../internals/create-non-enumerable-property"), f = e1("../internals/redefine-all"), h = e1("../internals/fails"), p = e1("../internals/an-instance"), B = e1("../internals/to-integer"), G = e1("../internals/to-length"), m = e1("../internals/to-index"), y = e1("../internals/ieee754"), V = e1("../internals/object-get-prototype-of"), g = e1("../internals/object-set-prototype-of"), z = e1("../internals/object-get-own-property-names").f, H = e1("../internals/object-define-property").f, W = e1("../internals/array-fill"), v = e1("../internals/set-to-string-tag"), e1 = e1("../internals/internal-state"), b = e1.get, j = e1.set, _ = "ArrayBuffer", x = "DataView", w = "prototype", S = "Wrong index", E = c[_], M = E, T = c[x], e1 = T && T[w], k = Object.prototype, O = c.RangeError, C = y.pack, A = y.unpack;
                if (U) {
                    if (!h(function() {
                        E(1);
                    }) || !h(function() {
                        new E(-1);
                    }) || h(function() {
                        return new E, new E(1.5), new E(NaN), E.name != _;
                    })) {
                        for(var P, c = (M = function(e1) {
                            return p(this, M), new E(m(e1));
                        })[w] = E[w], L = z(E), R = 0; L.length > R;)(P = L[R++]) in M || N(M, P, E[P]);
                        c.constructor = M;
                    }
                    g && V(e1) !== k && g(e1, k);
                    var y = new T(new M(2)), I = e1.setInt8;
                    y.setInt8(0, 2147483648), y.setInt8(1, 2147483649), !y.getInt8(0) && y.getInt8(1) || f(e1, {
                        setInt8: function(e1, t) {
                            I.call(this, e1, t << 24 >> 24);
                        },
                        setUint8: function(e1, t) {
                            I.call(this, e1, t << 24 >> 24);
                        }
                    }, {
                        unsafe: !0
                    });
                } else M = function(e1) {
                    p(this, M, _);
                    e1 = m(e1);
                    j(this, {
                        bytes: W.call(new Array(e1), 0),
                        byteLength: e1
                    }), d || (this.byteLength = e1);
                }, T = function(e1, t, r) {
                    p(this, T, x), p(e1, M, x);
                    var o = b(e1).byteLength, t = B(t);
                    if (t < 0 || o < t) throw O("Wrong offset");
                    if (o < t + (r = void 0 === r ? o - t : G(r))) throw O("Wrong length");
                    j(this, {
                        buffer: e1,
                        byteLength: r,
                        byteOffset: t
                    }), d || (this.buffer = e1, this.byteLength = r, this.byteOffset = t);
                }, d && (a(M, "byteLength"), a(T, "buffer"), a(T, "byteLength"), a(T, "byteOffset")), f(T[w], {
                    getInt8: function(e1) {
                        return l(this, 1, e1)[0] << 24 >> 24;
                    },
                    getUint8: function(e1) {
                        return l(this, 1, e1)[0];
                    },
                    getInt16: function(e1) {
                        e1 = l(this, 2, e1, 1 < arguments.length ? arguments[1] : void 0);
                        return (e1[1] << 8 | e1[0]) << 16 >> 16;
                    },
                    getUint16: function(e1) {
                        e1 = l(this, 2, e1, 1 < arguments.length ? arguments[1] : void 0);
                        return e1[1] << 8 | e1[0];
                    },
                    getInt32: function(e1) {
                        return s(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0));
                    },
                    getUint32: function(e1) {
                        return s(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0)) >>> 0;
                    },
                    getFloat32: function(e1) {
                        return A(l(this, 4, e1, 1 < arguments.length ? arguments[1] : void 0), 23);
                    },
                    getFloat64: function(e1) {
                        return A(l(this, 8, e1, 1 < arguments.length ? arguments[1] : void 0), 52);
                    },
                    setInt8: function(e1, t) {
                        u(this, 1, e1, r, t);
                    },
                    setUint8: function(e1, t) {
                        u(this, 1, e1, r, t);
                    },
                    setInt16: function(e1, t) {
                        u(this, 2, e1, o, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setUint16: function(e1, t) {
                        u(this, 2, e1, o, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setInt32: function(e1, t) {
                        u(this, 4, e1, n, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setUint32: function(e1, t) {
                        u(this, 4, e1, n, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setFloat32: function(e1, t) {
                        u(this, 4, e1, i, t, 2 < arguments.length ? arguments[2] : void 0);
                    },
                    setFloat64: function(e1, t) {
                        u(this, 8, e1, F, t, 2 < arguments.length ? arguments[2] : void 0);
                    }
                });
                v(M, _), v(T, x), t.exports = {
                    ArrayBuffer: M,
                    DataView: T
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-buffer-native": 11,
                "../internals/array-fill": 15,
                "../internals/create-non-enumerable-property": 38,
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 59,
                "../internals/ieee754": 65,
                "../internals/internal-state": 70,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-names": 95,
                "../internals/object-get-prototype-of": 97,
                "../internals/object-set-prototype-of": 101,
                "../internals/redefine-all": 107,
                "../internals/set-to-string-tag": 117,
                "../internals/to-index": 133,
                "../internals/to-integer": 135,
                "../internals/to-length": 136
            }
        ],
        14: [
            function(e1, t, r) {
                "use strict";
                var l = e1("../internals/to-object"), u = e1("../internals/to-absolute-index"), c = e1("../internals/to-length"), d = Math.min;
                t.exports = [].copyWithin || function(e1, t) {
                    var r = l(this), o = c(r.length), n = u(e1, o), s = u(t, o), e1 = 2 < arguments.length ? arguments[2] : void 0, i = d((void 0 === e1 ? o : u(e1, o)) - s, o - n), a = 1;
                    for(s < n && n < s + i && (a = -1, s += i - 1, n += i - 1); 0 < i--;)s in r ? r[n] = r[s] : delete r[n], n += a, s += a;
                    return r;
                };
            },
            {
                "../internals/to-absolute-index": 132,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        15: [
            function(e1, t, r) {
                "use strict";
                var i = e1("../internals/to-object"), a = e1("../internals/to-absolute-index"), l = e1("../internals/to-length");
                t.exports = function(e1) {
                    for(var t = i(this), r = l(t.length), o = arguments.length, n = a(1 < o ? arguments[1] : void 0, r), o = 2 < o ? arguments[2] : void 0, s = void 0 === o ? r : a(o, r); n < s;)t[n++] = e1;
                    return t;
                };
            },
            {
                "../internals/to-absolute-index": 132,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        16: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-iteration").forEach, n = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), n = n("forEach"), e1 = e1("forEach");
                t.exports = n && e1 ? [].forEach : function(e1) {
                    return o(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                };
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23
            }
        ],
        17: [
            function(e1, t, r) {
                "use strict";
                var h = e1("../internals/function-bind-context"), p = e1("../internals/to-object"), m = e1("../internals/call-with-safe-iteration-closing"), y = e1("../internals/is-array-iterator-method"), g = e1("../internals/to-length"), v = e1("../internals/create-property"), b = e1("../internals/get-iterator-method");
                t.exports = function(e1) {
                    var t, r, o, n, s, i, a = p(e1), e1 = "function" == typeof this ? this : Array, l = arguments.length, u = 1 < l ? arguments[1] : void 0, c = void 0 !== u, d = b(a), f = 0;
                    if (c && (u = h(u, 2 < l ? arguments[2] : void 0, 2)), null == d || e1 == Array && y(d)) for(r = new e1(t = g(a.length)); f < t; f++)i = c ? u(a[f], f) : a[f], v(r, f, i);
                    else for(s = (n = d.call(a)).next, r = new e1; !(o = s.call(n)).done; f++)i = c ? m(n, u, [
                        o.value,
                        f
                    ], !0) : o.value, v(r, f, i);
                    return r.length = f, r;
                };
            },
            {
                "../internals/call-with-safe-iteration-closing": 26,
                "../internals/create-property": 40,
                "../internals/function-bind-context": 54,
                "../internals/get-iterator-method": 57,
                "../internals/is-array-iterator-method": 71,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        18: [
            function(e1, t, r) {
                function o(a) {
                    return function(e1, t, r) {
                        var o, n = l(e1), s = u(n.length), i = c(r, s);
                        if (a && t != t) {
                            for(; i < s;)if ((o = n[i++]) != o) return !0;
                        } else for(; i < s; i++)if ((a || i in n) && n[i] === t) return a || i || 0;
                        return !a && -1;
                    };
                }
                var l = e1("../internals/to-indexed-object"), u = e1("../internals/to-length"), c = e1("../internals/to-absolute-index");
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/to-absolute-index": 132,
                "../internals/to-indexed-object": 134,
                "../internals/to-length": 136
            }
        ],
        19: [
            function(e1, t, r) {
                function o(f) {
                    var h = 1 == f, p = 2 == f, m = 3 == f, y = 4 == f, g = 6 == f, v = 5 == f || g;
                    return function(e1, t, r, o) {
                        for(var n, s, i = _(e1), a = j(i), l = b(t, r, 3), u = x(a.length), c = 0, t = o || w, d = h ? t(e1, u) : p ? t(e1, 0) : void 0; c < u; c++)if ((v || c in a) && (s = l(n = a[c], c, i), f)) {
                            if (h) d[c] = s;
                            else if (s) switch(f){
                                case 3:
                                    return !0;
                                case 5:
                                    return n;
                                case 6:
                                    return c;
                                case 2:
                                    S.call(d, n);
                            }
                            else if (y) return !1;
                        }
                        return g ? -1 : m || y ? y : d;
                    };
                }
                var b = e1("../internals/function-bind-context"), j = e1("../internals/indexed-object"), _ = e1("../internals/to-object"), x = e1("../internals/to-length"), w = e1("../internals/array-species-create"), S = [].push;
                t.exports = {
                    forEach: o(0),
                    map: o(1),
                    filter: o(2),
                    some: o(3),
                    every: o(4),
                    find: o(5),
                    findIndex: o(6)
                };
            },
            {
                "../internals/array-species-create": 25,
                "../internals/function-bind-context": 54,
                "../internals/indexed-object": 66,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        20: [
            function(e1, t, r) {
                "use strict";
                var n = e1("../internals/to-indexed-object"), s = e1("../internals/to-integer"), i = e1("../internals/to-length"), o = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), a = Math.min, l = [].lastIndexOf, u = !!l && 1 / [
                    1
                ].lastIndexOf(1, -0) < 0, o = o("lastIndexOf"), e1 = e1("indexOf", {
                    ACCESSORS: !0,
                    1: 0
                });
                t.exports = u || !o || !e1 ? function(e1) {
                    if (u) return l.apply(this, arguments) || 0;
                    var t = n(this), r = i(t.length), o = r - 1;
                    for((o = 1 < arguments.length ? a(o, s(arguments[1])) : o) < 0 && (o = r + o); 0 <= o; o--)if (o in t && t[o] === e1) return o || 0;
                    return -1;
                } : l;
            },
            {
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/to-indexed-object": 134,
                "../internals/to-integer": 135,
                "../internals/to-length": 136
            }
        ],
        21: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/well-known-symbol"), s = e1("../internals/engine-v8-version"), i = n("species");
                t.exports = function(t) {
                    return 51 <= s || !o(function() {
                        var e1 = [];
                        return (e1.constructor = {})[i] = function() {
                            return {
                                foo: 1
                            };
                        }, 1 !== e1[t](Boolean).foo;
                    });
                };
            },
            {
                "../internals/engine-v8-version": 48,
                "../internals/fails": 51,
                "../internals/well-known-symbol": 148
            }
        ],
        22: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fails");
                t.exports = function(e1, t) {
                    var r = [][e1];
                    return !!r && o(function() {
                        r.call(null, t || function() {
                            throw 1;
                        }, 1);
                    });
                };
            },
            {
                "../internals/fails": 51
            }
        ],
        23: [
            function(e1, t, r) {
                function i(e1) {
                    throw e1;
                }
                var a = e1("../internals/descriptors"), l = e1("../internals/fails"), u = e1("../internals/has"), c = Object.defineProperty, d = {};
                t.exports = function(e1, t) {
                    var r, o, n, s;
                    return u(d, e1) ? d[e1] : (r = [][e1], o = !!u(t = t || {}, "ACCESSORS") && t.ACCESSORS, n = u(t, 0) ? t[0] : i, s = u(t, 1) ? t[1] : void 0, d[e1] = !!r && !l(function() {
                        if (o && !a) return !0;
                        var e1 = {
                            length: -1
                        };
                        o ? c(e1, 1, {
                            enumerable: !0,
                            get: i
                        }) : e1[1] = 1, r.call(e1, n, s);
                    }));
                };
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/has": 60
            }
        ],
        24: [
            function(e1, t, r) {
                function o(u) {
                    return function(e1, t, r, o) {
                        c(t);
                        var n = d(e1), s = f(n), i = h(n.length), a = u ? i - 1 : 0, l = u ? -1 : 1;
                        if (r < 2) for(;;){
                            if (a in s) {
                                o = s[a], a += l;
                                break;
                            }
                            if (a += l, u ? a < 0 : i <= a) throw TypeError("Reduce of empty array with no initial value");
                        }
                        for(; u ? 0 <= a : a < i; a += l)a in s && (o = t(o, s[a], a, n));
                        return o;
                    };
                }
                var c = e1("../internals/a-function"), d = e1("../internals/to-object"), f = e1("../internals/indexed-object"), h = e1("../internals/to-length");
                t.exports = {
                    left: o(!1),
                    right: o(!0)
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/indexed-object": 66,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        25: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/is-array"), s = e1("../internals/well-known-symbol")("species");
                t.exports = function(e1, t) {
                    var r;
                    return new (void 0 === (r = n(e1) && ("function" == typeof (r = e1.constructor) && (r === Array || n(r.prototype)) || o(r) && null === (r = r[s])) ? void 0 : r) ? Array : r)(0 === t ? 0 : t);
                };
            },
            {
                "../internals/is-array": 72,
                "../internals/is-object": 74,
                "../internals/well-known-symbol": 148
            }
        ],
        26: [
            function(e1, t, r) {
                var n = e1("../internals/an-object");
                t.exports = function(t, e1, r, o) {
                    try {
                        return o ? e1(n(r)[0], r[1]) : e1(r);
                    } catch (e1) {
                        o = t.return;
                        throw void 0 !== o && n(o.call(t)), e1;
                    }
                };
            },
            {
                "../internals/an-object": 10
            }
        ],
        27: [
            function(e1, t, r) {
                var n = e1("../internals/well-known-symbol")("iterator"), s = !1;
                try {
                    var o = 0, i = {
                        next: function() {
                            return {
                                done: !!o++
                            };
                        },
                        return: function() {
                            s = !0;
                        }
                    };
                    i[n] = function() {
                        return this;
                    }, Array.from(i, function() {
                        throw 2;
                    });
                } catch (e1) {}
                t.exports = function(e1, t) {
                    if (!t && !s) return !1;
                    var r = !1;
                    try {
                        var o = {};
                        o[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e1(o);
                    } catch (e1) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 148
            }
        ],
        28: [
            function(e1, t, r) {
                var o = {}.toString;
                t.exports = function(e1) {
                    return o.call(e1).slice(8, -1);
                };
            },
            {}
        ],
        29: [
            function(e1, t, r) {
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/classof-raw"), s = e1("../internals/well-known-symbol")("toStringTag"), i = "Arguments" == n(function() {
                    return arguments;
                }());
                t.exports = o ? n : function(e1) {
                    var t;
                    return void 0 === e1 ? "Undefined" : null === e1 ? "Null" : "string" == typeof (t = function(e1, t) {
                        try {
                            return e1[t];
                        } catch (e1) {}
                    }(e1 = Object(e1), s)) ? t : i ? n(e1) : "Object" == (t = n(e1)) && "function" == typeof e1.callee ? "Arguments" : t;
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/to-string-tag-support": 141,
                "../internals/well-known-symbol": 148
            }
        ],
        30: [
            function(e1, t, r) {
                "use strict";
                var u = e1("../internals/object-define-property").f, c = e1("../internals/object-create"), d = e1("../internals/redefine-all"), f = e1("../internals/function-bind-context"), h = e1("../internals/an-instance"), p = e1("../internals/iterate"), i = e1("../internals/define-iterator"), a = e1("../internals/set-species"), m = e1("../internals/descriptors"), y = e1("../internals/internal-metadata").fastKey, e1 = e1("../internals/internal-state"), g = e1.set, v = e1.getterFor;
                t.exports = {
                    getConstructor: function(e1, r, o, n) {
                        function s(e1, t, r) {
                            var o, n = l(e1), s = i(e1, t);
                            return s ? s.value = r : (n.last = s = {
                                index: o = y(t, !0),
                                key: t,
                                value: r,
                                previous: t = n.last,
                                next: void 0,
                                removed: !1
                            }, n.first || (n.first = s), t && (t.next = s), m ? n.size++ : e1.size++, "F" !== o && (n.index[o] = s)), e1;
                        }
                        function i(e1, t) {
                            var r, e1 = l(e1), o = y(t);
                            if ("F" !== o) return e1.index[o];
                            for(r = e1.first; r; r = r.next)if (r.key == t) return r;
                        }
                        var a = e1(function(e1, t) {
                            h(e1, a, r), g(e1, {
                                type: r,
                                index: c(null),
                                first: void 0,
                                last: void 0,
                                size: 0
                            }), m || (e1.size = 0), null != t && p(t, e1[n], e1, o);
                        }), l = v(r);
                        return d(a.prototype, {
                            clear: function() {
                                for(var e1 = l(this), t = e1.index, r = e1.first; r;)r.removed = !0, r.previous && (r.previous = r.previous.next = void 0), delete t[r.index], r = r.next;
                                e1.first = e1.last = void 0, m ? e1.size = 0 : this.size = 0;
                            },
                            delete: function(e1) {
                                var t, r, o = l(this), e1 = i(this, e1);
                                return e1 && (t = e1.next, r = e1.previous, delete o.index[e1.index], e1.removed = !0, r && (r.next = t), t && (t.previous = r), o.first == e1 && (o.first = t), o.last == e1 && (o.last = r), m ? o.size-- : this.size--), !!e1;
                            },
                            forEach: function(e1) {
                                for(var t, r = l(this), o = f(e1, 1 < arguments.length ? arguments[1] : void 0, 3); t = t ? t.next : r.first;)for(o(t.value, t.key, this); t && t.removed;)t = t.previous;
                            },
                            has: function(e1) {
                                return !!i(this, e1);
                            }
                        }), d(a.prototype, o ? {
                            get: function(e1) {
                                e1 = i(this, e1);
                                return e1 && e1.value;
                            },
                            set: function(e1, t) {
                                return s(this, 0 === e1 ? 0 : e1, t);
                            }
                        } : {
                            add: function(e1) {
                                return s(this, e1 = 0 === e1 ? 0 : e1, e1);
                            }
                        }), m && u(a.prototype, "size", {
                            get: function() {
                                return l(this).size;
                            }
                        }), a;
                    },
                    setStrong: function(e1, t, r) {
                        var o = t + " Iterator", n = v(t), s = v(o);
                        i(e1, t, function(e1, t) {
                            g(this, {
                                type: o,
                                target: e1,
                                state: n(e1),
                                kind: t,
                                last: void 0
                            });
                        }, function() {
                            for(var e1 = s(this), t = e1.kind, r = e1.last; r && r.removed;)r = r.previous;
                            return e1.target && (e1.last = r = r ? r.next : e1.state.first) ? "keys" == t ? {
                                value: r.key,
                                done: !1
                            } : "values" == t ? {
                                value: r.value,
                                done: !1
                            } : {
                                value: [
                                    r.key,
                                    r.value
                                ],
                                done: !1
                            } : {
                                value: e1.target = void 0,
                                done: !0
                            };
                        }, r ? "entries" : "values", !r, !0), a(t);
                    }
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/define-iterator": 41,
                "../internals/descriptors": 43,
                "../internals/function-bind-context": 54,
                "../internals/internal-metadata": 69,
                "../internals/internal-state": 70,
                "../internals/iterate": 77,
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/redefine-all": 107,
                "../internals/set-species": 116
            }
        ],
        31: [
            function(e1, t, r) {
                "use strict";
                function l(e1) {
                    return e1.frozen || (e1.frozen = new o);
                }
                function o() {
                    this.entries = [];
                }
                function n(e1, t) {
                    return i(e1.entries, function(e1) {
                        return e1[0] === t;
                    });
                }
                var u = e1("../internals/redefine-all"), c = e1("../internals/internal-metadata").getWeakData, d = e1("../internals/an-object"), f = e1("../internals/is-object"), h = e1("../internals/an-instance"), p = e1("../internals/iterate"), s = e1("../internals/array-iteration"), m = e1("../internals/has"), e1 = e1("../internals/internal-state"), y = e1.set, g = e1.getterFor, i = s.find, a = s.findIndex, v = 0;
                o.prototype = {
                    get: function(e1) {
                        e1 = n(this, e1);
                        if (e1) return e1[1];
                    },
                    has: function(e1) {
                        return !!n(this, e1);
                    },
                    set: function(e1, t) {
                        var r = n(this, e1);
                        r ? r[1] = t : this.entries.push([
                            e1,
                            t
                        ]);
                    },
                    delete: function(t) {
                        var e1 = a(this.entries, function(e1) {
                            return e1[0] === t;
                        });
                        return ~e1 && this.entries.splice(e1, 1), !!~e1;
                    }
                }, t.exports = {
                    getConstructor: function(e1, r, o, n) {
                        function s(e1, t, r) {
                            var o = a(e1), n = c(d(t), !0);
                            return !0 === n ? l(o).set(t, r) : n[o.id] = r, e1;
                        }
                        var i = e1(function(e1, t) {
                            h(e1, i, r), y(e1, {
                                type: r,
                                id: v++,
                                frozen: void 0
                            }), null != t && p(t, e1[n], e1, o);
                        }), a = g(r);
                        return u(i.prototype, {
                            delete: function(e1) {
                                var t, r = a(this);
                                return !!f(e1) && (!0 === (t = c(e1)) ? l(r).delete(e1) : t && m(t, r.id) && delete t[r.id]);
                            },
                            has: function(e1) {
                                var t, r = a(this);
                                return !!f(e1) && (!0 === (t = c(e1)) ? l(r).has(e1) : t && m(t, r.id));
                            }
                        }), u(i.prototype, o ? {
                            get: function(e1) {
                                var t, r = a(this);
                                if (f(e1)) return !0 === (t = c(e1)) ? l(r).get(e1) : t ? t[r.id] : void 0;
                            },
                            set: function(e1, t) {
                                return s(this, e1, t);
                            }
                        } : {
                            add: function(e1) {
                                return s(this, e1, !0);
                            }
                        }), i;
                    }
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/an-object": 10,
                "../internals/array-iteration": 19,
                "../internals/has": 60,
                "../internals/internal-metadata": 69,
                "../internals/internal-state": 70,
                "../internals/is-object": 74,
                "../internals/iterate": 77,
                "../internals/redefine-all": 107
            }
        ],
        32: [
            function(e1, t, r) {
                "use strict";
                var y = e1("../internals/export"), g = e1("../internals/global"), v = e1("../internals/is-forced"), b = e1("../internals/redefine"), j = e1("../internals/internal-metadata"), _ = e1("../internals/iterate"), x = e1("../internals/an-instance"), w = e1("../internals/is-object"), S = e1("../internals/fails"), E = e1("../internals/check-correctness-of-iteration"), M = e1("../internals/set-to-string-tag"), T = e1("../internals/inherit-if-required");
                t.exports = function(r, e1, t) {
                    function o(e1) {
                        var r = h[e1];
                        b(h, e1, "add" == e1 ? function(e1) {
                            return r.call(this, 0 === e1 ? 0 : e1), this;
                        } : "delete" == e1 ? function(e1) {
                            return !(c && !w(e1)) && r.call(this, 0 === e1 ? 0 : e1);
                        } : "get" == e1 ? function(e1) {
                            return c && !w(e1) ? void 0 : r.call(this, 0 === e1 ? 0 : e1);
                        } : "has" == e1 ? function(e1) {
                            return !(c && !w(e1)) && r.call(this, 0 === e1 ? 0 : e1);
                        } : function(e1, t) {
                            return r.call(this, 0 === e1 ? 0 : e1, t), this;
                        });
                    }
                    var n, s, i, a, l, u = -1 !== r.indexOf("Map"), c = -1 !== r.indexOf("Weak"), d = u ? "set" : "add", f = g[r], h = f && f.prototype, p = f, m = {};
                    return v(r, "function" != typeof f || !(c || h.forEach && !S(function() {
                        (new f).entries().next();
                    }))) ? (p = t.getConstructor(e1, r, u, d), j.REQUIRED = !0) : v(r, !0) && (s = (n = new p)[d](c ? {} : -0, 1) != n, i = S(function() {
                        n.has(1);
                    }), a = E(function(e1) {
                        new f(e1);
                    }), l = !c && S(function() {
                        for(var e1 = new f, t = 5; t--;)e1[d](t, t);
                        return !e1.has(-0);
                    }), a || (((p = e1(function(e1, t) {
                        x(e1, p, r);
                        e1 = T(new f, e1, p);
                        return null != t && _(t, e1[d], e1, u), e1;
                    })).prototype = h).constructor = p), (i || l) && (o("delete"), o("has"), u && o("get")), (l || s) && o(d), c && h.clear && delete h.clear), m[r] = p, y({
                        global: !0,
                        forced: p != f
                    }, m), M(p, r), c || t.setStrong(p, r, u), p;
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/global": 59,
                "../internals/inherit-if-required": 67,
                "../internals/internal-metadata": 69,
                "../internals/is-forced": 73,
                "../internals/is-object": 74,
                "../internals/iterate": 77,
                "../internals/redefine": 108,
                "../internals/set-to-string-tag": 117
            }
        ],
        33: [
            function(e1, t, r) {
                var a = e1("../internals/has"), l = e1("../internals/own-keys"), u = e1("../internals/object-get-own-property-descriptor"), c = e1("../internals/object-define-property");
                t.exports = function(e1, t) {
                    for(var r = l(t), o = c.f, n = u.f, s = 0; s < r.length; s++){
                        var i = r[s];
                        a(e1, i) || o(e1, i, n(t, i));
                    }
                };
            },
            {
                "../internals/has": 60,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/own-keys": 103
            }
        ],
        34: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol")("match");
                t.exports = function(t) {
                    var r = /./;
                    try {
                        "/./"[t](r);
                    } catch (e1) {
                        try {
                            return r[o] = !1, "/./"[t](r);
                        } catch (e1) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 148
            }
        ],
        35: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    function e1() {}
                    return e1.prototype.constructor = null, Object.getPrototypeOf(new e1) !== e1.prototype;
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        36: [
            function(e1, t, r) {
                var s = e1("../internals/require-object-coercible"), i = /"/g;
                t.exports = function(e1, t, r, o) {
                    var e1 = String(s(e1)), n = "<" + t;
                    return "" !== r && (n += " " + r + '="' + String(o).replace(i, "&quot;") + '"'), n + ">" + e1 + "</" + t + ">";
                };
            },
            {
                "../internals/require-object-coercible": 113
            }
        ],
        37: [
            function(e1, t, r) {
                "use strict";
                function o() {
                    return this;
                }
                var n = e1("../internals/iterators-core").IteratorPrototype, s = e1("../internals/object-create"), i = e1("../internals/create-property-descriptor"), a = e1("../internals/set-to-string-tag"), l = e1("../internals/iterators");
                t.exports = function(e1, t, r) {
                    t += " Iterator";
                    return e1.prototype = s(n, {
                        next: i(1, r)
                    }), a(e1, t, !1, !0), l[t] = o, e1;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/iterators": 79,
                "../internals/iterators-core": 78,
                "../internals/object-create": 90,
                "../internals/set-to-string-tag": 117
            }
        ],
        38: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/object-define-property"), s = e1("../internals/create-property-descriptor");
                t.exports = o ? function(e1, t, r) {
                    return n.f(e1, t, s(1, r));
                } : function(e1, t, r) {
                    return e1[t] = r, e1;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/object-define-property": 92
            }
        ],
        39: [
            function(e1, t, r) {
                t.exports = function(e1, t) {
                    return {
                        enumerable: !(1 & e1),
                        configurable: !(2 & e1),
                        writable: !(4 & e1),
                        value: t
                    };
                };
            },
            {}
        ],
        40: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-primitive"), n = e1("../internals/object-define-property"), s = e1("../internals/create-property-descriptor");
                t.exports = function(e1, t, r) {
                    t = o(t);
                    t in e1 ? n.f(e1, t, s(0, r)) : e1[t] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/object-define-property": 92,
                "../internals/to-primitive": 140
            }
        ],
        41: [
            function(e1, t, r) {
                "use strict";
                function m() {
                    return this;
                }
                var y = e1("../internals/export"), g = e1("../internals/create-iterator-constructor"), v = e1("../internals/object-get-prototype-of"), b = e1("../internals/object-set-prototype-of"), j = e1("../internals/set-to-string-tag"), _ = e1("../internals/create-non-enumerable-property"), x = e1("../internals/redefine"), o = e1("../internals/well-known-symbol"), w = e1("../internals/is-pure"), S = e1("../internals/iterators"), e1 = e1("../internals/iterators-core"), E = e1.IteratorPrototype, M = e1.BUGGY_SAFARI_ITERATORS, T = o("iterator"), k = "values", O = "entries";
                t.exports = function(e1, t, r, o, n, s, i) {
                    g(r, t, o);
                    function a(e1) {
                        if (e1 === n && h) return h;
                        if (!M && e1 in d) return d[e1];
                        switch(e1){
                            case "keys":
                            case k:
                            case O:
                                return function() {
                                    return new r(this, e1);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }
                    var l, u, o = t + " Iterator", c = !1, d = e1.prototype, f = d[T] || d["@@iterator"] || n && d[n], h = !M && f || a(n), p = "Array" == t && d.entries || f;
                    if (p && (p = v(p.call(new e1)), E !== Object.prototype && p.next && (w || v(p) === E || (b ? b(p, E) : "function" != typeof p[T] && _(p, T, m)), j(p, o, !0, !0), w && (S[o] = m))), n == k && f && f.name !== k && (c = !0, h = function() {
                        return f.call(this);
                    }), w && !i || d[T] === h || _(d, T, h), S[t] = h, n) {
                        if (l = {
                            values: a(k),
                            keys: s ? h : a("keys"),
                            entries: a(O)
                        }, i) for(u in l)!M && !c && u in d || x(d, u, l[u]);
                        else y({
                            target: t,
                            proto: !0,
                            forced: M || c
                        }, l);
                    }
                    return l;
                };
            },
            {
                "../internals/create-iterator-constructor": 37,
                "../internals/create-non-enumerable-property": 38,
                "../internals/export": 50,
                "../internals/is-pure": 75,
                "../internals/iterators": 79,
                "../internals/iterators-core": 78,
                "../internals/object-get-prototype-of": 97,
                "../internals/object-set-prototype-of": 101,
                "../internals/redefine": 108,
                "../internals/set-to-string-tag": 117,
                "../internals/well-known-symbol": 148
            }
        ],
        42: [
            function(e1, t, r) {
                var o = e1("../internals/path"), n = e1("../internals/has"), s = e1("../internals/well-known-symbol-wrapped"), i = e1("../internals/object-define-property").f;
                t.exports = function(e1) {
                    var t = o.Symbol || (o.Symbol = {});
                    n(t, e1) || i(t, e1, {
                        value: s.f(e1)
                    });
                };
            },
            {
                "../internals/has": 60,
                "../internals/object-define-property": 92,
                "../internals/path": 104,
                "../internals/well-known-symbol-wrapped": 147
            }
        ],
        43: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    return 7 != Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        44: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/is-object"), n = o.document, s = e1(n) && e1(n.createElement);
                t.exports = function(e1) {
                    return s ? n.createElement(e1) : {};
                };
            },
            {
                "../internals/global": 59,
                "../internals/is-object": 74
            }
        ],
        45: [
            function(e1, t, r) {
                t.exports = {
                    CSSRuleList: 0,
                    CSSStyleDeclaration: 0,
                    CSSValueList: 0,
                    ClientRectList: 0,
                    DOMRectList: 0,
                    DOMStringList: 0,
                    DOMTokenList: 1,
                    DataTransferItemList: 0,
                    FileList: 0,
                    HTMLAllCollection: 0,
                    HTMLCollection: 0,
                    HTMLFormElement: 0,
                    HTMLSelectElement: 0,
                    MediaList: 0,
                    MimeTypeArray: 0,
                    NamedNodeMap: 0,
                    NodeList: 1,
                    PaintRequestList: 0,
                    Plugin: 0,
                    PluginArray: 0,
                    SVGLengthList: 0,
                    SVGNumberList: 0,
                    SVGPathSegList: 0,
                    SVGPointList: 0,
                    SVGStringList: 0,
                    SVGTransformList: 0,
                    SourceBufferList: 0,
                    StyleSheetList: 0,
                    TextTrackCueList: 0,
                    TextTrackList: 0,
                    TouchList: 0
                };
            },
            {}
        ],
        46: [
            function(e1, t, r) {
                e1 = e1("../internals/engine-user-agent");
                t.exports = /(iphone|ipod|ipad).*applewebkit/i.test(e1);
            },
            {
                "../internals/engine-user-agent": 47
            }
        ],
        47: [
            function(e1, t, r) {
                e1 = e1("../internals/get-built-in");
                t.exports = e1("navigator", "userAgent") || "";
            },
            {
                "../internals/get-built-in": 56
            }
        ],
        48: [
            function(e1, t, r) {
                var o, n, s = e1("../internals/global"), e1 = e1("../internals/engine-user-agent"), s = s.process, s = s && s.versions, s = s && s.v8;
                s ? n = (o = s.split("."))[0] + o[1] : e1 && (!(o = e1.match(/Edge\/(\d+)/)) || 74 <= o[1]) && (o = e1.match(/Chrome\/(\d+)/)) && (n = o[1]), t.exports = n && +n;
            },
            {
                "../internals/engine-user-agent": 47,
                "../internals/global": 59
            }
        ],
        49: [
            function(e1, t, r) {
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        50: [
            function(e1, t, r) {
                var u = e1("../internals/global"), c = e1("../internals/object-get-own-property-descriptor").f, d = e1("../internals/create-non-enumerable-property"), f = e1("../internals/redefine"), h = e1("../internals/set-global"), p = e1("../internals/copy-constructor-properties"), m = e1("../internals/is-forced");
                t.exports = function(e1, t) {
                    var r, o, n, s = e1.target, i = e1.global, a = e1.stat, l = i ? u : a ? u[s] || h(s, {}) : (u[s] || {}).prototype;
                    if (l) for(r in t){
                        if (o = t[r], n = e1.noTargetGet ? (n = c(l, r)) && n.value : l[r], !m(i ? r : s + (a ? "." : "#") + r, e1.forced) && void 0 !== n) {
                            if (typeof o == typeof n) continue;
                            p(o, n);
                        }
                        (e1.sham || n && n.sham) && d(o, "sham", !0), f(l, r, o, e1);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 33,
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 59,
                "../internals/is-forced": 73,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/redefine": 108,
                "../internals/set-global": 115
            }
        ],
        51: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    try {
                        return !!e1();
                    } catch (e1) {
                        return !0;
                    }
                };
            },
            {}
        ],
        52: [
            function(e1, t, r) {
                "use strict";
                e1("../modules/es.regexp.exec");
                var u = e1("../internals/redefine"), c = e1("../internals/fails"), d = e1("../internals/well-known-symbol"), f = e1("../internals/regexp-exec"), h = e1("../internals/create-non-enumerable-property"), p = d("species"), m = !c(function() {
                    var e1 = /./;
                    return e1.exec = function() {
                        var e1 = [];
                        return e1.groups = {
                            a: "7"
                        }, e1;
                    }, "7" !== "".replace(e1, "$<a>");
                }), y = "$0" === "a".replace(/./, "$0"), e1 = d("replace"), g = !!/./[e1] && "" === /./[e1]("a", "$0"), v = !c(function() {
                    var e1 = /(?:)/, t = e1.exec, e1 = (e1.exec = function() {
                        return t.apply(this, arguments);
                    }, "ab".split(e1));
                    return 2 !== e1.length || "a" !== e1[0] || "b" !== e1[1];
                });
                t.exports = function(r, e1, t, o) {
                    var s, n, i = d(r), a = !c(function() {
                        var e1 = {};
                        return e1[i] = function() {
                            return 7;
                        }, 7 != ""[r](e1);
                    }), l = a && !c(function() {
                        var e1 = !1, t = /a/;
                        return "split" === r && ((t = {
                            constructor: {}
                        }).constructor[p] = function() {
                            return t;
                        }, t.flags = "", t[i] = /./[i]), t.exec = function() {
                            return e1 = !0, null;
                        }, t[i](""), !e1;
                    });
                    a && l && ("replace" !== r || m && y && !g) && ("split" !== r || v) || (s = /./[i], t = (l = t(i, ""[r], function(e1, t, r, o, n) {
                        return t.exec === f ? a && !n ? {
                            done: !0,
                            value: s.call(t, r, o)
                        } : {
                            done: !0,
                            value: e1.call(r, t, o)
                        } : {
                            done: !1
                        };
                    }, {
                        REPLACE_KEEPS_$0: y,
                        REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: g
                    }))[0], n = l[1], u(String.prototype, r, t), u(RegExp.prototype, i, 2 == e1 ? function(e1, t) {
                        return n.call(e1, this, t);
                    } : function(e1) {
                        return n.call(e1, this);
                    })), o && h(RegExp.prototype[i], "sham", !0);
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/fails": 51,
                "../internals/redefine": 108,
                "../internals/regexp-exec": 110,
                "../internals/well-known-symbol": 148,
                "../modules/es.regexp.exec": 185
            }
        ],
        53: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !e1(function() {
                    return Object.isExtensible(Object.preventExtensions({}));
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        54: [
            function(e1, t, r) {
                var s = e1("../internals/a-function");
                t.exports = function(o, n, e1) {
                    if (s(o), void 0 === n) return o;
                    switch(e1){
                        case 0:
                            return function() {
                                return o.call(n);
                            };
                        case 1:
                            return function(e1) {
                                return o.call(n, e1);
                            };
                        case 2:
                            return function(e1, t) {
                                return o.call(n, e1, t);
                            };
                        case 3:
                            return function(e1, t, r) {
                                return o.call(n, e1, t, r);
                            };
                    }
                    return function() {
                        return o.apply(n, arguments);
                    };
                };
            },
            {
                "../internals/a-function": 5
            }
        ],
        55: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/a-function"), n = e1("../internals/is-object"), c = [].slice, d = {};
                t.exports = Function.bind || function(i) {
                    var a = o(this), l = c.call(arguments, 1), u = function() {
                        var e1 = l.concat(c.call(arguments));
                        if (this instanceof u) {
                            var t = a, r = e1.length, o = e1;
                            if (!(r in d)) {
                                for(var n = [], s = 0; s < r; s++)n[s] = "a[" + s + "]";
                                d[r] = Function("C,a", "return new C(" + n.join(",") + ")");
                            }
                            return d[r](t, o);
                        }
                        return a.apply(i, e1);
                    };
                    return n(a.prototype) && (u.prototype = a.prototype), u;
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/is-object": 74
            }
        ],
        56: [
            function(e1, t, r) {
                function o(e1) {
                    return "function" == typeof e1 ? e1 : void 0;
                }
                var n = e1("../internals/path"), s = e1("../internals/global");
                t.exports = function(e1, t) {
                    return arguments.length < 2 ? o(n[e1]) || o(s[e1]) : n[e1] && n[e1][t] || s[e1] && s[e1][t];
                };
            },
            {
                "../internals/global": 59,
                "../internals/path": 104
            }
        ],
        57: [
            function(e1, t, r) {
                var o = e1("../internals/classof"), n = e1("../internals/iterators"), s = e1("../internals/well-known-symbol")("iterator");
                t.exports = function(e1) {
                    if (null != e1) return e1[s] || e1["@@iterator"] || n[o(e1)];
                };
            },
            {
                "../internals/classof": 29,
                "../internals/iterators": 79,
                "../internals/well-known-symbol": 148
            }
        ],
        58: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/get-iterator-method");
                t.exports = function(e1) {
                    var t = n(e1);
                    if ("function" != typeof t) throw TypeError(String(e1) + " is not iterable");
                    return o(t.call(e1));
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/get-iterator-method": 57
            }
        ],
        59: [
            function(e1, r, t) {
                (function(e1) {
                    function t(e1) {
                        return e1 && e1.Math == Math && e1;
                    }
                    r.exports = t("object" == typeof globalThis && globalThis) || t("object" == typeof window && window) || t("object" == typeof self && self) || t("object" == typeof e1 && e1) || Function("return this")();
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        60: [
            function(e1, t, r) {
                var o = {}.hasOwnProperty;
                t.exports = function(e1, t) {
                    return o.call(e1, t);
                };
            },
            {}
        ],
        61: [
            function(e1, t, r) {
                t.exports = {};
            },
            {}
        ],
        62: [
            function(e1, t, r) {
                var o = e1("../internals/global");
                t.exports = function(e1, t) {
                    var r = o.console;
                    r && r.error && (1 === arguments.length ? r.error(e1) : r.error(e1, t));
                };
            },
            {
                "../internals/global": 59
            }
        ],
        63: [
            function(e1, t, r) {
                e1 = e1("../internals/get-built-in");
                t.exports = e1("document", "documentElement");
            },
            {
                "../internals/get-built-in": 56
            }
        ],
        64: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/fails"), s = e1("../internals/document-create-element");
                t.exports = !o && !n(function() {
                    return 7 != Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/document-create-element": 44,
                "../internals/fails": 51
            }
        ],
        65: [
            function(e1, t, r) {
                var f = Math.abs, h = Math.pow, p = Math.floor, m = Math.log, y = Math.LN2;
                t.exports = {
                    pack: function(e1, t, r) {
                        var o, n, s, i = new Array(r), a = 8 * r - t - 1, r = (1 << a) - 1, l = r >> 1, u = 23 === t ? h(2, -24) - h(2, -77) : 0, c = e1 < 0 || 0 === e1 && 1 / e1 < 0 ? 1 : 0, d = 0;
                        for((e1 = f(e1)) != e1 || e1 === 1 / 0 ? (n = e1 != e1 ? 1 : 0, o = r) : (o = p(m(e1) / y), e1 * (s = h(2, -o)) < 1 && (o--, s *= 2), 2 <= (e1 += 1 <= o + l ? u / s : u * h(2, 1 - l)) * s && (o++, s /= 2), r <= o + l ? (n = 0, o = r) : 1 <= o + l ? (n = (e1 * s - 1) * h(2, t), o += l) : (n = e1 * h(2, l - 1) * h(2, t), o = 0)); 8 <= t; i[d++] = 255 & n, n /= 256, t -= 8);
                        for(o = o << t | n, a += t; 0 < a; i[d++] = 255 & o, o /= 256, a -= 8);
                        return i[--d] |= 128 * c, i;
                    },
                    unpack: function(e1, t) {
                        var r, o = e1.length, n = 8 * o - t - 1, s = (1 << n) - 1, i = s >> 1, a = n - 7, l = o - 1, n = e1[l--], u = 127 & n;
                        for(n >>= 7; 0 < a; u = 256 * u + e1[l], l--, a -= 8);
                        for(r = u & (1 << -a) - 1, u >>= -a, a += t; 0 < a; r = 256 * r + e1[l], l--, a -= 8);
                        if (0 === u) u = 1 - i;
                        else {
                            if (u === s) return r ? NaN : n ? -1 / 0 : 1 / 0;
                            r += h(2, t), u -= i;
                        }
                        return (n ? -1 : 1) * r * h(2, u - t);
                    }
                };
            },
            {}
        ],
        66: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/classof-raw"), s = "".split;
                t.exports = o(function() {
                    return !Object("z").propertyIsEnumerable(0);
                }) ? function(e1) {
                    return "String" == n(e1) ? s.call(e1, "") : Object(e1);
                } : Object;
            },
            {
                "../internals/classof-raw": 28,
                "../internals/fails": 51
            }
        ],
        67: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/object-set-prototype-of");
                t.exports = function(e1, t, r) {
                    return n && "function" == typeof (t = t.constructor) && t !== r && o(t = t.prototype) && t !== r.prototype && n(e1, t), e1;
                };
            },
            {
                "../internals/is-object": 74,
                "../internals/object-set-prototype-of": 101
            }
        ],
        68: [
            function(e1, t, r) {
                var e1 = e1("../internals/shared-store"), o = Function.toString;
                "function" != typeof e1.inspectSource && (e1.inspectSource = function(e1) {
                    return o.call(e1);
                }), t.exports = e1.inspectSource;
            },
            {
                "../internals/shared-store": 119
            }
        ],
        69: [
            function(e1, t, r) {
                function o(e1) {
                    a(e1, c, {
                        value: {
                            objectID: "O" + ++d,
                            weakData: {}
                        }
                    });
                }
                var n = e1("../internals/hidden-keys"), s = e1("../internals/is-object"), i = e1("../internals/has"), a = e1("../internals/object-define-property").f, l = e1("../internals/uid"), u = e1("../internals/freezing"), c = l("meta"), d = 0, f = Object.isExtensible || function() {
                    return !0;
                }, h = t.exports = {
                    REQUIRED: !1,
                    fastKey: function(e1, t) {
                        if (!s(e1)) return "symbol" == typeof e1 ? e1 : ("string" == typeof e1 ? "S" : "P") + e1;
                        if (!i(e1, c)) {
                            if (!f(e1)) return "F";
                            if (!t) return "E";
                            o(e1);
                        }
                        return e1[c].objectID;
                    },
                    getWeakData: function(e1, t) {
                        if (!i(e1, c)) {
                            if (!f(e1)) return !0;
                            if (!t) return !1;
                            o(e1);
                        }
                        return e1[c].weakData;
                    },
                    onFreeze: function(e1) {
                        return u && h.REQUIRED && f(e1) && !i(e1, c) && o(e1), e1;
                    }
                };
                n[c] = !0;
            },
            {
                "../internals/freezing": 53,
                "../internals/has": 60,
                "../internals/hidden-keys": 61,
                "../internals/is-object": 74,
                "../internals/object-define-property": 92,
                "../internals/uid": 145
            }
        ],
        70: [
            function(e1, t, r) {
                var o, n, s, i, a, l, u, c, d = e1("../internals/native-weak-map"), f = e1("../internals/global"), h = e1("../internals/is-object"), p = e1("../internals/create-non-enumerable-property"), m = e1("../internals/has"), y = e1("../internals/shared-key"), e1 = e1("../internals/hidden-keys"), f = f.WeakMap;
                u = d ? (o = new f, n = o.get, s = o.has, i = o.set, a = function(e1, t) {
                    return i.call(o, e1, t), t;
                }, l = function(e1) {
                    return n.call(o, e1) || {};
                }, function(e1) {
                    return s.call(o, e1);
                }) : (e1[c = y("state")] = !0, a = function(e1, t) {
                    return p(e1, c, t), t;
                }, l = function(e1) {
                    return m(e1, c) ? e1[c] : {};
                }, function(e1) {
                    return m(e1, c);
                }), t.exports = {
                    set: a,
                    get: l,
                    has: u,
                    enforce: function(e1) {
                        return u(e1) ? l(e1) : a(e1, {});
                    },
                    getterFor: function(t) {
                        return function(e1) {
                            if (h(e1) && (e1 = l(e1)).type === t) return e1;
                            throw TypeError("Incompatible receiver, " + t + " required");
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/hidden-keys": 61,
                "../internals/is-object": 74,
                "../internals/native-weak-map": 85,
                "../internals/shared-key": 118
            }
        ],
        71: [
            function(e1, t, r) {
                var o = e1("../internals/well-known-symbol"), n = e1("../internals/iterators"), s = o("iterator"), i = Array.prototype;
                t.exports = function(e1) {
                    return void 0 !== e1 && (n.Array === e1 || i[s] === e1);
                };
            },
            {
                "../internals/iterators": 79,
                "../internals/well-known-symbol": 148
            }
        ],
        72: [
            function(e1, t, r) {
                var o = e1("../internals/classof-raw");
                t.exports = Array.isArray || function(e1) {
                    return "Array" == o(e1);
                };
            },
            {
                "../internals/classof-raw": 28
            }
        ],
        73: [
            function(e1, t, r) {
                function o(e1, t) {
                    return (e1 = a[i(e1)]) == u || e1 != l && ("function" == typeof t ? n(t) : !!t);
                }
                var n = e1("../internals/fails"), s = /#|\.prototype\./, i = o.normalize = function(e1) {
                    return String(e1).replace(s, ".").toLowerCase();
                }, a = o.data = {}, l = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 51
            }
        ],
        74: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    return "object" == typeof e1 ? null !== e1 : "function" == typeof e1;
                };
            },
            {}
        ],
        75: [
            function(e1, t, r) {
                t.exports = !1;
            },
            {}
        ],
        76: [
            function(e1, t, r) {
                var o = e1("../internals/is-object"), n = e1("../internals/classof-raw"), s = e1("../internals/well-known-symbol")("match");
                t.exports = function(e1) {
                    var t;
                    return o(e1) && (void 0 !== (t = e1[s]) ? !!t : "RegExp" == n(e1));
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/is-object": 74,
                "../internals/well-known-symbol": 148
            }
        ],
        77: [
            function(e1, t, r) {
                function f(e1, t) {
                    this.stopped = e1, this.result = t;
                }
                var h = e1("../internals/an-object"), p = e1("../internals/is-array-iterator-method"), m = e1("../internals/to-length"), y = e1("../internals/function-bind-context"), g = e1("../internals/get-iterator-method"), v = e1("../internals/call-with-safe-iteration-closing");
                (t.exports = function(e1, t, r, o, n) {
                    var s, i, a, l, u, c, d = y(t, r, o ? 2 : 1);
                    if (n) s = e1;
                    else {
                        if ("function" != typeof (t = g(e1))) throw TypeError("Target is not iterable");
                        if (p(t)) {
                            for(i = 0, a = m(e1.length); i < a; i++)if ((l = o ? d(h(c = e1[i])[0], c[1]) : d(e1[i])) && l instanceof f) return l;
                            return new f(!1);
                        }
                        s = t.call(e1);
                    }
                    for(u = s.next; !(c = u.call(s)).done;)if ("object" == typeof (l = v(s, d, c.value, o)) && l && l instanceof f) return l;
                    return new f(!1);
                }).stop = function(e1) {
                    return new f(!0, e1);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/call-with-safe-iteration-closing": 26,
                "../internals/function-bind-context": 54,
                "../internals/get-iterator-method": 57,
                "../internals/is-array-iterator-method": 71,
                "../internals/to-length": 136
            }
        ],
        78: [
            function(e1, t, r) {
                "use strict";
                var o, n, s = e1("../internals/object-get-prototype-of"), i = e1("../internals/create-non-enumerable-property"), a = e1("../internals/has"), l = e1("../internals/well-known-symbol"), e1 = e1("../internals/is-pure"), l = l("iterator"), u = !1;
                [].keys && ("next" in (n = [].keys()) ? (s = s(s(n))) !== Object.prototype && (o = s) : u = !0), null == o && (o = {}), e1 || a(o, l) || i(o, l, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: o,
                    BUGGY_SAFARI_ITERATORS: u
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/has": 60,
                "../internals/is-pure": 75,
                "../internals/object-get-prototype-of": 97,
                "../internals/well-known-symbol": 148
            }
        ],
        79: [
            function(e1, t, r) {
                t.exports = {};
            },
            {}
        ],
        80: [
            function(e1, t, r) {
                t.exports = Math.sign || function(e1) {
                    return 0 == (e1 = +e1) || e1 != e1 ? e1 : e1 < 0 ? -1 : 1;
                };
            },
            {}
        ],
        81: [
            function(e1, t, r) {
                var o, n, s, i, a, l, u, c, d = e1("../internals/global"), f = e1("../internals/object-get-own-property-descriptor").f, h = e1("../internals/classof-raw"), p = e1("../internals/task").set, e1 = e1("../internals/engine-is-ios"), m = d.MutationObserver || d.WebKitMutationObserver, y = d.process, g = d.Promise, v = "process" == h(y), h = f(d, "queueMicrotask"), f = h && h.value;
                f || (o = function() {
                    var e1, t;
                    for(v && (e1 = y.domain) && e1.exit(); n;){
                        t = n.fn, n = n.next;
                        try {
                            t();
                        } catch (e1) {
                            throw n ? i() : s = void 0, e1;
                        }
                    }
                    s = void 0, e1 && e1.enter();
                }, i = v ? function() {
                    y.nextTick(o);
                } : m && !e1 ? (a = !0, l = document.createTextNode(""), new m(o).observe(l, {
                    characterData: !0
                }), function() {
                    l.data = a = !a;
                }) : g && g.resolve ? (u = g.resolve(void 0), c = u.then, function() {
                    c.call(u, o);
                }) : function() {
                    p.call(d, o);
                }), t.exports = f || function(e1) {
                    e1 = {
                        fn: e1,
                        next: void 0
                    };
                    s && (s.next = e1), n || (n = e1, i()), s = e1;
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/engine-is-ios": 46,
                "../internals/global": 59,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/task": 130
            }
        ],
        82: [
            function(e1, t, r) {
                e1 = e1("../internals/global");
                t.exports = e1.Promise;
            },
            {
                "../internals/global": 59
            }
        ],
        83: [
            function(e1, t, r) {
                e1 = e1("../internals/fails");
                t.exports = !!Object.getOwnPropertySymbols && !e1(function() {
                    return !String(Symbol());
                });
            },
            {
                "../internals/fails": 51
            }
        ],
        84: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/well-known-symbol"), s = e1("../internals/is-pure"), i = n("iterator");
                t.exports = !o(function() {
                    var e1 = new URL("b?a=1&b=2&c=3", "http://a"), r = e1.searchParams, o = "";
                    return e1.pathname = "c%20d", r.forEach(function(e1, t) {
                        r.delete("b"), o += t + e1;
                    }), s && !e1.toJSON || !r.sort || "http://a/c%20d?a=1&c=3" !== e1.href || "3" !== r.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !r[i] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://\u0442\u0435\u0441\u0442").host || "#%D0%B1" !== new URL("http://a#\u0431").hash || "a1c3" !== o || "x" !== new URL("http://x", void 0).host;
                });
            },
            {
                "../internals/fails": 51,
                "../internals/is-pure": 75,
                "../internals/well-known-symbol": 148
            }
        ],
        85: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/inspect-source"), o = o.WeakMap;
                t.exports = "function" == typeof o && /native code/.test(e1(o));
            },
            {
                "../internals/global": 59,
                "../internals/inspect-source": 68
            }
        ],
        86: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    var r, o;
                    this.promise = new e1(function(e1, t) {
                        if (void 0 !== r || void 0 !== o) throw TypeError("Bad Promise constructor");
                        r = e1, o = t;
                    }), this.resolve = n(r), this.reject = n(o);
                }
                var n = e1("../internals/a-function");
                t.exports.f = function(e1) {
                    return new o(e1);
                };
            },
            {
                "../internals/a-function": 5
            }
        ],
        87: [
            function(e1, t, r) {
                var o = e1("../internals/is-regexp");
                t.exports = function(e1) {
                    if (o(e1)) throw TypeError("The method doesn't accept regular expressions");
                    return e1;
                };
            },
            {
                "../internals/is-regexp": 76
            }
        ],
        88: [
            function(e1, t, r) {
                var o = e1("../internals/global").isFinite;
                t.exports = Number.isFinite || function(e1) {
                    return "number" == typeof e1 && o(e1);
                };
            },
            {
                "../internals/global": 59
            }
        ],
        89: [
            function(e1, t, r) {
                "use strict";
                var f = e1("../internals/descriptors"), o = e1("../internals/fails"), h = e1("../internals/object-keys"), p = e1("../internals/object-get-own-property-symbols"), m = e1("../internals/object-property-is-enumerable"), y = e1("../internals/to-object"), g = e1("../internals/indexed-object"), n = Object.assign, s = Object.defineProperty;
                t.exports = !n || o(function() {
                    var e1, t, r, o;
                    return !(!f || 1 === n({
                        b: 1
                    }, n(s({}, "a", {
                        enumerable: !0,
                        get: function() {
                            s(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) || (t = {}, o = "abcdefghijklmnopqrst", (e1 = {})[r = Symbol()] = 7, o.split("").forEach(function(e1) {
                        t[e1] = e1;
                    }), 7 != n({}, e1)[r] || h(n({}, t)).join("") != o);
                }) ? function(e1, t) {
                    for(var r = y(e1), o = arguments.length, n = 1, s = p.f, i = m.f; n < o;)for(var a, l = g(arguments[n++]), u = s ? h(l).concat(s(l)) : h(l), c = u.length, d = 0; d < c;)a = u[d++], f && !i.call(l, a) || (r[a] = l[a]);
                    return r;
                } : n;
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/indexed-object": 66,
                "../internals/object-get-own-property-symbols": 96,
                "../internals/object-keys": 99,
                "../internals/object-property-is-enumerable": 100,
                "../internals/to-object": 137
            }
        ],
        90: [
            function(e1, t, r) {
                function o() {}
                var n, s = e1("../internals/an-object"), i = e1("../internals/object-define-properties"), a = e1("../internals/enum-bug-keys"), l = e1("../internals/hidden-keys"), u = e1("../internals/html"), c = e1("../internals/document-create-element"), e1 = e1("../internals/shared-key"), d = "prototype", f = "script", h = e1("IE_PROTO"), p = function(e1) {
                    return "<" + f + ">" + e1 + "</" + f + ">";
                }, m = function() {
                    try {
                        n = document.domain && new ActiveXObject("htmlfile");
                    } catch (e1) {}
                    m = n ? ((e1 = n).write(p("")), e1.close(), t = e1.parentWindow.Object, e1 = null, t) : (e1 = c("iframe"), t = "java" + f + ":", e1.style.display = "none", u.appendChild(e1), e1.src = String(t), (t = e1.contentWindow.document).open(), t.write(p("document.F=Object")), t.close(), t.F);
                    for(var e2, t, r = a.length; r--;)delete m[d][a[r]];
                    return m();
                };
                l[h] = !0, t.exports = Object.create || function(e1, t) {
                    var r;
                    return null !== e1 ? (o[d] = s(e1), r = new o, o[d] = null, r[h] = e1) : r = m(), void 0 === t ? r : i(r, t);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/document-create-element": 44,
                "../internals/enum-bug-keys": 49,
                "../internals/hidden-keys": 61,
                "../internals/html": 63,
                "../internals/object-define-properties": 91,
                "../internals/shared-key": 118
            }
        ],
        91: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), i = e1("../internals/object-define-property"), a = e1("../internals/an-object"), l = e1("../internals/object-keys");
                t.exports = o ? Object.defineProperties : function(e1, t) {
                    a(e1);
                    for(var r, o = l(t), n = o.length, s = 0; s < n;)i.f(e1, r = o[s++], t[r]);
                    return e1;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/descriptors": 43,
                "../internals/object-define-property": 92,
                "../internals/object-keys": 99
            }
        ],
        92: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/ie8-dom-define"), s = e1("../internals/an-object"), i = e1("../internals/to-primitive"), a = Object.defineProperty;
                r.f = o ? a : function(e1, t, r) {
                    if (s(e1), t = i(t, !0), s(r), n) try {
                        return a(e1, t, r);
                    } catch (e1) {}
                    if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
                    return "value" in r && (e1[t] = r.value), e1;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/descriptors": 43,
                "../internals/ie8-dom-define": 64,
                "../internals/to-primitive": 140
            }
        ],
        93: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/object-property-is-enumerable"), s = e1("../internals/create-property-descriptor"), i = e1("../internals/to-indexed-object"), a = e1("../internals/to-primitive"), l = e1("../internals/has"), u = e1("../internals/ie8-dom-define"), c = Object.getOwnPropertyDescriptor;
                r.f = o ? c : function(e1, t) {
                    if (e1 = i(e1), t = a(t, !0), u) try {
                        return c(e1, t);
                    } catch (e1) {}
                    if (l(e1, t)) return s(!n.f.call(e1, t), e1[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/has": 60,
                "../internals/ie8-dom-define": 64,
                "../internals/object-property-is-enumerable": 100,
                "../internals/to-indexed-object": 134,
                "../internals/to-primitive": 140
            }
        ],
        94: [
            function(e1, t, r) {
                var o = e1("../internals/to-indexed-object"), n = e1("../internals/object-get-own-property-names").f, s = {}.toString, i = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e1) {
                    if (!i || "[object Window]" != s.call(e1)) return n(o(e1));
                    try {
                        return n(e1);
                    } catch (e1) {
                        return i.slice();
                    }
                };
            },
            {
                "../internals/object-get-own-property-names": 95,
                "../internals/to-indexed-object": 134
            }
        ],
        95: [
            function(e1, t, r) {
                var o = e1("../internals/object-keys-internal"), n = e1("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e1) {
                    return o(e1, n);
                };
            },
            {
                "../internals/enum-bug-keys": 49,
                "../internals/object-keys-internal": 98
            }
        ],
        96: [
            function(e1, t, r) {
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        97: [
            function(e1, t, r) {
                var o = e1("../internals/has"), n = e1("../internals/to-object"), s = e1("../internals/shared-key"), e1 = e1("../internals/correct-prototype-getter"), i = s("IE_PROTO"), a = Object.prototype;
                t.exports = e1 ? Object.getPrototypeOf : function(e1) {
                    return e1 = n(e1), o(e1, i) ? e1[i] : "function" == typeof e1.constructor && e1 instanceof e1.constructor ? e1.constructor.prototype : e1 instanceof Object ? a : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 35,
                "../internals/has": 60,
                "../internals/shared-key": 118,
                "../internals/to-object": 137
            }
        ],
        98: [
            function(e1, t, r) {
                var i = e1("../internals/has"), a = e1("../internals/to-indexed-object"), l = e1("../internals/array-includes").indexOf, u = e1("../internals/hidden-keys");
                t.exports = function(e1, t) {
                    var r, o = a(e1), n = 0, s = [];
                    for(r in o)!i(u, r) && i(o, r) && s.push(r);
                    for(; t.length > n;)!i(o, r = t[n++]) || ~l(s, r) || s.push(r);
                    return s;
                };
            },
            {
                "../internals/array-includes": 18,
                "../internals/has": 60,
                "../internals/hidden-keys": 61,
                "../internals/to-indexed-object": 134
            }
        ],
        99: [
            function(e1, t, r) {
                var o = e1("../internals/object-keys-internal"), n = e1("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e1) {
                    return o(e1, n);
                };
            },
            {
                "../internals/enum-bug-keys": 49,
                "../internals/object-keys-internal": 98
            }
        ],
        100: [
            function(e1, t, r) {
                "use strict";
                var o = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, s = n && !o.call({
                    1: 2
                }, 1);
                r.f = s ? function(e1) {
                    e1 = n(this, e1);
                    return !!e1 && e1.enumerable;
                } : o;
            },
            {}
        ],
        101: [
            function(e1, t, r) {
                var n = e1("../internals/an-object"), s = e1("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var r, o = !1, e1 = {};
                    try {
                        (r = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(e1, []), o = e1 instanceof Array;
                    } catch (e1) {}
                    return function(e1, t) {
                        return n(e1), s(t), o ? r.call(e1, t) : e1.__proto__ = t, e1;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 6,
                "../internals/an-object": 10
            }
        ],
        102: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/classof");
                t.exports = o ? ({}).toString : function() {
                    return "[object " + n(this) + "]";
                };
            },
            {
                "../internals/classof": 29,
                "../internals/to-string-tag-support": 141
            }
        ],
        103: [
            function(e1, t, r) {
                var o = e1("../internals/get-built-in"), n = e1("../internals/object-get-own-property-names"), s = e1("../internals/object-get-own-property-symbols"), i = e1("../internals/an-object");
                t.exports = o("Reflect", "ownKeys") || function(e1) {
                    var t = n.f(i(e1)), r = s.f;
                    return r ? t.concat(r(e1)) : t;
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/get-built-in": 56,
                "../internals/object-get-own-property-names": 95,
                "../internals/object-get-own-property-symbols": 96
            }
        ],
        104: [
            function(e1, t, r) {
                e1 = e1("../internals/global");
                t.exports = e1;
            },
            {
                "../internals/global": 59
            }
        ],
        105: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    try {
                        return {
                            error: !1,
                            value: e1()
                        };
                    } catch (e1) {
                        return {
                            error: !0,
                            value: e1
                        };
                    }
                };
            },
            {}
        ],
        106: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/is-object"), s = e1("../internals/new-promise-capability");
                t.exports = function(e1, t) {
                    return o(e1), n(t) && t.constructor === e1 ? t : ((0, (e1 = s.f(e1)).resolve)(t), e1.promise);
                };
            },
            {
                "../internals/an-object": 10,
                "../internals/is-object": 74,
                "../internals/new-promise-capability": 86
            }
        ],
        107: [
            function(e1, t, r) {
                var n = e1("../internals/redefine");
                t.exports = function(e1, t, r) {
                    for(var o in t)n(e1, o, t[o], r);
                    return e1;
                };
            },
            {
                "../internals/redefine": 108
            }
        ],
        108: [
            function(e1, t, r) {
                var i = e1("../internals/global"), a = e1("../internals/create-non-enumerable-property"), l = e1("../internals/has"), u = e1("../internals/set-global"), o = e1("../internals/inspect-source"), e1 = e1("../internals/internal-state"), n = e1.get, c = e1.enforce, d = String(String).split("String");
                (t.exports = function(e1, t, r, o) {
                    var n = !!o && !!o.unsafe, s = !!o && !!o.enumerable, o = !!o && !!o.noTargetGet;
                    "function" == typeof r && ("string" != typeof t || l(r, "name") || a(r, "name", t), c(r).source = d.join("string" == typeof t ? t : "")), e1 === i ? s ? e1[t] = r : u(t, r) : (n ? !o && e1[t] && (s = !0) : delete e1[t], s ? e1[t] = r : a(e1, t, r));
                })(Function.prototype, "toString", function() {
                    return "function" == typeof this && n(this).source || o(this);
                });
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/inspect-source": 68,
                "../internals/internal-state": 70,
                "../internals/set-global": 115
            }
        ],
        109: [
            function(e1, t, r) {
                var o = e1("./classof-raw"), n = e1("./regexp-exec");
                t.exports = function(e1, t) {
                    var r = e1.exec;
                    if ("function" == typeof r) {
                        r = r.call(e1, t);
                        if ("object" != typeof r) throw TypeError("RegExp exec method returned something other than an Object or null");
                        return r;
                    }
                    if ("RegExp" !== o(e1)) throw TypeError("RegExp#exec called on incompatible receiver");
                    return n.call(e1, t);
                };
            },
            {
                "./classof-raw": 28,
                "./regexp-exec": 110
            }
        ],
        110: [
            function(e1, t, r) {
                "use strict";
                var o, n, d = e1("./regexp-flags"), e1 = e1("./regexp-sticky-helpers"), f = RegExp.prototype.exec, h = String.prototype.replace, s = f, p = (o = /a/, n = /b*/g, f.call(o, "a"), f.call(n, "a"), 0 !== o.lastIndex || 0 !== n.lastIndex), m = e1.UNSUPPORTED_Y || e1.BROKEN_CARET, y = void 0 !== /()??/.exec("")[1];
                t.exports = s = p || y || m ? function(e1) {
                    var t, r, o, n, s = this, i = m && s.sticky, a = d.call(s), l = s.source, u = 0, c = e1;
                    return i && (-1 === (a = a.replace("y", "")).indexOf("g") && (a += "g"), c = String(e1).slice(s.lastIndex), 0 < s.lastIndex && (!s.multiline || s.multiline && "\n" !== e1[s.lastIndex - 1]) && (l = "(?: " + l + ")", c = " " + c, u++), r = new RegExp("^(?:" + l + ")", a)), y && (r = new RegExp("^" + l + "$(?!\\s)", a)), p && (t = s.lastIndex), o = f.call(i ? r : s, c), i ? o ? (o.input = o.input.slice(u), o[0] = o[0].slice(u), o.index = s.lastIndex, s.lastIndex += o[0].length) : s.lastIndex = 0 : p && o && (s.lastIndex = s.global ? o.index + o[0].length : t), y && o && 1 < o.length && h.call(o[0], r, function() {
                        for(n = 1; n < arguments.length - 2; n++)void 0 === arguments[n] && (o[n] = void 0);
                    }), o;
                } : s;
            },
            {
                "./regexp-flags": 111,
                "./regexp-sticky-helpers": 112
            }
        ],
        111: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/an-object");
                t.exports = function() {
                    var e1 = o(this), t = "";
                    return e1.global && (t += "g"), e1.ignoreCase && (t += "i"), e1.multiline && (t += "m"), e1.dotAll && (t += "s"), e1.unicode && (t += "u"), e1.sticky && (t += "y"), t;
                };
            },
            {
                "../internals/an-object": 10
            }
        ],
        112: [
            function(e1, t, r) {
                "use strict";
                e1 = e1("./fails");
                function o(e1, t) {
                    return RegExp(e1, t);
                }
                r.UNSUPPORTED_Y = e1(function() {
                    var e1 = o("a", "y");
                    return e1.lastIndex = 2, null != e1.exec("abcd");
                }), r.BROKEN_CARET = e1(function() {
                    var e1 = o("^r", "gy");
                    return e1.lastIndex = 2, null != e1.exec("str");
                });
            },
            {
                "./fails": 51
            }
        ],
        113: [
            function(e1, t, r) {
                t.exports = function(e1) {
                    if (null == e1) throw TypeError("Can't call method on " + e1);
                    return e1;
                };
            },
            {}
        ],
        114: [
            function(e1, t, r) {
                t.exports = Object.is || function(e1, t) {
                    return e1 === t ? 0 !== e1 || 1 / e1 == 1 / t : e1 != e1 && t != t;
                };
            },
            {}
        ],
        115: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/create-non-enumerable-property");
                t.exports = function(t, r) {
                    try {
                        n(o, t, r);
                    } catch (e1) {
                        o[t] = r;
                    }
                    return r;
                };
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/global": 59
            }
        ],
        116: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/get-built-in"), n = e1("../internals/object-define-property"), s = e1("../internals/well-known-symbol"), i = e1("../internals/descriptors"), a = s("species");
                t.exports = function(e1) {
                    var e1 = o(e1), t = n.f;
                    i && e1 && !e1[a] && t(e1, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/descriptors": 43,
                "../internals/get-built-in": 56,
                "../internals/object-define-property": 92,
                "../internals/well-known-symbol": 148
            }
        ],
        117: [
            function(e1, t, r) {
                var o = e1("../internals/object-define-property").f, n = e1("../internals/has"), s = e1("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e1, t, r) {
                    e1 && !n(e1 = r ? e1 : e1.prototype, s) && o(e1, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has": 60,
                "../internals/object-define-property": 92,
                "../internals/well-known-symbol": 148
            }
        ],
        118: [
            function(e1, t, r) {
                var o = e1("../internals/shared"), n = e1("../internals/uid"), s = o("keys");
                t.exports = function(e1) {
                    return s[e1] || (s[e1] = n(e1));
                };
            },
            {
                "../internals/shared": 120,
                "../internals/uid": 145
            }
        ],
        119: [
            function(e1, t, r) {
                var o = e1("../internals/global"), e1 = e1("../internals/set-global"), n = "__core-js_shared__", o = o[n] || e1(n, {});
                t.exports = o;
            },
            {
                "../internals/global": 59,
                "../internals/set-global": 115
            }
        ],
        120: [
            function(e1, t, r) {
                var o = e1("../internals/is-pure"), n = e1("../internals/shared-store");
                (t.exports = function(e1, t) {
                    return n[e1] || (n[e1] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.6.5",
                    mode: o ? "pure" : "global",
                    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
                });
            },
            {
                "../internals/is-pure": 75,
                "../internals/shared-store": 119
            }
        ],
        121: [
            function(e1, t, r) {
                var o = e1("../internals/an-object"), n = e1("../internals/a-function"), s = e1("../internals/well-known-symbol")("species");
                t.exports = function(e1, t) {
                    var e1 = o(e1).constructor;
                    return void 0 === e1 || null == (e1 = o(e1)[s]) ? t : n(e1);
                };
            },
            {
                "../internals/a-function": 5,
                "../internals/an-object": 10,
                "../internals/well-known-symbol": 148
            }
        ],
        122: [
            function(e1, t, r) {
                var o = e1("../internals/fails");
                t.exports = function(t) {
                    return o(function() {
                        var e1 = ""[t]('"');
                        return e1 !== e1.toLowerCase() || 3 < e1.split('"').length;
                    });
                };
            },
            {
                "../internals/fails": 51
            }
        ],
        123: [
            function(e1, t, r) {
                function o(n) {
                    return function(e1, t) {
                        var r, e1 = String(i(e1)), t = s(t), o = e1.length;
                        return t < 0 || o <= t ? n ? "" : void 0 : (r = e1.charCodeAt(t)) < 55296 || 56319 < r || t + 1 === o || (o = e1.charCodeAt(t + 1)) < 56320 || 57343 < o ? n ? e1.charAt(t) : r : n ? e1.slice(t, t + 2) : o - 56320 + (r - 55296 << 10) + 65536;
                    };
                }
                var s = e1("../internals/to-integer"), i = e1("../internals/require-object-coercible");
                t.exports = {
                    codeAt: o(!1),
                    charAt: o(!0)
                };
            },
            {
                "../internals/require-object-coercible": 113,
                "../internals/to-integer": 135
            }
        ],
        124: [
            function(e1, t, r) {
                e1 = e1("../internals/engine-user-agent");
                t.exports = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(e1);
            },
            {
                "../internals/engine-user-agent": 47
            }
        ],
        125: [
            function(e1, t, r) {
                function o(n) {
                    return function(e1, t, r) {
                        var e1 = String(a(e1)), o = e1.length, r = void 0 === r ? " " : String(r), t = s(t);
                        return t <= o || "" == r ? e1 : ((o = i.call(r, l((t = t - o) / r.length))).length > t && (o = o.slice(0, t)), n ? e1 + o : o + e1);
                    };
                }
                var s = e1("../internals/to-length"), i = e1("../internals/string-repeat"), a = e1("../internals/require-object-coercible"), l = Math.ceil;
                t.exports = {
                    start: o(!1),
                    end: o(!0)
                };
            },
            {
                "../internals/require-object-coercible": 113,
                "../internals/string-repeat": 127,
                "../internals/to-length": 136
            }
        ],
        126: [
            function(e1, t, r) {
                "use strict";
                function g(e1) {
                    return e1 + 22 + 75 * (e1 < 26);
                }
                function s(e1) {
                    var t, r = [], o = (e1 = function(e1) {
                        for(var t = [], r = 0, o = e1.length; r < o;){
                            var n, s = e1.charCodeAt(r++);
                            55296 <= s && s <= 56319 && r < o ? 56320 == (64512 & (n = e1.charCodeAt(r++))) ? t.push(((1023 & s) << 10) + (1023 & n) + 65536) : (t.push(s), r--) : t.push(s);
                        }
                        return t;
                    }(e1)).length, n = 128, s = 0, i = 72;
                    for(c = 0; c < e1.length; c++)(t = e1[c]) < 128 && r.push(M(t));
                    var a = r.length, l = a;
                    for(a && r.push("-"); l < o;){
                        for(var u = v, c = 0; c < e1.length; c++)n <= (t = e1[c]) && t < u && (u = t);
                        var d = l + 1;
                        if (u - n > E((v - s) / d)) throw RangeError(w);
                        for(s += (u - n) * d, n = u, c = 0; c < e1.length; c++){
                            if ((t = e1[c]) < n && ++s > v) throw RangeError(w);
                            if (t == n) {
                                for(var f = s, h = b;; h += b){
                                    var p = h <= i ? 1 : i + j <= h ? j : h - i;
                                    if (f < p) break;
                                    var m = f - p, y = b - p;
                                    r.push(M(g(p + m % y))), f = E(m / y);
                                }
                                r.push(M(g(f))), i = function(e1, t, r) {
                                    var o = 0;
                                    for(e1 = r ? E(e1 / x) : e1 >> 1, e1 += E(e1 / t); S * j >> 1 < e1; o += b)e1 = E(e1 / S);
                                    return E(o + (S + 1) * e1 / (e1 + _));
                                }(s, d, l == a), s = 0, ++l;
                            }
                        }
                        ++s, ++n;
                    }
                    return r.join("");
                }
                var v = 2147483647, b = 36, j = 26, _ = 38, x = 700, i = /[^\0-\u007E]/, a = /[.\u3002\uFF0E\uFF61]/g, w = "Overflow: input needs wider integers to process", S = b - 1, E = Math.floor, M = String.fromCharCode;
                t.exports = function(e1) {
                    for(var t, r = [], o = e1.toLowerCase().replace(a, ".").split("."), n = 0; n < o.length; n++)t = o[n], r.push(i.test(t) ? "xn--" + s(t) : t);
                    return r.join(".");
                };
            },
            {}
        ],
        127: [
            function(e1, t, r) {
                "use strict";
                var n = e1("../internals/to-integer"), s = e1("../internals/require-object-coercible");
                t.exports = "".repeat || function(e1) {
                    var t = String(s(this)), r = "", o = n(e1);
                    if (o < 0 || o == 1 / 0) throw RangeError("Wrong number of repetitions");
                    for(; 0 < o; (o >>>= 1) && (t += t))1 & o && (r += t);
                    return r;
                };
            },
            {
                "../internals/require-object-coercible": 113,
                "../internals/to-integer": 135
            }
        ],
        128: [
            function(e1, t, r) {
                var o = e1("../internals/fails"), n = e1("../internals/whitespaces");
                t.exports = function(e1) {
                    return o(function() {
                        return !!n[e1]() || "\u200B\x85\u180E" != "\u200B\x85\u180E"[e1]() || n[e1].name !== e1;
                    });
                };
            },
            {
                "../internals/fails": 51,
                "../internals/whitespaces": 149
            }
        ],
        129: [
            function(e1, t, r) {
                function o(t) {
                    return function(e1) {
                        e1 = String(n(e1));
                        return 1 & t && (e1 = e1.replace(s, "")), e1 = 2 & t ? e1.replace(i, "") : e1;
                    };
                }
                var n = e1("../internals/require-object-coercible"), e1 = "[" + e1("../internals/whitespaces") + "]", s = RegExp("^" + e1 + e1 + "*"), i = RegExp(e1 + e1 + "*$");
                t.exports = {
                    start: o(1),
                    end: o(2),
                    trim: o(3)
                };
            },
            {
                "../internals/require-object-coercible": 113,
                "../internals/whitespaces": 149
            }
        ],
        130: [
            function(e1, t, r) {
                function o(e1) {
                    return function() {
                        x(e1);
                    };
                }
                function n(e1) {
                    x(e1.data);
                }
                function s(e1) {
                    a.postMessage(e1 + "", h.protocol + "//" + h.host);
                }
                var i, a = e1("../internals/global"), l = e1("../internals/fails"), u = e1("../internals/classof-raw"), c = e1("../internals/function-bind-context"), d = e1("../internals/html"), f = e1("../internals/document-create-element"), e1 = e1("../internals/engine-is-ios"), h = a.location, p = a.setImmediate, m = a.clearImmediate, y = a.process, g = a.MessageChannel, v = a.Dispatch, b = 0, j = {}, _ = "onreadystatechange", x = function(e1) {
                    var t;
                    j.hasOwnProperty(e1) && (t = j[e1], delete j[e1], t());
                };
                p && m || (p = function(e1) {
                    for(var t = [], r = 1; r < arguments.length;)t.push(arguments[r++]);
                    return j[++b] = function() {
                        ("function" == typeof e1 ? e1 : Function(e1)).apply(void 0, t);
                    }, i(b), b;
                }, m = function(e1) {
                    delete j[e1];
                }, "process" == u(y) ? i = function(e1) {
                    y.nextTick(o(e1));
                } : v && v.now ? i = function(e1) {
                    v.now(o(e1));
                } : g && !e1 ? (e1 = (u = new g).port2, u.port1.onmessage = n, i = c(e1.postMessage, e1, 1)) : !a.addEventListener || "function" != typeof postMessage || a.importScripts || l(s) || "file:" === h.protocol ? i = _ in f("script") ? function(e1) {
                    d.appendChild(f("script"))[_] = function() {
                        d.removeChild(this), x(e1);
                    };
                } : function(e1) {
                    setTimeout(o(e1), 0);
                } : (i = s, a.addEventListener("message", n, !1))), t.exports = {
                    set: p,
                    clear: m
                };
            },
            {
                "../internals/classof-raw": 28,
                "../internals/document-create-element": 44,
                "../internals/engine-is-ios": 46,
                "../internals/fails": 51,
                "../internals/function-bind-context": 54,
                "../internals/global": 59,
                "../internals/html": 63
            }
        ],
        131: [
            function(e1, t, r) {
                var o = e1("../internals/classof-raw");
                t.exports = function(e1) {
                    if ("number" != typeof e1 && "Number" != o(e1)) throw TypeError("Incorrect invocation");
                    return +e1;
                };
            },
            {
                "../internals/classof-raw": 28
            }
        ],
        132: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = Math.max, s = Math.min;
                t.exports = function(e1, t) {
                    e1 = o(e1);
                    return e1 < 0 ? n(e1 + t, 0) : s(e1, t);
                };
            },
            {
                "../internals/to-integer": 135
            }
        ],
        133: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = e1("../internals/to-length");
                t.exports = function(e1) {
                    if (void 0 === e1) return 0;
                    var e1 = o(e1), t = n(e1);
                    if (e1 !== t) throw RangeError("Wrong length or index");
                    return t;
                };
            },
            {
                "../internals/to-integer": 135,
                "../internals/to-length": 136
            }
        ],
        134: [
            function(e1, t, r) {
                var o = e1("../internals/indexed-object"), n = e1("../internals/require-object-coercible");
                t.exports = function(e1) {
                    return o(n(e1));
                };
            },
            {
                "../internals/indexed-object": 66,
                "../internals/require-object-coercible": 113
            }
        ],
        135: [
            function(e1, t, r) {
                var o = Math.ceil, n = Math.floor;
                t.exports = function(e1) {
                    return isNaN(e1 = +e1) ? 0 : (0 < e1 ? n : o)(e1);
                };
            },
            {}
        ],
        136: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer"), n = Math.min;
                t.exports = function(e1) {
                    return 0 < e1 ? n(o(e1), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer": 135
            }
        ],
        137: [
            function(e1, t, r) {
                var o = e1("../internals/require-object-coercible");
                t.exports = function(e1) {
                    return Object(o(e1));
                };
            },
            {
                "../internals/require-object-coercible": 113
            }
        ],
        138: [
            function(e1, t, r) {
                var o = e1("../internals/to-positive-integer");
                t.exports = function(e1, t) {
                    e1 = o(e1);
                    if (e1 % t) throw RangeError("Wrong offset");
                    return e1;
                };
            },
            {
                "../internals/to-positive-integer": 139
            }
        ],
        139: [
            function(e1, t, r) {
                var o = e1("../internals/to-integer");
                t.exports = function(e1) {
                    e1 = o(e1);
                    if (e1 < 0) throw RangeError("The argument can't be less than 0");
                    return e1;
                };
            },
            {
                "../internals/to-integer": 135
            }
        ],
        140: [
            function(e1, t, r) {
                var n = e1("../internals/is-object");
                t.exports = function(e1, t) {
                    if (!n(e1)) return e1;
                    var r, o;
                    if (t && "function" == typeof (r = e1.toString) && !n(o = r.call(e1)) || "function" == typeof (r = e1.valueOf) && !n(o = r.call(e1)) || !t && "function" == typeof (r = e1.toString) && !n(o = r.call(e1))) return o;
                    throw TypeError("Can't convert object to primitive value");
                };
            },
            {
                "../internals/is-object": 74
            }
        ],
        141: [
            function(e1, t, r) {
                var o = {};
                o[e1("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(o);
            },
            {
                "../internals/well-known-symbol": 148
            }
        ],
        142: [
            function(e1, t, D) {
                "use strict";
                function h(e1, t) {
                    for(var r = 0, o = t.length, n = new (Q(e1))(o); r < o;)n[r] = t[r++];
                    return n;
                }
                function r(e1, t) {
                    M(e1, t, {
                        get: function() {
                            return E(this)[t];
                        }
                    });
                }
                function p(e1) {
                    return e1 instanceof k || "ArrayBuffer" == (e1 = B(e1)) || "SharedArrayBuffer" == e1;
                }
                function o(e1, t) {
                    return L(e1) && "symbol" != typeof t && t in e1 && String(+t) == String(t);
                }
                function n(e1, t) {
                    return o(e1, t = d(t, !0)) ? U(2, e1[t]) : X(e1, t);
                }
                function s(e1, t, r) {
                    return !(o(e1, t = d(t, !0)) && b(r) && f(r, "value")) || f(r, "get") || f(r, "set") || r.configurable || f(r, "writable") && !r.writable || f(r, "enumerable") && !r.enumerable ? M(e1, t, r) : (e1[t] = r.value, e1);
                }
                var a = e1("../internals/export"), l = e1("../internals/global"), i = e1("../internals/descriptors"), F = e1("../internals/typed-array-constructors-require-wrappers"), u = e1("../internals/array-buffer-view-core"), c = e1("../internals/array-buffer"), m = e1("../internals/an-instance"), U = e1("../internals/create-property-descriptor"), y = e1("../internals/create-non-enumerable-property"), N = e1("../internals/to-length"), g = e1("../internals/to-index"), v = e1("../internals/to-offset"), d = e1("../internals/to-primitive"), f = e1("../internals/has"), B = e1("../internals/classof"), b = e1("../internals/is-object"), G = e1("../internals/object-create"), j = e1("../internals/object-set-prototype-of"), V = e1("../internals/object-get-own-property-names").f, _ = e1("../internals/typed-array-from"), z = e1("../internals/array-iteration").forEach, H = e1("../internals/set-species"), x = e1("../internals/object-define-property"), w = e1("../internals/object-get-own-property-descriptor"), S = e1("../internals/internal-state"), W = e1("../internals/inherit-if-required"), E = S.get, q = S.set, M = x.f, X = w.f, Y = Math.round, T = l.RangeError, k = c.ArrayBuffer, Z = c.DataView, O = u.NATIVE_ARRAY_BUFFER_VIEWS, C = u.TYPED_ARRAY_TAG, A = u.TypedArray, P = u.TypedArrayPrototype, Q = u.aTypedArrayConstructor, L = u.isTypedArray, R = "BYTES_PER_ELEMENT", I = "Wrong length";
                i ? (O || (w.f = n, x.f = s, r(P, "buffer"), r(P, "byteOffset"), r(P, "byteLength"), r(P, "length")), a({
                    target: "Object",
                    stat: !0,
                    forced: !O
                }, {
                    getOwnPropertyDescriptor: n,
                    defineProperty: s
                }), t.exports = function(e1, t, n) {
                    function u(e1, o) {
                        M(e1, o, {
                            get: function() {
                                var e1 = this, t = o;
                                return (e1 = E(e1)).view[r](t * c + e1.byteOffset, !0);
                            },
                            set: function(e1) {
                                var t = this, r = o;
                                t = E(t), n && (e1 = (e1 = Y(e1)) < 0 ? 0 : 255 < e1 ? 255 : 255 & e1), t.view[s](r * c + t.byteOffset, e1, !0);
                            },
                            enumerable: !0
                        });
                    }
                    var c = e1.match(/\d+$/)[0] / 8, d = e1 + (n ? "Clamped" : "") + "Array", r = "get" + e1, s = "set" + e1, i = l[d], f = i, e1 = f && f.prototype, o = {};
                    O ? F && (f = t(function(e1, t, r, o) {
                        return m(e1, f, d), W(b(t) ? p(t) ? void 0 !== o ? new i(t, v(r, c), o) : void 0 !== r ? new i(t, v(r, c)) : new i(t) : L(t) ? h(f, t) : _.call(f, t) : new i(g(t)), e1, f);
                    }), j && j(f, A), z(V(i), function(e1) {
                        e1 in f || y(f, e1, i[e1]);
                    }), f.prototype = e1) : (f = t(function(e1, t, r, o) {
                        m(e1, f, d);
                        var n, s, i = 0, a = 0;
                        if (b(t)) {
                            if (!p(t)) return L(t) ? h(f, t) : _.call(f, t);
                            var l = t, a = v(r, c), r = t.byteLength;
                            if (void 0 === o) {
                                if (r % c) throw T(I);
                                if ((n = r - a) < 0) throw T(I);
                            } else if (r < (n = N(o) * c) + a) throw T(I);
                            s = n / c;
                        } else s = g(t), l = new k(n = s * c);
                        for(q(e1, {
                            buffer: l,
                            byteOffset: a,
                            byteLength: n,
                            length: s,
                            view: new Z(l)
                        }); i < s;)u(e1, i++);
                    }), j && j(f, A), e1 = f.prototype = G(P)), e1.constructor !== f && y(e1, "constructor", f), C && y(e1, C, d), o[d] = f, a({
                        global: !0,
                        forced: f != i,
                        sham: !O
                    }, o), R in f || y(f, R, c), R in e1 || y(e1, R, c), H(d);
                }) : t.exports = function() {};
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-buffer": 13,
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/classof": 29,
                "../internals/create-non-enumerable-property": 38,
                "../internals/create-property-descriptor": 39,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/inherit-if-required": 67,
                "../internals/internal-state": 70,
                "../internals/is-object": 74,
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/object-get-own-property-names": 95,
                "../internals/object-set-prototype-of": 101,
                "../internals/set-species": 116,
                "../internals/to-index": 133,
                "../internals/to-length": 136,
                "../internals/to-offset": 138,
                "../internals/to-primitive": 140,
                "../internals/typed-array-constructors-require-wrappers": 143,
                "../internals/typed-array-from": 144
            }
        ],
        143: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/fails"), s = e1("../internals/check-correctness-of-iteration"), e1 = e1("../internals/array-buffer-view-core").NATIVE_ARRAY_BUFFER_VIEWS, i = o.ArrayBuffer, a = o.Int8Array;
                t.exports = !e1 || !n(function() {
                    a(1);
                }) || !n(function() {
                    new a(-1);
                }) || !s(function(e1) {
                    new a, new a(null), new a(1.5), new a(e1);
                }, !0) || n(function() {
                    return 1 !== new a(new i(2), 1, void 0).length;
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/fails": 51,
                "../internals/global": 59
            }
        ],
        144: [
            function(e1, t, r) {
                var f = e1("../internals/to-object"), h = e1("../internals/to-length"), p = e1("../internals/get-iterator-method"), m = e1("../internals/is-array-iterator-method"), y = e1("../internals/function-bind-context"), g = e1("../internals/array-buffer-view-core").aTypedArrayConstructor;
                t.exports = function(e1) {
                    var t, r, o, n, s, i, a = f(e1), l = arguments.length, u = 1 < l ? arguments[1] : void 0, c = void 0 !== u, d = p(a);
                    if (null != d && !m(d)) for(i = (s = d.call(a)).next, a = []; !(n = i.call(s)).done;)a.push(n.value);
                    for(c && 2 < l && (u = y(u, arguments[2], 2)), r = h(a.length), o = new (g(this))(r), t = 0; t < r; t++)o[t] = c ? u(a[t], t) : a[t];
                    return o;
                };
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/function-bind-context": 54,
                "../internals/get-iterator-method": 57,
                "../internals/is-array-iterator-method": 71,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        145: [
            function(e1, t, r) {
                var o = 0, n = Math.random();
                t.exports = function(e1) {
                    return "Symbol(" + String(void 0 === e1 ? "" : e1) + ")_" + (++o + n).toString(36);
                };
            },
            {}
        ],
        146: [
            function(e1, t, r) {
                e1 = e1("../internals/native-symbol");
                t.exports = e1 && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/native-symbol": 83
            }
        ],
        147: [
            function(e1, t, r) {
                e1 = e1("../internals/well-known-symbol");
                r.f = e1;
            },
            {
                "../internals/well-known-symbol": 148
            }
        ],
        148: [
            function(e1, t, r) {
                var o = e1("../internals/global"), n = e1("../internals/shared"), s = e1("../internals/has"), i = e1("../internals/uid"), a = e1("../internals/native-symbol"), e1 = e1("../internals/use-symbol-as-uid"), l = n("wks"), u = o.Symbol, c = e1 ? u : u && u.withoutSetter || i;
                t.exports = function(e1) {
                    return s(l, e1) || (a && s(u, e1) ? l[e1] = u[e1] : l[e1] = c("Symbol." + e1)), l[e1];
                };
            },
            {
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/native-symbol": 83,
                "../internals/shared": 120,
                "../internals/uid": 145,
                "../internals/use-symbol-as-uid": 146
            }
        ],
        149: [
            function(e1, t, r) {
                t.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
            },
            {}
        ],
        150: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/global"), s = e1("../internals/array-buffer"), e1 = e1("../internals/set-species"), i = "ArrayBuffer", s = s[i];
                o({
                    global: !0,
                    forced: n[i] !== s
                }, {
                    ArrayBuffer: s
                }), e1(i);
            },
            {
                "../internals/array-buffer": 13,
                "../internals/export": 50,
                "../internals/global": 59,
                "../internals/set-species": 116
            }
        ],
        151: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/fails"), d = e1("../internals/is-array"), f = e1("../internals/is-object"), h = e1("../internals/to-object"), p = e1("../internals/to-length"), m = e1("../internals/create-property"), y = e1("../internals/array-species-create"), s = e1("../internals/array-method-has-species-support"), i = e1("../internals/well-known-symbol"), e1 = e1("../internals/engine-v8-version"), g = i("isConcatSpreadable"), v = 9007199254740991, b = "Maximum allowed index exceeded", i = 51 <= e1 || !n(function() {
                    var e1 = [];
                    return e1[g] = !1, e1.concat()[0] !== e1;
                }), e1 = s("concat");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !i || !e1
                }, {
                    concat: function(e1) {
                        for(var t, r, o, n, s, i = h(this), a = y(i, 0), l = 0, u = -1, c = arguments.length; u < c; u++)if (s = void 0, !f(n = o = -1 === u ? i : arguments[u]) || (void 0 !== (s = n[g]) ? !s : !d(n))) {
                            if (v <= l) throw TypeError(b);
                            m(a, l++, o);
                        } else {
                            if (r = p(o.length), v < l + r) throw TypeError(b);
                            for(t = 0; t < r; t++, l++)t in o && m(a, l, o[t]);
                        }
                        return a.length = l, a;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-species-create": 25,
                "../internals/create-property": 40,
                "../internals/engine-v8-version": 48,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/is-array": 72,
                "../internals/is-object": 74,
                "../internals/to-length": 136,
                "../internals/to-object": 137,
                "../internals/well-known-symbol": 148
            }
        ],
        152: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-copy-within"), e1 = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0
                }, {
                    copyWithin: n
                }), e1("copyWithin");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-copy-within": 14,
                "../internals/export": 50
            }
        ],
        153: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").every, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), s = s("every"), e1 = e1("every");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    every: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        154: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-fill"), e1 = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0
                }, {
                    fill: n
                }), e1("fill");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-fill": 15,
                "../internals/export": 50
            }
        ],
        155: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").filter, s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("filter"), e1 = e1("filter");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    filter: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        156: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), e1 = e1("../internals/array-for-each");
                o({
                    target: "Array",
                    proto: !0,
                    forced: [].forEach != e1
                }, {
                    forEach: e1
                });
            },
            {
                "../internals/array-for-each": 16,
                "../internals/export": 50
            }
        ],
        157: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/array-from");
                o({
                    target: "Array",
                    stat: !0,
                    forced: !e1("../internals/check-correctness-of-iteration")(function(e1) {
                        Array.from(e1);
                    })
                }, {
                    from: n
                });
            },
            {
                "../internals/array-from": 17,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/export": 50
            }
        ],
        158: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-includes").includes, s = e1("../internals/add-to-unscopables");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !e1("../internals/array-method-uses-to-length")("indexOf", {
                        ACCESSORS: !0,
                        1: 0
                    })
                }, {
                    includes: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                }), s("includes");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/array-includes": 18,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        159: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-includes").indexOf, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), i = [].indexOf, a = !!i && 1 / [
                    1
                ].indexOf(1, -0) < 0, s = s("indexOf"), e1 = e1("indexOf", {
                    ACCESSORS: !0,
                    1: 0
                });
                o({
                    target: "Array",
                    proto: !0,
                    forced: a || !s || !e1
                }, {
                    indexOf: function(e1) {
                        return a ? i.apply(this, arguments) || 0 : n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-includes": 18,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        160: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/to-indexed-object"), n = e1("../internals/add-to-unscopables"), s = e1("../internals/iterators"), i = e1("../internals/internal-state"), e1 = e1("../internals/define-iterator"), a = "Array Iterator", l = i.set, u = i.getterFor(a);
                t.exports = e1(Array, "Array", function(e1, t) {
                    l(this, {
                        type: a,
                        target: o(e1),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e1 = u(this), t = e1.target, r = e1.kind, o = e1.index++;
                    return !t || o >= t.length ? {
                        value: e1.target = void 0,
                        done: !0
                    } : "keys" == r ? {
                        value: o,
                        done: !1
                    } : "values" == r ? {
                        value: t[o],
                        done: !1
                    } : {
                        value: [
                            o,
                            t[o]
                        ],
                        done: !1
                    };
                }, "values"), s.Arguments = s.Array, n("keys"), n("values"), n("entries");
            },
            {
                "../internals/add-to-unscopables": 7,
                "../internals/define-iterator": 41,
                "../internals/internal-state": 70,
                "../internals/iterators": 79,
                "../internals/to-indexed-object": 134
            }
        ],
        161: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/indexed-object"), s = e1("../internals/to-indexed-object"), e1 = e1("../internals/array-method-is-strict"), i = [].join, n = n != Object, e1 = e1("join", ",");
                o({
                    target: "Array",
                    proto: !0,
                    forced: n || !e1
                }, {
                    join: function(e1) {
                        return i.call(s(this), void 0 === e1 ? "," : e1);
                    }
                });
            },
            {
                "../internals/array-method-is-strict": 22,
                "../internals/export": 50,
                "../internals/indexed-object": 66,
                "../internals/to-indexed-object": 134
            }
        ],
        162: [
            function(e1, t, r) {
                var o = e1("../internals/export"), e1 = e1("../internals/array-last-index-of");
                o({
                    target: "Array",
                    proto: !0,
                    forced: e1 !== [].lastIndexOf
                }, {
                    lastIndexOf: e1
                });
            },
            {
                "../internals/array-last-index-of": 20,
                "../internals/export": 50
            }
        ],
        163: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").map, s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("map"), e1 = e1("map");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    map: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        164: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), u = e1("../internals/is-object"), c = e1("../internals/is-array"), d = e1("../internals/to-absolute-index"), f = e1("../internals/to-length"), h = e1("../internals/to-indexed-object"), p = e1("../internals/create-property"), n = e1("../internals/well-known-symbol"), s = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), s = s("slice"), e1 = e1("slice", {
                    ACCESSORS: !0,
                    0: 0,
                    1: 2
                }), m = n("species"), y = [].slice, g = Math.max;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    slice: function(e1, t) {
                        var r, o, n, s = h(this), i = f(s.length), a = d(e1, i), l = d(void 0 === t ? i : t, i);
                        if (c(s) && ((r = "function" == typeof (r = s.constructor) && (r === Array || c(r.prototype)) || u(r) && null === (r = r[m]) ? void 0 : r) === Array || void 0 === r)) return y.call(s, a, l);
                        for(o = new (void 0 === r ? Array : r)(g(l - a, 0)), n = 0; a < l; a++, n++)a in s && p(o, n, s[a]);
                        return o.length = n, o;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/is-array": 72,
                "../internals/is-object": 74,
                "../internals/to-absolute-index": 132,
                "../internals/to-indexed-object": 134,
                "../internals/to-length": 136,
                "../internals/well-known-symbol": 148
            }
        ],
        165: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/array-iteration").some, s = e1("../internals/array-method-is-strict"), e1 = e1("../internals/array-method-uses-to-length"), s = s("some"), e1 = e1("some");
                o({
                    target: "Array",
                    proto: !0,
                    forced: !s || !e1
                }, {
                    some: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/array-iteration": 19,
                "../internals/array-method-is-strict": 22,
                "../internals/array-method-uses-to-length": 23,
                "../internals/export": 50
            }
        ],
        166: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), d = e1("../internals/to-absolute-index"), f = e1("../internals/to-integer"), h = e1("../internals/to-length"), p = e1("../internals/to-object"), m = e1("../internals/array-species-create"), y = e1("../internals/create-property"), n = e1("../internals/array-method-has-species-support"), e1 = e1("../internals/array-method-uses-to-length"), n = n("splice"), e1 = e1("splice", {
                    ACCESSORS: !0,
                    0: 0,
                    1: 2
                }), g = Math.max, v = Math.min;
                o({
                    target: "Array",
                    proto: !0,
                    forced: !n || !e1
                }, {
                    splice: function(e1, t) {
                        var r, o, n, s, i, a, l = p(this), u = h(l.length), c = d(e1, u), e1 = arguments.length;
                        if (0 === e1 ? r = o = 0 : o = 1 === e1 ? (r = 0, u - c) : (r = e1 - 2, v(g(f(t), 0), u - c)), 9007199254740991 < u + r - o) throw TypeError("Maximum allowed length exceeded");
                        for(n = m(l, o), s = 0; s < o; s++)(i = c + s) in l && y(n, s, l[i]);
                        if (r < (n.length = o)) {
                            for(s = c; s < u - o; s++)a = s + r, (i = s + o) in l ? l[a] = l[i] : delete l[a];
                            for(s = u; u - o + r < s; s--)delete l[s - 1];
                        } else if (o < r) for(s = u - o; c < s; s--)a = s + r - 1, (i = s + o - 1) in l ? l[a] = l[i] : delete l[a];
                        for(s = 0; s < r; s++)l[s + c] = arguments[s + 2];
                        return l.length = u - o + r, n;
                    }
                });
            },
            {
                "../internals/array-method-has-species-support": 21,
                "../internals/array-method-uses-to-length": 23,
                "../internals/array-species-create": 25,
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/to-absolute-index": 132,
                "../internals/to-integer": 135,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        167: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), e1 = e1("../internals/object-define-property").f, n = Function.prototype, s = n.toString, i = /^\s*function ([^ (]*)/;
                !o || "name" in n || e1(n, "name", {
                    configurable: !0,
                    get: function() {
                        try {
                            return s.call(this).match(i)[1];
                        } catch (e1) {
                            return "";
                        }
                    }
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/object-define-property": 92
            }
        ],
        168: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/collection"), e1 = e1("../internals/collection-strong");
                t.exports = o("Map", function(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }, e1);
            },
            {
                "../internals/collection": 32,
                "../internals/collection-strong": 30
            }
        ],
        169: [
            function(e1, t, r) {
                var e1 = e1("../internals/export"), o = Math.hypot, l = Math.abs, u = Math.sqrt;
                e1({
                    target: "Math",
                    stat: !0,
                    forced: !!o && o(1 / 0, NaN) !== 1 / 0
                }, {
                    hypot: function(e1, t) {
                        for(var r, o, n = 0, s = 0, i = arguments.length, a = 0; s < i;)a < (r = l(arguments[s++])) ? (n = n * (o = a / r) * o + 1, a = r) : n += 0 < r ? (o = r / a) * o : r;
                        return a === 1 / 0 ? 1 / 0 : a * u(n);
                    }
                });
            },
            {
                "../internals/export": 50
            }
        ],
        170: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "Math",
                    stat: !0
                }, {
                    sign: e1("../internals/math-sign")
                });
            },
            {
                "../internals/export": 50,
                "../internals/math-sign": 80
            }
        ],
        171: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    var t, r, o, n, s, i, a, l = d(e1, !1);
                    if ("string" == typeof l && 2 < l.length) {
                        if (43 === (e1 = (l = g(l)).charCodeAt(0)) || 45 === e1) {
                            if (88 === (t = l.charCodeAt(2)) || 120 === t) return NaN;
                        } else if (48 === e1) {
                            switch(l.charCodeAt(1)){
                                case 66:
                                case 98:
                                    r = 2, o = 49;
                                    break;
                                case 79:
                                case 111:
                                    r = 8, o = 55;
                                    break;
                                default:
                                    return +l;
                            }
                            for(s = (n = l.slice(2)).length, i = 0; i < s; i++)if ((a = n.charCodeAt(i)) < 48 || o < a) return NaN;
                            return parseInt(n, r);
                        }
                    }
                    return +l;
                }
                var n = e1("../internals/descriptors"), s = e1("../internals/global"), i = e1("../internals/is-forced"), a = e1("../internals/redefine"), l = e1("../internals/has"), u = e1("../internals/classof-raw"), c = e1("../internals/inherit-if-required"), d = e1("../internals/to-primitive"), f = e1("../internals/fails"), h = e1("../internals/object-create"), p = e1("../internals/object-get-own-property-names").f, m = e1("../internals/object-get-own-property-descriptor").f, y = e1("../internals/object-define-property").f, g = e1("../internals/string-trim").trim, v = "Number", b = s[v], j = b.prototype, _ = u(h(j)) == v;
                if (i(v, !b(" 0o1") || !b("0b1") || b("+0x1"))) {
                    for(var x, w = function(e1) {
                        var e1 = arguments.length < 1 ? 0 : e1, t = this;
                        return t instanceof w && (_ ? f(function() {
                            j.valueOf.call(t);
                        }) : u(t) != v) ? c(new b(o(e1)), t, w) : o(e1);
                    }, S = n ? p(b) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), E = 0; S.length > E; E++)l(b, x = S[E]) && !l(w, x) && y(w, x, m(b, x));
                    (w.prototype = j).constructor = w, a(s, v, w);
                }
            },
            {
                "../internals/classof-raw": 28,
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/inherit-if-required": 67,
                "../internals/is-forced": 73,
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/object-get-own-property-names": 95,
                "../internals/redefine": 108,
                "../internals/string-trim": 129,
                "../internals/to-primitive": 140
            }
        ],
        172: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isFinite: e1("../internals/number-is-finite")
                });
            },
            {
                "../internals/export": 50,
                "../internals/number-is-finite": 88
            }
        ],
        173: [
            function(e1, t, r) {
                "use strict";
                function c(e1, t, r) {
                    return 0 === t ? r : t % 2 == 1 ? c(e1, t - 1, r * e1) : c(e1 * e1, t / 2, r);
                }
                var o = e1("../internals/export"), d = e1("../internals/to-integer"), f = e1("../internals/this-number-value"), h = e1("../internals/string-repeat"), e1 = e1("../internals/fails"), n = 1..toFixed, p = Math.floor;
                o({
                    target: "Number",
                    proto: !0,
                    forced: n && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !e1(function() {
                        n.call({});
                    })
                }, {
                    toFixed: function(e1) {
                        function t(e1, t) {
                            for(var r = -1, o = t; ++r < 6;)o += e1 * a[r], a[r] = o % 1e7, o = p(o / 1e7);
                        }
                        function r(e1) {
                            for(var t = 6, r = 0; 0 <= --t;)r += a[t], a[t] = p(r / e1), r = r % e1 * 1e7;
                        }
                        function o() {
                            for(var e1, t = 6, r = ""; 0 <= --t;)"" === r && 0 !== t && 0 === a[t] || (e1 = String(a[t]), r = "" === r ? e1 : r + h.call("0", 7 - e1.length) + e1);
                            return r;
                        }
                        var n, s, i = f(this), e1 = d(e1), a = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], l = "", u = "0";
                        if (e1 < 0 || 20 < e1) throw RangeError("Incorrect fraction digits");
                        if (i != i) return "NaN";
                        if (i <= -1000000000000000000000 || 1e21 <= i) return String(i);
                        if (i < 0 && (l = "-", i = -i), 1e-21 < i) {
                            if (i = (n = function(e1) {
                                for(var t = 0, r = e1; 4096 <= r;)t += 12, r /= 4096;
                                for(; 2 <= r;)t += 1, r /= 2;
                                return t;
                            }(i * c(2, 69, 1)) - 69) < 0 ? i * c(2, -n, 1) : i / c(2, n, 1), i *= 4503599627370496, 0 < (n = 52 - n)) {
                                for(t(0, i), s = e1; 7 <= s;)t(1e7, 0), s -= 7;
                                for(t(c(10, s, 1), 0), s = n - 1; 23 <= s;)r(8388608), s -= 23;
                                r(1 << s), t(1, 1), r(2), u = o();
                            } else t(0, i), t(1 << -n, 0), u = o() + h.call("0", e1);
                        }
                        return u = 0 < e1 ? l + ((i = u.length) <= e1 ? "0." + h.call("0", e1 - i) + u : u.slice(0, i - e1) + "." + u.slice(i - e1)) : l + u;
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/string-repeat": 127,
                "../internals/this-number-value": 131,
                "../internals/to-integer": 135
            }
        ],
        174: [
            function(e1, t, r) {
                var o = e1("../internals/export"), e1 = e1("../internals/object-assign");
                o({
                    target: "Object",
                    stat: !0,
                    forced: Object.assign !== e1
                }, {
                    assign: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/object-assign": 89
            }
        ],
        175: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/iterate"), s = e1("../internals/create-property");
                o({
                    target: "Object",
                    stat: !0
                }, {
                    fromEntries: function(e1) {
                        var r = {};
                        return n(e1, function(e1, t) {
                            s(r, e1, t);
                        }, void 0, !0), r;
                    }
                });
            },
            {
                "../internals/create-property": 40,
                "../internals/export": 50,
                "../internals/iterate": 77
            }
        ],
        176: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), s = e1("../internals/to-indexed-object"), i = e1("../internals/object-get-own-property-descriptor").f, e1 = e1("../internals/descriptors"), n = n(function() {
                    i(1);
                });
                o({
                    target: "Object",
                    stat: !0,
                    forced: !e1 || n,
                    sham: !e1
                }, {
                    getOwnPropertyDescriptor: function(e1, t) {
                        return i(s(e1), t);
                    }
                });
            },
            {
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/to-indexed-object": 134
            }
        ],
        177: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), e1 = e1("../internals/object-get-own-property-names-external").f;
                o({
                    target: "Object",
                    stat: !0,
                    forced: n(function() {
                        return !Object.getOwnPropertyNames(1);
                    })
                }, {
                    getOwnPropertyNames: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-own-property-names-external": 94
            }
        ],
        178: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/fails"), s = e1("../internals/to-object"), i = e1("../internals/object-get-prototype-of"), e1 = e1("../internals/correct-prototype-getter");
                o({
                    target: "Object",
                    stat: !0,
                    forced: n(function() {
                        i(1);
                    }),
                    sham: !e1
                }, {
                    getPrototypeOf: function(e1) {
                        return i(s(e1));
                    }
                });
            },
            {
                "../internals/correct-prototype-getter": 35,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-get-prototype-of": 97,
                "../internals/to-object": 137
            }
        ],
        179: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/to-object"), s = e1("../internals/object-keys");
                o({
                    target: "Object",
                    stat: !0,
                    forced: e1("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e1) {
                        return s(n(e1));
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/object-keys": 99,
                "../internals/to-object": 137
            }
        ],
        180: [
            function(e1, t, r) {
                var o = e1("../internals/to-string-tag-support"), n = e1("../internals/redefine"), e1 = e1("../internals/object-to-string");
                o || n(Object.prototype, "toString", e1, {
                    unsafe: !0
                });
            },
            {
                "../internals/object-to-string": 102,
                "../internals/redefine": 108,
                "../internals/to-string-tag-support": 141
            }
        ],
        181: [
            function(e1, D, F) {
                "use strict";
                var r, t, o, n, s = e1("../internals/export"), i = e1("../internals/is-pure"), g = e1("../internals/global"), a = e1("../internals/get-built-in"), l = e1("../internals/native-promise-constructor"), U = e1("../internals/redefine"), N = e1("../internals/redefine-all"), B = e1("../internals/set-to-string-tag"), G = e1("../internals/set-species"), V = e1("../internals/is-object"), c = e1("../internals/a-function"), z = e1("../internals/an-instance"), H = e1("../internals/classof-raw"), W = e1("../internals/inspect-source"), d = e1("../internals/iterate"), q = e1("../internals/check-correctness-of-iteration"), X = e1("../internals/species-constructor"), v = e1("../internals/task").set, u = e1("../internals/microtask"), f = e1("../internals/promise-resolve"), Y = e1("../internals/host-report-errors"), h = e1("../internals/new-promise-capability"), b = e1("../internals/perform"), p = e1("../internals/internal-state"), Z = e1("../internals/is-forced"), m = e1("../internals/well-known-symbol"), y = e1("../internals/engine-v8-version"), Q = m("species"), j = "Promise", _ = p.get, J = p.set, K = p.getterFor(j), x = l, w = g.TypeError, S = g.document, E = g.process, M = a("fetch"), T = h.f, $ = T, k = "process" == H(E), ee = !!(S && S.createEvent && g.dispatchEvent), O = "unhandledrejection", te = "rejectionhandled", C = 1, re = 2, A = 1, oe = 2, e1 = Z(j, function() {
                    var e1, t;
                    if (!(W(x) !== String(x))) {
                        if (66 === y) return !0;
                        if (!k && "function" != typeof PromiseRejectionEvent) return !0;
                    }
                    return !(!i || x.prototype.finally) || !(51 <= y && /native code/.test(x)) && (t = function(e1) {
                        e1(function() {}, function() {});
                    }, ((e1 = x.resolve(1)).constructor = {})[Q] = t, !(e1.then(function() {}) instanceof t));
                }), m = e1 || !q(function(e1) {
                    x.all(e1).catch(function() {});
                }), ne = function(e1) {
                    var t;
                    return !(!V(e1) || "function" != typeof (t = e1.then)) && t;
                }, P = function(h, p, m) {
                    var y;
                    p.notified || (p.notified = !0, y = p.reactions, u(function() {
                        for(var r, o, e1 = p.value, t = p.state == C, n = 0; y.length > n;){
                            var s, i, a, l = y[n++], u = t ? l.ok : l.fail, c = l.resolve, d = l.reject, f = l.domain;
                            try {
                                u ? (t || (p.rejection === oe && function(e1, t) {
                                    v.call(g, function() {
                                        if (k) E.emit("rejectionHandled", e1);
                                        else se(te, e1, t.value);
                                    });
                                }(h, p), p.rejection = A), !0 === u ? s = e1 : (f && f.enter(), s = u(e1), f && (f.exit(), a = !0)), s === l.promise ? d(w("Promise-chain cycle")) : (i = ne(s)) ? i.call(s, c, d) : c(s)) : d(e1);
                            } catch (e1) {
                                f && !a && f.exit(), d(e1);
                            }
                        }
                        p.reactions = [], p.notified = !1, m && !p.rejection && (r = h, o = p, v.call(g, function() {
                            var e1 = o.value, t = ie(o);
                            if (t && (t = b(function() {
                                k ? E.emit("unhandledRejection", e1, r) : se(O, r, e1);
                            }), o.rejection = k || ie(o) ? oe : A, t.error)) throw t.value;
                        }));
                    }));
                }, se = function(e1, t, r) {
                    var o;
                    ee ? ((o = S.createEvent("Event")).promise = t, o.reason = r, o.initEvent(e1, !1, !0), g.dispatchEvent(o)) : o = {
                        promise: t,
                        reason: r
                    }, (t = g["on" + e1]) ? t(o) : e1 === O && Y("Unhandled promise rejection", r);
                }, ie = function(e1) {
                    return e1.rejection !== A && !e1.parent;
                }, L = function(t, r, o, n) {
                    return function(e1) {
                        t(r, o, e1, n);
                    };
                }, R = function(e1, t, r, o) {
                    t.done || (t.done = !0, (t = o ? o : t).value = r, t.state = re, P(e1, t, !0));
                }, I = function(r, o, e1, t) {
                    if (!o.done) {
                        o.done = !0, t && (o = t);
                        try {
                            if (r === e1) throw w("Promise can't be resolved itself");
                            var n = ne(e1);
                            n ? u(function() {
                                var t = {
                                    done: !1
                                };
                                try {
                                    n.call(e1, L(I, r, t, o), L(R, r, t, o));
                                } catch (e1) {
                                    R(r, t, e1, o);
                                }
                            }) : (o.value = e1, o.state = C, P(r, o, !1));
                        } catch (e1) {
                            R(r, {
                                done: !1
                            }, e1, o);
                        }
                    }
                };
                e1 && (x = function(e1) {
                    z(this, x, j), c(e1), r.call(this);
                    var t = _(this);
                    try {
                        e1(L(I, this, t), L(R, this, t));
                    } catch (e1) {
                        R(this, t, e1);
                    }
                }, (r = function(e1) {
                    J(this, {
                        type: j,
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: [],
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = N(x.prototype, {
                    then: function(e1, t) {
                        var r = K(this), o = T(X(this, x));
                        return o.ok = "function" != typeof e1 || e1, o.fail = "function" == typeof t && t, o.domain = k ? E.domain : void 0, r.parent = !0, r.reactions.push(o), 0 != r.state && P(this, r, !1), o.promise;
                    },
                    catch: function(e1) {
                        return this.then(void 0, e1);
                    }
                }), t = function() {
                    var e1 = new r, t = _(e1);
                    this.promise = e1, this.resolve = L(I, e1, t), this.reject = L(R, e1, t);
                }, h.f = T = function(e1) {
                    return e1 === x || e1 === o ? new t : $(e1);
                }, i || "function" != typeof l || (n = l.prototype.then, U(l.prototype, "then", function(e1, t) {
                    var r = this;
                    return new x(function(e1, t) {
                        n.call(r, e1, t);
                    }).then(e1, t);
                }, {
                    unsafe: !0
                }), "function" == typeof M && s({
                    global: !0,
                    enumerable: !0,
                    forced: !0
                }, {
                    fetch: function(e1) {
                        return f(x, M.apply(g, arguments));
                    }
                }))), s({
                    global: !0,
                    wrap: !0,
                    forced: e1
                }, {
                    Promise: x
                }), B(x, j, !1, !0), G(j), o = a(j), s({
                    target: j,
                    stat: !0,
                    forced: e1
                }, {
                    reject: function(e1) {
                        var t = T(this);
                        return t.reject.call(void 0, e1), t.promise;
                    }
                }), s({
                    target: j,
                    stat: !0,
                    forced: i || e1
                }, {
                    resolve: function(e1) {
                        return f(i && this === o ? x : this, e1);
                    }
                }), s({
                    target: j,
                    stat: !0,
                    forced: m
                }, {
                    all: function(e1) {
                        var a = this, t = T(a), l = t.resolve, u = t.reject, r = b(function() {
                            var o = c(a.resolve), n = [], s = 0, i = 1;
                            d(e1, function(e1) {
                                var t = s++, r = !1;
                                n.push(void 0), i++, o.call(a, e1).then(function(e1) {
                                    r || (r = !0, n[t] = e1, --i || l(n));
                                }, u);
                            }), --i || l(n);
                        });
                        return r.error && u(r.value), t.promise;
                    },
                    race: function(e1) {
                        var r = this, o = T(r), n = o.reject, t = b(function() {
                            var t = c(r.resolve);
                            d(e1, function(e1) {
                                t.call(r, e1).then(o.resolve, n);
                            });
                        });
                        return t.error && n(t.value), o.promise;
                    }
                });
            },
            {
                "../internals/a-function": 5,
                "../internals/an-instance": 9,
                "../internals/check-correctness-of-iteration": 27,
                "../internals/classof-raw": 28,
                "../internals/engine-v8-version": 48,
                "../internals/export": 50,
                "../internals/get-built-in": 56,
                "../internals/global": 59,
                "../internals/host-report-errors": 62,
                "../internals/inspect-source": 68,
                "../internals/internal-state": 70,
                "../internals/is-forced": 73,
                "../internals/is-object": 74,
                "../internals/is-pure": 75,
                "../internals/iterate": 77,
                "../internals/microtask": 81,
                "../internals/native-promise-constructor": 82,
                "../internals/new-promise-capability": 86,
                "../internals/perform": 105,
                "../internals/promise-resolve": 106,
                "../internals/redefine": 108,
                "../internals/redefine-all": 107,
                "../internals/set-species": 116,
                "../internals/set-to-string-tag": 117,
                "../internals/species-constructor": 121,
                "../internals/task": 130,
                "../internals/well-known-symbol": 148
            }
        ],
        182: [
            function(e1, t, r) {
                var o = e1("../internals/export"), n = e1("../internals/get-built-in"), s = e1("../internals/a-function"), i = e1("../internals/an-object"), a = e1("../internals/is-object"), l = e1("../internals/object-create"), u = e1("../internals/function-bind"), e1 = e1("../internals/fails"), c = n("Reflect", "construct"), d = e1(function() {
                    function e1() {}
                    return !(c(function() {}, [], e1) instanceof e1);
                }), f = !e1(function() {
                    c(function() {});
                }), n = d || f;
                o({
                    target: "Reflect",
                    stat: !0,
                    forced: n,
                    sham: n
                }, {
                    construct: function(e1, t) {
                        s(e1), i(t);
                        var r = arguments.length < 3 ? e1 : s(arguments[2]);
                        if (f && !d) return c(e1, t, r);
                        if (e1 == r) {
                            switch(t.length){
                                case 0:
                                    return new e1;
                                case 1:
                                    return new e1(t[0]);
                                case 2:
                                    return new e1(t[0], t[1]);
                                case 3:
                                    return new e1(t[0], t[1], t[2]);
                                case 4:
                                    return new e1(t[0], t[1], t[2], t[3]);
                            }
                            var o = [
                                null
                            ];
                            return o.push.apply(o, t), new (u.apply(e1, o));
                        }
                        o = r.prototype, r = l(a(o) ? o : Object.prototype), o = Function.apply.call(e1, r, t);
                        return a(o) ? o : r;
                    }
                });
            },
            {
                "../internals/a-function": 5,
                "../internals/an-object": 10,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/function-bind": 55,
                "../internals/get-built-in": 56,
                "../internals/is-object": 74,
                "../internals/object-create": 90
            }
        ],
        183: [
            function(e1, t, r) {
                var o = e1("../internals/export"), s = e1("../internals/is-object"), i = e1("../internals/an-object"), a = e1("../internals/has"), l = e1("../internals/object-get-own-property-descriptor"), u = e1("../internals/object-get-prototype-of");
                o({
                    target: "Reflect",
                    stat: !0
                }, {
                    get: function e1(t, r) {
                        var o, n = arguments.length < 3 ? t : arguments[2];
                        return i(t) === n ? t[r] : (o = l.f(t, r)) ? a(o, "value") ? o.value : void 0 === o.get ? void 0 : o.get.call(n) : s(o = u(t)) ? e1(o, r, n) : void 0;
                    }
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/export": 50,
                "../internals/has": 60,
                "../internals/is-object": 74,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/object-get-prototype-of": 97
            }
        ],
        184: [
            function(e1, t, r) {
                var o = e1("../internals/descriptors"), n = e1("../internals/global"), s = e1("../internals/is-forced"), i = e1("../internals/inherit-if-required"), a = e1("../internals/object-define-property").f, l = e1("../internals/object-get-own-property-names").f, u = e1("../internals/is-regexp"), c = e1("../internals/regexp-flags"), d = e1("../internals/regexp-sticky-helpers"), f = e1("../internals/redefine"), h = e1("../internals/fails"), p = e1("../internals/internal-state").set, m = e1("../internals/set-species"), y = e1("../internals/well-known-symbol")("match"), g = n.RegExp, v = g.prototype, b = /a/g, j = /a/g, _ = new g(b) !== b, x = d.UNSUPPORTED_Y;
                if (o && s("RegExp", !_ || x || h(function() {
                    return j[y] = !1, g(b) != b || g(j) == j || "/a/i" != g(b, "i");
                }))) {
                    for(var w = function(e1, t) {
                        var r, o = this instanceof w, n = u(e1), s = void 0 === t;
                        if (!o && n && e1.constructor === w && s) return e1;
                        _ ? n && !s && (e1 = e1.source) : e1 instanceof w && (s && (t = c.call(e1)), e1 = e1.source), x && (r = !!t && -1 < t.indexOf("y")) && (t = t.replace(/y/g, ""));
                        n = i(_ ? new g(e1, t) : g(e1, t), o ? this : v, w);
                        return x && r && p(n, {
                            sticky: r
                        }), n;
                    }, S = l(g), E = 0; S.length > E;)!function(t) {
                        t in w || a(w, t, {
                            configurable: !0,
                            get: function() {
                                return g[t];
                            },
                            set: function(e1) {
                                g[t] = e1;
                            }
                        });
                    }(S[E++]);
                    (v.constructor = w).prototype = v, f(n, "RegExp", w);
                }
                m("RegExp");
            },
            {
                "../internals/descriptors": 43,
                "../internals/fails": 51,
                "../internals/global": 59,
                "../internals/inherit-if-required": 67,
                "../internals/internal-state": 70,
                "../internals/is-forced": 73,
                "../internals/is-regexp": 76,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-names": 95,
                "../internals/redefine": 108,
                "../internals/regexp-flags": 111,
                "../internals/regexp-sticky-helpers": 112,
                "../internals/set-species": 116,
                "../internals/well-known-symbol": 148
            }
        ],
        185: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), e1 = e1("../internals/regexp-exec");
                o({
                    target: "RegExp",
                    proto: !0,
                    forced: /./.exec !== e1
                }, {
                    exec: e1
                });
            },
            {
                "../internals/export": 50,
                "../internals/regexp-exec": 110
            }
        ],
        186: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/redefine"), n = e1("../internals/an-object"), s = e1("../internals/fails"), i = e1("../internals/regexp-flags"), e1 = "toString", a = RegExp.prototype, l = a[e1], s = s(function() {
                    return "/a/b" != l.call({
                        source: "a",
                        flags: "b"
                    });
                }), u = l.name != e1;
                (s || u) && o(RegExp.prototype, e1, function() {
                    var e1 = n(this), t = String(e1.source), r = e1.flags;
                    return "/" + t + "/" + String(void 0 === r && e1 instanceof RegExp && !("flags" in a) ? i.call(e1) : r);
                }, {
                    unsafe: !0
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/fails": 51,
                "../internals/redefine": 108,
                "../internals/regexp-flags": 111
            }
        ],
        187: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/collection"), e1 = e1("../internals/collection-strong");
                t.exports = o("Set", function(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }, e1);
            },
            {
                "../internals/collection": 32,
                "../internals/collection-strong": 30
            }
        ],
        188: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/object-get-own-property-descriptor").f, s = e1("../internals/to-length"), i = e1("../internals/not-a-regexp"), a = e1("../internals/require-object-coercible"), l = e1("../internals/correct-is-regexp-logic"), e1 = e1("../internals/is-pure"), u = "".endsWith, c = Math.min, l = l("endsWith");
                o({
                    target: "String",
                    proto: !0,
                    forced: !!(e1 || l || !(o = n(String.prototype, "endsWith")) || o.writable) && !l
                }, {
                    endsWith: function(e1) {
                        var t = String(a(this)), r = (i(e1), 1 < arguments.length ? arguments[1] : void 0), o = s(t.length), r = void 0 === r ? o : c(s(r), o), o = String(e1);
                        return u ? u.call(t, o, r) : t.slice(r - o.length, r) === o;
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/is-pure": 75,
                "../internals/not-a-regexp": 87,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/require-object-coercible": 113,
                "../internals/to-length": 136
            }
        ],
        189: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/not-a-regexp"), s = e1("../internals/require-object-coercible");
                o({
                    target: "String",
                    proto: !0,
                    forced: !e1("../internals/correct-is-regexp-logic")("includes")
                }, {
                    includes: function(e1) {
                        return !!~String(s(this)).indexOf(n(e1), 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/not-a-regexp": 87,
                "../internals/require-object-coercible": 113
            }
        ],
        190: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/string-multibyte").charAt, n = e1("../internals/internal-state"), e1 = e1("../internals/define-iterator"), s = "String Iterator", i = n.set, a = n.getterFor(s);
                e1(String, "String", function(e1) {
                    i(this, {
                        type: s,
                        string: String(e1),
                        index: 0
                    });
                }, function() {
                    var e1 = a(this), t = e1.string, r = e1.index;
                    return r >= t.length ? {
                        value: void 0,
                        done: !0
                    } : (t = o(t, r), e1.index += t.length, {
                        value: t,
                        done: !1
                    });
                });
            },
            {
                "../internals/define-iterator": 41,
                "../internals/internal-state": 70,
                "../internals/string-multibyte": 123
            }
        ],
        191: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), c = e1("../internals/an-object"), d = e1("../internals/to-length"), n = e1("../internals/require-object-coercible"), f = e1("../internals/advance-string-index"), h = e1("../internals/regexp-exec-abstract");
                o("match", 1, function(o, l, u) {
                    return [
                        function(e1) {
                            var t = n(this), r = null == e1 ? void 0 : e1[o];
                            return void 0 !== r ? r.call(e1, t) : new RegExp(e1)[o](String(t));
                        },
                        function(e1) {
                            var t = u(l, e1, this);
                            if (t.done) return t.value;
                            var r = c(e1), o = String(this);
                            if (!r.global) return h(r, o);
                            for(var n = r.unicode, s = [], i = r.lastIndex = 0; null !== (a = h(r, o));){
                                var a = String(a[0]);
                                "" === (s[i] = a) && (r.lastIndex = f(o, d(r.lastIndex), n)), i++;
                            }
                            return 0 === i ? null : s;
                        }
                    ];
                });
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 109,
                "../internals/require-object-coercible": 113,
                "../internals/to-length": 136
            }
        ],
        192: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/string-pad").start;
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-pad-webkit-bug")
                }, {
                    padStart: function(e1) {
                        return n(this, e1, 1 < arguments.length ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-pad": 125,
                "../internals/string-pad-webkit-bug": 124
            }
        ],
        193: [
            function(e1, t, r) {
                e1("../internals/export")({
                    target: "String",
                    proto: !0
                }, {
                    repeat: e1("../internals/string-repeat")
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-repeat": 127
            }
        ],
        194: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), E = e1("../internals/an-object"), M = e1("../internals/to-object"), T = e1("../internals/to-length"), k = e1("../internals/to-integer"), s = e1("../internals/require-object-coercible"), O = e1("../internals/advance-string-index"), C = e1("../internals/regexp-exec-abstract"), A = Math.max, P = Math.min, L = Math.floor, R = /\$([$&'`]|\d\d?|<[^>]*>)/g, I = /\$([$&'`]|\d\d?)/g;
                o("replace", 2, function(n, j, _, e1) {
                    var x = e1.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, w = e1.REPLACE_KEEPS_$0, S = x ? "$" : "$0";
                    return [
                        function(e1, t) {
                            var r = s(this), o = null == e1 ? void 0 : e1[n];
                            return void 0 !== o ? o.call(e1, r, t) : j.call(String(r), e1, t);
                        },
                        function(e1, t) {
                            if (!x && w || "string" == typeof t && -1 === t.indexOf(S)) {
                                var r = _(j, e1, this, t);
                                if (r.done) return r.value;
                            }
                            for(var o, n = E(e1), s = String(this), i = "function" == typeof t, a = (i || (t = String(t)), n.global), l = (a && (o = n.unicode, n.lastIndex = 0), []); null !== (h = C(n, s)) && (l.push(h), a);)"" === String(h[0]) && (n.lastIndex = O(s, T(n.lastIndex), o));
                            for(var u, c = "", d = 0, f = 0; f < l.length; f++){
                                for(var h = l[f], p = String(h[0]), m = A(P(k(h.index), s.length), 0), y = [], g = 1; g < h.length; g++)y.push(void 0 === (u = h[g]) ? u : String(u));
                                var v = h.groups, b = i ? (b = [
                                    p
                                ].concat(y, m, s), void 0 !== v && b.push(v), String(t.apply(void 0, b))) : function(s, i, a, l, u, e1) {
                                    var c = a + s.length, d = l.length, t = I;
                                    void 0 !== u && (u = M(u), t = R);
                                    return j.call(e1, t, function(e1, t) {
                                        var r;
                                        switch(t.charAt(0)){
                                            case "$":
                                                return "$";
                                            case "&":
                                                return s;
                                            case "`":
                                                return i.slice(0, a);
                                            case "'":
                                                return i.slice(c);
                                            case "<":
                                                r = u[t.slice(1, -1)];
                                                break;
                                            default:
                                                var o, n = +t;
                                                if (0 == n) return e1;
                                                if (d < n) return 0 !== (o = L(n / 10)) && o <= d ? void 0 === l[o - 1] ? t.charAt(1) : l[o - 1] + t.charAt(1) : e1;
                                                r = l[n - 1];
                                        }
                                        return void 0 === r ? "" : r;
                                    });
                                }(p, s, m, y, v, t);
                                d <= m && (c += s.slice(d, m) + b, d = m + p.length);
                            }
                            return c + s.slice(d);
                        }
                    ];
                });
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 109,
                "../internals/require-object-coercible": 113,
                "../internals/to-integer": 135,
                "../internals/to-length": 136,
                "../internals/to-object": 137
            }
        ],
        195: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), i = e1("../internals/an-object"), a = e1("../internals/require-object-coercible"), l = e1("../internals/same-value"), u = e1("../internals/regexp-exec-abstract");
                o("search", 1, function(o, n, s) {
                    return [
                        function(e1) {
                            var t = a(this), r = null == e1 ? void 0 : e1[o];
                            return void 0 !== r ? r.call(e1, t) : new RegExp(e1)[o](String(t));
                        },
                        function(e1) {
                            var t, r = s(n, e1, this);
                            return r.done ? r.value : (r = i(e1), e1 = String(this), t = r.lastIndex, l(t, 0) || (r.lastIndex = 0), e1 = u(r, e1), l(r.lastIndex, t) || (r.lastIndex = t), null === e1 ? -1 : e1.index);
                        }
                    ];
                });
            },
            {
                "../internals/an-object": 10,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/regexp-exec-abstract": 109,
                "../internals/require-object-coercible": 113,
                "../internals/same-value": 114
            }
        ],
        196: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/fix-regexp-well-known-symbol-logic"), c = e1("../internals/is-regexp"), g = e1("../internals/an-object"), d = e1("../internals/require-object-coercible"), v = e1("../internals/species-constructor"), b = e1("../internals/advance-string-index"), j = e1("../internals/to-length"), _ = e1("../internals/regexp-exec-abstract"), f = e1("../internals/regexp-exec"), e1 = e1("../internals/fails"), h = [].push, x = Math.min, w = 4294967295, S = !e1(function() {
                    return !RegExp(w, "y");
                });
                o("split", 2, function(n, p, m) {
                    var y = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || 1 < ".".split(/()()/).length || "".split(/.?/).length ? function(e1, t) {
                        var r = String(d(this)), o = void 0 === t ? w : t >>> 0;
                        if (0 == o) return [];
                        if (void 0 === e1) return [
                            r
                        ];
                        if (!c(e1)) return p.call(r, e1, o);
                        for(var n, s, i, a = [], t = (e1.ignoreCase ? "i" : "") + (e1.multiline ? "m" : "") + (e1.unicode ? "u" : "") + (e1.sticky ? "y" : ""), l = 0, u = new RegExp(e1.source, t + "g"); (n = f.call(u, r)) && !(l < (s = u.lastIndex) && (a.push(r.slice(l, n.index)), 1 < n.length && n.index < r.length && h.apply(a, n.slice(1)), i = n[0].length, l = s, a.length >= o));)u.lastIndex === n.index && u.lastIndex++;
                        return l === r.length ? !i && u.test("") || a.push("") : a.push(r.slice(l)), a.length > o ? a.slice(0, o) : a;
                    } : "0".split(void 0, 0).length ? function(e1, t) {
                        return void 0 === e1 && 0 === t ? [] : p.call(this, e1, t);
                    } : p;
                    return [
                        function(e1, t) {
                            var r = d(this), o = null == e1 ? void 0 : e1[n];
                            return void 0 !== o ? o.call(e1, r, t) : y.call(String(r), e1, t);
                        },
                        function(e1, t) {
                            var r = m(y, e1, this, t, y !== p);
                            if (r.done) return r.value;
                            var r = g(e1), o = String(this), e1 = v(r, RegExp), n = r.unicode, s = (r.ignoreCase ? "i" : "") + (r.multiline ? "m" : "") + (r.unicode ? "u" : "") + (S ? "y" : "g"), i = new e1(S ? r : "^(?:" + r.source + ")", s), a = void 0 === t ? w : t >>> 0;
                            if (0 == a) return [];
                            if (0 === o.length) return null === _(i, o) ? [
                                o
                            ] : [];
                            for(var l = 0, u = 0, c = []; u < o.length;){
                                i.lastIndex = S ? u : 0;
                                var d, f = _(i, S ? o : o.slice(u));
                                if (null === f || (d = x(j(i.lastIndex + (S ? 0 : u)), o.length)) === l) u = b(o, u, n);
                                else {
                                    if (c.push(o.slice(l, u)), c.length === a) return c;
                                    for(var h = 1; h <= f.length - 1; h++)if (c.push(f[h]), c.length === a) return c;
                                    u = l = d;
                                }
                            }
                            return c.push(o.slice(l)), c;
                        }
                    ];
                }, !S);
            },
            {
                "../internals/advance-string-index": 8,
                "../internals/an-object": 10,
                "../internals/fails": 51,
                "../internals/fix-regexp-well-known-symbol-logic": 52,
                "../internals/is-regexp": 76,
                "../internals/regexp-exec": 110,
                "../internals/regexp-exec-abstract": 109,
                "../internals/require-object-coercible": 113,
                "../internals/species-constructor": 121,
                "../internals/to-length": 136
            }
        ],
        197: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/object-get-own-property-descriptor").f, s = e1("../internals/to-length"), i = e1("../internals/not-a-regexp"), a = e1("../internals/require-object-coercible"), l = e1("../internals/correct-is-regexp-logic"), e1 = e1("../internals/is-pure"), u = "".startsWith, c = Math.min, l = l("startsWith");
                o({
                    target: "String",
                    proto: !0,
                    forced: !!(e1 || l || !(o = n(String.prototype, "startsWith")) || o.writable) && !l
                }, {
                    startsWith: function(e1) {
                        var t = String(a(this)), r = (i(e1), s(c(1 < arguments.length ? arguments[1] : void 0, t.length))), e1 = String(e1);
                        return u ? u.call(t, e1, r) : t.slice(r, r + e1.length) === e1;
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 34,
                "../internals/export": 50,
                "../internals/is-pure": 75,
                "../internals/not-a-regexp": 87,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/require-object-coercible": 113,
                "../internals/to-length": 136
            }
        ],
        198: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/create-html");
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-html-forced")("sub")
                }, {
                    sub: function() {
                        return n(this, "sub", "", "");
                    }
                });
            },
            {
                "../internals/create-html": 36,
                "../internals/export": 50,
                "../internals/string-html-forced": 122
            }
        ],
        199: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/export"), n = e1("../internals/string-trim").trim;
                o({
                    target: "String",
                    proto: !0,
                    forced: e1("../internals/string-trim-forced")("trim")
                }, {
                    trim: function() {
                        return n(this);
                    }
                });
            },
            {
                "../internals/export": 50,
                "../internals/string-trim": 129,
                "../internals/string-trim-forced": 128
            }
        ],
        200: [
            function(e1, t, r) {
                "use strict";
                var o, n, s, i, a, l = e1("../internals/export"), u = e1("../internals/descriptors"), c = e1("../internals/global"), d = e1("../internals/has"), f = e1("../internals/is-object"), h = e1("../internals/object-define-property").f, e1 = e1("../internals/copy-constructor-properties"), p = c.Symbol;
                !u || "function" != typeof p || "description" in p.prototype && void 0 === p().description || (o = {}, e1(n = function() {
                    var e1 = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]), t = this instanceof n ? new p(e1) : void 0 === e1 ? p() : p(e1);
                    return "" === e1 && (o[t] = !0), t;
                }, p), (c = n.prototype = p.prototype).constructor = n, s = c.toString, i = "Symbol(test)" == String(p("test")), a = /^Symbol\((.*)\)[^)]+$/, h(c, "description", {
                    configurable: !0,
                    get: function() {
                        var e1 = f(this) ? this.valueOf() : this, t = s.call(e1);
                        return d(o, e1) ? "" : "" === (e1 = i ? t.slice(7, -1) : t.replace(a, "$1")) ? void 0 : e1;
                    }
                }), l({
                    global: !0,
                    forced: !0
                }, {
                    Symbol: n
                }));
            },
            {
                "../internals/copy-constructor-properties": 33,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/is-object": 74,
                "../internals/object-define-property": 92
            }
        ],
        201: [
            function(e1, t, r) {
                e1("../internals/define-well-known-symbol")("iterator");
            },
            {
                "../internals/define-well-known-symbol": 42
            }
        ],
        202: [
            function(e1, D, F) {
                "use strict";
                function o(e1, t) {
                    var r = M[e1] = h(w[_]);
                    return ie(r, {
                        type: j,
                        tag: e1,
                        description: t
                    }), s || (r.description = t), r;
                }
                function r(t, e1) {
                    u(t);
                    var r = c(e1), e1 = q(r).concat(I(r));
                    return v(e1, function(e1) {
                        s && !R.call(r, e1) || L(t, e1, r[e1]);
                    }), t;
                }
                function t(e1, t) {
                    var r, e1 = c(e1), t = d(t, !0);
                    if (e1 !== x || !l(M, t) || l(T, t)) return !(r = le(e1, t)) || !l(M, t) || l(e1, b) && e1[b][t] || (r.enumerable = !0), r;
                }
                function U(e1) {
                    var e1 = ue(c(e1)), t = [];
                    return v(e1, function(e1) {
                        l(M, e1) || l(ee, e1) || t.push(e1);
                    }), t;
                }
                var n = e1("../internals/export"), N = e1("../internals/global"), B = e1("../internals/get-built-in"), G = e1("../internals/is-pure"), s = e1("../internals/descriptors"), i = e1("../internals/native-symbol"), V = e1("../internals/use-symbol-as-uid"), a = e1("../internals/fails"), l = e1("../internals/has"), z = e1("../internals/is-array"), H = e1("../internals/is-object"), u = e1("../internals/an-object"), W = e1("../internals/to-object"), c = e1("../internals/to-indexed-object"), d = e1("../internals/to-primitive"), f = e1("../internals/create-property-descriptor"), h = e1("../internals/object-create"), q = e1("../internals/object-keys"), X = e1("../internals/object-get-own-property-names"), Y = e1("../internals/object-get-own-property-names-external"), p = e1("../internals/object-get-own-property-symbols"), Z = e1("../internals/object-get-own-property-descriptor"), Q = e1("../internals/object-define-property"), J = e1("../internals/object-property-is-enumerable"), K = e1("../internals/create-non-enumerable-property"), m = e1("../internals/redefine"), y = e1("../internals/shared"), $ = e1("../internals/shared-key"), ee = e1("../internals/hidden-keys"), te = e1("../internals/uid"), re = e1("../internals/well-known-symbol"), oe = e1("../internals/well-known-symbol-wrapped"), ne = e1("../internals/define-well-known-symbol"), se = e1("../internals/set-to-string-tag"), g = e1("../internals/internal-state"), v = e1("../internals/array-iteration").forEach, b = $("hidden"), j = "Symbol", _ = "prototype", e1 = re("toPrimitive"), ie = g.set, ae = g.getterFor(j), x = Object[_], w = N.Symbol, S = B("JSON", "stringify"), le = Z.f, E = Q.f, ue = Y.f, ce = J.f, M = y("symbols"), T = y("op-symbols"), k = y("string-to-symbol-registry"), O = y("symbol-to-string-registry"), $ = y("wks"), g = N.QObject, C = !g || !g[_] || !g[_].findChild, A = s && a(function() {
                    return 7 != h(E({}, "a", {
                        get: function() {
                            return E(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? function(e1, t, r) {
                    var o = le(x, t);
                    o && delete x[t], E(e1, t, r), o && e1 !== x && E(x, t, o);
                } : E, P = V ? function(e1) {
                    return "symbol" == typeof e1;
                } : function(e1) {
                    return Object(e1) instanceof w;
                }, L = function(e1, t, r) {
                    e1 === x && L(T, t, r), u(e1);
                    t = d(t, !0);
                    return u(r), (l(M, t) ? (r.enumerable ? (l(e1, b) && e1[b][t] && (e1[b][t] = !1), r = h(r, {
                        enumerable: f(0, !1)
                    })) : (l(e1, b) || E(e1, b, f(1, {})), e1[b][t] = !0), A) : E)(e1, t, r);
                }, R = function(e1) {
                    var e1 = d(e1, !0), t = ce.call(this, e1);
                    return !(this === x && l(M, e1) && !l(T, e1)) && (!(t || !l(this, e1) || !l(M, e1) || l(this, b) && this[b][e1]) || t);
                }, I = function(e1) {
                    var t = e1 === x, e1 = ue(t ? T : c(e1)), r = [];
                    return v(e1, function(e1) {
                        !l(M, e1) || t && !l(x, e1) || r.push(M[e1]);
                    }), r;
                };
                i || (m((w = function() {
                    if (this instanceof w) throw TypeError("Symbol is not a constructor");
                    var e1 = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0, t = te(e1), r = function(e1) {
                        this === x && r.call(T, e1), l(this, b) && l(this[b], t) && (this[b][t] = !1), A(this, t, f(1, e1));
                    };
                    return s && C && A(x, t, {
                        configurable: !0,
                        set: r
                    }), o(t, e1);
                })[_], "toString", function() {
                    return ae(this).tag;
                }), m(w, "withoutSetter", function(e1) {
                    return o(te(e1), e1);
                }), J.f = R, Q.f = L, Z.f = t, X.f = Y.f = U, p.f = I, oe.f = function(e1) {
                    return o(re(e1), e1);
                }, s && (E(w[_], "description", {
                    configurable: !0,
                    get: function() {
                        return ae(this).description;
                    }
                }), G || m(x, "propertyIsEnumerable", R, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    wrap: !0,
                    forced: !i,
                    sham: !i
                }, {
                    Symbol: w
                }), v(q($), function(e1) {
                    ne(e1);
                }), n({
                    target: j,
                    stat: !0,
                    forced: !i
                }, {
                    for: function(e1) {
                        var t, e1 = String(e1);
                        return l(k, e1) ? k[e1] : (t = w(e1), k[e1] = t, O[t] = e1, t);
                    },
                    keyFor: function(e1) {
                        if (!P(e1)) throw TypeError(e1 + " is not a symbol");
                        if (l(O, e1)) return O[e1];
                    },
                    useSetter: function() {
                        C = !0;
                    },
                    useSimple: function() {
                        C = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !i,
                    sham: !s
                }, {
                    create: function(e1, t) {
                        return void 0 === t ? h(e1) : r(h(e1), t);
                    },
                    defineProperty: L,
                    defineProperties: r,
                    getOwnPropertyDescriptor: t
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !i
                }, {
                    getOwnPropertyNames: U,
                    getOwnPropertySymbols: I
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: a(function() {
                        p.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e1) {
                        return p.f(W(e1));
                    }
                }), S && n({
                    target: "JSON",
                    stat: !0,
                    forced: !i || a(function() {
                        var e1 = w();
                        return "[null]" != S([
                            e1
                        ]) || "{}" != S({
                            a: e1
                        }) || "{}" != S(Object(e1));
                    })
                }, {
                    stringify: function(e1, t, r) {
                        for(var o, n = [
                            e1
                        ], s = 1; s < arguments.length;)n.push(arguments[s++]);
                        if ((H(o = t) || void 0 !== e1) && !P(e1)) return z(t) || (t = function(e1, t) {
                            if ("function" == typeof o && (t = o.call(this, e1, t)), !P(t)) return t;
                        }), n[1] = t, S.apply(null, n);
                    }
                }), w[_][e1] || K(w[_], e1, w[_].valueOf), se(w, j), ee[b] = !0;
            },
            {
                "../internals/an-object": 10,
                "../internals/array-iteration": 19,
                "../internals/create-non-enumerable-property": 38,
                "../internals/create-property-descriptor": 39,
                "../internals/define-well-known-symbol": 42,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/fails": 51,
                "../internals/get-built-in": 56,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/hidden-keys": 61,
                "../internals/internal-state": 70,
                "../internals/is-array": 72,
                "../internals/is-object": 74,
                "../internals/is-pure": 75,
                "../internals/native-symbol": 83,
                "../internals/object-create": 90,
                "../internals/object-define-property": 92,
                "../internals/object-get-own-property-descriptor": 93,
                "../internals/object-get-own-property-names": 95,
                "../internals/object-get-own-property-names-external": 94,
                "../internals/object-get-own-property-symbols": 96,
                "../internals/object-keys": 99,
                "../internals/object-property-is-enumerable": 100,
                "../internals/redefine": 108,
                "../internals/set-to-string-tag": 117,
                "../internals/shared": 120,
                "../internals/shared-key": 118,
                "../internals/to-indexed-object": 134,
                "../internals/to-object": 137,
                "../internals/to-primitive": 140,
                "../internals/uid": 145,
                "../internals/use-symbol-as-uid": 146,
                "../internals/well-known-symbol": 148,
                "../internals/well-known-symbol-wrapped": 147
            }
        ],
        203: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-copy-within"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("copyWithin", function(e1, t) {
                    return n.call(s(this), e1, t, 2 < arguments.length ? arguments[2] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-copy-within": 14
            }
        ],
        204: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").every, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("every", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        205: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-fill"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("fill", function(e1) {
                    return n.apply(s(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-fill": 15
            }
        ],
        206: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), s = e1("../internals/array-iteration").filter, i = e1("../internals/species-constructor"), a = o.aTypedArray, l = o.aTypedArrayConstructor;
                (0, o.exportTypedArrayMethod)("filter", function(e1) {
                    for(var t = s(a(this), e1, 1 < arguments.length ? arguments[1] : void 0), e1 = i(this, this.constructor), r = 0, o = t.length, n = new (l(e1))(o); r < o;)n[r] = t[r++];
                    return n;
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/species-constructor": 121
            }
        ],
        207: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").findIndex, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("findIndex", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        208: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").find, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("find", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        209: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Float32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        210: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Float64", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        211: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").forEach, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("forEach", function(e1) {
                    n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        212: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-includes").includes, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("includes", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-includes": 18
            }
        ],
        213: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-includes").indexOf, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("indexOf", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-includes": 18
            }
        ],
        214: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Int16", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        215: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Int32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        216: [
            function(e1, t, r) {
                "use strict";
                function o() {
                    return a.call(c(this));
                }
                var n = e1("../internals/global"), s = e1("../internals/array-buffer-view-core"), i = e1("../modules/es.array.iterator"), e1 = e1("../internals/well-known-symbol")("iterator"), n = n.Uint8Array, a = i.values, l = i.keys, u = i.entries, c = s.aTypedArray, i = s.exportTypedArrayMethod, s = n && n.prototype[e1], n = !!s && ("values" == s.name || null == s.name);
                i("entries", function() {
                    return u.call(c(this));
                }), i("keys", function() {
                    return l.call(c(this));
                }), i("values", o, !n), i(e1, o, !n);
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/global": 59,
                "../internals/well-known-symbol": 148,
                "../modules/es.array.iterator": 160
            }
        ],
        217: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), o = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, n = [].join;
                e1("join", function(e1) {
                    return n.apply(o(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        218: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-last-index-of"), s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("lastIndexOf", function(e1) {
                    return n.apply(s(this), arguments);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-last-index-of": 20
            }
        ],
        219: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").map, s = e1("../internals/species-constructor"), i = o.aTypedArray, a = o.aTypedArrayConstructor;
                (0, o.exportTypedArrayMethod)("map", function(e1) {
                    return n(i(this), e1, 1 < arguments.length ? arguments[1] : void 0, function(e1, t) {
                        return new (a(s(e1, e1.constructor)))(t);
                    });
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19,
                "../internals/species-constructor": 121
            }
        ],
        220: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-reduce").right, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("reduceRight", function(e1) {
                    return n(s(this), e1, arguments.length, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-reduce": 24
            }
        ],
        221: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-reduce").left, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("reduce", function(e1) {
                    return n(s(this), e1, arguments.length, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-reduce": 24
            }
        ],
        222: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), n = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, s = Math.floor;
                e1("reverse", function() {
                    for(var e1, t = n(this).length, r = s(t / 2), o = 0; o < r;)e1 = this[o], this[o++] = this[--t], this[t] = e1;
                    return this;
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        223: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), i = e1("../internals/to-length"), a = e1("../internals/to-offset"), l = e1("../internals/to-object"), e1 = e1("../internals/fails"), u = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("set", function(e1) {
                    u(this);
                    var t = a(1 < arguments.length ? arguments[1] : void 0, 1), r = this.length, o = l(e1), n = i(o.length), s = 0;
                    if (r < n + t) throw RangeError("Wrong length");
                    for(; s < n;)this[t + s] = o[s++];
                }, e1(function() {
                    new Int8Array(1).set({});
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/to-length": 136,
                "../internals/to-object": 137,
                "../internals/to-offset": 138
            }
        ],
        224: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), i = e1("../internals/species-constructor"), e1 = e1("../internals/fails"), a = o.aTypedArray, l = o.aTypedArrayConstructor, o = o.exportTypedArrayMethod, u = [].slice;
                o("slice", function(e1, t) {
                    for(var r = u.call(a(this), e1, t), e1 = i(this, this.constructor), o = 0, n = r.length, s = new (l(e1))(n); o < n;)s[o] = r[o++];
                    return s;
                }, e1(function() {
                    new Int8Array(1).slice();
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/species-constructor": 121
            }
        ],
        225: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/array-iteration").some, s = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("some", function(e1) {
                    return n(s(this), e1, 1 < arguments.length ? arguments[1] : void 0);
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/array-iteration": 19
            }
        ],
        226: [
            function(e1, t, r) {
                "use strict";
                var e1 = e1("../internals/array-buffer-view-core"), o = e1.aTypedArray, e1 = e1.exportTypedArrayMethod, n = [].sort;
                e1("sort", function(e1) {
                    return n.call(o(this), e1);
                });
            },
            {
                "../internals/array-buffer-view-core": 12
            }
        ],
        227: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core"), n = e1("../internals/to-length"), s = e1("../internals/to-absolute-index"), i = e1("../internals/species-constructor"), a = o.aTypedArray;
                (0, o.exportTypedArrayMethod)("subarray", function(e1, t) {
                    var r = a(this), o = r.length, e1 = s(e1, o);
                    return new (i(r, r.constructor))(r.buffer, r.byteOffset + e1 * r.BYTES_PER_ELEMENT, n((void 0 === t ? o : s(t, o)) - e1));
                });
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/species-constructor": 121,
                "../internals/to-absolute-index": 132,
                "../internals/to-length": 136
            }
        ],
        228: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/global"), n = e1("../internals/array-buffer-view-core"), e1 = e1("../internals/fails"), s = o.Int8Array, i = n.aTypedArray, o = n.exportTypedArrayMethod, a = [].toLocaleString, l = [].slice, u = !!s && e1(function() {
                    a.call(new s(1));
                });
                o("toLocaleString", function() {
                    return a.apply(u ? l.call(i(this)) : i(this), arguments);
                }, e1(function() {
                    return [
                        1,
                        2
                    ].toLocaleString() != new s([
                        1,
                        2
                    ]).toLocaleString();
                }) || !e1(function() {
                    s.prototype.toLocaleString.call([
                        1,
                        2
                    ]);
                }));
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/global": 59
            }
        ],
        229: [
            function(e1, t, r) {
                "use strict";
                var o = e1("../internals/array-buffer-view-core").exportTypedArrayMethod, n = e1("../internals/fails"), e1 = e1("../internals/global").Uint8Array, e1 = e1 && e1.prototype || {}, s = [].toString, i = [].join, n = (n(function() {
                    s.call({});
                }) && (s = function() {
                    return i.call(this);
                }), e1.toString != s);
                o("toString", s, n);
            },
            {
                "../internals/array-buffer-view-core": 12,
                "../internals/fails": 51,
                "../internals/global": 59
            }
        ],
        230: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint16", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        231: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint32", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        232: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint8", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                });
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        233: [
            function(e1, t, r) {
                e1("../internals/typed-array-constructor")("Uint8", function(o) {
                    return function(e1, t, r) {
                        return o(this, e1, t, r);
                    };
                }, !0);
            },
            {
                "../internals/typed-array-constructor": 142
            }
        ],
        234: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return function() {
                        return e1(this, arguments.length ? arguments[0] : void 0);
                    };
                }
                var n, s, i, a, l, u = e1("../internals/global"), c = e1("../internals/redefine-all"), d = e1("../internals/internal-metadata"), f = e1("../internals/collection"), h = e1("../internals/collection-weak"), p = e1("../internals/is-object"), m = e1("../internals/internal-state").enforce, e1 = e1("../internals/native-weak-map"), u = !u.ActiveXObject && "ActiveXObject" in u, y = Object.isExtensible, t = t.exports = f("WeakMap", o, h);
                e1 && u && (n = h.getConstructor(o, "WeakMap", !0), d.REQUIRED = !0, f = t.prototype, s = f.delete, i = f.has, a = f.get, l = f.set, c(f, {
                    delete: function(e1) {
                        var t;
                        return p(e1) && !y(e1) ? ((t = m(this)).frozen || (t.frozen = new n), s.call(this, e1) || t.frozen.delete(e1)) : s.call(this, e1);
                    },
                    has: function(e1) {
                        var t;
                        return p(e1) && !y(e1) ? ((t = m(this)).frozen || (t.frozen = new n), i.call(this, e1) || t.frozen.has(e1)) : i.call(this, e1);
                    },
                    get: function(e1) {
                        var t;
                        return !p(e1) || y(e1) || ((t = m(this)).frozen || (t.frozen = new n), i.call(this, e1)) ? a.call(this, e1) : t.frozen.get(e1);
                    },
                    set: function(e1, t) {
                        var r;
                        return !p(e1) || y(e1) || ((r = m(this)).frozen || (r.frozen = new n), i.call(this, e1)) ? l.call(this, e1, t) : r.frozen.set(e1, t), this;
                    }
                }));
            },
            {
                "../internals/collection": 32,
                "../internals/collection-weak": 31,
                "../internals/global": 59,
                "../internals/internal-metadata": 69,
                "../internals/internal-state": 70,
                "../internals/is-object": 74,
                "../internals/native-weak-map": 85,
                "../internals/redefine-all": 107
            }
        ],
        235: [
            function(e1, t, r) {
                var o, n = e1("../internals/global"), s = e1("../internals/dom-iterables"), i = e1("../internals/array-for-each"), a = e1("../internals/create-non-enumerable-property");
                for(o in s){
                    var l = n[o], l = l && l.prototype;
                    if (l && l.forEach !== i) try {
                        a(l, "forEach", i);
                    } catch (e1) {
                        l.forEach = i;
                    }
                }
            },
            {
                "../internals/array-for-each": 16,
                "../internals/create-non-enumerable-property": 38,
                "../internals/dom-iterables": 45,
                "../internals/global": 59
            }
        ],
        236: [
            function(e1, t, r) {
                var o, n = e1("../internals/global"), s = e1("../internals/dom-iterables"), i = e1("../modules/es.array.iterator"), a = e1("../internals/create-non-enumerable-property"), e1 = e1("../internals/well-known-symbol"), l = e1("iterator"), u = e1("toStringTag"), c = i.values;
                for(o in s){
                    var d = n[o], f = d && d.prototype;
                    if (f) {
                        if (f[l] !== c) try {
                            a(f, l, c);
                        } catch (e1) {
                            f[l] = c;
                        }
                        if (f[u] || a(f, u, o), s[o]) {
                            for(var h in i)if (f[h] !== i[h]) try {
                                a(f, h, i[h]);
                            } catch (e1) {
                                f[h] = i[h];
                            }
                        }
                    }
                }
            },
            {
                "../internals/create-non-enumerable-property": 38,
                "../internals/dom-iterables": 45,
                "../internals/global": 59,
                "../internals/well-known-symbol": 148,
                "../modules/es.array.iterator": 160
            }
        ],
        237: [
            function(e1, t, D) {
                "use strict";
                e1("../modules/es.array.iterator");
                function n(t) {
                    try {
                        return decodeURIComponent(t);
                    } catch (e1) {
                        return t;
                    }
                }
                function r(e1) {
                    return B[e1];
                }
                function s(e1) {
                    return encodeURIComponent(e1).replace(N, r);
                }
                function c(e1) {
                    this.entries.length = 0, R(this.entries, e1);
                }
                function u(e1, t) {
                    if (e1 < t) throw TypeError("Not enough arguments");
                }
                function d() {
                    y(this, d, k);
                    var e1, t, r, o, n, s, i, a, l = 0 < arguments.length ? arguments[0] : void 0, u = [];
                    if (C(this, {
                        type: k,
                        entries: u,
                        updateURL: function() {},
                        updateSearchParams: c
                    }), void 0 !== l) {
                        if (_(l)) {
                            if ("function" == typeof (e1 = E(l))) for(r = (t = e1.call(l)).next; !(o = r.call(t)).done;){
                                if ((s = (n = (o = S(j(o.value))).next).call(o)).done || (i = n.call(o)).done || !n.call(o).done) throw TypeError("Expected sequence with length 2");
                                u.push({
                                    key: s.value + "",
                                    value: i.value + ""
                                });
                            }
                            else for(a in l)g(l, a) && u.push({
                                key: a,
                                value: l[a] + ""
                            });
                        } else R(u, "string" == typeof l ? "?" === l.charAt(0) ? l.slice(1) : l : l + "");
                    }
                }
                var o = e1("../internals/export"), i = e1("../internals/get-built-in"), a = e1("../internals/native-url"), l = e1("../internals/redefine"), f = e1("../internals/redefine-all"), h = e1("../internals/set-to-string-tag"), p = e1("../internals/create-iterator-constructor"), m = e1("../internals/internal-state"), y = e1("../internals/an-instance"), g = e1("../internals/has"), v = e1("../internals/function-bind-context"), b = e1("../internals/classof"), j = e1("../internals/an-object"), _ = e1("../internals/is-object"), x = e1("../internals/object-create"), w = e1("../internals/create-property-descriptor"), S = e1("../internals/get-iterator"), E = e1("../internals/get-iterator-method"), e1 = e1("../internals/well-known-symbol"), M = i("fetch"), T = i("Headers"), i = e1("iterator"), k = "URLSearchParams", O = k + "Iterator", C = m.set, A = m.getterFor(k), F = m.getterFor(O), U = /\+/g, P = Array(4), L = function(e1) {
                    var t, r = e1.replace(U, " "), o = 4;
                    try {
                        return decodeURIComponent(r);
                    } catch (e1) {
                        for(; o;)r = r.replace((t = o--, P[t - 1] || (P[t - 1] = RegExp("((?:%[\\da-f]{2}){" + t + "})", "gi"))), n);
                        return r;
                    }
                }, N = /[!'()~]|%20/g, B = {
                    "!": "%21",
                    "'": "%27",
                    "(": "%28",
                    ")": "%29",
                    "~": "%7E",
                    "%20": "+"
                }, R = function(e1, t) {
                    if (t) for(var r, o = t.split("&"), n = 0; n < o.length;)(r = o[n++]).length && (r = r.split("="), e1.push({
                        key: L(r.shift()),
                        value: L(r.join("="))
                    }));
                }, I = p(function(e1, t) {
                    C(this, {
                        type: O,
                        iterator: S(A(e1).entries),
                        kind: t
                    });
                }, "Iterator", function() {
                    var e1 = F(this), t = e1.kind, e1 = e1.iterator.next(), r = e1.value;
                    return e1.done || (e1.value = "keys" === t ? r.key : "values" === t ? r.value : [
                        r.key,
                        r.value
                    ]), e1;
                }), e1 = d.prototype;
                f(e1, {
                    append: function(e1, t) {
                        u(arguments.length, 2);
                        var r = A(this);
                        r.entries.push({
                            key: e1 + "",
                            value: t + ""
                        }), r.updateURL();
                    },
                    delete: function(e1) {
                        u(arguments.length, 1);
                        for(var t = A(this), r = t.entries, o = e1 + "", n = 0; n < r.length;)r[n].key === o ? r.splice(n, 1) : n++;
                        t.updateURL();
                    },
                    get: function(e1) {
                        u(arguments.length, 1);
                        for(var t = A(this).entries, r = e1 + "", o = 0; o < t.length; o++)if (t[o].key === r) return t[o].value;
                        return null;
                    },
                    getAll: function(e1) {
                        u(arguments.length, 1);
                        for(var t = A(this).entries, r = e1 + "", o = [], n = 0; n < t.length; n++)t[n].key === r && o.push(t[n].value);
                        return o;
                    },
                    has: function(e1) {
                        u(arguments.length, 1);
                        for(var t = A(this).entries, r = e1 + "", o = 0; o < t.length;)if (t[o++].key === r) return !0;
                        return !1;
                    },
                    set: function(e1, t) {
                        u(arguments.length, 1);
                        for(var r, o = A(this), n = o.entries, s = !1, i = e1 + "", a = t + "", l = 0; l < n.length; l++)(r = n[l]).key === i && (s ? n.splice(l--, 1) : (s = !0, r.value = a));
                        s || n.push({
                            key: i,
                            value: a
                        }), o.updateURL();
                    },
                    sort: function() {
                        for(var e1, t, r = A(this), o = r.entries, n = o.slice(), s = o.length = 0; s < n.length; s++){
                            for(e1 = n[s], t = 0; t < s; t++)if (o[t].key > e1.key) {
                                o.splice(t, 0, e1);
                                break;
                            }
                            t === s && o.push(e1);
                        }
                        r.updateURL();
                    },
                    forEach: function(e1) {
                        for(var t, r = A(this).entries, o = v(e1, 1 < arguments.length ? arguments[1] : void 0, 3), n = 0; n < r.length;)o((t = r[n++]).value, t.key, this);
                    },
                    keys: function() {
                        return new I(this, "keys");
                    },
                    values: function() {
                        return new I(this, "values");
                    },
                    entries: function() {
                        return new I(this, "entries");
                    }
                }, {
                    enumerable: !0
                }), l(e1, i, e1.entries), l(e1, "toString", function() {
                    for(var e1, t = A(this).entries, r = [], o = 0; o < t.length;)e1 = t[o++], r.push(s(e1.key) + "=" + s(e1.value));
                    return r.join("&");
                }, {
                    enumerable: !0
                }), h(d, k), o({
                    global: !0,
                    forced: !a
                }, {
                    URLSearchParams: d
                }), a || "function" != typeof M || "function" != typeof T || o({
                    global: !0,
                    enumerable: !0,
                    forced: !0
                }, {
                    fetch: function(e1) {
                        var t, r, o, e1 = [
                            e1
                        ];
                        return 1 < arguments.length && (_(t = arguments[1]) && (r = t.body, b(r) === k && ((o = t.headers ? new T(t.headers) : new T).has("content-type") || o.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = x(t, {
                            body: w(0, String(r)),
                            headers: w(0, o)
                        }))), e1.push(t)), M.apply(this, e1);
                    }
                }), t.exports = {
                    URLSearchParams: d,
                    getState: A
                };
            },
            {
                "../internals/an-instance": 9,
                "../internals/an-object": 10,
                "../internals/classof": 29,
                "../internals/create-iterator-constructor": 37,
                "../internals/create-property-descriptor": 39,
                "../internals/export": 50,
                "../internals/function-bind-context": 54,
                "../internals/get-built-in": 56,
                "../internals/get-iterator": 58,
                "../internals/get-iterator-method": 57,
                "../internals/has": 60,
                "../internals/internal-state": 70,
                "../internals/is-object": 74,
                "../internals/native-url": 84,
                "../internals/object-create": 90,
                "../internals/redefine": 108,
                "../internals/redefine-all": 107,
                "../internals/set-to-string-tag": 117,
                "../internals/well-known-symbol": 148,
                "../modules/es.array.iterator": 160
            }
        ],
        238: [
            function(e1, y, F) {
                "use strict";
                e1("../modules/es.string.iterator");
                function c(e1) {
                    var t, r, o, n;
                    if ("number" == typeof e1) {
                        for(t = [], r = 0; r < 4; r++)t.unshift(e1 % 256), e1 = Y(e1 / 256);
                        return t.join(".");
                    }
                    if ("object" != typeof e1) return e1;
                    for(t = "", o = le(e1), r = 0; r < 8; r++)n && 0 === e1[r] || (n = n && !1, o === r ? (t += r ? ":" : "::", n = !0) : (t += e1[r].toString(16), r < 7 && (t += ":")));
                    return "[" + t + "]";
                }
                function n(e1) {
                    return !e1.host || e1.cannotBeABaseURL || "file" == e1.scheme;
                }
                function a(e1, t, r, o) {
                    var n, s, i, a = r || me, l = 0, u = "", c = !1, d = !1, f = !1;
                    for(r || (e1.scheme = "", e1.username = "", e1.password = "", e1.host = null, e1.port = null, e1.path = [], e1.query = null, e1.fragment = null, e1.cannotBeABaseURL = !1, t = t.replace(ie, "")), t = t.replace(ae, ""), n = b(t); l <= n.length;){
                        switch(s = n[l], a){
                            case me:
                                if (!s || !K.test(s)) {
                                    if (r) return j;
                                    a = ge;
                                    continue;
                                }
                                u += s.toLowerCase(), a = ye;
                                break;
                            case ye:
                                if (s && ($.test(s) || "+" == s || "-" == s || "." == s)) u += s.toLowerCase();
                                else {
                                    if (":" != s) {
                                        if (r) return j;
                                        u = "", a = ge, l = 0;
                                        continue;
                                    }
                                    if (r && (k(e1) != v(T, u) || "file" == u && (O(e1) || null !== e1.port) || "file" == e1.scheme && !e1.host)) return;
                                    if (e1.scheme = u, r) return void (k(e1) && T[e1.scheme] == e1.port && (e1.port = null));
                                    u = "", "file" == e1.scheme ? a = Me : k(e1) && o && o.scheme == e1.scheme ? a = ve : k(e1) ? a = xe : "/" == n[l + 1] ? (a = be, l++) : (e1.cannotBeABaseURL = !0, e1.path.push(""), a = Oe);
                                }
                                break;
                            case ge:
                                if (!o || o.cannotBeABaseURL && "#" != s) return j;
                                if (o.cannotBeABaseURL && "#" == s) {
                                    e1.scheme = o.scheme, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", e1.cannotBeABaseURL = !0, a = D;
                                    break;
                                }
                                a = "file" == o.scheme ? Me : je;
                                continue;
                            case ve:
                                if ("/" != s || "/" != n[l + 1]) {
                                    a = je;
                                    continue;
                                }
                                a = A, l++;
                                break;
                            case be:
                                if ("/" == s) {
                                    a = P;
                                    break;
                                }
                                a = R;
                                continue;
                            case je:
                                if (e1.scheme = o.scheme, s == g) e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = o.query;
                                else if ("/" == s || "\\" == s && k(e1)) a = _e;
                                else if ("?" == s) e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = "", a = I;
                                else {
                                    if ("#" != s) {
                                        e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.path.pop(), a = R;
                                        continue;
                                    }
                                    e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", a = D;
                                }
                                break;
                            case _e:
                                if (!k(e1) || "/" != s && "\\" != s) {
                                    if ("/" != s) {
                                        e1.username = o.username, e1.password = o.password, e1.host = o.host, e1.port = o.port, a = R;
                                        continue;
                                    }
                                    a = P;
                                } else a = A;
                                break;
                            case xe:
                                if (a = A, "/" != s || "/" != u.charAt(l + 1)) continue;
                                l++;
                                break;
                            case A:
                                if ("/" == s || "\\" == s) break;
                                a = P;
                                continue;
                            case P:
                                if ("@" == s) {
                                    c && (u = "%40" + u);
                                    for(var c = !0, h = b(u), p = 0; p < h.length; p++){
                                        var m = h[p];
                                        ":" != m || f ? (m = M(m, E), f ? e1.password += m : e1.username += m) : f = !0;
                                    }
                                    u = "";
                                } else if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1)) {
                                    if (c && "" == u) return Q;
                                    l -= b(u).length + 1, u = "", a = we;
                                } else u += s;
                                break;
                            case we:
                            case Se:
                                if (r && "file" == e1.scheme) {
                                    a = ke;
                                    continue;
                                }
                                if (":" != s || d) {
                                    if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1)) {
                                        if (k(e1) && "" == u) return _;
                                        if (r && "" == u && (O(e1) || null !== e1.port)) return;
                                        if (i = w(e1, u)) return i;
                                        if (u = "", a = L, r) return;
                                        continue;
                                    }
                                    "[" == s ? d = !0 : "]" == s && (d = !1), u += s;
                                } else {
                                    if ("" == u) return _;
                                    if (i = w(e1, u)) return i;
                                    if (u = "", a = Ee, r == Se) return;
                                }
                                break;
                            case Ee:
                                if (!x.test(s)) {
                                    if (s == g || "/" == s || "?" == s || "#" == s || "\\" == s && k(e1) || r) {
                                        if ("" != u) {
                                            var y = parseInt(u, 10);
                                            if (65535 < y) return J;
                                            e1.port = k(e1) && y === T[e1.scheme] ? null : y, u = "";
                                        }
                                        if (r) return;
                                        a = L;
                                        continue;
                                    }
                                    return J;
                                }
                                u += s;
                                break;
                            case Me:
                                if (e1.scheme = "file", "/" == s || "\\" == s) a = Te;
                                else {
                                    if (!o || "file" != o.scheme) {
                                        a = R;
                                        continue;
                                    }
                                    if (s == g) e1.host = o.host, e1.path = o.path.slice(), e1.query = o.query;
                                    else if ("?" == s) e1.host = o.host, e1.path = o.path.slice(), e1.query = "", a = I;
                                    else {
                                        if ("#" != s) {
                                            de(n.slice(l).join("")) || (e1.host = o.host, e1.path = o.path.slice(), fe(e1)), a = R;
                                            continue;
                                        }
                                        e1.host = o.host, e1.path = o.path.slice(), e1.query = o.query, e1.fragment = "", a = D;
                                    }
                                }
                                break;
                            case Te:
                                if ("/" == s || "\\" == s) {
                                    a = ke;
                                    break;
                                }
                                o && "file" == o.scheme && !de(n.slice(l).join("")) && (C(o.path[0], !0) ? e1.path.push(o.path[0]) : e1.host = o.host), a = R;
                                continue;
                            case ke:
                                if (s == g || "/" == s || "\\" == s || "?" == s || "#" == s) {
                                    if (!r && C(u)) a = R;
                                    else {
                                        if ("" == u) {
                                            if (e1.host = "", r) return;
                                        } else {
                                            if (i = w(e1, u)) return i;
                                            if ("localhost" == e1.host && (e1.host = ""), r) return;
                                            u = "";
                                        }
                                        a = L;
                                    }
                                    continue;
                                }
                                u += s;
                                break;
                            case L:
                                if (k(e1)) {
                                    if (a = R, "/" != s && "\\" != s) continue;
                                } else if (r || "?" != s) {
                                    if (r || "#" != s) {
                                        if (s != g && (a = R, "/" != s)) continue;
                                    } else e1.fragment = "", a = D;
                                } else e1.query = "", a = I;
                                break;
                            case R:
                                if (s == g || "/" == s || "\\" == s && k(e1) || !r && ("?" == s || "#" == s)) {
                                    if (pe(u) ? (fe(e1), "/" == s || "\\" == s && k(e1) || e1.path.push("")) : he(u) ? "/" == s || "\\" == s && k(e1) || e1.path.push("") : ("file" == e1.scheme && !e1.path.length && C(u) && (e1.host && (e1.host = ""), u = u.charAt(0) + ":"), e1.path.push(u)), u = "", "file" == e1.scheme && (s == g || "?" == s || "#" == s)) for(; 1 < e1.path.length && "" === e1.path[0];)e1.path.shift();
                                    "?" == s ? (e1.query = "", a = I) : "#" == s && (e1.fragment = "", a = D);
                                } else u += M(s, ce);
                                break;
                            case Oe:
                                "?" == s ? (e1.query = "", a = I) : "#" == s ? (e1.fragment = "", a = D) : s != g && (e1.path[0] += M(s, S));
                                break;
                            case I:
                                r || "#" != s ? s != g && ("'" == s && k(e1) ? e1.query += "%27" : e1.query += "#" == s ? "%23" : M(s, S)) : (e1.fragment = "", a = D);
                                break;
                            case D:
                                s != g && (e1.fragment += M(s, ue));
                        }
                        l++;
                    }
                }
                function l(e1) {
                    var t, r, o = G(this, l, "URL"), n = 1 < arguments.length ? arguments[1] : void 0, e1 = String(e1), s = X(o, {
                        type: "URL"
                    });
                    if (void 0 !== n) {
                        if (n instanceof l) t = p(n);
                        else if (r = a(t = {}, String(n))) throw TypeError(r);
                    }
                    if (r = a(s, e1, null, t)) throw TypeError(r);
                    var i = s.searchParams = new q;
                    (n = h(i)).updateSearchParams(s.query), n.updateURL = function() {
                        s.query = String(i) || null;
                    }, u || (o.href = m.call(o), o.origin = Ce.call(o), o.protocol = Ae.call(o), o.username = Pe.call(o), o.password = Le.call(o), o.host = Re.call(o), o.hostname = Ie.call(o), o.port = De.call(o), o.pathname = Fe.call(o), o.search = Ue.call(o), o.searchParams = Ne.call(o), o.hash = Be.call(o));
                }
                function t(e1, t) {
                    return {
                        get: e1,
                        set: t,
                        configurable: !0,
                        enumerable: !0
                    };
                }
                var g, r, o, U = e1("../internals/export"), u = e1("../internals/descriptors"), N = e1("../internals/native-url"), s = e1("../internals/global"), B = e1("../internals/object-define-properties"), i = e1("../internals/redefine"), G = e1("../internals/an-instance"), v = e1("../internals/has"), d = e1("../internals/object-assign"), b = e1("../internals/array-from"), V = e1("../internals/string-multibyte").codeAt, z = e1("../internals/string-punycode-to-ascii"), H = e1("../internals/set-to-string-tag"), W = e1("../modules/web.url-search-params"), e1 = e1("../internals/internal-state"), f = s.URL, q = W.URLSearchParams, h = W.getState, X = e1.set, p = e1.getterFor("URL"), Y = Math.floor, Z = Math.pow, Q = "Invalid authority", j = "Invalid scheme", _ = "Invalid host", J = "Invalid port", K = /[A-Za-z]/, $ = /[\d+-.A-Za-z]/, x = /\d/, ee = /^(0x|0X)/, te = /^[0-7]+$/, re = /^\d+$/, oe = /^[\dA-Fa-f]+$/, ne = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/, se = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/, ie = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g, ae = /[\u0009\u000A\u000D]/g, w = function(e1, t) {
                    var r, o, n;
                    if ("[" == t.charAt(0)) return "]" == t.charAt(t.length - 1) && (r = function(e1) {
                        var t = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ], r = 0, o = null, n = 0, s, i, a, l, u, c, d, f = function() {
                            return e1.charAt(n);
                        };
                        if (f() == ":") {
                            if (e1.charAt(1) != ":") return;
                            n += 2;
                            r++;
                            o = r;
                        }
                        while(f()){
                            if (r == 8) return;
                            if (f() == ":") {
                                if (o !== null) return;
                                n++;
                                r++;
                                o = r;
                                continue;
                            }
                            s = i = 0;
                            while(i < 4 && oe.test(f())){
                                s = s * 16 + parseInt(f(), 16);
                                n++;
                                i++;
                            }
                            if (f() == ".") {
                                if (i == 0) return;
                                n -= i;
                                if (r > 6) return;
                                a = 0;
                                while(f()){
                                    l = null;
                                    if (a > 0) {
                                        if (f() == "." && a < 4) n++;
                                        else return;
                                    }
                                    if (!x.test(f())) return;
                                    while(x.test(f())){
                                        u = parseInt(f(), 10);
                                        if (l === null) l = u;
                                        else if (l == 0) return;
                                        else l = l * 10 + u;
                                        if (l > 255) return;
                                        n++;
                                    }
                                    t[r] = t[r] * 256 + l;
                                    a++;
                                    if (a == 2 || a == 4) r++;
                                }
                                if (a != 4) return;
                                break;
                            } else if (f() == ":") {
                                n++;
                                if (!f()) return;
                            } else if (f()) return;
                            t[r++] = s;
                        }
                        if (o !== null) {
                            c = r - o;
                            r = 7;
                            while(r != 0 && c > 0){
                                d = t[r];
                                t[r--] = t[o + c - 1];
                                t[o + --c] = d;
                            }
                        } else if (r != 8) return;
                        return t;
                    }(t.slice(1, -1))) ? void (e1.host = r) : _;
                    if (k(e1)) return t = z(t), ne.test(t) || null === (r = function(e1) {
                        var t = e1.split("."), r, o, n, s, i, a, l;
                        if (t.length && t[t.length - 1] == "") t.pop();
                        if ((r = t.length) > 4) return e1;
                        for(o = [], n = 0; n < r; n++){
                            s = t[n];
                            if (s == "") return e1;
                            i = 10;
                            if (s.length > 1 && s.charAt(0) == "0") {
                                i = ee.test(s) ? 16 : 8;
                                s = s.slice(i == 8 ? 1 : 2);
                            }
                            if (s === "") a = 0;
                            else {
                                if (!(i == 10 ? re : i == 8 ? te : oe).test(s)) return e1;
                                a = parseInt(s, i);
                            }
                            o.push(a);
                        }
                        for(n = 0; n < r; n++){
                            a = o[n];
                            if (n == r - 1) {
                                if (a >= Z(256, 5 - r)) return null;
                            } else if (a > 255) return null;
                        }
                        for(l = o.pop(), n = 0; n < o.length; n++)l += o[n] * Z(256, 3 - n);
                        return l;
                    }(t)) ? _ : void (e1.host = r);
                    if (se.test(t)) return _;
                    for(r = "", o = b(t), n = 0; n < o.length; n++)r += M(o[n], S);
                    e1.host = r;
                }, le = function(e1) {
                    for(var t = null, r = 1, o = null, n = 0, s = 0; s < 8; s++)0 !== e1[s] ? (r < n && (t = o, r = n), o = null, n = 0) : (null === o && (o = s), ++n);
                    return r < n && (t = o, r = n), t;
                }, S = {}, ue = d({}, S, {
                    " ": 1,
                    '"': 1,
                    "<": 1,
                    ">": 1,
                    "`": 1
                }), ce = d({}, ue, {
                    "#": 1,
                    "?": 1,
                    "{": 1,
                    "}": 1
                }), E = d({}, ce, {
                    "/": 1,
                    ":": 1,
                    ";": 1,
                    "=": 1,
                    "@": 1,
                    "[": 1,
                    "\\": 1,
                    "]": 1,
                    "^": 1,
                    "|": 1
                }), M = function(e1, t) {
                    var r = V(e1, 0);
                    return 32 < r && r < 127 && !v(t, e1) ? e1 : encodeURIComponent(e1);
                }, T = {
                    ftp: 21,
                    file: null,
                    http: 80,
                    https: 443,
                    ws: 80,
                    wss: 443
                }, k = function(e1) {
                    return v(T, e1.scheme);
                }, O = function(e1) {
                    return "" != e1.username || "" != e1.password;
                }, C = function(e1, t) {
                    return 2 == e1.length && K.test(e1.charAt(0)) && (":" == (e1 = e1.charAt(1)) || !t && "|" == e1);
                }, de = function(e1) {
                    return 1 < e1.length && C(e1.slice(0, 2)) && (2 == e1.length || "/" === (e1 = e1.charAt(2)) || "\\" === e1 || "?" === e1 || "#" === e1);
                }, fe = function(e1) {
                    var t = e1.path, r = t.length;
                    !r || "file" == e1.scheme && 1 == r && C(t[0], !0) || t.pop();
                }, he = function(e1) {
                    return "." === e1 || "%2e" === e1.toLowerCase();
                }, pe = function(e1) {
                    return ".." === (e1 = e1.toLowerCase()) || "%2e." === e1 || ".%2e" === e1 || "%2e%2e" === e1;
                }, me = {}, ye = {}, ge = {}, ve = {}, be = {}, je = {}, _e = {}, xe = {}, A = {}, P = {}, we = {}, Se = {}, Ee = {}, Me = {}, Te = {}, ke = {}, L = {}, R = {}, Oe = {}, I = {}, D = {}, s = l.prototype, m = function() {
                    var e1 = p(this), t = e1.scheme, r = e1.username, o = e1.password, n = e1.host, s = e1.port, i = e1.path, a = e1.query, l = e1.fragment, u = t + ":";
                    return null !== n ? (u += "//", O(e1) && (u += r + (o ? ":" + o : "") + "@"), u += c(n), null !== s && (u += ":" + s)) : "file" == t && (u += "//"), u += e1.cannotBeABaseURL ? i[0] : i.length ? "/" + i.join("/") : "", null !== a && (u += "?" + a), null !== l && (u += "#" + l), u;
                }, Ce = function() {
                    var e1 = p(this), t = e1.scheme, r = e1.port;
                    if ("blob" == t) try {
                        return new URL(t.path[0]).origin;
                    } catch (e1) {
                        return "null";
                    }
                    return "file" != t && k(e1) ? t + "://" + c(e1.host) + (null !== r ? ":" + r : "") : "null";
                }, Ae = function() {
                    return p(this).scheme + ":";
                }, Pe = function() {
                    return p(this).username;
                }, Le = function() {
                    return p(this).password;
                }, Re = function() {
                    var e1 = p(this), t = e1.host, e1 = e1.port;
                    return null === t ? "" : null === e1 ? c(t) : c(t) + ":" + e1;
                }, Ie = function() {
                    var e1 = p(this).host;
                    return null === e1 ? "" : c(e1);
                }, De = function() {
                    var e1 = p(this).port;
                    return null === e1 ? "" : String(e1);
                }, Fe = function() {
                    var e1 = p(this), t = e1.path;
                    return e1.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : "";
                }, Ue = function() {
                    var e1 = p(this).query;
                    return e1 ? "?" + e1 : "";
                }, Ne = function() {
                    return p(this).searchParams;
                }, Be = function() {
                    var e1 = p(this).fragment;
                    return e1 ? "#" + e1 : "";
                };
                u && B(s, {
                    href: t(m, function(e1) {
                        var t = p(this), e1 = String(e1), e1 = a(t, e1);
                        if (e1) throw TypeError(e1);
                        h(t.searchParams).updateSearchParams(t.query);
                    }),
                    origin: t(Ce),
                    protocol: t(Ae, function(e1) {
                        var t = p(this);
                        a(t, String(e1) + ":", me);
                    }),
                    username: t(Pe, function(e1) {
                        var t = p(this), r = b(String(e1));
                        if (!n(t)) {
                            t.username = "";
                            for(var o = 0; o < r.length; o++)t.username += M(r[o], E);
                        }
                    }),
                    password: t(Le, function(e1) {
                        var t = p(this), r = b(String(e1));
                        if (!n(t)) {
                            t.password = "";
                            for(var o = 0; o < r.length; o++)t.password += M(r[o], E);
                        }
                    }),
                    host: t(Re, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || a(t, String(e1), we);
                    }),
                    hostname: t(Ie, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || a(t, String(e1), Se);
                    }),
                    port: t(De, function(e1) {
                        var t = p(this);
                        n(t) || ("" == (e1 = String(e1)) ? t.port = null : a(t, e1, Ee));
                    }),
                    pathname: t(Fe, function(e1) {
                        var t = p(this);
                        t.cannotBeABaseURL || (t.path = [], a(t, e1 + "", L));
                    }),
                    search: t(Ue, function(e1) {
                        var t = p(this);
                        "" == (e1 = String(e1)) ? t.query = null : ("?" == e1.charAt(0) && (e1 = e1.slice(1)), t.query = "", a(t, e1, I)), h(t.searchParams).updateSearchParams(t.query);
                    }),
                    searchParams: t(Ne),
                    hash: t(Be, function(e1) {
                        var t = p(this);
                        "" == (e1 = String(e1)) ? t.fragment = null : ("#" == e1.charAt(0) && (e1 = e1.slice(1)), t.fragment = "", a(t, e1, D));
                    })
                }), i(s, "toJSON", function() {
                    return m.call(this);
                }, {
                    enumerable: !0
                }), i(s, "toString", function() {
                    return m.call(this);
                }, {
                    enumerable: !0
                }), f && (r = f.createObjectURL, o = f.revokeObjectURL, r && i(l, "createObjectURL", function(e1) {
                    return r.apply(f, arguments);
                }), o && i(l, "revokeObjectURL", function(e1) {
                    return o.apply(f, arguments);
                })), H(l, "URL"), U({
                    global: !0,
                    forced: !N,
                    sham: !u
                }, {
                    URL: l
                });
            },
            {
                "../internals/an-instance": 9,
                "../internals/array-from": 17,
                "../internals/descriptors": 43,
                "../internals/export": 50,
                "../internals/global": 59,
                "../internals/has": 60,
                "../internals/internal-state": 70,
                "../internals/native-url": 84,
                "../internals/object-assign": 89,
                "../internals/object-define-properties": 91,
                "../internals/redefine": 108,
                "../internals/set-to-string-tag": 117,
                "../internals/string-multibyte": 123,
                "../internals/string-punycode-to-ascii": 126,
                "../modules/es.string.iterator": 190,
                "../modules/web.url-search-params": 237
            }
        ],
        239: [
            function(e1, t, r) {
                "use strict";
                t.exports = e1("./").polyfill();
            },
            {
                "./": 240
            }
        ],
        240: [
            function(V, r, o) {
                (function(B, G) {
                    var e1, t;
                    e1 = this, t = function() {
                        "use strict";
                        function l(e1) {
                            return "function" == typeof e1;
                        }
                        var r = Array.isArray || function(e1) {
                            return "[object Array]" === Object.prototype.toString.call(e1);
                        }, o = 0, t = void 0, n = void 0, i = function(e1, t) {
                            d[o] = e1, d[o + 1] = t, 2 === (o += 2) && (n ? n(f) : D());
                        };
                        var e1 = "undefined" != typeof window ? window : void 0, s = e1 || {}, s = s.MutationObserver || s.WebKitMutationObserver, a = "undefined" == typeof self && void 0 !== B && "[object process]" === ({}).toString.call(B), u = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
                        function c() {
                            var e1 = setTimeout;
                            return function() {
                                return e1(f, 1);
                            };
                        }
                        var d = new Array(1e3);
                        function f() {
                            for(var e1 = 0; e1 < o; e1 += 2)(0, d[e1])(d[e1 + 1]), d[e1] = void 0, d[e1 + 1] = void 0;
                            o = 0;
                        }
                        function h() {
                            try {
                                var e1 = Function("return this")().require("vertx");
                                return void 0 !== (t = e1.runOnLoop || e1.runOnContext) ? function() {
                                    t(f);
                                } : c();
                            } catch (e1) {
                                return c();
                            }
                        }
                        var p, m, y, D = void 0;
                        function g(e1, t) {
                            var r, o = this, n = new this.constructor(j), s = (void 0 === n[b] && P(n), o._state);
                            return s ? (r = arguments[s - 1], i(function() {
                                return C(s, n, r, o._result);
                            })) : k(o, n, e1, t), n;
                        }
                        function v(e1) {
                            var t;
                            return e1 && "object" == typeof e1 && e1.constructor === this ? e1 : (E(t = new this(j), e1), t);
                        }
                        var D = a ? function() {
                            return B.nextTick(f);
                        } : s ? (m = 0, a = new s(f), y = document.createTextNode(""), a.observe(y, {
                            characterData: !0
                        }), function() {
                            y.data = m = ++m % 2;
                        }) : u ? ((p = new MessageChannel).port1.onmessage = f, function() {
                            return p.port2.postMessage(0);
                        }) : (void 0 === e1 && "function" == typeof V ? h : c)(), b = Math.random().toString(36).substring(2);
                        function j() {}
                        var _ = void 0, x = 1, w = 2;
                        function F(e1, o, n) {
                            i(function(t) {
                                var r = !1, e1 = function(e1, t, r, o) {
                                    try {
                                        e1.call(t, r, o);
                                    } catch (e1) {
                                        return e1;
                                    }
                                }(n, o, function(e1) {
                                    r || (r = !0, (o !== e1 ? E : M)(t, e1));
                                }, function(e1) {
                                    r || (r = !0, T(t, e1));
                                }, t._label);
                                !r && e1 && (r = !0, T(t, e1));
                            }, e1);
                        }
                        function S(e1, t, r) {
                            var o, n;
                            t.constructor === e1.constructor && r === g && t.constructor.resolve === v ? (o = e1, (n = t)._state === x ? M(o, n._result) : n._state === w ? T(o, n._result) : k(n, void 0, function(e1) {
                                return E(o, e1);
                            }, function(e1) {
                                return T(o, e1);
                            })) : void 0 !== r && l(r) ? F(e1, t, r) : M(e1, t);
                        }
                        function E(t, e1) {
                            if (t === e1) T(t, new TypeError("You cannot resolve a promise with itself"));
                            else if (r = typeof e1, null === e1 || "object" != r && "function" != r) M(t, e1);
                            else {
                                r = void 0;
                                try {
                                    r = e1.then;
                                } catch (e1) {
                                    return void T(t, e1);
                                }
                                S(t, e1, r);
                            }
                            var r;
                        }
                        function U(e1) {
                            e1._onerror && e1._onerror(e1._result), O(e1);
                        }
                        function M(e1, t) {
                            e1._state === _ && (e1._result = t, e1._state = x, 0 !== e1._subscribers.length && i(O, e1));
                        }
                        function T(e1, t) {
                            e1._state === _ && (e1._state = w, e1._result = t, i(U, e1));
                        }
                        function k(e1, t, r, o) {
                            var n = e1._subscribers, s = n.length;
                            e1._onerror = null, n[s] = t, n[s + x] = r, n[s + w] = o, 0 === s && e1._state && i(O, e1);
                        }
                        function O(e1) {
                            var t = e1._subscribers, r = e1._state;
                            if (0 !== t.length) {
                                for(var o, n = void 0, s = e1._result, i = 0; i < t.length; i += 3)o = t[i], n = t[i + r], o ? C(r, o, n, s) : n(s);
                                e1._subscribers.length = 0;
                            }
                        }
                        function C(e1, t, r, o) {
                            var n = l(r), s = void 0, i = void 0, a = !0;
                            if (n) {
                                try {
                                    s = r(o);
                                } catch (e1) {
                                    a = !1, i = e1;
                                }
                                if (t === s) return void T(t, new TypeError("A promises callback cannot return that same promise."));
                            } else s = o;
                            t._state === _ && (n && a ? E(t, s) : !1 === a ? T(t, i) : e1 === x ? M(t, s) : e1 === w && T(t, s));
                        }
                        var A = 0;
                        function P(e1) {
                            e1[b] = A++, e1._state = void 0, e1._result = void 0, e1._subscribers = [];
                        }
                        L.prototype._enumerate = function(e1) {
                            for(var t = 0; this._state === _ && t < e1.length; t++)this._eachEntry(e1[t], t);
                        }, L.prototype._eachEntry = function(t, e1) {
                            var r = this._instanceConstructor, o = r.resolve;
                            if (o === v) {
                                var n, s = void 0, i = void 0, a = !1;
                                try {
                                    s = t.then;
                                } catch (e1) {
                                    a = !0, i = e1;
                                }
                                s === g && t._state !== _ ? this._settledAt(t._state, e1, t._result) : "function" != typeof s ? (this._remaining--, this._result[e1] = t) : r === R ? (n = new r(j), a ? T(n, i) : S(n, t, s), this._willSettleAt(n, e1)) : this._willSettleAt(new r(function(e1) {
                                    return e1(t);
                                }), e1);
                            } else this._willSettleAt(o(t), e1);
                        }, L.prototype._settledAt = function(e1, t, r) {
                            var o = this.promise;
                            o._state === _ && (this._remaining--, e1 === w ? T(o, r) : this._result[t] = r), 0 === this._remaining && M(o, this._result);
                        }, L.prototype._willSettleAt = function(e1, t) {
                            var r = this;
                            k(e1, void 0, function(e1) {
                                return r._settledAt(x, t, e1);
                            }, function(e1) {
                                return r._settledAt(w, t, e1);
                            });
                        };
                        var N = L;
                        function L(e1, t) {
                            this._instanceConstructor = e1, this.promise = new e1(j), this.promise[b] || P(this.promise), r(t) ? (this.length = t.length, this._remaining = t.length, this._result = new Array(this.length), 0 !== this.length && (this.length = this.length || 0, this._enumerate(t), 0 !== this._remaining) || M(this.promise, this._result)) : T(this.promise, new Error("Array Methods must be provided an Array"));
                        }
                        I.prototype.catch = function(e1) {
                            return this.then(null, e1);
                        }, I.prototype.finally = function(t) {
                            var r = this.constructor;
                            return l(t) ? this.then(function(e1) {
                                return r.resolve(t()).then(function() {
                                    return e1;
                                });
                            }, function(e1) {
                                return r.resolve(t()).then(function() {
                                    throw e1;
                                });
                            }) : this.then(t, t);
                        };
                        var R = I;
                        function I(e1) {
                            if (this[b] = A++, this._result = this._state = void 0, this._subscribers = [], j !== e1) {
                                if ("function" != typeof e1) throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                                if (!(this instanceof I)) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                                var t = this;
                                try {
                                    e1(function(e1) {
                                        E(t, e1);
                                    }, function(e1) {
                                        T(t, e1);
                                    });
                                } catch (e1) {
                                    T(t, e1);
                                }
                            }
                        }
                        return R.prototype.then = g, R.all = function(e1) {
                            return new N(this, e1).promise;
                        }, R.race = function(n) {
                            var s = this;
                            return r(n) ? new s(function(e1, t) {
                                for(var r = n.length, o = 0; o < r; o++)s.resolve(n[o]).then(e1, t);
                            }) : new s(function(e1, t) {
                                return t(new TypeError("You must pass an array to race."));
                            });
                        }, R.resolve = v, R.reject = function(e1) {
                            var t = new this(j);
                            return T(t, e1), t;
                        }, R._setScheduler = function(e1) {
                            n = e1;
                        }, R._setAsap = function(e1) {
                            i = e1;
                        }, R._asap = i, R.polyfill = function() {
                            var e1 = void 0;
                            if (void 0 !== G) e1 = G;
                            else if ("undefined" != typeof self) e1 = self;
                            else try {
                                e1 = Function("return this")();
                            } catch (e1) {
                                throw new Error("polyfill failed because global object is unavailable in this environment");
                            }
                            var t = e1.Promise;
                            if (t) {
                                var r = null;
                                try {
                                    r = Object.prototype.toString.call(t.resolve());
                                } catch (e1) {}
                                if ("[object Promise]" === r && !t.cast) return;
                            }
                            e1.Promise = R;
                        }, R.Promise = R;
                    }, "object" == typeof o && void 0 !== r ? r.exports = t() : "function" == typeof s && s.amd ? s(t) : e1.ES6Promise = t();
                }).call(this, V("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 249
            }
        ],
        241: [
            function(e1, t, r) {
                var o, n;
                o = this, n = function(e1, t) {
                    "use strict";
                    var r = 5e3, o = "callback";
                    function d(t) {
                        try {
                            delete window[t];
                        } catch (e1) {
                            window[t] = void 0;
                        }
                    }
                    function f(e1) {
                        e1 = document.getElementById(e1);
                        e1 && document.getElementsByTagName("head")[0].removeChild(e1);
                    }
                    t.exports = function(s) {
                        var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1], a = s, l = i.timeout || r, u = i.jsonpCallback || o, c = void 0;
                        return new Promise(function(t, e1) {
                            var r = i.jsonpCallbackFunction || "jsonp_" + Date.now() + "_" + Math.ceil(1e5 * Math.random()), o = u + "_" + r, n = (window[r] = function(e1) {
                                t({
                                    ok: !0,
                                    json: function() {
                                        return Promise.resolve(e1);
                                    }
                                }), c && clearTimeout(c), f(o), d(r);
                            }, a += -1 === a.indexOf("?") ? "?" : "&", document.createElement("script"));
                            n.setAttribute("src", "" + a + u + "=" + r), i.charset && n.setAttribute("charset", i.charset), n.id = o, document.getElementsByTagName("head")[0].appendChild(n), c = setTimeout(function() {
                                e1(new Error("JSONP request to " + s + " timed out")), d(r), f(o), window[r] = function() {
                                    d(r);
                                };
                            }, l), n.onerror = function() {
                                e1(new Error("JSONP request to " + s + " failed")), d(r), f(o), c && clearTimeout(c);
                            };
                        });
                    };
                }, "function" == typeof s && s.amd ? s([
                    "exports",
                    "module"
                ], n) : void 0 !== r && void 0 !== t ? n(0, t) : (n(n = {
                    exports: {}
                }, n), o.fetchJsonp = n.exports);
            },
            {}
        ],
        242: [
            function(e1, t, r) {
                var o = function(a) {
                    "use strict";
                    var l, u, c, d, f, h, t, p, m, o, e1;
                    if (!(void 0 === a || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) return e1 = a.document, l = function() {
                        return a.URL || a.webkitURL || a;
                    }, u = e1.createElementNS("http://www.w3.org/1999/xhtml", "a"), c = "download" in u, d = /constructor/i.test(a.HTMLElement) || a.safari, f = /CriOS\/[\d]+/.test(navigator.userAgent), h = function(e1) {
                        (a.setImmediate || a.setTimeout)(function() {
                            throw e1;
                        }, 0);
                    }, t = 4e4, p = function(e1) {
                        setTimeout(function() {
                            "string" == typeof e1 ? l().revokeObjectURL(e1) : e1.remove();
                        }, t);
                    }, m = function(e1) {
                        return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e1.type) ? new Blob([
                            String.fromCharCode(65279),
                            e1
                        ], {
                            type: e1.type
                        }) : e1;
                    }, e1 = (o = function(e1, r, t) {
                        t || (e1 = m(e1));
                        var o, n, s = this, t = "application/octet-stream" === e1.type, i = function() {
                            for(var e1 = s, t = "writestart progress write writeend".split(" "), r = void 0, o = (t = [].concat(t)).length; o--;){
                                var n = e1["on" + t[o]];
                                if ("function" == typeof n) try {
                                    n.call(e1, r || e1);
                                } catch (e1) {
                                    h(e1);
                                }
                            }
                        };
                        s.readyState = s.INIT, c ? (o = l().createObjectURL(e1), setTimeout(function() {
                            var e1, t;
                            u.href = o, u.download = r, e1 = u, t = new MouseEvent("click"), e1.dispatchEvent(t), i(), p(o), s.readyState = s.DONE;
                        })) : (f || t && d) && a.FileReader ? ((n = new FileReader).onloadend = function() {
                            var e1 = f ? n.result : n.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                            a.open(e1, "_blank") || (a.location.href = e1), e1 = void 0, s.readyState = s.DONE, i();
                        }, n.readAsDataURL(e1), s.readyState = s.INIT) : (o = o || l().createObjectURL(e1), !t && a.open(o, "_blank") || (a.location.href = o), s.readyState = s.DONE, i(), p(o));
                    }).prototype, "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function(e1, t, r) {
                        return t = t || e1.name || "download", r || (e1 = m(e1)), navigator.msSaveOrOpenBlob(e1, t);
                    } : (e1.abort = function() {}, e1.readyState = e1.INIT = 0, e1.WRITING = 1, e1.DONE = 2, e1.error = e1.onwritestart = e1.onprogress = e1.onwrite = e1.onabort = e1.onerror = e1.onwriteend = null, function(e1, t, r) {
                        return new o(e1, t || e1.name || "download", r);
                    });
                }("undefined" != typeof self && self || "undefined" != typeof window && window || this.content);
                void 0 !== t && t.exports ? t.exports.saveAs = o : null != s && null !== s.amd && s("FileSaver.js", function() {
                    return o;
                });
            },
            {}
        ],
        243: [
            function(e1, t, r) {
                var o, n = Object.defineProperty, s = (n(r, "__esModule", {
                    value: !0
                }), r), i = {
                    GIFEncoder: ()=>f,
                    applyPalette: ()=>function(e1, t, r = "rgb565") {
                            if (!e1 || !e1.buffer) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (!(e1 instanceof Uint8Array || e1 instanceof Uint8ClampedArray)) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (256 < t.length) throw new Error("applyPalette() only works with 256 colors or less");
                            const o = new Uint32Array(e1.buffer), n = o.length, s = "rgb444" === r ? 4096 : 65536, i = new Uint8Array(n), a = new Array(s);
                            if ("rgba4444" === r) for(let e1 = 0; e1 < n; e1++){
                                var l = o[e1], u = l >> 24 & 255, c = l >> 16 & 255, d = l >> 8 & 255, l = 255 & l, f = A(l, d, c, u), f = f in a ? a[f] : a[f] = function(t, r, o, n, s) {
                                    let i = 0, a = 1e100;
                                    for(let e1 = 0; e1 < s.length; e1++){
                                        var l, u = s[e1], c = v(u[3] - n);
                                        c > a || (l = u[0], (c += v(l - t)) > a || (l = u[1], (c += v(l - r)) > a || (l = u[2], (c += v(l - o)) > a || (a = c, i = e1))));
                                    }
                                    return i;
                                }(l, d, c, u, t);
                                i[e1] = f;
                            }
                            else {
                                const g = "rgb444" === r ? P : C;
                                for(let e1 = 0; e1 < n; e1++){
                                    var h = o[e1], p = h >> 16 & 255, m = h >> 8 & 255, h = 255 & h, y = g(h, m, p), y = y in a ? a[y] : a[y] = function(t, r, o, n) {
                                        let s = 0, i = 1e100;
                                        for(let e1 = 0; e1 < n.length; e1++){
                                            var a, l = n[e1], u = v(l[0] - t);
                                            u > i || (a = l[1], (u += v(a - r)) > i || (a = l[2], (u += v(a - o)) > i || (i = u, s = e1)));
                                        }
                                        return s;
                                    }(h, m, p, t);
                                    i[e1] = y;
                                }
                            }
                            return i;
                        },
                    default: ()=>h,
                    nearestColor: ()=>function(e1, t, r = u) {
                            return e1[l(e1, t, r)];
                        },
                    nearestColorIndex: ()=>l,
                    nearestColorIndexWithDistance: ()=>d,
                    prequantize: ()=>function(e1, { roundRGB: r = 5, roundAlpha: o = 10, oneBitAlpha: n = null } = {}) {
                            const s = new Uint32Array(e1.buffer);
                            for(let t = 0; t < s.length; t++){
                                var i = s[t];
                                let e1 = i >> 24 & 255;
                                var a, l = i >> 16 & 255, u = i >> 8 & 255, i = 255 & i;
                                e1 = c(e1, o), n && (a = "number" == typeof n ? n : 127, e1 = e1 <= a ? 0 : 255), i = c(i, r), u = c(u, r), l = c(l, r), s[t] = e1 << 24 | l << 16 | u << 8 | i << 0;
                            }
                        },
                    quantize: ()=>function(e1, t, r = {}) {
                            var { format: o = "rgb565", clearAlpha: n = !0, clearAlphaColor: s = 0, clearAlphaThreshold: i = 0, oneBitAlpha: a = !1 } = r;
                            if (!e1 || !e1.buffer) throw new Error("quantize() expected RGBA Uint8Array data");
                            if (!(e1 instanceof Uint8Array || e1 instanceof Uint8ClampedArray)) throw new Error("quantize() expected RGBA Uint8Array data");
                            e1 = new Uint32Array(e1.buffer);
                            let l = !1 !== r.useSqrt;
                            const u = "rgba4444" === o, c = function(r, e1) {
                                const t = "rgb444" === e1 ? 4096 : 65536, o = new Array(t), n = r.length;
                                if ("rgba4444" === e1) for(let t = 0; t < n; ++t){
                                    var s = r[t], i = s >> 24 & 255, a = s >> 16 & 255, l = s >> 8 & 255, s = 255 & s, u = A(s, l, a, i);
                                    let e1 = u in o ? o[u] : o[u] = D();
                                    e1.rc += s, e1.gc += l, e1.bc += a, e1.ac += i, e1.cnt++;
                                }
                                else if ("rgb444" === e1) for(let t = 0; t < n; ++t){
                                    var c = r[t], d = c >> 16 & 255, f = c >> 8 & 255, c = 255 & c, h = P(c, f, d);
                                    let e1 = h in o ? o[h] : o[h] = D();
                                    e1.rc += c, e1.gc += f, e1.bc += d, e1.cnt++;
                                }
                                else for(let t = 0; t < n; ++t){
                                    var p = r[t], m = p >> 16 & 255, y = p >> 8 & 255, p = 255 & p, g = C(p, y, m);
                                    let e1 = g in o ? o[g] : o[g] = D();
                                    e1.rc += p, e1.gc += y, e1.bc += m, e1.cnt++;
                                }
                                return o;
                            }(e1, o), d = c.length, f = d - 1, h = new Uint32Array(d + 1);
                            for(var p = 0, m = 0; m < d; ++m){
                                const O = c[m];
                                null != O && (M = 1 / O.cnt, u && (O.ac *= M), O.rc *= M, O.gc *= M, O.bc *= M, c[p++] = O);
                            }
                            R(t) / p < .022 && (l = !1);
                            for(var y, g, v, m = 0; m < p - 1; ++m)c[m].fw = m + 1, c[m + 1].bk = m, l && (c[m].cnt = Math.sqrt(c[m].cnt));
                            l && (c[m].cnt = Math.sqrt(c[m].cnt));
                            for(m = 0; m < p; ++m){
                                I(c, m, !1);
                                var b = c[m].err;
                                for(g = ++h[0]; 1 < g && (v = g >> 1, !(c[y = h[v]].err <= b)); g = v)h[g] = y;
                                h[g] = m;
                            }
                            var j, _ = p - t;
                            for(m = 0; m < _;){
                                for(;;){
                                    var x = h[1];
                                    if ((j = c[x]).tm >= j.mtm && c[j.nn].mtm <= j.tm) break;
                                    j.mtm == f ? x = h[1] = h[h[0]--] : (I(c, x, !1), j.tm = m);
                                    b = c[x].err;
                                    for(g = 1; (v = g + g) <= h[0] && (v < h[0] && c[h[v]].err > c[h[v + 1]].err && v++, !(b <= c[y = h[v]].err)); g = v)h[g] = y;
                                    h[g] = x;
                                }
                                var w = c[j.nn], S = j.cnt, E = w.cnt, M = 1 / (S + E);
                                u && (j.ac = M * (S * j.ac + E * w.ac)), j.rc = M * (S * j.rc + E * w.rc), j.gc = M * (S * j.gc + E * w.gc), j.bc = M * (S * j.bc + E * w.bc), j.cnt += w.cnt, j.mtm = ++m, c[w.bk].fw = w.fw, c[w.fw].bk = w.bk, w.mtm = f;
                            }
                            let T = [];
                            for(m = 0;;){
                                let e1 = L(Math.round(c[m].rc), 0, 255), t = L(Math.round(c[m].gc), 0, 255), r = L(Math.round(c[m].bc), 0, 255), o = 255;
                                u && (o = L(Math.round(c[m].ac), 0, 255), a && (k = "number" == typeof a ? a : 127, o = o <= k ? 0 : 255), n && o <= i && (e1 = t = r = s, o = 0));
                                var k = u ? [
                                    e1,
                                    t,
                                    r,
                                    o
                                ] : [
                                    e1,
                                    t,
                                    r
                                ];
                                if (function(t, r) {
                                    for(let e1 = 0; e1 < t.length; e1++){
                                        var o = t[e1], n = o[0] === r[0] && o[1] === r[1] && o[2] === r[2], o = !(4 <= o.length && 4 <= r.length) || o[3] === r[3];
                                        if (n && o) return !0;
                                    }
                                    return !1;
                                }(T, k) || T.push(k), 0 == (m = c[m].fw)) break;
                            }
                            return T;
                        },
                    snapColorsToPalette: ()=>function(r, o, e1 = 5) {
                            if (r.length && o.length) {
                                var n = r.map((e1)=>e1.slice(0, 3)), s = e1 * e1, i = r[0].length;
                                for(let t = 0; t < o.length; t++){
                                    let e1 = o[t];
                                    e1 = e1.length < i ? [
                                        e1[0],
                                        e1[1],
                                        e1[2],
                                        255
                                    ] : e1.length > i ? e1.slice(0, 3) : e1.slice();
                                    var a = d(n, e1.slice(0, 3), u), l = a[0], a = a[1];
                                    0 < a && a <= s && (r[l] = e1);
                                }
                            }
                        }
                };
                for(o in i)n(s, o, {
                    get: i[o],
                    enumerable: !0
                });
                var a = {
                    signature: "GIF",
                    version: "89a",
                    trailer: 59,
                    extensionIntroducer: 33,
                    applicationExtensionLabel: 255,
                    graphicControlExtensionLabel: 249,
                    imageSeparator: 44,
                    signatureSize: 3,
                    versionSize: 3,
                    globalColorTableFlagMask: 128,
                    colorResolutionMask: 112,
                    sortFlagMask: 8,
                    globalColorTableSizeMask: 7,
                    applicationIdentifierSize: 8,
                    applicationAuthCodeSize: 3,
                    disposalMethodMask: 28,
                    userInputFlagMask: 2,
                    transparentColorFlagMask: 1,
                    localColorTableFlagMask: 128,
                    interlaceFlagMask: 64,
                    idSortFlagMask: 32,
                    localColorTableSizeMask: 7
                };
                function T(e1 = 256) {
                    let n = 0, s = new Uint8Array(e1);
                    return {
                        get buffer () {
                            return s.buffer;
                        },
                        reset () {
                            n = 0;
                        },
                        bytesView () {
                            return s.subarray(0, n);
                        },
                        bytes () {
                            return s.slice(0, n);
                        },
                        writeByte (e1) {
                            i(n + 1), s[n] = e1, n++;
                        },
                        writeBytes (t, r = 0, o = t.length) {
                            i(n + o);
                            for(let e1 = 0; e1 < o; e1++)s[n++] = t[e1 + r];
                        },
                        writeBytesView (e1, t = 0, r = e1.byteLength) {
                            i(n + r), s.set(e1.subarray(t, t + r), n), n += r;
                        }
                    };
                    function i(e1) {
                        var t = s.length;
                        if (!(e1 <= t)) {
                            e1 = Math.max(e1, t * (t < 1048576 ? 2 : 1.125) >>> 0), 0 != t && (e1 = Math.max(e1, 256));
                            const r = s;
                            s = new Uint8Array(e1), 0 < n && s.set(r.subarray(0, n), 0);
                        }
                    }
                }
                var k = [
                    0,
                    1,
                    3,
                    7,
                    15,
                    31,
                    63,
                    127,
                    255,
                    511,
                    1023,
                    2047,
                    4095,
                    8191,
                    16383,
                    32767,
                    65535
                ];
                var S = function(e1, t, r, o, n = T(512), s = new Uint8Array(256), i = new Int32Array(5003), a = new Int32Array(5003)) {
                    var l = i.length, o = Math.max(2, o);
                    s.fill(0), a.fill(0), i.fill(-1);
                    let u = 0, c = 0;
                    var d = o + 1;
                    const f = d;
                    let h = !1, p = f, m = (1 << p) - 1;
                    var y = 1 << d - 1;
                    const g = 1 + y;
                    let v = 2 + y, b = 0, j = r[0], _ = 0;
                    for(let e1 = l; e1 < 65536; e1 *= 2)++_;
                    _ = 8 - _, n.writeByte(o), M(y);
                    var x = r.length;
                    for(let t = 1; t < x; t++)e: {
                        var w = r[t], S = (w << 12) + j;
                        let e1 = w << _ ^ j;
                        if (i[e1] === S) j = a[e1];
                        else {
                            for(var E = 0 === e1 ? 1 : l - e1; 0 <= i[e1];)if ((e1 -= E) < 0 && (e1 += l), i[e1] === S) {
                                j = a[e1];
                                break e;
                            }
                            M(j), j = w, v < 4096 ? (a[e1] = v++, i[e1] = S) : (i.fill(-1), v = 2 + y, h = !0, M(y));
                        }
                    }
                    return M(j), M(g), n.writeByte(0), n.bytesView();
                    function M(e1) {
                        for(u &= k[c], 0 < c ? u |= e1 << c : u = e1, c += p; 8 <= c;)s[b++] = 255 & u, 254 <= b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0), u >>= 8, c -= 8;
                        if ((v > m || h) && (h ? (p = f, m = (1 << p) - 1, h = !1) : (++p, m = 12 === p ? 1 << p : (1 << p) - 1)), e1 == g) {
                            for(; 0 < c;)s[b++] = 255 & u, 254 <= b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0), u >>= 8, c -= 8;
                            0 < b && (n.writeByte(b), n.writeBytesView(s, 0, b), b = 0);
                        }
                    }
                };
                function C(e1, t, r) {
                    return e1 << 8 & 63488 | t << 2 & 992 | r >> 3;
                }
                function A(e1, t, r, o) {
                    return e1 >> 4 | 240 & t | (240 & r) << 4 | (240 & o) << 8;
                }
                function P(e1, t, r) {
                    return e1 >> 4 << 8 | 240 & t | r >> 4;
                }
                function L(e1, t, r) {
                    return e1 < t ? t : r < e1 ? r : e1;
                }
                function R(e1) {
                    return e1 * e1;
                }
                function I(e1, t, r) {
                    var o = 0, n = 1e100;
                    const s = e1[t];
                    for(var i = s.cnt, a = s.ac, l = s.rc, u = s.gc, c = s.bc, d = s.fw; 0 != d; d = e1[d].fw){
                        var f, h = e1[d], p = h.cnt, p = i * p / (i + p);
                        n <= p || (f = 0, r && n <= (f += p * R(h.ac - a)) || n <= (f += p * R(h.rc - l)) || n <= (f += p * R(h.gc - u)) || n <= (f += p * R(h.bc - c)) || (n = f, o = d));
                    }
                    s.err = n, s.nn = o;
                }
                function D() {
                    return {
                        ac: 0,
                        rc: 0,
                        gc: 0,
                        bc: 0,
                        cnt: 0,
                        nn: 0,
                        fw: 0,
                        bk: 0,
                        tm: 0,
                        mtm: 0,
                        err: 0
                    };
                }
                function u(e1, t) {
                    for(var r = 0, o = 0; o < e1.length; o++){
                        var n = e1[o] - t[o];
                        r += n * n;
                    }
                    return r;
                }
                function c(e1, t) {
                    return 1 < t ? Math.round(e1 / t) * t : e1;
                }
                function v(e1) {
                    return e1 * e1;
                }
                function l(t, r, o = u) {
                    let n = 1 / 0, s = -1;
                    for(let e1 = 0; e1 < t.length; e1++){
                        var i = o(r, t[e1]);
                        i < n && (n = i, s = e1);
                    }
                    return s;
                }
                function d(t, r, o = u) {
                    let n = 1 / 0, s = -1;
                    for(let e1 = 0; e1 < t.length; e1++){
                        var i = o(r, t[e1]);
                        i < n && (n = i, s = e1);
                    }
                    return [
                        s,
                        n
                    ];
                }
                function f(e1 = {}) {
                    const { initialCapacity: t = 4096, auto: g = !0 } = e1, v = T(t);
                    const b = new Uint8Array(256), j = new Int32Array(5003), _ = new Int32Array(5003);
                    let x = !1;
                    return {
                        reset () {
                            v.reset(), x = !1;
                        },
                        finish () {
                            v.writeByte(a.trailer);
                        },
                        bytes () {
                            return v.bytes();
                        },
                        bytesView () {
                            return v.bytesView();
                        },
                        get buffer () {
                            return v.buffer;
                        },
                        get stream () {
                            return v;
                        },
                        writeHeader: w,
                        writeFrame (e1, t, r, o = {}) {
                            var { transparent: n = !1, transparentIndex: s = 0, delay: i = 0, palette: a = null, repeat: l = 0, colorDepth: u = 8, dispose: c = -1 } = o;
                            let d = !1;
                            if (g ? x || (d = !0, w(), x = !0) : d = Boolean(o.first), t = Math.max(0, Math.floor(t)), r = Math.max(0, Math.floor(r)), d) {
                                if (!a) throw new Error("First frame must include a { palette } option");
                                var [o, f, h, p, m = 8] = [
                                    v,
                                    t,
                                    r,
                                    a,
                                    u
                                ];
                                p = F(p.length) - 1, m = 128 | m - 1 << 4 | p, M(o, f), M(o, h), o.writeBytes([
                                    m,
                                    0,
                                    0
                                ]), E(v, a), 0 <= l && (p = v, f = l, p.writeByte(33), p.writeByte(255), p.writeByte(11), O(p, "NETSCAPE2.0"), p.writeByte(3), p.writeByte(1), M(p, f), p.writeByte(0));
                            }
                            var y, h = Math.round(i / 10), o = v, m = c, l = h, f = n, p = s, i = (o.writeByte(33), o.writeByte(249), o.writeByte(4), p < 0 && (p = 0, f = !1), f = f ? (y = 1, 2) : y = 0, 0 <= m && (f = 7 & m), f <<= 2, o.writeByte(0 | f | y), M(o, l), o.writeByte(p || 0), o.writeByte(0), Boolean(a) && !d);
                            c = v, n = t, s = r, y = i ? a : null, c.writeByte(44), M(c, 0), M(c, 0), M(c, n), M(c, s), y ? (n = F(y.length) - 1, c.writeByte(128 | n)) : c.writeByte(0), i && E(v, a), [l, o, s, n, c = 8, i, a, e1] = [
                                v,
                                e1,
                                t,
                                r,
                                u,
                                b,
                                j,
                                _
                            ], S(s, n, o, c, l, i, a, e1);
                        }
                    };
                    function w() {
                        O(v, "GIF89a");
                    }
                }
                function E(r, o) {
                    var e1 = 1 << F(o.length);
                    for(let t = 0; t < e1; t++){
                        let e1 = [
                            0,
                            0,
                            0
                        ];
                        t < o.length && (e1 = o[t]), r.writeByte(e1[0]), r.writeByte(e1[1]), r.writeByte(e1[2]);
                    }
                }
                function M(e1, t) {
                    e1.writeByte(255 & t), e1.writeByte(t >> 8 & 255);
                }
                function O(e1, t) {
                    for(var r = 0; r < t.length; r++)e1.writeByte(t.charCodeAt(r));
                }
                function F(e1) {
                    return Math.max(Math.ceil(Math.log2(e1)), 1);
                }
                var h = f;
            },
            {}
        ],
        244: [
            function(e1, t, r) {
                r.read = function(e1, t, r, o, n) {
                    var s, i, a = 8 * n - o - 1, l = (1 << a) - 1, u = l >> 1, c = -7, d = r ? n - 1 : 0, f = r ? -1 : 1, n = e1[t + d];
                    for(d += f, s = n & (1 << -c) - 1, n >>= -c, c += a; 0 < c; s = 256 * s + e1[t + d], d += f, c -= 8);
                    for(i = s & (1 << -c) - 1, s >>= -c, c += o; 0 < c; i = 256 * i + e1[t + d], d += f, c -= 8);
                    if (0 === s) s = 1 - u;
                    else {
                        if (s === l) return i ? NaN : 1 / 0 * (n ? -1 : 1);
                        i += Math.pow(2, o), s -= u;
                    }
                    return (n ? -1 : 1) * i * Math.pow(2, s - o);
                }, r.write = function(e1, t, r, o, n, s) {
                    var i, a, l = 8 * s - n - 1, u = (1 << l) - 1, c = u >> 1, d = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = o ? 0 : s - 1, h = o ? 1 : -1, s = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, i = u) : (i = Math.floor(Math.log(t) / Math.LN2), t * (o = Math.pow(2, -i)) < 1 && (i--, o *= 2), 2 <= (t += 1 <= i + c ? d / o : d * Math.pow(2, 1 - c)) * o && (i++, o /= 2), u <= i + c ? (a = 0, i = u) : 1 <= i + c ? (a = (t * o - 1) * Math.pow(2, n), i += c) : (a = t * Math.pow(2, c - 1) * Math.pow(2, n), i = 0)); 8 <= n; e1[r + f] = 255 & a, f += h, a /= 256, n -= 8);
                    for(i = i << n | a, l += n; 0 < l; e1[r + f] = 255 & i, f += h, i /= 256, l -= 8);
                    e1[r + f - h] |= 128 * s;
                };
            },
            {}
        ],
        245: [
            function(o, e1, c) {
                "use strict";
                var t;
                function y(e1, t) {
                    return e1.b === t.b && e1.a === t.a;
                }
                function g(e1, t) {
                    return e1.b < t.b || e1.b === t.b && e1.a <= t.a;
                }
                function v(e1, t, r) {
                    var o = t.b - e1.b, n = r.b - t.b;
                    return 0 < o + n ? o < n ? t.a - e1.a + o / (o + n) * (e1.a - r.a) : t.a - r.a + n / (o + n) * (r.a - e1.a) : 0;
                }
                function b(e1, t, r) {
                    var o = t.b - e1.b, n = r.b - t.b;
                    return 0 < o + n ? (t.a - r.a) * o + (t.a - e1.a) * n : 0;
                }
                function j(e1, t) {
                    return e1.a < t.a || e1.a === t.a && e1.b <= t.b;
                }
                function V(e1, t, r) {
                    var o = t.a - e1.a, n = r.a - t.a;
                    return 0 < o + n ? o < n ? t.b - e1.b + o / (o + n) * (e1.b - r.b) : t.b - r.b + n / (o + n) * (r.b - e1.b) : 0;
                }
                function z(e1, t, r) {
                    var o = t.a - e1.a, n = r.a - t.a;
                    return 0 < o + n ? (t.b - r.b) * o + (t.b - e1.b) * n : 0;
                }
                function _(e1, t, r, o) {
                    return (e1 = e1 < 0 ? 0 : e1) <= (r = r < 0 ? 0 : r) ? 0 === r ? (t + o) / 2 : t + e1 / (e1 + r) * (o - t) : o + r / (e1 + r) * (t - o);
                }
                function d(e1) {
                    var t = s(e1.b);
                    return n(t, e1.c), n(t.b, e1.c), i(t, e1.a), t;
                }
                function x(e1, t) {
                    var r = !1, o = !1;
                    e1 !== t && (t.a !== e1.a && (o = !0, M(t.a, e1.a)), t.d !== e1.d && (r = !0, a(t.d, e1.d)), E(t, e1), o || (n(t, e1.a), e1.a.c = e1), r || (i(t, e1.d), e1.d.a = e1));
                }
                function m(e1) {
                    var t = e1.b, r = !1;
                    e1.d !== e1.b.d && (r = !0, a(e1.d, e1.b.d)), e1.c === e1 ? M(e1.a, null) : (e1.b.d.a = e1.b.e, e1.a.c = e1.c, E(e1, e1.b.e), r || i(e1, e1.d)), t.c === t ? (M(t.a, null), a(t.d, null)) : (e1.d.a = t.b.e, t.a.c = t.c, E(t, t.b.e)), H(e1);
                }
                function w(e1) {
                    var t = s(e1), r = t.b;
                    return E(t, e1.e), t.a = e1.b.a, n(r, t.a), t.d = r.d = e1.d, t = t.b, E(e1.b, e1.b.b.e), E(e1.b, t), e1.b.a = t.a, t.b.a.c = t.b, t.b.d = e1.b.d, t.f = e1.f, t.b.f = e1.b.f, t;
                }
                function S(e1, t) {
                    var r = !1, o = s(e1), n = o.b;
                    return t.d !== e1.d && (r = !0, a(t.d, e1.d)), E(o, e1.e), E(n, t), o.a = e1.b.a, n.a = t.a, o.d = n.d = e1.d, e1.d.a = n, r || i(o, e1.d), o;
                }
                function s(e1) {
                    var t = new u, r = new u, o = e1.b.h;
                    return (((r.h = o).b.h = t).h = e1).b.h = r, t.b = r, ((t.c = t).e = r).b = t, (r.c = r).e = t;
                }
                function E(e1, t) {
                    var r = e1.c, o = t.c;
                    r.b.e = t, (o.b.e = e1).c = o, t.c = r;
                }
                function n(e1, t) {
                    var r = t.f, o = new D(t, r);
                    for(r.e = o, r = (t.f = o).c = e1; r.a = o, (r = r.c) !== e1;);
                }
                function i(e1, t) {
                    var r = t.d, o = new te(t, r);
                    for(r.b = o, (t.d = o).a = e1, o.c = t.c, r = e1; r.d = o, (r = r.e) !== e1;);
                }
                function H(e1) {
                    var t = e1.h;
                    e1 = e1.b.h, (t.b.h = e1).b.h = t;
                }
                function M(e1, t) {
                    for(var r = e1.c, o = r; o.a = t, (o = o.c) !== r;);
                    r = e1.f, ((o = e1.e).f = r).e = o;
                }
                function a(e1, t) {
                    for(var r = e1.a, o = r; o.d = t, (o = o.e) !== r;);
                    r = e1.d, ((o = e1.b).d = r).b = o;
                }
                function W(e1) {
                    var t = 0;
                    return Math.abs(e1[1]) > Math.abs(e1[0]) && (t = 1), t = Math.abs(e1[2]) > Math.abs(e1[t]) ? 2 : t;
                }
                function T(e1, t) {
                    e1.f += t.f, e1.b.f += t.b.f;
                }
                function f(e1, t, r) {
                    return e1 = e1.a, t = t.a, r = r.a, t.b.a === e1 ? r.b.a === e1 ? g(t.a, r.a) ? b(r.b.a, t.a, r.a) <= 0 : 0 <= b(t.b.a, r.a, t.a) : b(r.b.a, e1, r.a) <= 0 : r.b.a === e1 ? 0 <= b(t.b.a, e1, t.a) : (t = v(t.b.a, e1, t.a), (e1 = v(r.b.a, e1, r.a)) <= t);
                }
                function k(e1) {
                    e1.a.i = null;
                    var t = e1.e;
                    t.a.c = t.c, t.c.a = t.a, e1.e = null;
                }
                function O(e1, t) {
                    m(e1.a), e1.c = !1, (e1.a = t).i = e1;
                }
                function C(e1) {
                    for(var t = e1.a.a; (e1 = G(e1)).a.a === t;);
                    return e1.c && (O(e1, t = S(B(e1).a.b, e1.a.e)), e1 = G(e1)), e1;
                }
                function q(e1, t, r) {
                    var o = new N;
                    return o.a = r, o.e = p(e1.f, t.e, o), r.i = o;
                }
                function X(e1, t) {
                    switch(e1.s){
                        case 100130:
                            return 0 != (1 & t);
                        case 100131:
                            return 0 !== t;
                        case 100132:
                            return 0 < t;
                        case 100133:
                            return t < 0;
                        case 100134:
                            return 2 <= t || t <= -2;
                    }
                    return !1;
                }
                function h(e1) {
                    var t = e1.a, r = t.d;
                    r.c = e1.d, r.a = t, k(e1);
                }
                function A(e1, t, r) {
                    for(t = (e1 = t).a; e1 !== r;){
                        e1.c = !1;
                        var o = B(e1), n = o.a;
                        if (n.a !== t.a) {
                            if (!o.c) {
                                h(e1);
                                break;
                            }
                            O(o, n = S(t.c.b, n.b));
                        }
                        t.c !== n && (x(n.b.e, n), x(t, n)), h(e1), t = o.a, e1 = o;
                    }
                    return t;
                }
                function P(e1, t, r, o, n, s) {
                    for(var i = !0; q(e1, t, r.b), (r = r.c) !== o;);
                    for(null === n && (n = B(t).a.b.c); (r = (o = B(t)).a.b).a === n.a;)r.c !== n && (x(r.b.e, r), x(n.b.e, r)), o.f = t.f - r.f, o.d = X(e1, o.f), t.b = !0, !i && R(e1, t) && (T(r, n), k(t), m(n)), i = !1, t = o, n = r;
                    t.b = !0, s && J(e1, t);
                }
                function Y(e1, t, r, o, n) {
                    var s = [
                        t.g[0],
                        t.g[1],
                        t.g[2]
                    ];
                    t.d = null, t.d = e1.o && e1.o(s, r, o, e1.c) || null, null === t.d && (n ? e1.n || (l(e1, 100156), e1.n = !0) : t.d = r[0]);
                }
                function L(e1, t, r) {
                    var o = [
                        null,
                        null,
                        null,
                        null
                    ];
                    o[0] = t.a.d, o[1] = r.a.d, Y(e1, t.a, o, [
                        .5,
                        .5,
                        0,
                        0
                    ], !1), x(t, r);
                }
                function Z(e1, t, r, o, n) {
                    var s = Math.abs(t.b - e1.b) + Math.abs(t.a - e1.a), i = Math.abs(r.b - e1.b) + Math.abs(r.a - e1.a), a = n + 1;
                    o[n] = .5 * i / (s + i), o[a] = .5 * s / (s + i), e1.g[0] += o[n] * t.g[0] + o[a] * r.g[0], e1.g[1] += o[n] * t.g[1] + o[a] * r.g[1], e1.g[2] += o[n] * t.g[2] + o[a] * r.g[2];
                }
                function R(e1, t) {
                    var r = B(t), o = t.a, n = r.a;
                    if (g(o.a, n.a)) {
                        if (0 < b(n.b.a, o.a, n.a)) return;
                        if (y(o.a, n.a)) {
                            if (o.a !== n.a) {
                                var r = e1.e, s = o.a.h;
                                if (0 <= s) {
                                    var i = (r = r.b).d, a = r.e, l = r.c, u = l[s];
                                    i[u] = i[r.a], (l[i[u]] = u) <= --r.a && (u <= 1 || g(a[i[u >> 1]], a[i[u]]) ? U : ue)(r, u), a[s] = null, l[s] = r.b, r.b = s;
                                } else for(r.c[-(s + 1)] = null; 0 < r.a && null === r.c[r.d[r.a - 1]];)--r.a;
                                L(e1, n.b.e, o);
                            }
                        } else w(n.b), x(o, n.b.e), t.b = r.b = !0;
                    } else {
                        if (b(o.b.a, n.a, o.a) < 0) return;
                        G(t).b = t.b = !0, w(o.b), x(n.b.e, o);
                    }
                    return 1;
                }
                function Q(e1, t) {
                    var r = B(t), o = t.a, n = r.a, s = o.a, i = n.a, a = o.b.a, l = n.b.a, u = new D;
                    if (b(a, e1.a, s), b(l, e1.a, i), !(s === i || Math.min(s.a, a.a) > Math.max(i.a, l.a))) {
                        if (g(s, i)) {
                            if (0 < b(l, s, i)) return;
                        } else if (b(a, i, s) < 0) return;
                        var c, d, f = a, h = s, p = l, m = i;
                        if (g(f, h) || (c = f, f = h, h = c), g(p, m) || (c = p, p = m, m = c), g(f, p) || (c = f, f = p, p = c, c = h, h = m, m = c), g(p, h) ? g(h, m) ? ((c = v(f, p, h)) + (d = v(p, h, m)) < 0 && (c = -c, d = -d), u.b = _(c, p.b, d, h.b)) : ((c = b(f, p, h)) + (d = -b(f, m, h)) < 0 && (c = -c, d = -d), u.b = _(c, p.b, d, m.b)) : u.b = (p.b + h.b) / 2, j(f, h) || (c = f, f = h, h = c), j(p, m) || (c = p, p = m, m = c), j(f, p) || (c = f, f = p, p = c, c = h, h = m, m = c), j(p, h) ? j(h, m) ? ((c = V(f, p, h)) + (d = V(p, h, m)) < 0 && (c = -c, d = -d), u.a = _(c, p.a, d, h.a)) : ((c = z(f, p, h)) + (d = -z(f, m, h)) < 0 && (c = -c, d = -d), u.a = _(c, p.a, d, m.a)) : u.a = (p.a + h.a) / 2, g(u, e1.a) && (u.b = e1.a.b, u.a = e1.a.a), f = g(s, i) ? s : i, g(f, u) && (u.b = f.b, u.a = f.a), y(u, s) || y(u, i)) return R(e1, t), 0;
                        if (!y(a, e1.a) && 0 <= b(a, e1.a, u) || !y(l, e1.a) && b(l, e1.a, u) <= 0) {
                            if (l === e1.a) w(o.b), x(n.b, o), o = B(t = C(t)).a, A(e1, B(t), r), P(e1, t, o.b.e, o, o, !0);
                            else {
                                if (a !== e1.a) return 0 <= b(a, e1.a, u) && (G(t).b = t.b = !0, w(o.b), o.a.b = e1.a.b, o.a.a = e1.a.a), void (b(l, e1.a, u) <= 0 && (t.b = r.b = !0, w(n.b), n.a.b = e1.a.b, n.a.a = e1.a.a));
                                for(w(n.b), x(o.e, n.b.e), i = (s = r = t).a.b.a; (s = G(s)).a.b.a === i;);
                                s = B(t = s).a.b.c, r.a = n.b.e, P(e1, t, (n = A(e1, r, null)).c, o.b.c, s, !0);
                            }
                            return 1;
                        }
                        w(o.b), w(n.b), x(n.b.e, o), o.a.b = u.b, o.a.a = u.a, o.a.h = ne(e1.e, o.a), o = o.a, n = [
                            0,
                            0,
                            0,
                            0
                        ], u = [
                            s.d,
                            a.d,
                            i.d,
                            l.d
                        ], o.g[0] = o.g[1] = o.g[2] = 0, Z(o, s, a, n, 0), Z(o, i, l, n, 2), Y(e1, o, u, n, !0), G(t).b = t.b = r.b = !0;
                    }
                }
                function J(e1, t) {
                    for(var r = B(t);;){
                        for(; r.b;)r = B(t = r);
                        if (!t.b && (null === (t = G(r = t)) || !t.b)) break;
                        t.b = !1;
                        var o = t.a, n = r.a;
                        if (s = o.b.a !== n.b.a) e: {
                            var s, i = B(s = t), a = s.a, l = i.a, u = void 0;
                            if (g(a.b.a, l.b.a)) {
                                if (b(a.b.a, l.b.a, a.a) < 0) {
                                    s = !1;
                                    break e;
                                }
                                G(s).b = s.b = !0, u = w(a), x(l.b, u), u.d.c = s.d;
                            } else {
                                if (0 < b(l.b.a, a.b.a, l.a)) {
                                    s = !1;
                                    break e;
                                }
                                s.b = i.b = !0, u = w(l), x(a.e, l.b), u.b.d.c = s.d;
                            }
                            s = !0;
                        }
                        if (s && (r.c ? (k(r), m(n), n = (r = B(t)).a) : t.c && (k(t), m(o), o = (t = G(r)).a)), o.a !== n.a) {
                            if (o.b.a === n.b.a || t.c || r.c || o.b.a !== e1.a && n.b.a !== e1.a) R(e1, t);
                            else if (Q(e1, t)) break;
                        }
                        o.a === n.a && o.b.a === n.b.a && (T(n, o), k(t), m(o), t = G(r));
                    }
                }
                function K(e1, t) {
                    var r = new N, o = d(e1.b);
                    o.a.b = 4e150, o.a.a = t, o.b.a.b = -4000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, o.b.a.a = t, e1.a = o.b.a, r.a = o, r.f = 0, r.d = !1, r.c = !1, r.h = !0, r.b = !1, o = p(o = e1.f, o.a, r), r.e = o;
                }
                function $(e1) {
                    this.a = new ee, this.b = e1, this.c = f;
                }
                function p(e1, t, r) {
                    for(; null !== (t = t.c).b && !e1.c(e1.b, t.b, r););
                    return e1 = new ee(r, t.a, t), t.a.c = e1, t.a = e1;
                }
                function ee(e1, t, r) {
                    this.b = e1 || null, this.a = t || this, this.c = r || this;
                }
                function r() {
                    this.d = 0, this.p = this.b = this.q = null, this.j = [
                        0,
                        0,
                        0
                    ], this.s = 100130, this.n = !1, this.o = this.a = this.e = this.f = null, this.m = !1, this.c = this.r = this.i = this.k = this.l = this.h = null;
                }
                function I(e1, t) {
                    if (e1.d !== t) for(; e1.d !== t;)if (e1.d < t) switch(e1.d){
                        case 0:
                            l(e1, 100151), e1.u(null);
                            break;
                        case 1:
                            l(e1, 100152), e1.t();
                    }
                    else switch(e1.d){
                        case 2:
                            l(e1, 100154), e1.v();
                            break;
                        case 1:
                            l(e1, 100153), e1.w();
                    }
                }
                function l(e1, t) {
                    e1.p && e1.p(t, e1.c);
                }
                function te(e1, t) {
                    this.b = e1 || this, this.d = t || this, this.a = null, this.c = !1;
                }
                function u() {
                    (this.h = this).i = this.d = this.a = this.e = this.c = this.b = null, this.f = 0;
                }
                function re() {
                    this.c = new D, this.a = new te, this.b = new u, this.d = new u, this.b.b = this.d, this.d.b = this.b;
                }
                function D(e1, t) {
                    this.e = e1 || this, this.f = t || this, this.d = this.c = null, this.g = [
                        0,
                        0,
                        0
                    ], this.h = this.a = this.b = 0;
                }
                function oe() {
                    this.c = [], this.d = null, this.a = 0, this.e = !1, this.b = new ie;
                }
                function ne(e1, t) {
                    var r, o, n;
                    return e1.e ? (2 * (o = ++(r = e1.b).a) > r.f && (r.f *= 2, r.c = ae(r.c, r.f + 1)), 0 === r.b ? n = o : (n = r.b, r.b = r.c[r.b]), r.e[n] = t, r.c[n] = o, r.d[o] = n, r.h && ue(r, o), n) : (r = e1.a++, e1.c[r] = t, -(r + 1));
                }
                function se(e1) {
                    if (0 === e1.a) return le(e1.b);
                    var t = e1.c[e1.d[e1.a - 1]];
                    if (0 !== e1.b.a && g(F(e1.b), t)) return le(e1.b);
                    for(; --e1.a, 0 < e1.a && null === e1.c[e1.d[e1.a - 1]];);
                    return t;
                }
                function ie() {
                    this.d = ae([
                        0
                    ], 33), this.e = [
                        null,
                        null
                    ], this.c = [
                        0,
                        0
                    ], this.a = 0, this.f = 32, this.b = 0, this.h = !1, this.d[1] = 1;
                }
                function ae(e1, t) {
                    for(var r = Array(t), o = 0; o < e1.length; o++)r[o] = e1[o];
                    for(; o < t; o++)r[o] = 0;
                    return r;
                }
                function F(e1) {
                    return e1.e[e1.d[1]];
                }
                function le(e1) {
                    var t = e1.d, r = e1.e, o = e1.c, n = t[1], s = r[n];
                    return 0 < e1.a && (t[1] = t[e1.a], o[t[1]] = 1, r[n] = null, o[n] = e1.b, e1.b = n, 0 < --e1.a && U(e1, 1)), s;
                }
                function U(e1, t) {
                    for(var r = e1.d, o = e1.e, n = e1.c, s = t, i = r[s];;){
                        var a = s << 1, l = (a < e1.a && g(o[r[a + 1]], o[r[a]]) && (a += 1), r[a]);
                        if (a > e1.a || g(o[i], o[l])) {
                            n[r[s] = i] = s;
                            break;
                        }
                        n[r[s] = l] = s, s = a;
                    }
                }
                function ue(e1, t) {
                    for(var r = e1.d, o = e1.e, n = e1.c, s = t, i = r[s];;){
                        var a = s >> 1, l = r[a];
                        if (0 == a || g(o[l], o[i])) {
                            n[r[s] = i] = s;
                            break;
                        }
                        n[r[s] = l] = s, s = a;
                    }
                }
                function N() {
                    this.e = this.a = null, this.f = 0, this.c = this.b = this.h = this.d = !1;
                }
                function B(e1) {
                    return e1.e.c.b;
                }
                function G(e1) {
                    return e1.e.a.b;
                }
                (t = r.prototype).x = function() {
                    I(this, 0);
                }, t.B = function(e1, t) {
                    switch(e1){
                        case 100142:
                            return;
                        case 100140:
                            switch(t){
                                case 100130:
                                case 100131:
                                case 100132:
                                case 100133:
                                case 100134:
                                    return void (this.s = t);
                            }
                            break;
                        case 100141:
                            return void (this.m = !!t);
                        default:
                            return void l(this, 100900);
                    }
                    l(this, 100901);
                }, t.y = function(e1) {
                    switch(e1){
                        case 100142:
                            return 0;
                        case 100140:
                            return this.s;
                        case 100141:
                            return this.m;
                        default:
                            l(this, 100900);
                    }
                    return !1;
                }, t.A = function(e1, t, r) {
                    this.j[0] = e1, this.j[1] = t, this.j[2] = r;
                }, t.z = function(e1, t) {
                    var r = t || null;
                    switch(e1){
                        case 100100:
                        case 100106:
                            this.h = r;
                            break;
                        case 100104:
                        case 100110:
                            this.l = r;
                            break;
                        case 100101:
                        case 100107:
                            this.k = r;
                            break;
                        case 100102:
                        case 100108:
                            this.i = r;
                            break;
                        case 100103:
                        case 100109:
                            this.p = r;
                            break;
                        case 100105:
                        case 100111:
                            this.o = r;
                            break;
                        case 100112:
                            this.r = r;
                            break;
                        default:
                            l(this, 100900);
                    }
                }, t.C = function(e1, t) {
                    var r = !1, o = [
                        0,
                        0,
                        0
                    ];
                    I(this, 2);
                    for(var n = 0; n < 3; ++n){
                        var s = e1[n];
                        s < -1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000 && (s = -1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000, r = !0), 1e150 < s && (s = 1e150, r = !0), o[n] = s;
                    }
                    r && l(this, 100155), null === (r = this.q) ? x(r = d(this.b), r.b) : (w(r), r = r.e), r.a.d = t, r.a.g[0] = o[0], r.a.g[1] = o[1], r.a.g[2] = o[2], r.f = 1, r.b.f = -1, this.q = r;
                }, t.u = function(e1) {
                    I(this, 0), this.d = 1, this.b = new re, this.c = e1;
                }, t.t = function() {
                    I(this, 1), this.d = 2, this.q = null;
                }, t.v = function() {
                    I(this, 2), this.d = 1;
                }, t.w = function() {
                    I(this, 1), this.d = 0;
                    var e1, t, r = this.j[0], o = this.j[1], n = this.j[2], s = !1, i = [
                        r,
                        o,
                        n
                    ];
                    if (0 === r && 0 === o && 0 === n) {
                        for(var o = [
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                            -2000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000
                        ], a = [
                            2e150,
                            2e150,
                            2e150
                        ], n = [], l = [], r = (s = this.b.c).e; r !== s; r = r.e)for(var u = 0; u < 3; ++u){
                            var c = r.g[u];
                            c < a[u] && (a[u] = c, l[u] = r), c > o[u] && (o[u] = c, n[u] = r);
                        }
                        if (o[1] - a[1] > o[r = 0] - a[0] && (r = 1), a[r = o[2] - a[2] > o[r] - a[r] ? 2 : r] >= o[r]) i[0] = 0, i[1] = 0, i[2] = 1;
                        else {
                            for(a = l[r], n = n[r], l = [
                                o = 0,
                                0,
                                0
                            ], a = [
                                a.g[0] - n.g[0],
                                a.g[1] - n.g[1],
                                a.g[2] - n.g[2]
                            ], u = [
                                0,
                                0,
                                0
                            ], r = s.e; r !== s; r = r.e)u[0] = r.g[0] - n.g[0], u[1] = r.g[1] - n.g[1], u[2] = r.g[2] - n.g[2], l[0] = a[1] * u[2] - a[2] * u[1], l[1] = a[2] * u[0] - a[0] * u[2], l[2] = a[0] * u[1] - a[1] * u[0], o < (c = l[0] * l[0] + l[1] * l[1] + l[2] * l[2]) && (o = c, i[0] = l[0], i[1] = l[1], i[2] = l[2]);
                            o <= 0 && (i[0] = i[1] = i[2] = 0, i[W(a)] = 1);
                        }
                        s = !0;
                    }
                    for(l = W(i), r = this.b.c, o = (l + 1) % 3, n = (l + 2) % 3, l = 0 < i[l] ? 1 : -1, i = r.e; i !== r; i = i.e)i.b = i.g[o], i.a = l * i.g[n];
                    if (s) {
                        for(i = 0, r = (s = this.b.a).b; r !== s; r = r.b)if (!((o = r.a).f <= 0)) for(; i += (o.a.b - o.b.a.b) * (o.a.a + o.b.a.a), (o = o.e) !== r.a;);
                        if (i < 0) for(s = (i = this.b.c).e; s !== i; s = s.e)s.a = -s.a;
                    }
                    for(this.n = !1, i = this.b.b, r = i.h; r !== i; r = s)s = r.h, o = r.e, y(r.a, r.b.a) && r.e.e !== r && (L(this, o, r), m(r), o = (r = o).e), o.e === r && (o !== r && (o !== s && o !== s.b || (s = s.h), m(o)), r !== s && r !== s.b || (s = s.h), m(r));
                    for(this.e = i = new oe, s = this.b.c, r = s.e; r !== s; r = r.e)r.h = ne(i, r);
                    var d = i;
                    d.d = [];
                    for(var f = 0; f < d.a; f++)d.d[f] = f;
                    d.d.sort(function(r) {
                        return function(e1, t) {
                            return g(r[e1], r[t]) ? 1 : -1;
                        };
                    }(d.c)), d.e = !0;
                    for(var h = d.b, p = h.a; 1 <= p; --p)U(h, p);
                    for(h.h = !0, this.f = new $(this), K(this, -4000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000), K(this, 4e150); null !== (i = se(this.e));){
                        for(;;){
                            e: if (0 === (r = this.e).a) s = F(r.b);
                            else if (s = r.c[r.d[r.a - 1]], 0 !== r.b.a && g(r = F(r.b), s)) {
                                s = r;
                                break e;
                            }
                            if (null === s || !y(s, i)) break;
                            s = se(this.e), L(this, i.c, s.c);
                        }
                        !function e1(t, r) {
                            for(var o, n = (t.a = r).c; null === n.i;)if ((n = n.c) === r.c) {
                                var n = t, s = r;
                                (c = new N).a = s.c.b;
                                for(var i = (a = n.f).a; null !== (i = i.a).b && !a.c(a.b, c, i.b););
                                var a, l, u = B(a = i.b), c = a.a, i = u.a;
                                return void (0 === b(c.b.a, s, c.a) ? y((c = a.a).a, s) || y(c.b.a, s) || (w(c.b), a.c && (m(c.c), a.c = !1), x(s.c, c), e1(n, s)) : (l = g(i.b.a, c.b.a) ? a : u, u = void 0, a.d || l.c ? (u = l === a ? S(s.c.b, c.e) : S(i.b.c.b, s.c).b, l.c ? O(l, u) : ((a = q(c = n, a, u)).f = G(a).f + a.a.f, a.d = X(c, a.f)), e1(n, s)) : P(n, a, s.c, s.c, null, !0)));
                            }
                            a = (c = B(n = C(n.i))).a, (c = A(t, c, null)).c === a ? (c = (a = c).c, i = B(n), u = n.a, l = i.a, o = !1, u.b.a !== l.b.a && Q(t, n), y(u.a, t.a) && (x(c.b.e, u), c = B(n = C(n)).a, A(t, B(n), i), o = !0), y(l.a, t.a) && (x(a, l.b.e), a = A(t, i, null), o = !0), o ? P(t, n, a.c, c, c, !0) : (s = g(l.a, u.a) ? l.b.e : u, P(t, n, s = S(a.c.b, s), s.c, s.c, !1), s.b.i.c = !0, J(t, n))) : P(t, n, c.c, a, a, !0);
                        }(this, i);
                    }
                    for(this.a = this.f.a.a.b.a.a, i = 0; null !== (s = this.f.a.a.b);)s.h || ++i, k(s);
                    for(this.f = null, (i = this.e).b = null, i.d = null, this.e = i.c = null, i = this.b, r = i.a.b; r !== i.a; r = s)s = r.b, (r = r.a).e.e === r && (T(r.c, r), m(r));
                    if (!this.n) {
                        if (i = this.b, this.m) for(r = i.b.h; r !== i.b; r = s)s = r.h, r.b.d.c !== r.d.c ? r.f = r.d.c ? 1 : -1 : m(r);
                        else for(r = i.a.b; r !== i.a; r = s)if (s = r.b, r.c) {
                            for(r = r.a; g(r.b.a, r.a); r = r.c.b);
                            for(; g(r.a, r.b.a); r = r.e);
                            for(o = r.c.b, n = void 0; r.e !== o;)if (g(r.b.a, o.a)) {
                                for(; o.e !== r && (g((t = o.e).b.a, t.a) || b(o.a, o.b.a, o.e.b.a) <= 0);)o = (n = S(o.e, o)).b;
                                o = o.c.b;
                            } else {
                                for(; o.e !== r && (g((e1 = r.c.b).a, e1.b.a) || 0 <= b(r.b.a, r.a, r.c.b.a));)r = (n = S(r, r.c.b)).b;
                                r = r.e;
                            }
                            for(; o.e.e !== r;)n = S(o.e, o), o = n.b;
                        }
                        if (this.h || this.i || this.k || this.l) {
                            if (this.m) {
                                for(s = (i = this.b).a.b; s !== i.a; s = s.b)if (s.c) {
                                    for(this.h && this.h(2, this.c), r = s.a; this.k && this.k(r.a.d, this.c), (r = r.e) !== s.a;);
                                    this.i && this.i(this.c);
                                }
                            } else {
                                for(i = this.b, s = !!this.l, r = !1, o = -1, n = i.a.d; n !== i.a; n = n.d)if (n.c) for(r || (this.h && this.h(4, this.c), r = !0), l = n.a; s && (a = l.b.d.c ? 0 : 1, o !== a && (o = a, this.l && this.l(!!o, this.c))), this.k && this.k(l.a.d, this.c), (l = l.e) !== n.a;);
                                r && this.i && this.i(this.c);
                            }
                        }
                        if (this.r) {
                            for(i = this.b, r = i.a.b; r !== i.a; r = s)if (s = r.b, !r.c) {
                                for(n = (o = r.a).e, l = void 0; n = (l = n).e, (l.d = null) === l.b.d && (l.c === l ? M(l.a, null) : (l.a.c = l.c, E(l, l.b.e)), (a = l.b).c === a ? M(a.a, null) : (a.a.c = a.c, E(a, a.b.e)), H(l)), l !== o;);
                                o = r.d, ((r = r.b).d = o).b = r;
                            }
                            return this.r(this.b), void (this.c = this.b = null);
                        }
                    }
                    this.b = this.c = null;
                }, this.libtess = {
                    GluTesselator: r,
                    windingRule: {
                        GLU_TESS_WINDING_ODD: 100130,
                        GLU_TESS_WINDING_NONZERO: 100131,
                        GLU_TESS_WINDING_POSITIVE: 100132,
                        GLU_TESS_WINDING_NEGATIVE: 100133,
                        GLU_TESS_WINDING_ABS_GEQ_TWO: 100134
                    },
                    primitiveType: {
                        GL_LINE_LOOP: 2,
                        GL_TRIANGLES: 4,
                        GL_TRIANGLE_STRIP: 5,
                        GL_TRIANGLE_FAN: 6
                    },
                    errorType: {
                        GLU_TESS_MISSING_BEGIN_POLYGON: 100151,
                        GLU_TESS_MISSING_END_POLYGON: 100153,
                        GLU_TESS_MISSING_BEGIN_CONTOUR: 100152,
                        GLU_TESS_MISSING_END_CONTOUR: 100154,
                        GLU_TESS_COORD_TOO_LARGE: 100155,
                        GLU_TESS_NEED_COMBINE_CALLBACK: 100156
                    },
                    gluEnum: {
                        GLU_TESS_MESH: 100112,
                        GLU_TESS_TOLERANCE: 100142,
                        GLU_TESS_WINDING_RULE: 100140,
                        GLU_TESS_BOUNDARY_ONLY: 100141,
                        GLU_INVALID_ENUM: 100900,
                        GLU_INVALID_VALUE: 100901,
                        GLU_TESS_BEGIN: 100100,
                        GLU_TESS_VERTEX: 100101,
                        GLU_TESS_END: 100102,
                        GLU_TESS_ERROR: 100103,
                        GLU_TESS_EDGE_FLAG: 100104,
                        GLU_TESS_COMBINE: 100105,
                        GLU_TESS_BEGIN_DATA: 100106,
                        GLU_TESS_VERTEX_DATA: 100107,
                        GLU_TESS_END_DATA: 100108,
                        GLU_TESS_ERROR_DATA: 100109,
                        GLU_TESS_EDGE_FLAG_DATA: 100110,
                        GLU_TESS_COMBINE_DATA: 100111
                    }
                }, r.prototype.gluDeleteTess = r.prototype.x, r.prototype.gluTessProperty = r.prototype.B, r.prototype.gluGetTessProperty = r.prototype.y, r.prototype.gluTessNormal = r.prototype.A, r.prototype.gluTessCallback = r.prototype.z, r.prototype.gluTessVertex = r.prototype.C, r.prototype.gluTessBeginPolygon = r.prototype.u, r.prototype.gluTessBeginContour = r.prototype.t, r.prototype.gluTessEndContour = r.prototype.v, r.prototype.gluTessEndPolygon = r.prototype.w, void 0 !== e1 && (e1.exports = this.libtess);
            },
            {}
        ],
        246: [
            function(e1, t, r) {
                "use strict";
                function o(g, e1, t, r) {
                    var v = 0, o = void 0 === (r = void 0 === r ? {} : r).loop ? null : r.loop, b = void 0 === r.palette ? null : r.palette;
                    if (e1 <= 0 || t <= 0 || 65535 < e1 || 65535 < t) throw new Error("Width/Height invalid.");
                    function j(e1) {
                        e1 = e1.length;
                        if (e1 < 2 || 256 < e1 || e1 & e1 - 1) throw new Error("Invalid code/color length, must be power of 2 and 2 .. 256.");
                        return e1;
                    }
                    g[v++] = 71, g[v++] = 73, g[v++] = 70, g[v++] = 56, g[v++] = 57, g[v++] = 97;
                    var n = 0, s = 0;
                    if (null !== b) {
                        for(var i = j(b); i >>= 1;)++n;
                        if (i = 1 << n, --n, void 0 !== r.background) {
                            if (i <= (s = r.background)) throw new Error("Background index out of range.");
                            if (0 === s) throw new Error("Background index explicitly passed as 0.");
                        }
                    }
                    if (g[v++] = 255 & e1, g[v++] = e1 >> 8 & 255, g[v++] = 255 & t, g[v++] = t >> 8 & 255, g[v++] = (null !== b ? 128 : 0) | n, g[v++] = s, g[v++] = 0, null !== b) for(var a = 0, l = b.length; a < l; ++a){
                        var u = b[a];
                        g[v++] = u >> 16 & 255, g[v++] = u >> 8 & 255, g[v++] = 255 & u;
                    }
                    if (null !== o) {
                        if (o < 0 || 65535 < o) throw new Error("Loop count invalid.");
                        g[v++] = 33, g[v++] = 255, g[v++] = 11, g[v++] = 78, g[v++] = 69, g[v++] = 84, g[v++] = 83, g[v++] = 67, g[v++] = 65, g[v++] = 80, g[v++] = 69, g[v++] = 50, g[v++] = 46, g[v++] = 48, g[v++] = 3, g[v++] = 1, g[v++] = 255 & o, g[v++] = o >> 8 & 255, g[v++] = 0;
                    }
                    var _ = !1;
                    this.addFrame = function(e1, t, r, o, n, s) {
                        if (!0 === _ && (--v, _ = !1), s = void 0 === s ? {} : s, e1 < 0 || t < 0 || 65535 < e1 || 65535 < t) throw new Error("x/y invalid.");
                        if (r <= 0 || o <= 0 || 65535 < r || 65535 < o) throw new Error("Width/Height invalid.");
                        if (n.length < r * o) throw new Error("Not enough pixels for the frame size.");
                        var i = !0, a = s.palette;
                        if (null == a && (i = !1, a = b), null == a) throw new Error("Must supply either a local or global palette.");
                        for(var l = j(a), u = 0; l >>= 1;)++u;
                        var l = 1 << u, c = void 0 === s.delay ? 0 : s.delay, d = void 0 === s.disposal ? 0 : s.disposal;
                        if (d < 0 || 3 < d) throw new Error("Disposal out of range.");
                        var f = !1, h = 0;
                        if (void 0 !== s.transparent && null !== s.transparent && (f = !0, (h = s.transparent) < 0 || l <= h)) throw new Error("Transparent color index.");
                        if (0 === d && !f && 0 === c || (g[v++] = 33, g[v++] = 249, g[v++] = 4, g[v++] = d << 2 | (!0 === f ? 1 : 0), g[v++] = 255 & c, g[v++] = c >> 8 & 255, g[v++] = h, g[v++] = 0), g[v++] = 44, g[v++] = 255 & e1, g[v++] = e1 >> 8 & 255, g[v++] = 255 & t, g[v++] = t >> 8 & 255, g[v++] = 255 & r, g[v++] = r >> 8 & 255, g[v++] = 255 & o, g[v++] = o >> 8 & 255, g[v++] = !0 === i ? 128 | u - 1 : 0, !0 === i) for(var p = 0, m = a.length; p < m; ++p){
                            var y = a[p];
                            g[v++] = y >> 16 & 255, g[v++] = y >> 8 & 255, g[v++] = 255 & y;
                        }
                        return v = function(t, r, e1, o) {
                            t[r++] = e1;
                            var n = r++, s = 1 << e1, i = s - 1, a = 1 + s, l = 1 + a, u = e1 + 1, c = 0, d = 0;
                            function f(e1) {
                                for(; e1 <= c;)t[r++] = 255 & d, d >>= 8, c -= 8, r === n + 256 && (t[n] = 255, n = r++);
                            }
                            function h(e1) {
                                d |= e1 << c, c += u, f(8);
                            }
                            var p = o[0] & i, m = {};
                            h(s);
                            for(var y = 1, g = o.length; y < g; ++y){
                                var v = o[y] & i, b = p << 8 | v, j = m[b];
                                if (void 0 === j) {
                                    for(d |= p << c, c += u; 8 <= c;)t[r++] = 255 & d, d >>= 8, c -= 8, r === n + 256 && (t[n] = 255, n = r++);
                                    4096 === l ? (h(s), l = 1 + a, u = e1 + 1, m = {}) : (1 << u <= l && ++u, m[b] = l++), p = v;
                                } else p = j;
                            }
                            h(p), h(a), f(1), n + 1 === r ? t[n] = 0 : (t[n] = r - n - 1, t[r++] = 0);
                            return r;
                        }(g, v, u < 2 ? 2 : u, n);
                    }, this.end = function() {
                        return !1 === _ && (g[v++] = 59, _ = !0), v;
                    }, this.getOutputBuffer = function() {
                        return g;
                    }, this.setOutputBuffer = function(e1) {
                        g = e1;
                    }, this.getOutputBufferPosition = function() {
                        return v;
                    }, this.setOutputBufferPosition = function(e1) {
                        v = e1;
                    };
                }
                function M(e1, t, r, o) {
                    for(var n = e1[t++], s = 1 << n, i = 1 + s, a = 1 + i, l = n + 1, u = (1 << l) - 1, c = 0, d = 0, f = 0, h = e1[t++], p = new Int32Array(4096), m = null;;){
                        for(; c < 16 && 0 !== h;)d |= e1[t++] << c, c += 8, 1 === h ? h = e1[t++] : --h;
                        if (c < l) break;
                        var y = d & u;
                        if (d >>= l, c -= l, y == s) a = 1 + i, u = (1 << (l = n + 1)) - 1, m = null;
                        else {
                            if (y == i) break;
                            for(var g = y < a ? y : m, v = 0, b = g; s < b;)b = p[b] >> 8, ++v;
                            var j = b;
                            if (o < f + v + (g !== y ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
                            r[f++] = j;
                            var _ = f += v;
                            for(g !== y && (r[f++] = j), b = g; v--;)b = p[b], r[--_] = 255 & b, b >>= 8;
                            null !== m && a < 4096 && (p[a++] = m << 8 | j, u + 1 <= a && l < 12 && (++l, u = u << 1 | 1)), m = y;
                        }
                    }
                    f !== o && console.log("Warning, gif stream shorter than expected.");
                }
                try {
                    r.GifWriter = o, r.GifReader = function(b) {
                        var e1 = 0;
                        if (71 !== b[e1++] || 73 !== b[e1++] || 70 !== b[e1++] || 56 !== b[e1++] || 56 != (b[e1++] + 1 & 253) || 97 !== b[e1++]) throw new Error("Invalid GIF 87a/89a header.");
                        var j = b[e1++] | b[e1++] << 8, t = b[e1++] | b[e1++] << 8, r = b[e1++], o = 1 << 1 + (7 & r), n = (b[e1++], b[e1++], null), s = null, i = (r >> 7 && (n = e1, e1 += 3 * (s = o)), !0), a = [], l = 0, u = null, c = 0, d = null;
                        for(this.width = j, this.height = t; i && e1 < b.length;)switch(b[e1++]){
                            case 33:
                                switch(b[e1++]){
                                    case 255:
                                        if (11 !== b[e1] || 78 == b[e1 + 1] && 69 == b[e1 + 2] && 84 == b[e1 + 3] && 83 == b[e1 + 4] && 67 == b[e1 + 5] && 65 == b[e1 + 6] && 80 == b[e1 + 7] && 69 == b[e1 + 8] && 50 == b[e1 + 9] && 46 == b[e1 + 10] && 48 == b[e1 + 11] && 3 == b[e1 + 12] && 1 == b[e1 + 13] && 0 == b[e1 + 16]) e1 += 14, d = b[e1++] | b[e1++] << 8, e1++;
                                        else for(e1 += 12;;){
                                            if (!(0 <= (h = b[e1++]))) throw Error("Invalid block size");
                                            if (0 === h) break;
                                            e1 += h;
                                        }
                                        break;
                                    case 249:
                                        if (4 !== b[e1++] || 0 !== b[e1 + 4]) throw new Error("Invalid graphics extension block.");
                                        var f = b[e1++], l = b[e1++] | b[e1++] << 8, u = b[e1++];
                                        0 == (1 & f) && (u = null), c = f >> 2 & 7, e1++;
                                        break;
                                    case 254:
                                        for(;;){
                                            if (!(0 <= (h = b[e1++]))) throw Error("Invalid block size");
                                            if (0 === h) break;
                                            e1 += h;
                                        }
                                        break;
                                    default:
                                        throw new Error("Unknown graphic control label: 0x" + b[e1 - 1].toString(16));
                                }
                                break;
                            case 44:
                                var h, p = b[e1++] | b[e1++] << 8, m = b[e1++] | b[e1++] << 8, y = b[e1++] | b[e1++] << 8, g = b[e1++] | b[e1++] << 8, v = b[e1++], _ = v >> 6 & 1, x = 1 << 1 + (7 & v), w = n, S = s, E = !1, v = (v >> 7 && (E = !0, w = e1, e1 += 3 * (S = x)), e1);
                                for(e1++;;){
                                    if (!(0 <= (h = b[e1++]))) throw Error("Invalid block size");
                                    if (0 === h) break;
                                    e1 += h;
                                }
                                a.push({
                                    x: p,
                                    y: m,
                                    width: y,
                                    height: g,
                                    has_local_palette: E,
                                    palette_offset: w,
                                    palette_size: S,
                                    data_offset: v,
                                    data_length: e1 - v,
                                    transparent_index: u,
                                    interlaced: !!_,
                                    delay: l,
                                    disposal: c
                                });
                                break;
                            case 59:
                                i = !1;
                                break;
                            default:
                                throw new Error("Unknown gif block: 0x" + b[e1 - 1].toString(16));
                        }
                        this.numFrames = function() {
                            return a.length;
                        }, this.loopCount = function() {
                            return d;
                        }, this.frameInfo = function(e1) {
                            if (e1 < 0 || e1 >= a.length) throw new Error("Frame index out of range.");
                            return a[e1];
                        }, this.decodeAndBlitFrameBGRA = function(e1, t) {
                            for(var e1 = this.frameInfo(e1), r = e1.width * e1.height, o = new Uint8Array(r), n = (M(b, e1.data_offset, o, r), e1.palette_offset), s = e1.transparent_index, i = (null === s && (s = 256), e1.width), a = j - i, l = i, u = 4 * (e1.y * j + e1.x), c = 4 * ((e1.y + e1.height) * j + e1.x), d = u, f = 4 * a, h = (!0 === e1.interlaced && (f += 4 * j * 7), 8), p = 0, m = o.length; p < m; ++p){
                                var y, g, v = o[p];
                                0 === l && (l = i, c <= (d += f) && (f = 4 * a + 4 * j * (h - 1), d = u + (i + a) * (h << 1), h >>= 1)), v === s ? d += 4 : (y = b[n + 3 * v], g = b[n + 3 * v + 1], v = b[n + 3 * v + 2], t[d++] = v, t[d++] = g, t[d++] = y, t[d++] = 255), --l;
                            }
                        }, this.decodeAndBlitFrameRGBA = function(e1, t) {
                            for(var e1 = this.frameInfo(e1), r = e1.width * e1.height, o = new Uint8Array(r), n = (M(b, e1.data_offset, o, r), e1.palette_offset), s = e1.transparent_index, i = (null === s && (s = 256), e1.width), a = j - i, l = i, u = 4 * (e1.y * j + e1.x), c = 4 * ((e1.y + e1.height) * j + e1.x), d = u, f = 4 * a, h = (!0 === e1.interlaced && (f += 4 * j * 7), 8), p = 0, m = o.length; p < m; ++p){
                                var y, g, v = o[p];
                                0 === l && (l = i, c <= (d += f) && (f = 4 * a + 4 * j * (h - 1), d = u + (i + a) * (h << 1), h >>= 1)), v === s ? d += 4 : (y = b[n + 3 * v], g = b[n + 3 * v + 1], v = b[n + 3 * v + 2], t[d++] = y, t[d++] = g, t[d++] = v, t[d++] = 255), --l;
                            }
                        };
                    };
                } catch (e1) {}
            },
            {}
        ],
        247: [
            function(Pr, r, o) {
                (function(Ar) {
                    var e1, t;
                    e1 = this, t = function(j) {
                        "use strict";
                        function D(e1) {
                            if (null == this) throw TypeError();
                            var t, r = String(this), o = r.length, e1 = e1 ? Number(e1) : 0;
                            if (!((e1 = e1 != e1 ? 0 : e1) < 0 || o <= e1)) return 55296 <= (t = r.charCodeAt(e1)) && t <= 56319 && e1 + 1 < o && 56320 <= (o = r.charCodeAt(e1 + 1)) && o <= 57343 ? 1024 * (t - 55296) + o - 56320 + 65536 : t;
                        }
                        String.prototype.codePointAt || ((F = function() {
                            try {
                                var e1 = {}, t = Object.defineProperty, r = t(e1, e1, e1) && t;
                            } catch (e1) {}
                            return r;
                        }()) ? F(String.prototype, "codePointAt", {
                            value: D,
                            configurable: !0,
                            writable: !0
                        }) : String.prototype.codePointAt = D);
                        var F, U = 0, N = -3;
                        function B() {
                            this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
                        }
                        function G(e1, t) {
                            this.source = e1, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = t, this.destLen = 0, this.ltree = new B, this.dtree = new B;
                        }
                        var V = new B, z = new B, H = new Uint8Array(30), W = new Uint16Array(30), q = new Uint8Array(30), X = new Uint16Array(30), Y = new Uint8Array([
                            16,
                            17,
                            18,
                            0,
                            8,
                            7,
                            9,
                            6,
                            10,
                            5,
                            11,
                            4,
                            12,
                            3,
                            13,
                            2,
                            14,
                            1,
                            15
                        ]), Z = new B, v = new Uint8Array(320);
                        function Q(e1, t, r, o) {
                            for(var n, s = 0; s < r; ++s)e1[s] = 0;
                            for(s = 0; s < 30 - r; ++s)e1[s + r] = s / r | 0;
                            for(n = o, s = 0; s < 30; ++s)t[s] = n, n += 1 << e1[s];
                        }
                        var J = new Uint16Array(16);
                        function K(e1, t, r, o) {
                            for(var n, s = 0; s < 16; ++s)e1.table[s] = 0;
                            for(s = 0; s < o; ++s)e1.table[t[r + s]]++;
                            for(s = n = e1.table[0] = 0; s < 16; ++s)J[s] = n, n += e1.table[s];
                            for(s = 0; s < o; ++s)t[r + s] && (e1.trans[J[t[r + s]]++] = s);
                        }
                        function b(e1, t, r) {
                            if (!t) return r;
                            for(; e1.bitcount < 24;)e1.tag |= e1.source[e1.sourceIndex++] << e1.bitcount, e1.bitcount += 8;
                            var o = e1.tag & 65535 >>> 16 - t;
                            return e1.tag >>>= t, e1.bitcount -= t, o + r;
                        }
                        function $(e1, t) {
                            for(; e1.bitcount < 24;)e1.tag |= e1.source[e1.sourceIndex++] << e1.bitcount, e1.bitcount += 8;
                            for(var r = 0, o = 0, n = 0, s = e1.tag; o = 2 * o + (1 & s), s >>>= 1, r += t.table[++n], 0 <= (o -= t.table[n]););
                            return e1.tag = s, e1.bitcount -= n, t.trans[r + o];
                        }
                        function ee(e1, t, r) {
                            for(;;){
                                var o = $(e1, t);
                                if (256 === o) return U;
                                if (o < 256) e1.dest[e1.destLen++] = o;
                                else for(var n, s = b(e1, H[o -= 257], W[o]), o = $(e1, r), i = n = e1.destLen - b(e1, q[o], X[o]); i < n + s; ++i)e1.dest[e1.destLen++] = e1.dest[i];
                            }
                        }
                        for(var e1 = V, te = z, t = 0; t < 7; ++t)e1.table[t] = 0;
                        for(e1.table[7] = 24, e1.table[8] = 152, e1.table[9] = 112, t = 0; t < 24; ++t)e1.trans[t] = 256 + t;
                        for(t = 0; t < 144; ++t)e1.trans[24 + t] = t;
                        for(t = 0; t < 8; ++t)e1.trans[168 + t] = 280 + t;
                        for(t = 0; t < 112; ++t)e1.trans[176 + t] = 144 + t;
                        for(t = 0; t < 5; ++t)te.table[t] = 0;
                        for(te.table[5] = 32, t = 0; t < 32; ++t)te.trans[t] = t;
                        Q(H, W, 4, 3), Q(q, X, 2, 1), H[28] = 0, W[28] = 258;
                        var re = function(e1, t) {
                            var r, o, n, s = new G(e1, t);
                            do {
                                switch(n = void 0, (o = s).bitcount-- || (o.tag = o.source[o.sourceIndex++], o.bitcount = 7), n = 1 & o.tag, o.tag >>>= 1, o = n, b(s, 2, 0)){
                                    case 0:
                                        r = function(e1) {
                                            for(var t, r; 8 < e1.bitcount;)e1.sourceIndex--, e1.bitcount -= 8;
                                            if ((t = 256 * e1.source[e1.sourceIndex + 1] + e1.source[e1.sourceIndex]) !== (65535 & ~(256 * e1.source[e1.sourceIndex + 3] + e1.source[e1.sourceIndex + 2]))) return N;
                                            for(e1.sourceIndex += 4, r = t; r; --r)e1.dest[e1.destLen++] = e1.source[e1.sourceIndex++];
                                            return e1.bitcount = 0, U;
                                        }(s);
                                        break;
                                    case 1:
                                        r = ee(s, V, z);
                                        break;
                                    case 2:
                                        y = m = p = g = i = h = f = d = c = u = l = a = void 0;
                                        for(var i, a = s, l = s.ltree, u = s.dtree, c = b(a, 5, 257), d = b(a, 5, 1), f = b(a, 4, 4), h = 0; h < 19; ++h)v[h] = 0;
                                        for(h = 0; h < f; ++h){
                                            var p = b(a, 3, 0);
                                            v[Y[h]] = p;
                                        }
                                        for(K(Z, v, 0, 19), i = 0; i < c + d;){
                                            var m = $(a, Z);
                                            switch(m){
                                                case 16:
                                                    for(var y = v[i - 1], g = b(a, 2, 3); g; --g)v[i++] = y;
                                                    break;
                                                case 17:
                                                    for(g = b(a, 3, 3); g; --g)v[i++] = 0;
                                                    break;
                                                case 18:
                                                    for(g = b(a, 7, 11); g; --g)v[i++] = 0;
                                                    break;
                                                default:
                                                    v[i++] = m;
                                            }
                                        }
                                        K(l, v, 0, c), K(u, v, c, d), r = ee(s, s.ltree, s.dtree);
                                        break;
                                    default:
                                        r = N;
                                }
                                if (r !== U) throw new Error("Data error");
                            }while (!o);
                            return s.destLen < s.dest.length ? "function" == typeof s.dest.slice ? s.dest.slice(0, s.destLen) : s.dest.subarray(0, s.destLen) : s.dest;
                        };
                        function g(e1, t, r, o, n) {
                            return Math.pow(1 - n, 3) * e1 + 3 * Math.pow(1 - n, 2) * n * t + 3 * (1 - n) * Math.pow(n, 2) * r + Math.pow(n, 3) * o;
                        }
                        function a() {
                            this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN;
                        }
                        function f() {
                            this.commands = [], this.fill = "black", this.stroke = null, this.strokeWidth = 1;
                        }
                        function oe(e1) {
                            throw new Error(e1);
                        }
                        function ne(e1, t) {
                            e1 || oe(t);
                        }
                        a.prototype.isEmpty = function() {
                            return isNaN(this.x1) || isNaN(this.y1) || isNaN(this.x2) || isNaN(this.y2);
                        }, a.prototype.addPoint = function(e1, t) {
                            "number" == typeof e1 && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e1, this.x2 = e1), e1 < this.x1 && (this.x1 = e1), e1 > this.x2 && (this.x2 = e1)), "number" == typeof t && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
                        }, a.prototype.addX = function(e1) {
                            this.addPoint(e1, null);
                        }, a.prototype.addY = function(e1) {
                            this.addPoint(null, e1);
                        }, a.prototype.addBezier = function(e1, t, r, o, n, s, i, a) {
                            var l = [
                                e1,
                                t
                            ], u = [
                                r,
                                o
                            ], c = [
                                n,
                                s
                            ], d = [
                                i,
                                a
                            ];
                            this.addPoint(e1, t), this.addPoint(i, a);
                            for(var f = 0; f <= 1; f++){
                                var h, p = 6 * l[f] - 12 * u[f] + 6 * c[f], m = -3 * l[f] + 9 * u[f] - 9 * c[f] + 3 * d[f], y = 3 * u[f] - 3 * l[f];
                                0 == m ? 0 == p || 0 < (h = -y / p) && h < 1 && (0 === f && this.addX(g(l[f], u[f], c[f], d[f], h)), 1 === f && this.addY(g(l[f], u[f], c[f], d[f], h))) : (h = Math.pow(p, 2) - 4 * y * m) < 0 || (0 < (y = (-p + Math.sqrt(h)) / (2 * m)) && y < 1 && (0 === f && this.addX(g(l[f], u[f], c[f], d[f], y)), 1 === f && this.addY(g(l[f], u[f], c[f], d[f], y))), 0 < (y = (-p - Math.sqrt(h)) / (2 * m)) && y < 1 && (0 === f && this.addX(g(l[f], u[f], c[f], d[f], y)), 1 === f && this.addY(g(l[f], u[f], c[f], d[f], y))));
                            }
                        }, a.prototype.addQuad = function(e1, t, r, o, n, s) {
                            r = e1 + 2 / 3 * (r - e1), o = t + 2 / 3 * (o - t);
                            this.addBezier(e1, t, r, o, r + 1 / 3 * (n - e1), o + 1 / 3 * (s - t), n, s);
                        }, f.prototype.moveTo = function(e1, t) {
                            this.commands.push({
                                type: "M",
                                x: e1,
                                y: t
                            });
                        }, f.prototype.lineTo = function(e1, t) {
                            this.commands.push({
                                type: "L",
                                x: e1,
                                y: t
                            });
                        }, f.prototype.curveTo = f.prototype.bezierCurveTo = function(e1, t, r, o, n, s) {
                            this.commands.push({
                                type: "C",
                                x1: e1,
                                y1: t,
                                x2: r,
                                y2: o,
                                x: n,
                                y: s
                            });
                        }, f.prototype.quadTo = f.prototype.quadraticCurveTo = function(e1, t, r, o) {
                            this.commands.push({
                                type: "Q",
                                x1: e1,
                                y1: t,
                                x: r,
                                y: o
                            });
                        }, f.prototype.close = f.prototype.closePath = function() {
                            this.commands.push({
                                type: "Z"
                            });
                        }, f.prototype.extend = function(e1) {
                            var t;
                            if (e1.commands) e1 = e1.commands;
                            else if (e1 instanceof a) return t = e1, this.moveTo(t.x1, t.y1), this.lineTo(t.x2, t.y1), this.lineTo(t.x2, t.y2), this.lineTo(t.x1, t.y2), void this.close();
                            Array.prototype.push.apply(this.commands, e1);
                        }, f.prototype.getBoundingBox = function() {
                            for(var e1 = new a, t = 0, r = 0, o = 0, n = 0, s = 0; s < this.commands.length; s++){
                                var i = this.commands[s];
                                switch(i.type){
                                    case "M":
                                        e1.addPoint(i.x, i.y), t = o = i.x, r = n = i.y;
                                        break;
                                    case "L":
                                        e1.addPoint(i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "Q":
                                        e1.addQuad(o, n, i.x1, i.y1, i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "C":
                                        e1.addBezier(o, n, i.x1, i.y1, i.x2, i.y2, i.x, i.y), o = i.x, n = i.y;
                                        break;
                                    case "Z":
                                        o = t, n = r;
                                        break;
                                    default:
                                        throw new Error("Unexpected path command " + i.type);
                                }
                            }
                            return e1.isEmpty() && e1.addPoint(0, 0), e1;
                        }, f.prototype.draw = function(e1) {
                            e1.beginPath();
                            for(var t = 0; t < this.commands.length; t += 1){
                                var r = this.commands[t];
                                "M" === r.type ? e1.moveTo(r.x, r.y) : "L" === r.type ? e1.lineTo(r.x, r.y) : "C" === r.type ? e1.bezierCurveTo(r.x1, r.y1, r.x2, r.y2, r.x, r.y) : "Q" === r.type ? e1.quadraticCurveTo(r.x1, r.y1, r.x, r.y) : "Z" === r.type && e1.closePath();
                            }
                            this.fill && (e1.fillStyle = this.fill, e1.fill()), this.stroke && (e1.strokeStyle = this.stroke, e1.lineWidth = this.strokeWidth, e1.stroke());
                        }, f.prototype.toPathData = function(n) {
                            function e1() {
                                for(var e1 = arguments, t = "", r = 0; r < arguments.length; r += 1){
                                    var o = e1[r];
                                    0 <= o && 0 < r && (t += " "), t += (o, Math.round(o) === o ? "" + Math.round(o) : o.toFixed(n));
                                }
                                return t;
                            }
                            n = void 0 !== n ? n : 2;
                            for(var t = "", r = 0; r < this.commands.length; r += 1){
                                var o = this.commands[r];
                                "M" === o.type ? t += "M" + e1(o.x, o.y) : "L" === o.type ? t += "L" + e1(o.x, o.y) : "C" === o.type ? t += "C" + e1(o.x1, o.y1, o.x2, o.y2, o.x, o.y) : "Q" === o.type ? t += "Q" + e1(o.x1, o.y1, o.x, o.y) : "Z" === o.type && (t += "Z");
                            }
                            return t;
                        }, f.prototype.toSVG = function(e1) {
                            var t = (t = '<path d="') + this.toPathData(e1) + '"';
                            return this.fill && "black" !== this.fill && (null === this.fill ? t += ' fill="none"' : t += ' fill="' + this.fill + '"'), this.stroke && (t += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"'), t += "/>";
                        }, f.prototype.toDOMElement = function(e1) {
                            var e1 = this.toPathData(e1), t = document.createElementNS("http://www.w3.org/2000/svg", "path");
                            return t.setAttribute("d", e1), t;
                        };
                        var L = {
                            fail: oe,
                            argument: ne,
                            assert: ne
                        }, m = {}, w = {}, l = {};
                        function r(e1) {
                            return function() {
                                return e1;
                            };
                        }
                        w.BYTE = function(e1) {
                            return L.argument(0 <= e1 && e1 <= 255, "Byte value should be between 0 and 255."), [
                                e1
                            ];
                        }, l.BYTE = r(1), w.CHAR = function(e1) {
                            return [
                                e1.charCodeAt(0)
                            ];
                        }, l.CHAR = r(1), w.CHARARRAY = function(e1) {
                            for(var t = [], r = 0; r < e1.length; r += 1)t[r] = e1.charCodeAt(r);
                            return t;
                        }, l.CHARARRAY = function(e1) {
                            return e1.length;
                        }, w.USHORT = function(e1) {
                            return [
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.USHORT = r(2), w.SHORT = function(e1) {
                            return [
                                (e1 = 32768 <= e1 ? -(65536 - e1) : e1) >> 8 & 255,
                                255 & e1
                            ];
                        }, l.SHORT = r(2), w.UINT24 = function(e1) {
                            return [
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.UINT24 = r(3), w.ULONG = function(e1) {
                            return [
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.ULONG = r(4), w.LONG = function(e1) {
                            return [
                                (e1 = 2147483648 <= e1 ? -(4294967296 - e1) : e1) >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.LONG = r(4), w.FIXED = w.ULONG, l.FIXED = l.ULONG, w.FWORD = w.SHORT, l.FWORD = l.SHORT, w.UFWORD = w.USHORT, l.UFWORD = l.USHORT, w.LONGDATETIME = function(e1) {
                            return [
                                0,
                                0,
                                0,
                                0,
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.LONGDATETIME = r(8), w.TAG = function(e1) {
                            return L.argument(4 === e1.length, "Tag should be exactly 4 ASCII characters."), [
                                e1.charCodeAt(0),
                                e1.charCodeAt(1),
                                e1.charCodeAt(2),
                                e1.charCodeAt(3)
                            ];
                        }, l.TAG = r(4), w.Card8 = w.BYTE, l.Card8 = l.BYTE, w.Card16 = w.USHORT, l.Card16 = l.USHORT, w.OffSize = w.BYTE, l.OffSize = l.BYTE, w.SID = w.USHORT, l.SID = l.USHORT, w.NUMBER = function(e1) {
                            return -107 <= e1 && e1 <= 107 ? [
                                e1 + 139
                            ] : 108 <= e1 && e1 <= 1131 ? [
                                247 + ((e1 -= 108) >> 8),
                                255 & e1
                            ] : -1131 <= e1 && e1 <= -108 ? [
                                251 + ((e1 = -e1 - 108) >> 8),
                                255 & e1
                            ] : -32768 <= e1 && e1 <= 32767 ? w.NUMBER16(e1) : w.NUMBER32(e1);
                        }, l.NUMBER = function(e1) {
                            return w.NUMBER(e1).length;
                        }, w.NUMBER16 = function(e1) {
                            return [
                                28,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.NUMBER16 = r(3), w.NUMBER32 = function(e1) {
                            return [
                                29,
                                e1 >> 24 & 255,
                                e1 >> 16 & 255,
                                e1 >> 8 & 255,
                                255 & e1
                            ];
                        }, l.NUMBER32 = r(5), w.REAL = function(e1) {
                            for(var t = e1.toString(), r = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(t), o = (r && (r = parseFloat("1e" + ((r[2] ? +r[2] : 0) + r[1].length)), t = (Math.round(e1 * r) / r).toString()), ""), n = 0, s = t.length; n < s; n += 1){
                                var i = t[n];
                                o += "e" === i ? "-" === t[++n] ? "c" : "b" : "." === i ? "a" : "-" === i ? "e" : i;
                            }
                            for(var a = [
                                30
                            ], l = 0, u = (o += 1 & o.length ? "f" : "ff").length; l < u; l += 2)a.push(parseInt(o.substr(l, 2), 16));
                            return a;
                        }, l.REAL = function(e1) {
                            return w.REAL(e1).length;
                        }, w.NAME = w.CHARARRAY, l.NAME = l.CHARARRAY, w.STRING = w.CHARARRAY, l.STRING = l.CHARARRAY, m.UTF8 = function(e1, t, r) {
                            for(var o = [], n = r, s = 0; s < n; s++, t += 1)o[s] = e1.getUint8(t);
                            return String.fromCharCode.apply(null, o);
                        }, m.UTF16 = function(e1, t, r) {
                            for(var o = [], n = r / 2, s = 0; s < n; s++, t += 2)o[s] = e1.getUint16(t);
                            return String.fromCharCode.apply(null, o);
                        }, w.UTF16 = function(e1) {
                            for(var t = [], r = 0; r < e1.length; r += 1){
                                var o = e1.charCodeAt(r);
                                t[t.length] = o >> 8 & 255, t[t.length] = 255 & o;
                            }
                            return t;
                        }, l.UTF16 = function(e1) {
                            return 2 * e1.length;
                        };
                        var se, ie = {
                            "x-mac-croatian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u03A9\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uF8FF\xa9\u2044\u20AC\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7",
                            "x-mac-cyrillic": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E",
                            "x-mac-gaelic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u1E02\xb1\u2264\u2265\u1E03\u010A\u010B\u1E0A\u1E0B\u1E1E\u1E1F\u0120\u0121\u1E40\xe6\xf8\u1E41\u1E56\u1E57\u027C\u0192\u017F\u1E60\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\u1E61\u1E9B\xff\u0178\u1E6A\u20AC\u2039\u203A\u0176\u0177\u1E6B\xb7\u1EF2\u1EF3\u204A\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\u2663\xd2\xda\xdb\xd9\u0131\xdd\xfd\u0174\u0175\u1E84\u1E85\u1E80\u1E81\u1E82\u1E83",
                            "x-mac-greek": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\u20AC\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\xb7\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\xad",
                            "x-mac-icelandic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-inuit": "\u1403\u1404\u1405\u1406\u140A\u140B\u1431\u1432\u1433\u1434\u1438\u1439\u1449\u144E\u144F\u1450\u1451\u1455\u1456\u1466\u146D\u146E\u146F\u1470\u1472\u1473\u1483\u148B\u148C\u148D\u148E\u1490\u1491\xb0\u14A1\u14A5\u14A6\u2022\xb6\u14A7\xae\xa9\u2122\u14A8\u14AA\u14AB\u14BB\u14C2\u14C3\u14C4\u14C5\u14C7\u14C8\u14D0\u14EF\u14F0\u14F1\u14F2\u14F4\u14F5\u1505\u14D5\u14D6\u14D7\u14D8\u14DA\u14DB\u14EA\u1528\u1529\u152A\u152B\u152D\u2026\xa0\u152E\u153E\u1555\u1556\u1557\u2013\u2014\u201C\u201D\u2018\u2019\u1558\u1559\u155A\u155D\u1546\u1547\u1548\u1549\u154B\u154C\u1550\u157F\u1580\u1581\u1582\u1583\u1584\u1585\u158F\u1590\u1591\u1592\u1593\u1594\u1595\u1671\u1672\u1673\u1674\u1675\u1676\u1596\u15A0\u15A1\u15A2\u15A3\u15A4\u15A5\u15A6\u157C\u0141\u0142",
                            "x-mac-ce": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7",
                            macintosh: "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-romanian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u0218\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\u0103\u0219\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\u021A\u021B\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
                            "x-mac-turkish": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\uF8A0\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
                        }, ae = (m.MACSTRING = function(e1, t, r, o) {
                            var n = ie[o];
                            if (void 0 !== n) {
                                for(var s = "", i = 0; i < r; i++){
                                    var a = e1.getUint8(t + i);
                                    s += a <= 127 ? String.fromCharCode(a) : n[127 & a];
                                }
                                return s;
                            }
                        }, "function" == typeof WeakMap && new WeakMap);
                        function le(e1) {
                            return -128 <= e1 && e1 <= 127;
                        }
                        w.MACSTRING = function(e1, t) {
                            var r = function(e1) {
                                if (!se) for(var t in se = {}, ie)se[t] = new String(t);
                                var r = se[e1];
                                if (void 0 !== r) {
                                    if (ae) {
                                        var o = ae.get(r);
                                        if (void 0 !== o) return o;
                                    }
                                    var n = ie[e1];
                                    if (void 0 !== n) {
                                        for(var s = {}, i = 0; i < n.length; i++)s[n.charCodeAt(i)] = i + 128;
                                        return ae && ae.set(r, s), s;
                                    }
                                }
                            }(t);
                            if (void 0 !== r) {
                                for(var o = [], n = 0; n < e1.length; n++){
                                    var s = e1.charCodeAt(n);
                                    if (128 <= s && void 0 === (s = r[s])) return;
                                    o[n] = s;
                                }
                                return o;
                            }
                        }, l.MACSTRING = function(e1, t) {
                            e1 = w.MACSTRING(e1, t);
                            return void 0 !== e1 ? e1.length : 0;
                        }, w.VARDELTAS = function(e1) {
                            for(var t = 0, r = []; t < e1.length;)var o = e1[t], t = (0 === o ? function(e1, t, r) {
                                for(var o = 0, n = e1.length; t < n && o < 64 && 0 === e1[t];)++t, ++o;
                                return r.push(128 | o - 1), t;
                            } : -128 <= o && o <= 127 ? function(e1, t, r) {
                                for(var o = 0, n = e1.length, s = t; s < n && o < 64;){
                                    var i = e1[s];
                                    if (!le(i)) break;
                                    if (0 === i && s + 1 < n && 0 === e1[s + 1]) break;
                                    ++s, ++o;
                                }
                                r.push(o - 1);
                                for(var a = t; a < s; ++a)r.push(e1[a] + 256 & 255);
                                return s;
                            } : function(e1, t, r) {
                                for(var o = 0, n = e1.length, s = t; s < n && o < 64;){
                                    var i = e1[s];
                                    if (0 === i) break;
                                    if (le(i) && s + 1 < n && le(e1[s + 1])) break;
                                    ++s, ++o;
                                }
                                r.push(64 | o - 1);
                                for(var a = t; a < s; ++a){
                                    var l = e1[a];
                                    r.push(l + 65536 >> 8 & 255, l + 256 & 255);
                                }
                                return s;
                            })(e1, t, r);
                            return r;
                        }, w.INDEX = function(e1) {
                            for(var t = 1, r = [
                                t
                            ], o = [], n = 0; n < e1.length; n += 1){
                                var s = w.OBJECT(e1[n]);
                                Array.prototype.push.apply(o, s), t += s.length, r.push(t);
                            }
                            if (0 === o.length) return [
                                0,
                                0
                            ];
                            for(var i = [], a = 1 + Math.floor(Math.log(t) / Math.log(2)) / 8 | 0, l = [
                                void 0,
                                w.BYTE,
                                w.USHORT,
                                w.UINT24,
                                w.ULONG
                            ][a], u = 0; u < r.length; u += 1){
                                var c = l(r[u]);
                                Array.prototype.push.apply(i, c);
                            }
                            return Array.prototype.concat(w.Card16(e1.length), w.OffSize(a), i, o);
                        }, l.INDEX = function(e1) {
                            return w.INDEX(e1).length;
                        }, w.DICT = function(e1) {
                            for(var t = [], r = Object.keys(e1), o = r.length, n = 0; n < o; n += 1){
                                var s = parseInt(r[n], 0), i = e1[s];
                                t = (t = t.concat(w.OPERAND(i.value, i.type))).concat(w.OPERATOR(s));
                            }
                            return t;
                        }, l.DICT = function(e1) {
                            return w.DICT(e1).length;
                        }, w.OPERATOR = function(e1) {
                            return e1 < 1200 ? [
                                e1
                            ] : [
                                12,
                                e1 - 1200
                            ];
                        }, w.OPERAND = function(e1, t) {
                            var r = [];
                            if (Array.isArray(t)) for(var o = 0; o < t.length; o += 1)L.argument(e1.length === t.length, "Not enough arguments given for type" + t), r = r.concat(w.OPERAND(e1[o], t[o]));
                            else if ("SID" === t) r = r.concat(w.NUMBER(e1));
                            else if ("offset" === t) r = r.concat(w.NUMBER32(e1));
                            else if ("number" === t) r = r.concat(w.NUMBER(e1));
                            else {
                                if ("real" !== t) throw new Error("Unknown operand type " + t);
                                r = r.concat(w.REAL(e1));
                            }
                            return r;
                        }, w.OP = w.BYTE, l.OP = l.BYTE;
                        var ue = "function" == typeof WeakMap && new WeakMap;
                        function n(e1, t, r) {
                            for(var o = 0; o < t.length; o += 1){
                                var n = t[o];
                                this[n.name] = n.value;
                            }
                            if (this.tableName = e1, this.fields = t, r) for(var s = Object.keys(r), i = 0; i < s.length; i += 1){
                                var a = s[i], l = r[a];
                                void 0 !== this[a] && (this[a] = l);
                            }
                        }
                        function ce(e1, t, r) {
                            void 0 === r && (r = t.length);
                            var o = new Array(t.length + 1);
                            o[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: r
                            };
                            for(var n = 0; n < t.length; n++)o[n + 1] = {
                                name: e1 + n,
                                type: "USHORT",
                                value: t[n]
                            };
                            return o;
                        }
                        function de(e1, t, r) {
                            var o = t.length, n = new Array(o + 1);
                            n[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: o
                            };
                            for(var s = 0; s < o; s++)n[s + 1] = {
                                name: e1 + s,
                                type: "TABLE",
                                value: r(t[s], s)
                            };
                            return n;
                        }
                        function fe(e1, t, r) {
                            var o = t.length, n = [];
                            n[0] = {
                                name: e1 + "Count",
                                type: "USHORT",
                                value: o
                            };
                            for(var s = 0; s < o; s++)n = n.concat(r(t[s], s));
                            return n;
                        }
                        function he(e1) {
                            1 === e1.format ? n.call(this, "coverageTable", [
                                {
                                    name: "coverageFormat",
                                    type: "USHORT",
                                    value: 1
                                }
                            ].concat(ce("glyph", e1.glyphs))) : L.assert(!1, "Can't create coverage table format 2 yet.");
                        }
                        function pe(e1) {
                            n.call(this, "scriptListTable", fe("scriptRecord", e1, function(e1, t) {
                                var r = e1.script, o = r.defaultLangSys;
                                return L.assert(!!o, "Unable to write GSUB: script " + e1.tag + " has no default language system."), [
                                    {
                                        name: "scriptTag" + t,
                                        type: "TAG",
                                        value: e1.tag
                                    },
                                    {
                                        name: "script" + t,
                                        type: "TABLE",
                                        value: new n("scriptTable", [
                                            {
                                                name: "defaultLangSys",
                                                type: "TABLE",
                                                value: new n("defaultLangSys", [
                                                    {
                                                        name: "lookupOrder",
                                                        type: "USHORT",
                                                        value: 0
                                                    },
                                                    {
                                                        name: "reqFeatureIndex",
                                                        type: "USHORT",
                                                        value: o.reqFeatureIndex
                                                    }
                                                ].concat(ce("featureIndex", o.featureIndexes)))
                                            }
                                        ].concat(fe("langSys", r.langSysRecords, function(e1, t) {
                                            var r = e1.langSys;
                                            return [
                                                {
                                                    name: "langSysTag" + t,
                                                    type: "TAG",
                                                    value: e1.tag
                                                },
                                                {
                                                    name: "langSys" + t,
                                                    type: "TABLE",
                                                    value: new n("langSys", [
                                                        {
                                                            name: "lookupOrder",
                                                            type: "USHORT",
                                                            value: 0
                                                        },
                                                        {
                                                            name: "reqFeatureIndex",
                                                            type: "USHORT",
                                                            value: r.reqFeatureIndex
                                                        }
                                                    ].concat(ce("featureIndex", r.featureIndexes)))
                                                }
                                            ];
                                        })))
                                    }
                                ];
                            }));
                        }
                        function me(e1) {
                            n.call(this, "featureListTable", fe("featureRecord", e1, function(e1, t) {
                                var r = e1.feature;
                                return [
                                    {
                                        name: "featureTag" + t,
                                        type: "TAG",
                                        value: e1.tag
                                    },
                                    {
                                        name: "feature" + t,
                                        type: "TABLE",
                                        value: new n("featureTable", [
                                            {
                                                name: "featureParams",
                                                type: "USHORT",
                                                value: r.featureParams
                                            }
                                        ].concat(ce("lookupListIndex", r.lookupListIndexes)))
                                    }
                                ];
                            }));
                        }
                        function ye(e1, r) {
                            n.call(this, "lookupListTable", de("lookup", e1, function(e1) {
                                var t = r[e1.lookupType];
                                return L.assert(!!t, "Unable to write GSUB lookup type " + e1.lookupType + " tables."), new n("lookupTable", [
                                    {
                                        name: "lookupType",
                                        type: "USHORT",
                                        value: e1.lookupType
                                    },
                                    {
                                        name: "lookupFlag",
                                        type: "USHORT",
                                        value: e1.lookupFlag
                                    }
                                ].concat(de("subtable", e1.subtables, t)));
                            }));
                        }
                        w.CHARSTRING = function(e1) {
                            if (ue) {
                                var t = ue.get(e1);
                                if (void 0 !== t) return t;
                            }
                            for(var r = [], o = e1.length, n = 0; n < o; n += 1)var s = e1[n], r = r.concat(w[s.type](s.value));
                            return ue && ue.set(e1, r), r;
                        }, l.CHARSTRING = function(e1) {
                            return w.CHARSTRING(e1).length;
                        }, w.OBJECT = function(e1) {
                            var t = w[e1.type];
                            return L.argument(void 0 !== t, "No encoding function for type " + e1.type), t(e1.value);
                        }, l.OBJECT = function(e1) {
                            var t = l[e1.type];
                            return L.argument(void 0 !== t, "No sizeOf function for type " + e1.type), t(e1.value);
                        }, w.TABLE = function(e1) {
                            for(var t = [], r = e1.fields.length, o = [], n = [], s = 0; s < r; s += 1){
                                var i = e1.fields[s], a = w[i.type], l = (L.argument(void 0 !== a, "No encoding function for field type " + i.type + " (" + i.name + ")"), e1[i.name]), a = a(l = void 0 === l ? i.value : l);
                                "TABLE" === i.type ? (n.push(t.length), t = t.concat([
                                    0,
                                    0
                                ]), o.push(a)) : t = t.concat(a);
                            }
                            for(var u = 0; u < o.length; u += 1){
                                var c = n[u], d = t.length;
                                L.argument(d < 65536, "Table " + e1.tableName + " too big."), t[c] = d >> 8, t[c + 1] = 255 & d, t = t.concat(o[u]);
                            }
                            return t;
                        }, l.TABLE = function(e1) {
                            for(var t = 0, r = e1.fields.length, o = 0; o < r; o += 1){
                                var n = e1.fields[o], s = l[n.type], i = (L.argument(void 0 !== s, "No sizeOf function for field type " + n.type + " (" + n.name + ")"), e1[n.name]);
                                t += s(i = void 0 === i ? n.value : i), "TABLE" === n.type && (t += 2);
                            }
                            return t;
                        }, w.RECORD = w.TABLE, l.RECORD = l.TABLE, w.LITERAL = function(e1) {
                            return e1;
                        }, l.LITERAL = function(e1) {
                            return e1.length;
                        }, n.prototype.encode = function() {
                            return w.TABLE(this);
                        }, n.prototype.sizeOf = function() {
                            return l.TABLE(this);
                        };
                        var S = {
                            Table: n,
                            Record: n,
                            Coverage: (he.prototype = Object.create(n.prototype)).constructor = he,
                            ScriptList: (pe.prototype = Object.create(n.prototype)).constructor = pe,
                            FeatureList: (me.prototype = Object.create(n.prototype)).constructor = me,
                            LookupList: (ye.prototype = Object.create(n.prototype)).constructor = ye,
                            ushortList: ce,
                            tableList: de,
                            recordList: fe
                        };
                        function ge(e1, t) {
                            return e1.getUint8(t);
                        }
                        function ve(e1, t) {
                            return e1.getUint16(t, !1);
                        }
                        function be(e1, t) {
                            return e1.getUint32(t, !1);
                        }
                        function je(e1, t) {
                            return e1.getInt16(t, !1) + e1.getUint16(t + 2, !1) / 65535;
                        }
                        var _e = {
                            byte: 1,
                            uShort: 2,
                            short: 2,
                            uLong: 4,
                            fixed: 4,
                            longDateTime: 8,
                            tag: 4
                        };
                        function u(e1, t) {
                            this.data = e1, this.offset = t, this.relativeOffset = 0;
                        }
                        u.prototype.parseByte = function() {
                            var e1 = this.data.getUint8(this.offset + this.relativeOffset);
                            return this.relativeOffset += 1, e1;
                        }, u.prototype.parseChar = function() {
                            var e1 = this.data.getInt8(this.offset + this.relativeOffset);
                            return this.relativeOffset += 1, e1;
                        }, u.prototype.parseCard8 = u.prototype.parseByte, u.prototype.parseCard16 = u.prototype.parseUShort = function() {
                            var e1 = this.data.getUint16(this.offset + this.relativeOffset);
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseSID = u.prototype.parseUShort, u.prototype.parseOffset16 = u.prototype.parseUShort, u.prototype.parseShort = function() {
                            var e1 = this.data.getInt16(this.offset + this.relativeOffset);
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseF2Dot14 = function() {
                            var e1 = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
                            return this.relativeOffset += 2, e1;
                        }, u.prototype.parseOffset32 = u.prototype.parseULong = function() {
                            var e1 = be(this.data, this.offset + this.relativeOffset);
                            return this.relativeOffset += 4, e1;
                        }, u.prototype.parseFixed = function() {
                            var e1 = je(this.data, this.offset + this.relativeOffset);
                            return this.relativeOffset += 4, e1;
                        }, u.prototype.parseString = function(e1) {
                            var t = this.data, r = this.offset + this.relativeOffset, o = "";
                            this.relativeOffset += e1;
                            for(var n = 0; n < e1; n++)o += String.fromCharCode(t.getUint8(r + n));
                            return o;
                        }, u.prototype.parseTag = function() {
                            return this.parseString(4);
                        }, u.prototype.parseLongDateTime = function() {
                            var e1 = be(this.data, this.offset + this.relativeOffset + 4);
                            return e1 -= 2082844800, this.relativeOffset += 8, e1;
                        }, u.prototype.parseVersion = function(e1) {
                            var t = ve(this.data, this.offset + this.relativeOffset), r = ve(this.data, this.offset + this.relativeOffset + 2);
                            return this.relativeOffset += 4, t + r / (e1 = void 0 === e1 ? 4096 : e1) / 10;
                        }, u.prototype.skip = function(e1, t) {
                            this.relativeOffset += _e[e1] * (t = void 0 === t ? 1 : t);
                        }, u.prototype.parseULongList = function(e1) {
                            void 0 === e1 && (e1 = this.parseULong());
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint32(o), o += 4;
                            return this.relativeOffset += 4 * e1, t;
                        }, u.prototype.parseOffset16List = u.prototype.parseUShortList = function(e1) {
                            void 0 === e1 && (e1 = this.parseUShort());
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint16(o), o += 2;
                            return this.relativeOffset += 2 * e1, t;
                        }, u.prototype.parseShortList = function(e1) {
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getInt16(o), o += 2;
                            return this.relativeOffset += 2 * e1, t;
                        }, u.prototype.parseByteList = function(e1) {
                            for(var t = new Array(e1), r = this.data, o = this.offset + this.relativeOffset, n = 0; n < e1; n++)t[n] = r.getUint8(o++);
                            return this.relativeOffset += e1, t;
                        }, u.prototype.parseList = function(e1, t) {
                            t || (t = e1, e1 = this.parseUShort());
                            for(var r = new Array(e1), o = 0; o < e1; o++)r[o] = t.call(this);
                            return r;
                        }, u.prototype.parseList32 = function(e1, t) {
                            t || (t = e1, e1 = this.parseULong());
                            for(var r = new Array(e1), o = 0; o < e1; o++)r[o] = t.call(this);
                            return r;
                        }, u.prototype.parseRecordList = function(e1, t) {
                            t || (t = e1, e1 = this.parseUShort());
                            for(var r = new Array(e1), o = Object.keys(t), n = 0; n < e1; n++){
                                for(var s = {}, i = 0; i < o.length; i++){
                                    var a = o[i], l = t[a];
                                    s[a] = l.call(this);
                                }
                                r[n] = s;
                            }
                            return r;
                        }, u.prototype.parseRecordList32 = function(e1, t) {
                            t || (t = e1, e1 = this.parseULong());
                            for(var r = new Array(e1), o = Object.keys(t), n = 0; n < e1; n++){
                                for(var s = {}, i = 0; i < o.length; i++){
                                    var a = o[i], l = t[a];
                                    s[a] = l.call(this);
                                }
                                r[n] = s;
                            }
                            return r;
                        }, u.prototype.parseStruct = function(e1) {
                            if ("function" == typeof e1) return e1.call(this);
                            for(var t = Object.keys(e1), r = {}, o = 0; o < t.length; o++){
                                var n = t[o], s = e1[n];
                                r[n] = s.call(this);
                            }
                            return r;
                        }, u.prototype.parseValueRecord = function(e1) {
                            var t;
                            if (0 !== (e1 = void 0 === e1 ? this.parseUShort() : e1)) return t = {}, 1 & e1 && (t.xPlacement = this.parseShort()), 2 & e1 && (t.yPlacement = this.parseShort()), 4 & e1 && (t.xAdvance = this.parseShort()), 8 & e1 && (t.yAdvance = this.parseShort()), 16 & e1 && (t.xPlaDevice = void 0, this.parseShort()), 32 & e1 && (t.yPlaDevice = void 0, this.parseShort()), 64 & e1 && (t.xAdvDevice = void 0, this.parseShort()), 128 & e1 && (t.yAdvDevice = void 0, this.parseShort()), t;
                        }, u.prototype.parseValueRecordList = function() {
                            for(var e1 = this.parseUShort(), t = this.parseUShort(), r = new Array(t), o = 0; o < t; o++)r[o] = this.parseValueRecord(e1);
                            return r;
                        }, u.prototype.parsePointer = function(e1) {
                            var t = this.parseOffset16();
                            if (0 < t) return new u(this.data, this.offset + t).parseStruct(e1);
                        }, u.prototype.parsePointer32 = function(e1) {
                            var t = this.parseOffset32();
                            if (0 < t) return new u(this.data, this.offset + t).parseStruct(e1);
                        }, u.prototype.parseListOfLists = function(e1) {
                            for(var t = this.parseOffset16List(), r = t.length, o = this.relativeOffset, n = new Array(r), s = 0; s < r; s++){
                                var i = t[s];
                                if (0 === i) n[s] = void 0;
                                else if (this.relativeOffset = i, e1) {
                                    for(var a = this.parseOffset16List(), l = new Array(a.length), u = 0; u < a.length; u++)this.relativeOffset = i + a[u], l[u] = e1.call(this);
                                    n[s] = l;
                                } else n[s] = this.parseUShortList();
                            }
                            return this.relativeOffset = o, n;
                        }, u.prototype.parseCoverage = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort(), r = this.parseUShort();
                            if (1 === t) return {
                                format: 1,
                                glyphs: this.parseUShortList(r)
                            };
                            if (2 !== t) throw new Error("0x" + e1.toString(16) + ": Coverage format must be 1 or 2.");
                            for(var o = new Array(r), n = 0; n < r; n++)o[n] = {
                                start: this.parseUShort(),
                                end: this.parseUShort(),
                                index: this.parseUShort()
                            };
                            return {
                                format: 2,
                                ranges: o
                            };
                        }, u.prototype.parseClassDef = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            if (1 === t) return {
                                format: 1,
                                startGlyph: this.parseUShort(),
                                classes: this.parseUShortList()
                            };
                            if (2 === t) return {
                                format: 2,
                                ranges: this.parseRecordList({
                                    start: u.uShort,
                                    end: u.uShort,
                                    classId: u.uShort
                                })
                            };
                            throw new Error("0x" + e1.toString(16) + ": ClassDef format must be 1 or 2.");
                        }, u.list = function(e1, t) {
                            return function() {
                                return this.parseList(e1, t);
                            };
                        }, u.list32 = function(e1, t) {
                            return function() {
                                return this.parseList32(e1, t);
                            };
                        }, u.recordList = function(e1, t) {
                            return function() {
                                return this.parseRecordList(e1, t);
                            };
                        }, u.recordList32 = function(e1, t) {
                            return function() {
                                return this.parseRecordList32(e1, t);
                            };
                        }, u.pointer = function(e1) {
                            return function() {
                                return this.parsePointer(e1);
                            };
                        }, u.pointer32 = function(e1) {
                            return function() {
                                return this.parsePointer32(e1);
                            };
                        }, u.tag = u.prototype.parseTag, u.byte = u.prototype.parseByte, u.uShort = u.offset16 = u.prototype.parseUShort, u.uShortList = u.prototype.parseUShortList, u.uLong = u.offset32 = u.prototype.parseULong, u.uLongList = u.prototype.parseULongList, u.struct = u.prototype.parseStruct, u.coverage = u.prototype.parseCoverage, u.classDef = u.prototype.parseClassDef;
                        var xe = {
                            reserved: u.uShort,
                            reqFeatureIndex: u.uShort,
                            featureIndexes: u.uShortList
                        }, R = (u.prototype.parseScriptList = function() {
                            return this.parsePointer(u.recordList({
                                tag: u.tag,
                                script: u.pointer({
                                    defaultLangSys: u.pointer(xe),
                                    langSysRecords: u.recordList({
                                        tag: u.tag,
                                        langSys: u.pointer(xe)
                                    })
                                })
                            })) || [];
                        }, u.prototype.parseFeatureList = function() {
                            return this.parsePointer(u.recordList({
                                tag: u.tag,
                                feature: u.pointer({
                                    featureParams: u.offset16,
                                    lookupListIndexes: u.uShortList
                                })
                            })) || [];
                        }, u.prototype.parseLookupList = function(o) {
                            return this.parsePointer(u.list(u.pointer(function() {
                                var e1 = this.parseUShort(), t = (L.argument(1 <= e1 && e1 <= 9, "GPOS/GSUB lookup type " + e1 + " unknown."), this.parseUShort()), r = 16 & t;
                                return {
                                    lookupType: e1,
                                    lookupFlag: t,
                                    subtables: this.parseList(u.pointer(o[e1])),
                                    markFilteringSet: r ? this.parseUShort() : void 0
                                };
                            }))) || [];
                        }, u.prototype.parseFeatureVariationsList = function() {
                            return this.parsePointer32(function() {
                                var e1 = this.parseUShort(), t = this.parseUShort();
                                return L.argument(1 === e1 && t < 1, "GPOS/GSUB feature variations table unknown."), this.parseRecordList32({
                                    conditionSetOffset: u.offset32,
                                    featureTableSubstitutionOffset: u.offset32
                                });
                            }) || [];
                        }, {
                            getByte: ge,
                            getCard8: ge,
                            getUShort: ve,
                            getCard16: ve,
                            getShort: function(e1, t) {
                                return e1.getInt16(t, !1);
                            },
                            getULong: be,
                            getFixed: je,
                            getTag: function(e1, t) {
                                for(var r = "", o = t; o < t + 4; o += 1)r += String.fromCharCode(e1.getInt8(o));
                                return r;
                            },
                            getOffset: function(e1, t, r) {
                                for(var o = 0, n = 0; n < r; n += 1)o = (o <<= 8) + e1.getUint8(t + n);
                                return o;
                            },
                            getBytes: function(e1, t, r) {
                                for(var o = [], n = t; n < r; n += 1)o.push(e1.getUint8(n));
                                return o;
                            },
                            bytesToString: function(e1) {
                                for(var t = "", r = 0; r < e1.length; r += 1)t += String.fromCharCode(e1[r]);
                                return t;
                            },
                            Parser: u
                        });
                        var we = {
                            parse: function(e1, t) {
                                for(var r = {}, o = (r.version = R.getUShort(e1, t), L.argument(0 === r.version, "cmap table version should be 0."), r.numTables = R.getUShort(e1, t + 2), -1), n = r.numTables - 1; 0 <= n; --n){
                                    var s = R.getUShort(e1, t + 4 + 8 * n), i = R.getUShort(e1, t + 4 + 8 * n + 2);
                                    if (3 === s && (0 === i || 1 === i || 10 === i) || 0 === s && (0 === i || 1 === i || 2 === i || 3 === i || 4 === i)) {
                                        o = R.getULong(e1, t + 4 + 8 * n + 4);
                                        break;
                                    }
                                }
                                if (-1 === o) throw new Error("No valid cmap sub-tables found.");
                                var a = new R.Parser(e1, t + o);
                                if (r.format = a.parseUShort(), 12 === r.format) {
                                    var l, u = r, c = a;
                                    c.parseUShort(), u.length = c.parseULong(), u.language = c.parseULong(), u.groupCount = l = c.parseULong(), u.glyphIndexMap = {};
                                    for(var d = 0; d < l; d += 1)for(var f = c.parseULong(), h = c.parseULong(), p = c.parseULong(), m = f; m <= h; m += 1)u.glyphIndexMap[m] = p, p++;
                                } else {
                                    if (4 !== r.format) throw new Error("Only format 4 and 12 cmap tables are supported (found format " + r.format + ").");
                                    var y = r, g = e1, v = t, b = o;
                                    y.length = a.parseUShort(), y.language = a.parseUShort(), y.segCount = j = a.parseUShort() >> 1, a.skip("uShort", 3), y.glyphIndexMap = {};
                                    for(var j, _ = new R.Parser(g, v + b + 14), x = new R.Parser(g, v + b + 16 + 2 * j), w = new R.Parser(g, v + b + 16 + 4 * j), S = new R.Parser(g, v + b + 16 + 6 * j), E = v + b + 16 + 8 * j, M = 0; M < j - 1; M += 1)for(var T = void 0, k = _.parseUShort(), O = x.parseUShort(), C = w.parseShort(), A = S.parseUShort(), P = O; P <= k; P += 1)0 !== A ? (E = (E = S.offset + S.relativeOffset - 2) + A + 2 * (P - O), 0 !== (T = R.getUShort(g, E)) && (T = T + C & 65535)) : T = P + C & 65535, y.glyphIndexMap[P] = T;
                                }
                                return r;
                            },
                            make: function(e1) {
                                for(var t = !0, r = e1.length - 1; 0 < r; --r)if (65535 < e1.get(r).unicode) {
                                    console.log("Adding CMAP format 12 (needed!)"), t = !1;
                                    break;
                                }
                                var o, n, s = [
                                    {
                                        name: "version",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "numTables",
                                        type: "USHORT",
                                        value: t ? 1 : 2
                                    },
                                    {
                                        name: "platformID",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "encodingID",
                                        type: "USHORT",
                                        value: 1
                                    },
                                    {
                                        name: "offset",
                                        type: "ULONG",
                                        value: t ? 12 : 20
                                    }
                                ], i = (s = (s = t ? s : s.concat([
                                    {
                                        name: "cmap12PlatformID",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "cmap12EncodingID",
                                        type: "USHORT",
                                        value: 10
                                    },
                                    {
                                        name: "cmap12Offset",
                                        type: "ULONG",
                                        value: 0
                                    }
                                ])).concat([
                                    {
                                        name: "format",
                                        type: "USHORT",
                                        value: 4
                                    },
                                    {
                                        name: "cmap4Length",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "language",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "segCountX2",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "searchRange",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "entrySelector",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "rangeShift",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ]), new S.Table("cmap", s));
                                for(i.segments = [], r = 0; r < e1.length; r += 1){
                                    for(var a = e1.get(r), l = 0; l < a.unicodes.length; l += 1)o = a.unicodes[l], n = r, i.segments.push({
                                        end: o,
                                        start: o,
                                        delta: -(o - n),
                                        offset: 0,
                                        glyphIndex: n
                                    });
                                    i.segments = i.segments.sort(function(e1, t) {
                                        return e1.start - t.start;
                                    });
                                }
                                i.segments.push({
                                    end: 65535,
                                    start: 65535,
                                    delta: 1,
                                    offset: 0
                                });
                                var u = i.segments.length, c = 0, d = [], f = [], h = [], p = [], m = [], y = [];
                                for(r = 0; r < u; r += 1){
                                    var g = i.segments[r];
                                    g.end <= 65535 && g.start <= 65535 ? (d = d.concat({
                                        name: "end_" + r,
                                        type: "USHORT",
                                        value: g.end
                                    }), f = f.concat({
                                        name: "start_" + r,
                                        type: "USHORT",
                                        value: g.start
                                    }), h = h.concat({
                                        name: "idDelta_" + r,
                                        type: "SHORT",
                                        value: g.delta
                                    }), p = p.concat({
                                        name: "idRangeOffset_" + r,
                                        type: "USHORT",
                                        value: g.offset
                                    }), void 0 !== g.glyphId && (m = m.concat({
                                        name: "glyph_" + r,
                                        type: "USHORT",
                                        value: g.glyphId
                                    }))) : c += 1, t || void 0 === g.glyphIndex || (y = (y = (y = y.concat({
                                        name: "cmap12Start_" + r,
                                        type: "ULONG",
                                        value: g.start
                                    })).concat({
                                        name: "cmap12End_" + r,
                                        type: "ULONG",
                                        value: g.end
                                    })).concat({
                                        name: "cmap12Glyph_" + r,
                                        type: "ULONG",
                                        value: g.glyphIndex
                                    }));
                                }
                                return i.segCountX2 = 2 * (u - c), i.searchRange = 2 * Math.pow(2, Math.floor(Math.log(u - c) / Math.log(2))), i.entrySelector = Math.log(i.searchRange / 2) / Math.log(2), i.rangeShift = i.segCountX2 - i.searchRange, i.fields = i.fields.concat(d), i.fields.push({
                                    name: "reservedPad",
                                    type: "USHORT",
                                    value: 0
                                }), i.fields = i.fields.concat(f), i.fields = i.fields.concat(h), i.fields = i.fields.concat(p), i.fields = i.fields.concat(m), i.cmap4Length = 14 + 2 * d.length + 2 + 2 * f.length + 2 * h.length + 2 * p.length + 2 * m.length, t || (s = 16 + 4 * y.length, i.cmap12Offset = 20 + i.cmap4Length, i.fields = i.fields.concat([
                                    {
                                        name: "cmap12Format",
                                        type: "USHORT",
                                        value: 12
                                    },
                                    {
                                        name: "cmap12Reserved",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "cmap12Length",
                                        type: "ULONG",
                                        value: s
                                    },
                                    {
                                        name: "cmap12Language",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "cmap12nGroups",
                                        type: "ULONG",
                                        value: y.length / 3
                                    }
                                ]), i.fields = i.fields.concat(y)), i;
                            }
                        }, Se = [
                            ".notdef",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quoteright",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "quoteleft",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "exclamdown",
                            "cent",
                            "sterling",
                            "fraction",
                            "yen",
                            "florin",
                            "section",
                            "currency",
                            "quotesingle",
                            "quotedblleft",
                            "guillemotleft",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "endash",
                            "dagger",
                            "daggerdbl",
                            "periodcentered",
                            "paragraph",
                            "bullet",
                            "quotesinglbase",
                            "quotedblbase",
                            "quotedblright",
                            "guillemotright",
                            "ellipsis",
                            "perthousand",
                            "questiondown",
                            "grave",
                            "acute",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "dieresis",
                            "ring",
                            "cedilla",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "emdash",
                            "AE",
                            "ordfeminine",
                            "Lslash",
                            "Oslash",
                            "OE",
                            "ordmasculine",
                            "ae",
                            "dotlessi",
                            "lslash",
                            "oslash",
                            "oe",
                            "germandbls",
                            "onesuperior",
                            "logicalnot",
                            "mu",
                            "trademark",
                            "Eth",
                            "onehalf",
                            "plusminus",
                            "Thorn",
                            "onequarter",
                            "divide",
                            "brokenbar",
                            "degree",
                            "thorn",
                            "threequarters",
                            "twosuperior",
                            "registered",
                            "minus",
                            "eth",
                            "multiply",
                            "threesuperior",
                            "copyright",
                            "Aacute",
                            "Acircumflex",
                            "Adieresis",
                            "Agrave",
                            "Aring",
                            "Atilde",
                            "Ccedilla",
                            "Eacute",
                            "Ecircumflex",
                            "Edieresis",
                            "Egrave",
                            "Iacute",
                            "Icircumflex",
                            "Idieresis",
                            "Igrave",
                            "Ntilde",
                            "Oacute",
                            "Ocircumflex",
                            "Odieresis",
                            "Ograve",
                            "Otilde",
                            "Scaron",
                            "Uacute",
                            "Ucircumflex",
                            "Udieresis",
                            "Ugrave",
                            "Yacute",
                            "Ydieresis",
                            "Zcaron",
                            "aacute",
                            "acircumflex",
                            "adieresis",
                            "agrave",
                            "aring",
                            "atilde",
                            "ccedilla",
                            "eacute",
                            "ecircumflex",
                            "edieresis",
                            "egrave",
                            "iacute",
                            "icircumflex",
                            "idieresis",
                            "igrave",
                            "ntilde",
                            "oacute",
                            "ocircumflex",
                            "odieresis",
                            "ograve",
                            "otilde",
                            "scaron",
                            "uacute",
                            "ucircumflex",
                            "udieresis",
                            "ugrave",
                            "yacute",
                            "ydieresis",
                            "zcaron",
                            "exclamsmall",
                            "Hungarumlautsmall",
                            "dollaroldstyle",
                            "dollarsuperior",
                            "ampersandsmall",
                            "Acutesmall",
                            "parenleftsuperior",
                            "parenrightsuperior",
                            "266 ff",
                            "onedotenleader",
                            "zerooldstyle",
                            "oneoldstyle",
                            "twooldstyle",
                            "threeoldstyle",
                            "fouroldstyle",
                            "fiveoldstyle",
                            "sixoldstyle",
                            "sevenoldstyle",
                            "eightoldstyle",
                            "nineoldstyle",
                            "commasuperior",
                            "threequartersemdash",
                            "periodsuperior",
                            "questionsmall",
                            "asuperior",
                            "bsuperior",
                            "centsuperior",
                            "dsuperior",
                            "esuperior",
                            "isuperior",
                            "lsuperior",
                            "msuperior",
                            "nsuperior",
                            "osuperior",
                            "rsuperior",
                            "ssuperior",
                            "tsuperior",
                            "ff",
                            "ffi",
                            "ffl",
                            "parenleftinferior",
                            "parenrightinferior",
                            "Circumflexsmall",
                            "hyphensuperior",
                            "Gravesmall",
                            "Asmall",
                            "Bsmall",
                            "Csmall",
                            "Dsmall",
                            "Esmall",
                            "Fsmall",
                            "Gsmall",
                            "Hsmall",
                            "Ismall",
                            "Jsmall",
                            "Ksmall",
                            "Lsmall",
                            "Msmall",
                            "Nsmall",
                            "Osmall",
                            "Psmall",
                            "Qsmall",
                            "Rsmall",
                            "Ssmall",
                            "Tsmall",
                            "Usmall",
                            "Vsmall",
                            "Wsmall",
                            "Xsmall",
                            "Ysmall",
                            "Zsmall",
                            "colonmonetary",
                            "onefitted",
                            "rupiah",
                            "Tildesmall",
                            "exclamdownsmall",
                            "centoldstyle",
                            "Lslashsmall",
                            "Scaronsmall",
                            "Zcaronsmall",
                            "Dieresissmall",
                            "Brevesmall",
                            "Caronsmall",
                            "Dotaccentsmall",
                            "Macronsmall",
                            "figuredash",
                            "hypheninferior",
                            "Ogoneksmall",
                            "Ringsmall",
                            "Cedillasmall",
                            "questiondownsmall",
                            "oneeighth",
                            "threeeighths",
                            "fiveeighths",
                            "seveneighths",
                            "onethird",
                            "twothirds",
                            "zerosuperior",
                            "foursuperior",
                            "fivesuperior",
                            "sixsuperior",
                            "sevensuperior",
                            "eightsuperior",
                            "ninesuperior",
                            "zeroinferior",
                            "oneinferior",
                            "twoinferior",
                            "threeinferior",
                            "fourinferior",
                            "fiveinferior",
                            "sixinferior",
                            "seveninferior",
                            "eightinferior",
                            "nineinferior",
                            "centinferior",
                            "dollarinferior",
                            "periodinferior",
                            "commainferior",
                            "Agravesmall",
                            "Aacutesmall",
                            "Acircumflexsmall",
                            "Atildesmall",
                            "Adieresissmall",
                            "Aringsmall",
                            "AEsmall",
                            "Ccedillasmall",
                            "Egravesmall",
                            "Eacutesmall",
                            "Ecircumflexsmall",
                            "Edieresissmall",
                            "Igravesmall",
                            "Iacutesmall",
                            "Icircumflexsmall",
                            "Idieresissmall",
                            "Ethsmall",
                            "Ntildesmall",
                            "Ogravesmall",
                            "Oacutesmall",
                            "Ocircumflexsmall",
                            "Otildesmall",
                            "Odieresissmall",
                            "OEsmall",
                            "Oslashsmall",
                            "Ugravesmall",
                            "Uacutesmall",
                            "Ucircumflexsmall",
                            "Udieresissmall",
                            "Yacutesmall",
                            "Thornsmall",
                            "Ydieresissmall",
                            "001.000",
                            "001.001",
                            "001.002",
                            "001.003",
                            "Black",
                            "Bold",
                            "Book",
                            "Light",
                            "Medium",
                            "Regular",
                            "Roman",
                            "Semibold"
                        ], Ee = [
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quoteright",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "quoteleft",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "exclamdown",
                            "cent",
                            "sterling",
                            "fraction",
                            "yen",
                            "florin",
                            "section",
                            "currency",
                            "quotesingle",
                            "quotedblleft",
                            "guillemotleft",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "",
                            "endash",
                            "dagger",
                            "daggerdbl",
                            "periodcentered",
                            "",
                            "paragraph",
                            "bullet",
                            "quotesinglbase",
                            "quotedblbase",
                            "quotedblright",
                            "guillemotright",
                            "ellipsis",
                            "perthousand",
                            "",
                            "questiondown",
                            "",
                            "grave",
                            "acute",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "dieresis",
                            "",
                            "ring",
                            "cedilla",
                            "",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "emdash",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "AE",
                            "",
                            "ordfeminine",
                            "",
                            "",
                            "",
                            "",
                            "Lslash",
                            "Oslash",
                            "OE",
                            "ordmasculine",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "ae",
                            "",
                            "",
                            "",
                            "dotlessi",
                            "",
                            "",
                            "lslash",
                            "oslash",
                            "oe",
                            "germandbls"
                        ], Me = [
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "space",
                            "exclamsmall",
                            "Hungarumlautsmall",
                            "",
                            "dollaroldstyle",
                            "dollarsuperior",
                            "ampersandsmall",
                            "Acutesmall",
                            "parenleftsuperior",
                            "parenrightsuperior",
                            "twodotenleader",
                            "onedotenleader",
                            "comma",
                            "hyphen",
                            "period",
                            "fraction",
                            "zerooldstyle",
                            "oneoldstyle",
                            "twooldstyle",
                            "threeoldstyle",
                            "fouroldstyle",
                            "fiveoldstyle",
                            "sixoldstyle",
                            "sevenoldstyle",
                            "eightoldstyle",
                            "nineoldstyle",
                            "colon",
                            "semicolon",
                            "commasuperior",
                            "threequartersemdash",
                            "periodsuperior",
                            "questionsmall",
                            "",
                            "asuperior",
                            "bsuperior",
                            "centsuperior",
                            "dsuperior",
                            "esuperior",
                            "",
                            "",
                            "isuperior",
                            "",
                            "",
                            "lsuperior",
                            "msuperior",
                            "nsuperior",
                            "osuperior",
                            "",
                            "",
                            "rsuperior",
                            "ssuperior",
                            "tsuperior",
                            "",
                            "ff",
                            "fi",
                            "fl",
                            "ffi",
                            "ffl",
                            "parenleftinferior",
                            "",
                            "parenrightinferior",
                            "Circumflexsmall",
                            "hyphensuperior",
                            "Gravesmall",
                            "Asmall",
                            "Bsmall",
                            "Csmall",
                            "Dsmall",
                            "Esmall",
                            "Fsmall",
                            "Gsmall",
                            "Hsmall",
                            "Ismall",
                            "Jsmall",
                            "Ksmall",
                            "Lsmall",
                            "Msmall",
                            "Nsmall",
                            "Osmall",
                            "Psmall",
                            "Qsmall",
                            "Rsmall",
                            "Ssmall",
                            "Tsmall",
                            "Usmall",
                            "Vsmall",
                            "Wsmall",
                            "Xsmall",
                            "Ysmall",
                            "Zsmall",
                            "colonmonetary",
                            "onefitted",
                            "rupiah",
                            "Tildesmall",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "exclamdownsmall",
                            "centoldstyle",
                            "Lslashsmall",
                            "",
                            "",
                            "Scaronsmall",
                            "Zcaronsmall",
                            "Dieresissmall",
                            "Brevesmall",
                            "Caronsmall",
                            "",
                            "Dotaccentsmall",
                            "",
                            "",
                            "Macronsmall",
                            "",
                            "",
                            "figuredash",
                            "hypheninferior",
                            "",
                            "",
                            "Ogoneksmall",
                            "Ringsmall",
                            "Cedillasmall",
                            "",
                            "",
                            "",
                            "onequarter",
                            "onehalf",
                            "threequarters",
                            "questiondownsmall",
                            "oneeighth",
                            "threeeighths",
                            "fiveeighths",
                            "seveneighths",
                            "onethird",
                            "twothirds",
                            "",
                            "",
                            "zerosuperior",
                            "onesuperior",
                            "twosuperior",
                            "threesuperior",
                            "foursuperior",
                            "fivesuperior",
                            "sixsuperior",
                            "sevensuperior",
                            "eightsuperior",
                            "ninesuperior",
                            "zeroinferior",
                            "oneinferior",
                            "twoinferior",
                            "threeinferior",
                            "fourinferior",
                            "fiveinferior",
                            "sixinferior",
                            "seveninferior",
                            "eightinferior",
                            "nineinferior",
                            "centinferior",
                            "dollarinferior",
                            "periodinferior",
                            "commainferior",
                            "Agravesmall",
                            "Aacutesmall",
                            "Acircumflexsmall",
                            "Atildesmall",
                            "Adieresissmall",
                            "Aringsmall",
                            "AEsmall",
                            "Ccedillasmall",
                            "Egravesmall",
                            "Eacutesmall",
                            "Ecircumflexsmall",
                            "Edieresissmall",
                            "Igravesmall",
                            "Iacutesmall",
                            "Icircumflexsmall",
                            "Idieresissmall",
                            "Ethsmall",
                            "Ntildesmall",
                            "Ogravesmall",
                            "Oacutesmall",
                            "Ocircumflexsmall",
                            "Otildesmall",
                            "Odieresissmall",
                            "OEsmall",
                            "Oslashsmall",
                            "Ugravesmall",
                            "Uacutesmall",
                            "Ucircumflexsmall",
                            "Udieresissmall",
                            "Yacutesmall",
                            "Thornsmall",
                            "Ydieresissmall"
                        ], c = [
                            ".notdef",
                            ".null",
                            "nonmarkingreturn",
                            "space",
                            "exclam",
                            "quotedbl",
                            "numbersign",
                            "dollar",
                            "percent",
                            "ampersand",
                            "quotesingle",
                            "parenleft",
                            "parenright",
                            "asterisk",
                            "plus",
                            "comma",
                            "hyphen",
                            "period",
                            "slash",
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five",
                            "six",
                            "seven",
                            "eight",
                            "nine",
                            "colon",
                            "semicolon",
                            "less",
                            "equal",
                            "greater",
                            "question",
                            "at",
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T",
                            "U",
                            "V",
                            "W",
                            "X",
                            "Y",
                            "Z",
                            "bracketleft",
                            "backslash",
                            "bracketright",
                            "asciicircum",
                            "underscore",
                            "grave",
                            "a",
                            "b",
                            "c",
                            "d",
                            "e",
                            "f",
                            "g",
                            "h",
                            "i",
                            "j",
                            "k",
                            "l",
                            "m",
                            "n",
                            "o",
                            "p",
                            "q",
                            "r",
                            "s",
                            "t",
                            "u",
                            "v",
                            "w",
                            "x",
                            "y",
                            "z",
                            "braceleft",
                            "bar",
                            "braceright",
                            "asciitilde",
                            "Adieresis",
                            "Aring",
                            "Ccedilla",
                            "Eacute",
                            "Ntilde",
                            "Odieresis",
                            "Udieresis",
                            "aacute",
                            "agrave",
                            "acircumflex",
                            "adieresis",
                            "atilde",
                            "aring",
                            "ccedilla",
                            "eacute",
                            "egrave",
                            "ecircumflex",
                            "edieresis",
                            "iacute",
                            "igrave",
                            "icircumflex",
                            "idieresis",
                            "ntilde",
                            "oacute",
                            "ograve",
                            "ocircumflex",
                            "odieresis",
                            "otilde",
                            "uacute",
                            "ugrave",
                            "ucircumflex",
                            "udieresis",
                            "dagger",
                            "degree",
                            "cent",
                            "sterling",
                            "section",
                            "bullet",
                            "paragraph",
                            "germandbls",
                            "registered",
                            "copyright",
                            "trademark",
                            "acute",
                            "dieresis",
                            "notequal",
                            "AE",
                            "Oslash",
                            "infinity",
                            "plusminus",
                            "lessequal",
                            "greaterequal",
                            "yen",
                            "mu",
                            "partialdiff",
                            "summation",
                            "product",
                            "pi",
                            "integral",
                            "ordfeminine",
                            "ordmasculine",
                            "Omega",
                            "ae",
                            "oslash",
                            "questiondown",
                            "exclamdown",
                            "logicalnot",
                            "radical",
                            "florin",
                            "approxequal",
                            "Delta",
                            "guillemotleft",
                            "guillemotright",
                            "ellipsis",
                            "nonbreakingspace",
                            "Agrave",
                            "Atilde",
                            "Otilde",
                            "OE",
                            "oe",
                            "endash",
                            "emdash",
                            "quotedblleft",
                            "quotedblright",
                            "quoteleft",
                            "quoteright",
                            "divide",
                            "lozenge",
                            "ydieresis",
                            "Ydieresis",
                            "fraction",
                            "currency",
                            "guilsinglleft",
                            "guilsinglright",
                            "fi",
                            "fl",
                            "daggerdbl",
                            "periodcentered",
                            "quotesinglbase",
                            "quotedblbase",
                            "perthousand",
                            "Acircumflex",
                            "Ecircumflex",
                            "Aacute",
                            "Edieresis",
                            "Egrave",
                            "Iacute",
                            "Icircumflex",
                            "Idieresis",
                            "Igrave",
                            "Oacute",
                            "Ocircumflex",
                            "apple",
                            "Ograve",
                            "Uacute",
                            "Ucircumflex",
                            "Ugrave",
                            "dotlessi",
                            "circumflex",
                            "tilde",
                            "macron",
                            "breve",
                            "dotaccent",
                            "ring",
                            "cedilla",
                            "hungarumlaut",
                            "ogonek",
                            "caron",
                            "Lslash",
                            "lslash",
                            "Scaron",
                            "scaron",
                            "Zcaron",
                            "zcaron",
                            "brokenbar",
                            "Eth",
                            "eth",
                            "Yacute",
                            "yacute",
                            "Thorn",
                            "thorn",
                            "minus",
                            "multiply",
                            "onesuperior",
                            "twosuperior",
                            "threesuperior",
                            "onehalf",
                            "onequarter",
                            "threequarters",
                            "franc",
                            "Gbreve",
                            "gbreve",
                            "Idotaccent",
                            "Scedilla",
                            "scedilla",
                            "Cacute",
                            "cacute",
                            "Ccaron",
                            "ccaron",
                            "dcroat"
                        ];
                        function Te(e1) {
                            this.font = e1;
                        }
                        function ke(e1) {
                            this.cmap = e1;
                        }
                        function Oe(e1, t) {
                            this.encoding = e1, this.charset = t;
                        }
                        function Ce(e1) {
                            switch(e1.version){
                                case 1:
                                    this.names = c.slice();
                                    break;
                                case 2:
                                    this.names = new Array(e1.numberOfGlyphs);
                                    for(var t = 0; t < e1.numberOfGlyphs; t++)e1.glyphNameIndex[t] < c.length ? this.names[t] = c[e1.glyphNameIndex[t]] : this.names[t] = e1.names[e1.glyphNameIndex[t] - c.length];
                                    break;
                                case 2.5:
                                    this.names = new Array(e1.numberOfGlyphs);
                                    for(var r = 0; r < e1.numberOfGlyphs; r++)this.names[r] = c[r + e1.glyphNameIndex[r]];
                                    break;
                                default:
                                    this.names = [];
                            }
                        }
                        Te.prototype.charToGlyphIndex = function(e1) {
                            var t = e1.codePointAt(0), r = this.font.glyphs;
                            if (r) {
                                for(var o = 0; o < r.length; o += 1)for(var n = r.get(o), s = 0; s < n.unicodes.length; s += 1)if (n.unicodes[s] === t) return o;
                            }
                            return null;
                        }, ke.prototype.charToGlyphIndex = function(e1) {
                            return this.cmap.glyphIndexMap[e1.codePointAt(0)] || 0;
                        }, Oe.prototype.charToGlyphIndex = function(e1) {
                            e1 = e1.codePointAt(0), e1 = this.encoding[e1];
                            return this.charset.indexOf(e1);
                        }, Ce.prototype.nameToGlyphIndex = function(e1) {
                            return this.names.indexOf(e1);
                        }, Ce.prototype.glyphIndexToName = function(e1) {
                            return this.names[e1];
                        };
                        var d = {
                            line: function(e1, t, r, o, n) {
                                e1.beginPath(), e1.moveTo(t, r), e1.lineTo(o, n), e1.stroke();
                            }
                        };
                        function h(e1) {
                            this.bindConstructorValues(e1);
                        }
                        function Ae(t, e1, r) {
                            Object.defineProperty(t, e1, {
                                get: function() {
                                    return t.path, t[r];
                                },
                                set: function(e1) {
                                    t[r] = e1;
                                },
                                enumerable: !0,
                                configurable: !0
                            });
                        }
                        function Pe(e1, t) {
                            if (this.font = e1, this.glyphs = {}, Array.isArray(t)) for(var r = 0; r < t.length; r++)this.glyphs[r] = t[r];
                            this.length = t && t.length || 0;
                        }
                        h.prototype.bindConstructorValues = function(e1) {
                            var t;
                            this.index = e1.index || 0, this.name = e1.name || null, this.unicode = e1.unicode || void 0, this.unicodes = e1.unicodes || void 0 !== e1.unicode ? [
                                e1.unicode
                            ] : [], e1.xMin && (this.xMin = e1.xMin), e1.yMin && (this.yMin = e1.yMin), e1.xMax && (this.xMax = e1.xMax), e1.yMax && (this.yMax = e1.yMax), e1.advanceWidth && (this.advanceWidth = e1.advanceWidth), Object.defineProperty(this, "path", (e1 = e1.path, t = e1 || new f, {
                                configurable: !0,
                                get: function() {
                                    return t = "function" == typeof t ? t() : t;
                                },
                                set: function(e1) {
                                    t = e1;
                                }
                            }));
                        }, h.prototype.addUnicode = function(e1) {
                            0 === this.unicodes.length && (this.unicode = e1), this.unicodes.push(e1);
                        }, h.prototype.getBoundingBox = function() {
                            return this.path.getBoundingBox();
                        }, h.prototype.getPath = function(e1, t, r, o, n) {
                            e1 = void 0 !== e1 ? e1 : 0, t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 72;
                            for(var s, i, a = (o = o || {}).xScale, l = o.yScale, u = ((s = o.hinting && n && n.hinting ? this.path && n.hinting.exec(this, r) : s) ? (i = n.hinting.getCommands(s), e1 = Math.round(e1), t = Math.round(t), a = l = 1) : (i = this.path.commands, o = 1 / this.path.unitsPerEm * r, void 0 === a && (a = o), void 0 === l && (l = o)), new f), c = 0; c < i.length; c += 1){
                                var d = i[c];
                                "M" === d.type ? u.moveTo(e1 + d.x * a, t + -d.y * l) : "L" === d.type ? u.lineTo(e1 + d.x * a, t + -d.y * l) : "Q" === d.type ? u.quadraticCurveTo(e1 + d.x1 * a, t + -d.y1 * l, e1 + d.x * a, t + -d.y * l) : "C" === d.type ? u.curveTo(e1 + d.x1 * a, t + -d.y1 * l, e1 + d.x2 * a, t + -d.y2 * l, e1 + d.x * a, t + -d.y * l) : "Z" === d.type && u.closePath();
                            }
                            return u;
                        }, h.prototype.getContours = function() {
                            if (void 0 === this.points) return [];
                            for(var e1 = [], t = [], r = 0; r < this.points.length; r += 1){
                                var o = this.points[r];
                                t.push(o), o.lastPointOfContour && (e1.push(t), t = []);
                            }
                            return L.argument(0 === t.length, "There are still points left in the current contour."), e1;
                        }, h.prototype.getMetrics = function() {
                            for(var e1 = this.path.commands, t = [], r = [], o = 0; o < e1.length; o += 1){
                                var n = e1[o];
                                "Z" !== n.type && (t.push(n.x), r.push(n.y)), "Q" !== n.type && "C" !== n.type || (t.push(n.x1), r.push(n.y1)), "C" === n.type && (t.push(n.x2), r.push(n.y2));
                            }
                            var s = {
                                xMin: Math.min.apply(null, t),
                                yMin: Math.min.apply(null, r),
                                xMax: Math.max.apply(null, t),
                                yMax: Math.max.apply(null, r),
                                leftSideBearing: this.leftSideBearing
                            };
                            return isFinite(s.xMin) || (s.xMin = 0), isFinite(s.xMax) || (s.xMax = this.advanceWidth), isFinite(s.yMin) || (s.yMin = 0), isFinite(s.yMax) || (s.yMax = 0), s.rightSideBearing = this.advanceWidth - s.leftSideBearing - (s.xMax - s.xMin), s;
                        }, h.prototype.draw = function(e1, t, r, o, n) {
                            this.getPath(t, r, o, n).draw(e1);
                        }, h.prototype.drawPoints = function(i, e1, t, r) {
                            function o(e1, t, r, o) {
                                var n = 2 * Math.PI;
                                i.beginPath();
                                for(var s = 0; s < e1.length; s += 1)i.moveTo(t + e1[s].x * o, r + e1[s].y * o), i.arc(t + e1[s].x * o, r + e1[s].y * o, 2, 0, n, !1);
                                i.closePath(), i.fill();
                            }
                            e1 = void 0 !== e1 ? e1 : 0, t = void 0 !== t ? t : 0;
                            for(var r = 1 / this.path.unitsPerEm * (r = void 0 !== r ? r : 24), n = [], s = [], a = this.path, l = 0; l < a.commands.length; l += 1){
                                var u = a.commands[l];
                                void 0 !== u.x && n.push({
                                    x: u.x,
                                    y: -u.y
                                }), void 0 !== u.x1 && s.push({
                                    x: u.x1,
                                    y: -u.y1
                                }), void 0 !== u.x2 && s.push({
                                    x: u.x2,
                                    y: -u.y2
                                });
                            }
                            i.fillStyle = "blue", o(n, e1, t, r), i.fillStyle = "red", o(s, e1, t, r);
                        }, h.prototype.drawMetrics = function(e1, t, r, o) {
                            t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 0, o = 1 / this.path.unitsPerEm * (o = void 0 !== o ? o : 24), e1.lineWidth = 1, e1.strokeStyle = "black", d.line(e1, t, -10000, t, 1e4), d.line(e1, -10000, r, 1e4, r);
                            var n = this.xMin || 0, s = this.yMin || 0, i = this.xMax || 0, a = this.yMax || 0, l = this.advanceWidth || 0;
                            e1.strokeStyle = "blue", d.line(e1, t + n * o, -10000, t + n * o, 1e4), d.line(e1, t + i * o, -10000, t + i * o, 1e4), d.line(e1, -10000, r + -s * o, 1e4, r + -s * o), d.line(e1, -10000, r + -a * o, 1e4, r + -a * o), e1.strokeStyle = "green", d.line(e1, t + l * o, -10000, t + l * o, 1e4);
                        }, Pe.prototype.get = function(e1) {
                            return "function" == typeof this.glyphs[e1] && (this.glyphs[e1] = this.glyphs[e1]()), this.glyphs[e1];
                        }, Pe.prototype.push = function(e1, t) {
                            this.glyphs[e1] = t, this.length++;
                        };
                        var p = {
                            GlyphSet: Pe,
                            glyphLoader: function(e1, t) {
                                return new h({
                                    index: t,
                                    font: e1
                                });
                            },
                            ttfGlyphLoader: function(r, e1, o, n, s, i) {
                                return function() {
                                    var t = new h({
                                        index: e1,
                                        font: r
                                    });
                                    return t.path = function() {
                                        o(t, n, s);
                                        var e1 = i(r.glyphs, t);
                                        return e1.unitsPerEm = r.unitsPerEm, e1;
                                    }, Ae(t, "xMin", "_xMin"), Ae(t, "xMax", "_xMax"), Ae(t, "yMin", "_yMin"), Ae(t, "yMax", "_yMax"), t;
                                };
                            },
                            cffGlyphLoader: function(r, e1, o, n) {
                                return function() {
                                    var t = new h({
                                        index: e1,
                                        font: r
                                    });
                                    return t.path = function() {
                                        var e1 = o(r, t, n);
                                        return e1.unitsPerEm = r.unitsPerEm, e1;
                                    }, t;
                                };
                            }
                        };
                        function Le(e1) {
                            e1 = e1.length < 1240 ? 107 : e1.length < 33900 ? 1131 : 32768;
                            return e1;
                        }
                        function y(e1, t, r) {
                            var o, n = [], s = [], i = R.getCard16(e1, t);
                            if (0 !== i) {
                                for(var a = R.getByte(e1, t + 2), l = t + (i + 1) * a + 2, u = t + 3, c = 0; c < i + 1; c += 1)n.push(R.getOffset(e1, u, a)), u += a;
                                o = l + n[i];
                            } else o = t + 2;
                            for(var d = 0; d < n.length - 1; d += 1){
                                var f = R.getBytes(e1, l + n[d], l + n[d + 1]);
                                r && (f = r(f)), s.push(f);
                            }
                            return {
                                objects: s,
                                startOffset: t,
                                endOffset: o
                            };
                        }
                        function Re(e1, t) {
                            if (28 === t) return e1.parseByte() << 8 | e1.parseByte();
                            if (29 === t) return e1.parseByte() << 24 | e1.parseByte() << 16 | e1.parseByte() << 8 | e1.parseByte();
                            if (30 === t) {
                                for(var r = e1, o = "", n = [
                                    "0",
                                    "1",
                                    "2",
                                    "3",
                                    "4",
                                    "5",
                                    "6",
                                    "7",
                                    "8",
                                    "9",
                                    ".",
                                    "E",
                                    "E-",
                                    null,
                                    "-"
                                ];;){
                                    var s = r.parseByte(), i = s >> 4, s = 15 & s;
                                    if (15 == i) break;
                                    if (o += n[i], 15 == s) break;
                                    o += n[s];
                                }
                                return parseFloat(o);
                            }
                            if (32 <= t && t <= 246) return t - 139;
                            if (247 <= t && t <= 250) return 256 * (t - 247) + e1.parseByte() + 108;
                            if (251 <= t && t <= 254) return 256 * -(t - 251) - e1.parseByte() - 108;
                            throw new Error("Invalid b0 " + t);
                        }
                        function Ie(e1, t, r) {
                            var o = new R.Parser(e1, t = void 0 !== t ? t : 0), n = [], s = [];
                            for(r = void 0 !== r ? r : e1.length; o.relativeOffset < r;){
                                var i = o.parseByte();
                                i <= 21 ? (12 === i && (i = 1200 + o.parseByte()), n.push([
                                    i,
                                    s
                                ]), s = []) : s.push(Re(o, i));
                            }
                            for(var a = n, l = {}, u = 0; u < a.length; u += 1){
                                var c = a[u][0], d = a[u][1], f = void 0, f = 1 === d.length ? d[0] : d;
                                if (l.hasOwnProperty(c) && !isNaN(l[c])) throw new Error("Object " + l + " already has key " + c);
                                l[c] = f;
                            }
                            return l;
                        }
                        function De(e1, t) {
                            return t = t <= 390 ? Se[t] : e1[t - 391];
                        }
                        function Fe(e1, t, r) {
                            for(var o, n = {}, s = 0; s < t.length; s += 1){
                                var i = t[s];
                                if (Array.isArray(i.type)) {
                                    var a = [];
                                    a.length = i.type.length;
                                    for(var l = 0; l < i.type.length; l++)void 0 === (o = void 0 !== e1[i.op] ? e1[i.op][l] : void 0) && (o = void 0 !== i.value && void 0 !== i.value[l] ? i.value[l] : null), "SID" === i.type[l] && (o = De(r, o)), a[l] = o;
                                    n[i.name] = a;
                                } else void 0 === (o = e1[i.op]) && (o = void 0 !== i.value ? i.value : null), "SID" === i.type && (o = De(r, o)), n[i.name] = o;
                            }
                            return n;
                        }
                        var Ue = [
                            {
                                name: "version",
                                op: 0,
                                type: "SID"
                            },
                            {
                                name: "notice",
                                op: 1,
                                type: "SID"
                            },
                            {
                                name: "copyright",
                                op: 1200,
                                type: "SID"
                            },
                            {
                                name: "fullName",
                                op: 2,
                                type: "SID"
                            },
                            {
                                name: "familyName",
                                op: 3,
                                type: "SID"
                            },
                            {
                                name: "weight",
                                op: 4,
                                type: "SID"
                            },
                            {
                                name: "isFixedPitch",
                                op: 1201,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "italicAngle",
                                op: 1202,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "underlinePosition",
                                op: 1203,
                                type: "number",
                                value: -100
                            },
                            {
                                name: "underlineThickness",
                                op: 1204,
                                type: "number",
                                value: 50
                            },
                            {
                                name: "paintType",
                                op: 1205,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "charstringType",
                                op: 1206,
                                type: "number",
                                value: 2
                            },
                            {
                                name: "fontMatrix",
                                op: 1207,
                                type: [
                                    "real",
                                    "real",
                                    "real",
                                    "real",
                                    "real",
                                    "real"
                                ],
                                value: [
                                    .001,
                                    0,
                                    0,
                                    .001,
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "uniqueId",
                                op: 13,
                                type: "number"
                            },
                            {
                                name: "fontBBox",
                                op: 5,
                                type: [
                                    "number",
                                    "number",
                                    "number",
                                    "number"
                                ],
                                value: [
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "strokeWidth",
                                op: 1208,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "xuid",
                                op: 14,
                                type: [],
                                value: null
                            },
                            {
                                name: "charset",
                                op: 15,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "encoding",
                                op: 16,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "charStrings",
                                op: 17,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "private",
                                op: 18,
                                type: [
                                    "number",
                                    "offset"
                                ],
                                value: [
                                    0,
                                    0
                                ]
                            },
                            {
                                name: "ros",
                                op: 1230,
                                type: [
                                    "SID",
                                    "SID",
                                    "number"
                                ]
                            },
                            {
                                name: "cidFontVersion",
                                op: 1231,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidFontRevision",
                                op: 1232,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidFontType",
                                op: 1233,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "cidCount",
                                op: 1234,
                                type: "number",
                                value: 8720
                            },
                            {
                                name: "uidBase",
                                op: 1235,
                                type: "number"
                            },
                            {
                                name: "fdArray",
                                op: 1236,
                                type: "offset"
                            },
                            {
                                name: "fdSelect",
                                op: 1237,
                                type: "offset"
                            },
                            {
                                name: "fontName",
                                op: 1238,
                                type: "SID"
                            }
                        ], Ne = [
                            {
                                name: "subrs",
                                op: 19,
                                type: "offset",
                                value: 0
                            },
                            {
                                name: "defaultWidthX",
                                op: 20,
                                type: "number",
                                value: 0
                            },
                            {
                                name: "nominalWidthX",
                                op: 21,
                                type: "number",
                                value: 0
                            }
                        ];
                        function Be(e1, t, r, o) {
                            return Fe(Ie(e1, t, r), Ne, o);
                        }
                        function Ge(e1, t, r, o) {
                            for(var n = [], s = 0; s < r.length; s += 1){
                                var i = new DataView(new Uint8Array(r[s]).buffer), i = (a = o, Fe(Ie(i, 0, i.byteLength), Ue, a)), a = (i._subrs = [], i._subrsBias = 0, i.private[0]), l = i.private[1];
                                0 !== a && 0 !== l && (a = Be(e1, l + t, a, o), i._defaultWidthX = a.defaultWidthX, i._nominalWidthX = a.nominalWidthX, 0 !== a.subrs && (l = y(e1, l + a.subrs + t), i._subrs = l.objects, i._subrsBias = Le(i._subrs)), i._privateDict = a), n.push(i);
                            }
                            return n;
                        }
                        function Ve(y, g, e1) {
                            var v, b, j, _, t, x, w, r, S, E = new f, M = [], T = 0, k = !1, O = !1, C = 0, A = 0, P = (S = (y.isCIDFont ? (t = y.tables.cff.topDict._fdSelect[g.index], t = y.tables.cff.topDict._fdArray[t], x = t._subrs, w = t._subrsBias, r = t._defaultWidthX, t) : (x = y.tables.cff.topDict._subrs, w = y.tables.cff.topDict._subrsBias, r = y.tables.cff.topDict._defaultWidthX, y.tables.cff.topDict))._nominalWidthX, r);
                            function L(e1, t) {
                                O && E.closePath(), E.moveTo(e1, t), O = !0;
                            }
                            function R() {
                                M.length % 2 == 0 || k || (P = M.shift() + S), T += M.length >> 1, M.length = 0, k = !0;
                            }
                            return function e1(t) {
                                for(var r, o, n, s, i, a, l, u, c, d, f, h, p = 0; p < t.length;){
                                    var m = t[p];
                                    switch(p += 1, m){
                                        case 1:
                                        case 3:
                                            R();
                                            break;
                                        case 4:
                                            1 < M.length && !k && (P = M.shift() + S, k = !0), A += M.pop(), L(C, A);
                                            break;
                                        case 5:
                                            for(; 0 < M.length;)C += M.shift(), A += M.shift(), E.lineTo(C, A);
                                            break;
                                        case 6:
                                            for(; 0 < M.length && (C += M.shift(), E.lineTo(C, A), 0 !== M.length);)A += M.shift(), E.lineTo(C, A);
                                            break;
                                        case 7:
                                            for(; 0 < M.length && (A += M.shift(), E.lineTo(C, A), 0 !== M.length);)C += M.shift(), E.lineTo(C, A);
                                            break;
                                        case 8:
                                            for(; 0 < M.length;)v = C + M.shift(), b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), C = j + M.shift(), A = _ + M.shift(), E.curveTo(v, b, j, _, C, A);
                                            break;
                                        case 10:
                                            i = M.pop() + w, (a = x[i]) && e1(a);
                                            break;
                                        case 11:
                                            return;
                                        case 12:
                                            switch(m = t[p], p += 1, m){
                                                case 35:
                                                    v = C + M.shift(), b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), l = j + M.shift(), u = _ + M.shift(), c = l + M.shift(), d = u + M.shift(), f = c + M.shift(), h = d + M.shift(), C = f + M.shift(), A = h + M.shift(), M.shift(), E.curveTo(v, b, j, _, l, u), E.curveTo(c, d, f, h, C, A);
                                                    break;
                                                case 34:
                                                    v = C + M.shift(), b = A, j = v + M.shift(), _ = b + M.shift(), l = j + M.shift(), u = _, c = l + M.shift(), d = _, f = c + M.shift(), h = A, C = f + M.shift(), E.curveTo(v, b, j, _, l, u), E.curveTo(c, d, f, h, C, A);
                                                    break;
                                                case 36:
                                                    v = C + M.shift(), b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), l = j + M.shift(), u = _, c = l + M.shift(), d = _, f = c + M.shift(), h = d + M.shift(), C = f + M.shift(), E.curveTo(v, b, j, _, l, u), E.curveTo(c, d, f, h, C, A);
                                                    break;
                                                case 37:
                                                    v = C + M.shift(), b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), l = j + M.shift(), u = _ + M.shift(), c = l + M.shift(), d = u + M.shift(), f = c + M.shift(), h = d + M.shift(), Math.abs(f - C) > Math.abs(h - A) ? C = f + M.shift() : A = h + M.shift(), E.curveTo(v, b, j, _, l, u), E.curveTo(c, d, f, h, C, A);
                                                    break;
                                                default:
                                                    console.log("Glyph " + g.index + ": unknown operator 1200" + m), M.length = 0;
                                            }
                                            break;
                                        case 14:
                                            0 < M.length && !k && (P = M.shift() + S, k = !0), O && (E.closePath(), O = !1);
                                            break;
                                        case 18:
                                            R();
                                            break;
                                        case 19:
                                        case 20:
                                            R(), p += T + 7 >> 3;
                                            break;
                                        case 21:
                                            2 < M.length && !k && (P = M.shift() + S, k = !0), A += M.pop(), L(C += M.pop(), A);
                                            break;
                                        case 22:
                                            1 < M.length && !k && (P = M.shift() + S, k = !0), L(C += M.pop(), A);
                                            break;
                                        case 23:
                                            R();
                                            break;
                                        case 24:
                                            for(; 2 < M.length;)v = C + M.shift(), b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), C = j + M.shift(), A = _ + M.shift(), E.curveTo(v, b, j, _, C, A);
                                            C += M.shift(), A += M.shift(), E.lineTo(C, A);
                                            break;
                                        case 25:
                                            for(; 6 < M.length;)C += M.shift(), A += M.shift(), E.lineTo(C, A);
                                            v = C + M.shift(), b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), C = j + M.shift(), A = _ + M.shift(), E.curveTo(v, b, j, _, C, A);
                                            break;
                                        case 26:
                                            for(M.length % 2 && (C += M.shift()); 0 < M.length;)v = C, b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), C = j, A = _ + M.shift(), E.curveTo(v, b, j, _, C, A);
                                            break;
                                        case 27:
                                            for(M.length % 2 && (A += M.shift()); 0 < M.length;)v = C + M.shift(), b = A, j = v + M.shift(), _ = b + M.shift(), C = j + M.shift(), A = _, E.curveTo(v, b, j, _, C, A);
                                            break;
                                        case 28:
                                            r = t[p], o = t[p + 1], M.push((r << 24 | o << 16) >> 16), p += 2;
                                            break;
                                        case 29:
                                            i = M.pop() + y.gsubrsBias, (a = y.gsubrs[i]) && e1(a);
                                            break;
                                        case 30:
                                            for(; 0 < M.length && (v = C, b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), C = j + M.shift(), A = _ + (1 === M.length ? M.shift() : 0), E.curveTo(v, b, j, _, C, A), 0 !== M.length);)v = C + M.shift(), b = A, j = v + M.shift(), _ = b + M.shift(), A = _ + M.shift(), C = j + (1 === M.length ? M.shift() : 0), E.curveTo(v, b, j, _, C, A);
                                            break;
                                        case 31:
                                            for(; 0 < M.length && (v = C + M.shift(), b = A, j = v + M.shift(), _ = b + M.shift(), A = _ + M.shift(), C = j + (1 === M.length ? M.shift() : 0), E.curveTo(v, b, j, _, C, A), 0 !== M.length);)v = C, b = A + M.shift(), j = v + M.shift(), _ = b + M.shift(), C = j + M.shift(), A = _ + (1 === M.length ? M.shift() : 0), E.curveTo(v, b, j, _, C, A);
                                            break;
                                        default:
                                            m < 32 ? console.log("Glyph " + g.index + ": unknown operator " + m) : m < 247 ? M.push(m - 139) : m < 251 ? (r = t[p], p += 1, M.push(256 * (m - 247) + r + 108)) : m < 255 ? (r = t[p], p += 1, M.push(256 * -(m - 251) - r - 108)) : (r = t[p], o = t[p + 1], n = t[p + 2], s = t[p + 3], p += 4, M.push((r << 24 | o << 16 | n << 8 | s) / 65536));
                                    }
                                }
                            }(e1), g.advanceWidth = P, E;
                        }
                        function ze(e1, t) {
                            var r, o = Se.indexOf(e1);
                            return 0 <= o && (r = o), 0 <= (o = t.indexOf(e1)) ? r = o + Se.length : (r = Se.length + t.length, t.push(e1)), r;
                        }
                        function He(e1, t, r) {
                            for(var o = {}, n = 0; n < e1.length; n += 1){
                                var s = e1[n], i = t[s.name];
                                void 0 === i || function e1(t, r) {
                                    if (t === r) return 1;
                                    if (Array.isArray(t) && Array.isArray(r) && t.length === r.length) {
                                        for(var o = 0; o < t.length; o += 1)if (!e1(t[o], r[o])) return;
                                        return 1;
                                    }
                                }(i, s.value) || ("SID" === s.type && (i = ze(i, r)), o[s.op] = {
                                    name: s.name,
                                    type: s.type,
                                    value: i
                                });
                            }
                            return o;
                        }
                        function We(e1, t) {
                            var r = new S.Record("Top DICT", [
                                {
                                    name: "dict",
                                    type: "DICT",
                                    value: {}
                                }
                            ]);
                            return r.dict = He(Ue, e1, t), r;
                        }
                        function qe(e1) {
                            var t = new S.Record("Top DICT INDEX", [
                                {
                                    name: "topDicts",
                                    type: "INDEX",
                                    value: []
                                }
                            ]);
                            return t.topDicts = [
                                {
                                    name: "topDict_0",
                                    type: "TABLE",
                                    value: e1
                                }
                            ], t;
                        }
                        function Xe(e1) {
                            for(var t = new S.Record("CharStrings INDEX", [
                                {
                                    name: "charStrings",
                                    type: "INDEX",
                                    value: []
                                }
                            ]), r = 0; r < e1.length; r += 1){
                                var o = e1.get(r), n = function(e1) {
                                    for(var t = [], r = e1.path, o = (t.push({
                                        name: "width",
                                        type: "NUMBER",
                                        value: e1.advanceWidth
                                    }), 0), n = 0, s = 0; s < r.commands.length; s += 1){
                                        var i, a, l, u, c = void 0, d = void 0, f = r.commands[s];
                                        "M" === (f = "Q" === f.type ? {
                                            type: "C",
                                            x: f.x,
                                            y: f.y,
                                            x1: 1 / 3 * o + 2 / 3 * f.x1,
                                            y1: 1 / 3 * n + 2 / 3 * f.y1,
                                            x2: 1 / 3 * f.x + 2 / 3 * f.x1,
                                            y2: 1 / 3 * f.y + 2 / 3 * f.y1
                                        } : f).type ? (c = Math.round(f.x - o), d = Math.round(f.y - n), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rmoveto",
                                            type: "OP",
                                            value: 21
                                        }), o = Math.round(f.x), n = Math.round(f.y)) : "L" === f.type ? (c = Math.round(f.x - o), d = Math.round(f.y - n), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rlineto",
                                            type: "OP",
                                            value: 5
                                        }), o = Math.round(f.x), n = Math.round(f.y)) : "C" === f.type && (i = Math.round(f.x1 - o), a = Math.round(f.y1 - n), l = Math.round(f.x2 - f.x1), u = Math.round(f.y2 - f.y1), c = Math.round(f.x - f.x2), d = Math.round(f.y - f.y2), t.push({
                                            name: "dx1",
                                            type: "NUMBER",
                                            value: i
                                        }), t.push({
                                            name: "dy1",
                                            type: "NUMBER",
                                            value: a
                                        }), t.push({
                                            name: "dx2",
                                            type: "NUMBER",
                                            value: l
                                        }), t.push({
                                            name: "dy2",
                                            type: "NUMBER",
                                            value: u
                                        }), t.push({
                                            name: "dx",
                                            type: "NUMBER",
                                            value: c
                                        }), t.push({
                                            name: "dy",
                                            type: "NUMBER",
                                            value: d
                                        }), t.push({
                                            name: "rrcurveto",
                                            type: "OP",
                                            value: 8
                                        }), o = Math.round(f.x), n = Math.round(f.y));
                                    }
                                    return t.push({
                                        name: "endchar",
                                        type: "OP",
                                        value: 14
                                    }), t;
                                }(o);
                                t.charStrings.push({
                                    name: o.name,
                                    type: "CHARSTRING",
                                    value: n
                                });
                            }
                            return t;
                        }
                        var Ye = {
                            parse: function(e1, t, r) {
                                r.tables.cff = {}, o = e1, n = t, (s = {}).formatMajor = R.getCard8(o, n), s.formatMinor = R.getCard8(o, n + 1), s.size = R.getCard8(o, n + 2), s.offsetSize = R.getCard8(o, n + 3), s.startOffset = n, s.endOffset = n + 4;
                                var o = y(e1, s.endOffset, R.bytesToString), n = y(e1, o.endOffset), s = y(e1, n.endOffset, R.bytesToString), o = y(e1, s.endOffset);
                                if (r.gsubrs = o.objects, r.gsubrsBias = Le(r.gsubrs), 1 !== (o = Ge(e1, t, n.objects, s.objects)).length) throw new Error("CFF table has too many fonts in 'FontSet' - count of fonts NameIndex.length = " + o.length);
                                if (n = o[0], (r.tables.cff.topDict = n)._privateDict && (r.defaultWidthX = n._privateDict.defaultWidthX, r.nominalWidthX = n._privateDict.nominalWidthX), void 0 !== n.ros[0] && void 0 !== n.ros[1] && (r.isCIDFont = !0), r.isCIDFont) {
                                    var o = n.fdArray, i = n.fdSelect;
                                    if (0 === o || 0 === i) throw new Error("Font is marked as a CID font, but FDArray and/or FDSelect information is missing");
                                    o = Ge(e1, t, y(e1, o += t).objects, s.objects);
                                    n._fdArray = o, n._fdSelect = function(e1, t, r, o) {
                                        var n, s = [], i = new R.Parser(e1, t);
                                        if (0 === (e1 = i.parseCard8())) for(var a = 0; a < r; a++){
                                            if (o <= (n = i.parseCard8())) throw new Error("CFF table CID Font FDSelect has bad FD index value " + n + " (FD count " + o + ")");
                                            s.push(n);
                                        }
                                        else {
                                            if (3 !== e1) throw new Error("CFF Table CID Font FDSelect table has unsupported format " + e1);
                                            var l, u = i.parseCard16(), c = i.parseCard16();
                                            if (0 !== c) throw new Error("CFF Table CID Font FDSelect format 3 range has bad initial GID " + c);
                                            for(var d = 0; d < u; d++){
                                                if (n = i.parseCard8(), l = i.parseCard16(), o <= n) throw new Error("CFF table CID Font FDSelect has bad FD index value " + n + " (FD count " + o + ")");
                                                if (r < l) throw new Error("CFF Table CID Font FDSelect format 3 range has bad GID " + l);
                                                for(; c < l; c++)s.push(n);
                                                c = l;
                                            }
                                            if (l !== r) throw new Error("CFF Table CID Font FDSelect format 3 range has bad final GID " + l);
                                        }
                                        return s;
                                    }(e1, i += t, r.numGlyphs, o.length);
                                }
                                var i = t + n.private[1], o = Be(e1, i, n.private[0], s.objects), a = (r.defaultWidthX = o.defaultWidthX, r.nominalWidthX = o.nominalWidthX, 0 !== o.subrs ? (i = y(e1, i + o.subrs), r.subrs = i.objects, r.subrsBias = Le(r.subrs)) : (r.subrs = [], r.subrsBias = 0), y(e1, t + n.charStrings)), o = (r.nGlyphs = a.objects.length, function(e1, t, r, o) {
                                    var n = new R.Parser(e1, t), s = (--r, [
                                        ".notdef"
                                    ]);
                                    if (0 === (e1 = n.parseCard8())) for(var i = 0; i < r; i += 1)a = n.parseSID(), s.push(De(o, a));
                                    else if (1 === e1) for(; s.length <= r;)for(var a = n.parseSID(), l = n.parseCard8(), u = 0; u <= l; u += 1)s.push(De(o, a)), a += 1;
                                    else {
                                        if (2 !== e1) throw new Error("Unknown charset format " + e1);
                                        for(; s.length <= r;){
                                            a = n.parseSID(), l = n.parseCard16();
                                            for(var c = 0; c <= l; c += 1)s.push(De(o, a)), a += 1;
                                        }
                                    }
                                    return s;
                                }(e1, t + n.charset, r.nGlyphs, s.objects));
                                0 === n.encoding ? r.cffEncoding = new Oe(Ee, o) : 1 === n.encoding ? r.cffEncoding = new Oe(Me, o) : r.cffEncoding = function(e1, t, r) {
                                    var o = {}, n = new R.Parser(e1, t);
                                    if (0 === (e1 = n.parseCard8())) for(var s = n.parseCard8(), i = 0; i < s; i += 1)o[l = n.parseCard8()] = i;
                                    else {
                                        if (1 !== e1) throw new Error("Unknown encoding format " + e1);
                                        for(var a = n.parseCard8(), l = 1, u = 0; u < a; u += 1)for(var c = n.parseCard8(), d = n.parseCard8(), f = c; f <= c + d; f += 1)o[f] = l, l += 1;
                                    }
                                    return new Oe(o, r);
                                }(e1, t + n.encoding, o), r.encoding = r.encoding || r.cffEncoding, r.glyphs = new p.GlyphSet(r);
                                for(var l = 0; l < r.nGlyphs; l += 1){
                                    var u = a.objects[l];
                                    r.glyphs.push(l, p.cffGlyphLoader(r, l, Ve, u));
                                }
                            },
                            make: function(e1, t) {
                                for(var r, o = new S.Table("CFF ", [
                                    {
                                        name: "header",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "nameIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "topDictIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "stringIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "globalSubrIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "charsets",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "charStringsIndex",
                                        type: "RECORD"
                                    },
                                    {
                                        name: "privateDict",
                                        type: "RECORD"
                                    }
                                ]), n = 1 / t.unitsPerEm, n = {
                                    version: t.version,
                                    fullName: t.fullName,
                                    familyName: t.familyName,
                                    weight: t.weightName,
                                    fontBBox: t.fontBBox || [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    fontMatrix: [
                                        n,
                                        0,
                                        0,
                                        n,
                                        0,
                                        0
                                    ],
                                    charset: 999,
                                    encoding: 0,
                                    charStrings: 999,
                                    private: [
                                        0,
                                        999
                                    ]
                                }, s = [], i = 1; i < e1.length; i += 1)r = e1.get(i), s.push(r.name);
                                var a, l, u = [], t = (o.header = new S.Record("Header", [
                                    {
                                        name: "major",
                                        type: "Card8",
                                        value: 1
                                    },
                                    {
                                        name: "minor",
                                        type: "Card8",
                                        value: 0
                                    },
                                    {
                                        name: "hdrSize",
                                        type: "Card8",
                                        value: 4
                                    },
                                    {
                                        name: "major",
                                        type: "Card8",
                                        value: 1
                                    }
                                ]), o.nameIndex = function(e1) {
                                    var t = new S.Record("Name INDEX", [
                                        {
                                            name: "names",
                                            type: "INDEX",
                                            value: []
                                        }
                                    ]);
                                    t.names = [];
                                    for(var r = 0; r < e1.length; r += 1)t.names.push({
                                        name: "name_" + r,
                                        type: "NAME",
                                        value: e1[r]
                                    });
                                    return t;
                                }([
                                    t.postScriptName
                                ]), We(n, u)), c = (o.topDictIndex = qe(t), o.globalSubrIndex = new S.Record("Global Subr INDEX", [
                                    {
                                        name: "subrs",
                                        type: "INDEX",
                                        value: []
                                    }
                                ]), o.charsets = function(e1, t) {
                                    for(var r = new S.Record("Charsets", [
                                        {
                                            name: "format",
                                            type: "Card8",
                                            value: 0
                                        }
                                    ]), o = 0; o < e1.length; o += 1){
                                        var n = ze(e1[o], t);
                                        r.fields.push({
                                            name: "glyph_" + o,
                                            type: "SID",
                                            value: n
                                        });
                                    }
                                    return r;
                                }(s, u), o.charStringsIndex = Xe(e1), o.privateDict = (c = {}, a = u, (l = new S.Record("Private DICT", [
                                    {
                                        name: "dict",
                                        type: "DICT",
                                        value: {}
                                    }
                                ])).dict = He(Ne, c, a), l), o.stringIndex = function(e1) {
                                    var t = new S.Record("String INDEX", [
                                        {
                                            name: "strings",
                                            type: "INDEX",
                                            value: []
                                        }
                                    ]);
                                    t.strings = [];
                                    for(var r = 0; r < e1.length; r += 1)t.strings.push({
                                        name: "string_" + r,
                                        type: "STRING",
                                        value: e1[r]
                                    });
                                    return t;
                                }(u), o.header.sizeOf() + o.nameIndex.sizeOf() + o.topDictIndex.sizeOf() + o.stringIndex.sizeOf() + o.globalSubrIndex.sizeOf());
                                return n.charset = c, n.encoding = 0, n.charStrings = n.charset + o.charsets.sizeOf(), n.private[1] = n.charStrings + o.charStringsIndex.sizeOf(), t = We(n, u), o.topDictIndex = qe(t), o;
                            }
                        };
                        var Ze = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.fontRevision = Math.round(1e3 * e1.parseFixed()) / 1e3, r.checkSumAdjustment = e1.parseULong(), r.magicNumber = e1.parseULong(), L.argument(1594834165 === r.magicNumber, "Font header has wrong magic number."), r.flags = e1.parseUShort(), r.unitsPerEm = e1.parseUShort(), r.created = e1.parseLongDateTime(), r.modified = e1.parseLongDateTime(), r.xMin = e1.parseShort(), r.yMin = e1.parseShort(), r.xMax = e1.parseShort(), r.yMax = e1.parseShort(), r.macStyle = e1.parseUShort(), r.lowestRecPPEM = e1.parseUShort(), r.fontDirectionHint = e1.parseShort(), r.indexToLocFormat = e1.parseShort(), r.glyphDataFormat = e1.parseShort(), r;
                            },
                            make: function(e1) {
                                var t = Math.round((new Date).getTime() / 1e3) + 2082844800, r = t;
                                return e1.createdTimestamp && (r = e1.createdTimestamp + 2082844800), new S.Table("head", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "fontRevision",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "checkSumAdjustment",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "magicNumber",
                                        type: "ULONG",
                                        value: 1594834165
                                    },
                                    {
                                        name: "flags",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "unitsPerEm",
                                        type: "USHORT",
                                        value: 1e3
                                    },
                                    {
                                        name: "created",
                                        type: "LONGDATETIME",
                                        value: r
                                    },
                                    {
                                        name: "modified",
                                        type: "LONGDATETIME",
                                        value: t
                                    },
                                    {
                                        name: "xMin",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "yMin",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "xMax",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "yMax",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "macStyle",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "lowestRecPPEM",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "fontDirectionHint",
                                        type: "SHORT",
                                        value: 2
                                    },
                                    {
                                        name: "indexToLocFormat",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "glyphDataFormat",
                                        type: "SHORT",
                                        value: 0
                                    }
                                ], e1);
                            }
                        };
                        var Qe = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.ascender = e1.parseShort(), r.descender = e1.parseShort(), r.lineGap = e1.parseShort(), r.advanceWidthMax = e1.parseUShort(), r.minLeftSideBearing = e1.parseShort(), r.minRightSideBearing = e1.parseShort(), r.xMaxExtent = e1.parseShort(), r.caretSlopeRise = e1.parseShort(), r.caretSlopeRun = e1.parseShort(), r.caretOffset = e1.parseShort(), e1.relativeOffset += 8, r.metricDataFormat = e1.parseShort(), r.numberOfHMetrics = e1.parseUShort(), r;
                            },
                            make: function(e1) {
                                return new S.Table("hhea", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 65536
                                    },
                                    {
                                        name: "ascender",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "descender",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "lineGap",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "advanceWidthMax",
                                        type: "UFWORD",
                                        value: 0
                                    },
                                    {
                                        name: "minLeftSideBearing",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "minRightSideBearing",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "xMaxExtent",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "caretSlopeRise",
                                        type: "SHORT",
                                        value: 1
                                    },
                                    {
                                        name: "caretSlopeRun",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "caretOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved1",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved2",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved3",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "reserved4",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "metricDataFormat",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "numberOfHMetrics",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ], e1);
                            }
                        };
                        var Je = {
                            parse: function(e1, t, r, o, n) {
                                for(var s, i, a = new R.Parser(e1, t), l = 0; l < o; l += 1){
                                    l < r && (s = a.parseUShort(), i = a.parseShort());
                                    var u = n.get(l);
                                    u.advanceWidth = s, u.leftSideBearing = i;
                                }
                            },
                            make: function(e1) {
                                for(var t = new S.Table("hmtx", []), r = 0; r < e1.length; r += 1){
                                    var o = e1.get(r), n = o.advanceWidth || 0, o = o.leftSideBearing || 0;
                                    t.fields.push({
                                        name: "advanceWidth_" + r,
                                        type: "USHORT",
                                        value: n
                                    }), t.fields.push({
                                        name: "leftSideBearing_" + r,
                                        type: "SHORT",
                                        value: o
                                    });
                                }
                                return t;
                            }
                        };
                        var Ke = {
                            make: function(e1) {
                                for(var t = new S.Table("ltag", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 1
                                    },
                                    {
                                        name: "flags",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "numTags",
                                        type: "ULONG",
                                        value: e1.length
                                    }
                                ]), r = "", o = 12 + 4 * e1.length, n = 0; n < e1.length; ++n){
                                    var s = r.indexOf(e1[n]);
                                    s < 0 && (s = r.length, r += e1[n]), t.fields.push({
                                        name: "offset " + n,
                                        type: "USHORT",
                                        value: o + s
                                    }), t.fields.push({
                                        name: "length " + n,
                                        type: "USHORT",
                                        value: e1[n].length
                                    });
                                }
                                return t.fields.push({
                                    name: "stringPool",
                                    type: "CHARARRAY",
                                    value: r
                                }), t;
                            },
                            parse: function(e1, t) {
                                for(var r = new R.Parser(e1, t), o = r.parseULong(), n = (L.argument(1 === o, "Unsupported ltag table version."), r.skip("uLong", 1), r.parseULong()), s = [], i = 0; i < n; i++){
                                    for(var a = "", l = t + r.parseUShort(), u = r.parseUShort(), c = l; c < l + u; ++c)a += String.fromCharCode(e1.getInt8(c));
                                    s.push(a);
                                }
                                return s;
                            }
                        };
                        var $e = {
                            parse: function(e1, t) {
                                var r = {}, e1 = new R.Parser(e1, t);
                                return r.version = e1.parseVersion(), r.numGlyphs = e1.parseUShort(), 1 === r.version && (r.maxPoints = e1.parseUShort(), r.maxContours = e1.parseUShort(), r.maxCompositePoints = e1.parseUShort(), r.maxCompositeContours = e1.parseUShort(), r.maxZones = e1.parseUShort(), r.maxTwilightPoints = e1.parseUShort(), r.maxStorage = e1.parseUShort(), r.maxFunctionDefs = e1.parseUShort(), r.maxInstructionDefs = e1.parseUShort(), r.maxStackElements = e1.parseUShort(), r.maxSizeOfInstructions = e1.parseUShort(), r.maxComponentElements = e1.parseUShort(), r.maxComponentDepth = e1.parseUShort()), r;
                            },
                            make: function(e1) {
                                return new S.Table("maxp", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 20480
                                    },
                                    {
                                        name: "numGlyphs",
                                        type: "USHORT",
                                        value: e1
                                    }
                                ]);
                            }
                        }, et = [
                            "copyright",
                            "fontFamily",
                            "fontSubfamily",
                            "uniqueID",
                            "fullName",
                            "version",
                            "postScriptName",
                            "trademark",
                            "manufacturer",
                            "designer",
                            "description",
                            "manufacturerURL",
                            "designerURL",
                            "license",
                            "licenseURL",
                            "reserved",
                            "preferredFamily",
                            "preferredSubfamily",
                            "compatibleFullName",
                            "sampleText",
                            "postScriptFindFontName",
                            "wwsFamily",
                            "wwsSubfamily"
                        ], tt = {
                            0: "en",
                            1: "fr",
                            2: "de",
                            3: "it",
                            4: "nl",
                            5: "sv",
                            6: "es",
                            7: "da",
                            8: "pt",
                            9: "no",
                            10: "he",
                            11: "ja",
                            12: "ar",
                            13: "fi",
                            14: "el",
                            15: "is",
                            16: "mt",
                            17: "tr",
                            18: "hr",
                            19: "zh-Hant",
                            20: "ur",
                            21: "hi",
                            22: "th",
                            23: "ko",
                            24: "lt",
                            25: "pl",
                            26: "hu",
                            27: "es",
                            28: "lv",
                            29: "se",
                            30: "fo",
                            31: "fa",
                            32: "ru",
                            33: "zh",
                            34: "nl-BE",
                            35: "ga",
                            36: "sq",
                            37: "ro",
                            38: "cz",
                            39: "sk",
                            40: "si",
                            41: "yi",
                            42: "sr",
                            43: "mk",
                            44: "bg",
                            45: "uk",
                            46: "be",
                            47: "uz",
                            48: "kk",
                            49: "az-Cyrl",
                            50: "az-Arab",
                            51: "hy",
                            52: "ka",
                            53: "mo",
                            54: "ky",
                            55: "tg",
                            56: "tk",
                            57: "mn-CN",
                            58: "mn",
                            59: "ps",
                            60: "ks",
                            61: "ku",
                            62: "sd",
                            63: "bo",
                            64: "ne",
                            65: "sa",
                            66: "mr",
                            67: "bn",
                            68: "as",
                            69: "gu",
                            70: "pa",
                            71: "or",
                            72: "ml",
                            73: "kn",
                            74: "ta",
                            75: "te",
                            76: "si",
                            77: "my",
                            78: "km",
                            79: "lo",
                            80: "vi",
                            81: "id",
                            82: "tl",
                            83: "ms",
                            84: "ms-Arab",
                            85: "am",
                            86: "ti",
                            87: "om",
                            88: "so",
                            89: "sw",
                            90: "rw",
                            91: "rn",
                            92: "ny",
                            93: "mg",
                            94: "eo",
                            128: "cy",
                            129: "eu",
                            130: "ca",
                            131: "la",
                            132: "qu",
                            133: "gn",
                            134: "ay",
                            135: "tt",
                            136: "ug",
                            137: "dz",
                            138: "jv",
                            139: "su",
                            140: "gl",
                            141: "af",
                            142: "br",
                            143: "iu",
                            144: "gd",
                            145: "gv",
                            146: "ga",
                            147: "to",
                            148: "el-polyton",
                            149: "kl",
                            150: "az",
                            151: "nn"
                        }, rt = {
                            0: 0,
                            1: 0,
                            2: 0,
                            3: 0,
                            4: 0,
                            5: 0,
                            6: 0,
                            7: 0,
                            8: 0,
                            9: 0,
                            10: 5,
                            11: 1,
                            12: 4,
                            13: 0,
                            14: 6,
                            15: 0,
                            16: 0,
                            17: 0,
                            18: 0,
                            19: 2,
                            20: 4,
                            21: 9,
                            22: 21,
                            23: 3,
                            24: 29,
                            25: 29,
                            26: 29,
                            27: 29,
                            28: 29,
                            29: 0,
                            30: 0,
                            31: 4,
                            32: 7,
                            33: 25,
                            34: 0,
                            35: 0,
                            36: 0,
                            37: 0,
                            38: 29,
                            39: 29,
                            40: 0,
                            41: 5,
                            42: 7,
                            43: 7,
                            44: 7,
                            45: 7,
                            46: 7,
                            47: 7,
                            48: 7,
                            49: 7,
                            50: 4,
                            51: 24,
                            52: 23,
                            53: 7,
                            54: 7,
                            55: 7,
                            56: 7,
                            57: 27,
                            58: 7,
                            59: 4,
                            60: 4,
                            61: 4,
                            62: 4,
                            63: 26,
                            64: 9,
                            65: 9,
                            66: 9,
                            67: 13,
                            68: 13,
                            69: 11,
                            70: 10,
                            71: 12,
                            72: 17,
                            73: 16,
                            74: 14,
                            75: 15,
                            76: 18,
                            77: 19,
                            78: 20,
                            79: 22,
                            80: 30,
                            81: 0,
                            82: 0,
                            83: 0,
                            84: 4,
                            85: 28,
                            86: 28,
                            87: 28,
                            88: 0,
                            89: 0,
                            90: 0,
                            91: 0,
                            92: 0,
                            93: 0,
                            94: 0,
                            128: 0,
                            129: 0,
                            130: 0,
                            131: 0,
                            132: 0,
                            133: 0,
                            134: 0,
                            135: 7,
                            136: 4,
                            137: 26,
                            138: 0,
                            139: 0,
                            140: 0,
                            141: 0,
                            142: 0,
                            143: 28,
                            144: 0,
                            145: 0,
                            146: 0,
                            147: 0,
                            148: 6,
                            149: 0,
                            150: 0,
                            151: 0
                        }, ot = {
                            1078: "af",
                            1052: "sq",
                            1156: "gsw",
                            1118: "am",
                            5121: "ar-DZ",
                            15361: "ar-BH",
                            3073: "ar",
                            2049: "ar-IQ",
                            11265: "ar-JO",
                            13313: "ar-KW",
                            12289: "ar-LB",
                            4097: "ar-LY",
                            6145: "ary",
                            8193: "ar-OM",
                            16385: "ar-QA",
                            1025: "ar-SA",
                            10241: "ar-SY",
                            7169: "aeb",
                            14337: "ar-AE",
                            9217: "ar-YE",
                            1067: "hy",
                            1101: "as",
                            2092: "az-Cyrl",
                            1068: "az",
                            1133: "ba",
                            1069: "eu",
                            1059: "be",
                            2117: "bn",
                            1093: "bn-IN",
                            8218: "bs-Cyrl",
                            5146: "bs",
                            1150: "br",
                            1026: "bg",
                            1027: "ca",
                            3076: "zh-HK",
                            5124: "zh-MO",
                            2052: "zh",
                            4100: "zh-SG",
                            1028: "zh-TW",
                            1155: "co",
                            1050: "hr",
                            4122: "hr-BA",
                            1029: "cs",
                            1030: "da",
                            1164: "prs",
                            1125: "dv",
                            2067: "nl-BE",
                            1043: "nl",
                            3081: "en-AU",
                            10249: "en-BZ",
                            4105: "en-CA",
                            9225: "en-029",
                            16393: "en-IN",
                            6153: "en-IE",
                            8201: "en-JM",
                            17417: "en-MY",
                            5129: "en-NZ",
                            13321: "en-PH",
                            18441: "en-SG",
                            7177: "en-ZA",
                            11273: "en-TT",
                            2057: "en-GB",
                            1033: "en",
                            12297: "en-ZW",
                            1061: "et",
                            1080: "fo",
                            1124: "fil",
                            1035: "fi",
                            2060: "fr-BE",
                            3084: "fr-CA",
                            1036: "fr",
                            5132: "fr-LU",
                            6156: "fr-MC",
                            4108: "fr-CH",
                            1122: "fy",
                            1110: "gl",
                            1079: "ka",
                            3079: "de-AT",
                            1031: "de",
                            5127: "de-LI",
                            4103: "de-LU",
                            2055: "de-CH",
                            1032: "el",
                            1135: "kl",
                            1095: "gu",
                            1128: "ha",
                            1037: "he",
                            1081: "hi",
                            1038: "hu",
                            1039: "is",
                            1136: "ig",
                            1057: "id",
                            1117: "iu",
                            2141: "iu-Latn",
                            2108: "ga",
                            1076: "xh",
                            1077: "zu",
                            1040: "it",
                            2064: "it-CH",
                            1041: "ja",
                            1099: "kn",
                            1087: "kk",
                            1107: "km",
                            1158: "quc",
                            1159: "rw",
                            1089: "sw",
                            1111: "kok",
                            1042: "ko",
                            1088: "ky",
                            1108: "lo",
                            1062: "lv",
                            1063: "lt",
                            2094: "dsb",
                            1134: "lb",
                            1071: "mk",
                            2110: "ms-BN",
                            1086: "ms",
                            1100: "ml",
                            1082: "mt",
                            1153: "mi",
                            1146: "arn",
                            1102: "mr",
                            1148: "moh",
                            1104: "mn",
                            2128: "mn-CN",
                            1121: "ne",
                            1044: "nb",
                            2068: "nn",
                            1154: "oc",
                            1096: "or",
                            1123: "ps",
                            1045: "pl",
                            1046: "pt",
                            2070: "pt-PT",
                            1094: "pa",
                            1131: "qu-BO",
                            2155: "qu-EC",
                            3179: "qu",
                            1048: "ro",
                            1047: "rm",
                            1049: "ru",
                            9275: "smn",
                            4155: "smj-NO",
                            5179: "smj",
                            3131: "se-FI",
                            1083: "se",
                            2107: "se-SE",
                            8251: "sms",
                            6203: "sma-NO",
                            7227: "sms",
                            1103: "sa",
                            7194: "sr-Cyrl-BA",
                            3098: "sr",
                            6170: "sr-Latn-BA",
                            2074: "sr-Latn",
                            1132: "nso",
                            1074: "tn",
                            1115: "si",
                            1051: "sk",
                            1060: "sl",
                            11274: "es-AR",
                            16394: "es-BO",
                            13322: "es-CL",
                            9226: "es-CO",
                            5130: "es-CR",
                            7178: "es-DO",
                            12298: "es-EC",
                            17418: "es-SV",
                            4106: "es-GT",
                            18442: "es-HN",
                            2058: "es-MX",
                            19466: "es-NI",
                            6154: "es-PA",
                            15370: "es-PY",
                            10250: "es-PE",
                            20490: "es-PR",
                            3082: "es",
                            1034: "es",
                            21514: "es-US",
                            14346: "es-UY",
                            8202: "es-VE",
                            2077: "sv-FI",
                            1053: "sv",
                            1114: "syr",
                            1064: "tg",
                            2143: "tzm",
                            1097: "ta",
                            1092: "tt",
                            1098: "te",
                            1054: "th",
                            1105: "bo",
                            1055: "tr",
                            1090: "tk",
                            1152: "ug",
                            1058: "uk",
                            1070: "hsb",
                            1056: "ur",
                            2115: "uz-Cyrl",
                            1091: "uz",
                            1066: "vi",
                            1106: "cy",
                            1160: "wo",
                            1157: "sah",
                            1144: "ii",
                            1130: "yo"
                        };
                        var nt = "utf-16", st = {
                            0: "macintosh",
                            1: "x-mac-japanese",
                            2: "x-mac-chinesetrad",
                            3: "x-mac-korean",
                            6: "x-mac-greek",
                            7: "x-mac-cyrillic",
                            9: "x-mac-devanagai",
                            10: "x-mac-gurmukhi",
                            11: "x-mac-gujarati",
                            12: "x-mac-oriya",
                            13: "x-mac-bengali",
                            14: "x-mac-tamil",
                            15: "x-mac-telugu",
                            16: "x-mac-kannada",
                            17: "x-mac-malayalam",
                            18: "x-mac-sinhalese",
                            19: "x-mac-burmese",
                            20: "x-mac-khmer",
                            21: "x-mac-thai",
                            22: "x-mac-lao",
                            23: "x-mac-georgian",
                            24: "x-mac-armenian",
                            25: "x-mac-chinesesimp",
                            26: "x-mac-tibetan",
                            27: "x-mac-mongolian",
                            28: "x-mac-ethiopic",
                            29: "x-mac-ce",
                            30: "x-mac-vietnamese",
                            31: "x-mac-extarabic"
                        }, it = {
                            15: "x-mac-icelandic",
                            17: "x-mac-turkish",
                            18: "x-mac-croatian",
                            24: "x-mac-ce",
                            25: "x-mac-ce",
                            26: "x-mac-ce",
                            27: "x-mac-ce",
                            28: "x-mac-ce",
                            30: "x-mac-icelandic",
                            37: "x-mac-romanian",
                            38: "x-mac-ce",
                            39: "x-mac-ce",
                            40: "x-mac-ce",
                            143: "x-mac-inuit",
                            146: "x-mac-gaelic"
                        };
                        function at(e1, t, r) {
                            switch(e1){
                                case 0:
                                    return nt;
                                case 1:
                                    return it[r] || st[t];
                                case 3:
                                    if (1 === t || 10 === t) return nt;
                            }
                        }
                        function lt(e1) {
                            var t, r = {};
                            for(t in e1)r[e1[t]] = parseInt(t);
                            return r;
                        }
                        function ut(e1, t, r, o, n, s) {
                            return new S.Record("NameRecord", [
                                {
                                    name: "platformID",
                                    type: "USHORT",
                                    value: e1
                                },
                                {
                                    name: "encodingID",
                                    type: "USHORT",
                                    value: t
                                },
                                {
                                    name: "languageID",
                                    type: "USHORT",
                                    value: r
                                },
                                {
                                    name: "nameID",
                                    type: "USHORT",
                                    value: o
                                },
                                {
                                    name: "length",
                                    type: "USHORT",
                                    value: n
                                },
                                {
                                    name: "offset",
                                    type: "USHORT",
                                    value: s
                                }
                            ]);
                        }
                        function ct(e1, t) {
                            if ((r = function(e1, t) {
                                var r = e1.length, o = t.length - r + 1;
                                e: for(var n = 0; n < o; n++)for(; n < o; n++){
                                    for(var s = 0; s < r; s++)if (t[n + s] !== e1[s]) continue e;
                                    return n;
                                }
                                return -1;
                            }(e1, t)) < 0) for(var r = t.length, o = 0, n = e1.length; o < n; ++o)t.push(e1[o]);
                            return r;
                        }
                        var dt = {
                            parse: function(e1, t, r) {
                                for(var o = {}, n = new R.Parser(e1, t), t = n.parseUShort(), s = n.parseUShort(), i = n.offset + n.parseUShort(), a = 0; a < s; a++){
                                    var l = n.parseUShort(), u = n.parseUShort(), c = n.parseUShort(), d = n.parseUShort(), d = et[d] || d, f = n.parseUShort(), h = n.parseUShort(), p = function(e1, t, r) {
                                        switch(e1){
                                            case 0:
                                                if (65535 === t) return "und";
                                                if (r) return r[t];
                                                break;
                                            case 1:
                                                return tt[t];
                                            case 3:
                                                return ot[t];
                                        }
                                    }(l, c, r), l = at(l, u, c);
                                    void 0 !== l && void 0 !== p && (u = void 0, (u = l === nt ? m.UTF16(e1, i + h, f) : m.MACSTRING(e1, i + h, f, l)) && ((c = void 0 === (c = o[d]) ? o[d] = {} : c)[p] = u));
                                }
                                return 1 === t && n.parseUShort(), o;
                            },
                            make: function(e1, t) {
                                var r, o = [], n = {}, s = lt(et);
                                for(r in e1){
                                    var i = s[r];
                                    if (void 0 === i && (i = r), f = parseInt(i), isNaN(f)) throw new Error('Name table entry "' + r + '" does not exist, see nameTableNames for complete list.');
                                    n[f] = e1[r], o.push(f);
                                }
                                for(var a = lt(tt), l = lt(ot), u = [], c = [], d = 0; d < o.length; d++){
                                    var f, h, p = n[f = o[d]];
                                    for(h in p){
                                        var m = p[h], y = 1, g = a[h], v = rt[g], b = at(y, v, g), b = w.MACSTRING(m, b), j = (void 0 === b && (y = 0, (g = t.indexOf(h)) < 0 && (g = t.length, t.push(h)), v = 4, b = w.UTF16(m)), ct(b, c)), y = (u.push(ut(y, v, g, f, b.length, j)), l[h]);
                                        void 0 !== y && (g = ct(v = w.UTF16(m), c), u.push(ut(3, 1, y, f, v.length, g)));
                                    }
                                }
                                u.sort(function(e1, t) {
                                    return e1.platformID - t.platformID || e1.encodingID - t.encodingID || e1.languageID - t.languageID || e1.nameID - t.nameID;
                                });
                                for(var _ = new S.Table("name", [
                                    {
                                        name: "format",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "count",
                                        type: "USHORT",
                                        value: u.length
                                    },
                                    {
                                        name: "stringOffset",
                                        type: "USHORT",
                                        value: 6 + 12 * u.length
                                    }
                                ]), x = 0; x < u.length; x++)_.fields.push({
                                    name: "record_" + x,
                                    type: "RECORD",
                                    value: u[x]
                                });
                                return _.fields.push({
                                    name: "strings",
                                    type: "LITERAL",
                                    value: c
                                }), _;
                            }
                        }, ft = [
                            {
                                begin: 0,
                                end: 127
                            },
                            {
                                begin: 128,
                                end: 255
                            },
                            {
                                begin: 256,
                                end: 383
                            },
                            {
                                begin: 384,
                                end: 591
                            },
                            {
                                begin: 592,
                                end: 687
                            },
                            {
                                begin: 688,
                                end: 767
                            },
                            {
                                begin: 768,
                                end: 879
                            },
                            {
                                begin: 880,
                                end: 1023
                            },
                            {
                                begin: 11392,
                                end: 11519
                            },
                            {
                                begin: 1024,
                                end: 1279
                            },
                            {
                                begin: 1328,
                                end: 1423
                            },
                            {
                                begin: 1424,
                                end: 1535
                            },
                            {
                                begin: 42240,
                                end: 42559
                            },
                            {
                                begin: 1536,
                                end: 1791
                            },
                            {
                                begin: 1984,
                                end: 2047
                            },
                            {
                                begin: 2304,
                                end: 2431
                            },
                            {
                                begin: 2432,
                                end: 2559
                            },
                            {
                                begin: 2560,
                                end: 2687
                            },
                            {
                                begin: 2688,
                                end: 2815
                            },
                            {
                                begin: 2816,
                                end: 2943
                            },
                            {
                                begin: 2944,
                                end: 3071
                            },
                            {
                                begin: 3072,
                                end: 3199
                            },
                            {
                                begin: 3200,
                                end: 3327
                            },
                            {
                                begin: 3328,
                                end: 3455
                            },
                            {
                                begin: 3584,
                                end: 3711
                            },
                            {
                                begin: 3712,
                                end: 3839
                            },
                            {
                                begin: 4256,
                                end: 4351
                            },
                            {
                                begin: 6912,
                                end: 7039
                            },
                            {
                                begin: 4352,
                                end: 4607
                            },
                            {
                                begin: 7680,
                                end: 7935
                            },
                            {
                                begin: 7936,
                                end: 8191
                            },
                            {
                                begin: 8192,
                                end: 8303
                            },
                            {
                                begin: 8304,
                                end: 8351
                            },
                            {
                                begin: 8352,
                                end: 8399
                            },
                            {
                                begin: 8400,
                                end: 8447
                            },
                            {
                                begin: 8448,
                                end: 8527
                            },
                            {
                                begin: 8528,
                                end: 8591
                            },
                            {
                                begin: 8592,
                                end: 8703
                            },
                            {
                                begin: 8704,
                                end: 8959
                            },
                            {
                                begin: 8960,
                                end: 9215
                            },
                            {
                                begin: 9216,
                                end: 9279
                            },
                            {
                                begin: 9280,
                                end: 9311
                            },
                            {
                                begin: 9312,
                                end: 9471
                            },
                            {
                                begin: 9472,
                                end: 9599
                            },
                            {
                                begin: 9600,
                                end: 9631
                            },
                            {
                                begin: 9632,
                                end: 9727
                            },
                            {
                                begin: 9728,
                                end: 9983
                            },
                            {
                                begin: 9984,
                                end: 10175
                            },
                            {
                                begin: 12288,
                                end: 12351
                            },
                            {
                                begin: 12352,
                                end: 12447
                            },
                            {
                                begin: 12448,
                                end: 12543
                            },
                            {
                                begin: 12544,
                                end: 12591
                            },
                            {
                                begin: 12592,
                                end: 12687
                            },
                            {
                                begin: 43072,
                                end: 43135
                            },
                            {
                                begin: 12800,
                                end: 13055
                            },
                            {
                                begin: 13056,
                                end: 13311
                            },
                            {
                                begin: 44032,
                                end: 55215
                            },
                            {
                                begin: 55296,
                                end: 57343
                            },
                            {
                                begin: 67840,
                                end: 67871
                            },
                            {
                                begin: 19968,
                                end: 40959
                            },
                            {
                                begin: 57344,
                                end: 63743
                            },
                            {
                                begin: 12736,
                                end: 12783
                            },
                            {
                                begin: 64256,
                                end: 64335
                            },
                            {
                                begin: 64336,
                                end: 65023
                            },
                            {
                                begin: 65056,
                                end: 65071
                            },
                            {
                                begin: 65040,
                                end: 65055
                            },
                            {
                                begin: 65104,
                                end: 65135
                            },
                            {
                                begin: 65136,
                                end: 65279
                            },
                            {
                                begin: 65280,
                                end: 65519
                            },
                            {
                                begin: 65520,
                                end: 65535
                            },
                            {
                                begin: 3840,
                                end: 4095
                            },
                            {
                                begin: 1792,
                                end: 1871
                            },
                            {
                                begin: 1920,
                                end: 1983
                            },
                            {
                                begin: 3456,
                                end: 3583
                            },
                            {
                                begin: 4096,
                                end: 4255
                            },
                            {
                                begin: 4608,
                                end: 4991
                            },
                            {
                                begin: 5024,
                                end: 5119
                            },
                            {
                                begin: 5120,
                                end: 5759
                            },
                            {
                                begin: 5760,
                                end: 5791
                            },
                            {
                                begin: 5792,
                                end: 5887
                            },
                            {
                                begin: 6016,
                                end: 6143
                            },
                            {
                                begin: 6144,
                                end: 6319
                            },
                            {
                                begin: 10240,
                                end: 10495
                            },
                            {
                                begin: 40960,
                                end: 42127
                            },
                            {
                                begin: 5888,
                                end: 5919
                            },
                            {
                                begin: 66304,
                                end: 66351
                            },
                            {
                                begin: 66352,
                                end: 66383
                            },
                            {
                                begin: 66560,
                                end: 66639
                            },
                            {
                                begin: 118784,
                                end: 119039
                            },
                            {
                                begin: 119808,
                                end: 120831
                            },
                            {
                                begin: 1044480,
                                end: 1048573
                            },
                            {
                                begin: 65024,
                                end: 65039
                            },
                            {
                                begin: 917504,
                                end: 917631
                            },
                            {
                                begin: 6400,
                                end: 6479
                            },
                            {
                                begin: 6480,
                                end: 6527
                            },
                            {
                                begin: 6528,
                                end: 6623
                            },
                            {
                                begin: 6656,
                                end: 6687
                            },
                            {
                                begin: 11264,
                                end: 11359
                            },
                            {
                                begin: 11568,
                                end: 11647
                            },
                            {
                                begin: 19904,
                                end: 19967
                            },
                            {
                                begin: 43008,
                                end: 43055
                            },
                            {
                                begin: 65536,
                                end: 65663
                            },
                            {
                                begin: 65856,
                                end: 65935
                            },
                            {
                                begin: 66432,
                                end: 66463
                            },
                            {
                                begin: 66464,
                                end: 66527
                            },
                            {
                                begin: 66640,
                                end: 66687
                            },
                            {
                                begin: 66688,
                                end: 66735
                            },
                            {
                                begin: 67584,
                                end: 67647
                            },
                            {
                                begin: 68096,
                                end: 68191
                            },
                            {
                                begin: 119552,
                                end: 119647
                            },
                            {
                                begin: 73728,
                                end: 74751
                            },
                            {
                                begin: 119648,
                                end: 119679
                            },
                            {
                                begin: 7040,
                                end: 7103
                            },
                            {
                                begin: 7168,
                                end: 7247
                            },
                            {
                                begin: 7248,
                                end: 7295
                            },
                            {
                                begin: 43136,
                                end: 43231
                            },
                            {
                                begin: 43264,
                                end: 43311
                            },
                            {
                                begin: 43312,
                                end: 43359
                            },
                            {
                                begin: 43520,
                                end: 43615
                            },
                            {
                                begin: 65936,
                                end: 65999
                            },
                            {
                                begin: 66e3,
                                end: 66047
                            },
                            {
                                begin: 66208,
                                end: 66271
                            },
                            {
                                begin: 127024,
                                end: 127135
                            }
                        ];
                        var ht = {
                            parse: function(e1, t) {
                                var r = {}, o = new R.Parser(e1, t);
                                r.version = o.parseUShort(), r.xAvgCharWidth = o.parseShort(), r.usWeightClass = o.parseUShort(), r.usWidthClass = o.parseUShort(), r.fsType = o.parseUShort(), r.ySubscriptXSize = o.parseShort(), r.ySubscriptYSize = o.parseShort(), r.ySubscriptXOffset = o.parseShort(), r.ySubscriptYOffset = o.parseShort(), r.ySuperscriptXSize = o.parseShort(), r.ySuperscriptYSize = o.parseShort(), r.ySuperscriptXOffset = o.parseShort(), r.ySuperscriptYOffset = o.parseShort(), r.yStrikeoutSize = o.parseShort(), r.yStrikeoutPosition = o.parseShort(), r.sFamilyClass = o.parseShort(), r.panose = [];
                                for(var n = 0; n < 10; n++)r.panose[n] = o.parseByte();
                                return r.ulUnicodeRange1 = o.parseULong(), r.ulUnicodeRange2 = o.parseULong(), r.ulUnicodeRange3 = o.parseULong(), r.ulUnicodeRange4 = o.parseULong(), r.achVendID = String.fromCharCode(o.parseByte(), o.parseByte(), o.parseByte(), o.parseByte()), r.fsSelection = o.parseUShort(), r.usFirstCharIndex = o.parseUShort(), r.usLastCharIndex = o.parseUShort(), r.sTypoAscender = o.parseShort(), r.sTypoDescender = o.parseShort(), r.sTypoLineGap = o.parseShort(), r.usWinAscent = o.parseUShort(), r.usWinDescent = o.parseUShort(), 1 <= r.version && (r.ulCodePageRange1 = o.parseULong(), r.ulCodePageRange2 = o.parseULong()), 2 <= r.version && (r.sxHeight = o.parseShort(), r.sCapHeight = o.parseShort(), r.usDefaultChar = o.parseUShort(), r.usBreakChar = o.parseUShort(), r.usMaxContent = o.parseUShort()), r;
                            },
                            make: function(e1) {
                                return new S.Table("OS/2", [
                                    {
                                        name: "version",
                                        type: "USHORT",
                                        value: 3
                                    },
                                    {
                                        name: "xAvgCharWidth",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWeightClass",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWidthClass",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "fsType",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySubscriptXSize",
                                        type: "SHORT",
                                        value: 650
                                    },
                                    {
                                        name: "ySubscriptYSize",
                                        type: "SHORT",
                                        value: 699
                                    },
                                    {
                                        name: "ySubscriptXOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySubscriptYOffset",
                                        type: "SHORT",
                                        value: 140
                                    },
                                    {
                                        name: "ySuperscriptXSize",
                                        type: "SHORT",
                                        value: 650
                                    },
                                    {
                                        name: "ySuperscriptYSize",
                                        type: "SHORT",
                                        value: 699
                                    },
                                    {
                                        name: "ySuperscriptXOffset",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ySuperscriptYOffset",
                                        type: "SHORT",
                                        value: 479
                                    },
                                    {
                                        name: "yStrikeoutSize",
                                        type: "SHORT",
                                        value: 49
                                    },
                                    {
                                        name: "yStrikeoutPosition",
                                        type: "SHORT",
                                        value: 258
                                    },
                                    {
                                        name: "sFamilyClass",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "bFamilyType",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bSerifStyle",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bWeight",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bProportion",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bContrast",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bStrokeVariation",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bArmStyle",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bLetterform",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bMidline",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "bXHeight",
                                        type: "BYTE",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange2",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange3",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulUnicodeRange4",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "achVendID",
                                        type: "CHARARRAY",
                                        value: "XXXX"
                                    },
                                    {
                                        name: "fsSelection",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usFirstCharIndex",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usLastCharIndex",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoAscender",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoDescender",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sTypoLineGap",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWinAscent",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usWinDescent",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "ulCodePageRange1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "ulCodePageRange2",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "sxHeight",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "sCapHeight",
                                        type: "SHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usDefaultChar",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usBreakChar",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "usMaxContext",
                                        type: "USHORT",
                                        value: 0
                                    }
                                ], e1);
                            },
                            unicodeRanges: ft,
                            getUnicodeRange: function(e1) {
                                for(var t = 0; t < ft.length; t += 1){
                                    var r = ft[t];
                                    if (e1 >= r.begin && e1 < r.end) return t;
                                }
                                return -1;
                            }
                        };
                        var pt = {
                            parse: function(e1, t) {
                                var r = {}, o = new R.Parser(e1, t);
                                switch(r.version = o.parseVersion(), r.italicAngle = o.parseFixed(), r.underlinePosition = o.parseShort(), r.underlineThickness = o.parseShort(), r.isFixedPitch = o.parseULong(), r.minMemType42 = o.parseULong(), r.maxMemType42 = o.parseULong(), r.minMemType1 = o.parseULong(), r.maxMemType1 = o.parseULong(), r.version){
                                    case 1:
                                        r.names = c.slice();
                                        break;
                                    case 2:
                                        r.numberOfGlyphs = o.parseUShort(), r.glyphNameIndex = new Array(r.numberOfGlyphs);
                                        for(var n = 0; n < r.numberOfGlyphs; n++)r.glyphNameIndex[n] = o.parseUShort();
                                        r.names = [];
                                        for(var s, i = 0; i < r.numberOfGlyphs; i++)r.glyphNameIndex[i] >= c.length && (s = o.parseChar(), r.names.push(o.parseString(s)));
                                        break;
                                    case 2.5:
                                        r.numberOfGlyphs = o.parseUShort(), r.offset = new Array(r.numberOfGlyphs);
                                        for(var a = 0; a < r.numberOfGlyphs; a++)r.offset[a] = o.parseChar();
                                }
                                return r;
                            },
                            make: function() {
                                return new S.Table("post", [
                                    {
                                        name: "version",
                                        type: "FIXED",
                                        value: 196608
                                    },
                                    {
                                        name: "italicAngle",
                                        type: "FIXED",
                                        value: 0
                                    },
                                    {
                                        name: "underlinePosition",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "underlineThickness",
                                        type: "FWORD",
                                        value: 0
                                    },
                                    {
                                        name: "isFixedPitch",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "minMemType42",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "maxMemType42",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "minMemType1",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "maxMemType1",
                                        type: "ULONG",
                                        value: 0
                                    }
                                ]);
                            }
                        }, o = new Array(9), s = (o[1] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                substFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                deltaGlyphId: this.parseUShort()
                            } : 2 === t ? {
                                substFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                substitute: this.parseOffset16List()
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": lookup type 1 format must be 1 or 2.");
                        }, o[2] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Multiple Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                sequences: this.parseListOfLists()
                            };
                        }, o[3] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Alternate Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                alternateSets: this.parseListOfLists()
                            };
                        }, o[4] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB ligature table identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                ligatureSets: this.parseListOfLists(function() {
                                    return {
                                        ligGlyph: this.parseUShort(),
                                        components: this.parseUShortList(this.parseUShort() - 1)
                                    };
                                })
                            };
                        }, {
                            sequenceIndex: u.uShort,
                            lookupListIndex: u.uShort
                        });
                        o[5] = function() {
                            var e1, t, r = this.offset + this.relativeOffset, o = this.parseUShort();
                            return 1 === o ? {
                                substFormat: o,
                                coverage: this.parsePointer(u.coverage),
                                ruleSets: this.parseListOfLists(function() {
                                    var e1 = this.parseUShort(), t = this.parseUShort();
                                    return {
                                        input: this.parseUShortList(e1 - 1),
                                        lookupRecords: this.parseRecordList(t, s)
                                    };
                                })
                            } : 2 === o ? {
                                substFormat: o,
                                coverage: this.parsePointer(u.coverage),
                                classDef: this.parsePointer(u.classDef),
                                classSets: this.parseListOfLists(function() {
                                    var e1 = this.parseUShort(), t = this.parseUShort();
                                    return {
                                        classes: this.parseUShortList(e1 - 1),
                                        lookupRecords: this.parseRecordList(t, s)
                                    };
                                })
                            } : 3 === o ? (e1 = this.parseUShort(), t = this.parseUShort(), {
                                substFormat: o,
                                coverages: this.parseList(e1, u.pointer(u.coverage)),
                                lookupRecords: this.parseRecordList(t, s)
                            }) : void L.assert(!1, "0x" + r.toString(16) + ": lookup type 5 format must be 1, 2 or 3.");
                        }, o[6] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                substFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                chainRuleSets: this.parseListOfLists(function() {
                                    return {
                                        backtrack: this.parseUShortList(),
                                        input: this.parseUShortList(this.parseShort() - 1),
                                        lookahead: this.parseUShortList(),
                                        lookupRecords: this.parseRecordList(s)
                                    };
                                })
                            } : 2 === t ? {
                                substFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                backtrackClassDef: this.parsePointer(u.classDef),
                                inputClassDef: this.parsePointer(u.classDef),
                                lookaheadClassDef: this.parsePointer(u.classDef),
                                chainClassSet: this.parseListOfLists(function() {
                                    return {
                                        backtrack: this.parseUShortList(),
                                        input: this.parseUShortList(this.parseShort() - 1),
                                        lookahead: this.parseUShortList(),
                                        lookupRecords: this.parseRecordList(s)
                                    };
                                })
                            } : 3 === t ? {
                                substFormat: 3,
                                backtrackCoverage: this.parseList(u.pointer(u.coverage)),
                                inputCoverage: this.parseList(u.pointer(u.coverage)),
                                lookaheadCoverage: this.parseList(u.pointer(u.coverage)),
                                lookupRecords: this.parseRecordList(s)
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": lookup type 6 format must be 1, 2 or 3.");
                        }, o[7] = function() {
                            var e1 = this.parseUShort(), e1 = (L.argument(1 === e1, "GSUB Extension Substitution subtable identifier-format must be 1"), this.parseUShort()), t = new u(this.data, this.offset + this.parseULong());
                            return {
                                substFormat: 1,
                                lookupType: e1,
                                extension: o[e1].call(t)
                            };
                        }, o[8] = function() {
                            var e1 = this.parseUShort();
                            return L.argument(1 === e1, "GSUB Reverse Chaining Contextual Single Substitution Subtable identifier-format must be 1"), {
                                substFormat: e1,
                                coverage: this.parsePointer(u.coverage),
                                backtrackCoverage: this.parseList(u.pointer(u.coverage)),
                                lookaheadCoverage: this.parseList(u.pointer(u.coverage)),
                                substitutes: this.parseUShortList()
                            };
                        };
                        var mt = new Array(9);
                        mt[1] = function(e1) {
                            return 1 === e1.substFormat ? new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                },
                                {
                                    name: "deltaGlyphID",
                                    type: "USHORT",
                                    value: e1.deltaGlyphId
                                }
                            ]) : new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 2
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.ushortList("substitute", e1.substitute)));
                        }, mt[3] = function(e1) {
                            return L.assert(1 === e1.substFormat, "Lookup type 3 substFormat must be 1."), new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.tableList("altSet", e1.alternateSets, function(e1) {
                                return new S.Table("alternateSetTable", S.ushortList("alternate", e1));
                            })));
                        }, mt[4] = function(e1) {
                            return L.assert(1 === e1.substFormat, "Lookup type 4 substFormat must be 1."), new S.Table("substitutionTable", [
                                {
                                    name: "substFormat",
                                    type: "USHORT",
                                    value: 1
                                },
                                {
                                    name: "coverage",
                                    type: "TABLE",
                                    value: new S.Coverage(e1.coverage)
                                }
                            ].concat(S.tableList("ligSet", e1.ligatureSets, function(e1) {
                                return new S.Table("ligatureSetTable", S.tableList("ligature", e1, function(e1) {
                                    return new S.Table("ligatureTable", [
                                        {
                                            name: "ligGlyph",
                                            type: "USHORT",
                                            value: e1.ligGlyph
                                        }
                                    ].concat(S.ushortList("component", e1.components, e1.components.length + 1)));
                                }));
                            })));
                        };
                        var yt = {
                            parse: function(e1, t) {
                                return t = (e1 = new u(e1, t = t || 0)).parseVersion(1), L.argument(1 === t || 1.1 === t, "Unsupported GSUB table version."), 1 === t ? {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(o)
                                } : {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(o),
                                    variations: e1.parseFeatureVariationsList()
                                };
                            },
                            make: function(e1) {
                                return new S.Table("GSUB", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "scripts",
                                        type: "TABLE",
                                        value: new S.ScriptList(e1.scripts)
                                    },
                                    {
                                        name: "features",
                                        type: "TABLE",
                                        value: new S.FeatureList(e1.features)
                                    },
                                    {
                                        name: "lookups",
                                        type: "TABLE",
                                        value: new S.LookupList(e1.lookups, mt)
                                    }
                                ]);
                            }
                        };
                        var gt = {
                            parse: function(e1, t) {
                                for(var r = new R.Parser(e1, t), o = r.parseULong(), n = (L.argument(1 === o, "Unsupported META table version."), r.parseULong(), r.parseULong(), r.parseULong()), s = {}, i = 0; i < n; i++){
                                    var a = r.parseTag(), l = r.parseULong(), u = r.parseULong(), l = m.UTF8(e1, t + l, u);
                                    s[a] = l;
                                }
                                return s;
                            },
                            make: function(e1) {
                                var t, r = Object.keys(e1).length, o = "", n = 16 + 12 * r, s = new S.Table("meta", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 1
                                    },
                                    {
                                        name: "flags",
                                        type: "ULONG",
                                        value: 0
                                    },
                                    {
                                        name: "offset",
                                        type: "ULONG",
                                        value: n
                                    },
                                    {
                                        name: "numTags",
                                        type: "ULONG",
                                        value: r
                                    }
                                ]);
                                for(t in e1){
                                    var i = o.length;
                                    o += e1[t], s.fields.push({
                                        name: "tag " + t,
                                        type: "TAG",
                                        value: t
                                    }), s.fields.push({
                                        name: "offset " + t,
                                        type: "ULONG",
                                        value: n + i
                                    }), s.fields.push({
                                        name: "length " + t,
                                        type: "ULONG",
                                        value: e1[t].length
                                    });
                                }
                                return s.fields.push({
                                    name: "stringPool",
                                    type: "CHARARRAY",
                                    value: o
                                }), s;
                            }
                        };
                        function vt(e1) {
                            return Math.log(e1) / Math.log(2) | 0;
                        }
                        function bt(e1) {
                            for(; e1.length % 4 != 0;)e1.push(0);
                            for(var t = 0, r = 0; r < e1.length; r += 4)t += (e1[r] << 24) + (e1[r + 1] << 16) + (e1[r + 2] << 8) + e1[r + 3];
                            return t %= Math.pow(2, 32);
                        }
                        function jt(e1, t, r, o) {
                            return new S.Record("Table Record", [
                                {
                                    name: "tag",
                                    type: "TAG",
                                    value: void 0 !== e1 ? e1 : ""
                                },
                                {
                                    name: "checkSum",
                                    type: "ULONG",
                                    value: void 0 !== t ? t : 0
                                },
                                {
                                    name: "offset",
                                    type: "ULONG",
                                    value: void 0 !== r ? r : 0
                                },
                                {
                                    name: "length",
                                    type: "ULONG",
                                    value: void 0 !== o ? o : 0
                                }
                            ]);
                        }
                        function _t(e1) {
                            for(var t = new S.Table("sfnt", [
                                {
                                    name: "version",
                                    type: "TAG",
                                    value: "OTTO"
                                },
                                {
                                    name: "numTables",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "searchRange",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "entrySelector",
                                    type: "USHORT",
                                    value: 0
                                },
                                {
                                    name: "rangeShift",
                                    type: "USHORT",
                                    value: 0
                                }
                            ]), r = (t.tables = e1, t.numTables = e1.length, Math.pow(2, vt(t.numTables))), o = (t.searchRange = 16 * r, t.entrySelector = vt(r), t.rangeShift = 16 * t.numTables - t.searchRange, []), n = [], s = t.sizeOf() + jt().sizeOf() * t.numTables; s % 4 != 0;)s += 1, n.push({
                                name: "padding",
                                type: "BYTE",
                                value: 0
                            });
                            for(var i = 0; i < e1.length; i += 1){
                                var a = e1[i], l = (L.argument(4 === a.tableName.length, "Table name" + a.tableName + " is invalid."), a.sizeOf()), u = jt(a.tableName, bt(a.encode()), s, l);
                                for(o.push({
                                    name: u.tag + " Table Record",
                                    type: "RECORD",
                                    value: u
                                }), n.push({
                                    name: a.tableName + " table",
                                    type: "RECORD",
                                    value: a
                                }), s += l, L.argument(!isNaN(s), "Something went wrong calculating the offset."); s % 4 != 0;)s += 1, n.push({
                                    name: "padding",
                                    type: "BYTE",
                                    value: 0
                                });
                            }
                            return o.sort(function(e1, t) {
                                return e1.value.tag > t.value.tag ? 1 : -1;
                            }), t.fields = t.fields.concat(o), t.fields = t.fields.concat(n), t;
                        }
                        function xt(e1, t, r) {
                            for(var o = 0; o < t.length; o += 1){
                                var n = e1.charToGlyphIndex(t[o]);
                                if (0 < n) return e1.glyphs.get(n).getMetrics();
                            }
                            return r;
                        }
                        var wt = {
                            make: _t,
                            fontToTable: function(e1) {
                                for(var t, r = [], o = [], n = [], s = [], i = [], a = [], l = [], u = 0, c = 0, d = 0, f = 0, h = 0, p = 0; p < e1.glyphs.length; p += 1){
                                    var m = e1.glyphs.get(p), y = 0 | m.unicode;
                                    if (isNaN(m.advanceWidth)) throw new Error("Glyph " + m.name + " (" + p + "): advanceWidth is not a number.");
                                    (y < t || void 0 === t) && 0 < y && (t = y), u < y && (u = y);
                                    var y = ht.getUnicodeRange(y);
                                    if (y < 32) c |= 1 << y;
                                    else if (y < 64) d |= 1 << y - 32;
                                    else if (y < 96) f |= 1 << y - 64;
                                    else {
                                        if (!(y < 123)) throw new Error("Unicode ranges bits > 123 are reserved for internal usage");
                                        h |= 1 << y - 96;
                                    }
                                    ".notdef" !== m.name && (y = m.getMetrics(), r.push(y.xMin), o.push(y.yMin), n.push(y.xMax), s.push(y.yMax), a.push(y.leftSideBearing), l.push(y.rightSideBearing), i.push(m.advanceWidth));
                                }
                                var g, v = {
                                    xMin: Math.min.apply(null, r),
                                    yMin: Math.min.apply(null, o),
                                    xMax: Math.max.apply(null, n),
                                    yMax: Math.max.apply(null, s),
                                    advanceWidthMax: Math.max.apply(null, i),
                                    advanceWidthAvg: function(e1) {
                                        for(var t = 0, r = 0; r < e1.length; r += 1)t += e1[r];
                                        return t / e1.length;
                                    }(i),
                                    minLeftSideBearing: Math.min.apply(null, a),
                                    maxLeftSideBearing: Math.max.apply(null, a),
                                    minRightSideBearing: Math.min.apply(null, l)
                                }, b = (v.ascender = e1.ascender, v.descender = e1.descender, Ze.make({
                                    flags: 3,
                                    unitsPerEm: e1.unitsPerEm,
                                    xMin: v.xMin,
                                    yMin: v.yMin,
                                    xMax: v.xMax,
                                    yMax: v.yMax,
                                    lowestRecPPEM: 3,
                                    createdTimestamp: e1.createdTimestamp
                                })), j = Qe.make({
                                    ascender: v.ascender,
                                    descender: v.descender,
                                    advanceWidthMax: v.advanceWidthMax,
                                    minLeftSideBearing: v.minLeftSideBearing,
                                    minRightSideBearing: v.minRightSideBearing,
                                    xMaxExtent: v.maxLeftSideBearing + (v.xMax - v.xMin),
                                    numberOfHMetrics: e1.glyphs.length
                                }), _ = $e.make(e1.glyphs.length), x = ht.make({
                                    xAvgCharWidth: Math.round(v.advanceWidthAvg),
                                    usWeightClass: e1.tables.os2.usWeightClass,
                                    usWidthClass: e1.tables.os2.usWidthClass,
                                    usFirstCharIndex: t,
                                    usLastCharIndex: u,
                                    ulUnicodeRange1: c,
                                    ulUnicodeRange2: d,
                                    ulUnicodeRange3: f,
                                    ulUnicodeRange4: h,
                                    fsSelection: e1.tables.os2.fsSelection,
                                    sTypoAscender: v.ascender,
                                    sTypoDescender: v.descender,
                                    sTypoLineGap: 0,
                                    usWinAscent: v.yMax,
                                    usWinDescent: Math.abs(v.yMin),
                                    ulCodePageRange1: 1,
                                    sxHeight: xt(e1, "xyvw", {
                                        yMax: Math.round(v.ascender / 2)
                                    }).yMax,
                                    sCapHeight: xt(e1, "HIKLEFJMNTZBDPRAGOQSUVWXY", v).yMax,
                                    usDefaultChar: e1.hasChar(" ") ? 32 : 0,
                                    usBreakChar: e1.hasChar(" ") ? 32 : 0
                                }), w = Je.make(e1.glyphs), S = we.make(e1.glyphs), E = e1.getEnglishName("fontFamily"), M = e1.getEnglishName("fontSubfamily"), T = E + " " + M, k = (k = e1.getEnglishName("postScriptName")) || E.replace(/\s/g, "") + "-" + M, O = {};
                                for(g in e1.names)O[g] = e1.names[g];
                                O.uniqueID || (O.uniqueID = {
                                    en: e1.getEnglishName("manufacturer") + ":" + T
                                }), O.postScriptName || (O.postScriptName = {
                                    en: k
                                }), O.preferredFamily || (O.preferredFamily = e1.names.fontFamily), O.preferredSubfamily || (O.preferredSubfamily = e1.names.fontSubfamily);
                                var C = [], A = dt.make(O, C), C = 0 < C.length ? Ke.make(C) : void 0, P = pt.make(), T = Ye.make(e1.glyphs, {
                                    version: e1.getEnglishName("version"),
                                    fullName: T,
                                    familyName: E,
                                    weightName: M,
                                    postScriptName: k,
                                    unitsPerEm: e1.unitsPerEm,
                                    fontBBox: [
                                        0,
                                        v.yMin,
                                        v.ascender,
                                        v.advanceWidthMax
                                    ]
                                }), E = e1.metas && 0 < Object.keys(e1.metas).length ? gt.make(e1.metas) : void 0, M = [
                                    b,
                                    j,
                                    _,
                                    x,
                                    A,
                                    S,
                                    P,
                                    T,
                                    w
                                ];
                                C && M.push(C), e1.tables.gsub && M.push(yt.make(e1.tables.gsub)), E && M.push(E);
                                for(var D = bt((k = _t(M)).encode()), L = k.fields, R = !1, I = 0; I < L.length; I += 1)if ("head table" === L[I].name) {
                                    L[I].value.checkSumAdjustment = 2981146554 - D, R = !0;
                                    break;
                                }
                                if (R) return k;
                                throw new Error("Could not find head table with checkSum to adjust.");
                            },
                            computeCheckSum: bt
                        };
                        function St(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n = r + o >>> 1, s = e1[n].tag;
                                if (s === t) return n;
                                s < t ? r = 1 + n : o = n - 1;
                            }
                            return -r - 1;
                        }
                        function Et(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n = r + o >>> 1, s = e1[n];
                                if (s === t) return n;
                                s < t ? r = 1 + n : o = n - 1;
                            }
                            return -r - 1;
                        }
                        function Mt(e1, t) {
                            for(var r = 0, o = e1.length - 1; r <= o;){
                                var n, s = r + o >>> 1, i = (n = e1[s]).start;
                                if (i === t) return n;
                                i < t ? r = 1 + s : o = s - 1;
                            }
                            if (0 < r) return t > (n = e1[r - 1]).end ? 0 : n;
                        }
                        function Tt(e1, t) {
                            this.font = e1, this.tableName = t;
                        }
                        function kt(e1) {
                            Tt.call(this, e1, "gpos");
                        }
                        function i(e1) {
                            Tt.call(this, e1, "gsub");
                        }
                        function Ot(e1, t, r) {
                            for(var o = e1.subtables, n = 0; n < o.length; n++){
                                var s = o[n];
                                if (s.substFormat === t) return s;
                            }
                            if (r) return o.push(r), r;
                        }
                        function Ct(e1) {
                            for(var t = new ArrayBuffer(e1.length), r = new Uint8Array(t), o = 0; o < e1.length; ++o)r[o] = e1[o];
                            return t;
                        }
                        function _(e1, t) {
                            if (!e1) throw t;
                        }
                        function At(e1, t, r, o, n) {
                            var s = 0 < (t & o) ? (s = e1.parseByte(), r + (s = 0 == (t & n) ? -s : s)) : 0 < (t & n) ? r : r + e1.parseShort();
                            return s;
                        }
                        function Pt(e1, t, r) {
                            var o, n = new R.Parser(t, r);
                            if (e1.numberOfContours = n.parseShort(), e1._xMin = n.parseShort(), e1._yMin = n.parseShort(), e1._xMax = n.parseShort(), e1._yMax = n.parseShort(), 0 < e1.numberOfContours) {
                                for(var s = e1.endPointIndices = [], i = 0; i < e1.numberOfContours; i += 1)s.push(n.parseUShort());
                                e1.instructionLength = n.parseUShort(), e1.instructions = [];
                                for(var a = 0; a < e1.instructionLength; a += 1)e1.instructions.push(n.parseByte());
                                for(var l = s[s.length - 1] + 1, u = [], c = 0; c < l; c += 1)if (o = n.parseByte(), u.push(o), 0 < (8 & o)) for(var d = n.parseByte(), f = 0; f < d; f += 1)u.push(o), c += 1;
                                if (L.argument(u.length === l, "Bad flags."), 0 < s.length) {
                                    var h, p = [];
                                    if (0 < l) {
                                        for(var m = 0; m < l; m += 1)o = u[m], (h = {}).onCurve = !!(1 & o), h.lastPointOfContour = 0 <= s.indexOf(m), p.push(h);
                                        for(var y = 0, g = 0; g < l; g += 1)o = u[g], (h = p[g]).x = At(n, o, y, 2, 16), y = h.x;
                                        for(var v = 0, b = 0; b < l; b += 1)o = u[b], (h = p[b]).y = At(n, o, v, 4, 32), v = h.y;
                                    }
                                    e1.points = p;
                                } else e1.points = [];
                            } else if (0 === e1.numberOfContours) e1.points = [];
                            else {
                                e1.isComposite = !0, e1.points = [], e1.components = [];
                                for(var j = !0; j;){
                                    u = n.parseUShort();
                                    var _ = {
                                        glyphIndex: n.parseUShort(),
                                        xScale: 1,
                                        scale01: 0,
                                        scale10: 0,
                                        yScale: 1,
                                        dx: 0,
                                        dy: 0
                                    };
                                    0 < (1 & u) ? 0 < (2 & u) ? (_.dx = n.parseShort(), _.dy = n.parseShort()) : _.matchedPoints = [
                                        n.parseUShort(),
                                        n.parseUShort()
                                    ] : 0 < (2 & u) ? (_.dx = n.parseChar(), _.dy = n.parseChar()) : _.matchedPoints = [
                                        n.parseByte(),
                                        n.parseByte()
                                    ], 0 < (8 & u) ? _.xScale = _.yScale = n.parseF2Dot14() : 0 < (64 & u) ? (_.xScale = n.parseF2Dot14(), _.yScale = n.parseF2Dot14()) : 0 < (128 & u) && (_.xScale = n.parseF2Dot14(), _.scale01 = n.parseF2Dot14(), _.scale10 = n.parseF2Dot14(), _.yScale = n.parseF2Dot14()), e1.components.push(_), j = !!(32 & u);
                                }
                                if (256 & u) {
                                    e1.instructionLength = n.parseUShort(), e1.instructions = [];
                                    for(var x = 0; x < e1.instructionLength; x += 1)e1.instructions.push(n.parseByte());
                                }
                            }
                        }
                        function Lt(e1, t) {
                            for(var r = [], o = 0; o < e1.length; o += 1){
                                var n = e1[o], n = {
                                    x: t.xScale * n.x + t.scale01 * n.y + t.dx,
                                    y: t.scale10 * n.x + t.yScale * n.y + t.dy,
                                    onCurve: n.onCurve,
                                    lastPointOfContour: n.lastPointOfContour
                                };
                                r.push(n);
                            }
                            return r;
                        }
                        function Rt(e1) {
                            var t = new f;
                            if (e1) for(var r = function(e1) {
                                for(var t = [], r = [], o = 0; o < e1.length; o += 1){
                                    var n = e1[o];
                                    r.push(n), n.lastPointOfContour && (t.push(r), r = []);
                                }
                                return L.argument(0 === r.length, "There are still points left in the current contour."), t;
                            }(e1), o = 0; o < r.length; ++o){
                                var n, s = r[o], i = s[s.length - 1], a = s[0];
                                i.onCurve ? t.moveTo(i.x, i.y) : a.onCurve ? t.moveTo(a.x, a.y) : (n = {
                                    x: .5 * (i.x + a.x),
                                    y: .5 * (i.y + a.y)
                                }, t.moveTo(n.x, n.y));
                                for(var l = 0; l < s.length; ++l){
                                    var u, c = i, i = a, a = s[(l + 1) % s.length];
                                    i.onCurve ? t.lineTo(i.x, i.y) : (u = a, c.onCurve || (i.x, c.x, i.y, c.y), a.onCurve || (u = {
                                        x: .5 * (i.x + a.x),
                                        y: .5 * (i.y + a.y)
                                    }), t.quadraticCurveTo(i.x, i.y, u.x, u.y));
                                }
                                t.closePath();
                            }
                            return t;
                        }
                        function It(e1, t) {
                            if (t.isComposite) for(var r = 0; r < t.components.length; r += 1){
                                var o = t.components[r], n = e1.get(o.glyphIndex);
                                if (n.getPath(), n.points) {
                                    var s = void 0;
                                    if (void 0 === o.matchedPoints) s = Lt(n.points, o);
                                    else {
                                        if (o.matchedPoints[0] > t.points.length - 1 || o.matchedPoints[1] > n.points.length - 1) throw Error("Matched points out of range in " + t.name);
                                        var i = t.points[o.matchedPoints[0]], a = n.points[o.matchedPoints[1]], o = {
                                            xScale: o.xScale,
                                            scale01: o.scale01,
                                            scale10: o.scale10,
                                            yScale: o.yScale,
                                            dx: 0,
                                            dy: 0
                                        }, a = Lt([
                                            a
                                        ], o)[0];
                                        o.dx = i.x - a.x, o.dy = i.y - a.y, s = Lt(n.points, o);
                                    }
                                    t.points = t.points.concat(s);
                                }
                            }
                            return Rt(t.points);
                        }
                        (kt.prototype = Tt.prototype = {
                            searchTag: St,
                            binSearch: Et,
                            getTable: function(e1) {
                                var t = this.font.tables[this.tableName];
                                return t = !t && e1 ? this.font.tables[this.tableName] = this.createDefaultTable() : t;
                            },
                            getScriptNames: function() {
                                var e1 = this.getTable();
                                return e1 ? e1.scripts.map(function(e1) {
                                    return e1.tag;
                                }) : [];
                            },
                            getDefaultScriptName: function() {
                                var e1 = this.getTable();
                                if (e1) {
                                    for(var t = !1, r = 0; r < e1.scripts.length; r++){
                                        var o = e1.scripts[r].tag;
                                        if ("DFLT" === o) return o;
                                        "latn" === o && (t = !0);
                                    }
                                    return t ? "latn" : void 0;
                                }
                            },
                            getScriptTable: function(e1, t) {
                                var r, o = this.getTable(t);
                                if (o) return r = o.scripts, 0 <= (o = St(o.scripts, e1 = e1 || "DFLT")) ? r[o].script : t ? (r.splice(-1 - o, 0, t = {
                                    tag: e1,
                                    script: {
                                        defaultLangSys: {
                                            reserved: 0,
                                            reqFeatureIndex: 65535,
                                            featureIndexes: []
                                        },
                                        langSysRecords: []
                                    }
                                }), t.script) : void 0;
                            },
                            getLangSysTable: function(e1, t, r) {
                                var o, e1 = this.getScriptTable(e1, r);
                                if (e1) return t && "dflt" !== t && "DFLT" !== t ? 0 <= (o = St(e1.langSysRecords, t)) ? e1.langSysRecords[o].langSys : r ? (e1.langSysRecords.splice(-1 - o, 0, r = {
                                    tag: t,
                                    langSys: {
                                        reserved: 0,
                                        reqFeatureIndex: 65535,
                                        featureIndexes: []
                                    }
                                }), r.langSys) : void 0 : e1.defaultLangSys;
                            },
                            getFeatureTable: function(e1, t, r, o) {
                                e1 = this.getLangSysTable(e1, t, o);
                                if (e1) {
                                    for(var n, s = e1.featureIndexes, i = this.font.tables[this.tableName].features, a = 0; a < s.length; a++)if ((n = i[s[a]]).tag === r) return n.feature;
                                    if (o) return t = i.length, L.assert(0 === t || r >= i[t - 1].tag, "Features must be added in alphabetical order."), i.push(n = {
                                        tag: r,
                                        feature: {
                                            params: 0,
                                            lookupListIndexes: []
                                        }
                                    }), s.push(t), n.feature;
                                }
                            },
                            getLookupTables: function(e1, t, r, o, n) {
                                var e1 = this.getFeatureTable(e1, t, r, n), s = [];
                                if (e1) {
                                    for(var i, a = e1.lookupListIndexes, l = this.font.tables[this.tableName].lookups, u = 0; u < a.length; u++)(i = l[a[u]]).lookupType === o && s.push(i);
                                    if (0 === s.length && n) return t = l.length, l.push(i = {
                                        lookupType: o,
                                        lookupFlag: 0,
                                        subtables: [],
                                        markFilteringSet: void 0
                                    }), a.push(t), [
                                        i
                                    ];
                                }
                                return s;
                            },
                            getGlyphClass: function(e1, t) {
                                switch(e1.format){
                                    case 1:
                                        return e1.startGlyph <= t && t < e1.startGlyph + e1.classes.length ? e1.classes[t - e1.startGlyph] : 0;
                                    case 2:
                                        var r = Mt(e1.ranges, t);
                                        return r ? r.classId : 0;
                                }
                            },
                            getCoverageIndex: function(e1, t) {
                                switch(e1.format){
                                    case 1:
                                        var r = Et(e1.glyphs, t);
                                        return 0 <= r ? r : -1;
                                    case 2:
                                        r = Mt(e1.ranges, t);
                                        return r ? r.index + t - r.start : -1;
                                }
                            },
                            expandCoverage: function(e1) {
                                if (1 === e1.format) return e1.glyphs;
                                for(var t = [], r = e1.ranges, o = 0; o < r.length; o++)for(var n = r[o], s = n.start, i = n.end, a = s; a <= i; a++)t.push(a);
                                return t;
                            }
                        }).init = function() {
                            var e1 = this.getDefaultScriptName();
                            this.defaultKerningTables = this.getKerningTables(e1);
                        }, kt.prototype.getKerningValue = function(e1, t, r) {
                            for(var o = 0; o < e1.length; o++)for(var n = e1[o].subtables, s = 0; s < n.length; s++){
                                var i = n[s], a = this.getCoverageIndex(i.coverage, t);
                                if (!(a < 0)) switch(i.posFormat){
                                    case 1:
                                        for(var l = i.pairSets[a], u = 0; u < l.length; u++){
                                            var c = l[u];
                                            if (c.secondGlyph === r) return c.value1 && c.value1.xAdvance || 0;
                                        }
                                        break;
                                    case 2:
                                        var d = this.getGlyphClass(i.classDef1, t), f = this.getGlyphClass(i.classDef2, r), d = i.classRecords[d][f];
                                        return d.value1 && d.value1.xAdvance || 0;
                                }
                            }
                            return 0;
                        }, kt.prototype.getKerningTables = function(e1, t) {
                            if (this.font.tables.gpos) return this.getLookupTables(e1, t, "kern", 2);
                        }, (i.prototype = Tt.prototype).createDefaultTable = function() {
                            return {
                                version: 1,
                                scripts: [
                                    {
                                        tag: "DFLT",
                                        script: {
                                            defaultLangSys: {
                                                reserved: 0,
                                                reqFeatureIndex: 65535,
                                                featureIndexes: []
                                            },
                                            langSysRecords: []
                                        }
                                    }
                                ],
                                features: [],
                                lookups: []
                            };
                        }, i.prototype.getSingle = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 1), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++){
                                var l = i[a], u = this.expandCoverage(l.coverage), c = void 0;
                                if (1 === l.substFormat) for(var d = l.deltaGlyphId, c = 0; c < u.length; c++){
                                    var f = u[c];
                                    o.push({
                                        sub: f,
                                        by: f + d
                                    });
                                }
                                else {
                                    var h = l.substitute;
                                    for(c = 0; c < u.length; c++)o.push({
                                        sub: u[c],
                                        by: h[c]
                                    });
                                }
                            }
                            return o;
                        }, i.prototype.getAlternates = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 3), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++)for(var l = i[a], u = this.expandCoverage(l.coverage), c = l.alternateSets, d = 0; d < u.length; d++)o.push({
                                sub: u[d],
                                by: c[d]
                            });
                            return o;
                        }, i.prototype.getLigatures = function(e1, t, r) {
                            for(var o = [], n = this.getLookupTables(t, r, e1, 4), s = 0; s < n.length; s++)for(var i = n[s].subtables, a = 0; a < i.length; a++)for(var l = i[a], u = this.expandCoverage(l.coverage), c = l.ligatureSets, d = 0; d < u.length; d++)for(var f = u[d], h = c[d], p = 0; p < h.length; p++){
                                var m = h[p];
                                o.push({
                                    sub: [
                                        f
                                    ].concat(m.components),
                                    by: m.ligGlyph
                                });
                            }
                            return o;
                        }, i.prototype.addSingle = function(e1, t, r, o) {
                            r = Ot(this.getLookupTables(r, o, e1, 1, !0)[0], 2, {
                                substFormat: 2,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                substitute: []
                            }), L.assert(1 === r.coverage.format, "Ligature: unable to modify coverage table format " + r.coverage.format), o = t.sub, e1 = this.binSearch(r.coverage.glyphs, o);
                            e1 < 0 && (r.coverage.glyphs.splice(e1 = -1 - e1, 0, o), r.substitute.splice(e1, 0, 0)), r.substitute[e1] = t.by;
                        }, i.prototype.addAlternate = function(e1, t, r, o) {
                            r = Ot(this.getLookupTables(r, o, e1, 3, !0)[0], 1, {
                                substFormat: 1,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                alternateSets: []
                            }), L.assert(1 === r.coverage.format, "Ligature: unable to modify coverage table format " + r.coverage.format), o = t.sub, e1 = this.binSearch(r.coverage.glyphs, o);
                            e1 < 0 && (r.coverage.glyphs.splice(e1 = -1 - e1, 0, o), r.alternateSets.splice(e1, 0, 0)), r.alternateSets[e1] = t.by;
                        }, i.prototype.addLigature = function(e1, t, r, o) {
                            var r = this.getLookupTables(r, o, e1, 4, !0)[0], o = r.subtables[0], e1 = (o || (r.subtables[0] = o = {
                                substFormat: 1,
                                coverage: {
                                    format: 1,
                                    glyphs: []
                                },
                                ligatureSets: []
                            }), L.assert(1 === o.coverage.format, "Ligature: unable to modify coverage table format " + o.coverage.format), t.sub[0]), n = t.sub.slice(1), r = {
                                ligGlyph: t.by,
                                components: n
                            }, t = this.binSearch(o.coverage.glyphs, e1);
                            if (0 <= t) {
                                for(var s = o.ligatureSets[t], i = 0; i < s.length; i++)if (function(e1, t) {
                                    var r = e1.length;
                                    if (r === t.length) {
                                        for(var o = 0; o < r; o++)if (e1[o] !== t[o]) return;
                                        return 1;
                                    }
                                }(s[i].components, n)) return;
                                s.push(r);
                            } else o.coverage.glyphs.splice(t = -1 - t, 0, e1), o.ligatureSets.splice(t, 0, [
                                r
                            ]);
                        }, i.prototype.getFeature = function(e1, t, r) {
                            if (/ss\d\d/.test(e1)) return this.getSingle(e1, t, r);
                            switch(e1){
                                case "aalt":
                                case "salt":
                                    return this.getSingle(e1, t, r).concat(this.getAlternates(e1, t, r));
                                case "dlig":
                                case "liga":
                                case "rlig":
                                    return this.getLigatures(e1, t, r);
                            }
                        }, i.prototype.add = function(e1, t, r, o) {
                            if (/ss\d\d/.test(e1)) return this.addSingle(e1, t, r, o);
                            switch(e1){
                                case "aalt":
                                case "salt":
                                    return "number" == typeof t.by ? this.addSingle(e1, t, r, o) : this.addAlternate(e1, t, r, o);
                                case "dlig":
                                case "liga":
                                case "rlig":
                                    return this.addLigature(e1, t, r, o);
                            }
                        };
                        var Dt = {
                            getPath: Rt,
                            parse: function(e1, t, r, o) {
                                for(var n = new p.GlyphSet(o), s = 0; s < r.length - 1; s += 1){
                                    var i = r[s];
                                    i !== r[s + 1] ? n.push(s, p.ttfGlyphLoader(o, s, Pt, e1, t + i, It)) : n.push(s, p.glyphLoader(o, s));
                                }
                                return n;
                            }
                        };
                        function Ft(e1) {
                            this.font = e1, this.getCommands = function(e1) {
                                return Dt.getPath(e1).commands;
                            }, this._fpgmState = this._prepState = void 0, this._errorState = 0;
                        }
                        function Ut(e1) {
                            return e1;
                        }
                        function Nt(e1) {
                            return Math.sign(e1) * Math.round(Math.abs(e1));
                        }
                        function Bt(e1) {
                            return Math.sign(e1) * Math.round(Math.abs(2 * e1)) / 2;
                        }
                        function Gt(e1) {
                            return Math.sign(e1) * (Math.round(Math.abs(e1) + .5) - .5);
                        }
                        function Vt(e1) {
                            return Math.sign(e1) * Math.ceil(Math.abs(e1));
                        }
                        function zt(e1) {
                            return Math.sign(e1) * Math.floor(Math.abs(e1));
                        }
                        function Ht(e1) {
                            var t = this.srPeriod, r = this.srPhase, o = 1;
                            return e1 < 0 && (e1 = -e1, o = -1), e1 += this.srThreshold - r, e1 = Math.trunc(e1 / t) * t, (e1 += r) < 0 ? r * o : e1 * o;
                        }
                        var x = {
                            x: 1,
                            y: 0,
                            axis: "x",
                            distance: function(e1, t, r, o) {
                                return (r ? e1.xo : e1.x) - (o ? t.xo : t.x);
                            },
                            interpolate: function(e1, t, r, o) {
                                var n, s, i, a, l, u, c;
                                if (!o || o === this) return n = e1.xo - t.xo, s = e1.xo - r.xo, l = t.x - t.xo, u = r.x - r.xo, 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? void (e1.x = e1.xo + (l + u) / 2) : void (e1.x = e1.xo + (l * a + u * i) / c);
                                n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), l = o.distance(t, t, !1, !0), u = o.distance(r, r, !1, !0), 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? x.setRelative(e1, e1, (l + u) / 2, o, !0) : x.setRelative(e1, e1, (l * a + u * i) / c, o, !0);
                            },
                            normalSlope: Number.NEGATIVE_INFINITY,
                            setRelative: function(e1, t, r, o, n) {
                                var s, i;
                                o && o !== this ? (s = n ? t.xo : t.x, i = n ? t.yo : t.y, s += r * o.x, i += r * o.y, e1.x = s + (e1.y - i) / o.normalSlope) : e1.x = (n ? t.xo : t.x) + r;
                            },
                            slope: 0,
                            touch: function(e1) {
                                e1.xTouched = !0;
                            },
                            touched: function(e1) {
                                return e1.xTouched;
                            },
                            untouch: function(e1) {
                                e1.xTouched = !1;
                            }
                        }, E = {
                            x: 0,
                            y: 1,
                            axis: "y",
                            distance: function(e1, t, r, o) {
                                return (r ? e1.yo : e1.y) - (o ? t.yo : t.y);
                            },
                            interpolate: function(e1, t, r, o) {
                                var n, s, i, a, l, u, c;
                                if (!o || o === this) return n = e1.yo - t.yo, s = e1.yo - r.yo, l = t.y - t.yo, u = r.y - r.yo, 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? void (e1.y = e1.yo + (l + u) / 2) : void (e1.y = e1.yo + (l * a + u * i) / c);
                                n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), l = o.distance(t, t, !1, !0), u = o.distance(r, r, !1, !0), 0 === (c = (i = Math.abs(n)) + (a = Math.abs(s))) ? E.setRelative(e1, e1, (l + u) / 2, o, !0) : E.setRelative(e1, e1, (l * a + u * i) / c, o, !0);
                            },
                            normalSlope: 0,
                            setRelative: function(e1, t, r, o, n) {
                                var s, i;
                                o && o !== this ? (s = n ? t.xo : t.x, i = n ? t.yo : t.y, s += r * o.x, i += r * o.y, e1.y = i + o.normalSlope * (e1.x - s)) : e1.y = (n ? t.yo : t.y) + r;
                            },
                            slope: Number.POSITIVE_INFINITY,
                            touch: function(e1) {
                                e1.yTouched = !0;
                            },
                            touched: function(e1) {
                                return e1.yTouched;
                            },
                            untouch: function(e1) {
                                e1.yTouched = !1;
                            }
                        };
                        function Wt(e1, t) {
                            this.x = e1, this.y = t, this.axis = void 0, this.slope = t / e1, this.normalSlope = -e1 / t, Object.freeze(this);
                        }
                        function qt(e1, t) {
                            var r = Math.sqrt(e1 * e1 + t * t);
                            return t /= r, 1 === (e1 /= r) && 0 === t ? x : 0 === e1 && 1 === t ? E : new Wt(e1, t);
                        }
                        function M(e1, t, r, o) {
                            this.x = this.xo = Math.round(64 * e1) / 64, this.y = this.yo = Math.round(64 * t) / 64, this.lastPointOfContour = r, this.onCurve = o, this.prevPointOnContour = void 0, this.nextPointOnContour = void 0, this.xTouched = !1, this.yTouched = !1, Object.preventExtensions(this);
                        }
                        Object.freeze(x), Object.freeze(E), Wt.prototype.distance = function(e1, t, r, o) {
                            return this.x * x.distance(e1, t, r, o) + this.y * E.distance(e1, t, r, o);
                        }, Wt.prototype.interpolate = function(e1, t, r, o) {
                            var n = o.distance(e1, t, !0, !0), s = o.distance(e1, r, !0, !0), t = o.distance(t, t, !1, !0), r = o.distance(r, r, !1, !0), n = Math.abs(n), s = Math.abs(s), i = n + s;
                            0 === i ? this.setRelative(e1, e1, (t + r) / 2, o, !0) : this.setRelative(e1, e1, (t * s + r * n) / i, o, !0);
                        }, Wt.prototype.setRelative = function(e1, t, r, o, n) {
                            var s = n ? t.xo : t.x, n = n ? t.yo : t.y, t = s + r * (o = o || this).x, s = n + r * o.y, n = o.normalSlope, r = this.slope, o = e1.x, i = e1.y;
                            e1.x = (r * o - n * t + s - i) / (r - n), e1.y = r * (e1.x - o) + i;
                        }, Wt.prototype.touch = function(e1) {
                            e1.xTouched = !0, e1.yTouched = !0;
                        }, M.prototype.nextTouched = function(e1) {
                            for(var t = this.nextPointOnContour; !e1.touched(t) && t !== this;)t = t.nextPointOnContour;
                            return t;
                        }, M.prototype.prevTouched = function(e1) {
                            for(var t = this.prevPointOnContour; !e1.touched(t) && t !== this;)t = t.prevPointOnContour;
                            return t;
                        };
                        var Xt = Object.freeze(new M(0, 0)), Yt = {
                            cvCutIn: 17 / 16,
                            deltaBase: 9,
                            deltaShift: .125,
                            loop: 1,
                            minDis: 1,
                            autoFlip: !0
                        };
                        function T(e1, t) {
                            switch(this.env = e1, this.stack = [], this.prog = t, e1){
                                case "glyf":
                                    this.zp0 = this.zp1 = this.zp2 = 1, this.rp0 = this.rp1 = this.rp2 = 0;
                                case "prep":
                                    this.fv = this.pv = this.dpv = x, this.round = Nt;
                            }
                        }
                        function Zt(e1) {
                            for(var t = e1.tZone = new Array(e1.gZone.length), r = 0; r < t.length; r++)t[r] = new M(0, 0);
                        }
                        function Qt(e1, t) {
                            var r, o = e1.prog, n = e1.ip, s = 1;
                            do {
                                if (88 === (r = o[++n])) s++;
                                else if (89 === r) s--;
                                else if (64 === r) n += o[n + 1] + 1;
                                else if (65 === r) n += 2 * o[n + 1] + 1;
                                else if (176 <= r && r <= 183) n += r - 176 + 1;
                                else if (184 <= r && r <= 191) n += 2 * (r - 184 + 1);
                                else if (t && 1 === s && 27 === r) break;
                            }while (0 < s);
                            e1.ip = n;
                        }
                        function Jt(e1, t) {
                            j.DEBUG && console.log(t.step, "SVTCA[" + e1.axis + "]"), t.fv = t.pv = t.dpv = e1;
                        }
                        function Kt(e1, t) {
                            j.DEBUG && console.log(t.step, "SPVTCA[" + e1.axis + "]"), t.pv = t.dpv = e1;
                        }
                        function $t(e1, t) {
                            j.DEBUG && console.log(t.step, "SFVTCA[" + e1.axis + "]"), t.fv = e1;
                        }
                        function er(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            j.DEBUG && console.log("SPVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.pv = t.dpv = qt(r, n);
                        }
                        function tr(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            j.DEBUG && console.log("SFVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.fv = qt(r, n);
                        }
                        function rr(e1) {
                            j.DEBUG && console.log(e1.step, "POP[]"), e1.stack.pop();
                        }
                        function or(e1, t) {
                            var r = t.stack.pop(), o = t.z0[r], n = t.fv, s = t.pv, i = (j.DEBUG && console.log(t.step, "MDAP[" + e1 + "]", r), s.distance(o, Xt));
                            e1 && (i = t.round(i)), n.setRelative(o, Xt, i, s), n.touch(o), t.rp0 = t.rp1 = r;
                        }
                        function nr(e1, t) {
                            var r, o, n, s = t.z2, i = s.length - 2;
                            j.DEBUG && console.log(t.step, "IUP[" + e1.axis + "]");
                            for(var a = 0; a < i; a++)r = s[a], e1.touched(r) || (o = r.prevTouched(e1)) !== r && (o === (n = r.nextTouched(e1)) && e1.setRelative(r, r, e1.distance(o, o, !1, !0), e1, !0), e1.interpolate(r, o, n, e1));
                        }
                        function sr(e1, t) {
                            for(var r = t.stack, o = e1 ? t.rp1 : t.rp2, n = (e1 ? t.z0 : t.z1)[o], s = t.fv, i = t.pv, a = t.loop, l = t.z2; a--;){
                                var u = r.pop(), c = l[u], d = i.distance(n, n, !1, !0);
                                s.setRelative(c, c, d, i), s.touch(c), j.DEBUG && console.log(t.step, (1 < t.loop ? "loop " + (t.loop - a) + ": " : "") + "SHP[" + (e1 ? "rp1" : "rp2") + "]", u);
                            }
                            t.loop = 1;
                        }
                        function ir(e1, t) {
                            for(var r = t.stack, o = e1 ? t.rp1 : t.rp2, n = (e1 ? t.z0 : t.z1)[o], s = t.fv, i = t.pv, o = r.pop(), a = t.z2[t.contours[o]], l = a, u = (j.DEBUG && console.log(t.step, "SHC[" + e1 + "]", o), i.distance(n, n, !1, !0)); l !== n && s.setRelative(l, l, u, i), (l = l.nextPointOnContour) !== a;);
                        }
                        function ar(e1, t) {
                            var r, o, n = t.stack, s = e1 ? t.rp1 : t.rp2, s = (e1 ? t.z0 : t.z1)[s], i = t.fv, a = t.pv, n = n.pop();
                            switch(j.DEBUG && console.log(t.step, "SHZ[" + e1 + "]", n), n){
                                case 0:
                                    r = t.tZone;
                                    break;
                                case 1:
                                    r = t.gZone;
                                    break;
                                default:
                                    throw new Error("Invalid zone");
                            }
                            for(var l = a.distance(s, s, !1, !0), u = r.length - 2, c = 0; c < u; c++)o = r[c], i.setRelative(o, o, l, a);
                        }
                        function lr(e1, t) {
                            var r = t.stack, o = r.pop() / 64, r = r.pop(), n = t.z1[r], s = t.z0[t.rp0], i = t.fv, a = t.pv;
                            i.setRelative(n, s, o, a), i.touch(n), j.DEBUG && console.log(t.step, "MSIRP[" + e1 + "]", o, r), t.rp1 = t.rp0, t.rp2 = r, e1 && (t.rp0 = r);
                        }
                        function ur(e1, t) {
                            var r = t.stack, o = r.pop(), r = r.pop(), n = t.z0[r], s = t.fv, i = t.pv, a = t.cvt[o], o = (j.DEBUG && console.log(t.step, "MIAP[" + e1 + "]", o, "(", a, ")", r), i.distance(n, Xt));
                            e1 && (Math.abs(o - a) < t.cvCutIn && (o = a), o = t.round(o)), s.setRelative(n, Xt, o, i), 0 === t.zp0 && (n.xo = n.x, n.yo = n.y), s.touch(n), t.rp0 = t.rp1 = r;
                        }
                        function cr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.z2[o];
                            j.DEBUG && console.log(t.step, "GC[" + e1 + "]", o), r.push(64 * t.dpv.distance(n, Xt, e1, !1));
                        }
                        function dr(e1, t) {
                            var r = t.stack, o = r.pop(), r = r.pop(), n = t.z1[o], s = t.z0[r], s = t.dpv.distance(s, n, e1, e1);
                            j.DEBUG && console.log(t.step, "MD[" + e1 + "]", o, r, "->", s), t.stack.push(Math.round(64 * s));
                        }
                        function fr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.fv, s = t.pv, i = t.ppem, a = t.deltaBase + 16 * (e1 - 1), l = t.deltaShift, u = t.z0;
                            j.DEBUG && console.log(t.step, "DELTAP[" + e1 + "]", o, r);
                            for(var c = 0; c < o; c++){
                                var d = r.pop(), f = r.pop();
                                a + ((240 & f) >> 4) === i && (0 <= (f = (15 & f) - 8) && f++, j.DEBUG && console.log(t.step, "DELTAPFIX", d, "by", f * l), d = u[d], n.setRelative(d, d, f * l, s));
                            }
                        }
                        function hr(e1, t) {
                            var r = t.stack, o = r.pop();
                            j.DEBUG && console.log(t.step, "ROUND[]"), r.push(64 * t.round(o / 64));
                        }
                        function pr(e1, t) {
                            var r = t.stack, o = r.pop(), n = t.ppem, s = t.deltaBase + 16 * (e1 - 1), i = t.deltaShift;
                            j.DEBUG && console.log(t.step, "DELTAC[" + e1 + "]", o, r);
                            for(var a = 0; a < o; a++){
                                var l = r.pop(), u = r.pop();
                                s + ((240 & u) >> 4) === n && (0 <= (u = (15 & u) - 8) && u++, u = u * i, j.DEBUG && console.log(t.step, "DELTACFIX", l, "by", u), t.cvt[l] += u);
                            }
                        }
                        function mr(e1, t) {
                            var r, o = t.stack, n = o.pop(), o = o.pop(), s = t.z2[n], i = t.z1[o];
                            j.DEBUG && console.log(t.step, "SDPVTL[" + e1 + "]", n, o), n = e1 ? (r = s.y - i.y, i.x - s.x) : (r = i.x - s.x, i.y - s.y), t.dpv = qt(r, n);
                        }
                        function k(e1, t) {
                            var r = t.stack, o = t.prog, n = t.ip;
                            j.DEBUG && console.log(t.step, "PUSHB[" + e1 + "]");
                            for(var s = 0; s < e1; s++)r.push(o[++n]);
                            t.ip = n;
                        }
                        function O(e1, t) {
                            var r = t.ip, o = t.prog, n = t.stack;
                            j.DEBUG && console.log(t.ip, "PUSHW[" + e1 + "]");
                            for(var s = 0; s < e1; s++){
                                var i = o[++r] << 8 | o[++r];
                                32768 & i && (i = -(1 + (65535 ^ i))), n.push(i);
                            }
                            t.ip = r;
                        }
                        function C(e1, t, r, o, n, s) {
                            var i, a, l = s.stack, u = e1 && l.pop(), l = l.pop(), c = s.rp0, c = s.z0[c], d = s.z1[l], f = s.minDis, h = s.fv, p = s.dpv, m = i = p.distance(d, c, !0, !0), y = 0 <= m ? 1 : -1;
                            m = Math.abs(m), e1 && (a = s.cvt[u], o && Math.abs(m - a) < s.cvCutIn && (m = a)), r && m < f && (m = f), o && (m = s.round(m)), h.setRelative(d, c, y * m, p), h.touch(d), j.DEBUG && console.log(s.step, (e1 ? "MIRP[" : "MDRP[") + (t ? "M" : "m") + (r ? ">" : "_") + (o ? "R" : "_") + (0 === n ? "Gr" : 1 === n ? "Bl" : 2 === n ? "Wh" : "") + "]", e1 ? u + "(" + s.cvt[u] + "," + a + ")" : "", l, "(d =", i, "->", y * m, ")"), s.rp1 = s.rp0, s.rp2 = l, t && (s.rp0 = l);
                        }
                        Ft.prototype.exec = function(e1, t) {
                            if ("number" != typeof t) throw new Error("Point size is not a number!");
                            if (!(2 < this._errorState)) {
                                var r = this.font, o = this._prepState;
                                if (!o || o.ppem !== t) {
                                    var n = this._fpgmState;
                                    if (!n) {
                                        T.prototype = Yt, (n = this._fpgmState = new T("fpgm", r.tables.fpgm)).funcs = [], n.font = r, j.DEBUG && (console.log("---EXEC FPGM---"), n.step = -1);
                                        try {
                                            vr(n);
                                        } catch (e1) {
                                            return console.log("Hinting error in FPGM:" + e1), void (this._errorState = 3);
                                        }
                                    }
                                    T.prototype = n, (o = this._prepState = new T("prep", r.tables.prep)).ppem = t;
                                    var s = r.tables.cvt;
                                    if (s) for(var i = o.cvt = new Array(s.length), a = t / r.unitsPerEm, l = 0; l < s.length; l++)i[l] = s[l] * a;
                                    else o.cvt = [];
                                    j.DEBUG && (console.log("---EXEC PREP---"), o.step = -1);
                                    try {
                                        vr(o);
                                    } catch (e1) {
                                        this._errorState < 2 && console.log("Hinting error in PREP:" + e1), this._errorState = 2;
                                    }
                                }
                                if (!(1 < this._errorState)) try {
                                    return yr(e1, o);
                                } catch (e1) {
                                    this._errorState < 1 && (console.log("Hinting error:" + e1), console.log("Note: further hinting errors are silenced")), this._errorState = 1;
                                }
                            }
                        };
                        var yr = function(e1, t) {
                            var r = t.ppem / t.font.unitsPerEm, o = r, n = e1.components;
                            if (T.prototype = t, n) {
                                for(var s = t.font, i = [], a = [], l = 0; l < n.length; l++){
                                    var u = n[l], c = s.glyphs.get(u.glyphIndex), d = new T("glyf", c.instructions);
                                    j.DEBUG && (console.log("---EXEC COMP " + l + "---"), d.step = -1), gr(c, d, r, o);
                                    for(var f = Math.round(u.dx * r), h = Math.round(u.dy * o), p = d.gZone, m = d.contours, y = 0; y < p.length; y++){
                                        var g = p[y];
                                        g.xTouched = g.yTouched = !1, g.xo = g.x = g.x + f, g.yo = g.y = g.y + h;
                                    }
                                    var v = i.length;
                                    i.push.apply(i, p);
                                    for(var b = 0; b < m.length; b++)a.push(m[b] + v);
                                }
                                e1.instructions && !d.inhibitGridFit && ((d = new T("glyf", e1.instructions)).gZone = d.z0 = d.z1 = d.z2 = i, d.contours = a, i.push(new M(0, 0), new M(Math.round(e1.advanceWidth * r), 0)), j.DEBUG && (console.log("---EXEC COMPOSITE---"), d.step = -1), vr(d), i.length -= 2);
                            } else d = new T("glyf", e1.instructions), j.DEBUG && (console.log("---EXEC GLYPH---"), d.step = -1), gr(e1, d, r, o), i = d.gZone;
                            return i;
                        }, gr = function(e1, t, r, o) {
                            for(var n, s, i, a = e1.points || [], l = a.length, u = t.gZone = t.z0 = t.z1 = t.z2 = [], c = t.contours = [], d = 0; d < l; d++)n = a[d], u[d] = new M(n.x * r, n.y * o, n.lastPointOfContour, n.onCurve);
                            for(var f = 0; f < l; f++)n = u[f], s || (s = n, c.push(f)), n.lastPointOfContour ? ((n.nextPointOnContour = s).prevPointOnContour = n, s = void 0) : (i = u[f + 1], (n.nextPointOnContour = i).prevPointOnContour = n);
                            if (!t.inhibitGridFit) {
                                if (j.DEBUG) {
                                    console.log("PROCESSING GLYPH", t.stack);
                                    for(var h = 0; h < l; h++)console.log(h, u[h].x, u[h].y);
                                }
                                if (u.push(new M(0, 0), new M(Math.round(e1.advanceWidth * r), 0)), vr(t), u.length -= 2, j.DEBUG) {
                                    console.log("FINISHED GLYPH", t.stack);
                                    for(var p = 0; p < l; p++)console.log(p, u[p].x, u[p].y);
                                }
                            }
                        }, vr = function(e1) {
                            var t = e1.prog;
                            if (t) {
                                var r, o = t.length;
                                for(e1.ip = 0; e1.ip < o; e1.ip++){
                                    if (j.DEBUG && e1.step++, !(r = br[t[e1.ip]])) throw new Error("unknown instruction: 0x" + Number(t[e1.ip]).toString(16));
                                    r(e1);
                                }
                            }
                        }, br = [
                            Jt.bind(void 0, E),
                            Jt.bind(void 0, x),
                            Kt.bind(void 0, E),
                            Kt.bind(void 0, x),
                            $t.bind(void 0, E),
                            $t.bind(void 0, x),
                            er.bind(void 0, 0),
                            er.bind(void 0, 1),
                            tr.bind(void 0, 0),
                            tr.bind(void 0, 1),
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                j.DEBUG && console.log(e1.step, "SPVFS[]", t, r), e1.pv = e1.dpv = qt(r, t);
                            },
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                j.DEBUG && console.log(e1.step, "SPVFS[]", t, r), e1.fv = qt(r, t);
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.pv;
                                j.DEBUG && console.log(e1.step, "GPV[]"), t.push(16384 * r.x), t.push(16384 * r.y);
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.fv;
                                j.DEBUG && console.log(e1.step, "GFV[]"), t.push(16384 * r.x), t.push(16384 * r.y);
                            },
                            function(e1) {
                                e1.fv = e1.pv, j.DEBUG && console.log(e1.step, "SFVTPV[]");
                            },
                            function(e1) {
                                var t = (s = e1.stack).pop(), r = s.pop(), o = s.pop(), n = s.pop(), s = s.pop(), i = e1.z0, a = e1.z1, l = i[t], i = i[r], u = a[o], a = a[n], e1 = e1.z2[s], t = (j.DEBUG && console.log("ISECT[], ", t, r, o, n, s), l.x), r = l.y, o = i.x, n = i.y, s = u.x, l = u.y, i = a.x, u = a.y, a = (t - o) * (l - u) - (r - n) * (s - i), c = t * n - r * o, d = s * u - l * i;
                                e1.x = (c * (s - i) - d * (t - o)) / a, e1.y = (c * (l - u) - d * (r - n)) / a;
                            },
                            function(e1) {
                                e1.rp0 = e1.stack.pop(), j.DEBUG && console.log(e1.step, "SRP0[]", e1.rp0);
                            },
                            function(e1) {
                                e1.rp1 = e1.stack.pop(), j.DEBUG && console.log(e1.step, "SRP1[]", e1.rp1);
                            },
                            function(e1) {
                                e1.rp2 = e1.stack.pop(), j.DEBUG && console.log(e1.step, "SRP2[]", e1.rp2);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SZP0[]", t), e1.zp0 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z0 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z0 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SZP1[]", t), e1.zp1 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z1 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z1 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SZP2[]", t), e1.zp2 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z2 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z2 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SZPS[]", t), e1.zp0 = e1.zp1 = e1.zp2 = t){
                                    case 0:
                                        e1.tZone || Zt(e1), e1.z0 = e1.z1 = e1.z2 = e1.tZone;
                                        break;
                                    case 1:
                                        e1.z0 = e1.z1 = e1.z2 = e1.gZone;
                                        break;
                                    default:
                                        throw new Error("Invalid zone pointer");
                                }
                            },
                            function(e1) {
                                e1.loop = e1.stack.pop(), j.DEBUG && console.log(e1.step, "SLOOP[]", e1.loop);
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RTG[]"), e1.round = Nt;
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RTHG[]"), e1.round = Gt;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SMD[]", t), e1.minDis = t / 64;
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "ELSE[]"), Qt(e1, !1);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "JMPR[]", t), e1.ip += t - 1;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SCVTCI[]", t), e1.cvCutIn = t / 64;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack;
                                j.DEBUG && console.log(e1.step, "DUP[]"), t.push(t[t.length - 1]);
                            },
                            rr,
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "CLEAR[]"), e1.stack.length = 0;
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "SWAP[]"), t.push(r), t.push(o);
                            },
                            function(e1) {
                                var t = e1.stack;
                                j.DEBUG && console.log(e1.step, "DEPTH[]"), t.push(t.length);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "CINDEX[]", r), t.push(t[t.length - r]);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "MINDEX[]", r), t.push(t.splice(t.length - r, 1)[0]);
                            },
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = (o = e1.stack).pop(), r = o.pop(), o = (j.DEBUG && console.log(e1.step, "LOOPCALL[]", t, r), e1.ip), n = e1.prog;
                                e1.prog = e1.funcs[t];
                                for(var s = 0; s < r; s++)vr(e1), j.DEBUG && console.log(++e1.step, s + 1 < r ? "next loopcall" : "done loopcall", s);
                                e1.ip = o, e1.prog = n;
                            },
                            function(e1) {
                                var t = e1.stack.pop(), r = (j.DEBUG && console.log(e1.step, "CALL[]", t), e1.ip), o = e1.prog;
                                e1.prog = e1.funcs[t], vr(e1), e1.ip = r, e1.prog = o, j.DEBUG && console.log(++e1.step, "returning from", t);
                            },
                            function(e1) {
                                if ("fpgm" !== e1.env) throw new Error("FDEF not allowed here");
                                var t = e1.stack, r = e1.prog, o = e1.ip, t = t.pop(), n = o;
                                for(j.DEBUG && console.log(e1.step, "FDEF[]", t); 45 !== r[++o];);
                                e1.ip = o, e1.funcs[t] = r.slice(n + 1, o);
                            },
                            void 0,
                            or.bind(void 0, 0),
                            or.bind(void 0, 1),
                            nr.bind(void 0, E),
                            nr.bind(void 0, x),
                            sr.bind(void 0, 0),
                            sr.bind(void 0, 1),
                            ir.bind(void 0, 0),
                            ir.bind(void 0, 1),
                            ar.bind(void 0, 0),
                            ar.bind(void 0, 1),
                            function(e1) {
                                for(var t = e1.stack, r = e1.loop, o = e1.fv, n = t.pop() / 64, s = e1.z2; r--;){
                                    var i = t.pop(), a = s[i];
                                    j.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - r) + ": " : "") + "SHPIX[]", i, n), o.setRelative(a, a, n), o.touch(a);
                                }
                                e1.loop = 1;
                            },
                            function(e1) {
                                for(var t = e1.stack, r = e1.rp1, o = e1.rp2, n = e1.loop, s = e1.z0[r], i = e1.z1[o], a = e1.fv, l = e1.dpv, u = e1.z2; n--;){
                                    var c = t.pop(), d = u[c];
                                    j.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - n) + ": " : "") + "IP[]", c, r, "<->", o), a.interpolate(d, s, i, l), a.touch(d);
                                }
                                e1.loop = 1;
                            },
                            lr.bind(void 0, 0),
                            lr.bind(void 0, 1),
                            function(e1) {
                                for(var t = e1.stack, r = e1.rp0, o = e1.z0[r], n = e1.loop, s = e1.fv, i = e1.pv, a = e1.z1; n--;){
                                    var l = t.pop(), u = a[l];
                                    j.DEBUG && console.log(e1.step, (1 < e1.loop ? "loop " + (e1.loop - n) + ": " : "") + "ALIGNRP[]", l), s.setRelative(u, o, 0, i), s.touch(u);
                                }
                                e1.loop = 1;
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RTDG[]"), e1.round = Bt;
                            },
                            ur.bind(void 0, 0),
                            ur.bind(void 0, 1),
                            function(e1) {
                                var t = e1.prog, r = e1.ip, o = e1.stack, n = t[++r];
                                j.DEBUG && console.log(e1.step, "NPUSHB[]", n);
                                for(var s = 0; s < n; s++)o.push(t[++r]);
                                e1.ip = r;
                            },
                            function(e1) {
                                var t = e1.ip, r = e1.prog, o = e1.stack, n = r[++t];
                                j.DEBUG && console.log(e1.step, "NPUSHW[]", n);
                                for(var s = 0; s < n; s++){
                                    var i = r[++t] << 8 | r[++t];
                                    32768 & i && (i = -(1 + (65535 ^ i))), o.push(i);
                                }
                                e1.ip = t;
                            },
                            function(e1) {
                                var t = e1.stack, r = (r = e1.store) || (e1.store = []), o = t.pop(), t = t.pop();
                                j.DEBUG && console.log(e1.step, "WS", o, t), r[t] = o;
                            },
                            function(e1) {
                                var t = e1.stack, r = e1.store, o = t.pop(), e1 = (j.DEBUG && console.log(e1.step, "RS", o), r && r[o] || 0);
                                t.push(e1);
                            },
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                j.DEBUG && console.log(e1.step, "WCVTP", t, r), e1.cvt[r] = t / 64;
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "RCVT", r), t.push(64 * e1.cvt[r]);
                            },
                            cr.bind(void 0, 0),
                            cr.bind(void 0, 1),
                            void 0,
                            dr.bind(void 0, 0),
                            dr.bind(void 0, 1),
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "MPPEM[]"), e1.stack.push(e1.ppem);
                            },
                            void 0,
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "FLIPON[]"), e1.autoFlip = !0;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "LT[]", r, o), t.push(o < r ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "LTEQ[]", r, o), t.push(o <= r ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "GT[]", r, o), t.push(r < o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "GTEQ[]", r, o), t.push(r <= o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "EQ[]", r, o), t.push(r === o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "NEQ[]", r, o), t.push(r !== o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "ODD[]", r), t.push(Math.trunc(r) % 2 ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "EVEN[]", r), t.push(Math.trunc(r) % 2 ? 0 : 1);
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "IF[]", t), t || (Qt(e1, !0), j.DEBUG && console.log(e1.step, "EIF[]"));
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "EIF[]");
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "AND[]", r, o), t.push(r && o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "OR[]", r, o), t.push(r || o ? 1 : 0);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "NOT[]", r), t.push(r ? 0 : 1);
                            },
                            fr.bind(void 0, 1),
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SDB[]", t), e1.deltaBase = t;
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SDS[]", t), e1.deltaShift = Math.pow(.5, t);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "ADD[]", r, o), t.push(o + r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "SUB[]", r, o), t.push(o - r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "DIV[]", r, o), t.push(64 * o / r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "MUL[]", r, o), t.push(o * r / 64);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "ABS[]", r), t.push(Math.abs(r));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "NEG[]", r), t.push(-r);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "FLOOR[]", r), t.push(64 * Math.floor(r / 64));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop();
                                j.DEBUG && console.log(e1.step, "CEILING[]", r), t.push(64 * Math.ceil(r / 64));
                            },
                            hr.bind(void 0, 0),
                            hr.bind(void 0, 1),
                            hr.bind(void 0, 2),
                            hr.bind(void 0, 3),
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = (r = e1.stack).pop(), r = r.pop();
                                j.DEBUG && console.log(e1.step, "WCVTF[]", t, r), e1.cvt[r] = t * e1.ppem / e1.font.unitsPerEm;
                            },
                            fr.bind(void 0, 2),
                            fr.bind(void 0, 3),
                            pr.bind(void 0, 1),
                            pr.bind(void 0, 2),
                            pr.bind(void 0, 3),
                            function(e1) {
                                var t, r = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "SROUND[]", r), e1.round = Ht, 192 & r){
                                    case 0:
                                        t = .5;
                                        break;
                                    case 64:
                                        t = 1;
                                        break;
                                    case 128:
                                        t = 2;
                                        break;
                                    default:
                                        throw new Error("invalid SROUND value");
                                }
                                switch(e1.srPeriod = t, 48 & r){
                                    case 0:
                                        e1.srPhase = 0;
                                        break;
                                    case 16:
                                        e1.srPhase = .25 * t;
                                        break;
                                    case 32:
                                        e1.srPhase = .5 * t;
                                        break;
                                    case 48:
                                        e1.srPhase = .75 * t;
                                        break;
                                    default:
                                        throw new Error("invalid SROUND value");
                                }
                                e1.srThreshold = 0 === (r &= 15) ? 0 : (r / 8 - .5) * t;
                            },
                            function(e1) {
                                var t, r = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "S45ROUND[]", r), e1.round = Ht, 192 & r){
                                    case 0:
                                        t = Math.sqrt(2) / 2;
                                        break;
                                    case 64:
                                        t = Math.sqrt(2);
                                        break;
                                    case 128:
                                        t = 2 * Math.sqrt(2);
                                        break;
                                    default:
                                        throw new Error("invalid S45ROUND value");
                                }
                                switch(e1.srPeriod = t, 48 & r){
                                    case 0:
                                        e1.srPhase = 0;
                                        break;
                                    case 16:
                                        e1.srPhase = .25 * t;
                                        break;
                                    case 32:
                                        e1.srPhase = .5 * t;
                                        break;
                                    case 48:
                                        e1.srPhase = .75 * t;
                                        break;
                                    default:
                                        throw new Error("invalid S45ROUND value");
                                }
                                e1.srThreshold = 0 === (r &= 15) ? 0 : (r / 8 - .5) * t;
                            },
                            void 0,
                            void 0,
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "ROFF[]"), e1.round = Ut;
                            },
                            void 0,
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RUTG[]"), e1.round = Vt;
                            },
                            function(e1) {
                                j.DEBUG && console.log(e1.step, "RDTG[]"), e1.round = zt;
                            },
                            rr,
                            rr,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SCANCTRL[]", t);
                            },
                            mr.bind(void 0, 0),
                            mr.bind(void 0, 1),
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = 0;
                                j.DEBUG && console.log(e1.step, "GETINFO[]", r), 1 & r && (o = 35), 32 & r && (o |= 4096), t.push(o);
                            },
                            void 0,
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop(), n = t.pop();
                                j.DEBUG && console.log(e1.step, "ROLL[]"), t.push(o), t.push(r), t.push(n);
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "MAX[]", r, o), t.push(Math.max(o, r));
                            },
                            function(e1) {
                                var t = e1.stack, r = t.pop(), o = t.pop();
                                j.DEBUG && console.log(e1.step, "MIN[]", r, o), t.push(Math.min(o, r));
                            },
                            function(e1) {
                                var t = e1.stack.pop();
                                j.DEBUG && console.log(e1.step, "SCANTYPE[]", t);
                            },
                            function(e1) {
                                var t = e1.stack.pop(), r = e1.stack.pop();
                                switch(j.DEBUG && console.log(e1.step, "INSTCTRL[]", t, r), t){
                                    case 1:
                                        return void (e1.inhibitGridFit = !!r);
                                    case 2:
                                        return void (e1.ignoreCvt = !!r);
                                    default:
                                        throw new Error("invalid INSTCTRL[] selector");
                                }
                            },
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            void 0,
                            k.bind(void 0, 1),
                            k.bind(void 0, 2),
                            k.bind(void 0, 3),
                            k.bind(void 0, 4),
                            k.bind(void 0, 5),
                            k.bind(void 0, 6),
                            k.bind(void 0, 7),
                            k.bind(void 0, 8),
                            O.bind(void 0, 1),
                            O.bind(void 0, 2),
                            O.bind(void 0, 3),
                            O.bind(void 0, 4),
                            O.bind(void 0, 5),
                            O.bind(void 0, 6),
                            O.bind(void 0, 7),
                            O.bind(void 0, 8),
                            C.bind(void 0, 0, 0, 0, 0, 0),
                            C.bind(void 0, 0, 0, 0, 0, 1),
                            C.bind(void 0, 0, 0, 0, 0, 2),
                            C.bind(void 0, 0, 0, 0, 0, 3),
                            C.bind(void 0, 0, 0, 0, 1, 0),
                            C.bind(void 0, 0, 0, 0, 1, 1),
                            C.bind(void 0, 0, 0, 0, 1, 2),
                            C.bind(void 0, 0, 0, 0, 1, 3),
                            C.bind(void 0, 0, 0, 1, 0, 0),
                            C.bind(void 0, 0, 0, 1, 0, 1),
                            C.bind(void 0, 0, 0, 1, 0, 2),
                            C.bind(void 0, 0, 0, 1, 0, 3),
                            C.bind(void 0, 0, 0, 1, 1, 0),
                            C.bind(void 0, 0, 0, 1, 1, 1),
                            C.bind(void 0, 0, 0, 1, 1, 2),
                            C.bind(void 0, 0, 0, 1, 1, 3),
                            C.bind(void 0, 0, 1, 0, 0, 0),
                            C.bind(void 0, 0, 1, 0, 0, 1),
                            C.bind(void 0, 0, 1, 0, 0, 2),
                            C.bind(void 0, 0, 1, 0, 0, 3),
                            C.bind(void 0, 0, 1, 0, 1, 0),
                            C.bind(void 0, 0, 1, 0, 1, 1),
                            C.bind(void 0, 0, 1, 0, 1, 2),
                            C.bind(void 0, 0, 1, 0, 1, 3),
                            C.bind(void 0, 0, 1, 1, 0, 0),
                            C.bind(void 0, 0, 1, 1, 0, 1),
                            C.bind(void 0, 0, 1, 1, 0, 2),
                            C.bind(void 0, 0, 1, 1, 0, 3),
                            C.bind(void 0, 0, 1, 1, 1, 0),
                            C.bind(void 0, 0, 1, 1, 1, 1),
                            C.bind(void 0, 0, 1, 1, 1, 2),
                            C.bind(void 0, 0, 1, 1, 1, 3),
                            C.bind(void 0, 1, 0, 0, 0, 0),
                            C.bind(void 0, 1, 0, 0, 0, 1),
                            C.bind(void 0, 1, 0, 0, 0, 2),
                            C.bind(void 0, 1, 0, 0, 0, 3),
                            C.bind(void 0, 1, 0, 0, 1, 0),
                            C.bind(void 0, 1, 0, 0, 1, 1),
                            C.bind(void 0, 1, 0, 0, 1, 2),
                            C.bind(void 0, 1, 0, 0, 1, 3),
                            C.bind(void 0, 1, 0, 1, 0, 0),
                            C.bind(void 0, 1, 0, 1, 0, 1),
                            C.bind(void 0, 1, 0, 1, 0, 2),
                            C.bind(void 0, 1, 0, 1, 0, 3),
                            C.bind(void 0, 1, 0, 1, 1, 0),
                            C.bind(void 0, 1, 0, 1, 1, 1),
                            C.bind(void 0, 1, 0, 1, 1, 2),
                            C.bind(void 0, 1, 0, 1, 1, 3),
                            C.bind(void 0, 1, 1, 0, 0, 0),
                            C.bind(void 0, 1, 1, 0, 0, 1),
                            C.bind(void 0, 1, 1, 0, 0, 2),
                            C.bind(void 0, 1, 1, 0, 0, 3),
                            C.bind(void 0, 1, 1, 0, 1, 0),
                            C.bind(void 0, 1, 1, 0, 1, 1),
                            C.bind(void 0, 1, 1, 0, 1, 2),
                            C.bind(void 0, 1, 1, 0, 1, 3),
                            C.bind(void 0, 1, 1, 1, 0, 0),
                            C.bind(void 0, 1, 1, 1, 0, 1),
                            C.bind(void 0, 1, 1, 1, 0, 2),
                            C.bind(void 0, 1, 1, 1, 0, 3),
                            C.bind(void 0, 1, 1, 1, 1, 0),
                            C.bind(void 0, 1, 1, 1, 1, 1),
                            C.bind(void 0, 1, 1, 1, 1, 2),
                            C.bind(void 0, 1, 1, 1, 1, 3)
                        ], jr = Array.from || function(e1) {
                            return e1.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]?|[^\uD800-\uDFFF]|./g) || [];
                        };
                        function A(e1) {
                            (e1 = e1 || {}).empty || (_(e1.familyName, "When creating a new Font object, familyName is required."), _(e1.styleName, "When creating a new Font object, styleName is required."), _(e1.unitsPerEm, "When creating a new Font object, unitsPerEm is required."), _(e1.ascender, "When creating a new Font object, ascender is required."), _(e1.descender, "When creating a new Font object, descender is required."), _(e1.descender < 0, "Descender should be negative (e.g. -512)."), this.names = {
                                fontFamily: {
                                    en: e1.familyName || " "
                                },
                                fontSubfamily: {
                                    en: e1.styleName || " "
                                },
                                fullName: {
                                    en: e1.fullName || e1.familyName + " " + e1.styleName
                                },
                                postScriptName: {
                                    en: e1.postScriptName || (e1.familyName + e1.styleName).replace(/\s/g, "")
                                },
                                designer: {
                                    en: e1.designer || " "
                                },
                                designerURL: {
                                    en: e1.designerURL || " "
                                },
                                manufacturer: {
                                    en: e1.manufacturer || " "
                                },
                                manufacturerURL: {
                                    en: e1.manufacturerURL || " "
                                },
                                license: {
                                    en: e1.license || " "
                                },
                                licenseURL: {
                                    en: e1.licenseURL || " "
                                },
                                version: {
                                    en: e1.version || "Version 0.1"
                                },
                                description: {
                                    en: e1.description || " "
                                },
                                copyright: {
                                    en: e1.copyright || " "
                                },
                                trademark: {
                                    en: e1.trademark || " "
                                }
                            }, this.unitsPerEm = e1.unitsPerEm || 1e3, this.ascender = e1.ascender, this.descender = e1.descender, this.createdTimestamp = e1.createdTimestamp, this.tables = {
                                os2: {
                                    usWeightClass: e1.weightClass || this.usWeightClasses.MEDIUM,
                                    usWidthClass: e1.widthClass || this.usWidthClasses.MEDIUM,
                                    fsSelection: e1.fsSelection || this.fsSelectionValues.REGULAR
                                }
                            }), this.supported = !0, this.glyphs = new p.GlyphSet(this, e1.glyphs || []), this.encoding = new Te(this), this.position = new kt(this), this.substitution = new i(this), this.tables = this.tables || {}, Object.defineProperty(this, "hinting", {
                                get: function() {
                                    return this._hinting || ("truetype" === this.outlinesFormat ? this._hinting = new Ft(this) : void 0);
                                }
                            });
                        }
                        function _r(e1, t) {
                            var r, o = JSON.stringify(e1), n = 256;
                            for(r in t){
                                var s = parseInt(r);
                                if (s && !(s < 256)) {
                                    if (JSON.stringify(t[r]) === o) return s;
                                    n <= s && (n = s + 1);
                                }
                            }
                            return t[n] = e1, n;
                        }
                        A.prototype.hasChar = function(e1) {
                            return null !== this.encoding.charToGlyphIndex(e1);
                        }, A.prototype.charToGlyphIndex = function(e1) {
                            return this.encoding.charToGlyphIndex(e1);
                        }, A.prototype.charToGlyph = function(e1) {
                            e1 = this.charToGlyphIndex(e1);
                            return this.glyphs.get(e1) || this.glyphs.get(0);
                        }, A.prototype.stringToGlyphs = function(e1, t) {
                            t = t || this.defaultRenderOptions;
                            for(var r = jr(e1), o = [], n = 0; n < r.length; n += 1){
                                var s = r[n];
                                o.push(this.charToGlyphIndex(s));
                            }
                            var i = o.length;
                            if (t.features) {
                                var e1 = t.script || this.substitution.getDefaultScriptName(), a = [];
                                t.features.liga && (a = a.concat(this.substitution.getFeature("liga", e1, t.language))), t.features.rlig && (a = a.concat(this.substitution.getFeature("rlig", e1, t.language)));
                                for(var l = 0; l < i; l += 1)for(var u = 0; u < a.length; u++){
                                    for(var c = a[u], d = c.sub, f = d.length, h = 0; h < f && d[h] === o[l + h];)h++;
                                    h === f && (o.splice(l, f, c.by), i = i - f + 1);
                                }
                            }
                            for(var p = new Array(i), m = this.glyphs.get(0), y = 0; y < i; y += 1)p[y] = this.glyphs.get(o[y]) || m;
                            return p;
                        }, A.prototype.nameToGlyphIndex = function(e1) {
                            return this.glyphNames.nameToGlyphIndex(e1);
                        }, A.prototype.nameToGlyph = function(e1) {
                            e1 = this.nameToGlyphIndex(e1);
                            return this.glyphs.get(e1) || this.glyphs.get(0);
                        }, A.prototype.glyphIndexToName = function(e1) {
                            return this.glyphNames.glyphIndexToName ? this.glyphNames.glyphIndexToName(e1) : "";
                        }, A.prototype.getKerningValue = function(e1, t) {
                            e1 = e1.index || e1, t = t.index || t;
                            var r = this.position.defaultKerningTables;
                            return r ? this.position.getKerningValue(r, e1, t) : this.kerningPairs[e1 + "," + t] || 0;
                        }, A.prototype.defaultRenderOptions = {
                            kerning: !0,
                            features: {
                                liga: !0,
                                rlig: !0
                            }
                        }, A.prototype.forEachGlyph = function(e1, t, r, o, n, s) {
                            t = void 0 !== t ? t : 0, r = void 0 !== r ? r : 0, n = n || this.defaultRenderOptions;
                            var i, a = 1 / this.unitsPerEm * (o = void 0 !== o ? o : 72), l = this.stringToGlyphs(e1, n);
                            n.kerning && (e1 = n.script || this.position.getDefaultScriptName(), i = this.position.getKerningTables(e1, n.language));
                            for(var u = 0; u < l.length; u += 1){
                                var c = l[u];
                                s.call(this, c, t, r, o, n), c.advanceWidth && (t += c.advanceWidth * a), n.kerning && u < l.length - 1 && (t += (i ? this.position.getKerningValue(i, c.index, l[u + 1].index) : this.getKerningValue(c, l[u + 1])) * a), n.letterSpacing ? t += n.letterSpacing * o : n.tracking && (t += n.tracking / 1e3 * o);
                            }
                            return t;
                        }, A.prototype.getPath = function(e1, t, r, o, n) {
                            var s = new f;
                            return this.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                e1 = e1.getPath(t, r, o, n, this);
                                s.extend(e1);
                            }), s;
                        }, A.prototype.getPaths = function(e1, t, r, o, n) {
                            var s = [];
                            return this.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                e1 = e1.getPath(t, r, o, n, this);
                                s.push(e1);
                            }), s;
                        }, A.prototype.getAdvanceWidth = function(e1, t, r) {
                            return this.forEachGlyph(e1, 0, 0, t, r, function() {});
                        }, A.prototype.draw = function(e1, t, r, o, n, s) {
                            this.getPath(t, r, o, n, s).draw(e1);
                        }, A.prototype.drawPoints = function(n, e1, t, r, o, s) {
                            this.forEachGlyph(e1, t, r, o, s, function(e1, t, r, o) {
                                e1.drawPoints(n, t, r, o);
                            });
                        }, A.prototype.drawMetrics = function(n, e1, t, r, o, s) {
                            this.forEachGlyph(e1, t, r, o, s, function(e1, t, r, o) {
                                e1.drawMetrics(n, t, r, o);
                            });
                        }, A.prototype.getEnglishName = function(e1) {
                            e1 = this.names[e1];
                            if (e1) return e1.en;
                        }, A.prototype.validate = function() {
                            var t = this;
                            function e1(e1) {
                                e1 = t.getEnglishName(e1);
                                e1 && e1.trim().length;
                            }
                            e1("fontFamily"), e1("weightName"), e1("manufacturer"), e1("copyright"), e1("version"), this.unitsPerEm;
                        }, A.prototype.toTables = function() {
                            return wt.fontToTable(this);
                        }, A.prototype.toBuffer = function() {
                            return console.warn("Font.toBuffer is deprecated. Use Font.toArrayBuffer instead."), this.toArrayBuffer();
                        }, A.prototype.toArrayBuffer = function() {
                            for(var e1 = this.toTables().encode(), t = new ArrayBuffer(e1.length), r = new Uint8Array(t), o = 0; o < e1.length; o++)r[o] = e1[o];
                            return t;
                        }, A.prototype.download = function(t) {
                            var e1 = this.getEnglishName("fontFamily"), r = this.getEnglishName("fontSubfamily"), o = (t = t || e1.replace(/\s/g, "") + "-" + r + ".otf", this.toArrayBuffer());
                            "undefined" != typeof window ? (window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem, window.requestFileSystem(window.TEMPORARY, o.byteLength, function(e1) {
                                e1.root.getFile(t, {
                                    create: !0
                                }, function(r) {
                                    r.createWriter(function(e1) {
                                        var t = new DataView(o), t = new Blob([
                                            t
                                        ], {
                                            type: "font/opentype"
                                        });
                                        e1.write(t), e1.addEventListener("writeend", function() {
                                            location.href = r.toURL();
                                        }, !1);
                                    });
                                });
                            }, function(e1) {
                                throw new Error(e1.name + ": " + e1.message);
                            })) : (e1 = Pr("fs"), r = function(e1) {
                                for(var t = new Ar(e1.byteLength), r = new Uint8Array(e1), o = 0; o < t.length; ++o)t[o] = r[o];
                                return t;
                            }(o), e1.writeFileSync(t, r));
                        }, A.prototype.fsSelectionValues = {
                            ITALIC: 1,
                            UNDERSCORE: 2,
                            NEGATIVE: 4,
                            OUTLINED: 8,
                            STRIKEOUT: 16,
                            BOLD: 32,
                            REGULAR: 64,
                            USER_TYPO_METRICS: 128,
                            WWS: 256,
                            OBLIQUE: 512
                        }, A.prototype.usWidthClasses = {
                            ULTRA_CONDENSED: 1,
                            EXTRA_CONDENSED: 2,
                            CONDENSED: 3,
                            SEMI_CONDENSED: 4,
                            MEDIUM: 5,
                            SEMI_EXPANDED: 6,
                            EXPANDED: 7,
                            EXTRA_EXPANDED: 8,
                            ULTRA_EXPANDED: 9
                        }, A.prototype.usWeightClasses = {
                            THIN: 100,
                            EXTRA_LIGHT: 200,
                            LIGHT: 300,
                            NORMAL: 400,
                            MEDIUM: 500,
                            SEMI_BOLD: 600,
                            BOLD: 700,
                            EXTRA_BOLD: 800,
                            BLACK: 900
                        };
                        var xr = {
                            make: function(e1, t) {
                                var r = new S.Table("fvar", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "offsetToData",
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "countSizePairs",
                                        type: "USHORT",
                                        value: 2
                                    },
                                    {
                                        name: "axisCount",
                                        type: "USHORT",
                                        value: e1.axes.length
                                    },
                                    {
                                        name: "axisSize",
                                        type: "USHORT",
                                        value: 20
                                    },
                                    {
                                        name: "instanceCount",
                                        type: "USHORT",
                                        value: e1.instances.length
                                    },
                                    {
                                        name: "instanceSize",
                                        type: "USHORT",
                                        value: 4 + 4 * e1.axes.length
                                    }
                                ]);
                                r.offsetToData = r.sizeOf();
                                for(var o, n, s, i = 0; i < e1.axes.length; i++)r.fields = r.fields.concat((o = i, n = e1.axes[i], s = t, s = _r(n.name, t), [
                                    {
                                        name: "tag_" + o,
                                        type: "TAG",
                                        value: n.tag
                                    },
                                    {
                                        name: "minValue_" + o,
                                        type: "FIXED",
                                        value: n.minValue << 16
                                    },
                                    {
                                        name: "defaultValue_" + o,
                                        type: "FIXED",
                                        value: n.defaultValue << 16
                                    },
                                    {
                                        name: "maxValue_" + o,
                                        type: "FIXED",
                                        value: n.maxValue << 16
                                    },
                                    {
                                        name: "flags_" + o,
                                        type: "USHORT",
                                        value: 0
                                    },
                                    {
                                        name: "nameID_" + o,
                                        type: "USHORT",
                                        value: s
                                    }
                                ]));
                                for(var a = 0; a < e1.instances.length; a++)r.fields = r.fields.concat(function(e1, t, r, o) {
                                    for(var n = [
                                        {
                                            name: "nameID_" + e1,
                                            type: "USHORT",
                                            value: _r(t.name, o)
                                        },
                                        {
                                            name: "flags_" + e1,
                                            type: "USHORT",
                                            value: 0
                                        }
                                    ], s = 0; s < r.length; ++s){
                                        var i = r[s].tag;
                                        n.push({
                                            name: "axis_" + e1 + " " + i,
                                            type: "FIXED",
                                            value: t.coordinates[i] << 16
                                        });
                                    }
                                    return n;
                                }(a, e1.instances[a], e1.axes, t));
                                return r;
                            },
                            parse: function(e1, t, r) {
                                for(var o, n, s, i, a = new R.Parser(e1, t), l = a.parseULong(), u = (L.argument(65536 === l, "Unsupported fvar table version."), a.parseOffset16()), c = (a.skip("uShort", 1), a.parseUShort()), d = a.parseUShort(), f = a.parseUShort(), h = a.parseUShort(), p = [], m = 0; m < c; m++)p.push((o = e1, n = t + u + m * d, s = r, i = {}, o = new R.Parser(o, n), i.tag = o.parseTag(), i.minValue = o.parseFixed(), i.defaultValue = o.parseFixed(), i.maxValue = o.parseFixed(), o.skip("uShort", 1), i.name = s[o.parseUShort()] || {}, i));
                                for(var y = [], g = t + u + c * d, v = 0; v < f; v++)y.push(function(e1, t, r, o) {
                                    var n = {}, s = new R.Parser(e1, t);
                                    n.name = o[s.parseUShort()] || {}, s.skip("uShort", 1), n.coordinates = {};
                                    for(var i = 0; i < r.length; ++i)n.coordinates[r[i].tag] = s.parseFixed();
                                    return n;
                                }(e1, g + v * h, p, r));
                                return {
                                    axes: p,
                                    instances: y
                                };
                            }
                        }, P = new Array(10);
                        P[1] = function() {
                            var e1 = this.offset + this.relativeOffset, t = this.parseUShort();
                            return 1 === t ? {
                                posFormat: 1,
                                coverage: this.parsePointer(u.coverage),
                                value: this.parseValueRecord()
                            } : 2 === t ? {
                                posFormat: 2,
                                coverage: this.parsePointer(u.coverage),
                                values: this.parseValueRecordList()
                            } : void L.assert(!1, "0x" + e1.toString(16) + ": GPOS lookup type 1 format must be 1 or 2.");
                        }, P[2] = function() {
                            var e1, t, r, o, n = this.offset + this.relativeOffset, s = this.parseUShort(), n = (L.assert(1 === s || 2 === s, "0x" + n.toString(16) + ": GPOS lookup type 2 format must be 1 or 2."), this.parsePointer(u.coverage)), i = this.parseUShort(), a = this.parseUShort();
                            return 1 === s ? {
                                posFormat: s,
                                coverage: n,
                                valueFormat1: i,
                                valueFormat2: a,
                                pairSets: this.parseList(u.pointer(u.list(function() {
                                    return {
                                        secondGlyph: this.parseUShort(),
                                        value1: this.parseValueRecord(i),
                                        value2: this.parseValueRecord(a)
                                    };
                                })))
                            } : 2 === s ? (e1 = this.parsePointer(u.classDef), t = this.parsePointer(u.classDef), r = this.parseUShort(), o = this.parseUShort(), {
                                posFormat: s,
                                coverage: n,
                                valueFormat1: i,
                                valueFormat2: a,
                                classDef1: e1,
                                classDef2: t,
                                class1Count: r,
                                class2Count: o,
                                classRecords: this.parseList(r, u.list(o, function() {
                                    return {
                                        value1: this.parseValueRecord(i),
                                        value2: this.parseValueRecord(a)
                                    };
                                }))
                            }) : void 0;
                        }, P[3] = function() {
                            return {
                                error: "GPOS Lookup 3 not supported"
                            };
                        }, P[4] = function() {
                            return {
                                error: "GPOS Lookup 4 not supported"
                            };
                        }, P[5] = function() {
                            return {
                                error: "GPOS Lookup 5 not supported"
                            };
                        }, P[6] = function() {
                            return {
                                error: "GPOS Lookup 6 not supported"
                            };
                        }, P[7] = function() {
                            return {
                                error: "GPOS Lookup 7 not supported"
                            };
                        }, P[8] = function() {
                            return {
                                error: "GPOS Lookup 8 not supported"
                            };
                        }, P[9] = function() {
                            return {
                                error: "GPOS Lookup 9 not supported"
                            };
                        };
                        var wr = new Array(10);
                        var Sr = {
                            parse: function(e1, t) {
                                return t = (e1 = new u(e1, t = t || 0)).parseVersion(1), L.argument(1 === t || 1.1 === t, "Unsupported GPOS table version " + t), 1 === t ? {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(P)
                                } : {
                                    version: t,
                                    scripts: e1.parseScriptList(),
                                    features: e1.parseFeatureList(),
                                    lookups: e1.parseLookupList(P),
                                    variations: e1.parseFeatureVariationsList()
                                };
                            },
                            make: function(e1) {
                                return new S.Table("GPOS", [
                                    {
                                        name: "version",
                                        type: "ULONG",
                                        value: 65536
                                    },
                                    {
                                        name: "scripts",
                                        type: "TABLE",
                                        value: new S.ScriptList(e1.scripts)
                                    },
                                    {
                                        name: "features",
                                        type: "TABLE",
                                        value: new S.FeatureList(e1.features)
                                    },
                                    {
                                        name: "lookups",
                                        type: "TABLE",
                                        value: new S.LookupList(e1.lookups, wr)
                                    }
                                ]);
                            }
                        };
                        var Er = {
                            parse: function(e1, t) {
                                if (e1 = new R.Parser(e1, t), 0 === (t = e1.parseUShort())) {
                                    var r = e1, o = {}, n = (r.skip("uShort"), r.parseUShort()), s = (L.argument(0 === n, "Unsupported kern sub-table version."), r.skip("uShort", 2), r.parseUShort());
                                    r.skip("uShort", 3);
                                    for(var i = 0; i < s; i += 1){
                                        var a = r.parseUShort(), l = r.parseUShort(), u = r.parseShort();
                                        o[a + "," + l] = u;
                                    }
                                    return o;
                                }
                                if (1 !== t) throw new Error("Unsupported kern table version (" + t + ").");
                                var c = e1, d = {}, n = (c.skip("uShort"), 1 < c.parseULong() && console.warn("Only the first kern subtable is supported."), c.skip("uLong"), 255 & c.parseUShort());
                                if (c.skip("uShort"), 0 == n) {
                                    var f = c.parseUShort();
                                    c.skip("uShort", 3);
                                    for(var h = 0; h < f; h += 1){
                                        var p = c.parseUShort(), m = c.parseUShort(), y = c.parseShort();
                                        d[p + "," + m] = y;
                                    }
                                }
                                return d;
                            }
                        };
                        var Mr = {
                            parse: function(e1, t, r, o) {
                                for(var n = new R.Parser(e1, t), s = o ? n.parseUShort : n.parseULong, i = [], a = 0; a < r + 1; a += 1){
                                    var l = s.call(n);
                                    o && (l *= 2), i.push(l);
                                }
                                return i;
                            }
                        };
                        function Tr(e1, r) {
                            Pr("fs").readFile(e1, function(e1, t) {
                                if (e1) return r(e1.message);
                                r(null, Ct(t));
                            });
                        }
                        function kr(e1, t) {
                            var r = new XMLHttpRequest;
                            r.open("get", e1, !0), r.responseType = "arraybuffer", r.onload = function() {
                                return r.response ? t(null, r.response) : t("Font could not be loaded: " + r.statusText);
                            }, r.onerror = function() {
                                t("Font could not be loaded");
                            }, r.send();
                        }
                        function Or(e1, t) {
                            for(var r = [], o = 12, n = 0; n < t; n += 1){
                                var s = R.getTag(e1, o), i = R.getULong(e1, o + 4), a = R.getULong(e1, o + 8), l = R.getULong(e1, o + 12);
                                r.push({
                                    tag: s,
                                    checksum: i,
                                    offset: a,
                                    length: l,
                                    compression: !1
                                }), o += 16;
                            }
                            return r;
                        }
                        function I(e1, t) {
                            if ("WOFF" !== t.compression) return {
                                data: e1,
                                offset: t.offset
                            };
                            var e1 = new Uint8Array(e1.buffer, t.offset + 2, t.compressedLength - 2), r = new Uint8Array(t.length);
                            if (re(e1, r), r.byteLength !== t.length) throw new Error("Decompression error: " + t.tag + " decompressed length doesn't match recorded length");
                            return {
                                data: new DataView(r.buffer, 0),
                                offset: 0
                            };
                        }
                        function Cr(e1) {
                            var t, r, o, n, s, i, a, l, u, c, d, f, h, p, m = new A({
                                empty: !0
                            }), y = new DataView(e1, 0), g = [], e1 = R.getTag(y, 0);
                            if (e1 === String.fromCharCode(0, 1, 0, 0) || "true" === e1 || "typ1" === e1) m.outlinesFormat = "truetype", g = Or(y, o = R.getUShort(y, 4));
                            else if ("OTTO" === e1) m.outlinesFormat = "cff", g = Or(y, o = R.getUShort(y, 4));
                            else {
                                if ("wOFF" !== e1) throw new Error("Unsupported OpenType signature " + e1);
                                var v = R.getTag(y, 4);
                                if (v === String.fromCharCode(0, 1, 0, 0)) m.outlinesFormat = "truetype";
                                else {
                                    if ("OTTO" !== v) throw new Error("Unsupported OpenType flavor " + e1);
                                    m.outlinesFormat = "cff";
                                }
                                g = function(e1, t) {
                                    for(var r = [], o = 44, n = 0; n < t; n += 1){
                                        var s = R.getTag(e1, o), i = R.getULong(e1, o + 4), a = R.getULong(e1, o + 8), l = R.getULong(e1, o + 12), u = void 0, u = a < l && "WOFF";
                                        r.push({
                                            tag: s,
                                            offset: i,
                                            compression: u,
                                            compressedLength: a,
                                            length: l
                                        }), o += 20;
                                    }
                                    return r;
                                }(y, o = R.getUShort(y, 12));
                            }
                            for(var b = 0; b < o; b += 1){
                                var j = g[b], _ = void 0;
                                switch(j.tag){
                                    case "cmap":
                                        _ = I(y, j), m.tables.cmap = we.parse(_.data, _.offset), m.encoding = new ke(m.tables.cmap);
                                        break;
                                    case "cvt ":
                                        _ = I(y, j), p = new R.Parser(_.data, _.offset), m.tables.cvt = p.parseShortList(j.length / 2);
                                        break;
                                    case "fvar":
                                        s = j;
                                        break;
                                    case "fpgm":
                                        _ = I(y, j), p = new R.Parser(_.data, _.offset), m.tables.fpgm = p.parseByteList(j.length);
                                        break;
                                    case "head":
                                        _ = I(y, j), m.tables.head = Ze.parse(_.data, _.offset), m.unitsPerEm = m.tables.head.unitsPerEm, t = m.tables.head.indexToLocFormat;
                                        break;
                                    case "hhea":
                                        _ = I(y, j), m.tables.hhea = Qe.parse(_.data, _.offset), m.ascender = m.tables.hhea.ascender, m.descender = m.tables.hhea.descender, m.numberOfHMetrics = m.tables.hhea.numberOfHMetrics;
                                        break;
                                    case "hmtx":
                                        u = j;
                                        break;
                                    case "ltag":
                                        _ = I(y, j), r = Ke.parse(_.data, _.offset);
                                        break;
                                    case "maxp":
                                        _ = I(y, j), m.tables.maxp = $e.parse(_.data, _.offset), m.numGlyphs = m.tables.maxp.numGlyphs;
                                        break;
                                    case "name":
                                        f = j;
                                        break;
                                    case "OS/2":
                                        _ = I(y, j), m.tables.os2 = ht.parse(_.data, _.offset);
                                        break;
                                    case "post":
                                        _ = I(y, j), m.tables.post = pt.parse(_.data, _.offset), m.glyphNames = new Ce(m.tables.post);
                                        break;
                                    case "prep":
                                        _ = I(y, j), p = new R.Parser(_.data, _.offset), m.tables.prep = p.parseByteList(j.length);
                                        break;
                                    case "glyf":
                                        i = j;
                                        break;
                                    case "loca":
                                        d = j;
                                        break;
                                    case "CFF ":
                                        n = j;
                                        break;
                                    case "kern":
                                        c = j;
                                        break;
                                    case "GPOS":
                                        a = j;
                                        break;
                                    case "GSUB":
                                        l = j;
                                        break;
                                    case "meta":
                                        h = j;
                                }
                            }
                            v = I(y, f);
                            if (m.tables.name = dt.parse(v.data, v.offset, r), m.names = m.tables.name, i && d) {
                                e1 = 0 === t, v = I(y, d), v = Mr.parse(v.data, v.offset, m.numGlyphs, e1), e1 = I(y, i);
                                m.glyphs = Dt.parse(e1.data, e1.offset, v, m);
                            } else {
                                if (!n) throw new Error("Font doesn't contain TrueType or CFF outlines.");
                                e1 = I(y, n);
                                Ye.parse(e1.data, e1.offset, m);
                            }
                            for(var v = I(y, u), x = (Je.parse(v.data, v.offset, m.numberOfHMetrics, m.numGlyphs, m.glyphs), m), w = x.tables.cmap.glyphIndexMap, S = Object.keys(w), E = 0; E < S.length; E += 1){
                                var M, T = S[E], k = w[T];
                                (M = x.glyphs.get(k)).addUnicode(parseInt(T));
                            }
                            for(var O = 0; O < x.glyphs.length; O += 1)M = x.glyphs.get(O), x.cffEncoding ? x.isCIDFont ? M.name = "gid" + O : M.name = x.cffEncoding.charset[O] : x.glyphNames.names && (M.name = x.glyphNames.glyphIndexToName(O));
                            return c ? (e1 = I(y, c), m.kerningPairs = Er.parse(e1.data, e1.offset)) : m.kerningPairs = {}, a && (v = I(y, a), m.tables.gpos = Sr.parse(v.data, v.offset), m.position.init()), l && (e1 = I(y, l), m.tables.gsub = yt.parse(e1.data, e1.offset)), s && (v = I(y, s), m.tables.fvar = xr.parse(v.data, v.offset, m.names)), h && (e1 = I(y, h), m.tables.meta = gt.parse(e1.data, e1.offset), m.metas = m.tables.meta), m;
                        }
                        j.Font = A, j.Glyph = h, j.Path = f, j.BoundingBox = a, j._parse = R, j.parse = Cr, j.load = function(e1, o) {
                            ("undefined" == typeof window ? Tr : kr)(e1, function(e1, t) {
                                if (e1) return o(e1);
                                var r;
                                try {
                                    r = Cr(t);
                                } catch (e1) {
                                    return o(e1, null);
                                }
                                return o(null, r);
                            });
                        }, j.loadSync = function(e1) {
                            return Cr(Ct(Pr("fs").readFileSync(e1)));
                        }, Object.defineProperty(j, "__esModule", {
                            value: !0
                        });
                    }, "object" == typeof o && void 0 !== r ? t(o) : "function" == typeof s && s.amd ? s([
                        "exports"
                    ], t) : t(e1.opentype = {});
                }).call(this, Pr("buffer").Buffer);
            },
            {
                buffer: 4,
                fs: 2
            }
        ],
        248: [
            function(e1, t, u) {
                (function(n) {
                    function s(e1, t) {
                        for(var r = 0, o = e1.length - 1; 0 <= o; o--){
                            var n = e1[o];
                            "." === n ? e1.splice(o, 1) : ".." === n ? (e1.splice(o, 1), r++) : r && (e1.splice(o, 1), r--);
                        }
                        if (t) for(; r--;)e1.unshift("..");
                        return e1;
                    }
                    function i(e1, t) {
                        if (e1.filter) return e1.filter(t);
                        for(var r = [], o = 0; o < e1.length; o++)t(e1[o], o, e1) && r.push(e1[o]);
                        return r;
                    }
                    u.resolve = function() {
                        for(var e1 = "", t = !1, r = arguments.length - 1; -1 <= r && !t; r--){
                            var o = 0 <= r ? arguments[r] : n.cwd();
                            if ("string" != typeof o) throw new TypeError("Arguments to path.resolve must be strings");
                            o && (e1 = o + "/" + e1, t = "/" === o.charAt(0));
                        }
                        return (t ? "/" : "") + (e1 = s(i(e1.split("/"), function(e1) {
                            return !!e1;
                        }), !t).join("/")) || ".";
                    }, u.normalize = function(e1) {
                        var t = u.isAbsolute(e1), r = "/" === o(e1, -1);
                        return (e1 = (e1 = s(i(e1.split("/"), function(e1) {
                            return !!e1;
                        }), !t).join("/")) || t ? e1 : ".") && r && (e1 += "/"), (t ? "/" : "") + e1;
                    }, u.isAbsolute = function(e1) {
                        return "/" === e1.charAt(0);
                    }, u.join = function() {
                        var e1 = Array.prototype.slice.call(arguments, 0);
                        return u.normalize(i(e1, function(e1, t) {
                            if ("string" != typeof e1) throw new TypeError("Arguments to path.join must be strings");
                            return e1;
                        }).join("/"));
                    }, u.relative = function(e1, t) {
                        function r(e1) {
                            for(var t = 0; t < e1.length && "" === e1[t]; t++);
                            for(var r = e1.length - 1; 0 <= r && "" === e1[r]; r--);
                            return r < t ? [] : e1.slice(t, r - t + 1);
                        }
                        e1 = u.resolve(e1).substr(1), t = u.resolve(t).substr(1);
                        for(var o = r(e1.split("/")), n = r(t.split("/")), s = Math.min(o.length, n.length), i = s, a = 0; a < s; a++)if (o[a] !== n[a]) {
                            i = a;
                            break;
                        }
                        for(var l = [], a = i; a < o.length; a++)l.push("..");
                        return (l = l.concat(n.slice(i))).join("/");
                    }, u.sep = "/", u.delimiter = ":", u.dirname = function(e1) {
                        if ("string" != typeof e1 && (e1 += ""), 0 === e1.length) return ".";
                        for(var t = 47 === e1.charCodeAt(0), r = -1, o = !0, n = e1.length - 1; 1 <= n; --n)if (47 === e1.charCodeAt(n)) {
                            if (!o) {
                                r = n;
                                break;
                            }
                        } else o = !1;
                        return -1 === r ? t ? "/" : "." : t && 1 === r ? "/" : e1.slice(0, r);
                    }, u.basename = function(e1, t) {
                        e1 = function(e1) {
                            "string" != typeof e1 && (e1 += "");
                            for(var t = 0, r = -1, o = !0, n = e1.length - 1; 0 <= n; --n)if (47 === e1.charCodeAt(n)) {
                                if (!o) {
                                    t = n + 1;
                                    break;
                                }
                            } else -1 === r && (o = !1, r = n + 1);
                            return -1 === r ? "" : e1.slice(t, r);
                        }(e1);
                        return e1 = t && e1.substr(-1 * t.length) === t ? e1.substr(0, e1.length - t.length) : e1;
                    }, u.extname = function(e1) {
                        "string" != typeof e1 && (e1 += "");
                        for(var t = -1, r = 0, o = -1, n = !0, s = 0, i = e1.length - 1; 0 <= i; --i){
                            var a = e1.charCodeAt(i);
                            if (47 === a) {
                                if (n) continue;
                                r = i + 1;
                                break;
                            }
                            -1 === o && (n = !1, o = i + 1), 46 === a ? -1 === t ? t = i : 1 !== s && (s = 1) : -1 !== t && (s = -1);
                        }
                        return -1 === t || -1 === o || 0 === s || 1 === s && t === o - 1 && t === r + 1 ? "" : e1.slice(t, o);
                    };
                    var o = "b" === "ab".substr(-1) ? function(e1, t, r) {
                        return e1.substr(t, r);
                    } : function(e1, t, r) {
                        return t < 0 && (t = e1.length + t), e1.substr(t, r);
                    };
                }).call(this, e1("_process"));
            },
            {
                _process: 249
            }
        ],
        249: [
            function(e1, t, r) {
                var o, n, t = t.exports = {};
                function s() {
                    throw new Error("setTimeout has not been defined");
                }
                function i() {
                    throw new Error("clearTimeout has not been defined");
                }
                try {
                    o = "function" == typeof setTimeout ? setTimeout : s;
                } catch (e1) {
                    o = s;
                }
                try {
                    n = "function" == typeof clearTimeout ? clearTimeout : i;
                } catch (e1) {
                    n = i;
                }
                function a(t) {
                    if (o === setTimeout) return setTimeout(t, 0);
                    if ((o === s || !o) && setTimeout) return (o = setTimeout)(t, 0);
                    try {
                        return o(t, 0);
                    } catch (e1) {
                        try {
                            return o.call(null, t, 0);
                        } catch (e1) {
                            return o.call(this, t, 0);
                        }
                    }
                }
                var l, u = [], c = !1, d = -1;
                function f() {
                    c && l && (c = !1, l.length ? u = l.concat(u) : d = -1, u.length && h());
                }
                function h() {
                    if (!c) {
                        for(var e1 = a(f), t = (c = !0, u.length); t;){
                            for(l = u, u = []; ++d < t;)l && l[d].run();
                            d = -1, t = u.length;
                        }
                        l = null, c = !1, !function(t) {
                            if (n === clearTimeout) return clearTimeout(t);
                            if ((n === i || !n) && clearTimeout) return (n = clearTimeout)(t);
                            try {
                                n(t);
                            } catch (e1) {
                                try {
                                    return n.call(null, t);
                                } catch (e1) {
                                    return n.call(this, t);
                                }
                            }
                        }(e1);
                    }
                }
                function p(e1, t) {
                    this.fun = e1, this.array = t;
                }
                function m() {}
                t.nextTick = function(e1) {
                    var t = new Array(arguments.length - 1);
                    if (1 < arguments.length) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new p(e1, t)), 1 !== u.length || c || a(h);
                }, p.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, t.title = "browser", t.browser = !0, t.env = {}, t.argv = [], t.version = "", t.versions = {}, t.on = m, t.addListener = m, t.once = m, t.off = m, t.removeListener = m, t.removeAllListeners = m, t.emit = m, t.prependListener = m, t.prependOnceListener = m, t.listeners = function(e1) {
                    return [];
                }, t.binding = function(e1) {
                    throw new Error("process.binding is not supported");
                }, t.cwd = function() {
                    return "/";
                }, t.chdir = function(e1) {
                    throw new Error("process.chdir is not supported");
                }, t.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        250: [
            function(e1, t, r) {
                t = function(s) {
                    "use strict";
                    var l, e1 = Object.prototype, u = e1.hasOwnProperty, t = "function" == typeof Symbol ? Symbol : {}, o = t.iterator || "@@iterator", r = t.asyncIterator || "@@asyncIterator", n = t.toStringTag || "@@toStringTag";
                    function i(e1, t, r, o) {
                        var n, s, i, a, t = t && t.prototype instanceof y ? t : y, t = Object.create(t.prototype), o = new S(o || []);
                        return t._invoke = (n = e1, s = r, i = o, a = d, function(e1, t) {
                            if (a === h) throw new Error("Generator is already running");
                            if (a === p) {
                                if ("throw" === e1) throw t;
                                return M();
                            }
                            for(i.method = e1, i.arg = t;;){
                                var r = i.delegate;
                                if (r) {
                                    r = function e1(t, r) {
                                        var o = t.iterator[r.method];
                                        if (o === l) {
                                            if (r.delegate = null, "throw" === r.method) {
                                                if (t.iterator.return && (r.method = "return", r.arg = l, e1(t, r), "throw" === r.method)) return m;
                                                r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
                                            }
                                            return m;
                                        }
                                        o = c(o, t.iterator, r.arg);
                                        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, m;
                                        o = o.arg;
                                        if (!o) return r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m;
                                        if (!o.done) return o;
                                        r[t.resultName] = o.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = l);
                                        r.delegate = null;
                                        return m;
                                    }(r, i);
                                    if (r) {
                                        if (r === m) continue;
                                        return r;
                                    }
                                }
                                if ("next" === i.method) i.sent = i._sent = i.arg;
                                else if ("throw" === i.method) {
                                    if (a === d) throw a = p, i.arg;
                                    i.dispatchException(i.arg);
                                } else "return" === i.method && i.abrupt("return", i.arg);
                                a = h;
                                r = c(n, s, i);
                                if ("normal" === r.type) {
                                    if (a = i.done ? p : f, r.arg !== m) return {
                                        value: r.arg,
                                        done: i.done
                                    };
                                } else "throw" === r.type && (a = p, i.method = "throw", i.arg = r.arg);
                            }
                        }), t;
                    }
                    function c(e1, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, r)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    s.wrap = i;
                    var d = "suspendedStart", f = "suspendedYield", h = "executing", p = "completed", m = {};
                    function y() {}
                    function a() {}
                    function g() {}
                    var t = {}, v = (t[o] = function() {
                        return this;
                    }, Object.getPrototypeOf), v = v && v(v(E([]))), b = (v && v !== e1 && u.call(v, o) && (t = v), g.prototype = y.prototype = Object.create(t));
                    function j(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            e1[t] = function(e1) {
                                return this._invoke(t, e1);
                            };
                        });
                    }
                    function _(i) {
                        var t;
                        this._invoke = function(r, o) {
                            function e1() {
                                return new Promise(function(e1, t) {
                                    !function t(e1, r, o, n) {
                                        var s, e1 = c(i[e1], i, r);
                                        if ("throw" !== e1.type) return (r = (s = e1.arg).value) && "object" == typeof r && u.call(r, "__await") ? Promise.resolve(r.__await).then(function(e1) {
                                            t("next", e1, o, n);
                                        }, function(e1) {
                                            t("throw", e1, o, n);
                                        }) : Promise.resolve(r).then(function(e1) {
                                            s.value = e1, o(s);
                                        }, function(e1) {
                                            return t("throw", e1, o, n);
                                        });
                                        n(e1.arg);
                                    }(r, o, e1, t);
                                });
                            }
                            return t = t ? t.then(e1, e1) : e1();
                        };
                    }
                    function x(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function w(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function S(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(x, this), this.reset(!0);
                    }
                    function E(t) {
                        if (t) {
                            var r, e1 = t[o];
                            if (e1) return e1.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) return r = -1, (e1 = function e1() {
                                for(; ++r < t.length;)if (u.call(t, r)) return e1.value = t[r], e1.done = !1, e1;
                                return e1.value = l, e1.done = !0, e1;
                            }).next = e1;
                        }
                        return {
                            next: M
                        };
                    }
                    function M() {
                        return {
                            value: l,
                            done: !0
                        };
                    }
                    return (a.prototype = b.constructor = g).constructor = a, g[n] = a.displayName = "GeneratorFunction", s.isGeneratorFunction = function(e1) {
                        e1 = "function" == typeof e1 && e1.constructor;
                        return !!e1 && (e1 === a || "GeneratorFunction" === (e1.displayName || e1.name));
                    }, s.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, g) : (e1.__proto__ = g, n in e1 || (e1[n] = "GeneratorFunction")), e1.prototype = Object.create(b), e1;
                    }, s.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, j(_.prototype), _.prototype[r] = function() {
                        return this;
                    }, s.AsyncIterator = _, s.async = function(e1, t, r, o) {
                        var n = new _(i(e1, t, r, o));
                        return s.isGeneratorFunction(t) ? n : n.next().then(function(e1) {
                            return e1.done ? e1.value : n.next();
                        });
                    }, j(b), b[n] = "Generator", b[o] = function() {
                        return this;
                    }, b.toString = function() {
                        return "[object Generator]";
                    }, s.keys = function(r) {
                        var e1, o = [];
                        for(e1 in r)o.push(e1);
                        return o.reverse(), function e1() {
                            for(; o.length;){
                                var t = o.pop();
                                if (t in r) return e1.value = t, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, s.values = E, S.prototype = {
                        constructor: S,
                        reset: function(e1) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = l, this.done = !1, this.delegate = null, this.method = "next", this.arg = l, this.tryEntries.forEach(w), !e1) for(var t in this)"t" === t.charAt(0) && u.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = l);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(r) {
                            if (this.done) throw r;
                            var o = this;
                            function e1(e1, t) {
                                return s.type = "throw", s.arg = r, o.next = e1, t && (o.method = "next", o.arg = l), !!t;
                            }
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var n = this.tryEntries[t], s = n.completion;
                                if ("root" === n.tryLoc) return e1("end");
                                if (n.tryLoc <= this.prev) {
                                    var i = u.call(n, "catchLoc"), a = u.call(n, "finallyLoc");
                                    if (i && a) {
                                        if (this.prev < n.catchLoc) return e1(n.catchLoc, !0);
                                        if (this.prev < n.finallyLoc) return e1(n.finallyLoc);
                                    } else if (i) {
                                        if (this.prev < n.catchLoc) return e1(n.catchLoc, !0);
                                    } else {
                                        if (!a) throw new Error("try statement without catch or finally");
                                        if (this.prev < n.finallyLoc) return e1(n.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var r = this.tryEntries.length - 1; 0 <= r; --r){
                                var o = this.tryEntries[r];
                                if (o.tryLoc <= this.prev && u.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                    var n = o;
                                    break;
                                }
                            }
                            var s = (n = n && ("break" === e1 || "continue" === e1) && n.tryLoc <= t && t <= n.finallyLoc ? null : n) ? n.completion : {};
                            return s.type = e1, s.arg = t, n ? (this.method = "next", this.next = n.finallyLoc, m) : this.complete(s);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), m;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e1) return this.complete(r.completion, r.afterLoc), w(r), m;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; 0 <= t; --t){
                                var r, o, n = this.tryEntries[t];
                                if (n.tryLoc === e1) return "throw" === (r = n.completion).type && (o = r.arg, w(n)), o;
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e1, t, r) {
                            return this.delegate = {
                                iterator: E(e1),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = l), m;
                        }
                    }, s;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = t;
                } catch (e1) {
                    Function("r", "regeneratorRuntime = r")(t);
                }
            },
            {}
        ],
        251: [
            function(e1, t, r) {
                !function(e1) {
                    "use strict";
                    var t, r, i, o, n, s, a, l, u, c;
                    function d(e1) {
                        if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e1)) throw new TypeError("Invalid character in header field name");
                        return e1.toLowerCase();
                    }
                    function f(e1) {
                        return e1 = "string" != typeof e1 ? String(e1) : e1;
                    }
                    function h(t) {
                        var e1 = {
                            next: function() {
                                var e1 = t.shift();
                                return {
                                    done: void 0 === e1,
                                    value: e1
                                };
                            }
                        };
                        return r && (e1[Symbol.iterator] = function() {
                            return e1;
                        }), e1;
                    }
                    function p(t) {
                        this.map = {}, t instanceof p ? t.forEach(function(e1, t) {
                            this.append(t, e1);
                        }, this) : Array.isArray(t) ? t.forEach(function(e1) {
                            this.append(e1[0], e1[1]);
                        }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e1) {
                            this.append(e1, t[e1]);
                        }, this);
                    }
                    function m(e1) {
                        if (e1.bodyUsed) return Promise.reject(new TypeError("Already read"));
                        e1.bodyUsed = !0;
                    }
                    function y(r) {
                        return new Promise(function(e1, t) {
                            r.onload = function() {
                                e1(r.result);
                            }, r.onerror = function() {
                                t(r.error);
                            };
                        });
                    }
                    function g(e1) {
                        var t = new FileReader, r = y(t);
                        return t.readAsArrayBuffer(e1), r;
                    }
                    function v(e1) {
                        var t;
                        return e1.slice ? e1.slice(0) : ((t = new Uint8Array(e1.byteLength)).set(new Uint8Array(e1)), t.buffer);
                    }
                    function b() {
                        return this.bodyUsed = !1, this._initBody = function(e1) {
                            if (this._bodyInit = e1) {
                                if ("string" == typeof e1) this._bodyText = e1;
                                else if (i && Blob.prototype.isPrototypeOf(e1)) this._bodyBlob = e1;
                                else if (o && FormData.prototype.isPrototypeOf(e1)) this._bodyFormData = e1;
                                else if (t && URLSearchParams.prototype.isPrototypeOf(e1)) this._bodyText = e1.toString();
                                else if (n && i && a(e1)) this._bodyArrayBuffer = v(e1.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ]);
                                else {
                                    if (!n || !ArrayBuffer.prototype.isPrototypeOf(e1) && !l(e1)) throw new Error("unsupported BodyInit type");
                                    this._bodyArrayBuffer = v(e1);
                                }
                            } else this._bodyText = "";
                            this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : t && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                        }, i && (this.blob = function() {
                            var e1 = m(this);
                            if (e1) return e1;
                            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                            if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                this._bodyArrayBuffer
                            ]));
                            if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                            return Promise.resolve(new Blob([
                                this._bodyText
                            ]));
                        }, this.arrayBuffer = function() {
                            return this._bodyArrayBuffer ? m(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(g);
                        }), this.text = function() {
                            var e1, t, r = m(this);
                            if (r) return r;
                            if (this._bodyBlob) return r = this._bodyBlob, e1 = new FileReader, t = y(e1), e1.readAsText(r), t;
                            if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                                for(var t = new Uint8Array(e1), r = new Array(t.length), o = 0; o < t.length; o++)r[o] = String.fromCharCode(t[o]);
                                return r.join("");
                            }(this._bodyArrayBuffer));
                            if (this._bodyFormData) throw new Error("could not read FormData body as text");
                            return Promise.resolve(this._bodyText);
                        }, o && (this.formData = function() {
                            return this.text().then(_);
                        }), this.json = function() {
                            return this.text().then(JSON.parse);
                        }, this;
                    }
                    function j(e1, t) {
                        var r, o = (t = t || {}).body;
                        if (e1 instanceof j) {
                            if (e1.bodyUsed) throw new TypeError("Already read");
                            this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new p(e1.headers)), this.method = e1.method, this.mode = e1.mode, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                        } else this.url = String(e1);
                        if (this.credentials = t.credentials || this.credentials || "omit", !t.headers && this.headers || (this.headers = new p(t.headers)), this.method = (e1 = t.method || this.method || "GET", r = e1.toUpperCase(), -1 < u.indexOf(r) ? r : e1), this.mode = t.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                        this._initBody(o);
                    }
                    function _(e1) {
                        var r = new FormData;
                        return e1.trim().split("&").forEach(function(e1) {
                            var t;
                            e1 && (t = (e1 = e1.split("=")).shift().replace(/\+/g, " "), e1 = e1.join("=").replace(/\+/g, " "), r.append(decodeURIComponent(t), decodeURIComponent(e1)));
                        }), r;
                    }
                    function x(e1, t) {
                        t = t || {}, this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = 200 <= this.status && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new p(t.headers), this.url = t.url || "", this._initBody(e1);
                    }
                    e1.fetch || (t = "URLSearchParams" in e1, r = "Symbol" in e1 && "iterator" in Symbol, i = "FileReader" in e1 && "Blob" in e1 && function() {
                        try {
                            return new Blob, !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), o = "FormData" in e1, (n = "ArrayBuffer" in e1) && (s = [
                        "[object Int8Array]",
                        "[object Uint8Array]",
                        "[object Uint8ClampedArray]",
                        "[object Int16Array]",
                        "[object Uint16Array]",
                        "[object Int32Array]",
                        "[object Uint32Array]",
                        "[object Float32Array]",
                        "[object Float64Array]"
                    ], a = function(e1) {
                        return e1 && DataView.prototype.isPrototypeOf(e1);
                    }, l = ArrayBuffer.isView || function(e1) {
                        return e1 && -1 < s.indexOf(Object.prototype.toString.call(e1));
                    }), p.prototype.append = function(e1, t) {
                        e1 = d(e1), t = f(t);
                        var r = this.map[e1];
                        this.map[e1] = r ? r + "," + t : t;
                    }, p.prototype.delete = function(e1) {
                        delete this.map[d(e1)];
                    }, p.prototype.get = function(e1) {
                        return e1 = d(e1), this.has(e1) ? this.map[e1] : null;
                    }, p.prototype.has = function(e1) {
                        return this.map.hasOwnProperty(d(e1));
                    }, p.prototype.set = function(e1, t) {
                        this.map[d(e1)] = f(t);
                    }, p.prototype.forEach = function(e1, t) {
                        for(var r in this.map)this.map.hasOwnProperty(r) && e1.call(t, this.map[r], r, this);
                    }, p.prototype.keys = function() {
                        var r = [];
                        return this.forEach(function(e1, t) {
                            r.push(t);
                        }), h(r);
                    }, p.prototype.values = function() {
                        var t = [];
                        return this.forEach(function(e1) {
                            t.push(e1);
                        }), h(t);
                    }, p.prototype.entries = function() {
                        var r = [];
                        return this.forEach(function(e1, t) {
                            r.push([
                                t,
                                e1
                            ]);
                        }), h(r);
                    }, r && (p.prototype[Symbol.iterator] = p.prototype.entries), u = [
                        "DELETE",
                        "GET",
                        "HEAD",
                        "OPTIONS",
                        "POST",
                        "PUT"
                    ], j.prototype.clone = function() {
                        return new j(this, {
                            body: this._bodyInit
                        });
                    }, b.call(j.prototype), b.call(x.prototype), x.prototype.clone = function() {
                        return new x(this._bodyInit, {
                            status: this.status,
                            statusText: this.statusText,
                            headers: new p(this.headers),
                            url: this.url
                        });
                    }, x.error = function() {
                        var e1 = new x(null, {
                            status: 0,
                            statusText: ""
                        });
                        return e1.type = "error", e1;
                    }, c = [
                        301,
                        302,
                        303,
                        307,
                        308
                    ], x.redirect = function(e1, t) {
                        if (-1 === c.indexOf(t)) throw new RangeError("Invalid status code");
                        return new x(null, {
                            status: t,
                            headers: {
                                location: e1
                            }
                        });
                    }, e1.Headers = p, e1.Request = j, e1.Response = x, e1.fetch = function(r, s) {
                        return new Promise(function(o, e1) {
                            var t = new j(r, s), n = new XMLHttpRequest;
                            n.onload = function() {
                                var r, e1 = {
                                    status: n.status,
                                    statusText: n.statusText,
                                    headers: (e1 = n.getAllResponseHeaders() || "", r = new p, e1.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e1) {
                                        var e1 = e1.split(":"), t = e1.shift().trim();
                                        t && (e1 = e1.join(":").trim(), r.append(t, e1));
                                    }), r)
                                }, t = (e1.url = "responseURL" in n ? n.responseURL : e1.headers.get("X-Request-URL"), "response" in n ? n.response : n.responseText);
                                o(new x(t, e1));
                            }, n.onerror = function() {
                                e1(new TypeError("Network request failed"));
                            }, n.ontimeout = function() {
                                e1(new TypeError("Network request failed"));
                            }, n.open(t.method, t.url, !0), "include" === t.credentials ? n.withCredentials = !0 : "omit" === t.credentials && (n.withCredentials = !1), "responseType" in n && i && (n.responseType = "blob"), t.headers.forEach(function(e1, t) {
                                n.setRequestHeader(t, e1);
                            }), n.send(void 0 === t._bodyInit ? null : t._bodyInit);
                        });
                    }, e1.fetch.polyfill = !0);
                }("undefined" != typeof self ? self : this);
            },
            {}
        ],
        252: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l, o = n(e1("../core/main")), u = n(e1("../color/color_conversion"));
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                var c = [
                    {
                        h: 0,
                        s: 0,
                        b: .8275,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .8627,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .7529,
                        name: "gray"
                    },
                    {
                        h: .0167,
                        s: .1176,
                        b: 1,
                        name: "light pink"
                    }
                ], d = [
                    {
                        h: 0,
                        s: 0,
                        b: 0,
                        name: "black"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: .5,
                        name: "gray"
                    },
                    {
                        h: 0,
                        s: 0,
                        b: 1,
                        name: "white"
                    },
                    {
                        h: 0,
                        s: .5,
                        b: .5,
                        name: "dark maroon"
                    },
                    {
                        h: 0,
                        s: .5,
                        b: 1,
                        name: "salmon pink"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: 0,
                        name: "black"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: .5,
                        name: "dark red"
                    },
                    {
                        h: 0,
                        s: 1,
                        b: 1,
                        name: "red"
                    },
                    {
                        h: 5,
                        s: 0,
                        b: 1,
                        name: "very light peach"
                    },
                    {
                        h: 5,
                        s: .5,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 5,
                        s: .5,
                        b: 1,
                        name: "peach"
                    },
                    {
                        h: 5,
                        s: 1,
                        b: .5,
                        name: "brick red"
                    },
                    {
                        h: 5,
                        s: 1,
                        b: 1,
                        name: "crimson"
                    },
                    {
                        h: 10,
                        s: 0,
                        b: 1,
                        name: "light peach"
                    },
                    {
                        h: 10,
                        s: .5,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 10,
                        s: .5,
                        b: 1,
                        name: "light orange"
                    },
                    {
                        h: 10,
                        s: 1,
                        b: .5,
                        name: "brown"
                    },
                    {
                        h: 10,
                        s: 1,
                        b: 1,
                        name: "orange"
                    },
                    {
                        h: 15,
                        s: 0,
                        b: 1,
                        name: "very light yellow"
                    },
                    {
                        h: 15,
                        s: .5,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 15,
                        s: .5,
                        b: 1,
                        name: "light yellow"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: 0,
                        name: "dark olive green"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 15,
                        s: 1,
                        b: 1,
                        name: "yellow"
                    },
                    {
                        h: 20,
                        s: 0,
                        b: 1,
                        name: "very light yellow"
                    },
                    {
                        h: 20,
                        s: .5,
                        b: .5,
                        name: "olive green"
                    },
                    {
                        h: 20,
                        s: .5,
                        b: 1,
                        name: "light yellow green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: 0,
                        name: "dark olive green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: .5,
                        name: "dark yellow green"
                    },
                    {
                        h: 20,
                        s: 1,
                        b: 1,
                        name: "yellow green"
                    },
                    {
                        h: 25,
                        s: .5,
                        b: .5,
                        name: "dark yellow green"
                    },
                    {
                        h: 25,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 25,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 25,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 30,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 30,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 30,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 35,
                        s: 0,
                        b: .5,
                        name: "light green"
                    },
                    {
                        h: 35,
                        s: 0,
                        b: 1,
                        name: "very light green"
                    },
                    {
                        h: 35,
                        s: .5,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 35,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: 0,
                        name: "very dark green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 35,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 40,
                        s: 0,
                        b: 1,
                        name: "very light green"
                    },
                    {
                        h: 40,
                        s: .5,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 40,
                        s: .5,
                        b: 1,
                        name: "light green"
                    },
                    {
                        h: 40,
                        s: 1,
                        b: .5,
                        name: "dark green"
                    },
                    {
                        h: 40,
                        s: 1,
                        b: 1,
                        name: "green"
                    },
                    {
                        h: 45,
                        s: .5,
                        b: 1,
                        name: "light turquoise"
                    },
                    {
                        h: 45,
                        s: 1,
                        b: .5,
                        name: "dark turquoise"
                    },
                    {
                        h: 45,
                        s: 1,
                        b: 1,
                        name: "turquoise"
                    },
                    {
                        h: 50,
                        s: 0,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 50,
                        s: .5,
                        b: .5,
                        name: "dark cyan"
                    },
                    {
                        h: 50,
                        s: .5,
                        b: 1,
                        name: "light cyan"
                    },
                    {
                        h: 50,
                        s: 1,
                        b: .5,
                        name: "dark cyan"
                    },
                    {
                        h: 50,
                        s: 1,
                        b: 1,
                        name: "cyan"
                    },
                    {
                        h: 55,
                        s: 0,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 55,
                        s: .5,
                        b: 1,
                        name: "light sky blue"
                    },
                    {
                        h: 55,
                        s: 1,
                        b: .5,
                        name: "dark blue"
                    },
                    {
                        h: 55,
                        s: 1,
                        b: 1,
                        name: "sky blue"
                    },
                    {
                        h: 60,
                        s: 0,
                        b: .5,
                        name: "gray"
                    },
                    {
                        h: 60,
                        s: 0,
                        b: 1,
                        name: "very light blue"
                    },
                    {
                        h: 60,
                        s: .5,
                        b: .5,
                        name: "blue"
                    },
                    {
                        h: 60,
                        s: .5,
                        b: 1,
                        name: "light blue"
                    },
                    {
                        h: 60,
                        s: 1,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 60,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 65,
                        s: 0,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 65,
                        s: .5,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 65,
                        s: .5,
                        b: 1,
                        name: "light purple"
                    },
                    {
                        h: 65,
                        s: 1,
                        b: .5,
                        name: "dark navy blue"
                    },
                    {
                        h: 65,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 70,
                        s: 0,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 70,
                        s: .5,
                        b: .5,
                        name: "navy blue"
                    },
                    {
                        h: 70,
                        s: .5,
                        b: 1,
                        name: "lavender blue"
                    },
                    {
                        h: 70,
                        s: 1,
                        b: .5,
                        name: "dark navy blue"
                    },
                    {
                        h: 70,
                        s: 1,
                        b: 1,
                        name: "blue"
                    },
                    {
                        h: 75,
                        s: .5,
                        b: 1,
                        name: "lavender"
                    },
                    {
                        h: 75,
                        s: 1,
                        b: .5,
                        name: "dark purple"
                    },
                    {
                        h: 75,
                        s: 1,
                        b: 1,
                        name: "purple"
                    },
                    {
                        h: 80,
                        s: .5,
                        b: 1,
                        name: "pinkish purple"
                    },
                    {
                        h: 80,
                        s: 1,
                        b: .5,
                        name: "dark purple"
                    },
                    {
                        h: 80,
                        s: 1,
                        b: 1,
                        name: "purple"
                    },
                    {
                        h: 85,
                        s: 0,
                        b: 1,
                        name: "light pink"
                    },
                    {
                        h: 85,
                        s: .5,
                        b: .5,
                        name: "purple"
                    },
                    {
                        h: 85,
                        s: .5,
                        b: 1,
                        name: "light fuchsia"
                    },
                    {
                        h: 85,
                        s: 1,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 85,
                        s: 1,
                        b: 1,
                        name: "fuchsia"
                    },
                    {
                        h: 90,
                        s: .5,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 90,
                        s: .5,
                        b: 1,
                        name: "hot pink"
                    },
                    {
                        h: 90,
                        s: 1,
                        b: .5,
                        name: "dark fuchsia"
                    },
                    {
                        h: 90,
                        s: 1,
                        b: 1,
                        name: "fuchsia"
                    },
                    {
                        h: 95,
                        s: 0,
                        b: 1,
                        name: "pink"
                    },
                    {
                        h: 95,
                        s: .5,
                        b: 1,
                        name: "light pink"
                    },
                    {
                        h: 95,
                        s: 1,
                        b: .5,
                        name: "dark magenta"
                    },
                    {
                        h: 95,
                        s: 1,
                        b: 1,
                        name: "magenta"
                    }
                ];
                o.default.prototype._rgbColorName = function(e1) {
                    var t, r, e1 = u.default._rgbaToHSBA(e1), o = [
                        (l = e1)[0],
                        e1[1],
                        e1[2]
                    ];
                    0 !== o[0] && (o[0] = Math.round(100 * o[0]), (e1 = o[0].toString().split(""))[r = e1.length - 1] = parseInt(e1[r]), e1[r] < 2.5 ? e1[r] = 0 : 2.5 <= e1[r] && e1[r] < 7.5 && (e1[r] = 5), 2 === e1.length ? (e1[0] = parseInt(e1[0]), 7.5 <= e1[r] && (e1[r] = 0, e1[0] = e1[0] + 1), o[0] = 10 * e1[0] + e1[1]) : 7.5 <= e1[r] ? o[0] = 10 : o[0] = e1[r]), o[2] = o[2] / 255;
                    for(var n = o.length - 1; 1 <= n; n--)o[n] <= .25 ? o[n] = 0 : .25 < o[n] && o[n] < .75 ? o[n] = .5 : o[n] = 1;
                    if (0 === o[0] && 0 === o[1] && 1 === o[2]) {
                        for(var s = 2; 0 <= s; s--)l[s] = Math.round(1e4 * l[s]) / 1e4;
                        for(var i = 0; i < c.length; i++){
                            if (c[i].h === l[0] && c[i].s === l[1] && c[i].b === l[2]) {
                                t = c[i].name;
                                break;
                            }
                            t = "white";
                        }
                    } else for(var a = 0; a < d.length; a++)if (d[a].h === o[0] && d[a].s === o[1] && d[a].b === o[2]) {
                        t = d[a].name;
                        break;
                    }
                    return t;
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../color/color_conversion": 258,
                "../core/main": 273,
                "core-js/modules/es.function.name": 167,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.split": 196
            }
        ],
        253: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.replace"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                var i = "_Description", a = "_fallbackDesc", l = "_fallbackTable", u = "_Label", c = "_labelDesc", d = "_labelTable";
                function f(e1) {
                    if ("label" === e1 || "fallback" === e1) throw new Error("description should not be LABEL or FALLBACK");
                    return e1.endsWith(".") || e1.endsWith(";") || e1.endsWith(",") || e1.endsWith("?") || e1.endsWith("!") || (e1 += "."), e1;
                }
                s.default.prototype.describe = function(e1, t) {
                    var r;
                    s.default._validateParameters("describe", arguments), "string" == typeof e1 && (r = this.canvas.id, e1 = f(e1), this.dummyDOM || (this.dummyDOM = document.getElementById(r).parentNode), this.descriptions || (this.descriptions = {}), this.descriptions.fallback ? this.descriptions.fallback.innerHTML !== e1 && (this.descriptions.fallback.innerHTML = e1) : this._describeHTML("fallback", e1), t === this.LABEL && (this.descriptions.label ? this.descriptions.label.innerHTML !== e1 && (this.descriptions.label.innerHTML = e1) : this._describeHTML("label", e1)));
                }, s.default.prototype.describeElement = function(e1, t, r) {
                    var o, n;
                    s.default._validateParameters("describeElement", arguments), "string" == typeof t && "string" == typeof e1 && (o = this.canvas.id, t = f(t), n = function(e1) {
                        if ("label" === e1 || "fallback" === e1) throw new Error("element name should not be LABEL or FALLBACK");
                        e1.endsWith(".") || e1.endsWith(";") || e1.endsWith(",") ? e1 = e1.replace(/.$/, ":") : e1.endsWith(":") || (e1 += ":");
                        return e1;
                    }(e1), e1 = e1.replace(/[^a-zA-Z0-9]/g, ""), n = '<th scope="row">'.concat(n, "</th><td>").concat(t, "</td>"), this.dummyDOM || (this.dummyDOM = document.getElementById(o).parentNode), this.descriptions ? this.descriptions.fallbackElements || (this.descriptions.fallbackElements = {}) : this.descriptions = {
                        fallbackElements: {}
                    }, this.descriptions.fallbackElements[e1] ? this.descriptions.fallbackElements[e1].innerHTML !== n && (this.descriptions.fallbackElements[e1].innerHTML = n) : this._describeElementHTML("fallback", e1, n), r === this.LABEL && (this.descriptions.labelElements || (this.descriptions.labelElements = {}), this.descriptions.labelElements[e1] ? this.descriptions.labelElements[e1].innerHTML !== n && (this.descriptions.labelElements[e1].innerHTML = n) : this._describeElementHTML("label", e1, n)));
                }, s.default.prototype._describeHTML = function(e1, t) {
                    var r, o = this.canvas.id;
                    "fallback" === e1 ? (this.dummyDOM.querySelector("#".concat(o + i)) ? this.dummyDOM.querySelector("#" + o + l).insertAdjacentHTML("beforebegin", '<p id="'.concat(o + a, '"></p>')) : (r = '<div id="'.concat(o).concat(i, '" role="region" aria-label="Canvas Description"><p id="').concat(o).concat(a, '"></p></div>'), this.dummyDOM.querySelector("#".concat(o, "accessibleOutput")) ? this.dummyDOM.querySelector("#".concat(o, "accessibleOutput")).insertAdjacentHTML("beforebegin", r) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = r), this.descriptions.fallback = this.dummyDOM.querySelector("#".concat(o).concat(a)), this.descriptions.fallback.innerHTML = t) : "label" === e1 && (this.dummyDOM.querySelector("#".concat(o + u)) ? this.dummyDOM.querySelector("#".concat(o + d)) && this.dummyDOM.querySelector("#".concat(o + d)).insertAdjacentHTML("beforebegin", '<p id="'.concat(o).concat(c, '"></p>')) : (r = '<div id="'.concat(o).concat(u, '" class="p5Label"><p id="').concat(o).concat(c, '"></p></div>'), this.dummyDOM.querySelector("#".concat(o, "accessibleOutputLabel")) ? this.dummyDOM.querySelector("#".concat(o, "accessibleOutputLabel")).insertAdjacentHTML("beforebegin", r) : this.dummyDOM.querySelector("#" + o).insertAdjacentHTML("afterend", r)), this.descriptions.label = this.dummyDOM.querySelector("#" + o + c), this.descriptions.label.innerHTML = t);
                }, s.default.prototype._describeElementHTML = function(e1, t, r) {
                    var o, n = this.canvas.id;
                    "fallback" === e1 ? (this.dummyDOM.querySelector("#".concat(n + i)) ? this.dummyDOM.querySelector("#" + n + l) || this.dummyDOM.querySelector("#" + n + a).insertAdjacentHTML("afterend", '<table id="'.concat(n).concat(l, '"><caption>Canvas elements and their descriptions</caption></table>')) : (o = '<div id="'.concat(n).concat(i, '" role="region" aria-label="Canvas Description"><table id="').concat(n).concat(l, '"><caption>Canvas elements and their descriptions</caption></table></div>'), this.dummyDOM.querySelector("#".concat(n, "accessibleOutput")) ? this.dummyDOM.querySelector("#".concat(n, "accessibleOutput")).insertAdjacentHTML("beforebegin", o) : this.dummyDOM.querySelector("#" + n).innerHTML = o), (o = document.createElement("tr")).id = n + "_fte_" + t, this.dummyDOM.querySelector("#" + n + l).appendChild(o), this.descriptions.fallbackElements[t] = this.dummyDOM.querySelector("#".concat(n).concat("_fte_").concat(t)), this.descriptions.fallbackElements[t].innerHTML = r) : "label" === e1 && (this.dummyDOM.querySelector("#".concat(n + u)) ? this.dummyDOM.querySelector("#".concat(n + d)) || this.dummyDOM.querySelector("#" + n + c).insertAdjacentHTML("afterend", '<table id="'.concat(n + d, '"></table>')) : (o = '<div id="'.concat(n).concat(u, '" class="p5Label"><table id="').concat(n).concat(d, '"></table></div>'), this.dummyDOM.querySelector("#".concat(n, "accessibleOutputLabel")) ? this.dummyDOM.querySelector("#".concat(n, "accessibleOutputLabel")).insertAdjacentHTML("beforebegin", o) : this.dummyDOM.querySelector("#" + n).insertAdjacentHTML("afterend", o)), (e1 = document.createElement("tr")).id = n + "_lte_" + t, this.dummyDOM.querySelector("#" + n + d).appendChild(e1), this.descriptions.labelElements[t] = this.dummyDOM.querySelector("#".concat(n).concat("_lte_").concat(t)), this.descriptions.labelElements[t].innerHTML = r);
                };
                e1 = s.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.ends-with": 188,
                "core-js/modules/es.string.replace": 194
            }
        ],
        254: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.string.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype._updateGridOutput = function(e1) {
                    var t, r, o, n;
                    this.dummyDOM.querySelector("#".concat(e1, "_summary")) && (t = this._accessibleOutputs[e1], o = function(e1, t, r, o) {
                        t = "".concat(t, " canvas, ").concat(r, " by ").concat(o, " pixels, contains ").concat(e1[0]);
                        t = (1 === e1[0] ? "".concat(t, " shape: ") : "".concat(t, " shapes: ")).concat(e1[1]);
                        return t;
                    }((r = function(e1, t) {
                        var r, o = "", n = "", s = 0;
                        for(r in t){
                            var i, a = 0;
                            for(i in t[r]){
                                var l = '<li id="'.concat(e1, "shape").concat(s, '">').concat(t[r][i].color, " ").concat(r, ",");
                                "line" === r ? l += " location = ".concat(t[r][i].pos, ", length = ").concat(t[r][i].length, " pixels") : (l += " location = ".concat(t[r][i].pos), "point" !== r && (l += ", area = ".concat(t[r][i].area, " %")), l += "</li>"), o += l, a++, s++;
                            }
                            n = 1 < a ? "".concat(n, " ").concat(a, " ").concat(r, "s") : "".concat(n, " ").concat(a, " ").concat(r);
                        }
                        return {
                            numShapes: [
                                s,
                                n
                            ],
                            details: o
                        };
                    }(e1, this.ingredients.shapes)).numShapes, this.ingredients.colors.background, this.width, this.height), n = function(e1, t) {
                        var r, o, n = 0, s = "", i = Array.from(Array(10), function() {
                            return Array(10);
                        });
                        for(r in t)for(var a in t[r]){
                            var l = void 0;
                            l = "line" !== r ? '<a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][a].color, " ").concat(r, "</a>") : '<a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][a].color, " ").concat(r, " midpoint</a>"), i[t[r][a].loc.locY][t[r][a].loc.locX] ? i[t[r][a].loc.locY][t[r][a].loc.locX] = i[t[r][a].loc.locY][t[r][a].loc.locX] + "  " + l : i[t[r][a].loc.locY][t[r][a].loc.locX] = l, n++;
                        }
                        for(o in i){
                            var u, c = "<tr>";
                            for(u in i[o])c += "<td>", void 0 !== i[o][u] && (c += i[o][u]), c += "</td>";
                            s = s + c + "</tr>";
                        }
                        return s;
                    }(e1, this.ingredients.shapes), o !== t.summary.innerHTML && (t.summary.innerHTML = o), n !== t.map.innerHTML && (t.map.innerHTML = n), r.details !== t.shapeDetails.innerHTML && (t.shapeDetails.innerHTML = r.details), this._accessibleOutputs[e1] = t);
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.string.iterator": 190
            }
        ],
        255: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function l(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function u(e1, t, r) {
                    t = Math.floor(e1[0] / t * 10), e1 = Math.floor(e1[1] / r * 10);
                    return 10 === t && (t -= 1), 10 === e1 && (e1 -= 1), {
                        locX: t,
                        locY: e1
                    };
                }
                o.default.prototype.textOutput = function(e1) {
                    o.default._validateParameters("textOutput", arguments), this._accessibleOutputs.text || (this._accessibleOutputs.text = !0, this._createOutput("textOutput", "Fallback"), e1 === this.LABEL && (this._accessibleOutputs.textLabel = !0, this._createOutput("textOutput", "Label")));
                }, o.default.prototype.gridOutput = function(e1) {
                    o.default._validateParameters("gridOutput", arguments), this._accessibleOutputs.grid || (this._accessibleOutputs.grid = !0, this._createOutput("gridOutput", "Fallback"), e1 === this.LABEL && (this._accessibleOutputs.gridLabel = !0, this._createOutput("gridOutput", "Label")));
                }, o.default.prototype._addAccsOutput = function() {
                    return this._accessibleOutputs || (this._accessibleOutputs = {
                        text: !1,
                        grid: !1,
                        textLabel: !1,
                        gridLabel: !1
                    }), this._accessibleOutputs.grid || this._accessibleOutputs.text;
                }, o.default.prototype._createOutput = function(e1, t) {
                    var r, o, n, s = this.canvas.id, i = (this.ingredients || (this.ingredients = {
                        shapes: {},
                        colors: {
                            background: "white",
                            fill: "white",
                            stroke: "black"
                        },
                        pShapes: ""
                    }), this.dummyDOM || (this.dummyDOM = document.getElementById(s).parentNode), "");
                    "Fallback" === t ? (r = s + e1, this.dummyDOM.querySelector("#".concat(o = s + "accessibleOutput")) || (this.dummyDOM.querySelector("#".concat(s, "_Description")) ? this.dummyDOM.querySelector("#".concat(s, "_Description")).insertAdjacentHTML("afterend", '<div id="'.concat(o, '" role="region" aria-label="Canvas Outputs"></div>')) : this.dummyDOM.querySelector("#".concat(s)).innerHTML = '<div id="'.concat(o, '" role="region" aria-label="Canvas Outputs"></div>'))) : "Label" === t && (r = s + e1 + (i = t), this.dummyDOM.querySelector("#".concat(o = s + "accessibleOutput" + t)) || (this.dummyDOM.querySelector("#".concat(s, "_Label")) ? this.dummyDOM.querySelector("#".concat(s, "_Label")) : this.dummyDOM.querySelector("#".concat(s))).insertAdjacentHTML("afterend", '<div id="'.concat(o, '"></div>'))), this._accessibleOutputs[r] = {}, "textOutput" === e1 ? (i = "#".concat(s, "gridOutput").concat(i), n = '<div id="'.concat(r, '">Text Output<div id="').concat(r, 'Summary" aria-label="text output summary"><p id="').concat(r, '_summary"></p><ul id="').concat(r, '_list"></ul></div><table id="').concat(r, '_shapeDetails" summary="text output shape details"></table></div>'), this.dummyDOM.querySelector(i) ? this.dummyDOM.querySelector(i).insertAdjacentHTML("beforebegin", n) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = n, this._accessibleOutputs[r].list = this.dummyDOM.querySelector("#".concat(r, "_list"))) : "gridOutput" === e1 && (i = "#".concat(s, "textOutput").concat(i), n = '<div id="'.concat(r, '">Grid Output<p id="').concat(r, '_summary" aria-label="grid output summary"><table id="').concat(r, '_map" summary="grid output content"></table><ul id="').concat(r, '_shapeDetails" aria-label="grid output shape details"></ul></div>'), this.dummyDOM.querySelector(i) ? this.dummyDOM.querySelector(i).insertAdjacentHTML("afterend", n) : this.dummyDOM.querySelector("#".concat(o)).innerHTML = n, this._accessibleOutputs[r].map = this.dummyDOM.querySelector("#".concat(r, "_map"))), this._accessibleOutputs[r].shapeDetails = this.dummyDOM.querySelector("#".concat(r, "_shapeDetails")), this._accessibleOutputs[r].summary = this.dummyDOM.querySelector("#".concat(r, "_summary"));
                }, o.default.prototype._updateAccsOutput = function() {
                    var e1 = this.canvas.id;
                    JSON.stringify(this.ingredients.shapes) !== this.ingredients.pShapes && (this.ingredients.pShapes = JSON.stringify(this.ingredients.shapes), this._accessibleOutputs.text && this._updateTextOutput(e1 + "textOutput"), this._accessibleOutputs.grid && this._updateGridOutput(e1 + "gridOutput"), this._accessibleOutputs.textLabel && this._updateTextOutput(e1 + "textOutputLabel"), this._accessibleOutputs.gridLabel && this._updateGridOutput(e1 + "gridOutputLabel"));
                }, o.default.prototype._accsBackground = function(e1) {
                    this.ingredients.pShapes = JSON.stringify(this.ingredients.shapes), this.ingredients.shapes = {}, this.ingredients.colors.backgroundRGBA !== e1 && (this.ingredients.colors.backgroundRGBA = e1, this.ingredients.colors.background = this._rgbColorName(e1));
                }, o.default.prototype._accsCanvasColors = function(e1, t) {
                    "fill" === e1 ? this.ingredients.colors.fillRGBA !== t && (this.ingredients.colors.fillRGBA = t, this.ingredients.colors.fill = this._rgbColorName(t)) : "stroke" === e1 && this.ingredients.colors.strokeRGBA !== t && (this.ingredients.colors.strokeRGBA = t, this.ingredients.colors.stroke = this._rgbColorName(t));
                }, o.default.prototype._accsOutput = function(e1, t) {
                    "ellipse" === e1 && t[2] === t[3] ? e1 = "circle" : "rectangle" === e1 && t[2] === t[3] && (e1 = "square");
                    var r, o, n = {}, s = !0, i = function(e1, t) {
                        var r;
                        e1 = "rectangle" === e1 || "ellipse" === e1 || "arc" === e1 || "circle" === e1 || "square" === e1 ? (r = Math.round(t[0] + t[2] / 2), Math.round(t[1] + t[3] / 2)) : "triangle" === e1 ? (r = (t[0] + t[2] + t[4]) / 3, (t[1] + t[3] + t[5]) / 3) : "quadrilateral" === e1 ? (r = (t[0] + t[2] + t[4] + t[6]) / 4, (t[1] + t[3] + t[5] + t[7]) / 4) : "line" === e1 ? (r = (t[0] + t[2]) / 2, (t[1] + t[3]) / 2) : (r = t[0], t[1]);
                        return [
                            r,
                            e1
                        ];
                    }(e1, t);
                    if ("line" === e1 ? (n.color = this.ingredients.colors.stroke, n.length = Math.round(this.dist(t[0], t[1], t[2], t[3])), r = this._getPos(t[0], [
                        1
                    ]), o = this._getPos(t[2], [
                        3
                    ]), n.loc = u(i, this.width, this.height), n.pos = r === o ? "at ".concat(r) : "from ".concat(r, " to ").concat(o)) : ("point" === e1 ? n.color = this.ingredients.colors.stroke : (n.color = this.ingredients.colors.fill, n.area = this._getArea(e1, t)), n.pos = this._getPos.apply(this, l(i)), n.loc = u(i, this.width, this.height)), this.ingredients.shapes[e1]) {
                        if (this.ingredients.shapes[e1] !== [
                            n
                        ]) {
                            for(var a in this.ingredients.shapes[e1])JSON.stringify(this.ingredients.shapes[e1][a]) === JSON.stringify(n) && (s = !1);
                            !0 === s && this.ingredients.shapes[e1].push(n);
                        }
                    } else this.ingredients.shapes[e1] = [
                        n
                    ];
                }, o.default.prototype._getPos = function(e1, t) {
                    var e1 = new DOMPointReadOnly(e1, t), t = this._renderer.isP3D ? new DOMMatrix(this._renderer.uMVMatrix.mat4) : this.drawingContext.getTransform(), e1 = e1.matrixTransform(t), t = e1.x, e1 = e1.y, r = this.width, o = this.height;
                    return t < .4 * r ? e1 < .4 * o ? "top left" : .6 * o < e1 ? "bottom left" : "mid left" : .6 * r < t ? e1 < .4 * o ? "top right" : .6 * o < e1 ? "bottom right" : "mid right" : e1 < .4 * o ? "top middle" : .6 * o < e1 ? "bottom middle" : "middle";
                }, o.default.prototype._getArea = function(e1, t) {
                    var r, o, n = 0, s = ("arc" === e1 ? (n = (r = ((t[5] - t[4]) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI)) * t[2] * t[3] / 8, "open" !== t[6] && "chord" !== t[6] || (o = t[0], u = t[1], s = t[0] + t[2] / 2 * Math.cos(t[4]).toFixed(2), c = t[1] + t[3] / 2 * Math.sin(t[4]).toFixed(2), a = t[0] + t[2] / 2 * Math.cos(t[5]).toFixed(2), i = t[1] + t[3] / 2 * Math.sin(t[5]).toFixed(2), o = Math.abs(o * (c - i) + s * (i - u) + a * (u - c)) / 2, r > Math.PI ? n += o : n -= o)) : "ellipse" === e1 || "circle" === e1 ? n = 3.14 * t[2] / 2 * t[3] / 2 : "line" === e1 || "point" === e1 ? n = 0 : "quadrilateral" === e1 ? n = Math.abs((t[6] + t[0]) * (t[7] - t[1]) + (t[0] + t[2]) * (t[1] - t[3]) + (t[2] + t[4]) * (t[3] - t[5]) + (t[4] + t[6]) * (t[5] - t[7])) / 2 : "rectangle" === e1 || "square" === e1 ? n = t[2] * t[3] : "triangle" === e1 && (n = Math.abs(t[0] * (t[3] - t[5]) + t[2] * (t[5] - t[1]) + t[4] * (t[1] - t[3])) / 2), this.width * this._pixelDensity), i = this.height * this._pixelDensity, a = [
                        new DOMPoint(0, 0),
                        new DOMPoint(s, 0),
                        new DOMPoint(s, i),
                        new DOMPoint(0, i)
                    ], l = (this._renderer.isP3D ? new DOMMatrix(this._renderer.uMVMatrix.mat4) : this.drawingContext.getTransform()).inverse(), u = a.map(function(e1) {
                        return e1.matrixTransform(l);
                    }), c = Math.abs((u[3].x + u[0].x) * (u[3].y - u[0].y) + (u[0].x + u[1].x) * (u[0].y - u[1].y) + (u[1].x + u[2].x) * (u[1].y - u[2].y) + (u[2].x + u[3].x) * (u[2].y - u[3].y)) / 2;
                    return Math.round(100 * n / c);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.number.to-fixed": 173,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        256: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.concat"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype._updateTextOutput = function(e1) {
                    var t, r, o, n;
                    this.dummyDOM.querySelector("#".concat(e1, "_summary")) && (t = this._accessibleOutputs[e1], o = function(e1, t, r, o) {
                        r = "Your output is a, ".concat(r, " by ").concat(o, " pixels, ").concat(t, " canvas containing the following");
                        r = 1 === e1 ? "".concat(r, " shape:") : "".concat(r, " ").concat(e1, " shapes:");
                        return r;
                    }((r = function(e1, t) {
                        var r, o = "", n = 0;
                        for(r in t)for(var s in t[r]){
                            var i = '<li><a href="#'.concat(e1, "shape").concat(n, '">').concat(t[r][s].color, " ").concat(r, "</a>");
                            "line" === r ? i += ", ".concat(t[r][s].pos, ", ").concat(t[r][s].length, " pixels long.</li>") : (i += ", at ".concat(t[r][s].pos), "point" !== r && (i += ", covering ".concat(t[r][s].area, "% of the canvas")), i += ".</li>"), o += i, n++;
                        }
                        return {
                            numShapes: n,
                            listShapes: o
                        };
                    }(e1, this.ingredients.shapes)).numShapes, this.ingredients.colors.background, this.width, this.height), n = function(e1, t) {
                        var r, o = "", n = 0;
                        for(r in t)for(var s in t[r]){
                            var i = '<tr id="'.concat(e1, "shape").concat(n, '"><th>').concat(t[r][s].color, " ").concat(r, "</th>");
                            "line" === r ? i += "<td>location = ".concat(t[r][s].pos, "</td><td>length = ").concat(t[r][s].length, " pixels</td></tr>") : (i += "<td>location = ".concat(t[r][s].pos, "</td>"), "point" !== r && (i += "<td> area = ".concat(t[r][s].area, "%</td>")), i += "</tr>"), o += i, n++;
                        }
                        return o;
                    }(e1, this.ingredients.shapes), o !== t.summary.innerHTML && (t.summary.innerHTML = o), r.listShapes !== t.list.innerHTML && (t.list.innerHTML = r.listShapes), n !== t.shapeDetails.innerHTML && (t.shapeDetails.innerHTML = n), this._accessibleOutputs[e1] = t);
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151
            }
        ],
        257: [
            function(e1, t, r) {
                "use strict";
                var o = (o = e1("./core/main")) && o.__esModule ? o : {
                    default: o
                };
                e1("./core/constants"), e1("./core/environment"), e1("./core/friendly_errors/stacktrace"), e1("./core/friendly_errors/validate_params"), e1("./core/friendly_errors/file_errors"), e1("./core/friendly_errors/fes_core"), e1("./core/friendly_errors/sketch_reader"), e1("./core/helpers"), e1("./core/legacy"), e1("./core/preload"), e1("./core/p5.Element"), e1("./core/p5.Graphics"), e1("./core/p5.Renderer"), e1("./core/p5.Renderer2D"), e1("./core/rendering"), e1("./core/shim"), e1("./core/structure"), e1("./core/transform"), e1("./core/shape/2d_primitives"), e1("./core/shape/attributes"), e1("./core/shape/curves"), e1("./core/shape/vertex"), e1("./accessibility/outputs"), e1("./accessibility/textOutput"), e1("./accessibility/gridOutput"), e1("./accessibility/color_namer"), e1("./color/color_conversion"), e1("./color/creating_reading"), e1("./color/p5.Color"), e1("./color/setting"), e1("./data/p5.TypedDict"), e1("./data/local_storage.js"), e1("./dom/dom"), e1("./accessibility/describe"), e1("./events/acceleration"), e1("./events/keyboard"), e1("./events/mouse"), e1("./events/touch"), e1("./image/filters"), e1("./image/image"), e1("./image/loading_displaying"), e1("./image/p5.Image"), e1("./image/pixels"), e1("./io/files"), e1("./io/p5.Table"), e1("./io/p5.TableRow"), e1("./io/p5.XML"), e1("./math/calculation"), e1("./math/math"), e1("./math/noise"), e1("./math/p5.Vector"), e1("./math/random"), e1("./math/trigonometry"), e1("./typography/attributes"), e1("./typography/loading_displaying"), e1("./typography/p5.Font"), e1("./utilities/array_functions"), e1("./utilities/conversion"), e1("./utilities/string_functions"), e1("./utilities/time_date"), e1("./webgl/3d_primitives"), e1("./webgl/interaction"), e1("./webgl/light"), e1("./webgl/loading"), e1("./webgl/material"), e1("./webgl/p5.Camera"), e1("./webgl/p5.Geometry"), e1("./webgl/p5.Matrix"), e1("./webgl/p5.RendererGL.Immediate"), e1("./webgl/p5.RendererGL"), e1("./webgl/p5.RendererGL.Retained"), e1("./webgl/p5.Framebuffer"), e1("./webgl/p5.Shader"), e1("./webgl/p5.RenderBuffer"), e1("./webgl/p5.Texture"), e1("./webgl/text"), e1("./core/init"), t.exports = o.default;
            },
            {
                "./accessibility/color_namer": 252,
                "./accessibility/describe": 253,
                "./accessibility/gridOutput": 254,
                "./accessibility/outputs": 255,
                "./accessibility/textOutput": 256,
                "./color/color_conversion": 258,
                "./color/creating_reading": 259,
                "./color/p5.Color": 260,
                "./color/setting": 261,
                "./core/constants": 262,
                "./core/environment": 263,
                "./core/friendly_errors/fes_core": 264,
                "./core/friendly_errors/file_errors": 265,
                "./core/friendly_errors/sketch_reader": 266,
                "./core/friendly_errors/stacktrace": 267,
                "./core/friendly_errors/validate_params": 268,
                "./core/helpers": 269,
                "./core/init": 270,
                "./core/legacy": 272,
                "./core/main": 273,
                "./core/p5.Element": 274,
                "./core/p5.Graphics": 275,
                "./core/p5.Renderer": 276,
                "./core/p5.Renderer2D": 277,
                "./core/preload": 278,
                "./core/rendering": 279,
                "./core/shape/2d_primitives": 280,
                "./core/shape/attributes": 281,
                "./core/shape/curves": 282,
                "./core/shape/vertex": 283,
                "./core/shim": 284,
                "./core/structure": 285,
                "./core/transform": 286,
                "./data/local_storage.js": 287,
                "./data/p5.TypedDict": 288,
                "./dom/dom": 289,
                "./events/acceleration": 290,
                "./events/keyboard": 291,
                "./events/mouse": 292,
                "./events/touch": 293,
                "./image/filters": 294,
                "./image/image": 295,
                "./image/loading_displaying": 296,
                "./image/p5.Image": 297,
                "./image/pixels": 298,
                "./io/files": 299,
                "./io/p5.Table": 300,
                "./io/p5.TableRow": 301,
                "./io/p5.XML": 302,
                "./math/calculation": 303,
                "./math/math": 304,
                "./math/noise": 305,
                "./math/p5.Vector": 306,
                "./math/random": 307,
                "./math/trigonometry": 308,
                "./typography/attributes": 309,
                "./typography/loading_displaying": 310,
                "./typography/p5.Font": 311,
                "./utilities/array_functions": 312,
                "./utilities/conversion": 313,
                "./utilities/string_functions": 314,
                "./utilities/time_date": 315,
                "./webgl/3d_primitives": 316,
                "./webgl/interaction": 317,
                "./webgl/light": 318,
                "./webgl/loading": 319,
                "./webgl/material": 320,
                "./webgl/p5.Camera": 321,
                "./webgl/p5.Framebuffer": 322,
                "./webgl/p5.Geometry": 323,
                "./webgl/p5.Matrix": 324,
                "./webgl/p5.RenderBuffer": 325,
                "./webgl/p5.RendererGL": 328,
                "./webgl/p5.RendererGL.Immediate": 326,
                "./webgl/p5.RendererGL.Retained": 327,
                "./webgl/p5.Shader": 329,
                "./webgl/p5.Texture": 330,
                "./webgl/text": 331
            }
        ],
        258: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.ColorConversion = {
                    _hsbaToHSLA: function(e1) {
                        var t = e1[0], r = e1[1], o = e1[2], n = (2 - r) * o / 2;
                        return 0 != n && (1 == n ? r = 0 : n < .5 ? r /= 2 - r : r = r * o / (2 - 2 * n)), [
                            t,
                            r,
                            n,
                            e1[3]
                        ];
                    },
                    _hsbaToRGBA: function(e1) {
                        var t, r, o, n, s, i = 6 * e1[0], a = e1[1], l = e1[2];
                        return 0 === a ? [
                            l,
                            l,
                            l,
                            e1[3]
                        ] : (r = l * (1 - a), o = l * (1 - a * (i - (t = Math.floor(i)))), a = l * (1 - a * (1 + t - i)), i = 1 === t ? (n = o, s = l, r) : 2 === t ? (n = r, s = l, a) : 3 === t ? (n = r, s = o, l) : 4 === t ? (n = a, s = r, l) : 5 === t ? (n = l, s = r, o) : (n = l, s = a, r), [
                            n,
                            s,
                            i,
                            e1[3]
                        ]);
                    },
                    _hslaToHSBA: function(e1) {
                        var t = e1[0], r = e1[1], o = e1[2], n = o < .5 ? (1 + r) * o : o + r - o * r;
                        return [
                            t,
                            r = 2 * (n - o) / n,
                            n,
                            e1[3]
                        ];
                    },
                    _hslaToRGBA: function(e1) {
                        var t, r = 6 * e1[0], o = e1[1], n = e1[2];
                        return 0 === o ? [
                            n,
                            n,
                            n,
                            e1[3]
                        ] : [
                            (t = function(e1, t, r) {
                                return e1 < 0 ? e1 += 6 : 6 <= e1 && (e1 -= 6), e1 < 1 ? t + (r - t) * e1 : e1 < 3 ? r : e1 < 4 ? t + (r - t) * (4 - e1) : t;
                            })(2 + r, o = 2 * n - (n = n < .5 ? (1 + o) * n : n + o - n * o), n),
                            t(r, o, n),
                            t(r - 2, o, n),
                            e1[3]
                        ];
                    },
                    _rgbaToHSBA: function(e1) {
                        var t, r, o = e1[0], n = e1[1], s = e1[2], i = Math.max(o, n, s), a = i - Math.min(o, n, s);
                        return 0 == a ? r = t = 0 : (r = a / i, o === i ? t = (n - s) / a : n === i ? t = 2 + (s - o) / a : s === i && (t = 4 + (o - n) / a), t < 0 ? t += 6 : 6 <= t && (t -= 6)), [
                            t / 6,
                            r,
                            i,
                            e1[3]
                        ];
                    },
                    _rgbaToHSLA: function(e1) {
                        var t, r, o = e1[0], n = e1[1], s = e1[2], i = Math.max(o, n, s), a = Math.min(o, n, s), l = i + a, a = i - a;
                        return 0 == a ? r = t = 0 : (r = l < 1 ? a / l : a / (2 - l), o === i ? t = (n - s) / a : n === i ? t = 2 + (s - o) / a : s === i && (t = 4 + (o - n) / a), t < 0 ? t += 6 : 6 <= t && (t -= 6)), [
                            t / 6,
                            r,
                            l / 2,
                            e1[3]
                        ];
                    }
                };
                e1 = e1.default.ColorConversion;
                r.default = e1;
            },
            {
                "../core/main": 273
            }
        ],
        259: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.map"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, u = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Color"), e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), l.default.prototype.alpha = function(e1) {
                    return l.default._validateParameters("alpha", arguments), this.color(e1)._getAlpha();
                }, l.default.prototype.blue = function(e1) {
                    return l.default._validateParameters("blue", arguments), this.color(e1)._getBlue();
                }, l.default.prototype.brightness = function(e1) {
                    return l.default._validateParameters("brightness", arguments), this.color(e1)._getBrightness();
                }, l.default.prototype.color = function() {
                    var e1;
                    return l.default._validateParameters("color", arguments), arguments[0] instanceof l.default.Color ? arguments[0] : (e1 = arguments[0] instanceof Array ? arguments[0] : arguments, new l.default.Color(this, e1));
                }, l.default.prototype.green = function(e1) {
                    return l.default._validateParameters("green", arguments), this.color(e1)._getGreen();
                }, l.default.prototype.hue = function(e1) {
                    return l.default._validateParameters("hue", arguments), this.color(e1)._getHue();
                }, l.default.prototype.lerpColor = function(e1, t, r) {
                    l.default._validateParameters("lerpColor", arguments);
                    var o, n, s, i = this._colorMode, a = this._colorMaxes;
                    if (i === u.RGB) n = e1.levels.map(function(e1) {
                        return e1 / 255;
                    }), s = t.levels.map(function(e1) {
                        return e1 / 255;
                    });
                    else if (i === u.HSB) e1._getBrightness(), t._getBrightness(), n = e1.hsba, s = t.hsba;
                    else {
                        if (i !== u.HSL) throw new Error("".concat(i, "cannot be used for interpolation."));
                        e1._getLightness(), t._getLightness(), n = e1.hsla, s = t.hsla;
                    }
                    return r = Math.max(Math.min(r, 1), 0), void 0 === this.lerp && (this.lerp = function(e1, t, r) {
                        return r * (t - e1) + e1;
                    }), e1 = this.lerp(n[0], s[0], r), t = this.lerp(n[1], s[1], r), o = this.lerp(n[2], s[2], r), n = this.lerp(n[3], s[3], r), e1 *= a[i][0], t *= a[i][1], o *= a[i][2], n *= a[i][3], this.color(e1, t, o, n);
                }, l.default.prototype.lightness = function(e1) {
                    return l.default._validateParameters("lightness", arguments), this.color(e1)._getLightness();
                }, l.default.prototype.red = function(e1) {
                    return l.default._validateParameters("red", arguments), this.color(e1)._getRed();
                }, l.default.prototype.saturation = function(e1) {
                    return l.default._validateParameters("saturation", arguments), this.color(e1)._getSaturation();
                };
                var n = l.default;
                r.default = n;
            },
            {
                "../core/constants": 262,
                "../core/friendly_errors/fes_core": 264,
                "../core/friendly_errors/file_errors": 265,
                "../core/friendly_errors/validate_params": 268,
                "../core/main": 273,
                "./p5.Color": 260,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        260: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e1("../core/main")), d = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), f = s(e1("./color_conversion"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var h = {
                    aliceblue: "#f0f8ff",
                    antiquewhite: "#faebd7",
                    aqua: "#00ffff",
                    aquamarine: "#7fffd4",
                    azure: "#f0ffff",
                    beige: "#f5f5dc",
                    bisque: "#ffe4c4",
                    black: "#000000",
                    blanchedalmond: "#ffebcd",
                    blue: "#0000ff",
                    blueviolet: "#8a2be2",
                    brown: "#a52a2a",
                    burlywood: "#deb887",
                    cadetblue: "#5f9ea0",
                    chartreuse: "#7fff00",
                    chocolate: "#d2691e",
                    coral: "#ff7f50",
                    cornflowerblue: "#6495ed",
                    cornsilk: "#fff8dc",
                    crimson: "#dc143c",
                    cyan: "#00ffff",
                    darkblue: "#00008b",
                    darkcyan: "#008b8b",
                    darkgoldenrod: "#b8860b",
                    darkgray: "#a9a9a9",
                    darkgreen: "#006400",
                    darkgrey: "#a9a9a9",
                    darkkhaki: "#bdb76b",
                    darkmagenta: "#8b008b",
                    darkolivegreen: "#556b2f",
                    darkorange: "#ff8c00",
                    darkorchid: "#9932cc",
                    darkred: "#8b0000",
                    darksalmon: "#e9967a",
                    darkseagreen: "#8fbc8f",
                    darkslateblue: "#483d8b",
                    darkslategray: "#2f4f4f",
                    darkslategrey: "#2f4f4f",
                    darkturquoise: "#00ced1",
                    darkviolet: "#9400d3",
                    deeppink: "#ff1493",
                    deepskyblue: "#00bfff",
                    dimgray: "#696969",
                    dimgrey: "#696969",
                    dodgerblue: "#1e90ff",
                    firebrick: "#b22222",
                    floralwhite: "#fffaf0",
                    forestgreen: "#228b22",
                    fuchsia: "#ff00ff",
                    gainsboro: "#dcdcdc",
                    ghostwhite: "#f8f8ff",
                    gold: "#ffd700",
                    goldenrod: "#daa520",
                    gray: "#808080",
                    green: "#008000",
                    greenyellow: "#adff2f",
                    grey: "#808080",
                    honeydew: "#f0fff0",
                    hotpink: "#ff69b4",
                    indianred: "#cd5c5c",
                    indigo: "#4b0082",
                    ivory: "#fffff0",
                    khaki: "#f0e68c",
                    lavender: "#e6e6fa",
                    lavenderblush: "#fff0f5",
                    lawngreen: "#7cfc00",
                    lemonchiffon: "#fffacd",
                    lightblue: "#add8e6",
                    lightcoral: "#f08080",
                    lightcyan: "#e0ffff",
                    lightgoldenrodyellow: "#fafad2",
                    lightgray: "#d3d3d3",
                    lightgreen: "#90ee90",
                    lightgrey: "#d3d3d3",
                    lightpink: "#ffb6c1",
                    lightsalmon: "#ffa07a",
                    lightseagreen: "#20b2aa",
                    lightskyblue: "#87cefa",
                    lightslategray: "#778899",
                    lightslategrey: "#778899",
                    lightsteelblue: "#b0c4de",
                    lightyellow: "#ffffe0",
                    lime: "#00ff00",
                    limegreen: "#32cd32",
                    linen: "#faf0e6",
                    magenta: "#ff00ff",
                    maroon: "#800000",
                    mediumaquamarine: "#66cdaa",
                    mediumblue: "#0000cd",
                    mediumorchid: "#ba55d3",
                    mediumpurple: "#9370db",
                    mediumseagreen: "#3cb371",
                    mediumslateblue: "#7b68ee",
                    mediumspringgreen: "#00fa9a",
                    mediumturquoise: "#48d1cc",
                    mediumvioletred: "#c71585",
                    midnightblue: "#191970",
                    mintcream: "#f5fffa",
                    mistyrose: "#ffe4e1",
                    moccasin: "#ffe4b5",
                    navajowhite: "#ffdead",
                    navy: "#000080",
                    oldlace: "#fdf5e6",
                    olive: "#808000",
                    olivedrab: "#6b8e23",
                    orange: "#ffa500",
                    orangered: "#ff4500",
                    orchid: "#da70d6",
                    palegoldenrod: "#eee8aa",
                    palegreen: "#98fb98",
                    paleturquoise: "#afeeee",
                    palevioletred: "#db7093",
                    papayawhip: "#ffefd5",
                    peachpuff: "#ffdab9",
                    peru: "#cd853f",
                    pink: "#ffc0cb",
                    plum: "#dda0dd",
                    powderblue: "#b0e0e6",
                    purple: "#800080",
                    rebeccapurple: "#663399",
                    red: "#ff0000",
                    rosybrown: "#bc8f8f",
                    royalblue: "#4169e1",
                    saddlebrown: "#8b4513",
                    salmon: "#fa8072",
                    sandybrown: "#f4a460",
                    seagreen: "#2e8b57",
                    seashell: "#fff5ee",
                    sienna: "#a0522d",
                    silver: "#c0c0c0",
                    skyblue: "#87ceeb",
                    slateblue: "#6a5acd",
                    slategray: "#708090",
                    slategrey: "#708090",
                    snow: "#fffafa",
                    springgreen: "#00ff7f",
                    steelblue: "#4682b4",
                    tan: "#d2b48c",
                    teal: "#008080",
                    thistle: "#d8bfd8",
                    tomato: "#ff6347",
                    turquoise: "#40e0d0",
                    violet: "#ee82ee",
                    wheat: "#f5deb3",
                    white: "#ffffff",
                    whitesmoke: "#f5f5f5",
                    yellow: "#ffff00",
                    yellowgreen: "#9acd32"
                }, e1 = /\s*/, u = /(\d{1,3})/, c = /((?:\d+(?:\.\d+)?)|(?:\.\d+))/, p = new RegExp("".concat(c.source, "%")), m = {
                    HEX3: /^#([a-f0-9])([a-f0-9])([a-f0-9])$/i,
                    HEX4: /^#([a-f0-9])([a-f0-9])([a-f0-9])([a-f0-9])$/i,
                    HEX6: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,
                    HEX8: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,
                    RGB: new RegExp([
                        "^rgb\\(",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        u.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGB_PERCENT: new RegExp([
                        "^rgb\\(",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGBA: new RegExp([
                        "^rgba\\(",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        u.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    RGBA_PERCENT: new RegExp([
                        "^rgba\\(",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSL: new RegExp([
                        "^hsl\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSLA: new RegExp([
                        "^hsla\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSB: new RegExp([
                        "^hsb\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        "\\)$"
                    ].join(e1.source), "i"),
                    HSBA: new RegExp([
                        "^hsba\\(",
                        u.source,
                        ",",
                        p.source,
                        ",",
                        p.source,
                        ",",
                        c.source,
                        "\\)$"
                    ].join(e1.source), "i")
                }, u = (n.default.Color = function() {
                    function c(e1, t) {
                        if (!(this instanceof c)) throw new TypeError("Cannot call a class as a function");
                        if (this._storeModeAndMaxes(e1._colorMode, e1._colorMaxes), ![
                            d.RGB,
                            d.HSL,
                            d.HSB
                        ].includes(this.mode)) throw new Error("".concat(this.mode, " is an invalid colorMode."));
                        this._array = c._parseInputs.apply(this, t), this._calculateLevels();
                    }
                    var e1, t, r;
                    return e1 = c, r = [
                        {
                            key: "_parseInputs",
                            value: function(e1, t, r, o) {
                                var n, s = arguments.length, i = this.mode, a = this.maxes[i], l = [];
                                if (3 <= s) {
                                    for(l[0] = e1 / a[0], l[1] = t / a[1], l[2] = r / a[2], l[3] = "number" == typeof o ? o / a[3] : 1, n = l.length - 1; 0 <= n; --n){
                                        var u = l[n];
                                        u < 0 ? l[n] = 0 : 1 < u && (l[n] = 1);
                                    }
                                    return i === d.HSL ? f.default._hslaToRGBA(l) : i === d.HSB ? f.default._hsbaToRGBA(l) : l;
                                }
                                if (1 === s && "string" == typeof e1) {
                                    r = e1.trim().toLowerCase();
                                    if (h[r]) return c._parseInputs.call(this, h[r]);
                                    if (m.HEX3.test(r)) return (l = m.HEX3.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1 + e1, 16) / 255;
                                    }))[3] = 1, l;
                                    if (m.HEX6.test(r)) return (l = m.HEX6.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1, 16) / 255;
                                    }))[3] = 1, l;
                                    if (m.HEX4.test(r)) return l = m.HEX4.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1 + e1, 16) / 255;
                                    });
                                    if (m.HEX8.test(r)) return l = m.HEX8.exec(r).slice(1).map(function(e1) {
                                        return parseInt(e1, 16) / 255;
                                    });
                                    if (m.RGB.test(r)) return (l = m.RGB.exec(r).slice(1).map(function(e1) {
                                        return e1 / 255;
                                    }))[3] = 1, l;
                                    if (m.RGB_PERCENT.test(r)) return (l = m.RGB_PERCENT.exec(r).slice(1).map(function(e1) {
                                        return parseFloat(e1) / 100;
                                    }))[3] = 1, l;
                                    if (m.RGBA.test(r)) return l = m.RGBA.exec(r).slice(1).map(function(e1, t) {
                                        return 3 === t ? parseFloat(e1) : e1 / 255;
                                    });
                                    if (m.RGBA_PERCENT.test(r)) return l = m.RGBA_PERCENT.exec(r).slice(1).map(function(e1, t) {
                                        return 3 === t ? parseFloat(e1) : parseFloat(e1) / 100;
                                    });
                                    if (m.HSL.test(r) ? (l = m.HSL.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : parseInt(e1, 10) / 100;
                                    }))[3] = 1 : m.HSLA.test(r) && (l = m.HSLA.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : 3 === t ? parseFloat(e1) : parseInt(e1, 10) / 100;
                                    })), (l = l.map(function(e1) {
                                        return Math.max(Math.min(e1, 1), 0);
                                    })).length) return f.default._hslaToRGBA(l);
                                    if (m.HSB.test(r) ? (l = m.HSB.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : parseInt(e1, 10) / 100;
                                    }))[3] = 1 : m.HSBA.test(r) && (l = m.HSBA.exec(r).slice(1).map(function(e1, t) {
                                        return 0 === t ? parseInt(e1, 10) / 360 : 3 === t ? parseFloat(e1) : parseInt(e1, 10) / 100;
                                    })), l.length) {
                                        for(n = l.length - 1; 0 <= n; --n)l[n] = Math.max(Math.min(l[n], 1), 0);
                                        return f.default._hsbaToRGBA(l);
                                    }
                                    l = [
                                        1,
                                        1,
                                        1,
                                        1
                                    ];
                                } else {
                                    if (1 !== s && 2 !== s || "number" != typeof e1) throw new Error("".concat(arguments, "is not a valid color representation."));
                                    l[0] = e1 / a[2], l[1] = e1 / a[2], l[2] = e1 / a[2], l[3] = "number" == typeof t ? t / a[3] : 1, l = l.map(function(e1) {
                                        return Math.max(Math.min(e1, 1), 0);
                                    });
                                }
                                return l;
                            }
                        }
                    ], t = [
                        {
                            key: "toString",
                            value: function(e1) {
                                var t = this.levels, r = this._array, o = r[3];
                                switch(e1){
                                    case "#rrggbb":
                                        return "#".concat(t[0] < 16 ? "0".concat(t[0].toString(16)) : t[0].toString(16), t[1] < 16 ? "0".concat(t[1].toString(16)) : t[1].toString(16), t[2] < 16 ? "0".concat(t[2].toString(16)) : t[2].toString(16));
                                    case "#rrggbbaa":
                                        return "#".concat(t[0] < 16 ? "0".concat(t[0].toString(16)) : t[0].toString(16), t[1] < 16 ? "0".concat(t[1].toString(16)) : t[1].toString(16), t[2] < 16 ? "0".concat(t[2].toString(16)) : t[2].toString(16), t[3] < 16 ? "0".concat(t[3].toString(16)) : t[3].toString(16));
                                    case "#rgb":
                                        return "#".concat(Math.round(15 * r[0]).toString(16), Math.round(15 * r[1]).toString(16), Math.round(15 * r[2]).toString(16));
                                    case "#rgba":
                                        return "#".concat(Math.round(15 * r[0]).toString(16), Math.round(15 * r[1]).toString(16), Math.round(15 * r[2]).toString(16), Math.round(15 * r[3]).toString(16));
                                    case "rgb":
                                        return "rgb(".concat(t[0], ", ", t[1], ", ", t[2], ")");
                                    case "rgb%":
                                        return "rgb(".concat((100 * r[0]).toPrecision(3), "%, ", (100 * r[1]).toPrecision(3), "%, ", (100 * r[2]).toPrecision(3), "%)");
                                    case "rgba%":
                                        return "rgba(".concat((100 * r[0]).toPrecision(3), "%, ", (100 * r[1]).toPrecision(3), "%, ", (100 * r[2]).toPrecision(3), "%, ", (100 * r[3]).toPrecision(3), "%)");
                                    case "hsb":
                                    case "hsv":
                                        return this.hsba || (this.hsba = f.default._rgbaToHSBA(this._array)), "hsb(".concat(this.hsba[0] * this.maxes[d.HSB][0], ", ", this.hsba[1] * this.maxes[d.HSB][1], ", ", this.hsba[2] * this.maxes[d.HSB][2], ")");
                                    case "hsb%":
                                    case "hsv%":
                                        return this.hsba || (this.hsba = f.default._rgbaToHSBA(this._array)), "hsb(".concat((100 * this.hsba[0]).toPrecision(3), "%, ", (100 * this.hsba[1]).toPrecision(3), "%, ", (100 * this.hsba[2]).toPrecision(3), "%)");
                                    case "hsba":
                                    case "hsva":
                                        return this.hsba || (this.hsba = f.default._rgbaToHSBA(this._array)), "hsba(".concat(this.hsba[0] * this.maxes[d.HSB][0], ", ", this.hsba[1] * this.maxes[d.HSB][1], ", ", this.hsba[2] * this.maxes[d.HSB][2], ", ", o, ")");
                                    case "hsba%":
                                    case "hsva%":
                                        return this.hsba || (this.hsba = f.default._rgbaToHSBA(this._array)), "hsba(".concat((100 * this.hsba[0]).toPrecision(3), "%, ", (100 * this.hsba[1]).toPrecision(3), "%, ", (100 * this.hsba[2]).toPrecision(3), "%, ", (100 * o).toPrecision(3), "%)");
                                    case "hsl":
                                        return this.hsla || (this.hsla = f.default._rgbaToHSLA(this._array)), "hsl(".concat(this.hsla[0] * this.maxes[d.HSL][0], ", ", this.hsla[1] * this.maxes[d.HSL][1], ", ", this.hsla[2] * this.maxes[d.HSL][2], ")");
                                    case "hsl%":
                                        return this.hsla || (this.hsla = f.default._rgbaToHSLA(this._array)), "hsl(".concat((100 * this.hsla[0]).toPrecision(3), "%, ", (100 * this.hsla[1]).toPrecision(3), "%, ", (100 * this.hsla[2]).toPrecision(3), "%)");
                                    case "hsla":
                                        return this.hsla || (this.hsla = f.default._rgbaToHSLA(this._array)), "hsla(".concat(this.hsla[0] * this.maxes[d.HSL][0], ", ", this.hsla[1] * this.maxes[d.HSL][1], ", ", this.hsla[2] * this.maxes[d.HSL][2], ", ", o, ")");
                                    case "hsla%":
                                        return this.hsla || (this.hsla = f.default._rgbaToHSLA(this._array)), "hsl(".concat((100 * this.hsla[0]).toPrecision(3), "%, ", (100 * this.hsla[1]).toPrecision(3), "%, ", (100 * this.hsla[2]).toPrecision(3), "%, ", (100 * o).toPrecision(3), "%)");
                                    default:
                                        return "rgba(".concat(t[0], ",", t[1], ",", t[2], ",", o, ")");
                                }
                            }
                        },
                        {
                            key: "setRed",
                            value: function(e1) {
                                this._array[0] = e1 / this.maxes[d.RGB][0], this._calculateLevels();
                            }
                        },
                        {
                            key: "setGreen",
                            value: function(e1) {
                                this._array[1] = e1 / this.maxes[d.RGB][1], this._calculateLevels();
                            }
                        },
                        {
                            key: "setBlue",
                            value: function(e1) {
                                this._array[2] = e1 / this.maxes[d.RGB][2], this._calculateLevels();
                            }
                        },
                        {
                            key: "setAlpha",
                            value: function(e1) {
                                this._array[3] = e1 / this.maxes[this.mode][3], this._calculateLevels();
                            }
                        },
                        {
                            key: "_calculateLevels",
                            value: function() {
                                for(var e1 = this._array, t = this.levels = new Array(e1.length), r = e1.length - 1; 0 <= r; --r)t[r] = Math.round(255 * e1[r]);
                                this.hsla = null, this.hsba = null;
                            }
                        },
                        {
                            key: "_getAlpha",
                            value: function() {
                                return this._array[3] * this.maxes[this.mode][3];
                            }
                        },
                        {
                            key: "_storeModeAndMaxes",
                            value: function(e1, t) {
                                this.mode = e1, this.maxes = t;
                            }
                        },
                        {
                            key: "_getMode",
                            value: function() {
                                return this.mode;
                            }
                        },
                        {
                            key: "_getMaxes",
                            value: function() {
                                return this.maxes;
                            }
                        },
                        {
                            key: "_getBlue",
                            value: function() {
                                return this._array[2] * this.maxes[d.RGB][2];
                            }
                        },
                        {
                            key: "_getBrightness",
                            value: function() {
                                return this.hsba || (this.hsba = f.default._rgbaToHSBA(this._array)), this.hsba[2] * this.maxes[d.HSB][2];
                            }
                        },
                        {
                            key: "_getGreen",
                            value: function() {
                                return this._array[1] * this.maxes[d.RGB][1];
                            }
                        },
                        {
                            key: "_getHue",
                            value: function() {
                                return this.mode === d.HSB ? (this.hsba || (this.hsba = f.default._rgbaToHSBA(this._array)), this.hsba[0] * this.maxes[d.HSB][0]) : (this.hsla || (this.hsla = f.default._rgbaToHSLA(this._array)), this.hsla[0] * this.maxes[d.HSL][0]);
                            }
                        },
                        {
                            key: "_getLightness",
                            value: function() {
                                return this.hsla || (this.hsla = f.default._rgbaToHSLA(this._array)), this.hsla[2] * this.maxes[d.HSL][2];
                            }
                        },
                        {
                            key: "_getRed",
                            value: function() {
                                return this._array[0] * this.maxes[d.RGB][0];
                            }
                        },
                        {
                            key: "_getSaturation",
                            value: function() {
                                return this.mode === d.HSB ? (this.hsba || (this.hsba = f.default._rgbaToHSBA(this._array)), this.hsba[1] * this.maxes[d.HSB][1]) : (this.hsla || (this.hsla = f.default._rgbaToHSLA(this._array)), this.hsla[1] * this.maxes[d.HSL][1]);
                            }
                        }
                    ], l(e1.prototype, t), r && l(e1, r), c;
                }(), n.default.Color);
                r.default = u;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "./color_conversion": 258,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.constructor": 184,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.trim": 199,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        261: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.fill"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Color"), s.default.prototype.background = function() {
                    var e1;
                    return (e1 = this._renderer).background.apply(e1, arguments), this;
                }, s.default.prototype.clear = function() {
                    return this._renderer.clear((arguments.length <= 0 ? void 0 : arguments[0]) || 0, (arguments.length <= 1 ? void 0 : arguments[1]) || 0, (arguments.length <= 2 ? void 0 : arguments[2]) || 0, (arguments.length <= 3 ? void 0 : arguments[3]) || 0), this;
                }, s.default.prototype.colorMode = function(e1, t, r, o, n) {
                    return s.default._validateParameters("colorMode", arguments), e1 !== a.RGB && e1 !== a.HSB && e1 !== a.HSL || (this._colorMode = e1, e1 = this._colorMaxes[e1], 2 === arguments.length ? (e1[0] = t, e1[1] = t, e1[2] = t, e1[3] = t) : 4 === arguments.length ? (e1[0] = t, e1[1] = r, e1[2] = o) : 5 === arguments.length && (e1[0] = t, e1[1] = r, e1[2] = o, e1[3] = n)), this;
                }, s.default.prototype.fill = function() {
                    var e1;
                    return this._renderer._setProperty("_fillSet", !0), this._renderer._setProperty("_doFill", !0), (e1 = this._renderer).fill.apply(e1, arguments), this;
                }, s.default.prototype.noFill = function() {
                    return this._renderer._setProperty("_doFill", !1), this;
                }, s.default.prototype.noStroke = function() {
                    return this._renderer._setProperty("_doStroke", !1), this;
                }, s.default.prototype.stroke = function() {
                    var e1;
                    return this._renderer._setProperty("_strokeSet", !0), this._renderer._setProperty("_doStroke", !0), (e1 = this._renderer).stroke.apply(e1, arguments), this;
                }, s.default.prototype.erase = function() {
                    return this._renderer.erase(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 255, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 255), this;
                }, s.default.prototype.noErase = function() {
                    return this._renderer.noErase(), this;
                };
                var n = s.default;
                r.default = n;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "./p5.Color": 260,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        262: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QUADRATIC = r.LINEAR = r._CTX_MIDDLE = r._DEFAULT_LEADMULT = r._DEFAULT_TEXT_FILL = r.WORD = r.CHAR = r.BOLDITALIC = r.BOLD = r.ITALIC = r.NORMAL = r.BLUR = r.ERODE = r.DILATE = r.POSTERIZE = r.INVERT = r.OPAQUE = r.GRAY = r.THRESHOLD = r.BURN = r.DODGE = r.SOFT_LIGHT = r.HARD_LIGHT = r.OVERLAY = r.REPLACE = r.SCREEN = r.MULTIPLY = r.EXCLUSION = r.SUBTRACT = r.DIFFERENCE = r.LIGHTEST = r.DARKEST = r.ADD = r.REMOVE = r.BLEND = r.UP_ARROW = r.TAB = r.SHIFT = r.RIGHT_ARROW = r.RETURN = r.OPTION = r.LEFT_ARROW = r.ESCAPE = r.ENTER = r.DOWN_ARROW = r.DELETE = r.CONTROL = r.BACKSPACE = r.ALT = r.AUTO = r.HSL = r.HSB = r.RGB = r.MITER = r.BEVEL = r.ROUND = r.SQUARE = r.PROJECT = r.PIE = r.CHORD = r.OPEN = r.CLOSE = r.TESS = r.QUAD_STRIP = r.QUADS = r.TRIANGLE_STRIP = r.TRIANGLE_FAN = r.TRIANGLES = r.LINE_LOOP = r.LINE_STRIP = r.LINES = r.POINTS = r.BASELINE = r.BOTTOM = r.TOP = r.CENTER = r.LEFT = r.RIGHT = r.RADIUS = r.CORNERS = r.CORNER = r.RAD_TO_DEG = r.DEG_TO_RAD = r.RADIANS = r.DEGREES = r.TWO_PI = r.TAU = r.QUARTER_PI = r.PI = r.HALF_PI = r.WAIT = r.TEXT = r.MOVE = r.HAND = r.CROSS = r.ARROW = r.WEBGL2 = r.WEBGL = r.P2D = r.VERSION = void 0, r.RGBA = r.HALF_FLOAT = r.FLOAT = r.UNSIGNED_INT = r.UNSIGNED_BYTE = r.COVER = r.CONTAIN = r.FALLBACK = r.LABEL = r.AXES = r.GRID = r._DEFAULT_FILL = r._DEFAULT_STROKE = r.PORTRAIT = r.LANDSCAPE = r.MIRROR = r.CLAMP = r.REPEAT = r.NEAREST = r.IMAGE = r.IMMEDIATE = r.TEXTURE = r.FILL = r.STROKE = r.CURVE = r.BEZIER = void 0;
                var o = Math.PI, n = (r.VERSION = "1.7.0", r.P2D = "p2d", r.WEBGL = "webgl", r.WEBGL2 = "webgl2", r.ARROW = "default", r.CROSS = "crosshair", r.HAND = "pointer", r.MOVE = "move", r.TEXT = "text", r.WAIT = "wait", o / 2), n = (r.HALF_PI = n, o), n = (r.PI = n, o / 4), n = (r.QUARTER_PI = n, 2 * o), n = (r.TAU = n, 2 * o), n = (r.TWO_PI = n, r.DEGREES = "degrees", r.RADIANS = "radians", o / 180), n = (r.DEG_TO_RAD = n, 180 / o);
                r.RAD_TO_DEG = n, r.CORNER = "corner", r.CORNERS = "corners", r.RADIUS = "radius", r.RIGHT = "right", r.LEFT = "left", r.CENTER = "center", r.TOP = "top", r.BOTTOM = "bottom", r.BASELINE = "alphabetic", r.POINTS = 0, r.LINES = 1, r.LINE_STRIP = 3, r.LINE_LOOP = 2, r.TRIANGLES = 4, r.TRIANGLE_FAN = 6, r.TRIANGLE_STRIP = 5, r.QUADS = "quads", r.QUAD_STRIP = "quad_strip", r.TESS = "tess", r.CLOSE = "close", r.OPEN = "open", r.CHORD = "chord", r.PIE = "pie", r.PROJECT = "square", r.SQUARE = "butt", r.ROUND = "round", r.BEVEL = "bevel", r.MITER = "miter", r.RGB = "rgb", r.HSB = "hsb", r.HSL = "hsl", r.AUTO = "auto", r.ALT = 18, r.BACKSPACE = 8, r.CONTROL = 17, r.DELETE = 46, r.DOWN_ARROW = 40, r.ENTER = 13, r.ESCAPE = 27, r.LEFT_ARROW = 37, r.OPTION = 18, r.RETURN = 13, r.RIGHT_ARROW = 39, r.SHIFT = 16, r.TAB = 9, r.UP_ARROW = 38, r.BLEND = "source-over", r.REMOVE = "destination-out", r.ADD = "lighter", r.DARKEST = "darken", r.LIGHTEST = "lighten", r.DIFFERENCE = "difference", r.SUBTRACT = "subtract", r.EXCLUSION = "exclusion", r.MULTIPLY = "multiply", r.SCREEN = "screen", r.REPLACE = "copy", r.OVERLAY = "overlay", r.HARD_LIGHT = "hard-light", r.SOFT_LIGHT = "soft-light", r.DODGE = "color-dodge", r.BURN = "color-burn", r.THRESHOLD = "threshold", r.GRAY = "gray", r.OPAQUE = "opaque", r.INVERT = "invert", r.POSTERIZE = "posterize", r.DILATE = "dilate", r.ERODE = "erode", r.BLUR = "blur", r.NORMAL = "normal", r.ITALIC = "italic", r.BOLD = "bold", r.BOLDITALIC = "bold italic", r.CHAR = "CHAR", r.WORD = "WORD", r._DEFAULT_TEXT_FILL = "#000000", r._DEFAULT_LEADMULT = 1.25, r._CTX_MIDDLE = "middle", r.LINEAR = "linear", r.QUADRATIC = "quadratic", r.BEZIER = "bezier", r.CURVE = "curve", r.STROKE = "stroke", r.FILL = "fill", r.TEXTURE = "texture", r.IMMEDIATE = "immediate", r.IMAGE = "image", r.NEAREST = "nearest", r.REPEAT = "repeat", r.CLAMP = "clamp", r.MIRROR = "mirror", r.LANDSCAPE = "landscape", r.PORTRAIT = "portrait", r._DEFAULT_STROKE = "#000000", r._DEFAULT_FILL = "#FFFFFF", r.GRID = "grid", r.AXES = "axes", r.LABEL = "label", r.FALLBACK = "fallback", r.CONTAIN = "contain", r.COVER = "cover", r.UNSIGNED_BYTE = "unsigned-byte", r.UNSIGNED_INT = "unsigned-int", r.FLOAT = "float", r.HALF_FLOAT = "half-float";
                r.RGBA = "rgba";
            },
            {}
        ],
        263: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.search"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.search"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (s = e1("./main")) && s.__esModule ? s : {
                    default: s
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                var l = [
                    s.ARROW,
                    s.CROSS,
                    s.HAND,
                    s.MOVE,
                    s.TEXT,
                    s.WAIT
                ], u = (n.default.prototype._frameRate = 0, n.default.prototype._lastFrameTime = window.performance.now(), n.default.prototype._targetFrameRate = 60, window.print);
                function c() {
                    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth || 0;
                }
                function d() {
                    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight || 0;
                }
                n.default.prototype.print = function() {
                    var e1;
                    arguments.length ? (e1 = console).log.apply(e1, arguments) : u();
                }, n.default.prototype.frameCount = 0, n.default.prototype.deltaTime = 0, n.default.prototype.focused = document.hasFocus(), n.default.prototype.cursor = function(e1, t, r) {
                    var o, n = "auto", s = this._curElement.elt;
                    l.includes(e1) ? n = e1 : "string" == typeof e1 && (o = "", t && r && "number" == typeof t && "number" == typeof r && (o = "".concat(t, " ").concat(r)), n = "http://" === e1.substring(0, 7) || "https://" === e1.substring(0, 8) || /\.(cur|jpg|jpeg|gif|png|CUR|JPG|JPEG|GIF|PNG)$/.test(e1) ? "url(".concat(e1, ") ").concat(o, ", auto") : e1), s.style.cursor = n;
                }, n.default.prototype.frameRate = function(e1) {
                    return n.default._validateParameters("frameRate", arguments), "number" != typeof e1 || e1 < 0 ? this._frameRate : (this._setProperty("_targetFrameRate", e1), 0 === e1 && this._setProperty("_frameRate", e1), this);
                }, n.default.prototype.getFrameRate = function() {
                    return this.frameRate();
                }, n.default.prototype.setFrameRate = function(e1) {
                    return this.frameRate(e1);
                }, n.default.prototype.getTargetFrameRate = function() {
                    return this._targetFrameRate;
                }, n.default.prototype.noCursor = function() {
                    this._curElement.elt.style.cursor = "none";
                }, n.default.prototype.webglVersion = s.P2D, n.default.prototype.displayWidth = screen.width, n.default.prototype.displayHeight = screen.height, n.default.prototype.windowWidth = c(), n.default.prototype.windowHeight = d(), n.default.prototype._onresize = function(e1) {
                    this._setProperty("windowWidth", c()), this._setProperty("windowHeight", d());
                    var t = this._isGlobal ? window : this;
                    "function" != typeof t.windowResized || void 0 === (t = t.windowResized(e1)) || t || e1.preventDefault();
                }, n.default.prototype.width = 0, n.default.prototype.height = 0, n.default.prototype.fullscreen = function(e1) {
                    if (n.default._validateParameters("fullscreen", arguments), void 0 === e1) return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
                    if (e1) {
                        e1 = document.documentElement;
                        if (!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled)) throw new Error("Fullscreen not enabled in this browser.");
                        e1.requestFullscreen ? e1.requestFullscreen() : e1.mozRequestFullScreen ? e1.mozRequestFullScreen() : e1.webkitRequestFullscreen ? e1.webkitRequestFullscreen() : e1.msRequestFullscreen && e1.msRequestFullscreen();
                    } else document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                }, n.default.prototype.pixelDensity = function(e1) {
                    var t;
                    return n.default._validateParameters("pixelDensity", arguments), "number" == typeof e1 ? (e1 !== this._pixelDensity && (this._pixelDensity = e1), (t = this).resizeCanvas(this.width, this.height, !0)) : t = this._pixelDensity, t;
                }, n.default.prototype.displayDensity = function() {
                    return window.devicePixelRatio;
                }, n.default.prototype.getURL = function() {
                    return location.href;
                }, n.default.prototype.getURLPath = function() {
                    return location.pathname.split("/").filter(function(e1) {
                        return "" !== e1;
                    });
                }, n.default.prototype.getURLParams = function() {
                    for(var e1, t = /[?&]([^&=]+)(?:[&=])([^&=]+)/gim, r = {}; null != (e1 = t.exec(location.search));)e1.index === t.lastIndex && t.lastIndex++, r[e1[1]] = e1[2];
                    return r;
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "./constants": 262,
                "./main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.search": 195,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        264: [
            function(r, e1, t) {
                "use strict";
                r("core-js/modules/es.symbol"), r("core-js/modules/es.symbol.description"), r("core-js/modules/es.symbol.iterator"), r("core-js/modules/es.array.concat"), r("core-js/modules/es.array.filter"), r("core-js/modules/es.array.for-each"), r("core-js/modules/es.array.includes"), r("core-js/modules/es.array.iterator"), r("core-js/modules/es.array.join"), r("core-js/modules/es.array.map"), r("core-js/modules/es.array.slice"), r("core-js/modules/es.array.some"), r("core-js/modules/es.function.name"), r("core-js/modules/es.object.assign"), r("core-js/modules/es.object.get-own-property-names"), r("core-js/modules/es.object.keys"), r("core-js/modules/es.object.to-string"), r("core-js/modules/es.regexp.constructor"), r("core-js/modules/es.regexp.exec"), r("core-js/modules/es.regexp.to-string"), r("core-js/modules/es.string.iterator"), r("core-js/modules/es.string.match"), r("core-js/modules/es.string.replace"), r("core-js/modules/es.string.split"), r("core-js/modules/es.string.starts-with"), r("core-js/modules/web.dom-collections.for-each"), r("core-js/modules/web.dom-collections.iterator"), r("core-js/modules/es.symbol"), r("core-js/modules/es.symbol.description"), r("core-js/modules/es.symbol.iterator"), r("core-js/modules/es.array.concat"), r("core-js/modules/es.array.filter"), r("core-js/modules/es.array.for-each"), r("core-js/modules/es.array.includes"), r("core-js/modules/es.array.iterator"), r("core-js/modules/es.array.join"), r("core-js/modules/es.array.map"), r("core-js/modules/es.array.slice"), r("core-js/modules/es.array.some"), r("core-js/modules/es.function.name"), r("core-js/modules/es.object.assign"), r("core-js/modules/es.object.get-own-property-names"), r("core-js/modules/es.object.keys"), r("core-js/modules/es.object.to-string"), r("core-js/modules/es.regexp.constructor"), r("core-js/modules/es.regexp.exec"), r("core-js/modules/es.regexp.to-string"), r("core-js/modules/es.string.iterator"), r("core-js/modules/es.string.match"), r("core-js/modules/es.string.replace"), r("core-js/modules/es.string.split"), r("core-js/modules/es.string.starts-with"), r("core-js/modules/web.dom-collections.for-each"), r("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var o = (l = r("../main")) && l.__esModule ? l : {
                    default: l
                };
                r("../internationalization");
                function n(r, o) {
                    o = o || console.log.bind(console), s || i(), s.some(function(e1) {
                        var t;
                        if (r.message && null !== r.message.match("\\W?".concat(e1.name, "\\W"))) return t = "function" === e1.type ? "".concat(e1.name, "()") : e1.name, o("Did you just try to use p5.js's ".concat(t, " ").concat(e1.type, "? If so, you may want to move it into your sketch's setup() function.\n\nFor more details, see: ").concat(a)), !0;
                    });
                }
                var s = null, i = null, a = (o.default._friendlyError = o.default._checkForUserDefinedFunctions = o.default._fesErrorMonitor = function() {}, s = null, "https://github.com/processing/p5.js/wiki/p5.js-overview#why-cant-i-assign-variables-using-p5-functions-and-variables-before-setup"), i = function() {
                    function e1(r) {
                        return Object.getOwnPropertyNames(r).filter(function(e1) {
                            return "_" !== e1[0] && !(e1 in t) && (t[e1] = !0);
                        }).map(function(e1) {
                            var t = "function" == typeof r[e1] ? "function" : e1 === e1.toUpperCase() ? "constant" : "variable";
                            return {
                                name: e1,
                                type: t
                            };
                        });
                    }
                    var t = {};
                    (s = [].concat(e1(o.default.prototype), e1(r("../constants")))).sort(function(e1, t) {
                        return t.name.length - e1.name.length;
                    });
                }, l = (o.default.prototype._helpForMisusedAtTopLevelCode = n, "complete" !== document.readyState && (window.addEventListener("error", n, !1), window.addEventListener("load", function() {
                    window.removeEventListener("error", n, !1);
                })), o.default);
                t.default = l;
            },
            {
                "../constants": 262,
                "../internationalization": 271,
                "../main": 273,
                "./browser_errors": void 0,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.array.some": 165,
                "core-js/modules/es.function.name": 167,
                "core-js/modules/es.object.assign": 174,
                "core-js/modules/es.object.get-own-property-names": 177,
                "core-js/modules/es.object.keys": 179,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.constructor": 184,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.match": 191,
                "core-js/modules/es.string.replace": 194,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.string.starts-with": 197,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.for-each": 235,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        265: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (o = e1("../main")) && o.__esModule ? o : {
                    default: o
                };
                e1("../internationalization");
                o.default._friendlyFileLoadError = function() {};
                e1 = o.default;
                r.default = e1;
            },
            {
                "../internationalization": 271,
                "../main": 273
            }
        ],
        266: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = C(e1("../main")), s = e1("../internationalization"), a = O(e1("../constants")), l, u, c, d, f, h, p, m, y, g, v, b, j, _, x, w, S, E, M, T, I;
                function k() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, k = function() {
                        return e1;
                    }, e1);
                }
                function O(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = k();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o, n = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1)Object.prototype.hasOwnProperty.call(e1, r) && ((o = s ? Object.getOwnPropertyDescriptor(e1, r) : null) && (o.get || o.set) ? Object.defineProperty(n, r, o) : n[r] = e1[r]);
                    return n.default = e1, t && t.set(e1, n), n;
                }
                function C(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function D(e1) {
                    return L(e1) || P(e1) || A();
                }
                function A() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance");
                }
                function P(e1) {
                    if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                }
                function L(e1) {
                    if (Array.isArray(e1)) {
                        for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                        return r;
                    }
                }
                n.default._fesCodeReader = function() {};
                var R = n.default;
                r.default = R;
            },
            {
                "../constants": 262,
                "../internationalization": 271,
                "../main": 273,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.keys": 179,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.constructor": 184,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.match": 191,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.string.trim": 199,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.for-each": 235,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        267: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o() {
                    var t = /(^|@)\S+:\d+/, r = /^\s*at .*(\S+:\d+|\(native\))/m, o = /^(eval@)?(\[native code])?$/;
                    return {
                        parse: function(e1) {
                            return void 0 !== e1.stacktrace || void 0 !== e1["opera#sourceloc"] ? this.parseOpera(e1) : e1.stack && e1.stack.match(r) ? this.parseV8OrIE(e1) : e1.stack ? this.parseFFOrSafari(e1) : void 0;
                        },
                        extractLocation: function(e1) {
                            return -1 === e1.indexOf(":") ? [
                                e1
                            ] : [
                                (e1 = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e1.replace(/[()]/g, "")))[1],
                                e1[2] || void 0,
                                e1[3] || void 0
                            ];
                        },
                        parseV8OrIE: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !!e1.match(r);
                            }, this).map(function(e1) {
                                var t = (e1 = -1 < e1.indexOf("(eval ") ? e1.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, "") : e1).replace(/^\s+/, "").replace(/\(eval code/g, "("), r = t.match(/ (\((.+):(\d+):(\d+)\)$)/), t = (t = r ? t.replace(r[0], "") : t).split(/\s+/).slice(1), r = this.extractLocation(r ? r[1] : t.pop());
                                return {
                                    functionName: t.join(" ") || void 0,
                                    fileName: -1 < [
                                        "eval",
                                        "<anonymous>"
                                    ].indexOf(r[0]) ? void 0 : r[0],
                                    lineNumber: r[1],
                                    columnNumber: r[2],
                                    source: e1
                                };
                            }, this);
                        },
                        parseFFOrSafari: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !e1.match(o);
                            }, this).map(function(e1) {
                                var t, r;
                                return -1 === (e1 = -1 < e1.indexOf(" > eval") ? e1.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1") : e1).indexOf("@") && -1 === e1.indexOf(":") ? {
                                    functionName: e1
                                } : {
                                    functionName: (r = e1.match(t = /((.*".+"[^@]*)?[^@]*)(?:@)/)) && r[1] ? r[1] : void 0,
                                    fileName: (r = this.extractLocation(e1.replace(t, "")))[0],
                                    lineNumber: r[1],
                                    columnNumber: r[2],
                                    source: e1
                                };
                            }, this);
                        },
                        parseOpera: function(e1) {
                            return !e1.stacktrace || -1 < e1.message.indexOf("\n") && e1.message.split("\n").length > e1.stacktrace.split("\n").length ? this.parseOpera9(e1) : e1.stack ? this.parseOpera11(e1) : this.parseOpera10(e1);
                        },
                        parseOpera9: function(e1) {
                            for(var t = /Line (\d+).*script (?:in )?(\S+)/i, r = e1.message.split("\n"), o = [], n = 2, s = r.length; n < s; n += 2){
                                var i = t.exec(r[n]);
                                i && o.push({
                                    fileName: i[2],
                                    lineNumber: i[1],
                                    source: r[n]
                                });
                            }
                            return o;
                        },
                        parseOpera10: function(e1) {
                            for(var t = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, r = e1.stacktrace.split("\n"), o = [], n = 0, s = r.length; n < s; n += 2){
                                var i = t.exec(r[n]);
                                i && o.push({
                                    functionName: i[3] || void 0,
                                    fileName: i[2],
                                    lineNumber: i[1],
                                    source: r[n]
                                });
                            }
                            return o;
                        },
                        parseOpera11: function(e1) {
                            return e1.stack.split("\n").filter(function(e1) {
                                return !!e1.match(t) && !e1.match(/^Error created at/);
                            }, this).map(function(e1) {
                                var t, r = e1.split("@"), o = this.extractLocation(r.pop()), r = r.shift() || "";
                                return {
                                    functionName: r.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0,
                                    args: void 0 === (t = r.match(/\(([^)]*)\)/) ? r.replace(/^[^(]+\(([^)]*)\)$/, "$1") : t) || "[arguments not available]" === t ? void 0 : t.split(","),
                                    fileName: o[0],
                                    lineNumber: o[1],
                                    columnNumber: o[2],
                                    source: e1
                                };
                            }, this);
                        }
                    };
                }
                e1.default._getErrorStackParser = function() {
                    return new o;
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../main": 273,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.match": 191,
                "core-js/modules/es.string.replace": 194,
                "core-js/modules/es.string.split": 196
            }
        ],
        268: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../main")) && n.__esModule ? n : {
                    default: n
                };
                (function(e1) {
                    if (e1 && e1.__esModule) return;
                    if (null === e1 || "object" !== a(e1) && "function" != typeof e1) return;
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                })(e1("../constants")), e1("../internationalization");
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function a(e1) {
                    return (a = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                n.default._validateParameters = n.default._clearValidateParamsCache = function() {};
                e1 = n.default;
                r.default = e1;
            },
            {
                "../../../docs/parameterData.json": void 0,
                "../constants": 262,
                "../internationalization": 271,
                "../main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.last-index-of": 162,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.function.name": 167,
                "core-js/modules/es.map": 168,
                "core-js/modules/es.number.constructor": 171,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.keys": 179,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.set": 187,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.for-each": 235,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        269: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                r.default = {
                    modeAdjust: function(e1, t, r, o, n) {
                        return n === s.CORNER ? {
                            x: e1,
                            y: t,
                            w: r,
                            h: o
                        } : n === s.CORNERS ? {
                            x: e1,
                            y: t,
                            w: r - e1,
                            h: o - t
                        } : n === s.RADIUS ? {
                            x: e1 - r,
                            y: t - o,
                            w: 2 * r,
                            h: 2 * o
                        } : n === s.CENTER ? {
                            x: e1 - .5 * r,
                            y: t - .5 * o,
                            w: r,
                            h: o
                        } : void 0;
                    }
                };
            },
            {
                "./constants": 262,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        270: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator");
                var o = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                };
                e1("./internationalization");
                var n = Promise.resolve();
                Promise.all([
                    new Promise(function(e1, t) {
                        "complete" === document.readyState ? e1() : window.addEventListener("load", e1, !1);
                    }),
                    n
                ]).then(function() {
                    void 0 !== window._setupDone ? console.warn("p5.js seems to have been imported multiple times. Please remove the duplicate import") : window.mocha || (window.setup && "function" == typeof window.setup || window.draw && "function" == typeof window.draw) && !o.default.instance && new o.default;
                });
            },
            {
                "../core/main": 273,
                "./internationalization": 271,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.promise": 181,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        271: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.setTranslatorLanguage = r.currentTranslatorLanguage = r.availableTranslatorLanguages = r.initialize = r.translator = void 0;
                var n, s, o = a(e1("i18next")), i = a(e1("i18next-browser-languagedetector"));
                function a(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function l(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var u = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.init(e1, t);
                    }
                    var e1, t, o;
                    return e1 = r, t = [
                        {
                            key: "fetchWithTimeout",
                            value: function(e1, t) {
                                var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 2e3;
                                return Promise.race([
                                    fetch(e1, t),
                                    new Promise(function(e1, t) {
                                        return setTimeout(function() {
                                            return t(new Error("timeout"));
                                        }, r);
                                    })
                                ]);
                            }
                        },
                        {
                            key: "init",
                            value: function(e1) {
                                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
                                this.services = e1, this.options = t;
                            }
                        },
                        {
                            key: "read",
                            value: function(e1, t, r) {
                                var o = this.options.loadPath;
                                e1 === this.options.fallback ? r(null, n[e1][t]) : s.includes(e1) ? (o = this.services.interpolator.interpolate(o, {
                                    lng: e1,
                                    ns: t
                                }), this.loadUrl(o, r)) : r("Not found", !1);
                            }
                        },
                        {
                            key: "loadUrl",
                            value: function(t, r) {
                                this.fetchWithTimeout(t).then(function(e1) {
                                    if (e1.ok) return e1.json();
                                    throw new Error("failed loading ".concat(t));
                                }, function() {
                                    throw new Error("failed loading ".concat(t));
                                }).then(function(e1) {
                                    return r(null, e1);
                                }).catch(r);
                            }
                        }
                    ], l(e1.prototype, t), o && l(e1, o), r;
                }();
                u.type = "backend", r.translator = function(e1, t) {
                    console.debug("p5.js translator called before translations were loaded"), o.default.t(e1, t);
                }, r.initialize = function() {
                    return o.default.use(i.default).use(u).init({
                        fallbackLng: "en",
                        nestingPrefix: "$tr(",
                        nestingSuffix: ")",
                        defaultNS: "translation",
                        returnEmptyString: !1,
                        interpolation: {
                            escapeValue: !1
                        },
                        detection: {
                            checkWhitelist: !1,
                            order: [
                                "querystring",
                                "navigator",
                                "htmlTag",
                                "path",
                                "subdomain"
                            ],
                            caches: []
                        },
                        backend: {
                            fallback: "en",
                            loadPath: "https://cdn.jsdelivr.net/npm/p5/translations/{{lng}}/{{ns}}.json"
                        },
                        partialBundledLanguages: !0,
                        resources: n
                    }).then(function(e1) {
                        r.translator = e1;
                    }, function(e1) {
                        return console.debug("Translations failed to load (".concat(e1, ")"));
                    });
                }, r.availableTranslatorLanguages = function() {
                    return o.default.languages;
                }, r.currentTranslatorLanguage = function(e1) {
                    return o.default.language;
                };
                r.setTranslatorLanguage = function(e1) {
                    return o.default.changeLanguage(e1 || void 0, function(e1) {
                        return console.debug("Translations failed to load (".concat(e1, ")"));
                    });
                };
            },
            {
                "../../translations": void 0,
                "../../translations/dev": void 0,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.keys": 179,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.promise": 181,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/web.dom-collections.iterator": 236,
                i18next: 3,
                "i18next-browser-languagedetector": 3
            }
        ],
        272: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.pushStyle = function() {
                    throw new Error("pushStyle() not used, see push()");
                }, e1.default.prototype.popStyle = function() {
                    throw new Error("popStyle() not used, see pop()");
                }, e1.default.prototype.popMatrix = function() {
                    throw new Error("popMatrix() not used, see pop()");
                }, e1.default.prototype.pushMatrix = function() {
                    throw new Error("pushMatrix() not used, see push()");
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "./main": 273
            }
        ],
        273: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-own-property-names"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-names"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0, e1("./shim");
                var n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var l, u = function() {
                    function v(e1, t, r) {
                        var d = this;
                        if (!(this instanceof v)) throw new TypeError("Cannot call a class as a function");
                        this._setupDone = !1, this._preloadDone = !1, this._pixelDensity = Math.ceil(window.devicePixelRatio) || 1, this._userNode = t, this._curElement = null, this._elements = [], this._glAttributes = null, this._requestAnimId = 0, this._preloadCount = 0, this._isGlobal = !1, this._loop = !0, this._initializeInstanceVariables(), this._defaultCanvasSize = {
                            width: 100,
                            height: 100
                        }, this._events = {
                            mousemove: null,
                            mousedown: null,
                            mouseup: null,
                            dragend: null,
                            dragover: null,
                            click: null,
                            dblclick: null,
                            mouseover: null,
                            mouseout: null,
                            keydown: null,
                            keyup: null,
                            keypress: null,
                            touchstart: null,
                            touchmove: null,
                            touchend: null,
                            resize: null,
                            blur: null
                        }, this._millisStart = -1, this._recording = !1, this._lcg_random_state = null, this._gaussian_previous = !1, this._events.wheel = null, this._loadingScreenId = "p5_loading", this._registeredMethods = {};
                        var t = Object.getOwnPropertyNames(v.prototype._registeredMethods), o = !0, n = !1, s = void 0;
                        try {
                            for(var i, a = t[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                var l = i.value;
                                this._registeredMethods[l] = v.prototype._registeredMethods[l].slice();
                            }
                        } catch (e1) {
                            n = !0, s = e1;
                        } finally{
                            try {
                                o || null == a.return || a.return();
                            } finally{
                                if (n) throw s;
                            }
                        }
                        window.DeviceOrientationEvent && (this._events.deviceorientation = null), window.DeviceMotionEvent && !window._isNodeWebkit && (this._events.devicemotion = null), this._start = function() {
                            d._userNode && "string" == typeof d._userNode && (d._userNode = document.getElementById(d._userNode));
                            var e1 = d._isGlobal ? window : d;
                            if (e1.preload) {
                                var t, r = document.getElementById(d._loadingScreenId), o = (r || ((r = document.createElement("div")).innerHTML = "Loading...", r.style.position = "absolute", r.id = d._loadingScreenId, (d._userNode || document.body).appendChild(r)), d._preloadMethods);
                                for(t in o){
                                    o[t] = o[t] || v;
                                    var n = o[t];
                                    n !== v.prototype && n !== v || (d._isGlobal && (window[t] = d._wrapPreload(d, t)), n = d), d._registeredPreloadMethods[t] = n[t], n[t] = d._wrapPreload(n, t);
                                }
                                e1.preload(), d._runIfPreloadsAreDone();
                            } else d._setup(), d._recording || d._draw();
                        }, this._runIfPreloadsAreDone = function() {
                            var e1, t = this._isGlobal ? window : this;
                            0 === t._preloadCount && ((e1 = document.getElementById(t._loadingScreenId)) && e1.parentNode.removeChild(e1), this._setupDone || (this._lastTargetFrameTime = window.performance.now(), this._lastRealFrameTime = window.performance.now(), t._setup(), this._recording || t._draw()));
                        }, this._decrementPreload = function() {
                            var e1 = this._isGlobal ? window : this;
                            e1._preloadDone || "function" != typeof e1.preload || (e1._setProperty("_preloadCount", e1._preloadCount - 1), e1._runIfPreloadsAreDone());
                        }, this._wrapPreload = function(o, n) {
                            var s = this;
                            return function() {
                                s._incrementPreload();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return s._registeredPreloadMethods[n].apply(o, t);
                            };
                        }, this._incrementPreload = function() {
                            var e1 = this._isGlobal ? window : this;
                            e1._preloadDone || e1._setProperty("_preloadCount", e1._preloadCount + 1);
                        }, this._setup = function() {
                            d.createCanvas(d._defaultCanvasSize.width, d._defaultCanvasSize.height, "p2d");
                            var e1 = d._isGlobal ? window : d;
                            if ("function" == typeof e1.preload) for(var t in d._preloadMethods)e1[t] = d._preloadMethods[t][t], e1[t] && d && (e1[t] = e1[t].bind(d));
                            d._millisStart = window.performance.now(), e1._preloadDone = !0, "function" == typeof e1.setup && e1.setup();
                            var r = document.getElementsByTagName("canvas"), o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = r[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                    var l = i.value;
                                    "true" === l.dataset.hidden && (l.style.visibility = "", delete l.dataset.hidden);
                                }
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            d._lastTargetFrameTime = window.performance.now(), d._lastRealFrameTime = window.performance.now(), d._setupDone = !0, (d._accessibleOutputs.grid || d._accessibleOutputs.text) && d._updateAccsOutput();
                        }, this._draw = function() {
                            var e1 = window.performance.now(), t = e1 - d._lastTargetFrameTime, r = 1e3 / d._targetFrameRate;
                            (!d._loop || r - 5 <= t) && (d.deltaTime = e1 - d._lastRealFrameTime, d._setProperty("deltaTime", d.deltaTime), d._frameRate = 1e3 / d.deltaTime, d.redraw(), d._lastTargetFrameTime = Math.max(d._lastTargetFrameTime + r, e1), d._lastRealFrameTime = e1, void 0 !== d._updateMouseCoords && (d._updateMouseCoords(), d._setProperty("movedX", 0), d._setProperty("movedY", 0))), d._loop && (d._requestAnimId = window.requestAnimationFrame(d._draw));
                        }, this._setProperty = function(e1, t) {
                            d[e1] = t, d._isGlobal && (window[e1] = t);
                        }, this.remove = function() {
                            var t = document.getElementById(d._loadingScreenId);
                            if (t && (t.parentNode.removeChild(t), d._incrementPreload()), d._curElement) {
                                for(var e1 in d._loop = !1, d._requestAnimId && window.cancelAnimationFrame(d._requestAnimId), d._events)window.removeEventListener(e1, d._events[e1]);
                                var r = !0, t = !1, o = void 0;
                                try {
                                    for(var n, s = d._elements[Symbol.iterator](); !(r = (n = s.next()).done); r = !0){
                                        var i, a = n.value;
                                        for(i in a.elt && a.elt.parentNode && a.elt.parentNode.removeChild(a.elt), a._events)a.elt.removeEventListener(i, a._events[i]);
                                    }
                                } catch (e1) {
                                    t = !0, o = e1;
                                } finally{
                                    try {
                                        r || null == s.return || s.return();
                                    } finally{
                                        if (t) throw o;
                                    }
                                }
                                var l = d;
                                d._registeredMethods.remove.forEach(function(e1) {
                                    void 0 !== e1 && e1.call(l);
                                });
                            }
                            if (d._isGlobal) {
                                for(var u in v.prototype)try {
                                    delete window[u];
                                } catch (e1) {
                                    window[u] = void 0;
                                }
                                for(var c in d)if (d.hasOwnProperty(c)) try {
                                    delete window[c];
                                } catch (e1) {
                                    window[c] = void 0;
                                }
                                v.instance = null;
                            }
                        }, this._registeredMethods.init.forEach(function(e1) {
                            void 0 !== e1 && e1.call(this);
                        }, this), this._setupPromisePreloads();
                        var u, c, f = this._createFriendlyGlobalFunctionBinder();
                        if (e1) e1(this), v._checkForUserDefinedFunctions(this);
                        else {
                            for(var h in this._isGlobal = !0, v.instance = this, v.prototype)"function" == typeof v.prototype[h] ? (u = h.substring(2), this._events.hasOwnProperty(u) || (Math.hasOwnProperty(h) && Math[h] === v.prototype[h] ? f(h, v.prototype[h]) : f(h, v.prototype[h].bind(this)))) : f(h, v.prototype[h]);
                            for(var p in this)this.hasOwnProperty(p) && f(p, this[p]);
                        }
                        for(c in this._events){
                            var m = this["_on".concat(c)];
                            m && (m = m.bind(this), window.addEventListener(c, m, {
                                passive: !1
                            }), this._events[c] = m);
                        }
                        function y() {
                            d._setProperty("focused", !0);
                        }
                        function g() {
                            d._setProperty("focused", !1);
                        }
                        window.addEventListener("focus", y), window.addEventListener("blur", g), this.registerMethod("remove", function() {
                            window.removeEventListener("focus", y), window.removeEventListener("blur", g);
                        }), "complete" === document.readyState ? this._start() : window.addEventListener("load", this._start.bind(this), !1);
                    }
                    var e1, t, r;
                    return e1 = v, t = [
                        {
                            key: "_initializeInstanceVariables",
                            value: function() {
                                this._accessibleOutputs = {
                                    text: !1,
                                    grid: !1,
                                    textLabel: !1,
                                    gridLabel: !1
                                }, this._styles = [], this._bezierDetail = 20, this._curveDetail = 20, this._colorMode = n.RGB, this._colorMaxes = {
                                    rgb: [
                                        255,
                                        255,
                                        255,
                                        255
                                    ],
                                    hsb: [
                                        360,
                                        100,
                                        100,
                                        1
                                    ],
                                    hsl: [
                                        360,
                                        100,
                                        100,
                                        1
                                    ]
                                }, this._downKeys = {};
                            }
                        },
                        {
                            key: "registerPreloadMethod",
                            value: function(e1, t) {
                                v.prototype._preloadMethods.hasOwnProperty(e1) || (v.prototype._preloadMethods[e1] = t);
                            }
                        },
                        {
                            key: "registerMethod",
                            value: function(e1, t) {
                                var r = this || v.prototype;
                                r._registeredMethods.hasOwnProperty(e1) || (r._registeredMethods[e1] = []), r._registeredMethods[e1].push(t);
                            }
                        },
                        {
                            key: "_createFriendlyGlobalFunctionBinder",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}, r = e1.globalObject || window;
                                e1.log || console.log.bind(console);
                                return function(e1, t) {
                                    v.disableFriendlyErrors, r[e1] = t;
                                };
                            }
                        }
                    ], s(e1.prototype, t), r && s(e1, r), v;
                }();
                for(l in u.instance = null, u.disableFriendlyErrors = !1, n)u.prototype[l] = n[l];
                u.VERSION = n.VERSION, u.prototype._preloadMethods = {
                    loadJSON: u.prototype,
                    loadImage: u.prototype,
                    loadStrings: u.prototype,
                    loadXML: u.prototype,
                    loadBytes: u.prototype,
                    loadTable: u.prototype,
                    loadFont: u.prototype,
                    loadModel: u.prototype,
                    loadShader: u.prototype
                }, u.prototype._registeredMethods = {
                    init: [],
                    pre: [],
                    post: [],
                    remove: []
                }, u.prototype._registeredPreloadMethods = {}, r.default = u;
            },
            {
                "./constants": 262,
                "./shim": 284,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.get-own-property-names": 177,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.for-each": 235,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        274: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                n.default.Element = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.elt = e1, this._pInst = this._pixelsState = t, this._events = {}, this.width = this.elt.offsetWidth, this.height = this.elt.offsetHeight;
                    }
                    var e1, t, o;
                    return e1 = r, o = [
                        {
                            key: "_adjustListener",
                            value: function(e1, t, r) {
                                return !1 === t ? n.default.Element._detachListener(e1, r) : n.default.Element._attachListener(e1, t, r), this;
                            }
                        },
                        {
                            key: "_attachListener",
                            value: function(e1, t, r) {
                                r._events[e1] && n.default.Element._detachListener(e1, r);
                                t = t.bind(r);
                                r.elt.addEventListener(e1, t, !1), r._events[e1] = t;
                            }
                        },
                        {
                            key: "_detachListener",
                            value: function(e1, t) {
                                var r = t._events[e1];
                                t.elt.removeEventListener(e1, r, !1), t._events[e1] = null;
                            }
                        }
                    ], t = [
                        {
                            key: "parent",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.parentNode : ("string" == typeof e1 ? ("#" === e1[0] && (e1 = e1.substring(1)), e1 = document.getElementById(e1)) : e1 instanceof n.default.Element && (e1 = e1.elt), e1.appendChild(this.elt), this);
                            }
                        },
                        {
                            key: "id",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.id : (this.elt.id = e1, this.width = this.elt.offsetWidth, this.height = this.elt.offsetHeight, this);
                            }
                        },
                        {
                            key: "class",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.className : (this.elt.className = e1, this);
                            }
                        },
                        {
                            key: "mousePressed",
                            value: function(t) {
                                return n.default.Element._adjustListener("mousedown", function(e1) {
                                    return this._pInst._setProperty("mouseIsPressed", !0), this._pInst._setMouseButton(e1), t.call(this, e1);
                                }, this), this;
                            }
                        },
                        {
                            key: "doubleClicked",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dblclick", e1, this), this;
                            }
                        },
                        {
                            key: "mouseWheel",
                            value: function(e1) {
                                return n.default.Element._adjustListener("wheel", e1, this), this;
                            }
                        },
                        {
                            key: "mouseReleased",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseup", e1, this), this;
                            }
                        },
                        {
                            key: "mouseClicked",
                            value: function(e1) {
                                return n.default.Element._adjustListener("click", e1, this), this;
                            }
                        },
                        {
                            key: "mouseMoved",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mousemove", e1, this), this;
                            }
                        },
                        {
                            key: "mouseOver",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseover", e1, this), this;
                            }
                        },
                        {
                            key: "mouseOut",
                            value: function(e1) {
                                return n.default.Element._adjustListener("mouseout", e1, this), this;
                            }
                        },
                        {
                            key: "touchStarted",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchstart", e1, this), this;
                            }
                        },
                        {
                            key: "touchMoved",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchmove", e1, this), this;
                            }
                        },
                        {
                            key: "touchEnded",
                            value: function(e1) {
                                return n.default.Element._adjustListener("touchend", e1, this), this;
                            }
                        },
                        {
                            key: "dragOver",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dragover", e1, this), this;
                            }
                        },
                        {
                            key: "dragLeave",
                            value: function(e1) {
                                return n.default.Element._adjustListener("dragleave", e1, this), this;
                            }
                        },
                        {
                            key: "_setProperty",
                            value: function(e1, t) {
                                this[e1] = t;
                            }
                        }
                    ], s(e1.prototype, t), o && s(e1, o), r;
                }();
                e1 = n.default.Element;
                r.default = e1;
            },
            {
                "./main": 273
            }
        ],
        275: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var c = (u = e1("./main")) && u.__esModule ? u : {
                    default: u
                }, d = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== a(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function a(e1) {
                    return (a = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function s(e1, t) {
                    return (s = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function f(r) {
                    return function() {
                        var e1, t = l(r);
                        return h(this, function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = l(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments));
                    };
                }
                function h(e1, t) {
                    return !t || "object" !== a(t) && "function" != typeof t ? p(e1) : t;
                }
                function p(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function l(e1) {
                    return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                c.default.Graphics = function(e1) {
                    var t = u;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && s(t, e1);
                    var r, l = f(u);
                    function u(e1, t, r, o, n) {
                        var s;
                        if (!(this instanceof u)) throw new TypeError("Cannot call a class as a function");
                        a = n || document.createElement("canvas"), (s = l.call(this, a, o)).canvas = a;
                        var i, a = r || d.P2D, r = o._userNode || document.body;
                        for(i in n || r.appendChild(s.canvas), c.default.prototype)s[i] || ("function" == typeof c.default.prototype[i] ? s[i] = c.default.prototype[i].bind(p(s)) : s[i] = c.default.prototype[i]);
                        return c.default.prototype._initializeInstanceVariables.apply(p(s)), s.width = e1, s.height = t, s._pixelDensity = o._pixelDensity, a === d.WEBGL ? s._renderer = new c.default.RendererGL(s.canvas, p(s), !1) : s._renderer = new c.default.Renderer2D(s.canvas, p(s), !1), o._elements.push(p(s)), Object.defineProperty(p(s), "deltaTime", {
                            get: function() {
                                return this._pInst.deltaTime;
                            }
                        }), s._renderer.resize(e1, t), s._renderer._applyDefaults(), h(s, p(s));
                    }
                    return t = u, e1 = [
                        {
                            key: "reset",
                            value: function() {
                                this._renderer.resetMatrix(), this._renderer.isP3D && this._renderer._update();
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.elt.parentNode && this.elt.parentNode.removeChild(this.elt);
                                var e1, t = this._pInst._elements.indexOf(this);
                                for(e1 in -1 !== t && this._pInst._elements.splice(t, 1), this._events)this.elt.removeEventListener(e1, this._events[e1]);
                            }
                        },
                        {
                            key: "createFramebuffer",
                            value: function(e1) {
                                return new c.default.Framebuffer(this, e1);
                            }
                        }
                    ], n(t.prototype, e1), r && n(t, r), u;
                }(c.default.Element);
                var u = c.default.Graphics;
                r.default = u;
            },
            {
                "./constants": 262,
                "./main": 273,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.splice": 166,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        276: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (s = e1("./main")) && s.__esModule ? s : {
                    default: s
                }, A = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== l(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function l(e1) {
                    return (l = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function c(e1, t) {
                    return (c = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function d(o) {
                    return function() {
                        var e1, t, r = n(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = n(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== l(t) && "function" != typeof t ? f(r) : t;
                    };
                }
                function f(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function n(e1) {
                    return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                var s = function(e1) {
                    var t = s;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && c(t, e1);
                    var r, n = d(s);
                    function s(e1, t, r) {
                        var o;
                        if (this instanceof s) return (o = n.call(this, e1, t)).canvas = e1, o._pixelsState = t, r ? (o._isMainCanvas = !0, o._pInst._setProperty("_curElement", f(o)), o._pInst._setProperty("canvas", o.canvas), o._pInst._setProperty("width", o.width), o._pInst._setProperty("height", o.height)) : (o.canvas.style.display = "none", o._styles = []), o._textSize = 12, o._textLeading = 15, o._textFont = "sans-serif", o._textStyle = A.NORMAL, o._textAscent = null, o._textDescent = null, o._textAlign = A.LEFT, o._textBaseline = A.BASELINE, o._textWrap = A.WORD, o._rectMode = A.CORNER, o._ellipseMode = A.CENTER, o._curveTightness = 0, o._imageMode = A.CORNER, o._tint = null, o._doStroke = !0, o._doFill = !0, o._strokeSet = !1, o._fillSet = !1, o._leadingSet = !1, o;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = s, e1 = [
                        {
                            key: "push",
                            value: function() {
                                return {
                                    properties: {
                                        _doStroke: this._doStroke,
                                        _strokeSet: this._strokeSet,
                                        _doFill: this._doFill,
                                        _fillSet: this._fillSet,
                                        _tint: this._tint,
                                        _imageMode: this._imageMode,
                                        _rectMode: this._rectMode,
                                        _ellipseMode: this._ellipseMode,
                                        _textFont: this._textFont,
                                        _textLeading: this._textLeading,
                                        _leadingSet: this._leadingSet,
                                        _textSize: this._textSize,
                                        _textAlign: this._textAlign,
                                        _textBaseline: this._textBaseline,
                                        _textStyle: this._textStyle,
                                        _textWrap: this._textWrap
                                    }
                                };
                            }
                        },
                        {
                            key: "pop",
                            value: function(e1) {
                                e1.properties && Object.assign(this, e1.properties);
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                this.width = e1, this.height = t, this.elt.width = e1 * this._pInst._pixelDensity, this.elt.height = t * this._pInst._pixelDensity, this.elt.style.width = "".concat(e1, "px"), this.elt.style.height = "".concat(t, "px"), this._isMainCanvas && (this._pInst._setProperty("width", this.width), this._pInst._setProperty("height", this.height));
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                var n = this._pixelsState, s = n._pixelDensity, i = this.canvas;
                                if (void 0 === e1 && void 0 === t) e1 = t = 0, r = n.width, o = n.height;
                                else if (e1 *= s, t *= s, void 0 === r && void 0 === o) return e1 < 0 || t < 0 || e1 >= i.width || t >= i.height ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : this._getPixel(e1, t);
                                n = new a.default.Image(r, o);
                                return n.canvas.getContext("2d").drawImage(i, e1, t, r * s, o * s, 0, 0, r, o), n;
                            }
                        },
                        {
                            key: "textLeading",
                            value: function(e1) {
                                return "number" == typeof e1 ? (this._setProperty("_leadingSet", !0), this._setProperty("_textLeading", e1), this._pInst) : this._textLeading;
                            }
                        },
                        {
                            key: "textStyle",
                            value: function(e1) {
                                return e1 ? (e1 !== A.NORMAL && e1 !== A.ITALIC && e1 !== A.BOLD && e1 !== A.BOLDITALIC || this._setProperty("_textStyle", e1), this._applyTextProperties()) : this._textStyle;
                            }
                        },
                        {
                            key: "textAscent",
                            value: function() {
                                return null === this._textAscent && this._updateTextMetrics(), this._textAscent;
                            }
                        },
                        {
                            key: "textDescent",
                            value: function() {
                                return null === this._textDescent && this._updateTextMetrics(), this._textDescent;
                            }
                        },
                        {
                            key: "textAlign",
                            value: function(e1, t) {
                                return void 0 !== e1 ? (this._setProperty("_textAlign", e1), void 0 !== t && this._setProperty("_textBaseline", t), this._applyTextProperties()) : {
                                    horizontal: this._textAlign,
                                    vertical: this._textBaseline
                                };
                            }
                        },
                        {
                            key: "textWrap",
                            value: function(e1) {
                                return this._setProperty("_textWrap", e1), this._textWrap;
                            }
                        },
                        {
                            key: "text",
                            value: function(e1, t, r, o, n) {
                                var s, i, a, l, u = this._pInst, c = this._textWrap, d = Number.MAX_VALUE, f = r;
                                if ((this._doFill || this._doStroke) && void 0 !== e1) {
                                    if (s = (e1 = (e1 = "string" != typeof e1 ? e1.toString() : e1).replace(/(\t)/g, "  ")).split("\n"), void 0 !== o) {
                                        switch(this._rectMode === A.CENTER && (t -= o / 2), this._textAlign){
                                            case A.CENTER:
                                                t += o / 2;
                                                break;
                                            case A.RIGHT:
                                                t += o;
                                        }
                                        if (void 0 !== n) {
                                            this._rectMode === A.CENTER && (r -= n / 2, f -= n / 2);
                                            var e1 = r, h = u.textAscent();
                                            switch(this._textBaseline){
                                                case A.BOTTOM:
                                                    l = r + n, r = Math.max(l, r), f += h;
                                                    break;
                                                case A.CENTER:
                                                    l = r + n / 2, r = Math.max(l, r), f += h / 2;
                                            }
                                            d = r + n - h, this._textBaseline === A.CENTER && (d = e1 + n - h / 2);
                                        } else this._textBaseline !== A.BOTTOM && this._textBaseline !== A.CENTER || (f = r - (e1 = u.textSize() * this._textLeading) / 2, d = r + e1 / 2);
                                        if (c === A.WORD) {
                                            for(var p = [], m = 0; m < s.length; m++){
                                                for(var y = "", g = s[m].split(" "), v = 0; v < g.length; v++)i = "".concat(y + g[v]) + " ", y = o < (a = this.textWidth(i)) && 0 < y.length ? (p.push(y), "".concat(g[v]) + " ") : i;
                                                p.push(y);
                                            }
                                            var b = 0;
                                            this._textBaseline === A.CENTER ? b = (p.length - 1) * u.textLeading() / 2 : this._textBaseline === A.BOTTOM && (b = (p.length - 1) * u.textLeading());
                                            for(var j = 0; j < s.length; j++){
                                                y = "", g = s[j].split(" ");
                                                for(var _ = 0; _ < g.length; _++)i = "".concat(y + g[_]) + " ", o < (a = this.textWidth(i)) && 0 < y.length ? (this._renderText(u, y.trim(), t, r - b, d, f), y = "".concat(g[_]) + " ", r += u.textLeading()) : y = i;
                                                this._renderText(u, y.trim(), t, r - b, d, f), r += u.textLeading();
                                            }
                                        } else {
                                            for(var x = [], w = 0; w < s.length; w++)for(var S = s[w].split(y = ""), E = 0; E < S.length; E++)i = "".concat(y + S[E]), (a = this.textWidth(i)) <= o ? y += S[E] : o < a && 0 < y.length && (x.push(y), y = "".concat(S[E]));
                                            x.push(y);
                                            var M = 0;
                                            this._textBaseline === A.CENTER ? M = (x.length - 1) * u.textLeading() / 2 : this._textBaseline === A.BOTTOM && (M = (x.length - 1) * u.textLeading());
                                            for(var T = 0; T < s.length; T++){
                                                S = s[T].split(y = "");
                                                for(var k = 0; k < S.length; k++)i = "".concat(y + S[k]), (a = this.textWidth(i)) <= o ? y += S[k] : o < a && 0 < y.length && (this._renderText(u, y.trim(), t, r - M, d, f), r += u.textLeading(), y = "".concat(S[k]));
                                            }
                                            this._renderText(u, y.trim(), t, r - M, d, f), r += u.textLeading();
                                        }
                                    } else {
                                        var O = 0;
                                        this._textBaseline === A.CENTER ? O = (s.length - 1) * u.textLeading() / 2 : this._textBaseline === A.BOTTOM && (O = (s.length - 1) * u.textLeading());
                                        for(var C = 0; C < s.length; C++)this._renderText(u, s[C], t, r - O, d, f - O), r += u.textLeading();
                                    }
                                    return u;
                                }
                            }
                        },
                        {
                            key: "_applyDefaults",
                            value: function() {
                                return this;
                            }
                        },
                        {
                            key: "_isOpenType",
                            value: function() {
                                var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : this._textFont;
                                return "object" === l(e1) && e1.font && e1.font.supported;
                            }
                        },
                        {
                            key: "_updateTextMetrics",
                            value: function() {
                                var e1, t, r, o, n, s;
                                return this._isOpenType() ? (this._setProperty("_textAscent", this._textFont._textAscent()), this._setProperty("_textDescent", this._textFont._textDescent())) : ((e1 = document.createElement("span")).style.fontFamily = this._textFont, e1.style.fontSize = "".concat(this._textSize, "px"), e1.innerHTML = "ABCjgq|", (s = document.createElement("div")).style.display = "inline-block", s.style.width = "1px", s.style.height = "0px", o = ((t = document.createElement("div")).appendChild(e1), t.appendChild(s), t.style.height = "0px", t.style.overflow = "hidden", document.body.appendChild(t), s.style.verticalAlign = "baseline", h(s)), n = h(e1), r = o[1] - n[1], o = (s.style.verticalAlign = "bottom", h(s)), n = h(e1), s = o[1] - n[1] - r, document.body.removeChild(t), this._setProperty("_textAscent", r), this._setProperty("_textDescent", s)), this;
                            }
                        }
                    ], u(t.prototype, e1), r && u(t, r), s;
                }(a.default.Element);
                function h(e1) {
                    var t = 0, r = 0;
                    if (e1.offsetParent) for(; t += e1.offsetLeft, r += e1.offsetTop, e1 = e1.offsetParent;);
                    else t += e1.offsetLeft, r += e1.offsetTop;
                    return [
                        t,
                        r
                    ];
                }
                s.prototype.textSize = function(e1) {
                    return "number" == typeof e1 ? (this._setProperty("_textSize", e1), this._leadingSet || this._setProperty("_textLeading", e1 * A._DEFAULT_LEADMULT), this._applyTextProperties()) : this._textSize;
                }, a.default.Renderer = s;
                e1 = a.default.Renderer;
                r.default = e1;
            },
            {
                "../core/constants": 262,
                "./main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.number.constructor": 171,
                "core-js/modules/es.object.assign": 174,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.replace": 194,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.string.trim": 199,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        277: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var d = (n = e1("./main")) && n.__esModule ? n : {
                    default: n
                }, p = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== a(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function a(e1) {
                    return (a = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function l(e1, t, r) {
                    return (l = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e1, t, r) {
                        var e1 = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = f(e1)););
                            return e1;
                        }(e1, t);
                        if (e1) return (e1 = Object.getOwnPropertyDescriptor(e1, t)).get ? e1.get.call(r) : e1.value;
                    })(e1, t, r || e1);
                }
                function u(e1, t) {
                    return (u = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function c(r) {
                    return function() {
                        var e1, t = f(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = f(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== a(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function f(e1) {
                    return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                e1("./p5.Renderer");
                var h = "rgba(0,0,0,0)", n = function(e1) {
                    var t = n;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && u(t, e1);
                    var r, o = c(n);
                    function n(e1, t, r) {
                        if (this instanceof n) return (e1 = o.call(this, e1, t, r)).drawingContext = e1.canvas.getContext("2d"), e1._pInst._setProperty("drawingContext", e1.drawingContext), e1;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = n, e1 = [
                        {
                            key: "_applyDefaults",
                            value: function() {
                                this._cachedFillStyle = this._cachedStrokeStyle = void 0, this._cachedBlendMode = p.BLEND, this._setFill(p._DEFAULT_FILL), this._setStroke(p._DEFAULT_STROKE), this.drawingContext.lineCap = p.ROUND, this.drawingContext.font = "normal 12px sans-serif";
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                l(f(n.prototype), "resize", this).call(this, e1, t), this.drawingContext.scale(this._pInst._pixelDensity, this._pInst._pixelDensity);
                            }
                        },
                        {
                            key: "background",
                            value: function() {
                                var e1, t;
                                this.drawingContext.save(), this.resetMatrix(), (arguments.length <= 0 ? void 0 : arguments[0]) instanceof d.default.Image ? 0 <= (arguments.length <= 1 ? void 0 : arguments[1]) ? (e1 = arguments.length <= 0 ? void 0 : arguments[0], this.drawingContext.globalAlpha = (arguments.length <= 1 ? void 0 : arguments[1]) / 255, this._pInst.image(e1, 0, 0, this.width, this.height)) : this._pInst.image(arguments.length <= 0 ? void 0 : arguments[0], 0, 0, this.width, this.height) : (e1 = this._getFill(), t = (t = this._pInst).color.apply(t, arguments), this._pInst._addAccsOutput() && this._pInst._accsBackground(t.levels), t = t.toString(), this._setFill(t), this._isErasing && this.blendMode(this._cachedBlendMode), this.drawingContext.fillRect(0, 0, this.width, this.height), this._setFill(e1), this._isErasing && this._pInst.erase()), this.drawingContext.restore();
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.drawingContext.save(), this.resetMatrix(), this.drawingContext.clearRect(0, 0, this.width, this.height), this.drawingContext.restore();
                            }
                        },
                        {
                            key: "fill",
                            value: function() {
                                var e1 = (e1 = this._pInst).color.apply(e1, arguments);
                                this._setFill(e1.toString()), this._pInst._addAccsOutput() && this._pInst._accsCanvasColors("fill", e1.levels);
                            }
                        },
                        {
                            key: "stroke",
                            value: function() {
                                var e1 = (e1 = this._pInst).color.apply(e1, arguments);
                                this._setStroke(e1.toString()), this._pInst._addAccsOutput() && this._pInst._accsCanvasColors("stroke", e1.levels);
                            }
                        },
                        {
                            key: "erase",
                            value: function(e1, t) {
                                this._isErasing || (this._cachedFillStyle = this.drawingContext.fillStyle, e1 = this._pInst.color(255, e1).toString(), this.drawingContext.fillStyle = e1, this._cachedStrokeStyle = this.drawingContext.strokeStyle, e1 = this._pInst.color(255, t).toString(), this.drawingContext.strokeStyle = e1, t = this._cachedBlendMode, this.blendMode(p.REMOVE), this._cachedBlendMode = t, this._isErasing = !0);
                            }
                        },
                        {
                            key: "noErase",
                            value: function() {
                                this._isErasing && (this.drawingContext.fillStyle = this._cachedFillStyle, this.drawingContext.strokeStyle = this._cachedStrokeStyle, this.blendMode(this._cachedBlendMode), this._isErasing = !1);
                            }
                        },
                        {
                            key: "image",
                            value: function(e1, t, r, o, n, s, i, a, l) {
                                e1.gifProperties && e1._animateGif(this._pInst);
                                try {
                                    d.default.MediaElement && e1 instanceof d.default.MediaElement && e1._ensureCanvas();
                                    var u = (u = this._tint && e1.canvas ? this._getTintedImageCanvas(e1) : u) || e1.canvas || e1.elt, c = 1;
                                    e1.width && 0 < e1.width && (c = u.width / e1.width), this._isErasing && this.blendMode(this._cachedBlendMode), this.drawingContext.drawImage(u, c * t, c * r, c * o, c * n, s, i, a, l), this._isErasing && this._pInst.erase();
                                } catch (e1) {
                                    if ("NS_ERROR_NOT_AVAILABLE" !== e1.name) throw e1;
                                }
                            }
                        },
                        {
                            key: "_getTintedImageCanvas",
                            value: function(e1) {
                                if (!e1.canvas) return e1;
                                e1.tintCanvas || (e1.tintCanvas = document.createElement("canvas")), e1.tintCanvas.width !== e1.canvas.width && (e1.tintCanvas.width = e1.canvas.width), e1.tintCanvas.height !== e1.canvas.height && (e1.tintCanvas.height = e1.canvas.height);
                                var t = e1.tintCanvas.getContext("2d");
                                return t.save(), t.clearRect(0, 0, e1.canvas.width, e1.canvas.height), (this._tint[0] < 255 || this._tint[1] < 255 || this._tint[2] < 255) && (t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "luminosity", t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "color", t.drawImage(e1.canvas, 0, 0), t.globalCompositeOperation = "multiply", t.fillStyle = "rgb(".concat(this._tint.slice(0, 3).join(", "), ")"), t.fillRect(0, 0, e1.canvas.width, e1.canvas.height), t.globalCompositeOperation = "destination-in"), t.globalAlpha = this._tint[3] / 255, t.drawImage(e1.canvas, 0, 0), t.restore(), e1.tintCanvas;
                            }
                        },
                        {
                            key: "blendMode",
                            value: function(e1) {
                                if (e1 === p.SUBTRACT) console.warn("blendMode(SUBTRACT) only works in WEBGL mode.");
                                else {
                                    if (e1 !== p.BLEND && e1 !== p.REMOVE && e1 !== p.DARKEST && e1 !== p.LIGHTEST && e1 !== p.DIFFERENCE && e1 !== p.MULTIPLY && e1 !== p.EXCLUSION && e1 !== p.SCREEN && e1 !== p.REPLACE && e1 !== p.OVERLAY && e1 !== p.HARD_LIGHT && e1 !== p.SOFT_LIGHT && e1 !== p.DODGE && e1 !== p.BURN && e1 !== p.ADD) throw new Error("Mode ".concat(e1, " not recognized."));
                                    this._cachedBlendMode = e1, this.drawingContext.globalCompositeOperation = e1;
                                }
                            }
                        },
                        {
                            key: "blend",
                            value: function() {
                                for(var e1 = this.drawingContext.globalCompositeOperation, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                                var n = r[r.length - 1], s = Array.prototype.slice.call(r, 0, r.length - 1);
                                this.drawingContext.globalCompositeOperation = n, d.default.prototype.copy.apply(this, s), this.drawingContext.globalCompositeOperation = e1;
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function(e1, t) {
                                e1 = this.drawingContext.getImageData(e1, t, 1, 1).data;
                                return [
                                    e1[0],
                                    e1[1],
                                    e1[2],
                                    e1[3]
                                ];
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1 = this._pixelsState, t = e1._pixelDensity, r = this.width * t, t = this.height * t, r = this.drawingContext.getImageData(0, 0, r, t);
                                e1._setProperty("imageData", r), e1._setProperty("pixels", r.data);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                e1 = Math.floor(e1), t = Math.floor(t);
                                var o = this._pixelsState;
                                if (r instanceof d.default.Image) this.drawingContext.save(), this.drawingContext.setTransform(1, 0, 0, 1, 0, 0), this.drawingContext.scale(o._pixelDensity, o._pixelDensity), this.drawingContext.clearRect(e1, t, r.width, r.height), this.drawingContext.drawImage(r.canvas, e1, t), this.drawingContext.restore();
                                else {
                                    var n = 0, s = 0, i = 0, a = 0, l = 4 * (t * o._pixelDensity * (this.width * o._pixelDensity) + e1 * o._pixelDensity);
                                    if (o.imageData || o.loadPixels.call(o), "number" == typeof r) l < o.pixels.length && (i = s = n = r, a = 255);
                                    else if (r instanceof Array) {
                                        if (r.length < 4) throw new Error("pixel array must be of the form [R, G, B, A]");
                                        l < o.pixels.length && (n = r[0], s = r[1], i = r[2], a = r[3]);
                                    } else r instanceof d.default.Color && l < o.pixels.length && (n = r.levels[0], s = r.levels[1], i = r.levels[2], a = r.levels[3]);
                                    for(var u = 0; u < o._pixelDensity; u++)for(var c = 0; c < o._pixelDensity; c++)l = 4 * ((t * o._pixelDensity + c) * this.width * o._pixelDensity + (e1 * o._pixelDensity + u)), o.pixels[l] = n, o.pixels[l + 1] = s, o.pixels[l + 2] = i, o.pixels[l + 3] = a;
                                }
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                var n = this._pixelsState, s = n._pixelDensity;
                                void 0 === e1 && void 0 === t && void 0 === r && void 0 === o && (t = e1 = 0, r = this.width, o = this.height), e1 *= s, t *= s, r *= s, o *= s, this.gifProperties && (this.gifProperties.frames[this.gifProperties.displayIndex].image = n.imageData), this.drawingContext.putImageData(n.imageData, e1, t, 0, 0, r, o);
                            }
                        },
                        {
                            key: "_acuteArcToBezier",
                            value: function(e1, t) {
                                var r = t / 2, o = Math.cos(r), n = Math.sin(r), s = 1 / Math.tan(r), r = e1 + r, i = Math.cos(r), r = Math.sin(r), a = (4 - o) / 3, n = n + (o - a) * s;
                                return {
                                    ax: Math.cos(e1).toFixed(7),
                                    ay: Math.sin(e1).toFixed(7),
                                    bx: (a * i + n * r).toFixed(7),
                                    by: (a * r - n * i).toFixed(7),
                                    cx: (a * i - n * r).toFixed(7),
                                    cy: (a * r + n * i).toFixed(7),
                                    dx: Math.cos(e1 + t).toFixed(7),
                                    dy: Math.sin(e1 + t).toFixed(7)
                                };
                            }
                        },
                        {
                            key: "arc",
                            value: function(r, o, e1, t, n, s, i) {
                                var a, l = this.drawingContext, u = e1 / 2, c = t / 2, d = [];
                                for(r += u, o += c; 1e-5 <= s - n;)a = Math.min(s - n, p.HALF_PI), d.push(this._acuteArcToBezier(n, a)), n += a;
                                return this._doFill && (l.beginPath(), d.forEach(function(e1, t) {
                                    0 === t && l.moveTo(r + e1.ax * u, o + e1.ay * c), l.bezierCurveTo(r + e1.bx * u, o + e1.by * c, r + e1.cx * u, o + e1.cy * c, r + e1.dx * u, o + e1.dy * c);
                                }), i !== p.PIE && null != i || l.lineTo(r, o), l.closePath(), l.fill()), this._doStroke && (l.beginPath(), d.forEach(function(e1, t) {
                                    0 === t && l.moveTo(r + e1.ax * u, o + e1.ay * c), l.bezierCurveTo(r + e1.bx * u, o + e1.by * c, r + e1.cx * u, o + e1.cy * c, r + e1.dx * u, o + e1.dy * c);
                                }), i === p.PIE ? (l.lineTo(r, o), l.closePath()) : i === p.CHORD && l.closePath(), l.stroke()), this;
                            }
                        },
                        {
                            key: "ellipse",
                            value: function(e1) {
                                var t = this.drawingContext, r = this._doFill, o = this._doStroke, n = parseFloat(e1[0]), s = parseFloat(e1[1]), i = parseFloat(e1[2]), e1 = parseFloat(e1[3]);
                                if (r && !o) {
                                    if (this._getFill() === h) return this;
                                } else if (!r && o && this._getStroke() === h) return this;
                                var a = i / 2 * .5522847498, l = e1 / 2 * .5522847498, u = n + i, c = s + e1, i = n + i / 2, e1 = s + e1 / 2;
                                t.beginPath(), t.moveTo(n, e1), t.bezierCurveTo(n, e1 - l, i - a, s, i, s), t.bezierCurveTo(i + a, s, u, e1 - l, u, e1), t.bezierCurveTo(u, e1 + l, i + a, c, i, c), t.bezierCurveTo(i - a, c, n, e1 + l, n, e1), r && t.fill(), o && t.stroke();
                            }
                        },
                        {
                            key: "line",
                            value: function(e1, t, r, o) {
                                var n = this.drawingContext;
                                return this._doStroke && this._getStroke() !== h && (n.beginPath(), n.moveTo(e1, t), n.lineTo(r, o), n.stroke()), this;
                            }
                        },
                        {
                            key: "point",
                            value: function(e1, t) {
                                var r, o, n = this.drawingContext;
                                return !this._doStroke || this._getStroke() === h ? this : (r = this._getStroke(), o = this._getFill(), this._setFill(r), n.beginPath(), n.arc(e1, t, n.lineWidth / 2, 0, p.TWO_PI, !1), n.fill(), void this._setFill(o));
                            }
                        },
                        {
                            key: "quad",
                            value: function(e1, t, r, o, n, s, i, a) {
                                var l = this.drawingContext, u = this._doFill, c = this._doStroke;
                                if (u && !c) {
                                    if (this._getFill() === h) return this;
                                } else if (!u && c && this._getStroke() === h) return this;
                                return l.beginPath(), l.moveTo(e1, t), l.lineTo(r, o), l.lineTo(n, s), l.lineTo(i, a), l.closePath(), u && l.fill(), c && l.stroke(), this;
                            }
                        },
                        {
                            key: "rect",
                            value: function(e1) {
                                var t, r, o = e1[0], n = e1[1], s = e1[2], i = e1[3], a = e1[4], l = e1[5], u = e1[6], e1 = e1[7], c = this.drawingContext, d = this._doFill, f = this._doStroke;
                                if (d && !f) {
                                    if (this._getFill() === h) return this;
                                } else if (!d && f && this._getStroke() === h) return this;
                                return c.beginPath(), void 0 === a ? c.rect(o, n, s, i) : (void 0 === l && (l = a), void 0 === u && (u = l), void 0 === e1 && (e1 = u), f = (d = Math.abs(s)) / 2, r = (t = Math.abs(i)) / 2, t < 2 * (a = d < 2 * a ? f : a) && (a = r), t < 2 * (l = d < 2 * l ? f : l) && (l = r), t < 2 * (u = d < 2 * u ? f : u) && (u = r), t < 2 * (e1 = d < 2 * e1 ? f : e1) && (e1 = r), c.beginPath(), c.moveTo(o + a, n), c.arcTo(o + s, n, o + s, n + i, l), c.arcTo(o + s, n + i, o, n + i, u), c.arcTo(o, n + i, o, n, e1), c.arcTo(o, n, o + s, n, a), c.closePath()), this._doFill && c.fill(), this._doStroke && c.stroke(), this;
                            }
                        },
                        {
                            key: "triangle",
                            value: function(e1) {
                                var t = this.drawingContext, r = this._doFill, o = this._doStroke, n = e1[0], s = e1[1], i = e1[2], a = e1[3], l = e1[4], e1 = e1[5];
                                if (r && !o) {
                                    if (this._getFill() === h) return this;
                                } else if (!r && o && this._getStroke() === h) return this;
                                t.beginPath(), t.moveTo(n, s), t.lineTo(i, a), t.lineTo(l, e1), t.closePath(), r && t.fill(), o && t.stroke();
                            }
                        },
                        {
                            key: "endShape",
                            value: function(e1, t, r, o, n, s, i) {
                                if (0 !== t.length && (this._doStroke || this._doFill)) {
                                    var a, l, u, c = e1 === p.CLOSE, d = (c && !s && t.push(t[0]), t.length);
                                    if (!r || i !== p.POLYGON && null !== i) {
                                        if (!o || i !== p.POLYGON && null !== i) {
                                            if (!n || i !== p.POLYGON && null !== i) {
                                                if (i === p.POINTS) for(l = 0; l < d; l++)a = t[l], this._doStroke && this._pInst.stroke(a[6]), this._pInst.point(a[0], a[1]);
                                                else if (i === p.LINES) for(l = 0; l + 1 < d; l += 2)a = t[l], this._doStroke && this._pInst.stroke(t[l + 1][6]), this._pInst.line(a[0], a[1], t[l + 1][0], t[l + 1][1]);
                                                else if (i === p.TRIANGLES) for(l = 0; l + 2 < d; l += 3)a = t[l], this.drawingContext.beginPath(), this.drawingContext.moveTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(t[l + 2][0], t[l + 2][1]), this.drawingContext.closePath(), this._doFill && (this._pInst.fill(t[l + 2][5]), this.drawingContext.fill()), this._doStroke && (this._pInst.stroke(t[l + 2][6]), this.drawingContext.stroke());
                                                else if (i === p.TRIANGLE_STRIP) for(l = 0; l + 1 < d; l++)a = t[l], this.drawingContext.beginPath(), this.drawingContext.moveTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(a[0], a[1]), this._doStroke && this._pInst.stroke(t[l + 1][6]), this._doFill && this._pInst.fill(t[l + 1][5]), l + 2 < d && (this.drawingContext.lineTo(t[l + 2][0], t[l + 2][1]), this._doStroke && this._pInst.stroke(t[l + 2][6]), this._doFill && this._pInst.fill(t[l + 2][5])), this._doFillStrokeClose(c);
                                                else if (i === p.TRIANGLE_FAN) {
                                                    if (2 < d) {
                                                        for(this.drawingContext.beginPath(), l = 2; l < d; l++)a = t[l], this.drawingContext.moveTo(t[0][0], t[0][1]), this.drawingContext.lineTo(t[l - 1][0], t[l - 1][1]), this.drawingContext.lineTo(a[0], a[1]), this.drawingContext.lineTo(t[0][0], t[0][1]), l < d - 1 && (this._doFill && a[5] !== t[l + 1][5] || this._doStroke && a[6] !== t[l + 1][6]) && (this._doFill && (this._pInst.fill(a[5]), this.drawingContext.fill(), this._pInst.fill(t[l + 1][5])), this._doStroke && (this._pInst.stroke(a[6]), this.drawingContext.stroke(), this._pInst.stroke(t[l + 1][6])), this.drawingContext.closePath(), this.drawingContext.beginPath());
                                                        this._doFillStrokeClose(c);
                                                    }
                                                } else if (i === p.QUADS) for(l = 0; l + 3 < d; l += 4){
                                                    for(a = t[l], this.drawingContext.beginPath(), this.drawingContext.moveTo(a[0], a[1]), u = 1; u < 4; u++)this.drawingContext.lineTo(t[l + u][0], t[l + u][1]);
                                                    this.drawingContext.lineTo(a[0], a[1]), this._doFill && this._pInst.fill(t[l + 3][5]), this._doStroke && this._pInst.stroke(t[l + 3][6]), this._doFillStrokeClose(c);
                                                }
                                                else if (i === p.QUAD_STRIP) {
                                                    if (3 < d) for(l = 0; l + 1 < d; l += 2)a = t[l], this.drawingContext.beginPath(), l + 3 < d ? (this.drawingContext.moveTo(t[l + 2][0], t[l + 2][1]), this.drawingContext.lineTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this.drawingContext.lineTo(t[l + 3][0], t[l + 3][1]), this._doFill && this._pInst.fill(t[l + 3][5]), this._doStroke && this._pInst.stroke(t[l + 3][6])) : (this.drawingContext.moveTo(a[0], a[1]), this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1])), this._doFillStrokeClose(c);
                                                } else {
                                                    for(this.drawingContext.beginPath(), this.drawingContext.moveTo(t[0][0], t[0][1]), l = 1; l < d; l++)(a = t[l]).isVert && (a.moveTo ? this.drawingContext.moveTo(a[0], a[1]) : this.drawingContext.lineTo(a[0], a[1]));
                                                    this._doFillStrokeClose(c);
                                                }
                                            } else {
                                                for(this.drawingContext.beginPath(), l = 0; l < d; l++)t[l].isVert ? t[l].moveTo ? this.drawingContext.moveTo(t[l][0], t[l][1]) : this.drawingContext.lineTo(t[l][0], t[l][1]) : this.drawingContext.quadraticCurveTo(t[l][0], t[l][1], t[l][2], t[l][3]);
                                                this._doFillStrokeClose(c);
                                            }
                                        } else {
                                            for(this.drawingContext.beginPath(), l = 0; l < d; l++)t[l].isVert ? t[l].moveTo ? this.drawingContext.moveTo(t[l][0], t[l][1]) : this.drawingContext.lineTo(t[l][0], t[l][1]) : this.drawingContext.bezierCurveTo(t[l][0], t[l][1], t[l][2], t[l][3], t[l][4], t[l][5]);
                                            this._doFillStrokeClose(c);
                                        }
                                    } else if (3 < d) {
                                        var f = [], h = 1 - this._curveTightness;
                                        for(this.drawingContext.beginPath(), this.drawingContext.moveTo(t[1][0], t[1][1]), l = 1; l + 2 < d; l++)a = t[l], f[0] = [
                                            a[0],
                                            a[1]
                                        ], f[1] = [
                                            a[0] + (h * t[l + 1][0] - h * t[l - 1][0]) / 6,
                                            a[1] + (h * t[l + 1][1] - h * t[l - 1][1]) / 6
                                        ], f[2] = [
                                            t[l + 1][0] + (h * t[l][0] - h * t[l + 2][0]) / 6,
                                            t[l + 1][1] + (h * t[l][1] - h * t[l + 2][1]) / 6
                                        ], f[3] = [
                                            t[l + 1][0],
                                            t[l + 1][1]
                                        ], this.drawingContext.bezierCurveTo(f[1][0], f[1][1], f[2][0], f[2][1], f[3][0], f[3][1]);
                                        c && this.drawingContext.lineTo(t[l + 1][0], t[l + 1][1]), this._doFillStrokeClose(c);
                                    }
                                    s = n = o = r = !1, c && t.pop();
                                }
                                return this;
                            }
                        },
                        {
                            key: "strokeCap",
                            value: function(e1) {
                                return e1 !== p.ROUND && e1 !== p.SQUARE && e1 !== p.PROJECT || (this.drawingContext.lineCap = e1), this;
                            }
                        },
                        {
                            key: "strokeJoin",
                            value: function(e1) {
                                return e1 !== p.ROUND && e1 !== p.BEVEL && e1 !== p.MITER || (this.drawingContext.lineJoin = e1), this;
                            }
                        },
                        {
                            key: "strokeWeight",
                            value: function(e1) {
                                return this.drawingContext.lineWidth = void 0 === e1 || 0 === e1 ? 1e-4 : e1, this;
                            }
                        },
                        {
                            key: "_getFill",
                            value: function() {
                                return this._cachedFillStyle || (this._cachedFillStyle = this.drawingContext.fillStyle), this._cachedFillStyle;
                            }
                        },
                        {
                            key: "_setFill",
                            value: function(e1) {
                                e1 !== this._cachedFillStyle && (this.drawingContext.fillStyle = e1, this._cachedFillStyle = e1);
                            }
                        },
                        {
                            key: "_getStroke",
                            value: function() {
                                return this._cachedStrokeStyle || (this._cachedStrokeStyle = this.drawingContext.strokeStyle), this._cachedStrokeStyle;
                            }
                        },
                        {
                            key: "_setStroke",
                            value: function(e1) {
                                e1 !== this._cachedStrokeStyle && (this.drawingContext.strokeStyle = e1, this._cachedStrokeStyle = e1);
                            }
                        },
                        {
                            key: "bezier",
                            value: function(e1, t, r, o, n, s, i, a) {
                                return this._pInst.beginShape(), this._pInst.vertex(e1, t), this._pInst.bezierVertex(r, o, n, s, i, a), this._pInst.endShape(), this;
                            }
                        },
                        {
                            key: "curve",
                            value: function(e1, t, r, o, n, s, i, a) {
                                return this._pInst.beginShape(), this._pInst.curveVertex(e1, t), this._pInst.curveVertex(r, o), this._pInst.curveVertex(n, s), this._pInst.curveVertex(i, a), this._pInst.endShape(), this;
                            }
                        },
                        {
                            key: "_doFillStrokeClose",
                            value: function(e1) {
                                e1 && this.drawingContext.closePath(), this._doFill && this.drawingContext.fill(), this._doStroke && this.drawingContext.stroke();
                            }
                        },
                        {
                            key: "applyMatrix",
                            value: function(e1, t, r, o, n, s) {
                                this.drawingContext.transform(e1, t, r, o, n, s);
                            }
                        },
                        {
                            key: "resetMatrix",
                            value: function() {
                                return this.drawingContext.setTransform(1, 0, 0, 1, 0, 0), this.drawingContext.scale(this._pInst._pixelDensity, this._pInst._pixelDensity), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1) {
                                this.drawingContext.rotate(e1);
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t) {
                                return this.drawingContext.scale(e1, t), this;
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1, t) {
                                return e1 instanceof d.default.Vector && (t = e1.y, e1 = e1.x), this.drawingContext.translate(e1, t), this;
                            }
                        },
                        {
                            key: "_renderText",
                            value: function(e1, t, r, o, n, s) {
                                if (!(o < s || n <= o)) return e1.push(), this._isOpenType() ? this._textFont._renderPath(t, r, o, {
                                    renderer: this
                                }) : (this._doStroke && this._strokeSet && this.drawingContext.strokeText(t, r, o), this._doFill && (this._fillSet || this._setFill(p._DEFAULT_TEXT_FILL), this.drawingContext.fillText(t, r, o))), e1.pop(), e1;
                            }
                        },
                        {
                            key: "textWidth",
                            value: function(e1) {
                                return this._isOpenType() ? this._textFont._textWidth(e1, this._textSize) : this.drawingContext.measureText(e1).width;
                            }
                        },
                        {
                            key: "_applyTextProperties",
                            value: function() {
                                var e1, t = this._pInst;
                                return this._setProperty("_textAscent", null), this._setProperty("_textDescent", null), e1 = this._textFont, this._isOpenType() && (e1 = this._textFont.font.familyName, this._setProperty("_textStyle", this._textFont.font.styleName)), this.drawingContext.font = "".concat(this._textStyle || "normal", " ").concat(this._textSize || 12, "px ").concat(e1 || "sans-serif"), this.drawingContext.textAlign = this._textAlign, this._textBaseline === p.CENTER ? this.drawingContext.textBaseline = p._CTX_MIDDLE : this.drawingContext.textBaseline = this._textBaseline, t;
                            }
                        },
                        {
                            key: "push",
                            value: function() {
                                return this.drawingContext.save(), l(f(n.prototype), "push", this).call(this);
                            }
                        },
                        {
                            key: "pop",
                            value: function(e1) {
                                this.drawingContext.restore(), this._cachedFillStyle = this.drawingContext.fillStyle, this._cachedStrokeStyle = this.drawingContext.strokeStyle, l(f(n.prototype), "pop", this).call(this, e1);
                            }
                        }
                    ], s(t.prototype, e1), r && s(t, r), n;
                }(d.default.Renderer), e1 = (n.prototype.text = function(e1, t, r, o, n) {
                    void 0 !== o && this.drawingContext.textBaseline === p.BASELINE && (s = !0, this.drawingContext.textBaseline = p.TOP);
                    var s, o = d.default.Renderer.prototype.text.apply(this, arguments);
                    return s && (this.drawingContext.textBaseline = p.BASELINE), o;
                }, d.default.Renderer2D = n, d.default.Renderer2D);
                r.default = e1;
            },
            {
                "./constants": 262,
                "./main": 273,
                "./p5.Renderer": 276,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.function.name": 167,
                "core-js/modules/es.number.to-fixed": 173,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.reflect.get": 183,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        278: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator");
                var f = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                f.default.prototype._promisePreloads = [];
                function o() {
                    return {};
                }
                var h = (f.default.prototype.registerPromisePreload = function(e1) {
                    f.default.prototype._promisePreloads.push(e1);
                }, false);
                f.default.prototype._setupPromisePreloads = function() {
                    var e1 = !0, t = !1, r = void 0;
                    try {
                        for(var o, n = this._promisePreloads[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                            var s = o.value, i = this, a = s.method, l = s.addCallbacks, u = s.legacyPreloadSetup, c = s.target || this, d = c[a].bind(c);
                            if (c === f.default.prototype) {
                                if (h) continue;
                                i = null, d = c[a];
                            }
                            c[a] = this._wrapPromisePreload(i, d, l), u && (c[u.method] = this._legacyPreloadGenerator(i, u, c[a]));
                        }
                    } catch (e1) {
                        t = !0, r = e1;
                    } finally{
                        try {
                            e1 || null == n.return || n.return();
                        } finally{
                            if (t) throw r;
                        }
                    }
                    h = !0;
                }, f.default.prototype._wrapPromisePreload = function(e1, l, u) {
                    var t = function() {
                        for(var e1 = this, t = (this._incrementPreload(), null), r = null, o = arguments.length, n = new Array(o), s = 0; s < o; s++)n[s] = arguments[s];
                        if (u) for(var i = n.length - 1; 0 <= i && !r && "function" == typeof n[i]; i--)r = t, t = n.pop();
                        var a = Promise.resolve(l.apply(this, n));
                        return t && a.then(t), r && a.catch(r), a.then(function() {
                            return e1._decrementPreload();
                        }), a;
                    };
                    return t = e1 ? t.bind(e1) : t;
                };
                f.default.prototype._legacyPreloadGenerator = function(e1, t, s) {
                    var i = t.createBaseObject || o, t = function() {
                        var t = this;
                        this._incrementPreload();
                        for(var e1 = arguments.length, r = new Array(e1), o = 0; o < e1; o++)r[o] = arguments[o];
                        var n = i.apply(this, r);
                        return s.apply(this, r).then(function(e1) {
                            Object.assign(n, e1), t._decrementPreload();
                        }), n;
                    };
                    return t = e1 ? t.bind(e1) : t;
                };
            },
            {
                "./main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.assign": 174,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.promise": 181,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        279: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("./main")) && n.__esModule ? n : {
                    default: n
                }, u = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== a(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("./constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function a(e1) {
                    return (a = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("./p5.Graphics"), e1("./p5.Renderer2D"), e1("../webgl/p5.RendererGL");
                var c = "defaultCanvas0", n = (l.default.prototype.createCanvas = function(e1, t, r, o) {
                    var n, s, i;
                    if (l.default._validateParameters("createCanvas", arguments), arguments[2] instanceof HTMLCanvasElement ? (r = u.P2D, o = arguments[2]) : n = r || u.P2D, o) (i = document.getElementById(c)) && i.parentNode.removeChild(i), i = o, this._defaultGraphicsCreated = !1;
                    else {
                        if (n === u.WEBGL) (i = document.getElementById(c)) && (i.parentNode.removeChild(i), s = this._renderer, this._elements = this._elements.filter(function(e1) {
                            return e1 !== s;
                        })), (i = document.createElement("canvas")).id = c, i.classList.add("p5Canvas");
                        else if (this._defaultGraphicsCreated) i = this.canvas;
                        else {
                            i = o || document.createElement("canvas");
                            for(var a = 0; document.getElementById("defaultCanvas".concat(a));)a++;
                            c = "defaultCanvas".concat(a), i.id = c, i.classList.add("p5Canvas");
                        }
                        this._setupDone || (i.dataset.hidden = !0, i.style.visibility = "hidden"), (this._userNode || (0 === document.getElementsByTagName("main").length && (r = document.createElement("main"), document.body.appendChild(r)), document.getElementsByTagName("main")[0])).appendChild(i);
                    }
                    return n === u.WEBGL ? (this._setProperty("_renderer", new l.default.RendererGL(i, this, !0)), this._elements.push(this._renderer)) : this._defaultGraphicsCreated || (this._setProperty("_renderer", new l.default.Renderer2D(i, this, !0)), this._defaultGraphicsCreated = !0, this._elements.push(this._renderer)), this._renderer.resize(e1, t), this._renderer._applyDefaults(), this._renderer;
                }, l.default.prototype.resizeCanvas = function(e1, t, r) {
                    if (l.default._validateParameters("resizeCanvas", arguments), this._renderer) {
                        var o, n, s = {};
                        for(o in this.drawingContext){
                            var i = this.drawingContext[o];
                            "object" !== a(i) && "function" != typeof i && (s[o] = i);
                        }
                        for(n in this.width = e1, this.height = t, this._renderer.resize(e1, t), s)try {
                            this.drawingContext[n] = s[n];
                        } catch (e1) {}
                        r || this.redraw();
                    }
                    this._addAccsOutput() && this._updateAccsOutput();
                }, l.default.prototype.noCanvas = function() {
                    this.canvas && this.canvas.parentNode.removeChild(this.canvas);
                }, l.default.prototype.createGraphics = function(e1, t, r, o) {
                    return arguments[2] instanceof HTMLCanvasElement && (r = u.P2D, o = arguments[2]), l.default._validateParameters("createGraphics", arguments), new l.default.Graphics(e1, t, r, this, o);
                }, l.default.prototype.createFramebuffer = function(e1) {
                    return new l.default.Framebuffer(this, e1);
                }, l.default.prototype.blendMode = function(e1) {
                    l.default._validateParameters("blendMode", arguments), e1 === u.NORMAL && (console.warn("NORMAL has been deprecated for use in blendMode. defaulting to BLEND instead."), e1 = u.BLEND), this._renderer.blendMode(e1);
                }, l.default);
                r.default = n;
            },
            {
                "../webgl/p5.RendererGL": 328,
                "./constants": 262,
                "./main": 273,
                "./p5.Graphics": 275,
                "./p5.Renderer2D": 277,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        280: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = n(e1("../main")), a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = c();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants")), u = n(e1("../helpers"));
                function c() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, c = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function s(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                e1("../friendly_errors/fes_core"), e1("../friendly_errors/file_errors"), e1("../friendly_errors/validate_params"), l.default.prototype._normalizeArcAngles = function(e1, t, r, o, n) {
                    var s;
                    return e1 -= a.TWO_PI * Math.floor(e1 / a.TWO_PI), t -= a.TWO_PI * Math.floor(t / a.TWO_PI), s = Math.min(Math.abs(e1 - t), a.TWO_PI - Math.abs(e1 - t)), n && (e1 = e1 <= a.HALF_PI ? Math.atan(r / o * Math.tan(e1)) : e1 > a.HALF_PI && e1 <= 3 * a.HALF_PI ? Math.atan(r / o * Math.tan(e1)) + a.PI : Math.atan(r / o * Math.tan(e1)) + a.TWO_PI, t = t <= a.HALF_PI ? Math.atan(r / o * Math.tan(t)) : t > a.HALF_PI && t <= 3 * a.HALF_PI ? Math.atan(r / o * Math.tan(t)) + a.PI : Math.atan(r / o * Math.tan(t)) + a.TWO_PI), t < e1 && (t += a.TWO_PI), {
                        start: e1,
                        stop: t,
                        correspondToSamePoint: s < 1e-5
                    };
                }, l.default.prototype.arc = function(e1, t, r, o, n, s, i, a) {
                    return l.default._validateParameters("arc", arguments), (this._renderer._doStroke || this._renderer._doFill) && n !== s && (n = this._toRadians(n), s = this._toRadians(s), r = Math.abs(r), o = Math.abs(o), e1 = u.default.modeAdjust(e1, t, r, o, this._renderer._ellipseMode), (t = this._normalizeArcAngles(n, s, e1.w, e1.h, !0)).correspondToSamePoint ? this._renderer.ellipse([
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        a
                    ]) : (this._renderer.arc(e1.x, e1.y, e1.w, e1.h, t.start, t.stop, i, a), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("arc", [
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        t.start,
                        t.stop,
                        i
                    ]))), this;
                }, l.default.prototype.ellipse = function(e1, t, r, o, n) {
                    return l.default._validateParameters("ellipse", arguments), this._renderEllipse.apply(this, arguments);
                }, l.default.prototype.circle = function() {
                    l.default._validateParameters("circle", arguments);
                    var e1 = Array.prototype.slice.call(arguments, 0, 2);
                    return e1.push(arguments[2]), e1.push(arguments[2]), this._renderEllipse.apply(this, s(e1));
                }, l.default.prototype._renderEllipse = function(e1, t, r, o, n) {
                    return (this._renderer._doStroke || this._renderer._doFill) && (r < 0 && (r = Math.abs(r)), void 0 === o ? o = r : o < 0 && (o = Math.abs(o)), e1 = u.default.modeAdjust(e1, t, r, o, this._renderer._ellipseMode), this._renderer.ellipse([
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h,
                        n
                    ]), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("ellipse", [
                        e1.x,
                        e1.y,
                        e1.w,
                        e1.h
                    ])), this;
                }, l.default.prototype.line = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("line", r), this._renderer._doStroke && (e1 = this._renderer).line.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("line", r), this;
                }, l.default.prototype.point = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("point", r), this._renderer._doStroke && (1 === r.length && r[0] instanceof l.default.Vector ? this._renderer.point.call(this._renderer, r[0].x, r[0].y, r[0].z) : ((e1 = this._renderer).point.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("point", r))), this;
                }, l.default.prototype.quad = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("quad", r), (this._renderer._doStroke || this._renderer._doFill) && (this._renderer.isP3D && r.length < 12 ? this._renderer.quad.call(this._renderer, r[0], r[1], 0, r[2], r[3], 0, r[4], r[5], 0, r[6], r[7], 0, r[8], r[9]) : ((e1 = this._renderer).quad.apply(e1, r), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("quadrilateral", r))), this;
                }, l.default.prototype.rect = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return l.default._validateParameters("rect", t), this._renderRect.apply(this, t);
                }, l.default.prototype.square = function(e1, t, r, o, n, s, i) {
                    return l.default._validateParameters("square", arguments), this._renderRect.call(this, e1, t, r, r, o, n, s, i);
                }, l.default.prototype._renderRect = function() {
                    if (this._renderer._doStroke || this._renderer._doFill) {
                        3 === arguments.length && (arguments[3] = arguments[2]);
                        for(var e1 = u.default.modeAdjust(arguments[0], arguments[1], arguments[2], arguments[3], this._renderer._rectMode), t = [
                            e1.x,
                            e1.y,
                            e1.w,
                            e1.h
                        ], r = 4; r < arguments.length; r++)t[r] = arguments[r];
                        this._renderer.rect(t), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("rectangle", [
                            e1.x,
                            e1.y,
                            e1.w,
                            e1.h
                        ]);
                    }
                    return this;
                }, l.default.prototype.triangle = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return l.default._validateParameters("triangle", t), (this._renderer._doStroke || this._renderer._doFill) && this._renderer.triangle(t), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._accsOutput("triangle", t), this;
                };
                e1 = l.default;
                r.default = e1;
            },
            {
                "../constants": 262,
                "../friendly_errors/fes_core": 264,
                "../friendly_errors/file_errors": 265,
                "../friendly_errors/validate_params": 268,
                "../helpers": 269,
                "../main": 273,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        281: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (l = e1("../main")) && l.__esModule ? l : {
                    default: l
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype.ellipseMode = function(e1) {
                    return n.default._validateParameters("ellipseMode", arguments), e1 !== s.CORNER && e1 !== s.CORNERS && e1 !== s.RADIUS && e1 !== s.CENTER || (this._renderer._ellipseMode = e1), this;
                }, n.default.prototype.noSmooth = function() {
                    return this._renderer.isP3D ? this.setAttributes("antialias", !1) : "imageSmoothingEnabled" in this.drawingContext && (this.drawingContext.imageSmoothingEnabled = !1), this;
                }, n.default.prototype.rectMode = function(e1) {
                    return n.default._validateParameters("rectMode", arguments), e1 !== s.CORNER && e1 !== s.CORNERS && e1 !== s.RADIUS && e1 !== s.CENTER || (this._renderer._rectMode = e1), this;
                }, n.default.prototype.smooth = function() {
                    return this.setAttributes("antialias", !0), this._renderer.isP3D || "imageSmoothingEnabled" in this.drawingContext && (this.drawingContext.imageSmoothingEnabled = !0), this;
                }, n.default.prototype.strokeCap = function(e1) {
                    return n.default._validateParameters("strokeCap", arguments), e1 !== s.ROUND && e1 !== s.SQUARE && e1 !== s.PROJECT || this._renderer.strokeCap(e1), this;
                }, n.default.prototype.strokeJoin = function(e1) {
                    return n.default._validateParameters("strokeJoin", arguments), e1 !== s.ROUND && e1 !== s.BEVEL && e1 !== s.MITER || this._renderer.strokeJoin(e1), this;
                }, n.default.prototype.strokeWeight = function(e1) {
                    return n.default._validateParameters("strokeWeight", arguments), this._renderer.strokeWeight(e1), this;
                };
                var l = n.default;
                r.default = l;
            },
            {
                "../constants": 262,
                "../main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        282: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (o = e1("../main")) && o.__esModule ? o : {
                    default: o
                };
                e1("../friendly_errors/fes_core"), e1("../friendly_errors/file_errors"), e1("../friendly_errors/validate_params"), l.default.prototype.bezier = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("bezier", r), (this._renderer._doStroke || this._renderer._doFill) && (e1 = this._renderer).bezier.apply(e1, r), this;
                }, l.default.prototype.bezierDetail = function(e1) {
                    return l.default._validateParameters("bezierDetail", arguments), this._bezierDetail = e1, this;
                }, l.default.prototype.bezierPoint = function(e1, t, r, o, n) {
                    l.default._validateParameters("bezierPoint", arguments);
                    var s = 1 - n;
                    return Math.pow(s, 3) * e1 + 3 * Math.pow(s, 2) * n * t + 3 * s * Math.pow(n, 2) * r + Math.pow(n, 3) * o;
                }, l.default.prototype.bezierTangent = function(e1, t, r, o, n) {
                    l.default._validateParameters("bezierTangent", arguments);
                    var s = 1 - n;
                    return 3 * o * Math.pow(n, 2) - 3 * r * Math.pow(n, 2) + 6 * r * s * n - 6 * t * s * n + 3 * t * Math.pow(s, 2) - 3 * e1 * Math.pow(s, 2);
                }, l.default.prototype.curve = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return l.default._validateParameters("curve", r), this._renderer._doStroke && (e1 = this._renderer).curve.apply(e1, r), this;
                }, l.default.prototype.curveDetail = function(e1) {
                    return l.default._validateParameters("curveDetail", arguments), this._curveDetail = e1 < 3 ? 3 : e1, this;
                }, l.default.prototype.curveTightness = function(e1) {
                    return l.default._validateParameters("curveTightness", arguments), this._renderer._curveTightness = e1, this;
                }, l.default.prototype.curvePoint = function(e1, t, r, o, n) {
                    l.default._validateParameters("curvePoint", arguments);
                    var s = this._renderer._curveTightness, i = n * n * n, a = n * n;
                    return e1 * ((s - 1) / 2 * i + (1 - s) * a + (s - 1) / 2 * n) + t * ((s + 3) / 2 * i + (-5 - s) / 2 * a + 1) + r * ((-3 - s) / 2 * i + (s + 2) * a + (1 - s) / 2 * n) + o * ((1 - s) / 2 * i + (s - 1) / 2 * a);
                }, l.default.prototype.curveTangent = function(e1, t, r, o, n) {
                    l.default._validateParameters("curveTangent", arguments);
                    var s = this._renderer._curveTightness, i = n * n * 3, n = 2 * n;
                    return e1 * ((s - 1) / 2 * i + (1 - s) * n + (s - 1) / 2) + t * ((s + 3) / 2 * i + (-5 - s) / 2 * n) + r * ((-3 - s) / 2 * i + (s + 2) * n + (1 - s) / 2) + o * ((1 - s) / 2 * i + (s - 1) / 2 * n);
                };
                var o = l.default;
                r.default = o;
            },
            {
                "../friendly_errors/fes_core": 264,
                "../friendly_errors/file_errors": 265,
                "../friendly_errors/validate_params": 268,
                "../main": 273
            }
        ],
        283: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.slice"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (y = e1("../main")) && y.__esModule ? y : {
                    default: y
                }, l = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = u();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../constants"));
                function u() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, u = function() {
                        return e1;
                    }, e1);
                }
                var n = null, c = [], d = [], f = !1, s = !1, h = !1, p = !1, m = !0, y = (a.default.prototype.beginContour = function() {
                    return d = [], p = !0, this;
                }, a.default.prototype.beginShape = function(e1) {
                    var t;
                    return a.default._validateParameters("beginShape", arguments), this._renderer.isP3D ? (t = this._renderer).beginShape.apply(t, arguments) : (n = e1 === l.POINTS || e1 === l.LINES || e1 === l.TRIANGLES || e1 === l.TRIANGLE_FAN || e1 === l.TRIANGLE_STRIP || e1 === l.QUADS || e1 === l.QUAD_STRIP ? e1 : null, c = [], d = []), this;
                }, a.default.prototype.bezierVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    if (a.default._validateParameters("bezierVertex", r), this._renderer.isP3D) (e1 = this._renderer).bezierVertex.apply(e1, r);
                    else if (0 === c.length) a.default._friendlyError("vertex() must be used once before calling bezierVertex()", "bezierVertex");
                    else {
                        f = !0;
                        for(var n = [], s = 0; s < r.length; s++)n[s] = r[s];
                        n.isVert = !1, (p ? d : c).push(n);
                    }
                    return this;
                }, a.default.prototype.curveVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return a.default._validateParameters("curveVertex", r), this._renderer.isP3D ? (e1 = this._renderer).curveVertex.apply(e1, r) : (s = !0, this.vertex(r[0], r[1])), this;
                }, a.default.prototype.endContour = function() {
                    var e1 = d[0].slice();
                    e1.isVert = d[0].isVert, e1.moveTo = !1, d.push(e1), m && (c.push(c[0]), m = !1);
                    for(var t = 0; t < d.length; t++)c.push(d[t]);
                    return this;
                }, a.default.prototype.endShape = function(e1) {
                    if (a.default._validateParameters("endShape", arguments), this._renderer.isP3D) this._renderer.endShape(e1, s, f, h, p, n);
                    else {
                        if (0 === c.length) return this;
                        if (!this._renderer._doStroke && !this._renderer._doFill) return this;
                        var t = e1 === l.CLOSE;
                        t && !p && c.push(c[0]), this._renderer.endShape(e1, c, s, f, h, p, n), m = (p = h = f = s = !1, true), t && c.pop();
                    }
                    return this;
                }, a.default.prototype.quadraticVertex = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    if (a.default._validateParameters("quadraticVertex", r), this._renderer.isP3D) (e1 = this._renderer).quadraticVertex.apply(e1, r);
                    else {
                        if (this._contourInited) return (e1 = {}).x = r[0], e1.y = r[1], e1.x3 = r[2], e1.y3 = r[3], e1.type = l.QUADRATIC, this._contourVertices.push(e1), this;
                        if (0 < c.length) {
                            h = !0;
                            for(var n = [], s = 0; s < r.length; s++)n[s] = r[s];
                            n.isVert = !1, (p ? d : c).push(n);
                        } else a.default._friendlyError("vertex() must be used once before calling quadraticVertex()", "quadraticVertex");
                    }
                    return this;
                }, a.default.prototype.vertex = function(e1, t, r, o, n) {
                    var s;
                    return this._renderer.isP3D ? (s = this._renderer).vertex.apply(s, arguments) : ((s = []).isVert = !0, s[0] = e1, s[1] = t, s[2] = 0, s[3] = 0, s[4] = 0, s[5] = this._renderer._getFill(), s[6] = this._renderer._getStroke(), r && (s.moveTo = r), (p ? (0 === d.length && (s.moveTo = !0), d) : c).push(s)), this;
                }, a.default.prototype.normal = function(e1, t, r) {
                    var o;
                    return this._assert3d("normal"), a.default._validateParameters("normal", arguments), (o = this._renderer).normal.apply(o, arguments), this;
                }, a.default);
                r.default = y;
            },
            {
                "../constants": 262,
                "../main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        284: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function a(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function n(e1) {
                    return (n = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                var l, u, c;
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(e1, t) {
                    window.setTimeout(e1, 1e3 / 60);
                }, "undefined" == typeof Uint8ClampedArray || Uint8ClampedArray.prototype.slice || Object.defineProperty(Uint8ClampedArray.prototype, "slice", {
                    value: Array.prototype.slice,
                    writable: !0,
                    configurable: !0,
                    enumerable: !1
                }), Object.assign || (l = Object.keys, e1 = Object.defineProperty, u = "function" == typeof Symbol && "symbol" === n(Symbol()), c = Object.prototype.propertyIsEnumerable, e1(Object, "assign", {
                    value: function(e1, t) {
                        if (null == e1) throw new TypeError("target must be an object");
                        for(var r, o = Object(e1), n = 1; n < arguments.length; ++n){
                            var s = Object(arguments[n]), i = l(s);
                            for(u && Object.getOwnPropertySymbols && i.push.apply(i, a(Object.getOwnPropertySymbols(s).filter(function(t) {
                                return function(e1) {
                                    return c.call(t, e1);
                                };
                            }(s)))), r = 0; r < i.length; ++r)o[i[r]] = s[i[r]];
                        }
                        return o;
                    },
                    configurable: !0,
                    enumerable: !1,
                    writable: !0
                }));
            },
            {
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.assign": 174,
                "core-js/modules/es.object.keys": 179,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint8-clamped-array": 233,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        285: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/web.dom-collections.for-each"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.noLoop = function() {
                    this._loop = !1;
                }, e1.default.prototype.loop = function() {
                    this._loop || (this._loop = !0, this._setupDone && this._draw());
                }, e1.default.prototype.isLooping = function() {
                    return this._loop;
                }, e1.default.prototype.push = function() {
                    this._styles.push({
                        props: {
                            _colorMode: this._colorMode
                        },
                        renderer: this._renderer.push()
                    });
                }, e1.default.prototype.pop = function() {
                    var e1 = this._styles.pop();
                    e1 ? (this._renderer.pop(e1.renderer), Object.assign(this, e1.props)) : console.warn("pop() was called without matching push()");
                }, e1.default.prototype.redraw = function(e1) {
                    if (!this._inUserDraw && this._setupDone) {
                        var t = parseInt(e1), r = ((isNaN(t) || t < 1) && (t = 1), this._isGlobal ? window : this);
                        if ("function" == typeof r.draw) {
                            void 0 === r.setup && r.scale(r._pixelDensity, r._pixelDensity);
                            for(var o = function(e1) {
                                e1.call(r);
                            }, n = 0; n < t; n++){
                                r.resetMatrix(), (this._accessibleOutputs.grid || this._accessibleOutputs.text) && this._updateAccsOutput(), r._renderer.isP3D && r._renderer._update(), r._setProperty("frameCount", r.frameCount + 1), r._registeredMethods.pre.forEach(o), this._inUserDraw = !0;
                                try {
                                    r.draw();
                                } finally{
                                    this._inUserDraw = !1;
                                }
                                r._registeredMethods.post.forEach(o);
                            }
                        }
                    }
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "./main": 273,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.object.assign": 174,
                "core-js/modules/web.dom-collections.for-each": 235
            }
        ],
        286: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("./main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                n.default.prototype.applyMatrix = function() {
                    var e1 = (arguments.length <= 0 ? void 0 : arguments[0]) instanceof Object.getPrototypeOf(Uint8Array);
                    return Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) || e1 ? (e1 = this._renderer).applyMatrix.apply(e1, o(arguments.length <= 0 ? void 0 : arguments[0])) : (e1 = this._renderer).applyMatrix.apply(e1, arguments), this;
                }, n.default.prototype.resetMatrix = function() {
                    return this._renderer.resetMatrix(), this;
                }, n.default.prototype.rotate = function(e1, t) {
                    return n.default._validateParameters("rotate", arguments), this._renderer.rotate(this._toRadians(e1), t), this;
                }, n.default.prototype.rotateX = function(e1) {
                    return this._assert3d("rotateX"), n.default._validateParameters("rotateX", arguments), this._renderer.rotateX(this._toRadians(e1)), this;
                }, n.default.prototype.rotateY = function(e1) {
                    return this._assert3d("rotateY"), n.default._validateParameters("rotateY", arguments), this._renderer.rotateY(this._toRadians(e1)), this;
                }, n.default.prototype.rotateZ = function(e1) {
                    return this._assert3d("rotateZ"), n.default._validateParameters("rotateZ", arguments), this._renderer.rotateZ(this._toRadians(e1)), this;
                }, n.default.prototype.scale = function(e1, t, r) {
                    var o;
                    return n.default._validateParameters("scale", arguments), e1 instanceof n.default.Vector ? (e1 = (o = e1).x, t = o.y, r = o.z) : e1 instanceof Array && (e1 = (o = e1)[0], t = o[1], r = o[2] || 1), isNaN(t) ? t = r = e1 : isNaN(r) && (r = 1), this._renderer.scale.call(this._renderer, e1, t, r), this;
                }, n.default.prototype.shearX = function(e1) {
                    n.default._validateParameters("shearX", arguments);
                    e1 = this._toRadians(e1);
                    return this._renderer.applyMatrix(1, 0, Math.tan(e1), 1, 0, 0), this;
                }, n.default.prototype.shearY = function(e1) {
                    n.default._validateParameters("shearY", arguments);
                    e1 = this._toRadians(e1);
                    return this._renderer.applyMatrix(1, Math.tan(e1), 0, 1, 0, 0), this;
                }, n.default.prototype.translate = function(e1, t, r) {
                    return n.default._validateParameters("translate", arguments), this._renderer.isP3D ? this._renderer.translate(e1, t, r) : this._renderer.translate(e1, t), this;
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "./main": 273,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint8-array": 232,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        287: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.ends-with"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator");
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                n.default.prototype.storeItem = function(e1, t) {
                    "string" != typeof e1 && console.log("The argument that you passed to storeItem() - ".concat(e1, " is not a string.")), e1.endsWith("p5TypeID") && console.log("The argument that you passed to storeItem() - ".concat(e1, " must not end with 'p5TypeID'.")), void 0 === t && console.log("You cannot store undefined variables using storeItem().");
                    var r = i(t);
                    switch(r){
                        case "number":
                        case "boolean":
                            t = t.toString();
                            break;
                        case "object":
                            t instanceof n.default.Color ? r = "p5.Color" : t instanceof n.default.Vector && (r = "p5.Vector", t = [
                                t.x,
                                t.y,
                                t.z
                            ]), t = JSON.stringify(t);
                    }
                    localStorage.setItem(e1, t);
                    e1 = "".concat(e1, "p5TypeID");
                    localStorage.setItem(e1, r);
                }, n.default.prototype.getItem = function(e1) {
                    var t = localStorage.getItem(e1), r = localStorage.getItem("".concat(e1, "p5TypeID"));
                    if (void 0 === r) console.log("Unable to determine type of item stored under ".concat(e1, "in local storage. Did you save the item with something other than setItem()?"));
                    else if (null !== t) switch(r){
                        case "number":
                            t = parseFloat(t);
                            break;
                        case "boolean":
                            t = "true" === t;
                            break;
                        case "object":
                            t = JSON.parse(t);
                            break;
                        case "p5.Color":
                            t = JSON.parse(t), t = this.color.apply(this, s(t.levels));
                            break;
                        case "p5.Vector":
                            t = JSON.parse(t), t = this.createVector.apply(this, s(t));
                    }
                    return t;
                }, n.default.prototype.clearStorage = function() {
                    localStorage.clear();
                }, n.default.prototype.removeItem = function(e1) {
                    "string" != typeof e1 && console.log("The argument that you passed to removeItem() - ".concat(e1, " is not a string.")), localStorage.removeItem(e1), localStorage.removeItem("".concat(e1, "p5TypeID"));
                };
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.ends-with": 188,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        288: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1) {
                    return (n = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function i(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && a(e1, t);
                }
                function a(e1, t) {
                    return (a = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function l(r) {
                    return function() {
                        var e1, t = u(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = u(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== n(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function u(e1) {
                    return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function c(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function d(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function f(e1, t, r) {
                    t && d(e1.prototype, t), r && d(e1, r);
                }
                s.default.prototype.createStringDict = function(e1, t) {
                    return s.default._validateParameters("createStringDict", arguments), new s.default.StringDict(e1, t);
                }, s.default.prototype.createNumberDict = function(e1, t) {
                    return s.default._validateParameters("createNumberDict", arguments), new s.default.NumberDict(e1, t);
                }, s.default.TypedDict = function() {
                    function r(e1, t) {
                        return c(this, r), e1 instanceof Object ? this.data = e1 : (this.data = {}, this.data[e1] = t), this;
                    }
                    return f(r, [
                        {
                            key: "size",
                            value: function() {
                                return Object.keys(this.data).length;
                            }
                        },
                        {
                            key: "hasKey",
                            value: function(e1) {
                                return this.data.hasOwnProperty(e1);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1) {
                                if (this.data.hasOwnProperty(e1)) return this.data[e1];
                                console.log("".concat(e1, " does not exist in this Dictionary"));
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t) {
                                this._validate(t) ? this.data[e1] = t : console.log("Those values dont work for this dictionary type.");
                            }
                        },
                        {
                            key: "_addObj",
                            value: function(e1) {
                                for(var t in e1)this.set(t, e1[t]);
                            }
                        },
                        {
                            key: "create",
                            value: function(e1, t) {
                                e1 instanceof Object && void 0 === t ? this._addObj(e1) : void 0 !== e1 ? this.set(e1, t) : console.log("In order to create a new Dictionary entry you must pass an object or a key, value pair");
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.data = {};
                            }
                        },
                        {
                            key: "remove",
                            value: function(e1) {
                                if (!this.data.hasOwnProperty(e1)) throw new Error("".concat(e1, " does not exist in this Dictionary"));
                                delete this.data[e1];
                            }
                        },
                        {
                            key: "print",
                            value: function() {
                                for(var e1 in this.data)console.log("key:".concat(e1, " value:").concat(this.data[e1]));
                            }
                        },
                        {
                            key: "saveTable",
                            value: function(e1) {
                                var t, r = "";
                                for(t in this.data)r += "".concat(t, ",").concat(this.data[t], "\n");
                                var o = new Blob([
                                    r
                                ], {
                                    type: "text/csv"
                                });
                                s.default.prototype.downloadFile(o, e1 || "mycsv", "csv");
                            }
                        },
                        {
                            key: "saveJSON",
                            value: function(e1, t) {
                                s.default.prototype.saveJSON(this.data, e1, t);
                            }
                        },
                        {
                            key: "_validate",
                            value: function(e1) {
                                return !0;
                            }
                        }
                    ]), r;
                }(), s.default.StringDict = function() {
                    i(n, s.default.TypedDict);
                    var o = l(n);
                    function n() {
                        c(this, n);
                        for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                        return o.call.apply(o, [
                            this
                        ].concat(t));
                    }
                    return f(n, [
                        {
                            key: "_validate",
                            value: function(e1) {
                                return "string" == typeof e1;
                            }
                        }
                    ]), n;
                }(), s.default.NumberDict = function() {
                    i(n, s.default.TypedDict);
                    var o = l(n);
                    function n() {
                        c(this, n);
                        for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                        return o.call.apply(o, [
                            this
                        ].concat(t));
                    }
                    return f(n, [
                        {
                            key: "_validate",
                            value: function(e1) {
                                return "number" == typeof e1;
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] += t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "sub",
                            value: function(e1, t) {
                                this.add(e1, -t);
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] *= t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "div",
                            value: function(e1, t) {
                                this.data.hasOwnProperty(e1) ? this.data[e1] /= t : console.log("The key - ".concat(e1, " does not exist in this dictionary."));
                            }
                        },
                        {
                            key: "_valueTest",
                            value: function(e1) {
                                if (0 === Object.keys(this.data).length) throw new Error("Unable to search for a minimum or maximum value on an empty NumberDict");
                                if (1 === Object.keys(this.data).length) return this.data[Object.keys(this.data)[0]];
                                var t, r = this.data[Object.keys(this.data)[0]];
                                for(t in this.data)this.data[t] * e1 < r * e1 && (r = this.data[t]);
                                return r;
                            }
                        },
                        {
                            key: "minValue",
                            value: function() {
                                return this._valueTest(1);
                            }
                        },
                        {
                            key: "maxValue",
                            value: function() {
                                return this._valueTest(-1);
                            }
                        },
                        {
                            key: "_keyTest",
                            value: function(e1) {
                                if (0 === Object.keys(this.data).length) throw new Error("Unable to use minValue on an empty NumberDict");
                                if (1 === Object.keys(this.data).length) return Object.keys(this.data)[0];
                                for(var t = Object.keys(this.data)[0], r = 1; r < Object.keys(this.data).length; r++)Object.keys(this.data)[r] * e1 < t * e1 && (t = Object.keys(this.data)[r]);
                                return t;
                            }
                        },
                        {
                            key: "minKey",
                            value: function() {
                                return this._keyTest(1);
                            }
                        },
                        {
                            key: "maxKey",
                            value: function() {
                                return this._keyTest(-1);
                            }
                        }
                    ]), n;
                }();
                e1 = s.default.TypedDict;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.keys": 179,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        289: [
            function(t, r, o) {
                "use strict";
                function n(e1) {
                    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                t("core-js/modules/es.symbol"), t("core-js/modules/es.symbol.description"), t("core-js/modules/es.symbol.iterator"), t("core-js/modules/es.array.every"), t("core-js/modules/es.array.filter"), t("core-js/modules/es.array.for-each"), t("core-js/modules/es.array.from"), t("core-js/modules/es.array.index-of"), t("core-js/modules/es.array.iterator"), t("core-js/modules/es.array.map"), t("core-js/modules/es.array.slice"), t("core-js/modules/es.array.splice"), t("core-js/modules/es.function.name"), t("core-js/modules/es.object.get-prototype-of"), t("core-js/modules/es.object.to-string"), t("core-js/modules/es.promise"), t("core-js/modules/es.reflect.construct"), t("core-js/modules/es.regexp.exec"), t("core-js/modules/es.regexp.to-string"), t("core-js/modules/es.string.iterator"), t("core-js/modules/es.string.replace"), t("core-js/modules/es.string.split"), t("core-js/modules/es.string.trim"), t("core-js/modules/web.dom-collections.for-each"), t("core-js/modules/web.dom-collections.iterator"), t("core-js/modules/web.url"), t("core-js/modules/es.symbol"), t("core-js/modules/es.symbol.description"), t("core-js/modules/es.symbol.iterator"), t("core-js/modules/es.array.every"), t("core-js/modules/es.array.filter"), t("core-js/modules/es.array.for-each"), t("core-js/modules/es.array.from"), t("core-js/modules/es.array.index-of"), t("core-js/modules/es.array.iterator"), t("core-js/modules/es.array.map"), t("core-js/modules/es.array.slice"), t("core-js/modules/es.array.splice"), t("core-js/modules/es.function.name"), t("core-js/modules/es.object.to-string"), t("core-js/modules/es.promise"), t("core-js/modules/es.reflect.construct"), t("core-js/modules/es.regexp.exec"), t("core-js/modules/es.regexp.to-string"), t("core-js/modules/es.string.iterator"), t("core-js/modules/es.string.replace"), t("core-js/modules/es.string.split"), t("core-js/modules/es.string.trim"), t("core-js/modules/web.dom-collections.for-each"), t("core-js/modules/web.dom-collections.iterator"), t("core-js/modules/web.url"), Object.defineProperty(o, "__esModule", {
                    value: !0
                }), o.default = void 0;
                var h = (t = t("../core/main")) && t.__esModule ? t : {
                    default: t
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function a(e1, t, r) {
                    t && s(e1.prototype, t), r && s(e1, r);
                }
                function l(e1, t) {
                    return (l = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function u(o) {
                    return function() {
                        var e1, t, r = i(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = i(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== f(t) && "function" != typeof t ? c(r) : t;
                    };
                }
                function c(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function i(e1) {
                    return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function d(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function f(e1) {
                    return (f = "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? function(e1) {
                        return n(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : n(e1);
                    })(e1);
                }
                function p(e1, t, r) {
                    (t._userNode || document.body).appendChild(e1);
                    r = new (r ? h.default.MediaElement : h.default.Element)(e1, t);
                    return t._elements.push(r), r;
                }
                function m(e1, t, r, o) {
                    var n = document.createElement(t), s = ("string" == typeof (r = r || "") && (r = [
                        r
                    ]), !0), t = !1, i = void 0;
                    try {
                        for(var a, l = r[Symbol.iterator](); !(s = (a = l.next()).done); s = !0){
                            var u = a.value, c = document.createElement("source");
                            c.setAttribute("src", u), n.appendChild(c);
                        }
                    } catch (e1) {
                        t = !0, i = e1;
                    } finally{
                        try {
                            s || null == l.return || l.return();
                        } finally{
                            if (t) throw i;
                        }
                    }
                    "function" == typeof o && n.addEventListener("canplaythrough", function e1() {
                        o(), n.removeEventListener("canplaythrough", e1);
                    });
                    var d = p(n, e1, !0);
                    return d.loadedmetadata = !1, n.addEventListener("loadedmetadata", function() {
                        d.width = n.videoWidth, d.height = n.videoHeight, 0 === d.elt.width && (d.elt.width = n.videoWidth), 0 === d.elt.height && (d.elt.height = n.videoHeight), d.presetPlaybackRate && (d.elt.playbackRate = d.presetPlaybackRate, delete d.presetPlaybackRate), d.loadedmetadata = !0;
                    }), d;
                }
                h.default.prototype.select = function(e1, t) {
                    h.default._validateParameters("select", arguments);
                    t = this._getContainer(t).querySelector(e1);
                    return t ? this._wrapElement(t) : null;
                }, h.default.prototype.selectAll = function(e1, t) {
                    h.default._validateParameters("selectAll", arguments);
                    var r = [], o = this._getContainer(t).querySelectorAll(e1);
                    if (o) for(var n = 0; n < o.length; n++){
                        var s = this._wrapElement(o[n]);
                        r.push(s);
                    }
                    return r;
                }, h.default.prototype._getContainer = function(e1) {
                    var t = document;
                    return "string" == typeof e1 ? t = document.querySelector(e1) || document : e1 instanceof h.default.Element ? t = e1.elt : e1 instanceof HTMLElement && (t = e1), t;
                }, h.default.prototype._wrapElement = function(e1) {
                    var t, r = Array.prototype.slice.call(e1.children);
                    return "INPUT" === e1.tagName && "checkbox" === e1.type ? ((t = new h.default.Element(e1, this)).checked = function() {
                        return 0 === arguments.length ? this.elt.checked : (this.elt.checked = !(arguments.length <= 0 || !arguments[0]), this);
                    }, t) : "VIDEO" === e1.tagName || "AUDIO" === e1.tagName ? new h.default.MediaElement(e1, this) : "SELECT" === e1.tagName ? this.createSelect(new h.default.Element(e1, this)) : 0 < r.length && r.every(function(e1) {
                        return "INPUT" === e1.tagName || "LABEL" === e1.tagName;
                    }) ? this.createRadio(new h.default.Element(e1, this)) : new h.default.Element(e1, this);
                }, h.default.prototype.removeElements = function(e1) {
                    h.default._validateParameters("removeElements", arguments);
                    this._elements.filter(function(e1) {
                        return !(e1.elt instanceof HTMLCanvasElement);
                    }).map(function(e1) {
                        return e1.remove();
                    });
                }, h.default.Element.prototype.changed = function(e1) {
                    return h.default.Element._adjustListener("change", e1, this), this;
                }, h.default.Element.prototype.input = function(e1) {
                    return h.default.Element._adjustListener("input", e1, this), this;
                }, h.default.prototype.createDiv = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("div");
                    return t.innerHTML = e1, p(t, this);
                }, h.default.prototype.createP = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("p");
                    return t.innerHTML = e1, p(t, this);
                }, h.default.prototype.createSpan = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = document.createElement("span");
                    return t.innerHTML = e1, p(t, this);
                }, h.default.prototype.createImg = function() {
                    h.default._validateParameters("createImg", arguments);
                    var t, r = document.createElement("img"), o = arguments;
                    return 1 < o.length && "string" == typeof o[1] && (r.alt = o[1]), 2 < o.length && "string" == typeof o[2] && (r.crossOrigin = o[2]), r.src = o[0], t = p(r, this), r.addEventListener("load", function() {
                        t.width = r.offsetWidth || r.width, t.height = r.offsetHeight || r.height;
                        var e1 = o[o.length - 1];
                        "function" == typeof e1 && e1(t);
                    }), t;
                }, h.default.prototype.createA = function(e1, t, r) {
                    h.default._validateParameters("createA", arguments);
                    var o = document.createElement("a");
                    return o.href = e1, o.innerHTML = t, r && (o.target = r), p(o, this);
                }, h.default.prototype.createSlider = function(e1, t, r, o) {
                    h.default._validateParameters("createSlider", arguments);
                    var n = document.createElement("input");
                    return n.type = "range", n.min = e1, n.max = t, 0 === o ? n.step = 1e-18 : o && (n.step = o), "number" == typeof r && (n.value = r), p(n, this);
                }, h.default.prototype.createButton = function(e1, t) {
                    h.default._validateParameters("createButton", arguments);
                    var r = document.createElement("button");
                    return r.innerHTML = e1, t && (r.value = t), p(r, this);
                }, h.default.prototype.createCheckbox = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    h.default._validateParameters("createCheckbox", t);
                    var o = document.createElement("div"), n = document.createElement("input"), s = (n.type = "checkbox", document.createElement("label")), i = (s.appendChild(n), o.appendChild(s), p(o, this));
                    return i.checked = function() {
                        var e1 = i.elt.firstElementChild.getElementsByTagName("input")[0];
                        if (e1) {
                            if (0 === arguments.length) return e1.checked;
                            e1.checked = !(arguments.length <= 0 || !arguments[0]);
                        }
                        return i;
                    }, this.value = function(e1) {
                        return i.value = e1, this;
                    }, t[0] && (i.value(t[0]), (o = document.createElement("span")).innerHTML = t[0], s.appendChild(o)), t[1] && (n.checked = !0), i;
                }, h.default.prototype.createSelect = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    h.default._validateParameters("createSelect", r);
                    var n, s = r[0];
                    return s instanceof h.default.Element && s.elt instanceof HTMLSelectElement ? this.elt = (e1 = s).elt : s instanceof HTMLSelectElement ? (e1 = p(s, this), this.elt = s) : (n = document.createElement("select"), s && "boolean" == typeof s && n.setAttribute("multiple", "true"), e1 = p(n, this), this.elt = n), e1.option = function(e1, t) {
                        var r;
                        if (void 0 !== e1) {
                            for(var o, n = 0; n < this.elt.length; n += 1)if (this.elt[n].textContent === e1) {
                                r = n;
                                break;
                            }
                            void 0 !== r ? !1 === t ? this.elt.remove(r) : this.elt[r].value = t : ((o = document.createElement("option")).textContent = e1, o.value = void 0 === t ? e1 : t, this.elt.appendChild(o), this._pInst._elements.push(o));
                        }
                    }, e1.selected = function(e1) {
                        if (void 0 !== e1) {
                            for(var t = 0; t < this.elt.length; t += 1)this.elt[t].value.toString() === e1.toString() && (this.elt.selectedIndex = t);
                            return this;
                        }
                        if (this.elt.getAttribute("multiple")) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = this.elt.selectedOptions[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                    var l = i.value;
                                    r.push(l.value);
                                }
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                        return this.elt.value;
                    }, e1.disable = function(e1) {
                        if ("string" == typeof e1) for(var t = 0; t < this.elt.length; t++)this.elt[t].value.toString() === e1 && (this.elt[t].disabled = !0, this.elt[t].selected = !1);
                        else this.elt.disabled = !0;
                        return this;
                    }, e1.enable = function(e1) {
                        if ("string" == typeof e1) for(var t = 0; t < this.elt.length; t++)this.elt[t].value.toString() === e1 && (this.elt[t].disabled = !1, this.elt[t].selected = !1);
                        else {
                            this.elt.disabled = !1;
                            for(var r = 0; r < this.elt.length; r++)this.elt[r].disabled = !1, this.elt[r].selected = !1;
                        }
                        return this;
                    }, e1;
                }, h.default.prototype.createRadio = function() {
                    function t(e1) {
                        return e1 instanceof HTMLInputElement && "radio" === e1.type;
                    }
                    function d(e1) {
                        return e1 instanceof HTMLLabelElement;
                    }
                    var f, e1, r, o = arguments.length <= 0 ? void 0 : arguments[0];
                    o instanceof h.default.Element && (o.elt instanceof HTMLDivElement || o.elt instanceof HTMLSpanElement) ? (f = o, this.elt = o.elt) : o instanceof HTMLDivElement || o instanceof HTMLSpanElement ? (f = p(o, this), e1 = this.elt = o, "string" == typeof (arguments.length <= 1 ? void 0 : arguments[1]) && (r = arguments.length <= 1 ? void 0 : arguments[1])) : ("string" == typeof o && (r = o), e1 = document.createElement("div"), f = p(e1, this), this.elt = e1), f._name = r || "radioOption";
                    return f._getOptionsArray = function() {
                        return Array.from(this.elt.children).filter(function(e1) {
                            return t(e1) || d(e1) && t(e1.firstElementChild);
                        }).map(function(e1) {
                            return t(e1) ? e1 : e1.firstElementChild;
                        });
                    }, f.option = function(e1, t) {
                        var r, o, n, s = !0, i = !1, a = void 0;
                        try {
                            for(var l, u = f._getOptionsArray()[Symbol.iterator](); !(s = (l = u.next()).done); s = !0){
                                var c = l.value;
                                if (c.value === e1) {
                                    r = c;
                                    break;
                                }
                            }
                        } catch (e1) {
                            i = !0, a = e1;
                        } finally{
                            try {
                                s || null == u.return || u.return();
                            } finally{
                                if (i) throw a;
                            }
                        }
                        return void 0 === r && ((r = document.createElement("input")).setAttribute("type", "radio"), r.setAttribute("value", e1)), r.setAttribute("name", f._name), d(r.parentElement) ? o = r.parentElement : (o = document.createElement("label")).insertAdjacentElement("afterbegin", r), o.lastElementChild instanceof HTMLSpanElement ? n = o.lastElementChild : (n = document.createElement("span"), r.insertAdjacentElement("afterend", n)), n.innerHTML = void 0 === t ? e1 : t, this.elt.appendChild(o), r;
                    }, f.remove = function(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = f._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                if (i.value === e1) return void (d(i.parentElement) ? i.parentElement : i).remove();
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, f.value = function() {
                        var e1 = "", t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = f._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                if (i.checked) {
                                    e1 = i.value;
                                    break;
                                }
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                        return e1;
                    }, f.selected = function(e1) {
                        var t = null;
                        if (void 0 === e1) {
                            var r = !0, o = !1, n = void 0;
                            try {
                                for(var s, i = f._getOptionsArray()[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                    var a = s.value;
                                    if (a.checked) {
                                        t = a;
                                        break;
                                    }
                                }
                            } catch (e1) {
                                o = !0, n = e1;
                            } finally{
                                try {
                                    r || null == i.return || i.return();
                                } finally{
                                    if (o) throw n;
                                }
                            }
                        } else {
                            f._getOptionsArray().forEach(function(e1) {
                                e1.checked = !1, e1.removeAttribute("checked");
                            });
                            var l = !0, o = !1, n = void 0;
                            try {
                                for(var u, c = f._getOptionsArray()[Symbol.iterator](); !(l = (u = c.next()).done); l = !0){
                                    var d = u.value;
                                    d.value === e1 && (d.setAttribute("checked", !0), d.checked = !0, t = d);
                                }
                            } catch (e1) {
                                o = !0, n = e1;
                            } finally{
                                try {
                                    l || null == c.return || c.return();
                                } finally{
                                    if (o) throw n;
                                }
                            }
                        }
                        return t;
                    }, f.disable = function() {
                        var e1 = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0], t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = f._getOptionsArray()[Symbol.iterator](); !(t = (n = s.next()).done); t = !0)n.value.setAttribute("disabled", e1);
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, f;
                }, h.default.prototype.createColorPicker = function(e1) {
                    h.default._validateParameters("createColorPicker", arguments);
                    var t = document.createElement("input");
                    return t.type = "color", e1 ? e1 instanceof h.default.Color ? t.value = e1.toString("#rrggbb") : (h.default.prototype._colorMode = "rgb", h.default.prototype._colorMaxes = {
                        rgb: [
                            255,
                            255,
                            255,
                            255
                        ],
                        hsb: [
                            360,
                            100,
                            100,
                            1
                        ],
                        hsl: [
                            360,
                            100,
                            100,
                            1
                        ]
                    }, t.value = h.default.prototype.color(e1).toString("#rrggbb")) : t.value = "#000000", (t = p(t, this)).color = function() {
                        return e1 && (e1.mode && (h.default.prototype._colorMode = e1.mode), e1.maxes && (h.default.prototype._colorMaxes = e1.maxes)), h.default.prototype.color(this.elt.value);
                    }, t;
                }, h.default.prototype.createInput = function() {
                    var e1 = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "", t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "text", r = (h.default._validateParameters("createInput", arguments), document.createElement("input"));
                    return r.setAttribute("value", e1), r.setAttribute("type", t), p(r, this);
                }, h.default.prototype.createFileInput = function(a) {
                    var e1, t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1];
                    h.default._validateParameters("createFileInput", arguments);
                    if (window.File && window.FileReader && window.FileList && window.Blob) return (e1 = document.createElement("input")).setAttribute("type", "file"), t && e1.setAttribute("multiple", !0), e1.addEventListener("change", function(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1.target.files[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                h.default.File._load(i, a);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, !1), p(e1, this);
                    console.log("The File APIs are not fully supported in this browser. Cannot create element.");
                }, h.default.prototype.createVideo = function(e1, t) {
                    return h.default._validateParameters("createVideo", arguments), m(this, "video", e1, t);
                }, h.default.prototype.createAudio = function(e1, t) {
                    return h.default._validateParameters("createAudio", arguments), m(this, "audio", e1, t);
                }, h.default.prototype.VIDEO = "video", h.default.prototype.AUDIO = "audio", void 0 === navigator.mediaDevices && (navigator.mediaDevices = {}), void 0 === navigator.mediaDevices.getUserMedia && (navigator.mediaDevices.getUserMedia = function(r) {
                    var o = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                    return o ? new Promise(function(e1, t) {
                        o.call(navigator, r, e1, t);
                    }) : Promise.reject(new Error("getUserMedia is not implemented in this browser"));
                }), h.default.prototype.createCapture = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    if (h.default._validateParameters("createCapture", t), !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new DOMException("getUserMedia not supported in this browser");
                    for(var o, n = !0, s = !0, i = 0, a = t; i < a.length; i++){
                        var l = a[i];
                        l === h.default.prototype.VIDEO ? s = !1 : l === h.default.prototype.AUDIO ? n = !1 : "object" === f(l) ? u = l : "function" == typeof l && (o = l);
                    }
                    var u = u || {
                        video: n,
                        audio: s
                    }, c = document.createElement("video"), d = (c.setAttribute("playsinline", ""), navigator.mediaDevices.getUserMedia(u).then(function(t) {
                        try {
                            "srcObject" in c ? c.srcObject = t : c.src = window.URL.createObjectURL(t);
                        } catch (e1) {
                            c.src = t;
                        }
                    }, console.log), p(c, this, !0));
                    return d.loadedmetadata = !1, c.addEventListener("loadedmetadata", function() {
                        c.play(), c.width ? (d.width = c.width, d.height = c.height) : (d.width = d.elt.width = c.videoWidth, d.height = d.elt.height = c.videoHeight), d.loadedmetadata = !0, o && o(c.srcObject);
                    }), d;
                }, h.default.prototype.createElement = function(e1, t) {
                    h.default._validateParameters("createElement", arguments);
                    e1 = document.createElement(e1);
                    return void 0 !== t && (e1.innerHTML = t), p(e1, this);
                }, h.default.Element.prototype.addClass = function(e1) {
                    return this.elt.className ? this.hasClass(e1) || (this.elt.className = this.elt.className + " " + e1) : this.elt.className = e1, this;
                }, h.default.Element.prototype.removeClass = function(e1) {
                    return this.elt.classList.remove(e1), this;
                }, h.default.Element.prototype.hasClass = function(e1) {
                    return this.elt.classList.contains(e1);
                }, h.default.Element.prototype.toggleClass = function(e1) {
                    return this.elt.classList.contains(e1) ? this.elt.classList.remove(e1) : this.elt.classList.add(e1), this;
                }, h.default.Element.prototype.child = function(e1) {
                    return void 0 === e1 ? this.elt.childNodes : ("string" == typeof e1 ? ("#" === e1[0] && (e1 = e1.substring(1)), e1 = document.getElementById(e1)) : e1 instanceof h.default.Element && (e1 = e1.elt), e1 instanceof HTMLElement && this.elt.appendChild(e1), this);
                }, h.default.Element.prototype.center = function(e1) {
                    var t = this.elt.style.display, r = "none" === this.elt.style.display, o = "none" === this.parent().style.display, n = {
                        x: this.elt.offsetLeft,
                        y: this.elt.offsetTop
                    }, s = (r && this.show(), o && this.parent().show(), this.elt.style.display = "block", this.position(0, 0), Math.abs(this.parent().offsetWidth - this.elt.offsetWidth)), i = Math.abs(this.parent().offsetHeight - this.elt.offsetHeight);
                    return "both" === e1 || void 0 === e1 ? this.position(s / 2 + this.parent().offsetLeft, i / 2 + this.parent().offsetTop) : "horizontal" === e1 ? this.position(s / 2 + this.parent().offsetLeft, n.y) : "vertical" === e1 && this.position(n.x, i / 2 + this.parent().offsetTop), this.style("display", t), r && this.hide(), o && this.parent().hide(), this;
                }, h.default.Element.prototype.html = function() {
                    return 0 === arguments.length ? this.elt.innerHTML : (arguments.length <= 1 || !arguments[1] ? this.elt.innerHTML = arguments.length <= 0 ? void 0 : arguments[0] : this.elt.insertAdjacentHTML("beforeend", arguments.length <= 0 ? void 0 : arguments[0]), this);
                }, h.default.Element.prototype.position = function() {
                    return 0 === arguments.length ? {
                        x: this.elt.offsetLeft,
                        y: this.elt.offsetTop
                    } : (this.elt.style.position = "static" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "fixed" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "relative" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "sticky" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "initial" !== (arguments.length <= 2 ? void 0 : arguments[2]) && "inherit" !== (arguments.length <= 2 ? void 0 : arguments[2]) ? "absolute" : arguments.length <= 2 ? void 0 : arguments[2], this.elt.style.left = (arguments.length <= 0 ? void 0 : arguments[0]) + "px", this.elt.style.top = (arguments.length <= 1 ? void 0 : arguments[1]) + "px", this.x = arguments.length <= 0 ? void 0 : arguments[0], this.y = arguments.length <= 1 ? void 0 : arguments[1], this);
                }, h.default.Element.prototype._translate = function() {
                    this.elt.style.position = "absolute";
                    var e1 = "";
                    return this.elt.style.transform && (e1 = (e1 = this.elt.style.transform.replace(/translate3d\(.*\)/g, "")).replace(/translate[X-Z]?\(.*\)/g, "")), 2 === arguments.length ? this.elt.style.transform = "translate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "px, " + (arguments.length <= 1 ? void 0 : arguments[1]) + "px)" : 2 < arguments.length && (this.elt.style.transform = "translate3d(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "px," + (arguments.length <= 1 ? void 0 : arguments[1]) + "px," + (arguments.length <= 2 ? void 0 : arguments[2]) + "px)", this.elt.parentElement.style.perspective = 3 === arguments.length ? "1000px" : (arguments.length <= 3 ? void 0 : arguments[3]) + "px"), this.elt.style.transform += e1, this;
                }, h.default.Element.prototype._rotate = function() {
                    var e1 = "";
                    return this.elt.style.transform && (e1 = (e1 = this.elt.style.transform.replace(/rotate3d\(.*\)/g, "")).replace(/rotate[X-Z]?\(.*\)/g, "")), 1 === arguments.length ? this.elt.style.transform = "rotate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg)" : 2 === arguments.length ? this.elt.style.transform = "rotate(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg, " + (arguments.length <= 1 ? void 0 : arguments[1]) + "deg)" : 3 === arguments.length && (this.elt.style.transform = "rotateX(" + (arguments.length <= 0 ? void 0 : arguments[0]) + "deg)", this.elt.style.transform += "rotateY(" + (arguments.length <= 1 ? void 0 : arguments[1]) + "deg)", this.elt.style.transform += "rotateZ(" + (arguments.length <= 2 ? void 0 : arguments[2]) + "deg)"), this.elt.style.transform += e1, this;
                }, h.default.Element.prototype.style = function(e1, t) {
                    if (void 0 === (t = t instanceof h.default.Color ? "rgba(" + t.levels[0] + "," + t.levels[1] + "," + t.levels[2] + "," + t.levels[3] / 255 + ")" : t)) {
                        if (-1 === e1.indexOf(":")) return window.getComputedStyle(this.elt).getPropertyValue(e1);
                        for(var r = e1.split(";"), o = 0; o < r.length; o++){
                            var n = r[o].split(":");
                            n[0] && n[1] && (this.elt.style[n[0].trim()] = n[1].trim());
                        }
                    } else this.elt.style[e1] = t, "width" !== e1 && "height" !== e1 && "left" !== e1 && "top" !== e1 || (t = window.getComputedStyle(this.elt).getPropertyValue(e1).replace(/[^\d.]/g, ""), this[e1] = Math.round(parseFloat(t, 10)));
                    return this;
                }, h.default.Element.prototype.attribute = function(e1, t) {
                    if (null == this.elt.firstChild || "checkbox" !== this.elt.firstChild.type && "radio" !== this.elt.firstChild.type) return void 0 === t ? this.elt.getAttribute(e1) : (this.elt.setAttribute(e1, t), this);
                    if (void 0 === t) return this.elt.firstChild.getAttribute(e1);
                    for(var r = 0; r < this.elt.childNodes.length; r++)this.elt.childNodes[r].setAttribute(e1, t);
                }, h.default.Element.prototype.removeAttribute = function(e1) {
                    if (null != this.elt.firstChild && ("checkbox" === this.elt.firstChild.type || "radio" === this.elt.firstChild.type)) for(var t = 0; t < this.elt.childNodes.length; t++)this.elt.childNodes[t].removeAttribute(e1);
                    return this.elt.removeAttribute(e1), this;
                }, h.default.Element.prototype.value = function() {
                    return 0 < arguments.length ? (this.elt.value = arguments.length <= 0 ? void 0 : arguments[0], this) : "range" === this.elt.type ? parseFloat(this.elt.value) : this.elt.value;
                }, h.default.Element.prototype.show = function() {
                    return this.elt.style.display = "block", this;
                }, h.default.Element.prototype.hide = function() {
                    return this.elt.style.display = "none", this;
                }, h.default.Element.prototype.size = function(e1, t) {
                    if (0 === arguments.length) return {
                        width: this.elt.offsetWidth,
                        height: this.elt.offsetHeight
                    };
                    var r = e1, o = t, n = h.default.prototype.AUTO;
                    if (r !== n || o !== n) {
                        if (r === n ? r = t * this.width / this.height : o === n && (o = e1 * this.height / this.width), this.elt instanceof HTMLCanvasElement) {
                            var s, i = {}, a = this.elt.getContext("2d");
                            for(s in a)i[s] = a[s];
                            for(s in this.elt.setAttribute("width", r * this._pInst._pixelDensity), this.elt.setAttribute("height", o * this._pInst._pixelDensity), this.elt.style.width = r + "px", this.elt.style.height = o + "px", this._pInst.scale(this._pInst._pixelDensity, this._pInst._pixelDensity), i)this.elt.getContext("2d")[s] = i[s];
                        } else this.elt.style.width = r + "px", this.elt.style.height = o + "px", this.elt.width = r, this.elt.height = o;
                        this.width = this.elt.offsetWidth, this.height = this.elt.offsetHeight, this._pInst && this._pInst._curElement && this._pInst._curElement.elt === this.elt && (this._pInst._setProperty("width", this.elt.offsetWidth), this._pInst._setProperty("height", this.elt.offsetHeight));
                    }
                    return this;
                }, h.default.Element.prototype.remove = function() {
                    this instanceof h.default.MediaElement && (this.stop(), null !== (t = this.elt.srcObject) && t.getTracks().forEach(function(e1) {
                        e1.stop();
                    }));
                    var e1, t = this._pInst._elements.indexOf(this);
                    for(e1 in -1 !== t && this._pInst._elements.splice(t, 1), this._events)this.elt.removeEventListener(e1, this._events[e1]);
                    this.elt && this.elt.parentNode && this.elt.parentNode.removeChild(this.elt);
                }, h.default.Element.prototype.drop = function(a, l) {
                    var e1;
                    return window.File && window.FileReader && window.FileList && window.Blob ? (this._dragDisabled || (this._dragDisabled = !0, this.elt.addEventListener("dragover", e1 = function(e1) {
                        e1.preventDefault();
                    }), this.elt.addEventListener("dragleave", e1)), h.default.Element._attachListener("drop", function(e1) {
                        e1.preventDefault(), "function" == typeof l && l.call(this, e1);
                        var e1 = e1.dataTransfer.files, t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                h.default.File._load(i, a);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }, this)) : console.log("The File APIs are not fully supported in this browser."), this;
                };
                function y(e1, t, r, o) {
                    d(this, y), this.callback = e1, this.time = t, this.id = r, this.val = o;
                }
                t = function(t) {
                    var r = i;
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    r.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: r,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && l(r, t);
                    var s = u(i);
                    function i(o, e1) {
                        d(this, i);
                        var n = c(e1 = s.call(this, o, e1));
                        return e1.elt.crossOrigin = "anonymous", e1._prevTime = 0, e1._cueIDCounter = 0, e1._cues = [], e1.pixels = [], e1._pixelsState = c(e1), e1._pixelDensity = 1, e1._modified = !1, e1._frameOnCanvas = -1, Object.defineProperty(n, "src", {
                            get: function() {
                                var e1 = n.elt.children[0].src, t = n.elt.src === window.location.href ? "" : n.elt.src;
                                return e1 === window.location.href ? t : e1;
                            },
                            set: function(e1) {
                                for(var t = 0; t < n.elt.children.length; t++)n.elt.removeChild(n.elt.children[t]);
                                var r = document.createElement("source");
                                r.src = e1, o.appendChild(r), n.elt.src = e1, n.modified = !0;
                            }
                        }), n._onended = function() {}, n.elt.onended = function() {
                            n._onended(n);
                        }, e1;
                    }
                    return a(i, [
                        {
                            key: "play",
                            value: function() {
                                var e1;
                                return this.elt.currentTime === this.elt.duration && (this.elt.currentTime = 0), 1 < this.elt.readyState || this.elt.load(), (e1 = this.elt.play()) && e1.catch && e1.catch(function(e1) {
                                    "NotAllowedError" === e1.name ? console.error(e1) : console.error("Media play method encountered an unexpected error", e1);
                                }), this;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                return this.elt.pause(), this.elt.currentTime = 0, this;
                            }
                        },
                        {
                            key: "pause",
                            value: function() {
                                return this.elt.pause(), this;
                            }
                        },
                        {
                            key: "loop",
                            value: function() {
                                return this.elt.setAttribute("loop", !0), this.play(), this;
                            }
                        },
                        {
                            key: "noLoop",
                            value: function() {
                                return this.elt.removeAttribute("loop"), this;
                            }
                        },
                        {
                            key: "_setupAutoplayFailDetection",
                            value: function() {
                                var t = setTimeout(function() {
                                    console.error(e);
                                }, 500);
                                this.elt.addEventListener("play", function() {
                                    return clearTimeout(t);
                                }, {
                                    passive: !0,
                                    once: !0
                                });
                            }
                        },
                        {
                            key: "autoplay",
                            value: function(e1) {
                                var t = this, r = this.elt.getAttribute("autoplay");
                                return this.elt.setAttribute("autoplay", e1), e1 && !r && (e1 = function() {
                                    return t._setupAutoplayFailDetection();
                                }, 4 === this.elt.readyState ? e1() : this.elt.addEventListener("canplay", e1, {
                                    passive: !0,
                                    once: !0
                                })), this;
                            }
                        },
                        {
                            key: "volume",
                            value: function(e1) {
                                if (void 0 === e1) return this.elt.volume;
                                this.elt.volume = e1;
                            }
                        },
                        {
                            key: "speed",
                            value: function(e1) {
                                if (void 0 === e1) return this.presetPlaybackRate || this.elt.playbackRate;
                                this.loadedmetadata ? this.elt.playbackRate = e1 : this.presetPlaybackRate = e1;
                            }
                        },
                        {
                            key: "time",
                            value: function(e1) {
                                return void 0 === e1 ? this.elt.currentTime : (this.elt.currentTime = e1, this);
                            }
                        },
                        {
                            key: "duration",
                            value: function() {
                                return this.elt.duration;
                            }
                        },
                        {
                            key: "_ensureCanvas",
                            value: function() {
                                this.canvas || (this.canvas = document.createElement("canvas"), this.drawingContext = this.canvas.getContext("2d"), this.setModified(!0));
                                var e1 = this._frameOnCanvas !== this._pInst.frameCount;
                                this.loadedmetadata && e1 && (this.canvas.width !== this.elt.width && (this.canvas.width = this.elt.width, this.canvas.height = this.elt.height, this.width = this.canvas.width, this.height = this.canvas.height), this.drawingContext.drawImage(this.elt, 0, 0, this.canvas.width, this.canvas.height), this.setModified(!0), this._frameOnCanvas = this._pInst.frameCount);
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return h.default.Renderer2D.prototype.loadPixels.apply(this, t);
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                return this.loadedmetadata && (this._ensureCanvas(), h.default.Renderer2D.prototype.updatePixels.call(this, e1, t, r, o)), this.setModified(!0), this;
                            }
                        },
                        {
                            key: "get",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return h.default.Renderer2D.prototype.get.apply(this, t);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function() {
                                this.loadPixels();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return h.default.Renderer2D.prototype._getPixel.apply(this, t);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                this.loadedmetadata && (this._ensureCanvas(), h.default.Renderer2D.prototype.set.call(this, e1, t, r), this.setModified(!0));
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                this._ensureCanvas();
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                h.default.prototype.copy.apply(this, t);
                            }
                        },
                        {
                            key: "mask",
                            value: function() {
                                this.loadPixels(), this.setModified(!0);
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                h.default.Image.prototype.mask.apply(this, t);
                            }
                        },
                        {
                            key: "isModified",
                            value: function() {
                                return this._modified;
                            }
                        },
                        {
                            key: "setModified",
                            value: function(e1) {
                                this._modified = e1;
                            }
                        },
                        {
                            key: "onended",
                            value: function(e1) {
                                return this._onended = e1, this;
                            }
                        },
                        {
                            key: "connect",
                            value: function(e1) {
                                var t, r;
                                if ("function" == typeof h.default.prototype.getAudioContext) t = h.default.prototype.getAudioContext(), r = h.default.soundOut.input;
                                else try {
                                    r = (t = e1.context).destination;
                                } catch (e1) {
                                    throw "connect() is meant to be used with Web Audio API or p5.sound.js";
                                }
                                this.audioSourceNode || (this.audioSourceNode = t.createMediaElementSource(this.elt), this.audioSourceNode.connect(r)), e1 ? e1.input ? this.audioSourceNode.connect(e1.input) : this.audioSourceNode.connect(e1) : this.audioSourceNode.connect(r);
                            }
                        },
                        {
                            key: "disconnect",
                            value: function() {
                                if (!this.audioSourceNode) throw "nothing to disconnect";
                                this.audioSourceNode.disconnect();
                            }
                        },
                        {
                            key: "showControls",
                            value: function() {
                                this.elt.style["text-align"] = "inherit", this.elt.controls = !0;
                            }
                        },
                        {
                            key: "hideControls",
                            value: function() {
                                this.elt.controls = !1;
                            }
                        },
                        {
                            key: "addCue",
                            value: function(e1, t, r) {
                                var o = this._cueIDCounter++, t = new y(t, e1, o, r);
                                return this._cues.push(t), this.elt.ontimeupdate || (this.elt.ontimeupdate = this._onTimeUpdate.bind(this)), o;
                            }
                        },
                        {
                            key: "removeCue",
                            value: function(e1) {
                                for(var t = 0; t < this._cues.length; t++)this._cues[t].id === e1 && (console.log(e1), this._cues.splice(t, 1));
                                0 === this._cues.length && (this.elt.ontimeupdate = null);
                            }
                        },
                        {
                            key: "clearCues",
                            value: function() {
                                this._cues = [], this.elt.ontimeupdate = null;
                            }
                        },
                        {
                            key: "_onTimeUpdate",
                            value: function() {
                                for(var e1 = this.time(), t = 0; t < this._cues.length; t++){
                                    var r = this._cues[t].time, o = this._cues[t].val;
                                    this._prevTime < r && r <= e1 && this._cues[t].callback(o);
                                }
                                this._prevTime = e1;
                            }
                        }
                    ]), i;
                }(h.default.Element), h.default.MediaElement = t, t = function() {
                    function r(e1, t) {
                        d(this, r), this.file = e1, this._pInst = t;
                        t = e1.type.split("/");
                        this.type = t[0], this.subtype = t[1], this.name = e1.name, this.size = e1.size, this.data = void 0;
                    }
                    return a(r, null, [
                        {
                            key: "_createLoader",
                            value: function(o, n) {
                                var e1 = new FileReader;
                                return e1.onload = function(e1) {
                                    var t, r = new h.default.File(o);
                                    "application/json" === r.file.type ? r.data = JSON.parse(e1.target.result) : "text/xml" === r.file.type ? (t = (new DOMParser).parseFromString(e1.target.result, "text/xml"), r.data = new h.default.XML(t.documentElement)) : r.data = e1.target.result, n(r);
                                }, e1;
                            }
                        },
                        {
                            key: "_load",
                            value: function(e1, t) {
                                var r;
                                /^text\//.test(e1.type) || "application/json" === e1.type ? h.default.File._createLoader(e1, t).readAsText(e1) : /^(video|audio)\//.test(e1.type) ? ((r = new h.default.File(e1)).data = URL.createObjectURL(e1), t(r)) : h.default.File._createLoader(e1, t).readAsDataURL(e1);
                            }
                        }
                    ]), r;
                }(), h.default.File = t, t = h.default;
                o.default = t;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.every": 153,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.array.splice": 166,
                "core-js/modules/es.function.name": 167,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.promise": 181,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.replace": 194,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.string.trim": 199,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.for-each": 235,
                "core-js/modules/web.dom-collections.iterator": 236,
                "core-js/modules/web.url": 238
            }
        ],
        290: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (y = e1("../core/main")) && y.__esModule ? y : {
                    default: y
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype.deviceOrientation = 1 < window.innerWidth / window.innerHeight ? "landscape" : "portrait", n.default.prototype.accelerationX = 0, n.default.prototype.accelerationY = 0, n.default.prototype.accelerationZ = 0, n.default.prototype.pAccelerationX = 0, n.default.prototype.pAccelerationY = 0, n.default.prototype.pAccelerationZ = 0, n.default.prototype._updatePAccelerations = function() {
                    this._setProperty("pAccelerationX", this.accelerationX), this._setProperty("pAccelerationY", this.accelerationY), this._setProperty("pAccelerationZ", this.accelerationZ);
                }, n.default.prototype.rotationX = 0, n.default.prototype.rotationY = 0, n.default.prototype.rotationZ = 0, n.default.prototype.pRotationX = 0, n.default.prototype.pRotationY = 0;
                var l = n.default.prototype.pRotationZ = 0, u = 0, c = 0, d = "clockwise", f = "clockwise", h = "clockwise", p = (n.default.prototype.pRotateDirectionX = void 0, n.default.prototype.pRotateDirectionY = void 0, n.default.prototype.pRotateDirectionZ = void 0, n.default.prototype._updatePRotations = function() {
                    this._setProperty("pRotationX", this.rotationX), this._setProperty("pRotationY", this.rotationY), this._setProperty("pRotationZ", this.rotationZ);
                }, n.default.prototype.turnAxis = void 0, .5), m = 30, y = (n.default.prototype.setMoveThreshold = function(e1) {
                    n.default._validateParameters("setMoveThreshold", arguments), p = e1;
                }, n.default.prototype.setShakeThreshold = function(e1) {
                    n.default._validateParameters("setShakeThreshold", arguments), m = e1;
                }, n.default.prototype._ondeviceorientation = function(e1) {
                    this._updatePRotations(), this._angleMode === s.radians && (e1.beta = e1.beta * (_PI / 180), e1.gamma = e1.gamma * (_PI / 180), e1.alpha = e1.alpha * (_PI / 180)), this._setProperty("rotationX", e1.beta), this._setProperty("rotationY", e1.gamma), this._setProperty("rotationZ", e1.alpha), this._handleMotion();
                }, n.default.prototype._ondevicemotion = function(e1) {
                    this._updatePAccelerations(), this._setProperty("accelerationX", 2 * e1.acceleration.x), this._setProperty("accelerationY", 2 * e1.acceleration.y), this._setProperty("accelerationZ", 2 * e1.acceleration.z), this._handleMotion();
                }, n.default.prototype._handleMotion = function() {
                    90 === window.orientation || -90 === window.orientation ? this._setProperty("deviceOrientation", "landscape") : 0 === window.orientation ? this._setProperty("deviceOrientation", "portrait") : void 0 === window.orientation && this._setProperty("deviceOrientation", "undefined");
                    var e1, t, r, o, n, s = this._isGlobal ? window : this;
                    "function" == typeof s.deviceMoved && (Math.abs(this.accelerationX - this.pAccelerationX) > p || Math.abs(this.accelerationY - this.pAccelerationY) > p || Math.abs(this.accelerationZ - this.pAccelerationZ) > p) && s.deviceMoved(), "function" == typeof s.deviceTurned && (t = this.rotationX + 180, e1 = this.pRotationX + 180, r = l + 180, 0 < t - e1 && t - e1 < 270 || t - e1 < -270 ? d = "clockwise" : (t - e1 < 0 || 270 < t - e1) && (d = "counter-clockwise"), d !== this.pRotateDirectionX && (r = t), 90 < Math.abs(t - r) && Math.abs(t - r) < 270 && (r = t, this._setProperty("turnAxis", "X"), s.deviceTurned()), this.pRotateDirectionX = d, l = r - 180, e1 = this.rotationY + 180, t = this.pRotationY + 180, r = u + 180, 0 < e1 - t && e1 - t < 270 || e1 - t < -270 ? f = "clockwise" : (e1 - t < 0 || 270 < e1 - this.pRotationY) && (f = "counter-clockwise"), f !== this.pRotateDirectionY && (r = e1), 90 < Math.abs(e1 - r) && Math.abs(e1 - r) < 270 && (r = e1, this._setProperty("turnAxis", "Y"), s.deviceTurned()), this.pRotateDirectionY = f, u = r - 180, 0 < this.rotationZ - this.pRotationZ && this.rotationZ - this.pRotationZ < 270 || this.rotationZ - this.pRotationZ < -270 ? h = "clockwise" : (this.rotationZ - this.pRotationZ < 0 || 270 < this.rotationZ - this.pRotationZ) && (h = "counter-clockwise"), h !== this.pRotateDirectionZ && (c = this.rotationZ), 90 < Math.abs(this.rotationZ - c) && Math.abs(this.rotationZ - c) < 270 && (c = this.rotationZ, this._setProperty("turnAxis", "Z"), s.deviceTurned()), this.pRotateDirectionZ = h, this._setProperty("turnAxis", void 0)), "function" == typeof s.deviceShaken && (null !== this.pAccelerationX && (o = Math.abs(this.accelerationX - this.pAccelerationX), n = Math.abs(this.accelerationY - this.pAccelerationY)), m < o + n && s.deviceShaken());
                }, n.default);
                r.default = y;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        291: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                o.default.prototype.isKeyPressed = !1, o.default.prototype.keyIsPressed = !1, o.default.prototype.key = "", o.default.prototype.keyCode = 0, o.default.prototype._onkeydown = function(e1) {
                    var t;
                    this._downKeys[e1.which] || (this._setProperty("isKeyPressed", !0), this._setProperty("keyIsPressed", !0), this._setProperty("keyCode", e1.which), this._downKeys[e1.which] = !0, this._setProperty("key", e1.key || String.fromCharCode(e1.which) || e1.which), "function" != typeof (t = this._isGlobal ? window : this).keyPressed || e1.charCode || !1 === t.keyPressed(e1) && e1.preventDefault());
                }, o.default.prototype._onkeyup = function(e1) {
                    this._downKeys[e1.which] = !1, this._areDownKeys() || (this._setProperty("isKeyPressed", !1), this._setProperty("keyIsPressed", !1)), this._setProperty("_lastKeyCodeTyped", null), this._setProperty("key", e1.key || String.fromCharCode(e1.which) || e1.which), this._setProperty("keyCode", e1.which);
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.keyReleased && !1 === t.keyReleased(e1) && e1.preventDefault();
                }, o.default.prototype._onkeypress = function(e1) {
                    var t;
                    e1.which !== this._lastKeyCodeTyped && (this._setProperty("_lastKeyCodeTyped", e1.which), this._setProperty("key", e1.key || String.fromCharCode(e1.which) || e1.which), "function" == typeof (t = this._isGlobal ? window : this).keyTyped && !1 === t.keyTyped(e1) && e1.preventDefault());
                }, o.default.prototype._onblur = function(e1) {
                    this._downKeys = {};
                }, o.default.prototype.keyIsDown = function(e1) {
                    return o.default._validateParameters("keyIsDown", arguments), this._downKeys[e1] || !1;
                }, o.default.prototype._areDownKeys = function() {
                    for(var e1 in this._downKeys)if (this._downKeys.hasOwnProperty(e1) && !0 === this._downKeys[e1]) return !0;
                    return !1;
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 273
            }
        ],
        292: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.string.includes"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype.movedX = 0, n.default.prototype.movedY = 0, n.default.prototype._hasMouseInteracted = !1, n.default.prototype.mouseX = 0, n.default.prototype.mouseY = 0, n.default.prototype.pmouseX = 0, n.default.prototype.pmouseY = 0, n.default.prototype.winMouseX = 0, n.default.prototype.winMouseY = 0, n.default.prototype.pwinMouseX = 0, n.default.prototype.pwinMouseY = 0, n.default.prototype.mouseButton = 0, n.default.prototype.mouseIsPressed = !1, n.default.prototype._updateNextMouseCoords = function(e1) {
                    var t, r, o, n, s;
                    null !== this._curElement && (!e1.touches || 0 < e1.touches.length) && (t = this._curElement.elt, r = this.width, o = this.height, (n = e1) && !n.clientX && (n.touches ? n = n.touches[0] : n.changedTouches && (n = n.changedTouches[0])), s = t.getBoundingClientRect(), r = t.scrollWidth / r || 1, t = t.scrollHeight / o || 1, o = {
                        x: (n.clientX - s.left) / r,
                        y: (n.clientY - s.top) / t,
                        winX: n.clientX,
                        winY: n.clientY,
                        id: n.identifier
                    }, this._setProperty("movedX", e1.movementX), this._setProperty("movedY", e1.movementY), this._setProperty("mouseX", o.x), this._setProperty("mouseY", o.y), this._setProperty("winMouseX", o.winX), this._setProperty("winMouseY", o.winY)), this._hasMouseInteracted || (this._updateMouseCoords(), this._setProperty("_hasMouseInteracted", !0));
                }, n.default.prototype._updateMouseCoords = function() {
                    this._setProperty("pmouseX", this.mouseX), this._setProperty("pmouseY", this.mouseY), this._setProperty("pwinMouseX", this.winMouseX), this._setProperty("pwinMouseY", this.winMouseY), this._setProperty("_pmouseWheelDeltaY", this._mouseWheelDeltaY);
                }, n.default.prototype._setMouseButton = function(e1) {
                    1 === e1.button ? this._setProperty("mouseButton", s.CENTER) : 2 === e1.button ? this._setProperty("mouseButton", s.RIGHT) : this._setProperty("mouseButton", s.LEFT);
                }, n.default.prototype._onmousemove = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._updateNextMouseCoords(e1), this.mouseIsPressed ? "function" == typeof t.mouseDragged ? !1 === t.mouseDragged(e1) && e1.preventDefault() : "function" == typeof t.touchMoved && !1 === t.touchMoved(e1) && e1.preventDefault() : "function" == typeof t.mouseMoved && !1 === t.mouseMoved(e1) && e1.preventDefault();
                }, n.default.prototype._onmousedown = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !0), this._setMouseButton(e1), this._updateNextMouseCoords(e1), "function" == typeof t.mousePressed ? !1 === t.mousePressed(e1) && e1.preventDefault() : navigator.userAgent.toLowerCase().includes("safari") && "function" == typeof t.touchStarted && !1 === t.touchStarted(e1) && e1.preventDefault();
                }, n.default.prototype._onmouseup = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !1), "function" == typeof t.mouseReleased ? !1 === t.mouseReleased(e1) && e1.preventDefault() : "function" == typeof t.touchEnded && !1 === t.touchEnded(e1) && e1.preventDefault();
                }, n.default.prototype._ondragend = n.default.prototype._onmouseup, n.default.prototype._ondragover = n.default.prototype._onmousemove, n.default.prototype._onclick = function(e1) {
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.mouseClicked && !1 === t.mouseClicked(e1) && e1.preventDefault();
                }, n.default.prototype._ondblclick = function(e1) {
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.doubleClicked && !1 === t.doubleClicked(e1) && e1.preventDefault();
                }, n.default.prototype._mouseWheelDeltaY = 0, n.default.prototype._pmouseWheelDeltaY = 0, n.default.prototype._onwheel = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("_mouseWheelDeltaY", e1.deltaY), "function" == typeof t.mouseWheel && (e1.delta = e1.deltaY, !1 === t.mouseWheel(e1) && e1.preventDefault());
                }, n.default.prototype.requestPointerLock = function() {
                    var e1 = this._curElement.elt;
                    return e1.requestPointerLock = e1.requestPointerLock || e1.mozRequestPointerLock, e1.requestPointerLock ? (e1.requestPointerLock(), !0) : (console.log("requestPointerLock is not implemented in this browser"), !1);
                }, n.default.prototype.exitPointerLock = function() {
                    document.exitPointerLock();
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        293: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.string.includes"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.touches = [], e1.default.prototype._updateTouchCoords = function(e1) {
                    if (null !== this._curElement) {
                        for(var t = [], r = 0; r < e1.touches.length; r++)t[r] = function(e1, t, r, o) {
                            var n = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, s = e1.getBoundingClientRect(), t = e1.scrollWidth / t || 1, e1 = e1.scrollHeight / r || 1, r = o.touches[n] || o.changedTouches[n];
                            return {
                                x: (r.clientX - s.left) / t,
                                y: (r.clientY - s.top) / e1,
                                winX: r.clientX,
                                winY: r.clientY,
                                id: r.identifier
                            };
                        }(this._curElement.elt, this.width, this.height, e1, r);
                        this._setProperty("touches", t);
                    }
                }, e1.default.prototype._ontouchstart = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._setProperty("mouseIsPressed", !0), this._updateTouchCoords(e1), this._updateNextMouseCoords(e1), this._updateMouseCoords(), "function" == typeof t.touchStarted ? !1 === t.touchStarted(e1) && e1.preventDefault() : navigator.userAgent.toLowerCase().includes("safari") && "function" == typeof t.mousePressed && !1 === t.mousePressed(e1) && e1.preventDefault();
                }, e1.default.prototype._ontouchmove = function(e1) {
                    var t = this._isGlobal ? window : this;
                    this._updateTouchCoords(e1), this._updateNextMouseCoords(e1), "function" == typeof t.touchMoved ? !1 === t.touchMoved(e1) && e1.preventDefault() : "function" == typeof t.mouseDragged && !1 === t.mouseDragged(e1) && e1.preventDefault();
                }, e1.default.prototype._ontouchend = function(e1) {
                    this._setProperty("mouseIsPressed", !1), this._updateTouchCoords(e1), this._updateNextMouseCoords(e1);
                    var t = this._isGlobal ? window : this;
                    "function" == typeof t.touchEnded ? !1 === t.touchEnded(e1) && e1.preventDefault() : "function" == typeof t.mouseReleased && !1 === t.mouseReleased(e1) && e1.preventDefault();
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.string.includes": 189
            }
        ],
        294: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.int32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.int32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var U, N, B, G, V = {
                    _toPixels: function(e1) {
                        var t, r;
                        return e1 instanceof ImageData ? e1.data : e1.getContext("2d") ? e1.getContext("2d").getImageData(0, 0, e1.width, e1.height).data : e1.getContext("webgl") ? (r = (t = e1.getContext("webgl")).drawingBufferWidth * t.drawingBufferHeight * 4, r = new Uint8Array(r), t.readPixels(0, 0, e1.width, e1.height, t.RGBA, t.UNSIGNED_BYTE, r), r) : void 0;
                    },
                    _getARGB: function(e1, t) {
                        t *= 4;
                        return e1[3 + t] << 24 & 4278190080 | e1[t] << 16 & 16711680 | e1[1 + t] << 8 & 65280 | 255 & e1[2 + t];
                    },
                    _setPixels: function(e1, t) {
                        for(var r, o = 0, n = e1.length; o < n; o++)e1[0 + (r = 4 * o)] = (16711680 & t[o]) >>> 16, e1[1 + r] = (65280 & t[o]) >>> 8, e1[2 + r] = 255 & t[o], e1[3 + r] = (4278190080 & t[o]) >>> 24;
                    },
                    _toImageData: function(e1) {
                        return e1 instanceof ImageData ? e1 : e1.getContext("2d").getImageData(0, 0, e1.width, e1.height);
                    },
                    _createImageData: function(e1, t) {
                        return V._tmpCanvas = document.createElement("canvas"), V._tmpCtx = V._tmpCanvas.getContext("2d"), this._tmpCtx.createImageData(e1, t);
                    },
                    apply: function(e1, t, r) {
                        var o = e1.getContext("2d"), n = o.getImageData(0, 0, e1.width, e1.height), t = t(n, r);
                        t instanceof ImageData ? o.putImageData(t, 0, 0, 0, 0, e1.width, e1.height) : o.putImageData(n, 0, 0, 0, 0, e1.width, e1.height);
                    },
                    threshold: function(e1, t) {
                        for(var r = V._toPixels(e1), o = (void 0 === t && (t = .5), Math.floor(255 * t)), n = 0; n < r.length; n += 4){
                            var s = void 0, s = o <= .2126 * r[n] + .7152 * r[n + 1] + .0722 * r[n + 2] ? 255 : 0;
                            r[n] = r[n + 1] = r[n + 2] = s;
                        }
                    },
                    gray: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4){
                            var o = t[r], n = t[r + 1], s = t[r + 2];
                            t[r] = t[r + 1] = t[r + 2] = .2126 * o + .7152 * n + .0722 * s;
                        }
                    },
                    opaque: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4)t[r + 3] = 255;
                        return t;
                    },
                    invert: function(e1) {
                        for(var t = V._toPixels(e1), r = 0; r < t.length; r += 4)t[r] = 255 - t[r], t[r + 1] = 255 - t[r + 1], t[r + 2] = 255 - t[r + 2];
                    },
                    posterize: function(e1, t) {
                        var r = V._toPixels(e1);
                        if (t < 2 || 255 < t) throw new Error("Level must be greater than 2 and less than 255 for posterize");
                        for(var o = t - 1, n = 0; n < r.length; n += 4){
                            var s = r[n], i = r[n + 1], a = r[n + 2];
                            r[n] = 255 * (s * t >> 8) / o, r[n + 1] = 255 * (i * t >> 8) / o, r[n + 2] = 255 * (a * t >> 8) / o;
                        }
                    },
                    dilate: function(e1) {
                        for(var t, r, o, n, s, i, a, l, u, c = V._toPixels(e1), d = 0, f = c.length ? c.length / 4 : 0, h = new Int32Array(f); d < f;)for(r = (t = d) + e1.width; d < r;)n = o = V._getARGB(c, d), (u = d - 1) < t && (u = d), r <= (l = d + 1) && (l = d), (s = d - e1.width) < 0 && (s = 0), f <= (i = d + e1.width) && (i = d), s = V._getARGB(c, s), u = V._getARGB(c, u), i = V._getARGB(c, i), (n = 77 * (n >> 16 & 255) + 151 * (n >> 8 & 255) + 28 * (255 & n)) < (a = 77 * (u >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) && (o = u, n = a), n < (a = 77 * ((u = V._getARGB(c, l)) >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) && (o = u, n = a), n < (l = 77 * (s >> 16 & 255) + 151 * (s >> 8 & 255) + 28 * (255 & s)) && (o = s, n = l), n < (u = 77 * (i >> 16 & 255) + 151 * (i >> 8 & 255) + 28 * (255 & i)) && (o = i, n = u), h[d++] = o;
                        V._setPixels(c, h);
                    },
                    erode: function(e1) {
                        for(var t, r, o, n, s, i, a, l, u, c = V._toPixels(e1), d = 0, f = c.length ? c.length / 4 : 0, h = new Int32Array(f); d < f;)for(r = (t = d) + e1.width; d < r;)n = o = V._getARGB(c, d), (u = d - 1) < t && (u = d), r <= (l = d + 1) && (l = d), (s = d - e1.width) < 0 && (s = 0), f <= (i = d + e1.width) && (i = d), s = V._getARGB(c, s), u = V._getARGB(c, u), i = V._getARGB(c, i), (a = 77 * (u >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) < (n = 77 * (n >> 16 & 255) + 151 * (n >> 8 & 255) + 28 * (255 & n)) && (o = u, n = a), (a = 77 * ((u = V._getARGB(c, l)) >> 16 & 255) + 151 * (u >> 8 & 255) + 28 * (255 & u)) < n && (o = u, n = a), (l = 77 * (s >> 16 & 255) + 151 * (s >> 8 & 255) + 28 * (255 & s)) < n && (o = s, n = l), (u = 77 * (i >> 16 & 255) + 151 * (i >> 8 & 255) + 28 * (255 & i)) < n && (o = i, n = u), h[d++] = o;
                        V._setPixels(c, h);
                    },
                    blur: function(e1, D) {
                        for(var t, r, o, n, s, i, a, l, u, c, d = V._toPixels(e1), f = e1.width, h = e1.height, p = f * h, m = new Int32Array(p), y = 0; y < p; y++)m[y] = V._getARGB(d, y);
                        var g, v, b, j, _, x, w, S, E = new Int32Array(p), M = new Int32Array(p), T = new Int32Array(p), F = new Int32Array(p), k = 0, O = 3.5 * D | 0;
                        if (U !== (O = O < 1 ? 1 : O < 248 ? O : 248)) {
                            N = 1 + (U = O) << 1, B = new Int32Array(N), G = new Array(N);
                            for(var C = 0; C < N; C++)G[C] = new Int32Array(256);
                            for(var A = 1, P = O - 1; A < O; A++){
                                B[O + A] = B[P] = x = P * P, w = G[O + A], S = G[P--];
                                for(var L = 0; L < 256; L++)w[L] = S[L] = x * L;
                            }
                            _ = B[O] = O * O, w = G[O];
                            for(var R = 0; R < 256; R++)w[R] = _ * R;
                        }
                        for(v = 0; v < h; v++){
                            for(g = 0; g < f; g++){
                                if (n = o = r = s = t = 0, (i = g - U) < 0) c = -i, i = 0;
                                else {
                                    if (f <= i) break;
                                    c = 0;
                                }
                                for(b = c; b < N && !(f <= i); b++){
                                    var I = m[i + k];
                                    j = G[b], s += j[(-16777216 & I) >>> 24], r += j[(16711680 & I) >> 16], o += j[(65280 & I) >> 8], n += j[255 & I], t += B[b], i++;
                                }
                                E[a = k + g] = s / t, M[a] = r / t, T[a] = o / t, F[a] = n / t;
                            }
                            k += f;
                        }
                        for(u = (l = -U) * f, v = k = 0; v < h; v++){
                            for(g = 0; g < f; g++){
                                if (n = o = r = s = t = 0, l < 0) c = a = -l, i = g;
                                else {
                                    if (h <= l) break;
                                    c = 0, a = l, i = g + u;
                                }
                                for(b = c; b < N && !(h <= a); b++)j = G[b], s += j[E[i]], r += j[M[i]], o += j[T[i]], n += j[F[i]], t += B[b], a++, i += f;
                                m[g + k] = s / t << 24 | r / t << 16 | o / t << 8 | n / t;
                            }
                            k += f, u += f, l++;
                        }
                        V._setPixels(d, m);
                    }
                };
                r.default = V;
            },
            {
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.int32-array": 215,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint8-array": 232
            }
        ],
        295: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var O = o(e1("../core/main")), C = o(e1("omggif"));
                function o(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function A(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                O.default.prototype.createImage = function(e1, t) {
                    return O.default._validateParameters("createImage", arguments), new O.default.Image(e1, t);
                }, O.default.prototype.saveCanvas = function() {
                    O.default._validateParameters("saveCanvas", arguments);
                    var e1, t, r, o, n = [].slice.call(arguments);
                    switch(arguments[0] instanceof HTMLCanvasElement ? (e1 = arguments[0], n.shift()) : arguments[0] instanceof O.default.Element ? (e1 = arguments[0].elt, n.shift()) : e1 = this._curElement && this._curElement.elt, 1 <= n.length && (t = n[0]), r = (r = 2 <= n.length ? n[1] : r) || O.default.prototype._checkFileExtension(t, r)[1] || "png"){
                        default:
                            o = "image/png";
                            break;
                        case "jpeg":
                        case "jpg":
                            o = "image/jpeg";
                    }
                    e1.toBlob(function(e1) {
                        O.default.prototype.downloadFile(e1, t, r);
                    }, o);
                }, O.default.prototype.encodeAndDownloadGif = function(d, e1) {
                    for(var f = d.gifProperties, t = f.loopLimit, r = (1 === t ? t = null : null === t && (t = 0), new Uint8Array(d.width * d.height * f.numFrames)), h = [], o = {}, n = 0; n < f.numFrames; n++){
                        for(var s = new Set, i = f.frames[n].image.data, a = i.length, l = new Uint32Array(d.width * d.height), u = 0, c = 0; u < a; u += 4, c++){
                            var p = i[u + 0] << 16 | i[u + 1] << 8 | i[u + 2] << 0;
                            s.add(p), l[c] = p;
                        }
                        var m = A(s).sort().toString();
                        void 0 === o[m] ? o[m] = {
                            freq: 1,
                            frames: [
                                n
                            ]
                        } : (o[m].freq += 1, o[m].frames.push(n)), h.push(l);
                    }
                    for(var y = [], g = Object.keys(o).sort(function(e1, t) {
                        return o[t].freq - o[e1].freq;
                    }), v = g[0].split(",").map(function(e1) {
                        return parseInt(e1);
                    }), y = y.concat(o[v].frames), b = new Set(v), j = 1; j < g.length; j++){
                        var _ = g[j].split(",").map(function(e1) {
                            return parseInt(e1);
                        }).filter(function(e1) {
                            return !b.has(e1);
                        });
                        if (v.length + _.length <= 256) {
                            for(var x = 0; x < _.length; x++)v.push(_[x]), b.add(_[x]);
                            y = y.concat(o[g[j]].frames);
                        }
                    }
                    y = new Set(y);
                    for(var w = {}, S = 0; S < v.length; S++)w[v[S]] || (w[v[S]] = S);
                    for(var E = 1; E < v.length;)E <<= 1;
                    v.length = E;
                    for(var t = {
                        loop: t,
                        palette: new Uint32Array(v)
                    }, M = new C.default.GifWriter(r, d.width, d.height, t), T = {}, k = 0; k < f.numFrames; k++)!function(r) {
                        var o = !y.has(r), n = o ? [] : v, s = new Uint8Array(d.width * d.height), i = {}, a = new Set, e1 = (h[r].forEach(function(e1, t) {
                            o ? (void 0 === i[e1] && (i[e1] = n.length, n.push(e1)), s[t] = i[e1]) : s[t] = w[e1], 0 < r && h[r - 1][t] !== e1 && a.add(e1);
                        }), {}), t = n.filter(function(e1) {
                            return !a.has(e1);
                        });
                        if (0 < t.length) {
                            var t = t[0], l = (o ? i : w)[t];
                            if (0 < r) {
                                for(var u = 0; u < h[r].length; u++)h[r - 1][u] === h[r][u] && (s[u] = l);
                                e1.transparent = l, T.frameOpts.disposal = 1;
                            }
                        }
                        if (e1.delay = f.frames[r].delay / 10, o) {
                            for(var c = 1; c < n.length;)c <<= 1;
                            n.length = c, e1.palette = new Uint32Array(n);
                        }
                        0 < r && M.addFrame(0, 0, d.width, d.height, T.pixelPaletteIndex, T.frameOpts), T = {
                            pixelPaletteIndex: s,
                            frameOpts: e1
                        };
                    }(k);
                    T.frameOpts.disposal = 1, M.addFrame(0, 0, d.width, d.height, T.pixelPaletteIndex, T.frameOpts);
                    t = new Blob([
                        r.slice(0, M.end())
                    ], {
                        type: "image/gif"
                    });
                    O.default.prototype.downloadFile(t, e1, "gif");
                }, O.default.prototype.saveFrames = function(e1, t, r, o, i) {
                    O.default._validateParameters("saveFrames", arguments);
                    r = O.default.prototype.constrain(r = r || 3, 0, 15);
                    r *= 1e3;
                    var o = O.default.prototype.constrain(o || 15, 0, 22), n = 0, s = O.default.prototype._makeFrame, a = this._curElement.elt, l = [], u = setInterval(function() {
                        l.push(s(e1 + n, t, a)), n++;
                    }, 1e3 / o);
                    setTimeout(function() {
                        if (clearInterval(u), i) i(l);
                        else {
                            var e1 = !0, t = !1, r = void 0;
                            try {
                                for(var o, n = l[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                                    var s = o.value;
                                    O.default.prototype.downloadFile(s.imageData, s.filename, s.ext);
                                }
                            } catch (e1) {
                                t = !0, r = e1;
                            } finally{
                                try {
                                    e1 || null == n.return || n.return();
                                } finally{
                                    if (t) throw r;
                                }
                            }
                        }
                        l = [];
                    }, .01 + r);
                }, O.default.prototype._makeFrame = function(e1, t, r) {
                    var o, r = this ? this._curElement.elt : r;
                    if (t) switch(t.toLowerCase()){
                        case "png":
                            o = "image/png";
                            break;
                        case "jpeg":
                        case "jpg":
                            o = "image/jpeg";
                            break;
                        default:
                            o = "image/png";
                    }
                    else t = "png", o = "image/png";
                    var r = (r = r.toDataURL(o)).replace(o, "image/octet-stream"), n = {};
                    return n.imageData = r, n.filename = e1, n.ext = t, n;
                };
                e1 = O.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.keys": 179,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.set": 187,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.replace": 194,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint32-array": 231,
                "core-js/modules/es.typed-array.uint8-array": 232,
                "core-js/modules/web.dom-collections.for-each": 235,
                "core-js/modules/web.dom-collections.iterator": 236,
                omggif: 246
            }
        ],
        296: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0, e1("regenerator-runtime/runtime");
                var C = n(e1("../core/main")), m = n(e1("../core/helpers")), j = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), g = n(e1("omggif")), A = e1("gifenc");
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function l(e1, t, r, o, n, s, i) {
                    try {
                        var a = e1[s](i), l = a.value;
                    } catch (e1) {
                        return void r(e1);
                    }
                    a.done ? t(l) : Promise.resolve(l).then(o, n);
                }
                function y(e1, t, r, o, n, s, i, a, l, u, c) {
                    var d, f, h, p, m, y, g, v, b;
                    return e1 === j.COVER && (d = t, h = r, g = s, v = i, y = a, b = l, f = u, p = c, m = Math.max(g / f, v / p), g /= m, v /= m, m = y, y = b, d === j.CENTER ? m += (f - g) / 2 : d === j.RIGHT && (m += f - g), h === j.CENTER ? y += (p - v) / 2 : h === j.BOTTOM && (y += p - v), a = (b = {
                        x: m,
                        y: y,
                        w: g,
                        h: v
                    }).x, l = b.y, u = b.w, c = b.h), e1 === j.CONTAIN && (d = t, f = r, h = o, p = n, m = s, y = i, g = u, v = c, b = Math.max(g / m, v / y), g /= b, v /= b, b = h, h = p, d === j.CENTER ? b += (m - g) / 2 : d === j.RIGHT && (b += m - g), f === j.CENTER ? h += (y - v) / 2 : f === j.BOTTOM && (h += y - v), o = (e1 = {
                        x: b,
                        y: h,
                        w: g,
                        h: v
                    }).x, n = e1.y, s = e1.w, i = e1.h), {
                        sx: a,
                        sy: l,
                        sw: u,
                        sh: c,
                        dx: o,
                        dy: n,
                        dw: s,
                        dh: i
                    };
                }
                function v(e1, t) {
                    return 0 < e1 && e1 < t ? e1 : t;
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), C.default.prototype.loadImage = function(o, h, p) {
                    C.default._validateParameters("loadImage", arguments);
                    var m = new C.default.Image(1, 1, this), y = this, e1 = new Request(o, {
                        method: "GET",
                        mode: "cors"
                    });
                    return fetch(o, e1).then(function(e1) {
                        var t, r = e1.headers.get("content-type");
                        null === r && console.warn("The image you loaded does not have a Content-Type header. If you are using the online editor consider reuploading the asset."), r && r.includes("image/gif") ? e1.arrayBuffer().then(function(e1) {
                            if (e1) {
                                for(var e1 = new Uint8Array(e1), r = m, t = h, o = p, n = (function(e1) {
                                    y._decrementPreload();
                                }).bind(y), s = new g.default.GifReader(e1), i = (r.width = r.canvas.width = s.width, r.height = r.canvas.height = s.height, []), a = s.numFrames(), l = new Uint8ClampedArray(r.width * r.height * 4), u = 0; u < a; u++){
                                    var c = s.frameInfo(u), d = r.drawingContext.getImageData(0, 0, r.width, r.height), f = (l = d.data.slice(), !function(e1, t) {
                                        try {
                                            t.decodeAndBlitFrameRGBA(e1, l);
                                        } catch (e1) {
                                            C.default._friendlyFileLoadError(8, r.src), "function" == typeof o ? o(e1) : console.error(e1);
                                        }
                                    }(u, s), new ImageData(l, r.width, r.height)), f = (r.drawingContext.putImageData(f, 0, 0), c.delay);
                                    0 === f && (f = 10), i.push({
                                        image: r.drawingContext.getImageData(0, 0, r.width, r.height),
                                        delay: 10 * f
                                    }), 2 === c.disposal ? r.drawingContext.clearRect(c.x, c.y, c.width, c.height) : 3 === c.disposal && r.drawingContext.putImageData(d, 0, 0, c.x, c.y, c.width, c.height);
                                }
                                null === (e1 = s.loopCount()) ? e1 = 1 : 0 === e1 && (e1 = null), r.drawingContext.putImageData(i[0].image, 0, 0), 1 < i.length && (r.gifProperties = {
                                    displayIndex: 0,
                                    loopLimit: e1,
                                    loopCount: 0,
                                    frames: i,
                                    numFrames: a,
                                    playing: !0,
                                    timeDisplayed: 0,
                                    lastChangeTime: 0
                                }), "function" == typeof t && t(r), n();
                            }
                        }, function(e1) {
                            "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                        }) : ((t = new Image).onload = function() {
                            m.width = m.canvas.width = t.width, m.height = m.canvas.height = t.height, m.drawingContext.drawImage(t, 0, 0), m.modified = !0, "function" == typeof h && h(m), y._decrementPreload();
                        }, t.onerror = function(e1) {
                            C.default._friendlyFileLoadError(0, t.src), "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                        }, 0 !== o.indexOf("data:image/") && (t.crossOrigin = "Anonymous"), t.src = o), m.modified = !0;
                    }).catch(function(e1) {
                        C.default._friendlyFileLoadError(0, o), "function" == typeof p ? (p(e1), y._decrementPreload()) : console.error(e1);
                    }), m;
                }, C.default.prototype.saveGif = function() {
                    a = regeneratorRuntime.mark(function e1(t, r) {
                        var o, n, s, i, a, l, u, c, d, f, h, p, m, y, g, v, b, j, _, x, w, S, E, M, T, k, O = arguments;
                        return regeneratorRuntime.wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = 2 < O.length && void 0 !== O[2] ? O[2] : {
                                        delay: 0,
                                        units: "seconds",
                                        silent: !1,
                                        notificationDuration: 0,
                                        notificationID: "progressBar"
                                    }, "string" != typeof t) throw TypeError("fileName parameter must be a string");
                                    e1.next = 3;
                                    break;
                                case 3:
                                    if ("number" != typeof r) throw TypeError("Duration parameter must be a number");
                                    e1.next = 5;
                                    break;
                                case 5:
                                    if (n = o && o.delay || 0, s = o && o.units || "seconds", i = o && o.silent || !1, a = o && o.notificationDuration || 0, l = o && o.notificationID || "progressBar", "number" != typeof n) throw TypeError("Delay parameter must be a number");
                                    e1.next = 12;
                                    break;
                                case 12:
                                    if ("seconds" !== s && "frames" !== s) throw TypeError('Units parameter must be either "frames" or "seconds"');
                                    e1.next = 14;
                                    break;
                                case 14:
                                    if ("boolean" != typeof i) throw TypeError("Silent parameter must be a boolean");
                                    e1.next = 16;
                                    break;
                                case 16:
                                    if ("number" != typeof a) throw TypeError("Notification duration parameter must be a number");
                                    e1.next = 18;
                                    break;
                                case 18:
                                    if ("string" != typeof l) throw TypeError("Notification ID parameter must be a string");
                                    e1.next = 20;
                                    break;
                                case 20:
                                    return this._recording = !0, f = this._targetFrameRate, u = (u = 1 / (f = f !== 1 / 0 && void 0 !== f && 0 !== f ? f : 60) * 1e3) < 20 ? 20 : u, d = (c = "seconds" === s ? r * f : r) + (f = "seconds" === s ? n * f : n), f, this.frameCount = f, h = this._pixelDensity, this.pixelDensity(1), p = [], null !== document.getElementById(l) && document.getElementById(l).remove(), i || ((m = this.createP("")).id(l), m.style("font-size", "16px"), m.style("font-family", "Montserrat"), m.style("background-color", "#ffffffa0"), m.style("padding", "8px"), m.style("border-radius", "10px"), m.position(0, 0)), this._renderer instanceof C.default.RendererGL && (g = this.drawingContext, y = new Uint8Array(g.drawingBufferWidth * g.drawingBufferHeight * 4)), this.noLoop(), e1.next = 39, Promise.resolve();
                                case 39:
                                    if (f < d) return this.redraw(), M = void 0, M = this._renderer instanceof C.default.RendererGL ? (y = new Uint8Array(g.drawingBufferWidth * g.drawingBufferHeight * 4), g.readPixels(0, 0, g.drawingBufferWidth, g.drawingBufferHeight, g.RGBA, g.UNSIGNED_BYTE, y), function(e1) {
                                        for(var t = parseInt(height / 2), r = 4 * width, o = new Uint8Array(4 * width), n = 0; n < t; ++n){
                                            var s = n * r, i = (height - n - 1) * r;
                                            o.set(e1.subarray(s, s + r)), e1.copyWithin(s, i, i + r), e1.set(o, i);
                                        }
                                        return e1;
                                    }(y)) : this.drawingContext.getImageData(0, 0, this.width, this.height).data, p.push(M), f++, i || m.html("Saved frame <b>" + p.length.toString() + "</b> out of " + c.toString()), e1.next = 48, new Promise(function(e1) {
                                        return setTimeout(e1, 0);
                                    });
                                    e1.next = 50;
                                    break;
                                case 48:
                                    e1.next = 39;
                                    break;
                                case 50:
                                    i || m.html("Frames processed, generating color palette..."), this.loop(), this.pixelDensity(h), v = (0, A.GIFEncoder)(), b = function(e1) {
                                        for(var t = new Uint8Array(e1.length * e1[0].length), r = 0; r < e1.length; r++)t.set(e1[r], r * e1[0].length);
                                        var o = (0, A.quantize)(t, 256, {
                                            format: "rgba4444",
                                            oneBitAlpha: !0
                                        });
                                        256 === o.length ? o[o.length - 1] = [
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            0
                                        ] : o.push([
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            255 * Math.random(),
                                            0
                                        ]);
                                        return o;
                                    }(p), j = {}, _ = function(e1) {
                                        for(var t = e1.length / 4, r = new Uint8Array(t), o = 0; o < t; o++){
                                            var n = e1[4 * o] << 24 | e1[4 * o + 1] << 16 | e1[4 * o + 2] << 8 | e1[4 * o + 3];
                                            void 0 === j[n] && (j[n] = (0, A.nearestColorIndex)(b, e1.slice(4 * o, 4 * (o + 1)))), r[o] = j[n];
                                        }
                                        return r;
                                    }, x = b.length - 1, w = [], S = 0;
                                case 60:
                                    if (!(S < p.length)) {
                                        e1.next = 71;
                                        break;
                                    }
                                    if (E = _(p[S]), M = E.slice(), 0 === S) v.writeFrame(E, this.width, this.height, {
                                        palette: b,
                                        delay: u,
                                        dispose: 1
                                    });
                                    else {
                                        for(T = 0; T < E.length; T++)E[T] === w[T] && (E[T] = x);
                                        v.writeFrame(E, this.width, this.height, {
                                            delay: u,
                                            transparent: !0,
                                            transparentIndex: x,
                                            dispose: 1
                                        });
                                    }
                                    return w = M, i || m.html("Rendered frame <b>" + S.toString() + "</b> out of " + c.toString()), e1.next = 68, new Promise(function(e1) {
                                        return setTimeout(e1, 0);
                                    });
                                case 68:
                                    S++, e1.next = 60;
                                    break;
                                case 71:
                                    v.finish(), k = v.bytesView(), k = new Blob([
                                        k
                                    ], {
                                        type: "image/gif"
                                    }), p = [], this._recording = !1, this.loop(), i || (m.html("Done. Downloading your gif!\uD83C\uDF38"), 0 < a && setTimeout(function() {
                                        return m.remove();
                                    }, 1e3 * a)), C.default.prototype.downloadFile(k, t, "gif");
                                case 80:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, this);
                    });
                    var a, r = function() {
                        var e1 = this, i = arguments;
                        return new Promise(function(t, r) {
                            var o = a.apply(e1, i);
                            function n(e1) {
                                l(o, t, r, n, s, "next", e1);
                            }
                            function s(e1) {
                                l(o, t, r, n, s, "throw", e1);
                            }
                            n(void 0);
                        });
                    };
                    return function(e1, t) {
                        return r.apply(this, arguments);
                    };
                }(), C.default.prototype.image = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    C.default._validateParameters("image", arguments);
                    var f = e1.width, h = e1.height, p = (d = d || j.CENTER, c = c || j.CENTER, e1.elt && e1.elt.videoWidth && !e1.canvas && (f = e1.elt.videoWidth, h = e1.elt.videoHeight), o || f), n = n || h, s = s || 0, i = i || 0, a = v(a || f, f), f = v(l || h, h), l = 1;
                    e1.elt && !e1.canvas && e1.elt.style.width && (l = e1.elt.videoWidth && !o ? e1.elt.videoWidth : e1.elt.width, l /= parseInt(e1.elt.style.width, 10)), s *= l, i *= l, f *= l, a *= l;
                    h = y(u, c, d, (h = m.default.modeAdjust(t, r, p, n, this._renderer._imageMode)).x, h.y, h.w, h.h, s, i, a, f);
                    this._renderer.image(e1, h.sx, h.sy, h.sw, h.sh, h.dx, h.dy, h.dw, h.dh);
                }, C.default.prototype.tint = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    C.default._validateParameters("tint", t);
                    var o = this.color.apply(this, t);
                    this._renderer._tint = o.levels;
                }, C.default.prototype.noTint = function() {
                    this._renderer._tint = null;
                }, C.default.prototype._getTintedImageCanvas = C.default.Renderer2D.prototype._getTintedImageCanvas, C.default.prototype.imageMode = function(e1) {
                    C.default._validateParameters("imageMode", arguments), e1 !== j.CORNER && e1 !== j.CORNERS && e1 !== j.CENTER || (this._renderer._imageMode = e1);
                };
                e1 = C.default;
                r.default = e1;
            },
            {
                "../core/constants": 262,
                "../core/friendly_errors/fes_core": 264,
                "../core/friendly_errors/file_errors": 265,
                "../core/friendly_errors/validate_params": 268,
                "../core/helpers": 269,
                "../core/main": 273,
                "core-js/modules/es.array.copy-within": 152,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.promise": 181,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint8-array": 232,
                "core-js/modules/es.typed-array.uint8-clamped-array": 233,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236,
                gifenc: 243,
                omggif: 246,
                "regenerator-runtime/runtime": 250
            }
        ],
        297: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = o(e1("../core/main")), n = o(e1("./filters"));
                function o(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function i(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                s.default.Image = function() {
                    function r(e1, t) {
                        if (!(this instanceof r)) throw new TypeError("Cannot call a class as a function");
                        this.width = e1, this.height = t, this.canvas = document.createElement("canvas"), this.canvas.width = this.width, this.canvas.height = this.height, this.drawingContext = this.canvas.getContext("2d"), (this._pixelsState = this)._pixelDensity = 1, this.gifProperties = null, this._modified = !1, this.pixels = [];
                    }
                    var e1, t, o;
                    return e1 = r, t = [
                        {
                            key: "_animateGif",
                            value: function(e1) {
                                var t, r = this.gifProperties, e1 = e1._lastRealFrameTime;
                                0 === r.lastChangeTime && (r.lastChangeTime = e1), r.playing && (r.timeDisplayed = e1 - r.lastChangeTime, t = r.frames[r.displayIndex].delay, r.timeDisplayed >= t && (t = Math.floor(r.timeDisplayed / t), r.timeDisplayed = 0, r.lastChangeTime = e1, r.displayIndex += t, r.loopCount = Math.floor(r.displayIndex / r.numFrames), null !== r.loopLimit && r.loopCount >= r.loopLimit ? r.playing = !1 : (e1 = r.displayIndex % r.numFrames, this.drawingContext.putImageData(r.frames[e1].image, 0, 0), r.displayIndex = e1, this.setModified(!0))));
                            }
                        },
                        {
                            key: "_setProperty",
                            value: function(e1, t) {
                                this[e1] = t, this.setModified(!0);
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                s.default.Renderer2D.prototype.loadPixels.call(this), this.setModified(!0);
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function(e1, t, r, o) {
                                s.default.Renderer2D.prototype.updatePixels.call(this, e1, t, r, o), this.setModified(!0);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                return s.default._validateParameters("p5.Image.get", arguments), s.default.Renderer2D.prototype.get.apply(this, arguments);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                return s.default.Renderer2D.prototype._getPixel.apply(this, t);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                s.default.Renderer2D.prototype.set.call(this, e1, t, r), this.setModified(!0);
                            }
                        },
                        {
                            key: "resize",
                            value: function(e1, t) {
                                0 === e1 && 0 === t ? (e1 = this.canvas.width, t = this.canvas.height) : 0 === e1 ? e1 = this.canvas.width * t / this.canvas.height : 0 === t && (t = this.canvas.height * e1 / this.canvas.width), e1 = Math.floor(e1), t = Math.floor(t);
                                var r = document.createElement("canvas");
                                if (r.width = e1, r.height = t, this.gifProperties) for(var o = this.gifProperties, n = 0; n < o.numFrames; n++){
                                    for(var s = this.drawingContext.createImageData(e1, t), i = (d = d = c = u = l = void 0, o.frames[n].image), a = s, l = 0, u = 0; u < a.height; u++)for(var c = 0; c < a.width; c++){
                                        var d = Math.floor(c * i.width / a.width), d = 4 * (Math.floor(u * i.height / a.height) * i.width + d);
                                        a.data[l++] = i.data[d++], a.data[l++] = i.data[d++], a.data[l++] = i.data[d++], a.data[l++] = i.data[+d];
                                    }
                                    o.frames[n].image = s;
                                }
                                r.getContext("2d").drawImage(this.canvas, 0, 0, this.canvas.width, this.canvas.height, 0, 0, r.width, r.height), this.canvas.width = this.width = e1, this.canvas.height = this.height = t, this.drawingContext.drawImage(r, 0, 0, e1, t, 0, 0, e1, t), 0 < this.pixels.length && this.loadPixels(), this.setModified(!0);
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                s.default.prototype.copy.apply(this, t);
                            }
                        },
                        {
                            key: "mask",
                            value: function(e1) {
                                var t = this.drawingContext.globalCompositeOperation, r = 1, o = [
                                    e1 = void 0 === e1 ? this : e1,
                                    0,
                                    0,
                                    (r = e1 instanceof s.default.Renderer ? e1._pInst._pixelDensity : r) * e1.width,
                                    r * e1.height,
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ];
                                if (this.drawingContext.globalCompositeOperation = "destination-in", this.gifProperties) {
                                    for(var n = 0; n < this.gifProperties.frames.length; n++)this.drawingContext.putImageData(this.gifProperties.frames[n].image, 0, 0), this.copy.apply(this, o), this.gifProperties.frames[n].image = this.drawingContext.getImageData(0, 0, this.width, this.height);
                                    this.drawingContext.putImageData(this.gifProperties.frames[this.gifProperties.displayIndex].image, 0, 0);
                                } else this.copy.apply(this, o);
                                this.drawingContext.globalCompositeOperation = t, this.setModified(!0);
                            }
                        },
                        {
                            key: "filter",
                            value: function(e1, t) {
                                n.default.apply(this.canvas, n.default[e1], t), this.setModified(!0);
                            }
                        },
                        {
                            key: "blend",
                            value: function() {
                                for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                                s.default._validateParameters("p5.Image.blend", arguments), s.default.prototype.blend.apply(this, t), this.setModified(!0);
                            }
                        },
                        {
                            key: "setModified",
                            value: function(e1) {
                                this._modified = e1;
                            }
                        },
                        {
                            key: "isModified",
                            value: function() {
                                return this._modified;
                            }
                        },
                        {
                            key: "save",
                            value: function(e1, t) {
                                this.gifProperties ? s.default.prototype.encodeAndDownloadGif(this, e1) : s.default.prototype.saveCanvas(this.canvas, e1, t);
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                var e1;
                                this.gifProperties && ((e1 = this.gifProperties).playing = !0, e1.timeSinceStart = 0, e1.timeDisplayed = 0, e1.lastChangeTime = 0, e1.loopCount = 0, e1.displayIndex = 0, this.drawingContext.putImageData(e1.frames[0].image, 0, 0));
                            }
                        },
                        {
                            key: "getCurrentFrame",
                            value: function() {
                                var e1;
                                if (this.gifProperties) return (e1 = this.gifProperties).displayIndex % e1.numFrames;
                            }
                        },
                        {
                            key: "setFrame",
                            value: function(e1) {
                                var t;
                                this.gifProperties && (e1 < (t = this.gifProperties).numFrames && 0 <= e1 ? (t.timeDisplayed = 0, t.lastChangeTime = 0, t.displayIndex = e1, this.drawingContext.putImageData(t.frames[e1].image, 0, 0)) : console.log("Cannot set GIF to a frame number that is higher than total number of frames or below zero."));
                            }
                        },
                        {
                            key: "numFrames",
                            value: function() {
                                if (this.gifProperties) return this.gifProperties.numFrames;
                            }
                        },
                        {
                            key: "play",
                            value: function() {
                                this.gifProperties && (this.gifProperties.playing = !0);
                            }
                        },
                        {
                            key: "pause",
                            value: function() {
                                this.gifProperties && (this.gifProperties.playing = !1);
                            }
                        },
                        {
                            key: "delay",
                            value: function(e1, t) {
                                if (this.gifProperties) {
                                    var r = this.gifProperties;
                                    if (t < r.numFrames && 0 <= t) r.frames[t].delay = e1;
                                    else {
                                        var o = !0, t = !1, n = void 0;
                                        try {
                                            for(var s, i = r.frames[Symbol.iterator](); !(o = (s = i.next()).done); o = !0)s.value.delay = e1;
                                        } catch (e1) {
                                            t = !0, n = e1;
                                        } finally{
                                            try {
                                                o || null == i.return || i.return();
                                            } finally{
                                                if (t) throw n;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    ], i(e1.prototype, t), o && i(e1, o), r;
                }();
                e1 = s.default.Image;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "./filters": 294,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        298: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.filter"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var h = n(e1("../core/main")), o = n(e1("./filters"));
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                e1("../color/p5.Color"), h.default.prototype.pixels = [], h.default.prototype.blend = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    h.default._validateParameters("blend", r), this._renderer ? (e1 = this._renderer).blend.apply(e1, r) : h.default.Renderer2D.prototype.blend.apply(this, r);
                }, h.default.prototype.copy = function() {
                    for(var e1, t, r, o, n, s, i, a, l, u = arguments.length, c = new Array(u), d = 0; d < u; d++)c[d] = arguments[d];
                    if (h.default._validateParameters("copy", c), 9 === c.length) e1 = c[0], t = c[1], r = c[2], o = c[3], n = c[4], s = c[5], i = c[6], a = c[7], l = c[8];
                    else {
                        if (8 !== c.length) throw new Error("Signature not supported");
                        e1 = this, t = c[0], r = c[1], o = c[2], n = c[3], s = c[4], i = c[5], a = c[6], l = c[7];
                    }
                    h.default.prototype._copyHelper(this, e1, t, r, o, n, s, i, a, l);
                }, h.default.prototype._copyHelper = function(e1, t, r, o, n, s, i, a, l, u) {
                    t.loadPixels();
                    var c = t.canvas.width / t.width, d = 0, f = 0;
                    t._renderer && t._renderer.isP3D && (d = t.width / 2, f = t.height / 2), e1._renderer && e1._renderer.isP3D ? h.default.RendererGL.prototype.image.call(e1._renderer, t, r + d, o + f, n, s, i, a, l, u) : e1.drawingContext.drawImage(t.canvas, c * (r + d), c * (o + f), c * n, c * s, i, a, l, u);
                }, h.default.prototype.filter = function(e1, t) {
                    h.default._validateParameters("filter", arguments), void 0 !== this.canvas ? o.default.apply(this.canvas, o.default[e1], t) : o.default.apply(this.elt, o.default[e1], t);
                }, h.default.prototype.get = function(e1, t, r, o) {
                    var n;
                    return h.default._validateParameters("get", arguments), (n = this._renderer).get.apply(n, arguments);
                }, h.default.prototype.loadPixels = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    h.default._validateParameters("loadPixels", t), this._renderer.loadPixels();
                }, h.default.prototype.set = function(e1, t, r) {
                    this._renderer.set(e1, t, r);
                }, h.default.prototype.updatePixels = function(e1, t, r, o) {
                    h.default._validateParameters("updatePixels", arguments), 0 !== this.pixels.length && this._renderer.updatePixels(e1, t, r, o);
                };
                e1 = h.default;
                r.default = e1;
            },
            {
                "../color/p5.Color": 260,
                "../core/main": 273,
                "./filters": 294,
                "core-js/modules/es.array.filter": 155
            }
        ],
        299: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/web.url"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.promise"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/web.url"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var v = s(e1("../core/main")), m = (e1("whatwg-fetch"), e1("es6-promise/auto"), s(e1("fetch-jsonp"))), n = s(e1("file-saver"));
                function s(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function y(e1) {
                    return (y = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function g(e1) {
                    return e1.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
                }
                function i(e1, t) {
                    t && !0 !== t && "true" !== t || (t = "");
                    var r = "";
                    return (e1 = e1 || "untitled", e1.includes(".")) && (r = e1.split(".").pop()), t && r !== t && (r = t, e1 = "".concat(e1, ".").concat(r)), [
                        e1,
                        r
                    ];
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), v.default.prototype.loadJSON = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    v.default._validateParameters("loadJSON", t);
                    for(var o, n, s, i = t[0], a = {}, l = "json", u = 1; u < t.length; u++){
                        var c = t[u];
                        "string" == typeof c ? "jsonp" !== c && "json" !== c || (l = c) : "function" == typeof c ? o ? n = c : o = c : "object" === y(c) && (c.hasOwnProperty("jsonpCallback") || c.hasOwnProperty("jsonpCallbackFunction")) && (l = "jsonp", s = c);
                    }
                    var d = this;
                    return this.httpDo(i, "GET", s, l, function(e1) {
                        for(var t in e1)a[t] = e1[t];
                        void 0 !== o && o(e1), d._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(5, i), !n) throw e1;
                        n(e1);
                    }), a;
                }, v.default.prototype.loadStrings = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    v.default._validateParameters("loadStrings", t);
                    for(var n, o, s = [], i = 1; i < t.length; i++){
                        var a = t[i];
                        "function" == typeof a && (void 0 === n ? n = a : void 0 === o && (o = a));
                    }
                    var l = this;
                    return v.default.prototype.httpDo.call(this, t[0], "GET", "text", function(e1) {
                        for(var t = e1.replace(/\r\n/g, "\r").replace(/\n/g, "\r").split(/\r/), r = 0, o = t.length; r < o; r += 32768)Array.prototype.push.apply(s, t.slice(r, Math.min(r + 32768, o)));
                        void 0 !== n && n(s), l._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(3, e1), !o) throw e1;
                        o(e1);
                    }), s;
                }, v.default.prototype.loadTable = function(t) {
                    var h, r, p, e1 = [], m = !1, o = t.substring(t.lastIndexOf(".") + 1, t.length);
                    "csv" === o ? p = "," : "ssv" === o ? p = ";" : "tsv" === o && (p = "	");
                    for(var n = 1; n < arguments.length; n++)"function" == typeof arguments[n] ? void 0 === h ? h = arguments[n] : void 0 === r && (r = arguments[n]) : "string" == typeof arguments[n] && (e1.push(arguments[n]), "header" === arguments[n] && (m = !0), "csv" === arguments[n] ? p = "," : "ssv" === arguments[n] ? p = ";" : "tsv" === arguments[n] && (p = "	"));
                    var y = new v.default.Table, g = this;
                    return this.httpDo(t, "GET", "table", function(e1) {
                        for(var t, r, o = {}, n = 0, s = [], i = 0, a = null, l = function() {
                            o.currentState = n, o.token = "";
                        }, u = function() {
                            a.push(o.token), l();
                        }, c = function() {
                            o.currentState = 4, s.push(a), a = null;
                        };;){
                            if (null == (t = e1[i++])) {
                                if (o.escaped) throw new Error("Unclosed quote in file.");
                                if (a) {
                                    u(), c();
                                    break;
                                }
                            }
                            if (null === a && (o.escaped = !1, a = [], l()), o.currentState === n) {
                                if ('"' === t) {
                                    o.escaped = !0, o.currentState = 1;
                                    continue;
                                }
                                o.currentState = 1;
                            }
                            if (1 === o.currentState && o.escaped) {
                                if ('"' === t) '"' === e1[i] ? (o.token += '"', i++) : (o.escaped = !1, o.currentState = 2);
                                else {
                                    if ("\r" === t) continue;
                                    o.token += t;
                                }
                            } else "\r" === t ? ("\n" === e1[i] && i++, u(), c()) : "\n" === t ? (u(), c()) : t === p ? u() : 1 === o.currentState && (o.token += t);
                        }
                        if (m) y.columns = s.shift();
                        else for(var d = 0; d < s[0].length; d++)y.columns[d] = "null";
                        for(var f = 0; f < s.length; f++)(1 !== s[f].length || "undefined" !== s[f][0] && "" !== s[f][0]) && ((r = new v.default.TableRow).arr = s[f], r.obj = function(r, e1) {
                            if (void 0 === (e1 = e1 || [])) for(var t = 0; t < r.length; t++)e1[t.toString()] = t;
                            return Object.fromEntries(e1.map(function(e1, t) {
                                return [
                                    e1,
                                    r[t]
                                ];
                            }));
                        }(s[f], y.columns), y.addRow(r));
                        "function" == typeof h && h(y), g._decrementPreload();
                    }, function(e1) {
                        v.default._friendlyFileLoadError(2, t), r ? r(e1) : console.error(e1);
                    }), y;
                }, v.default.prototype.loadXML = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    for(var o, n, s = new v.default.XML, i = 1; i < t.length; i++){
                        var a = t[i];
                        "function" == typeof a && (void 0 === o ? o = a : void 0 === n && (n = a));
                    }
                    var l = this;
                    return this.httpDo(t[0], "GET", "xml", function(e1) {
                        for(var t in e1)s[t] = e1[t];
                        void 0 !== o && o(s), l._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(1, e1), !n) throw e1;
                        n(e1);
                    }), s;
                }, v.default.prototype.loadBytes = function(t, r, o) {
                    var n = {}, s = this;
                    return this.httpDo(t, "GET", "arrayBuffer", function(e1) {
                        n.bytes = new Uint8Array(e1), "function" == typeof r && r(n), s._decrementPreload();
                    }, function(e1) {
                        if (v.default._friendlyFileLoadError(6, t), !o) throw e1;
                        o(e1);
                    }), n;
                }, v.default.prototype.httpGet = function() {
                    v.default._validateParameters("httpGet", arguments);
                    var e1 = Array.prototype.slice.call(arguments);
                    return e1.splice(1, 0, "GET"), v.default.prototype.httpDo.apply(this, e1);
                }, v.default.prototype.httpPost = function() {
                    v.default._validateParameters("httpPost", arguments);
                    var e1 = Array.prototype.slice.call(arguments);
                    return e1.splice(1, 0, "POST"), v.default.prototype.httpDo.apply(this, e1);
                }, v.default.prototype.httpDo = function() {
                    for(var r, e1, t, o = {}, n = 0, s = "text/plain", i = arguments.length - 1; 0 < i && "function" == typeof (i < 0 || arguments.length <= i ? void 0 : arguments[i]); i--)n++;
                    var a = arguments.length - n, l = arguments.length <= 0 ? void 0 : arguments[0];
                    if (2 == a && "string" == typeof l && "object" === y(arguments.length <= 1 ? void 0 : arguments[1])) p = new Request(l, arguments.length <= 1 ? void 0 : arguments[1]), e1 = arguments.length <= 2 ? void 0 : arguments[2], t = arguments.length <= 3 ? void 0 : arguments[3];
                    else {
                        for(var u, c = "GET", d = 1; d < arguments.length; d++){
                            var f = d < 0 || arguments.length <= d ? void 0 : arguments[d];
                            if ("string" == typeof f) "GET" === f || "POST" === f || "PUT" === f || "DELETE" === f ? c = f : "json" === f || "jsonp" === f || "binary" === f || "arrayBuffer" === f || "xml" === f || "text" === f || "table" === f ? r = f : u = f;
                            else if ("number" == typeof f) u = f.toString();
                            else if ("object" === y(f)) {
                                if (f.hasOwnProperty("jsonpCallback") || f.hasOwnProperty("jsonpCallbackFunction")) for(var h in f)o[h] = f[h];
                                else s = f instanceof v.default.XML ? (u = f.serialize(), "application/xml") : (u = JSON.stringify(f), "application/json");
                            } else "function" == typeof f && (e1 ? t = f : e1 = f);
                        }
                        var a = "GET" === c ? new Headers : new Headers({
                            "Content-Type": s
                        }), p = new Request(l, {
                            method: c,
                            mode: "cors",
                            body: u,
                            headers: a
                        });
                    }
                    return (a = (a = "jsonp" === (r = r || (l.includes("json") ? "json" : l.includes("xml") ? "xml" : "text")) ? (0, m.default)(l, o) : fetch(p)).then(function(e1) {
                        if (!e1.ok) throw (t = new Error(e1.body)).status = e1.status, t.ok = !1, t;
                        var t = 0;
                        switch((t = "jsonp" !== r ? e1.headers.get("content-length") : t) && 64e6 < t && v.default._friendlyFileLoadError(7, l), r){
                            case "json":
                            case "jsonp":
                                return e1.json();
                            case "binary":
                                return e1.blob();
                            case "arrayBuffer":
                                return e1.arrayBuffer();
                            case "xml":
                                return e1.text().then(function(e1) {
                                    e1 = (new DOMParser).parseFromString(e1, "text/xml");
                                    return new v.default.XML(e1.documentElement);
                                });
                            default:
                                return e1.text();
                        }
                    })).then(e1 || function() {}), a.catch(t || console.error), a;
                }, window.URL = window.URL || window.webkitURL, v.default.prototype._pWriters = [], v.default.prototype.createWriter = function(e1, t) {
                    var r, o;
                    for(o in v.default.prototype._pWriters)if (v.default.prototype._pWriters[o].name === e1) return r = new v.default.PrintWriter(e1 + this.millis(), t), v.default.prototype._pWriters.push(r), r;
                    return r = new v.default.PrintWriter(e1, t), v.default.prototype._pWriters.push(r), r;
                }, v.default.PrintWriter = function(r, o) {
                    var n = this;
                    this.name = r, this.content = "", this.write = function(e1) {
                        this.content += e1;
                    }, this.print = function(e1) {
                        this.content += "".concat(e1, "\n");
                    }, this.clear = function() {
                        this.content = "";
                    }, this.close = function() {
                        var e1, t = [];
                        for(e1 in t.push(this.content), v.default.prototype.writeFile(t, r, o), v.default.prototype._pWriters)v.default.prototype._pWriters[e1].name === this.name && v.default.prototype._pWriters.splice(e1, 1);
                        n.clear(), n = {};
                    };
                }, v.default.prototype.save = function(e1, t, r) {
                    var o = arguments, n = (this._curElement || this).elt;
                    if (0 === o.length) v.default.prototype.saveCanvas(n);
                    else if (o[0] instanceof v.default.Renderer || o[0] instanceof v.default.Graphics) v.default.prototype.saveCanvas(o[0].elt, o[1], o[2]);
                    else if (1 === o.length && "string" == typeof o[0]) v.default.prototype.saveCanvas(n, o[0]);
                    else switch(i(o[1], o[2])[1]){
                        case "json":
                            return void v.default.prototype.saveJSON(o[0], o[1], o[2]);
                        case "txt":
                            return void v.default.prototype.saveStrings(o[0], o[1], o[2]);
                        default:
                            o[0] instanceof Array ? v.default.prototype.saveStrings(o[0], o[1], o[2]) : o[0] instanceof v.default.Table ? v.default.prototype.saveTable(o[0], o[1], o[2]) : o[0] instanceof v.default.Image ? v.default.prototype.saveCanvas(o[0].canvas, o[1]) : o[0] instanceof v.default.SoundFile && v.default.prototype.saveSound(o[0], o[1], o[2], o[3]);
                    }
                }, v.default.prototype.saveJSON = function(e1, t, r) {
                    v.default._validateParameters("saveJSON", arguments), r = r ? JSON.stringify(e1) : JSON.stringify(e1, void 0, 2), this.saveStrings(r.split("\n"), t, "json");
                }, v.default.prototype.saveJSONObject = v.default.prototype.saveJSON, v.default.prototype.saveJSONArray = v.default.prototype.saveJSON, v.default.prototype.saveStrings = function(e1, t, r, o) {
                    v.default._validateParameters("saveStrings", arguments);
                    for(var n = this.createWriter(t, r || "txt"), s = 0; s < e1.length; s++)o ? n.write(e1[s] + "\r\n") : n.write(e1[s] + "\n");
                    n.close(), n.clear();
                }, v.default.prototype.saveTable = function(e1, t, r) {
                    v.default._validateParameters("saveTable", arguments), o = void 0 === r ? t.substring(t.lastIndexOf(".") + 1, t.length) : r;
                    var o, n = this.createWriter(t, o), s = e1.columns, i = "tsv" === o ? "	" : ",";
                    if ("html" !== o) {
                        if ("0" !== s[0]) {
                            for(var a = 0; a < s.length; a++)a < s.length - 1 ? n.write(s[a] + i) : n.write(s[a]);
                            n.write("\n");
                        }
                        for(var l = 0; l < e1.rows.length; l++){
                            for(var u = void 0, u = 0; u < e1.rows[l].arr.length; u++)u < e1.rows[l].arr.length - 1 ? "csv" === o && String(e1.rows[l].arr[u]).includes(",") ? n.write('"' + e1.rows[l].arr[u] + '"' + i) : n.write(e1.rows[l].arr[u] + i) : "csv" === o && String(e1.rows[l].arr[u]).includes(",") ? n.write('"' + e1.rows[l].arr[u] + '"') : n.write(e1.rows[l].arr[u]);
                            n.write("\n");
                        }
                    } else {
                        n.print("<html>"), n.print("<head>");
                        if (n.print('  <meta http-equiv="content-type" content="text/html;charset=utf-8" />'), n.print("</head>"), n.print("<body>"), n.print("  <table>"), "0" !== s[0]) {
                            n.print("    <tr>");
                            for(var c = 0; c < s.length; c++){
                                var d = g(s[c]);
                                n.print("      <td>".concat(d)), n.print("      </td>");
                            }
                            n.print("    </tr>");
                        }
                        for(var f = 0; f < e1.rows.length; f++){
                            n.print("    <tr>");
                            for(var h = 0; h < e1.columns.length; h++){
                                var p = g(e1.rows[f].getString(h));
                                n.print("      <td>".concat(p)), n.print("      </td>");
                            }
                            n.print("    </tr>");
                        }
                        n.print("  </table>"), n.print("</body>"), n.print("</html>");
                    }
                    n.close(), n.clear();
                }, v.default.prototype.writeFile = function(e1, t, r) {
                    var o = "application/octet-stream", e1 = (v.default.prototype._isSafari() && (o = "text/plain"), new Blob(e1, {
                        type: o
                    }));
                    v.default.prototype.downloadFile(e1, t, r);
                }, v.default.prototype.downloadFile = function(e1, t, r) {
                    var o, t = i(t, r), r = t[0];
                    e1 instanceof Blob ? n.default.saveAs(e1, r) : ((o = document.createElement("a")).href = e1, o.download = r, o.onclick = function(e1) {
                        document.body.removeChild(e1.target), e1.stopPropagation();
                    }, o.style.display = "none", document.body.appendChild(o), v.default.prototype._isSafari() && (e1 = (e1 = 'Hello, Safari user! To download this file...\n1. Go to File --> Save As.\n2. Choose "Page Source" as the Format.\n') + '3. Name it with this extension: ."'.concat(t[1], '"'), alert(e1)), o.click());
                }, v.default.prototype._checkFileExtension = i, v.default.prototype._isSafari = function() {
                    return 0 < Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor");
                };
                e1 = v.default;
                r.default = e1;
            },
            {
                "../core/friendly_errors/fes_core": 264,
                "../core/friendly_errors/file_errors": 265,
                "../core/friendly_errors/validate_params": 268,
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.last-index-of": 162,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.array.splice": 166,
                "core-js/modules/es.function.name": 167,
                "core-js/modules/es.object.from-entries": 175,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.promise": 181,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.replace": 194,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint8-array": 232,
                "core-js/modules/web.dom-collections.iterator": 236,
                "core-js/modules/web.url": 238,
                "es6-promise/auto": 239,
                "fetch-jsonp": 241,
                "file-saver": 242,
                "whatwg-fetch": 251
            }
        ],
        300: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.replace"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                n.default.Table = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        this.columns = [], this.rows = [];
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "addRow",
                            value: function(e1) {
                                e1 = e1 || new n.default.TableRow;
                                if (void 0 === e1.arr || void 0 === e1.obj) throw new Error("invalid TableRow: ".concat(e1));
                                return (e1.table = this).rows.push(e1), e1;
                            }
                        },
                        {
                            key: "removeRow",
                            value: function(e1) {
                                this.rows[e1].table = null;
                                e1 = this.rows.splice(e1 + 1, this.rows.length);
                                this.rows.pop(), this.rows = this.rows.concat(e1);
                            }
                        },
                        {
                            key: "getRow",
                            value: function(e1) {
                                return this.rows[e1];
                            }
                        },
                        {
                            key: "getRows",
                            value: function() {
                                return this.rows;
                            }
                        },
                        {
                            key: "findRow",
                            value: function(e1, t) {
                                if ("string" == typeof t) {
                                    for(var r = 0; r < this.rows.length; r++)if (this.rows[r].obj[t] === e1) return this.rows[r];
                                } else for(var o = 0; o < this.rows.length; o++)if (this.rows[o].arr[t] === e1) return this.rows[o];
                                return null;
                            }
                        },
                        {
                            key: "findRows",
                            value: function(e1, t) {
                                var r = [];
                                if ("string" == typeof t) for(var o = 0; o < this.rows.length; o++)this.rows[o].obj[t] === e1 && r.push(this.rows[o]);
                                else for(var n = 0; n < this.rows.length; n++)this.rows[n].arr[t] === e1 && r.push(this.rows[n]);
                                return r;
                            }
                        },
                        {
                            key: "matchRow",
                            value: function(e1, t) {
                                if ("number" == typeof t) {
                                    for(var r = 0; r < this.rows.length; r++)if (this.rows[r].arr[t].match(e1)) return this.rows[r];
                                } else for(var o = 0; o < this.rows.length; o++)if (this.rows[o].obj[t].match(e1)) return this.rows[o];
                                return null;
                            }
                        },
                        {
                            key: "matchRows",
                            value: function(e1, t) {
                                var r = [];
                                if ("number" == typeof t) for(var o = 0; o < this.rows.length; o++)this.rows[o].arr[t].match(e1) && r.push(this.rows[o]);
                                else for(var n = 0; n < this.rows.length; n++)this.rows[n].obj[t].match(e1) && r.push(this.rows[n]);
                                return r;
                            }
                        },
                        {
                            key: "getColumn",
                            value: function(e1) {
                                var t = [];
                                if ("string" == typeof e1) for(var r = 0; r < this.rows.length; r++)t.push(this.rows[r].obj[e1]);
                                else for(var o = 0; o < this.rows.length; o++)t.push(this.rows[o].arr[e1]);
                                return t;
                            }
                        },
                        {
                            key: "clearRows",
                            value: function() {
                                delete this.rows, this.rows = [];
                            }
                        },
                        {
                            key: "addColumn",
                            value: function(e1) {
                                this.columns.push(e1 || null);
                            }
                        },
                        {
                            key: "getColumnCount",
                            value: function() {
                                return this.columns.length;
                            }
                        },
                        {
                            key: "getRowCount",
                            value: function() {
                                return this.rows.length;
                            }
                        },
                        {
                            key: "removeTokens",
                            value: function(e1, t) {
                                for(var r = [], o = 0; o < e1.length; o++)r.push(e1.charAt(o).replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"));
                                var n = new RegExp(r.join("|"), "g");
                                if (void 0 === t) for(var s = 0; s < this.columns.length; s++)for(var i = 0; i < this.rows.length; i++){
                                    var a = (a = this.rows[i].arr[s]).replace(n, "");
                                    this.rows[i].arr[s] = a, this.rows[i].obj[this.columns[s]] = a;
                                }
                                else if ("string" == typeof t) for(var l = 0; l < this.rows.length; l++){
                                    var u = (u = this.rows[l].obj[t]).replace(n, ""), c = (this.rows[l].obj[t] = u, this.columns.indexOf(t));
                                    this.rows[l].arr[c] = u;
                                }
                                else for(var d = 0; d < this.rows.length; d++){
                                    var f = (f = this.rows[d].arr[t]).replace(n, "");
                                    this.rows[d].arr[t] = f, this.rows[d].obj[this.columns[t]] = f;
                                }
                            }
                        },
                        {
                            key: "trim",
                            value: function(e1) {
                                var t = new RegExp(" ", "g");
                                if (void 0 === e1) for(var r = 0; r < this.columns.length; r++)for(var o = 0; o < this.rows.length; o++){
                                    var n = (n = this.rows[o].arr[r]).replace(t, "");
                                    this.rows[o].arr[r] = n, this.rows[o].obj[this.columns[r]] = n;
                                }
                                else if ("string" == typeof e1) for(var s = 0; s < this.rows.length; s++){
                                    var i = (i = this.rows[s].obj[e1]).replace(t, ""), a = (this.rows[s].obj[e1] = i, this.columns.indexOf(e1));
                                    this.rows[s].arr[a] = i;
                                }
                                else for(var l = 0; l < this.rows.length; l++){
                                    var u = (u = this.rows[l].arr[e1]).replace(t, "");
                                    this.rows[l].arr[e1] = u, this.rows[l].obj[this.columns[e1]] = u;
                                }
                            }
                        },
                        {
                            key: "removeColumn",
                            value: function(e1) {
                                "string" == typeof e1 ? r = this.columns.indexOf(t = e1) : t = this.columns[r = e1];
                                var t, r, e1 = this.columns.splice(r + 1, this.columns.length);
                                this.columns.pop(), this.columns = this.columns.concat(e1);
                                for(var o = 0; o < this.rows.length; o++){
                                    var n = this.rows[o].arr, s = n.splice(r + 1, n.length);
                                    n.pop(), this.rows[o].arr = n.concat(s), delete this.rows[o].obj[t];
                                }
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                this.rows[e1].set(t, r);
                            }
                        },
                        {
                            key: "setNum",
                            value: function(e1, t, r) {
                                this.rows[e1].setNum(t, r);
                            }
                        },
                        {
                            key: "setString",
                            value: function(e1, t, r) {
                                this.rows[e1].setString(t, r);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t) {
                                return this.rows[e1].get(t);
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1, t) {
                                return this.rows[e1].getNum(t);
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1, t) {
                                return this.rows[e1].getString(t);
                            }
                        },
                        {
                            key: "getObject",
                            value: function(e1) {
                                for(var t, r = {}, o = 0; o < this.rows.length; o++)if (t = this.rows[o].obj, "string" == typeof e1) {
                                    if (!(0 <= this.columns.indexOf(e1))) throw new Error('This table has no column named "'.concat(e1, '"'));
                                    r[t[e1]] = t;
                                } else r[o] = this.rows[o].obj;
                                return r;
                            }
                        },
                        {
                            key: "getArray",
                            value: function() {
                                for(var e1 = [], t = 0; t < this.rows.length; t++)e1.push(this.rows[t].arr);
                                return e1;
                            }
                        }
                    ], s(e1.prototype, r), o && s(e1, o), t;
                }();
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.splice": 166,
                "core-js/modules/es.regexp.constructor": 184,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.match": 191,
                "core-js/modules/es.string.replace": 194
            }
        ],
        301: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.from-entries"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                e1.default.TableRow = function() {
                    function o(e1, t) {
                        if (!(this instanceof o)) throw new TypeError("Cannot call a class as a function");
                        var r = [];
                        e1 && (r = e1.split(t = t || ",")), this.arr = r, this.obj = Object.fromEntries(r.entries()), this.table = null;
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "set",
                            value: function(e1, t) {
                                if ("string" == typeof e1) {
                                    var r = this.table.columns.indexOf(e1);
                                    if (!(0 <= r)) throw new Error('This table has no column named "'.concat(e1, '"'));
                                    this.obj[e1] = t, this.arr[r] = t;
                                } else {
                                    if (!(e1 < this.table.columns.length)) throw new Error("Column #".concat(e1, " is out of the range of this table"));
                                    this.arr[e1] = t;
                                    r = this.table.columns[e1];
                                    this.obj[r] = t;
                                }
                            }
                        },
                        {
                            key: "setNum",
                            value: function(e1, t) {
                                t = parseFloat(t);
                                this.set(e1, t);
                            }
                        },
                        {
                            key: "setString",
                            value: function(e1, t) {
                                t = t.toString();
                                this.set(e1, t);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1) {
                                return ("string" == typeof e1 ? this.obj : this.arr)[e1];
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1) {
                                var t = "string" == typeof e1 ? parseFloat(this.obj[e1]) : parseFloat(this.arr[e1]);
                                if ("NaN" === t.toString()) throw "Error: ".concat(this.obj[e1], " is NaN (Not a Number)");
                                return t;
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1) {
                                return ("string" == typeof e1 ? this.obj : this.arr)[e1].toString();
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.from-entries": 175,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        302: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function s(e1) {
                    for(var t = [], r = 0; r < e1.length; r++)t.push(new a.default.XML(e1[r]));
                    return t;
                }
                a.default.XML = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        e1 ? this.DOM = e1 : (e1 = document.implementation.createDocument(null, "doc"), this.DOM = e1.createElement("root"));
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "getParent",
                            value: function() {
                                return new a.default.XML(this.DOM.parentElement);
                            }
                        },
                        {
                            key: "getName",
                            value: function() {
                                return this.DOM.tagName;
                            }
                        },
                        {
                            key: "setName",
                            value: function(e1) {
                                var t = this.DOM.innerHTML, r = this.DOM.attributes, o = document.implementation.createDocument(null, "default").createElement(e1);
                                o.innerHTML = t;
                                for(var n = 0; n < r.length; n++)o.setAttribute(r[n].nodeName, r.nodeValue);
                                this.DOM = o;
                            }
                        },
                        {
                            key: "hasChildren",
                            value: function() {
                                return 0 < this.DOM.children.length;
                            }
                        },
                        {
                            key: "listChildren",
                            value: function() {
                                for(var e1 = [], t = 0; t < this.DOM.childNodes.length; t++)e1.push(this.DOM.childNodes[t].nodeName);
                                return e1;
                            }
                        },
                        {
                            key: "getChildren",
                            value: function(e1) {
                                return s(e1 ? this.DOM.getElementsByTagName(e1) : this.DOM.children);
                            }
                        },
                        {
                            key: "getChild",
                            value: function(e1) {
                                if ("string" != typeof e1) return new a.default.XML(this.DOM.children[e1]);
                                var t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.DOM.children[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value;
                                        if (i.tagName === e1) return new a.default.XML(i);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                            }
                        },
                        {
                            key: "addChild",
                            value: function(e1) {
                                e1 instanceof a.default.XML && this.DOM.appendChild(e1.DOM);
                            }
                        },
                        {
                            key: "removeChild",
                            value: function(e1) {
                                var t = -1;
                                if ("string" == typeof e1) {
                                    for(var r = 0; r < this.DOM.children.length; r++)if (this.DOM.children[r].tagName === e1) {
                                        t = r;
                                        break;
                                    }
                                } else t = e1;
                                -1 !== t && this.DOM.removeChild(this.DOM.children[t]);
                            }
                        },
                        {
                            key: "getAttributeCount",
                            value: function() {
                                return this.DOM.attributes.length;
                            }
                        },
                        {
                            key: "listAttributes",
                            value: function() {
                                var e1 = [], t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.DOM.attributes[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value;
                                        e1.push(i.nodeName);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                                return e1;
                            }
                        },
                        {
                            key: "hasAttribute",
                            value: function(e1) {
                                var t = {}, r = !0, o = !1, n = void 0;
                                try {
                                    for(var s, i = this.DOM.attributes[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                        var a = s.value;
                                        t[a.nodeName] = a.nodeValue;
                                    }
                                } catch (e1) {
                                    o = !0, n = e1;
                                } finally{
                                    try {
                                        r || null == i.return || i.return();
                                    } finally{
                                        if (o) throw n;
                                    }
                                }
                                return !!t[e1];
                            }
                        },
                        {
                            key: "getNum",
                            value: function(e1, t) {
                                var r = {}, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = this.DOM.attributes[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                        var l = i.value;
                                        r[l.nodeName] = l.nodeValue;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                return Number(r[e1]) || t || 0;
                            }
                        },
                        {
                            key: "getString",
                            value: function(e1, t) {
                                var r = {}, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = this.DOM.attributes[Symbol.iterator](); !(o = (i = a.next()).done); o = !0){
                                        var l = i.value;
                                        r[l.nodeName] = l.nodeValue;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                return r[e1] ? String(r[e1]) : t || null;
                            }
                        },
                        {
                            key: "setAttribute",
                            value: function(e1, t) {
                                this.DOM.setAttribute(e1, t);
                            }
                        },
                        {
                            key: "getContent",
                            value: function(e1) {
                                var t = this.DOM.textContent;
                                return (t = t.replace(/\s\s+/g, ",")) || e1 || null;
                            }
                        },
                        {
                            key: "setContent",
                            value: function(e1) {
                                this.DOM.children.length || (this.DOM.textContent = e1);
                            }
                        },
                        {
                            key: "serialize",
                            value: function() {
                                return (new XMLSerializer).serializeToString(this.DOM);
                            }
                        }
                    ], n(e1.prototype, r), o && n(e1, o), t;
                }();
                e1 = a.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.number.constructor": 171,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.replace": 194,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        303: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var i = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o() {
                    if ("function" == typeof Math.hypot) return Math.hypot.apply(null, arguments);
                    for(var e1 = arguments.length, t = [], r = 0, o = 0; o < e1; o++){
                        var n = arguments[o];
                        if ((n = +n) === 1 / 0 || n === -1 / 0) return 1 / 0;
                        r < (n = Math.abs(n)) && (r = n), t[o] = n;
                    }
                    0 === r && (r = 1);
                    for(var s = 0, i = 0, a = 0; a < e1; a++)var l = t[a] / r, l = l * l - i, u = s + l, i = u - s - l, s = u;
                    return Math.sqrt(s) * r;
                }
                i.default.prototype.abs = Math.abs, i.default.prototype.ceil = Math.ceil, i.default.prototype.constrain = function(e1, t, r) {
                    return i.default._validateParameters("constrain", arguments), Math.max(Math.min(e1, r), t);
                }, i.default.prototype.dist = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return i.default._validateParameters("dist", t), 4 === t.length ? o(t[2] - t[0], t[3] - t[1]) : 6 === t.length ? o(t[3] - t[0], t[4] - t[1], t[5] - t[2]) : void 0;
                }, i.default.prototype.exp = Math.exp, i.default.prototype.floor = Math.floor, i.default.prototype.lerp = function(e1, t, r) {
                    return i.default._validateParameters("lerp", arguments), r * (t - e1) + e1;
                }, i.default.prototype.log = Math.log, i.default.prototype.mag = function(e1, t) {
                    return i.default._validateParameters("mag", arguments), o(e1, t);
                }, i.default.prototype.map = function(e1, t, r, o, n, s) {
                    i.default._validateParameters("map", arguments);
                    e1 = (e1 - t) / (r - t) * (n - o) + o;
                    return s ? o < n ? this.constrain(e1, o, n) : this.constrain(e1, n, o) : e1;
                }, i.default.prototype.max = function() {
                    for(var e1 = function(e1) {
                        var t = -1 / 0, r = !0, o = !1, n = void 0;
                        try {
                            for(var s, i = e1[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)var a = s.value, t = t < a ? a : t;
                        } catch (e1) {
                            o = !0, n = e1;
                        } finally{
                            try {
                                r || null == i.return || i.return();
                            } finally{
                                if (o) throw n;
                            }
                        }
                        return t;
                    }, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return r[0] instanceof Array ? e1(r[0]) : e1(r);
                }, i.default.prototype.min = function() {
                    for(var e1 = function(e1) {
                        var t = 1 / 0, r = !0, o = !1, n = void 0;
                        try {
                            for(var s, i = e1[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)var a = s.value, t = a < t ? a : t;
                        } catch (e1) {
                            o = !0, n = e1;
                        } finally{
                            try {
                                r || null == i.return || i.return();
                            } finally{
                                if (o) throw n;
                            }
                        }
                        return t;
                    }, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return r[0] instanceof Array ? e1(r[0]) : e1(r);
                }, i.default.prototype.norm = function(e1, t, r) {
                    return i.default._validateParameters("norm", arguments), this.map(e1, t, r, 0, 1);
                }, i.default.prototype.pow = Math.pow, i.default.prototype.round = function(e1, t) {
                    return t ? (t = Math.pow(10, t), Math.round(e1 * t) / t) : Math.round(e1);
                }, i.default.prototype.sq = function(e1) {
                    return e1 * e1;
                }, i.default.prototype.sqrt = Math.sqrt, i.default.prototype.fract = function(e1) {
                    i.default._validateParameters("fract", arguments);
                    var t, r = 0, e1 = Number(e1);
                    return isNaN(e1) || Math.abs(e1) === 1 / 0 ? e1 : (e1 < 0 && (e1 = -e1, r = 1), String(e1).includes(".") && !String(e1).includes("e") ? (t = String(e1), t = Number("0" + t.slice(t.indexOf("."))), Math.abs(r - t)) : e1 < 1 ? Math.abs(r - e1) : 0);
                };
                e1 = i.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.math.hypot": 169,
                "core-js/modules/es.number.constructor": 171,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        304: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t, r) {
                    return (n = function() {
                        if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                            if ("function" == typeof Proxy) return 1;
                            try {
                                return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                            } catch (e1) {}
                        }
                    }() ? Reflect.construct : function(e1, t, r) {
                        var o = [
                            null
                        ];
                        o.push.apply(o, t);
                        t = new (Function.bind.apply(e1, o));
                        return r && s(t, r.prototype), t;
                    }).apply(null, arguments);
                }
                function s(e1, t) {
                    return (s = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                o.default.prototype.createVector = function(e1, t, r) {
                    return this instanceof o.default ? n(o.default.Vector, [
                        this._fromRadians.bind(this),
                        this._toRadians.bind(this)
                    ].concat(Array.prototype.slice.call(arguments))) : new o.default.Vector(e1, t, r);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.regexp.to-string": 186
            }
        ],
        305: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function b(e1) {
                    return .5 * (1 - Math.cos(e1 * Math.PI));
                }
                var j, _ = 4095, x = 4, w = .5, e1 = (e1.default.prototype.noise = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0;
                    if (null == j) {
                        j = new Array(4096);
                        for(var o = 0; o < 4096; o++)j[o] = Math.random();
                    }
                    e1 < 0 && (e1 = -e1), t < 0 && (t = -t), r < 0 && (r = -r);
                    for(var n, s, i = Math.floor(e1), a = Math.floor(t), l = Math.floor(r), u = e1 - i, c = t - a, d = r - l, f = 0, h = .5, p = 0; p < x; p++){
                        var m = i + (a << 4) + (l << 8), y = b(u), g = b(c), v = j[m & _];
                        v += y * (j[m + 1 & _] - v), n = j[m + 16 & _], v += g * ((n += y * (j[m + 16 + 1 & _] - n)) - v), n = j[(m += 256) & _], n += y * (j[m + 1 & _] - n), s = j[m + 16 & _], n += g * ((s += y * (j[m + 16 + 1 & _] - s)) - n), f += (v += b(d) * (n - v)) * h, h *= w, i <<= 1, a <<= 1, l <<= 1, 1 <= (u *= 2) && (i++, u--), 1 <= (c *= 2) && (a++, c--), 1 <= (d *= 2) && (l++, d--);
                    }
                    return f;
                }, e1.default.prototype.noiseDetail = function(e1, t) {
                    0 < e1 && (x = e1), 0 < t && (w = t);
                }, e1.default.prototype.noiseSeed = function(e1) {
                    o = 4294967296;
                    var t, r, o, n = {
                        setSeed: function(e1) {
                            r = t = (null == e1 ? Math.random() * o : e1) >>> 0;
                        },
                        getSeed: function() {
                            return t;
                        },
                        rand: function() {
                            return (r = (1664525 * r + 1013904223) % o) / o;
                        }
                    };
                    n.setSeed(e1), j = new Array(4096);
                    for(var s = 0; s < 4096; s++)j[s] = n.rand();
                }, e1.default);
                r.default = e1;
            },
            {
                "../core/main": 273
            }
        ],
        306: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.number.is-finite"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.number.is-finite"), e1("core-js/modules/es.string.sub"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function c(e1, t) {
                    return 0 !== e1 && (this.x = this.x % e1), 0 !== t && (this.y = this.y % t), this;
                }
                function d(e1, t, r) {
                    return 0 !== e1 && (this.x = this.x % e1), 0 !== t && (this.y = this.y % t), 0 !== r && (this.z = this.z % r), this;
                }
                a.default.Vector = function() {
                    function n() {
                        var e1 = this, t = n;
                        if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                        var r, o, e1 = "function" == typeof (arguments.length <= 0 ? void 0 : arguments[0]) ? (this.isPInst = !0, this._fromRadians = arguments.length <= 0 ? void 0 : arguments[0], this._toRadians = arguments.length <= 1 ? void 0 : arguments[1], r = (arguments.length <= 2 ? void 0 : arguments[2]) || 0, o = (arguments.length <= 3 ? void 0 : arguments[3]) || 0, (arguments.length <= 4 ? void 0 : arguments[4]) || 0) : (r = (arguments.length <= 0 ? void 0 : arguments[0]) || 0, o = (arguments.length <= 1 ? void 0 : arguments[1]) || 0, (arguments.length <= 2 ? void 0 : arguments[2]) || 0);
                        this.x = r, this.y = o, this.z = e1;
                    }
                    var e1, t, r;
                    return e1 = n, r = [
                        {
                            key: "fromAngle",
                            value: function(e1, t) {
                                return new a.default.Vector((t = void 0 === t ? 1 : t) * Math.cos(e1), t * Math.sin(e1), 0);
                            }
                        },
                        {
                            key: "fromAngles",
                            value: function(e1, t, r) {
                                void 0 === r && (r = 1);
                                var o = Math.cos(t), t = Math.sin(t), n = Math.cos(e1), e1 = Math.sin(e1);
                                return new a.default.Vector(r * e1 * t, -r * n, r * e1 * o);
                            }
                        },
                        {
                            key: "random2D",
                            value: function() {
                                return this.fromAngle(Math.random() * s.TWO_PI);
                            }
                        },
                        {
                            key: "random3D",
                            value: function() {
                                var e1 = Math.random() * s.TWO_PI, t = 2 * Math.random() - 1, r = Math.sqrt(1 - t * t), o = r * Math.cos(e1), r = r * Math.sin(e1);
                                return new a.default.Vector(o, r, t);
                            }
                        },
                        {
                            key: "copy",
                            value: function(e1) {
                                return e1.copy(e1);
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t, r) {
                                return r ? r.set(e1) : (r = e1.copy(), 3 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.add")), r.add(t), r;
                            }
                        },
                        {
                            key: "rem",
                            value: function(e1, t) {
                                if (e1 instanceof a.default.Vector && t instanceof a.default.Vector) return (e1 = e1.copy()).rem(t), e1;
                            }
                        },
                        {
                            key: "sub",
                            value: function(e1, t, r) {
                                return r ? r.set(e1) : (r = e1.copy(), 3 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.sub")), r.sub(t), r;
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1, t, r) {
                                return r ? r.set(e1) : (r = e1.copy(), 3 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.mult")), r.mult(t), r;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1, t, r) {
                                return 2 === arguments.length ? r = e1.copy() : (r instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.rotate"), r.set(e1)), r.rotate(t), r;
                            }
                        },
                        {
                            key: "div",
                            value: function(e1, t, r) {
                                return r ? r.set(e1) : (r = e1.copy(), 3 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.div")), r.div(t), r;
                            }
                        },
                        {
                            key: "dot",
                            value: function(e1, t) {
                                return e1.dot(t);
                            }
                        },
                        {
                            key: "cross",
                            value: function(e1, t) {
                                return e1.cross(t);
                            }
                        },
                        {
                            key: "dist",
                            value: function(e1, t) {
                                return e1.dist(t);
                            }
                        },
                        {
                            key: "lerp",
                            value: function(e1, t, r, o) {
                                return o ? o.set(e1) : (o = e1.copy(), 4 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.lerp")), o.lerp(t, r), o;
                            }
                        },
                        {
                            key: "slerp",
                            value: function(e1, t, r, o) {
                                return o ? o.set(e1) : (o = e1.copy(), 4 === arguments.length && a.default._friendlyError("The target parameter is undefined, it should be of type p5.Vector", "p5.Vector.slerp")), o.slerp(t, r), o;
                            }
                        },
                        {
                            key: "mag",
                            value: function(e1) {
                                return e1.mag();
                            }
                        },
                        {
                            key: "magSq",
                            value: function(e1) {
                                return e1.magSq();
                            }
                        },
                        {
                            key: "normalize",
                            value: function(e1, t) {
                                return arguments.length < 2 ? t = e1.copy() : (t instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.normalize"), t.set(e1)), t.normalize();
                            }
                        },
                        {
                            key: "limit",
                            value: function(e1, t, r) {
                                return arguments.length < 3 ? r = e1.copy() : (r instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.limit"), r.set(e1)), r.limit(t);
                            }
                        },
                        {
                            key: "setMag",
                            value: function(e1, t, r) {
                                return arguments.length < 3 ? r = e1.copy() : (r instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.setMag"), r.set(e1)), r.setMag(t);
                            }
                        },
                        {
                            key: "heading",
                            value: function(e1) {
                                return e1.heading();
                            }
                        },
                        {
                            key: "angleBetween",
                            value: function(e1, t) {
                                return e1.angleBetween(t);
                            }
                        },
                        {
                            key: "reflect",
                            value: function(e1, t, r) {
                                return arguments.length < 3 ? r = e1.copy() : (r instanceof a.default.Vector || a.default._friendlyError("The target parameter should be of type p5.Vector", "p5.Vector.reflect"), r.set(e1)), r.reflect(t);
                            }
                        },
                        {
                            key: "array",
                            value: function(e1) {
                                return e1.array();
                            }
                        },
                        {
                            key: "equals",
                            value: function(e1, t) {
                                var r;
                                return e1 instanceof a.default.Vector ? r = e1 : e1 instanceof Array ? r = (new a.default.Vector).set(e1) : a.default._friendlyError("The v1 parameter should be of type Array or p5.Vector", "p5.Vector.equals"), r.equals(t);
                            }
                        }
                    ], t = [
                        {
                            key: "toString",
                            value: function() {
                                return "p5.Vector Object : [".concat(this.x, ", ").concat(this.y, ", ").concat(this.z, "]");
                            }
                        },
                        {
                            key: "set",
                            value: function(e1, t, r) {
                                return e1 instanceof a.default.Vector ? (this.x = e1.x || 0, this.y = e1.y || 0, this.z = e1.z || 0) : Array.isArray(e1) ? (this.x = e1[0] || 0, this.y = e1[1] || 0, this.z = e1[2] || 0) : (this.x = e1 || 0, this.y = t || 0, this.z = r || 0), this;
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                return this.isPInst ? new a.default.Vector(this._fromRadians, this._toRadians, this.x, this.y, this.z) : new a.default.Vector(this.x, this.y, this.z);
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t, r) {
                                return e1 instanceof a.default.Vector ? (this.x += e1.x || 0, this.y += e1.y || 0, this.z += e1.z || 0) : Array.isArray(e1) ? (this.x += e1[0] || 0, this.y += e1[1] || 0, this.z += e1[2] || 0) : (this.x += e1 || 0, this.y += t || 0, this.z += r || 0), this;
                            }
                        },
                        {
                            key: "rem",
                            value: function(e1, t, r) {
                                var o;
                                if (e1 instanceof a.default.Vector) {
                                    if ([
                                        e1.x,
                                        e1.y,
                                        e1.z
                                    ].every(Number.isFinite)) return n = parseFloat(e1.x), s = parseFloat(e1.y), o = parseFloat(e1.z), d.call(this, n, s, o);
                                } else if (Array.isArray(e1)) {
                                    if (e1.every(function(e1) {
                                        return Number.isFinite(e1);
                                    })) return 2 === e1.length ? c.call(this, e1[0], e1[1]) : 3 === e1.length ? d.call(this, e1[0], e1[1], e1[2]) : void 0;
                                } else if (1 === arguments.length) {
                                    if (Number.isFinite(e1) && 0 !== e1) return this.x = this.x % e1, this.y = this.y % e1, this.z = this.z % e1, this;
                                } else if (2 === arguments.length) {
                                    var n = Array.prototype.slice.call(arguments);
                                    if (n.every(function(e1) {
                                        return Number.isFinite(e1);
                                    }) && 2 === n.length) return c.call(this, n[0], n[1]);
                                } else if (3 === arguments.length) {
                                    var s = Array.prototype.slice.call(arguments);
                                    if (s.every(function(e1) {
                                        return Number.isFinite(e1);
                                    }) && 3 === s.length) return d.call(this, s[0], s[1], s[2]);
                                }
                            }
                        },
                        {
                            key: "sub",
                            value: function(e1, t, r) {
                                return e1 instanceof a.default.Vector ? (this.x -= e1.x || 0, this.y -= e1.y || 0, this.z -= e1.z || 0) : Array.isArray(e1) ? (this.x -= e1[0] || 0, this.y -= e1[1] || 0, this.z -= e1[2] || 0) : (this.x -= e1 || 0, this.y -= t || 0, this.z -= r || 0), this;
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1, t, r) {
                                var o;
                                return e1 instanceof a.default.Vector ? Number.isFinite(e1.x) && Number.isFinite(e1.y) && Number.isFinite(e1.z) && "number" == typeof e1.x && "number" == typeof e1.y && "number" == typeof e1.z ? (this.x *= e1.x, this.y *= e1.y, this.z *= e1.z) : console.warn("p5.Vector.prototype.mult:", "x contains components that are either undefined or not finite numbers") : Array.isArray(e1) ? e1.every(function(e1) {
                                    return Number.isFinite(e1);
                                }) && e1.every(function(e1) {
                                    return "number" == typeof e1;
                                }) ? 1 === e1.length ? (this.x *= e1[0], this.y *= e1[0], this.z *= e1[0]) : 2 === e1.length ? (this.x *= e1[0], this.y *= e1[1]) : 3 === e1.length && (this.x *= e1[0], this.y *= e1[1], this.z *= e1[2]) : console.warn("p5.Vector.prototype.mult:", "x contains elements that are either undefined or not finite numbers") : (o = Array.prototype.slice.call(arguments)).every(function(e1) {
                                    return Number.isFinite(e1);
                                }) && o.every(function(e1) {
                                    return "number" == typeof e1;
                                }) ? (1 === arguments.length && (this.x *= e1, this.y *= e1, this.z *= e1), 2 === arguments.length && (this.x *= e1, this.y *= t), 3 === arguments.length && (this.x *= e1, this.y *= t, this.z *= r)) : console.warn("p5.Vector.prototype.mult:", "x, y, or z arguments are either undefined or not a finite number"), this;
                            }
                        },
                        {
                            key: "div",
                            value: function(e1, t, r) {
                                if (e1 instanceof a.default.Vector) {
                                    if (Number.isFinite(e1.x) && Number.isFinite(e1.y) && Number.isFinite(e1.z) && "number" == typeof e1.x && "number" == typeof e1.y && "number" == typeof e1.z) {
                                        var o = 0 === e1.z && 0 === this.z;
                                        if (0 === e1.x || 0 === e1.y || !o && 0 === e1.z) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                        this.x /= e1.x, this.y /= e1.y, o || (this.z /= e1.z);
                                    } else console.warn("p5.Vector.prototype.div:", "x contains components that are either undefined or not finite numbers");
                                } else if (Array.isArray(e1)) {
                                    if (e1.every(function(e1) {
                                        return Number.isFinite(e1);
                                    }) && e1.every(function(e1) {
                                        return "number" == typeof e1;
                                    })) {
                                        if (e1.some(function(e1) {
                                            return 0 === e1;
                                        })) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                        1 === e1.length ? (this.x /= e1[0], this.y /= e1[0], this.z /= e1[0]) : 2 === e1.length ? (this.x /= e1[0], this.y /= e1[1]) : 3 === e1.length && (this.x /= e1[0], this.y /= e1[1], this.z /= e1[2]);
                                    } else console.warn("p5.Vector.prototype.div:", "x contains components that are either undefined or not finite numbers");
                                } else {
                                    o = Array.prototype.slice.call(arguments);
                                    if (o.every(function(e1) {
                                        return Number.isFinite(e1);
                                    }) && o.every(function(e1) {
                                        return "number" == typeof e1;
                                    })) {
                                        if (o.some(function(e1) {
                                            return 0 === e1;
                                        })) return console.warn("p5.Vector.prototype.div:", "divide by 0"), this;
                                        1 === arguments.length && (this.x /= e1, this.y /= e1, this.z /= e1), 2 === arguments.length && (this.x /= e1, this.y /= t), 3 === arguments.length && (this.x /= e1, this.y /= t, this.z /= r);
                                    } else console.warn("p5.Vector.prototype.div:", "x, y, or z arguments are either undefined or not a finite number");
                                }
                                return this;
                            }
                        },
                        {
                            key: "mag",
                            value: function() {
                                return Math.sqrt(this.magSq());
                            }
                        },
                        {
                            key: "magSq",
                            value: function() {
                                var e1 = this.x, t = this.y, r = this.z;
                                return e1 * e1 + t * t + r * r;
                            }
                        },
                        {
                            key: "dot",
                            value: function(e1, t, r) {
                                return e1 instanceof a.default.Vector ? this.dot(e1.x, e1.y, e1.z) : this.x * (e1 || 0) + this.y * (t || 0) + this.z * (r || 0);
                            }
                        },
                        {
                            key: "cross",
                            value: function(e1) {
                                var t = this.y * e1.z - this.z * e1.y, r = this.z * e1.x - this.x * e1.z, e1 = this.x * e1.y - this.y * e1.x;
                                return this.isPInst ? new a.default.Vector(this._fromRadians, this._toRadians, t, r, e1) : new a.default.Vector(t, r, e1);
                            }
                        },
                        {
                            key: "dist",
                            value: function(e1) {
                                return e1.copy().sub(this).mag();
                            }
                        },
                        {
                            key: "normalize",
                            value: function() {
                                var e1 = this.mag();
                                return 0 !== e1 && this.mult(1 / e1), this;
                            }
                        },
                        {
                            key: "limit",
                            value: function(e1) {
                                var t = this.magSq();
                                return e1 * e1 < t && this.div(Math.sqrt(t)).mult(e1), this;
                            }
                        },
                        {
                            key: "setMag",
                            value: function(e1) {
                                return this.normalize().mult(e1);
                            }
                        },
                        {
                            key: "heading",
                            value: function() {
                                var e1 = Math.atan2(this.y, this.x);
                                return this.isPInst ? this._fromRadians(e1) : e1;
                            }
                        },
                        {
                            key: "setHeading",
                            value: function(e1) {
                                this.isPInst && (e1 = this._toRadians(e1));
                                var t = this.mag();
                                return this.x = t * Math.cos(e1), this.y = t * Math.sin(e1), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1) {
                                var e1 = this.heading() + e1, t = (this.isPInst && (e1 = this._toRadians(e1)), this.mag());
                                return this.x = Math.cos(e1) * t, this.y = Math.sin(e1) * t, this;
                            }
                        },
                        {
                            key: "angleBetween",
                            value: function(e1) {
                                var t;
                                return 0 == this.magSq() * e1.magSq() ? NaN : (t = this.cross(e1), e1 = Math.atan2(t.mag(), this.dot(e1)) * Math.sign(t.z || 1), this.isPInst ? this._fromRadians(e1) : e1);
                            }
                        },
                        {
                            key: "lerp",
                            value: function(e1, t, r, o) {
                                return e1 instanceof a.default.Vector ? this.lerp(e1.x, e1.y, e1.z, t) : (this.x += (e1 - this.x) * o || 0, this.y += (t - this.y) * o || 0, this.z += (r - this.z) * o || 0, this);
                            }
                        },
                        {
                            key: "slerp",
                            value: function(e1, t) {
                                if (0 !== t) {
                                    if (1 === t) return this.set(e1);
                                    var r = this.mag(), o = e1.mag();
                                    if (0 == r * o) this.mult(1 - t).add(e1.x * t, e1.y * t, e1.z * t);
                                    else {
                                        var n = this.cross(e1), s = n.mag(), i = Math.atan2(s, this.dot(e1));
                                        if (0 < s) n.x /= s, n.y /= s, n.z /= s;
                                        else {
                                            if (i < .5 * Math.PI) return this.mult(1 - t).add(e1.x * t, e1.y * t, e1.z * t), this;
                                            0 === this.z && 0 === e1.z ? n.set(0, 0, 1) : 0 !== this.x ? n.set(this.y, -this.x, 0).normalize() : n.set(1, 0, 0);
                                        }
                                        s = n.cross(this), e1 = 1 - t + t * o / r, n = e1 * Math.cos(t * i), o = e1 * Math.sin(t * i);
                                        this.x = this.x * n + s.x * o, this.y = this.y * n + s.y * o, this.z = this.z * n + s.z * o;
                                    }
                                }
                                return this;
                            }
                        },
                        {
                            key: "reflect",
                            value: function(e1) {
                                return e1.normalize(), this.sub(e1.mult(2 * this.dot(e1)));
                            }
                        },
                        {
                            key: "array",
                            value: function() {
                                return [
                                    this.x || 0,
                                    this.y || 0,
                                    this.z || 0
                                ];
                            }
                        },
                        {
                            key: "equals",
                            value: function(e1, t, r) {
                                var o, n, e1 = e1 instanceof a.default.Vector ? (o = e1.x || 0, n = e1.y || 0, e1.z || 0) : Array.isArray(e1) ? (o = e1[0] || 0, n = e1[1] || 0, e1[2] || 0) : (o = e1 || 0, n = t || 0, r || 0);
                                return this.x === o && this.y === n && this.z === e1;
                            }
                        }
                    ], u(e1.prototype, t), r && u(e1, r), n;
                }();
                var n = a.default.Vector;
                r.default = n;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.every": 153,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.array.some": 165,
                "core-js/modules/es.math.sign": 170,
                "core-js/modules/es.number.constructor": 171,
                "core-js/modules/es.number.is-finite": 172,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.sub": 198,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        307: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                var s = "_lcg_random_state", o = 4294967296, i = 0, e1 = (n.default.prototype._lcg = function(e1) {
                    return this[e1] = (1664525 * this[e1] + 1013904223) % o, this[e1] / o;
                }, n.default.prototype._lcgSetSeed = function(e1, t) {
                    this[e1] = (null == t ? Math.random() * o : t) >>> 0;
                }, n.default.prototype.randomSeed = function(e1) {
                    this._lcgSetSeed(s, e1), this._gaussian_previous = !1;
                }, n.default.prototype.random = function(e1, t) {
                    var r, o;
                    return n.default._validateParameters("random", arguments), r = null != this[s] ? this._lcg(s) : Math.random(), void 0 === e1 ? r : void 0 === t ? e1 instanceof Array ? e1[Math.floor(r * e1.length)] : r * e1 : (t < e1 && (o = e1, e1 = t, t = o), r * (t - e1) + e1);
                }, n.default.prototype.randomGaussian = function(e1) {
                    var t, r, o, n, s = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 1;
                    if (this._gaussian_previous) t = i, this._gaussian_previous = !1;
                    else {
                        for(; 1 <= (n = (r = this.random(2) - 1) * r + (o = this.random(2) - 1) * o););
                        t = r * (n = Math.sqrt(-2 * Math.log(n) / n)), i = o * n, this._gaussian_previous = !0;
                    }
                    return t * s + (e1 || 0);
                }, n.default);
                r.default = e1;
            },
            {
                "../core/main": 273
            }
        ],
        308: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (l = e1("../core/main")) && l.__esModule ? l : {
                    default: l
                }, s = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                n.default.prototype._angleMode = s.RADIANS, n.default.prototype.acos = function(e1) {
                    return this._fromRadians(Math.acos(e1));
                }, n.default.prototype.asin = function(e1) {
                    return this._fromRadians(Math.asin(e1));
                }, n.default.prototype.atan = function(e1) {
                    return this._fromRadians(Math.atan(e1));
                }, n.default.prototype.atan2 = function(e1, t) {
                    return this._fromRadians(Math.atan2(e1, t));
                }, n.default.prototype.cos = function(e1) {
                    return Math.cos(this._toRadians(e1));
                }, n.default.prototype.sin = function(e1) {
                    return Math.sin(this._toRadians(e1));
                }, n.default.prototype.tan = function(e1) {
                    return Math.tan(this._toRadians(e1));
                }, n.default.prototype.degrees = function(e1) {
                    return e1 * s.RAD_TO_DEG;
                }, n.default.prototype.radians = function(e1) {
                    return e1 * s.DEG_TO_RAD;
                }, n.default.prototype.angleMode = function(e1) {
                    if (n.default._validateParameters("angleMode", arguments), void 0 === e1) return this._angleMode;
                    e1 !== s.DEGREES && e1 !== s.RADIANS || (this._angleMode = e1);
                }, n.default.prototype._toRadians = function(e1) {
                    return this._angleMode === s.DEGREES ? e1 * s.DEG_TO_RAD : e1;
                }, n.default.prototype._toDegrees = function(e1) {
                    return this._angleMode === s.RADIANS ? e1 * s.RAD_TO_DEG : e1;
                }, n.default.prototype._fromRadians = function(e1) {
                    return this._angleMode === s.DEGREES ? e1 * s.RAD_TO_DEG : e1;
                };
                var l = n.default;
                r.default = l;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        309: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                n.default.prototype.textAlign = function(e1, t) {
                    var r;
                    return n.default._validateParameters("textAlign", arguments), (r = this._renderer).textAlign.apply(r, arguments);
                }, n.default.prototype.textLeading = function(e1) {
                    var t;
                    return n.default._validateParameters("textLeading", arguments), (t = this._renderer).textLeading.apply(t, arguments);
                }, n.default.prototype.textSize = function(e1) {
                    var t;
                    return n.default._validateParameters("textSize", arguments), (t = this._renderer).textSize.apply(t, arguments);
                }, n.default.prototype.textStyle = function(e1) {
                    var t;
                    return n.default._validateParameters("textStyle", arguments), (t = this._renderer).textStyle.apply(t, arguments);
                }, n.default.prototype.textWidth = function() {
                    for(var e1, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return r[0] += "", n.default._validateParameters("textWidth", r), 0 === r[0].length ? 0 : (e1 = this._renderer).textWidth.apply(e1, r);
                }, n.default.prototype.textAscent = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return n.default._validateParameters("textAscent", t), this._renderer.textAscent();
                }, n.default.prototype.textDescent = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return n.default._validateParameters("textDescent", t), this._renderer.textDescent();
                }, n.default.prototype._updateTextMetrics = function() {
                    return this._renderer._updateTextMetrics();
                }, n.default.prototype.textWrap = function(e1) {
                    if ("WORD" !== e1 && "CHAR" !== e1) throw "Error: textWrap accepts only WORD or CHAR";
                    return this._renderer.textWrap(e1);
                };
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/main": 273
            }
        ],
        310: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.last-index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.split"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (c = e1("../core/main")) && c.__esModule ? c : {
                    default: c
                }, n = s(e1("../core/constants")), u = s(e1("opentype.js"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function s(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o, n = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1)Object.prototype.hasOwnProperty.call(e1, r) && ((o = s ? Object.getOwnPropertyDescriptor(e1, r) : null) && (o.get || o.set) ? Object.defineProperty(n, r, o) : n[r] = e1[r]);
                    return n.default = e1, t && t.set(e1, n), n;
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), l.default.prototype.loadFont = function(o, n, s) {
                    l.default._validateParameters("loadFont", arguments);
                    var i = new l.default.Font(this), a = this;
                    return u.load(o, function(e1, t) {
                        if (e1) return l.default._friendlyFileLoadError(4, o), void 0 !== s ? s(e1) : void console.error(e1, o);
                        i.font = t, void 0 !== n && n(i), a._decrementPreload();
                        var e1 = o.split("\\").pop().split("/").pop(), t = e1.lastIndexOf("."), r = t < 1 ? null : e1.slice(t + 1);
                        [
                            "ttf",
                            "otf",
                            "woff",
                            "woff2"
                        ].includes(r) && (r = e1.slice(0, -1 !== t ? t : 0), (e1 = document.createElement("style")).appendChild(document.createTextNode("\n@font-face {\nfont-family: ".concat(r, ";\nsrc: url(").concat(o, ");\n}\n"))), document.head.appendChild(e1));
                    }), i;
                }, l.default.prototype.text = function(e1, t, r, o, n) {
                    var s;
                    return l.default._validateParameters("text", arguments), this._renderer._doFill || this._renderer._doStroke ? (s = this._renderer).text.apply(s, arguments) : this;
                }, l.default.prototype.textFont = function(e1, t) {
                    if (l.default._validateParameters("textFont", arguments), arguments.length) {
                        if (e1) return this._renderer._setProperty("_textFont", e1), t && (this._renderer._setProperty("_textSize", t), this._renderer._leadingSet || this._renderer._setProperty("_textLeading", t * n._DEFAULT_LEADMULT)), this._renderer._applyTextProperties();
                        throw new Error("null font passed to textFont");
                    }
                    return this._renderer._textFont;
                };
                var c = l.default;
                r.default = c;
            },
            {
                "../core/constants": 262,
                "../core/friendly_errors/fes_core": 264,
                "../core/friendly_errors/file_errors": 265,
                "../core/friendly_errors/validate_params": 268,
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.last-index-of": 162,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236,
                "opentype.js": 247
            }
        ],
        311: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, v = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== p(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function p(e1) {
                    return (p = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function m(e1, t) {
                    var r = e1.length;
                    return e1[t < 0 ? t % r + r : t % r];
                }
                function y(e1, t, r, o) {
                    var n, s, i;
                    return o ? (void 0 === y.tmpPoint1 && (y.tmpPoint1 = [], y.tmpPoint2 = []), s = y.tmpPoint1, i = y.tmpPoint2, s.x = t.x - e1.x, s.y = t.y - e1.y, i.x = r.x - t.x, i.y = r.y - t.y, n = s.x * i.x + s.y * i.y, s = Math.sqrt(s.x * s.x + s.y * s.y), i = Math.sqrt(i.x * i.x + i.y * i.y), Math.acos(n / (s * i)) < o) : 0 == (t[0] - e1[0]) * (r[1] - e1[1]) - (r[0] - e1[0]) * (t[1] - e1[1]);
                }
                function d(e1, t, r, o, n, s, i, a, l) {
                    var u = 1 - l, c = Math.pow(u, 3), d = Math.pow(u, 2), f = l * l, h = f * l, p = c * e1 + 3 * d * l * r + 3 * u * l * l * n + h * i, c = c * t + 3 * d * l * o + 3 * u * l * l * s + h * a, d = e1 + 2 * l * (r - e1) + f * (n - 2 * r + e1), h = t + 2 * l * (o - t) + f * (s - 2 * o + t), m = r + 2 * l * (n - r) + f * (i - 2 * n + r), f = o + 2 * l * (s - o) + f * (a - 2 * s + o), e1 = u * e1 + l * r, r = u * t + l * o, t = u * n + l * i, o = u * s + l * a, n = 90 - 180 * Math.atan2(d - m, h - f) / Math.PI;
                    return (m < d || h < f) && (n += 180), {
                        x: p,
                        y: c,
                        m: {
                            x: d,
                            y: h
                        },
                        n: {
                            x: m,
                            y: f
                        },
                        start: {
                            x: e1,
                            y: r
                        },
                        end: {
                            x: t,
                            y: o
                        },
                        alpha: n
                    };
                }
                function f(e1, t, r, o, n, s, i, a, l) {
                    return null == l ? h(e1, t, r, o, n, s, i, a) : d(e1, t, r, o, n, s, i, a, function(e1, t, r, o, n, s, i, a, l) {
                        if (!(l < 0 || h(e1, t, r, o, n, s, i, a) < l)) {
                            var u, c = .5, d = 1 - c;
                            for(u = h(e1, t, r, o, n, s, i, a, d); .01 < Math.abs(u - l);)u = h(e1, t, r, o, n, s, i, a, d += (u < l ? 1 : -1) * (c /= 2));
                            return d;
                        }
                    }(e1, t, r, o, n, s, i, a, l));
                }
                function g(e1, t, r) {
                    for(var o, n, s, i, a, l = 0, u = 0, c = (e1 = function(e1, t) {
                        function r(e1, t, r) {
                            var o, n;
                            if (!e1) return [
                                "C",
                                t.x,
                                t.y,
                                t.x,
                                t.y,
                                t.x,
                                t.y
                            ];
                            switch((e1[0] in {
                                T: 1,
                                Q: 1
                            }) || (t.qx = t.qy = null), e1[0]){
                                case "M":
                                    t.X = e1[1], t.Y = e1[2];
                                    break;
                                case "A":
                                    e1 = [
                                        "C"
                                    ].concat(M.apply(0, [
                                        t.x,
                                        t.y
                                    ].concat(e1.slice(1))));
                                    break;
                                case "S":
                                    n = "C" === r || "S" === r ? (o = 2 * t.x - t.bx, 2 * t.y - t.by) : (o = t.x, t.y), e1 = [
                                        "C",
                                        o,
                                        n
                                    ].concat(e1.slice(1));
                                    break;
                                case "T":
                                    "Q" === r || "T" === r ? (t.qx = 2 * t.x - t.qx, t.qy = 2 * t.y - t.qy) : (t.qx = t.x, t.qy = t.y), e1 = [
                                        "C"
                                    ].concat(x(t.x, t.y, t.qx, t.qy, e1[1], e1[2]));
                                    break;
                                case "Q":
                                    t.qx = e1[1], t.qy = e1[2], e1 = [
                                        "C"
                                    ].concat(x(t.x, t.y, e1[1], e1[2], e1[3], e1[4]));
                                    break;
                                case "L":
                                    e1 = [
                                        "C"
                                    ].concat(_(t.x, t.y, e1[1], e1[2]));
                                    break;
                                case "H":
                                    e1 = [
                                        "C"
                                    ].concat(_(t.x, t.y, e1[1], t.y));
                                    break;
                                case "V":
                                    e1 = [
                                        "C"
                                    ].concat(_(t.x, t.y, t.x, e1[1]));
                                    break;
                                case "Z":
                                    e1 = [
                                        "C"
                                    ].concat(_(t.x, t.y, t.X, t.Y));
                            }
                            return e1;
                        }
                        function o(e1, t) {
                            if (7 < e1[t].length) {
                                e1[t].shift();
                                for(var r = e1[t]; r.length;)c[t] = "A", a && (d[t] = "A"), e1.splice(t++, 0, [
                                    "C"
                                ].concat(r.splice(0, 6)));
                                e1.splice(t, 1), s = Math.max(i.length, a && a.length || 0);
                            }
                        }
                        function n(e1, t, r, o, n) {
                            e1 && t && "M" === e1[n][0] && "M" !== t[n][0] && (t.splice(n, 0, [
                                "M",
                                o.x,
                                o.y
                            ]), r.bx = 0, r.by = 0, r.x = e1[n][1], r.y = e1[n][2], s = Math.max(i.length, a && a.length || 0));
                        }
                        var s, i = b(e1), a = t && b(t), l = {
                            x: 0,
                            y: 0,
                            bx: 0,
                            by: 0,
                            X: 0,
                            Y: 0,
                            qx: null,
                            qy: null
                        }, u = {
                            x: 0,
                            y: 0,
                            bx: 0,
                            by: 0,
                            X: 0,
                            Y: 0,
                            qx: null,
                            qy: null
                        }, c = [], d = [], f = "", h = "";
                        s = Math.max(i.length, a && a.length || 0);
                        for(var p = 0; p < s; p++){
                            "C" !== (f = i[p] ? i[p][0] : f) && (c[p] = f, p && (h = c[p - 1])), i[p] = r(i[p], l, h), "A" !== c[p] && "C" === f && (c[p] = "C"), o(i, p), a && ("C" !== (f = a[p] ? a[p][0] : f) && (d[p] = f, p && (h = d[p - 1])), a[p] = r(a[p], u, h), "A" !== d[p] && "C" === f && (d[p] = "C"), o(a, p)), n(i, a, l, u, p), n(a, i, u, l, p);
                            var m = i[p], y = a && a[p], g = m.length, v = a && y.length;
                            l.x = m[g - 2], l.y = m[g - 1], l.bx = parseFloat(m[g - 4]) || l.x, l.by = parseFloat(m[g - 3]) || l.y, u.bx = a && (parseFloat(y[v - 4]) || u.x), u.by = a && (parseFloat(y[v - 3]) || u.y), u.x = a && y[v - 2], u.y = a && y[v - 1];
                        }
                        return a ? [
                            i,
                            a
                        ] : i;
                    }(e1)).length; u < c; u++){
                        if ("M" === (s = e1[u])[0]) o = +s[1], n = +s[2];
                        else {
                            if (t < l + (i = f(o, n, s[1], s[2], s[3], s[4], s[5], s[6])) && !r) return {
                                x: (a = f(o, n, s[1], s[2], s[3], s[4], s[5], s[6], t - l)).x,
                                y: a.y,
                                alpha: a.alpha
                            };
                            l += i, o = +s[5], n = +s[6];
                        }
                        s.shift();
                    }
                    return a = (a = r ? l : d(o, n, s[0], s[1], s[2], s[3], s[4], s[5], 1)).alpha ? {
                        x: a.x,
                        y: a.y,
                        alpha: a.alpha
                    } : a;
                }
                function b(e1) {
                    var t = [], r = 0, o = 0, n = 0, s = 0, i = 0;
                    if (e1) {
                        "M" === e1[0][0] && (n = r = +e1[0][1], s = o = +e1[0][2], i++, t[0] = [
                            "M",
                            r,
                            o
                        ]);
                        for(var a, l, u = 3 === e1.length && "M" === e1[0][0] && "R" === e1[1][0].toUpperCase() && "Z" === e1[2][0].toUpperCase(), c = i, d = e1.length; c < d; c++){
                            if (t.push(a = []), (l = e1[c])[0] !== String.prototype.toUpperCase.call(l[0])) switch(a[0] = String.prototype.toUpperCase.call(l[0]), a[0]){
                                case "A":
                                    a[1] = l[1], a[2] = l[2], a[3] = l[3], a[4] = l[4], a[5] = l[5], a[6] = +(l[6] + r), a[7] = +(l[7] + o);
                                    break;
                                case "V":
                                    a[1] = +l[1] + o;
                                    break;
                                case "H":
                                    a[1] = +l[1] + r;
                                    break;
                                case "R":
                                    for(var f, h = 2, p = (f = [
                                        r,
                                        o
                                    ].concat(l.slice(1))).length; h < p; h++)f[h] = +f[h] + r, f[++h] = +f[h] + o;
                                    t.pop(), t = t.concat(j(f, u));
                                    break;
                                case "M":
                                    n = +l[1] + r, s = +l[2] + o;
                                    break;
                                default:
                                    for(var m = 1, y = l.length; m < y; m++)a[m] = +l[m] + (m % 2 ? r : o);
                            }
                            else if ("R" === l[0]) f = [
                                r,
                                o
                            ].concat(l.slice(1)), t.pop(), t = t.concat(j(f, u)), a = [
                                "R"
                            ].concat(l.slice(-2));
                            else for(var g = 0, v = l.length; g < v; g++)a[g] = l[g];
                            switch(a[0]){
                                case "Z":
                                    r = n, o = s;
                                    break;
                                case "H":
                                    r = a[1];
                                    break;
                                case "V":
                                    o = a[1];
                                    break;
                                case "M":
                                    n = a[a.length - 2], s = a[a.length - 1];
                                    break;
                                default:
                                    r = a[a.length - 2], o = a[a.length - 1];
                            }
                        }
                    }
                    return t;
                }
                function M(e1, t, r, o, n, s, i, a, l, u) {
                    function c(e1, t, r) {
                        return {
                            x: e1 * Math.cos(r) - t * Math.sin(r),
                            y: e1 * Math.sin(r) + t * Math.cos(r)
                        };
                    }
                    var d, f = Math.PI, h = 120 * f / 180, p = f / 180 * (+n || 0), m = [], y = (u ? (x = u[0], d = u[1], j = u[2], _ = u[3]) : (e1 = (v = c(e1, t, -p)).x, t = v.y, 1 < (y = (g = (e1 - (a = (v = c(a, l, -p)).x)) / 2) * g / (r * r) + (v = (t - (l = v.y)) / 2) * v / (o * o)) && (r *= y = Math.sqrt(y), o *= y), y = r * r, b = o * o, j = (s = (s === i ? -1 : 1) * Math.sqrt(Math.abs((y * b - y * v * v - b * g * g) / (y * v * v + b * g * g)))) * r * v / o + (e1 + a) / 2, _ = s * -o * g / r + (t + l) / 2, x = Math.asin(((t - _) / o).toFixed(9)), d = Math.asin(((l - _) / o).toFixed(9)), (x = e1 < j ? f - x : x) < 0 && (x = 2 * f + x), (d = a < j ? f - d : d) < 0 && (d = 2 * f + d), i && d < x && (x -= 2 * f), !i && x < d && (d -= 2 * f)), d - x), g = (Math.abs(y) > h && (b = d, v = a, s = l, d = x + h * (i && x < d ? 1 : -1), m = M(a = j + r * Math.cos(d), l = _ + o * Math.sin(d), r, o, n, 0, i, v, s, [
                        d,
                        b,
                        j,
                        _
                    ])), y = d - x, Math.cos(x)), f = Math.sin(x), h = Math.cos(d), n = Math.sin(d), i = Math.tan(y / 4), v = 4 / 3 * r * i, s = 4 / 3 * o * i, b = [
                        e1,
                        t
                    ], j = [
                        e1 + v * f,
                        t - s * g
                    ], _ = [
                        a + v * n,
                        l - s * h
                    ], x = [
                        a,
                        l
                    ];
                    if (j[0] = 2 * b[0] - j[0], j[1] = 2 * b[1] - j[1], u) return [
                        j,
                        _,
                        x
                    ].concat(m);
                    for(var w = [], S = 0, E = (m = [
                        j,
                        _,
                        x
                    ].concat(m).join().split(",")).length; S < E; S++)w[S] = S % 2 ? c(m[S - 1], m[S], p).y : c(m[S], m[S + 1], p).x;
                    return w;
                }
                function j(e1, t) {
                    for(var r = [], o = 0, n = e1.length; o < n - 2 * !t; o += 2){
                        var s = [
                            {
                                x: +e1[o - 2],
                                y: +e1[o - 1]
                            },
                            {
                                x: +e1[o],
                                y: +e1[o + 1]
                            },
                            {
                                x: +e1[o + 2],
                                y: +e1[o + 3]
                            },
                            {
                                x: +e1[o + 4],
                                y: +e1[o + 5]
                            }
                        ];
                        t ? o ? n - 4 === o ? s[3] = {
                            x: +e1[0],
                            y: +e1[1]
                        } : n - 2 === o && (s[2] = {
                            x: +e1[0],
                            y: +e1[1]
                        }, s[3] = {
                            x: +e1[2],
                            y: +e1[3]
                        }) : s[0] = {
                            x: +e1[n - 2],
                            y: +e1[n - 1]
                        } : n - 4 === o ? s[3] = s[2] : o || (s[0] = {
                            x: +e1[o],
                            y: +e1[o + 1]
                        }), r.push([
                            "C",
                            (-s[0].x + 6 * s[1].x + s[2].x) / 6,
                            (-s[0].y + 6 * s[1].y + s[2].y) / 6,
                            (s[1].x + 6 * s[2].x - s[3].x) / 6,
                            (s[1].y + 6 * s[2].y - s[3].y) / 6,
                            s[2].x,
                            s[2].y
                        ]);
                    }
                    return r;
                }
                function _(e1, t, r, o) {
                    return [
                        e1,
                        t,
                        r,
                        o,
                        r,
                        o
                    ];
                }
                function x(e1, t, r, o, n, s) {
                    return [
                        1 / 3 * e1 + 2 / 3 * r,
                        1 / 3 * t + 2 / 3 * o,
                        1 / 3 * n + 2 / 3 * r,
                        1 / 3 * s + 2 / 3 * o,
                        n,
                        s
                    ];
                }
                function h(e1, t, r, o, n, s, i, a, l) {
                    for(var u = (l = 1 < (l = null == l ? 1 : l) ? 1 : l < 0 ? 0 : l) / 2, c = [
                        -0.1252,
                        .1252,
                        -0.3678,
                        .3678,
                        -0.5873,
                        .5873,
                        -0.7699,
                        .7699,
                        -0.9041,
                        .9041,
                        -0.9816,
                        .9816
                    ], d = 0, f = [
                        .2491,
                        .2491,
                        .2335,
                        .2335,
                        .2032,
                        .2032,
                        .1601,
                        .1601,
                        .1069,
                        .1069,
                        .0472,
                        .0472
                    ], h = 0; h < 12; h++){
                        var p = u * c[h] + u, m = w(p, e1, r, n, i), p = w(p, t, o, s, a);
                        d += f[h] * Math.sqrt(m * m + p * p);
                    }
                    return u * d;
                }
                function w(e1, t, r, o, n) {
                    return e1 * (e1 * (-3 * t + 9 * r - 9 * o + 3 * n) + 6 * t - 12 * r + 6 * o) - 3 * t + 3 * r;
                }
                n.default.Font = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        this.parent = e1, this.cache = {}, this.font = void 0;
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "textBounds",
                            value: function(e1) {
                                var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : 0, o = 3 < arguments.length ? arguments[3] : void 0, n = 4 < arguments.length ? arguments[4] : void 0, s = n && n.renderer && n.renderer._pInst || this.parent, i = s._renderer.drawingContext, o = (i.textAlign || v.LEFT, i.textBaseline || v.BASELINE, o || s._renderer._textSize);
                                if (!g) {
                                    for(var a = [], l = [], u = [], c = (u[0] = [], []), d = this._scale(o), f = s._renderer.textLeading(), h = 0, p = (this.font.forEachGlyph(e1, t, r, o, n, function(e1, t, r, o) {
                                        var n = e1.getMetrics();
                                        0 === e1.index || 10 === e1.index ? u[h += 1] = [] : (u[h].push(t + n.xMin * d), u[h].push(t + n.xMax * d), c.push(r + h * f + -n.yMin * d), c.push(r + h * f + -n.yMax * d));
                                    }), 0 < u[h].length && (a[h] = Math.min.apply(null, u[h]), l[h] = Math.max.apply(null, u[h])), 0), m = 0; m <= h; m++){
                                        a[m] = Math.min.apply(null, u[m]), l[m] = Math.max.apply(null, u[m]);
                                        var y = l[m] - a[m];
                                        p < y && (p = y);
                                    }
                                    var i = Math.min.apply(null, a), g = {
                                        x: i,
                                        y: r = Math.min.apply(null, c),
                                        h: Math.max.apply(null, c) - r,
                                        w: p,
                                        advance: i - t
                                    }, o = this._handleAlignment(s._renderer, e1, g.x, g.y, g.w + g.advance);
                                    g.x = o.x, g.y = o.y;
                                }
                                return g;
                            }
                        },
                        {
                            key: "textToPoints",
                            value: function(e1, t, r, o, n) {
                                var s = 0, i = [], a = this._getGlyphs(e1);
                                o = o || this.parent._renderer._textSize;
                                for(var l, u = 0; u < a.length; u++){
                                    if (!(a[l = u].name && "space" === a[l].name || e1.length === a.length && " " === e1[l])) for(var c = function(e1) {
                                        for(var t, r = [], o = 0; o < e1.length; o++)"M" === e1[o].type && (t && r.push(t), t = []), t.push(function(e1) {
                                            var t = [
                                                e1.type
                                            ];
                                            "M" === e1.type || "L" === e1.type ? t.push(e1.x, e1.y) : "C" === e1.type ? t.push(e1.x1, e1.y1, e1.x2, e1.y2, e1.x, e1.y) : "Q" === e1.type && t.push(e1.x1, e1.y1, e1.x, e1.y);
                                            return t;
                                        }(e1[o]));
                                        return r.push(t), r;
                                    }(a[u].getPath(t, r, o).commands), d = 0; d < c.length; d++)for(var f = function(e1, t) {
                                        for(var t = function(e1, t) {
                                            if ("object" !== p(e1)) e1 = t;
                                            else for(var r in t)void 0 === e1[r] && (e1[r] = t[r]);
                                            return e1;
                                        }(t, {
                                            sampleFactor: .1,
                                            simplifyThreshold: 0
                                        }), r = g(e1, 0, 1), o = r / (r * t.sampleFactor), n = [], s = 0; s < r; s += o)n.push(g(e1, s));
                                        t.simplifyThreshold && !function(e1) {
                                            for(var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 0, r = 0, o = e1.length - 1; 3 < e1.length && 0 <= o; --o)y(m(e1, o - 1), m(e1, o), m(e1, o + 1), t) && (e1.splice(o % e1.length, 1), r++);
                                        }(n, t.simplifyThreshold);
                                        return n;
                                    }(c[d], n), h = 0; h < f.length; h++)f[h].x += s, i.push(f[h]);
                                    s += a[u].advanceWidth * this._scale(o);
                                }
                                return i;
                            }
                        },
                        {
                            key: "_getGlyphs",
                            value: function(e1) {
                                return this.font.stringToGlyphs(e1);
                            }
                        },
                        {
                            key: "_getPath",
                            value: function(e1, t, r, o) {
                                var n = (o && o.renderer && o.renderer._pInst || this.parent)._renderer, t = this._handleAlignment(n, e1, t, r);
                                return this.font.getPath(e1, t.x, t.y, n._textSize, o);
                            }
                        },
                        {
                            key: "_getPathData",
                            value: function(e1, t, r, o) {
                                var n = 3;
                                return "string" == typeof e1 && 2 < arguments.length ? e1 = this._getPath(e1, t, r, o) : "object" === p(t) && (o = t), o && "number" == typeof o.decimals && (n = o.decimals), e1.toPathData(n);
                            }
                        },
                        {
                            key: "_getSVG",
                            value: function(e1, t, r, o) {
                                var n = 3;
                                return "string" == typeof e1 && 2 < arguments.length ? e1 = this._getPath(e1, t, r, o) : "object" === p(t) && (o = t), o && ("number" == typeof o.decimals && (n = o.decimals), "number" == typeof o.strokeWidth && (e1.strokeWidth = o.strokeWidth), void 0 !== o.fill && (e1.fill = o.fill), void 0 !== o.stroke && (e1.stroke = o.stroke)), e1.toSVG(n);
                            }
                        },
                        {
                            key: "_renderPath",
                            value: function(e1, t, r, o) {
                                var n = o && o.renderer || this.parent._renderer, s = n.drawingContext, e1 = ("object" === p(e1) && e1.commands ? e1 : this._getPath(e1, t, r, o)).commands, i = (s.beginPath(), !0), t = !1, r = void 0;
                                try {
                                    for(var a, l = e1[Symbol.iterator](); !(i = (a = l.next()).done); i = !0){
                                        var u = a.value;
                                        "M" === u.type ? s.moveTo(u.x, u.y) : "L" === u.type ? s.lineTo(u.x, u.y) : "C" === u.type ? s.bezierCurveTo(u.x1, u.y1, u.x2, u.y2, u.x, u.y) : "Q" === u.type ? s.quadraticCurveTo(u.x1, u.y1, u.x, u.y) : "Z" === u.type && s.closePath();
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        i || null == l.return || l.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                                return n._doStroke && n._strokeSet && s.stroke(), n._doFill && (n._fillSet || n._setFill(v._DEFAULT_TEXT_FILL), s.fill()), this;
                            }
                        },
                        {
                            key: "_textWidth",
                            value: function(e1, t) {
                                return this.font.getAdvanceWidth(e1, t);
                            }
                        },
                        {
                            key: "_textAscent",
                            value: function(e1) {
                                return this.font.ascender * this._scale(e1);
                            }
                        },
                        {
                            key: "_textDescent",
                            value: function(e1) {
                                return -this.font.descender * this._scale(e1);
                            }
                        },
                        {
                            key: "_scale",
                            value: function(e1) {
                                return 1 / this.font.unitsPerEm * (e1 || this.parent._renderer._textSize);
                            }
                        },
                        {
                            key: "_handleAlignment",
                            value: function(e1, t, r, o, n) {
                                var s = e1._textSize;
                                switch(void 0 === n && (n = this._textWidth(t, s)), e1._textAlign){
                                    case v.CENTER:
                                        r -= n / 2;
                                        break;
                                    case v.RIGHT:
                                        r -= n;
                                }
                                switch(e1._textBaseline){
                                    case v.TOP:
                                        o += this._textAscent(s);
                                        break;
                                    case v.CENTER:
                                        o += this._textAscent(s) / 2;
                                        break;
                                    case v.BOTTOM:
                                        o -= this._textDescent(s);
                                }
                                return {
                                    x: r,
                                    y: o
                                };
                            }
                        }
                    ], s(e1.prototype, r), o && s(e1, o), t;
                }();
                e1 = n.default;
                r.default = e1;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.array.splice": 166,
                "core-js/modules/es.function.name": 167,
                "core-js/modules/es.number.to-fixed": 173,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        312: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.array-buffer.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.array-buffer.constructor"), e1("core-js/modules/es.object.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.append = function(e1, t) {
                    return e1.push(t), e1;
                }, e1.default.prototype.arrayCopy = function(e1, t, r, o, n) {
                    var s, i;
                    e1 = void 0 !== n ? (i = Math.min(n, e1.length), s = o, e1.slice(t, i + t)) : (i = void 0 !== r ? (i = r, Math.min(i, e1.length)) : e1.length, r = t, e1.slice(s = 0, i)), Array.prototype.splice.apply(r, [
                        s,
                        i
                    ].concat(e1));
                }, e1.default.prototype.concat = function(e1, t) {
                    return e1.concat(t);
                }, e1.default.prototype.reverse = function(e1) {
                    return e1.reverse();
                }, e1.default.prototype.shorten = function(e1) {
                    return e1.pop(), e1;
                }, e1.default.prototype.shuffle = function(e1, t) {
                    for(var r, o, n = ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(e1), s = (e1 = t || n ? e1 : e1.slice()).length; 1 < s;)r = this.random(0, 1) * s | 0, o = e1[--s], e1[s] = e1[r], e1[r] = o;
                    return e1;
                }, e1.default.prototype.sort = function(e1, t) {
                    var r = t ? e1.slice(0, Math.min(t, e1.length)) : e1, t = t ? e1.slice(Math.min(t, e1.length)) : [];
                    return (r = "string" == typeof r[0] ? r.sort() : r.sort(function(e1, t) {
                        return e1 - t;
                    })).concat(t);
                }, e1.default.prototype.splice = function(e1, t, r) {
                    return Array.prototype.splice.apply(e1, [
                        r,
                        0
                    ].concat(t)), e1;
                }, e1.default.prototype.subset = function(e1, t, r) {
                    return void 0 !== r ? e1.slice(t, t + r) : e1.slice(t, e1.length);
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array-buffer.constructor": 150,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.array.splice": 166,
                "core-js/modules/es.object.to-string": 180
            }
        ],
        313: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.repeat"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.number.constructor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.repeat"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var o = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                o.default.prototype.float = function(e1) {
                    return e1 instanceof Array ? e1.map(parseFloat) : parseFloat(e1);
                }, o.default.prototype.int = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 10;
                    return e1 === 1 / 0 || "Infinity" === e1 ? 1 / 0 : e1 === -1 / 0 || "-Infinity" === e1 ? -1 / 0 : "string" == typeof e1 ? parseInt(e1, t) : "number" == typeof e1 ? 0 | e1 : "boolean" == typeof e1 ? e1 ? 1 : 0 : e1 instanceof Array ? e1.map(function(e1) {
                        return o.default.prototype.int(e1, t);
                    }) : void 0;
                }, o.default.prototype.str = function(e1) {
                    return e1 instanceof Array ? e1.map(o.default.prototype.str) : String(e1);
                }, o.default.prototype.boolean = function(e1) {
                    return "number" == typeof e1 ? 0 !== e1 : "string" == typeof e1 ? "true" === e1.toLowerCase() : "boolean" == typeof e1 ? e1 : e1 instanceof Array ? e1.map(o.default.prototype.boolean) : void 0;
                }, o.default.prototype.byte = function(e1) {
                    e1 = o.default.prototype.int(e1, 10);
                    return "number" == typeof e1 ? (e1 + 128) % 256 - 128 : e1 instanceof Array ? e1.map(o.default.prototype.byte) : void 0;
                }, o.default.prototype.char = function(e1) {
                    return "number" != typeof e1 || isNaN(e1) ? e1 instanceof Array ? e1.map(o.default.prototype.char) : "string" == typeof e1 ? o.default.prototype.char(parseInt(e1, 10)) : void 0 : String.fromCharCode(e1);
                }, o.default.prototype.unchar = function(e1) {
                    return "string" == typeof e1 && 1 === e1.length ? e1.charCodeAt(0) : e1 instanceof Array ? e1.map(o.default.prototype.unchar) : void 0;
                }, o.default.prototype.hex = function(e1, t) {
                    if (t = null == t ? 8 : t, e1 instanceof Array) return e1.map(function(e1) {
                        return o.default.prototype.hex(e1, t);
                    });
                    if (e1 === 1 / 0 || e1 === -1 / 0) return (e1 === 1 / 0 ? "F" : "0").repeat(t);
                    if ("number" == typeof e1) {
                        e1 < 0 && (e1 = 4294967295 + e1 + 1);
                        for(var r = Number(e1).toString(16).toUpperCase(); r.length < t;)r = "0".concat(r);
                        return r = r.length >= t ? r.substring(r.length - t, r.length) : r;
                    }
                }, o.default.prototype.unhex = function(e1) {
                    return e1 instanceof Array ? e1.map(o.default.prototype.unhex) : parseInt("0x".concat(e1), 16);
                };
                e1 = o.default;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.number.constructor": 171,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.repeat": 193
            }
        ],
        314: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.pad-start"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.filter"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.constructor"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.pad-start"), e1("core-js/modules/es.string.replace"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (u = e1("../core/main")) && u.__esModule ? u : {
                    default: u
                };
                function i(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                function o(e1, t, r) {
                    var o = i(e1.toString().split("."), 2), n = o[0], o = o[1];
                    return void 0 === r ? (n = n.padStart(t, "0"), o ? n + "." + o : n) : (n = (e1 = i(e1.toFixed(r).toString().split("."), 2))[0], o = e1[1], (n = n.padStart(t, "0")) + "." + o);
                }
                function n(e1, t) {
                    var r = (e1 = e1.toString()).indexOf("."), o = -1 !== r ? e1.substring(r) : "", e1 = (e1 = -1 !== r ? e1.substring(0, r) : e1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    if (0 === t) o = "";
                    else if (void 0 !== t) {
                        if (t > o.length) for(var n = t - (o += -1 === r ? "." : "").length + 1, s = 0; s < n; s++)o += "0";
                        else o = o.substring(0, t + 1);
                    }
                    return e1 + o;
                }
                function a(e1) {
                    return 0 < parseFloat(e1) ? "+".concat(e1.toString()) : e1.toString();
                }
                function l(e1) {
                    return 0 <= parseFloat(e1) ? " ".concat(e1.toString()) : e1.toString();
                }
                e1("../core/friendly_errors/validate_params"), e1("../core/friendly_errors/file_errors"), e1("../core/friendly_errors/fes_core"), s.default.prototype.join = function(e1, t) {
                    return s.default._validateParameters("join", arguments), e1.join(t);
                }, s.default.prototype.match = function(e1, t) {
                    return s.default._validateParameters("match", arguments), e1.match(t);
                }, s.default.prototype.matchAll = function(e1, t) {
                    s.default._validateParameters("matchAll", arguments);
                    for(var r = new RegExp(t, "g"), o = r.exec(e1), n = []; null !== o;)n.push(o), o = r.exec(e1);
                    return n;
                }, s.default.prototype.nf = function(e1, t, r) {
                    return s.default._validateParameters("nf", arguments), e1 instanceof Array ? e1.map(function(e1) {
                        return o(e1, t, r);
                    }) : "[object Arguments]" === Object.prototype.toString.call(e1) ? 3 === e1.length ? this.nf(e1[0], e1[1], e1[2]) : 2 === e1.length ? this.nf(e1[0], e1[1]) : this.nf(e1[0]) : o(e1, t, r);
                }, s.default.prototype.nfc = function(e1, t) {
                    return s.default._validateParameters("nfc", arguments), e1 instanceof Array ? e1.map(function(e1) {
                        return n(e1, t);
                    }) : n(e1, t);
                }, s.default.prototype.nfp = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    s.default._validateParameters("nfp", t);
                    var o = s.default.prototype.nf.apply(this, t);
                    return o instanceof Array ? o.map(a) : a(o);
                }, s.default.prototype.nfs = function() {
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    s.default._validateParameters("nfs", t);
                    var o = s.default.prototype.nf.apply(this, t);
                    return o instanceof Array ? o.map(l) : l(o);
                }, s.default.prototype.split = function(e1, t) {
                    return s.default._validateParameters("split", arguments), e1.split(t);
                }, s.default.prototype.splitTokens = function(e1, t) {
                    var r, o;
                    return s.default._validateParameters("splitTokens", arguments), o = void 0 !== t ? (o = /\]/g.exec(t), (r = /\[/g.exec(t)) && o ? (t = t.slice(0, o.index) + t.slice(o.index + 1), r = /\[/g.exec(t), t = t.slice(0, r.index) + t.slice(r.index + 1), new RegExp("[\\[".concat(t, "\\]]"), "g")) : o ? (t = t.slice(0, o.index) + t.slice(o.index + 1), new RegExp("[".concat(t, "\\]]"), "g")) : r ? (t = t.slice(0, r.index) + t.slice(r.index + 1), new RegExp("[".concat(t, "\\[]"), "g")) : new RegExp("[".concat(t, "]"), "g")) : /\s/g, e1.split(o).filter(function(e1) {
                        return e1;
                    });
                }, s.default.prototype.trim = function(e1) {
                    return s.default._validateParameters("trim", arguments), e1 instanceof Array ? e1.map(this.trim) : e1.trim();
                };
                var u = s.default;
                r.default = u;
            },
            {
                "../core/friendly_errors/fes_core": 264,
                "../core/friendly_errors/file_errors": 265,
                "../core/friendly_errors/validate_params": 268,
                "../core/main": 273,
                "core-js/modules/es.array.filter": 155,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.number.to-fixed": 173,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.constructor": 184,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.match": 191,
                "core-js/modules/es.string.pad-start": 192,
                "core-js/modules/es.string.replace": 194,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.string.trim": 199,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        315: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                e1.default.prototype.day = function() {
                    return (new Date).getDate();
                }, e1.default.prototype.hour = function() {
                    return (new Date).getHours();
                }, e1.default.prototype.minute = function() {
                    return (new Date).getMinutes();
                }, e1.default.prototype.millis = function() {
                    return -1 === this._millisStart ? 0 : window.performance.now() - this._millisStart;
                }, e1.default.prototype.month = function() {
                    return (new Date).getMonth() + 1;
                }, e1.default.prototype.second = function() {
                    return (new Date).getSeconds();
                }, e1.default.prototype.year = function() {
                    return (new Date).getFullYear();
                };
                e1 = e1.default;
                r.default = e1;
            },
            {
                "../core/main": 273
            }
        ],
        316: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.number.to-fixed"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var S = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, _ = (e1("./p5.Geometry"), function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                S.default.prototype.plane = function(e1, t, r, o) {
                    this._assert3d("plane"), S.default._validateParameters("plane", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === o && (o = 1);
                    var n, s = "plane|".concat(r = void 0 === r ? 1 : r, "|").concat(o);
                    return this._renderer.geometryInHash(s) || ((n = new S.default.Geometry(r, o, function() {
                        for(var e1, t, r = 0; r <= this.detailY; r++)for(var o = r / this.detailY, n = 0; n <= this.detailX; n++)e1 = n / this.detailX, t = new S.default.Vector(e1 - .5, o - .5, 0), this.vertices.push(t), this.uvs.push(e1, o);
                    })).computeFaces().computeNormals(), r <= 1 && o <= 1 ? n._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on plane objects with more than 1 detailX or 1 detailY"), this._renderer.createBuffers(s, n)), this._renderer.drawBuffersScaled(s, e1, t, 1), this;
                }, S.default.prototype.box = function(e1, t, r, o, n) {
                    this._assert3d("box"), S.default._validateParameters("box", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === r && (r = t);
                    var s, i = this._renderer.attributes && this._renderer.attributes.perPixelLighting, i = (void 0 === n && (n = i ? 1 : 4), "box|".concat(o = void 0 === o ? i ? 1 : 4 : o, "|").concat(n));
                    return this._renderer.geometryInHash(i) || ((s = new S.default.Geometry(o, n, function() {
                        var n = this;
                        this.edges = [
                            [
                                0,
                                1
                            ],
                            [
                                1,
                                3
                            ],
                            [
                                3,
                                2
                            ],
                            [
                                6,
                                7
                            ],
                            [
                                8,
                                9
                            ],
                            [
                                9,
                                11
                            ],
                            [
                                14,
                                15
                            ],
                            [
                                16,
                                17
                            ],
                            [
                                17,
                                19
                            ],
                            [
                                18,
                                19
                            ],
                            [
                                20,
                                21
                            ],
                            [
                                22,
                                23
                            ]
                        ], [
                            [
                                0,
                                4,
                                2,
                                6
                            ],
                            [
                                1,
                                3,
                                5,
                                7
                            ],
                            [
                                0,
                                1,
                                4,
                                5
                            ],
                            [
                                2,
                                6,
                                3,
                                7
                            ],
                            [
                                0,
                                2,
                                1,
                                3
                            ],
                            [
                                4,
                                5,
                                6,
                                7
                            ]
                        ].forEach(function(e1, t) {
                            for(var t = 4 * t, r = 0; r < 4; r++){
                                var o = e1[r], o = new S.default.Vector((2 * (1 & o) - 1) / 2, ((2 & o) - 1) / 2, ((4 & o) / 2 - 1) / 2);
                                n.vertices.push(o), n.uvs.push(1 & r, (2 & r) / 2);
                            }
                            n.faces.push([
                                t,
                                1 + t,
                                2 + t
                            ]), n.faces.push([
                                2 + t,
                                1 + t,
                                3 + t
                            ]);
                        });
                    })).computeNormals(), o <= 4 && n <= 4 ? s._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on box objects with more than 4 detailX or 4 detailY"), this._renderer.createBuffers(i, s)), this._renderer.drawBuffersScaled(i, e1, t, r), this;
                }, S.default.prototype.sphere = function(e1, t, r) {
                    return this._assert3d("sphere"), S.default._validateParameters("sphere", arguments), this.ellipsoid(e1 = void 0 === e1 ? 50 : e1, e1, e1, t = void 0 === t ? 24 : t, r = void 0 === r ? 16 : r), this;
                };
                function l(e1, t, r, o, n, s, i) {
                    e1 = e1 <= 0 ? 1 : e1, t = t < 0 ? 0 : t, r = r <= 0 ? e1 : r, o = o < 3 ? 3 : o;
                    for(var a, l, u = (s = void 0 === s || s) ? -2 : 0, c = (n = n < 1 ? 1 : n) + ((i = void 0 === i ? 0 !== t : i) ? 2 : 0), d = Math.atan2(e1 - t, r), f = Math.sin(d), h = Math.cos(d), p = u; p <= c; ++p){
                        var m = p / n, y = r * m, g = void 0, g = p < 0 ? (m = y = 0, e1) : n < p ? (y = r, m = 1, t) : e1 + (t - e1) * m;
                        for(-2 !== p && p !== n + 2 || (g = 0), y -= r / 2, a = 0; a < o; ++a){
                            var v = a / (o - 1), b = 2 * Math.PI * v, j = Math.sin(b), b = Math.cos(b), _ = (this.vertices.push(new S.default.Vector(j * g, y, b * g)), void 0), _ = p < 0 ? new S.default.Vector(0, -1, 0) : n < p && t ? new S.default.Vector(0, 1, 0) : new S.default.Vector(j * h, f, b * h);
                            this.vertexNormals.push(_), this.uvs.push(v, m);
                        }
                    }
                    var x = 0;
                    if (s) {
                        for(l = 0; l < o; ++l)this.faces.push([
                            x + l,
                            x + o + (l + 1) % o,
                            x + o + l
                        ]);
                        x += 2 * o;
                    }
                    for(p = 0; p < n; ++p){
                        for(a = 0; a < o; ++a){
                            var w = (a + 1) % o;
                            this.faces.push([
                                x + a,
                                x + w,
                                x + o + w
                            ]), this.faces.push([
                                x + a,
                                x + o + w,
                                x + o + a
                            ]);
                        }
                        x += o;
                    }
                    if (i) for(x += o, a = 0; a < o; ++a)this.faces.push([
                        x + a,
                        x + (a + 1) % o,
                        x + o
                    ]);
                }
                S.default.prototype.cylinder = function(e1, t, r, o, n, s) {
                    this._assert3d("cylinder"), S.default._validateParameters("cylinder", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === o && (o = 1), void 0 === s && (s = !0), void 0 === n && (n = !0);
                    var i, a = "cylinder|".concat(r = void 0 === r ? 24 : r, "|").concat(o, "|").concat(n, "|").concat(s);
                    return this._renderer.geometryInHash(a) || (i = new S.default.Geometry(r, o), l.call(i, 1, 1, 1, r, o, n, s), r <= 24 && o <= 16 ? i._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on cylinder objects with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(a, i)), this._renderer.drawBuffersScaled(a, e1, t, e1), this;
                }, S.default.prototype.cone = function(e1, t, r, o, n) {
                    this._assert3d("cone"), S.default._validateParameters("cone", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === o && (o = 1), void 0 === n && (n = !0);
                    var s, i = "cone|".concat(r = void 0 === r ? 24 : r, "|").concat(o, "|").concat(n);
                    return this._renderer.geometryInHash(i) || (s = new S.default.Geometry(r, o), l.call(s, 1, 0, 1, r, o, n, !1), r <= 24 && o <= 16 ? s._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on cone objects with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(i, s)), this._renderer.drawBuffersScaled(i, e1, t, e1), this;
                }, S.default.prototype.ellipsoid = function(e1, t, r, o, n) {
                    this._assert3d("ellipsoid"), S.default._validateParameters("ellipsoid", arguments), void 0 === e1 && (e1 = 50), void 0 === t && (t = e1), void 0 === r && (r = e1), void 0 === n && (n = 16);
                    var s, i = "ellipsoid|".concat(o = void 0 === o ? 24 : o, "|").concat(n);
                    return this._renderer.geometryInHash(i) || ((s = new S.default.Geometry(o, n, function() {
                        for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = Math.PI * t - Math.PI / 2, o = Math.cos(r), n = Math.sin(r), s = 0; s <= this.detailX; s++){
                            var i = s / this.detailX, a = 2 * Math.PI * i, l = Math.cos(a), a = Math.sin(a), a = new S.default.Vector(o * a, n, o * l);
                            this.vertices.push(a), this.vertexNormals.push(a), this.uvs.push(i, t);
                        }
                    })).computeFaces(), o <= 24 && n <= 24 ? s._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw stroke on ellipsoids with more than 24 detailX or 24 detailY"), this._renderer.createBuffers(i, s)), this._renderer.drawBuffersScaled(i, e1, t, r), this;
                }, S.default.prototype.torus = function(e1, t, r, o) {
                    if (this._assert3d("torus"), S.default._validateParameters("torus", arguments), void 0 === e1) e1 = 50;
                    else if (!e1) return;
                    if (void 0 === t) t = 10;
                    else if (!t) return;
                    void 0 === r && (r = 24), void 0 === o && (o = 16);
                    var n, d = (t / e1).toPrecision(4), t = "torus|".concat(d, "|").concat(r, "|").concat(o);
                    return this._renderer.geometryInHash(t) || ((n = new S.default.Geometry(r, o, function() {
                        for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = 2 * Math.PI * t, o = Math.cos(r), n = Math.sin(r), s = 1 + d * o, i = 0; i <= this.detailX; i++){
                            var a = i / this.detailX, l = 2 * Math.PI * a, u = Math.cos(l), l = Math.sin(l), c = new S.default.Vector(s * u, s * l, d * n), u = new S.default.Vector(o * u, o * l, n);
                            this.vertices.push(c), this.vertexNormals.push(u), this.uvs.push(a, t);
                        }
                    })).computeFaces(), r <= 24 && o <= 16 ? n._makeTriangleEdges()._edgesToVertices() : this._renderer._doStroke && console.log("Cannot draw strokes on torus object with more than 24 detailX or 16 detailY"), this._renderer.createBuffers(t, n)), this._renderer.drawBuffersScaled(t, e1, e1, e1), this;
                }, S.default.RendererGL.prototype.point = function(e1, t, r) {
                    var o = [];
                    return o.push(new S.default.Vector(e1, t, r = void 0 === r ? 0 : r)), this._drawPoints(o, this.immediateMode.buffers.point), this;
                }, S.default.RendererGL.prototype.triangle = function(e1) {
                    var t = e1[0], r = e1[1], o = e1[2], n = e1[3], s = e1[4], e1 = e1[5], i = (this.geometryInHash("tri") || ((i = new S.default.Geometry(1, 1, function() {
                        var e1 = [];
                        e1.push(new S.default.Vector(0, 0, 0)), e1.push(new S.default.Vector(1, 0, 0)), e1.push(new S.default.Vector(0, 1, 0)), this.edges = [
                            [
                                0,
                                1
                            ],
                            [
                                1,
                                2
                            ],
                            [
                                2,
                                0
                            ]
                        ], this.vertices = e1, this.faces = [
                            [
                                0,
                                1,
                                2
                            ]
                        ], this.uvs = [
                            0,
                            0,
                            1,
                            0,
                            1,
                            1
                        ];
                    }))._edgesToVertices(), i.computeNormals(), this.createBuffers("tri", i)), this.uMVMatrix.copy());
                    try {
                        var a = Math.sign(t * n - o * r + o * e1 - s * n + s * r - t * e1), l = new S.default.Matrix([
                            o - t,
                            n - r,
                            0,
                            0,
                            s - t,
                            e1 - r,
                            0,
                            0,
                            0,
                            0,
                            a,
                            0,
                            t,
                            r,
                            0,
                            1
                        ]).mult(this.uMVMatrix);
                        this.uMVMatrix = l, this.drawBuffers("tri");
                    } finally{
                        this.uMVMatrix = i;
                    }
                    return this;
                }, S.default.RendererGL.prototype.ellipse = function(e1) {
                    this.arc(e1[0], e1[1], e1[2], e1[3], 0, _.TWO_PI, _.OPEN, e1[4]);
                }, S.default.RendererGL.prototype.arc = function(e1) {
                    var t, r = arguments[1], o = arguments[2], n = arguments[3], s = arguments[4], i = arguments[5], a = arguments[6], l = arguments[7] || 25, u = (Math.abs(i - s) >= _.TWO_PI ? "".concat(c = "ellipse", "|") : "".concat(c = "arc", "|").concat(s, "|").concat(i, "|").concat(a, "|")).concat(l, "|"), c = (this.geometryInHash(u) || ((t = new S.default.Geometry(l, 1, function() {
                        if (s.toFixed(10) !== i.toFixed(10)) {
                            a !== _.PIE && void 0 !== a || (this.vertices.push(new S.default.Vector(.5, .5, 0)), this.uvs.push([
                                .5,
                                .5
                            ]));
                            for(var e1 = 0; e1 <= l; e1++){
                                var t = (i - s) * (e1 / l) + s, r = .5 + Math.cos(t) / 2, t = .5 + Math.sin(t) / 2;
                                this.vertices.push(new S.default.Vector(r, t, 0)), this.uvs.push([
                                    r,
                                    t
                                ]), e1 < l - 1 && (this.faces.push([
                                    0,
                                    e1 + 1,
                                    e1 + 2
                                ]), this.edges.push([
                                    e1 + 1,
                                    e1 + 2
                                ]));
                            }
                            switch(a){
                                case _.PIE:
                                    this.faces.push([
                                        0,
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        0,
                                        1
                                    ]), this.edges.push([
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        0,
                                        this.vertices.length - 1
                                    ]);
                                    break;
                                case _.CHORD:
                                    this.edges.push([
                                        0,
                                        1
                                    ]), this.edges.push([
                                        0,
                                        this.vertices.length - 1
                                    ]);
                                    break;
                                case _.OPEN:
                                    this.edges.push([
                                        0,
                                        1
                                    ]);
                                    break;
                                default:
                                    this.faces.push([
                                        0,
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]), this.edges.push([
                                        this.vertices.length - 2,
                                        this.vertices.length - 1
                                    ]);
                            }
                        }
                    })).computeNormals(), l <= 50 ? t._edgesToVertices(t) : this._doStroke && console.log("Cannot apply a stroke to an ".concat(c, " with more than 50 detail")), this.createBuffers(u, t)), this.uMVMatrix.copy());
                    try {
                        this.uMVMatrix.translate([
                            e1,
                            r,
                            0
                        ]), this.uMVMatrix.scale(o, n, 1), this.drawBuffers(u);
                    } finally{
                        this.uMVMatrix = c;
                    }
                    return this;
                }, S.default.RendererGL.prototype.rect = function(e1) {
                    var t = e1[0], r = e1[1], o = e1[2], n = e1[3];
                    if (void 0 === e1[4]) {
                        var s = this._pInst._glAttributes.perPixelLighting, i = e1[4] || (s ? 1 : 24), a = e1[5] || (s ? 1 : 16), s = "rect|".concat(i, "|").concat(a), l = (this.geometryInHash(s) || ((l = new S.default.Geometry(i, a, function() {
                            for(var e1 = 0; e1 <= this.detailY; e1++)for(var t = e1 / this.detailY, r = 0; r <= this.detailX; r++){
                                var o = r / this.detailX, n = new S.default.Vector(o, t, 0);
                                this.vertices.push(n), this.uvs.push(o, t);
                            }
                            0 < i && 0 < a && (this.edges = [
                                [
                                    0,
                                    i
                                ],
                                [
                                    i,
                                    (i + 1) * (a + 1) - 1
                                ],
                                [
                                    (i + 1) * (a + 1) - 1,
                                    (i + 1) * a
                                ],
                                [
                                    (i + 1) * a,
                                    0
                                ]
                            ]);
                        })).computeFaces().computeNormals()._edgesToVertices(), this.createBuffers(s, l)), this.uMVMatrix.copy());
                        try {
                            this.uMVMatrix.translate([
                                t,
                                r,
                                0
                            ]), this.uMVMatrix.scale(o, n, 1), this.drawBuffers(s);
                        } finally{
                            this.uMVMatrix = l;
                        }
                    } else {
                        var s = e1[4], l = void 0 === e1[5] ? s : e1[5], u = void 0 === e1[6] ? l : e1[6], e1 = void 0 === e1[7] ? u : e1[7], c = o, d = n, f = ((c += t) < t && (f = t, t = c, c = f), (d += r) < r && (f = r, r = d, d = f), Math.min((c - t) / 2, (d - r) / 2)), h = (f < s && (s = f), f < l && (l = f), f < u && (u = f), f < e1 && (e1 = f), t), p = r, f = c, t = d, m = (this.beginShape(), 0 !== l ? (this.vertex(f - l, p), this.quadraticVertex(f, p, f, p + l)) : this.vertex(f, p), 0 !== u ? (this.vertex(f, t - u), this.quadraticVertex(f, t, f - u, t)) : this.vertex(f, t), 0 !== e1 ? (this.vertex(h + e1, t), this.quadraticVertex(h, t, h, t - e1)) : this.vertex(h, t), 0 !== s ? (this.vertex(h, p + s), this.quadraticVertex(h, p, h + s, p)) : this.vertex(h, p), this.immediateMode.geometry.uvs.length = 0, true), r = !1, c = void 0;
                        try {
                            for(var y, g = this.immediateMode.geometry.vertices[Symbol.iterator](); !(m = (y = g.next()).done); m = !0){
                                var v = y.value, b = (v.x - h) / o, j = (v.y - p) / n;
                                this.immediateMode.geometry.uvs.push(b, j);
                            }
                        } catch (e1) {
                            r = !0, c = e1;
                        } finally{
                            try {
                                m || null == g.return || g.return();
                            } finally{
                                if (r) throw c;
                            }
                        }
                        this.endShape(_.CLOSE);
                    }
                    return this;
                }, S.default.RendererGL.prototype.quad = function(i, a, l, u, c, d, f, h, p, m, y, g, e1, t) {
                    void 0 === e1 && (e1 = 2), void 0 === t && (t = 2);
                    var r = "quad|".concat(i, "|").concat(a, "|").concat(l, "|").concat(u, "|").concat(c, "|").concat(d, "|").concat(f, "|").concat(h, "|").concat(p, "|").concat(m, "|").concat(y, "|").concat(g, "|").concat(e1, "|").concat(t);
                    if (!this.geometryInHash(r)) {
                        var o = new S.default.Geometry(e1, t, function() {
                            for(var e1 = 1 / (this.detailX - 1), t = 1 / (this.detailY - 1), r = 0; r < this.detailY; r++)for(var o = 0; o < this.detailX; o++){
                                var n = o * e1, s = r * t;
                                this.vertices.push(new S.default.Vector((1 - n) * ((1 - s) * i + s * m) + n * ((1 - s) * u + s * f), (1 - n) * ((1 - s) * a + s * y) + n * ((1 - s) * c + s * h), (1 - n) * ((1 - s) * l + s * g) + n * ((1 - s) * d + s * p))), this.uvs.push([
                                    n,
                                    s
                                ]);
                            }
                        });
                        o.faces = [];
                        for(var n = 0; n < t - 1; n++)for(var s = 0; s < e1 - 1; s++){
                            var v = s + n * e1, b = s + 1 + (n + 1) * e1, j = s + (n + 1) * e1;
                            o.faces.push([
                                v,
                                s + 1 + n * e1,
                                b
                            ]), o.faces.push([
                                v,
                                b,
                                j
                            ]);
                        }
                        o.computeNormals()._makeTriangleEdges()._edgesToVertices(), this.createBuffers(r, o);
                    }
                    return this.drawBuffers(r), this;
                }, S.default.RendererGL.prototype.bezier = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    8 === arguments.length && (c = a, u = i, a = s, i = n, n = o, o = r, r = s = l = d = 0);
                    var f = this._pInst._bezierDetail || 20;
                    this.beginShape();
                    for(var h = 0; h <= f; h++){
                        var p = Math.pow(1 - h / f, 3), m = h / f * 3 * Math.pow(1 - h / f, 2), y = 3 * Math.pow(h / f, 2) * (1 - h / f), g = Math.pow(h / f, 3);
                        this.vertex(e1 * p + o * m + i * y + u * g, t * p + n * m + a * y + c * g, r * p + s * m + l * y + d * g);
                    }
                    return this.endShape(), this;
                }, S.default.RendererGL.prototype.curve = function(e1, t, r, o, n, s, i, a, l, u, c, d) {
                    8 === arguments.length && (u = i, c = a, i = n, a = o, n = o = r, r = s = l = d = 0);
                    var f = this._pInst._curveDetail;
                    this.beginShape();
                    for(var h = 0; h <= f; h++){
                        var p = .5 * Math.pow(h / f, 3), m = .5 * Math.pow(h / f, 2), y = h / f * .5;
                        this.vertex(p * (3 * o - e1 - 3 * i + u) + m * (2 * e1 - 5 * o + 4 * i - u) + y * (-e1 + i) + 2 * o * .5, p * (3 * n - t - 3 * a + c) + m * (2 * t - 5 * n + 4 * a - c) + y * (-t + a) + 2 * n * .5, p * (3 * s - r - 3 * l + d) + m * (2 * r - 5 * s + 4 * l - d) + y * (-r + l) + 2 * s * .5);
                    }
                    return this.endShape(), this;
                }, S.default.RendererGL.prototype.line = function() {
                    return 6 === arguments.length ? (this.beginShape(_.LINES), this.vertex(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], arguments.length <= 2 ? void 0 : arguments[2]), this.vertex(arguments.length <= 3 ? void 0 : arguments[3], arguments.length <= 4 ? void 0 : arguments[4], arguments.length <= 5 ? void 0 : arguments[5]), this.endShape()) : 4 === arguments.length && (this.beginShape(_.LINES), this.vertex(arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1], 0), this.vertex(arguments.length <= 2 ? void 0 : arguments[2], arguments.length <= 3 ? void 0 : arguments[3], 0), this.endShape()), this;
                }, S.default.RendererGL.prototype.bezierVertex = function() {
                    if (0 === this.immediateMode._bezierVertex.length) throw Error("vertex() must be used once before calling bezierVertex()");
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableBezier.length || this._lutBezierDetail !== this._pInst._curveDetail) {
                        this._lookUpTableBezier = [], this._lutBezierDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutBezierDetail, c = 0, d = 1, f = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableBezier[f] = this._bezierCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++f, this._lookUpTableBezier[f] = this._bezierCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++f;
                        }
                    }
                    for(var h = this._lookUpTableBezier.length, p = [], m = 0; m < 4; m++)p.push([]);
                    p[0] = this.immediateMode.geometry.vertexColors.slice(-4), p[3] = this.curFillColor.slice();
                    var y = [];
                    for(m = 0; m < 4; m++)y.push([]);
                    if (y[0] = this.immediateMode.geometry.vertexStrokeColors.slice(-4), y[3] = this.curStrokeColor.slice(), 6 === l) {
                        this.isBezier = !0;
                        var i = [
                            this.immediateMode._bezierVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 4 ? void 0 : arguments[4]
                        ], a = [
                            this.immediateMode._bezierVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 3 ? void 0 : arguments[3],
                            arguments.length <= 5 ? void 0 : arguments[5]
                        ], g = Math.hypot(i[0] - i[1], a[0] - a[1]), v = Math.hypot(i[1] - i[2], a[1] - a[2]), b = Math.hypot(i[2] - i[3], a[2] - a[3]), v = g + v + b;
                        for(g /= v, b /= v, n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - g) + p[3][n] * g), p[2].push(p[0][n] * b + p[3][n] * (1 - b)), y[1].push(y[0][n] * (1 - g) + y[3][n] * g), y[2].push(y[0][n] * b + y[3][n] * (1 - b));
                        for(o = 0; o < h; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = 0; m < 4; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableBezier[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableBezier[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableBezier[o][m], t += a[m] * this._lookUpTableBezier[o][m];
                            }
                            this.vertex(e1, t);
                        }
                        this.curFillColor = p[3], this.curStrokeColor = y[3], this.immediateMode._bezierVertex[0] = arguments.length <= 4 ? void 0 : arguments[4], this.immediateMode._bezierVertex[1] = arguments.length <= 5 ? void 0 : arguments[5];
                    } else if (9 === l) {
                        this.isBezier = !0, i = [
                            this.immediateMode._bezierVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 3 ? void 0 : arguments[3],
                            arguments.length <= 6 ? void 0 : arguments[6]
                        ], a = [
                            this.immediateMode._bezierVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 4 ? void 0 : arguments[4],
                            arguments.length <= 7 ? void 0 : arguments[7]
                        ];
                        var j = [
                            this.immediateMode._bezierVertex[2],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 5 ? void 0 : arguments[5],
                            arguments.length <= 8 ? void 0 : arguments[8]
                        ], _ = Math.hypot(i[0] - i[1], a[0] - a[1], j[0] - j[1]), v = Math.hypot(i[1] - i[2], a[1] - a[2], j[1] - j[2]), x = Math.hypot(i[2] - i[3], a[2] - a[3], j[2] - j[3]), l = _ + v + x;
                        for(_ /= l, x /= l, n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - _) + p[3][n] * _), p[2].push(p[0][n] * x + p[3][n] * (1 - x)), y[1].push(y[0][n] * (1 - _) + y[3][n] * _), y[2].push(y[0][n] * x + y[3][n] * (1 - x));
                        for(o = 0; o < h; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = r = 0; m < 4; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableBezier[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableBezier[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableBezier[o][m], t += a[m] * this._lookUpTableBezier[o][m], r += j[m] * this._lookUpTableBezier[o][m];
                            }
                            this.vertex(e1, t, r);
                        }
                        this.curFillColor = p[3], this.curStrokeColor = y[3], this.immediateMode._bezierVertex[0] = arguments.length <= 6 ? void 0 : arguments[6], this.immediateMode._bezierVertex[1] = arguments.length <= 7 ? void 0 : arguments[7], this.immediateMode._bezierVertex[2] = arguments.length <= 8 ? void 0 : arguments[8];
                    }
                }, S.default.RendererGL.prototype.quadraticVertex = function() {
                    if (0 === this.immediateMode._quadraticVertex.length) throw Error("vertex() must be used once before calling quadraticVertex()");
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableQuadratic.length || this._lutQuadraticDetail !== this._pInst._curveDetail) {
                        this._lookUpTableQuadratic = [], this._lutQuadraticDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutQuadraticDetail, c = 0, d = 1, f = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableQuadratic[f] = this._quadraticCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++f, this._lookUpTableQuadratic[f] = this._quadraticCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++f;
                        }
                    }
                    for(var h = this._lookUpTableQuadratic.length, p = [], m = 0; m < 3; m++)p.push([]);
                    p[0] = this.immediateMode.geometry.vertexColors.slice(-4), p[2] = this.curFillColor.slice();
                    var y = [];
                    for(m = 0; m < 3; m++)y.push([]);
                    if (y[0] = this.immediateMode.geometry.vertexStrokeColors.slice(-4), y[2] = this.curStrokeColor.slice(), 4 === l) {
                        this.isQuadratic = !0;
                        var i = [
                            this.immediateMode._quadraticVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 2 ? void 0 : arguments[2]
                        ], a = [
                            this.immediateMode._quadraticVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 3 ? void 0 : arguments[3]
                        ], g = Math.hypot(i[0] - i[1], a[0] - a[1]);
                        for(g /= g + Math.hypot(i[1] - i[2], a[1] - a[2]), n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - g) + p[2][n] * g), y[1].push(y[0][n] * (1 - g) + y[2][n] * g);
                        for(o = 0; o < h; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = 0; m < 3; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableQuadratic[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableQuadratic[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableQuadratic[o][m], t += a[m] * this._lookUpTableQuadratic[o][m];
                            }
                            this.vertex(e1, t);
                        }
                        this.curFillColor = p[2], this.curStrokeColor = y[2], this.immediateMode._quadraticVertex[0] = arguments.length <= 2 ? void 0 : arguments[2], this.immediateMode._quadraticVertex[1] = arguments.length <= 3 ? void 0 : arguments[3];
                    } else if (6 === l) {
                        this.isQuadratic = !0, i = [
                            this.immediateMode._quadraticVertex[0],
                            arguments.length <= 0 ? void 0 : arguments[0],
                            arguments.length <= 3 ? void 0 : arguments[3]
                        ], a = [
                            this.immediateMode._quadraticVertex[1],
                            arguments.length <= 1 ? void 0 : arguments[1],
                            arguments.length <= 4 ? void 0 : arguments[4]
                        ];
                        var v = [
                            this.immediateMode._quadraticVertex[2],
                            arguments.length <= 2 ? void 0 : arguments[2],
                            arguments.length <= 5 ? void 0 : arguments[5]
                        ], b = Math.hypot(i[0] - i[1], a[0] - a[1], v[0] - v[1]);
                        for(b /= b + Math.hypot(i[1] - i[2], a[1] - a[2], v[1] - v[2]), n = 0; n < 4; n++)p[1].push(p[0][n] * (1 - b) + p[2][n] * b), y[1].push(y[0][n] * (1 - b) + y[2][n] * b);
                        for(o = 0; o < h; o++){
                            for(this.curFillColor = [
                                0,
                                0,
                                0,
                                0
                            ], this.curStrokeColor = [
                                0,
                                0,
                                0,
                                0
                            ], m = e1 = t = r = 0; m < 3; m++){
                                for(n = 0; n < 4; n++)this.curFillColor[n] += this._lookUpTableQuadratic[o][m] * p[m][n], this.curStrokeColor[n] += this._lookUpTableQuadratic[o][m] * y[m][n];
                                e1 += i[m] * this._lookUpTableQuadratic[o][m], t += a[m] * this._lookUpTableQuadratic[o][m], r += v[m] * this._lookUpTableQuadratic[o][m];
                            }
                            this.vertex(e1, t, r);
                        }
                        this.curFillColor = p[2], this.curStrokeColor = y[2], this.immediateMode._quadraticVertex[0] = arguments.length <= 3 ? void 0 : arguments[3], this.immediateMode._quadraticVertex[1] = arguments.length <= 4 ? void 0 : arguments[4], this.immediateMode._quadraticVertex[2] = arguments.length <= 5 ? void 0 : arguments[5];
                    }
                }, S.default.RendererGL.prototype.curveVertex = function() {
                    var e1, t, r, o, n, s, i = [], a = [], l = arguments.length;
                    if (0 === this._lookUpTableBezier.length || this._lutBezierDetail !== this._pInst._curveDetail) {
                        this._lookUpTableBezier = [], this._lutBezierDetail = this._pInst._curveDetail;
                        for(var u = 1 / this._lutBezierDetail, c = 0, d = 1, f = 0; c < 1;){
                            if (s = parseFloat(c.toFixed(6)), this._lookUpTableBezier[f] = this._bezierCoefficients(s), d.toFixed(6) === u.toFixed(6)) {
                                s = parseFloat(d.toFixed(6)) + parseFloat(c.toFixed(6)), ++f, this._lookUpTableBezier[f] = this._bezierCoefficients(s);
                                break;
                            }
                            c += u, d -= u, ++f;
                        }
                    }
                    var h = this._lookUpTableBezier.length;
                    if (2 === l) {
                        if (this.immediateMode._curveVertex.push(arguments.length <= 0 ? void 0 : arguments[0]), this.immediateMode._curveVertex.push(arguments.length <= 1 ? void 0 : arguments[1]), 8 === this.immediateMode._curveVertex.length) {
                            for(this.isCurve = !0, i = this._bezierToCatmull([
                                this.immediateMode._curveVertex[0],
                                this.immediateMode._curveVertex[2],
                                this.immediateMode._curveVertex[4],
                                this.immediateMode._curveVertex[6]
                            ]), a = this._bezierToCatmull([
                                this.immediateMode._curveVertex[1],
                                this.immediateMode._curveVertex[3],
                                this.immediateMode._curveVertex[5],
                                this.immediateMode._curveVertex[7]
                            ]), n = 0; n < h; n++)t = i[0] * this._lookUpTableBezier[n][0] + i[1] * this._lookUpTableBezier[n][1] + i[2] * this._lookUpTableBezier[n][2] + i[3] * this._lookUpTableBezier[n][3], r = a[0] * this._lookUpTableBezier[n][0] + a[1] * this._lookUpTableBezier[n][1] + a[2] * this._lookUpTableBezier[n][2] + a[3] * this._lookUpTableBezier[n][3], this.vertex(t, r);
                            for(n = 0; n < l; n++)this.immediateMode._curveVertex.shift();
                        }
                    } else if (3 === l && (this.immediateMode._curveVertex.push(arguments.length <= 0 ? void 0 : arguments[0]), this.immediateMode._curveVertex.push(arguments.length <= 1 ? void 0 : arguments[1]), this.immediateMode._curveVertex.push(arguments.length <= 2 ? void 0 : arguments[2]), 12 === this.immediateMode._curveVertex.length)) {
                        for(this.isCurve = !0, i = this._bezierToCatmull([
                            this.immediateMode._curveVertex[0],
                            this.immediateMode._curveVertex[3],
                            this.immediateMode._curveVertex[6],
                            this.immediateMode._curveVertex[9]
                        ]), a = this._bezierToCatmull([
                            this.immediateMode._curveVertex[1],
                            this.immediateMode._curveVertex[4],
                            this.immediateMode._curveVertex[7],
                            this.immediateMode._curveVertex[10]
                        ]), e1 = this._bezierToCatmull([
                            this.immediateMode._curveVertex[2],
                            this.immediateMode._curveVertex[5],
                            this.immediateMode._curveVertex[8],
                            this.immediateMode._curveVertex[11]
                        ]), n = 0; n < h; n++)t = i[0] * this._lookUpTableBezier[n][0] + i[1] * this._lookUpTableBezier[n][1] + i[2] * this._lookUpTableBezier[n][2] + i[3] * this._lookUpTableBezier[n][3], r = a[0] * this._lookUpTableBezier[n][0] + a[1] * this._lookUpTableBezier[n][1] + a[2] * this._lookUpTableBezier[n][2] + a[3] * this._lookUpTableBezier[n][3], o = e1[0] * this._lookUpTableBezier[n][0] + e1[1] * this._lookUpTableBezier[n][1] + e1[2] * this._lookUpTableBezier[n][2] + e1[3] * this._lookUpTableBezier[n][3], this.vertex(t, r, o);
                        for(n = 0; n < l; n++)this.immediateMode._curveVertex.shift();
                    }
                }, S.default.RendererGL.prototype.image = function(e1, t, r, o, n, s, i, a, l) {
                    this._isErasing && this.blendMode(this._cachedBlendMode), this._pInst.push(), this._pInst.noLights(), this._pInst.noStroke(), this._pInst.texture(e1), this._pInst.textureMode(_.NORMAL);
                    var u = 0, c = (t <= e1.width && (u = t / e1.width), 1), t = (t + o <= e1.width && (c = (t + o) / e1.width), 0), o = (r <= e1.height && (t = r / e1.height), 1);
                    r + n <= e1.height && (o = (r + n) / e1.height), this.beginShape(), this.vertex(s, i, 0, u, t), this.vertex(s + a, i, 0, c, t), this.vertex(s + a, i + l, 0, c, o), this.vertex(s, i + l, 0, u, o), this.endShape(_.CLOSE), this._pInst.pop(), this._isErasing && this.blendMode(_.REMOVE);
                };
                var n = S.default;
                r.default = n;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "./p5.Geometry": 323,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.math.hypot": 169,
                "core-js/modules/es.math.sign": 170,
                "core-js/modules/es.number.to-fixed": 173,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        317: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.math.sign"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var g = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== v(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = i();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function i() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, i = function() {
                        return e1;
                    }, e1);
                }
                function v(e1) {
                    return (v = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                g.default.prototype.orbitControl = function(e1, t, r, o) {
                    var n = this, s = (this._assert3d("orbitControl"), g.default._validateParameters("orbitControl", arguments), this._renderer._curCamera);
                    void 0 === e1 && (e1 = 1), void 0 === t && (t = e1), void 0 === r && (r = 1), "object" !== v(o) && (o = {}), !0 !== this.contextMenuDisabled && (this.canvas.oncontextmenu = function() {
                        return !1;
                    }, this._setProperty("contextMenuDisabled", !0)), !0 !== this.wheelDefaultDisabled && (this.canvas.onwheel = function() {
                        return !1;
                    }, this._setProperty("wheelDefaultDisabled", !0));
                    var i = o.disableTouchActions;
                    !0 === this.touchActionsDisabled || void 0 !== i && !i || (this.canvas.style["touch-action"] = "none", this._setProperty("touchActionsDisabled", !0));
                    var a, l, u, i = o.freeRotation, o = void 0 !== i && i, c = [], i = (this.touches.forEach(function(t) {
                        n._renderer.prevTouches.forEach(function(e1) {
                            t.id === e1.id && (e1 = {
                                x: t.x,
                                y: t.y,
                                px: e1.x,
                                py: e1.y
                            }, c.push(e1));
                        });
                    }), this._renderer.prevTouches = this.touches, 0), d = 0, f = 0, h = 0, p = 0, m = this.height < this.width ? this.height : this.width, y = !1;
                    return 0 < c.length ? (y = 0 < c[0].x && c[0].x < this.width && 0 < c[0].y && c[0].y < this.height, 1 === c.length ? (d = -e1 * ((a = c[0]).x - a.px) / m, f = t * (a.y - a.py) / m) : (a = c[0], l = c[1], i = -(Math.hypot(a.x - l.x, a.y - l.y) - Math.hypot(a.px - l.px, a.py - l.py)) * r * 4e-4, h = .5 * (a.x + l.x) - .5 * (a.px + l.px), p = .5 * (a.y + l.y) - .5 * (a.py + l.py)), 0 < this.touches.length ? y && (this._renderer.executeRotateAndMove = !0, this._renderer.executeZoom = !0) : (this._renderer.executeRotateAndMove = !1, this._renderer.executeZoom = !1)) : (y = 0 < this.mouseX && this.mouseX < this.width && 0 < this.mouseY && this.mouseY < this.height, 0 !== this._mouseWheelDeltaY ? (i = Math.sign(this._mouseWheelDeltaY) * r, i *= .01, this._mouseWheelDeltaY = 0, y && (this._renderer.executeZoom = !0)) : this._renderer.zoomFlag = !1, this.mouseIsPressed ? (this.mouseButton === this.LEFT ? (d = -e1 * this.movedX / m, f = t * this.movedY / m) : this.mouseButton === this.RIGHT && (h = this.movedX, p = this.movedY), y && (this._renderer.executeRotateAndMove = !0)) : this._renderer.executeRotateAndMove = !1), 0 !== i && this._renderer.executeZoom && (this._renderer.zoomVelocity += i), .001 < Math.abs(this._renderer.zoomVelocity) ? (o ? s._orbitFree(0, 0, this._renderer.zoomVelocity) : s._orbit(0, 0, this._renderer.zoomVelocity), 0 !== s.projMatrix.mat4[15] && (s.projMatrix.mat4[0] *= Math.pow(10, -this._renderer.zoomVelocity), s.projMatrix.mat4[5] *= Math.pow(10, -this._renderer.zoomVelocity), this._renderer.uPMatrix.mat4[0] = s.projMatrix.mat4[0], this._renderer.uPMatrix.mat4[5] = s.projMatrix.mat4[5]), this._renderer.zoomVelocity *= .85) : this._renderer.zoomVelocity = 0, 0 === d && 0 === f || !this._renderer.executeRotateAndMove || this._renderer.rotateVelocity.add(.6 * d, .6 * f), 1e-6 < this._renderer.rotateVelocity.magSq() ? (o ? s._orbitFree(-this._renderer.rotateVelocity.x, this._renderer.rotateVelocity.y, 0) : s._orbit(this._renderer.rotateVelocity.x, this._renderer.rotateVelocity.y, 0), this._renderer.rotateVelocity.mult(.85)) : this._renderer.rotateVelocity.set(0, 0), 0 === h && 0 === p || !this._renderer.executeRotateAndMove || (a = 2 * h / this.width, l = 2 * -p / this.height, this._renderer.moveVelocity.add(.15 * a, .15 * l)), 1e-6 < this._renderer.moveVelocity.magSq() ? (r = s._getLocalAxes(), e1 = s.eyeX - s.centerX, t = s.eyeY - s.centerY, m = s.eyeZ - s.centerZ, y = Math.sqrt(e1 * e1 + t * t + m * m), i = new g.default.Vector(s.centerX, s.centerY, s.centerZ), i = s.cameraMatrix.multiplyPoint(i), (i = this._renderer.uPMatrix.multiplyAndNormalizePoint(i)).x -= this._renderer.moveVelocity.x, i.y -= this._renderer.moveVelocity.y, f = 0 === (d = this._renderer.uPMatrix.mat4)[15] ? (u = (d[8] + i.x) / d[0] * y, (d[9] + i.y) / d[5] * y) : (u = (i.x - d[12]) / d[0], (i.y - d[13]) / d[5]), s.setPosition(s.eyeX + u * r.x[0] + f * r.y[0], s.eyeY + u * r.x[1] + f * r.y[1], s.eyeZ + u * r.x[2] + f * r.y[2]), this._renderer.moveVelocity.mult(.85)) : this._renderer.moveVelocity.set(0, 0), this;
                }, g.default.prototype.debugMode = function() {
                    this._assert3d("debugMode");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    g.default._validateParameters("debugMode", t);
                    for(var o = this._registeredMethods.post.length - 1; 0 <= o; o--)this._registeredMethods.post[o].toString() !== this._grid().toString() && this._registeredMethods.post[o].toString() !== this._axesIcon().toString() || this._registeredMethods.post.splice(o, 1);
                    t[0] === n.GRID ? this.registerMethod("post", this._grid.call(this, t[1], t[2], t[3], t[4], t[5])) : t[0] === n.AXES ? this.registerMethod("post", this._axesIcon.call(this, t[1], t[2], t[3], t[4])) : (this.registerMethod("post", this._grid.call(this, t[0], t[1], t[2], t[3], t[4])), this.registerMethod("post", this._axesIcon.call(this, t[5], t[6], t[7], t[8])));
                }, g.default.prototype.noDebugMode = function() {
                    this._assert3d("noDebugMode");
                    for(var e1 = this._registeredMethods.post.length - 1; 0 <= e1; e1--)this._registeredMethods.post[e1].toString() !== this._grid().toString() && this._registeredMethods.post[e1].toString() !== this._axesIcon().toString() || this._registeredMethods.post.splice(e1, 1);
                }, g.default.prototype._grid = function(e1, r, o, n, s) {
                    void 0 === e1 && (e1 = this.width / 2), void 0 === r && (r = Math.round(e1 / 30) < 4 ? 4 : Math.round(e1 / 30)), void 0 === o && (o = 0), void 0 === n && (n = 0), void 0 === s && (s = 0);
                    var i = e1 / r, a = e1 / 2;
                    return function() {
                        this.push(), this.stroke(255 * this._renderer.curStrokeColor[0], 255 * this._renderer.curStrokeColor[1], 255 * this._renderer.curStrokeColor[2]), this._renderer.uMVMatrix.set(this._renderer._curCamera.cameraMatrix.mat4[0], this._renderer._curCamera.cameraMatrix.mat4[1], this._renderer._curCamera.cameraMatrix.mat4[2], this._renderer._curCamera.cameraMatrix.mat4[3], this._renderer._curCamera.cameraMatrix.mat4[4], this._renderer._curCamera.cameraMatrix.mat4[5], this._renderer._curCamera.cameraMatrix.mat4[6], this._renderer._curCamera.cameraMatrix.mat4[7], this._renderer._curCamera.cameraMatrix.mat4[8], this._renderer._curCamera.cameraMatrix.mat4[9], this._renderer._curCamera.cameraMatrix.mat4[10], this._renderer._curCamera.cameraMatrix.mat4[11], this._renderer._curCamera.cameraMatrix.mat4[12], this._renderer._curCamera.cameraMatrix.mat4[13], this._renderer._curCamera.cameraMatrix.mat4[14], this._renderer._curCamera.cameraMatrix.mat4[15]);
                        for(var e1 = 0; e1 <= r; e1++)this.beginShape(this.LINES), this.vertex(-a + o, n, e1 * i - a + s), this.vertex(a + o, n, e1 * i - a + s), this.endShape();
                        for(var t = 0; t <= r; t++)this.beginShape(this.LINES), this.vertex(t * i - a + o, n, -a + s), this.vertex(t * i - a + o, n, a + s), this.endShape();
                        this.pop();
                    };
                }, g.default.prototype._axesIcon = function(e1, t, r, o) {
                    return void 0 === e1 && (e1 = 40 < this.width / 20 ? this.width / 20 : 40), void 0 === t && (t = -this.width / 4), void 0 === r && (r = t), void 0 === o && (o = t), function() {
                        this.push(), this._renderer.uMVMatrix.set(this._renderer._curCamera.cameraMatrix.mat4[0], this._renderer._curCamera.cameraMatrix.mat4[1], this._renderer._curCamera.cameraMatrix.mat4[2], this._renderer._curCamera.cameraMatrix.mat4[3], this._renderer._curCamera.cameraMatrix.mat4[4], this._renderer._curCamera.cameraMatrix.mat4[5], this._renderer._curCamera.cameraMatrix.mat4[6], this._renderer._curCamera.cameraMatrix.mat4[7], this._renderer._curCamera.cameraMatrix.mat4[8], this._renderer._curCamera.cameraMatrix.mat4[9], this._renderer._curCamera.cameraMatrix.mat4[10], this._renderer._curCamera.cameraMatrix.mat4[11], this._renderer._curCamera.cameraMatrix.mat4[12], this._renderer._curCamera.cameraMatrix.mat4[13], this._renderer._curCamera.cameraMatrix.mat4[14], this._renderer._curCamera.cameraMatrix.mat4[15]), this.strokeWeight(2), this.stroke(255, 0, 0), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t + e1, r, o), this.endShape(), this.stroke(0, 255, 0), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t, r + e1, o), this.endShape(), this.stroke(0, 0, 255), this.beginShape(this.LINES), this.vertex(t, r, o), this.vertex(t, r, o + e1), this.endShape(), this.pop();
                    };
                };
                var s = g.default;
                r.default = s;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.splice": 166,
                "core-js/modules/es.math.hypot": 169,
                "core-js/modules/es.math.sign": 170,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.for-each": 235,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        318: [
            function(e1, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var m = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                m.default.prototype.ambientLight = function(e1, t, r, o) {
                    this._assert3d("ambientLight"), m.default._validateParameters("ambientLight", arguments);
                    var n = this.color.apply(this, arguments);
                    return this._renderer.ambientLightColors.push(n._array[0], n._array[1], n._array[2]), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.specularColor = function(e1, t, r) {
                    this._assert3d("specularColor"), m.default._validateParameters("specularColor", arguments);
                    var o = this.color.apply(this, arguments);
                    return this._renderer.specularColors = [
                        o._array[0],
                        o._array[1],
                        o._array[2]
                    ], this;
                }, m.default.prototype.directionalLight = function(e1, t, r, o, n, s) {
                    this._assert3d("directionalLight"), m.default._validateParameters("directionalLight", arguments), e1 = e1 instanceof m.default.Color ? e1 : this.color(e1, t, r);
                    var i, a, t = arguments[arguments.length - 1], r = "number" == typeof t ? (i = arguments[arguments.length - 3], a = arguments[arguments.length - 2], arguments[arguments.length - 1]) : (i = t.x, a = t.y, t.z), t = Math.sqrt(i * i + a * a + r * r);
                    return this._renderer.directionalLightDirections.push(i / t, a / t, r / t), this._renderer.directionalLightDiffuseColors.push(e1._array[0], e1._array[1], e1._array[2]), Array.prototype.push.apply(this._renderer.directionalLightSpecularColors, this._renderer.specularColors), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.pointLight = function(e1, t, r, o, n, s) {
                    this._assert3d("pointLight"), m.default._validateParameters("pointLight", arguments), e1 = e1 instanceof m.default.Color ? e1 : this.color(e1, t, r);
                    var i, a, t = arguments[arguments.length - 1], r = "number" == typeof t ? (i = arguments[arguments.length - 3], a = arguments[arguments.length - 2], arguments[arguments.length - 1]) : (i = t.x, a = t.y, t.z);
                    return this._renderer.pointLightPositions.push(i, a, r), this._renderer.pointLightDiffuseColors.push(e1._array[0], e1._array[1], e1._array[2]), Array.prototype.push.apply(this._renderer.pointLightSpecularColors, this._renderer.specularColors), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.lights = function() {
                    this._assert3d("lights");
                    var e1 = this.color("rgb(128,128,128)");
                    return this.ambientLight(e1), this.directionalLight(e1, 0, 0, -1), this;
                }, m.default.prototype.lightFalloff = function(e1, t, r) {
                    return this._assert3d("lightFalloff"), m.default._validateParameters("lightFalloff", arguments), e1 < 0 && (e1 = 0, console.warn("Value of constant argument in lightFalloff() should be never be negative. Set to 0.")), t < 0 && (t = 0, console.warn("Value of linear argument in lightFalloff() should be never be negative. Set to 0.")), r < 0 && (r = 0, console.warn("Value of quadratic argument in lightFalloff() should be never be negative. Set to 0.")), 0 === e1 && 0 === t && 0 === r && (e1 = 1, console.warn("Either one of the three arguments in lightFalloff() should be greater than zero. Set constant argument to 1.")), this._renderer.constantAttenuation = e1, this._renderer.linearAttenuation = t, this._renderer.quadraticAttenuation = r, this;
                }, m.default.prototype.spotLight = function(e1, t, r, o, n, s, i, a, l, u, c) {
                    this._assert3d("spotLight"), m.default._validateParameters("spotLight", arguments);
                    var d, f, h, p = arguments.length;
                    switch(p){
                        case 11:
                        case 10:
                            d = this.color(e1, t, r), f = new m.default.Vector(o, n, s), h = new m.default.Vector(i, a, l);
                            break;
                        case 9:
                            e1 instanceof m.default.Color ? (d = e1, f = new m.default.Vector(t, r, o), h = new m.default.Vector(n, s, i), u = a, c = l) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), f = o, h = new m.default.Vector(n, s, i), u = a, c = l) : i instanceof m.default.Vector ? (d = this.color(e1, t, r), f = new m.default.Vector(o, n, s), h = i, u = a, c = l) : (d = this.color(e1, t, r), f = new m.default.Vector(o, n, s), h = new m.default.Vector(i, a, l));
                            break;
                        case 8:
                            u = (h = e1 instanceof m.default.Color ? (d = e1, f = new m.default.Vector(t, r, o), new m.default.Vector(n, s, i)) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), f = o, new m.default.Vector(n, s, i)) : (d = this.color(e1, t, r), f = new m.default.Vector(o, n, s), i), a);
                            break;
                        case 7:
                            e1 instanceof m.default.Color && t instanceof m.default.Vector ? (d = e1, f = t, h = new m.default.Vector(r, o, n), u = s, c = i) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, f = new m.default.Vector(t, r, o), h = n, u = s, c = i) : o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), f = o, h = n, u = s, c = i) : h = e1 instanceof m.default.Color ? (d = e1, f = new m.default.Vector(t, r, o), new m.default.Vector(n, s, i)) : o instanceof m.default.Vector ? (d = this.color(e1, t, r), f = o, new m.default.Vector(n, s, i)) : (d = this.color(e1, t, r), f = new m.default.Vector(o, n, s), i);
                            break;
                        case 6:
                            o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), f = o, h = n, u = s) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, f = new m.default.Vector(t, r, o), h = n, u = s) : e1 instanceof m.default.Color && t instanceof m.default.Vector && (d = e1, f = t, h = new m.default.Vector(r, o, n), u = s);
                            break;
                        case 5:
                            e1 instanceof m.default.Color && t instanceof m.default.Vector && r instanceof m.default.Vector ? (d = e1, f = t, h = r, u = o, c = n) : o instanceof m.default.Vector && n instanceof m.default.Vector ? (d = this.color(e1, t, r), f = o, h = n) : e1 instanceof m.default.Color && n instanceof m.default.Vector ? (d = e1, f = new m.default.Vector(t, r, o), h = n) : e1 instanceof m.default.Color && t instanceof m.default.Vector && (d = e1, f = t, h = new m.default.Vector(r, o, n));
                            break;
                        case 4:
                            d = e1, f = t, h = r, u = o;
                            break;
                        case 3:
                            d = e1, f = t, h = r;
                            break;
                        default:
                            return console.warn("Sorry, input for spotlight() is not in prescribed format. Too ".concat(p < 3 ? "few" : "many", " arguments were provided")), this;
                    }
                    return this._renderer.spotLightDiffuseColors.push(d._array[0], d._array[1], d._array[2]), Array.prototype.push.apply(this._renderer.spotLightSpecularColors, this._renderer.specularColors), this._renderer.spotLightPositions.push(f.x, f.y, f.z), h.normalize(), this._renderer.spotLightDirections.push(h.x, h.y, h.z), void 0 === u && (u = Math.PI / 3), void 0 !== c && c < 1 ? (c = 1, console.warn("Value of concentration needs to be greater than 1. Setting it to 1")) : void 0 === c && (c = 100), u = this._renderer._pInst._toRadians(u), this._renderer.spotLightAngle.push(Math.cos(u)), this._renderer.spotLightConc.push(c), this._renderer._enableLighting = !0, this;
                }, m.default.prototype.noLights = function() {
                    this._assert3d("noLights");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return m.default._validateParameters("noLights", t), this._renderer._enableLighting = !1, this._renderer.ambientLightColors.length = 0, this._renderer.specularColors = [
                        1,
                        1,
                        1
                    ], this._renderer.directionalLightDirections.length = 0, this._renderer.directionalLightDiffuseColors.length = 0, this._renderer.directionalLightSpecularColors.length = 0, this._renderer.pointLightPositions.length = 0, this._renderer.pointLightDiffuseColors.length = 0, this._renderer.pointLightSpecularColors.length = 0, this._renderer.spotLightPositions.length = 0, this._renderer.spotLightDirections.length = 0, this._renderer.spotLightDiffuseColors.length = 0, this._renderer.spotLightSpecularColors.length = 0, this._renderer.spotLightAngle.length = 0, this._renderer.spotLightConc.length = 0, this._renderer.constantAttenuation = 1, this._renderer.linearAttenuation = 0, this._renderer.quadraticAttenuation = 0, this._renderer._useShininess = 1, this;
                };
                e1 = m.default;
                r.default = e1;
            },
            {
                "../core/main": 273
            }
        ],
        319: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.splice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.match"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.trim"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var x = (o = e1("../core/main")) && o.__esModule ? o : {
                    default: o
                };
                e1("./p5.Geometry"), x.default.prototype.loadModel = function(e1) {
                    x.default._validateParameters("loadModel", arguments);
                    var y, g, t, r = e1.slice(-4), v = ("boolean" == typeof arguments[1] ? (y = arguments[1], g = arguments[2], t = arguments[3], void 0 !== arguments[4] && (r = arguments[4])) : (y = !1, g = arguments[1], t = arguments[2], void 0 !== arguments[3] && (r = arguments[3])), new x.default.Geometry), b = (v.gid = "".concat(e1, "|").concat(y), this);
                    return r.match(/\.stl$/i) ? this.httpDo(e1, "GET", "arrayBuffer", function(e1) {
                        !function(e1, t) {
                            if (function(e1) {
                                for(var t = new DataView(e1), r = [
                                    115,
                                    111,
                                    108,
                                    105,
                                    100
                                ], o = 0; o < 5; o++)if (function(e1, t, r) {
                                    for(var o = 0, n = e1.length; o < n; o++)if (e1[o] !== t.getUint8(r + o, !1)) return;
                                    return 1;
                                }(r, t, o)) return;
                                return 1;
                            }(t)) !function(e1, t) {
                                for(var r, o, n, s, i, a, l, u = new DataView(t), c = u.getUint32(80, !0), d = !1, f = 0; f < 70; f++)1129270351 === u.getUint32(f, !1) && 82 === u.getUint8(f + 4) && 61 === u.getUint8(f + 5) && (d = !0, s = [], i = u.getUint8(f + 6) / 255, a = u.getUint8(f + 7) / 255, l = u.getUint8(f + 8) / 255);
                                for(var h = 0; h < c; h++){
                                    for(var p, m = 84 + 50 * h, y = u.getFloat32(m, !0), g = u.getFloat32(4 + m, !0), v = u.getFloat32(8 + m, !0), b = (d && (p = u.getUint16(48 + m, !0), n = 0 == (32768 & p) ? (r = (31 & p) / 31, o = (p >> 5 & 31) / 31, (p >> 10 & 31) / 31) : (r = i, o = a, l)), new x.default.Vector(y, g, v)), j = 1; j <= 3; j++){
                                        var _ = m + 12 * j, _ = new x.default.Vector(u.getFloat32(_, !0), u.getFloat32(4 + _, !0), u.getFloat32(8 + _, !0));
                                        e1.vertices.push(_), e1.vertexNormals.push(b), d && s.push(r, o, n);
                                    }
                                    e1.faces.push([
                                        3 * h,
                                        3 * h + 1,
                                        3 * h + 2
                                    ]), e1.uvs.push([
                                        0,
                                        0
                                    ], [
                                        0,
                                        0
                                    ], [
                                        0,
                                        0
                                    ]);
                                }
                            }(e1, t);
                            else {
                                t = new DataView(t);
                                if (!("TextDecoder" in window)) return console.warn("Sorry, ASCII STL loading only works in browsers that support TextDecoder (https://caniuse.com/#feat=textencoder)");
                                t = new TextDecoder("utf-8").decode(t).split("\n");
                                !function(e1, t) {
                                    for(var r, o, n = "", s = [], i = 0; i < t.length; ++i){
                                        for(var a = t[i].trim(), l = a.split(" "), u = 0; u < l.length; ++u)"" === l[u] && l.splice(u, 1);
                                        if (0 !== l.length) switch(n){
                                            case "":
                                                if ("solid" !== l[0]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "solid"'));
                                                n = "solid";
                                                break;
                                            case "solid":
                                                if ("facet" !== l[0] || "normal" !== l[1]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "facet normal"'));
                                                r = new x.default.Vector(parseFloat(l[2]), parseFloat(l[3]), parseFloat(l[4])), e1.vertexNormals.push(r, r, r), n = "facet normal";
                                                break;
                                            case "facet normal":
                                                if ("outer" !== l[0] || "loop" !== l[1]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "outer loop"'));
                                                n = "vertex";
                                                break;
                                            case "vertex":
                                                if ("vertex" === l[0]) o = new x.default.Vector(parseFloat(l[1]), parseFloat(l[2]), parseFloat(l[3])), e1.vertices.push(o), e1.uvs.push([
                                                    0,
                                                    0
                                                ]), s.push(e1.vertices.indexOf(o));
                                                else {
                                                    if ("endloop" !== l[0]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "vertex" or "endloop"'));
                                                    e1.faces.push(s), s = [], n = "endloop";
                                                }
                                                break;
                                            case "endloop":
                                                if ("endfacet" !== l[0]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "endfacet"'));
                                                n = "endfacet";
                                                break;
                                            case "endfacet":
                                                if ("endsolid" !== l[0]) {
                                                    if ("facet" !== l[0] || "normal" !== l[1]) return console.error(a), console.error('Invalid state "'.concat(l[0], '", should be "endsolid" or "facet normal"'));
                                                    r = new x.default.Vector(parseFloat(l[2]), parseFloat(l[3]), parseFloat(l[4])), e1.vertexNormals.push(r, r, r), n = "facet normal";
                                                }
                                                break;
                                            default:
                                                console.error('Invalid state "'.concat(n, '"'));
                                        }
                                    }
                                }(e1, t);
                            }
                        }(v, e1), y && v.normalize(), b._decrementPreload(), "function" == typeof g && g(v);
                    }, t) : r.match(/\.obj$/i) ? this.loadStrings(e1, function(e1) {
                        for(var t = v, r = e1, o = {
                            v: [],
                            vt: [],
                            vn: []
                        }, n = {}, s = 0; s < r.length; ++s){
                            var i = r[s].trim().split(/\b\s+/);
                            if (0 < i.length) {
                                if ("v" === i[0] || "vn" === i[0]) {
                                    var a = new x.default.Vector(parseFloat(i[1]), parseFloat(i[2]), parseFloat(i[3]));
                                    o[i[0]].push(a);
                                } else if ("vt" === i[0]) {
                                    a = [
                                        parseFloat(i[1]),
                                        1 - parseFloat(i[2])
                                    ];
                                    o[i[0]].push(a);
                                } else if ("f" === i[0]) for(var l = 3; l < i.length; ++l){
                                    for(var u = [], c = [
                                        1,
                                        l - 1,
                                        l
                                    ], d = 0; d < c.length; ++d){
                                        var f = i[c[d]], h = 0;
                                        if (void 0 !== n[f]) h = n[f];
                                        else {
                                            for(var p = f.split("/"), m = 0; m < p.length; m++)p[m] = parseInt(p[m]) - 1;
                                            h = n[f] = t.vertices.length, t.vertices.push(o.v[p[0]].copy()), o.vt[p[1]] ? t.uvs.push(o.vt[p[1]].slice()) : t.uvs.push([
                                                0,
                                                0
                                            ]), o.vn[p[2]] && t.vertexNormals.push(o.vn[p[2]].copy());
                                        }
                                        u.push(h);
                                    }
                                    u[0] !== u[1] && u[0] !== u[2] && u[1] !== u[2] && t.faces.push(u);
                                }
                            }
                        }
                        0 === t.vertexNormals.length && t.computeNormals(), y && v.normalize(), b._decrementPreload(), "function" == typeof g && g(v);
                    }, t) : (x.default._friendlyFileLoadError(3, e1), t ? t() : x.default._friendlyError("Sorry, the file type is invalid. Only OBJ and STL files are supported.")), v;
                }, x.default.prototype.model = function(e1) {
                    this._assert3d("model"), x.default._validateParameters("model", arguments), 0 < e1.vertices.length && (this._renderer.geometryInHash(e1.gid) || (0 === e1.edges.length && e1._makeTriangleEdges(), e1._edgesToVertices(), this._renderer.createBuffers(e1.gid, e1)), this._renderer.drawBuffers(e1.gid));
                };
                var o = x.default;
                r.default = o;
            },
            {
                "../core/main": 273,
                "./p5.Geometry": 323,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.array.splice": 166,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.match": 191,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.string.trim": 199
            }
        ],
        320: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.join"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = (s = e1("../core/main")) && s.__esModule ? s : {
                    default: s
                }, n = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                e1("./p5.Texture"), u.default.prototype.loadShader = function(e1, t, r, o) {
                    u.default._validateParameters("loadShader", arguments), o = o || console.error;
                    function n() {
                        i._decrementPreload(), r && r(s);
                    }
                    var s = new u.default.Shader, i = this, a = !1, l = !1;
                    return this.loadStrings(e1, function(e1) {
                        s._vertSrc = e1.join("\n"), l = !0, a && n();
                    }, o), this.loadStrings(t, function(e1) {
                        s._fragSrc = e1.join("\n"), a = !0, l && n();
                    }, o), s;
                }, u.default.prototype.createShader = function(e1, t) {
                    return this._assert3d("createShader"), u.default._validateParameters("createShader", arguments), new u.default.Shader(this._renderer, e1, t);
                }, u.default.prototype.shader = function(e1) {
                    return this._assert3d("shader"), u.default._validateParameters("shader", arguments), void 0 === e1._renderer && (e1._renderer = this._renderer), e1.init(), e1.isStrokeShader() ? this._renderer.userStrokeShader = e1 : (this._renderer.userFillShader = e1, this._renderer._useNormalMaterial = !1), this;
                }, u.default.prototype.resetShader = function() {
                    return this._renderer.userFillShader = this._renderer.userStrokeShader = null, this;
                }, u.default.prototype.texture = function(e1) {
                    return this._assert3d("texture"), u.default._validateParameters("texture", arguments), e1.gifProperties && e1._animateGif(this), this._renderer.drawMode = n.TEXTURE, this._renderer._useNormalMaterial = !1, this._renderer._tex = e1, this._renderer._setProperty("_doFill", !0), this;
                }, u.default.prototype.textureMode = function(e1) {
                    e1 !== n.IMAGE && e1 !== n.NORMAL ? console.warn("You tried to set ".concat(e1, " textureMode only supports IMAGE & NORMAL ")) : this._renderer.textureMode = e1;
                }, u.default.prototype.textureWrap = function(e1) {
                    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : e1, r = (this._renderer.textureWrapX = e1, this._renderer.textureWrapY = t, !0), o = !1, n = void 0;
                    try {
                        for(var s, i = this._renderer.textures.values()[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)s.value.setWrapMode(e1, t);
                    } catch (e1) {
                        o = !0, n = e1;
                    } finally{
                        try {
                            r || null == i.return || i.return();
                        } finally{
                            if (o) throw n;
                        }
                    }
                }, u.default.prototype.normalMaterial = function() {
                    this._assert3d("normalMaterial");
                    for(var e1 = arguments.length, t = new Array(e1), r = 0; r < e1; r++)t[r] = arguments[r];
                    return u.default._validateParameters("normalMaterial", t), this._renderer.drawMode = n.FILL, this._renderer._useSpecularMaterial = !1, this._renderer._useEmissiveMaterial = !1, this._renderer._useNormalMaterial = !0, this._renderer.curFillColor = [
                        1,
                        1,
                        1,
                        1
                    ], this._renderer._setProperty("_doFill", !0), this.noStroke(), this;
                }, u.default.prototype.ambientMaterial = function(e1, t, r) {
                    this._assert3d("ambientMaterial"), u.default._validateParameters("ambientMaterial", arguments);
                    var o = u.default.prototype.color.apply(this, arguments);
                    return this._renderer._hasSetAmbient = !0, this._renderer.curAmbientColor = o._array, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this._renderer._setProperty("_doFill", !0), this;
                }, u.default.prototype.emissiveMaterial = function(e1, t, r, o) {
                    this._assert3d("emissiveMaterial"), u.default._validateParameters("emissiveMaterial", arguments);
                    var n = u.default.prototype.color.apply(this, arguments);
                    return this._renderer.curEmissiveColor = n._array, this._renderer._useEmissiveMaterial = !0, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this;
                }, u.default.prototype.specularMaterial = function(e1, t, r, o) {
                    this._assert3d("specularMaterial"), u.default._validateParameters("specularMaterial", arguments);
                    var n = u.default.prototype.color.apply(this, arguments);
                    return this._renderer.curSpecularColor = n._array, this._renderer._useSpecularMaterial = !0, this._renderer._useNormalMaterial = !1, this._renderer._enableLighting = !0, this;
                }, u.default.prototype.shininess = function(e1) {
                    return this._assert3d("shininess"), u.default._validateParameters("shininess", arguments), this._renderer._useShininess = e1 = e1 < 1 ? 1 : e1, this;
                }, u.default.RendererGL.prototype._applyColorBlend = function(e1) {
                    var t = this.GL, r = this.drawMode === n.TEXTURE, r = this.userFillShader || this.userStrokeShader || this.userPointShader || r || this.curBlendMode !== n.BLEND || e1[e1.length - 1] < 1 || this._isErasing;
                    return r !== this._isBlending && (r || this.curBlendMode !== n.BLEND && this.curBlendMode !== n.ADD ? t.enable(t.BLEND) : t.disable(t.BLEND), t.depthMask(!0), this._isBlending = r), this._applyBlendMode(), e1;
                }, u.default.RendererGL.prototype._applyBlendMode = function() {
                    if (this._cachedBlendMode !== this.curBlendMode) {
                        var e1 = this.GL;
                        switch(this.curBlendMode){
                            case n.BLEND:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.ADD:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE);
                                break;
                            case n.REMOVE:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ZERO, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.MULTIPLY:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.DST_COLOR, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.SCREEN:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ONE_MINUS_SRC_COLOR);
                                break;
                            case n.EXCLUSION:
                                e1.blendEquationSeparate(e1.FUNC_ADD, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE_MINUS_DST_COLOR, e1.ONE_MINUS_SRC_COLOR, e1.ONE, e1.ONE);
                                break;
                            case n.REPLACE:
                                e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ZERO);
                                break;
                            case n.SUBTRACT:
                                e1.blendEquationSeparate(e1.FUNC_REVERSE_SUBTRACT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case n.DARKEST:
                                this.blendExt ? (e1.blendEquationSeparate(this.blendExt.MIN || this.blendExt.MIN_EXT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE)) : console.warn("blendMode(DARKEST) does not work in your browser in WEBGL mode.");
                                break;
                            case n.LIGHTEST:
                                this.blendExt ? (e1.blendEquationSeparate(this.blendExt.MAX || this.blendExt.MAX_EXT, e1.FUNC_ADD), e1.blendFuncSeparate(e1.ONE, e1.ONE, e1.ONE, e1.ONE)) : console.warn("blendMode(LIGHTEST) does not work in your browser in WEBGL mode.");
                                break;
                            default:
                                console.error("Oops! Somehow RendererGL set curBlendMode to an unsupported mode.");
                        }
                        this._isErasing || (this._cachedBlendMode = this.curBlendMode);
                    }
                };
                var s = u.default;
                r.default = s;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "./p5.Texture": 330,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.join": 161,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        321: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.math.hypot"), e1("core-js/modules/es.string.sub"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var _ = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                _.default.prototype.camera = function() {
                    var e1;
                    this._assert3d("camera");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return _.default._validateParameters("camera", r), (e1 = this._renderer._curCamera).camera.apply(e1, r), this;
                }, _.default.prototype.perspective = function() {
                    var e1;
                    this._assert3d("perspective");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return _.default._validateParameters("perspective", r), (e1 = this._renderer._curCamera).perspective.apply(e1, r), this;
                }, _.default.prototype.ortho = function() {
                    var e1;
                    this._assert3d("ortho");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return _.default._validateParameters("ortho", r), (e1 = this._renderer._curCamera).ortho.apply(e1, r), this;
                }, _.default.prototype.frustum = function() {
                    var e1;
                    this._assert3d("frustum");
                    for(var t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
                    return _.default._validateParameters("frustum", r), (e1 = this._renderer._curCamera).frustum.apply(e1, r), this;
                }, _.default.prototype.createCamera = function() {
                    this._assert3d("createCamera");
                    var e1 = new _.default.Camera(this._renderer);
                    return e1._computeCameraDefaultSettings(), e1._setDefaultCamera(), this._renderer._curCamera = e1;
                }, _.default.Camera = function() {
                    function t(e1) {
                        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
                        this._renderer = e1, this.cameraType = "default", this.cameraMatrix = new _.default.Matrix, this.projMatrix = new _.default.Matrix, this.yScale = 1;
                    }
                    var e1, r, o;
                    return e1 = t, r = [
                        {
                            key: "perspective",
                            value: function(e1, t, r, o) {
                                this.cameraType = 0 < arguments.length ? "custom" : "default", void 0 === e1 ? (e1 = this.defaultCameraFOV, this.cameraFOV = e1) : this.cameraFOV = this._renderer._pInst._toRadians(e1), void 0 === t && (t = this.defaultAspectRatio), void 0 === r && (r = this.defaultCameraNear), void 0 === o && (o = this.defaultCameraFar), r <= 1e-4 && (r = .01, console.log("Avoid perspective near plane values close to or below 0. Setting value to 0.01.")), o < r && console.log("Perspective far plane value is less than near plane value. Nothing will be shown."), this.aspectRatio = t, this.cameraNear = r, this.cameraFar = o, this.projMatrix = _.default.Matrix.identity();
                                var e1 = 1 / Math.tan(this.cameraFOV / 2), n = 1 / (this.cameraNear - this.cameraFar);
                                this.projMatrix.set(e1 / t, 0, 0, 0, 0, -e1 * this.yScale, 0, 0, 0, 0, (o + r) * n, -1, 0, 0, 2 * o * r * n, 0), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix.mat4[0], this.projMatrix.mat4[1], this.projMatrix.mat4[2], this.projMatrix.mat4[3], this.projMatrix.mat4[4], this.projMatrix.mat4[5], this.projMatrix.mat4[6], this.projMatrix.mat4[7], this.projMatrix.mat4[8], this.projMatrix.mat4[9], this.projMatrix.mat4[10], this.projMatrix.mat4[11], this.projMatrix.mat4[12], this.projMatrix.mat4[13], this.projMatrix.mat4[14], this.projMatrix.mat4[15]);
                            }
                        },
                        {
                            key: "ortho",
                            value: function(e1, t, r, o, n, s) {
                                void 0 === e1 && (e1 = -this._renderer.width / 2), void 0 === t && (t = +this._renderer.width / 2), void 0 === r && (r = -this._renderer.height / 2), void 0 === o && (o = +this._renderer.height / 2), void 0 === n && (n = 0), void 0 === s && (s = Math.max(this._renderer.width, this._renderer.height)), this.cameraNear = n;
                                var i = t - e1, a = o - r, l = (this.cameraFar = s) - n, u = 2 / i, c = 2 / a * this.yScale, d = -2 / l, t = -(t + e1) / i, e1 = -(o + r) / a, i = -(s + n) / l;
                                this.projMatrix = _.default.Matrix.identity(), this.projMatrix.set(u, 0, 0, 0, 0, -c, 0, 0, 0, 0, d, 0, t, e1, i, 1), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix.mat4[0], this.projMatrix.mat4[1], this.projMatrix.mat4[2], this.projMatrix.mat4[3], this.projMatrix.mat4[4], this.projMatrix.mat4[5], this.projMatrix.mat4[6], this.projMatrix.mat4[7], this.projMatrix.mat4[8], this.projMatrix.mat4[9], this.projMatrix.mat4[10], this.projMatrix.mat4[11], this.projMatrix.mat4[12], this.projMatrix.mat4[13], this.projMatrix.mat4[14], this.projMatrix.mat4[15]), this.cameraType = "custom";
                            }
                        },
                        {
                            key: "frustum",
                            value: function(e1, t, r, o, n, s) {
                                void 0 === e1 && (e1 = .05 * -this._renderer.width), void 0 === t && (t = .05 * +this._renderer.width), void 0 === r && (r = .05 * +this._renderer.height), void 0 === o && (o = .05 * -this._renderer.height), void 0 === n && (n = this.defaultCameraNear), void 0 === s && (s = this.defaultCameraFar), this.cameraNear = n;
                                var i = t - e1, a = o - r, l = (this.cameraFar = s) - n, u = 2 * n / i, c = 2 * n / a * this.yScale, d = -2 * s * n / l, t = (t + e1) / i, e1 = (o + r) / a, i = -(s + n) / l;
                                this.projMatrix = _.default.Matrix.identity(), this.projMatrix.set(u, 0, 0, 0, 0, -c, 0, 0, t, e1, i, -1, 0, 0, d, 0), this._isActive() && this._renderer.uPMatrix.set(this.projMatrix.mat4[0], this.projMatrix.mat4[1], this.projMatrix.mat4[2], this.projMatrix.mat4[3], this.projMatrix.mat4[4], this.projMatrix.mat4[5], this.projMatrix.mat4[6], this.projMatrix.mat4[7], this.projMatrix.mat4[8], this.projMatrix.mat4[9], this.projMatrix.mat4[10], this.projMatrix.mat4[11], this.projMatrix.mat4[12], this.projMatrix.mat4[13], this.projMatrix.mat4[14], this.projMatrix.mat4[15]), this.cameraType = "custom";
                            }
                        },
                        {
                            key: "_rotateView",
                            value: function(e1, t, r, o) {
                                var n = this.centerX, s = this.centerY, i = this.centerZ, a = (n -= this.eyeX, s -= this.eyeY, i -= this.eyeZ, _.default.Matrix.identity(this._renderer._pInst)), e1 = (a.rotate(this._renderer._pInst._toRadians(e1), t, r, o), [
                                    n * a.mat4[0] + s * a.mat4[4] + i * a.mat4[8],
                                    n * a.mat4[1] + s * a.mat4[5] + i * a.mat4[9],
                                    n * a.mat4[2] + s * a.mat4[6] + i * a.mat4[10]
                                ]);
                                e1[0] += this.eyeX, e1[1] += this.eyeY, e1[2] += this.eyeZ, this.camera(this.eyeX, this.eyeY, this.eyeZ, e1[0], e1[1], e1[2], this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "pan",
                            value: function(e1) {
                                var t = this._getLocalAxes();
                                this._rotateView(e1, t.y[0], t.y[1], t.y[2]);
                            }
                        },
                        {
                            key: "tilt",
                            value: function(e1) {
                                var t = this._getLocalAxes();
                                this._rotateView(e1, t.x[0], t.x[1], t.x[2]);
                            }
                        },
                        {
                            key: "lookAt",
                            value: function(e1, t, r) {
                                this.camera(this.eyeX, this.eyeY, this.eyeZ, e1, t, r, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "camera",
                            value: function(e1, t, r, o, n, s, i, a, l) {
                                void 0 === e1 && (e1 = this.defaultEyeX, t = this.defaultEyeY, r = this.defaultEyeZ, o = e1, n = t, a = 1, l = i = s = 0), this.eyeX = e1, this.eyeY = t, this.eyeZ = r, void 0 !== o && (this.centerX = o, this.centerY = n, this.centerZ = s), void 0 !== i && (this.upX = i, this.upY = a, this.upZ = l);
                                o = this._getLocalAxes(), this.cameraMatrix.set(o.x[0], o.y[0], o.z[0], 0, o.x[1], o.y[1], o.z[1], 0, o.x[2], o.y[2], o.z[2], 0, 0, 0, 0, 1), n = -e1;
                                return this.cameraMatrix.translate([
                                    n,
                                    -t,
                                    -r
                                ]), this._isActive() && this._renderer.uMVMatrix.set(this.cameraMatrix.mat4[0], this.cameraMatrix.mat4[1], this.cameraMatrix.mat4[2], this.cameraMatrix.mat4[3], this.cameraMatrix.mat4[4], this.cameraMatrix.mat4[5], this.cameraMatrix.mat4[6], this.cameraMatrix.mat4[7], this.cameraMatrix.mat4[8], this.cameraMatrix.mat4[9], this.cameraMatrix.mat4[10], this.cameraMatrix.mat4[11], this.cameraMatrix.mat4[12], this.cameraMatrix.mat4[13], this.cameraMatrix.mat4[14], this.cameraMatrix.mat4[15]), this;
                            }
                        },
                        {
                            key: "move",
                            value: function(e1, t, r) {
                                var o = this._getLocalAxes(), e1 = [
                                    o.x[0] * e1,
                                    o.x[1] * e1,
                                    o.x[2] * e1
                                ], t = [
                                    o.y[0] * t,
                                    o.y[1] * t,
                                    o.y[2] * t
                                ], o = [
                                    o.z[0] * r,
                                    o.z[1] * r,
                                    o.z[2] * r
                                ];
                                this.camera(this.eyeX + e1[0] + t[0] + o[0], this.eyeY + e1[1] + t[1] + o[1], this.eyeZ + e1[2] + t[2] + o[2], this.centerX + e1[0] + t[0] + o[0], this.centerY + e1[1] + t[1] + o[1], this.centerZ + e1[2] + t[2] + o[2], this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "setPosition",
                            value: function(e1, t, r) {
                                var o = e1 - this.eyeX, n = t - this.eyeY, s = r - this.eyeZ;
                                this.camera(e1, t, r, this.centerX + o, this.centerY + n, this.centerZ + s, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "set",
                            value: function(e1) {
                                for(var t = 0, r = [
                                    "eyeX",
                                    "eyeY",
                                    "eyeZ",
                                    "centerX",
                                    "centerY",
                                    "centerZ",
                                    "upX",
                                    "upY",
                                    "upZ",
                                    "cameraFOV",
                                    "aspectRatio",
                                    "cameraNear",
                                    "cameraFar",
                                    "cameraType"
                                ]; t < r.length; t++){
                                    var o = r[t];
                                    this[o] = e1[o];
                                }
                                this.cameraMatrix = e1.cameraMatrix.copy(), this.projMatrix = e1.projMatrix.copy(), this._isActive() && (this._renderer.uMVMatrix.mat4 = this.cameraMatrix.mat4.slice(), this._renderer.uPMatrix.mat4 = this.projMatrix.mat4.slice());
                            }
                        },
                        {
                            key: "slerp",
                            value: function(e1, t, r) {
                                var o, n, s, i, a, l, u, c, d, f, h, p, m, y, g, v, b, j;
                                0 === r ? this.set(e1) : 1 === r ? this.set(t) : (0 !== this.projMatrix.mat4[15] && (this.projMatrix.mat4[0] = e1.projMatrix.mat4[0] * Math.pow(t.projMatrix.mat4[0] / e1.projMatrix.mat4[0], r), this.projMatrix.mat4[5] = e1.projMatrix.mat4[5] * Math.pow(t.projMatrix.mat4[5] / e1.projMatrix.mat4[5], r), this._isActive() && (this._renderer.uPMatrix.mat4 = this.projMatrix.mat4.slice())), i = new _.default.Vector(e1.eyeX, e1.eyeY, e1.eyeZ), a = new _.default.Vector(t.eyeX, t.eyeY, t.eyeZ), v = new _.default.Vector(e1.centerX, e1.centerY, e1.centerZ), j = new _.default.Vector(t.centerX, t.centerY, t.centerZ), s = _.default.Vector.dist(i, v), o = _.default.Vector.dist(a, j), o = s * Math.pow(o / s, r), s = _.default.Vector.sub(i, a), n = 1, 1e-6 < (b = (y = i.copy().sub(a).sub(v).add(j)).magSq()) && (n = _.default.Vector.dot(s, y) / b, n = Math.max(0, Math.min(n, 1))), s = _.default.Vector.lerp(_.default.Vector.lerp(i, v, n), _.default.Vector.lerp(a, j, n), r), y = e1.cameraMatrix.createSubMatrix3x3(), b = t.cameraMatrix.createSubMatrix3x3(), i = y.column(2), v = b.column(2), a = y.column(1), j = b.column(1), e1 = new _.default.Vector, t = new _.default.Vector, l = new _.default.Vector, u = new _.default.Vector, 1 - (c = .5 * ((y = (b = b.mult3x3(y.copy().transpose3x3())).diagonal())[0] + y[1] + y[2] - 1)) < 1e-7 ? (e1.set(_.default.Vector.lerp(i, v, r)).normalize(), l.set(e1).mult(n * o).add(s), u.set(e1).mult((n - 1) * o).add(s), t.set(_.default.Vector.lerp(a, j, r)).normalize()) : (v = 1 / (1 - c), j = Math.max(y[0], y[1], y[2]), p = b.mat3[1] + b.mat3[3], m = b.mat3[2] + b.mat3[6], g = b.mat3[5] + b.mat3[7], j = j === y[0] ? (f = .5 * p * (v /= d = Math.sqrt((y[0] - c) * v)), h = .5 * m * v, .5 * (b.mat3[7] - b.mat3[5]) / d) : j === y[1] ? (h = .5 * g * (v /= f = Math.sqrt((y[1] - c) * v)), d = .5 * p * v, .5 * (b.mat3[2] - b.mat3[6]) / f) : (d = .5 * m * (v /= h = Math.sqrt((y[2] - c) * v)), f = .5 * g * v, .5 * (b.mat3[3] - b.mat3[1]) / h), p = r * Math.atan2(j, c), m = Math.cos(p), y = Math.sin(p), (j = new _.default.Matrix("mat3", [
                                    m + (g = 1 - m) * d * d,
                                    g * (v = d * f) - y * h,
                                    g * (b = h * d) + y * f,
                                    g * v + y * h,
                                    m + g * f * f,
                                    g * (r = f * h) - y * d,
                                    g * b - y * f,
                                    g * r + y * d,
                                    m + g * h * h
                                ])).multiplyVec3(i, e1), l.set(e1).mult(n * o).add(s), u.set(e1).mult((n - 1) * o).add(s), j.multiplyVec3(a, t)), this.camera(l.x, l.y, l.z, u.x, u.y, u.z, t.x, t.y, t.z));
                            }
                        },
                        {
                            key: "_computeCameraDefaultSettings",
                            value: function() {
                                this.defaultCameraFOV = 60 / 180 * Math.PI, this.defaultAspectRatio = this._renderer.width / this._renderer.height, this.defaultEyeX = 0, this.defaultEyeY = 0, this.defaultEyeZ = this._renderer.height / 2 / Math.tan(this.defaultCameraFOV / 2), this.defaultCenterX = 0, this.defaultCenterY = 0, this.defaultCenterZ = 0, this.defaultCameraNear = .1 * this.defaultEyeZ, this.defaultCameraFar = 10 * this.defaultEyeZ;
                            }
                        },
                        {
                            key: "_setDefaultCamera",
                            value: function() {
                                this.cameraFOV = this.defaultCameraFOV, this.aspectRatio = this.defaultAspectRatio, this.eyeX = this.defaultEyeX, this.eyeY = this.defaultEyeY, this.eyeZ = this.defaultEyeZ, this.centerX = this.defaultCenterX, this.centerY = this.defaultCenterY, this.centerZ = this.defaultCenterZ, this.upX = 0, this.upY = 1, this.upZ = 0, this.cameraNear = this.defaultCameraNear, this.cameraFar = this.defaultCameraFar, this.perspective(), this.camera(), this.cameraType = "default";
                            }
                        },
                        {
                            key: "_resize",
                            value: function() {
                                "default" === this.cameraType ? (this._computeCameraDefaultSettings(), this._setDefaultCamera()) : this.perspective(this.cameraFOV, this._renderer.width / this._renderer.height);
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                var e1 = new _.default.Camera(this._renderer);
                                return e1.cameraFOV = this.cameraFOV, e1.aspectRatio = this.aspectRatio, e1.eyeX = this.eyeX, e1.eyeY = this.eyeY, e1.eyeZ = this.eyeZ, e1.centerX = this.centerX, e1.centerY = this.centerY, e1.centerZ = this.centerZ, e1.upX = this.upX, e1.upY = this.upY, e1.upZ = this.upZ, e1.cameraNear = this.cameraNear, e1.cameraFar = this.cameraFar, e1.cameraType = this.cameraType, e1.cameraMatrix = this.cameraMatrix.copy(), e1.projMatrix = this.projMatrix.copy(), e1;
                            }
                        },
                        {
                            key: "_getLocalAxes",
                            value: function() {
                                var e1 = this.eyeX - this.centerX, t = this.eyeY - this.centerY, r = this.eyeZ - this.centerZ, o = Math.sqrt(e1 * e1 + t * t + r * r), o = (0 !== o && (e1 /= o, t /= o, r /= o), this.upX), n = (a = this.upY) * r - (l = this.upZ) * t, s = -o * r + l * e1, i = o * t - a * e1, o = t * i - r * s, a = -e1 * i + r * n, l = e1 * s - t * n, u = Math.sqrt(n * n + s * s + i * i), u = (0 !== u && (n /= u, s /= u, i /= u), Math.sqrt(o * o + a * a + l * l));
                                return 0 !== u && (o /= u, a /= u, l /= u), {
                                    x: [
                                        n,
                                        s,
                                        i
                                    ],
                                    y: [
                                        o,
                                        a,
                                        l
                                    ],
                                    z: [
                                        e1,
                                        t,
                                        r
                                    ]
                                };
                            }
                        },
                        {
                            key: "_orbit",
                            value: function(e1, t, r) {
                                var o = this.eyeX - this.centerX, n = this.eyeY - this.centerY, s = this.eyeZ - this.centerZ, i = Math.hypot(o, n, s), o = new _.default.Vector(o, n, s).normalize(), n = new _.default.Vector(this.upX, this.upY, this.upZ).normalize(), s = new _.default.Vector.cross(n, o).normalize(), a = new _.default.Vector.cross(s, n), r = ((i = (i *= Math.pow(10, r)) < this.cameraNear ? this.cameraNear : i) > this.cameraFar && (i = this.cameraFar), Math.acos(Math.max(-1, Math.min(1, _.default.Vector.dot(o, n)))) + t), t = e1;
                                (r <= 0 || r >= Math.PI) && (this.upX *= -1, this.upY *= -1, this.upZ *= -1), n.mult(Math.cos(r)), a.mult(Math.cos(t) * Math.sin(r)), s.mult(Math.sin(t) * Math.sin(r)), o.set(n).add(a).add(s), this.eyeX = i * o.x + this.centerX, this.eyeY = i * o.y + this.centerY, this.eyeZ = i * o.z + this.centerZ, this.camera(this.eyeX, this.eyeY, this.eyeZ, this.centerX, this.centerY, this.centerZ, this.upX, this.upY, this.upZ);
                            }
                        },
                        {
                            key: "_orbitFree",
                            value: function(e1, t, r) {
                                var o = this.eyeX - this.centerX, n = this.eyeY - this.centerY, s = this.eyeZ - this.centerZ, i = Math.hypot(o, n, s), o = new _.default.Vector(o, n, s).normalize(), n = new _.default.Vector(this.upX, this.upY, this.upZ), s = new _.default.Vector.cross(n, o).normalize(), a = new _.default.Vector.cross(o, s), l = Math.atan2(t, e1), l = (a.mult(Math.sin(l)), s.mult(Math.cos(l)).add(a), Math.sqrt(e1 * e1 + t * t)), a = new _.default.Vector.cross(o, s), e1 = ((i = (i *= Math.pow(10, r)) < this.cameraNear ? this.cameraNear : i) > this.cameraFar && (i = this.cameraFar), Math.cos(l)), t = Math.sin(l), r = n.dot(o), l = n.dot(s), u = r * e1 + l * t, r = -r * t + l * e1, l = n.dot(a);
                                n.x = u * o.x + r * s.x + l * a.x, n.y = u * o.y + r * s.y + l * a.y, n.z = u * o.z + r * s.z + l * a.z, s.mult(-t), o.mult(e1).add(s).mult(i), this.camera(o.x + this.centerX, o.y + this.centerY, o.z + this.centerZ, this.centerX, this.centerY, this.centerZ, n.x, n.y, n.z);
                            }
                        },
                        {
                            key: "_isActive",
                            value: function() {
                                return this === this._renderer._curCamera;
                            }
                        }
                    ], n(e1.prototype, r), o && n(e1, o), t;
                }(), _.default.prototype.setCamera = function(e1) {
                    this._renderer._curCamera = e1, this._renderer.uPMatrix.set(e1.projMatrix.mat4[0], e1.projMatrix.mat4[1], e1.projMatrix.mat4[2], e1.projMatrix.mat4[3], e1.projMatrix.mat4[4], e1.projMatrix.mat4[5], e1.projMatrix.mat4[6], e1.projMatrix.mat4[7], e1.projMatrix.mat4[8], e1.projMatrix.mat4[9], e1.projMatrix.mat4[10], e1.projMatrix.mat4[11], e1.projMatrix.mat4[12], e1.projMatrix.mat4[13], e1.projMatrix.mat4[14], e1.projMatrix.mat4[15]);
                };
                e1 = _.default.Camera;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.math.hypot": 169,
                "core-js/modules/es.string.sub": 198
            }
        ],
        322: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.reflect.get"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint8-clamped-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var h = (x = e1("../core/main")) && x.__esModule ? x : {
                    default: x
                }, i = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== c(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), n = e1("./p5.Texture"), p = e1("./p5.RendererGL");
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function l(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function u(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) {
                            var r = [], o = !0, n = !1, s = void 0;
                            try {
                                for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
                            } catch (e1) {
                                n = !0, s = e1;
                            } finally{
                                try {
                                    o || null == a.return || a.return();
                                } finally{
                                    if (n) throw s;
                                }
                            }
                            return r;
                        }
                    }(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                function s(e1, t, r) {
                    return t in e1 ? Object.defineProperty(e1, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = r, e1;
                }
                function c(e1) {
                    return (c = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function d(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function f(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function m(e1, t, r) {
                    t && f(e1.prototype, t), r && f(e1, r);
                }
                function y(e1, t, r) {
                    return (y = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e1, t, r) {
                        var e1 = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = b(e1)););
                            return e1;
                        }(e1, t);
                        if (e1) return (e1 = Object.getOwnPropertyDescriptor(e1, t)).get ? e1.get.call(r) : e1.value;
                    })(e1, t, r || e1);
                }
                function g(e1, t) {
                    return (g = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function v(r) {
                    return function() {
                        var e1, t = b(r), t = (e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = b(this).constructor, Reflect.construct(t, arguments, e1)) : t.apply(this, arguments), this);
                        if (!e1 || "object" !== c(e1) && "function" != typeof e1) {
                            if (void 0 !== t) return t;
                            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        }
                        return e1;
                    };
                }
                function b(e1) {
                    return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                var j = function(e1) {
                    var t = o;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && g(t, e1);
                    var r = v(o);
                    function o(e1) {
                        var t;
                        return d(this, o), (t = r.call(this, e1.target._renderer)).fbo = e1, t.yScale = -1, t;
                    }
                    return m(o, [
                        {
                            key: "_computeCameraDefaultSettings",
                            value: function() {
                                y(b(o.prototype), "_computeCameraDefaultSettings", this).call(this), this.defaultAspectRatio = this.fbo.width / this.fbo.height, this.defaultEyeZ = this.fbo.height / 2 / Math.tan(this.defaultCameraFOV / 2), this.defaultCameraNear = .1 * this.defaultEyeZ, this.defaultCameraFar = 10 * this.defaultEyeZ;
                            }
                        },
                        {
                            key: "_resize",
                            value: function() {
                                "default" === this.cameraType ? (this._computeCameraDefaultSettings(), this._setDefaultCamera()) : this.perspective(this.cameraFOV, this.fbo.width / this.fbo.height);
                            }
                        }
                    ]), o;
                }(h.default.Camera), _ = (h.default.FramebufferCamera = j, function() {
                    function r(e1, t) {
                        d(this, r), this.framebuffer = e1, this.property = t;
                    }
                    return m(r, [
                        {
                            key: "rawTexture",
                            value: function() {
                                return this.framebuffer[this.property];
                            }
                        },
                        {
                            key: "width",
                            get: function() {
                                return this.framebuffer.width * this.framebuffer.density;
                            }
                        },
                        {
                            key: "height",
                            get: function() {
                                return this.framebuffer.height * this.framebuffer.density;
                            }
                        }
                    ]), r;
                }()), x = (h.default.FramebufferTexture = _, function() {
                    function r(e1) {
                        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, t = (d(this, r), this.target = e1, this.target._renderer.framebuffers.add(this), this.pixels = [], this.format = t.format || i.UNSIGNED_BYTE, this.channels = t.channels || (e1._renderer._pInst._glAttributes.alpha ? i.RGBA : i.RGB), this.useDepth = void 0 === t.depth || t.depth, this.depthFormat = t.depthFormat || i.FLOAT, this.textureFiltering = t.textureFiltering || i.LINEAR, void 0 === t.antialias ? this.antialiasSamples = e1._renderer._pInst._glAttributes.antialias ? 2 : 0 : "number" == typeof t.antialias ? this.antialiasSamples = t.antialias : this.antialiasSamples = t.antialias ? 2 : 0, this.antialias = 0 < this.antialiasSamples, this.antialias && e1.webglVersion !== i.WEBGL2 && (console.warn("Antialiasing is unsupported in a WebGL 1 context"), this.antialias = !1), t.width && t.height ? (this.width = t.width, this.height = t.height, this.autoSized = !1) : (void 0 === t.width != (void 0 === t.height) && console.warn("Please supply both width and height for a framebuffer to give it a size. Only one was given, so the framebuffer will match the size of its canvas."), this.width = e1.width, this.height = e1.height, this.autoSized = !0), this.density = t.density || e1.pixelDensity(), e1._renderer.GL);
                        if (this.gl = t, this._checkIfFormatsAvailable(), this.framebuffer = t.createFramebuffer(), !this.framebuffer) throw new Error("Unable to create a framebuffer");
                        if (this.antialias && (this.aaFramebuffer = t.createFramebuffer(), !this.aaFramebuffer)) throw new Error("Unable to create a framebuffer for antialiasing");
                        this._recreateTextures();
                        e1 = this.target._renderer._curCamera;
                        this.defaultCamera = this.createCamera(), this.target._renderer._curCamera = e1;
                    }
                    return m(r, [
                        {
                            key: "resize",
                            value: function(e1, t) {
                                this.autoSized = !1, this.width = e1, this.height = t, this._handleResize();
                            }
                        },
                        {
                            key: "pixelDensity",
                            value: function(e1) {
                                if (!e1) return this.density;
                                this.autoSized = !1, this.density = e1, this._handleResize();
                            }
                        },
                        {
                            key: "autoSized",
                            value: function(e1) {
                                if (void 0 === e1) return this.autoSized;
                                this.autoSized = e1, this._handleResize();
                            }
                        },
                        {
                            key: "_checkIfFormatsAvailable",
                            value: function() {
                                var e1 = this.gl, e1 = (this.useDepth && this.target.webglVersion === i.WEBGL && !e1.getExtension("WEBGL_depth_texture") && (console.warn("Unable to create depth textures in this environment. Falling back to a framebuffer without depth."), this.useDepth = !1), this.useDepth && this.target.webglVersion === i.WEBGL && this.depthFormat === i.FLOAT && (console.warn("FLOAT depth format is unavailable in WebGL 1. Defaulting to UNSIGNED_INT."), this.depthFormat = i.UNSIGNED_INT), [
                                    i.UNSIGNED_BYTE,
                                    i.FLOAT,
                                    i.HALF_FLOAT
                                ].includes(this.format) || (console.warn("Unknown Framebuffer format. Please use UNSIGNED_BYTE, FLOAT, or HALF_FLOAT. Defaulting to UNSIGNED_BYTE."), this.format = i.UNSIGNED_BYTE), this.useDepth && ![
                                    i.UNSIGNED_INT,
                                    i.FLOAT
                                ].includes(this.depthFormat) && (console.warn("Unknown Framebuffer depth format. Please use UNSIGNED_INT or FLOAT. Defaulting to FLOAT."), this.depthFormat = i.FLOAT), (0, n.checkWebGLCapabilities)(this.target._renderer));
                                e1.float || this.format !== i.FLOAT || (console.warn("This environment does not support FLOAT textures. Falling back to UNSIGNED_BYTE."), this.format = i.UNSIGNED_BYTE), this.useDepth && !e1.float && this.depthFormat === i.FLOAT && (console.warn("This environment does not support FLOAT depth textures. Falling back to UNSIGNED_INT."), this.depthFormat = i.UNSIGNED_INT), e1.halfFloat || this.format !== i.HALF_FLOAT || (console.warn("This environment does not support HALF_FLOAT textures. Falling back to UNSIGNED_BYTE."), this.format = i.UNSIGNED_BYTE), this.channels === i.RGB && [
                                    i.FLOAT,
                                    i.HALF_FLOAT
                                ].includes(this.format) && (console.warn("FLOAT and HALF_FLOAT formats do not work cross-platform with only RGB channels. Falling back to RGBA."), this.channels = i.RGBA);
                            }
                        },
                        {
                            key: "_recreateTextures",
                            value: function() {
                                var e1 = this.gl, t = (this._updateSize(), e1.getParameter(e1.TEXTURE_BINDING_2D)), r = e1.getParameter(e1.FRAMEBUFFER_BINDING), o = e1.createTexture();
                                if (!o) throw new Error("Unable to create color texture");
                                e1.bindTexture(e1.TEXTURE_2D, o);
                                var n = this._glColorFormat();
                                if (e1.texImage2D(e1.TEXTURE_2D, 0, n.internalFormat, this.width * this.density, this.height * this.density, 0, n.format, n.type, null), this.colorTexture = o, e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, o, 0), this.useDepth) {
                                    var o = e1.createTexture();
                                    if (!o) throw new Error("Unable to create depth texture");
                                    var s = this._glDepthFormat();
                                    e1.bindTexture(e1.TEXTURE_2D, o), e1.texImage2D(e1.TEXTURE_2D, 0, s.internalFormat, this.width * this.density, this.height * this.density, 0, s.format, s.type, null), e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.TEXTURE_2D, o, 0), this.depthTexture = o;
                                }
                                this.antialias && (this.colorRenderbuffer = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, this.colorRenderbuffer), e1.renderbufferStorageMultisample(e1.RENDERBUFFER, Math.max(0, Math.min(this.antialiasSamples, e1.getParameter(e1.MAX_SAMPLES))), n.internalFormat, this.width * this.density, this.height * this.density), this.useDepth && (s = this._glDepthFormat(), this.depthRenderbuffer = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, this.depthRenderbuffer), e1.renderbufferStorageMultisample(e1.RENDERBUFFER, Math.max(0, Math.min(this.antialiasSamples, e1.getParameter(e1.MAX_SAMPLES))), s.internalFormat, this.width * this.density, this.height * this.density)), e1.bindFramebuffer(e1.FRAMEBUFFER, this.aaFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.RENDERBUFFER, this.colorRenderbuffer), this.useDepth && e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, this.depthRenderbuffer)), this.useDepth && (this.depth = new _(this, "depthTexture"), o = e1.NEAREST, this.depthP5Texture = new h.default.Texture(this.target._renderer, this.depth, {
                                    minFilter: o,
                                    magFilter: o
                                }), this.target._renderer.textures.set(this.depth, this.depthP5Texture)), this.color = new _(this, "colorTexture");
                                n = this.textureFiltering === i.LINEAR ? e1.LINEAR : e1.NEAREST;
                                this.colorP5Texture = new h.default.Texture(this.target._renderer, this.color, {
                                    glMinFilter: n,
                                    glMagFilter: n
                                }), this.target._renderer.textures.set(this.color, this.colorP5Texture), e1.bindTexture(e1.TEXTURE_2D, t), e1.bindFramebuffer(e1.FRAMEBUFFER, r);
                            }
                        },
                        {
                            key: "_glColorFormat",
                            value: function() {
                                var e1, t, r = this.gl, o = this.format === i.FLOAT ? r.FLOAT : this.format === i.HALF_FLOAT ? this.target.webglVersion === i.WEBGL2 ? r.HALF_FLOAT : r.getExtension("OES_texture_half_float").HALF_FLOAT_OES : r.UNSIGNED_BYTE, n = this.channels === i.RGBA ? r.RGBA : r.RGB;
                                return {
                                    internalFormat: this.target.webglVersion === i.WEBGL2 ? (s(t = {}, r.FLOAT, s({}, r.RGBA, r.RGBA32F)), s(t, r.HALF_FLOAT, s({}, r.RGBA, r.RGBA16F)), s(t, r.UNSIGNED_BYTE, (s(e1 = {}, r.RGBA, r.RGBA8), s(e1, r.RGB, r.RGB8), e1)), t[o][n]) : this.format === i.HALF_FLOAT ? r.RGBA : n,
                                    format: n,
                                    type: o
                                };
                            }
                        },
                        {
                            key: "_glDepthFormat",
                            value: function() {
                                var e1 = this.gl, t = this.depthFormat === i.FLOAT ? e1.FLOAT : e1.UNSIGNED_INT, r = e1.DEPTH_COMPONENT, e1 = this.target.webglVersion === i.WEBGL2 ? this.depthFormat === i.FLOAT ? e1.DEPTH_COMPONENT32F : e1.DEPTH_COMPONENT24 : e1.DEPTH_COMPONENT;
                                return {
                                    internalFormat: e1,
                                    format: r,
                                    type: t
                                };
                            }
                        },
                        {
                            key: "_updateSize",
                            value: function() {
                                this.autoSized && (this.width = this.target.width, this.height = this.target.height, this.density = this.target.pixelDensity());
                            }
                        },
                        {
                            key: "_canvasSizeChanged",
                            value: function() {
                                this.autoSized && this._handleResize();
                            }
                        },
                        {
                            key: "_handleResize",
                            value: function() {
                                var e1 = this.color, t = this.depth, r = this.colorRenderbuffer, o = this.depthRenderbuffer, e1 = (this._deleteTexture(e1), t && this._deleteTexture(t), this.gl);
                                r && e1.deleteRenderbuffer(r), o && e1.deleteRenderbuffer(o), this._recreateTextures(), this.defaultCamera._resize();
                            }
                        },
                        {
                            key: "createCamera",
                            value: function() {
                                var e1 = new j(this);
                                return e1._computeCameraDefaultSettings(), e1._setDefaultCamera(), this.target._renderer._curCamera = e1;
                            }
                        },
                        {
                            key: "_deleteTexture",
                            value: function(e1) {
                                this.gl.deleteTexture(e1.rawTexture()), this.target._renderer.textures.delete(e1);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                var e1 = this.gl;
                                this._deleteTexture(this.color), this.depth && this._deleteTexture(this.depth), e1.deleteFramebuffer(this.framebuffer), this.aaFramebuffer && e1.deleteFramebuffer(this.aaFramebuffer), this.depthRenderbuffer && e1.deleteRenderbuffer(this.depthRenderbuffer), this.colorRenderbuffer && e1.deleteRenderbuffer(this.colorRenderbuffer), this.target._renderer.framebuffers.delete(this);
                            }
                        },
                        {
                            key: "begin",
                            value: function() {
                                var e1 = this.gl;
                                this.prevFramebuffer = e1.getParameter(e1.FRAMEBUFFER_BINDING), this.antialias ? e1.bindFramebuffer(e1.FRAMEBUFFER, this.aaFramebuffer) : e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), this.prevViewport = e1.getParameter(e1.VIEWPORT), e1.viewport(0, 0, this.width * this.density, this.height * this.density), this.target.push(), this.target.setCamera(this.defaultCamera), this.target._renderer.uMVMatrix.set(this.target._renderer._curCamera.cameraMatrix.mat4[0], this.target._renderer._curCamera.cameraMatrix.mat4[1], this.target._renderer._curCamera.cameraMatrix.mat4[2], this.target._renderer._curCamera.cameraMatrix.mat4[3], this.target._renderer._curCamera.cameraMatrix.mat4[4], this.target._renderer._curCamera.cameraMatrix.mat4[5], this.target._renderer._curCamera.cameraMatrix.mat4[6], this.target._renderer._curCamera.cameraMatrix.mat4[7], this.target._renderer._curCamera.cameraMatrix.mat4[8], this.target._renderer._curCamera.cameraMatrix.mat4[9], this.target._renderer._curCamera.cameraMatrix.mat4[10], this.target._renderer._curCamera.cameraMatrix.mat4[11], this.target._renderer._curCamera.cameraMatrix.mat4[12], this.target._renderer._curCamera.cameraMatrix.mat4[13], this.target._renderer._curCamera.cameraMatrix.mat4[14], this.target._renderer._curCamera.cameraMatrix.mat4[15]);
                            }
                        },
                        {
                            key: "end",
                            value: function() {
                                var e1 = this.gl;
                                if (this.antialias) {
                                    e1.bindFramebuffer(e1.READ_FRAMEBUFFER, this.aaFramebuffer), e1.bindFramebuffer(e1.DRAW_FRAMEBUFFER, this.framebuffer);
                                    var t = [
                                        [
                                            e1.COLOR_BUFFER_BIT,
                                            this.colorP5Texture.glMagFilter
                                        ]
                                    ];
                                    this.useDepth && t.push([
                                        e1.DEPTH_BUFFER_BIT,
                                        this.depthP5Texture.glMagFilter
                                    ]);
                                    for(var r = 0, o = t; r < o.length; r++){
                                        var n = u(o[r], 2), s = n[0], n = n[1];
                                        e1.blitFramebuffer(0, 0, this.width * this.density, this.height * this.density, 0, 0, this.width * this.density, this.height * this.density, s, n);
                                    }
                                }
                                e1.bindFramebuffer(e1.FRAMEBUFFER, this.prevFramebuffer), e1.viewport.apply(e1, l(this.prevViewport)), this.target.pop();
                            }
                        },
                        {
                            key: "draw",
                            value: function(e1) {
                                this.begin(), e1(), this.end();
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1 = this.gl, t = e1.getParameter(e1.FRAMEBUFFER_BINDING), r = (e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), this._glColorFormat());
                                this.pixels = (0, p.readPixelsWebGL)(this.pixels, e1, this.framebuffer, 0, 0, this.width * this.density, this.height * this.density, r.format, r.type), e1.bindFramebuffer(e1.FRAMEBUFFER, t);
                            }
                        },
                        {
                            key: "get",
                            value: function(e1, t, r, o) {
                                h.default._validateParameters("p5.Framebuffer.get", arguments);
                                var n = this._glColorFormat();
                                if (void 0 === e1 && void 0 === t) t = e1 = 0, r = this.width, o = this.height;
                                else if (void 0 === r && void 0 === o) return (e1 < 0 || t < 0 || e1 >= this.width || t >= this.height) && (console.warn("The x and y values passed to p5.Framebuffer.get are outside of its range and will be clamped."), e1 = this.target.constrain(e1, 0, this.width - 1), t = this.target.constrain(t, 0, this.height - 1)), (0, p.readPixelWebGL)(this.gl, this.framebuffer, e1 * this.density, t * this.density, n.format, n.type);
                                e1 = this.target.constrain(e1, 0, this.width - 1), t = this.target.constrain(t, 0, this.height - 1), r = this.target.constrain(r, 1, this.width - e1), o = this.target.constrain(o, 1, this.height - t);
                                for(var s = (0, p.readPixelsWebGL)(void 0, this.gl, this.framebuffer, e1 * this.density, t * this.density, r * this.density, o * this.density, n.format, n.type), i = new Uint8ClampedArray(r * o * this.density * this.density * 4), a = (i.fill(255), n.type === this.gl.RGB ? 3 : 4), l = 0; l < o * this.density; l++)for(var u = 0; u < r * this.density; u++)for(var c = 0; c < 4; c++){
                                    var d, f = 4 * (l * r * this.density + u) + c;
                                    c < a && (d = 4 == a ? f : (l * r * this.density + u) * a + c, i[f] = s[d]);
                                }
                                e1 = new h.default.Image(r * this.density, o * this.density);
                                return e1.imageData = e1.canvas.getContext("2d").createImageData(e1.width, e1.height), e1.imageData.data.set(i), e1.pixels = e1.imageData.data, e1.updatePixels(), 1 !== this.density && e1.resize(r, o), e1;
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function() {
                                var e1 = this.gl, t = (this.colorP5Texture.bindTexture(), this._glColorFormat()), r = t.format === e1.RGBA ? 4 : 3, r = this.width * this.height * this.density * this.density * r, o = t.type === e1.UNSIGNED_BYTE ? Uint8Array : Float32Array;
                                if (!(this.pixels instanceof o) || this.pixels.length !== r) throw new Error("The pixels array has not been set correctly. Please call loadPixels() before updatePixels().");
                                e1.texImage2D(e1.TEXTURE_2D, 0, t.internalFormat, this.width * this.density, this.height * this.density, 0, t.format, t.type, this.pixels), this.colorP5Texture.unbindTexture(), this.prevFramebuffer = e1.getParameter(e1.FRAMEBUFFER_BINDING), this.antialias ? (this.begin(), this.target.push(), this.target.imageMode(this.target.CENTER), this.target.resetMatrix(), this.target.noStroke(), this.target.clear(), this.target.image(this, 0, 0), this.target.pop(), this.useDepth && (e1.clearDepth(1), e1.clear(e1.DEPTH_BUFFER_BIT)), this.end()) : (e1.bindFramebuffer(e1.FRAMEBUFFER, this.framebuffer), this.useDepth && (e1.clearDepth(1), e1.clear(e1.DEPTH_BUFFER_BIT)), e1.bindFramebuffer(e1.FRAMEBUFFER, this.prevFramebuffer));
                            }
                        }
                    ]), r;
                }()), e1 = h.default.Framebuffer = x;
                r.default = e1;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "./p5.RendererGL": 328,
                "./p5.Texture": 330,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.reflect.get": 183,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.float32-array": 209,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint8-array": 232,
                "core-js/modules/es.typed-array.uint8-clamped-array": 233,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        323: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/web.dom-collections.for-each"), e1("core-js/modules/es.array.for-each"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/web.dom-collections.for-each"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                a.default.Geometry = function() {
                    function o(e1, t, r) {
                        if (this instanceof o) return this.vertices = [], this.lineVertices = [], this.lineTangentsIn = [], this.lineTangentsOut = [], this.lineSides = [], this.vertexNormals = [], this.faces = [], this.uvs = [], this.edges = [], this.vertexColors = [], this.vertexStrokeColors = [], this.lineVertexColors = [], this.detailX = void 0 !== e1 ? e1 : 1, this.detailY = void 0 !== t ? t : 1, this.dirtyFlags = {}, r instanceof Function && r.call(this), this;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "reset",
                            value: function() {
                                this.lineVertices.length = 0, this.lineTangentsIn.length = 0, this.lineTangentsOut.length = 0, this.lineSides.length = 0, this.vertices.length = 0, this.edges.length = 0, this.vertexColors.length = 0, this.vertexStrokeColors.length = 0, this.lineVertexColors.length = 0, this.vertexNormals.length = 0, this.uvs.length = 0, this.dirtyFlags = {};
                            }
                        },
                        {
                            key: "computeFaces",
                            value: function() {
                                this.faces.length = 0;
                                for(var e1, t, r, o = this.detailX + 1, n = 0; n < this.detailY; n++)for(var s = 0; s < this.detailX; s++)t = (n + 1) * o + s + 1, this.faces.push([
                                    n * o + s,
                                    e1 = n * o + s + 1,
                                    r = (n + 1) * o + s
                                ]), this.faces.push([
                                    r,
                                    e1,
                                    t
                                ]);
                                return this;
                            }
                        },
                        {
                            key: "_getFaceNormal",
                            value: function(e1) {
                                var e1 = this.faces[e1], t = this.vertices[e1[0]], r = this.vertices[e1[1]], e1 = this.vertices[e1[2]], r = a.default.Vector.sub(r, t), e1 = a.default.Vector.sub(e1, t), t = a.default.Vector.cross(r, e1), o = a.default.Vector.mag(t), r = o / (a.default.Vector.mag(r) * a.default.Vector.mag(e1));
                                return 0 === r || isNaN(r) ? (console.warn("p5.Geometry.prototype._getFaceNormal:", "face has colinear sides or a repeated vertex"), t) : (1 < r && (r = 1), t.mult(Math.asin(r) / o));
                            }
                        },
                        {
                            key: "computeNormals",
                            value: function() {
                                for(var s = this, i = this.vertexNormals, e1 = this.vertices, t = this.faces, r = i.length = 0; r < e1.length; ++r)i.push(new a.default.Vector);
                                for(t.forEach(function(e1, t) {
                                    for(var r = s._getFaceNormal(t), o = 0; o < 3; ++o){
                                        var n = e1[o];
                                        i[n].add(r);
                                    }
                                }), r = 0; r < e1.length; ++r)i[r].normalize();
                                return this;
                            }
                        },
                        {
                            key: "averageNormals",
                            value: function() {
                                for(var e1 = 0; e1 <= this.detailY; e1++){
                                    var t = this.detailX + 1, r = a.default.Vector.add(this.vertexNormals[e1 * t], this.vertexNormals[e1 * t + this.detailX]), r = a.default.Vector.div(r, 2);
                                    this.vertexNormals[e1 * t] = r, this.vertexNormals[e1 * t + this.detailX] = r;
                                }
                                return this;
                            }
                        },
                        {
                            key: "averagePoleNormals",
                            value: function() {
                                for(var e1 = new a.default.Vector(0, 0, 0), t = 0; t < this.detailX; t++)e1.add(this.vertexNormals[t]);
                                for(var e1 = a.default.Vector.div(e1, this.detailX), r = 0; r < this.detailX; r++)this.vertexNormals[r] = e1;
                                e1 = new a.default.Vector(0, 0, 0);
                                for(var o = this.vertices.length - 1; o > this.vertices.length - 1 - this.detailX; o--)e1.add(this.vertexNormals[o]);
                                e1 = a.default.Vector.div(e1, this.detailX);
                                for(var n = this.vertices.length - 1; n > this.vertices.length - 1 - this.detailX; n--)this.vertexNormals[n] = e1;
                                return this;
                            }
                        },
                        {
                            key: "_makeTriangleEdges",
                            value: function() {
                                for(var e1 = this.edges.length = 0; e1 < this.faces.length; e1++)this.edges.push([
                                    this.faces[e1][0],
                                    this.faces[e1][1]
                                ]), this.edges.push([
                                    this.faces[e1][1],
                                    this.faces[e1][2]
                                ]), this.edges.push([
                                    this.faces[e1][2],
                                    this.faces[e1][0]
                                ]);
                                return this;
                            }
                        },
                        {
                            key: "_edgesToVertices",
                            value: function() {
                                this.lineVertices.length = 0, this.lineTangentsIn.length = 0, this.lineTangentsOut.length = 0, this.lineSides.length = 0;
                                for(var e1, t = 1 < this.edges.length && this.edges[0][0] === this.edges[this.edges.length - 1][1], r = !1, o = 0; o < this.edges.length; o++){
                                    var n = this.edges[o - 1], s = this.edges[o], i = this.vertices[s[0]], a = this.vertices[s[1]], l = 0 < this.vertexStrokeColors.length ? this.vertexStrokeColors.slice(4 * s[0], 4 * (s[0] + 1)) : [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], u = 0 < this.vertexStrokeColors.length ? this.vertexStrokeColors.slice(4 * s[1], 4 * (s[1] + 1)) : [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], c = a.copy().sub(i).normalize(), d = 0 < c.magSq();
                                    d && this._addSegment(i, a, l, u, c), 0 < o && n[1] === s[0] ? (e1 && d && c.dot(e1) < 1 - 1e-8 && this._addJoin(i, e1, c, l), !d || r || t || (this._addCap(i, c.copy().mult(-1), l), r = !0)) : (r = !1, d && (!t || 0 < o) && (this._addCap(i, c.copy().mult(-1), l), r = !0), e1 && (!t || o < this.edges.length - 1) && (this._addCap(this.vertices[n[1]], e1, l), e1 = void 0)), o === this.edges.length - 1 && (t ? this._addJoin(a, c, this.vertices[this.edges[0][1]].copy().sub(a).normalize(), u) : this._addCap(a, c, u)), d && (e1 = c);
                                }
                                return this;
                            }
                        },
                        {
                            key: "_addSegment",
                            value: function(e1, t, r, o, n) {
                                var e1 = e1.array(), t = t.array(), s = n.array();
                                this.lineSides.push(1, -1, 1, 1, -1, -1);
                                for(var i = 0, a = [
                                    this.lineTangentsIn,
                                    this.lineTangentsOut
                                ]; i < a.length; i++)a[i].push(s, s, s, s, s, s);
                                return this.lineVertices.push(e1, e1, t, t, e1, t), this.lineVertexColors.push(r, r, o, o, r, o), this;
                            }
                        },
                        {
                            key: "_addCap",
                            value: function(e1, t, r) {
                                for(var o = e1.array(), n = t.array(), s = [
                                    0,
                                    0,
                                    0
                                ], i = 0; i < 6; i++)this.lineVertices.push(o), this.lineTangentsIn.push(n), this.lineTangentsOut.push(s), this.lineVertexColors.push(r);
                                return this.lineSides.push(-1, -2, 2, 2, 1, -1), this;
                            }
                        },
                        {
                            key: "_addJoin",
                            value: function(e1, t, r, o) {
                                for(var n = e1.array(), s = t.array(), i = r.array(), a = 0; a < 12; a++)this.lineVertices.push(n), this.lineTangentsIn.push(s), this.lineTangentsOut.push(i), this.lineVertexColors.push(o);
                                for(var l = 0, u = [
                                    -1,
                                    1
                                ]; l < u.length; l++){
                                    var c = u[l];
                                    this.lineSides.push(c, 2 * c, 3 * c, c, 3 * c, 0);
                                }
                                return this;
                            }
                        },
                        {
                            key: "normalize",
                            value: function() {
                                if (0 < this.vertices.length) {
                                    for(var e1 = this.vertices[0].copy(), t = this.vertices[0].copy(), r = 0; r < this.vertices.length; r++)e1.x = Math.max(e1.x, this.vertices[r].x), t.x = Math.min(t.x, this.vertices[r].x), e1.y = Math.max(e1.y, this.vertices[r].y), t.y = Math.min(t.y, this.vertices[r].y), e1.z = Math.max(e1.z, this.vertices[r].z), t.z = Math.min(t.z, this.vertices[r].z);
                                    for(var o = a.default.Vector.lerp(e1, t, .5), n = a.default.Vector.sub(e1, t), s = 200 / Math.max(Math.max(n.x, n.y), n.z), i = 0; i < this.vertices.length; i++)this.vertices[i].sub(o), this.vertices[i].mult(s);
                                }
                                return this;
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                e1 = a.default.Geometry;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.for-each": 156,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.string.sub": 198,
                "core-js/modules/web.dom-collections.for-each": 235
            }
        ],
        324: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var O = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                var s = Array, C = function(e1) {
                    return Array.isArray(e1);
                }, e1 = ("undefined" != typeof Float32Array && (s = Float32Array, C = function(e1) {
                    return Array.isArray(e1) || e1 instanceof Float32Array;
                }), O.default.Matrix = function() {
                    function r() {
                        var e1 = this, t = r;
                        if (e1 instanceof t) return arguments.length && ((e1 = arguments.length - 1) < 0 || arguments.length <= e1 ? void 0 : arguments[e1]) instanceof O.default && (this.p5 = (t = arguments.length - 1) < 0 || arguments.length <= t ? void 0 : arguments[t]), "mat3" === (arguments.length <= 0 ? void 0 : arguments[0]) ? this.mat3 = Array.isArray(arguments.length <= 1 ? void 0 : arguments[1]) ? arguments.length <= 1 ? void 0 : arguments[1] : new s([
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ]) : this.mat4 = Array.isArray(arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : new s([
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ]), this;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    var e1, t, o;
                    return e1 = r, o = [
                        {
                            key: "identity",
                            value: function(e1) {
                                return new O.default.Matrix(e1);
                            }
                        }
                    ], t = [
                        {
                            key: "set",
                            value: function(e1) {
                                return e1 instanceof O.default.Matrix ? this.mat4 = e1.mat4 : C(e1) ? this.mat4 = e1 : 16 === arguments.length && (this.mat4[0] = e1, this.mat4[1] = arguments[1], this.mat4[2] = arguments[2], this.mat4[3] = arguments[3], this.mat4[4] = arguments[4], this.mat4[5] = arguments[5], this.mat4[6] = arguments[6], this.mat4[7] = arguments[7], this.mat4[8] = arguments[8], this.mat4[9] = arguments[9], this.mat4[10] = arguments[10], this.mat4[11] = arguments[11], this.mat4[12] = arguments[12], this.mat4[13] = arguments[13], this.mat4[14] = arguments[14], this.mat4[15] = arguments[15]), this;
                            }
                        },
                        {
                            key: "get",
                            value: function() {
                                return new O.default.Matrix(this.mat4, this.p5);
                            }
                        },
                        {
                            key: "copy",
                            value: function() {
                                var e1;
                                return void 0 !== this.mat3 ? ((e1 = new O.default.Matrix("mat3", this.p5)).mat3[0] = this.mat3[0], e1.mat3[1] = this.mat3[1], e1.mat3[2] = this.mat3[2], e1.mat3[3] = this.mat3[3], e1.mat3[4] = this.mat3[4], e1.mat3[5] = this.mat3[5], e1.mat3[6] = this.mat3[6], e1.mat3[7] = this.mat3[7], e1.mat3[8] = this.mat3[8]) : ((e1 = new O.default.Matrix(this.p5)).mat4[0] = this.mat4[0], e1.mat4[1] = this.mat4[1], e1.mat4[2] = this.mat4[2], e1.mat4[3] = this.mat4[3], e1.mat4[4] = this.mat4[4], e1.mat4[5] = this.mat4[5], e1.mat4[6] = this.mat4[6], e1.mat4[7] = this.mat4[7], e1.mat4[8] = this.mat4[8], e1.mat4[9] = this.mat4[9], e1.mat4[10] = this.mat4[10], e1.mat4[11] = this.mat4[11], e1.mat4[12] = this.mat4[12], e1.mat4[13] = this.mat4[13], e1.mat4[14] = this.mat4[14], e1.mat4[15] = this.mat4[15]), e1;
                            }
                        },
                        {
                            key: "transpose",
                            value: function(e1) {
                                var t, r, o, n, s, i;
                                return e1 instanceof O.default.Matrix ? (t = e1.mat4[1], r = e1.mat4[2], o = e1.mat4[3], n = e1.mat4[6], s = e1.mat4[7], i = e1.mat4[11], this.mat4[0] = e1.mat4[0], this.mat4[1] = e1.mat4[4], this.mat4[2] = e1.mat4[8], this.mat4[3] = e1.mat4[12], this.mat4[4] = t, this.mat4[5] = e1.mat4[5], this.mat4[6] = e1.mat4[9], this.mat4[7] = e1.mat4[13], this.mat4[8] = r, this.mat4[9] = n, this.mat4[10] = e1.mat4[10], this.mat4[11] = e1.mat4[14], this.mat4[12] = o, this.mat4[13] = s, this.mat4[14] = i, this.mat4[15] = e1.mat4[15]) : C(e1) && (t = e1[1], r = e1[2], o = e1[3], n = e1[6], s = e1[7], i = e1[11], this.mat4[0] = e1[0], this.mat4[1] = e1[4], this.mat4[2] = e1[8], this.mat4[3] = e1[12], this.mat4[4] = t, this.mat4[5] = e1[5], this.mat4[6] = e1[9], this.mat4[7] = e1[13], this.mat4[8] = r, this.mat4[9] = n, this.mat4[10] = e1[10], this.mat4[11] = e1[14], this.mat4[12] = o, this.mat4[13] = s, this.mat4[14] = i, this.mat4[15] = e1[15]), this;
                            }
                        },
                        {
                            key: "invert",
                            value: function(e1) {
                                e1 instanceof O.default.Matrix ? (t = e1.mat4[0], r = e1.mat4[1], o = e1.mat4[2], n = e1.mat4[3], s = e1.mat4[4], i = e1.mat4[5], a = e1.mat4[6], l = e1.mat4[7], u = e1.mat4[8], c = e1.mat4[9], d = e1.mat4[10], f = e1.mat4[11], h = e1.mat4[12], p = e1.mat4[13], m = e1.mat4[14], y = e1.mat4[15]) : C(e1) && (t = e1[0], r = e1[1], o = e1[2], n = e1[3], s = e1[4], i = e1[5], a = e1[6], l = e1[7], u = e1[8], c = e1[9], d = e1[10], f = e1[11], h = e1[12], p = e1[13], m = e1[14], y = e1[15]);
                                var t, r, o, n, s, i, a, l, u, c, d, f, h, p, m, y, e1 = t * i - r * s, g = t * a - o * s, v = t * l - n * s, b = r * a - o * i, j = r * l - n * i, _ = o * l - n * a, x = u * p - c * h, w = u * m - d * h, S = u * y - f * h, E = c * m - d * p, M = c * y - f * p, T = d * y - f * m, k = e1 * T - g * M + v * E + b * S - j * w + _ * x;
                                return k ? (this.mat4[0] = (i * T - a * M + l * E) * (k = 1 / k), this.mat4[1] = (o * M - r * T - n * E) * k, this.mat4[2] = (p * _ - m * j + y * b) * k, this.mat4[3] = (d * j - c * _ - f * b) * k, this.mat4[4] = (a * S - s * T - l * w) * k, this.mat4[5] = (t * T - o * S + n * w) * k, this.mat4[6] = (m * v - h * _ - y * g) * k, this.mat4[7] = (u * _ - d * v + f * g) * k, this.mat4[8] = (s * M - i * S + l * x) * k, this.mat4[9] = (r * S - t * M - n * x) * k, this.mat4[10] = (h * j - p * v + y * e1) * k, this.mat4[11] = (c * v - u * j - f * e1) * k, this.mat4[12] = (i * w - s * E - a * x) * k, this.mat4[13] = (t * E - r * w + o * x) * k, this.mat4[14] = (p * g - h * b - m * e1) * k, this.mat4[15] = (u * b - c * g + d * e1) * k, this) : null;
                            }
                        },
                        {
                            key: "invert3x3",
                            value: function() {
                                var e1 = this.mat3[0], t = this.mat3[1], r = this.mat3[2], o = this.mat3[3], n = this.mat3[4], s = this.mat3[5], i = this.mat3[6], a = this.mat3[7], l = this.mat3[8], u = l * n - s * a, c = -l * o + s * i, d = a * o - n * i, f = e1 * u + t * c + r * d;
                                return f ? (this.mat3[0] = u * (f = 1 / f), this.mat3[1] = (-l * t + r * a) * f, this.mat3[2] = (s * t - r * n) * f, this.mat3[3] = c * f, this.mat3[4] = (l * e1 - r * i) * f, this.mat3[5] = (-s * e1 + r * o) * f, this.mat3[6] = d * f, this.mat3[7] = (-a * e1 + t * i) * f, this.mat3[8] = (n * e1 - t * o) * f, this) : null;
                            }
                        },
                        {
                            key: "transpose3x3",
                            value: function(e1) {
                                var t = (e1 = void 0 === e1 ? this.mat3 : e1)[1], r = e1[2], o = e1[5];
                                return this.mat3[0] = e1[0], this.mat3[1] = e1[3], this.mat3[2] = e1[6], this.mat3[3] = t, this.mat3[4] = e1[4], this.mat3[5] = e1[7], this.mat3[6] = r, this.mat3[7] = o, this.mat3[8] = e1[8], this;
                            }
                        },
                        {
                            key: "inverseTranspose",
                            value: function(e1) {
                                e1 = e1.mat4, void 0 === this.mat3 ? O.default._friendlyError("sorry, this function only works with mat3") : (this.mat3[0] = e1[0], this.mat3[1] = e1[1], this.mat3[2] = e1[2], this.mat3[3] = e1[4], this.mat3[4] = e1[5], this.mat3[5] = e1[6], this.mat3[6] = e1[8], this.mat3[7] = e1[9], this.mat3[8] = e1[10]), e1 = this.invert3x3();
                                if (e1) e1.transpose3x3(this.mat3);
                                else for(var t = 0; t < 9; t++)this.mat3[t] = 0;
                                return this;
                            }
                        },
                        {
                            key: "determinant",
                            value: function() {
                                var e1 = this.mat4[0] * this.mat4[5] - this.mat4[1] * this.mat4[4], t = this.mat4[0] * this.mat4[6] - this.mat4[2] * this.mat4[4], r = this.mat4[0] * this.mat4[7] - this.mat4[3] * this.mat4[4], o = this.mat4[1] * this.mat4[6] - this.mat4[2] * this.mat4[5], n = this.mat4[1] * this.mat4[7] - this.mat4[3] * this.mat4[5], s = this.mat4[2] * this.mat4[7] - this.mat4[3] * this.mat4[6], i = this.mat4[8] * this.mat4[13] - this.mat4[9] * this.mat4[12], a = this.mat4[8] * this.mat4[14] - this.mat4[10] * this.mat4[12], l = this.mat4[8] * this.mat4[15] - this.mat4[11] * this.mat4[12], u = this.mat4[9] * this.mat4[14] - this.mat4[10] * this.mat4[13], c = this.mat4[9] * this.mat4[15] - this.mat4[11] * this.mat4[13];
                                return e1 * (this.mat4[10] * this.mat4[15] - this.mat4[11] * this.mat4[14]) - t * c + r * u + o * l - n * a + s * i;
                            }
                        },
                        {
                            key: "mult",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat4) t = this.copy().mat4;
                                else if (e1 instanceof O.default.Matrix) t = e1.mat4;
                                else if (C(e1)) t = e1;
                                else {
                                    if (16 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat4[0], r = this.mat4[1], o = this.mat4[2], n = this.mat4[3];
                                return this.mat4[0] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[1] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[2] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[3] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[4], r = this.mat4[5], o = this.mat4[6], n = this.mat4[7], this.mat4[4] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[5] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[6] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[7] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[8], r = this.mat4[9], o = this.mat4[10], n = this.mat4[11], this.mat4[8] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[9] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[10] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[11] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], e1 = this.mat4[12], r = this.mat4[13], o = this.mat4[14], n = this.mat4[15], this.mat4[12] = e1 * t[0] + r * t[4] + o * t[8] + n * t[12], this.mat4[13] = e1 * t[1] + r * t[5] + o * t[9] + n * t[13], this.mat4[14] = e1 * t[2] + r * t[6] + o * t[10] + n * t[14], this.mat4[15] = e1 * t[3] + r * t[7] + o * t[11] + n * t[15], this;
                            }
                        },
                        {
                            key: "apply",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat4) t = this.copy().mat4;
                                else if (e1 instanceof O.default.Matrix) t = e1.mat4;
                                else if (C(e1)) t = e1;
                                else {
                                    if (16 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat4, r = e1[0], o = e1[4], n = e1[8], s = e1[12], r = (e1[0] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[4] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[8] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[12] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[1]), o = e1[5], n = e1[9], s = e1[13], r = (e1[1] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[5] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[9] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[13] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[2]), o = e1[6], n = e1[10], s = e1[14], r = (e1[2] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[6] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[10] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[14] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, e1[3]), o = e1[7], n = e1[11], s = e1[15];
                                return e1[3] = t[0] * r + t[1] * o + t[2] * n + t[3] * s, e1[7] = t[4] * r + t[5] * o + t[6] * n + t[7] * s, e1[11] = t[8] * r + t[9] * o + t[10] * n + t[11] * s, e1[15] = t[12] * r + t[13] * o + t[14] * n + t[15] * s, this;
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t, r) {
                                return e1 instanceof O.default.Vector ? (t = e1.y, r = e1.z, e1 = e1.x) : e1 instanceof Array && (t = e1[1], r = e1[2], e1 = e1[0]), this.mat4[0] *= e1, this.mat4[1] *= e1, this.mat4[2] *= e1, this.mat4[3] *= e1, this.mat4[4] *= t, this.mat4[5] *= t, this.mat4[6] *= t, this.mat4[7] *= t, this.mat4[8] *= r, this.mat4[9] *= r, this.mat4[10] *= r, this.mat4[11] *= r, this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1, t, r, o) {
                                t instanceof O.default.Vector ? (r = t.y, o = t.z, t = t.x) : t instanceof Array && (r = t[1], o = t[2], t = t[0]);
                                var n = Math.sqrt(t * t + r * r + o * o), n = (t *= 1 / n, r *= 1 / n, o *= 1 / n, this.mat4[0]), s = this.mat4[1], i = this.mat4[2], a = this.mat4[3], l = this.mat4[4], u = this.mat4[5], c = this.mat4[6], d = this.mat4[7], f = this.mat4[8], h = this.mat4[9], p = this.mat4[10], m = this.mat4[11], y = Math.sin(e1), e1 = Math.cos(e1), g = 1 - e1, v = t * t * g + e1, b = r * t * g + o * y, j = o * t * g - r * y, _ = t * r * g - o * y, x = r * r * g + e1, w = o * r * g + t * y, S = t * o * g + r * y, r = r * o * g - t * y, t = o * o * g + e1;
                                return this.mat4[0] = n * v + l * b + f * j, this.mat4[1] = s * v + u * b + h * j, this.mat4[2] = i * v + c * b + p * j, this.mat4[3] = a * v + d * b + m * j, this.mat4[4] = n * _ + l * x + f * w, this.mat4[5] = s * _ + u * x + h * w, this.mat4[6] = i * _ + c * x + p * w, this.mat4[7] = a * _ + d * x + m * w, this.mat4[8] = n * S + l * r + f * t, this.mat4[9] = s * S + u * r + h * t, this.mat4[10] = i * S + c * r + p * t, this.mat4[11] = a * S + d * r + m * t, this;
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1) {
                                var t = e1[0], r = e1[1], e1 = e1[2] || 0;
                                this.mat4[12] += this.mat4[0] * t + this.mat4[4] * r + this.mat4[8] * e1, this.mat4[13] += this.mat4[1] * t + this.mat4[5] * r + this.mat4[9] * e1, this.mat4[14] += this.mat4[2] * t + this.mat4[6] * r + this.mat4[10] * e1, this.mat4[15] += this.mat4[3] * t + this.mat4[7] * r + this.mat4[11] * e1;
                            }
                        },
                        {
                            key: "rotateX",
                            value: function(e1) {
                                this.rotate(e1, 1, 0, 0);
                            }
                        },
                        {
                            key: "rotateY",
                            value: function(e1) {
                                this.rotate(e1, 0, 1, 0);
                            }
                        },
                        {
                            key: "rotateZ",
                            value: function(e1) {
                                this.rotate(e1, 0, 0, 1);
                            }
                        },
                        {
                            key: "perspective",
                            value: function(e1, t, r, o) {
                                var e1 = 1 / Math.tan(e1 / 2), n = 1 / (r - o);
                                return this.mat4[0] = e1 / t, this.mat4[1] = 0, this.mat4[2] = 0, this.mat4[3] = 0, this.mat4[4] = 0, this.mat4[5] = e1, this.mat4[6] = 0, this.mat4[7] = 0, this.mat4[8] = 0, this.mat4[9] = 0, this.mat4[10] = (o + r) * n, this.mat4[11] = -1, this.mat4[12] = 0, this.mat4[13] = 0, this.mat4[14] = 2 * o * r * n, this.mat4[15] = 0, this;
                            }
                        },
                        {
                            key: "ortho",
                            value: function(e1, t, r, o, n, s) {
                                var i = 1 / (e1 - t), a = 1 / (r - o), l = 1 / (n - s);
                                return this.mat4[0] = -2 * i, this.mat4[1] = 0, this.mat4[2] = 0, this.mat4[3] = 0, this.mat4[4] = 0, this.mat4[5] = -2 * a, this.mat4[6] = 0, this.mat4[7] = 0, this.mat4[8] = 0, this.mat4[9] = 0, this.mat4[10] = 2 * l, this.mat4[11] = 0, this.mat4[12] = (e1 + t) * i, this.mat4[13] = (o + r) * a, this.mat4[14] = (s + n) * l, this.mat4[15] = 1, this;
                            }
                        },
                        {
                            key: "multiplyVec4",
                            value: function(e1, t, r, o) {
                                var n = new Array(4), s = this.mat4;
                                return n[0] = s[0] * e1 + s[4] * t + s[8] * r + s[12] * o, n[1] = s[1] * e1 + s[5] * t + s[9] * r + s[13] * o, n[2] = s[2] * e1 + s[6] * t + s[10] * r + s[14] * o, n[3] = s[3] * e1 + s[7] * t + s[11] * r + s[15] * o, n;
                            }
                        },
                        {
                            key: "multiplyPoint",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 1);
                                return new O.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "multiplyAndNormalizePoint",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 1);
                                return t[0] /= t[3], t[1] /= t[3], t[2] /= t[3], new O.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "multiplyDirection",
                            value: function(e1) {
                                var t = e1.x, r = e1.y, e1 = e1.z, t = this.multiplyVec4(t, r, e1, 0);
                                return new O.default.Vector(t[0], t[1], t[2]);
                            }
                        },
                        {
                            key: "mult3x3",
                            value: function(e1) {
                                var t;
                                if (e1 === this || e1 === this.mat3) t = this.copy().mat3;
                                else if (e1 instanceof O.default.Matrix) t = e1.mat3;
                                else if (C(e1)) t = e1;
                                else {
                                    if (9 !== arguments.length) return;
                                    t = arguments;
                                }
                                var e1 = this.mat3[0], r = this.mat3[1], o = this.mat3[2];
                                return this.mat3[0] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[1] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[2] = e1 * t[2] + r * t[5] + o * t[8], e1 = this.mat3[3], r = this.mat3[4], o = this.mat3[5], this.mat3[3] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[4] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[5] = e1 * t[2] + r * t[5] + o * t[8], e1 = this.mat3[6], r = this.mat3[7], o = this.mat3[8], this.mat3[6] = e1 * t[0] + r * t[3] + o * t[6], this.mat3[7] = e1 * t[1] + r * t[4] + o * t[7], this.mat3[8] = e1 * t[2] + r * t[5] + o * t[8], this;
                            }
                        },
                        {
                            key: "column",
                            value: function(e1) {
                                return new O.default.Vector(this.mat3[e1], this.mat3[e1 + 3], this.mat3[e1 + 6]);
                            }
                        },
                        {
                            key: "row",
                            value: function(e1) {
                                return new O.default.Vector(this.mat3[3 * e1], this.mat3[3 * e1 + 1], this.mat3[3 * e1 + 2]);
                            }
                        },
                        {
                            key: "diagonal",
                            value: function() {
                                return void 0 !== this.mat3 ? [
                                    this.mat3[0],
                                    this.mat3[4],
                                    this.mat3[8]
                                ] : [
                                    this.mat4[0],
                                    this.mat4[5],
                                    this.mat4[10],
                                    this.mat4[15]
                                ];
                            }
                        },
                        {
                            key: "multiplyVec3",
                            value: function(e1, t) {
                                return (t = void 0 === t ? e1.copy() : t).x = this.row(0).dot(e1), t.y = this.row(1).dot(e1), t.z = this.row(2).dot(e1), t;
                            }
                        },
                        {
                            key: "createSubMatrix3x3",
                            value: function() {
                                var e1 = new O.default.Matrix("mat3");
                                return e1.mat3[0] = this.mat4[0], e1.mat3[1] = this.mat4[1], e1.mat3[2] = this.mat4[2], e1.mat3[3] = this.mat4[4], e1.mat3[4] = this.mat4[5], e1.mat3[5] = this.mat4[6], e1.mat3[6] = this.mat4[8], e1.mat3[7] = this.mat4[9], e1.mat3[8] = this.mat4[10], e1;
                            }
                        }
                    ], n(e1.prototype, t), o && n(e1, o), r;
                }(), O.default.Matrix);
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.float32-array": 209,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229
            }
        ],
        325: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.map"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                e1 = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function o(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                e1.default.RenderBuffer = function() {
                    function i(e1, t, r, o, n, s) {
                        if (!(this instanceof i)) throw new TypeError("Cannot call a class as a function");
                        this.size = e1, this.src = t, this.dst = r, this.attr = o, this._renderer = n, this.map = s;
                    }
                    var e1, t, r;
                    return e1 = i, t = [
                        {
                            key: "_prepareBuffer",
                            value: function(e1, t) {
                                var r, o, n, s = t.attributes, i = this._renderer.GL, a = e1.model || e1, s = s[this.attr];
                                s && (r = e1[this.dst], 0 < (o = a[this.src]).length ? ((n = !r) && (e1[this.dst] = r = i.createBuffer()), i.bindBuffer(i.ARRAY_BUFFER, r), !n && !1 === a.dirtyFlags[this.src] || (n = (e1 = this.map) ? e1(o) : o, this._renderer._bindBuffer(r, i.ARRAY_BUFFER, n), a.dirtyFlags[this.src] = !1), t.enableAttrib(s, this.size)) : -1 !== (e1 = s.location) && this._renderer.registerEnabled[e1] && (i.disableVertexAttribArray(e1), this._renderer.registerEnabled[e1] = !1));
                            }
                        }
                    ], o(e1.prototype, t), r && o(e1, r), i;
                }();
                e1 = e1.default.RenderBuffer;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.map": 163
            }
        ],
        326: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.map"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var l = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, u = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function c(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                e1("./p5.RenderBuffer"), l.default.RendererGL.prototype.beginShape = function(e1) {
                    return this.immediateMode.shapeMode = void 0 !== e1 ? e1 : u.TESS, this.immediateMode.geometry.reset(), this;
                };
                var d = {
                    vertices: 1,
                    vertexNormals: 1,
                    vertexColors: 4,
                    vertexStrokeColors: 4,
                    uvs: 2
                }, n = (l.default.RendererGL.prototype.vertex = function(e1, t) {
                    if (this.immediateMode.shapeMode === u.QUADS && this.immediateMode.geometry.vertices.length % 6 == 3) for(var r in d){
                        var o = d[r], r = this.immediateMode.geometry[r];
                        r.push.apply(r, c(r.slice(r.length - 3 * o, r.length - 2 * o)).concat(c(r.slice(r.length - o, r.length))));
                    }
                    var n, s, i = n = s = 0, a = (3 === arguments.length ? i = arguments[2] : 4 === arguments.length ? (n = arguments[2], s = arguments[3]) : 5 === arguments.length && (i = arguments[2], n = arguments[3], s = arguments[4]), new l.default.Vector(e1, t, i)), a = (this.immediateMode.geometry.vertices.push(a), this.immediateMode.geometry.vertexNormals.push(this._currentNormal), this.curFillColor || [
                        .5,
                        .5,
                        .5,
                        1
                    ]), a = (this.immediateMode.geometry.vertexColors.push(a[0], a[1], a[2], a[3]), this.curStrokeColor || [
                        .5,
                        .5,
                        .5,
                        1
                    ]);
                    return this.immediateMode.geometry.vertexStrokeColors.push(a[0], a[1], a[2], a[3]), this.textureMode === u.IMAGE && (null !== this._tex ? 0 < this._tex.width && 0 < this._tex.height && (n /= this._tex.width, s /= this._tex.height) : !this.isProcessingVertices && null === this._tex && 4 <= arguments.length && console.warn("You must first call texture() before using vertex() with image based u and v coordinates")), this.immediateMode.geometry.uvs.push(n, s), this.immediateMode._bezierVertex[0] = e1, this.immediateMode._bezierVertex[1] = t, this.immediateMode._bezierVertex[2] = i, this.immediateMode._quadraticVertex[0] = e1, this.immediateMode._quadraticVertex[1] = t, this.immediateMode._quadraticVertex[2] = i, this;
                }, l.default.RendererGL.prototype.normal = function(e1, t, r) {
                    return e1 instanceof l.default.Vector ? this._currentNormal = e1 : this._currentNormal = new l.default.Vector(e1, t, r), this;
                }, l.default.RendererGL.prototype.endShape = function(e1, t, r, o, n, s) {
                    return this.immediateMode.shapeMode === u.POINTS ? this._drawPoints(this.immediateMode.geometry.vertices, this.immediateMode.buffers.point) : (this.isProcessingVertices = !0, this._processVertices.apply(this, arguments), this.isProcessingVertices = !1, this._doFill && 1 < this.immediateMode.geometry.vertices.length && this._drawImmediateFill(), this._doStroke && 1 < this.immediateMode.geometry.lineVertices.length && this._drawImmediateStroke(), this.isBezier = !1, this.isQuadratic = !1, this.isCurve = !1, this.immediateMode._bezierVertex.length = 0, this.immediateMode._quadraticVertex.length = 0, this.immediateMode._curveVertex.length = 0), this;
                }, l.default.RendererGL.prototype._processVertices = function(e1) {
                    var t;
                    0 !== this.immediateMode.geometry.vertices.length && (t = this._doStroke, e1 = e1 === u.CLOSE, t && (this.immediateMode.geometry.edges = this._calculateEdges(this.immediateMode.shapeMode, this.immediateMode.geometry.vertices, e1), this.immediateMode.geometry._edgesToVertices()), t = this.immediateMode.shapeMode === u.TESS, this._doFill && (this.isBezier || this.isQuadratic || this.isCurve || t) && this.immediateMode.shapeMode !== u.LINES && this._tesselateShape());
                }, l.default.RendererGL.prototype._calculateEdges = function(e1, t, r) {
                    var o = [], n = 0;
                    switch(e1){
                        case u.TRIANGLE_STRIP:
                            for(n = 0; n < t.length - 2; n++)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n,
                                n + 2
                            ]);
                            o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        case u.TRIANGLE_FAN:
                            for(n = 1; n < t.length - 1; n++)o.push([
                                0,
                                n
                            ]), o.push([
                                n,
                                n + 1
                            ]);
                            o.push([
                                0,
                                t.length - 1
                            ]);
                            break;
                        case u.TRIANGLES:
                            for(n = 0; n < t.length - 2; n += 3)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n + 1,
                                n + 2
                            ]), o.push([
                                n + 2,
                                n
                            ]);
                            break;
                        case u.LINES:
                            for(n = 0; n < t.length - 1; n += 2)o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        case u.QUADS:
                            for(n = 0; n < t.length - 5; n += 6)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n + 1,
                                n + 2
                            ]), o.push([
                                n + 3,
                                n + 5
                            ]), o.push([
                                n + 4,
                                n + 5
                            ]);
                            break;
                        case u.QUAD_STRIP:
                            for(n = 0; n < t.length - 2; n += 2)o.push([
                                n,
                                n + 1
                            ]), o.push([
                                n,
                                n + 2
                            ]), o.push([
                                n + 1,
                                n + 3
                            ]);
                            o.push([
                                n,
                                n + 1
                            ]);
                            break;
                        default:
                            for(n = 0; n < t.length - 1; n++)o.push([
                                n,
                                n + 1
                            ]);
                    }
                    return r && o.push([
                        t.length - 1,
                        0
                    ]), o;
                }, l.default.RendererGL.prototype._tesselateShape = function() {
                    for(var r = this, e1 = (this.immediateMode.shapeMode = u.TRIANGLES, [
                        this._flatten(this.immediateMode.geometry.vertices.map(function(e1, t) {
                            return [
                                e1.x,
                                e1.y,
                                e1.z,
                                r.immediateMode.geometry.uvs[2 * t],
                                r.immediateMode.geometry.uvs[2 * t + 1],
                                r.immediateMode.geometry.vertexColors[4 * t],
                                r.immediateMode.geometry.vertexColors[4 * t + 1],
                                r.immediateMode.geometry.vertexColors[4 * t + 2],
                                r.immediateMode.geometry.vertexColors[4 * t + 3],
                                r.immediateMode.geometry.vertexNormals[t].x,
                                r.immediateMode.geometry.vertexNormals[t].y,
                                r.immediateMode.geometry.vertexNormals[t].z
                            ];
                        }))
                    ]), t = this._triangulate(e1), o = (this.immediateMode.geometry.vertices = [], this.immediateMode.geometry.vertexNormals = [], this.immediateMode.geometry.uvs = [], []), n = 0, s = t.length; n < s; n += l.default.RendererGL.prototype.tessyVertexSize)o.push.apply(o, c(t.slice(n + 5, n + 9))), this.normal.apply(this, c(t.slice(n + 9, n + 12))), this.vertex.apply(this, c(t.slice(n, n + 5)));
                    this.immediateMode.geometry.vertexColors = o;
                }, l.default.RendererGL.prototype._drawImmediateFill = function() {
                    var e1 = this.GL, t = (this._useVertexColor = 0 < this.immediateMode.geometry.vertexColors.length, this._getImmediateFillShader()), r = (this._setFillUniforms(t), !0), o = !1, n = void 0;
                    try {
                        for(var s, i = this.immediateMode.buffers.fill[Symbol.iterator](); !(r = (s = i.next()).done); r = !0)s.value._prepareBuffer(this.immediateMode.geometry, t);
                    } catch (e1) {
                        o = !0, n = e1;
                    } finally{
                        try {
                            r || null == i.return || i.return();
                        } finally{
                            if (o) throw n;
                        }
                    }
                    this.immediateMode.shapeMode !== u.LINE_STRIP && this.immediateMode.shapeMode !== u.LINES || (this.immediateMode.shapeMode = u.TRIANGLE_FAN), this.immediateMode.shapeMode === u.QUADS ? this.immediateMode.shapeMode = u.TRIANGLES : this.immediateMode.shapeMode === u.QUAD_STRIP && (this.immediateMode.shapeMode = u.TRIANGLE_STRIP), this._applyColorBlend(this.curFillColor), e1.drawArrays(this.immediateMode.shapeMode, 0, this.immediateMode.geometry.vertices.length), t.unbindShader();
                }, l.default.RendererGL.prototype._drawImmediateStroke = function() {
                    var e1 = this.GL, t = e1.isEnabled(e1.CULL_FACE), r = (e1.disable(e1.CULL_FACE), this._getImmediateStrokeShader()), o = (this._useLineColor = 0 < this.immediateMode.geometry.vertexStrokeColors.length, this._setStrokeUniforms(r), !0), n = !1, s = void 0;
                    try {
                        for(var i, a = this.immediateMode.buffers.stroke[Symbol.iterator](); !(o = (i = a.next()).done); o = !0)i.value._prepareBuffer(this.immediateMode.geometry, r);
                    } catch (e1) {
                        n = !0, s = e1;
                    } finally{
                        try {
                            o || null == a.return || a.return();
                        } finally{
                            if (n) throw s;
                        }
                    }
                    this._applyColorBlend(this.curStrokeColor), e1.drawArrays(e1.TRIANGLES, 0, this.immediateMode.geometry.lineVertices.length), t && e1.enable(e1.CULL_FACE), r.unbindShader();
                }, l.default.RendererGL);
                r.default = n;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "./p5.RenderBuffer": 325,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.map": 163,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        327: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.object.keys"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var a = (u = e1("../core/main")) && u.__esModule ? u : {
                    default: u
                }, n = (e1("./p5.RendererGL"), e1("./p5.RenderBuffer"), function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                var s = 0, u = (a.default.RendererGL.prototype._initBufferDefaults = function(e1) {
                    var t;
                    return this._freeBuffers(e1), 1e3 < ++s && (t = Object.keys(this.retainedMode.geometry)[0], delete this.retainedMode.geometry[t], s--), this.retainedMode.geometry[e1] = {};
                }, a.default.RendererGL.prototype._freeBuffers = function(e1) {
                    var a, l = this.retainedMode.geometry[e1];
                    function t(e1) {
                        var t = !0, r = !1, o = void 0;
                        try {
                            for(var n, s = e1[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                var i = n.value;
                                l[i.dst] && (a.deleteBuffer(l[i.dst]), l[i.dst] = null);
                            }
                        } catch (e1) {
                            r = !0, o = e1;
                        } finally{
                            try {
                                t || null == s.return || s.return();
                            } finally{
                                if (r) throw o;
                            }
                        }
                    }
                    l && (delete this.retainedMode.geometry[e1], s--, a = this.GL, l.indexBuffer && a.deleteBuffer(l.indexBuffer), t(this.retainedMode.buffers.stroke), t(this.retainedMode.buffers.fill));
                }, a.default.RendererGL.prototype.createBuffers = function(e1, t) {
                    var r, o, n, s = this.GL, e1 = this._initBufferDefaults(e1), i = (e1.model = t, e1.indexBuffer);
                    return t.faces.length ? (i = i || (e1.indexBuffer = s.createBuffer()), n = (o = (r = a.default.RendererGL.prototype._flatten(t.faces)).some(function(e1) {
                        return 65535 < e1;
                    })) ? Uint32Array : Uint16Array, this._bindBuffer(i, s.ELEMENT_ARRAY_BUFFER, r, n), e1.indexBufferType = o ? s.UNSIGNED_INT : s.UNSIGNED_SHORT, e1.vertexCount = 3 * t.faces.length) : (i && (s.deleteBuffer(i), e1.indexBuffer = null), e1.vertexCount = t.vertices ? t.vertices.length : 0), e1.lineVertexCount = t.lineVertices ? t.lineVertices.length : 0, e1;
                }, a.default.RendererGL.prototype.drawBuffers = function(e1) {
                    var t = this.GL, r = this.retainedMode.geometry[e1];
                    if (this._doFill) {
                        this._useVertexColor = 0 < r.model.vertexColors.length;
                        var o = this._getRetainedFillShader(), n = (this._setFillUniforms(o), !0), s = !1, i = void 0;
                        try {
                            for(var a, l = this.retainedMode.buffers.fill[Symbol.iterator](); !(n = (a = l.next()).done); n = !0)a.value._prepareBuffer(r, o);
                        } catch (e1) {
                            s = !0, i = e1;
                        } finally{
                            try {
                                n || null == l.return || l.return();
                            } finally{
                                if (s) throw i;
                            }
                        }
                        r.indexBuffer && this._bindBuffer(r.indexBuffer, t.ELEMENT_ARRAY_BUFFER), this._applyColorBlend(this.curFillColor), this._drawElements(t.TRIANGLES, e1), o.unbindShader();
                    }
                    if (this._doStroke && 0 < r.lineVertexCount) {
                        var s = t.isEnabled(t.CULL_FACE), u = (t.disable(t.CULL_FACE), this._getRetainedStrokeShader()), c = (this._useLineColor = 0 < r.model.vertexStrokeColors.length, this._setStrokeUniforms(u), !0), i = !1, d = void 0;
                        try {
                            for(var f, h = this.retainedMode.buffers.stroke[Symbol.iterator](); !(c = (f = h.next()).done); c = !0)f.value._prepareBuffer(r, u);
                        } catch (e1) {
                            i = !0, d = e1;
                        } finally{
                            try {
                                c || null == h.return || h.return();
                            } finally{
                                if (i) throw d;
                            }
                        }
                        this._applyColorBlend(this.curStrokeColor), this._drawArrays(t.TRIANGLES, e1), s && t.enable(t.CULL_FACE), u.unbindShader();
                    }
                    return this;
                }, a.default.RendererGL.prototype.drawBuffersScaled = function(e1, t, r, o) {
                    var n = this.uMVMatrix.copy();
                    try {
                        this.uMVMatrix.scale(t, r, o), this.drawBuffers(e1);
                    } finally{
                        this.uMVMatrix = n;
                    }
                }, a.default.RendererGL.prototype._drawArrays = function(e1, t) {
                    return this.GL.drawArrays(e1, 0, this.retainedMode.geometry[t].lineVertexCount), this;
                }, a.default.RendererGL.prototype._drawElements = function(e1, t) {
                    var t = this.retainedMode.geometry[t], r = this.GL;
                    if (t.indexBuffer) {
                        if (this._pInst.webglVersion !== n.WEBGL2 && t.indexBufferType === r.UNSIGNED_INT && !r.getExtension("OES_element_index_uint")) throw new Error("Unable to render a 3d model with > 65535 triangles. Your web browser does not support the WebGL Extension OES_element_index_uint.");
                        r.drawElements(r.TRIANGLES, t.vertexCount, t.indexBufferType, 0);
                    } else r.drawArrays(e1 || r.TRIANGLES, 0, t.vertexCount);
                }, a.default.RendererGL.prototype._drawPoints = function(e1, t) {
                    var r = this.GL, o = this._getImmediatePointShader();
                    this._setPointUniforms(o), this._bindBuffer(t, r.ARRAY_BUFFER, this._vToNArray(e1), Float32Array, r.STATIC_DRAW), o.enableAttrib(o.attributes.aPosition, 3), this._applyColorBlend(this.curStrokeColor), r.drawArrays(r.Points, 0, e1.length), o.unbindShader();
                }, a.default.RendererGL);
                r.default = u;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "./p5.RenderBuffer": 325,
                "./p5.RendererGL": 328,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.some": 165,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.keys": 179,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.float32-array": 209,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint16-array": 230,
                "core-js/modules/es.typed-array.uint32-array": 231,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        328: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.float64-array"), e1("core-js/modules/es.typed-array.int16-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.concat"), e1("core-js/modules/es.array.copy-within"), e1("core-js/modules/es.array.every"), e1("core-js/modules/es.array.fill"), e1("core-js/modules/es.array.from"), e1("core-js/modules/es.array.includes"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.array.some"), e1("core-js/modules/es.map"), e1("core-js/modules/es.object.assign"), e1("core-js/modules/es.object.get-prototype-of"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.reflect.construct"), e1("core-js/modules/es.regexp.to-string"), e1("core-js/modules/es.set"), e1("core-js/modules/es.string.includes"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.float32-array"), e1("core-js/modules/es.typed-array.float64-array"), e1("core-js/modules/es.typed-array.int16-array"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.uint16-array"), e1("core-js/modules/es.typed-array.uint32-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.readPixelsWebGL = w, r.readPixelWebGL = S, r.default = void 0;
                var g = n(e1("../core/main")), i = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== u(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants")), a = n(e1("libtess"));
                e1("./p5.Shader"), e1("./p5.Camera"), e1("../core/p5.Renderer"), e1("./p5.Matrix"), e1("path");
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function n(e1) {
                    return e1 && e1.__esModule ? e1 : {
                        default: e1
                    };
                }
                function u(e1) {
                    return (u = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                function c(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) {
                            for(var t = 0, r = new Array(e1.length); t < e1.length; t++)r[t] = e1[t];
                            return r;
                        }
                    }(e1) || function(e1) {
                        if (Symbol.iterator in Object(e1) || "[object Arguments]" === Object.prototype.toString.call(e1)) return Array.from(e1);
                    }(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance");
                    }();
                }
                function d(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function f(e1, t) {
                    return (f = Object.setPrototypeOf || function(e1, t) {
                        return e1.__proto__ = t, e1;
                    })(e1, t);
                }
                function h(o) {
                    return function() {
                        var e1, t, r = s(o);
                        return e1 = function() {
                            if ("undefined" != typeof Reflect && Reflect.construct && !Reflect.construct.sham) {
                                if ("function" == typeof Proxy) return 1;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), 1;
                                } catch (e1) {}
                            }
                        }() ? (e1 = s(this).constructor, Reflect.construct(r, arguments, e1)) : r.apply(this, arguments), r = this, !(t = e1) || "object" !== u(t) && "function" != typeof t ? p(r) : t;
                    };
                }
                function p(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                function s(e1) {
                    return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    })(e1);
                }
                function m(e1, t) {
                    j += "#define STROKE_CAP_".concat(e1, " ").concat(t, "\n"), v[i[e1]] = t;
                }
                function y(e1, t) {
                    j += "#define STROKE_JOIN_".concat(e1, " ").concat(t, "\n"), b[i[e1]] = t;
                }
                var v = {}, b = {}, j = "", e1 = (m("ROUND", 0), m("PROJECT", 1), m("SQUARE", 2), y("ROUND", 0), y("MITER", 1), y("BEVEL", 2), "precision highp float;\nprecision highp int;\n\nuniform mat4 uViewMatrix;\n\nuniform bool uUseLighting;\n\nuniform int uAmbientLightCount;\nuniform vec3 uAmbientColor[5];\n\nuniform int uDirectionalLightCount;\nuniform vec3 uLightingDirection[5];\nuniform vec3 uDirectionalDiffuseColors[5];\nuniform vec3 uDirectionalSpecularColors[5];\n\nuniform int uPointLightCount;\nuniform vec3 uPointLightLocation[5];\nuniform vec3 uPointLightDiffuseColors[5];	\nuniform vec3 uPointLightSpecularColors[5];\n\nuniform int uSpotLightCount;\nuniform float uSpotLightAngle[5];\nuniform float uSpotLightConc[5];\nuniform vec3 uSpotLightDiffuseColors[5];\nuniform vec3 uSpotLightSpecularColors[5];\nuniform vec3 uSpotLightLocation[5];\nuniform vec3 uSpotLightDirection[5];\n\nuniform bool uSpecular;\nuniform float uShininess;\n\nuniform float uConstantAttenuation;\nuniform float uLinearAttenuation;\nuniform float uQuadraticAttenuation;\n\nconst float specularFactor = 2.0;\nconst float diffuseFactor = 0.73;\n\nstruct LightResult {\n  float specular;\n  float diffuse;\n};\n\nfloat _phongSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float shininess) {\n\n  vec3 R = reflect(lightDirection, surfaceNormal);\n  return pow(max(0.0, dot(R, viewDirection)), shininess);\n}\n\nfloat _lambertDiffuse(vec3 lightDirection, vec3 surfaceNormal) {\n  return max(0.0, dot(-lightDirection, surfaceNormal));\n}\n\nLightResult _light(vec3 viewDirection, vec3 normal, vec3 lightVector) {\n\n  vec3 lightDir = normalize(lightVector);\n\n  //compute our diffuse & specular terms\n  LightResult lr;\n  if (uSpecular)\n    lr.specular = _phongSpecular(lightDir, viewDirection, normal, uShininess);\n  lr.diffuse = _lambertDiffuse(lightDir, normal);\n  return lr;\n}\n\nvoid totalLight(\n  vec3 modelPosition,\n  vec3 normal,\n  out vec3 totalDiffuse,\n  out vec3 totalSpecular\n) {\n\n  totalSpecular = vec3(0.0);\n\n  if (!uUseLighting) {\n    totalDiffuse = vec3(1.0);\n    return;\n  }\n\n  totalDiffuse = vec3(0.0);\n\n  vec3 viewDirection = normalize(-modelPosition);\n\n  for (int j = 0; j < 5; j++) {\n    if (j < uDirectionalLightCount) {\n      vec3 lightVector = (uViewMatrix * vec4(uLightingDirection[j], 0.0)).xyz;\n      vec3 lightColor = uDirectionalDiffuseColors[j];\n      vec3 specularColor = uDirectionalSpecularColors[j];\n      LightResult result = _light(viewDirection, normal, lightVector);\n      totalDiffuse += result.diffuse * lightColor;\n      totalSpecular += result.specular * lightColor * specularColor;\n    }\n\n    if (j < uPointLightCount) {\n      vec3 lightPosition = (uViewMatrix * vec4(uPointLightLocation[j], 1.0)).xyz;\n      vec3 lightVector = modelPosition - lightPosition;\n    \n      //calculate attenuation\n      float lightDistance = length(lightVector);\n      float lightFalloff = 1.0 / (uConstantAttenuation + lightDistance * uLinearAttenuation + (lightDistance * lightDistance) * uQuadraticAttenuation);\n      vec3 lightColor = lightFalloff * uPointLightDiffuseColors[j];\n      vec3 specularColor = lightFalloff * uPointLightSpecularColors[j];\n\n      LightResult result = _light(viewDirection, normal, lightVector);\n      totalDiffuse += result.diffuse * lightColor;\n      totalSpecular += result.specular * lightColor * specularColor;\n    }\n\n    if(j < uSpotLightCount) {\n      vec3 lightPosition = (uViewMatrix * vec4(uSpotLightLocation[j], 1.0)).xyz;\n      vec3 lightVector = modelPosition - lightPosition;\n    \n      float lightDistance = length(lightVector);\n      float lightFalloff = 1.0 / (uConstantAttenuation + lightDistance * uLinearAttenuation + (lightDistance * lightDistance) * uQuadraticAttenuation);\n\n      vec3 lightDirection = (uViewMatrix * vec4(uSpotLightDirection[j], 0.0)).xyz;\n      float spotDot = dot(normalize(lightVector), normalize(lightDirection));\n      float spotFalloff;\n      if(spotDot < uSpotLightAngle[j]) {\n        spotFalloff = 0.0;\n      }\n      else {\n        spotFalloff = pow(spotDot, uSpotLightConc[j]);\n      }\n      lightFalloff *= spotFalloff;\n\n      vec3 lightColor = uSpotLightDiffuseColors[j];\n      vec3 specularColor = uSpotLightSpecularColors[j];\n     \n      LightResult result = _light(viewDirection, normal, lightVector);\n      \n      totalDiffuse += result.diffuse * lightColor * lightFalloff;\n      totalSpecular += result.specular * lightColor * specularColor * lightFalloff;\n    }\n  }\n\n  totalDiffuse *= diffuseFactor;\n  totalSpecular *= specularFactor;\n}\n"), _ = "#ifdef WEBGL2\n\n#define IN in\n#define OUT out\n\n#ifdef FRAGMENT_SHADER\nout vec4 outColor;\n#define OUT_COLOR outColor\n#endif\n#define TEXTURE texture\n\n#else\n\n#ifdef FRAGMENT_SHADER\n#define IN varying\n#else\n#define IN attribute\n#endif\n#define OUT varying\n#define TEXTURE texture2D\n\n#ifdef FRAGMENT_SHADER\n#define OUT_COLOR gl_FragColor\n#endif\n\n#endif\n", x = {
                    immediateVert: "attribute vec3 aPosition;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uResolution;\nuniform float uPointSize;\n\nvarying vec4 vColor;\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n  gl_PointSize = uPointSize;\n}\n",
                    vertexColorVert: "attribute vec3 aPosition;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n}\n",
                    vertexColorFrag: "precision mediump float;\nvarying vec4 vColor;\nvoid main(void) {\n  gl_FragColor = vec4(vColor.rgb, 1.) * vColor.a;\n}\n",
                    normalVert: "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nuniform vec4 uMaterialColor;\nuniform bool uUseVertexColor;\n\nvarying vec3 vVertexNormal;\nvarying highp vec2 vVertTexCoord;\nvarying vec4 vColor;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vVertexNormal = normalize(vec3( uNormalMatrix * aNormal ));\n  vVertTexCoord = aTexCoord;\n  vColor = (uUseVertexColor ? aVertexColor : uMaterialColor);\n}\n",
                    normalFrag: "precision mediump float;\nvarying vec3 vVertexNormal;\nvoid main(void) {\n  gl_FragColor = vec4(vVertexNormal, 1.0);\n}",
                    basicFrag: "precision mediump float;\nvarying vec4 vColor;\nvoid main(void) {\n  gl_FragColor = vec4(vColor.rgb, 1.) * vColor.a;\n}\n",
                    lightVert: e1 + "// include lighting.glgl\n\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nuniform bool uUseVertexColor;\nuniform vec4 uMaterialColor;\n\nvarying highp vec2 vVertTexCoord;\nvarying vec3 vDiffuseColor;\nvarying vec3 vSpecularColor;\nvarying vec4 vColor;\n\nvoid main(void) {\n\n  vec4 viewModelPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * viewModelPosition;\n\n  vec3 vertexNormal = normalize(uNormalMatrix * aNormal);\n  vVertTexCoord = aTexCoord;\n\n  totalLight(viewModelPosition.xyz, vertexNormal, vDiffuseColor, vSpecularColor);\n\n  for (int i = 0; i < 8; i++) {\n    if (i < uAmbientLightCount) {\n      vDiffuseColor += uAmbientColor[i];\n    }\n  }\n  \n  vColor = (uUseVertexColor ? aVertexColor : uMaterialColor);\n}\n",
                    lightTextureFrag: "precision highp float;\n\nuniform vec4 uTint;\nuniform sampler2D uSampler;\nuniform bool isTexture;\nuniform bool uEmissive;\n\nvarying highp vec2 vVertTexCoord;\nvarying vec3 vDiffuseColor;\nvarying vec3 vSpecularColor;\nvarying vec4 vColor;\n\nvoid main(void) {\n  if(uEmissive && !isTexture) {\n    gl_FragColor = vColor;\n  }\n  else {\n    vec4 baseColor = isTexture\n      // Textures come in with premultiplied alpha. To apply tint and still have\n      // premultiplied alpha output, we need to multiply the RGB channels by the\n      // tint RGB, and all channels by the tint alpha.\n      ? texture2D(uSampler, vVertTexCoord) * vec4(uTint.rgb/255., 1.) * (uTint.a/255.)\n      // Colors come in with unmultiplied alpha, so we need to multiply the RGB\n      // channels by alpha to convert it to premultiplied alpha.\n      : vec4(vColor.rgb * vColor.a, vColor.a);\n    gl_FragColor = vec4(baseColor.rgb * vDiffuseColor + vSpecularColor, baseColor.a);\n  }\n}\n",
                    phongVert: "precision highp float;\nprecision highp int;\n\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nattribute vec4 aVertexColor;\n\nuniform vec3 uAmbientColor[5];\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\nuniform int uAmbientLightCount;\n\nuniform bool uUseVertexColor;\nuniform vec4 uMaterialColor;\n\nvarying vec3 vNormal;\nvarying vec2 vTexCoord;\nvarying vec3 vViewPosition;\nvarying vec3 vAmbientColor;\nvarying vec4 vColor;\n\nvoid main(void) {\n\n  vec4 viewModelPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n\n  // Pass varyings to fragment shader\n  vViewPosition = viewModelPosition.xyz;\n  gl_Position = uProjectionMatrix * viewModelPosition;  \n\n  vNormal = uNormalMatrix * aNormal;\n  vTexCoord = aTexCoord;\n\n  // TODO: this should be a uniform\n  vAmbientColor = vec3(0.0);\n  for (int i = 0; i < 5; i++) {\n    if (i < uAmbientLightCount) {\n      vAmbientColor += uAmbientColor[i];\n    }\n  }\n  \n  vColor = (uUseVertexColor ? aVertexColor : uMaterialColor);\n}\n",
                    phongFrag: e1 + "// include lighting.glsl\nprecision highp float;\nprecision highp int;\n\nuniform bool uHasSetAmbient;\nuniform vec4 uSpecularMatColor;\nuniform vec4 uAmbientMatColor;\nuniform vec4 uEmissiveMatColor;\n\nuniform vec4 uTint;\nuniform sampler2D uSampler;\nuniform bool isTexture;\n\nvarying vec3 vNormal;\nvarying vec2 vTexCoord;\nvarying vec3 vViewPosition;\nvarying vec3 vAmbientColor;\nvarying vec4 vColor;\n\nvoid main(void) {\n\n  vec3 diffuse;\n  vec3 specular;\n  totalLight(vViewPosition, normalize(vNormal), diffuse, specular);\n\n  // Calculating final color as result of all lights (plus emissive term).\n\n  vec4 baseColor = isTexture\n    // Textures come in with premultiplied alpha. To apply tint and still have\n    // premultiplied alpha output, we need to multiply the RGB channels by the\n    // tint RGB, and all channels by the tint alpha.\n    ? texture2D(uSampler, vTexCoord) * vec4(uTint.rgb/255., 1.) * (uTint.a/255.)\n    // Colors come in with unmultiplied alpha, so we need to multiply the RGB\n    // channels by alpha to convert it to premultiplied alpha.\n    : vec4(vColor.rgb * vColor.a, vColor.a);\n  gl_FragColor = vec4(diffuse * baseColor.rgb + \n                    vAmbientColor * (\n                      uHasSetAmbient ? uAmbientMatColor.rgb : baseColor.rgb\n                    ) + \n                    specular * uSpecularMatColor.rgb + \n                    uEmissiveMatColor.rgb, baseColor.a);\n}\n",
                    fontVert: _ + "IN vec3 aPosition;\nIN vec2 aTexCoord;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nuniform vec4 uGlyphRect;\nuniform float uGlyphOffset;\n\nOUT vec2 vTexCoord;\nOUT float w;\n\nvoid main() {\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n\n  // scale by the size of the glyph's rectangle\n  positionVec4.xy *= uGlyphRect.zw - uGlyphRect.xy;\n\n  // Expand glyph bounding boxes by 1px on each side to give a bit of room\n  // for antialiasing\n  vec2 pixelScale = vec2(\n    1. / uModelViewMatrix[0][0],\n    1. / uModelViewMatrix[1][1]\n  );\n  vec2 offset = pixelScale * normalize(aTexCoord - vec2(0.5, 0.5)) * vec2(1., -1.);\n  vec2 textureOffset = offset * (1. / vec2(\n    uGlyphRect.z - uGlyphRect.x,\n    uGlyphRect.w - uGlyphRect.y\n  ));\n\n  // move to the corner of the glyph\n  positionVec4.xy += uGlyphRect.xy;\n\n  // move to the letter's line offset\n  positionVec4.x += uGlyphOffset;\n\n  positionVec4.xy += offset;\n  \n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vTexCoord = aTexCoord + textureOffset;\n  w = gl_Position.w;\n}\n",
                    fontFrag: _ + "#ifndef WEBGL2\n#extension GL_OES_standard_derivatives : enable\n#endif\n\n#if 0\n  // simulate integer math using floats\n	#define int float\n	#define ivec2 vec2\n	#define INT(x) float(x)\n\n	int ifloor(float v) { return floor(v); }\n	ivec2 ifloor(vec2 v) { return floor(v); }\n\n#else\n  // use native integer math\n	precision highp int;\n	#define INT(x) x\n\n	int ifloor(float v) { return int(v); }\n	int ifloor(int v) { return v; }\n	ivec2 ifloor(vec2 v) { return ivec2(v); }\n\n#endif\n\nuniform sampler2D uSamplerStrokes;\nuniform sampler2D uSamplerRowStrokes;\nuniform sampler2D uSamplerRows;\nuniform sampler2D uSamplerColStrokes;\nuniform sampler2D uSamplerCols;\n\nuniform ivec2 uStrokeImageSize;\nuniform ivec2 uCellsImageSize;\nuniform ivec2 uGridImageSize;\n\nuniform ivec2 uGridOffset;\nuniform ivec2 uGridSize;\nuniform vec4 uMaterialColor;\n\nIN vec2 vTexCoord;\n\n// some helper functions\nint ROUND(float v) { return ifloor(v + 0.5); }\nivec2 ROUND(vec2 v) { return ifloor(v + 0.5); }\nfloat saturate(float v) { return clamp(v, 0.0, 1.0); }\nvec2 saturate(vec2 v) { return clamp(v, 0.0, 1.0); }\n\nint mul(float v1, int v2) {\n  return ifloor(v1 * float(v2));\n}\n\nivec2 mul(vec2 v1, ivec2 v2) {\n  return ifloor(v1 * vec2(v2) + 0.5);\n}\n\n// unpack a 16-bit integer from a float vec2\nint getInt16(vec2 v) {\n  ivec2 iv = ROUND(v * 255.0);\n  return iv.x * INT(128) + iv.y;\n}\n\nvec2 pixelScale;\nvec2 coverage = vec2(0.0);\nvec2 weight = vec2(0.5);\nconst float minDistance = 1.0/8192.0;\nconst float hardness = 1.05; // amount of antialias\n\n// the maximum number of curves in a glyph\nconst int N = INT(250);\n\n// retrieves an indexed pixel from a sampler\nvec4 getTexel(sampler2D sampler, int pos, ivec2 size) {\n  int width = size.x;\n  int y = ifloor(pos / width);\n  int x = pos - y * width;  // pos % width\n\n  return TEXTURE(sampler, (vec2(x, y) + 0.5) / vec2(size));\n}\n\nvoid calulateCrossings(vec2 p0, vec2 p1, vec2 p2, out vec2 C1, out vec2 C2) {\n\n  // get the coefficients of the quadratic in t\n  vec2 a = p0 - p1 * 2.0 + p2;\n  vec2 b = p0 - p1;\n  vec2 c = p0 - vTexCoord;\n\n  // found out which values of 't' it crosses the axes\n  vec2 surd = sqrt(max(vec2(0.0), b * b - a * c));\n  vec2 t1 = ((b - surd) / a).yx;\n  vec2 t2 = ((b + surd) / a).yx;\n\n  // approximate straight lines to avoid rounding errors\n  if (abs(a.y) < 0.001)\n    t1.x = t2.x = c.y / (2.0 * b.y);\n\n  if (abs(a.x) < 0.001)\n    t1.y = t2.y = c.x / (2.0 * b.x);\n\n  // plug into quadratic formula to find the corrdinates of the crossings\n  C1 = ((a * t1 - b * 2.0) * t1 + c) * pixelScale;\n  C2 = ((a * t2 - b * 2.0) * t2 + c) * pixelScale;\n}\n\nvoid coverageX(vec2 p0, vec2 p1, vec2 p2) {\n\n  vec2 C1, C2;\n  calulateCrossings(p0, p1, p2, C1, C2);\n\n  // determine on which side of the x-axis the points lie\n  bool y0 = p0.y > vTexCoord.y;\n  bool y1 = p1.y > vTexCoord.y;\n  bool y2 = p2.y > vTexCoord.y;\n\n  // could web be under the curve (after t1)?\n  if (y1 ? !y2 : y0) {\n    // add the coverage for t1\n    coverage.x += saturate(C1.x + 0.5);\n    // calculate the anti-aliasing for t1\n    weight.x = min(weight.x, abs(C1.x));\n  }\n\n  // are we outside the curve (after t2)?\n  if (y1 ? !y0 : y2) {\n    // subtract the coverage for t2\n    coverage.x -= saturate(C2.x + 0.5);\n    // calculate the anti-aliasing for t2\n    weight.x = min(weight.x, abs(C2.x));\n  }\n}\n\n// this is essentially the same as coverageX, but with the axes swapped\nvoid coverageY(vec2 p0, vec2 p1, vec2 p2) {\n\n  vec2 C1, C2;\n  calulateCrossings(p0, p1, p2, C1, C2);\n\n  bool x0 = p0.x > vTexCoord.x;\n  bool x1 = p1.x > vTexCoord.x;\n  bool x2 = p2.x > vTexCoord.x;\n\n  if (x1 ? !x2 : x0) {\n    coverage.y -= saturate(C1.y + 0.5);\n    weight.y = min(weight.y, abs(C1.y));\n  }\n\n  if (x1 ? !x0 : x2) {\n    coverage.y += saturate(C2.y + 0.5);\n    weight.y = min(weight.y, abs(C2.y));\n  }\n}\n\nvoid main() {\n\n  // calculate the pixel scale based on screen-coordinates\n  pixelScale = hardness / fwidth(vTexCoord);\n\n  // which grid cell is this pixel in?\n  ivec2 gridCoord = ifloor(vTexCoord * vec2(uGridSize));\n\n  // intersect curves in this row\n  {\n    // the index into the row info bitmap\n    int rowIndex = gridCoord.y + uGridOffset.y;\n    // fetch the info texel\n    vec4 rowInfo = getTexel(uSamplerRows, rowIndex, uGridImageSize);\n    // unpack the rowInfo\n    int rowStrokeIndex = getInt16(rowInfo.xy);\n    int rowStrokeCount = getInt16(rowInfo.zw);\n\n    for (int iRowStroke = INT(0); iRowStroke < N; iRowStroke++) {\n      if (iRowStroke >= rowStrokeCount)\n        break;\n\n      // each stroke is made up of 3 points: the start and control point\n      // and the start of the next curve.\n      // fetch the indices of this pair of strokes:\n      vec4 strokeIndices = getTexel(uSamplerRowStrokes, rowStrokeIndex++, uCellsImageSize);\n\n      // unpack the stroke index\n      int strokePos = getInt16(strokeIndices.xy);\n\n      // fetch the two strokes\n      vec4 stroke0 = getTexel(uSamplerStrokes, strokePos + INT(0), uStrokeImageSize);\n      vec4 stroke1 = getTexel(uSamplerStrokes, strokePos + INT(1), uStrokeImageSize);\n\n      // calculate the coverage\n      coverageX(stroke0.xy, stroke0.zw, stroke1.xy);\n    }\n  }\n\n  // intersect curves in this column\n  {\n    int colIndex = gridCoord.x + uGridOffset.x;\n    vec4 colInfo = getTexel(uSamplerCols, colIndex, uGridImageSize);\n    int colStrokeIndex = getInt16(colInfo.xy);\n    int colStrokeCount = getInt16(colInfo.zw);\n    \n    for (int iColStroke = INT(0); iColStroke < N; iColStroke++) {\n      if (iColStroke >= colStrokeCount)\n        break;\n\n      vec4 strokeIndices = getTexel(uSamplerColStrokes, colStrokeIndex++, uCellsImageSize);\n\n      int strokePos = getInt16(strokeIndices.xy);\n      vec4 stroke0 = getTexel(uSamplerStrokes, strokePos + INT(0), uStrokeImageSize);\n      vec4 stroke1 = getTexel(uSamplerStrokes, strokePos + INT(1), uStrokeImageSize);\n      coverageY(stroke0.xy, stroke0.zw, stroke1.xy);\n    }\n  }\n\n  weight = saturate(1.0 - weight * 2.0);\n  float distance = max(weight.x + weight.y, minDistance); // manhattan approx.\n  float antialias = abs(dot(coverage, weight) / distance);\n  float cover = min(abs(coverage.x), abs(coverage.y));\n  OUT_COLOR = vec4(uMaterialColor.rgb, 1.) * uMaterialColor.a;\n  OUT_COLOR *= saturate(max(antialias, cover));\n}\n",
                    lineVert: j + "/*\n  Part of the Processing project - http://processing.org\n  Copyright (c) 2012-15 The Processing Foundation\n  Copyright (c) 2004-12 Ben Fry and Casey Reas\n  Copyright (c) 2001-04 Massachusetts Institute of Technology\n  This library is free software; you can redistribute it and/or\n  modify it under the terms of the GNU Lesser General Public\n  License as published by the Free Software Foundation, version 2.1.\n  This library is distributed in the hope that it will be useful,\n  but WITHOUT ANY WARRANTY; without even the implied warranty of\n  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU\n  Lesser General Public License for more details.\n  You should have received a copy of the GNU Lesser General\n  Public License along with this library; if not, write to the\n  Free Software Foundation, Inc., 59 Temple Place, Suite 330,\n  Boston, MA  02111-1307  USA\n*/\n\n#define PROCESSING_LINE_SHADER\n\nprecision mediump float;\nprecision mediump int;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uStrokeWeight;\n\nuniform bool uUseLineColor;\nuniform vec4 uMaterialColor;\n\nuniform vec4 uViewport;\nuniform int uPerspective;\nuniform int uStrokeJoin;\n\nattribute vec4 aPosition;\nattribute vec3 aTangentIn;\nattribute vec3 aTangentOut;\nattribute float aSide;\nattribute vec4 aVertexColor;\n\nvarying vec4 vColor;\nvarying vec2 vTangent;\nvarying vec2 vCenter;\nvarying vec2 vPosition;\nvarying float vMaxDist;\nvarying float vCap;\nvarying float vJoin;\n\nvec2 lineIntersection(vec2 aPoint, vec2 aDir, vec2 bPoint, vec2 bDir) {\n  // Rotate and translate so a starts at the origin and goes out to the right\n  bPoint -= aPoint;\n  vec2 rotatedBFrom = vec2(\n    bPoint.x*aDir.x + bPoint.y*aDir.y,\n    bPoint.y*aDir.x - bPoint.x*aDir.y\n  );\n  vec2 bTo = bPoint + bDir;\n  vec2 rotatedBTo = vec2(\n    bTo.x*aDir.x + bTo.y*aDir.y,\n    bTo.y*aDir.x - bTo.x*aDir.y\n  );\n  float intersectionDistance =\n    rotatedBTo.x + (rotatedBFrom.x - rotatedBTo.x) * rotatedBTo.y /\n    (rotatedBTo.y - rotatedBFrom.y);\n  return aPoint + aDir * intersectionDistance;\n}\n\nvoid main() {\n  // Caps have one of either the in or out tangent set to 0\n  vCap = (aTangentIn == vec3(0.)) != (aTangentOut == (vec3(0.)))\n    ? 1. : 0.;\n\n  // Joins have two unique, defined tangents\n  vJoin = (\n    aTangentIn != vec3(0.) &&\n    aTangentOut != vec3(0.) &&\n    aTangentIn != aTangentOut\n  ) ? 1. : 0.;\n\n  vec4 posp = uModelViewMatrix * aPosition;\n  vec4 posqIn = uModelViewMatrix * (aPosition + vec4(aTangentIn, 0));\n  vec4 posqOut = uModelViewMatrix * (aPosition + vec4(aTangentOut, 0));\n\n  float facingCamera = pow(\n    // The word space tangent's z value is 0 if it's facing the camera\n    abs(normalize(posqIn-posp).z),\n\n    // Using pow() here to ramp `facingCamera` up from 0 to 1 really quickly\n    // so most lines get scaled and don't get clipped\n    0.25\n  );\n\n  // using a scale <1 moves the lines towards the camera\n  // in order to prevent popping effects due to half of\n  // the line disappearing behind the geometry faces.\n  float scale = mix(1., 0.995, facingCamera);\n\n  // Moving vertices slightly toward the camera\n  // to avoid depth-fighting with the fill triangles.\n  // Discussed here:\n  // http://www.opengl.org/discussion_boards/ubbthreads.php?ubb=showflat&Number=252848  \n  posp.xyz = posp.xyz * scale;\n  posqIn.xyz = posqIn.xyz * scale;\n  posqOut.xyz = posqOut.xyz * scale;\n\n  vec4 p = uProjectionMatrix * posp;\n  vec4 qIn = uProjectionMatrix * posqIn;\n  vec4 qOut = uProjectionMatrix * posqOut;\n  vCenter = p.xy;\n\n  // formula to convert from clip space (range -1..1) to screen space (range 0..[width or height])\n  // screen_p = (p.xy/p.w + <1,1>) * 0.5 * uViewport.zw\n\n  // prevent division by W by transforming the tangent formula (div by 0 causes\n  // the line to disappear, see https://github.com/processing/processing/issues/5183)\n  // t = screen_q - screen_p\n  //\n  // tangent is normalized and we don't care which aDirection it points to (+-)\n  // t = +- normalize( screen_q - screen_p )\n  // t = +- normalize( (q.xy/q.w+<1,1>)*0.5*uViewport.zw - (p.xy/p.w+<1,1>)*0.5*uViewport.zw )\n  //\n  // extract common factor, <1,1> - <1,1> cancels out\n  // t = +- normalize( (q.xy/q.w - p.xy/p.w) * 0.5 * uViewport.zw )\n  //\n  // convert to common divisor\n  // t = +- normalize( ((q.xy*p.w - p.xy*q.w) / (p.w*q.w)) * 0.5 * uViewport.zw )\n  //\n  // remove the common scalar divisor/factor, not needed due to normalize and +-\n  // (keep uViewport - can't remove because it has different components for x and y\n  //  and corrects for aspect ratio, see https://github.com/processing/processing/issues/5181)\n  // t = +- normalize( (q.xy*p.w - p.xy*q.w) * uViewport.zw )\n\n  vec2 tangentIn = normalize((qIn.xy*p.w - p.xy*qIn.w) * uViewport.zw);\n  vec2 tangentOut = normalize((qOut.xy*p.w - p.xy*qOut.w) * uViewport.zw);\n\n  vec2 curPerspScale;\n  if(uPerspective == 1) {\n    // Perspective ---\n    // convert from world to clip by multiplying with projection scaling factor\n    // to get the right thickness (see https://github.com/processing/processing/issues/5182)\n    // invert Y, projections in Processing invert Y\n    curPerspScale = (uProjectionMatrix * vec4(1, -1, 0, 0)).xy;\n  } else {\n    // No Perspective ---\n    // multiply by W (to cancel out division by W later in the pipeline) and\n    // convert from screen to clip (derived from clip to screen above)\n    curPerspScale = p.w / (0.5 * uViewport.zw);\n  }\n\n  vec2 offset;\n  if (vJoin == 1.) {\n    vTangent = normalize(tangentIn + tangentOut);\n    vec2 normalIn = vec2(-tangentIn.y, tangentIn.x);\n    vec2 normalOut = vec2(-tangentOut.y, tangentOut.x);\n    float side = sign(aSide);\n    float sideEnum = abs(aSide);\n\n    // We generate vertices for joins on either side of the centerline, but\n    // the \"elbow\" side is the only one needing a join. By not setting the\n    // offset for the other side, all its vertices will end up in the same\n    // spot and not render, effectively discarding it.\n    if (sign(dot(tangentOut, vec2(-tangentIn.y, tangentIn.x))) != side) {\n      // Side enums:\n      //   1: the side going into the join\n      //   2: the middle of the join\n      //   3: the side going out of the join\n      if (sideEnum == 2.) {\n        // Calculate the position + tangent on either side of the join, and\n        // find where the lines intersect to find the elbow of the join\n        vec2 c = (posp.xy/posp.w + vec2(1.,1.)) * 0.5 * uViewport.zw;\n        vec2 intersection = lineIntersection(\n          c + (side * normalIn * uStrokeWeight / 2.) * curPerspScale,\n          tangentIn,\n          c + (side * normalOut * uStrokeWeight / 2.) * curPerspScale,\n          tangentOut\n        );\n        offset = (intersection - c);\n\n        // When lines are thick and the angle of the join approaches 180, the\n        // elbow might be really far from the center. We'll apply a limit to\n        // the magnitude to avoid lines going across the whole screen when this\n        // happens.\n        float mag = length(offset);\n        float maxMag = 3. * uStrokeWeight;\n        if (mag > maxMag) {\n          offset *= maxMag / mag;\n        }\n      } else if (sideEnum == 1.) {\n        offset = side * normalIn * curPerspScale * uStrokeWeight / 2.;\n      } else if (sideEnum == 3.) {\n        offset = side * normalOut * curPerspScale * uStrokeWeight / 2.;\n      }\n    }\n    if (uStrokeJoin == STROKE_JOIN_BEVEL) {\n      vec2 avgNormal = vec2(-vTangent.y, vTangent.x);\n      vMaxDist = abs(dot(avgNormal, normalIn * uStrokeWeight / 2.));\n    } else {\n      vMaxDist = uStrokeWeight / 2.;\n    }\n  } else {\n    vec2 tangent = aTangentIn == vec3(0.) ? tangentOut : tangentIn;\n    vTangent = tangent;\n    vec2 normal = vec2(-tangent.y, tangent.x);\n\n    float normalOffset = sign(aSide);\n    // Caps will have side values of -2 or 2 on the edge of the cap that\n    // extends out from the line\n    float tangentOffset = abs(aSide) - 1.;\n    offset = (normal * normalOffset + tangent * tangentOffset) *\n      uStrokeWeight * 0.5 * curPerspScale;\n    vMaxDist = uStrokeWeight / 2.;\n  }\n  vPosition = vCenter + offset / curPerspScale;\n\n  gl_Position.xy = p.xy + offset.xy;\n  gl_Position.zw = p.zw;\n  \n  vColor = (uUseLineColor ? aVertexColor : uMaterialColor);\n}\n",
                    lineFrag: j + "precision mediump float;\nprecision mediump int;\n\nuniform vec4 uMaterialColor;\nuniform int uStrokeCap;\nuniform int uStrokeJoin;\nuniform float uStrokeWeight;\n\nvarying vec4 vColor;\nvarying vec2 vTangent;\nvarying vec2 vCenter;\nvarying vec2 vPosition;\nvarying float vMaxDist;\nvarying float vCap;\nvarying float vJoin;\n\nfloat distSquared(vec2 a, vec2 b) {\n  vec2 aToB = b - a;\n  return dot(aToB, aToB);\n}\n\nvoid main() {\n  if (vCap > 0.) {\n    if (\n      uStrokeCap == STROKE_CAP_ROUND &&\n      distSquared(vPosition, vCenter) > uStrokeWeight * uStrokeWeight * 0.25\n    ) {\n      discard;\n    } else if (\n      uStrokeCap == STROKE_CAP_SQUARE &&\n      dot(vPosition - vCenter, vTangent) > 0.\n    ) {\n      discard;\n    }\n    // Use full area for PROJECT\n  } else if (vJoin > 0.) {\n    if (\n      uStrokeJoin == STROKE_JOIN_ROUND &&\n      distSquared(vPosition, vCenter) > uStrokeWeight * uStrokeWeight * 0.25\n    ) {\n      discard;\n    } else if (uStrokeJoin == STROKE_JOIN_BEVEL) {\n      vec2 normal = vec2(-vTangent.y, vTangent.x);\n      if (abs(dot(vPosition - vCenter, normal)) > vMaxDist) {\n        discard;\n      }\n    }\n    // Use full area for MITER\n  }\n  gl_FragColor = vec4(vColor.rgb, 1.) * vColor.a;\n}\n",
                    pointVert: "attribute vec3 aPosition;\nuniform float uPointSize;\nvarying float vStrokeWeight;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nvoid main() {\n	vec4 positionVec4 =  vec4(aPosition, 1.0);\n	gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n	gl_PointSize = uPointSize;\n	vStrokeWeight = uPointSize;\n}",
                    pointFrag: "precision mediump float;\nprecision mediump int;\nuniform vec4 uMaterialColor;\nvarying float vStrokeWeight;\n\nvoid main(){\n  float mask = 0.0;\n\n  // make a circular mask using the gl_PointCoord (goes from 0 - 1 on a point)\n  // might be able to get a nicer edge on big strokeweights with smoothstep but slightly less performant\n\n  mask = step(0.98, length(gl_PointCoord * 2.0 - 1.0));\n\n  // if strokeWeight is 1 or less lets just draw a square\n  // this prevents weird artifacting from carving circles when our points are really small\n  // if strokeWeight is larger than 1, we just use it as is\n\n  mask = mix(0.0, mask, clamp(floor(vStrokeWeight - 0.5),0.0,1.0));\n\n  // throw away the borders of the mask\n  // otherwise we get weird alpha blending issues\n\n  if(mask > 0.98){\n    discard;\n  }\n\n  gl_FragColor = vec4(uMaterialColor.rgb, 1.) * uMaterialColor.a;\n}\n"
                };
                function w(e1, t, r, o, n, s, i, a, l, u) {
                    var c = t.getParameter(t.FRAMEBUFFER_BINDING), r = (t.bindFramebuffer(t.FRAMEBUFFER, r), a === t.RGBA ? 4 : 3), d = s * i * r, f = l === t.UNSIGNED_BYTE ? Uint8Array : Float32Array;
                    if (e1 instanceof f && e1.length === d || (e1 = new f(d)), t.readPixels(o, u ? u - n - i : n, s, i, a, l, e1), t.bindFramebuffer(t.FRAMEBUFFER, c), u) for(var h = Math.floor(i / 2), p = new f(s * r), m = 0; m < h; m++){
                        var y = m * s * 4, g = (i - m - 1) * s * 4;
                        p.set(e1.subarray(y, y + 4 * s)), e1.copyWithin(y, g, g + 4 * s), e1.set(p, g);
                    }
                    return e1;
                }
                function S(e1, t, r, o, n, s, i) {
                    var a = e1.getParameter(e1.FRAMEBUFFER_BINDING), t = (e1.bindFramebuffer(e1.FRAMEBUFFER, t), n === e1.RGBA ? 4 : 3), t = new (s === e1.UNSIGNED_BYTE ? Uint8Array : Float32Array)(t);
                    return e1.readPixels(r, i ? i - o - 1 : o, 1, 1, n, s, t), e1.bindFramebuffer(e1.FRAMEBUFFER, a), Array.from(t);
                }
                g.default.prototype.setAttributes = function(e1, t) {
                    if (void 0 === this._glAttributes) console.log("You are trying to use setAttributes on a p5.Graphics object that does not use a WEBGL renderer.");
                    else {
                        var r = !0;
                        if (void 0 !== t ? (null === this._glAttributes && (this._glAttributes = {}), this._glAttributes[e1] !== t && (this._glAttributes[e1] = t, r = !1)) : e1 instanceof Object && this._glAttributes !== e1 && (this._glAttributes = e1, r = !1), this._renderer.isP3D && !r) {
                            if (!this._setupDone) {
                                for(var o in this._renderer.retainedMode.geometry)if (this._renderer.retainedMode.geometry.hasOwnProperty(o)) return void g.default._friendlyError("Sorry, Could not set the attributes, you need to call setAttributes() before calling the other drawing methods in setup()");
                            }
                            this.push(), this._renderer._resetContext(), this.pop(), this._renderer._curCamera && (this._renderer._curCamera._renderer = this._renderer);
                        }
                    }
                }, g.default.RendererGL = function(e1) {
                    var t = s;
                    if ("function" != typeof e1 && null !== e1) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e1 && e1.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e1 && f(t, e1);
                    var r, n = h(s);
                    function s(e1, t, r, o) {
                        if (this instanceof s) return (e1 = n.call(this, e1, t, r))._setAttributeDefaults(t), e1._initContext(), e1.isP3D = !0, e1.GL = e1.drawingContext, e1._pInst._setProperty("drawingContext", e1.drawingContext), e1._isErasing = !1, e1._enableLighting = !1, e1.ambientLightColors = [], e1.specularColors = [
                            1,
                            1,
                            1
                        ], e1.directionalLightDirections = [], e1.directionalLightDiffuseColors = [], e1.directionalLightSpecularColors = [], e1.pointLightPositions = [], e1.pointLightDiffuseColors = [], e1.pointLightSpecularColors = [], e1.spotLightPositions = [], e1.spotLightDirections = [], e1.spotLightDiffuseColors = [], e1.spotLightSpecularColors = [], e1.spotLightAngle = [], e1.spotLightConc = [], e1.drawMode = i.FILL, e1.curFillColor = e1._cachedFillStyle = [
                            1,
                            1,
                            1,
                            1
                        ], e1.curAmbientColor = e1._cachedFillStyle = [
                            1,
                            1,
                            1,
                            1
                        ], e1.curSpecularColor = e1._cachedFillStyle = [
                            0,
                            0,
                            0,
                            0
                        ], e1.curEmissiveColor = e1._cachedFillStyle = [
                            0,
                            0,
                            0,
                            0
                        ], e1.curStrokeColor = e1._cachedStrokeStyle = [
                            0,
                            0,
                            0,
                            1
                        ], e1.curBlendMode = i.BLEND, e1._cachedBlendMode = void 0, e1.webglVersion === i.WEBGL2 ? e1.blendExt = e1.GL : e1.blendExt = e1.GL.getExtension("EXT_blend_minmax"), e1._isBlending = !1, e1._hasSetAmbient = !1, e1._useSpecularMaterial = !1, e1._useEmissiveMaterial = !1, e1._useNormalMaterial = !1, e1._useShininess = 1, e1._useLineColor = !1, e1._useVertexColor = !1, e1.registerEnabled = [], e1._tint = [
                            255,
                            255,
                            255,
                            255
                        ], e1.constantAttenuation = 1, e1.linearAttenuation = 0, e1.quadraticAttenuation = 0, e1.uMVMatrix = new g.default.Matrix, e1.uPMatrix = new g.default.Matrix, e1.uNMatrix = new g.default.Matrix("mat3"), e1._currentNormal = new g.default.Vector(0, 0, 1), e1._curCamera = new g.default.Camera(p(e1)), e1._curCamera._computeCameraDefaultSettings(), e1._curCamera._setDefaultCamera(), e1.prevTouches = [], e1.zoomVelocity = 0, e1.rotateVelocity = new g.default.Vector(0, 0), e1.moveVelocity = new g.default.Vector(0, 0), e1.executeZoom = !1, e1.executeRotateAndMove = !1, e1._defaultLightShader = void 0, e1._defaultImmediateModeShader = void 0, e1._defaultNormalShader = void 0, e1._defaultColorShader = void 0, e1._defaultPointShader = void 0, e1.userFillShader = void 0, e1.userStrokeShader = void 0, e1.userPointShader = void 0, e1.retainedMode = {
                            geometry: {},
                            buffers: {
                                stroke: [
                                    new g.default.RenderBuffer(4, "lineVertexColors", "lineColorBuffer", "aVertexColor", p(e1), e1._flatten),
                                    new g.default.RenderBuffer(3, "lineVertices", "lineVerticesBuffer", "aPosition", p(e1), e1._flatten),
                                    new g.default.RenderBuffer(3, "lineTangentsIn", "lineTangentsInBuffer", "aTangentIn", p(e1), e1._flatten),
                                    new g.default.RenderBuffer(3, "lineTangentsOut", "lineTangentsOutBuffer", "aTangentOut", p(e1), e1._flatten),
                                    new g.default.RenderBuffer(1, "lineSides", "lineSidesBuffer", "aSide", p(e1))
                                ],
                                fill: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", p(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(3, "vertexNormals", "normalBuffer", "aNormal", p(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(4, "vertexColors", "colorBuffer", "aVertexColor", p(e1)),
                                    new g.default.RenderBuffer(3, "vertexAmbients", "ambientBuffer", "aAmbientColor", p(e1)),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", p(e1), e1._flatten)
                                ],
                                text: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", p(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", p(e1), e1._flatten)
                                ]
                            }
                        }, e1.immediateMode = {
                            geometry: new g.default.Geometry,
                            shapeMode: i.TRIANGLE_FAN,
                            _bezierVertex: [],
                            _quadraticVertex: [],
                            _curveVertex: [],
                            buffers: {
                                fill: [
                                    new g.default.RenderBuffer(3, "vertices", "vertexBuffer", "aPosition", p(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(3, "vertexNormals", "normalBuffer", "aNormal", p(e1), e1._vToNArray),
                                    new g.default.RenderBuffer(4, "vertexColors", "colorBuffer", "aVertexColor", p(e1)),
                                    new g.default.RenderBuffer(3, "vertexAmbients", "ambientBuffer", "aAmbientColor", p(e1)),
                                    new g.default.RenderBuffer(2, "uvs", "uvBuffer", "aTexCoord", p(e1), e1._flatten)
                                ],
                                stroke: [
                                    new g.default.RenderBuffer(4, "lineVertexColors", "lineColorBuffer", "aVertexColor", p(e1), e1._flatten),
                                    new g.default.RenderBuffer(3, "lineVertices", "lineVerticesBuffer", "aPosition", p(e1), e1._flatten),
                                    new g.default.RenderBuffer(3, "lineTangentsIn", "lineTangentsInBuffer", "aTangentIn", p(e1), e1._flatten),
                                    new g.default.RenderBuffer(3, "lineTangentsOut", "lineTangentsOutBuffer", "aTangentOut", p(e1), e1._flatten),
                                    new g.default.RenderBuffer(1, "lineSides", "lineSidesBuffer", "aSide", p(e1))
                                ],
                                point: e1.GL.createBuffer()
                            }
                        }, e1.pointSize = 5, e1.curStrokeWeight = 1, e1.curStrokeCap = i.ROUND, e1.curStrokeJoin = i.ROUND, e1.textures = new Map, e1.framebuffers = new Set, e1.textureMode = i.IMAGE, e1.textureWrapX = i.CLAMP, e1.textureWrapY = i.CLAMP, e1._tex = null, e1._curveTightness = 6, e1._lookUpTableBezier = [], e1._lookUpTableQuadratic = [], e1._lutBezierDetail = 0, e1._lutQuadraticDetail = 0, e1.isProcessingVertices = !1, e1._tessy = e1._initTessy(), e1.fontInfos = {}, e1._curShader = void 0, e1;
                        throw new TypeError("Cannot call a class as a function");
                    }
                    return t = s, e1 = [
                        {
                            key: "_setAttributeDefaults",
                            value: function(e1) {
                                var t = {
                                    alpha: !0,
                                    depth: !0,
                                    stencil: !0,
                                    antialias: navigator.userAgent.toLowerCase().includes("safari"),
                                    premultipliedAlpha: !0,
                                    preserveDrawingBuffer: !0,
                                    perPixelLighting: !0,
                                    version: 2
                                };
                                null === e1._glAttributes ? e1._glAttributes = t : e1._glAttributes = Object.assign(t, e1._glAttributes);
                            }
                        },
                        {
                            key: "_initContext",
                            value: function() {
                                if (1 !== this._pInst._glAttributes.version && (this.drawingContext = this.canvas.getContext("webgl2", this._pInst._glAttributes)), this.webglVersion = this.drawingContext ? i.WEBGL2 : i.WEBGL, this._pInst._setProperty("webglVersion", this.webglVersion), this.drawingContext || (this.drawingContext = this.canvas.getContext("webgl", this._pInst._glAttributes) || this.canvas.getContext("experimental-webgl", this._pInst._glAttributes)), null === this.drawingContext) throw new Error("Error creating webgl context");
                                var e1 = this.drawingContext;
                                e1.enable(e1.DEPTH_TEST), e1.depthFunc(e1.LEQUAL), e1.viewport(0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight), e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), this._viewport = this.drawingContext.getParameter(this.drawingContext.VIEWPORT);
                            }
                        },
                        {
                            key: "_resetContext",
                            value: function(e1, t) {
                                var r, o = this.width, n = this.height, s = this.canvas.id, i = this._pInst instanceof g.default.Graphics, s = (i ? ((r = this._pInst).canvas.parentNode.removeChild(r.canvas), r.canvas = document.createElement("canvas"), (r._pInst._userNode || document.body).appendChild(r.canvas), g.default.Element.call(r, r.canvas, r._pInst), r.width = o, r.height = n) : ((r = this.canvas) && r.parentNode.removeChild(r), (r = document.createElement("canvas")).id = s, (this._pInst._userNode || document.body).appendChild(r), this._pInst.canvas = r, this.canvas = r), new g.default.RendererGL(this._pInst.canvas, this._pInst, !i));
                                this._pInst._setProperty("_renderer", s), s.resize(o, n), s._applyDefaults(), i || this._pInst._elements.push(s), "function" == typeof t && setTimeout(function() {
                                    t.apply(window._renderer, e1);
                                }, 0);
                            }
                        },
                        {
                            key: "_update",
                            value: function() {
                                this.uMVMatrix.set(this._curCamera.cameraMatrix.mat4[0], this._curCamera.cameraMatrix.mat4[1], this._curCamera.cameraMatrix.mat4[2], this._curCamera.cameraMatrix.mat4[3], this._curCamera.cameraMatrix.mat4[4], this._curCamera.cameraMatrix.mat4[5], this._curCamera.cameraMatrix.mat4[6], this._curCamera.cameraMatrix.mat4[7], this._curCamera.cameraMatrix.mat4[8], this._curCamera.cameraMatrix.mat4[9], this._curCamera.cameraMatrix.mat4[10], this._curCamera.cameraMatrix.mat4[11], this._curCamera.cameraMatrix.mat4[12], this._curCamera.cameraMatrix.mat4[13], this._curCamera.cameraMatrix.mat4[14], this._curCamera.cameraMatrix.mat4[15]), this.ambientLightColors.length = 0, this.specularColors = [
                                    1,
                                    1,
                                    1
                                ], this.directionalLightDirections.length = 0, this.directionalLightDiffuseColors.length = 0, this.directionalLightSpecularColors.length = 0, this.pointLightPositions.length = 0, this.pointLightDiffuseColors.length = 0, this.pointLightSpecularColors.length = 0, this.spotLightPositions.length = 0, this.spotLightDirections.length = 0, this.spotLightDiffuseColors.length = 0, this.spotLightSpecularColors.length = 0, this.spotLightAngle.length = 0, this.spotLightConc.length = 0, this._enableLighting = !1, this._tint = [
                                    255,
                                    255,
                                    255,
                                    255
                                ], this.GL.clear(this.GL.DEPTH_BUFFER_BIT);
                            }
                        },
                        {
                            key: "background",
                            value: function() {
                                var e1 = (e1 = this._pInst).color.apply(e1, arguments), t = e1.levels[0] / 255, r = e1.levels[1] / 255, o = e1.levels[2] / 255, e1 = e1.levels[3] / 255;
                                this.clear(t, r, o, e1);
                            }
                        },
                        {
                            key: "fill",
                            value: function(e1, t, r, o) {
                                var n = g.default.prototype.color.apply(this._pInst, arguments);
                                this.curFillColor = n._array, this.drawMode = i.FILL, this._useNormalMaterial = !1, this._tex = null;
                            }
                        },
                        {
                            key: "stroke",
                            value: function(e1, t, r, o) {
                                var n = g.default.prototype.color.apply(this._pInst, arguments);
                                this.curStrokeColor = n._array;
                            }
                        },
                        {
                            key: "strokeCap",
                            value: function(e1) {
                                this.curStrokeCap = e1;
                            }
                        },
                        {
                            key: "strokeJoin",
                            value: function(e1) {
                                this.curStrokeJoin = e1;
                            }
                        },
                        {
                            key: "filter",
                            value: function(e1) {
                                g.default._friendlyError("filter() does not work in WEBGL mode");
                            }
                        },
                        {
                            key: "blendMode",
                            value: function(e1) {
                                e1 === i.DARKEST || e1 === i.LIGHTEST || e1 === i.ADD || e1 === i.BLEND || e1 === i.SUBTRACT || e1 === i.SCREEN || e1 === i.EXCLUSION || e1 === i.REPLACE || e1 === i.MULTIPLY || e1 === i.REMOVE ? this.curBlendMode = e1 : e1 !== i.BURN && e1 !== i.OVERLAY && e1 !== i.HARD_LIGHT && e1 !== i.SOFT_LIGHT && e1 !== i.DODGE || console.warn("BURN, OVERLAY, HARD_LIGHT, SOFT_LIGHT, and DODGE only work for blendMode in 2D mode.");
                            }
                        },
                        {
                            key: "erase",
                            value: function(e1, t) {
                                this._isErasing || (this._applyBlendMode(i.REMOVE), this._isErasing = !0, this._cachedFillStyle = this.curFillColor.slice(), this.curFillColor = [
                                    1,
                                    1,
                                    1,
                                    e1 / 255
                                ], this._cachedStrokeStyle = this.curStrokeColor.slice(), this.curStrokeColor = [
                                    1,
                                    1,
                                    1,
                                    t / 255
                                ]);
                            }
                        },
                        {
                            key: "noErase",
                            value: function() {
                                this._isErasing && (this._isErasing = !1, this.curFillColor = this._cachedFillStyle.slice(), this.curStrokeColor = this._cachedStrokeStyle.slice(), this.blendMode(this._cachedBlendMode));
                            }
                        },
                        {
                            key: "strokeWeight",
                            value: function(e1) {
                                this.curStrokeWeight !== e1 && (this.pointSize = e1, this.curStrokeWeight = e1);
                            }
                        },
                        {
                            key: "_getPixel",
                            value: function(e1, t) {
                                var r = this.GL;
                                return S(r, null, e1, t, r.RGBA, r.UNSIGNED_BYTE, this._pInst.height * this._pInst.pixelDensity());
                            }
                        },
                        {
                            key: "loadPixels",
                            value: function() {
                                var e1, t, r = this._pixelsState;
                                !0 !== this._pInst._glAttributes.preserveDrawingBuffer ? console.log("loadPixels only works in WebGL when preserveDrawingBuffer is true.") : (e1 = this._pInst._pixelDensity, t = this.GL, r._setProperty("pixels", w(r.pixels, t, null, 0, 0, this.width * e1, this.height * e1, t.RGBA, t.UNSIGNED_BYTE, this.height * e1)));
                            }
                        },
                        {
                            key: "updatePixels",
                            value: function() {
                                var e1 = this._getTempFramebuffer();
                                e1.pixels = this._pixelsState.pixels, e1.updatePixels(), this._pInst.push(), this._pInst.resetMatrix(), this._pInst.clear(), this._pInst.imageMode(i.CENTER), this._pInst.image(e1, 0, 0), this._pInst.pop(), this.GL.clearDepth(1), this.GL.clear(this.GL.DEPTH_BUFFER_BIT);
                            }
                        },
                        {
                            key: "_getTempFramebuffer",
                            value: function() {
                                return this._tempFramebuffer || (this._tempFramebuffer = this._pInst.createFramebuffer({
                                    format: i.UNSIGNED_BYTE,
                                    useDepth: this._pInst._glAttributes.depth,
                                    depthFormat: i.UNSIGNED_INT,
                                    antialias: this._pInst._glAttributes.antialias
                                })), this._tempFramebuffer;
                            }
                        },
                        {
                            key: "geometryInHash",
                            value: function(e1) {
                                return void 0 !== this.retainedMode.geometry[e1];
                            }
                        },
                        {
                            key: "resize",
                            value: function(t, r) {
                                g.default.Renderer.prototype.resize.call(this, t, r), this.GL.viewport(0, 0, this.GL.drawingBufferWidth, this.GL.drawingBufferHeight), this._viewport = this.GL.getParameter(this.GL.VIEWPORT), this._curCamera._resize();
                                var t = this._pixelsState, e1 = (void 0 !== t.pixels && t._setProperty("pixels", new Uint8Array(this.GL.drawingBufferWidth * this.GL.drawingBufferHeight * 4)), !0), r = !1, t = void 0;
                                try {
                                    for(var o, n = this.framebuffers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0)o.value._canvasSizeChanged();
                                } catch (e1) {
                                    r = !0, t = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (r) throw t;
                                    }
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                var e1 = (arguments.length <= 0 ? void 0 : arguments[0]) || 0, t = (arguments.length <= 1 ? void 0 : arguments[1]) || 0, r = (arguments.length <= 2 ? void 0 : arguments[2]) || 0, o = (arguments.length <= 3 ? void 0 : arguments[3]) || 0;
                                this.GL.clearColor(e1 * o, t * o, r * o, o), this.GL.clearDepth(1), this.GL.clear(this.GL.COLOR_BUFFER_BIT | this.GL.DEPTH_BUFFER_BIT);
                            }
                        },
                        {
                            key: "applyMatrix",
                            value: function(e1, t, r, o, n, s) {
                                16 === arguments.length ? g.default.Matrix.prototype.apply.apply(this.uMVMatrix, arguments) : this.uMVMatrix.apply([
                                    e1,
                                    t,
                                    0,
                                    0,
                                    r,
                                    o,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    n,
                                    s,
                                    0,
                                    1
                                ]);
                            }
                        },
                        {
                            key: "translate",
                            value: function(e1, t, r) {
                                return e1 instanceof g.default.Vector && (r = e1.z, t = e1.y, e1 = e1.x), this.uMVMatrix.translate([
                                    e1,
                                    t,
                                    r
                                ]), this;
                            }
                        },
                        {
                            key: "scale",
                            value: function(e1, t, r) {
                                return this.uMVMatrix.scale(e1, t, r), this;
                            }
                        },
                        {
                            key: "rotate",
                            value: function(e1, t) {
                                return void 0 === t ? this.rotateZ(e1) : (g.default.Matrix.prototype.rotate.apply(this.uMVMatrix, arguments), this);
                            }
                        },
                        {
                            key: "rotateX",
                            value: function(e1) {
                                return this.rotate(e1, 1, 0, 0), this;
                            }
                        },
                        {
                            key: "rotateY",
                            value: function(e1) {
                                return this.rotate(e1, 0, 1, 0), this;
                            }
                        },
                        {
                            key: "rotateZ",
                            value: function(e1) {
                                return this.rotate(e1, 0, 0, 1), this;
                            }
                        },
                        {
                            key: "push",
                            value: function() {
                                var e1 = g.default.Renderer.prototype.push.apply(this), t = e1.properties;
                                return t.uMVMatrix = this.uMVMatrix.copy(), t.uPMatrix = this.uPMatrix.copy(), t._curCamera = this._curCamera, this._curCamera = this._curCamera.copy(), t.ambientLightColors = this.ambientLightColors.slice(), t.specularColors = this.specularColors.slice(), t.directionalLightDirections = this.directionalLightDirections.slice(), t.directionalLightDiffuseColors = this.directionalLightDiffuseColors.slice(), t.directionalLightSpecularColors = this.directionalLightSpecularColors.slice(), t.pointLightPositions = this.pointLightPositions.slice(), t.pointLightDiffuseColors = this.pointLightDiffuseColors.slice(), t.pointLightSpecularColors = this.pointLightSpecularColors.slice(), t.spotLightPositions = this.spotLightPositions.slice(), t.spotLightDirections = this.spotLightDirections.slice(), t.spotLightDiffuseColors = this.spotLightDiffuseColors.slice(), t.spotLightSpecularColors = this.spotLightSpecularColors.slice(), t.spotLightAngle = this.spotLightAngle.slice(), t.spotLightConc = this.spotLightConc.slice(), t.userFillShader = this.userFillShader, t.userStrokeShader = this.userStrokeShader, t.userPointShader = this.userPointShader, t.pointSize = this.pointSize, t.curStrokeWeight = this.curStrokeWeight, t.curStrokeColor = this.curStrokeColor, t.curFillColor = this.curFillColor, t.curAmbientColor = this.curAmbientColor, t.curSpecularColor = this.curSpecularColor, t.curEmissiveColor = this.curEmissiveColor, t._hasSetAmbient = this._hasSetAmbient, t._useSpecularMaterial = this._useSpecularMaterial, t._useEmissiveMaterial = this._useEmissiveMaterial, t._useShininess = this._useShininess, t.constantAttenuation = this.constantAttenuation, t.linearAttenuation = this.linearAttenuation, t.quadraticAttenuation = this.quadraticAttenuation, t._enableLighting = this._enableLighting, t._useNormalMaterial = this._useNormalMaterial, t._tex = this._tex, t.drawMode = this.drawMode, t._currentNormal = this._currentNormal, t.curBlendMode = this.curBlendMode, e1;
                            }
                        },
                        {
                            key: "resetMatrix",
                            value: function() {
                                return this.uMVMatrix.set(this._curCamera.cameraMatrix.mat4[0], this._curCamera.cameraMatrix.mat4[1], this._curCamera.cameraMatrix.mat4[2], this._curCamera.cameraMatrix.mat4[3], this._curCamera.cameraMatrix.mat4[4], this._curCamera.cameraMatrix.mat4[5], this._curCamera.cameraMatrix.mat4[6], this._curCamera.cameraMatrix.mat4[7], this._curCamera.cameraMatrix.mat4[8], this._curCamera.cameraMatrix.mat4[9], this._curCamera.cameraMatrix.mat4[10], this._curCamera.cameraMatrix.mat4[11], this._curCamera.cameraMatrix.mat4[12], this._curCamera.cameraMatrix.mat4[13], this._curCamera.cameraMatrix.mat4[14], this._curCamera.cameraMatrix.mat4[15]), this;
                            }
                        },
                        {
                            key: "_getImmediateStrokeShader",
                            value: function() {
                                var e1 = this.userStrokeShader;
                                return e1 && e1.isStrokeShader() ? e1 : this._getLineShader();
                            }
                        },
                        {
                            key: "_getRetainedStrokeShader",
                            value: function() {
                                return this._getImmediateStrokeShader();
                            }
                        },
                        {
                            key: "_getImmediateFillShader",
                            value: function() {
                                var e1 = this.userFillShader;
                                if (this._useNormalMaterial && (!e1 || !e1.isNormalShader())) return this._getNormalShader();
                                if (this._enableLighting) {
                                    if (!e1 || !e1.isLightShader()) return this._getLightShader();
                                } else if (this._tex) {
                                    if (!e1 || !e1.isTextureShader()) return this._getLightShader();
                                } else if (!e1) return this._getImmediateModeShader();
                                return e1;
                            }
                        },
                        {
                            key: "_getRetainedFillShader",
                            value: function() {
                                if (this._useNormalMaterial) return this._getNormalShader();
                                var e1 = this.userFillShader;
                                if (this._enableLighting) {
                                    if (!e1 || !e1.isLightShader()) return this._getLightShader();
                                } else if (this._tex) {
                                    if (!e1 || !e1.isTextureShader()) return this._getLightShader();
                                } else if (!e1) return this._getColorShader();
                                return e1;
                            }
                        },
                        {
                            key: "_getImmediatePointShader",
                            value: function() {
                                var e1 = this.userPointShader;
                                return e1 && e1.isPointShader() ? e1 : this._getPointShader();
                            }
                        },
                        {
                            key: "_getRetainedLineShader",
                            value: function() {
                                return this._getImmediateLineShader();
                            }
                        },
                        {
                            key: "_getLightShader",
                            value: function() {
                                return this._defaultLightShader || (this._pInst._glAttributes.perPixelLighting ? this._defaultLightShader = new g.default.Shader(this, x.phongVert, x.phongFrag) : this._defaultLightShader = new g.default.Shader(this, x.lightVert, x.lightTextureFrag)), this._defaultLightShader;
                            }
                        },
                        {
                            key: "_getImmediateModeShader",
                            value: function() {
                                return this._defaultImmediateModeShader || (this._defaultImmediateModeShader = new g.default.Shader(this, x.immediateVert, x.vertexColorFrag)), this._defaultImmediateModeShader;
                            }
                        },
                        {
                            key: "_getNormalShader",
                            value: function() {
                                return this._defaultNormalShader || (this._defaultNormalShader = new g.default.Shader(this, x.normalVert, x.normalFrag)), this._defaultNormalShader;
                            }
                        },
                        {
                            key: "_getColorShader",
                            value: function() {
                                return this._defaultColorShader || (this._defaultColorShader = new g.default.Shader(this, x.normalVert, x.basicFrag)), this._defaultColorShader;
                            }
                        },
                        {
                            key: "_getPointShader",
                            value: function() {
                                return this._defaultPointShader || (this._defaultPointShader = new g.default.Shader(this, x.pointVert, x.pointFrag)), this._defaultPointShader;
                            }
                        },
                        {
                            key: "_getLineShader",
                            value: function() {
                                return this._defaultLineShader || (this._defaultLineShader = new g.default.Shader(this, x.lineVert, x.lineFrag)), this._defaultLineShader;
                            }
                        },
                        {
                            key: "_getFontShader",
                            value: function() {
                                return this._defaultFontShader || (this.webglVersion === i.WEBGL && this.GL.getExtension("OES_standard_derivatives"), this._defaultFontShader = new g.default.Shader(this, this._webGL2CompatibilityPrefix("vert", "mediump") + x.fontVert, this._webGL2CompatibilityPrefix("frag", "mediump") + x.fontFrag)), this._defaultFontShader;
                            }
                        },
                        {
                            key: "_webGL2CompatibilityPrefix",
                            value: function(e1, t) {
                                var r = "";
                                return this.webglVersion === i.WEBGL2 && (r += "#version 300 es\n#define WEBGL2\n"), "vert" === e1 ? r += "#define VERTEX_SHADER\n" : "frag" === e1 && (r += "#define FRAGMENT_SHADER\n"), t && (r += "precision ".concat(t, " float;\n")), r;
                            }
                        },
                        {
                            key: "_getEmptyTexture",
                            value: function() {
                                var e1;
                                return this._emptyTexture || ((e1 = new g.default.Image(1, 1)).set(0, 0, 255), this._emptyTexture = new g.default.Texture(this, e1)), this._emptyTexture;
                            }
                        },
                        {
                            key: "getTexture",
                            value: function(e1) {
                                e1 instanceof g.default.Framebuffer && (e1 = e1.color);
                                var t = this.textures.get(e1);
                                return t || (t = new g.default.Texture(this, e1), this.textures.set(e1, t), t);
                            }
                        },
                        {
                            key: "createFramebuffer",
                            value: function(e1) {
                                return new g.default.Framebuffer(this, e1);
                            }
                        },
                        {
                            key: "_setStrokeUniforms",
                            value: function(e1) {
                                e1.bindShader(), e1.setUniform("uUseLineColor", this._useLineColor), e1.setUniform("uMaterialColor", this.curStrokeColor), e1.setUniform("uStrokeWeight", this.curStrokeWeight), e1.setUniform("uStrokeCap", v[this.curStrokeCap]), e1.setUniform("uStrokeJoin", b[this.curStrokeJoin]);
                            }
                        },
                        {
                            key: "_setFillUniforms",
                            value: function(e1) {
                                e1.bindShader(), e1.setUniform("uUseVertexColor", this._useVertexColor), e1.setUniform("uMaterialColor", this.curFillColor), e1.setUniform("isTexture", !!this._tex), this._tex && e1.setUniform("uSampler", this._tex), e1.setUniform("uTint", this._tint), e1.setUniform("uHasSetAmbient", this._hasSetAmbient), e1.setUniform("uAmbientMatColor", this.curAmbientColor), e1.setUniform("uSpecularMatColor", this.curSpecularColor), e1.setUniform("uEmissiveMatColor", this.curEmissiveColor), e1.setUniform("uSpecular", this._useSpecularMaterial), e1.setUniform("uEmissive", this._useEmissiveMaterial), e1.setUniform("uShininess", this._useShininess), e1.setUniform("uUseLighting", this._enableLighting);
                                var t = this.pointLightDiffuseColors.length / 3, t = (e1.setUniform("uPointLightCount", t), e1.setUniform("uPointLightLocation", this.pointLightPositions), e1.setUniform("uPointLightDiffuseColors", this.pointLightDiffuseColors), e1.setUniform("uPointLightSpecularColors", this.pointLightSpecularColors), this.directionalLightDiffuseColors.length / 3), t = (e1.setUniform("uDirectionalLightCount", t), e1.setUniform("uLightingDirection", this.directionalLightDirections), e1.setUniform("uDirectionalDiffuseColors", this.directionalLightDiffuseColors), e1.setUniform("uDirectionalSpecularColors", this.directionalLightSpecularColors), this.ambientLightColors.length / 3), t = (e1.setUniform("uAmbientLightCount", t), e1.setUniform("uAmbientColor", this.ambientLightColors), this.spotLightDiffuseColors.length / 3);
                                e1.setUniform("uSpotLightCount", t), e1.setUniform("uSpotLightAngle", this.spotLightAngle), e1.setUniform("uSpotLightConc", this.spotLightConc), e1.setUniform("uSpotLightDiffuseColors", this.spotLightDiffuseColors), e1.setUniform("uSpotLightSpecularColors", this.spotLightSpecularColors), e1.setUniform("uSpotLightLocation", this.spotLightPositions), e1.setUniform("uSpotLightDirection", this.spotLightDirections), e1.setUniform("uConstantAttenuation", this.constantAttenuation), e1.setUniform("uLinearAttenuation", this.linearAttenuation), e1.setUniform("uQuadraticAttenuation", this.quadraticAttenuation), e1.bindTextures();
                            }
                        },
                        {
                            key: "_setPointUniforms",
                            value: function(e1) {
                                e1.bindShader(), e1.setUniform("uMaterialColor", this.curStrokeColor), e1.setUniform("uPointSize", this.pointSize * this._pInst._pixelDensity);
                            }
                        },
                        {
                            key: "_bindBuffer",
                            value: function(e1, t, r, o, n) {
                                t = t || this.GL.ARRAY_BUFFER, this.GL.bindBuffer(t, e1), void 0 !== r && (e1 = new (o || Float32Array)(r), this.GL.bufferData(t, e1, n || this.GL.STATIC_DRAW));
                            }
                        },
                        {
                            key: "_arraysEqual",
                            value: function(e1, r) {
                                return e1.length === r.length && e1.every(function(e1, t) {
                                    return e1 === r[t];
                                });
                            }
                        },
                        {
                            key: "_isTypedArray",
                            value: function(t) {
                                return [
                                    Float32Array,
                                    Float64Array,
                                    Int16Array,
                                    Uint16Array,
                                    Uint32Array
                                ].some(function(e1) {
                                    return t instanceof e1;
                                });
                            }
                        },
                        {
                            key: "_flatten",
                            value: function(e1) {
                                if (0 === e1.length) return [];
                                var t;
                                if (2e4 < e1.length) {
                                    for(var r = [], o = e1.slice(), n = o.pop(); Array.isArray(n) ? o.push.apply(o, c(n)) : r.push(n), o.length && void 0 !== (n = o.pop()););
                                    return r.reverse(), r;
                                }
                                return (t = []).concat.apply(t, c(e1));
                            }
                        },
                        {
                            key: "_vToNArray",
                            value: function(e1) {
                                var t = [], r = !0, o = !1, n = void 0;
                                try {
                                    for(var s, i = e1[Symbol.iterator](); !(r = (s = i.next()).done); r = !0){
                                        var a = s.value;
                                        t.push(a.x, a.y, a.z);
                                    }
                                } catch (e1) {
                                    o = !0, n = e1;
                                } finally{
                                    try {
                                        r || null == i.return || i.return();
                                    } finally{
                                        if (o) throw n;
                                    }
                                }
                                return t;
                            }
                        },
                        {
                            key: "_bezierCoefficients",
                            value: function(e1) {
                                var t = e1 * e1, r = 1 - e1, o = r * r;
                                return [
                                    o * r,
                                    3 * o * e1,
                                    3 * r * t,
                                    t * e1
                                ];
                            }
                        },
                        {
                            key: "_quadraticCoefficients",
                            value: function(e1) {
                                var t = 1 - e1;
                                return [
                                    t * t,
                                    2 * t * e1,
                                    e1 * e1
                                ];
                            }
                        },
                        {
                            key: "_bezierToCatmull",
                            value: function(e1) {
                                return [
                                    e1[1],
                                    e1[1] + (e1[2] - e1[0]) / this._curveTightness,
                                    e1[2] - (e1[3] - e1[1]) / this._curveTightness,
                                    e1[2]
                                ];
                            }
                        },
                        {
                            key: "_initTessy",
                            value: function() {
                                var e1 = new a.default.GluTesselator;
                                return e1.gluTessCallback(a.default.gluEnum.GLU_TESS_VERTEX_DATA, function(e1, t) {
                                    for(var r = 0; r < e1.length; r++)t.push(e1[r]);
                                }), e1.gluTessCallback(a.default.gluEnum.GLU_TESS_BEGIN, function(e1) {
                                    e1 !== a.default.primitiveType.GL_TRIANGLES && console.log("expected TRIANGLES but got type: ".concat(e1));
                                }), e1.gluTessCallback(a.default.gluEnum.GLU_TESS_ERROR, function(e1) {
                                    console.log("error callback"), console.log("error number: ".concat(e1));
                                }), e1.gluTessCallback(a.default.gluEnum.GLU_TESS_COMBINE, function(e1, t, r) {
                                    for(var o = new Array(g.default.RendererGL.prototype.tessyVertexSize).fill(0), n = 0; n < r.length; n++)for(var s = 0; s < o.length; s++)0 !== r[n] && t[n] && (o[s] += t[n][s] * r[n]);
                                    return o;
                                }), e1.gluTessCallback(a.default.gluEnum.GLU_TESS_EDGE_FLAG, function(e1) {}), e1;
                            }
                        },
                        {
                            key: "_triangulate",
                            value: function(e1) {
                                var t = e1[0] ? e1[0][2] : void 0, r = !0, o = !0, n = !1, s = void 0;
                                try {
                                    for(var i, a = e1[Symbol.iterator](); !(o = (i = a.next()).done); o = !0)for(var l = i.value, u = 0; u < l.length; u += g.default.RendererGL.prototype.tessyVertexSize)if (l[u + 2] !== t) {
                                        r = !1;
                                        break;
                                    }
                                } catch (e1) {
                                    n = !0, s = e1;
                                } finally{
                                    try {
                                        o || null == a.return || a.return();
                                    } finally{
                                        if (n) throw s;
                                    }
                                }
                                r ? this._tessy.gluTessNormal(0, 0, 1) : this._tessy.gluTessNormal(0, 0, 0);
                                var n = [], c = (this._tessy.gluTessBeginPolygon(n), !0), s = !1, d = void 0;
                                try {
                                    for(var f, h = e1[Symbol.iterator](); !(c = (f = h.next()).done); c = !0){
                                        var p = f.value;
                                        this._tessy.gluTessBeginContour();
                                        for(var m = 0; m < p.length; m += g.default.RendererGL.prototype.tessyVertexSize){
                                            var y = p.slice(m, m + g.default.RendererGL.prototype.tessyVertexSize);
                                            this._tessy.gluTessVertex(y, y);
                                        }
                                        this._tessy.gluTessEndContour();
                                    }
                                } catch (e1) {
                                    s = !0, d = e1;
                                } finally{
                                    try {
                                        c || null == h.return || h.return();
                                    } finally{
                                        if (s) throw d;
                                    }
                                }
                                return this._tessy.gluTessEndPolygon(), n;
                            }
                        }
                    ], d(t.prototype, e1), r && d(t, r), s;
                }(g.default.Renderer), g.default.prototype._assert3d = function(e1) {
                    if (!this._renderer.isP3D) throw new Error("".concat(e1, "() is only supported in WEBGL mode. If you'd like to use 3D graphics and WebGL, see  https://p5js.org/examples/form-3d-primitives.html for more information."));
                }, g.default.RendererGL.prototype.tessyVertexSize = 12;
                e1 = g.default.RendererGL;
                r.default = e1;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "../core/p5.Renderer": 276,
                "./p5.Camera": 321,
                "./p5.Matrix": 324,
                "./p5.Shader": 329,
                "core-js/modules/es.array.concat": 151,
                "core-js/modules/es.array.copy-within": 152,
                "core-js/modules/es.array.every": 153,
                "core-js/modules/es.array.fill": 154,
                "core-js/modules/es.array.from": 157,
                "core-js/modules/es.array.includes": 158,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.array.some": 165,
                "core-js/modules/es.map": 168,
                "core-js/modules/es.object.assign": 174,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.get-prototype-of": 178,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.reflect.construct": 182,
                "core-js/modules/es.regexp.to-string": 186,
                "core-js/modules/es.set": 187,
                "core-js/modules/es.string.includes": 189,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.float32-array": 209,
                "core-js/modules/es.typed-array.float64-array": 210,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.int16-array": 214,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint16-array": 230,
                "core-js/modules/es.typed-array.uint32-array": 231,
                "core-js/modules/es.typed-array.uint8-array": 232,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236,
                libtess: 245,
                path: 248
            }
        ],
        329: [
            function(e1, t, r) {
                "use strict";
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.index-of"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.array.slice"), e1("core-js/modules/es.function.name"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/web.dom-collections.iterator"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = (e1 = e1("../core/main")) && e1.__esModule ? e1 : {
                    default: e1
                };
                function n(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                s.default.Shader = function() {
                    function o(e1, t, r) {
                        if (!(this instanceof o)) throw new TypeError("Cannot call a class as a function");
                        this._renderer = e1, this._vertSrc = t, this._fragSrc = r, this._vertShader = -1, this._fragShader = -1, this._glProgram = 0, this._loadedAttributes = !1, this.attributes = {}, this._loadedUniforms = !1, this.uniforms = {}, this._bound = !1, this.samplers = [];
                    }
                    var e1, t, r;
                    return e1 = o, t = [
                        {
                            key: "init",
                            value: function() {
                                if (0 === this._glProgram) {
                                    var e1 = this._renderer.GL;
                                    if (this._vertShader = e1.createShader(e1.VERTEX_SHADER), e1.shaderSource(this._vertShader, this._vertSrc), e1.compileShader(this._vertShader), !e1.getShaderParameter(this._vertShader, e1.COMPILE_STATUS)) return s.default._friendlyError("Yikes! An error occurred compiling the vertex shader:".concat(e1.getShaderInfoLog(this._vertShader))), null;
                                    if (this._fragShader = e1.createShader(e1.FRAGMENT_SHADER), e1.shaderSource(this._fragShader, this._fragSrc), e1.compileShader(this._fragShader), !e1.getShaderParameter(this._fragShader, e1.COMPILE_STATUS)) return s.default._friendlyError("Darn! An error occurred compiling the fragment shader:".concat(e1.getShaderInfoLog(this._fragShader))), null;
                                    this._glProgram = e1.createProgram(), e1.attachShader(this._glProgram, this._vertShader), e1.attachShader(this._glProgram, this._fragShader), e1.linkProgram(this._glProgram), e1.getProgramParameter(this._glProgram, e1.LINK_STATUS) || s.default._friendlyError("Snap! Error linking shader program: ".concat(e1.getProgramInfoLog(this._glProgram))), this._loadAttributes(), this._loadUniforms();
                                }
                                return this;
                            }
                        },
                        {
                            key: "_loadAttributes",
                            value: function() {
                                if (!this._loadedAttributes) {
                                    this.attributes = {};
                                    for(var e1 = this._renderer.GL, t = e1.getProgramParameter(this._glProgram, e1.ACTIVE_ATTRIBUTES), r = 0; r < t; ++r){
                                        var o = e1.getActiveAttrib(this._glProgram, r), n = o.name, s = e1.getAttribLocation(this._glProgram, n), i = {};
                                        i.name = n, i.location = s, i.index = r, i.type = o.type, i.size = o.size, this.attributes[n] = i;
                                    }
                                    this._loadedAttributes = !0;
                                }
                            }
                        },
                        {
                            key: "_loadUniforms",
                            value: function() {
                                if (!this._loadedUniforms) {
                                    for(var e1 = this._renderer.GL, t = e1.getProgramParameter(this._glProgram, e1.ACTIVE_UNIFORMS), r = 0, o = 0; o < t; ++o){
                                        var n = e1.getActiveUniform(this._glProgram, o), s = {}, i = (s.location = e1.getUniformLocation(this._glProgram, n.name), s.size = n.size, n.name);
                                        1 < n.size && (i = i.substring(0, i.indexOf("[0]"))), s.name = i, s.type = n.type, s._cachedData = void 0, s.type === e1.SAMPLER_2D && (s.samplerIndex = r, r++, this.samplers.push(s)), s.isArray = 1 < n.size || s.type === e1.FLOAT_MAT3 || s.type === e1.FLOAT_MAT4 || s.type === e1.FLOAT_VEC2 || s.type === e1.FLOAT_VEC3 || s.type === e1.FLOAT_VEC4 || s.type === e1.INT_VEC2 || s.type === e1.INT_VEC4 || s.type === e1.INT_VEC3, this.uniforms[i] = s;
                                    }
                                    this._loadedUniforms = !0;
                                }
                            }
                        },
                        {
                            key: "compile",
                            value: function() {}
                        },
                        {
                            key: "bindShader",
                            value: function() {
                                this.init(), this._bound || (this.useProgram(), this._bound = !0, this._setMatrixUniforms(), this.setUniform("uViewport", this._renderer._viewport));
                            }
                        },
                        {
                            key: "unbindShader",
                            value: function() {
                                return this._bound && (this.unbindTextures(), this._bound = !1), this;
                            }
                        },
                        {
                            key: "bindTextures",
                            value: function() {
                                var e1 = this._renderer.GL, t = !0, r = !1, o = void 0;
                                try {
                                    for(var n, s = this.samplers[Symbol.iterator](); !(t = (n = s.next()).done); t = !0){
                                        var i = n.value, a = i.texture;
                                        void 0 === a && (a = this._renderer._getEmptyTexture()), e1.activeTexture(e1.TEXTURE0 + i.samplerIndex), a.bindTexture(), a.update(), e1.uniform1i(i.location, i.samplerIndex);
                                    }
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        t || null == s.return || s.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                            }
                        },
                        {
                            key: "updateTextures",
                            value: function() {
                                var e1 = !0, t = !1, r = void 0;
                                try {
                                    for(var o, n = this.samplers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                                        var s = o.value.texture;
                                        s && s.update();
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                            }
                        },
                        {
                            key: "unbindTextures",
                            value: function() {
                                var e1 = !0, t = !1, r = void 0;
                                try {
                                    for(var o, n = this.samplers[Symbol.iterator](); !(e1 = (o = n.next()).done); e1 = !0){
                                        var s = o.value;
                                        this.setUniform(s.name, this._renderer._getEmptyTexture());
                                    }
                                } catch (e1) {
                                    t = !0, r = e1;
                                } finally{
                                    try {
                                        e1 || null == n.return || n.return();
                                    } finally{
                                        if (t) throw r;
                                    }
                                }
                            }
                        },
                        {
                            key: "_setMatrixUniforms",
                            value: function() {
                                var e1 = this._renderer._curCamera.cameraMatrix, t = this._renderer.uPMatrix, r = this._renderer.uMVMatrix, o = r.copy();
                                o.mult(t), this.isStrokeShader() && ("default" === this._renderer._curCamera.cameraType ? this.setUniform("uPerspective", 1) : this.setUniform("uPerspective", 0)), this.setUniform("uViewMatrix", e1.mat4), this.setUniform("uProjectionMatrix", t.mat4), this.setUniform("uModelViewMatrix", r.mat4), this.setUniform("uModelViewProjectionMatrix", o.mat4), this.uniforms.uNormalMatrix && (this._renderer.uNMatrix.inverseTranspose(this._renderer.uMVMatrix), this.setUniform("uNormalMatrix", this._renderer.uNMatrix.mat3));
                            }
                        },
                        {
                            key: "useProgram",
                            value: function() {
                                var e1 = this._renderer.GL;
                                return this._renderer._curShader !== this && (e1.useProgram(this._glProgram), this._renderer._curShader = this), this;
                            }
                        },
                        {
                            key: "setUniform",
                            value: function(e1, t) {
                                var r = this.uniforms[e1];
                                if (r) {
                                    var o = this._renderer.GL;
                                    if (r.isArray) {
                                        if (r._cachedData && this._renderer._arraysEqual(r._cachedData, t)) return;
                                        r._cachedData = t.slice(0);
                                    } else {
                                        if (r._cachedData && r._cachedData === t) return;
                                        Array.isArray(t) ? r._cachedData = t.slice(0) : r._cachedData = t;
                                    }
                                    var n = r.location;
                                    switch(this.useProgram(), r.type){
                                        case o.BOOL:
                                            !0 === t ? o.uniform1i(n, 1) : o.uniform1i(n, 0);
                                            break;
                                        case o.INT:
                                            1 < r.size ? t.length && o.uniform1iv(n, t) : o.uniform1i(n, t);
                                            break;
                                        case o.FLOAT:
                                            1 < r.size ? t.length && o.uniform1fv(n, t) : o.uniform1f(n, t);
                                            break;
                                        case o.FLOAT_MAT3:
                                            o.uniformMatrix3fv(n, !1, t);
                                            break;
                                        case o.FLOAT_MAT4:
                                            o.uniformMatrix4fv(n, !1, t);
                                            break;
                                        case o.FLOAT_VEC2:
                                            1 < r.size ? t.length && o.uniform2fv(n, t) : o.uniform2f(n, t[0], t[1]);
                                            break;
                                        case o.FLOAT_VEC3:
                                            1 < r.size ? t.length && o.uniform3fv(n, t) : o.uniform3f(n, t[0], t[1], t[2]);
                                            break;
                                        case o.FLOAT_VEC4:
                                            1 < r.size ? t.length && o.uniform4fv(n, t) : o.uniform4f(n, t[0], t[1], t[2], t[3]);
                                            break;
                                        case o.INT_VEC2:
                                            1 < r.size ? t.length && o.uniform2iv(n, t) : o.uniform2i(n, t[0], t[1]);
                                            break;
                                        case o.INT_VEC3:
                                            1 < r.size ? t.length && o.uniform3iv(n, t) : o.uniform3i(n, t[0], t[1], t[2]);
                                            break;
                                        case o.INT_VEC4:
                                            1 < r.size ? t.length && o.uniform4iv(n, t) : o.uniform4i(n, t[0], t[1], t[2], t[3]);
                                            break;
                                        case o.SAMPLER_2D:
                                            o.activeTexture(o.TEXTURE0 + r.samplerIndex), r.texture = t instanceof s.default.Texture ? t : this._renderer.getTexture(t), o.uniform1i(n, r.samplerIndex), r.texture.src.gifProperties && r.texture.src._animateGif(this._renderer._pInst);
                                    }
                                    return this;
                                }
                            }
                        },
                        {
                            key: "isLightShader",
                            value: function() {
                                return void 0 !== this.attributes.aNormal || void 0 !== this.uniforms.uUseLighting || void 0 !== this.uniforms.uAmbientLightCount || void 0 !== this.uniforms.uDirectionalLightCount || void 0 !== this.uniforms.uPointLightCount || void 0 !== this.uniforms.uAmbientColor || void 0 !== this.uniforms.uDirectionalDiffuseColors || void 0 !== this.uniforms.uDirectionalSpecularColors || void 0 !== this.uniforms.uPointLightLocation || void 0 !== this.uniforms.uPointLightDiffuseColors || void 0 !== this.uniforms.uPointLightSpecularColors || void 0 !== this.uniforms.uLightingDirection || void 0 !== this.uniforms.uSpecular;
                            }
                        },
                        {
                            key: "isNormalShader",
                            value: function() {
                                return void 0 !== this.attributes.aNormal;
                            }
                        },
                        {
                            key: "isTextureShader",
                            value: function() {
                                return 0 < this.samplers.length;
                            }
                        },
                        {
                            key: "isColorShader",
                            value: function() {
                                return void 0 !== this.attributes.aVertexColor || void 0 !== this.uniforms.uMaterialColor;
                            }
                        },
                        {
                            key: "isTexLightShader",
                            value: function() {
                                return this.isLightShader() && this.isTextureShader();
                            }
                        },
                        {
                            key: "isStrokeShader",
                            value: function() {
                                return void 0 !== this.uniforms.uStrokeWeight;
                            }
                        },
                        {
                            key: "enableAttrib",
                            value: function(e1, t, r, o, n, s) {
                                var i;
                                return e1 && -1 !== (e1 = e1.location) && (i = this._renderer.GL, this._renderer.registerEnabled[e1] || (i.enableVertexAttribArray(e1), this._renderer.registerEnabled[e1] = !0), this._renderer.GL.vertexAttribPointer(e1, t, r || i.FLOAT, o || !1, n || 0, s || 0)), this;
                            }
                        }
                    ], n(e1.prototype, t), r && n(e1, r), o;
                }();
                e1 = s.default.Shader;
                r.default = e1;
            },
            {
                "../core/main": 273,
                "core-js/modules/es.array.index-of": 159,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.array.slice": 164,
                "core-js/modules/es.function.name": 167,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        330: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.typed-array.uint8-array"), e1("core-js/modules/es.typed-array.copy-within"), e1("core-js/modules/es.typed-array.every"), e1("core-js/modules/es.typed-array.fill"), e1("core-js/modules/es.typed-array.filter"), e1("core-js/modules/es.typed-array.find"), e1("core-js/modules/es.typed-array.find-index"), e1("core-js/modules/es.typed-array.for-each"), e1("core-js/modules/es.typed-array.includes"), e1("core-js/modules/es.typed-array.index-of"), e1("core-js/modules/es.typed-array.iterator"), e1("core-js/modules/es.typed-array.join"), e1("core-js/modules/es.typed-array.last-index-of"), e1("core-js/modules/es.typed-array.map"), e1("core-js/modules/es.typed-array.reduce"), e1("core-js/modules/es.typed-array.reduce-right"), e1("core-js/modules/es.typed-array.reverse"), e1("core-js/modules/es.typed-array.set"), e1("core-js/modules/es.typed-array.slice"), e1("core-js/modules/es.typed-array.some"), e1("core-js/modules/es.typed-array.sort"), e1("core-js/modules/es.typed-array.subarray"), e1("core-js/modules/es.typed-array.to-locale-string"), e1("core-js/modules/es.typed-array.to-string"), Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.checkWebGLCapabilities = c, r.default = void 0;
                var s = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, a = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = l();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function l() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, l = function() {
                        return e1;
                    }, e1);
                }
                function u(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function c(e1) {
                    var t = e1.GL, e1 = e1.webglVersion, r = e1 === a.WEBGL2 ? t.getExtension("EXT_color_buffer_float") && t.getExtension("EXT_float_blend") : t.getExtension("OES_texture_float"), o = r && t.getExtension("OES_texture_float_linear"), e1 = e1 === a.WEBGL2 ? t.getExtension("EXT_color_buffer_float") : t.getExtension("OES_texture_half_float");
                    return {
                        float: r,
                        floatLinear: o,
                        halfFloat: e1,
                        halfFloatLinear: e1 && t.getExtension("OES_texture_half_float_linear")
                    };
                }
                s.default.Texture = function() {
                    function n(e1, t, r) {
                        if (!(this instanceof n)) throw new TypeError("Cannot call a class as a function");
                        this._renderer = e1;
                        var o = this._renderer.GL, r = (r = r || {}, this.src = t, this.glTex = void 0, this.glTarget = o.TEXTURE_2D, this.glFormat = r.format || o.RGBA, this.mipmaps = !1, this.glMinFilter = r.minFilter || o.LINEAR, this.glMagFilter = r.magFilter || o.LINEAR, this.glWrapS = r.wrapS || o.CLAMP_TO_EDGE, this.glWrapT = r.wrapT || o.CLAMP_TO_EDGE, this.glDataType = r.dataType || o.UNSIGNED_BYTE, c(e1)), e1 = (this.glFormat !== o.HALF_FLOAT || r.halfFloat || (console.log("This device does not support dataType HALF_FLOAT. Falling back to FLOAT."), this.glDataType = o.FLOAT), this.glFormat !== o.HALF_FLOAT || this.glMinFilter !== o.LINEAR && this.glMagFilter !== o.LINEAR || r.halfFloatLinear || (console.log("This device does not support linear filtering for dataType FLOAT. Falling back to NEAREST."), this.glMinFilter === o.LINEAR && (this.glMinFilter = o.NEAREST), this.glMagFilter === o.LINEAR && (this.glMagFilter = o.NEAREST)), this.glFormat !== o.FLOAT || r.float || (console.log("This device does not support dataType FLOAT. Falling back to UNSIGNED_BYTE."), this.glDataType = o.UNSIGNED_BYTE), this.glFormat !== o.FLOAT || this.glMinFilter !== o.LINEAR && this.glMagFilter !== o.LINEAR || r.floatLinear || (console.log("This device does not support linear filtering for dataType FLOAT. Falling back to NEAREST."), this.glMinFilter === o.LINEAR && (this.glMinFilter = o.NEAREST), this.glMagFilter === o.LINEAR && (this.glMagFilter = o.NEAREST)), this.isSrcMediaElement = void 0 !== s.default.MediaElement && t instanceof s.default.MediaElement, this._videoPrevUpdateTime = 0, this.isSrcHTMLElement = void 0 !== s.default.Element && t instanceof s.default.Element && !(t instanceof s.default.Graphics) && !(t instanceof s.default.Renderer), this.isSrcP5Image = t instanceof s.default.Image, this.isSrcP5Graphics = t instanceof s.default.Graphics, this.isSrcP5Renderer = t instanceof s.default.Renderer, this.isImageData = "undefined" != typeof ImageData && t instanceof ImageData, this.isFramebufferTexture = t instanceof s.default.FramebufferTexture, this._getTextureDataFromSource());
                        return this.width = e1.width, this.height = e1.height, this.init(e1), this;
                    }
                    var e1, t, r;
                    return e1 = n, t = [
                        {
                            key: "_getTextureDataFromSource",
                            value: function() {
                                var e1;
                                return this.isFramebufferTexture ? e1 = this.src.rawTexture() : this.isSrcP5Image ? e1 = this.src.canvas : this.isSrcMediaElement || this.isSrcP5Graphics || this.isSrcP5Renderer || this.isSrcHTMLElement ? e1 = this.src.elt : this.isImageData && (e1 = this.src), e1;
                            }
                        },
                        {
                            key: "init",
                            value: function(e1) {
                                var t, r = this._renderer.GL;
                                this.isFramebufferTexture || (this.glTex = r.createTexture()), this.glWrapS = this._renderer.textureWrapX, this.glWrapT = this._renderer.textureWrapY, this.setWrapMode(this.glWrapS, this.glWrapT), this.bindTexture(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, this.glMagFilter), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.glMinFilter), this.isFramebufferTexture || (0 === this.width || 0 === this.height || this.isSrcMediaElement && !this.src.loadedmetadata ? (t = new Uint8Array([
                                    1,
                                    1,
                                    1,
                                    1
                                ]), r.texImage2D(this.glTarget, 0, r.RGBA, 1, 1, 0, this.glFormat, this.glDataType, t)) : r.texImage2D(this.glTarget, 0, this.glFormat, this.glFormat, this.glDataType, e1));
                            }
                        },
                        {
                            key: "update",
                            value: function() {
                                var e1, t, r, o = this.src;
                                return 0 !== o.width && 0 !== o.height && !this.isFramebufferTexture && (e1 = this._getTextureDataFromSource(), t = !1, r = this._renderer.GL, e1.width !== this.width || e1.height !== this.height ? (t = !0, this.width = e1.width || o.width, this.height = e1.height || o.height, this.isSrcP5Image ? o.setModified(!1) : (this.isSrcMediaElement || this.isSrcHTMLElement) && o.setModified(!0)) : this.isSrcP5Image ? o.isModified() && o.setModified((t = !0, false)) : this.isSrcMediaElement ? o.isModified() ? o.setModified((t = !0, false)) : o.loadedmetadata && this._videoPrevUpdateTime !== o.time() && (this._videoPrevUpdateTime = o.time(), t = !0) : this.isImageData ? o._dirty && (t = (o._dirty = !1, true)) : t = !0, t && (this.bindTexture(), r.texImage2D(this.glTarget, 0, this.glFormat, this.glFormat, this.glDataType, e1)), t);
                            }
                        },
                        {
                            key: "bindTexture",
                            value: function() {
                                return this._renderer.GL.bindTexture(this.glTarget, this.getTexture()), this;
                            }
                        },
                        {
                            key: "unbindTexture",
                            value: function() {
                                this._renderer.GL.bindTexture(this.glTarget, null);
                            }
                        },
                        {
                            key: "getTexture",
                            value: function() {
                                return this.isFramebufferTexture ? this.src.rawTexture() : this.glTex;
                            }
                        },
                        {
                            key: "setInterpolation",
                            value: function(e1, t) {
                                var r = this._renderer.GL;
                                e1 === a.NEAREST ? this.glMinFilter = r.NEAREST : this.glMinFilter = r.LINEAR, t === a.NEAREST ? this.glMagFilter = r.NEAREST : this.glMagFilter = r.LINEAR, this.bindTexture(), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.glMinFilter), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, this.glMagFilter), this.unbindTexture();
                            }
                        },
                        {
                            key: "setWrapMode",
                            value: function(e1, t) {
                                function r(e1) {
                                    return 0 == (e1 & e1 - 1);
                                }
                                var o = this._renderer.GL, n = this._getTextureDataFromSource(), n = n.naturalWidth && n.naturalHeight ? (s = n.naturalWidth, n.naturalHeight) : (s = this.width, this.height), s = r(s), n = r(n);
                                e1 === a.REPEAT ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapS = o.REPEAT : (console.warn("You tried to set the wrap mode to REPEAT but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapS = o.CLAMP_TO_EDGE) : e1 === a.MIRROR ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapS = o.MIRRORED_REPEAT : (console.warn("You tried to set the wrap mode to MIRROR but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapS = o.CLAMP_TO_EDGE) : this.glWrapS = o.CLAMP_TO_EDGE, t === a.REPEAT ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapT = o.REPEAT : (console.warn("You tried to set the wrap mode to REPEAT but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapT = o.CLAMP_TO_EDGE) : t === a.MIRROR ? this._renderer.webglVersion === a.WEBGL2 || s && n ? this.glWrapT = o.MIRRORED_REPEAT : (console.warn("You tried to set the wrap mode to MIRROR but the texture size is not a power of two. Setting to CLAMP instead"), this.glWrapT = o.CLAMP_TO_EDGE) : this.glWrapT = o.CLAMP_TO_EDGE, this.bindTexture(), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, this.glWrapS), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, this.glWrapT), this.unbindTexture();
                            }
                        }
                    ], u(e1.prototype, t), r && u(e1, r), n;
                }();
                var n = s.default.Texture;
                r.default = n;
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.typed-array.copy-within": 203,
                "core-js/modules/es.typed-array.every": 204,
                "core-js/modules/es.typed-array.fill": 205,
                "core-js/modules/es.typed-array.filter": 206,
                "core-js/modules/es.typed-array.find": 208,
                "core-js/modules/es.typed-array.find-index": 207,
                "core-js/modules/es.typed-array.for-each": 211,
                "core-js/modules/es.typed-array.includes": 212,
                "core-js/modules/es.typed-array.index-of": 213,
                "core-js/modules/es.typed-array.iterator": 216,
                "core-js/modules/es.typed-array.join": 217,
                "core-js/modules/es.typed-array.last-index-of": 218,
                "core-js/modules/es.typed-array.map": 219,
                "core-js/modules/es.typed-array.reduce": 221,
                "core-js/modules/es.typed-array.reduce-right": 220,
                "core-js/modules/es.typed-array.reverse": 222,
                "core-js/modules/es.typed-array.set": 223,
                "core-js/modules/es.typed-array.slice": 224,
                "core-js/modules/es.typed-array.some": 225,
                "core-js/modules/es.typed-array.sort": 226,
                "core-js/modules/es.typed-array.subarray": 227,
                "core-js/modules/es.typed-array.to-locale-string": 228,
                "core-js/modules/es.typed-array.to-string": 229,
                "core-js/modules/es.typed-array.uint8-array": 232,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ],
        331: [
            function(e1, t, r) {
                "use strict";
                function o(e1) {
                    return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    })(e1);
                }
                function i(e1) {
                    return (i = "function" == typeof Symbol && "symbol" === o(Symbol.iterator) ? function(e1) {
                        return o(e1);
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : o(e1);
                    })(e1);
                }
                e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.get-own-property-descriptor"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/es.weak-map"), e1("core-js/modules/web.dom-collections.iterator"), e1("core-js/modules/es.symbol"), e1("core-js/modules/es.symbol.description"), e1("core-js/modules/es.symbol.iterator"), e1("core-js/modules/es.array.iterator"), e1("core-js/modules/es.object.to-string"), e1("core-js/modules/es.regexp.exec"), e1("core-js/modules/es.string.iterator"), e1("core-js/modules/es.string.split"), e1("core-js/modules/es.string.sub"), e1("core-js/modules/web.dom-collections.iterator");
                var n, B = (n = e1("../core/main")) && n.__esModule ? n : {
                    default: n
                }, M = function(e1) {
                    if (e1 && e1.__esModule) return e1;
                    if (null === e1 || "object" !== i(e1) && "function" != typeof e1) return {
                        default: e1
                    };
                    var t = a();
                    if (t && t.has(e1)) return t.get(e1);
                    var r, o = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(r in e1){
                        var s;
                        Object.prototype.hasOwnProperty.call(e1, r) && ((s = n ? Object.getOwnPropertyDescriptor(e1, r) : null) && (s.get || s.set) ? Object.defineProperty(o, r, s) : o[r] = e1[r]);
                    }
                    o.default = e1, t && t.set(e1, o);
                    return o;
                }(e1("../core/constants"));
                function a() {
                    var e1;
                    return "function" != typeof WeakMap ? null : (e1 = new WeakMap, a = function() {
                        return e1;
                    }, e1);
                }
                function G(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function s(e1, t) {
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, o.key, o);
                    }
                }
                function V(e1, t, r) {
                    t && s(e1.prototype, t), r && s(e1, r);
                }
                e1("./p5.Shader"), e1("./p5.RendererGL.Retained"), B.default.RendererGL.prototype._applyTextProperties = function() {}, B.default.RendererGL.prototype.textWidth = function(e1) {
                    return this._isOpenType() ? this._textFont._textWidth(e1, this._textSize) : 0;
                };
                var l = function() {
                    function r(e1, t) {
                        G(this, r), this.width = e1, this.height = t, this.infos = [];
                    }
                    return V(r, [
                        {
                            key: "findImage",
                            value: function(e1) {
                                var t, r, o = this.width * this.height;
                                if (o < e1) throw new Error("font is too complex to render in 3D");
                                for(var n = this.infos.length - 1; 0 <= n; --n){
                                    var s = this.infos[n];
                                    if (s.index + e1 < o) {
                                        r = (t = s).imageData;
                                        break;
                                    }
                                }
                                if (!t) {
                                    try {
                                        r = new ImageData(this.width, this.height);
                                    } catch (e1) {
                                        var i = document.getElementsByTagName("canvas")[0], a = !i, l = (i || ((i = document.createElement("canvas")).style.display = "none", document.body.appendChild(i)), i.getContext("2d"));
                                        l && (r = l.createImageData(this.width, this.height)), a && document.body.removeChild(i);
                                    }
                                    this.infos.push(t = {
                                        index: 0,
                                        imageData: r
                                    });
                                }
                                l = t.index;
                                return t.index += e1, r._dirty = !0, {
                                    imageData: r,
                                    index: l
                                };
                            }
                        }
                    ]), r;
                }();
                function z(e1, t, r, o, n) {
                    var s = e1.imageData.data, e1 = 4 * e1.index++;
                    s[e1++] = t, s[e1++] = r, s[e1++] = o, s[+e1] = n;
                }
                var H = Math.sqrt(3), T = function() {
                    function t(e1) {
                        G(this, t), this.font = e1, this.strokeImageInfos = new l(64, 64), this.colDimImageInfos = new l(64, 64), this.rowDimImageInfos = new l(64, 64), this.colCellImageInfos = new l(64, 64), this.rowCellImageInfos = new l(64, 64), this.glyphInfos = {};
                    }
                    return V(t, [
                        {
                            key: "getGlyphInfo",
                            value: function(e1) {
                                var t = this.glyphInfos[e1.index];
                                if (!t) {
                                    var r = e1.getBoundingBox(), o = r.x1, n = r.y1, s = r.x2 - o, i = r.y2 - n, a = e1.path.commands;
                                    if (0 == s || 0 == i || !a.length) return this.glyphInfos[e1.index] = {};
                                    for(var u = [], c = [], d = [], l = 8; 0 <= l; --l)d.push([]);
                                    for(l = 8; 0 <= l; --l)c.push([]);
                                    var f, h, p, m, D = function() {
                                        function n(e1, t, r, o) {
                                            G(this, n), this.p0 = e1, this.c0 = t, this.c1 = r, this.p1 = o;
                                        }
                                        return V(n, [
                                            {
                                                key: "toQuadratic",
                                                value: function() {
                                                    return {
                                                        x: this.p0.x,
                                                        y: this.p0.y,
                                                        x1: this.p1.x,
                                                        y1: this.p1.y,
                                                        cx: (3 * (this.c0.x + this.c1.x) - (this.p0.x + this.p1.x)) / 4,
                                                        cy: (3 * (this.c0.y + this.c1.y) - (this.p0.y + this.p1.y)) / 4
                                                    };
                                                }
                                            },
                                            {
                                                key: "quadError",
                                                value: function() {
                                                    return B.default.Vector.sub(B.default.Vector.sub(this.p1, this.p0), B.default.Vector.mult(B.default.Vector.sub(this.c1, this.c0), 3)).mag() / 2;
                                                }
                                            },
                                            {
                                                key: "split",
                                                value: function(e1) {
                                                    var t = B.default.Vector.lerp(this.p0, this.c0, e1), r = B.default.Vector.lerp(this.c0, this.c1, e1), o = B.default.Vector.lerp(t, r, e1), r = (this.c1 = B.default.Vector.lerp(this.c1, this.p1, e1), this.c0 = B.default.Vector.lerp(r, this.c1, e1), B.default.Vector.lerp(o, this.c0, e1)), e1 = new n(this.p0, t, o, r);
                                                    return this.p0 = r, e1;
                                                }
                                            },
                                            {
                                                key: "splitInflections",
                                                value: function() {
                                                    var e1 = B.default.Vector.sub(this.c0, this.p0), t = B.default.Vector.sub(B.default.Vector.sub(this.c1, this.c0), e1), r = B.default.Vector.sub(B.default.Vector.sub(B.default.Vector.sub(this.p1, this.c1), e1), B.default.Vector.mult(t, 2)), o = [], n = t.x * r.y - t.y * r.x;
                                                    return 0 !== n && 0 <= (e1 = (r = e1.x * r.y - e1.y * r.x) * r - 4 * n * (e1.x * t.y - e1.y * t.x)) && (n < 0 && (n = -n, r = -r), e1 = (-r + (t = Math.sqrt(e1))) / (2 * n), 0 < (r = (-r - t) / (2 * n)) && r < 1 && (o.push(this.split(r)), e1 = 1 - (1 - e1) / (1 - r)), 0 < e1 && e1 < 1 && o.push(this.split(e1))), o.push(this), o;
                                                }
                                            }
                                        ]), n;
                                    }(), y = !0, g = !1, v = void 0;
                                    try {
                                        for(var b, j = a[Symbol.iterator](); !(y = (b = j.next()).done); y = !0){
                                            var _ = b.value, x = (_.x - o) / s, w = (_.y - n) / i;
                                            if (!U(f, h, x, w)) {
                                                switch(_.type){
                                                    case "M":
                                                        p = x, m = w;
                                                        break;
                                                    case "L":
                                                        I(f, h, x, w);
                                                        break;
                                                    case "Q":
                                                        var S = (_.x1 - o) / s, E = (_.y1 - n) / i;
                                                        L([
                                                            f,
                                                            x,
                                                            S
                                                        ], [
                                                            h,
                                                            w,
                                                            E
                                                        ], {
                                                            x: f,
                                                            y: h,
                                                            cx: S,
                                                            cy: E
                                                        });
                                                        break;
                                                    case "Z":
                                                        U(f, h, p, m) ? u.push({
                                                            x: f,
                                                            y: h
                                                        }) : (I(f, h, p, m), u.push({
                                                            x: p,
                                                            y: m
                                                        }));
                                                        break;
                                                    case "C":
                                                        for(var M = function(e1, t, r, o, n, s, i, a) {
                                                            var e1 = new D(new B.default.Vector(e1, t), new B.default.Vector(r, o), new B.default.Vector(n, s), new B.default.Vector(i, a)).splitInflections(), l = [], u = 30 / H, c = !0, t = !1, r = void 0;
                                                            try {
                                                                for(var d, f = e1[Symbol.iterator](); !(c = (d = f.next()).done); c = !0){
                                                                    for(var h = d.value, p = [], m = void 0; !(.125 <= (m = u / h.quadError()));){
                                                                        var y = Math.pow(m, 1 / 3), g = h.split(y), v = h.split(1 - y / (1 - y));
                                                                        l.push(g), p.push(h), h = v;
                                                                    }
                                                                    m < 1 && l.push(h.split(.5)), l.push(h), Array.prototype.push.apply(l, p.reverse());
                                                                }
                                                            } catch (e1) {
                                                                t = !0, r = e1;
                                                            } finally{
                                                                try {
                                                                    c || null == f.return || f.return();
                                                                } finally{
                                                                    if (t) throw r;
                                                                }
                                                            }
                                                            return l;
                                                        }(f, h, (_.x1 - o) / s, (_.y1 - n) / i, (_.x2 - o) / s, (_.y2 - n) / i, x, w), T = 0; T < M.length; T++){
                                                            var k = M[T].toQuadratic();
                                                            L([
                                                                k.x,
                                                                k.x1,
                                                                k.cx
                                                            ], [
                                                                k.y,
                                                                k.y1,
                                                                k.cy
                                                            ], k);
                                                        }
                                                        break;
                                                    default:
                                                        throw new Error("unknown command type: ".concat(_.type));
                                                }
                                                f = x, h = w;
                                            }
                                        }
                                    } catch (e1) {
                                        g = !0, v = e1;
                                    } finally{
                                        try {
                                            y || null == j.return || j.return();
                                        } finally{
                                            if (g) throw v;
                                        }
                                    }
                                    for(var O = u.length, C = this.strokeImageInfos.findImage(O), F = C.index, A = 0; A < O; ++A){
                                        var P = u[A];
                                        z(C, R(P.x), R(P.y), R(P.cx), R(P.cy));
                                    }
                                    (t = this.glyphInfos[e1.index] = {
                                        glyph: e1,
                                        uGlyphRect: [
                                            r.x1,
                                            -r.y1,
                                            r.x2,
                                            -r.y2
                                        ],
                                        strokeImageInfo: C,
                                        strokes: u,
                                        colInfo: N(d, this.colDimImageInfos, this.colCellImageInfos),
                                        rowInfo: N(c, this.rowDimImageInfos, this.rowCellImageInfos)
                                    }).uGridOffset = [
                                        t.colInfo.dimOffset,
                                        t.rowInfo.dimOffset
                                    ];
                                }
                                return t;
                                function L(e1, t, r) {
                                    var o = u.length;
                                    function n(e1, t, r) {
                                        for(var o = e1.length; 0 < o--;){
                                            var n = e1[o];
                                            n < t && (t = n), r < n && (r = n);
                                        }
                                        return {
                                            min: t,
                                            max: r
                                        };
                                    }
                                    u.push(r);
                                    for(var r = n(e1, 1, 0), e1 = Math.max(Math.floor(9 * r.min - .5), 0), s = Math.min(Math.ceil(9 * r.max + .5), 9), i = e1; i < s; ++i)d[i].push(o);
                                    for(var r = n(t, 1, 0), e1 = Math.max(Math.floor(9 * r.min - .5), 0), a = Math.min(Math.ceil(9 * r.max + .5), 9), l = e1; l < a; ++l)c[l].push(o);
                                }
                                function R(e1) {
                                    var t, r;
                                    return (e1 = (r = 255) * e1) < (t = 0) ? t : r < e1 ? r : e1;
                                }
                                function I(e1, t, r, o) {
                                    L([
                                        e1,
                                        r
                                    ], [
                                        t,
                                        o
                                    ], {
                                        x: e1,
                                        y: t,
                                        cx: (e1 + r) / 2,
                                        cy: (t + o) / 2
                                    });
                                }
                                function U(e1, t, r, o) {
                                    return Math.abs(r - e1) < 1e-5 && Math.abs(o - t) < 1e-5;
                                }
                                function N(e1, t, r) {
                                    for(var o = e1.length, n = t.findImage(o), t = n.index, s = 0, i = 0; i < o; ++i)s += e1[i].length;
                                    for(var a = r.findImage(s), l = 0; l < o; ++l){
                                        var u = e1[l], c = u.length, d = a.index;
                                        z(n, d >> 7, 127 & d, c >> 7, 127 & c);
                                        for(var f = 0; f < c; ++f){
                                            var h = u[f] + F;
                                            z(a, h >> 7, 127 & h, 0, 0);
                                        }
                                    }
                                    return {
                                        cellImageInfo: a,
                                        dimOffset: t,
                                        dimImageInfo: n
                                    };
                                }
                            }
                        }
                    ]), t;
                }();
                B.default.RendererGL.prototype._renderText = function(e1, t, r, o, n) {
                    if (this._textFont && "string" != typeof this._textFont) {
                        if (!(n <= o) && this._doFill) {
                            if (this._isOpenType()) {
                                e1.push();
                                var n = this._doStroke, s = this.drawMode, i = (this._doStroke = !1, this.drawMode = M.TEXTURE, this._textFont.font), a = (a = this._textFont._fontInfo) || (this._textFont._fontInfo = new T(i)), r = this._textFont._handleAlignment(this, t, r, o), o = this._textSize / i.unitsPerEm, l = (this.translate(r.x, r.y, 0), this.scale(o, o, 1), this.GL), r = !this._defaultFontShader, u = this._getFontShader(), c = (u.init(), u.bindShader(), r && (u.setUniform("uGridImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uCellsImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uStrokeImageSize", [
                                    64,
                                    64
                                ]), u.setUniform("uGridSize", [
                                    9,
                                    9
                                ])), this._applyColorBlend(this.curFillColor), this.retainedMode.geometry.glyph), d = (c || ((o = this._textGeom = new B.default.Geometry(1, 1, function() {
                                    for(var e1 = 0; e1 <= 1; e1++)for(var t = 0; t <= 1; t++)this.vertices.push(new B.default.Vector(t, e1, 0)), this.uvs.push(t, e1);
                                })).computeFaces().computeNormals(), c = this.createBuffers("glyph", o)), !0), r = !1, o = void 0;
                                try {
                                    for(var f, h = this.retainedMode.buffers.text[Symbol.iterator](); !(d = (f = h.next()).done); d = !0)f.value._prepareBuffer(c, u);
                                } catch (e1) {
                                    r = !0, o = e1;
                                } finally{
                                    try {
                                        d || null == h.return || h.return();
                                    } finally{
                                        if (r) throw o;
                                    }
                                }
                                this._bindBuffer(c.indexBuffer, l.ELEMENT_ARRAY_BUFFER), u.setUniform("uMaterialColor", this.curFillColor), l.pixelStorei(l.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1);
                                try {
                                    var p = 0, m = null, y = i.stringToGlyphs(t), g = !0, v = !1, b = void 0;
                                    try {
                                        for(var j, _ = y[Symbol.iterator](); !(g = (j = _.next()).done); g = !0){
                                            var x, w, S = j.value, E = (m && (p += i.getKerningValue(m, S)), a.getGlyphInfo(S));
                                            E.uGlyphRect && (x = E.rowInfo, w = E.colInfo, u.setUniform("uSamplerStrokes", E.strokeImageInfo.imageData), u.setUniform("uSamplerRowStrokes", x.cellImageInfo.imageData), u.setUniform("uSamplerRows", x.dimImageInfo.imageData), u.setUniform("uSamplerColStrokes", w.cellImageInfo.imageData), u.setUniform("uSamplerCols", w.dimImageInfo.imageData), u.setUniform("uGridOffset", E.uGridOffset), u.setUniform("uGlyphRect", E.uGlyphRect), u.setUniform("uGlyphOffset", p), u.bindTextures(), l.drawElements(l.TRIANGLES, 6, this.GL.UNSIGNED_SHORT, 0)), p += S.advanceWidth, m = S;
                                        }
                                    } catch (e1) {
                                        v = !0, b = e1;
                                    } finally{
                                        try {
                                            g || null == _.return || _.return();
                                        } finally{
                                            if (v) throw b;
                                        }
                                    }
                                } finally{
                                    u.unbindShader(), this._doStroke = n, this.drawMode = s, l.pixelStorei(l.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), e1.pop();
                                }
                            } else console.log("WEBGL: only Opentype (.otf) and Truetype (.ttf) fonts are supported");
                            return e1;
                        }
                    } else console.log("WEBGL: you must load and set a font before drawing text. See `loadFont` and `textFont` for more details.");
                };
            },
            {
                "../core/constants": 262,
                "../core/main": 273,
                "./p5.RendererGL.Retained": 327,
                "./p5.Shader": 329,
                "core-js/modules/es.array.iterator": 160,
                "core-js/modules/es.object.get-own-property-descriptor": 176,
                "core-js/modules/es.object.to-string": 180,
                "core-js/modules/es.regexp.exec": 185,
                "core-js/modules/es.string.iterator": 190,
                "core-js/modules/es.string.split": 196,
                "core-js/modules/es.string.sub": 198,
                "core-js/modules/es.symbol": 202,
                "core-js/modules/es.symbol.description": 200,
                "core-js/modules/es.symbol.iterator": 201,
                "core-js/modules/es.weak-map": 234,
                "core-js/modules/web.dom-collections.iterator": 236
            }
        ]
    }, {}, [
        257
    ])(257);
});


const $8087cb83ba2ea5ef$export$83d89fbfd8236492 = "14.7.77";


var $8f6857d83370bfe9$exports = {};



(function(global, factory) {
    factory($8f6857d83370bfe9$exports, (parcelRequire("02Ztr")), (parcelRequire("fu0YK")), (parcelRequire("lR7jo")));
})($8f6857d83370bfe9$exports, function(exports1, _slicedToArray, _classCallCheck, _createClass) {
    "use strict";
    var createExtendedExponentialRampToValueAutomationEvent = function createExtendedExponentialRampToValueAutomationEvent(value, endTime, insertTime) {
        return {
            endTime: endTime,
            insertTime: insertTime,
            type: "exponentialRampToValue",
            value: value
        };
    };
    var createExtendedLinearRampToValueAutomationEvent = function createExtendedLinearRampToValueAutomationEvent(value, endTime, insertTime) {
        return {
            endTime: endTime,
            insertTime: insertTime,
            type: "linearRampToValue",
            value: value
        };
    };
    var createSetValueAutomationEvent = function createSetValueAutomationEvent(value, startTime) {
        return {
            startTime: startTime,
            type: "setValue",
            value: value
        };
    };
    var createSetValueCurveAutomationEvent = function createSetValueCurveAutomationEvent(values, startTime, duration) {
        return {
            duration: duration,
            startTime: startTime,
            type: "setValueCurve",
            values: values
        };
    };
    var getTargetValueAtTime = function getTargetValueAtTime(time, valueAtStartTime, _ref) {
        var startTime = _ref.startTime, target = _ref.target, timeConstant = _ref.timeConstant;
        return target + (valueAtStartTime - target) * Math.exp((startTime - time) / timeConstant);
    };
    var isExponentialRampToValueAutomationEvent = function isExponentialRampToValueAutomationEvent(automationEvent) {
        return automationEvent.type === "exponentialRampToValue";
    };
    var isLinearRampToValueAutomationEvent = function isLinearRampToValueAutomationEvent(automationEvent) {
        return automationEvent.type === "linearRampToValue";
    };
    var isAnyRampToValueAutomationEvent = function isAnyRampToValueAutomationEvent(automationEvent) {
        return isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent);
    };
    var isSetValueAutomationEvent = function isSetValueAutomationEvent(automationEvent) {
        return automationEvent.type === "setValue";
    };
    var isSetValueCurveAutomationEvent = function isSetValueCurveAutomationEvent(automationEvent) {
        return automationEvent.type === "setValueCurve";
    };
    var getValueOfAutomationEventAtIndexAtTime = function getValueOfAutomationEventAtIndexAtTime(automationEvents, index, time, defaultValue) {
        var automationEvent = automationEvents[index];
        return automationEvent === undefined ? defaultValue : isAnyRampToValueAutomationEvent(automationEvent) || isSetValueAutomationEvent(automationEvent) ? automationEvent.value : isSetValueCurveAutomationEvent(automationEvent) ? automationEvent.values[automationEvent.values.length - 1] : getTargetValueAtTime(time, getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, automationEvent.startTime, defaultValue), automationEvent);
    };
    var getEndTimeAndValueOfPreviousAutomationEvent = function getEndTimeAndValueOfPreviousAutomationEvent(automationEvents, index, currentAutomationEvent, nextAutomationEvent, defaultValue) {
        return currentAutomationEvent === undefined ? [
            nextAutomationEvent.insertTime,
            defaultValue
        ] : isAnyRampToValueAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.endTime,
            currentAutomationEvent.value
        ] : isSetValueAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.startTime,
            currentAutomationEvent.value
        ] : isSetValueCurveAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.startTime + currentAutomationEvent.duration,
            currentAutomationEvent.values[currentAutomationEvent.values.length - 1]
        ] : [
            currentAutomationEvent.startTime,
            getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, currentAutomationEvent.startTime, defaultValue)
        ];
    };
    var isCancelAndHoldAutomationEvent = function isCancelAndHoldAutomationEvent(automationEvent) {
        return automationEvent.type === "cancelAndHold";
    };
    var isCancelScheduledValuesAutomationEvent = function isCancelScheduledValuesAutomationEvent(automationEvent) {
        return automationEvent.type === "cancelScheduledValues";
    };
    var getEventTime = function getEventTime(automationEvent) {
        if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) return automationEvent.cancelTime;
        if (isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent)) return automationEvent.endTime;
        return automationEvent.startTime;
    };
    var getExponentialRampValueAtTime = function getExponentialRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
        var endTime = _ref.endTime, value = _ref.value;
        if (valueAtStartTime === value) return value;
        if (0 < valueAtStartTime && 0 < value || valueAtStartTime < 0 && value < 0) return valueAtStartTime * Math.pow(value / valueAtStartTime, (time - startTime) / (endTime - startTime));
        return 0;
    };
    var getLinearRampValueAtTime = function getLinearRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
        var endTime = _ref.endTime, value = _ref.value;
        return valueAtStartTime + (time - startTime) / (endTime - startTime) * (value - valueAtStartTime);
    };
    var interpolateValue = function interpolateValue(values, theoreticIndex) {
        var lowerIndex = Math.floor(theoreticIndex);
        var upperIndex = Math.ceil(theoreticIndex);
        if (lowerIndex === upperIndex) return values[lowerIndex];
        return (1 - (theoreticIndex - lowerIndex)) * values[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * values[upperIndex];
    };
    var getValueCurveValueAtTime = function getValueCurveValueAtTime(time, _ref) {
        var duration = _ref.duration, startTime = _ref.startTime, values = _ref.values;
        var theoreticIndex = (time - startTime) / duration * (values.length - 1);
        return interpolateValue(values, theoreticIndex);
    };
    var isSetTargetAutomationEvent = function isSetTargetAutomationEvent(automationEvent) {
        return automationEvent.type === "setTarget";
    };
    var AutomationEventList = /*#__PURE__*/ function(_Symbol$iterator) {
        function AutomationEventList(defaultValue) {
            _classCallCheck(this, AutomationEventList);
            this._automationEvents = [];
            this._currenTime = 0;
            this._defaultValue = defaultValue;
        }
        _createClass(AutomationEventList, [
            {
                key: _Symbol$iterator,
                value: function value() {
                    return this._automationEvents[Symbol.iterator]();
                }
            },
            {
                key: "add",
                value: function add(automationEvent) {
                    var eventTime = getEventTime(automationEvent);
                    if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) {
                        var index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                            if (isCancelScheduledValuesAutomationEvent(automationEvent) && isSetValueCurveAutomationEvent(currentAutomationEvent)) return currentAutomationEvent.startTime + currentAutomationEvent.duration >= eventTime;
                            return getEventTime(currentAutomationEvent) >= eventTime;
                        });
                        var removedAutomationEvent = this._automationEvents[index];
                        if (index !== -1) this._automationEvents = this._automationEvents.slice(0, index);
                        if (isCancelAndHoldAutomationEvent(automationEvent)) {
                            var lastAutomationEvent = this._automationEvents[this._automationEvents.length - 1];
                            if (removedAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(removedAutomationEvent)) {
                                if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) throw new Error("The internal list is malformed.");
                                var startTime = lastAutomationEvent === undefined ? removedAutomationEvent.insertTime : isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.startTime + lastAutomationEvent.duration : getEventTime(lastAutomationEvent);
                                var startValue = lastAutomationEvent === undefined ? this._defaultValue : isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.values[lastAutomationEvent.values.length - 1] : lastAutomationEvent.value;
                                var value = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? getExponentialRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent) : getLinearRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent);
                                var truncatedAutomationEvent = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? createExtendedExponentialRampToValueAutomationEvent(value, eventTime, this._currenTime) : createExtendedLinearRampToValueAutomationEvent(value, eventTime, this._currenTime);
                                this._automationEvents.push(truncatedAutomationEvent);
                            }
                            if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) this._automationEvents.push(createSetValueAutomationEvent(this.getValue(eventTime), eventTime));
                            if (lastAutomationEvent !== undefined && isSetValueCurveAutomationEvent(lastAutomationEvent) && lastAutomationEvent.startTime + lastAutomationEvent.duration > eventTime) {
                                var duration = eventTime - lastAutomationEvent.startTime;
                                var ratio = (lastAutomationEvent.values.length - 1) / lastAutomationEvent.duration;
                                var length = Math.max(2, 1 + Math.ceil(duration * ratio));
                                var fraction = duration / (length - 1) * ratio;
                                var values = lastAutomationEvent.values.slice(0, length);
                                if (fraction < 1) for(var i = 1; i < length; i += 1){
                                    var factor = fraction * i % 1;
                                    values[i] = lastAutomationEvent.values[i - 1] * (1 - factor) + lastAutomationEvent.values[i] * factor;
                                }
                                this._automationEvents[this._automationEvents.length - 1] = createSetValueCurveAutomationEvent(values, lastAutomationEvent.startTime, duration);
                            }
                        }
                    } else {
                        var _index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                            return getEventTime(currentAutomationEvent) > eventTime;
                        });
                        var previousAutomationEvent = _index === -1 ? this._automationEvents[this._automationEvents.length - 1] : this._automationEvents[_index - 1];
                        if (previousAutomationEvent !== undefined && isSetValueCurveAutomationEvent(previousAutomationEvent) && getEventTime(previousAutomationEvent) + previousAutomationEvent.duration > eventTime) return false;
                        var persistentAutomationEvent = isExponentialRampToValueAutomationEvent(automationEvent) ? createExtendedExponentialRampToValueAutomationEvent(automationEvent.value, automationEvent.endTime, this._currenTime) : isLinearRampToValueAutomationEvent(automationEvent) ? createExtendedLinearRampToValueAutomationEvent(automationEvent.value, eventTime, this._currenTime) : automationEvent;
                        if (_index === -1) this._automationEvents.push(persistentAutomationEvent);
                        else {
                            if (isSetValueCurveAutomationEvent(automationEvent) && eventTime + automationEvent.duration > getEventTime(this._automationEvents[_index])) return false;
                            this._automationEvents.splice(_index, 0, persistentAutomationEvent);
                        }
                    }
                    return true;
                }
            },
            {
                key: "flush",
                value: function flush(time) {
                    var index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                        return getEventTime(currentAutomationEvent) > time;
                    });
                    if (index > 1) {
                        var remainingAutomationEvents = this._automationEvents.slice(index - 1);
                        var firstRemainingAutomationEvent = remainingAutomationEvents[0];
                        if (isSetTargetAutomationEvent(firstRemainingAutomationEvent)) remainingAutomationEvents.unshift(createSetValueAutomationEvent(getValueOfAutomationEventAtIndexAtTime(this._automationEvents, index - 2, firstRemainingAutomationEvent.startTime, this._defaultValue), firstRemainingAutomationEvent.startTime));
                        this._automationEvents = remainingAutomationEvents;
                    }
                }
            },
            {
                key: "getValue",
                value: function getValue(time) {
                    if (this._automationEvents.length === 0) return this._defaultValue;
                    var indexOfNextEvent = this._automationEvents.findIndex(function(automationEvent) {
                        return getEventTime(automationEvent) > time;
                    });
                    var nextAutomationEvent = this._automationEvents[indexOfNextEvent];
                    var indexOfCurrentEvent = (indexOfNextEvent === -1 ? this._automationEvents.length : indexOfNextEvent) - 1;
                    var currentAutomationEvent = this._automationEvents[indexOfCurrentEvent];
                    if (currentAutomationEvent !== undefined && isSetTargetAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || nextAutomationEvent.insertTime > time)) return getTargetValueAtTime(time, getValueOfAutomationEventAtIndexAtTime(this._automationEvents, indexOfCurrentEvent - 1, currentAutomationEvent.startTime, this._defaultValue), currentAutomationEvent);
                    if (currentAutomationEvent !== undefined && isSetValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) return currentAutomationEvent.value;
                    if (currentAutomationEvent !== undefined && isSetValueCurveAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || currentAutomationEvent.startTime + currentAutomationEvent.duration > time)) {
                        if (time < currentAutomationEvent.startTime + currentAutomationEvent.duration) return getValueCurveValueAtTime(time, currentAutomationEvent);
                        return currentAutomationEvent.values[currentAutomationEvent.values.length - 1];
                    }
                    if (currentAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) return currentAutomationEvent.value;
                    if (nextAutomationEvent !== undefined && isExponentialRampToValueAutomationEvent(nextAutomationEvent)) {
                        var _getEndTimeAndValueOf = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue), _getEndTimeAndValueOf2 = _slicedToArray(_getEndTimeAndValueOf, 2), startTime = _getEndTimeAndValueOf2[0], value = _getEndTimeAndValueOf2[1];
                        return getExponentialRampValueAtTime(time, startTime, value, nextAutomationEvent);
                    }
                    if (nextAutomationEvent !== undefined && isLinearRampToValueAutomationEvent(nextAutomationEvent)) {
                        var _getEndTimeAndValueOf3 = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue), _getEndTimeAndValueOf4 = _slicedToArray(_getEndTimeAndValueOf3, 2), _startTime = _getEndTimeAndValueOf4[0], _value = _getEndTimeAndValueOf4[1];
                        return getLinearRampValueAtTime(time, _startTime, _value, nextAutomationEvent);
                    }
                    return this._defaultValue;
                }
            }
        ]);
        return AutomationEventList;
    }(Symbol.iterator);
    var createCancelAndHoldAutomationEvent = function createCancelAndHoldAutomationEvent(cancelTime) {
        return {
            cancelTime: cancelTime,
            type: "cancelAndHold"
        };
    };
    var createCancelScheduledValuesAutomationEvent = function createCancelScheduledValuesAutomationEvent(cancelTime) {
        return {
            cancelTime: cancelTime,
            type: "cancelScheduledValues"
        };
    };
    var createExponentialRampToValueAutomationEvent = function createExponentialRampToValueAutomationEvent(value, endTime) {
        return {
            endTime: endTime,
            type: "exponentialRampToValue",
            value: value
        };
    };
    var createLinearRampToValueAutomationEvent = function createLinearRampToValueAutomationEvent(value, endTime) {
        return {
            endTime: endTime,
            type: "linearRampToValue",
            value: value
        };
    };
    var createSetTargetAutomationEvent = function createSetTargetAutomationEvent(target, startTime, timeConstant) {
        return {
            startTime: startTime,
            target: target,
            timeConstant: timeConstant,
            type: "setTarget"
        };
    };
    exports1.AutomationEventList = AutomationEventList;
    exports1.createCancelAndHoldAutomationEvent = createCancelAndHoldAutomationEvent;
    exports1.createCancelScheduledValuesAutomationEvent = createCancelScheduledValuesAutomationEvent;
    exports1.createExponentialRampToValueAutomationEvent = createExponentialRampToValueAutomationEvent;
    exports1.createLinearRampToValueAutomationEvent = createLinearRampToValueAutomationEvent;
    exports1.createSetTargetAutomationEvent = createSetTargetAutomationEvent;
    exports1.createSetValueAutomationEvent = createSetValueAutomationEvent;
    exports1.createSetValueCurveAutomationEvent = createSetValueCurveAutomationEvent;
});


const $a18cf10db56d480b$export$aff31bd5258e9fd4 = ()=>new DOMException("", "AbortError");


const $7f23be3a1785a3a3$export$43d20cccdc976834 = (insertElementInSet)=>{
    return (activeInputs, source, [output, input, eventListener], ignoreDuplicates)=>{
        insertElementInSet(activeInputs[input], [
            source,
            output,
            eventListener
        ], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
    };
};


const $38a67e4228ec27a5$export$7ff07578cebde522 = (audioNodeConnectionsStore)=>{
    return (audioNode, audioNodeRenderer, nativeAudioNode)=>{
        const activeInputs = [];
        for(let i = 0; i < nativeAudioNode.numberOfInputs; i += 1)activeInputs.push(new Set());
        audioNodeConnectionsStore.set(audioNode, {
            activeInputs: activeInputs,
            outputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioNodeRenderer
        });
    };
};


const $75c70a9d5b9cda8b$export$25226f7a087f88c3 = (audioParamConnectionsStore)=>{
    return (audioParam, audioParamRenderer)=>{
        audioParamConnectionsStore.set(audioParam, {
            activeInputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioParamRenderer
        });
    };
};


const $7718e734b2fef711$export$2b500979aea0913f = new WeakSet();
const $7718e734b2fef711$export$61ca80a8c8c6d728 = new WeakMap();
const $7718e734b2fef711$export$864a3cfb55580d0c = new WeakMap();
const $7718e734b2fef711$export$c5d3ff1f46a0185a = new WeakMap();
const $7718e734b2fef711$export$55484e3055c7a9e2 = new WeakMap();
const $7718e734b2fef711$export$7d17302229276f06 = new WeakMap();
const $7718e734b2fef711$export$c998cfefa4fd5136 = new WeakMap();
const $7718e734b2fef711$export$cf686a6a3e402092 = new WeakMap();
const $7718e734b2fef711$export$b9bea39f06f96914 = new WeakMap();
const $7718e734b2fef711$export$16d7878f7e059d67 = new WeakMap();


const $8b99c46ccea74444$var$handler = {
    construct () {
        return $8b99c46ccea74444$var$handler;
    }
};
const $8b99c46ccea74444$export$df064419399503e9 = (constructible)=>{
    try {
        const proxy = new Proxy(constructible, $8b99c46ccea74444$var$handler);
        new proxy(); // tslint:disable-line:no-unused-expression
    } catch  {
        return false;
    }
    return true;
};


/*
 * This massive regex tries to cover all the following cases.
 *
 * import './path';
 * import defaultImport from './path';
 * import { namedImport } from './path';
 * import { namedImport as renamendImport } from './path';
 * import * as namespaceImport from './path';
 * import defaultImport, { namedImport } from './path';
 * import defaultImport, { namedImport as renamendImport } from './path';
 * import defaultImport, * as namespaceImport from './path';
 */ const $666948ccc53d62d5$var$IMPORT_STATEMENT_REGEX = /^import(?:(?:[\s]+[\w]+|(?:[\s]+[\w]+[\s]*,)?[\s]*\{[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?(?:[\s]*,[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?)*[\s]*}|(?:[\s]+[\w]+[\s]*,)?[\s]*\*[\s]+as[\s]+[\w]+)[\s]+from)?(?:[\s]*)("([^"\\]|\\.)+"|'([^'\\]|\\.)+')(?:[\s]*);?/; // tslint:disable-line:max-line-length
const $666948ccc53d62d5$export$949058cf055dbb57 = (source, url)=>{
    const importStatements = [];
    let sourceWithoutImportStatements = source.replace(/^[\s]+/, "");
    let result = sourceWithoutImportStatements.match($666948ccc53d62d5$var$IMPORT_STATEMENT_REGEX);
    while(result !== null){
        const unresolvedUrl = result[1].slice(1, -1);
        const importStatementWithResolvedUrl = result[0].replace(/([\s]+)?;?$/, "").replace(unresolvedUrl, new URL(unresolvedUrl, url).toString());
        importStatements.push(importStatementWithResolvedUrl);
        sourceWithoutImportStatements = sourceWithoutImportStatements.slice(result[0].length).replace(/^[\s]+/, "");
        result = sourceWithoutImportStatements.match($666948ccc53d62d5$var$IMPORT_STATEMENT_REGEX);
    }
    return [
        importStatements.join(";"),
        sourceWithoutImportStatements
    ];
};


const $a5628482838dda15$var$verifyParameterDescriptors = (parameterDescriptors)=>{
    if (parameterDescriptors !== undefined && !Array.isArray(parameterDescriptors)) throw new TypeError("The parameterDescriptors property of given value for processorCtor is not an array.");
};
const $a5628482838dda15$var$verifyProcessorCtor = (processorCtor)=>{
    if (!(0, $8b99c46ccea74444$export$df064419399503e9)(processorCtor)) throw new TypeError("The given value for processorCtor should be a constructor.");
    if (processorCtor.prototype === null || typeof processorCtor.prototype !== "object") throw new TypeError("The given value for processorCtor should have a prototype.");
};
const $a5628482838dda15$export$16c6049a33c70efa = (cacheTestResult, createNotSupportedError, evaluateSource, exposeCurrentFrameAndCurrentTime, fetchSource, getNativeContext, getOrCreateBackupOfflineAudioContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, ongoingRequests, resolvedRequests, testAudioWorkletProcessorPostMessageSupport, window)=>{
    let index = 0;
    return (context, moduleURL, options = {
        credentials: "omit"
    })=>{
        const resolvedRequestsOfContext = resolvedRequests.get(context);
        if (resolvedRequestsOfContext !== undefined && resolvedRequestsOfContext.has(moduleURL)) return Promise.resolve();
        const ongoingRequestsOfContext = ongoingRequests.get(context);
        if (ongoingRequestsOfContext !== undefined) {
            const promiseOfOngoingRequest = ongoingRequestsOfContext.get(moduleURL);
            if (promiseOfOngoingRequest !== undefined) return promiseOfOngoingRequest;
        }
        const nativeContext = getNativeContext(context);
        // Bug #59: Safari does not implement the audioWorklet property.
        const promise = nativeContext.audioWorklet === undefined ? fetchSource(moduleURL).then(([source, absoluteUrl])=>{
            const [importStatements, sourceWithoutImportStatements] = (0, $666948ccc53d62d5$export$949058cf055dbb57)(source, absoluteUrl);
            /*
                 * This is the unminified version of the code used below:
                 *
                 * ```js
                 * ${ importStatements };
                 * ((a, b) => {
                 *     (a[b] = a[b] || [ ]).push(
                 *         (AudioWorkletProcessor, global, registerProcessor, sampleRate, self, window) => {
                 *             ${ sourceWithoutImportStatements }
                 *         }
                 *     );
                 * })(window, '_AWGS');
                 * ```
                 */ // tslint:disable-next-line:max-line-length
            const wrappedSource = `${importStatements};((a,b)=>{(a[b]=a[b]||[]).push((AudioWorkletProcessor,global,registerProcessor,sampleRate,self,window)=>{${sourceWithoutImportStatements}
})})(window,'_AWGS')`;
            // @todo Evaluating the given source code is a possible security problem.
            return evaluateSource(wrappedSource);
        }).then(()=>{
            const evaluateAudioWorkletGlobalScope = window._AWGS.pop();
            if (evaluateAudioWorkletGlobalScope === undefined) // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
            throw new SyntaxError();
            exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, ()=>evaluateAudioWorkletGlobalScope(class AudioWorkletProcessor {
                }, undefined, (name, processorCtor)=>{
                    if (name.trim() === "") throw createNotSupportedError();
                    const nodeNameToProcessorConstructorMap = (0, $7718e734b2fef711$export$b9bea39f06f96914).get(nativeContext);
                    if (nodeNameToProcessorConstructorMap !== undefined) {
                        if (nodeNameToProcessorConstructorMap.has(name)) throw createNotSupportedError();
                        $a5628482838dda15$var$verifyProcessorCtor(processorCtor);
                        $a5628482838dda15$var$verifyParameterDescriptors(processorCtor.parameterDescriptors);
                        nodeNameToProcessorConstructorMap.set(name, processorCtor);
                    } else {
                        $a5628482838dda15$var$verifyProcessorCtor(processorCtor);
                        $a5628482838dda15$var$verifyParameterDescriptors(processorCtor.parameterDescriptors);
                        (0, $7718e734b2fef711$export$b9bea39f06f96914).set(nativeContext, new Map([
                            [
                                name,
                                processorCtor
                            ]
                        ]));
                    }
                }, nativeContext.sampleRate, undefined, undefined));
        }) : Promise.all([
            fetchSource(moduleURL),
            Promise.resolve(cacheTestResult(testAudioWorkletProcessorPostMessageSupport, testAudioWorkletProcessorPostMessageSupport))
        ]).then(([[source, absoluteUrl], isSupportingPostMessage])=>{
            const currentIndex = index + 1;
            index = currentIndex;
            const [importStatements, sourceWithoutImportStatements] = (0, $666948ccc53d62d5$export$949058cf055dbb57)(source, absoluteUrl);
            /*
                 * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
                 *
                 * This is the unminified version of the code used below.
                 *
                 * ```js
                 * class extends AudioWorkletProcessor {
                 *
                 *     __buffers = new WeakSet();
                 *
                 *     constructor () {
                 *         super();
                 *
                 *         this.port.postMessage = ((postMessage) => {
                 *             return (message, transferables) => {
                 *                 const filteredTransferables = (transferables)
                 *                     ? transferables.filter((transferable) => !this.__buffers.has(transferable))
                 *                     : transferables;
                 *
                 *                 return postMessage.call(this.port, message, filteredTransferables);
                 *              };
                 *         })(this.port.postMessage);
                 *     }
                 * }
                 * ```
                 */ const patchedAudioWorkletProcessor = isSupportingPostMessage ? "AudioWorkletProcessor" : "class extends AudioWorkletProcessor {__b=new WeakSet();constructor(){super();(p=>p.postMessage=(q=>(m,t)=>q.call(p,m,t?t.filter(u=>!this.__b.has(u)):t))(p.postMessage))(this.port)}}";
            /*
                 * Bug #170: Chrome and Edge do call process() with an array with empty channelData for each input if no input is connected.
                 *
                 * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
                 *
                 * Bug #190: Safari doesn't throw an error when loading an unparsable module.
                 *
                 * This is the unminified version of the code used below:
                 *
                 * ```js
                 * `${ importStatements };
                 * ((AudioWorkletProcessor, registerProcessor) => {${ sourceWithoutImportStatements }
                 * })(
                 *     ${ patchedAudioWorkletProcessor },
                 *     (name, processorCtor) => registerProcessor(name, class extends processorCtor {
                 *
                 *         __collectBuffers = (array) => {
                 *             array.forEach((element) => this.__buffers.add(element.buffer));
                 *         };
                 *
                 *         process (inputs, outputs, parameters) {
                 *             inputs.forEach(this.__collectBuffers);
                 *             outputs.forEach(this.__collectBuffers);
                 *             this.__collectBuffers(Object.values(parameters));
                 *
                 *             return super.process(
                 *                 (inputs.map((input) => input.some((channelData) => channelData.length === 0)) ? [ ] : input),
                 *                 outputs,
                 *                 parameters
                 *             );
                 *         }
                 *
                 *     })
                 * );
                 *
                 * registerProcessor(`__sac${currentIndex}`, class extends AudioWorkletProcessor{
                 *
                 *     process () {
                 *         return false;
                 *     }
                 *
                 * })`
                 * ```
                 */ const memberDefinition = isSupportingPostMessage ? "" : "__c = (a) => a.forEach(e=>this.__b.add(e.buffer));";
            const bufferRegistration = isSupportingPostMessage ? "" : "i.forEach(this.__c);o.forEach(this.__c);this.__c(Object.values(p));";
            const wrappedSource = `${importStatements};((AudioWorkletProcessor,registerProcessor)=>{${sourceWithoutImportStatements}
})(${patchedAudioWorkletProcessor},(n,p)=>registerProcessor(n,class extends p{${memberDefinition}process(i,o,p){${bufferRegistration}return super.process(i.map(j=>j.some(k=>k.length===0)?[]:j),o,p)}}));registerProcessor('__sac${currentIndex}',class extends AudioWorkletProcessor{process(){return !1}})`;
            const blob = new Blob([
                wrappedSource
            ], {
                type: "application/javascript; charset=utf-8"
            });
            const url = URL.createObjectURL(blob);
            return nativeContext.audioWorklet.addModule(url, options).then(()=>{
                if (isNativeOfflineAudioContext(nativeContext)) return nativeContext;
                // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.
                const backupOfflineAudioContext = getOrCreateBackupOfflineAudioContext(nativeContext);
                return backupOfflineAudioContext.audioWorklet.addModule(url, options).then(()=>backupOfflineAudioContext);
            }).then((nativeContextOrBackupOfflineAudioContext)=>{
                if (nativeAudioWorkletNodeConstructor === null) throw new SyntaxError();
                try {
                    // Bug #190: Safari doesn't throw an error when loading an unparsable module.
                    new nativeAudioWorkletNodeConstructor(nativeContextOrBackupOfflineAudioContext, `__sac${currentIndex}`); // tslint:disable-line:no-unused-expression
                } catch  {
                    throw new SyntaxError();
                }
            }).finally(()=>URL.revokeObjectURL(url));
        });
        if (ongoingRequestsOfContext === undefined) ongoingRequests.set(context, new Map([
            [
                moduleURL,
                promise
            ]
        ]));
        else ongoingRequestsOfContext.set(moduleURL, promise);
        promise.then(()=>{
            const updatedResolvedRequestsOfContext = resolvedRequests.get(context);
            if (updatedResolvedRequestsOfContext === undefined) resolvedRequests.set(context, new Set([
                moduleURL
            ]));
            else updatedResolvedRequestsOfContext.add(moduleURL);
        }).finally(()=>{
            const updatedOngoingRequestsOfContext = ongoingRequests.get(context);
            if (updatedOngoingRequestsOfContext !== undefined) updatedOngoingRequestsOfContext.delete(moduleURL);
        });
        return promise;
    };
};


const $88ab0c374f97b769$export$520987e3ff3ffad3 = (map, key)=>{
    const value = map.get(key);
    if (value === undefined) throw new Error("A value with the given key could not be found.");
    return value;
};


const $b4907d346209c4aa$export$3f1b331b43a0e659 = (set, predicate)=>{
    const matchingElements = Array.from(set).filter(predicate);
    if (matchingElements.length > 1) throw Error("More than one element was found.");
    if (matchingElements.length === 0) throw Error("No element was found.");
    const [matchingElement] = matchingElements;
    set.delete(matchingElement);
    return matchingElement;
};


const $1347121a05cab167$export$26ec3ebc965d6cfd = (passiveInputs, source, output, input)=>{
    const passiveInputConnections = (0, $88ab0c374f97b769$export$520987e3ff3ffad3)(passiveInputs, source);
    const matchingConnection = (0, $b4907d346209c4aa$export$3f1b331b43a0e659)(passiveInputConnections, (passiveInputConnection)=>passiveInputConnection[0] === output && passiveInputConnection[1] === input);
    if (passiveInputConnections.size === 0) passiveInputs.delete(source);
    return matchingConnection;
};





const $4c5028d8fa80b78b$export$caac7ea54cb93b25 = (audioNode)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$c998cfefa4fd5136), audioNode);
};


const $6f1d61f1020f6c58$export$88a47afdc0e8539c = (audioNode)=>{
    if ((0, $7718e734b2fef711$export$2b500979aea0913f).has(audioNode)) throw new Error("The AudioNode is already stored.");
    (0, $7718e734b2fef711$export$2b500979aea0913f).add(audioNode);
    (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25)(audioNode).forEach((eventListener)=>eventListener(true));
};


const $c6114027b7817185$export$1293b9fc79a24682 = (audioNode)=>{
    return "port" in audioNode;
};




const $b44e7990017a0eb4$export$7c0830f3a5100dec = (audioNode)=>{
    if (!(0, $7718e734b2fef711$export$2b500979aea0913f).has(audioNode)) throw new Error("The AudioNode is not stored.");
    (0, $7718e734b2fef711$export$2b500979aea0913f).delete(audioNode);
    (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25)(audioNode).forEach((eventListener)=>eventListener(false));
};


const $d86f58cf827039bb$export$c74023ca160dc207 = (audioNode, activeInputs)=>{
    if (!(0, $c6114027b7817185$export$1293b9fc79a24682)(audioNode) && activeInputs.every((connections)=>connections.size === 0)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(audioNode);
};


const $dc45a634363b6091$export$1776cf0d295db1d7 = (addActiveInputConnectionToAudioNode, addPassiveInputConnectionToAudioNode, connectNativeAudioNodeToNativeAudioNode, deleteActiveInputConnectionToAudioNode, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getAudioNodeTailTime, getEventListenersOfAudioNode, getNativeAudioNode, insertElementInSet, isActiveAudioNode, isPartOfACycle, isPassiveAudioNode)=>{
    const tailTimeTimeoutIds = new WeakMap();
    return (source, destination, output, input, isOffline)=>{
        const { activeInputs: activeInputs, passiveInputs: passiveInputs } = getAudioNodeConnections(destination);
        const { outputs: outputs } = getAudioNodeConnections(source);
        const eventListeners = getEventListenersOfAudioNode(source);
        const eventListener = (isActive)=>{
            const nativeDestinationAudioNode = getNativeAudioNode(destination);
            const nativeSourceAudioNode = getNativeAudioNode(source);
            if (isActive) {
                const partialConnection = (0, $1347121a05cab167$export$26ec3ebc965d6cfd)(passiveInputs, source, output, input);
                addActiveInputConnectionToAudioNode(activeInputs, source, partialConnection, false);
                if (!isOffline && !isPartOfACycle(source)) connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
                if (isPassiveAudioNode(destination)) (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(destination);
            } else {
                const partialConnection = deleteActiveInputConnectionToAudioNode(activeInputs, source, output, input);
                addPassiveInputConnectionToAudioNode(passiveInputs, input, partialConnection, false);
                if (!isOffline && !isPartOfACycle(source)) disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
                const tailTime = getAudioNodeTailTime(destination);
                if (tailTime === 0) {
                    if (isActiveAudioNode(destination)) (0, $d86f58cf827039bb$export$c74023ca160dc207)(destination, activeInputs);
                } else {
                    const tailTimeTimeoutId = tailTimeTimeoutIds.get(destination);
                    if (tailTimeTimeoutId !== undefined) clearTimeout(tailTimeTimeoutId);
                    tailTimeTimeoutIds.set(destination, setTimeout(()=>{
                        if (isActiveAudioNode(destination)) (0, $d86f58cf827039bb$export$c74023ca160dc207)(destination, activeInputs);
                    }, tailTime * 1000));
                }
            }
        };
        if (insertElementInSet(outputs, [
            destination,
            output,
            input
        ], (outputConnection)=>outputConnection[0] === destination && outputConnection[1] === output && outputConnection[2] === input, true)) {
            eventListeners.add(eventListener);
            if (isActiveAudioNode(source)) addActiveInputConnectionToAudioNode(activeInputs, source, [
                output,
                input,
                eventListener
            ], true);
            else addPassiveInputConnectionToAudioNode(passiveInputs, input, [
                source,
                output,
                eventListener
            ], true);
            return true;
        }
        return false;
    };
};


const $3166079db94aa9a9$export$67aa4e90be3a506b = (insertElementInSet)=>{
    return (passiveInputs, input, [source, output, eventListener], ignoreDuplicates)=>{
        const passiveInputConnections = passiveInputs.get(source);
        if (passiveInputConnections === undefined) passiveInputs.set(source, new Set([
            [
                output,
                input,
                eventListener
            ]
        ]));
        else insertElementInSet(passiveInputConnections, [
            output,
            input,
            eventListener
        ], (passiveInputConnection)=>passiveInputConnection[0] === output && passiveInputConnection[1] === input, ignoreDuplicates);
    };
};


const $8d968cebac7e2205$export$c6991e18a29704b9 = (createNativeGainNode)=>{
    return (nativeContext, nativeAudioScheduledSourceNode)=>{
        const nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: "explicit",
            channelInterpretation: "discrete",
            gain: 0
        });
        nativeAudioScheduledSourceNode.connect(nativeGainNode).connect(nativeContext.destination);
        const disconnect = ()=>{
            nativeAudioScheduledSourceNode.removeEventListener("ended", disconnect);
            nativeAudioScheduledSourceNode.disconnect(nativeGainNode);
            nativeGainNode.disconnect();
        };
        nativeAudioScheduledSourceNode.addEventListener("ended", disconnect);
    };
};


const $c770a27b2f3749ca$export$fd0136b1517d036f = (getUnrenderedAudioWorkletNodes)=>{
    return (nativeContext, audioWorkletNode)=>{
        getUnrenderedAudioWorkletNodes(nativeContext).add(audioWorkletNode);
    };
};


const $108e1fe42ca28dbf$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers",
    fftSize: 2048,
    maxDecibels: -30,
    minDecibels: -100,
    smoothingTimeConstant: 0.8
};
const $108e1fe42ca28dbf$export$569b2da15d7fe153 = (audionNodeConstructor, createAnalyserNodeRenderer, createIndexSizeError, createNativeAnalyserNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class AnalyserNode extends audionNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$108e1fe42ca28dbf$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeAnalyserNode = createNativeAnalyserNode(nativeContext, mergedOptions);
            const analyserNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createAnalyserNodeRenderer() : null;
            super(context, false, nativeAnalyserNode, analyserNodeRenderer);
            this._nativeAnalyserNode = nativeAnalyserNode;
        }
        get fftSize() {
            return this._nativeAnalyserNode.fftSize;
        }
        set fftSize(value) {
            this._nativeAnalyserNode.fftSize = value;
        }
        get frequencyBinCount() {
            return this._nativeAnalyserNode.frequencyBinCount;
        }
        get maxDecibels() {
            return this._nativeAnalyserNode.maxDecibels;
        }
        set maxDecibels(value) {
            // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
            const maxDecibels = this._nativeAnalyserNode.maxDecibels;
            this._nativeAnalyserNode.maxDecibels = value;
            if (!(value > this._nativeAnalyserNode.minDecibels)) {
                this._nativeAnalyserNode.maxDecibels = maxDecibels;
                throw createIndexSizeError();
            }
        }
        get minDecibels() {
            return this._nativeAnalyserNode.minDecibels;
        }
        set minDecibels(value) {
            // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
            const minDecibels = this._nativeAnalyserNode.minDecibels;
            this._nativeAnalyserNode.minDecibels = value;
            if (!(this._nativeAnalyserNode.maxDecibels > value)) {
                this._nativeAnalyserNode.minDecibels = minDecibels;
                throw createIndexSizeError();
            }
        }
        get smoothingTimeConstant() {
            return this._nativeAnalyserNode.smoothingTimeConstant;
        }
        set smoothingTimeConstant(value) {
            this._nativeAnalyserNode.smoothingTimeConstant = value;
        }
        getByteFrequencyData(array) {
            this._nativeAnalyserNode.getByteFrequencyData(array);
        }
        getByteTimeDomainData(array) {
            this._nativeAnalyserNode.getByteTimeDomainData(array);
        }
        getFloatFrequencyData(array) {
            this._nativeAnalyserNode.getFloatFrequencyData(array);
        }
        getFloatTimeDomainData(array) {
            this._nativeAnalyserNode.getFloatTimeDomainData(array);
        }
    };
};


const $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc = (nativeAudioNode, nativeContext)=>{
    return nativeAudioNode.context === nativeContext;
};


const $af022ab249d12b4e$export$5fe3f5c2d995fe20 = (createNativeAnalyserNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAnalyserNodes = new WeakMap();
        const createAnalyserNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAnalyserNode = getNativeAudioNode(proxy);
            // If the initially used nativeAnalyserNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAnalyserNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAnalyserNode, nativeOfflineAudioContext);
            if (!nativeAnalyserNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAnalyserNode.channelCount,
                    channelCountMode: nativeAnalyserNode.channelCountMode,
                    channelInterpretation: nativeAnalyserNode.channelInterpretation,
                    fftSize: nativeAnalyserNode.fftSize,
                    maxDecibels: nativeAnalyserNode.maxDecibels,
                    minDecibels: nativeAnalyserNode.minDecibels,
                    smoothingTimeConstant: nativeAnalyserNode.smoothingTimeConstant
                };
                nativeAnalyserNode = createNativeAnalyserNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAnalyserNodes.set(nativeOfflineAudioContext, nativeAnalyserNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAnalyserNode);
            return nativeAnalyserNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAnalyserNode = renderedNativeAnalyserNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAnalyserNode !== undefined) return Promise.resolve(renderedNativeAnalyserNode);
                return createAnalyserNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $00de7ef4427b01cb$export$54e424f510c54ced = (nativeAudioBuffer)=>{
    try {
        nativeAudioBuffer.copyToChannel(new Float32Array(1), 0, -1);
    } catch  {
        return false;
    }
    return true;
};


const $e1139ef113001733$export$926e4aa3eed6ec13 = ()=>new DOMException("", "IndexSizeError");


const $e0def92b41d2ffa5$export$df65309cf6249598 = (audioBuffer)=>{
    audioBuffer.getChannelData = ((getChannelData)=>{
        return (channel)=>{
            try {
                return getChannelData.call(audioBuffer, channel);
            } catch (err) {
                if (err.code === 12) throw (0, $e1139ef113001733$export$926e4aa3eed6ec13)();
                throw err;
            }
        };
    })(audioBuffer.getChannelData);
};


const $05b6b25752b14d73$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $05b6b25752b14d73$export$c8b88126795b7df2 = (audioBufferStore, cacheTestResult, createNotSupportedError, nativeAudioBufferConstructor, nativeOfflineAudioContextConstructor, testNativeAudioBufferConstructorSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    let nativeOfflineAudioContext = null;
    return class AudioBuffer {
        constructor(options){
            if (nativeOfflineAudioContextConstructor === null) throw new Error("Missing the native OfflineAudioContext constructor.");
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$05b6b25752b14d73$var$DEFAULT_OPTIONS,
                ...options
            };
            if (nativeOfflineAudioContext === null) nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
            /*
             * Bug #99: Firefox does not throw a NotSupportedError when the numberOfChannels is zero. But it only does it when using the
             * factory function. But since Firefox also supports the constructor everything should be fine.
             */ const audioBuffer = nativeAudioBufferConstructor !== null && cacheTestResult(testNativeAudioBufferConstructorSupport, testNativeAudioBufferConstructorSupport) ? new nativeAudioBufferConstructor({
                length: length,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            }) : nativeOfflineAudioContext.createBuffer(numberOfChannels, length, sampleRate);
            // Bug #99: Safari does not throw an error when the numberOfChannels is zero.
            if (audioBuffer.numberOfChannels === 0) throw createNotSupportedError();
            // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
            // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
            if (typeof audioBuffer.copyFromChannel !== "function") {
                wrapAudioBufferCopyChannelMethods(audioBuffer);
                (0, $e0def92b41d2ffa5$export$df65309cf6249598)(audioBuffer);
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            } else if (!cacheTestResult((0, $00de7ef4427b01cb$export$54e424f510c54ced), ()=>(0, $00de7ef4427b01cb$export$54e424f510c54ced)(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            /*
             * This does violate all good pratices but it is necessary to allow this AudioBuffer to be used with native
             * (Offline)AudioContexts.
             */ return audioBuffer;
        }
        static [Symbol.hasInstance](instance) {
            return instance !== null && typeof instance === "object" && Object.getPrototypeOf(instance) === AudioBuffer.prototype || audioBufferStore.has(instance);
        }
    };
};


const $c205d95559d496ba$export$ced6a5c63b103b52 = -340282346638528860000000000000000000000;
const $c205d95559d496ba$export$ab43bedd17d6a167 = -$c205d95559d496ba$export$ced6a5c63b103b52;



const $74af653805090ad8$export$e44f0fc8e83fb084 = (audioNode)=>(0, $7718e734b2fef711$export$2b500979aea0913f).has(audioNode);




const $55305446a68bbcd4$var$DEFAULT_OPTIONS = {
    buffer: null,
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers",
    // Bug #149: Safari does not yet support the detune AudioParam.
    loop: false,
    loopEnd: 0,
    loopStart: 0,
    playbackRate: 1
};
const $55305446a68bbcd4$export$6857b764b4428518 = (audioNodeConstructor, createAudioBufferSourceNodeRenderer, createAudioParam, createInvalidStateError, createNativeAudioBufferSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class AudioBufferSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$55305446a68bbcd4$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const audioBufferSourceNodeRenderer = isOffline ? createAudioBufferSourceNodeRenderer() : null;
            super(context, false, nativeAudioBufferSourceNode, audioBufferSourceNodeRenderer);
            this._audioBufferSourceNodeRenderer = audioBufferSourceNodeRenderer;
            this._isBufferNullified = false;
            this._isBufferSet = mergedOptions.buffer !== null;
            this._nativeAudioBufferSourceNode = nativeAudioBufferSourceNode;
            this._onended = null;
            // Bug #73: Safari does not export the correct values for maxValue and minValue.
            this._playbackRate = createAudioParam(this, isOffline, nativeAudioBufferSourceNode.playbackRate, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
        }
        get buffer() {
            if (this._isBufferNullified) return null;
            return this._nativeAudioBufferSourceNode.buffer;
        }
        set buffer(value) {
            this._nativeAudioBufferSourceNode.buffer = value;
            // Bug #72: Only Chrome & Edge do not allow to reassign the buffer yet.
            if (value !== null) {
                if (this._isBufferSet) throw createInvalidStateError();
                this._isBufferSet = true;
            }
        }
        get loop() {
            return this._nativeAudioBufferSourceNode.loop;
        }
        set loop(value) {
            this._nativeAudioBufferSourceNode.loop = value;
        }
        get loopEnd() {
            return this._nativeAudioBufferSourceNode.loopEnd;
        }
        set loopEnd(value) {
            this._nativeAudioBufferSourceNode.loopEnd = value;
        }
        get loopStart() {
            return this._nativeAudioBufferSourceNode.loopStart;
        }
        set loopStart(value) {
            this._nativeAudioBufferSourceNode.loopStart = value;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === "function" ? wrapEventListener(this, value) : null;
            this._nativeAudioBufferSourceNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeAudioBufferSourceNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        get playbackRate() {
            return this._playbackRate;
        }
        start(when = 0, offset = 0, duration) {
            this._nativeAudioBufferSourceNode.start(when, offset, duration);
            if (this._audioBufferSourceNodeRenderer !== null) this._audioBufferSourceNodeRenderer.start = duration === undefined ? [
                when,
                offset
            ] : [
                when,
                offset,
                duration
            ];
            if (this.context.state !== "closed") {
                (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeAudioBufferSourceNode.removeEventListener("ended", resetInternalStateToPassive);
                    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(this)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(this);
                };
                this._nativeAudioBufferSourceNode.addEventListener("ended", resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeAudioBufferSourceNode.stop(when);
            if (this._audioBufferSourceNodeRenderer !== null) this._audioBufferSourceNodeRenderer.stop = when;
        }
    };
};



const $a4008e06a1e577c4$export$82721be5d1bb22c5 = (connectAudioParam, createNativeAudioBufferSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioBufferSourceNodes = new WeakMap();
        let start = null;
        let stop = null;
        const createAudioBufferSourceNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioBufferSourceNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeAudioBufferSourceNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeAudioBufferSourceNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAudioBufferSourceNode, nativeOfflineAudioContext);
            if (!nativeAudioBufferSourceNodeIsOwnedByContext) {
                const options = {
                    buffer: nativeAudioBufferSourceNode.buffer,
                    channelCount: nativeAudioBufferSourceNode.channelCount,
                    channelCountMode: nativeAudioBufferSourceNode.channelCountMode,
                    channelInterpretation: nativeAudioBufferSourceNode.channelInterpretation,
                    // Bug #149: Safari does not yet support the detune AudioParam.
                    loop: nativeAudioBufferSourceNode.loop,
                    loopEnd: nativeAudioBufferSourceNode.loopEnd,
                    loopStart: nativeAudioBufferSourceNode.loopStart,
                    playbackRate: nativeAudioBufferSourceNode.playbackRate.value
                };
                nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeAudioBufferSourceNode.start(...start);
                if (stop !== null) nativeAudioBufferSourceNode.stop(stop);
            }
            renderedNativeAudioBufferSourceNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode);
            if (!nativeAudioBufferSourceNodeIsOwnedByContext) // Bug #149: Safari does not yet support the detune AudioParam.
            await renderAutomation(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
            else // Bug #149: Safari does not yet support the detune AudioParam.
            await connectAudioParam(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioBufferSourceNode);
            return nativeAudioBufferSourceNode;
        };
        return {
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioBufferSourceNode = renderedNativeAudioBufferSourceNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioBufferSourceNode !== undefined) return Promise.resolve(renderedNativeAudioBufferSourceNode);
                return createAudioBufferSourceNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $828ce8df8991a5da$export$b030d1cb39b66ce3 = (audioNode)=>{
    return "playbackRate" in audioNode;
};



const $b1c01e8d3bb75909$export$8bbceb3e2d3b886a = (audioNode)=>{
    return "frequency" in audioNode && "gain" in audioNode;
};


const $a5e0cb451ced6be4$export$2b5f11f35c31b1bf = (audioNode)=>{
    return "offset" in audioNode;
};


const $d21f4a1b4ecd24ee$export$c124c0514d4f41ab = (audioNode)=>{
    return !("frequency" in audioNode) && "gain" in audioNode;
};


const $3f8d58a407d6c9bc$export$97bb3ed4238ea897 = (audioNode)=>{
    return "detune" in audioNode && "frequency" in audioNode;
};


const $adf78758fe2f7169$export$79ba82be14a0b006 = (audioNode)=>{
    return "pan" in audioNode;
};




const $b599ef0c4650ec6d$export$6b29eee2af836dfc = (audioNode)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$61ca80a8c8c6d728), audioNode);
};




const $ca92fb3bedacccdf$export$1b11f454bf19657 = (audioParam)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$c5d3ff1f46a0185a), audioParam);
};




const $91fa2a989bb9a820$export$e16f533d410eeca0 = (audioNode, trace)=>{
    const { activeInputs: activeInputs } = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(audioNode);
    activeInputs.forEach((connections)=>connections.forEach(([source])=>{
            if (!trace.includes(audioNode)) $91fa2a989bb9a820$export$e16f533d410eeca0(source, [
                ...trace,
                audioNode
            ]);
        }));
    const audioParams = (0, $828ce8df8991a5da$export$b030d1cb39b66ce3)(audioNode) ? [
        // Bug #149: Safari does not yet support the detune AudioParam.
        audioNode.playbackRate
    ] : (0, $c6114027b7817185$export$1293b9fc79a24682)(audioNode) ? Array.from(audioNode.parameters.values()) : (0, $b1c01e8d3bb75909$export$8bbceb3e2d3b886a)(audioNode) ? [
        audioNode.Q,
        audioNode.detune,
        audioNode.frequency,
        audioNode.gain
    ] : (0, $a5e0cb451ced6be4$export$2b5f11f35c31b1bf)(audioNode) ? [
        audioNode.offset
    ] : (0, $d21f4a1b4ecd24ee$export$c124c0514d4f41ab)(audioNode) ? [
        audioNode.gain
    ] : (0, $3f8d58a407d6c9bc$export$97bb3ed4238ea897)(audioNode) ? [
        audioNode.detune,
        audioNode.frequency
    ] : (0, $adf78758fe2f7169$export$79ba82be14a0b006)(audioNode) ? [
        audioNode.pan
    ] : [];
    for (const audioParam of audioParams){
        const audioParamConnections = (0, $ca92fb3bedacccdf$export$1b11f454bf19657)(audioParam);
        if (audioParamConnections !== undefined) audioParamConnections.activeInputs.forEach(([source])=>$91fa2a989bb9a820$export$e16f533d410eeca0(source, trace));
    }
    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(audioNode)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(audioNode);
};


const $6d385241f7fab45a$export$cbd606bc629ea938 = (context)=>{
    (0, $91fa2a989bb9a820$export$e16f533d410eeca0)(context.destination, []);
};


const $0cefff6266c0f0f4$export$82d5f0e102842fbe = (latencyHint)=>{
    return latencyHint === undefined || typeof latencyHint === "number" || typeof latencyHint === "string" && (latencyHint === "balanced" || latencyHint === "interactive" || latencyHint === "playback");
};


const $57f46748bc9ae741$export$c6fe175def53ff71 = (baseAudioContextConstructor, createInvalidStateError, createNotSupportedError, createUnknownError, mediaElementAudioSourceNodeConstructor, mediaStreamAudioDestinationNodeConstructor, mediaStreamAudioSourceNodeConstructor, mediaStreamTrackAudioSourceNodeConstructor, nativeAudioContextConstructor)=>{
    return class AudioContext extends baseAudioContextConstructor {
        constructor(options = {}){
            if (nativeAudioContextConstructor === null) throw new Error("Missing the native AudioContext constructor.");
            let nativeAudioContext;
            try {
                nativeAudioContext = new nativeAudioContextConstructor(options);
            } catch (err) {
                // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
                if (err.code === 12 && err.message === "sampleRate is not in range") throw createNotSupportedError();
                throw err;
            }
            // Bug #131 Safari returns null when there are four other AudioContexts running already.
            if (nativeAudioContext === null) throw createUnknownError();
            // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.
            if (!(0, $0cefff6266c0f0f4$export$82d5f0e102842fbe)(options.latencyHint)) throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
            // Bug #150 Safari does not support setting the sampleRate.
            if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) throw createNotSupportedError();
            super(nativeAudioContext, 2);
            const { latencyHint: latencyHint } = options;
            const { sampleRate: sampleRate } = nativeAudioContext;
            // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.
            this._baseLatency = typeof nativeAudioContext.baseLatency === "number" ? nativeAudioContext.baseLatency : latencyHint === "balanced" ? 512 / sampleRate : latencyHint === "interactive" || latencyHint === undefined ? 256 / sampleRate : latencyHint === "playback" ? 1024 / sampleRate : /*
                                   * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
                                   * ScriptProcessorNode.
                                   */ Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
            this._nativeAudioContext = nativeAudioContext;
            // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.
            if (nativeAudioContextConstructor.name === "webkitAudioContext") {
                this._nativeGainNode = nativeAudioContext.createGain();
                this._nativeOscillatorNode = nativeAudioContext.createOscillator();
                this._nativeGainNode.gain.value = 1e-37;
                this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);
                this._nativeOscillatorNode.start();
            } else {
                this._nativeGainNode = null;
                this._nativeOscillatorNode = null;
            }
            this._state = null;
            /*
             * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
             * to 'running'.
             */ if (nativeAudioContext.state === "running") {
                this._state = "suspended";
                const revokeState = ()=>{
                    if (this._state === "suspended") this._state = null;
                    nativeAudioContext.removeEventListener("statechange", revokeState);
                };
                nativeAudioContext.addEventListener("statechange", revokeState);
            }
        }
        get baseLatency() {
            return this._baseLatency;
        }
        get state() {
            return this._state !== null ? this._state : this._nativeAudioContext.state;
        }
        close() {
            // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
            if (this.state === "closed") return this._nativeAudioContext.close().then(()=>{
                throw createInvalidStateError();
            });
            // Bug #34: If the state was set to suspended before it should be revoked now.
            if (this._state === "suspended") this._state = null;
            return this._nativeAudioContext.close().then(()=>{
                if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
                    this._nativeOscillatorNode.stop();
                    this._nativeGainNode.disconnect();
                    this._nativeOscillatorNode.disconnect();
                }
                (0, $6d385241f7fab45a$export$cbd606bc629ea938)(this);
            });
        }
        createMediaElementSource(mediaElement) {
            return new mediaElementAudioSourceNodeConstructor(this, {
                mediaElement: mediaElement
            });
        }
        createMediaStreamDestination() {
            return new mediaStreamAudioDestinationNodeConstructor(this);
        }
        createMediaStreamSource(mediaStream) {
            return new mediaStreamAudioSourceNodeConstructor(this, {
                mediaStream: mediaStream
            });
        }
        createMediaStreamTrackSource(mediaStreamTrack) {
            return new mediaStreamTrackAudioSourceNodeConstructor(this, {
                mediaStreamTrack: mediaStreamTrack
            });
        }
        resume() {
            if (this._state === "suspended") return new Promise((resolve, reject)=>{
                const resolvePromise = ()=>{
                    this._nativeAudioContext.removeEventListener("statechange", resolvePromise);
                    if (this._nativeAudioContext.state === "running") resolve();
                    else this.resume().then(resolve, reject);
                };
                this._nativeAudioContext.addEventListener("statechange", resolvePromise);
            });
            return this._nativeAudioContext.resume().catch((err)=>{
                // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined || err.code === 15) throw createInvalidStateError();
                throw err;
            });
        }
        suspend() {
            return this._nativeAudioContext.suspend().catch((err)=>{
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined) throw createInvalidStateError();
                throw err;
            });
        }
    };
};


const $3c5495fa70efa802$export$cbbb0c3ba3f5dd5b = (audioNodeConstructor, createAudioDestinationNodeRenderer, createIndexSizeError, createInvalidStateError, createNativeAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext, renderInputsOfAudioNode)=>{
    return class AudioDestinationNode extends audioNodeConstructor {
        constructor(context, channelCount){
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const nativeAudioDestinationNode = createNativeAudioDestinationNode(nativeContext, channelCount, isOffline);
            const audioDestinationNodeRenderer = isOffline ? createAudioDestinationNodeRenderer(renderInputsOfAudioNode) : null;
            super(context, false, nativeAudioDestinationNode, audioDestinationNodeRenderer);
            this._isNodeOfNativeOfflineAudioContext = isOffline;
            this._nativeAudioDestinationNode = nativeAudioDestinationNode;
        }
        get channelCount() {
            return this._nativeAudioDestinationNode.channelCount;
        }
        set channelCount(value) {
            // Bug #52: Chrome, Edge & Safari do not throw an exception at all.
            // Bug #54: Firefox does throw an IndexSizeError.
            if (this._isNodeOfNativeOfflineAudioContext) throw createInvalidStateError();
            // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
            if (value > this._nativeAudioDestinationNode.maxChannelCount) throw createIndexSizeError();
            this._nativeAudioDestinationNode.channelCount = value;
        }
        get channelCountMode() {
            return this._nativeAudioDestinationNode.channelCountMode;
        }
        set channelCountMode(value) {
            // Bug #53: No browser does throw an exception yet.
            if (this._isNodeOfNativeOfflineAudioContext) throw createInvalidStateError();
            this._nativeAudioDestinationNode.channelCountMode = value;
        }
        get maxChannelCount() {
            return this._nativeAudioDestinationNode.maxChannelCount;
        }
    };
};


const $722e3b4b287a6f68$export$d44f3f5d4e42ced2 = (renderInputsOfAudioNode)=>{
    const renderedNativeAudioDestinationNodes = new WeakMap();
    const createAudioDestinationNode = async (proxy, nativeOfflineAudioContext)=>{
        const nativeAudioDestinationNode = nativeOfflineAudioContext.destination;
        renderedNativeAudioDestinationNodes.set(nativeOfflineAudioContext, nativeAudioDestinationNode);
        await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioDestinationNode);
        return nativeAudioDestinationNode;
    };
    return {
        render (proxy, nativeOfflineAudioContext) {
            const renderedNativeAudioDestinationNode = renderedNativeAudioDestinationNodes.get(nativeOfflineAudioContext);
            if (renderedNativeAudioDestinationNode !== undefined) return Promise.resolve(renderedNativeAudioDestinationNode);
            return createAudioDestinationNode(proxy, nativeOfflineAudioContext);
        }
    };
};



const $76e2077b6d4a003e$export$3e70692c55bd5b52 = (createAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeScriptProcessorNode, createNotSupportedError, getFirstSample, isNativeOfflineAudioContext, overwriteAccessors)=>{
    return (context, nativeContext)=>{
        const nativeListener = nativeContext.listener;
        // Bug #117: Only Chrome & Edge support the new interface already.
        const createFakeAudioParams = ()=>{
            const buffer = new Float32Array(1);
            const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
                channelCount: 1,
                channelCountMode: "explicit",
                channelInterpretation: "speakers",
                numberOfInputs: 9
            });
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            let isScriptProcessorNodeCreated = false;
            let lastOrientation = [
                0,
                0,
                -1,
                0,
                1,
                0
            ];
            let lastPosition = [
                0,
                0,
                0
            ];
            const createScriptProcessorNode = ()=>{
                if (isScriptProcessorNodeCreated) return;
                isScriptProcessorNodeCreated = true;
                const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 9, 0);
                // tslint:disable-next-line:deprecation
                scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer })=>{
                    const orientation = [
                        getFirstSample(inputBuffer, buffer, 0),
                        getFirstSample(inputBuffer, buffer, 1),
                        getFirstSample(inputBuffer, buffer, 2),
                        getFirstSample(inputBuffer, buffer, 3),
                        getFirstSample(inputBuffer, buffer, 4),
                        getFirstSample(inputBuffer, buffer, 5)
                    ];
                    if (orientation.some((value, index)=>value !== lastOrientation[index])) {
                        nativeListener.setOrientation(...orientation); // tslint:disable-line:deprecation
                        lastOrientation = orientation;
                    }
                    const positon = [
                        getFirstSample(inputBuffer, buffer, 6),
                        getFirstSample(inputBuffer, buffer, 7),
                        getFirstSample(inputBuffer, buffer, 8)
                    ];
                    if (positon.some((value, index)=>value !== lastPosition[index])) {
                        nativeListener.setPosition(...positon); // tslint:disable-line:deprecation
                        lastPosition = positon;
                    }
                };
                channelMergerNode.connect(scriptProcessorNode);
            };
            const createSetOrientation = (index)=>(value)=>{
                    if (value !== lastOrientation[index]) {
                        lastOrientation[index] = value;
                        nativeListener.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
                    }
                };
            const createSetPosition = (index)=>(value)=>{
                    if (value !== lastPosition[index]) {
                        lastPosition[index] = value;
                        nativeListener.setPosition(...lastPosition); // tslint:disable-line:deprecation
                    }
                };
            const createFakeAudioParam = (input, initialValue, setValue)=>{
                const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
                    channelCount: 1,
                    channelCountMode: "explicit",
                    channelInterpretation: "discrete",
                    offset: initialValue
                });
                constantSourceNode.connect(channelMergerNode, 0, input);
                // @todo This should be stopped when the context is closed.
                constantSourceNode.start();
                Object.defineProperty(constantSourceNode.offset, "defaultValue", {
                    get () {
                        return initialValue;
                    }
                });
                /*
                 * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and
                 * minValue for GainNodes.
                 */ const audioParam = createAudioParam({
                    context: context
                }, isOffline, constantSourceNode.offset, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
                overwriteAccessors(audioParam, "value", (get)=>()=>get.call(audioParam), (set)=>(value)=>{
                        try {
                            set.call(audioParam, value);
                        } catch (err) {
                            if (err.code !== 9) throw err;
                        }
                        createScriptProcessorNode();
                        if (isOffline) // Bug #117: Using setOrientation() and setPosition() doesn't work with an OfflineAudioContext.
                        setValue(value);
                    });
                audioParam.cancelAndHoldAtTime = ((cancelAndHoldAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = cancelAndHoldAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.cancelAndHoldAtTime);
                audioParam.cancelScheduledValues = ((cancelScheduledValues)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = cancelScheduledValues.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.cancelScheduledValues);
                audioParam.exponentialRampToValueAtTime = ((exponentialRampToValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = exponentialRampToValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.exponentialRampToValueAtTime);
                audioParam.linearRampToValueAtTime = ((linearRampToValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = linearRampToValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.linearRampToValueAtTime);
                audioParam.setTargetAtTime = ((setTargetAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setTargetAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setTargetAtTime);
                audioParam.setValueAtTime = ((setValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setValueAtTime);
                audioParam.setValueCurveAtTime = ((setValueCurveAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setValueCurveAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setValueCurveAtTime);
                return audioParam;
            };
            return {
                forwardX: createFakeAudioParam(0, 0, createSetOrientation(0)),
                forwardY: createFakeAudioParam(1, 0, createSetOrientation(1)),
                forwardZ: createFakeAudioParam(2, -1, createSetOrientation(2)),
                positionX: createFakeAudioParam(6, 0, createSetPosition(0)),
                positionY: createFakeAudioParam(7, 0, createSetPosition(1)),
                positionZ: createFakeAudioParam(8, 0, createSetPosition(2)),
                upX: createFakeAudioParam(3, 0, createSetOrientation(3)),
                upY: createFakeAudioParam(4, 1, createSetOrientation(4)),
                upZ: createFakeAudioParam(5, 0, createSetOrientation(5))
            };
        };
        const { forwardX: forwardX, forwardY: forwardY, forwardZ: forwardZ, positionX: positionX, positionY: positionY, positionZ: positionZ, upX: upX, upY: upY, upZ: upZ } = nativeListener.forwardX === undefined ? createFakeAudioParams() : nativeListener;
        return {
            get forwardX () {
                return forwardX;
            },
            get forwardY () {
                return forwardY;
            },
            get forwardZ () {
                return forwardZ;
            },
            get positionX () {
                return positionX;
            },
            get positionY () {
                return positionY;
            },
            get positionZ () {
                return positionZ;
            },
            get upX () {
                return upX;
            },
            get upY () {
                return upY;
            },
            get upZ () {
                return upZ;
            }
        };
    };
};



const $c23aedeecc2b6162$export$85cd8e93eb858e81 = (audioNodeOrAudioParam)=>{
    return "context" in audioNodeOrAudioParam;
};



const $ea4b38b6f3ac443b$export$419d66ef3a96a878 = (outputConnection)=>{
    return (0, $c23aedeecc2b6162$export$85cd8e93eb858e81)(outputConnection[0]);
};


const $b5b160ddb9cb72cc$export$64505511c8abc942 = (set, element, predicate, ignoreDuplicates)=>{
    for (const lmnt of set)if (predicate(lmnt)) {
        if (ignoreDuplicates) return false;
        throw Error("The set contains at least one similar element.");
    }
    set.add(element);
    return true;
};


const $21a3952b118bdc5d$export$3dfe9f7f712d42df = (activeInputs, source, [output, eventListener], ignoreDuplicates)=>{
    (0, $b5b160ddb9cb72cc$export$64505511c8abc942)(activeInputs, [
        source,
        output,
        eventListener
    ], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
};



const $3bcad23e25c57ecf$export$2a7c0e6916aa50e4 = (passiveInputs, [source, output, eventListener], ignoreDuplicates)=>{
    const passiveInputConnections = passiveInputs.get(source);
    if (passiveInputConnections === undefined) passiveInputs.set(source, new Set([
        [
            output,
            eventListener
        ]
    ]));
    else (0, $b5b160ddb9cb72cc$export$64505511c8abc942)(passiveInputConnections, [
        output,
        eventListener
    ], (passiveInputConnection)=>passiveInputConnection[0] === output, ignoreDuplicates);
};


const $0b958e40cf81116d$export$ac2aef07f705aa48 = (nativeAudioNodeOrNativeAudioNodeFaker)=>{
    return "inputs" in nativeAudioNodeOrNativeAudioNodeFaker;
};


const $19c742083556a242$export$b92162b3199b4461 = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input)=>{
    if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeDestinationAudioNode)) {
        const fakeNativeDestinationAudioNode = nativeDestinationAudioNode.inputs[input];
        nativeSourceAudioNode.connect(fakeNativeDestinationAudioNode, output, 0);
        return [
            fakeNativeDestinationAudioNode,
            output,
            0
        ];
    }
    nativeSourceAudioNode.connect(nativeDestinationAudioNode, output, input);
    return [
        nativeDestinationAudioNode,
        output,
        input
    ];
};


const $9d73a6929aae649e$export$6cc4c86d6b87a4b8 = (activeInputConnections, source, output)=>{
    for (const activeInputConnection of activeInputConnections)if (activeInputConnection[0] === source && activeInputConnection[1] === output) {
        activeInputConnections.delete(activeInputConnection);
        return activeInputConnection;
    }
    return null;
};



const $0af44684bfcfdb82$export$dc5a8616367736a9 = (activeInputs, source, output)=>{
    return (0, $b4907d346209c4aa$export$3f1b331b43a0e659)(activeInputs, (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output);
};



const $d8593c04fb61e4ca$export$b5a32c2e2eac4137 = (audioNode, eventListener)=>{
    const eventListeners = (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25)(audioNode);
    if (!eventListeners.delete(eventListener)) throw new Error("Missing the expected event listener.");
};





const $7e7e2ad0b0763524$export$368aa16ce008e2f4 = (passiveInputs, source, output)=>{
    const passiveInputConnections = (0, $88ab0c374f97b769$export$520987e3ff3ffad3)(passiveInputs, source);
    const matchingConnection = (0, $b4907d346209c4aa$export$3f1b331b43a0e659)(passiveInputConnections, (passiveInputConnection)=>passiveInputConnection[0] === output);
    if (passiveInputConnections.size === 0) passiveInputs.delete(source);
    return matchingConnection;
};



const $c5150425da7035f6$export$a19b495df4b88921 = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input)=>{
    if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeDestinationAudioNode)) nativeSourceAudioNode.disconnect(nativeDestinationAudioNode.inputs[input], output, 0);
    else nativeSourceAudioNode.disconnect(nativeDestinationAudioNode, output, input);
};







const $f19824d1c532946e$export$e719c0d45ea16d08 = (audioNode)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$864a3cfb55580d0c), audioNode);
};




const $6cb22515327e5f96$export$fad3d843b2a56ffb = (audioParam)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$55484e3055c7a9e2), audioParam);
};





const $5ab4cc8140911ed0$export$8658a39a04a404d5 = (audioNode)=>{
    return (0, $7718e734b2fef711$export$cf686a6a3e402092).has(audioNode);
};



const $a8abf1563cb0cb90$export$79a7cb9fa56970e = (audioNode)=>{
    return !(0, $7718e734b2fef711$export$2b500979aea0913f).has(audioNode);
};




const $8fbdf1ba7335a1ec$export$f938a299860627 = (nativeAudioContext, nativeAudioWorkletNodeConstructor)=>{
    return new Promise((resolve)=>{
        /*
         * This bug existed in Safari up until v14.0.2. Since AudioWorklets were not supported in Safari until v14.1 the presence of the
         * constructor for an AudioWorkletNode can be used here to skip the test.
         */ if (nativeAudioWorkletNodeConstructor !== null) resolve(true);
        else {
            const analyzer = nativeAudioContext.createScriptProcessor(256, 1, 1); // tslint:disable-line deprecation
            const dummy = nativeAudioContext.createGain();
            // Bug #95: Safari does not play one sample buffers.
            const ones = nativeAudioContext.createBuffer(1, 2, 44100);
            const channelData = ones.getChannelData(0);
            channelData[0] = 1;
            channelData[1] = 1;
            const source = nativeAudioContext.createBufferSource();
            source.buffer = ones;
            source.loop = true;
            source.connect(analyzer).connect(nativeAudioContext.destination);
            source.connect(dummy);
            source.disconnect(dummy);
            // tslint:disable-next-line:deprecation
            analyzer.onaudioprocess = (event)=>{
                const chnnlDt = event.inputBuffer.getChannelData(0); // tslint:disable-line deprecation
                if (Array.prototype.some.call(chnnlDt, (sample)=>sample === 1)) resolve(true);
                else resolve(false);
                source.stop();
                analyzer.onaudioprocess = null; // tslint:disable-line:deprecation
                source.disconnect(analyzer);
                analyzer.disconnect(nativeAudioContext.destination);
            };
            source.start();
        }
    });
};


const $c63caa1a29cc4f1a$export$f8092aa3a6fcf50f = (cycles, visitor)=>{
    const counts = new Map();
    for (const cycle of cycles)for (const audioNode of cycle){
        const count = counts.get(audioNode);
        counts.set(audioNode, count === undefined ? 1 : count + 1);
    }
    counts.forEach((count, audioNode)=>visitor(audioNode, count));
};


const $02572834e9cacc18$export$d647358384f164e0 = (nativeAudioNodeOrAudioParam)=>{
    return "context" in nativeAudioNodeOrAudioParam;
};


const $5cd1779abf94fd6d$export$d4ca24d0078a887f = (nativeAudioNode)=>{
    const connections = new Map();
    nativeAudioNode.connect = ((connect)=>{
        // tslint:disable-next-line:invalid-void no-inferrable-types
        return (destination, output = 0, input = 0)=>{
            const returnValue = (0, $02572834e9cacc18$export$d647358384f164e0)(destination) ? connect(destination, output, input) : connect(destination, output);
            // Save the new connection only if the calls to connect above didn't throw an error.
            const connectionsToDestination = connections.get(destination);
            if (connectionsToDestination === undefined) connections.set(destination, [
                {
                    input: input,
                    output: output
                }
            ]);
            else if (connectionsToDestination.every((connection)=>connection.input !== input || connection.output !== output)) connectionsToDestination.push({
                input: input,
                output: output
            });
            return returnValue;
        };
    })(nativeAudioNode.connect.bind(nativeAudioNode));
    nativeAudioNode.disconnect = ((disconnect)=>{
        return (destinationOrOutput, output, input)=>{
            disconnect.apply(nativeAudioNode);
            if (destinationOrOutput === undefined) connections.clear();
            else if (typeof destinationOrOutput === "number") for (const [destination, connectionsToDestination] of connections){
                const filteredConnections = connectionsToDestination.filter((connection)=>connection.output !== destinationOrOutput);
                if (filteredConnections.length === 0) connections.delete(destination);
                else connections.set(destination, filteredConnections);
            }
            else if (connections.has(destinationOrOutput)) {
                if (output === undefined) connections.delete(destinationOrOutput);
                else {
                    const connectionsToDestination = connections.get(destinationOrOutput);
                    if (connectionsToDestination !== undefined) {
                        const filteredConnections = connectionsToDestination.filter((connection)=>connection.output !== output && (connection.input !== input || input === undefined));
                        if (filteredConnections.length === 0) connections.delete(destinationOrOutput);
                        else connections.set(destinationOrOutput, filteredConnections);
                    }
                }
            }
            for (const [destination, connectionsToDestination] of connections)connectionsToDestination.forEach((connection)=>{
                if ((0, $02572834e9cacc18$export$d647358384f164e0)(destination)) nativeAudioNode.connect(destination, connection.output, connection.input);
                else nativeAudioNode.connect(destination, connection.output);
            });
        };
    })(nativeAudioNode.disconnect);
};


const $17fd1e9637f226c8$var$addConnectionToAudioParamOfAudioContext = (source, destination, output, isOffline)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $ca92fb3bedacccdf$export$1b11f454bf19657)(destination);
    const { outputs: outputs } = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(source);
    const eventListeners = (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25)(source);
    const eventListener = (isActive)=>{
        const nativeAudioNode = (0, $f19824d1c532946e$export$e719c0d45ea16d08)(source);
        const nativeAudioParam = (0, $6cb22515327e5f96$export$fad3d843b2a56ffb)(destination);
        if (isActive) {
            const partialConnection = (0, $7e7e2ad0b0763524$export$368aa16ce008e2f4)(passiveInputs, source, output);
            (0, $21a3952b118bdc5d$export$3dfe9f7f712d42df)(activeInputs, source, partialConnection, false);
            if (!isOffline && !(0, $5ab4cc8140911ed0$export$8658a39a04a404d5)(source)) nativeAudioNode.connect(nativeAudioParam, output);
        } else {
            const partialConnection = (0, $0af44684bfcfdb82$export$dc5a8616367736a9)(activeInputs, source, output);
            (0, $3bcad23e25c57ecf$export$2a7c0e6916aa50e4)(passiveInputs, partialConnection, false);
            if (!isOffline && !(0, $5ab4cc8140911ed0$export$8658a39a04a404d5)(source)) nativeAudioNode.disconnect(nativeAudioParam, output);
        }
    };
    if ((0, $b5b160ddb9cb72cc$export$64505511c8abc942)(outputs, [
        destination,
        output
    ], (outputConnection)=>outputConnection[0] === destination && outputConnection[1] === output, true)) {
        eventListeners.add(eventListener);
        if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(source)) (0, $21a3952b118bdc5d$export$3dfe9f7f712d42df)(activeInputs, source, [
            output,
            eventListener
        ], true);
        else (0, $3bcad23e25c57ecf$export$2a7c0e6916aa50e4)(passiveInputs, [
            source,
            output,
            eventListener
        ], true);
        return true;
    }
    return false;
};
const $17fd1e9637f226c8$var$deleteInputConnectionOfAudioNode = (source, destination, output, input)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(destination);
    const activeInputConnection = (0, $9d73a6929aae649e$export$6cc4c86d6b87a4b8)(activeInputs[input], source, output);
    if (activeInputConnection === null) {
        const passiveInputConnection = (0, $1347121a05cab167$export$26ec3ebc965d6cfd)(passiveInputs, source, output, input);
        return [
            passiveInputConnection[2],
            false
        ];
    }
    return [
        activeInputConnection[2],
        true
    ];
};
const $17fd1e9637f226c8$var$deleteInputConnectionOfAudioParam = (source, destination, output)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $ca92fb3bedacccdf$export$1b11f454bf19657)(destination);
    const activeInputConnection = (0, $9d73a6929aae649e$export$6cc4c86d6b87a4b8)(activeInputs, source, output);
    if (activeInputConnection === null) {
        const passiveInputConnection = (0, $7e7e2ad0b0763524$export$368aa16ce008e2f4)(passiveInputs, source, output);
        return [
            passiveInputConnection[1],
            false
        ];
    }
    return [
        activeInputConnection[2],
        true
    ];
};
const $17fd1e9637f226c8$var$deleteInputsOfAudioNode = (source, isOffline, destination, output, input)=>{
    const [listener, isActive] = $17fd1e9637f226c8$var$deleteInputConnectionOfAudioNode(source, destination, output, input);
    if (listener !== null) {
        (0, $d8593c04fb61e4ca$export$b5a32c2e2eac4137)(source, listener);
        if (isActive && !isOffline && !(0, $5ab4cc8140911ed0$export$8658a39a04a404d5)(source)) (0, $c5150425da7035f6$export$a19b495df4b88921)((0, $f19824d1c532946e$export$e719c0d45ea16d08)(source), (0, $f19824d1c532946e$export$e719c0d45ea16d08)(destination), output, input);
    }
    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(destination)) {
        const { activeInputs: activeInputs } = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(destination);
        (0, $d86f58cf827039bb$export$c74023ca160dc207)(destination, activeInputs);
    }
};
const $17fd1e9637f226c8$var$deleteInputsOfAudioParam = (source, isOffline, destination, output)=>{
    const [listener, isActive] = $17fd1e9637f226c8$var$deleteInputConnectionOfAudioParam(source, destination, output);
    if (listener !== null) {
        (0, $d8593c04fb61e4ca$export$b5a32c2e2eac4137)(source, listener);
        if (isActive && !isOffline && !(0, $5ab4cc8140911ed0$export$8658a39a04a404d5)(source)) (0, $f19824d1c532946e$export$e719c0d45ea16d08)(source).disconnect((0, $6cb22515327e5f96$export$fad3d843b2a56ffb)(destination), output);
    }
};
const $17fd1e9637f226c8$var$deleteAnyConnection = (source, isOffline)=>{
    const audioNodeConnectionsOfSource = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(source);
    const destinations = [];
    for (const outputConnection of audioNodeConnectionsOfSource.outputs){
        if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(outputConnection)) $17fd1e9637f226c8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $17fd1e9637f226c8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        destinations.push(outputConnection[0]);
    }
    audioNodeConnectionsOfSource.outputs.clear();
    return destinations;
};
const $17fd1e9637f226c8$var$deleteConnectionAtOutput = (source, isOffline, output)=>{
    const audioNodeConnectionsOfSource = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(source);
    const destinations = [];
    for (const outputConnection of audioNodeConnectionsOfSource.outputs)if (outputConnection[1] === output) {
        if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(outputConnection)) $17fd1e9637f226c8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $17fd1e9637f226c8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        destinations.push(outputConnection[0]);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
    }
    return destinations;
};
const $17fd1e9637f226c8$var$deleteConnectionToDestination = (source, isOffline, destination, output, input)=>{
    const audioNodeConnectionsOfSource = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(source);
    return Array.from(audioNodeConnectionsOfSource.outputs).filter((outputConnection)=>outputConnection[0] === destination && (output === undefined || outputConnection[1] === output) && (input === undefined || outputConnection[2] === input)).map((outputConnection)=>{
        if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(outputConnection)) $17fd1e9637f226c8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $17fd1e9637f226c8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
        return outputConnection[0];
    });
};
const $17fd1e9637f226c8$export$20e3fa4f981cb01d = (addAudioNodeConnections, addConnectionToAudioNode, cacheTestResult, createIncrementCycleCounter, createIndexSizeError, createInvalidAccessError, createNotSupportedError, decrementCycleCounter, detectCycles, eventTargetConstructor, getNativeContext, isNativeAudioContext, isNativeAudioNode, isNativeAudioParam, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor)=>{
    return class AudioNode extends eventTargetConstructor {
        constructor(context, isActive, nativeAudioNode, audioNodeRenderer){
            super(nativeAudioNode);
            this._context = context;
            this._nativeAudioNode = nativeAudioNode;
            const nativeContext = getNativeContext(context);
            // Bug #12: Safari does not support to disconnect a specific destination.
            if (isNativeAudioContext(nativeContext) && true !== cacheTestResult((0, $8fbdf1ba7335a1ec$export$f938a299860627), ()=>{
                return (0, $8fbdf1ba7335a1ec$export$f938a299860627)(nativeContext, nativeAudioWorkletNodeConstructor);
            })) (0, $5cd1779abf94fd6d$export$d4ca24d0078a887f)(nativeAudioNode);
            (0, $7718e734b2fef711$export$864a3cfb55580d0c).set(this, nativeAudioNode);
            (0, $7718e734b2fef711$export$c998cfefa4fd5136).set(this, new Set());
            if (context.state !== "closed" && isActive) (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(this);
            addAudioNodeConnections(this, audioNodeRenderer, nativeAudioNode);
        }
        get channelCount() {
            return this._nativeAudioNode.channelCount;
        }
        set channelCount(value) {
            this._nativeAudioNode.channelCount = value;
        }
        get channelCountMode() {
            return this._nativeAudioNode.channelCountMode;
        }
        set channelCountMode(value) {
            this._nativeAudioNode.channelCountMode = value;
        }
        get channelInterpretation() {
            return this._nativeAudioNode.channelInterpretation;
        }
        set channelInterpretation(value) {
            this._nativeAudioNode.channelInterpretation = value;
        }
        get context() {
            return this._context;
        }
        get numberOfInputs() {
            return this._nativeAudioNode.numberOfInputs;
        }
        get numberOfOutputs() {
            return this._nativeAudioNode.numberOfOutputs;
        }
        // tslint:disable-next-line:invalid-void
        connect(destination, output = 0, input = 0) {
            // Bug #174: Safari does expose a wrong numberOfOutputs for MediaStreamAudioDestinationNodes.
            if (output < 0 || output >= this._nativeAudioNode.numberOfOutputs) throw createIndexSizeError();
            const nativeContext = getNativeContext(this._context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            if (isNativeAudioNode(destination) || isNativeAudioParam(destination)) throw createInvalidAccessError();
            if ((0, $c23aedeecc2b6162$export$85cd8e93eb858e81)(destination)) {
                const nativeDestinationAudioNode = (0, $f19824d1c532946e$export$e719c0d45ea16d08)(destination);
                try {
                    const connection = (0, $19c742083556a242$export$b92162b3199b4461)(this._nativeAudioNode, nativeDestinationAudioNode, output, input);
                    const isPassive = (0, $a8abf1563cb0cb90$export$79a7cb9fa56970e)(this);
                    if (isOffline || isPassive) this._nativeAudioNode.disconnect(...connection);
                    if (this.context.state !== "closed" && !isPassive && (0, $a8abf1563cb0cb90$export$79a7cb9fa56970e)(destination)) (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(destination);
                } catch (err) {
                    // Bug #41: Safari does not throw the correct exception so far.
                    if (err.code === 12) throw createInvalidAccessError();
                    throw err;
                }
                const isNewConnectionToAudioNode = addConnectionToAudioNode(this, destination, output, input, isOffline);
                // Bug #164: Only Firefox detects cycles so far.
                if (isNewConnectionToAudioNode) {
                    const cycles = detectCycles([
                        this
                    ], destination);
                    (0, $c63caa1a29cc4f1a$export$f8092aa3a6fcf50f)(cycles, createIncrementCycleCounter(isOffline));
                }
                return destination;
            }
            const nativeAudioParam = (0, $6cb22515327e5f96$export$fad3d843b2a56ffb)(destination);
            /*
             * Bug #73, #147 & #153: Safari does not support to connect an input signal to the playbackRate AudioParam of an
             * AudioBufferSourceNode. This can't be easily detected and that's why the outdated name property is used here to identify
             * Safari. In addition to that the maxValue property is used to only detect the affected versions below v14.0.2.
             */ if (nativeAudioParam.name === "playbackRate" && nativeAudioParam.maxValue === 1024) throw createNotSupportedError();
            try {
                this._nativeAudioNode.connect(nativeAudioParam, output);
                if (isOffline || (0, $a8abf1563cb0cb90$export$79a7cb9fa56970e)(this)) this._nativeAudioNode.disconnect(nativeAudioParam, output);
            } catch (err) {
                // Bug #58: Safari doesn't throw an InvalidAccessError yet.
                if (err.code === 12) throw createInvalidAccessError();
                throw err;
            }
            const isNewConnectionToAudioParam = $17fd1e9637f226c8$var$addConnectionToAudioParamOfAudioContext(this, destination, output, isOffline);
            // Bug #164: Only Firefox detects cycles so far.
            if (isNewConnectionToAudioParam) {
                const cycles = detectCycles([
                    this
                ], destination);
                (0, $c63caa1a29cc4f1a$export$f8092aa3a6fcf50f)(cycles, createIncrementCycleCounter(isOffline));
            }
        }
        disconnect(destinationOrOutput, output, input) {
            let destinations;
            const nativeContext = getNativeContext(this._context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            if (destinationOrOutput === undefined) destinations = $17fd1e9637f226c8$var$deleteAnyConnection(this, isOffline);
            else if (typeof destinationOrOutput === "number") {
                if (destinationOrOutput < 0 || destinationOrOutput >= this.numberOfOutputs) throw createIndexSizeError();
                destinations = $17fd1e9637f226c8$var$deleteConnectionAtOutput(this, isOffline, destinationOrOutput);
            } else {
                if (output !== undefined && (output < 0 || output >= this.numberOfOutputs)) throw createIndexSizeError();
                if ((0, $c23aedeecc2b6162$export$85cd8e93eb858e81)(destinationOrOutput) && input !== undefined && (input < 0 || input >= destinationOrOutput.numberOfInputs)) throw createIndexSizeError();
                destinations = $17fd1e9637f226c8$var$deleteConnectionToDestination(this, isOffline, destinationOrOutput, output, input);
                if (destinations.length === 0) throw createInvalidAccessError();
            }
            // Bug #164: Only Firefox detects cycles so far.
            for (const destination of destinations){
                const cycles = detectCycles([
                    this
                ], destination);
                (0, $c63caa1a29cc4f1a$export$f8092aa3a6fcf50f)(cycles, decrementCycleCounter);
            }
        }
    };
};



const $361bc03ea1ca7077$export$25d3edb077748cfc = (addAudioParamConnections, audioParamAudioNodeStore, audioParamStore, createAudioParamRenderer, createCancelAndHoldAutomationEvent, createCancelScheduledValuesAutomationEvent, createExponentialRampToValueAutomationEvent, createLinearRampToValueAutomationEvent, createSetTargetAutomationEvent, createSetValueAutomationEvent, createSetValueCurveAutomationEvent, nativeAudioContextConstructor, setValueAtTimeUntilPossible)=>{
    return (audioNode, isAudioParamOfOfflineAudioContext, nativeAudioParam, maxValue = null, minValue = null)=>{
        // Bug #196 Only Safari sets the defaultValue to the initial value.
        const defaultValue = nativeAudioParam.value;
        const automationEventList = new (0, $8f6857d83370bfe9$exports.AutomationEventList)(defaultValue);
        const audioParamRenderer = isAudioParamOfOfflineAudioContext ? createAudioParamRenderer(automationEventList) : null;
        const audioParam = {
            get defaultValue () {
                return defaultValue;
            },
            get maxValue () {
                return maxValue === null ? nativeAudioParam.maxValue : maxValue;
            },
            get minValue () {
                return minValue === null ? nativeAudioParam.minValue : minValue;
            },
            get value () {
                return nativeAudioParam.value;
            },
            set value (value){
                nativeAudioParam.value = value;
                // Bug #98: Firefox & Safari do not yet treat the value setter like a call to setValueAtTime().
                audioParam.setValueAtTime(value, audioNode.context.currentTime);
            },
            cancelAndHoldAtTime (cancelTime) {
                // Bug #28: Firefox & Safari do not yet implement cancelAndHoldAtTime().
                if (typeof nativeAudioParam.cancelAndHoldAtTime === "function") {
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
                    nativeAudioParam.cancelAndHoldAtTime(cancelTime);
                } else {
                    const previousLastEvent = Array.from(automationEventList).pop();
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
                    const currentLastEvent = Array.from(automationEventList).pop();
                    nativeAudioParam.cancelScheduledValues(cancelTime);
                    if (previousLastEvent !== currentLastEvent && currentLastEvent !== undefined) {
                        if (currentLastEvent.type === "exponentialRampToValue") nativeAudioParam.exponentialRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
                        else if (currentLastEvent.type === "linearRampToValue") nativeAudioParam.linearRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
                        else if (currentLastEvent.type === "setValue") nativeAudioParam.setValueAtTime(currentLastEvent.value, currentLastEvent.startTime);
                        else if (currentLastEvent.type === "setValueCurve") nativeAudioParam.setValueCurveAtTime(currentLastEvent.values, currentLastEvent.startTime, currentLastEvent.duration);
                    }
                }
                return audioParam;
            },
            cancelScheduledValues (cancelTime) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createCancelScheduledValuesAutomationEvent(cancelTime));
                nativeAudioParam.cancelScheduledValues(cancelTime);
                return audioParam;
            },
            exponentialRampToValueAtTime (value1, endTime) {
                // Bug #45: Safari does not throw an error yet.
                if (value1 === 0) throw new RangeError();
                // Bug #187: Safari does not throw an error yet.
                if (!Number.isFinite(endTime) || endTime < 0) throw new RangeError();
                const currentTime = audioNode.context.currentTime;
                if (audioParamRenderer === null) automationEventList.flush(currentTime);
                // Bug #194: Firefox does not implicitly call setValueAtTime() if there is no previous event.
                if (Array.from(automationEventList).length === 0) {
                    automationEventList.add(createSetValueAutomationEvent(defaultValue, currentTime));
                    nativeAudioParam.setValueAtTime(defaultValue, currentTime);
                }
                automationEventList.add(createExponentialRampToValueAutomationEvent(value1, endTime));
                nativeAudioParam.exponentialRampToValueAtTime(value1, endTime);
                return audioParam;
            },
            linearRampToValueAtTime (value1, endTime) {
                const currentTime = audioNode.context.currentTime;
                if (audioParamRenderer === null) automationEventList.flush(currentTime);
                // Bug #195: Firefox does not implicitly call setValueAtTime() if there is no previous event.
                if (Array.from(automationEventList).length === 0) {
                    automationEventList.add(createSetValueAutomationEvent(defaultValue, currentTime));
                    nativeAudioParam.setValueAtTime(defaultValue, currentTime);
                }
                automationEventList.add(createLinearRampToValueAutomationEvent(value1, endTime));
                nativeAudioParam.linearRampToValueAtTime(value1, endTime);
                return audioParam;
            },
            setTargetAtTime (target, startTime, timeConstant) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createSetTargetAutomationEvent(target, startTime, timeConstant));
                nativeAudioParam.setTargetAtTime(target, startTime, timeConstant);
                return audioParam;
            },
            setValueAtTime (value1, startTime) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createSetValueAutomationEvent(value1, startTime));
                nativeAudioParam.setValueAtTime(value1, startTime);
                return audioParam;
            },
            setValueCurveAtTime (values, startTime, duration) {
                // Bug 183: Safari only accepts a Float32Array.
                const convertedValues = values instanceof Float32Array ? values : new Float32Array(values);
                /*
                 * Bug #152: Safari does not correctly interpolate the values of the curve.
                 * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the
                 * existence of the webkitAudioContext is used as a workaround here.
                 */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === "webkitAudioContext") {
                    const endTime = startTime + duration;
                    const sampleRate = audioNode.context.sampleRate;
                    const firstSample = Math.ceil(startTime * sampleRate);
                    const lastSample = Math.floor(endTime * sampleRate);
                    const numberOfInterpolatedValues = lastSample - firstSample;
                    const interpolatedValues = new Float32Array(numberOfInterpolatedValues);
                    for(let i = 0; i < numberOfInterpolatedValues; i += 1){
                        const theoreticIndex = (convertedValues.length - 1) / duration * ((firstSample + i) / sampleRate - startTime);
                        const lowerIndex = Math.floor(theoreticIndex);
                        const upperIndex = Math.ceil(theoreticIndex);
                        interpolatedValues[i] = lowerIndex === upperIndex ? convertedValues[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * convertedValues[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * convertedValues[upperIndex];
                    }
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createSetValueCurveAutomationEvent(interpolatedValues, startTime, duration));
                    nativeAudioParam.setValueCurveAtTime(interpolatedValues, startTime, duration);
                    const timeOfLastSample = lastSample / sampleRate;
                    if (timeOfLastSample < endTime) setValueAtTimeUntilPossible(audioParam, interpolatedValues[interpolatedValues.length - 1], timeOfLastSample);
                    setValueAtTimeUntilPossible(audioParam, convertedValues[convertedValues.length - 1], endTime);
                } else {
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createSetValueCurveAutomationEvent(convertedValues, startTime, duration));
                    nativeAudioParam.setValueCurveAtTime(convertedValues, startTime, duration);
                }
                return audioParam;
            }
        };
        audioParamStore.set(audioParam, nativeAudioParam);
        audioParamAudioNodeStore.set(audioParam, audioNode);
        addAudioParamConnections(audioParam, audioParamRenderer);
        return audioParam;
    };
};


const $403e2aebd17670b8$export$8858f507eb103ac6 = (automationEventList)=>{
    return {
        replay (audioParam) {
            for (const automationEvent of automationEventList){
                if (automationEvent.type === "exponentialRampToValue") {
                    const { endTime: endTime, value: value } = automationEvent;
                    audioParam.exponentialRampToValueAtTime(value, endTime);
                } else if (automationEvent.type === "linearRampToValue") {
                    const { endTime: endTime, value: value } = automationEvent;
                    audioParam.linearRampToValueAtTime(value, endTime);
                } else if (automationEvent.type === "setTarget") {
                    const { startTime: startTime, target: target, timeConstant: timeConstant } = automationEvent;
                    audioParam.setTargetAtTime(target, startTime, timeConstant);
                } else if (automationEvent.type === "setValue") {
                    const { startTime: startTime, value: value } = automationEvent;
                    audioParam.setValueAtTime(value, startTime);
                } else if (automationEvent.type === "setValueCurve") {
                    const { duration: duration, startTime: startTime, values: values } = automationEvent;
                    audioParam.setValueCurveAtTime(values, startTime, duration);
                } else throw new Error("Can't apply an unknown automation.");
            }
        }
    };
};



class $cb5c13986ebfa770$export$5da0cf80a3ca75d6 {
    constructor(parameters){
        this._map = new Map(parameters);
    }
    get size() {
        return this._map.size;
    }
    entries() {
        return this._map.entries();
    }
    forEach(callback, thisArg = null) {
        return this._map.forEach((value, key)=>callback.call(thisArg, value, key, this));
    }
    get(name) {
        return this._map.get(name);
    }
    has(name) {
        return this._map.has(name);
    }
    keys() {
        return this._map.keys();
    }
    values() {
        return this._map.values();
    }
}


const $81af2a00b3599a83$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    // Bug #61: The channelCountMode should be 'max' according to the spec but is set to 'explicit' to achieve consistent behavior.
    channelCountMode: "explicit",
    channelInterpretation: "speakers",
    numberOfInputs: 1,
    numberOfOutputs: 1,
    parameterData: {},
    processorOptions: {}
};
const $81af2a00b3599a83$export$48302d37fa2cf062 = (addUnrenderedAudioWorkletNode, audioNodeConstructor, createAudioParam, createAudioWorkletNodeRenderer, createNativeAudioWorkletNode, getAudioNodeConnections, getBackupOfflineAudioContext, getNativeContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, sanitizeAudioWorkletNodeOptions, setActiveAudioWorkletNodeInputs, testAudioWorkletNodeOptionsClonability, wrapEventListener)=>{
    return class AudioWorkletNode extends audioNodeConstructor {
        constructor(context, name, options){
            var _a;
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const mergedOptions = sanitizeAudioWorkletNodeOptions({
                ...$81af2a00b3599a83$var$DEFAULT_OPTIONS,
                ...options
            });
            // Bug #191: Safari doesn't throw an error if the options aren't clonable.
            testAudioWorkletNodeOptionsClonability(mergedOptions);
            const nodeNameToProcessorConstructorMap = (0, $7718e734b2fef711$export$b9bea39f06f96914).get(nativeContext);
            const processorConstructor = nodeNameToProcessorConstructorMap === null || nodeNameToProcessorConstructorMap === void 0 ? void 0 : nodeNameToProcessorConstructorMap.get(name);
            // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.
            const nativeContextOrBackupOfflineAudioContext = isOffline || nativeContext.state !== "closed" ? nativeContext : (_a = getBackupOfflineAudioContext(nativeContext)) !== null && _a !== void 0 ? _a : nativeContext;
            const nativeAudioWorkletNode = createNativeAudioWorkletNode(nativeContextOrBackupOfflineAudioContext, isOffline ? null : context.baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, mergedOptions);
            const audioWorkletNodeRenderer = isOffline ? createAudioWorkletNodeRenderer(name, mergedOptions, processorConstructor) : null;
            /*
             * @todo Add a mechanism to switch an AudioWorkletNode to passive once the process() function of the AudioWorkletProcessor
             * returns false.
             */ super(context, true, nativeAudioWorkletNode, audioWorkletNodeRenderer);
            const parameters = [];
            nativeAudioWorkletNode.parameters.forEach((nativeAudioParam, nm)=>{
                const audioParam = createAudioParam(this, isOffline, nativeAudioParam);
                parameters.push([
                    nm,
                    audioParam
                ]);
            });
            this._nativeAudioWorkletNode = nativeAudioWorkletNode;
            this._onprocessorerror = null;
            this._parameters = new (0, $cb5c13986ebfa770$export$5da0cf80a3ca75d6)(parameters);
            /*
             * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to
             * the destination.
             */ if (isOffline) addUnrenderedAudioWorkletNode(nativeContext, this);
            const { activeInputs: activeInputs } = getAudioNodeConnections(this);
            setActiveAudioWorkletNodeInputs(nativeAudioWorkletNode, activeInputs);
        }
        get onprocessorerror() {
            return this._onprocessorerror;
        }
        set onprocessorerror(value) {
            const wrappedListener = typeof value === "function" ? wrapEventListener(this, value) : null;
            this._nativeAudioWorkletNode.onprocessorerror = wrappedListener;
            const nativeOnProcessorError = this._nativeAudioWorkletNode.onprocessorerror;
            this._onprocessorerror = nativeOnProcessorError !== null && nativeOnProcessorError === wrappedListener ? value : nativeOnProcessorError;
        }
        get parameters() {
            if (this._parameters === null) // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            return this._nativeAudioWorkletNode.parameters;
            return this._parameters;
        }
        get port() {
            return this._nativeAudioWorkletNode.port;
        }
    };
};


function $824a78f49a5e02c5$export$e3c6e435bf217093(audioBuffer, // @todo There is currently no way to define something like { [ key: number | string ]: Float32Array }
parent, key, channelNumber, bufferOffset) {
    if (typeof audioBuffer.copyFromChannel === "function") {
        // The byteLength will be 0 when the ArrayBuffer was transferred.
        if (parent[key].byteLength === 0) parent[key] = new Float32Array(128);
        audioBuffer.copyFromChannel(parent[key], channelNumber, bufferOffset);
    // Bug #5: Safari does not support copyFromChannel().
    } else {
        const channelData = audioBuffer.getChannelData(channelNumber);
        // The byteLength will be 0 when the ArrayBuffer was transferred.
        if (parent[key].byteLength === 0) parent[key] = channelData.slice(bufferOffset, bufferOffset + 128);
        else {
            const slicedInput = new Float32Array(channelData.buffer, bufferOffset * Float32Array.BYTES_PER_ELEMENT, 128);
            parent[key].set(slicedInput);
        }
    }
}


const $b17c809f1f01ce66$export$6bb6d131144bd753 = (audioBuffer, parent, key, channelNumber, bufferOffset)=>{
    if (typeof audioBuffer.copyToChannel === "function") // The byteLength will be 0 when the ArrayBuffer was transferred.
    {
        if (parent[key].byteLength !== 0) audioBuffer.copyToChannel(parent[key], channelNumber, bufferOffset);
    } else // The byteLength will be 0 when the ArrayBuffer was transferred.
    if (parent[key].byteLength !== 0) audioBuffer.getChannelData(channelNumber).set(parent[key], bufferOffset);
};


const $495c163400b6fc08$export$495a31436d188d6d = (x, y)=>{
    const arrays = [];
    for(let i = 0; i < x; i += 1){
        const array = [];
        const length = typeof y === "number" ? y : y[i];
        for(let j = 0; j < length; j += 1)array.push(new Float32Array(128));
        arrays.push(array);
    }
    return arrays;
};






const $cd8aa197172c5463$export$d948bbdb8f0d97d7 = (nativeOfflineAudioContext, proxy)=>{
    const nodeToProcessorMap = (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$16d7878f7e059d67), nativeOfflineAudioContext);
    const nativeAudioWorkletNode = (0, $f19824d1c532946e$export$e719c0d45ea16d08)(proxy);
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)(nodeToProcessorMap, nativeAudioWorkletNode);
};



const $b10bbde18d49daa1$var$processBuffer = async (proxy, renderedBuffer, nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime)=>{
    // Ceil the length to the next full render quantum.
    // Bug #17: Safari does not yet expose the length.
    const length = renderedBuffer === null ? Math.ceil(proxy.context.length / 128) * 128 : renderedBuffer.length;
    const numberOfInputChannels = options.channelCount * options.numberOfInputs;
    const numberOfOutputChannels = outputChannelCount.reduce((sum, value)=>sum + value, 0);
    const processedBuffer = numberOfOutputChannels === 0 ? null : nativeOfflineAudioContext.createBuffer(numberOfOutputChannels, length, nativeOfflineAudioContext.sampleRate);
    if (processorConstructor === undefined) throw new Error("Missing the processor constructor.");
    const audioNodeConnections = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(proxy);
    const audioWorkletProcessor = await (0, $cd8aa197172c5463$export$d948bbdb8f0d97d7)(nativeOfflineAudioContext, proxy);
    const inputs = (0, $495c163400b6fc08$export$495a31436d188d6d)(options.numberOfInputs, options.channelCount);
    const outputs = (0, $495c163400b6fc08$export$495a31436d188d6d)(options.numberOfOutputs, outputChannelCount);
    const parameters = Array.from(proxy.parameters.keys()).reduce((prmtrs, name)=>({
            ...prmtrs,
            [name]: new Float32Array(128)
        }), {});
    for(let i = 0; i < length; i += 128){
        if (options.numberOfInputs > 0 && renderedBuffer !== null) {
            for(let j = 0; j < options.numberOfInputs; j += 1)for(let k = 0; k < options.channelCount; k += 1)(0, $824a78f49a5e02c5$export$e3c6e435bf217093)(renderedBuffer, inputs[j], k, k, i);
        }
        if (processorConstructor.parameterDescriptors !== undefined && renderedBuffer !== null) processorConstructor.parameterDescriptors.forEach(({ name: name }, index)=>{
            (0, $824a78f49a5e02c5$export$e3c6e435bf217093)(renderedBuffer, parameters, name, numberOfInputChannels + index, i);
        });
        for(let j = 0; j < options.numberOfInputs; j += 1){
            for(let k = 0; k < outputChannelCount[j]; k += 1)// The byteLength will be 0 when the ArrayBuffer was transferred.
            if (outputs[j][k].byteLength === 0) outputs[j][k] = new Float32Array(128);
        }
        try {
            const potentiallyEmptyInputs = inputs.map((input, index)=>{
                if (audioNodeConnections.activeInputs[index].size === 0) return [];
                return input;
            });
            const activeSourceFlag = exposeCurrentFrameAndCurrentTime(i / nativeOfflineAudioContext.sampleRate, nativeOfflineAudioContext.sampleRate, ()=>audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
            if (processedBuffer !== null) for(let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1){
                for(let k = 0; k < outputChannelCount[j]; k += 1)(0, $b17c809f1f01ce66$export$6bb6d131144bd753)(processedBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
                outputChannelSplitterNodeOutput += outputChannelCount[j];
            }
            if (!activeSourceFlag) break;
        } catch (error) {
            proxy.dispatchEvent(new ErrorEvent("processorerror", {
                colno: error.colno,
                filename: error.filename,
                lineno: error.lineno,
                message: error.message
            }));
            break;
        }
    }
    return processedBuffer;
};
const $b10bbde18d49daa1$export$3a898af5d2b29a5b = (connectAudioParam, connectMultipleOutputs, createNativeAudioBufferSourceNode, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, deleteUnrenderedAudioWorkletNode, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getNativeAudioNode, nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return (name, options, processorConstructor)=>{
        const renderedNativeAudioNodes = new WeakMap();
        let processedBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioWorkletNode = getNativeAudioNode(proxy);
            let nativeOutputNodes = null;
            const nativeAudioWorkletNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAudioWorkletNode, nativeOfflineAudioContext);
            const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount);
            // Bug #61: Only Chrome, Edge & Firefox have an implementation of the AudioWorkletNode yet.
            if (nativeAudioWorkletNodeConstructor === null) {
                const numberOfOutputChannels = outputChannelCount.reduce((sum, value)=>sum + value, 0);
                const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, {
                    channelCount: Math.max(1, numberOfOutputChannels),
                    channelCountMode: "explicit",
                    channelInterpretation: "discrete",
                    numberOfOutputs: Math.max(1, numberOfOutputChannels)
                });
                const outputChannelMergerNodes = [];
                for(let i = 0; i < proxy.numberOfOutputs; i += 1)outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeOfflineAudioContext, {
                    channelCount: 1,
                    channelCountMode: "explicit",
                    channelInterpretation: "speakers",
                    numberOfInputs: outputChannelCount[i]
                }));
                const outputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    channelCount: options.channelCount,
                    channelCountMode: options.channelCountMode,
                    channelInterpretation: options.channelInterpretation,
                    gain: 1
                });
                outputGainNode.connect = connectMultipleOutputs.bind(null, outputChannelMergerNodes);
                outputGainNode.disconnect = disconnectMultipleOutputs.bind(null, outputChannelMergerNodes);
                nativeOutputNodes = [
                    outputChannelSplitterNode,
                    outputChannelMergerNodes,
                    outputGainNode
                ];
            } else if (!nativeAudioWorkletNodeIsOwnedByContext) nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeOfflineAudioContext, name);
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeOutputNodes === null ? nativeAudioWorkletNode : nativeOutputNodes[2]);
            if (nativeOutputNodes !== null) {
                if (processedBufferPromise === null) {
                    if (processorConstructor === undefined) throw new Error("Missing the processor constructor.");
                    if (nativeOfflineAudioContextConstructor === null) throw new Error("Missing the native OfflineAudioContext constructor.");
                    // Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                    const numberOfInputChannels = proxy.channelCount * proxy.numberOfInputs;
                    const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
                    const numberOfChannels = numberOfInputChannels + numberOfParameters;
                    const renderBuffer = async ()=>{
                        const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(numberOfChannels, // Ceil the length to the next full render quantum.
                        // Bug #17: Safari does not yet expose the length.
                        Math.ceil(proxy.context.length / 128) * 128, nativeOfflineAudioContext.sampleRate);
                        const gainNodes = [];
                        const inputChannelSplitterNodes = [];
                        for(let i = 0; i < options.numberOfInputs; i += 1){
                            gainNodes.push(createNativeGainNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: options.channelCountMode,
                                channelInterpretation: options.channelInterpretation,
                                gain: 1
                            }));
                            inputChannelSplitterNodes.push(createNativeChannelSplitterNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: "explicit",
                                channelInterpretation: "discrete",
                                numberOfOutputs: options.channelCount
                            }));
                        }
                        const constantSourceNodes = await Promise.all(Array.from(proxy.parameters.values()).map(async (audioParam)=>{
                            const constantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: "explicit",
                                channelInterpretation: "discrete",
                                offset: audioParam.value
                            });
                            await renderAutomation(partialOfflineAudioContext, audioParam, constantSourceNode.offset);
                            return constantSourceNode;
                        }));
                        const inputChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                            channelCount: 1,
                            channelCountMode: "explicit",
                            channelInterpretation: "speakers",
                            numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
                        });
                        for(let i = 0; i < options.numberOfInputs; i += 1){
                            gainNodes[i].connect(inputChannelSplitterNodes[i]);
                            for(let j = 0; j < options.channelCount; j += 1)inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
                        }
                        for (const [index, constantSourceNode] of constantSourceNodes.entries()){
                            constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
                            constantSourceNode.start(0);
                        }
                        inputChannelMergerNode.connect(partialOfflineAudioContext.destination);
                        await Promise.all(gainNodes.map((gainNode)=>renderInputsOfAudioNode(proxy, partialOfflineAudioContext, gainNode)));
                        return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                    };
                    processedBufferPromise = $b10bbde18d49daa1$var$processBuffer(proxy, numberOfChannels === 0 ? null : await renderBuffer(), nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime);
                }
                const processedBuffer = await processedBufferPromise;
                const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                    buffer: null,
                    channelCount: 2,
                    channelCountMode: "max",
                    channelInterpretation: "speakers",
                    loop: false,
                    loopEnd: 0,
                    loopStart: 0,
                    playbackRate: 1
                });
                const [outputChannelSplitterNode, outputChannelMergerNodes, outputGainNode] = nativeOutputNodes;
                if (processedBuffer !== null) {
                    audioBufferSourceNode.buffer = processedBuffer;
                    audioBufferSourceNode.start(0);
                }
                audioBufferSourceNode.connect(outputChannelSplitterNode);
                for(let i = 0, outputChannelSplitterNodeOutput = 0; i < proxy.numberOfOutputs; i += 1){
                    const outputChannelMergerNode = outputChannelMergerNodes[i];
                    for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                    outputChannelSplitterNodeOutput += outputChannelCount[i];
                }
                return outputGainNode;
            }
            if (!nativeAudioWorkletNodeIsOwnedByContext) for (const [nm, audioParam] of proxy.parameters.entries())await renderAutomation(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            nativeAudioWorkletNode.parameters.get(nm));
            else for (const [nm, audioParam] of proxy.parameters.entries())await connectAudioParam(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            nativeAudioWorkletNode.parameters.get(nm));
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioWorkletNode);
            return nativeAudioWorkletNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                deleteUnrenderedAudioWorkletNode(nativeOfflineAudioContext, proxy);
                const renderedNativeAudioWorkletNodeOrGainNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioWorkletNodeOrGainNode !== undefined) return Promise.resolve(renderedNativeAudioWorkletNodeOrGainNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $c7dce4d973e69828$export$7824d6f4713e1e35 = (addAudioWorkletModule, analyserNodeConstructor, audioBufferConstructor, audioBufferSourceNodeConstructor, biquadFilterNodeConstructor, channelMergerNodeConstructor, channelSplitterNodeConstructor, constantSourceNodeConstructor, convolverNodeConstructor, decodeAudioData, delayNodeConstructor, dynamicsCompressorNodeConstructor, gainNodeConstructor, iIRFilterNodeConstructor, minimalBaseAudioContextConstructor, oscillatorNodeConstructor, pannerNodeConstructor, periodicWaveConstructor, stereoPannerNodeConstructor, waveShaperNodeConstructor)=>{
    return class BaseAudioContext extends minimalBaseAudioContextConstructor {
        constructor(_nativeContext, numberOfChannels){
            super(_nativeContext, numberOfChannels);
            this._nativeContext = _nativeContext;
            this._audioWorklet = addAudioWorkletModule === undefined ? undefined : {
                addModule: (moduleURL, options)=>{
                    return addAudioWorkletModule(this, moduleURL, options);
                }
            };
        }
        get audioWorklet() {
            return this._audioWorklet;
        }
        createAnalyser() {
            return new analyserNodeConstructor(this);
        }
        createBiquadFilter() {
            return new biquadFilterNodeConstructor(this);
        }
        createBuffer(numberOfChannels, length, sampleRate) {
            return new audioBufferConstructor({
                length: length,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            });
        }
        createBufferSource() {
            return new audioBufferSourceNodeConstructor(this);
        }
        createChannelMerger(numberOfInputs = 6) {
            return new channelMergerNodeConstructor(this, {
                numberOfInputs: numberOfInputs
            });
        }
        createChannelSplitter(numberOfOutputs = 6) {
            return new channelSplitterNodeConstructor(this, {
                numberOfOutputs: numberOfOutputs
            });
        }
        createConstantSource() {
            return new constantSourceNodeConstructor(this);
        }
        createConvolver() {
            return new convolverNodeConstructor(this);
        }
        createDelay(maxDelayTime = 1) {
            return new delayNodeConstructor(this, {
                maxDelayTime: maxDelayTime
            });
        }
        createDynamicsCompressor() {
            return new dynamicsCompressorNodeConstructor(this);
        }
        createGain() {
            return new gainNodeConstructor(this);
        }
        createIIRFilter(feedforward, feedback) {
            return new iIRFilterNodeConstructor(this, {
                feedback: feedback,
                feedforward: feedforward
            });
        }
        createOscillator() {
            return new oscillatorNodeConstructor(this);
        }
        createPanner() {
            return new pannerNodeConstructor(this);
        }
        createPeriodicWave(real, imag, constraints = {
            disableNormalization: false
        }) {
            return new periodicWaveConstructor(this, {
                ...constraints,
                imag: imag,
                real: real
            });
        }
        createStereoPanner() {
            return new stereoPannerNodeConstructor(this);
        }
        createWaveShaper() {
            return new waveShaperNodeConstructor(this);
        }
        decodeAudioData(audioData, successCallback, errorCallback) {
            return decodeAudioData(this._nativeContext, audioData).then((audioBuffer)=>{
                if (typeof successCallback === "function") successCallback(audioBuffer);
                return audioBuffer;
            }, (err)=>{
                if (typeof errorCallback === "function") errorCallback(err);
                throw err;
            });
        }
    };
};



const $66a4e6e6f309207a$var$DEFAULT_OPTIONS = {
    Q: 1,
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers",
    detune: 0,
    frequency: 350,
    gain: 0,
    type: "lowpass"
};
const $66a4e6e6f309207a$export$aa421daabad177b5 = (audioNodeConstructor, createAudioParam, createBiquadFilterNodeRenderer, createInvalidAccessError, createNativeBiquadFilterNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class BiquadFilterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$66a4e6e6f309207a$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeBiquadFilterNode = createNativeBiquadFilterNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const biquadFilterNodeRenderer = isOffline ? createBiquadFilterNodeRenderer() : null;
            super(context, false, nativeBiquadFilterNode, biquadFilterNodeRenderer);
            // Bug #80: Safari does not export the correct values for maxValue and minValue.
            this._Q = createAudioParam(this, isOffline, nativeBiquadFilterNode.Q, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            // Bug #78: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._detune = createAudioParam(this, isOffline, nativeBiquadFilterNode.detune, 1200 * Math.log2((0, $c205d95559d496ba$export$ab43bedd17d6a167)), -1200 * Math.log2((0, $c205d95559d496ba$export$ab43bedd17d6a167)));
            // Bug #77: Firefox & Safari do not export the correct value for minValue.
            this._frequency = createAudioParam(this, isOffline, nativeBiquadFilterNode.frequency, context.sampleRate / 2, 0);
            // Bug #79: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._gain = createAudioParam(this, isOffline, nativeBiquadFilterNode.gain, 40 * Math.log10((0, $c205d95559d496ba$export$ab43bedd17d6a167)), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._nativeBiquadFilterNode = nativeBiquadFilterNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get detune() {
            return this._detune;
        }
        get frequency() {
            return this._frequency;
        }
        get gain() {
            return this._gain;
        }
        get Q() {
            return this._Q;
        }
        get type() {
            return this._nativeBiquadFilterNode.type;
        }
        set type(value) {
            this._nativeBiquadFilterNode.type = value;
        }
        getFrequencyResponse(frequencyHz, magResponse, phaseResponse) {
            // Bug #189: Safari does throw an InvalidStateError.
            try {
                this._nativeBiquadFilterNode.getFrequencyResponse(frequencyHz, magResponse, phaseResponse);
            } catch (err) {
                if (err.code === 11) throw createInvalidAccessError();
                throw err;
            }
            // Bug #68: Safari does not throw an error if the parameters differ in their length.
            if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw createInvalidAccessError();
        }
    };
};



const $bcf262a04dcb901f$export$1532cc6682032d84 = (connectAudioParam, createNativeBiquadFilterNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeBiquadFilterNodes = new WeakMap();
        const createBiquadFilterNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeBiquadFilterNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeBiquadFilterNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeBiquadFilterNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeBiquadFilterNode, nativeOfflineAudioContext);
            if (!nativeBiquadFilterNodeIsOwnedByContext) {
                const options = {
                    Q: nativeBiquadFilterNode.Q.value,
                    channelCount: nativeBiquadFilterNode.channelCount,
                    channelCountMode: nativeBiquadFilterNode.channelCountMode,
                    channelInterpretation: nativeBiquadFilterNode.channelInterpretation,
                    detune: nativeBiquadFilterNode.detune.value,
                    frequency: nativeBiquadFilterNode.frequency.value,
                    gain: nativeBiquadFilterNode.gain.value,
                    type: nativeBiquadFilterNode.type
                };
                nativeBiquadFilterNode = createNativeBiquadFilterNode(nativeOfflineAudioContext, options);
            }
            renderedNativeBiquadFilterNodes.set(nativeOfflineAudioContext, nativeBiquadFilterNode);
            if (!nativeBiquadFilterNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.Q, nativeBiquadFilterNode.Q);
                await renderAutomation(nativeOfflineAudioContext, proxy.detune, nativeBiquadFilterNode.detune);
                await renderAutomation(nativeOfflineAudioContext, proxy.frequency, nativeBiquadFilterNode.frequency);
                await renderAutomation(nativeOfflineAudioContext, proxy.gain, nativeBiquadFilterNode.gain);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.Q, nativeBiquadFilterNode.Q);
                await connectAudioParam(nativeOfflineAudioContext, proxy.detune, nativeBiquadFilterNode.detune);
                await connectAudioParam(nativeOfflineAudioContext, proxy.frequency, nativeBiquadFilterNode.frequency);
                await connectAudioParam(nativeOfflineAudioContext, proxy.gain, nativeBiquadFilterNode.gain);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeBiquadFilterNode);
            return nativeBiquadFilterNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeBiquadFilterNode = renderedNativeBiquadFilterNodes.get(nativeOfflineAudioContext);
                if (renderedNativeBiquadFilterNode !== undefined) return Promise.resolve(renderedNativeBiquadFilterNode);
                return createBiquadFilterNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $c8f9a173cc3bf911$export$e72d622686b5f6c7 = (ongoingTests, testResults)=>{
    return (tester, test)=>{
        const cachedTestResult = testResults.get(tester);
        if (cachedTestResult !== undefined) return cachedTestResult;
        const ongoingTest = ongoingTests.get(tester);
        if (ongoingTest !== undefined) return ongoingTest;
        try {
            const synchronousTestResult = test();
            if (synchronousTestResult instanceof Promise) {
                ongoingTests.set(tester, synchronousTestResult);
                return synchronousTestResult.catch(()=>false).then((finalTestResult)=>{
                    ongoingTests.delete(tester);
                    testResults.set(tester, finalTestResult);
                    return finalTestResult;
                });
            }
            testResults.set(tester, synchronousTestResult);
            return synchronousTestResult;
        } catch  {
            testResults.set(tester, false);
            return false;
        }
    };
};


const $d240d532973e561a$var$DEFAULT_OPTIONS = {
    channelCount: 1,
    channelCountMode: "explicit",
    channelInterpretation: "speakers",
    numberOfInputs: 6
};
const $d240d532973e561a$export$a65a5a400135d27 = (audioNodeConstructor, createChannelMergerNodeRenderer, createNativeChannelMergerNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class ChannelMergerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$d240d532973e561a$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeChannelMergerNode = createNativeChannelMergerNode(nativeContext, mergedOptions);
            const channelMergerNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelMergerNodeRenderer() : null;
            super(context, false, nativeChannelMergerNode, channelMergerNodeRenderer);
        }
    };
};



const $49bc852e7ae475d1$export$79056cbe2b10cae5 = (createNativeChannelMergerNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioNode = getNativeAudioNode(proxy);
            // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAudioNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAudioNode, nativeOfflineAudioContext);
            if (!nativeAudioNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfInputs: nativeAudioNode.numberOfInputs
                };
                nativeAudioNode = createNativeChannelMergerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);
            return nativeAudioNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $ecc7f6221abcb6cb$var$DEFAULT_OPTIONS = {
    channelCount: 6,
    channelCountMode: "explicit",
    channelInterpretation: "discrete",
    numberOfOutputs: 6
};
const $ecc7f6221abcb6cb$export$ce9d996cafa605b = (audioNodeConstructor, createChannelSplitterNodeRenderer, createNativeChannelSplitterNode, getNativeContext, isNativeOfflineAudioContext, sanitizeChannelSplitterOptions)=>{
    return class ChannelSplitterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = sanitizeChannelSplitterOptions({
                ...$ecc7f6221abcb6cb$var$DEFAULT_OPTIONS,
                ...options
            });
            const nativeChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, mergedOptions);
            const channelSplitterNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelSplitterNodeRenderer() : null;
            super(context, false, nativeChannelSplitterNode, channelSplitterNodeRenderer);
        }
    };
};



const $cbf1ca25428a2bfd$export$d815cad16abde9c3 = (createNativeChannelSplitterNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioNode = getNativeAudioNode(proxy);
            // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAudioNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAudioNode, nativeOfflineAudioContext);
            if (!nativeAudioNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfOutputs: nativeAudioNode.numberOfOutputs
                };
                nativeAudioNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);
            return nativeAudioNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $d4e4872b149da763$export$1e69fdca2ad79f10 = (renderInputsOfAudioParam)=>{
    return (nativeOfflineAudioContext, audioParam, nativeAudioParam)=>{
        return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
    };
};



const $69e4c3c94e06c765$export$5f708e50316bf1a = (createIndexSizeError)=>{
    return (outputAudioNodes, destination, output = 0, input = 0)=>{
        const outputAudioNode = outputAudioNodes[output];
        if (outputAudioNode === undefined) throw createIndexSizeError();
        if ((0, $02572834e9cacc18$export$d647358384f164e0)(destination)) return outputAudioNode.connect(destination, 0, input);
        return outputAudioNode.connect(destination, 0);
    };
};


const $c57fc422e0055003$export$e82b2b63ea82dc82 = (createNativeAudioBufferSourceNode)=>{
    return (nativeContext, nativeAudioNode)=>{
        const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
            buffer: null,
            channelCount: 2,
            channelCountMode: "max",
            channelInterpretation: "speakers",
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            playbackRate: 1
        });
        const nativeAudioBuffer = nativeContext.createBuffer(1, 2, 44100);
        nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
        nativeAudioBufferSourceNode.loop = true;
        nativeAudioBufferSourceNode.connect(nativeAudioNode);
        nativeAudioBufferSourceNode.start();
        return ()=>{
            nativeAudioBufferSourceNode.stop();
            nativeAudioBufferSourceNode.disconnect(nativeAudioNode);
        };
    };
};






const $a2dd1c01048670e7$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers",
    offset: 1
};
const $a2dd1c01048670e7$export$a02a9a6200996500 = (audioNodeConstructor, createAudioParam, createConstantSourceNodeRendererFactory, createNativeConstantSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class ConstantSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$a2dd1c01048670e7$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeConstantSourceNode = createNativeConstantSourceNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const constantSourceNodeRenderer = isOffline ? createConstantSourceNodeRendererFactory() : null;
            super(context, false, nativeConstantSourceNode, constantSourceNodeRenderer);
            this._constantSourceNodeRenderer = constantSourceNodeRenderer;
            this._nativeConstantSourceNode = nativeConstantSourceNode;
            /*
             * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and minValue
             * for GainNodes.
             */ this._offset = createAudioParam(this, isOffline, nativeConstantSourceNode.offset, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._onended = null;
        }
        get offset() {
            return this._offset;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === "function" ? wrapEventListener(this, value) : null;
            this._nativeConstantSourceNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeConstantSourceNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        start(when = 0) {
            this._nativeConstantSourceNode.start(when);
            if (this._constantSourceNodeRenderer !== null) this._constantSourceNodeRenderer.start = when;
            if (this.context.state !== "closed") {
                (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeConstantSourceNode.removeEventListener("ended", resetInternalStateToPassive);
                    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(this)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(this);
                };
                this._nativeConstantSourceNode.addEventListener("ended", resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeConstantSourceNode.stop(when);
            if (this._constantSourceNodeRenderer !== null) this._constantSourceNodeRenderer.stop = when;
        }
    };
};



const $03ead4cb10fa624b$export$bc541a3c87b45a7d = (connectAudioParam, createNativeConstantSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeConstantSourceNodes = new WeakMap();
        let start = null;
        let stop = null;
        const createConstantSourceNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeConstantSourceNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeConstantSourceNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeConstantSourceNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeConstantSourceNode, nativeOfflineAudioContext);
            if (!nativeConstantSourceNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeConstantSourceNode.channelCount,
                    channelCountMode: nativeConstantSourceNode.channelCountMode,
                    channelInterpretation: nativeConstantSourceNode.channelInterpretation,
                    offset: nativeConstantSourceNode.offset.value
                };
                nativeConstantSourceNode = createNativeConstantSourceNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeConstantSourceNode.start(start);
                if (stop !== null) nativeConstantSourceNode.stop(stop);
            }
            renderedNativeConstantSourceNodes.set(nativeOfflineAudioContext, nativeConstantSourceNode);
            if (!nativeConstantSourceNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConstantSourceNode);
            return nativeConstantSourceNode;
        };
        return {
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeConstantSourceNode = renderedNativeConstantSourceNodes.get(nativeOfflineAudioContext);
                if (renderedNativeConstantSourceNode !== undefined) return Promise.resolve(renderedNativeConstantSourceNode);
                return createConstantSourceNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $9b55f1ea73efe39c$export$540e228106d2c471 = (unit32Array)=>{
    return (value)=>{
        unit32Array[0] = value;
        return unit32Array[0];
    };
};


const $841973333d0cd390$var$DEFAULT_OPTIONS = {
    buffer: null,
    channelCount: 2,
    channelCountMode: "clamped-max",
    channelInterpretation: "speakers",
    disableNormalization: false
};
const $841973333d0cd390$export$4894173a4b4ee485 = (audioNodeConstructor, createConvolverNodeRenderer, createNativeConvolverNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class ConvolverNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$841973333d0cd390$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeConvolverNode = createNativeConvolverNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const convolverNodeRenderer = isOffline ? createConvolverNodeRenderer() : null;
            super(context, false, nativeConvolverNode, convolverNodeRenderer);
            this._isBufferNullified = false;
            this._nativeConvolverNode = nativeConvolverNode;
            if (mergedOptions.buffer !== null) setAudioNodeTailTime(this, mergedOptions.buffer.duration);
        }
        get buffer() {
            if (this._isBufferNullified) return null;
            return this._nativeConvolverNode.buffer;
        }
        set buffer(value) {
            this._nativeConvolverNode.buffer = value;
            // Bug #115: Safari does not allow to set the buffer to null.
            if (value === null && this._nativeConvolverNode.buffer !== null) {
                const nativeContext = this._nativeConvolverNode.context;
                this._nativeConvolverNode.buffer = nativeContext.createBuffer(1, 1, nativeContext.sampleRate);
                this._isBufferNullified = true;
                setAudioNodeTailTime(this, 0);
            } else {
                this._isBufferNullified = false;
                setAudioNodeTailTime(this, this._nativeConvolverNode.buffer === null ? 0 : this._nativeConvolverNode.buffer.duration);
            }
        }
        get normalize() {
            return this._nativeConvolverNode.normalize;
        }
        set normalize(value) {
            this._nativeConvolverNode.normalize = value;
        }
    };
};




const $8432906c3c9b8cbf$export$5b278ccdb1a6393 = (createNativeConvolverNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeConvolverNodes = new WeakMap();
        const createConvolverNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeConvolverNode = getNativeAudioNode(proxy);
            // If the initially used nativeConvolverNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeConvolverNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeConvolverNode, nativeOfflineAudioContext);
            if (!nativeConvolverNodeIsOwnedByContext) {
                const options = {
                    buffer: nativeConvolverNode.buffer,
                    channelCount: nativeConvolverNode.channelCount,
                    channelCountMode: nativeConvolverNode.channelCountMode,
                    channelInterpretation: nativeConvolverNode.channelInterpretation,
                    disableNormalization: !nativeConvolverNode.normalize
                };
                nativeConvolverNode = createNativeConvolverNode(nativeOfflineAudioContext, options);
            }
            renderedNativeConvolverNodes.set(nativeOfflineAudioContext, nativeConvolverNode);
            if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeConvolverNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConvolverNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConvolverNode);
            return nativeConvolverNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeConvolverNode = renderedNativeConvolverNodes.get(nativeOfflineAudioContext);
                if (renderedNativeConvolverNode !== undefined) return Promise.resolve(renderedNativeConvolverNode);
                return createConvolverNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $b7a1d74149a5d9bf$export$ab44e304a31eb0ae = (createNotSupportedError, nativeOfflineAudioContextConstructor)=>{
    return (numberOfChannels, length, sampleRate)=>{
        if (nativeOfflineAudioContextConstructor === null) throw new Error("Missing the native OfflineAudioContext constructor.");
        try {
            return new nativeOfflineAudioContextConstructor(numberOfChannels, length, sampleRate);
        } catch (err) {
            // Bug #143, #144 & #146: Safari throws a SyntaxError when numberOfChannels, length or sampleRate are invalid.
            if (err.name === "SyntaxError") throw createNotSupportedError();
            throw err;
        }
    };
};


const $c9e239e1d431cf9c$export$fc1a599a84ca01a8 = ()=>new DOMException("", "DataCloneError");


const $a6bb0e541b432a5c$export$2d33e41548107ad3 = (arrayBuffer)=>{
    const { port1: port1, port2: port2 } = new MessageChannel();
    return new Promise((resolve)=>{
        const closeAndResolve = ()=>{
            port2.onmessage = null;
            port1.close();
            port2.close();
            resolve();
        };
        port2.onmessage = ()=>closeAndResolve();
        try {
            port1.postMessage(arrayBuffer, [
                arrayBuffer
            ]);
        } catch  {
        // Ignore errors.
        } finally{
            closeAndResolve();
        }
    });
};



const $9c7b16fbc9ba5a0d$export$d83e4a6039bccfb = (audioBufferStore, cacheTestResult, createDataCloneError, createEncodingError, detachedArrayBuffers, getNativeContext, isNativeContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, testPromiseSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    return (anyContext, audioData)=>{
        const nativeContext = isNativeContext(anyContext) ? anyContext : getNativeContext(anyContext);
        // Bug #43: Only Chrome and Edge do throw a DataCloneError.
        if (detachedArrayBuffers.has(audioData)) {
            const err = createDataCloneError();
            return Promise.reject(err);
        }
        // The audioData parameter maybe of a type which can't be added to a WeakSet.
        try {
            detachedArrayBuffers.add(audioData);
        } catch  {
        // Ignore errors.
        }
        // Bug #21: Safari does not support promises yet.
        if (cacheTestResult(testPromiseSupport, ()=>testPromiseSupport(nativeContext))) return nativeContext.decodeAudioData(audioData).then((audioBuffer)=>{
            // Bug #133: Safari does neuter the ArrayBuffer.
            (0, $a6bb0e541b432a5c$export$2d33e41548107ad3)(audioData).catch(()=>{
            // Ignore errors.
            });
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, ()=>testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            return audioBuffer;
        });
        // Bug #21: Safari does not return a Promise yet.
        return new Promise((resolve, reject)=>{
            const complete = async ()=>{
                // Bug #133: Safari does neuter the ArrayBuffer.
                try {
                    await (0, $a6bb0e541b432a5c$export$2d33e41548107ad3)(audioData);
                } catch  {
                // Ignore errors.
                }
            };
            const fail = (err)=>{
                reject(err);
                complete();
            };
            // Bug #26: Safari throws a synchronous error.
            try {
                // Bug #1: Safari requires a successCallback.
                nativeContext.decodeAudioData(audioData, (audioBuffer)=>{
                    // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
                    // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
                    if (typeof audioBuffer.copyFromChannel !== "function") {
                        wrapAudioBufferCopyChannelMethods(audioBuffer);
                        (0, $e0def92b41d2ffa5$export$df65309cf6249598)(audioBuffer);
                    }
                    audioBufferStore.add(audioBuffer);
                    complete().then(()=>resolve(audioBuffer));
                }, (err)=>{
                    // Bug #4: Safari returns null instead of an error.
                    if (err === null) fail(createEncodingError());
                    else fail(err);
                });
            } catch (err) {
                fail(err);
            }
        });
    };
};



const $c348d8459649177f$export$93f58f9268fde9f6 = (connectNativeAudioNodeToNativeAudioNode, cycleCounters, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, getNativeContext, isActiveAudioNode, isNativeOfflineAudioContext)=>{
    return (audioNode, count)=>{
        const cycleCounter = cycleCounters.get(audioNode);
        if (cycleCounter === undefined) throw new Error("Missing the expected cycle count.");
        const nativeContext = getNativeContext(audioNode.context);
        const isOffline = isNativeOfflineAudioContext(nativeContext);
        if (cycleCounter === count) {
            cycleCounters.delete(audioNode);
            if (!isOffline && isActiveAudioNode(audioNode)) {
                const nativeSourceAudioNode = getNativeAudioNode(audioNode);
                const { outputs: outputs } = getAudioNodeConnections(audioNode);
                for (const output of outputs)if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(output)) {
                    const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                    connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
                } else {
                    const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                    nativeSourceAudioNode.connect(nativeDestinationAudioParam, output[1]);
                }
            }
        } else cycleCounters.set(audioNode, cycleCounter - count);
    };
};


const $8e78583293513642$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers",
    delayTime: 0,
    maxDelayTime: 1
};
const $8e78583293513642$export$b89a0215c1c607e3 = (audioNodeConstructor, createAudioParam, createDelayNodeRenderer, createNativeDelayNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class DelayNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$8e78583293513642$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeDelayNode = createNativeDelayNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const delayNodeRenderer = isOffline ? createDelayNodeRenderer(mergedOptions.maxDelayTime) : null;
            super(context, false, nativeDelayNode, delayNodeRenderer);
            this._delayTime = createAudioParam(this, isOffline, nativeDelayNode.delayTime);
            setAudioNodeTailTime(this, mergedOptions.maxDelayTime);
        }
        get delayTime() {
            return this._delayTime;
        }
    };
};



const $f2c53e2a23d66a37$export$d03c2308083a28e5 = (connectAudioParam, createNativeDelayNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return (maxDelayTime)=>{
        const renderedNativeDelayNodes = new WeakMap();
        const createDelayNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeDelayNode = getNativeAudioNode(proxy);
            // If the initially used nativeDelayNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeDelayNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeDelayNode, nativeOfflineAudioContext);
            if (!nativeDelayNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeDelayNode.channelCount,
                    channelCountMode: nativeDelayNode.channelCountMode,
                    channelInterpretation: nativeDelayNode.channelInterpretation,
                    delayTime: nativeDelayNode.delayTime.value,
                    maxDelayTime: maxDelayTime
                };
                nativeDelayNode = createNativeDelayNode(nativeOfflineAudioContext, options);
            }
            renderedNativeDelayNodes.set(nativeOfflineAudioContext, nativeDelayNode);
            if (!nativeDelayNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.delayTime, nativeDelayNode.delayTime);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.delayTime, nativeDelayNode.delayTime);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDelayNode);
            return nativeDelayNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeDelayNode = renderedNativeDelayNodes.get(nativeOfflineAudioContext);
                if (renderedNativeDelayNode !== undefined) return Promise.resolve(renderedNativeDelayNode);
                return createDelayNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $e39a769fcfed862a$export$1f7c0152b9e322ae = (pickElementFromSet)=>{
    return (activeInputs, source, output, input)=>{
        return pickElementFromSet(activeInputs[input], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output);
    };
};


const $aaeabd7f1c2ff532$export$92df121abbf21dca = (getUnrenderedAudioWorkletNodes)=>{
    return (nativeContext, audioWorkletNode)=>{
        getUnrenderedAudioWorkletNodes(nativeContext).delete(audioWorkletNode);
    };
};



const $f41ec01349ffa62e$export$c283d436eafbd9b2 = (audioNode)=>{
    return "delayTime" in audioNode;
};


const $60aaea16e2e167aa$export$b4f8d2824d9887dc = (audioParamAudioNodeStore, getAudioNodeConnections, getValueForKey)=>{
    return function detectCycles(chain, nextLink) {
        const audioNode = (0, $c23aedeecc2b6162$export$85cd8e93eb858e81)(nextLink) ? nextLink : getValueForKey(audioParamAudioNodeStore, nextLink);
        if ((0, $f41ec01349ffa62e$export$c283d436eafbd9b2)(audioNode)) return [];
        if (chain[0] === audioNode) return [
            chain
        ];
        if (chain.includes(audioNode)) return [];
        const { outputs: outputs } = getAudioNodeConnections(audioNode);
        return Array.from(outputs).map((outputConnection)=>detectCycles([
                ...chain,
                audioNode
            ], outputConnection[0])).reduce((mergedCycles, nestedCycles)=>mergedCycles.concat(nestedCycles), []);
    };
};



const $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex = (createIndexSizeError, outputAudioNodes, output)=>{
    const outputAudioNode = outputAudioNodes[output];
    if (outputAudioNode === undefined) throw createIndexSizeError();
    return outputAudioNode;
};
const $777f7939fea8f1ed$export$78a992fad11cd00e = (createIndexSizeError)=>{
    return (outputAudioNodes, destinationOrOutput, output, input = 0)=>{
        if (destinationOrOutput === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect());
        if (typeof destinationOrOutput === "number") return $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, destinationOrOutput).disconnect();
        if ((0, $02572834e9cacc18$export$d647358384f164e0)(destinationOrOutput)) {
            if (output === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect(destinationOrOutput));
            if (input === undefined) return $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
            return $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0, input);
        }
        if (output === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect(destinationOrOutput));
        return $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
    };
};


const $84171167562b7343$var$DEFAULT_OPTIONS = {
    attack: 0.003,
    channelCount: 2,
    channelCountMode: "clamped-max",
    channelInterpretation: "speakers",
    knee: 30,
    ratio: 12,
    release: 0.25,
    threshold: -24
};
const $84171167562b7343$export$60ec6725c2d45fc8 = (audioNodeConstructor, createAudioParam, createDynamicsCompressorNodeRenderer, createNativeDynamicsCompressorNode, createNotSupportedError, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class DynamicsCompressorNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$84171167562b7343$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const dynamicsCompressorNodeRenderer = isOffline ? createDynamicsCompressorNodeRenderer() : null;
            super(context, false, nativeDynamicsCompressorNode, dynamicsCompressorNodeRenderer);
            this._attack = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.attack);
            this._knee = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.knee);
            this._nativeDynamicsCompressorNode = nativeDynamicsCompressorNode;
            this._ratio = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.ratio);
            this._release = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.release);
            this._threshold = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.threshold);
            setAudioNodeTailTime(this, 0.006);
        }
        get attack() {
            return this._attack;
        }
        // Bug #108: Safari allows a channelCount of three and above which is why the getter and setter needs to be overwritten here.
        get channelCount() {
            return this._nativeDynamicsCompressorNode.channelCount;
        }
        set channelCount(value) {
            const previousChannelCount = this._nativeDynamicsCompressorNode.channelCount;
            this._nativeDynamicsCompressorNode.channelCount = value;
            if (value > 2) {
                this._nativeDynamicsCompressorNode.channelCount = previousChannelCount;
                throw createNotSupportedError();
            }
        }
        /*
         * Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max' yet which is why the getter and setter needs to be
         * overwritten here.
         */ get channelCountMode() {
            return this._nativeDynamicsCompressorNode.channelCountMode;
        }
        set channelCountMode(value) {
            const previousChannelCount = this._nativeDynamicsCompressorNode.channelCountMode;
            this._nativeDynamicsCompressorNode.channelCountMode = value;
            if (value === "max") {
                this._nativeDynamicsCompressorNode.channelCountMode = previousChannelCount;
                throw createNotSupportedError();
            }
        }
        get knee() {
            return this._knee;
        }
        get ratio() {
            return this._ratio;
        }
        get reduction() {
            // Bug #111: Safari returns an AudioParam instead of a number.
            if (typeof this._nativeDynamicsCompressorNode.reduction.value === "number") return this._nativeDynamicsCompressorNode.reduction.value;
            return this._nativeDynamicsCompressorNode.reduction;
        }
        get release() {
            return this._release;
        }
        get threshold() {
            return this._threshold;
        }
    };
};



const $c9213159046e81d8$export$1b1e82cc3f0a2c8 = (connectAudioParam, createNativeDynamicsCompressorNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeDynamicsCompressorNodes = new WeakMap();
        const createDynamicsCompressorNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeDynamicsCompressorNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeDynamicsCompressorNode was not constructed on the same OfflineAudioContext it needs to be
             * created again.
             */ const nativeDynamicsCompressorNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeDynamicsCompressorNode, nativeOfflineAudioContext);
            if (!nativeDynamicsCompressorNodeIsOwnedByContext) {
                const options = {
                    attack: nativeDynamicsCompressorNode.attack.value,
                    channelCount: nativeDynamicsCompressorNode.channelCount,
                    channelCountMode: nativeDynamicsCompressorNode.channelCountMode,
                    channelInterpretation: nativeDynamicsCompressorNode.channelInterpretation,
                    knee: nativeDynamicsCompressorNode.knee.value,
                    ratio: nativeDynamicsCompressorNode.ratio.value,
                    release: nativeDynamicsCompressorNode.release.value,
                    threshold: nativeDynamicsCompressorNode.threshold.value
                };
                nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeOfflineAudioContext, options);
            }
            renderedNativeDynamicsCompressorNodes.set(nativeOfflineAudioContext, nativeDynamicsCompressorNode);
            if (!nativeDynamicsCompressorNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);
                await renderAutomation(nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);
                await renderAutomation(nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);
                await renderAutomation(nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);
                await renderAutomation(nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);
                await connectAudioParam(nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);
                await connectAudioParam(nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);
                await connectAudioParam(nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);
                await connectAudioParam(nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDynamicsCompressorNode);
            return nativeDynamicsCompressorNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeDynamicsCompressorNode = renderedNativeDynamicsCompressorNodes.get(nativeOfflineAudioContext);
                if (renderedNativeDynamicsCompressorNode !== undefined) return Promise.resolve(renderedNativeDynamicsCompressorNode);
                return createDynamicsCompressorNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $d2cc4ba64859d7eb$export$6372d3d9069bc778 = ()=>new DOMException("", "EncodingError");


const $6d1c2f45ab543604$export$43b563d089dd1d8 = (window)=>{
    return (source)=>new Promise((resolve, reject)=>{
            if (window === null) {
                // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
                reject(new SyntaxError());
                return;
            }
            const head = window.document.head;
            if (head === null) // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
            reject(new SyntaxError());
            else {
                const script = window.document.createElement("script");
                // @todo Safari doesn't like URLs with a type of 'application/javascript; charset=utf-8'.
                const blob = new Blob([
                    source
                ], {
                    type: "application/javascript"
                });
                const url = URL.createObjectURL(blob);
                const originalOnErrorHandler = window.onerror;
                const removeErrorEventListenerAndRevokeUrl = ()=>{
                    window.onerror = originalOnErrorHandler;
                    URL.revokeObjectURL(url);
                };
                window.onerror = (message, src, lineno, colno, error)=>{
                    // @todo Edge thinks the source is the one of the html document.
                    if (src === url || src === window.location.href && lineno === 1 && colno === 1) {
                        removeErrorEventListenerAndRevokeUrl();
                        reject(error);
                        return false;
                    }
                    if (originalOnErrorHandler !== null) return originalOnErrorHandler(message, src, lineno, colno, error);
                };
                script.onerror = ()=>{
                    removeErrorEventListenerAndRevokeUrl();
                    // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
                    reject(new SyntaxError());
                };
                script.onload = ()=>{
                    removeErrorEventListenerAndRevokeUrl();
                    resolve();
                };
                script.src = url;
                script.type = "module";
                head.appendChild(script);
            }
        });
};


const $2c6595a0ef043725$export$a512af3fc2ab91f2 = (wrapEventListener)=>{
    return class EventTarget {
        constructor(_nativeEventTarget){
            this._nativeEventTarget = _nativeEventTarget;
            this._listeners = new WeakMap();
        }
        addEventListener(type, listener, options) {
            if (listener !== null) {
                let wrappedEventListener = this._listeners.get(listener);
                if (wrappedEventListener === undefined) {
                    wrappedEventListener = wrapEventListener(this, listener);
                    if (typeof listener === "function") this._listeners.set(listener, wrappedEventListener);
                }
                this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
            }
        }
        dispatchEvent(event) {
            return this._nativeEventTarget.dispatchEvent(event);
        }
        removeEventListener(type, listener, options) {
            const wrappedEventListener = listener === null ? undefined : this._listeners.get(listener);
            this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
        }
    };
};


const $a687388505de094d$export$c43b8ab5e8913cbb = (window)=>{
    return (currentTime, sampleRate, fn)=>{
        Object.defineProperties(window, {
            currentFrame: {
                configurable: true,
                get () {
                    return Math.round(currentTime * sampleRate);
                }
            },
            currentTime: {
                configurable: true,
                get () {
                    return currentTime;
                }
            }
        });
        try {
            return fn();
        } finally{
            if (window !== null) {
                delete window.currentFrame;
                delete window.currentTime;
            }
        }
    };
};


const $0835f0aafb89dee3$export$c7282a393375a8ca = (createAbortError)=>{
    return async (url)=>{
        try {
            const response = await fetch(url);
            if (response.ok) return [
                await response.text(),
                response.url
            ];
        } catch  {
        // Ignore errors.
        } // tslint:disable-line:no-empty
        throw createAbortError();
    };
};



const $98e2667480721d0b$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers",
    gain: 1
};
const $98e2667480721d0b$export$7b37b693b55bf5d7 = (audioNodeConstructor, createAudioParam, createGainNodeRenderer, createNativeGainNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class GainNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$98e2667480721d0b$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeGainNode = createNativeGainNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const gainNodeRenderer = isOffline ? createGainNodeRenderer() : null;
            super(context, false, nativeGainNode, gainNodeRenderer);
            // Bug #74: Safari does not export the correct values for maxValue and minValue.
            this._gain = createAudioParam(this, isOffline, nativeGainNode.gain, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
        }
        get gain() {
            return this._gain;
        }
    };
};



const $49cb70513208922e$export$7312404e5bea9cd = (connectAudioParam, createNativeGainNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeGainNodes = new WeakMap();
        const createGainNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeGainNode = getNativeAudioNode(proxy);
            // If the initially used nativeGainNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeGainNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeGainNode, nativeOfflineAudioContext);
            if (!nativeGainNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeGainNode.channelCount,
                    channelCountMode: nativeGainNode.channelCountMode,
                    channelInterpretation: nativeGainNode.channelInterpretation,
                    gain: nativeGainNode.gain.value
                };
                nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, options);
            }
            renderedNativeGainNodes.set(nativeOfflineAudioContext, nativeGainNode);
            if (!nativeGainNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.gain, nativeGainNode.gain);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.gain, nativeGainNode.gain);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeGainNode);
            return nativeGainNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeGainNode = renderedNativeGainNodes.get(nativeOfflineAudioContext);
                if (renderedNativeGainNode !== undefined) return Promise.resolve(renderedNativeGainNode);
                return createGainNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $987f4a38ab3c6a37$export$8b01844840684f8d = (activeAudioWorkletNodeInputsStore, getValueForKey)=>{
    return (nativeAudioWorkletNode)=>getValueForKey(activeAudioWorkletNodeInputsStore, nativeAudioWorkletNode);
};


const $177173849cab3696$export$97bb1acefff8970e = (getAudioNodeConnections)=>{
    return (audioNode)=>{
        const audioNodeConnections = getAudioNodeConnections(audioNode);
        if (audioNodeConnections.renderer === null) throw new Error("Missing the renderer of the given AudioNode in the audio graph.");
        return audioNodeConnections.renderer;
    };
};


const $1c502bf8d77347a3$export$4abc3abd061bc2cc = (audioNodeTailTimeStore)=>{
    return (audioNode)=>{
        var _a;
        return (_a = audioNodeTailTimeStore.get(audioNode)) !== null && _a !== void 0 ? _a : 0;
    };
};


const $3555b7973f69ce40$export$1653dd3e76bcb1b0 = (getAudioParamConnections)=>{
    return (audioParam)=>{
        const audioParamConnections = getAudioParamConnections(audioParam);
        if (audioParamConnections.renderer === null) throw new Error("Missing the renderer of the given AudioParam in the audio graph.");
        return audioParamConnections.renderer;
    };
};


const $27e05528439e83f2$export$afecf147821b5609 = (backupOfflineAudioContextStore)=>{
    return (nativeContext)=>{
        return backupOfflineAudioContextStore.get(nativeContext);
    };
};


const $c4ed5904220d24ef$export$5a1c4cd5830ea09b = ()=>new DOMException("", "InvalidStateError");


const $ab34c55943f983a2$export$797a319a8065fb37 = (contextStore)=>{
    return (context)=>{
        const nativeContext = contextStore.get(context);
        if (nativeContext === undefined) throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
        return nativeContext;
    };
};


const $307a3ed6925bb7b6$export$70df0ae42e1340c8 = (backupOfflineAudioContextStore, nativeOfflineAudioContextConstructor)=>{
    return (nativeContext)=>{
        let backupOfflineAudioContext = backupOfflineAudioContextStore.get(nativeContext);
        if (backupOfflineAudioContext !== undefined) return backupOfflineAudioContext;
        if (nativeOfflineAudioContextConstructor === null) throw new Error("Missing the native OfflineAudioContext constructor.");
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        backupOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        backupOfflineAudioContextStore.set(nativeContext, backupOfflineAudioContext);
        return backupOfflineAudioContext;
    };
};


const $7674436fc406d726$export$43ef7eb1ae3d2f40 = (unrenderedAudioWorkletNodeStore)=>{
    return (nativeContext)=>{
        const unrenderedAudioWorkletNodes = unrenderedAudioWorkletNodeStore.get(nativeContext);
        if (unrenderedAudioWorkletNodes === undefined) throw new Error("The context has no set of AudioWorkletNodes.");
        return unrenderedAudioWorkletNodes;
    };
};


const $480811f16570294f$export$254c536c2ca9b917 = ()=>new DOMException("", "InvalidAccessError");


const $35a124fa8f0bfed5$export$8170ec2d1debbbdd = (nativeIIRFilterNode)=>{
    nativeIIRFilterNode.getFrequencyResponse = ((getFrequencyResponse)=>{
        return (frequencyHz, magResponse, phaseResponse)=>{
            if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw (0, $480811f16570294f$export$254c536c2ca9b917)();
            return getFrequencyResponse.call(nativeIIRFilterNode, frequencyHz, magResponse, phaseResponse);
        };
    })(nativeIIRFilterNode.getFrequencyResponse);
};


const $d8dda65cffc64cac$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers"
};
const $d8dda65cffc64cac$export$a22f1eb785a05608 = (audioNodeConstructor, createNativeIIRFilterNode, createIIRFilterNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class IIRFilterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const mergedOptions = {
                ...$d8dda65cffc64cac$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeIIRFilterNode = createNativeIIRFilterNode(nativeContext, isOffline ? null : context.baseLatency, mergedOptions);
            const iirFilterNodeRenderer = isOffline ? createIIRFilterNodeRenderer(mergedOptions.feedback, mergedOptions.feedforward) : null;
            super(context, false, nativeIIRFilterNode, iirFilterNodeRenderer);
            // Bug #23 & #24: FirefoxDeveloper does not throw an InvalidAccessError.
            // @todo Write a test which allows other browsers to remain unpatched.
            (0, $35a124fa8f0bfed5$export$8170ec2d1debbbdd)(nativeIIRFilterNode);
            this._nativeIIRFilterNode = nativeIIRFilterNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        getFrequencyResponse(frequencyHz, magResponse, phaseResponse) {
            return this._nativeIIRFilterNode.getFrequencyResponse(frequencyHz, magResponse, phaseResponse);
        }
    };
};


// This implementation as shamelessly inspired by source code of
// tslint:disable-next-line:max-line-length
// {@link https://chromium.googlesource.com/chromium/src.git/+/master/third_party/WebKit/Source/platform/audio/IIRFilter.cpp|Chromium's IIRFilter}.
const $753b6e2d7a61817d$export$7fa1177e7d2178dd = (feedback, feedbackLength, feedforward, feedforwardLength, minLength, xBuffer, yBuffer, bufferIndex, bufferLength, input, output)=>{
    const inputLength = input.length;
    let i = bufferIndex;
    for(let j = 0; j < inputLength; j += 1){
        let y = feedforward[0] * input[j];
        for(let k = 1; k < minLength; k += 1){
            const x = i - k & bufferLength - 1; // tslint:disable-line:no-bitwise
            y += feedforward[k] * xBuffer[x];
            y -= feedback[k] * yBuffer[x];
        }
        for(let k = minLength; k < feedforwardLength; k += 1)y += feedforward[k] * xBuffer[i - k & bufferLength - 1]; // tslint:disable-line:no-bitwise
        for(let k = minLength; k < feedbackLength; k += 1)y -= feedback[k] * yBuffer[i - k & bufferLength - 1]; // tslint:disable-line:no-bitwise
        xBuffer[i] = input[j];
        yBuffer[i] = y;
        i = i + 1 & bufferLength - 1; // tslint:disable-line:no-bitwise
        output[j] = y;
    }
    return i;
};



const $5f4b0a4e5f013c82$var$filterFullBuffer = (renderedBuffer, nativeOfflineAudioContext, feedback, feedforward)=>{
    const convertedFeedback = feedback instanceof Float64Array ? feedback : new Float64Array(feedback);
    const convertedFeedforward = feedforward instanceof Float64Array ? feedforward : new Float64Array(feedforward);
    const feedbackLength = convertedFeedback.length;
    const feedforwardLength = convertedFeedforward.length;
    const minLength = Math.min(feedbackLength, feedforwardLength);
    if (convertedFeedback[0] !== 1) {
        for(let i = 0; i < feedbackLength; i += 1)convertedFeedforward[i] /= convertedFeedback[0];
        for(let i = 1; i < feedforwardLength; i += 1)convertedFeedback[i] /= convertedFeedback[0];
    }
    const bufferLength = 32;
    const xBuffer = new Float32Array(bufferLength);
    const yBuffer = new Float32Array(bufferLength);
    const filteredBuffer = nativeOfflineAudioContext.createBuffer(renderedBuffer.numberOfChannels, renderedBuffer.length, renderedBuffer.sampleRate);
    const numberOfChannels = renderedBuffer.numberOfChannels;
    for(let i = 0; i < numberOfChannels; i += 1){
        const input = renderedBuffer.getChannelData(i);
        const output = filteredBuffer.getChannelData(i);
        xBuffer.fill(0);
        yBuffer.fill(0);
        (0, $753b6e2d7a61817d$export$7fa1177e7d2178dd)(convertedFeedback, feedbackLength, convertedFeedforward, feedforwardLength, minLength, xBuffer, yBuffer, 0, bufferLength, input, output);
    }
    return filteredBuffer;
};
const $5f4b0a4e5f013c82$export$329316f0ca6cf17e = (createNativeAudioBufferSourceNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return (feedback, feedforward)=>{
        const renderedNativeAudioNodes = new WeakMap();
        let filteredBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioBufferSourceNode = null;
            let nativeIIRFilterNode = getNativeAudioNode(proxy);
            // If the initially used nativeIIRFilterNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeIIRFilterNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeIIRFilterNode, nativeOfflineAudioContext);
            // Bug #9: Safari does not support IIRFilterNodes.
            if (nativeOfflineAudioContext.createIIRFilter === undefined) nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                buffer: null,
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                loop: false,
                loopEnd: 0,
                loopStart: 0,
                playbackRate: 1
            });
            else if (!nativeIIRFilterNodeIsOwnedByContext) // @todo TypeScript defines the parameters of createIIRFilter() as arrays of numbers.
            nativeIIRFilterNode = nativeOfflineAudioContext.createIIRFilter(feedforward, feedback);
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode === null ? nativeIIRFilterNode : nativeAudioBufferSourceNode);
            if (nativeAudioBufferSourceNode !== null) {
                if (filteredBufferPromise === null) {
                    if (nativeOfflineAudioContextConstructor === null) throw new Error("Missing the native OfflineAudioContext constructor.");
                    const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(// Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                    proxy.context.destination.channelCount, // Bug #17: Safari does not yet expose the length.
                    proxy.context.length, nativeOfflineAudioContext.sampleRate);
                    filteredBufferPromise = (async ()=>{
                        await renderInputsOfAudioNode(proxy, partialOfflineAudioContext, partialOfflineAudioContext.destination);
                        const renderedBuffer = await renderNativeOfflineAudioContext(partialOfflineAudioContext);
                        return $5f4b0a4e5f013c82$var$filterFullBuffer(renderedBuffer, nativeOfflineAudioContext, feedback, feedforward);
                    })();
                }
                const filteredBuffer = await filteredBufferPromise;
                nativeAudioBufferSourceNode.buffer = filteredBuffer;
                nativeAudioBufferSourceNode.start(0);
                return nativeAudioBufferSourceNode;
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeIIRFilterNode);
            return nativeIIRFilterNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};



const $f105592837a72b2d$export$e306a463e9286bbd = (cycleCounters, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, isActiveAudioNode)=>{
    return (isOffline)=>{
        return (audioNode, count)=>{
            const cycleCounter = cycleCounters.get(audioNode);
            if (cycleCounter === undefined) {
                if (!isOffline && isActiveAudioNode(audioNode)) {
                    const nativeSourceAudioNode = getNativeAudioNode(audioNode);
                    const { outputs: outputs } = getAudioNodeConnections(audioNode);
                    for (const output of outputs)if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(output)) {
                        const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                        disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
                    } else {
                        const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                        nativeSourceAudioNode.disconnect(nativeDestinationAudioParam, output[1]);
                    }
                }
                cycleCounters.set(audioNode, count);
            } else cycleCounters.set(audioNode, cycleCounter + count);
        };
    };
};





const $5640f46b23f2ba55$export$7030a6f3318876b = (contextStore, isNativeAudioContext)=>{
    return (anything)=>{
        const nativeContext = contextStore.get(anything);
        return isNativeAudioContext(nativeContext) || isNativeAudioContext(anything);
    };
};


const $a888bda59cc0dc6a$export$150a35c855945f9d = (audioNodeStore, isNativeAudioNode)=>{
    return (anything)=>audioNodeStore.has(anything) || isNativeAudioNode(anything);
};


const $e078436636c3eca1$export$41505fc8888255a0 = (audioParamStore, isNativeAudioParam)=>{
    return (anything)=>audioParamStore.has(anything) || isNativeAudioParam(anything);
};


const $3fc93d78c2927094$export$845691ce8ebc2907 = (contextStore, isNativeOfflineAudioContext)=>{
    return (anything)=>{
        const nativeContext = contextStore.get(anything);
        return isNativeOfflineAudioContext(nativeContext) || isNativeOfflineAudioContext(anything);
    };
};


const $5c37aa119fcb440b$export$5d44272df169092e = (nativeAudioContextConstructor)=>{
    return (anything)=>{
        return nativeAudioContextConstructor !== null && anything instanceof nativeAudioContextConstructor;
    };
};


const $3b617a30f7d7e286$export$96f2bb6e8a5795ea = (window)=>{
    return (anything)=>{
        return window !== null && typeof window.AudioNode === "function" && anything instanceof window.AudioNode;
    };
};


const $3ef59b79efb5ffe7$export$7c3a44537acaf24e = (window)=>{
    return (anything)=>{
        return window !== null && typeof window.AudioParam === "function" && anything instanceof window.AudioParam;
    };
};


const $c44d077ff851f0da$export$a7c969701e5471d0 = (isNativeAudioContext, isNativeOfflineAudioContext)=>{
    return (anything)=>{
        return isNativeAudioContext(anything) || isNativeOfflineAudioContext(anything);
    };
};


const $1f51870159fb4148$export$722bd4bab77df75a = (nativeOfflineAudioContextConstructor)=>{
    return (anything)=>{
        return nativeOfflineAudioContextConstructor !== null && anything instanceof nativeOfflineAudioContextConstructor;
    };
};


const $484b240e3f1f979d$export$2e9a7e6b17a9abae = (window)=>window !== null && window.isSecureContext;


const $c06e9ed236b03490$export$a245ecb43f54c4de = async (cacheTestResult, testAudioBufferCopyChannelMethodsSubarraySupport, testAudioContextCloseMethodSupport, testAudioContextDecodeAudioDataMethodTypeErrorSupport, testAudioContextOptionsSupport, testAudioNodeConnectMethodSupport, testAudioWorkletProcessorNoOutputsSupport, testChannelMergerNodeChannelCountSupport, testConstantSourceNodeAccurateSchedulingSupport, testConvolverNodeBufferReassignabilitySupport, testConvolverNodeChannelCountSupport, testDomExceptionContrucorSupport, testIsSecureContextSupport, testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport, testStereoPannerNodeDefaultValueSupport, testTransferablesSupport)=>{
    if (cacheTestResult(testAudioBufferCopyChannelMethodsSubarraySupport, testAudioBufferCopyChannelMethodsSubarraySupport) && cacheTestResult(testAudioContextCloseMethodSupport, testAudioContextCloseMethodSupport) && cacheTestResult(testAudioContextOptionsSupport, testAudioContextOptionsSupport) && cacheTestResult(testAudioNodeConnectMethodSupport, testAudioNodeConnectMethodSupport) && cacheTestResult(testChannelMergerNodeChannelCountSupport, testChannelMergerNodeChannelCountSupport) && cacheTestResult(testConstantSourceNodeAccurateSchedulingSupport, testConstantSourceNodeAccurateSchedulingSupport) && cacheTestResult(testConvolverNodeBufferReassignabilitySupport, testConvolverNodeBufferReassignabilitySupport) && cacheTestResult(testConvolverNodeChannelCountSupport, testConvolverNodeChannelCountSupport) && cacheTestResult(testDomExceptionContrucorSupport, testDomExceptionContrucorSupport) && cacheTestResult(testIsSecureContextSupport, testIsSecureContextSupport) && cacheTestResult(testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport, testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport)) {
        const results = await Promise.all([
            cacheTestResult(testAudioContextDecodeAudioDataMethodTypeErrorSupport, testAudioContextDecodeAudioDataMethodTypeErrorSupport),
            cacheTestResult(testAudioWorkletProcessorNoOutputsSupport, testAudioWorkletProcessorNoOutputsSupport),
            cacheTestResult(testStereoPannerNodeDefaultValueSupport, testStereoPannerNodeDefaultValueSupport),
            cacheTestResult(testTransferablesSupport, testTransferablesSupport)
        ]);
        return results.every((result)=>result);
    }
    return false;
};


const $5a5644b592df0bad$export$d24d3af0853fd021 = (audioNodeConstructor, createNativeMediaElementAudioSourceNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaElementAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaElementAudioSourceNode = createNativeMediaElementAudioSourceNode(nativeContext, options);
            // Bug #171: Safari allows to create a MediaElementAudioSourceNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw TypeError();
            super(context, true, nativeMediaElementAudioSourceNode, null);
            this._nativeMediaElementAudioSourceNode = nativeMediaElementAudioSourceNode;
        }
        get mediaElement() {
            return this._nativeMediaElementAudioSourceNode.mediaElement;
        }
    };
};


const $f377f0e28dbb751d$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "explicit",
    channelInterpretation: "speakers"
};
const $f377f0e28dbb751d$export$5d3ee2470cd2874 = (audioNodeConstructor, createNativeMediaStreamAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaStreamAudioDestinationNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            // Bug #173: Safari allows to create a MediaStreamAudioDestinationNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw new TypeError();
            const mergedOptions = {
                ...$f377f0e28dbb751d$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeMediaStreamAudioDestinationNode = createNativeMediaStreamAudioDestinationNode(nativeContext, mergedOptions);
            super(context, false, nativeMediaStreamAudioDestinationNode, null);
            this._nativeMediaStreamAudioDestinationNode = nativeMediaStreamAudioDestinationNode;
        }
        get stream() {
            return this._nativeMediaStreamAudioDestinationNode.stream;
        }
    };
};


const $304864b5ea02e52c$export$a42e10687df73a9d = (audioNodeConstructor, createNativeMediaStreamAudioSourceNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaStreamAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaStreamAudioSourceNode = createNativeMediaStreamAudioSourceNode(nativeContext, options);
            // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw new TypeError();
            super(context, true, nativeMediaStreamAudioSourceNode, null);
            this._nativeMediaStreamAudioSourceNode = nativeMediaStreamAudioSourceNode;
        }
        get mediaStream() {
            return this._nativeMediaStreamAudioSourceNode.mediaStream;
        }
    };
};


const $11b69ddc6f63f0f2$export$24f27d34fdf823bc = (audioNodeConstructor, createNativeMediaStreamTrackAudioSourceNode, getNativeContext)=>{
    return class MediaStreamTrackAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaStreamTrackAudioSourceNode = createNativeMediaStreamTrackAudioSourceNode(nativeContext, options);
            super(context, true, nativeMediaStreamTrackAudioSourceNode, null);
        }
    };
};




const $82d2d7cc0da6e790$export$8a5e66f668b2e9e8 = (createInvalidStateError, createNotSupportedError, createUnknownError, minimalBaseAudioContextConstructor, nativeAudioContextConstructor)=>{
    return class MinimalAudioContext extends minimalBaseAudioContextConstructor {
        constructor(options = {}){
            if (nativeAudioContextConstructor === null) throw new Error("Missing the native AudioContext constructor.");
            let nativeAudioContext;
            try {
                nativeAudioContext = new nativeAudioContextConstructor(options);
            } catch (err) {
                // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
                if (err.code === 12 && err.message === "sampleRate is not in range") throw createNotSupportedError();
                throw err;
            }
            // Bug #131 Safari returns null when there are four other AudioContexts running already.
            if (nativeAudioContext === null) throw createUnknownError();
            // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.
            if (!(0, $0cefff6266c0f0f4$export$82d5f0e102842fbe)(options.latencyHint)) throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
            // Bug #150 Safari does not support setting the sampleRate.
            if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) throw createNotSupportedError();
            super(nativeAudioContext, 2);
            const { latencyHint: latencyHint } = options;
            const { sampleRate: sampleRate } = nativeAudioContext;
            // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.
            this._baseLatency = typeof nativeAudioContext.baseLatency === "number" ? nativeAudioContext.baseLatency : latencyHint === "balanced" ? 512 / sampleRate : latencyHint === "interactive" || latencyHint === undefined ? 256 / sampleRate : latencyHint === "playback" ? 1024 / sampleRate : /*
                                   * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
                                   * ScriptProcessorNode.
                                   */ Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
            this._nativeAudioContext = nativeAudioContext;
            // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.
            if (nativeAudioContextConstructor.name === "webkitAudioContext") {
                this._nativeGainNode = nativeAudioContext.createGain();
                this._nativeOscillatorNode = nativeAudioContext.createOscillator();
                this._nativeGainNode.gain.value = 1e-37;
                this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);
                this._nativeOscillatorNode.start();
            } else {
                this._nativeGainNode = null;
                this._nativeOscillatorNode = null;
            }
            this._state = null;
            /*
             * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
             * to 'running'.
             */ if (nativeAudioContext.state === "running") {
                this._state = "suspended";
                const revokeState = ()=>{
                    if (this._state === "suspended") this._state = null;
                    nativeAudioContext.removeEventListener("statechange", revokeState);
                };
                nativeAudioContext.addEventListener("statechange", revokeState);
            }
        }
        get baseLatency() {
            return this._baseLatency;
        }
        get state() {
            return this._state !== null ? this._state : this._nativeAudioContext.state;
        }
        close() {
            // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
            if (this.state === "closed") return this._nativeAudioContext.close().then(()=>{
                throw createInvalidStateError();
            });
            // Bug #34: If the state was set to suspended before it should be revoked now.
            if (this._state === "suspended") this._state = null;
            return this._nativeAudioContext.close().then(()=>{
                if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
                    this._nativeOscillatorNode.stop();
                    this._nativeGainNode.disconnect();
                    this._nativeOscillatorNode.disconnect();
                }
                (0, $6d385241f7fab45a$export$cbd606bc629ea938)(this);
            });
        }
        resume() {
            if (this._state === "suspended") return new Promise((resolve, reject)=>{
                const resolvePromise = ()=>{
                    this._nativeAudioContext.removeEventListener("statechange", resolvePromise);
                    if (this._nativeAudioContext.state === "running") resolve();
                    else this.resume().then(resolve, reject);
                };
                this._nativeAudioContext.addEventListener("statechange", resolvePromise);
            });
            return this._nativeAudioContext.resume().catch((err)=>{
                // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined || err.code === 15) throw createInvalidStateError();
                throw err;
            });
        }
        suspend() {
            return this._nativeAudioContext.suspend().catch((err)=>{
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined) throw createInvalidStateError();
                throw err;
            });
        }
    };
};



const $487edb0432cdd783$export$3f49d9c870ba2692 = (audioDestinationNodeConstructor, createAudioListener, eventTargetConstructor, isNativeOfflineAudioContext, unrenderedAudioWorkletNodeStore, wrapEventListener)=>{
    return class MinimalBaseAudioContext extends eventTargetConstructor {
        constructor(_nativeContext, numberOfChannels){
            super(_nativeContext);
            this._nativeContext = _nativeContext;
            (0, $7718e734b2fef711$export$7d17302229276f06).set(this, _nativeContext);
            if (isNativeOfflineAudioContext(_nativeContext)) unrenderedAudioWorkletNodeStore.set(_nativeContext, new Set());
            this._destination = new audioDestinationNodeConstructor(this, numberOfChannels);
            this._listener = createAudioListener(this, _nativeContext);
            this._onstatechange = null;
        }
        get currentTime() {
            return this._nativeContext.currentTime;
        }
        get destination() {
            return this._destination;
        }
        get listener() {
            return this._listener;
        }
        get onstatechange() {
            return this._onstatechange;
        }
        set onstatechange(value) {
            const wrappedListener = typeof value === "function" ? wrapEventListener(this, value) : null;
            this._nativeContext.onstatechange = wrappedListener;
            const nativeOnStateChange = this._nativeContext.onstatechange;
            this._onstatechange = nativeOnStateChange !== null && nativeOnStateChange === wrappedListener ? value : nativeOnStateChange;
        }
        get sampleRate() {
            return this._nativeContext.sampleRate;
        }
        get state() {
            return this._nativeContext.state;
        }
    };
};



const $4590a073dac74a1e$export$9ec44223b1284cd4 = (nativeContext)=>{
    // This 12 numbers represent the 48 bytes of an empty WAVE file with a single sample.
    const uint32Array = new Uint32Array([
        1179011410,
        40,
        1163280727,
        544501094,
        16,
        131073,
        44100,
        176400,
        1048580,
        1635017060,
        4,
        0
    ]);
    try {
        // Bug #1: Safari requires a successCallback.
        const promise = nativeContext.decodeAudioData(uint32Array.buffer, ()=>{
        // Ignore the success callback.
        });
        if (promise === undefined) return false;
        promise.catch(()=>{
        // Ignore rejected errors.
        });
        return true;
    } catch  {
    // Ignore errors.
    }
    return false;
};


const $c34e943c39218d26$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $c34e943c39218d26$export$3d487af37fe7f521 = (cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, minimalBaseAudioContextConstructor, startRendering)=>{
    return class MinimalOfflineAudioContext extends minimalBaseAudioContextConstructor {
        constructor(options){
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$c34e943c39218d26$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
            // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
            if (!cacheTestResult((0, $4590a073dac74a1e$export$9ec44223b1284cd4), ()=>(0, $4590a073dac74a1e$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) nativeOfflineAudioContext.addEventListener("statechange", (()=>{
                let i = 0;
                const delayStateChangeEvent = (event)=>{
                    if (this._state === "running") {
                        if (i > 0) {
                            nativeOfflineAudioContext.removeEventListener("statechange", delayStateChangeEvent);
                            event.stopImmediatePropagation();
                            this._waitForThePromiseToSettle(event);
                        } else i += 1;
                    }
                };
                return delayStateChangeEvent;
            })());
            super(nativeOfflineAudioContext, numberOfChannels);
            this._length = length;
            this._nativeOfflineAudioContext = nativeOfflineAudioContext;
            this._state = null;
        }
        get length() {
            // Bug #17: Safari does not yet expose the length.
            if (this._nativeOfflineAudioContext.length === undefined) return this._length;
            return this._nativeOfflineAudioContext.length;
        }
        get state() {
            return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
        }
        startRendering() {
            /*
             * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
             * the state of the nativeOfflineAudioContext might no transition to running immediately.
             */ if (this._state === "running") return Promise.reject(createInvalidStateError());
            this._state = "running";
            return startRendering(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                this._state = null;
                (0, $6d385241f7fab45a$export$cbd606bc629ea938)(this);
            });
        }
        _waitForThePromiseToSettle(event) {
            if (this._state === null) this._nativeOfflineAudioContext.dispatchEvent(event);
            else setTimeout(()=>this._waitForThePromiseToSettle(event));
        }
    };
};


const $0c25af19b608275a$export$9f33b5a0b80f2717 = (insertElementInSet, isNativeAudioNode)=>{
    return (nativeAudioNode, whenConnected, whenDisconnected)=>{
        const connections = new Set();
        nativeAudioNode.connect = ((connect)=>{
            // tslint:disable-next-line:invalid-void no-inferrable-types
            return (destination, output = 0, input = 0)=>{
                const wasDisconnected = connections.size === 0;
                if (isNativeAudioNode(destination)) {
                    // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
                    connect.call(nativeAudioNode, destination, output, input);
                    insertElementInSet(connections, [
                        destination,
                        output,
                        input
                    ], (connection)=>connection[0] === destination && connection[1] === output && connection[2] === input, true);
                    if (wasDisconnected) whenConnected();
                    return destination;
                }
                connect.call(nativeAudioNode, destination, output);
                insertElementInSet(connections, [
                    destination,
                    output
                ], (connection)=>connection[0] === destination && connection[1] === output, true);
                if (wasDisconnected) whenConnected();
                return;
            };
        })(nativeAudioNode.connect);
        nativeAudioNode.disconnect = ((disconnect)=>{
            return (destinationOrOutput, output, input)=>{
                const wasConnected = connections.size > 0;
                if (destinationOrOutput === undefined) {
                    disconnect.apply(nativeAudioNode);
                    connections.clear();
                } else if (typeof destinationOrOutput === "number") {
                    // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput);
                    for (const connection of connections)if (connection[1] === destinationOrOutput) connections.delete(connection);
                } else {
                    if (isNativeAudioNode(destinationOrOutput)) // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput, output, input);
                    else // @todo TypeScript cannot infer the overloaded signature with 2 arguments yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput, output);
                    for (const connection of connections)if (connection[0] === destinationOrOutput && (output === undefined || connection[1] === output) && (input === undefined || connection[2] === input)) connections.delete(connection);
                }
                const isDisconnected = connections.size === 0;
                if (wasConnected && isDisconnected) whenDisconnected();
            };
        })(nativeAudioNode.disconnect);
        return nativeAudioNode;
    };
};


const $5eef3820deef0b72$export$26855c8d5a8f5839 = (nativeAudioNode, options, option)=>{
    const value = options[option];
    if (value !== undefined && value !== nativeAudioNode[option]) nativeAudioNode[option] = value;
};



const $acf0ae0814028a1b$export$a741a487b656b6ff = (nativeAudioNode, options)=>{
    (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioNode, options, "channelCount");
    (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioNode, options, "channelCountMode");
    (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioNode, options, "channelInterpretation");
};


const $ed9d2653a13b0c96$export$1cb15f891b4f5e5e = (nativeAnalyserNode)=>{
    return typeof nativeAnalyserNode.getFloatTimeDomainData === "function";
};


const $9bda2230e35c9ca6$export$df32660d042dab2e = (nativeAnalyserNode)=>{
    nativeAnalyserNode.getFloatTimeDomainData = (array)=>{
        const byteTimeDomainData = new Uint8Array(array.length);
        nativeAnalyserNode.getByteTimeDomainData(byteTimeDomainData);
        const length = Math.max(byteTimeDomainData.length, nativeAnalyserNode.fftSize);
        for(let i = 0; i < length; i += 1)array[i] = (byteTimeDomainData[i] - 128) * 0.0078125;
        return array;
    };
};


const $e8efe05ceea76e6b$export$36e704ad7c903a26 = (cacheTestResult, createIndexSizeError)=>{
    return (nativeContext, options)=>{
        const nativeAnalyserNode = nativeContext.createAnalyser();
        // Bug #37: Firefox does not create an AnalyserNode with the default properties.
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeAnalyserNode, options);
        // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
        if (!(options.maxDecibels > options.minDecibels)) throw createIndexSizeError();
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAnalyserNode, options, "fftSize");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAnalyserNode, options, "maxDecibels");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAnalyserNode, options, "minDecibels");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAnalyserNode, options, "smoothingTimeConstant");
        // Bug #36: Safari does not support getFloatTimeDomainData() yet.
        if (!cacheTestResult((0, $ed9d2653a13b0c96$export$1cb15f891b4f5e5e), ()=>(0, $ed9d2653a13b0c96$export$1cb15f891b4f5e5e)(nativeAnalyserNode))) (0, $9bda2230e35c9ca6$export$df32660d042dab2e)(nativeAnalyserNode);
        return nativeAnalyserNode;
    };
};


const $3fdc510d024142a6$export$1ddb6a79e564be96 = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty("AudioBuffer")) return window.AudioBuffer;
    return null;
};


const $ae111b58c598e4e4$export$4778de978774ec4f = (nativeAudioNode, options, audioParam)=>{
    const value = options[audioParam];
    if (value !== undefined && value !== nativeAudioNode[audioParam].value) nativeAudioNode[audioParam].value = value;
};





const $6ca747e8d28a6d93$export$6b4321a414ed55c5 = (nativeAudioBufferSourceNode)=>{
    nativeAudioBufferSourceNode.start = ((start)=>{
        let isScheduled = false;
        return (when = 0, offset = 0, duration)=>{
            if (isScheduled) throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
            start.call(nativeAudioBufferSourceNode, when, offset, duration);
            isScheduled = true;
        };
    })(nativeAudioBufferSourceNode.start);
};


const $e3342623b0c84b77$export$987b3a4087e6578c = (nativeAudioScheduledSourceNode)=>{
    nativeAudioScheduledSourceNode.start = ((start)=>{
        return (when = 0, offset = 0, duration)=>{
            if (typeof duration === "number" && duration < 0 || offset < 0 || when < 0) throw new RangeError("The parameters can't be negative.");
            // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
            start.call(nativeAudioScheduledSourceNode, when, offset, duration);
        };
    })(nativeAudioScheduledSourceNode.start);
};


const $ecb767d214ace196$export$7adf5b1e83aad45 = (nativeAudioScheduledSourceNode)=>{
    nativeAudioScheduledSourceNode.stop = ((stop)=>{
        return (when = 0)=>{
            if (when < 0) throw new RangeError("The parameter can't be negative.");
            stop.call(nativeAudioScheduledSourceNode, when);
        };
    })(nativeAudioScheduledSourceNode.stop);
};


const $fed0da5959484c32$export$4f48c993f264b207 = (addSilentConnection, cacheTestResult, testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, testAudioBufferSourceNodeStartMethodOffsetClampingSupport, testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioBufferSourceNodeStartMethodOffsetClampling, wrapAudioBufferSourceNodeStopMethodNullifiedBuffer, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls)=>{
    return (nativeContext, options)=>{
        const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeAudioBufferSourceNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeAudioBufferSourceNode, options, "playbackRate");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, "buffer");
        // Bug #149: Safari does not yet support the detune AudioParam.
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, "loop");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, "loopEnd");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, "loopStart");
        // Bug #69: Safari does allow calls to start() of an already scheduled AudioBufferSourceNode.
        if (!cacheTestResult(testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, ()=>testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport(nativeContext))) (0, $6ca747e8d28a6d93$export$6b4321a414ed55c5)(nativeAudioBufferSourceNode);
        // Bug #154 & #155: Safari does not handle offsets which are equal to or greater than the duration of the buffer.
        if (!cacheTestResult(testAudioBufferSourceNodeStartMethodOffsetClampingSupport, ()=>testAudioBufferSourceNodeStartMethodOffsetClampingSupport(nativeContext))) wrapAudioBufferSourceNodeStartMethodOffsetClampling(nativeAudioBufferSourceNode);
        // Bug #162: Safari does throw an error when stop() is called on an AudioBufferSourceNode which has no buffer assigned to it.
        if (!cacheTestResult(testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, ()=>testAudioBufferSourceNodeStopMethodNullifiedBufferSupport(nativeContext))) wrapAudioBufferSourceNodeStopMethodNullifiedBuffer(nativeAudioBufferSourceNode, nativeContext);
        // Bug #44: Safari does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $e3342623b0c84b77$export$987b3a4087e6578c)(nativeAudioBufferSourceNode);
        // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, ()=>testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeAudioBufferSourceNode, nativeContext);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $ecb767d214ace196$export$7adf5b1e83aad45)(nativeAudioBufferSourceNode);
        // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.
        addSilentConnection(nativeContext, nativeAudioBufferSourceNode);
        return nativeAudioBufferSourceNode;
    };
};


const $efc1676639ecd3f0$export$3a22fc4046f7b4ec = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty("AudioContext")) return window.AudioContext;
    return window.hasOwnProperty("webkitAudioContext") ? window.webkitAudioContext : null;
};


const $a12f35f127b69772$export$d3097038f258fce = (createNativeGainNode, overwriteAccessors)=>{
    return (nativeContext, channelCount, isNodeOfNativeOfflineAudioContext)=>{
        const nativeAudioDestinationNode = nativeContext.destination;
        // Bug #132: Safari does not have the correct channelCount.
        if (nativeAudioDestinationNode.channelCount !== channelCount) try {
            nativeAudioDestinationNode.channelCount = channelCount;
        } catch  {
        // Bug #169: Safari throws an error on each attempt to change the channelCount.
        }
        // Bug #83: Safari does not have the correct channelCountMode.
        if (isNodeOfNativeOfflineAudioContext && nativeAudioDestinationNode.channelCountMode !== "explicit") nativeAudioDestinationNode.channelCountMode = "explicit";
        // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
        if (nativeAudioDestinationNode.maxChannelCount === 0) Object.defineProperty(nativeAudioDestinationNode, "maxChannelCount", {
            value: channelCount
        });
        // Bug #168: No browser does yet have an AudioDestinationNode with an output.
        const gainNode = createNativeGainNode(nativeContext, {
            channelCount: channelCount,
            channelCountMode: nativeAudioDestinationNode.channelCountMode,
            channelInterpretation: nativeAudioDestinationNode.channelInterpretation,
            gain: 1
        });
        overwriteAccessors(gainNode, "channelCount", (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                try {
                    nativeAudioDestinationNode.channelCount = value;
                } catch (err) {
                    // Bug #169: Safari throws an error on each attempt to change the channelCount.
                    if (value > nativeAudioDestinationNode.maxChannelCount) throw err;
                }
            });
        overwriteAccessors(gainNode, "channelCountMode", (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                nativeAudioDestinationNode.channelCountMode = value;
            });
        overwriteAccessors(gainNode, "channelInterpretation", (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                nativeAudioDestinationNode.channelInterpretation = value;
            });
        Object.defineProperty(gainNode, "maxChannelCount", {
            get: ()=>nativeAudioDestinationNode.maxChannelCount
        });
        // @todo This should be disconnected when the context is closed.
        gainNode.connect(nativeAudioDestinationNode);
        return gainNode;
    };
};


const $8a58495112d71adf$export$b0ef4818c07d1453 = (window)=>{
    if (window === null) return null;
    return window.hasOwnProperty("AudioWorkletNode") ? window.AudioWorkletNode : null;
};


const $6cddc0f2f0dd9ae1$export$8bad4bda0c154746 = (audioWorkletNodeOptions)=>{
    const { port1: port1 } = new MessageChannel();
    try {
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port1.postMessage(audioWorkletNodeOptions);
    } finally{
        port1.close();
    }
};


const $81c404ba25d71de5$export$a6399b47836cd044 = (createInvalidStateError, createNativeAudioWorkletNodeFaker, createNativeGainNode, createNotSupportedError, monitorConnections)=>{
    return (nativeContext, baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, options)=>{
        if (nativeAudioWorkletNodeConstructor !== null) try {
            const nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeContext, name, options);
            const patchedEventListeners = new Map();
            let onprocessorerror = null;
            Object.defineProperties(nativeAudioWorkletNode, {
                /*
                     * Bug #61: Overwriting the property accessors for channelCount and channelCountMode is necessary as long as some
                     * browsers have no native implementation to achieve a consistent behavior.
                     */ channelCount: {
                    get: ()=>options.channelCount,
                    set: ()=>{
                        throw createInvalidStateError();
                    }
                },
                channelCountMode: {
                    get: ()=>"explicit",
                    set: ()=>{
                        throw createInvalidStateError();
                    }
                },
                // Bug #156: Chrome and Edge do not yet fire an ErrorEvent.
                onprocessorerror: {
                    get: ()=>onprocessorerror,
                    set: (value)=>{
                        if (typeof onprocessorerror === "function") nativeAudioWorkletNode.removeEventListener("processorerror", onprocessorerror);
                        onprocessorerror = typeof value === "function" ? value : null;
                        if (typeof onprocessorerror === "function") nativeAudioWorkletNode.addEventListener("processorerror", onprocessorerror);
                    }
                }
            });
            nativeAudioWorkletNode.addEventListener = ((addEventListener)=>{
                return (...args)=>{
                    if (args[0] === "processorerror") {
                        const unpatchedEventListener = typeof args[1] === "function" ? args[1] : typeof args[1] === "object" && args[1] !== null && typeof args[1].handleEvent === "function" ? args[1].handleEvent : null;
                        if (unpatchedEventListener !== null) {
                            const patchedEventListener = patchedEventListeners.get(args[1]);
                            if (patchedEventListener !== undefined) args[1] = patchedEventListener;
                            else {
                                args[1] = (event)=>{
                                    // Bug #178: Chrome and Edge do fire an event of type error.
                                    if (event.type === "error") {
                                        Object.defineProperties(event, {
                                            type: {
                                                value: "processorerror"
                                            }
                                        });
                                        unpatchedEventListener(event);
                                    } else unpatchedEventListener(new ErrorEvent(args[0], {
                                        ...event
                                    }));
                                };
                                patchedEventListeners.set(unpatchedEventListener, args[1]);
                            }
                        }
                    }
                    // Bug #178: Chrome and Edge do fire an event of type error.
                    addEventListener.call(nativeAudioWorkletNode, "error", args[1], args[2]);
                    return addEventListener.call(nativeAudioWorkletNode, ...args);
                };
            })(nativeAudioWorkletNode.addEventListener);
            nativeAudioWorkletNode.removeEventListener = ((removeEventListener)=>{
                return (...args)=>{
                    if (args[0] === "processorerror") {
                        const patchedEventListener = patchedEventListeners.get(args[1]);
                        if (patchedEventListener !== undefined) {
                            patchedEventListeners.delete(args[1]);
                            args[1] = patchedEventListener;
                        }
                    }
                    // Bug #178: Chrome and Edge do fire an event of type error.
                    removeEventListener.call(nativeAudioWorkletNode, "error", args[1], args[2]);
                    return removeEventListener.call(nativeAudioWorkletNode, args[0], args[1], args[2]);
                };
            })(nativeAudioWorkletNode.removeEventListener);
            /*
                 * Bug #86: Chrome and Edge do not invoke the process() function if the corresponding AudioWorkletNode is unconnected but
                 * has an output.
                 */ if (options.numberOfOutputs !== 0) {
                const nativeGainNode = createNativeGainNode(nativeContext, {
                    channelCount: 1,
                    channelCountMode: "explicit",
                    channelInterpretation: "discrete",
                    gain: 0
                });
                nativeAudioWorkletNode.connect(nativeGainNode).connect(nativeContext.destination);
                const whenConnected = ()=>nativeGainNode.disconnect();
                const whenDisconnected = ()=>nativeGainNode.connect(nativeContext.destination);
                // @todo Disconnect the connection when the process() function of the AudioWorkletNode returns false.
                return monitorConnections(nativeAudioWorkletNode, whenConnected, whenDisconnected);
            }
            return nativeAudioWorkletNode;
        } catch (err) {
            // Bug #60: Chrome & Edge throw an InvalidStateError instead of a NotSupportedError.
            if (err.code === 11) throw createNotSupportedError();
            throw err;
        }
        // Bug #61: Only Chrome & Edge have an implementation of the AudioWorkletNode yet.
        if (processorConstructor === undefined) throw createNotSupportedError();
        (0, $6cddc0f2f0dd9ae1$export$8bad4bda0c154746)(options);
        return createNativeAudioWorkletNodeFaker(nativeContext, baseLatency, processorConstructor, options);
    };
};



const $0470d07e32bfb928$export$c3c4ba87244c2bf4 = (baseLatency, sampleRate)=>{
    if (baseLatency === null) return 512;
    return Math.max(512, Math.min(16384, Math.pow(2, Math.round(Math.log2(baseLatency * sampleRate)))));
};





const $d3f33c86ba7c9d01$export$45f6aa3433a4eb0 = (audioWorkletNodeOptions)=>{
    return new Promise((resolve, reject)=>{
        const { port1: port1, port2: port2 } = new MessageChannel();
        port1.onmessage = ({ data: data })=>{
            port1.close();
            port2.close();
            resolve(data);
        };
        port1.onmessageerror = ({ data: data })=>{
            port1.close();
            port2.close();
            reject(data);
        };
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port2.postMessage(audioWorkletNodeOptions);
    });
};


const $5c252bbd462fc1fc$export$62410a657c3adf1d = async (processorConstructor, audioWorkletNodeOptions)=>{
    const clonedAudioWorkletNodeOptions = await (0, $d3f33c86ba7c9d01$export$45f6aa3433a4eb0)(audioWorkletNodeOptions);
    return new processorConstructor(clonedAudioWorkletNodeOptions);
};


const $b8276153f51079e2$export$5200a42feb14a7b7 = (nativeContext, nativeAudioWorkletNode, processorConstructor, audioWorkletNodeOptions)=>{
    let nodeToProcessorMap = (0, $7718e734b2fef711$export$16d7878f7e059d67).get(nativeContext);
    if (nodeToProcessorMap === undefined) {
        nodeToProcessorMap = new WeakMap();
        (0, $7718e734b2fef711$export$16d7878f7e059d67).set(nativeContext, nodeToProcessorMap);
    }
    const audioWorkletProcessorPromise = (0, $5c252bbd462fc1fc$export$62410a657c3adf1d)(processorConstructor, audioWorkletNodeOptions);
    nodeToProcessorMap.set(nativeAudioWorkletNode, audioWorkletProcessorPromise);
    return audioWorkletProcessorPromise;
};




const $d96ad3d348a8f882$export$ea40f9f600f0adcb = (connectMultipleOutputs, createIndexSizeError, createInvalidStateError, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, createNativeScriptProcessorNode, createNotSupportedError, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getActiveAudioWorkletNodeInputs, monitorConnections)=>{
    return (nativeContext, baseLatency, processorConstructor, options)=>{
        if (options.numberOfInputs === 0 && options.numberOfOutputs === 0) throw createNotSupportedError();
        const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount);
        // @todo Check if any of the channelCount values is greater than the implementation's maximum number of channels.
        if (outputChannelCount.some((channelCount)=>channelCount < 1)) throw createNotSupportedError();
        if (outputChannelCount.length !== options.numberOfOutputs) throw createIndexSizeError();
        // Bug #61: This is not part of the standard but required for the faker to work.
        if (options.channelCountMode !== "explicit") throw createNotSupportedError();
        const numberOfInputChannels = options.channelCount * options.numberOfInputs;
        const numberOfOutputChannels = outputChannelCount.reduce((sum, value1)=>sum + value1, 0);
        const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
        // Bug #61: This is not part of the standard but required for the faker to work.
        if (numberOfInputChannels + numberOfParameters > 6 || numberOfOutputChannels > 6) throw createNotSupportedError();
        const messageChannel = new MessageChannel();
        const gainNodes = [];
        const inputChannelSplitterNodes = [];
        for(let i = 0; i < options.numberOfInputs; i += 1){
            gainNodes.push(createNativeGainNode(nativeContext, {
                channelCount: options.channelCount,
                channelCountMode: options.channelCountMode,
                channelInterpretation: options.channelInterpretation,
                gain: 1
            }));
            inputChannelSplitterNodes.push(createNativeChannelSplitterNode(nativeContext, {
                channelCount: options.channelCount,
                channelCountMode: "explicit",
                channelInterpretation: "discrete",
                numberOfOutputs: options.channelCount
            }));
        }
        const constantSourceNodes = [];
        if (processorConstructor.parameterDescriptors !== undefined) for (const { defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, name: name } of processorConstructor.parameterDescriptors){
            const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
                channelCount: 1,
                channelCountMode: "explicit",
                channelInterpretation: "discrete",
                offset: options.parameterData[name] !== undefined ? options.parameterData[name] : defaultValue === undefined ? 0 : defaultValue
            });
            Object.defineProperties(constantSourceNode.offset, {
                defaultValue: {
                    get: ()=>defaultValue === undefined ? 0 : defaultValue
                },
                maxValue: {
                    get: ()=>maxValue === undefined ? (0, $c205d95559d496ba$export$ab43bedd17d6a167) : maxValue
                },
                minValue: {
                    get: ()=>minValue === undefined ? (0, $c205d95559d496ba$export$ced6a5c63b103b52) : minValue
                }
            });
            constantSourceNodes.push(constantSourceNode);
        }
        const inputChannelMergerNode = createNativeChannelMergerNode(nativeContext, {
            channelCount: 1,
            channelCountMode: "explicit",
            channelInterpretation: "speakers",
            numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
        });
        const bufferSize = (0, $0470d07e32bfb928$export$c3c4ba87244c2bf4)(baseLatency, nativeContext.sampleRate);
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, numberOfInputChannels + numberOfParameters, // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
        Math.max(1, numberOfOutputChannels));
        const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
            channelCount: Math.max(1, numberOfOutputChannels),
            channelCountMode: "explicit",
            channelInterpretation: "discrete",
            numberOfOutputs: Math.max(1, numberOfOutputChannels)
        });
        const outputChannelMergerNodes = [];
        for(let i = 0; i < options.numberOfOutputs; i += 1)outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeContext, {
            channelCount: 1,
            channelCountMode: "explicit",
            channelInterpretation: "speakers",
            numberOfInputs: outputChannelCount[i]
        }));
        for(let i = 0; i < options.numberOfInputs; i += 1){
            gainNodes[i].connect(inputChannelSplitterNodes[i]);
            for(let j = 0; j < options.channelCount; j += 1)inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
        }
        const parameterMap = new (0, $cb5c13986ebfa770$export$5da0cf80a3ca75d6)(processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.map(({ name: name }, index)=>{
            const constantSourceNode = constantSourceNodes[index];
            constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
            constantSourceNode.start(0);
            return [
                name,
                constantSourceNode.offset
            ];
        }));
        inputChannelMergerNode.connect(scriptProcessorNode);
        let channelInterpretation = options.channelInterpretation;
        let onprocessorerror = null;
        // Bug #87: Expose at least one output to make this node connectable.
        const outputAudioNodes = options.numberOfOutputs === 0 ? [
            scriptProcessorNode
        ] : outputChannelMergerNodes;
        const nativeAudioWorkletNodeFaker = {
            get bufferSize () {
                return bufferSize;
            },
            get channelCount () {
                return options.channelCount;
            },
            set channelCount (_){
                // Bug #61: This is not part of the standard but required for the faker to work.
                throw createInvalidStateError();
            },
            get channelCountMode () {
                return options.channelCountMode;
            },
            set channelCountMode (_){
                // Bug #61: This is not part of the standard but required for the faker to work.
                throw createInvalidStateError();
            },
            get channelInterpretation () {
                return channelInterpretation;
            },
            set channelInterpretation (value){
                for (const gainNode of gainNodes)gainNode.channelInterpretation = value;
                channelInterpretation = value;
            },
            get context () {
                return scriptProcessorNode.context;
            },
            get inputs () {
                return gainNodes;
            },
            get numberOfInputs () {
                return options.numberOfInputs;
            },
            get numberOfOutputs () {
                return options.numberOfOutputs;
            },
            get onprocessorerror () {
                return onprocessorerror;
            },
            set onprocessorerror (value){
                if (typeof onprocessorerror === "function") nativeAudioWorkletNodeFaker.removeEventListener("processorerror", onprocessorerror);
                onprocessorerror = typeof value === "function" ? value : null;
                if (typeof onprocessorerror === "function") nativeAudioWorkletNodeFaker.addEventListener("processorerror", onprocessorerror);
            },
            get parameters () {
                return parameterMap;
            },
            get port () {
                return messageChannel.port2;
            },
            addEventListener (...args) {
                return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
            },
            connect: connectMultipleOutputs.bind(null, outputAudioNodes),
            disconnect: disconnectMultipleOutputs.bind(null, outputAudioNodes),
            dispatchEvent (...args) {
                return scriptProcessorNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        const patchedEventListeners = new Map();
        messageChannel.port1.addEventListener = ((addEventListener)=>{
            return (...args)=>{
                if (args[0] === "message") {
                    const unpatchedEventListener = typeof args[1] === "function" ? args[1] : typeof args[1] === "object" && args[1] !== null && typeof args[1].handleEvent === "function" ? args[1].handleEvent : null;
                    if (unpatchedEventListener !== null) {
                        const patchedEventListener = patchedEventListeners.get(args[1]);
                        if (patchedEventListener !== undefined) args[1] = patchedEventListener;
                        else {
                            args[1] = (event)=>{
                                exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, ()=>unpatchedEventListener(event));
                            };
                            patchedEventListeners.set(unpatchedEventListener, args[1]);
                        }
                    }
                }
                return addEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
            };
        })(messageChannel.port1.addEventListener);
        messageChannel.port1.removeEventListener = ((removeEventListener)=>{
            return (...args)=>{
                if (args[0] === "message") {
                    const patchedEventListener = patchedEventListeners.get(args[1]);
                    if (patchedEventListener !== undefined) {
                        patchedEventListeners.delete(args[1]);
                        args[1] = patchedEventListener;
                    }
                }
                return removeEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
            };
        })(messageChannel.port1.removeEventListener);
        let onmessage = null;
        Object.defineProperty(messageChannel.port1, "onmessage", {
            get: ()=>onmessage,
            set: (value1)=>{
                if (typeof onmessage === "function") messageChannel.port1.removeEventListener("message", onmessage);
                onmessage = typeof value1 === "function" ? value1 : null;
                if (typeof onmessage === "function") {
                    messageChannel.port1.addEventListener("message", onmessage);
                    messageChannel.port1.start();
                }
            }
        });
        processorConstructor.prototype.port = messageChannel.port1;
        let audioWorkletProcessor = null;
        const audioWorkletProcessorPromise = (0, $b8276153f51079e2$export$5200a42feb14a7b7)(nativeContext, nativeAudioWorkletNodeFaker, processorConstructor, options);
        audioWorkletProcessorPromise.then((dWrkltPrcssr)=>audioWorkletProcessor = dWrkltPrcssr);
        const inputs = (0, $495c163400b6fc08$export$495a31436d188d6d)(options.numberOfInputs, options.channelCount);
        const outputs = (0, $495c163400b6fc08$export$495a31436d188d6d)(options.numberOfOutputs, outputChannelCount);
        const parameters = processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.reduce((prmtrs, { name: name })=>({
                ...prmtrs,
                [name]: new Float32Array(128)
            }), {});
        let isActive = true;
        const disconnectOutputsGraph = ()=>{
            if (options.numberOfOutputs > 0) scriptProcessorNode.disconnect(outputChannelSplitterNode);
            for(let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1){
                const outputChannelMergerNode = outputChannelMergerNodes[i];
                for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.disconnect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                outputChannelSplitterNodeOutput += outputChannelCount[i];
            }
        };
        const activeInputIndexes = new Map();
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer, outputBuffer: outputBuffer })=>{
            if (audioWorkletProcessor !== null) {
                const activeInputs = getActiveAudioWorkletNodeInputs(nativeAudioWorkletNodeFaker);
                for(let i = 0; i < bufferSize; i += 128){
                    for(let j = 0; j < options.numberOfInputs; j += 1)for(let k = 0; k < options.channelCount; k += 1)(0, $824a78f49a5e02c5$export$e3c6e435bf217093)(inputBuffer, inputs[j], k, k, i);
                    if (processorConstructor.parameterDescriptors !== undefined) processorConstructor.parameterDescriptors.forEach(({ name: name }, index)=>{
                        (0, $824a78f49a5e02c5$export$e3c6e435bf217093)(inputBuffer, parameters, name, numberOfInputChannels + index, i);
                    });
                    for(let j = 0; j < options.numberOfInputs; j += 1){
                        for(let k = 0; k < outputChannelCount[j]; k += 1)// The byteLength will be 0 when the ArrayBuffer was transferred.
                        if (outputs[j][k].byteLength === 0) outputs[j][k] = new Float32Array(128);
                    }
                    try {
                        const potentiallyEmptyInputs = inputs.map((input, index)=>{
                            const activeInput = activeInputs[index];
                            if (activeInput.size > 0) {
                                activeInputIndexes.set(index, bufferSize / 128);
                                return input;
                            }
                            const count = activeInputIndexes.get(index);
                            if (count === undefined) return [];
                            if (input.every((channelData)=>channelData.every((sample)=>sample === 0))) {
                                if (count === 1) activeInputIndexes.delete(index);
                                else activeInputIndexes.set(index, count - 1);
                            }
                            return input;
                        });
                        const activeSourceFlag = exposeCurrentFrameAndCurrentTime(nativeContext.currentTime + i / nativeContext.sampleRate, nativeContext.sampleRate, ()=>audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
                        isActive = activeSourceFlag;
                        for(let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1){
                            for(let k = 0; k < outputChannelCount[j]; k += 1)(0, $b17c809f1f01ce66$export$6bb6d131144bd753)(outputBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
                            outputChannelSplitterNodeOutput += outputChannelCount[j];
                        }
                    } catch (error) {
                        isActive = false;
                        nativeAudioWorkletNodeFaker.dispatchEvent(new ErrorEvent("processorerror", {
                            colno: error.colno,
                            filename: error.filename,
                            lineno: error.lineno,
                            message: error.message
                        }));
                    }
                    if (!isActive) {
                        for(let j = 0; j < options.numberOfInputs; j += 1){
                            gainNodes[j].disconnect(inputChannelSplitterNodes[j]);
                            for(let k = 0; k < options.channelCount; k += 1)inputChannelSplitterNodes[i].disconnect(inputChannelMergerNode, k, j * options.channelCount + k);
                        }
                        if (processorConstructor.parameterDescriptors !== undefined) {
                            const length = processorConstructor.parameterDescriptors.length;
                            for(let j = 0; j < length; j += 1){
                                const constantSourceNode = constantSourceNodes[j];
                                constantSourceNode.disconnect(inputChannelMergerNode, 0, numberOfInputChannels + j);
                                constantSourceNode.stop();
                            }
                        }
                        inputChannelMergerNode.disconnect(scriptProcessorNode);
                        scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation
                        if (isConnected) disconnectOutputsGraph();
                        else disconnectFakeGraph();
                        break;
                    }
                }
            }
        };
        let isConnected = false;
        // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
        const nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: "explicit",
            channelInterpretation: "discrete",
            gain: 0
        });
        const connectFakeGraph = ()=>scriptProcessorNode.connect(nativeGainNode).connect(nativeContext.destination);
        const disconnectFakeGraph = ()=>{
            scriptProcessorNode.disconnect(nativeGainNode);
            nativeGainNode.disconnect();
        };
        const whenConnected = ()=>{
            if (isActive) {
                disconnectFakeGraph();
                if (options.numberOfOutputs > 0) scriptProcessorNode.connect(outputChannelSplitterNode);
                for(let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1){
                    const outputChannelMergerNode = outputChannelMergerNodes[i];
                    for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                    outputChannelSplitterNodeOutput += outputChannelCount[i];
                }
            }
            isConnected = true;
        };
        const whenDisconnected = ()=>{
            if (isActive) {
                connectFakeGraph();
                disconnectOutputsGraph();
            }
            isConnected = false;
        };
        connectFakeGraph();
        return monitorConnections(nativeAudioWorkletNodeFaker, whenConnected, whenDisconnected);
    };
};





const $e80fde9dac479cbc$export$97e69c8dbd260f85 = (nativeContext, options)=>{
    const nativeBiquadFilterNode = nativeContext.createBiquadFilter();
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeBiquadFilterNode, options);
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeBiquadFilterNode, options, "Q");
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeBiquadFilterNode, options, "detune");
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeBiquadFilterNode, options, "frequency");
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeBiquadFilterNode, options, "gain");
    (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeBiquadFilterNode, options, "type");
    return nativeBiquadFilterNode;
};



const $2a5d9150f87cc567$export$99fe194415d94151 = (nativeAudioContextConstructor, wrapChannelMergerNode)=>{
    return (nativeContext, options)=>{
        const nativeChannelMergerNode = nativeContext.createChannelMerger(options.numberOfInputs);
        /*
         * Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
         * the webkitAudioContext is used as a workaround here.
         */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === "webkitAudioContext") wrapChannelMergerNode(nativeContext, nativeChannelMergerNode);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeChannelMergerNode, options);
        return nativeChannelMergerNode;
    };
};




const $ab180d1796a6eb7a$export$62f6b3ab91fa4589 = (channelSplitterNode)=>{
    const channelCount = channelSplitterNode.numberOfOutputs;
    // Bug #97: Safari does not throw an error when attempting to change the channelCount to something other than its initial value.
    Object.defineProperty(channelSplitterNode, "channelCount", {
        get: ()=>channelCount,
        set: (value)=>{
            if (value !== channelCount) throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
        }
    });
    // Bug #30: Safari does not throw an error when attempting to change the channelCountMode to something other than explicit.
    Object.defineProperty(channelSplitterNode, "channelCountMode", {
        get: ()=>"explicit",
        set: (value)=>{
            if (value !== "explicit") throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
        }
    });
    // Bug #32: Safari does not throw an error when attempting to change the channelInterpretation to something other than discrete.
    Object.defineProperty(channelSplitterNode, "channelInterpretation", {
        get: ()=>"discrete",
        set: (value)=>{
            if (value !== "discrete") throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
        }
    });
};


const $fb7eeefbad4e691e$export$17649533bf213707 = (nativeContext, options)=>{
    const nativeChannelSplitterNode = nativeContext.createChannelSplitter(options.numberOfOutputs);
    // Bug #96: Safari does not have the correct channelCount.
    // Bug #29: Safari does not have the correct channelCountMode.
    // Bug #31: Safari does not have the correct channelInterpretation.
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeChannelSplitterNode, options);
    // Bug #29, #30, #31, #32, #96 & #97: Only Chrome, Edge & Firefox partially support the spec yet.
    (0, $ab180d1796a6eb7a$export$62f6b3ab91fa4589)(nativeChannelSplitterNode);
    return nativeChannelSplitterNode;
};






const $cc19291652c95d8b$export$2dd44f7bb3dd8089 = (addSilentConnection, cacheTestResult, createNativeConstantSourceNodeFaker, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport)=>{
    return (nativeContext, options)=>{
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeContext.createConstantSource === undefined) return createNativeConstantSourceNodeFaker(nativeContext, options);
        const nativeConstantSourceNode = nativeContext.createConstantSource();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeConstantSourceNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeConstantSourceNode, options, "offset");
        // Bug #44: Safari does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $e3342623b0c84b77$export$987b3a4087e6578c)(nativeConstantSourceNode);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $ecb767d214ace196$export$7adf5b1e83aad45)(nativeConstantSourceNode);
        // Bug #175: Safari will not fire an ended event if the ConstantSourceNode is unconnected.
        addSilentConnection(nativeContext, nativeConstantSourceNode);
        return nativeConstantSourceNode;
    };
};


const $a05c6395c19a176f$export$19c8a106f82dff14 = (original, interceptor)=>{
    original.connect = interceptor.connect.bind(interceptor);
    original.disconnect = interceptor.disconnect.bind(interceptor);
    return original;
};


const $7750b35622dacdb4$export$360749cf3d02285a = (addSilentConnection, createNativeAudioBufferSourceNode, createNativeGainNode, monitorConnections)=>{
    return (nativeContext, { offset: offset, ...audioNodeOptions })=>{
        const audioBuffer = nativeContext.createBuffer(1, 2, 44100);
        const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
            buffer: null,
            channelCount: 2,
            channelCountMode: "max",
            channelInterpretation: "speakers",
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            playbackRate: 1
        });
        const gainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: offset
        });
        // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        const channelData = audioBuffer.getChannelData(0);
        // Bug #95: Safari does not play or loop one sample buffers.
        channelData[0] = 1;
        channelData[1] = 1;
        audioBufferSourceNode.buffer = audioBuffer;
        audioBufferSourceNode.loop = true;
        const nativeConstantSourceNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return gainNode.channelCount;
            },
            set channelCount (value){
                gainNode.channelCount = value;
            },
            get channelCountMode () {
                return gainNode.channelCountMode;
            },
            set channelCountMode (value){
                gainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return gainNode.channelInterpretation;
            },
            set channelInterpretation (value){
                gainNode.channelInterpretation = value;
            },
            get context () {
                return gainNode.context;
            },
            get inputs () {
                return [];
            },
            get numberOfInputs () {
                return audioBufferSourceNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return gainNode.numberOfOutputs;
            },
            get offset () {
                return gainNode.gain;
            },
            get onended () {
                return audioBufferSourceNode.onended;
            },
            set onended (value){
                audioBufferSourceNode.onended = value;
            },
            addEventListener (...args) {
                return audioBufferSourceNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return audioBufferSourceNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return audioBufferSourceNode.removeEventListener(args[0], args[1], args[2]);
            },
            start (when = 0) {
                audioBufferSourceNode.start.call(audioBufferSourceNode, when);
            },
            stop (when = 0) {
                audioBufferSourceNode.stop.call(audioBufferSourceNode, when);
            }
        };
        const whenConnected = ()=>audioBufferSourceNode.connect(gainNode);
        const whenDisconnected = ()=>audioBufferSourceNode.disconnect(gainNode);
        // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.
        addSilentConnection(nativeContext, audioBufferSourceNode);
        return monitorConnections((0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeConstantSourceNodeFaker, gainNode), whenConnected, whenDisconnected);
    };
};




const $370e4f21c26d451c$export$afdcf89d13ff62e = (createNotSupportedError, overwriteAccessors)=>{
    return (nativeContext, options)=>{
        const nativeConvolverNode = nativeContext.createConvolver();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeConvolverNode, options);
        // The normalize property needs to be set before setting the buffer.
        if (options.disableNormalization === nativeConvolverNode.normalize) nativeConvolverNode.normalize = !options.disableNormalization;
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeConvolverNode, options, "buffer");
        // Bug #113: Safari does allow to set the channelCount to a value larger than 2.
        if (options.channelCount > 2) throw createNotSupportedError();
        overwriteAccessors(nativeConvolverNode, "channelCount", (get)=>()=>get.call(nativeConvolverNode), (set)=>(value)=>{
                if (value > 2) throw createNotSupportedError();
                return set.call(nativeConvolverNode, value);
            });
        // Bug #114: Safari allows to set the channelCountMode to 'max'.
        if (options.channelCountMode === "max") throw createNotSupportedError();
        overwriteAccessors(nativeConvolverNode, "channelCountMode", (get)=>()=>get.call(nativeConvolverNode), (set)=>(value)=>{
                if (value === "max") throw createNotSupportedError();
                return set.call(nativeConvolverNode, value);
            });
        return nativeConvolverNode;
    };
};




const $ef87939e6b57ab0a$export$f7dd6d407a2109ef = (nativeContext, options)=>{
    const nativeDelayNode = nativeContext.createDelay(options.maxDelayTime);
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeDelayNode, options);
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDelayNode, options, "delayTime");
    return nativeDelayNode;
};




const $3bed81c18206a0fd$export$f19d90a0cd4a2ecc = (createNotSupportedError)=>{
    return (nativeContext, options)=>{
        const nativeDynamicsCompressorNode = nativeContext.createDynamicsCompressor();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeDynamicsCompressorNode, options);
        // Bug #108: Safari allows a channelCount of three and above.
        if (options.channelCount > 2) throw createNotSupportedError();
        // Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max'.
        if (options.channelCountMode === "max") throw createNotSupportedError();
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, "attack");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, "knee");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, "ratio");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, "release");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, "threshold");
        return nativeDynamicsCompressorNode;
    };
};




const $525849e875dd580b$export$7cf909169b9c4d6f = (nativeContext, options)=>{
    const nativeGainNode = nativeContext.createGain();
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeGainNode, options);
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeGainNode, options, "gain");
    return nativeGainNode;
};



const $45205c9bc193dafd$export$3c1aed24ed6efd9d = (createNativeIIRFilterNodeFaker)=>{
    return (nativeContext, baseLatency, options)=>{
        // Bug #9: Safari does not support IIRFilterNodes.
        if (nativeContext.createIIRFilter === undefined) return createNativeIIRFilterNodeFaker(nativeContext, baseLatency, options);
        // @todo TypeScript defines the parameters of createIIRFilter() as arrays of numbers.
        const nativeIIRFilterNode = nativeContext.createIIRFilter(options.feedforward, options.feedback);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeIIRFilterNode, options);
        return nativeIIRFilterNode;
    };
};





function $9c6b76deea631207$var$divide(a, b) {
    const denominator = b[0] * b[0] + b[1] * b[1];
    return [
        (a[0] * b[0] + a[1] * b[1]) / denominator,
        (a[1] * b[0] - a[0] * b[1]) / denominator
    ];
}
function $9c6b76deea631207$var$multiply(a, b) {
    return [
        a[0] * b[0] - a[1] * b[1],
        a[0] * b[1] + a[1] * b[0]
    ];
}
function $9c6b76deea631207$var$evaluatePolynomial(coefficient, z) {
    let result = [
        0,
        0
    ];
    for(let i = coefficient.length - 1; i >= 0; i -= 1){
        result = $9c6b76deea631207$var$multiply(result, z);
        result[0] += coefficient[i];
    }
    return result;
}
const $9c6b76deea631207$export$49dca6a724f463b = (createInvalidAccessError, createInvalidStateError, createNativeScriptProcessorNode, createNotSupportedError)=>{
    return (nativeContext, baseLatency, { channelCount: channelCount, channelCountMode: channelCountMode, channelInterpretation: channelInterpretation, feedback: feedback, feedforward: feedforward })=>{
        const bufferSize = (0, $0470d07e32bfb928$export$c3c4ba87244c2bf4)(baseLatency, nativeContext.sampleRate);
        const convertedFeedback = feedback instanceof Float64Array ? feedback : new Float64Array(feedback);
        const convertedFeedforward = feedforward instanceof Float64Array ? feedforward : new Float64Array(feedforward);
        const feedbackLength = convertedFeedback.length;
        const feedforwardLength = convertedFeedforward.length;
        const minLength = Math.min(feedbackLength, feedforwardLength);
        if (feedbackLength === 0 || feedbackLength > 20) throw createNotSupportedError();
        if (convertedFeedback[0] === 0) throw createInvalidStateError();
        if (feedforwardLength === 0 || feedforwardLength > 20) throw createNotSupportedError();
        if (convertedFeedforward[0] === 0) throw createInvalidStateError();
        if (convertedFeedback[0] !== 1) {
            for(let i = 0; i < feedforwardLength; i += 1)convertedFeedforward[i] /= convertedFeedback[0];
            for(let i = 1; i < feedbackLength; i += 1)convertedFeedback[i] /= convertedFeedback[0];
        }
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, channelCount, channelCount);
        scriptProcessorNode.channelCount = channelCount;
        scriptProcessorNode.channelCountMode = channelCountMode;
        scriptProcessorNode.channelInterpretation = channelInterpretation;
        const bufferLength = 32;
        const bufferIndexes = [];
        const xBuffers = [];
        const yBuffers = [];
        for(let i = 0; i < channelCount; i += 1){
            bufferIndexes.push(0);
            const xBuffer = new Float32Array(bufferLength);
            const yBuffer = new Float32Array(bufferLength);
            xBuffer.fill(0);
            yBuffer.fill(0);
            xBuffers.push(xBuffer);
            yBuffers.push(yBuffer);
        }
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = (event)=>{
            const inputBuffer = event.inputBuffer;
            const outputBuffer = event.outputBuffer;
            const numberOfChannels = inputBuffer.numberOfChannels;
            for(let i = 0; i < numberOfChannels; i += 1){
                const input = inputBuffer.getChannelData(i);
                const output = outputBuffer.getChannelData(i);
                bufferIndexes[i] = (0, $753b6e2d7a61817d$export$7fa1177e7d2178dd)(convertedFeedback, feedbackLength, convertedFeedforward, feedforwardLength, minLength, xBuffers[i], yBuffers[i], bufferIndexes[i], bufferLength, input, output);
            }
        };
        const nyquist = nativeContext.sampleRate / 2;
        const nativeIIRFilterNodeFaker = {
            get bufferSize () {
                return bufferSize;
            },
            get channelCount () {
                return scriptProcessorNode.channelCount;
            },
            set channelCount (value){
                scriptProcessorNode.channelCount = value;
            },
            get channelCountMode () {
                return scriptProcessorNode.channelCountMode;
            },
            set channelCountMode (value){
                scriptProcessorNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return scriptProcessorNode.channelInterpretation;
            },
            set channelInterpretation (value){
                scriptProcessorNode.channelInterpretation = value;
            },
            get context () {
                return scriptProcessorNode.context;
            },
            get inputs () {
                return [
                    scriptProcessorNode
                ];
            },
            get numberOfInputs () {
                return scriptProcessorNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return scriptProcessorNode.numberOfOutputs;
            },
            addEventListener (...args) {
                // @todo Dissallow adding an audioprocess listener.
                return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return scriptProcessorNode.dispatchEvent(args[0]);
            },
            getFrequencyResponse (frequencyHz, magResponse, phaseResponse) {
                if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw createInvalidAccessError();
                const length = frequencyHz.length;
                for(let i = 0; i < length; i += 1){
                    const omega = -Math.PI * (frequencyHz[i] / nyquist);
                    const z = [
                        Math.cos(omega),
                        Math.sin(omega)
                    ];
                    const numerator = $9c6b76deea631207$var$evaluatePolynomial(convertedFeedforward, z);
                    const denominator = $9c6b76deea631207$var$evaluatePolynomial(convertedFeedback, z);
                    const response = $9c6b76deea631207$var$divide(numerator, denominator);
                    magResponse[i] = Math.sqrt(response[0] * response[0] + response[1] * response[1]);
                    phaseResponse[i] = Math.atan2(response[1], response[0]);
                }
            },
            removeEventListener (...args) {
                return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        return (0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeIIRFilterNodeFaker, scriptProcessorNode);
    };
};


const $d4deb99e9b2af7cd$export$2b1682bf41b4d16b = (nativeAudioContext, options)=>{
    return nativeAudioContext.createMediaElementSource(options.mediaElement);
};



const $94c6adbd7f255efe$export$acb51039efa3405d = (nativeAudioContext, options)=>{
    const nativeMediaStreamAudioDestinationNode = nativeAudioContext.createMediaStreamDestination();
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeMediaStreamAudioDestinationNode, options);
    // Bug #174: Safari does expose a wrong numberOfOutputs.
    if (nativeMediaStreamAudioDestinationNode.numberOfOutputs === 1) Object.defineProperty(nativeMediaStreamAudioDestinationNode, "numberOfOutputs", {
        get: ()=>0
    });
    return nativeMediaStreamAudioDestinationNode;
};


const $b4d28d9c960c771a$export$ad3e497ef44fc577 = (nativeAudioContext, { mediaStream: mediaStream })=>{
    const audioStreamTracks = mediaStream.getAudioTracks();
    /*
     * Bug #151: Safari does not use the audio track as input anymore if it gets removed from the mediaStream after construction.
     * Bug #159: Safari picks the first audio track if the MediaStream has more than one audio track.
     */ audioStreamTracks.sort((a, b)=>a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
    const filteredAudioStreamTracks = audioStreamTracks.slice(0, 1);
    const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(new MediaStream(filteredAudioStreamTracks));
    /*
     * Bug #151 & #159: The given mediaStream gets reconstructed before it gets passed to the native node which is why the accessor needs
     * to be overwritten as it would otherwise expose the reconstructed version.
     */ Object.defineProperty(nativeMediaStreamAudioSourceNode, "mediaStream", {
        value: mediaStream
    });
    return nativeMediaStreamAudioSourceNode;
};


const $0d8737ad5d3f94df$export$87e46bc6eb8ed6ac = (createInvalidStateError, isNativeOfflineAudioContext)=>{
    return (nativeAudioContext, { mediaStreamTrack: mediaStreamTrack })=>{
        // Bug #121: Only Firefox does yet support the MediaStreamTrackAudioSourceNode.
        if (typeof nativeAudioContext.createMediaStreamTrackSource === "function") return nativeAudioContext.createMediaStreamTrackSource(mediaStreamTrack);
        const mediaStream = new MediaStream([
            mediaStreamTrack
        ]);
        const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(mediaStream);
        // Bug #120: Firefox does not throw an error if the mediaStream has no audio track.
        if (mediaStreamTrack.kind !== "audio") throw createInvalidStateError();
        // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.
        if (isNativeOfflineAudioContext(nativeAudioContext)) throw new TypeError();
        return nativeMediaStreamAudioSourceNode;
    };
};


const $19c5a8e8a9bd3d9c$export$e628a2a5fd5b78b9 = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty("OfflineAudioContext")) return window.OfflineAudioContext;
    return window.hasOwnProperty("webkitOfflineAudioContext") ? window.webkitOfflineAudioContext : null;
};







const $138975cc1d22c83a$export$a40e02c218ae01d3 = (addSilentConnection, cacheTestResult, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls)=>{
    return (nativeContext, options)=>{
        const nativeOscillatorNode = nativeContext.createOscillator();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeOscillatorNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeOscillatorNode, options, "detune");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeOscillatorNode, options, "frequency");
        if (options.periodicWave !== undefined) nativeOscillatorNode.setPeriodicWave(options.periodicWave);
        else (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeOscillatorNode, options, "type");
        // Bug #44: Only Chrome & Edge throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $e3342623b0c84b77$export$987b3a4087e6578c)(nativeOscillatorNode);
        // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, ()=>testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeOscillatorNode, nativeContext);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $ecb767d214ace196$export$7adf5b1e83aad45)(nativeOscillatorNode);
        // Bug #175: Safari will not fire an ended event if the OscillatorNode is unconnected.
        addSilentConnection(nativeContext, nativeOscillatorNode);
        return nativeOscillatorNode;
    };
};





const $d34e0e0fbe459c97$export$8e3c89af72a58833 = (createNativePannerNodeFaker)=>{
    return (nativeContext, options)=>{
        const nativePannerNode = nativeContext.createPanner();
        // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.
        if (nativePannerNode.orientationX === undefined) return createNativePannerNodeFaker(nativeContext, options);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativePannerNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, "orientationX");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, "orientationY");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, "orientationZ");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, "positionX");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, "positionY");
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, "positionZ");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, "coneInnerAngle");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, "coneOuterAngle");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, "coneOuterGain");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, "distanceModel");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, "maxDistance");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, "panningModel");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, "refDistance");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, "rolloffFactor");
        return nativePannerNode;
    };
};




const $4d9cae61d16712a4$export$f04468477689c1b4 = (connectNativeAudioNodeToNativeAudioNode, createInvalidStateError, createNativeChannelMergerNode, createNativeGainNode, createNativeScriptProcessorNode, createNativeWaveShaperNode, createNotSupportedError, disconnectNativeAudioNodeFromNativeAudioNode, getFirstSample, monitorConnections)=>{
    return (nativeContext, { coneInnerAngle: coneInnerAngle, coneOuterAngle: coneOuterAngle, coneOuterGain: coneOuterGain, distanceModel: distanceModel, maxDistance: maxDistance, orientationX: orientationX, orientationY: orientationY, orientationZ: orientationZ, panningModel: panningModel, positionX: positionX, positionY: positionY, positionZ: positionZ, refDistance: refDistance, rolloffFactor: rolloffFactor, ...audioNodeOptions })=>{
        const pannerNode = nativeContext.createPanner();
        // Bug #125: Safari does not throw an error yet.
        if (audioNodeOptions.channelCount > 2) throw createNotSupportedError();
        // Bug #126: Safari does not throw an error yet.
        if (audioNodeOptions.channelCountMode === "max") throw createNotSupportedError();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(pannerNode, audioNodeOptions);
        const SINGLE_CHANNEL_OPTIONS = {
            channelCount: 1,
            channelCountMode: "explicit",
            channelInterpretation: "discrete"
        };
        const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            channelInterpretation: "speakers",
            numberOfInputs: 6
        });
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const orientationXGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 1
        });
        const orientationYGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const orientationZGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionXGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionYGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionZGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 6, 1);
        const waveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            curve: new Float32Array([
                1,
                1
            ]),
            oversample: "none"
        });
        let lastOrientation = [
            orientationX,
            orientationY,
            orientationZ
        ];
        let lastPosition = [
            positionX,
            positionY,
            positionZ
        ];
        const buffer = new Float32Array(1);
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer })=>{
            const orientation = [
                getFirstSample(inputBuffer, buffer, 0),
                getFirstSample(inputBuffer, buffer, 1),
                getFirstSample(inputBuffer, buffer, 2)
            ];
            if (orientation.some((value1, index)=>value1 !== lastOrientation[index])) {
                pannerNode.setOrientation(...orientation); // tslint:disable-line:deprecation
                lastOrientation = orientation;
            }
            const positon = [
                getFirstSample(inputBuffer, buffer, 3),
                getFirstSample(inputBuffer, buffer, 4),
                getFirstSample(inputBuffer, buffer, 5)
            ];
            if (positon.some((value1, index)=>value1 !== lastPosition[index])) {
                pannerNode.setPosition(...positon); // tslint:disable-line:deprecation
                lastPosition = positon;
            }
        };
        Object.defineProperty(orientationYGainNode.gain, "defaultValue", {
            get: ()=>0
        });
        Object.defineProperty(orientationZGainNode.gain, "defaultValue", {
            get: ()=>0
        });
        Object.defineProperty(positionXGainNode.gain, "defaultValue", {
            get: ()=>0
        });
        Object.defineProperty(positionYGainNode.gain, "defaultValue", {
            get: ()=>0
        });
        Object.defineProperty(positionZGainNode.gain, "defaultValue", {
            get: ()=>0
        });
        const nativePannerNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return pannerNode.channelCount;
            },
            set channelCount (value){
                // Bug #125: Safari does not throw an error yet.
                if (value > 2) throw createNotSupportedError();
                inputGainNode.channelCount = value;
                pannerNode.channelCount = value;
            },
            get channelCountMode () {
                return pannerNode.channelCountMode;
            },
            set channelCountMode (value){
                // Bug #126: Safari does not throw an error yet.
                if (value === "max") throw createNotSupportedError();
                inputGainNode.channelCountMode = value;
                pannerNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return pannerNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
                pannerNode.channelInterpretation = value;
            },
            get coneInnerAngle () {
                return pannerNode.coneInnerAngle;
            },
            set coneInnerAngle (value){
                pannerNode.coneInnerAngle = value;
            },
            get coneOuterAngle () {
                return pannerNode.coneOuterAngle;
            },
            set coneOuterAngle (value){
                pannerNode.coneOuterAngle = value;
            },
            get coneOuterGain () {
                return pannerNode.coneOuterGain;
            },
            set coneOuterGain (value){
                // Bug #127: Safari does not throw an InvalidStateError yet.
                if (value < 0 || value > 1) throw createInvalidStateError();
                pannerNode.coneOuterGain = value;
            },
            get context () {
                return pannerNode.context;
            },
            get distanceModel () {
                return pannerNode.distanceModel;
            },
            set distanceModel (value){
                pannerNode.distanceModel = value;
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get maxDistance () {
                return pannerNode.maxDistance;
            },
            set maxDistance (value){
                // Bug #128: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.maxDistance = value;
            },
            get numberOfInputs () {
                return pannerNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return pannerNode.numberOfOutputs;
            },
            get orientationX () {
                return orientationXGainNode.gain;
            },
            get orientationY () {
                return orientationYGainNode.gain;
            },
            get orientationZ () {
                return orientationZGainNode.gain;
            },
            get panningModel () {
                return pannerNode.panningModel;
            },
            set panningModel (value){
                pannerNode.panningModel = value;
            },
            get positionX () {
                return positionXGainNode.gain;
            },
            get positionY () {
                return positionYGainNode.gain;
            },
            get positionZ () {
                return positionZGainNode.gain;
            },
            get refDistance () {
                return pannerNode.refDistance;
            },
            set refDistance (value){
                // Bug #129: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.refDistance = value;
            },
            get rolloffFactor () {
                return pannerNode.rolloffFactor;
            },
            set rolloffFactor (value){
                // Bug #130: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.rolloffFactor = value;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        if (coneInnerAngle !== nativePannerNodeFaker.coneInnerAngle) nativePannerNodeFaker.coneInnerAngle = coneInnerAngle;
        if (coneOuterAngle !== nativePannerNodeFaker.coneOuterAngle) nativePannerNodeFaker.coneOuterAngle = coneOuterAngle;
        if (coneOuterGain !== nativePannerNodeFaker.coneOuterGain) nativePannerNodeFaker.coneOuterGain = coneOuterGain;
        if (distanceModel !== nativePannerNodeFaker.distanceModel) nativePannerNodeFaker.distanceModel = distanceModel;
        if (maxDistance !== nativePannerNodeFaker.maxDistance) nativePannerNodeFaker.maxDistance = maxDistance;
        if (orientationX !== nativePannerNodeFaker.orientationX.value) nativePannerNodeFaker.orientationX.value = orientationX;
        if (orientationY !== nativePannerNodeFaker.orientationY.value) nativePannerNodeFaker.orientationY.value = orientationY;
        if (orientationZ !== nativePannerNodeFaker.orientationZ.value) nativePannerNodeFaker.orientationZ.value = orientationZ;
        if (panningModel !== nativePannerNodeFaker.panningModel) nativePannerNodeFaker.panningModel = panningModel;
        if (positionX !== nativePannerNodeFaker.positionX.value) nativePannerNodeFaker.positionX.value = positionX;
        if (positionY !== nativePannerNodeFaker.positionY.value) nativePannerNodeFaker.positionY.value = positionY;
        if (positionZ !== nativePannerNodeFaker.positionZ.value) nativePannerNodeFaker.positionZ.value = positionZ;
        if (refDistance !== nativePannerNodeFaker.refDistance) nativePannerNodeFaker.refDistance = refDistance;
        if (rolloffFactor !== nativePannerNodeFaker.rolloffFactor) nativePannerNodeFaker.rolloffFactor = rolloffFactor;
        if (lastOrientation[0] !== 1 || lastOrientation[1] !== 0 || lastOrientation[2] !== 0) pannerNode.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
        if (lastPosition[0] !== 0 || lastPosition[1] !== 0 || lastPosition[2] !== 0) pannerNode.setPosition(...lastPosition); // tslint:disable-line:deprecation
        const whenConnected = ()=>{
            inputGainNode.connect(pannerNode);
            // Bug #119: Safari does not fully support the WaveShaperNode.
            connectNativeAudioNodeToNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
            waveShaperNode.connect(orientationXGainNode).connect(channelMergerNode, 0, 0);
            waveShaperNode.connect(orientationYGainNode).connect(channelMergerNode, 0, 1);
            waveShaperNode.connect(orientationZGainNode).connect(channelMergerNode, 0, 2);
            waveShaperNode.connect(positionXGainNode).connect(channelMergerNode, 0, 3);
            waveShaperNode.connect(positionYGainNode).connect(channelMergerNode, 0, 4);
            waveShaperNode.connect(positionZGainNode).connect(channelMergerNode, 0, 5);
            channelMergerNode.connect(scriptProcessorNode).connect(nativeContext.destination);
        };
        const whenDisconnected = ()=>{
            inputGainNode.disconnect(pannerNode);
            // Bug #119: Safari does not fully support the WaveShaperNode.
            disconnectNativeAudioNodeFromNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
            waveShaperNode.disconnect(orientationXGainNode);
            orientationXGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(orientationYGainNode);
            orientationYGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(orientationZGainNode);
            orientationZGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionXGainNode);
            positionXGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionYGainNode);
            positionYGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionZGainNode);
            positionZGainNode.disconnect(channelMergerNode);
            channelMergerNode.disconnect(scriptProcessorNode);
            scriptProcessorNode.disconnect(nativeContext.destination);
        };
        return monitorConnections((0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativePannerNodeFaker, pannerNode), whenConnected, whenDisconnected);
    };
};


const $a6ed532ea5998f8a$export$3f519524c23feca0 = (createIndexSizeError)=>{
    return (nativeContext, { disableNormalization: disableNormalization, imag: imag, real: real })=>{
        // Bug #180: Safari does not allow to use ordinary arrays.
        const convertedImag = imag instanceof Float32Array ? imag : new Float32Array(imag);
        const convertedReal = real instanceof Float32Array ? real : new Float32Array(real);
        const nativePeriodicWave = nativeContext.createPeriodicWave(convertedReal, convertedImag, {
            disableNormalization: disableNormalization
        });
        // Bug #181: Safari does not throw an IndexSizeError so far if the given arrays have less than two values.
        if (Array.from(imag).length < 2) throw createIndexSizeError();
        return nativePeriodicWave;
    };
};


const $cb688845d3eca55e$export$9f784f497a6d6acb = (nativeContext, bufferSize, numberOfInputChannels, numberOfOutputChannels)=>{
    return nativeContext.createScriptProcessor(bufferSize, numberOfInputChannels, numberOfOutputChannels); // tslint:disable-line deprecation
};




const $e0e74a050611c4ea$export$247580dcf7d2f2c4 = (createNativeStereoPannerNodeFaker, createNotSupportedError)=>{
    return (nativeContext, options)=>{
        const channelCountMode = options.channelCountMode;
        /*
         * Bug #105: The channelCountMode of 'clamped-max' should be supported. However it is not possible to write a polyfill for Safari
         * which supports it and therefore it can't be supported at all.
         */ if (channelCountMode === "clamped-max") throw createNotSupportedError();
        // Bug #105: Safari does not support the StereoPannerNode.
        if (nativeContext.createStereoPanner === undefined) return createNativeStereoPannerNodeFaker(nativeContext, options);
        const nativeStereoPannerNode = nativeContext.createStereoPanner();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeStereoPannerNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeStereoPannerNode, options, "pan");
        /*
         * Bug #105: The channelCountMode of 'clamped-max' should be supported. However it is not possible to write a polyfill for Safari
         * which supports it and therefore it can't be supported at all.
         */ Object.defineProperty(nativeStereoPannerNode, "channelCountMode", {
            get: ()=>channelCountMode,
            set: (value)=>{
                if (value !== channelCountMode) throw createNotSupportedError();
            }
        });
        return nativeStereoPannerNode;
    };
};



const $ea55b90e6ec12a54$export$5fe2a787c06b2d34 = (createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeGainNode, createNativeWaveShaperNode, createNotSupportedError, monitorConnections)=>{
    // The curve has a size of 14bit plus 1 value to have an exact representation for zero. This value has been determined experimentally.
    const CURVE_SIZE = 16385;
    const DC_CURVE = new Float32Array([
        1,
        1
    ]);
    const HALF_PI = Math.PI / 2;
    const SINGLE_CHANNEL_OPTIONS = {
        channelCount: 1,
        channelCountMode: "explicit",
        channelInterpretation: "discrete"
    };
    const SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS = {
        ...SINGLE_CHANNEL_OPTIONS,
        oversample: "none"
    };
    const buildInternalGraphForMono = (nativeContext, inputGainNode, panGainNode, channelMergerNode)=>{
        const leftWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightWaveShaperCurve = new Float32Array(CURVE_SIZE);
        for(let i = 0; i < CURVE_SIZE; i += 1){
            const x = i / (CURVE_SIZE - 1) * HALF_PI;
            leftWaveShaperCurve[i] = Math.cos(x);
            rightWaveShaperCurve[i] = Math.sin(x);
        }
        const leftGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftWaveShaperCurve
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const panWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: DC_CURVE
        });
        const rightGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightWaveShaperCurve
        });
        return {
            connectGraph () {
                inputGainNode.connect(leftGainNode);
                inputGainNode.connect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                inputGainNode.connect(rightGainNode);
                panWaveShaperNode.connect(panGainNode);
                panGainNode.connect(leftWaveShaperNode.inputs === undefined ? leftWaveShaperNode : leftWaveShaperNode.inputs[0]);
                panGainNode.connect(rightWaveShaperNode.inputs === undefined ? rightWaveShaperNode : rightWaveShaperNode.inputs[0]);
                leftWaveShaperNode.connect(leftGainNode.gain);
                rightWaveShaperNode.connect(rightGainNode.gain);
                leftGainNode.connect(channelMergerNode, 0, 0);
                rightGainNode.connect(channelMergerNode, 0, 1);
            },
            disconnectGraph () {
                inputGainNode.disconnect(leftGainNode);
                inputGainNode.disconnect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                inputGainNode.disconnect(rightGainNode);
                panWaveShaperNode.disconnect(panGainNode);
                panGainNode.disconnect(leftWaveShaperNode.inputs === undefined ? leftWaveShaperNode : leftWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightWaveShaperNode.inputs === undefined ? rightWaveShaperNode : rightWaveShaperNode.inputs[0]);
                leftWaveShaperNode.disconnect(leftGainNode.gain);
                rightWaveShaperNode.disconnect(rightGainNode.gain);
                leftGainNode.disconnect(channelMergerNode, 0, 0);
                rightGainNode.disconnect(channelMergerNode, 0, 1);
            }
        };
    };
    const buildInternalGraphForStereo = (nativeContext, inputGainNode, panGainNode, channelMergerNode)=>{
        const leftInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const leftInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const centerIndex = Math.floor(CURVE_SIZE / 2);
        for(let i = 0; i < CURVE_SIZE; i += 1)if (i > centerIndex) {
            const x = (i - centerIndex) / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
            leftInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
            leftInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
            rightInputForLeftOutputWaveShaperCurve[i] = 0;
            rightInputForRightOutputWaveShaperCurve[i] = 1;
        } else {
            const x = i / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
            leftInputForLeftOutputWaveShaperCurve[i] = 1;
            leftInputForRightOutputWaveShaperCurve[i] = 0;
            rightInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
            rightInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
        }
        const channelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
            channelCount: 2,
            channelCountMode: "explicit",
            channelInterpretation: "discrete",
            numberOfOutputs: 2
        });
        const leftInputForLeftOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftInputForLeftOutputWaveShaperCurve
        });
        const leftInputForRightOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftInputForRightOutputWaveShaperCurve
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const panWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: DC_CURVE
        });
        const rightInputForLeftOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightInputForLeftOutputWaveShaperCurve
        });
        const rightInputForRightOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightInputForRightOutputWaveShaperCurve
        });
        return {
            connectGraph () {
                inputGainNode.connect(channelSplitterNode);
                inputGainNode.connect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                channelSplitterNode.connect(leftInputForLeftOutputGainNode, 0);
                channelSplitterNode.connect(leftInputForRightOutputGainNode, 0);
                channelSplitterNode.connect(rightInputForLeftOutputGainNode, 1);
                channelSplitterNode.connect(rightInputForRightOutputGainNode, 1);
                panWaveShaperNode.connect(panGainNode);
                panGainNode.connect(leftInputForLeftOutputWaveShaperNode.inputs === undefined ? leftInputForLeftOutputWaveShaperNode : leftInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(leftInputForRightOutputWaveShaperNode.inputs === undefined ? leftInputForRightOutputWaveShaperNode : leftInputForRightOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(rightInputForLeftOutputWaveShaperNode.inputs === undefined ? rightInputForLeftOutputWaveShaperNode : rightInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(rightInputForRightOutputWaveShaperNode.inputs === undefined ? rightInputForRightOutputWaveShaperNode : rightInputForRightOutputWaveShaperNode.inputs[0]);
                leftInputForLeftOutputWaveShaperNode.connect(leftInputForLeftOutputGainNode.gain);
                leftInputForRightOutputWaveShaperNode.connect(leftInputForRightOutputGainNode.gain);
                rightInputForLeftOutputWaveShaperNode.connect(rightInputForLeftOutputGainNode.gain);
                rightInputForRightOutputWaveShaperNode.connect(rightInputForRightOutputGainNode.gain);
                leftInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
                rightInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
                leftInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
                rightInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
            },
            disconnectGraph () {
                inputGainNode.disconnect(channelSplitterNode);
                inputGainNode.disconnect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                channelSplitterNode.disconnect(leftInputForLeftOutputGainNode, 0);
                channelSplitterNode.disconnect(leftInputForRightOutputGainNode, 0);
                channelSplitterNode.disconnect(rightInputForLeftOutputGainNode, 1);
                channelSplitterNode.disconnect(rightInputForRightOutputGainNode, 1);
                panWaveShaperNode.disconnect(panGainNode);
                panGainNode.disconnect(leftInputForLeftOutputWaveShaperNode.inputs === undefined ? leftInputForLeftOutputWaveShaperNode : leftInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(leftInputForRightOutputWaveShaperNode.inputs === undefined ? leftInputForRightOutputWaveShaperNode : leftInputForRightOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightInputForLeftOutputWaveShaperNode.inputs === undefined ? rightInputForLeftOutputWaveShaperNode : rightInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightInputForRightOutputWaveShaperNode.inputs === undefined ? rightInputForRightOutputWaveShaperNode : rightInputForRightOutputWaveShaperNode.inputs[0]);
                leftInputForLeftOutputWaveShaperNode.disconnect(leftInputForLeftOutputGainNode.gain);
                leftInputForRightOutputWaveShaperNode.disconnect(leftInputForRightOutputGainNode.gain);
                rightInputForLeftOutputWaveShaperNode.disconnect(rightInputForLeftOutputGainNode.gain);
                rightInputForRightOutputWaveShaperNode.disconnect(rightInputForRightOutputGainNode.gain);
                leftInputForLeftOutputGainNode.disconnect(channelMergerNode, 0, 0);
                rightInputForLeftOutputGainNode.disconnect(channelMergerNode, 0, 0);
                leftInputForRightOutputGainNode.disconnect(channelMergerNode, 0, 1);
                rightInputForRightOutputGainNode.disconnect(channelMergerNode, 0, 1);
            }
        };
    };
    const buildInternalGraph = (nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode)=>{
        if (channelCount === 1) return buildInternalGraphForMono(nativeContext, inputGainNode, panGainNode, channelMergerNode);
        if (channelCount === 2) return buildInternalGraphForStereo(nativeContext, inputGainNode, panGainNode, channelMergerNode);
        throw createNotSupportedError();
    };
    return (nativeContext, { channelCount: channelCount, channelCountMode: channelCountMode, pan: pan, ...audioNodeOptions })=>{
        if (channelCountMode === "max") throw createNotSupportedError();
        const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
            ...audioNodeOptions,
            channelCount: 1,
            channelCountMode: channelCountMode,
            numberOfInputs: 2
        });
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            channelCount: channelCount,
            channelCountMode: channelCountMode,
            gain: 1
        });
        const panGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: "explicit",
            channelInterpretation: "discrete",
            gain: pan
        });
        let { connectGraph: connectGraph, disconnectGraph: disconnectGraph } = buildInternalGraph(nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode);
        Object.defineProperty(panGainNode.gain, "defaultValue", {
            get: ()=>0
        });
        Object.defineProperty(panGainNode.gain, "maxValue", {
            get: ()=>1
        });
        Object.defineProperty(panGainNode.gain, "minValue", {
            get: ()=>-1
        });
        const nativeStereoPannerNodeFakerFactory = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return inputGainNode.channelCount;
            },
            set channelCount (value){
                if (inputGainNode.channelCount !== value) {
                    if (isConnected) disconnectGraph();
                    ({ connectGraph: connectGraph, disconnectGraph: disconnectGraph } = buildInternalGraph(nativeContext, value, inputGainNode, panGainNode, channelMergerNode));
                    if (isConnected) connectGraph();
                }
                inputGainNode.channelCount = value;
            },
            get channelCountMode () {
                return inputGainNode.channelCountMode;
            },
            set channelCountMode (value){
                if (value === "clamped-max" || value === "max") throw createNotSupportedError();
                inputGainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return inputGainNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
            },
            get context () {
                return inputGainNode.context;
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get numberOfInputs () {
                return inputGainNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return inputGainNode.numberOfOutputs;
            },
            get pan () {
                return panGainNode.gain;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        let isConnected = false;
        const whenConnected = ()=>{
            connectGraph();
            isConnected = true;
        };
        const whenDisconnected = ()=>{
            disconnectGraph();
            isConnected = false;
        };
        return monitorConnections((0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeStereoPannerNodeFakerFactory, channelMergerNode), whenConnected, whenDisconnected);
    };
};




const $a275aa5a2c573982$export$75168c4c8ce320c4 = (createConnectedNativeAudioBufferSourceNode, createInvalidStateError, createNativeWaveShaperNodeFaker, isDCCurve, monitorConnections, nativeAudioContextConstructor, overwriteAccessors)=>{
    return (nativeContext, options)=>{
        const nativeWaveShaperNode = nativeContext.createWaveShaper();
        /*
         * Bug #119: Safari does not correctly map the values.
         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
         * the webkitAudioContext is used as a workaround here. Testing for the automationRate property is necessary because this workaround
         * isn't necessary anymore since v14.0.2 of Safari.
         */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === "webkitAudioContext" && nativeContext.createGain().gain.automationRate === undefined) return createNativeWaveShaperNodeFaker(nativeContext, options);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeWaveShaperNode, options);
        const curve = options.curve === null || options.curve instanceof Float32Array ? options.curve : new Float32Array(options.curve);
        // Bug #104: Chrome and Edge will throw an InvalidAccessError when the curve has less than two samples.
        if (curve !== null && curve.length < 2) throw createInvalidStateError();
        // Only values of type Float32Array can be assigned to the curve property.
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeWaveShaperNode, {
            curve: curve
        }, "curve");
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeWaveShaperNode, options, "oversample");
        let disconnectNativeAudioBufferSourceNode = null;
        let isConnected = false;
        overwriteAccessors(nativeWaveShaperNode, "curve", (get)=>()=>get.call(nativeWaveShaperNode), (set)=>(value)=>{
                set.call(nativeWaveShaperNode, value);
                if (isConnected) {
                    if (isDCCurve(value) && disconnectNativeAudioBufferSourceNode === null) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, nativeWaveShaperNode);
                    else if (!isDCCurve(value) && disconnectNativeAudioBufferSourceNode !== null) {
                        disconnectNativeAudioBufferSourceNode();
                        disconnectNativeAudioBufferSourceNode = null;
                    }
                }
                return value;
            });
        const whenConnected = ()=>{
            isConnected = true;
            if (isDCCurve(nativeWaveShaperNode.curve)) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, nativeWaveShaperNode);
        };
        const whenDisconnected = ()=>{
            isConnected = false;
            if (disconnectNativeAudioBufferSourceNode !== null) {
                disconnectNativeAudioBufferSourceNode();
                disconnectNativeAudioBufferSourceNode = null;
            }
        };
        return monitorConnections(nativeWaveShaperNode, whenConnected, whenDisconnected);
    };
};




const $e6b48514e14721aa$export$f5f0b26abc22907e = (createConnectedNativeAudioBufferSourceNode, createInvalidStateError, createNativeGainNode, isDCCurve, monitorConnections)=>{
    return (nativeContext, { curve: curve, oversample: oversample, ...audioNodeOptions })=>{
        const negativeWaveShaperNode = nativeContext.createWaveShaper();
        const positiveWaveShaperNode = nativeContext.createWaveShaper();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(negativeWaveShaperNode, audioNodeOptions);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(positiveWaveShaperNode, audioNodeOptions);
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const invertGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: -1
        });
        const outputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const revertGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: -1
        });
        let disconnectNativeAudioBufferSourceNode = null;
        let isConnected = false;
        let unmodifiedCurve = null;
        const nativeWaveShaperNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return negativeWaveShaperNode.channelCount;
            },
            set channelCount (value){
                inputGainNode.channelCount = value;
                invertGainNode.channelCount = value;
                negativeWaveShaperNode.channelCount = value;
                outputGainNode.channelCount = value;
                positiveWaveShaperNode.channelCount = value;
                revertGainNode.channelCount = value;
            },
            get channelCountMode () {
                return negativeWaveShaperNode.channelCountMode;
            },
            set channelCountMode (value){
                inputGainNode.channelCountMode = value;
                invertGainNode.channelCountMode = value;
                negativeWaveShaperNode.channelCountMode = value;
                outputGainNode.channelCountMode = value;
                positiveWaveShaperNode.channelCountMode = value;
                revertGainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return negativeWaveShaperNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
                invertGainNode.channelInterpretation = value;
                negativeWaveShaperNode.channelInterpretation = value;
                outputGainNode.channelInterpretation = value;
                positiveWaveShaperNode.channelInterpretation = value;
                revertGainNode.channelInterpretation = value;
            },
            get context () {
                return negativeWaveShaperNode.context;
            },
            get curve () {
                return unmodifiedCurve;
            },
            set curve (value){
                // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
                if (value !== null && value.length < 2) throw createInvalidStateError();
                if (value === null) {
                    negativeWaveShaperNode.curve = value;
                    positiveWaveShaperNode.curve = value;
                } else {
                    const curveLength = value.length;
                    const negativeCurve = new Float32Array(curveLength + 2 - curveLength % 2);
                    const positiveCurve = new Float32Array(curveLength + 2 - curveLength % 2);
                    negativeCurve[0] = value[0];
                    positiveCurve[0] = -value[curveLength - 1];
                    const length = Math.ceil((curveLength + 1) / 2);
                    const centerIndex = (curveLength + 1) / 2 - 1;
                    for(let i = 1; i < length; i += 1){
                        const theoreticIndex = i / length * centerIndex;
                        const lowerIndex = Math.floor(theoreticIndex);
                        const upperIndex = Math.ceil(theoreticIndex);
                        negativeCurve[i] = lowerIndex === upperIndex ? value[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * value[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * value[upperIndex];
                        positiveCurve[i] = lowerIndex === upperIndex ? -value[curveLength - 1 - lowerIndex] : -((1 - (theoreticIndex - lowerIndex)) * value[curveLength - 1 - lowerIndex]) - (1 - (upperIndex - theoreticIndex)) * value[curveLength - 1 - upperIndex];
                    }
                    negativeCurve[length] = curveLength % 2 === 1 ? value[length - 1] : (value[length - 2] + value[length - 1]) / 2;
                    negativeWaveShaperNode.curve = negativeCurve;
                    positiveWaveShaperNode.curve = positiveCurve;
                }
                unmodifiedCurve = value;
                if (isConnected) {
                    if (isDCCurve(unmodifiedCurve) && disconnectNativeAudioBufferSourceNode === null) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, inputGainNode);
                    else if (disconnectNativeAudioBufferSourceNode !== null) {
                        disconnectNativeAudioBufferSourceNode();
                        disconnectNativeAudioBufferSourceNode = null;
                    }
                }
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get numberOfInputs () {
                return negativeWaveShaperNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return negativeWaveShaperNode.numberOfOutputs;
            },
            get oversample () {
                return negativeWaveShaperNode.oversample;
            },
            set oversample (value){
                negativeWaveShaperNode.oversample = value;
                positiveWaveShaperNode.oversample = value;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        if (curve !== null) // Only values of type Float32Array can be assigned to the curve property.
        nativeWaveShaperNodeFaker.curve = curve instanceof Float32Array ? curve : new Float32Array(curve);
        if (oversample !== nativeWaveShaperNodeFaker.oversample) nativeWaveShaperNodeFaker.oversample = oversample;
        const whenConnected = ()=>{
            inputGainNode.connect(negativeWaveShaperNode).connect(outputGainNode);
            inputGainNode.connect(invertGainNode).connect(positiveWaveShaperNode).connect(revertGainNode).connect(outputGainNode);
            isConnected = true;
            if (isDCCurve(unmodifiedCurve)) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, inputGainNode);
        };
        const whenDisconnected = ()=>{
            inputGainNode.disconnect(negativeWaveShaperNode);
            negativeWaveShaperNode.disconnect(outputGainNode);
            inputGainNode.disconnect(invertGainNode);
            invertGainNode.disconnect(positiveWaveShaperNode);
            positiveWaveShaperNode.disconnect(revertGainNode);
            revertGainNode.disconnect(outputGainNode);
            isConnected = false;
            if (disconnectNativeAudioBufferSourceNode !== null) {
                disconnectNativeAudioBufferSourceNode();
                disconnectNativeAudioBufferSourceNode = null;
            }
        };
        return monitorConnections((0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeWaveShaperNodeFaker, outputGainNode), whenConnected, whenDisconnected);
    };
};


const $b285affc6d8be1e4$export$dbebdb13622d486c = ()=>new DOMException("", "NotSupportedError");




const $18cd39af3f5a11f9$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $18cd39af3f5a11f9$export$a9b5caf52b398870 = (baseAudioContextConstructor, cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, startRendering)=>{
    return class OfflineAudioContext extends baseAudioContextConstructor {
        constructor(a, b, c){
            let options;
            if (typeof a === "number" && b !== undefined && c !== undefined) options = {
                length: b,
                numberOfChannels: a,
                sampleRate: c
            };
            else if (typeof a === "object") options = a;
            else throw new Error("The given parameters are not valid.");
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$18cd39af3f5a11f9$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
            // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
            if (!cacheTestResult((0, $4590a073dac74a1e$export$9ec44223b1284cd4), ()=>(0, $4590a073dac74a1e$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) nativeOfflineAudioContext.addEventListener("statechange", (()=>{
                let i = 0;
                const delayStateChangeEvent = (event)=>{
                    if (this._state === "running") {
                        if (i > 0) {
                            nativeOfflineAudioContext.removeEventListener("statechange", delayStateChangeEvent);
                            event.stopImmediatePropagation();
                            this._waitForThePromiseToSettle(event);
                        } else i += 1;
                    }
                };
                return delayStateChangeEvent;
            })());
            super(nativeOfflineAudioContext, numberOfChannels);
            this._length = length;
            this._nativeOfflineAudioContext = nativeOfflineAudioContext;
            this._state = null;
        }
        get length() {
            // Bug #17: Safari does not yet expose the length.
            if (this._nativeOfflineAudioContext.length === undefined) return this._length;
            return this._nativeOfflineAudioContext.length;
        }
        get state() {
            return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
        }
        startRendering() {
            /*
             * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
             * the state of the nativeOfflineAudioContext might no transition to running immediately.
             */ if (this._state === "running") return Promise.reject(createInvalidStateError());
            this._state = "running";
            return startRendering(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                this._state = null;
                (0, $6d385241f7fab45a$export$cbd606bc629ea938)(this);
            });
        }
        _waitForThePromiseToSettle(event) {
            if (this._state === null) this._nativeOfflineAudioContext.dispatchEvent(event);
            else setTimeout(()=>this._waitForThePromiseToSettle(event));
        }
    };
};





const $36f6248399d5f3b2$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers",
    detune: 0,
    frequency: 440,
    periodicWave: undefined,
    type: "sine"
};
const $36f6248399d5f3b2$export$c1c3584074b042b3 = (audioNodeConstructor, createAudioParam, createNativeOscillatorNode, createOscillatorNodeRenderer, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class OscillatorNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$36f6248399d5f3b2$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOscillatorNode = createNativeOscillatorNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const oscillatorNodeRenderer = isOffline ? createOscillatorNodeRenderer() : null;
            const nyquist = context.sampleRate / 2;
            super(context, false, nativeOscillatorNode, oscillatorNodeRenderer);
            // Bug #81: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._detune = createAudioParam(this, isOffline, nativeOscillatorNode.detune, 153600, -153600);
            // Bug #76: Safari does not export the correct values for maxValue and minValue.
            this._frequency = createAudioParam(this, isOffline, nativeOscillatorNode.frequency, nyquist, -nyquist);
            this._nativeOscillatorNode = nativeOscillatorNode;
            this._onended = null;
            this._oscillatorNodeRenderer = oscillatorNodeRenderer;
            if (this._oscillatorNodeRenderer !== null && mergedOptions.periodicWave !== undefined) this._oscillatorNodeRenderer.periodicWave = mergedOptions.periodicWave;
        }
        get detune() {
            return this._detune;
        }
        get frequency() {
            return this._frequency;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === "function" ? wrapEventListener(this, value) : null;
            this._nativeOscillatorNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeOscillatorNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        get type() {
            return this._nativeOscillatorNode.type;
        }
        set type(value) {
            this._nativeOscillatorNode.type = value;
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.periodicWave = null;
        }
        setPeriodicWave(periodicWave) {
            this._nativeOscillatorNode.setPeriodicWave(periodicWave);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.periodicWave = periodicWave;
        }
        start(when = 0) {
            this._nativeOscillatorNode.start(when);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.start = when;
            if (this.context.state !== "closed") {
                (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeOscillatorNode.removeEventListener("ended", resetInternalStateToPassive);
                    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(this)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(this);
                };
                this._nativeOscillatorNode.addEventListener("ended", resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeOscillatorNode.stop(when);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.stop = when;
        }
    };
};



const $0d4239b2159c3e55$export$99143538b3590be5 = (connectAudioParam, createNativeOscillatorNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeOscillatorNodes = new WeakMap();
        let periodicWave = null;
        let start = null;
        let stop = null;
        const createOscillatorNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeOscillatorNode = getNativeAudioNode(proxy);
            // If the initially used nativeOscillatorNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeOscillatorNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeOscillatorNode, nativeOfflineAudioContext);
            if (!nativeOscillatorNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeOscillatorNode.channelCount,
                    channelCountMode: nativeOscillatorNode.channelCountMode,
                    channelInterpretation: nativeOscillatorNode.channelInterpretation,
                    detune: nativeOscillatorNode.detune.value,
                    frequency: nativeOscillatorNode.frequency.value,
                    periodicWave: periodicWave === null ? undefined : periodicWave,
                    type: nativeOscillatorNode.type
                };
                nativeOscillatorNode = createNativeOscillatorNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeOscillatorNode.start(start);
                if (stop !== null) nativeOscillatorNode.stop(stop);
            }
            renderedNativeOscillatorNodes.set(nativeOfflineAudioContext, nativeOscillatorNode);
            if (!nativeOscillatorNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.detune, nativeOscillatorNode.detune);
                await renderAutomation(nativeOfflineAudioContext, proxy.frequency, nativeOscillatorNode.frequency);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.detune, nativeOscillatorNode.detune);
                await connectAudioParam(nativeOfflineAudioContext, proxy.frequency, nativeOscillatorNode.frequency);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeOscillatorNode);
            return nativeOscillatorNode;
        };
        return {
            set periodicWave (value){
                periodicWave = value;
            },
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeOscillatorNode = renderedNativeOscillatorNodes.get(nativeOfflineAudioContext);
                if (renderedNativeOscillatorNode !== undefined) return Promise.resolve(renderedNativeOscillatorNode);
                return createOscillatorNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};



const $ab22fa9f2ae9cf1a$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "clamped-max",
    channelInterpretation: "speakers",
    coneInnerAngle: 360,
    coneOuterAngle: 360,
    coneOuterGain: 0,
    distanceModel: "inverse",
    maxDistance: 10000,
    orientationX: 1,
    orientationY: 0,
    orientationZ: 0,
    panningModel: "equalpower",
    positionX: 0,
    positionY: 0,
    positionZ: 0,
    refDistance: 1,
    rolloffFactor: 1
};
const $ab22fa9f2ae9cf1a$export$91b046021cf98bac = (audioNodeConstructor, createAudioParam, createNativePannerNode, createPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class PannerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$ab22fa9f2ae9cf1a$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativePannerNode = createNativePannerNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const pannerNodeRenderer = isOffline ? createPannerNodeRenderer() : null;
            super(context, false, nativePannerNode, pannerNodeRenderer);
            this._nativePannerNode = nativePannerNode;
            // Bug #74: Safari does not export the correct values for maxValue and minValue.
            this._orientationX = createAudioParam(this, isOffline, nativePannerNode.orientationX, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._orientationY = createAudioParam(this, isOffline, nativePannerNode.orientationY, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._orientationZ = createAudioParam(this, isOffline, nativePannerNode.orientationZ, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._positionX = createAudioParam(this, isOffline, nativePannerNode.positionX, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._positionY = createAudioParam(this, isOffline, nativePannerNode.positionY, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._positionZ = createAudioParam(this, isOffline, nativePannerNode.positionZ, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get coneInnerAngle() {
            return this._nativePannerNode.coneInnerAngle;
        }
        set coneInnerAngle(value) {
            this._nativePannerNode.coneInnerAngle = value;
        }
        get coneOuterAngle() {
            return this._nativePannerNode.coneOuterAngle;
        }
        set coneOuterAngle(value) {
            this._nativePannerNode.coneOuterAngle = value;
        }
        get coneOuterGain() {
            return this._nativePannerNode.coneOuterGain;
        }
        set coneOuterGain(value) {
            this._nativePannerNode.coneOuterGain = value;
        }
        get distanceModel() {
            return this._nativePannerNode.distanceModel;
        }
        set distanceModel(value) {
            this._nativePannerNode.distanceModel = value;
        }
        get maxDistance() {
            return this._nativePannerNode.maxDistance;
        }
        set maxDistance(value) {
            this._nativePannerNode.maxDistance = value;
        }
        get orientationX() {
            return this._orientationX;
        }
        get orientationY() {
            return this._orientationY;
        }
        get orientationZ() {
            return this._orientationZ;
        }
        get panningModel() {
            return this._nativePannerNode.panningModel;
        }
        set panningModel(value) {
            this._nativePannerNode.panningModel = value;
        }
        get positionX() {
            return this._positionX;
        }
        get positionY() {
            return this._positionY;
        }
        get positionZ() {
            return this._positionZ;
        }
        get refDistance() {
            return this._nativePannerNode.refDistance;
        }
        set refDistance(value) {
            this._nativePannerNode.refDistance = value;
        }
        get rolloffFactor() {
            return this._nativePannerNode.rolloffFactor;
        }
        set rolloffFactor(value) {
            this._nativePannerNode.rolloffFactor = value;
        }
    };
};




const $23fb3d183f13b7ce$export$ccd091498494025 = (connectAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeGainNode, createNativePannerNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        let renderedBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeGainNode = null;
            let nativePannerNode = getNativeAudioNode(proxy);
            const commonAudioNodeOptions = {
                channelCount: nativePannerNode.channelCount,
                channelCountMode: nativePannerNode.channelCountMode,
                channelInterpretation: nativePannerNode.channelInterpretation
            };
            const commonNativePannerNodeOptions = {
                ...commonAudioNodeOptions,
                coneInnerAngle: nativePannerNode.coneInnerAngle,
                coneOuterAngle: nativePannerNode.coneOuterAngle,
                coneOuterGain: nativePannerNode.coneOuterGain,
                distanceModel: nativePannerNode.distanceModel,
                maxDistance: nativePannerNode.maxDistance,
                panningModel: nativePannerNode.panningModel,
                refDistance: nativePannerNode.refDistance,
                rolloffFactor: nativePannerNode.rolloffFactor
            };
            // If the initially used nativePannerNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativePannerNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativePannerNode, nativeOfflineAudioContext);
            // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.
            if ("bufferSize" in nativePannerNode) nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                ...commonAudioNodeOptions,
                gain: 1
            });
            else if (!nativePannerNodeIsOwnedByContext) {
                const options = {
                    ...commonNativePannerNodeOptions,
                    orientationX: nativePannerNode.orientationX.value,
                    orientationY: nativePannerNode.orientationY.value,
                    orientationZ: nativePannerNode.orientationZ.value,
                    positionX: nativePannerNode.positionX.value,
                    positionY: nativePannerNode.positionY.value,
                    positionZ: nativePannerNode.positionZ.value
                };
                nativePannerNode = createNativePannerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeGainNode === null ? nativePannerNode : nativeGainNode);
            if (nativeGainNode !== null) {
                if (renderedBufferPromise === null) {
                    if (nativeOfflineAudioContextConstructor === null) throw new Error("Missing the native OfflineAudioContext constructor.");
                    const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(6, // Bug #17: Safari does not yet expose the length.
                    proxy.context.length, nativeOfflineAudioContext.sampleRate);
                    const nativeChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "speakers",
                        numberOfInputs: 6
                    });
                    nativeChannelMergerNode.connect(partialOfflineAudioContext.destination);
                    renderedBufferPromise = (async ()=>{
                        const nativeConstantSourceNodes = await Promise.all([
                            proxy.orientationX,
                            proxy.orientationY,
                            proxy.orientationZ,
                            proxy.positionX,
                            proxy.positionY,
                            proxy.positionZ
                        ].map(async (audioParam, index)=>{
                            const nativeConstantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: "explicit",
                                channelInterpretation: "discrete",
                                offset: index === 0 ? 1 : 0
                            });
                            await renderAutomation(partialOfflineAudioContext, audioParam, nativeConstantSourceNode.offset);
                            return nativeConstantSourceNode;
                        }));
                        for(let i = 0; i < 6; i += 1){
                            nativeConstantSourceNodes[i].connect(nativeChannelMergerNode, 0, i);
                            nativeConstantSourceNodes[i].start(0);
                        }
                        return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                    })();
                }
                const renderedBuffer = await renderedBufferPromise;
                const inputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    ...commonAudioNodeOptions,
                    gain: 1
                });
                await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, inputGainNode);
                const channelDatas = [];
                for(let i = 0; i < renderedBuffer.numberOfChannels; i += 1)channelDatas.push(renderedBuffer.getChannelData(i));
                let lastOrientation = [
                    channelDatas[0][0],
                    channelDatas[1][0],
                    channelDatas[2][0]
                ];
                let lastPosition = [
                    channelDatas[3][0],
                    channelDatas[4][0],
                    channelDatas[5][0]
                ];
                let gateGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    ...commonAudioNodeOptions,
                    gain: 1
                });
                let partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, {
                    ...commonNativePannerNodeOptions,
                    orientationX: lastOrientation[0],
                    orientationY: lastOrientation[1],
                    orientationZ: lastOrientation[2],
                    positionX: lastPosition[0],
                    positionY: lastPosition[1],
                    positionZ: lastPosition[2]
                });
                inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                partialPannerNode.connect(nativeGainNode);
                for(let i = 128; i < renderedBuffer.length; i += 128){
                    const orientation = [
                        channelDatas[0][i],
                        channelDatas[1][i],
                        channelDatas[2][i]
                    ];
                    const positon = [
                        channelDatas[3][i],
                        channelDatas[4][i],
                        channelDatas[5][i]
                    ];
                    if (orientation.some((value, index)=>value !== lastOrientation[index]) || positon.some((value, index)=>value !== lastPosition[index])) {
                        lastOrientation = orientation;
                        lastPosition = positon;
                        const currentTime = i / nativeOfflineAudioContext.sampleRate;
                        gateGainNode.gain.setValueAtTime(0, currentTime);
                        gateGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                            ...commonAudioNodeOptions,
                            gain: 0
                        });
                        partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, {
                            ...commonNativePannerNodeOptions,
                            orientationX: lastOrientation[0],
                            orientationY: lastOrientation[1],
                            orientationZ: lastOrientation[2],
                            positionX: lastPosition[0],
                            positionY: lastPosition[1],
                            positionZ: lastPosition[2]
                        });
                        gateGainNode.gain.setValueAtTime(1, currentTime);
                        inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                        partialPannerNode.connect(nativeGainNode);
                    }
                }
                return nativeGainNode;
            }
            if (!nativePannerNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX);
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY);
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX);
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY);
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ);
            }
            if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativePannerNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode);
            return nativePannerNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeGainNodeOrNativePannerNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeGainNodeOrNativePannerNode !== undefined) return Promise.resolve(renderedNativeGainNodeOrNativePannerNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $51d2e80f451b9759$var$DEFAULT_OPTIONS = {
    disableNormalization: false
};
const $51d2e80f451b9759$export$10e47cfa48a5069d = (createNativePeriodicWave, getNativeContext, periodicWaveStore, sanitizePeriodicWaveOptions)=>{
    return class PeriodicWave {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = sanitizePeriodicWaveOptions({
                ...$51d2e80f451b9759$var$DEFAULT_OPTIONS,
                ...options
            });
            const periodicWave = createNativePeriodicWave(nativeContext, mergedOptions);
            periodicWaveStore.add(periodicWave);
            // This does violate all good pratices but it is used here to simplify the handling of periodic waves.
            return periodicWave;
        }
        static [Symbol.hasInstance](instance) {
            return instance !== null && typeof instance === "object" && Object.getPrototypeOf(instance) === PeriodicWave.prototype || periodicWaveStore.has(instance);
        }
    };
};


const $49e48dbdfe378aa1$export$889eef7d338963f6 = (getAudioParamRenderer, renderInputsOfAudioParam)=>{
    return (nativeOfflineAudioContext, audioParam, nativeAudioParam)=>{
        const audioParamRenderer = getAudioParamRenderer(audioParam);
        audioParamRenderer.replay(nativeAudioParam);
        return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
    };
};


const $d2ccdaf328a083a6$export$cff0938ddf51f6f4 = (getAudioNodeConnections, getAudioNodeRenderer, isPartOfACycle)=>{
    return async (audioNode, nativeOfflineAudioContext, nativeAudioNode)=>{
        const audioNodeConnections = getAudioNodeConnections(audioNode);
        await Promise.all(audioNodeConnections.activeInputs.map((connections, input)=>Array.from(connections).map(async ([source, output])=>{
                const audioNodeRenderer = getAudioNodeRenderer(source);
                const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
                const destination = audioNode.context.destination;
                if (!isPartOfACycle(source) && (audioNode !== destination || !isPartOfACycle(audioNode))) renderedNativeAudioNode.connect(nativeAudioNode, output, input);
            })).reduce((allRenderingPromises, renderingPromises)=>[
                ...allRenderingPromises,
                ...renderingPromises
            ], []));
    };
};


const $6ca48f6db88647ab$export$82cd58acb1062198 = (getAudioNodeRenderer, getAudioParamConnections, isPartOfACycle)=>{
    return async (audioParam, nativeOfflineAudioContext, nativeAudioParam)=>{
        const audioParamConnections = getAudioParamConnections(audioParam);
        await Promise.all(Array.from(audioParamConnections.activeInputs).map(async ([source, output])=>{
            const audioNodeRenderer = getAudioNodeRenderer(source);
            const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
            if (!isPartOfACycle(source)) renderedNativeAudioNode.connect(nativeAudioParam, output);
        }));
    };
};



const $ed4f60f8df7f2dc8$export$feb8d4a8e403af48 = (cacheTestResult, createNativeGainNode, createNativeScriptProcessorNode, testOfflineAudioContextCurrentTimeSupport)=>{
    return (nativeOfflineAudioContext)=>{
        // Bug #21: Safari does not support promises yet.
        if (cacheTestResult((0, $4590a073dac74a1e$export$9ec44223b1284cd4), ()=>(0, $4590a073dac74a1e$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) // Bug #158: Chrome and Edge do not advance currentTime if it is not accessed while rendering the audio.
        return Promise.resolve(cacheTestResult(testOfflineAudioContextCurrentTimeSupport, testOfflineAudioContextCurrentTimeSupport)).then((isOfflineAudioContextCurrentTimeSupported)=>{
            if (!isOfflineAudioContextCurrentTimeSupported) {
                const scriptProcessorNode = createNativeScriptProcessorNode(nativeOfflineAudioContext, 512, 0, 1);
                nativeOfflineAudioContext.oncomplete = ()=>{
                    scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation
                    scriptProcessorNode.disconnect();
                };
                scriptProcessorNode.onaudioprocess = ()=>nativeOfflineAudioContext.currentTime; // tslint:disable-line:deprecation
                scriptProcessorNode.connect(nativeOfflineAudioContext.destination);
            }
            return nativeOfflineAudioContext.startRendering();
        });
        return new Promise((resolve)=>{
            // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
            const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
                channelCount: 1,
                channelCountMode: "explicit",
                channelInterpretation: "discrete",
                gain: 0
            });
            nativeOfflineAudioContext.oncomplete = (event)=>{
                gainNode.disconnect();
                resolve(event.renderedBuffer);
            };
            gainNode.connect(nativeOfflineAudioContext.destination);
            nativeOfflineAudioContext.startRendering();
        });
    };
};


const $880c6c9afb613707$export$17328c9508de4388 = (activeAudioWorkletNodeInputsStore)=>{
    return (nativeAudioWorkletNode, activeInputs)=>{
        activeAudioWorkletNodeInputsStore.set(nativeAudioWorkletNode, activeInputs);
    };
};


const $63b106594231aed7$export$c5e78cc8035d00aa = (audioNodeTailTimeStore)=>{
    return (audioNode, tailTime)=>audioNodeTailTimeStore.set(audioNode, tailTime);
};



const $e1a515c24adcdd0a$export$a04cd80dfb1b8309 = (audioBufferStore, cacheTestResult, getAudioNodeRenderer, getUnrenderedAudioWorkletNodes, renderNativeOfflineAudioContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    return (destination, nativeOfflineAudioContext)=>getAudioNodeRenderer(destination).render(destination, nativeOfflineAudioContext)/*
         * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to the
         * destination.
         */ .then(()=>Promise.all(Array.from(getUnrenderedAudioWorkletNodes(nativeOfflineAudioContext)).map((audioWorkletNode)=>getAudioNodeRenderer(audioWorkletNode).render(audioWorkletNode, nativeOfflineAudioContext)))).then(()=>renderNativeOfflineAudioContext(nativeOfflineAudioContext)).then((audioBuffer)=>{
            // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
            // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
            if (typeof audioBuffer.copyFromChannel !== "function") {
                wrapAudioBufferCopyChannelMethods(audioBuffer);
                (0, $e0def92b41d2ffa5$export$df65309cf6249598)(audioBuffer);
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            } else if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, ()=>testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            return audioBuffer;
        });
};


const $24f00fc15291a590$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    /*
     * Bug #105: The channelCountMode should be 'clamped-max' according to the spec but is set to 'explicit' to achieve consistent
     * behavior.
     */ channelCountMode: "explicit",
    channelInterpretation: "speakers",
    pan: 0
};
const $24f00fc15291a590$export$9b005b0c35721c84 = (audioNodeConstructor, createAudioParam, createNativeStereoPannerNode, createStereoPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext)=>{
    return class StereoPannerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$24f00fc15291a590$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeStereoPannerNode = createNativeStereoPannerNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const stereoPannerNodeRenderer = isOffline ? createStereoPannerNodeRenderer() : null;
            super(context, false, nativeStereoPannerNode, stereoPannerNodeRenderer);
            this._pan = createAudioParam(this, isOffline, nativeStereoPannerNode.pan);
        }
        get pan() {
            return this._pan;
        }
    };
};




const $32b7f7e177963e5c$export$3ba9002bd6b539cf = (connectAudioParam, createNativeStereoPannerNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeStereoPannerNodes = new WeakMap();
        const createStereoPannerNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeStereoPannerNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeStereoPannerNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeStereoPannerNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeStereoPannerNode, nativeOfflineAudioContext);
            if (!nativeStereoPannerNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeStereoPannerNode.channelCount,
                    channelCountMode: nativeStereoPannerNode.channelCountMode,
                    channelInterpretation: nativeStereoPannerNode.channelInterpretation,
                    pan: nativeStereoPannerNode.pan.value
                };
                nativeStereoPannerNode = createNativeStereoPannerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeStereoPannerNodes.set(nativeOfflineAudioContext, nativeStereoPannerNode);
            if (!nativeStereoPannerNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.pan, nativeStereoPannerNode.pan);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.pan, nativeStereoPannerNode.pan);
            if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeStereoPannerNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeStereoPannerNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeStereoPannerNode);
            return nativeStereoPannerNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeStereoPannerNode = renderedNativeStereoPannerNodes.get(nativeOfflineAudioContext);
                if (renderedNativeStereoPannerNode !== undefined) return Promise.resolve(renderedNativeStereoPannerNode);
                return createStereoPannerNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


// Bug #33: Safari exposes an AudioBuffer but it can't be used as a constructor.
const $3988bd8c6f69cf53$export$5bddcff46df9c642 = (nativeAudioBufferConstructor)=>{
    return ()=>{
        if (nativeAudioBufferConstructor === null) return false;
        try {
            new nativeAudioBufferConstructor({
                length: 1,
                sampleRate: 44100
            }); // tslint:disable-line:no-unused-expression
        } catch  {
            return false;
        }
        return true;
    };
};


/*
 * Firefox up to version 67 didn't fully support the copyFromChannel() and copyToChannel() methods. Therefore testing one of those methods
 * is enough to know if the other one is supported as well.
 */ const $05c9e19f79e8946a$export$1995b5466f5c2709 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeAudioBuffer = nativeOfflineAudioContext.createBuffer(1, 1, 44100);
        // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        if (nativeAudioBuffer.copyToChannel === undefined) return true;
        const source = new Float32Array(2);
        try {
            nativeAudioBuffer.copyFromChannel(source, 0, 0);
        } catch  {
            return false;
        }
        return true;
    };
};


const $7b65ce19fe8f2342$export$34981ee6aafdf532 = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        // Try to check the prototype before constructing the AudioContext.
        if (nativeAudioContextConstructor.prototype !== undefined && nativeAudioContextConstructor.prototype.close !== undefined) return true;
        const audioContext = new nativeAudioContextConstructor();
        const isAudioContextClosable = audioContext.close !== undefined;
        try {
            audioContext.close();
        } catch  {
        // Ignore errors.
        }
        return isAudioContextClosable;
    };
};


/**
 * Edge up to version 14, Firefox up to version 52, Safari up to version 9 and maybe other browsers
 * did not refuse to decode invalid parameters with a TypeError.
 */ const $8590d5b2ea257754$export$622ba23aa6b35822 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #21: Safari does not support promises yet.
        return new Promise((resolve)=>{
            let isPending = true;
            const resolvePromise = (err)=>{
                if (isPending) {
                    isPending = false;
                    offlineAudioContext.startRendering();
                    resolve(err instanceof TypeError);
                }
            };
            let promise;
            // Bug #26: Safari throws a synchronous error.
            try {
                promise = offlineAudioContext// Bug #1: Safari requires a successCallback.
                .decodeAudioData(null, ()=>{
                // Ignore the success callback.
                }, resolvePromise);
            } catch (err) {
                resolvePromise(err);
            }
            // Bug #21: Safari does not support promises yet.
            if (promise !== undefined) // Bug #6: Chrome, Edge and Firefox do not call the errorCallback.
            promise.catch(resolvePromise);
        });
    };
};


const $867de883ce43c047$export$2f44088abd2df2e = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        let audioContext;
        try {
            audioContext = new nativeAudioContextConstructor({
                latencyHint: "balanced"
            });
        } catch  {
            return false;
        }
        audioContext.close();
        return true;
    };
};


// Safari up to version 12.0 (but not v12.1) didn't return the destination in case it was an AudioNode.
const $c42fe39c700d4e84$export$f77a3bce7e4efd81 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeGainNode = nativeOfflineAudioContext.createGain();
        const isSupported = nativeGainNode.connect(nativeGainNode) === nativeGainNode;
        nativeGainNode.disconnect(nativeGainNode);
        return isSupported;
    };
};


/**
 * Chrome version 66 and 67 did not call the process() function of an AudioWorkletProcessor if it had no outputs. AudioWorklet support was
 * enabled by default in version 66.
 */ const $071627c414f7ce66$export$ce5ba80a98dc0ba7 = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor)=>{
    return async ()=>{
        // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
        if (nativeAudioWorkletNodeConstructor === null) return true;
        if (nativeOfflineAudioContextConstructor === null) return false;
        const blob = new Blob([
            'let c,p;class A extends AudioWorkletProcessor{constructor(){super();this.port.onmessage=(e)=>{p=e.data;p.onmessage=()=>{p.postMessage(c);p.close()};this.port.postMessage(0)}}process(){c=1}}registerProcessor("a",A)'
        ], {
            type: "application/javascript; charset=utf-8"
        });
        const messageChannel = new MessageChannel();
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
        const url = URL.createObjectURL(blob);
        let isCallingProcess = false;
        try {
            await offlineAudioContext.audioWorklet.addModule(url);
            const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, "a", {
                numberOfOutputs: 0
            });
            const oscillator = offlineAudioContext.createOscillator();
            await new Promise((resolve)=>{
                audioWorkletNode.port.onmessage = ()=>resolve();
                audioWorkletNode.port.postMessage(messageChannel.port2, [
                    messageChannel.port2
                ]);
            });
            audioWorkletNode.port.onmessage = ()=>isCallingProcess = true;
            oscillator.connect(audioWorkletNode);
            oscillator.start(0);
            await offlineAudioContext.startRendering();
            isCallingProcess = await new Promise((resolve)=>{
                messageChannel.port1.onmessage = ({ data: data })=>resolve(data === 1);
                messageChannel.port1.postMessage(0);
            });
        } catch  {
        // Ignore errors.
        } finally{
            messageChannel.port1.close();
            URL.revokeObjectURL(url);
        }
        return isCallingProcess;
    };
};


// Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
const $f022a9196cd0a0cb$export$19b2cf184a7cfba8 = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor)=>{
    return async ()=>{
        // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
        if (nativeAudioWorkletNodeConstructor === null) return true;
        if (nativeOfflineAudioContextConstructor === null) return false;
        const blob = new Blob([
            'class A extends AudioWorkletProcessor{process(i){this.port.postMessage(i,[i[0][0].buffer])}}registerProcessor("a",A)'
        ], {
            type: "application/javascript; charset=utf-8"
        });
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
        const url = URL.createObjectURL(blob);
        let isEmittingMessageEvents = false;
        let isEmittingProcessorErrorEvents = false;
        try {
            await offlineAudioContext.audioWorklet.addModule(url);
            const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, "a", {
                numberOfOutputs: 0
            });
            const oscillator = offlineAudioContext.createOscillator();
            audioWorkletNode.port.onmessage = ()=>isEmittingMessageEvents = true;
            audioWorkletNode.onprocessorerror = ()=>isEmittingProcessorErrorEvents = true;
            oscillator.connect(audioWorkletNode);
            oscillator.start(0);
            await offlineAudioContext.startRendering();
            // Bug #197: Safari does not deliver the messages before the promise returned by startRendering() resolves.
            await new Promise((resolve)=>setTimeout(resolve));
        } catch  {
        // Ignore errors.
        } finally{
            URL.revokeObjectURL(url);
        }
        return isEmittingMessageEvents && !isEmittingProcessorErrorEvents;
    };
};


/**
 * Firefox up to version 69 did not throw an error when setting a different channelCount or channelCountMode.
 */ const $29d0b5a6333bdcd2$export$a04037cfe0b977fa = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeChannelMergerNode = offlineAudioContext.createChannelMerger();
        /**
         * Bug #15: Safari does not return the default properties. It still needs to be patched. This test is supposed to test the support
         * in other browsers.
         */ if (nativeChannelMergerNode.channelCountMode === "max") return true;
        try {
            nativeChannelMergerNode.channelCount = 2;
        } catch  {
            return true;
        }
        return false;
    };
};


const $b8e9b03ced2f5e1d$export$63ae3ec177f0ed66 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeOfflineAudioContext.createConstantSource === undefined) return true;
        const nativeConstantSourceNode = nativeOfflineAudioContext.createConstantSource();
        /*
         * @todo This is using bug #75 to detect bug #70. That works because both bugs were unique to
         * the implementation of Firefox right now, but it could probably be done in a better way.
         */ return nativeConstantSourceNode.offset.maxValue !== Number.POSITIVE_INFINITY;
    };
};


// Opera up to version 57 did not allow to reassign the buffer of a ConvolverNode.
const $ae5370edee7f0789$export$b6f3c4027f959b95 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeConvolverNode = offlineAudioContext.createConvolver();
        nativeConvolverNode.buffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
        try {
            nativeConvolverNode.buffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
        } catch  {
            return false;
        }
        return true;
    };
};


// Chrome up to version v80, Edge up to version v80 and Opera up to version v67 did not allow to set the channelCount property of a ConvolverNode to 1. They also did not allow to set the channelCountMode to 'explicit'.
const $9794ec347afccbb2$export$d1bddb88e5c21d26 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeConvolverNode = offlineAudioContext.createConvolver();
        try {
            nativeConvolverNode.channelCount = 1;
        } catch  {
            return false;
        }
        return true;
    };
};


const $e9f4e2f4c6bba1a3$export$41669e689e17d4f0 = (window)=>{
    return ()=>window !== null && window.hasOwnProperty("isSecureContext");
};


// Firefox up to version 68 did not throw an error when creating a MediaStreamAudioSourceNode with a mediaStream that had no audio track.
const $a6a66a7e2897c896$export$416bb3b14425e126 = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        const audioContext = new nativeAudioContextConstructor();
        try {
            audioContext.createMediaStreamSource(new MediaStream());
            return false;
        } catch (err) {
            return true;
        } finally{
            audioContext.close();
        }
    };
};


const $5c0e2069a30b8db9$export$6db7e9dd49157213 = (createNativeGainNode, nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
        const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
            channelCount: 1,
            channelCountMode: "explicit",
            channelInterpretation: "discrete",
            gain: 0
        });
        // Bug #21: Safari does not support promises yet.
        return new Promise((resolve)=>{
            nativeOfflineAudioContext.oncomplete = ()=>{
                gainNode.disconnect();
                resolve(nativeOfflineAudioContext.currentTime !== 0);
            };
            nativeOfflineAudioContext.startRendering();
        });
    };
};


/**
 * Firefox up to version 62 did not kick off the processing of the StereoPannerNode if the value of pan was zero.
 */ const $19fdb5dea8c1aa58$export$5ea70af76c7a03fc = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        /*
         * Bug #105: Safari does not support the StereoPannerNode. Therefore the returned value should normally be false but the faker does
         * support the tested behaviour.
         */ if (nativeOfflineAudioContext.createStereoPanner === undefined) return Promise.resolve(true);
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeOfflineAudioContext.createConstantSource === undefined) return Promise.resolve(true);
        const constantSourceNode = nativeOfflineAudioContext.createConstantSource();
        const stereoPanner = nativeOfflineAudioContext.createStereoPanner();
        constantSourceNode.channelCount = 1;
        constantSourceNode.offset.value = 1;
        stereoPanner.channelCount = 1;
        constantSourceNode.start();
        constantSourceNode.connect(stereoPanner).connect(nativeOfflineAudioContext.destination);
        return nativeOfflineAudioContext.startRendering().then((buffer)=>buffer.getChannelData(0)[0] !== 1);
    };
};


const $d528121802615e67$export$988fb803bae63f80 = ()=>new DOMException("", "UnknownError");


const $58dd6b66debb262c$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: "max",
    channelInterpretation: "speakers",
    curve: null,
    oversample: "none"
};
const $58dd6b66debb262c$export$3a30e911e17b1cf5 = (audioNodeConstructor, createInvalidStateError, createNativeWaveShaperNode, createWaveShaperNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class WaveShaperNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$58dd6b66debb262c$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeWaveShaperNode = createNativeWaveShaperNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const waveShaperNodeRenderer = isOffline ? createWaveShaperNodeRenderer() : null;
            // @todo Add a mechanism to only switch a WaveShaperNode to active while it is connected.
            super(context, true, nativeWaveShaperNode, waveShaperNodeRenderer);
            this._isCurveNullified = false;
            this._nativeWaveShaperNode = nativeWaveShaperNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get curve() {
            if (this._isCurveNullified) return null;
            return this._nativeWaveShaperNode.curve;
        }
        set curve(value) {
            // Bug #103: Safari does not allow to set the curve to null.
            if (value === null) {
                this._isCurveNullified = true;
                this._nativeWaveShaperNode.curve = new Float32Array([
                    0,
                    0
                ]);
            } else {
                // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
                // Bug #104: Chrome and Edge will throw an InvalidAccessError when the curve has less than two samples.
                if (value.length < 2) throw createInvalidStateError();
                this._isCurveNullified = false;
                this._nativeWaveShaperNode.curve = value;
            }
        }
        get oversample() {
            return this._nativeWaveShaperNode.oversample;
        }
        set oversample(value) {
            this._nativeWaveShaperNode.oversample = value;
        }
    };
};




const $99a27f25a76706ec$export$9709a48a5037d121 = (createNativeWaveShaperNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeWaveShaperNodes = new WeakMap();
        const createWaveShaperNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeWaveShaperNode = getNativeAudioNode(proxy);
            // If the initially used nativeWaveShaperNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeWaveShaperNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeWaveShaperNode, nativeOfflineAudioContext);
            if (!nativeWaveShaperNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeWaveShaperNode.channelCount,
                    channelCountMode: nativeWaveShaperNode.channelCountMode,
                    channelInterpretation: nativeWaveShaperNode.channelInterpretation,
                    curve: nativeWaveShaperNode.curve,
                    oversample: nativeWaveShaperNode.oversample
                };
                nativeWaveShaperNode = createNativeWaveShaperNode(nativeOfflineAudioContext, options);
            }
            renderedNativeWaveShaperNodes.set(nativeOfflineAudioContext, nativeWaveShaperNode);
            if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeWaveShaperNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeWaveShaperNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeWaveShaperNode);
            return nativeWaveShaperNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeWaveShaperNode = renderedNativeWaveShaperNodes.get(nativeOfflineAudioContext);
                if (renderedNativeWaveShaperNode !== undefined) return Promise.resolve(renderedNativeWaveShaperNode);
                return createWaveShaperNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $26d12d47448d9dca$export$ba255020126e276e = ()=>typeof window === "undefined" ? null : window;


const $f2cd13b04f18ee3f$export$dbf1ce6ba2b4bc6a = (convertNumberToUnsignedLong, createIndexSizeError)=>{
    return (audioBuffer)=>{
        audioBuffer.copyFromChannel = (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
            const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
            const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
            if (channelNumber >= audioBuffer.numberOfChannels) throw createIndexSizeError();
            const audioBufferLength = audioBuffer.length;
            const channelData = audioBuffer.getChannelData(channelNumber);
            const destinationLength = destination.length;
            for(let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < destinationLength; i += 1)destination[i] = channelData[i + bufferOffset];
        };
        audioBuffer.copyToChannel = (source, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
            const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
            const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
            if (channelNumber >= audioBuffer.numberOfChannels) throw createIndexSizeError();
            const audioBufferLength = audioBuffer.length;
            const channelData = audioBuffer.getChannelData(channelNumber);
            const sourceLength = source.length;
            for(let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < sourceLength; i += 1)channelData[i + bufferOffset] = source[i];
        };
    };
};


const $15fe4df42e65956b$export$bff9a41e76b37a6e = (convertNumberToUnsignedLong)=>{
    return (audioBuffer)=>{
        audioBuffer.copyFromChannel = ((copyFromChannel)=>{
            return (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
                const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
                const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
                if (bufferOffset < audioBuffer.length) return copyFromChannel.call(audioBuffer, destination, channelNumber, bufferOffset);
            };
        })(audioBuffer.copyFromChannel);
        audioBuffer.copyToChannel = ((copyToChannel)=>{
            return (source, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
                const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
                const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
                if (bufferOffset < audioBuffer.length) return copyToChannel.call(audioBuffer, source, channelNumber, bufferOffset);
            };
        })(audioBuffer.copyToChannel);
    };
};


const $0b1629607149f116$export$3c1722ed0f0ed532 = (overwriteAccessors)=>{
    return (nativeAudioBufferSourceNode, nativeContext)=>{
        const nullifiedBuffer = nativeContext.createBuffer(1, 1, 44100);
        if (nativeAudioBufferSourceNode.buffer === null) nativeAudioBufferSourceNode.buffer = nullifiedBuffer;
        overwriteAccessors(nativeAudioBufferSourceNode, "buffer", (get)=>()=>{
                const value = get.call(nativeAudioBufferSourceNode);
                return value === nullifiedBuffer ? null : value;
            }, (set)=>(value)=>{
                return set.call(nativeAudioBufferSourceNode, value === null ? nullifiedBuffer : value);
            });
    };
};


const $afaabbfeccddeb33$export$162785cfa8a63221 = (createInvalidStateError, monitorConnections)=>{
    return (nativeContext, channelMergerNode)=>{
        // Bug #15: Safari does not return the default properties.
        channelMergerNode.channelCount = 1;
        channelMergerNode.channelCountMode = "explicit";
        // Bug #16: Safari does not throw an error when setting a different channelCount or channelCountMode.
        Object.defineProperty(channelMergerNode, "channelCount", {
            get: ()=>1,
            set: ()=>{
                throw createInvalidStateError();
            }
        });
        Object.defineProperty(channelMergerNode, "channelCountMode", {
            get: ()=>"explicit",
            set: ()=>{
                throw createInvalidStateError();
            }
        });
        // Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
        const audioBufferSourceNode = nativeContext.createBufferSource();
        const whenConnected = ()=>{
            const length = channelMergerNode.numberOfInputs;
            for(let i = 0; i < length; i += 1)audioBufferSourceNode.connect(channelMergerNode, 0, i);
        };
        const whenDisconnected = ()=>audioBufferSourceNode.disconnect(channelMergerNode);
        monitorConnections(channelMergerNode, whenConnected, whenDisconnected);
    };
};








const $8d0551d2e3011348$export$4ec0c13c358eb2b5 = (audioBuffer, buffer, channelNumber)=>{
    // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
    if (audioBuffer.copyFromChannel === undefined) return audioBuffer.getChannelData(channelNumber)[0];
    audioBuffer.copyFromChannel(buffer, channelNumber);
    return buffer[0];
};







const $ac5d7f1a7bc00ad1$export$b32eba1f356dc699 = (curve)=>{
    if (curve === null) return false;
    const length = curve.length;
    if (length % 2 !== 0) return curve[Math.floor(length / 2)] !== 0;
    return curve[length / 2 - 1] + curve[length / 2] !== 0;
};




const $530b71ca59aca245$export$f25ed0e1b53c5d37 = (object, property, createGetter, createSetter)=>{
    let prototype = object;
    while(!prototype.hasOwnProperty(property))prototype = Object.getPrototypeOf(prototype);
    const { get: get, set: set } = Object.getOwnPropertyDescriptor(prototype, property);
    Object.defineProperty(object, property, {
        get: createGetter(get),
        set: createSetter(set)
    });
};



const $70e8704c373b96d4$export$9a47aefcb4b02450 = (options)=>{
    return {
        ...options,
        outputChannelCount: options.outputChannelCount !== undefined ? options.outputChannelCount : options.numberOfInputs === 1 && options.numberOfOutputs === 1 ? /*
                   * Bug #61: This should be the computedNumberOfChannels, but unfortunately that is almost impossible to fake. That's why
                   * the channelCountMode is required to be 'explicit' as long as there is not a native implementation in every browser. That
                   * makes sure the computedNumberOfChannels is equivilant to the channelCount which makes it much easier to compute.
                   */ [
            options.channelCount
        ] : Array.from({
            length: options.numberOfOutputs
        }, ()=>1)
    };
};


const $2bf28b0b46226c08$export$6edb0bde597f2c9a = (options)=>{
    return {
        ...options,
        channelCount: options.numberOfOutputs
    };
};


const $c6cbf9b4072d07b5$export$833c872c8eda5015 = (options)=>{
    const { imag: imag, real: real } = options;
    if (imag === undefined) {
        if (real === undefined) return {
            ...options,
            imag: [
                0,
                0
            ],
            real: [
                0,
                0
            ]
        };
        return {
            ...options,
            imag: Array.from(real, ()=>0),
            real: real
        };
    }
    if (real === undefined) return {
        ...options,
        imag: imag,
        real: Array.from(imag, ()=>0)
    };
    return {
        ...options,
        imag: imag,
        real: real
    };
};


const $2a8003ceab32d203$export$652ab3e522965552 = (audioParam, value, startTime)=>{
    try {
        audioParam.setValueAtTime(value, startTime);
    } catch (err) {
        if (err.code !== 9) throw err;
        $2a8003ceab32d203$export$652ab3e522965552(audioParam, value, startTime + 1e-7);
    }
};



const $cfb713f07f55dfb6$export$3211ed65c5b8326b = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.start();
    try {
        nativeAudioBufferSourceNode.start();
    } catch  {
        return true;
    }
    return false;
};


const $d7cdc94b55bf7d89$export$74929efb99360b7a = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    try {
        nativeAudioBufferSourceNode.start(0, 1);
    } catch  {
        return false;
    }
    return true;
};


const $cde727d83b713b25$export$c29f4eec5460fc70 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.start();
    try {
        nativeAudioBufferSourceNode.stop();
    } catch  {
        return false;
    }
    return true;
};


const $e3970505f53334fc$export$9be334adb9176c59 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createOscillator();
    try {
        nativeAudioBufferSourceNode.start(-1);
    } catch (err) {
        return err instanceof RangeError;
    }
    return false;
};


const $537c8041ad676874$export$a7f1019c14a08879 = (nativeContext)=>{
    const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    nativeAudioBufferSourceNode.start();
    nativeAudioBufferSourceNode.stop();
    try {
        nativeAudioBufferSourceNode.stop();
        return true;
    } catch  {
        return false;
    }
};


const $dadc6bbe89a710a4$export$67a72517a9facc5 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createOscillator();
    try {
        nativeAudioBufferSourceNode.stop(-1);
    } catch (err) {
        return err instanceof RangeError;
    }
    return false;
};


const $39927bdf4fc4578b$export$a40748749fc273c5 = (audioWorkletNodeOptions)=>{
    const { port1: port1, port2: port2 } = new MessageChannel();
    try {
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port1.postMessage(audioWorkletNodeOptions);
    } finally{
        port1.close();
        port2.close();
    }
};


/*
 * Bug #122: Edge up to version v18 did not allow to construct a DOMException'. It also had a couple more bugs but since this is easy to
 * test it's used here as a placeholder.
 *
 * Bug #27: Edge up to version v18 did reject an invalid arrayBuffer passed to decodeAudioData() with a DOMException.
 *
 * Bug #50: Edge up to version v18 did not allow to create AudioNodes on a closed context.
 *
 * Bug #57: Edge up to version v18 did not throw an error when assigning the type of an OscillatorNode to 'custom'.
 *
 * Bug #63: Edge up to version v18 did not expose the mediaElement property of a MediaElementAudioSourceNode.
 *
 * Bug #64: Edge up to version v18 did not support the MediaStreamAudioDestinationNode.
 *
 * Bug #71: Edge up to version v18 did not allow to set the buffer of an AudioBufferSourceNode to null.
 *
 * Bug #93: Edge up to version v18 did set the sampleRate of an AudioContext to zero when it was closed.
 *
 * Bug #101: Edge up to version v18 refused to execute decodeAudioData() on a closed context.
 *
 * Bug #106: Edge up to version v18 did not expose the maxValue and minValue properties of the pan AudioParam of a StereoPannerNode.
 *
 * Bug #110: Edge up to version v18 did not expose the maxValue and minValue properties of the attack, knee, ratio, release and threshold AudioParams of a DynamicsCompressorNode.
 *
 * Bug #123: Edge up to version v18 did not support HRTF as the panningModel for a PannerNode.
 *
 * Bug #145: Edge up to version v18 did throw an IndexSizeError when an OfflineAudioContext was created with a sampleRate of zero.
 *
 * Bug #161: Edge up to version v18 did not expose the maxValue and minValue properties of the delayTime AudioParam of a DelayNode.
 */ const $d626a25f56a8d82b$export$1310f0b96d9d8115 = ()=>{
    try {
        new DOMException(); // tslint:disable-line:no-unused-expression
    } catch  {
        return false;
    }
    return true;
};



// Safari at version 11 did not support transferables.
const $54d8faf59e52b4bd$export$4f6e0d4bb1ead9ce = ()=>new Promise((resolve)=>{
        const arrayBuffer = new ArrayBuffer(0);
        const { port1: port1, port2: port2 } = new MessageChannel();
        port1.onmessage = ({ data: data })=>resolve(data !== null);
        port2.postMessage(arrayBuffer, [
            arrayBuffer
        ]);
    });


const $2d8df0897195a211$export$c3eb87c85305df2 = (nativeAudioBufferSourceNode)=>{
    nativeAudioBufferSourceNode.start = ((start)=>{
        return (when = 0, offset = 0, duration)=>{
            const buffer = nativeAudioBufferSourceNode.buffer;
            // Bug #154: Safari does not clamp the offset if it is equal to or greater than the duration of the buffer.
            const clampedOffset = buffer === null ? offset : Math.min(buffer.duration, offset);
            // Bug #155: Safari does not handle the offset correctly if it would cause the buffer to be not be played at all.
            if (buffer !== null && clampedOffset > buffer.duration - 0.5 / nativeAudioBufferSourceNode.context.sampleRate) start.call(nativeAudioBufferSourceNode, when, 0, 0);
            else start.call(nativeAudioBufferSourceNode, when, clampedOffset, duration);
        };
    })(nativeAudioBufferSourceNode.start);
};



const $e13cb619e47d347b$export$587074127be31245 = (nativeAudioScheduledSourceNode, nativeContext)=>{
    const nativeGainNode = nativeContext.createGain();
    nativeAudioScheduledSourceNode.connect(nativeGainNode);
    const disconnectGainNode = ((disconnect)=>{
        return ()=>{
            // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
            disconnect.call(nativeAudioScheduledSourceNode, nativeGainNode);
            nativeAudioScheduledSourceNode.removeEventListener("ended", disconnectGainNode);
        };
    })(nativeAudioScheduledSourceNode.disconnect);
    nativeAudioScheduledSourceNode.addEventListener("ended", disconnectGainNode);
    (0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeAudioScheduledSourceNode, nativeGainNode);
    nativeAudioScheduledSourceNode.stop = ((stop)=>{
        let isStopped = false;
        return (when = 0)=>{
            if (isStopped) try {
                stop.call(nativeAudioScheduledSourceNode, when);
            } catch  {
                nativeGainNode.gain.setValueAtTime(0, when);
            }
            else {
                stop.call(nativeAudioScheduledSourceNode, when);
                isStopped = true;
            }
        };
    })(nativeAudioScheduledSourceNode.stop);
};


const $507dfbd6dc37b887$export$63f14ca2e716ed28 = (target, eventListener)=>{
    return (event)=>{
        const descriptor = {
            value: target
        };
        Object.defineProperties(event, {
            currentTarget: descriptor,
            target: descriptor
        });
        if (typeof eventListener === "function") return eventListener.call(target, event);
        return eventListener.handleEvent.call(target, event);
    };
};








































































































































































// @todo This is currently named IWorkletOptions and not IAudioWorkletOptions because it defines the options of a generic Worklet.




























































































































































































































































































































































































































































































































































































































































































































































































































const $73de05636a272705$var$addActiveInputConnectionToAudioNode = (0, $7f23be3a1785a3a3$export$43d20cccdc976834)((0, $b5b160ddb9cb72cc$export$64505511c8abc942));
const $73de05636a272705$var$addPassiveInputConnectionToAudioNode = (0, $3166079db94aa9a9$export$67aa4e90be3a506b)((0, $b5b160ddb9cb72cc$export$64505511c8abc942));
const $73de05636a272705$var$deleteActiveInputConnectionToAudioNode = (0, $e39a769fcfed862a$export$1f7c0152b9e322ae)((0, $b4907d346209c4aa$export$3f1b331b43a0e659));
const $73de05636a272705$var$audioNodeTailTimeStore = new WeakMap();
const $73de05636a272705$var$getAudioNodeTailTime = (0, $1c502bf8d77347a3$export$4abc3abd061bc2cc)($73de05636a272705$var$audioNodeTailTimeStore);
const $73de05636a272705$var$cacheTestResult = (0, $c8f9a173cc3bf911$export$e72d622686b5f6c7)(new Map(), new WeakMap());
const $73de05636a272705$var$window = (0, $26d12d47448d9dca$export$ba255020126e276e)();
const $73de05636a272705$var$createNativeAnalyserNode = (0, $e8efe05ceea76e6b$export$36e704ad7c903a26)($73de05636a272705$var$cacheTestResult, (0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$var$getAudioNodeRenderer = (0, $177173849cab3696$export$97bb1acefff8970e)((0, $b599ef0c4650ec6d$export$6b29eee2af836dfc));
const $73de05636a272705$var$renderInputsOfAudioNode = (0, $d2ccdaf328a083a6$export$cff0938ddf51f6f4)((0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), $73de05636a272705$var$getAudioNodeRenderer, (0, $5ab4cc8140911ed0$export$8658a39a04a404d5));
const $73de05636a272705$var$createAnalyserNodeRenderer = (0, $af022ab249d12b4e$export$5fe3f5c2d995fe20)($73de05636a272705$var$createNativeAnalyserNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$var$getNativeContext = (0, $ab34c55943f983a2$export$797a319a8065fb37)((0, $7718e734b2fef711$export$7d17302229276f06));
const $73de05636a272705$var$nativeOfflineAudioContextConstructor = (0, $19c5a8e8a9bd3d9c$export$e628a2a5fd5b78b9)($73de05636a272705$var$window);
const $73de05636a272705$var$isNativeOfflineAudioContext = (0, $1f51870159fb4148$export$722bd4bab77df75a)($73de05636a272705$var$nativeOfflineAudioContextConstructor);
const $73de05636a272705$var$audioParamAudioNodeStore = new WeakMap();
const $73de05636a272705$var$eventTargetConstructor = (0, $2c6595a0ef043725$export$a512af3fc2ab91f2)((0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$nativeAudioContextConstructor = (0, $efc1676639ecd3f0$export$3a22fc4046f7b4ec)($73de05636a272705$var$window);
const $73de05636a272705$var$isNativeAudioContext = (0, $5c37aa119fcb440b$export$5d44272df169092e)($73de05636a272705$var$nativeAudioContextConstructor);
const $73de05636a272705$var$isNativeAudioNode = (0, $3b617a30f7d7e286$export$96f2bb6e8a5795ea)($73de05636a272705$var$window);
const $73de05636a272705$var$isNativeAudioParam = (0, $3ef59b79efb5ffe7$export$7c3a44537acaf24e)($73de05636a272705$var$window);
const $73de05636a272705$var$nativeAudioWorkletNodeConstructor = (0, $8a58495112d71adf$export$b0ef4818c07d1453)($73de05636a272705$var$window);
const $73de05636a272705$var$audioNodeConstructor = (0, $17fd1e9637f226c8$export$20e3fa4f981cb01d)((0, $38a67e4228ec27a5$export$7ff07578cebde522)((0, $7718e734b2fef711$export$61ca80a8c8c6d728)), (0, $dc45a634363b6091$export$1776cf0d295db1d7)($73de05636a272705$var$addActiveInputConnectionToAudioNode, $73de05636a272705$var$addPassiveInputConnectionToAudioNode, (0, $19c742083556a242$export$b92162b3199b4461), $73de05636a272705$var$deleteActiveInputConnectionToAudioNode, (0, $c5150425da7035f6$export$a19b495df4b88921), (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), $73de05636a272705$var$getAudioNodeTailTime, (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25), (0, $f19824d1c532946e$export$e719c0d45ea16d08), (0, $b5b160ddb9cb72cc$export$64505511c8abc942), (0, $74af653805090ad8$export$e44f0fc8e83fb084), (0, $5ab4cc8140911ed0$export$8658a39a04a404d5), (0, $a8abf1563cb0cb90$export$79a7cb9fa56970e)), $73de05636a272705$var$cacheTestResult, (0, $f105592837a72b2d$export$e306a463e9286bbd)((0, $7718e734b2fef711$export$cf686a6a3e402092), (0, $c5150425da7035f6$export$a19b495df4b88921), (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), (0, $f19824d1c532946e$export$e719c0d45ea16d08), (0, $6cb22515327e5f96$export$fad3d843b2a56ffb), (0, $74af653805090ad8$export$e44f0fc8e83fb084)), (0, $e1139ef113001733$export$926e4aa3eed6ec13), (0, $480811f16570294f$export$254c536c2ca9b917), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $c348d8459649177f$export$93f58f9268fde9f6)((0, $19c742083556a242$export$b92162b3199b4461), (0, $7718e734b2fef711$export$cf686a6a3e402092), (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), (0, $f19824d1c532946e$export$e719c0d45ea16d08), (0, $6cb22515327e5f96$export$fad3d843b2a56ffb), $73de05636a272705$var$getNativeContext, (0, $74af653805090ad8$export$e44f0fc8e83fb084), $73de05636a272705$var$isNativeOfflineAudioContext), (0, $60aaea16e2e167aa$export$b4f8d2824d9887dc)($73de05636a272705$var$audioParamAudioNodeStore, (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), (0, $88ab0c374f97b769$export$520987e3ff3ffad3)), $73de05636a272705$var$eventTargetConstructor, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeAudioContext, $73de05636a272705$var$isNativeAudioNode, $73de05636a272705$var$isNativeAudioParam, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$nativeAudioWorkletNodeConstructor);
const $73de05636a272705$export$ed204192bbbabcef = (0, $108e1fe42ca28dbf$export$569b2da15d7fe153)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAnalyserNodeRenderer, (0, $e1139ef113001733$export$926e4aa3eed6ec13), $73de05636a272705$var$createNativeAnalyserNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$audioBufferStore = new WeakSet();
const $73de05636a272705$var$nativeAudioBufferConstructor = (0, $3fdc510d024142a6$export$1ddb6a79e564be96)($73de05636a272705$var$window);
const $73de05636a272705$var$convertNumberToUnsignedLong = (0, $9b55f1ea73efe39c$export$540e228106d2c471)(new Uint32Array(1));
const $73de05636a272705$var$wrapAudioBufferCopyChannelMethods = (0, $f2cd13b04f18ee3f$export$dbf1ce6ba2b4bc6a)($73de05636a272705$var$convertNumberToUnsignedLong, (0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$var$wrapAudioBufferCopyChannelMethodsOutOfBounds = (0, $15fe4df42e65956b$export$bff9a41e76b37a6e)($73de05636a272705$var$convertNumberToUnsignedLong);
const $73de05636a272705$export$2dbca7d91f7769d7 = (0, $05b6b25752b14d73$export$c8b88126795b7df2)($73de05636a272705$var$audioBufferStore, $73de05636a272705$var$cacheTestResult, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$nativeAudioBufferConstructor, $73de05636a272705$var$nativeOfflineAudioContextConstructor, (0, $3988bd8c6f69cf53$export$5bddcff46df9c642)($73de05636a272705$var$nativeAudioBufferConstructor), $73de05636a272705$var$wrapAudioBufferCopyChannelMethods, $73de05636a272705$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $73de05636a272705$var$addSilentConnection = (0, $8d968cebac7e2205$export$c6991e18a29704b9)((0, $525849e875dd580b$export$7cf909169b9c4d6f));
const $73de05636a272705$var$renderInputsOfAudioParam = (0, $6ca48f6db88647ab$export$82cd58acb1062198)($73de05636a272705$var$getAudioNodeRenderer, (0, $ca92fb3bedacccdf$export$1b11f454bf19657), (0, $5ab4cc8140911ed0$export$8658a39a04a404d5));
const $73de05636a272705$var$connectAudioParam = (0, $d4e4872b149da763$export$1e69fdca2ad79f10)($73de05636a272705$var$renderInputsOfAudioParam);
const $73de05636a272705$var$createNativeAudioBufferSourceNode = (0, $fed0da5959484c32$export$4f48c993f264b207)($73de05636a272705$var$addSilentConnection, $73de05636a272705$var$cacheTestResult, (0, $cfb713f07f55dfb6$export$3211ed65c5b8326b), (0, $d7cdc94b55bf7d89$export$74929efb99360b7a), (0, $cde727d83b713b25$export$c29f4eec5460fc70), (0, $e3970505f53334fc$export$9be334adb9176c59), (0, $537c8041ad676874$export$a7f1019c14a08879), (0, $dadc6bbe89a710a4$export$67a72517a9facc5), (0, $2d8df0897195a211$export$c3eb87c85305df2), (0, $0b1629607149f116$export$3c1722ed0f0ed532)((0, $530b71ca59aca245$export$f25ed0e1b53c5d37)), (0, $e13cb619e47d347b$export$587074127be31245));
const $73de05636a272705$var$renderAutomation = (0, $49e48dbdfe378aa1$export$889eef7d338963f6)((0, $3555b7973f69ce40$export$1653dd3e76bcb1b0)((0, $ca92fb3bedacccdf$export$1b11f454bf19657)), $73de05636a272705$var$renderInputsOfAudioParam);
const $73de05636a272705$var$createAudioBufferSourceNodeRenderer = (0, $a4008e06a1e577c4$export$82721be5d1bb22c5)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeAudioBufferSourceNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$var$createAudioParam = (0, $361bc03ea1ca7077$export$25d3edb077748cfc)((0, $75c70a9d5b9cda8b$export$25226f7a087f88c3)((0, $7718e734b2fef711$export$c5d3ff1f46a0185a)), $73de05636a272705$var$audioParamAudioNodeStore, (0, $7718e734b2fef711$export$55484e3055c7a9e2), (0, $403e2aebd17670b8$export$8858f507eb103ac6), (0, $8f6857d83370bfe9$exports.createCancelAndHoldAutomationEvent), (0, $8f6857d83370bfe9$exports.createCancelScheduledValuesAutomationEvent), (0, $8f6857d83370bfe9$exports.createExponentialRampToValueAutomationEvent), (0, $8f6857d83370bfe9$exports.createLinearRampToValueAutomationEvent), (0, $8f6857d83370bfe9$exports.createSetTargetAutomationEvent), (0, $8f6857d83370bfe9$exports.createSetValueAutomationEvent), (0, $8f6857d83370bfe9$exports.createSetValueCurveAutomationEvent), $73de05636a272705$var$nativeAudioContextConstructor, (0, $2a8003ceab32d203$export$652ab3e522965552));
const $73de05636a272705$export$c1b1480edd16e065 = (0, $55305446a68bbcd4$export$6857b764b4428518)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioBufferSourceNodeRenderer, $73de05636a272705$var$createAudioParam, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeAudioBufferSourceNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, (0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$audioDestinationNodeConstructor = (0, $3c5495fa70efa802$export$cbbb0c3ba3f5dd5b)($73de05636a272705$var$audioNodeConstructor, (0, $722e3b4b287a6f68$export$d44f3f5d4e42ced2), (0, $e1139ef113001733$export$926e4aa3eed6ec13), (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $a12f35f127b69772$export$d3097038f258fce)((0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $530b71ca59aca245$export$f25ed0e1b53c5d37)), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$var$createBiquadFilterNodeRenderer = (0, $bcf262a04dcb901f$export$1532cc6682032d84)($73de05636a272705$var$connectAudioParam, (0, $e80fde9dac479cbc$export$97e69c8dbd260f85), (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$var$setAudioNodeTailTime = (0, $63b106594231aed7$export$c5e78cc8035d00aa)($73de05636a272705$var$audioNodeTailTimeStore);
const $73de05636a272705$export$f068340fbfd684eb = (0, $66a4e6e6f309207a$export$aa421daabad177b5)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createBiquadFilterNodeRenderer, (0, $480811f16570294f$export$254c536c2ca9b917), (0, $e80fde9dac479cbc$export$97e69c8dbd260f85), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$monitorConnections = (0, $0c25af19b608275a$export$9f33b5a0b80f2717)((0, $b5b160ddb9cb72cc$export$64505511c8abc942), $73de05636a272705$var$isNativeAudioNode);
const $73de05636a272705$var$wrapChannelMergerNode = (0, $afaabbfeccddeb33$export$162785cfa8a63221)((0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeChannelMergerNode = (0, $2a5d9150f87cc567$export$99fe194415d94151)($73de05636a272705$var$nativeAudioContextConstructor, $73de05636a272705$var$wrapChannelMergerNode);
const $73de05636a272705$var$createChannelMergerNodeRenderer = (0, $49bc852e7ae475d1$export$79056cbe2b10cae5)($73de05636a272705$var$createNativeChannelMergerNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$7488bfd772ec10fc = (0, $d240d532973e561a$export$a65a5a400135d27)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createChannelMergerNodeRenderer, $73de05636a272705$var$createNativeChannelMergerNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$createChannelSplitterNodeRenderer = (0, $cbf1ca25428a2bfd$export$d815cad16abde9c3)((0, $fb7eeefbad4e691e$export$17649533bf213707), (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$6f860927b3cf75c1 = (0, $ecc7f6221abcb6cb$export$ce9d996cafa605b)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createChannelSplitterNodeRenderer, (0, $fb7eeefbad4e691e$export$17649533bf213707), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, (0, $2bf28b0b46226c08$export$6edb0bde597f2c9a));
const $73de05636a272705$var$createNativeConstantSourceNodeFaker = (0, $7750b35622dacdb4$export$360749cf3d02285a)($73de05636a272705$var$addSilentConnection, $73de05636a272705$var$createNativeAudioBufferSourceNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeConstantSourceNode = (0, $cc19291652c95d8b$export$2dd44f7bb3dd8089)($73de05636a272705$var$addSilentConnection, $73de05636a272705$var$cacheTestResult, $73de05636a272705$var$createNativeConstantSourceNodeFaker, (0, $e3970505f53334fc$export$9be334adb9176c59), (0, $dadc6bbe89a710a4$export$67a72517a9facc5));
const $73de05636a272705$var$createConstantSourceNodeRenderer = (0, $03ead4cb10fa624b$export$bc541a3c87b45a7d)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeConstantSourceNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$d394f3dc072b3480 = (0, $a2dd1c01048670e7$export$a02a9a6200996500)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createConstantSourceNodeRenderer, $73de05636a272705$var$createNativeConstantSourceNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, (0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$createNativeConvolverNode = (0, $370e4f21c26d451c$export$afdcf89d13ff62e)((0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $530b71ca59aca245$export$f25ed0e1b53c5d37));
const $73de05636a272705$var$createConvolverNodeRenderer = (0, $8432906c3c9b8cbf$export$5b278ccdb1a6393)($73de05636a272705$var$createNativeConvolverNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$20cfee6cb9c5d644 = (0, $841973333d0cd390$export$4894173a4b4ee485)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createConvolverNodeRenderer, $73de05636a272705$var$createNativeConvolverNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createDelayNodeRenderer = (0, $f2c53e2a23d66a37$export$d03c2308083a28e5)($73de05636a272705$var$connectAudioParam, (0, $ef87939e6b57ab0a$export$f7dd6d407a2109ef), (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$ce8664483cc583db = (0, $8e78583293513642$export$b89a0215c1c607e3)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createDelayNodeRenderer, (0, $ef87939e6b57ab0a$export$f7dd6d407a2109ef), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createNativeDynamicsCompressorNode = (0, $3bed81c18206a0fd$export$f19d90a0cd4a2ecc)((0, $b285affc6d8be1e4$export$dbebdb13622d486c));
const $73de05636a272705$var$createDynamicsCompressorNodeRenderer = (0, $c9213159046e81d8$export$1b1e82cc3f0a2c8)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeDynamicsCompressorNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$c74a663d797d02ba = (0, $84171167562b7343$export$60ec6725c2d45fc8)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createDynamicsCompressorNodeRenderer, $73de05636a272705$var$createNativeDynamicsCompressorNode, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createGainNodeRenderer = (0, $49cb70513208922e$export$7312404e5bea9cd)($73de05636a272705$var$connectAudioParam, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$db147ea22bd7e3ce = (0, $98e2667480721d0b$export$7b37b693b55bf5d7)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createGainNodeRenderer, (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$createNativeIIRFilterNodeFaker = (0, $9c6b76deea631207$export$49dca6a724f463b)((0, $480811f16570294f$export$254c536c2ca9b917), (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $cb688845d3eca55e$export$9f784f497a6d6acb), (0, $b285affc6d8be1e4$export$dbebdb13622d486c));
const $73de05636a272705$var$renderNativeOfflineAudioContext = (0, $ed4f60f8df7f2dc8$export$feb8d4a8e403af48)($73de05636a272705$var$cacheTestResult, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $cb688845d3eca55e$export$9f784f497a6d6acb), (0, $5c0e2069a30b8db9$export$6db7e9dd49157213)((0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$nativeOfflineAudioContextConstructor));
const $73de05636a272705$var$createIIRFilterNodeRenderer = (0, $5f4b0a4e5f013c82$export$329316f0ca6cf17e)($73de05636a272705$var$createNativeAudioBufferSourceNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$nativeOfflineAudioContextConstructor, $73de05636a272705$var$renderInputsOfAudioNode, $73de05636a272705$var$renderNativeOfflineAudioContext);
const $73de05636a272705$var$createNativeIIRFilterNode = (0, $45205c9bc193dafd$export$3c1aed24ed6efd9d)($73de05636a272705$var$createNativeIIRFilterNodeFaker);
const $73de05636a272705$export$81c00f34825a7708 = (0, $d8dda65cffc64cac$export$a22f1eb785a05608)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createNativeIIRFilterNode, $73de05636a272705$var$createIIRFilterNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createAudioListener = (0, $76e2077b6d4a003e$export$3e70692c55bd5b52)($73de05636a272705$var$createAudioParam, $73de05636a272705$var$createNativeChannelMergerNode, $73de05636a272705$var$createNativeConstantSourceNode, (0, $cb688845d3eca55e$export$9f784f497a6d6acb), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $8d0551d2e3011348$export$4ec0c13c358eb2b5), $73de05636a272705$var$isNativeOfflineAudioContext, (0, $530b71ca59aca245$export$f25ed0e1b53c5d37));
const $73de05636a272705$var$unrenderedAudioWorkletNodeStore = new WeakMap();
const $73de05636a272705$var$minimalBaseAudioContextConstructor = (0, $487edb0432cdd783$export$3f49d9c870ba2692)($73de05636a272705$var$audioDestinationNodeConstructor, $73de05636a272705$var$createAudioListener, $73de05636a272705$var$eventTargetConstructor, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$unrenderedAudioWorkletNodeStore, (0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$createNativeOscillatorNode = (0, $138975cc1d22c83a$export$a40e02c218ae01d3)($73de05636a272705$var$addSilentConnection, $73de05636a272705$var$cacheTestResult, (0, $e3970505f53334fc$export$9be334adb9176c59), (0, $537c8041ad676874$export$a7f1019c14a08879), (0, $dadc6bbe89a710a4$export$67a72517a9facc5), (0, $e13cb619e47d347b$export$587074127be31245));
const $73de05636a272705$var$createOscillatorNodeRenderer = (0, $0d4239b2159c3e55$export$99143538b3590be5)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeOscillatorNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$f44e83cdc55961f2 = (0, $36f6248399d5f3b2$export$c1c3584074b042b3)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createNativeOscillatorNode, $73de05636a272705$var$createOscillatorNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, (0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$createConnectedNativeAudioBufferSourceNode = (0, $c57fc422e0055003$export$e82b2b63ea82dc82)($73de05636a272705$var$createNativeAudioBufferSourceNode);
const $73de05636a272705$var$createNativeWaveShaperNodeFaker = (0, $e6b48514e14721aa$export$f5f0b26abc22907e)($73de05636a272705$var$createConnectedNativeAudioBufferSourceNode, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $ac5d7f1a7bc00ad1$export$b32eba1f356dc699), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeWaveShaperNode = (0, $a275aa5a2c573982$export$75168c4c8ce320c4)($73de05636a272705$var$createConnectedNativeAudioBufferSourceNode, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeWaveShaperNodeFaker, (0, $ac5d7f1a7bc00ad1$export$b32eba1f356dc699), $73de05636a272705$var$monitorConnections, $73de05636a272705$var$nativeAudioContextConstructor, (0, $530b71ca59aca245$export$f25ed0e1b53c5d37));
const $73de05636a272705$var$createNativePannerNodeFaker = (0, $4d9cae61d16712a4$export$f04468477689c1b4)((0, $19c742083556a242$export$b92162b3199b4461), (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeChannelMergerNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $cb688845d3eca55e$export$9f784f497a6d6acb), $73de05636a272705$var$createNativeWaveShaperNode, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $c5150425da7035f6$export$a19b495df4b88921), (0, $8d0551d2e3011348$export$4ec0c13c358eb2b5), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativePannerNode = (0, $d34e0e0fbe459c97$export$8e3c89af72a58833)($73de05636a272705$var$createNativePannerNodeFaker);
const $73de05636a272705$var$createPannerNodeRenderer = (0, $23fb3d183f13b7ce$export$ccd091498494025)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeChannelMergerNode, $73de05636a272705$var$createNativeConstantSourceNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$createNativePannerNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$nativeOfflineAudioContextConstructor, $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode, $73de05636a272705$var$renderNativeOfflineAudioContext);
const $73de05636a272705$export$dafa2f26c98332af = (0, $ab22fa9f2ae9cf1a$export$91b046021cf98bac)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createNativePannerNode, $73de05636a272705$var$createPannerNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createNativePeriodicWave = (0, $a6ed532ea5998f8a$export$3f519524c23feca0)((0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$export$6b71e63ac9d62aa3 = (0, $51d2e80f451b9759$export$10e47cfa48a5069d)($73de05636a272705$var$createNativePeriodicWave, $73de05636a272705$var$getNativeContext, new WeakSet(), (0, $c6cbf9b4072d07b5$export$833c872c8eda5015));
const $73de05636a272705$var$nativeStereoPannerNodeFakerFactory = (0, $ea55b90e6ec12a54$export$5fe2a787c06b2d34)($73de05636a272705$var$createNativeChannelMergerNode, (0, $fb7eeefbad4e691e$export$17649533bf213707), (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$createNativeWaveShaperNode, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeStereoPannerNode = (0, $e0e74a050611c4ea$export$247580dcf7d2f2c4)($73de05636a272705$var$nativeStereoPannerNodeFakerFactory, (0, $b285affc6d8be1e4$export$dbebdb13622d486c));
const $73de05636a272705$var$createStereoPannerNodeRenderer = (0, $32b7f7e177963e5c$export$3ba9002bd6b539cf)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeStereoPannerNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$4ee0e4c1628c69a6 = (0, $24f00fc15291a590$export$9b005b0c35721c84)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createNativeStereoPannerNode, $73de05636a272705$var$createStereoPannerNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$createWaveShaperNodeRenderer = (0, $99a27f25a76706ec$export$9709a48a5037d121)($73de05636a272705$var$createNativeWaveShaperNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$400071720810ca26 = (0, $58dd6b66debb262c$export$3a30e911e17b1cf5)($73de05636a272705$var$audioNodeConstructor, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeWaveShaperNode, $73de05636a272705$var$createWaveShaperNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$isSecureContext = (0, $484b240e3f1f979d$export$2e9a7e6b17a9abae)($73de05636a272705$var$window);
const $73de05636a272705$var$exposeCurrentFrameAndCurrentTime = (0, $a687388505de094d$export$c43b8ab5e8913cbb)($73de05636a272705$var$window);
const $73de05636a272705$var$backupOfflineAudioContextStore = new WeakMap();
const $73de05636a272705$var$getOrCreateBackupOfflineAudioContext = (0, $307a3ed6925bb7b6$export$70df0ae42e1340c8)($73de05636a272705$var$backupOfflineAudioContextStore, $73de05636a272705$var$nativeOfflineAudioContextConstructor);
const $73de05636a272705$export$f820757b6d3df312 = $73de05636a272705$var$isSecureContext ? (0, $a5628482838dda15$export$16c6049a33c70efa)($73de05636a272705$var$cacheTestResult, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $6d1c2f45ab543604$export$43b563d089dd1d8)($73de05636a272705$var$window), $73de05636a272705$var$exposeCurrentFrameAndCurrentTime, (0, $0835f0aafb89dee3$export$c7282a393375a8ca)((0, $a18cf10db56d480b$export$aff31bd5258e9fd4)), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$getOrCreateBackupOfflineAudioContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$nativeAudioWorkletNodeConstructor, new WeakMap(), new WeakMap(), (0, $f022a9196cd0a0cb$export$19b2cf184a7cfba8)($73de05636a272705$var$nativeAudioWorkletNodeConstructor, $73de05636a272705$var$nativeOfflineAudioContextConstructor), // @todo window is guaranteed to be defined because isSecureContext checks that as well.
$73de05636a272705$var$window) : undefined;
const $73de05636a272705$var$isNativeContext = (0, $c44d077ff851f0da$export$a7c969701e5471d0)($73de05636a272705$var$isNativeAudioContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$1fbfb80f24dc90ea = (0, $9c7b16fbc9ba5a0d$export$d83e4a6039bccfb)($73de05636a272705$var$audioBufferStore, $73de05636a272705$var$cacheTestResult, (0, $c9e239e1d431cf9c$export$fc1a599a84ca01a8), (0, $d2cc4ba64859d7eb$export$6372d3d9069bc778), new WeakSet(), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeContext, (0, $00de7ef4427b01cb$export$54e424f510c54ced), (0, $4590a073dac74a1e$export$9ec44223b1284cd4), $73de05636a272705$var$wrapAudioBufferCopyChannelMethods, $73de05636a272705$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $73de05636a272705$var$baseAudioContextConstructor = (0, $c7dce4d973e69828$export$7824d6f4713e1e35)($73de05636a272705$export$f820757b6d3df312, $73de05636a272705$export$ed204192bbbabcef, $73de05636a272705$export$2dbca7d91f7769d7, $73de05636a272705$export$c1b1480edd16e065, $73de05636a272705$export$f068340fbfd684eb, $73de05636a272705$export$7488bfd772ec10fc, $73de05636a272705$export$6f860927b3cf75c1, $73de05636a272705$export$d394f3dc072b3480, $73de05636a272705$export$20cfee6cb9c5d644, $73de05636a272705$export$1fbfb80f24dc90ea, $73de05636a272705$export$ce8664483cc583db, $73de05636a272705$export$c74a663d797d02ba, $73de05636a272705$export$db147ea22bd7e3ce, $73de05636a272705$export$81c00f34825a7708, $73de05636a272705$var$minimalBaseAudioContextConstructor, $73de05636a272705$export$f44e83cdc55961f2, $73de05636a272705$export$dafa2f26c98332af, $73de05636a272705$export$6b71e63ac9d62aa3, $73de05636a272705$export$4ee0e4c1628c69a6, $73de05636a272705$export$400071720810ca26);
const $73de05636a272705$export$cbdfd9619c90296e = (0, $5a5644b592df0bad$export$d24d3af0853fd021)($73de05636a272705$var$audioNodeConstructor, (0, $d4deb99e9b2af7cd$export$2b1682bf41b4d16b), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$3ebbc22363b821ba = (0, $f377f0e28dbb751d$export$5d3ee2470cd2874)($73de05636a272705$var$audioNodeConstructor, (0, $94c6adbd7f255efe$export$acb51039efa3405d), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$57f554392102e4c0 = (0, $304864b5ea02e52c$export$a42e10687df73a9d)($73de05636a272705$var$audioNodeConstructor, (0, $b4d28d9c960c771a$export$ad3e497ef44fc577), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$createNativeMediaStreamTrackAudioSourceNode = (0, $0d8737ad5d3f94df$export$87e46bc6eb8ed6ac)((0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$b6c8ffccaed2d826 = (0, $11b69ddc6f63f0f2$export$24f27d34fdf823bc)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createNativeMediaStreamTrackAudioSourceNode, $73de05636a272705$var$getNativeContext);
const $73de05636a272705$export$fcbc63750ec2a81f = (0, $57f46748bc9ae741$export$c6fe175def53ff71)($73de05636a272705$var$baseAudioContextConstructor, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $d528121802615e67$export$988fb803bae63f80), $73de05636a272705$export$cbdfd9619c90296e, $73de05636a272705$export$3ebbc22363b821ba, $73de05636a272705$export$57f554392102e4c0, $73de05636a272705$export$b6c8ffccaed2d826, $73de05636a272705$var$nativeAudioContextConstructor);
const $73de05636a272705$var$getUnrenderedAudioWorkletNodes = (0, $7674436fc406d726$export$43ef7eb1ae3d2f40)($73de05636a272705$var$unrenderedAudioWorkletNodeStore);
const $73de05636a272705$var$addUnrenderedAudioWorkletNode = (0, $c770a27b2f3749ca$export$fd0136b1517d036f)($73de05636a272705$var$getUnrenderedAudioWorkletNodes);
const $73de05636a272705$var$connectMultipleOutputs = (0, $69e4c3c94e06c765$export$5f708e50316bf1a)((0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$var$deleteUnrenderedAudioWorkletNode = (0, $aaeabd7f1c2ff532$export$92df121abbf21dca)($73de05636a272705$var$getUnrenderedAudioWorkletNodes);
const $73de05636a272705$var$disconnectMultipleOutputs = (0, $777f7939fea8f1ed$export$78a992fad11cd00e)((0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$var$activeAudioWorkletNodeInputsStore = new WeakMap();
const $73de05636a272705$var$getActiveAudioWorkletNodeInputs = (0, $987f4a38ab3c6a37$export$8b01844840684f8d)($73de05636a272705$var$activeAudioWorkletNodeInputsStore, (0, $88ab0c374f97b769$export$520987e3ff3ffad3));
const $73de05636a272705$var$createNativeAudioWorkletNodeFaker = (0, $d96ad3d348a8f882$export$ea40f9f600f0adcb)($73de05636a272705$var$connectMultipleOutputs, (0, $e1139ef113001733$export$926e4aa3eed6ec13), (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeChannelMergerNode, (0, $fb7eeefbad4e691e$export$17649533bf213707), $73de05636a272705$var$createNativeConstantSourceNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $cb688845d3eca55e$export$9f784f497a6d6acb), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$disconnectMultipleOutputs, $73de05636a272705$var$exposeCurrentFrameAndCurrentTime, $73de05636a272705$var$getActiveAudioWorkletNodeInputs, $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeAudioWorkletNode = (0, $81c404ba25d71de5$export$a6399b47836cd044)((0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeAudioWorkletNodeFaker, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createAudioWorkletNodeRenderer = (0, $b10bbde18d49daa1$export$3a898af5d2b29a5b)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$connectMultipleOutputs, $73de05636a272705$var$createNativeAudioBufferSourceNode, $73de05636a272705$var$createNativeChannelMergerNode, (0, $fb7eeefbad4e691e$export$17649533bf213707), $73de05636a272705$var$createNativeConstantSourceNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$deleteUnrenderedAudioWorkletNode, $73de05636a272705$var$disconnectMultipleOutputs, $73de05636a272705$var$exposeCurrentFrameAndCurrentTime, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$nativeAudioWorkletNodeConstructor, $73de05636a272705$var$nativeOfflineAudioContextConstructor, $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode, $73de05636a272705$var$renderNativeOfflineAudioContext);
const $73de05636a272705$var$getBackupOfflineAudioContext = (0, $27e05528439e83f2$export$afecf147821b5609)($73de05636a272705$var$backupOfflineAudioContextStore);
const $73de05636a272705$var$setActiveAudioWorkletNodeInputs = (0, $880c6c9afb613707$export$17328c9508de4388)($73de05636a272705$var$activeAudioWorkletNodeInputsStore);
// The AudioWorkletNode constructor is only available in a SecureContext.
const $73de05636a272705$export$bc6715221481535 = $73de05636a272705$var$isSecureContext ? (0, $81af2a00b3599a83$export$48302d37fa2cf062)($73de05636a272705$var$addUnrenderedAudioWorkletNode, $73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createAudioWorkletNodeRenderer, $73de05636a272705$var$createNativeAudioWorkletNode, (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), $73de05636a272705$var$getBackupOfflineAudioContext, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$nativeAudioWorkletNodeConstructor, (0, $70e8704c373b96d4$export$9a47aefcb4b02450), $73de05636a272705$var$setActiveAudioWorkletNodeInputs, (0, $39927bdf4fc4578b$export$a40748749fc273c5), (0, $507dfbd6dc37b887$export$63f14ca2e716ed28)) : undefined;
const $73de05636a272705$export$898a44341df73d6e = (0, $82d2d7cc0da6e790$export$8a5e66f668b2e9e8)((0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $d528121802615e67$export$988fb803bae63f80), $73de05636a272705$var$minimalBaseAudioContextConstructor, $73de05636a272705$var$nativeAudioContextConstructor);
const $73de05636a272705$var$createNativeOfflineAudioContext = (0, $b7a1d74149a5d9bf$export$ab44e304a31eb0ae)((0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$nativeOfflineAudioContextConstructor);
const $73de05636a272705$var$startRendering = (0, $e1a515c24adcdd0a$export$a04cd80dfb1b8309)($73de05636a272705$var$audioBufferStore, $73de05636a272705$var$cacheTestResult, $73de05636a272705$var$getAudioNodeRenderer, $73de05636a272705$var$getUnrenderedAudioWorkletNodes, $73de05636a272705$var$renderNativeOfflineAudioContext, (0, $00de7ef4427b01cb$export$54e424f510c54ced), $73de05636a272705$var$wrapAudioBufferCopyChannelMethods, $73de05636a272705$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $73de05636a272705$export$a6f995d32126fe2e = (0, $c34e943c39218d26$export$3d487af37fe7f521)($73de05636a272705$var$cacheTestResult, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeOfflineAudioContext, $73de05636a272705$var$minimalBaseAudioContextConstructor, $73de05636a272705$var$startRendering);
const $73de05636a272705$export$5ab5c649a10df7db = (0, $18cd39af3f5a11f9$export$a9b5caf52b398870)($73de05636a272705$var$baseAudioContextConstructor, $73de05636a272705$var$cacheTestResult, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeOfflineAudioContext, $73de05636a272705$var$startRendering);
const $73de05636a272705$export$e55e427bf52f793d = (0, $5640f46b23f2ba55$export$7030a6f3318876b)((0, $7718e734b2fef711$export$7d17302229276f06), $73de05636a272705$var$isNativeAudioContext);
const $73de05636a272705$export$61ea8ea4691b9a32 = (0, $a888bda59cc0dc6a$export$150a35c855945f9d)((0, $7718e734b2fef711$export$864a3cfb55580d0c), $73de05636a272705$var$isNativeAudioNode);
const $73de05636a272705$export$254dcc24b342c8c2 = (0, $e078436636c3eca1$export$41505fc8888255a0)((0, $7718e734b2fef711$export$55484e3055c7a9e2), $73de05636a272705$var$isNativeAudioParam);
const $73de05636a272705$export$e78994f7990ad5d3 = (0, $3fc93d78c2927094$export$845691ce8ebc2907)((0, $7718e734b2fef711$export$7d17302229276f06), $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$48c17662a6902497 = ()=>(0, $c06e9ed236b03490$export$a245ecb43f54c4de)($73de05636a272705$var$cacheTestResult, (0, $05c9e19f79e8946a$export$1995b5466f5c2709)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $7b65ce19fe8f2342$export$34981ee6aafdf532)($73de05636a272705$var$nativeAudioContextConstructor), (0, $8590d5b2ea257754$export$622ba23aa6b35822)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $867de883ce43c047$export$2f44088abd2df2e)($73de05636a272705$var$nativeAudioContextConstructor), (0, $c42fe39c700d4e84$export$f77a3bce7e4efd81)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $071627c414f7ce66$export$ce5ba80a98dc0ba7)($73de05636a272705$var$nativeAudioWorkletNodeConstructor, $73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $29d0b5a6333bdcd2$export$a04037cfe0b977fa)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $b8e9b03ced2f5e1d$export$63ae3ec177f0ed66)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $ae5370edee7f0789$export$b6f3c4027f959b95)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $9794ec347afccbb2$export$d1bddb88e5c21d26)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $d626a25f56a8d82b$export$1310f0b96d9d8115), (0, $e9f4e2f4c6bba1a3$export$41669e689e17d4f0)($73de05636a272705$var$window), (0, $a6a66a7e2897c896$export$416bb3b14425e126)($73de05636a272705$var$nativeAudioContextConstructor), (0, $19fdb5dea8c1aa58$export$5ea70af76c7a03fc)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $54d8faf59e52b4bd$export$4f6e0d4bb1ead9ce));


/**
 * Assert that the statement is true, otherwise invoke the error.
 * @param statement
 * @param error The message which is passed into an Error
 */ function $afc9146c77d080c2$export$a7a9523472993e97(statement, error) {
    if (!statement) throw new Error(error);
}
function $afc9146c77d080c2$export$6698b6d148bc9b0c(value, gte, lte = Infinity) {
    if (!(gte <= value && value <= lte)) throw new RangeError(`Value must be within [${gte}, ${lte}], got: ${value}`);
}
function $afc9146c77d080c2$export$8ef1ce44f93c2687(context) {
    // add a warning if the context is not started
    if (!context.isOffline && context.state !== "running") $afc9146c77d080c2$export$c106dd0671a0fc2d('The AudioContext is "suspended". Invoke Tone.start() from a user action to start the audio.');
}
/**
 * The default logger is the console
 */ let $afc9146c77d080c2$var$defaultLogger = console;
function $afc9146c77d080c2$export$3abbd92f765bee58(logger) {
    $afc9146c77d080c2$var$defaultLogger = logger;
}
function $afc9146c77d080c2$export$bef1f36f5486a6a3(...args) {
    $afc9146c77d080c2$var$defaultLogger.log(...args);
}
function $afc9146c77d080c2$export$c106dd0671a0fc2d(...args) {
    $afc9146c77d080c2$var$defaultLogger.warn(...args);
}


/**
 * Test if the arg is undefined
 */ function $4d7f709c9ffa5105$export$eb605f91c5895a5b(arg) {
    return typeof arg === "undefined";
}
function $4d7f709c9ffa5105$export$4e62c701997796c1(arg) {
    return !$4d7f709c9ffa5105$export$eb605f91c5895a5b(arg);
}
function $4d7f709c9ffa5105$export$f6e2535fb5126e54(arg) {
    return typeof arg === "function";
}
function $4d7f709c9ffa5105$export$7e4aa119212bc614(arg) {
    return typeof arg === "number";
}
function $4d7f709c9ffa5105$export$a6cdc56e425d0d0a(arg) {
    return Object.prototype.toString.call(arg) === "[object Object]" && arg.constructor === Object;
}
function $4d7f709c9ffa5105$export$f9ce7b637dfbe238(arg) {
    return typeof arg === "boolean";
}
function $4d7f709c9ffa5105$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $4d7f709c9ffa5105$export$844ec244b1367d54(arg) {
    return typeof arg === "string";
}
function $4d7f709c9ffa5105$export$4dcca4501f2037f9(arg) {
    return $4d7f709c9ffa5105$export$844ec244b1367d54(arg) && /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i.test(arg);
}


function $bed5511bac81cb8c$export$9e09b0a77eebe103(options) {
    return new (0, $73de05636a272705$export$fcbc63750ec2a81f)(options);
}
function $bed5511bac81cb8c$export$b7df220975ff4035(channels, length, sampleRate) {
    return new (0, $73de05636a272705$export$5ab5c649a10df7db)(channels, length, sampleRate);
}
const $bed5511bac81cb8c$export$a3ddad83b7a6ba2 = typeof self === "object" ? self : null;
const $bed5511bac81cb8c$export$50898d6dff7e65a3 = $bed5511bac81cb8c$export$a3ddad83b7a6ba2 && ($bed5511bac81cb8c$export$a3ddad83b7a6ba2.hasOwnProperty("AudioContext") || $bed5511bac81cb8c$export$a3ddad83b7a6ba2.hasOwnProperty("webkitAudioContext"));
function $bed5511bac81cb8c$export$f2cca0e3f6d50e11(context, name, options) {
    (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)((0, $73de05636a272705$export$bc6715221481535)), "This node only works in a secure context (https or localhost)");
    // @ts-ignore
    return new (0, $73de05636a272705$export$bc6715221481535)(context, name, options);
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


/**
 * A class which provides a reliable callback using either
 * a Web Worker, or if that isn't supported, falls back to setTimeout.
 */ class $1f93eef75029b0e2$export$39c54bcc89dcee11 {
    constructor(callback, type, updateInterval){
        this._callback = callback;
        this._type = type;
        this._updateInterval = updateInterval;
        // create the clock source for the first time
        this._createClock();
    }
    /**
     * Generate a web worker
     */ _createWorker() {
        const blob = new Blob([
            /* javascript */ `
			// the initial timeout time
			let timeoutTime =  ${(this._updateInterval * 1000).toFixed(1)};
			// onmessage callback
			self.onmessage = function(msg){
				timeoutTime = parseInt(msg.data);
			};
			// the tick function which posts a message
			// and schedules a new tick
			function tick(){
				setTimeout(tick, timeoutTime);
				self.postMessage('tick');
			}
			// call tick initially
			tick();
			`
        ], {
            type: "text/javascript"
        });
        const blobUrl = URL.createObjectURL(blob);
        const worker = new Worker(blobUrl);
        worker.onmessage = this._callback.bind(this);
        this._worker = worker;
    }
    /**
     * Create a timeout loop
     */ _createTimeout() {
        this._timeout = setTimeout(()=>{
            this._createTimeout();
            this._callback();
        }, this._updateInterval * 1000);
    }
    /**
     * Create the clock source.
     */ _createClock() {
        if (this._type === "worker") try {
            this._createWorker();
        } catch (e) {
            // workers not supported, fallback to timeout
            this._type = "timeout";
            this._createClock();
        }
        else if (this._type === "timeout") this._createTimeout();
    }
    /**
     * Clean up the current clock source
     */ _disposeClock() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = 0;
        }
        if (this._worker) {
            this._worker.terminate();
            this._worker.onmessage = null;
        }
    }
    /**
     * The rate in seconds the ticker will update
     */ get updateInterval() {
        return this._updateInterval;
    }
    set updateInterval(interval) {
        this._updateInterval = Math.max(interval, 128 / 44100);
        if (this._type === "worker") this._worker.postMessage(Math.max(interval * 1000, 1));
    }
    /**
     * The type of the ticker, either a worker or a timeout
     */ get type() {
        return this._type;
    }
    set type(type) {
        this._disposeClock();
        this._type = type;
        this._createClock();
    }
    /**
     * Clean up
     */ dispose() {
        this._disposeClock();
    }
}



function $1487bdec8f3de4a7$export$1abe4e52803657f3(arg) {
    return (0, $73de05636a272705$export$254dcc24b342c8c2)(arg);
}
function $1487bdec8f3de4a7$export$85cd8e93eb858e81(arg) {
    return (0, $73de05636a272705$export$61ea8ea4691b9a32)(arg);
}
function $1487bdec8f3de4a7$export$539f87c8e5511243(arg) {
    return (0, $73de05636a272705$export$e78994f7990ad5d3)(arg);
}
function $1487bdec8f3de4a7$export$c46cbd835dc15c90(arg) {
    return (0, $73de05636a272705$export$e55e427bf52f793d)(arg);
}
function $1487bdec8f3de4a7$export$3cc2454c233bdc32(arg) {
    return arg instanceof AudioBuffer;
}




/**
 * Some objects should not be merged
 */ function $07d9216a29f4e8bb$var$noCopy(key, arg) {
    return key === "value" || (0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(arg) || (0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(arg) || (0, $1487bdec8f3de4a7$export$3cc2454c233bdc32)(arg);
}
function $07d9216a29f4e8bb$export$6969335ea1e4e77c(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(target) && (0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(source)) for(const key in source){
        if ($07d9216a29f4e8bb$var$noCopy(key, source[key])) target[key] = source[key];
        else if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(source[key])) {
            if (!target[key]) Object.assign(target, {
                [key]: {}
            });
            $07d9216a29f4e8bb$export$6969335ea1e4e77c(target[key], source[key]);
        } else Object.assign(target, {
            [key]: source[key]
        });
    }
    // @ts-ignore
    return $07d9216a29f4e8bb$export$6969335ea1e4e77c(target, ...sources);
}
function $07d9216a29f4e8bb$export$73ce4178444047a5(arrayA, arrayB) {
    return arrayA.length === arrayB.length && arrayA.every((element, index)=>arrayB[index] === element);
}
function $07d9216a29f4e8bb$export$71d3255081da70a3(defaults, argsArray, keys = [], objKey) {
    const opts = {};
    const args = Array.from(argsArray);
    // if the first argument is an object and has an object key
    if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(args[0]) && objKey && !Reflect.has(args[0], objKey)) {
        // if it's not part of the defaults
        const partOfDefaults = Object.keys(args[0]).some((key)=>Reflect.has(defaults, key));
        if (!partOfDefaults) {
            // merge that key
            $07d9216a29f4e8bb$export$6969335ea1e4e77c(opts, {
                [objKey]: args[0]
            });
            // remove the obj key from the keys
            keys.splice(keys.indexOf(objKey), 1);
            // shift the first argument off
            args.shift();
        }
    }
    if (args.length === 1 && (0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(args[0])) $07d9216a29f4e8bb$export$6969335ea1e4e77c(opts, args[0]);
    else {
        for(let i = 0; i < keys.length; i++)if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(args[i])) opts[keys[i]] = args[i];
    }
    return $07d9216a29f4e8bb$export$6969335ea1e4e77c(defaults, opts);
}
function $07d9216a29f4e8bb$export$4b8c3341c9aef2b8(instance) {
    return instance.constructor.getDefaults();
}
function $07d9216a29f4e8bb$export$37721a79838ca038(given, fallback) {
    if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(given)) return fallback;
    else return given;
}
function $07d9216a29f4e8bb$export$e35a36a1f3b5e86b(obj, omit) {
    omit.forEach((prop)=>{
        if (Reflect.has(obj, prop)) delete obj[prop];
    });
    return obj;
}


/**
 * Tone.js
 * @author Yotam Mann
 * @license http://opensource.org/licenses/MIT MIT License
 * @copyright 2014-2019 Yotam Mann
 */ 


class $15ec6319bc02226c$export$12b11dc969d02fed {
    constructor(){
        //-------------------------------------
        // 	DEBUGGING
        //-------------------------------------
        /**
         * Set this debug flag to log all events that happen in this class.
         */ this.debug = false;
        //-------------------------------------
        // 	DISPOSING
        //-------------------------------------
        /**
         * Indicates if the instance was disposed
         */ this._wasDisposed = false;
    }
    /**
     * Returns all of the default options belonging to the class.
     */ static getDefaults() {
        return {};
    }
    /**
     * Prints the outputs to the console log for debugging purposes.
     * Prints the contents only if either the object has a property
     * called `debug` set to true, or a variable called TONE_DEBUG_CLASS
     * is set to the name of the class.
     * @example
     * const osc = new Tone.Oscillator();
     * // prints all logs originating from this oscillator
     * osc.debug = true;
     * // calls to start/stop will print in the console
     * osc.start();
     */ log(...args) {
        // if the object is either set to debug = true
        // or if there is a string on the Tone.global.with the class name
        if (this.debug || (0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2) && this.toString() === (0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2).TONE_DEBUG_CLASS) (0, $afc9146c77d080c2$export$bef1f36f5486a6a3)(this, ...args);
    }
    /**
     * disconnect and dispose.
     */ dispose() {
        this._wasDisposed = true;
        return this;
    }
    /**
     * Indicates if the instance was disposed. 'Disposing' an
     * instance means that all of the Web Audio nodes that were
     * created for the instance are disconnected and freed for garbage collection.
     */ get disposed() {
        return this._wasDisposed;
    }
    /**
     * Convert the class to a string
     * @example
     * const osc = new Tone.Oscillator();
     * console.log(osc.toString());
     */ toString() {
        return this.name;
    }
}
/**
 * The version number semver
 */ $15ec6319bc02226c$export$12b11dc969d02fed.version = (0, $8087cb83ba2ea5ef$export$83d89fbfd8236492);




/**
 * The threshold for correctness for operators. Less than one sample even
 * at very high sampling rates (e.g. `1e-6 < 1 / 192000`).
 */ const $0f7b0e628156f5de$var$EPSILON = 1e-6;
function $0f7b0e628156f5de$export$b023c82b48e70453(a, b) {
    return a > b + $0f7b0e628156f5de$var$EPSILON;
}
function $0f7b0e628156f5de$export$c846515610eb2c50(a, b) {
    return $0f7b0e628156f5de$export$b023c82b48e70453(a, b) || $0f7b0e628156f5de$export$1c0a5d05eb3f6e18(a, b);
}
function $0f7b0e628156f5de$export$7158f0ceb70f54c7(a, b) {
    return a + $0f7b0e628156f5de$var$EPSILON < b;
}
function $0f7b0e628156f5de$export$1c0a5d05eb3f6e18(a, b) {
    return Math.abs(a - b) < $0f7b0e628156f5de$var$EPSILON;
}
function $0f7b0e628156f5de$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.max(Math.min(value, max), min);
}


class $4f983a11dbbcfd64$export$e6a97ba2cae5bb94 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super();
        this.name = "Timeline";
        /**
         * The array of scheduled timeline events
         */ this._timeline = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4f983a11dbbcfd64$export$e6a97ba2cae5bb94.getDefaults(), arguments, [
            "memory"
        ]);
        this.memory = options.memory;
        this.increasing = options.increasing;
    }
    static getDefaults() {
        return {
            memory: Infinity,
            increasing: false
        };
    }
    /**
     * The number of items in the timeline.
     */ get length() {
        return this._timeline.length;
    }
    /**
     * Insert an event object onto the timeline. Events must have a "time" attribute.
     * @param event  The event object to insert into the timeline.
     */ add(event) {
        // the event needs to have a time attribute
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(Reflect.has(event, "time"), "Timeline: events must have a time attribute");
        event.time = event.time.valueOf();
        if (this.increasing && this.length) {
            const lastValue = this._timeline[this.length - 1];
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $0f7b0e628156f5de$export$c846515610eb2c50)(event.time, lastValue.time), "The time must be greater than or equal to the last scheduled time");
            this._timeline.push(event);
        } else {
            const index = this._search(event.time);
            this._timeline.splice(index + 1, 0, event);
        }
        // if the length is more than the memory, remove the previous ones
        if (this.length > this.memory) {
            const diff = this.length - this.memory;
            this._timeline.splice(0, diff);
        }
        return this;
    }
    /**
     * Remove an event from the timeline.
     * @param  {Object}  event  The event object to remove from the list.
     * @returns {Timeline} this
     */ remove(event) {
        const index = this._timeline.indexOf(event);
        if (index !== -1) this._timeline.splice(index, 1);
        return this;
    }
    /**
     * Get the nearest event whose time is less than or equal to the given time.
     * @param  time  The time to query.
     */ get(time, param = "time") {
        const index = this._search(time, param);
        if (index !== -1) return this._timeline[index];
        else return null;
    }
    /**
     * Return the first event in the timeline without removing it
     * @returns {Object} The first event object
     */ peek() {
        return this._timeline[0];
    }
    /**
     * Return the first event in the timeline and remove it
     */ shift() {
        return this._timeline.shift();
    }
    /**
     * Get the event which is scheduled after the given time.
     * @param  time  The time to query.
     */ getAfter(time, param = "time") {
        const index = this._search(time, param);
        if (index + 1 < this._timeline.length) return this._timeline[index + 1];
        else return null;
    }
    /**
     * Get the event before the event at the given time.
     * @param  time  The time to query.
     */ getBefore(time) {
        const len = this._timeline.length;
        // if it's after the last item, return the last item
        if (len > 0 && this._timeline[len - 1].time < time) return this._timeline[len - 1];
        const index = this._search(time);
        if (index - 1 >= 0) return this._timeline[index - 1];
        else return null;
    }
    /**
     * Cancel events at and after the given time
     * @param  after  The time to query.
     */ cancel(after) {
        if (this._timeline.length > 1) {
            let index = this._search(after);
            if (index >= 0) {
                if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(this._timeline[index].time, after)) {
                    // get the first item with that time
                    for(let i = index; i >= 0; i--){
                        if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(this._timeline[i].time, after)) index = i;
                        else break;
                    }
                    this._timeline = this._timeline.slice(0, index);
                } else this._timeline = this._timeline.slice(0, index + 1);
            } else this._timeline = [];
        } else if (this._timeline.length === 1) // the first item's time
        {
            if ((0, $0f7b0e628156f5de$export$c846515610eb2c50)(this._timeline[0].time, after)) this._timeline = [];
        }
        return this;
    }
    /**
     * Cancel events before or equal to the given time.
     * @param  time  The time to cancel before.
     */ cancelBefore(time) {
        const index = this._search(time);
        if (index >= 0) this._timeline = this._timeline.slice(index + 1);
        return this;
    }
    /**
     * Returns the previous event if there is one. null otherwise
     * @param  event The event to find the previous one of
     * @return The event right before the given event
     */ previousEvent(event) {
        const index = this._timeline.indexOf(event);
        if (index > 0) return this._timeline[index - 1];
        else return null;
    }
    /**
     * Does a binary search on the timeline array and returns the
     * nearest event index whose time is after or equal to the given time.
     * If a time is searched before the first index in the timeline, -1 is returned.
     * If the time is after the end, the index of the last item is returned.
     */ _search(time, param = "time") {
        if (this._timeline.length === 0) return -1;
        let beginning = 0;
        const len = this._timeline.length;
        let end = len;
        if (len > 0 && this._timeline[len - 1][param] <= time) return len - 1;
        while(beginning < end){
            // calculate the midpoint for roughly equal partition
            let midPoint = Math.floor(beginning + (end - beginning) / 2);
            const event = this._timeline[midPoint];
            const nextEvent = this._timeline[midPoint + 1];
            if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(event[param], time)) {
                // choose the last one that has the same time
                for(let i = midPoint; i < this._timeline.length; i++){
                    const testEvent = this._timeline[i];
                    if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(testEvent[param], time)) midPoint = i;
                    else break;
                }
                return midPoint;
            } else if ((0, $0f7b0e628156f5de$export$7158f0ceb70f54c7)(event[param], time) && (0, $0f7b0e628156f5de$export$b023c82b48e70453)(nextEvent[param], time)) return midPoint;
            else if ((0, $0f7b0e628156f5de$export$b023c82b48e70453)(event[param], time)) // search lower
            end = midPoint;
            else // search upper
            beginning = midPoint + 1;
        }
        return -1;
    }
    /**
     * Internal iterator. Applies extra safety checks for
     * removing items from the array.
     */ _iterate(callback, lowerBound = 0, upperBound = this._timeline.length - 1) {
        this._timeline.slice(lowerBound, upperBound + 1).forEach(callback);
    }
    /**
     * Iterate over everything in the array
     * @param  callback The callback to invoke with every item
     */ forEach(callback) {
        this._iterate(callback);
        return this;
    }
    /**
     * Iterate over everything in the array at or before the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachBefore(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const upperBound = this._search(time);
        if (upperBound !== -1) this._iterate(callback, 0, upperBound);
        return this;
    }
    /**
     * Iterate over everything in the array after the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachAfter(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const lowerBound = this._search(time);
        this._iterate(callback, lowerBound + 1);
        return this;
    }
    /**
     * Iterate over everything in the array between the startTime and endTime.
     * The timerange is inclusive of the startTime, but exclusive of the endTime.
     * range = [startTime, endTime).
     * @param  startTime The time to check if items are before
     * @param  endTime The end of the test interval.
     * @param  callback The callback to invoke with every item
     */ forEachBetween(startTime, endTime, callback) {
        let lowerBound = this._search(startTime);
        let upperBound = this._search(endTime);
        if (lowerBound !== -1 && upperBound !== -1) {
            if (this._timeline[lowerBound].time !== startTime) lowerBound += 1;
            // exclusive of the end time
            if (this._timeline[upperBound].time === endTime) upperBound -= 1;
            this._iterate(callback, lowerBound, upperBound);
        } else if (lowerBound === -1) this._iterate(callback, 0, upperBound);
        return this;
    }
    /**
     * Iterate over everything in the array at or after the given time. Similar to
     * forEachAfter, but includes the item(s) at the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachFrom(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        let lowerBound = this._search(time);
        // work backwards until the event time is less than time
        while(lowerBound >= 0 && this._timeline[lowerBound].time >= time)lowerBound--;
        this._iterate(callback, lowerBound + 1);
        return this;
    }
    /**
     * Iterate over everything in the array at the given time
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachAtTime(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const upperBound = this._search(time);
        if (upperBound !== -1 && (0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(this._timeline[upperBound].time, time)) {
            let lowerBound = upperBound;
            for(let i = upperBound; i >= 0; i--){
                if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(this._timeline[i].time, time)) lowerBound = i;
                else break;
            }
            this._iterate((event)=>{
                callback(event);
            }, lowerBound, upperBound);
        }
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._timeline = [];
        return this;
    }
}




//-------------------------------------
// INITIALIZING NEW CONTEXT
//-------------------------------------
/**
 * Array of callbacks to invoke when a new context is created
 */ const $33268d33018da22a$var$notifyNewContext = [];
function $33268d33018da22a$export$cdd816203a02e74e(cb) {
    $33268d33018da22a$var$notifyNewContext.push(cb);
}
function $33268d33018da22a$export$881f7fb71351b304(ctx) {
    // add any additional modules
    $33268d33018da22a$var$notifyNewContext.forEach((cb)=>cb(ctx));
}
/**
 * Array of callbacks to invoke when a new context is created
 */ const $33268d33018da22a$var$notifyCloseContext = [];
function $33268d33018da22a$export$7e1ecadd06ae8222(cb) {
    $33268d33018da22a$var$notifyCloseContext.push(cb);
}
function $33268d33018da22a$export$c7e36f690049420f(ctx) {
    // add any additional modules
    $33268d33018da22a$var$notifyCloseContext.forEach((cb)=>cb(ctx));
}




class $092748a42ac93843$export$4293555f241ae35a extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super(...arguments);
        this.name = "Emitter";
    }
    /**
     * Bind a callback to a specific event.
     * @param  event     The name of the event to listen for.
     * @param  callback  The callback to invoke when the event is emitted
     */ on(event, callback) {
        // split the event
        const events = event.split(/\W+/);
        events.forEach((eventName)=>{
            if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(this._events)) this._events = {};
            if (!this._events.hasOwnProperty(eventName)) this._events[eventName] = [];
            this._events[eventName].push(callback);
        });
        return this;
    }
    /**
     * Bind a callback which is only invoked once
     * @param  event     The name of the event to listen for.
     * @param  callback  The callback to invoke when the event is emitted
     */ once(event, callback) {
        const boundCallback = (...args)=>{
            // invoke the callback
            callback(...args);
            // remove the event
            this.off(event, boundCallback);
        };
        this.on(event, boundCallback);
        return this;
    }
    /**
     * Remove the event listener.
     * @param  event     The event to stop listening to.
     * @param  callback  The callback which was bound to the event with Emitter.on.
     *                   If no callback is given, all callbacks events are removed.
     */ off(event, callback) {
        const events = event.split(/\W+/);
        events.forEach((eventName)=>{
            if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(this._events)) this._events = {};
            if (this._events.hasOwnProperty(event)) {
                if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(callback)) this._events[event] = [];
                else {
                    const eventList = this._events[event];
                    for(let i = eventList.length - 1; i >= 0; i--)if (eventList[i] === callback) eventList.splice(i, 1);
                }
            }
        });
        return this;
    }
    /**
     * Invoke all of the callbacks bound to the event
     * with any arguments passed in.
     * @param  event  The name of the event.
     * @param args The arguments to pass to the functions listening.
     */ emit(event, ...args) {
        if (this._events) {
            if (this._events.hasOwnProperty(event)) {
                const eventList = this._events[event].slice(0);
                for(let i = 0, len = eventList.length; i < len; i++)eventList[i].apply(this, args);
            }
        }
        return this;
    }
    /**
     * Add Emitter functions (on/off/emit) to the object
     */ static mixin(constr) {
        // instance._events = {};
        [
            "on",
            "once",
            "off",
            "emit"
        ].forEach((name)=>{
            const property = Object.getOwnPropertyDescriptor($092748a42ac93843$export$4293555f241ae35a.prototype, name);
            Object.defineProperty(constr.prototype, name, property);
        });
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._events = undefined;
        return this;
    }
}


class $b31a039e43571af1$export$8138604c41bf2253 extends (0, $092748a42ac93843$export$4293555f241ae35a) {
    constructor(){
        super(...arguments);
        this.isOffline = false;
    }
    /*
     * This is a placeholder so that JSON.stringify does not throw an error
     * This matches what JSON.stringify(audioContext) returns on a native
     * audioContext instance.
     */ toJSON() {
        return {};
    }
}



class $97c32a9cce8e2f52$export$841858b892ce1f4c extends (0, $b31a039e43571af1$export$8138604c41bf2253) {
    constructor(){
        super();
        this.name = "Context";
        /**
         * An object containing all of the constants AudioBufferSourceNodes
         */ this._constants = new Map();
        /**
         * All of the setTimeout events.
         */ this._timeouts = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        /**
         * The timeout id counter
         */ this._timeoutIds = 0;
        /**
         * Private indicator if the context has been initialized
         */ this._initialized = false;
        /**
         * Indicates if the context is an OfflineAudioContext or an AudioContext
         */ this.isOffline = false;
        //--------------------------------------------
        // AUDIO WORKLET
        //--------------------------------------------
        /**
         * Maps a module name to promise of the addModule method
         */ this._workletModules = new Map();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($97c32a9cce8e2f52$export$841858b892ce1f4c.getDefaults(), arguments, [
            "context"
        ]);
        if (options.context) this._context = options.context;
        else this._context = (0, $bed5511bac81cb8c$export$9e09b0a77eebe103)({
            latencyHint: options.latencyHint
        });
        this._ticker = new (0, $1f93eef75029b0e2$export$39c54bcc89dcee11)(this.emit.bind(this, "tick"), options.clockSource, options.updateInterval);
        this.on("tick", this._timeoutLoop.bind(this));
        // fwd events from the context
        this._context.onstatechange = ()=>{
            this.emit("statechange", this.state);
        };
        this._setLatencyHint(options.latencyHint);
        this.lookAhead = options.lookAhead;
    }
    static getDefaults() {
        return {
            clockSource: "worker",
            latencyHint: "interactive",
            lookAhead: 0.1,
            updateInterval: 0.05
        };
    }
    /**
     * Finish setting up the context. **You usually do not need to do this manually.**
     */ initialize() {
        if (!this._initialized) {
            // add any additional modules
            (0, $33268d33018da22a$export$881f7fb71351b304)(this);
            this._initialized = true;
        }
        return this;
    }
    //---------------------------
    // BASE AUDIO CONTEXT METHODS
    //---------------------------
    createAnalyser() {
        return this._context.createAnalyser();
    }
    createOscillator() {
        return this._context.createOscillator();
    }
    createBufferSource() {
        return this._context.createBufferSource();
    }
    createBiquadFilter() {
        return this._context.createBiquadFilter();
    }
    createBuffer(numberOfChannels, length, sampleRate) {
        return this._context.createBuffer(numberOfChannels, length, sampleRate);
    }
    createChannelMerger(numberOfInputs) {
        return this._context.createChannelMerger(numberOfInputs);
    }
    createChannelSplitter(numberOfOutputs) {
        return this._context.createChannelSplitter(numberOfOutputs);
    }
    createConstantSource() {
        return this._context.createConstantSource();
    }
    createConvolver() {
        return this._context.createConvolver();
    }
    createDelay(maxDelayTime) {
        return this._context.createDelay(maxDelayTime);
    }
    createDynamicsCompressor() {
        return this._context.createDynamicsCompressor();
    }
    createGain() {
        return this._context.createGain();
    }
    createIIRFilter(feedForward, feedback) {
        // @ts-ignore
        return this._context.createIIRFilter(feedForward, feedback);
    }
    createPanner() {
        return this._context.createPanner();
    }
    createPeriodicWave(real, imag, constraints) {
        return this._context.createPeriodicWave(real, imag, constraints);
    }
    createStereoPanner() {
        return this._context.createStereoPanner();
    }
    createWaveShaper() {
        return this._context.createWaveShaper();
    }
    createMediaStreamSource(stream) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaStreamSource(stream);
    }
    createMediaElementSource(element) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaElementSource(element);
    }
    createMediaStreamDestination() {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaStreamDestination();
    }
    decodeAudioData(audioData) {
        return this._context.decodeAudioData(audioData);
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get currentTime() {
        return this._context.currentTime;
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get state() {
        return this._context.state;
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get sampleRate() {
        return this._context.sampleRate;
    }
    /**
     * The listener
     */ get listener() {
        this.initialize();
        return this._listener;
    }
    set listener(l) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._initialized, "The listener cannot be set after initialization.");
        this._listener = l;
    }
    /**
     * There is only one Transport per Context. It is created on initialization.
     */ get transport() {
        this.initialize();
        return this._transport;
    }
    set transport(t) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._initialized, "The transport cannot be set after initialization.");
        this._transport = t;
    }
    /**
     * This is the Draw object for the context which is useful for synchronizing the draw frame with the Tone.js clock.
     */ get draw() {
        this.initialize();
        return this._draw;
    }
    set draw(d) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._initialized, "Draw cannot be set after initialization.");
        this._draw = d;
    }
    /**
     * A reference to the Context's destination node.
     */ get destination() {
        this.initialize();
        return this._destination;
    }
    set destination(d) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._initialized, "The destination cannot be set after initialization.");
        this._destination = d;
    }
    /**
     * Create an audio worklet node from a name and options. The module
     * must first be loaded using [[addAudioWorkletModule]].
     */ createAudioWorkletNode(name, options) {
        return (0, $bed5511bac81cb8c$export$f2cca0e3f6d50e11)(this.rawContext, name, options);
    }
    /**
     * Add an AudioWorkletProcessor module
     * @param url The url of the module
     * @param name The name of the module
     */ addAudioWorkletModule(url, name) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.rawContext.audioWorklet), "AudioWorkletNode is only available in a secure context (https or localhost)");
            if (!this._workletModules.has(name)) this._workletModules.set(name, this.rawContext.audioWorklet.addModule(url));
            yield this._workletModules.get(name);
        });
    }
    /**
     * Returns a promise which resolves when all of the worklets have been loaded on this context
     */ workletsAreReady() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const promises = [];
            this._workletModules.forEach((promise)=>promises.push(promise));
            yield Promise.all(promises);
        });
    }
    //---------------------------
    // TICKER
    //---------------------------
    /**
     * How often the interval callback is invoked.
     * This number corresponds to how responsive the scheduling
     * can be. context.updateInterval + context.lookAhead gives you the
     * total latency between scheduling an event and hearing it.
     */ get updateInterval() {
        return this._ticker.updateInterval;
    }
    set updateInterval(interval) {
        this._ticker.updateInterval = interval;
    }
    /**
     * What the source of the clock is, either "worker" (default),
     * "timeout", or "offline" (none).
     */ get clockSource() {
        return this._ticker.type;
    }
    set clockSource(type) {
        this._ticker.type = type;
    }
    /**
     * The type of playback, which affects tradeoffs between audio
     * output latency and responsiveness.
     * In addition to setting the value in seconds, the latencyHint also
     * accepts the strings "interactive" (prioritizes low latency),
     * "playback" (prioritizes sustained playback), "balanced" (balances
     * latency and performance).
     * @example
     * // prioritize sustained playback
     * const context = new Tone.Context({ latencyHint: "playback" });
     * // set this context as the global Context
     * Tone.setContext(context);
     * // the global context is gettable with Tone.getContext()
     * console.log(Tone.getContext().latencyHint);
     */ get latencyHint() {
        return this._latencyHint;
    }
    /**
     * Update the lookAhead and updateInterval based on the latencyHint
     */ _setLatencyHint(hint) {
        let lookAheadValue = 0;
        this._latencyHint = hint;
        if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(hint)) switch(hint){
            case "interactive":
                lookAheadValue = 0.1;
                break;
            case "playback":
                lookAheadValue = 0.5;
                break;
            case "balanced":
                lookAheadValue = 0.25;
                break;
        }
        this.lookAhead = lookAheadValue;
        this.updateInterval = lookAheadValue / 2;
    }
    /**
     * The unwrapped AudioContext or OfflineAudioContext
     */ get rawContext() {
        return this._context;
    }
    /**
     * The current audio context time plus a short [[lookAhead]].
     */ now() {
        return this._context.currentTime + this.lookAhead;
    }
    /**
     * The current audio context time without the [[lookAhead]].
     * In most cases it is better to use [[now]] instead of [[immediate]] since
     * with [[now]] the [[lookAhead]] is applied equally to _all_ components including internal components,
     * to making sure that everything is scheduled in sync. Mixing [[now]] and [[immediate]]
     * can cause some timing issues. If no lookAhead is desired, you can set the [[lookAhead]] to `0`.
     */ immediate() {
        return this._context.currentTime;
    }
    /**
     * Starts the audio context from a suspended state. This is required
     * to initially start the AudioContext. See [[Tone.start]]
     */ resume() {
        if ((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context)) return this._context.resume();
        else return Promise.resolve();
    }
    /**
     * Close the context. Once closed, the context can no longer be used and
     * any AudioNodes created from the context will be silent.
     */ close() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            if ((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context)) yield this._context.close();
            if (this._initialized) (0, $33268d33018da22a$export$c7e36f690049420f)(this);
        });
    }
    /**
     * **Internal** Generate a looped buffer at some constant value.
     */ getConstant(val) {
        if (this._constants.has(val)) return this._constants.get(val);
        else {
            const buffer = this._context.createBuffer(1, 128, this._context.sampleRate);
            const arr = buffer.getChannelData(0);
            for(let i = 0; i < arr.length; i++)arr[i] = val;
            const constant = this._context.createBufferSource();
            constant.channelCount = 1;
            constant.channelCountMode = "explicit";
            constant.buffer = buffer;
            constant.loop = true;
            constant.start(0);
            this._constants.set(val, constant);
            return constant;
        }
    }
    /**
     * Clean up. Also closes the audio context.
     */ dispose() {
        super.dispose();
        this._ticker.dispose();
        this._timeouts.dispose();
        Object.keys(this._constants).map((val)=>this._constants[val].disconnect());
        return this;
    }
    //---------------------------
    // TIMEOUTS
    //---------------------------
    /**
     * The private loop which keeps track of the context scheduled timeouts
     * Is invoked from the clock source
     */ _timeoutLoop() {
        const now = this.now();
        let firstEvent = this._timeouts.peek();
        while(this._timeouts.length && firstEvent && firstEvent.time <= now){
            // invoke the callback
            firstEvent.callback();
            // shift the first event off
            this._timeouts.shift();
            // get the next one
            firstEvent = this._timeouts.peek();
        }
    }
    /**
     * A setTimeout which is guaranteed by the clock source.
     * Also runs in the offline context.
     * @param  fn       The callback to invoke
     * @param  timeout  The timeout in seconds
     * @returns ID to use when invoking Context.clearTimeout
     */ setTimeout(fn, timeout) {
        this._timeoutIds++;
        const now = this.now();
        this._timeouts.add({
            callback: fn,
            id: this._timeoutIds,
            time: now + timeout
        });
        return this._timeoutIds;
    }
    /**
     * Clears a previously scheduled timeout with Tone.context.setTimeout
     * @param  id  The ID returned from setTimeout
     */ clearTimeout(id) {
        this._timeouts.forEach((event)=>{
            if (event.id === id) this._timeouts.remove(event);
        });
        return this;
    }
    /**
     * Clear the function scheduled by [[setInterval]]
     */ clearInterval(id) {
        return this.clearTimeout(id);
    }
    /**
     * Adds a repeating event to the context's callback clock
     */ setInterval(fn, interval) {
        const id = ++this._timeoutIds;
        const intervalFn = ()=>{
            const now = this.now();
            this._timeouts.add({
                callback: ()=>{
                    // invoke the callback
                    fn();
                    // invoke the event to repeat it
                    intervalFn();
                },
                id: id,
                time: now + interval
            });
        };
        // kick it off
        intervalFn();
        return id;
    }
}




class $0ec515c97546cbe4$export$bc5f2fd86e1bc223 extends (0, $b31a039e43571af1$export$8138604c41bf2253) {
    constructor(){
        super(...arguments);
        this.lookAhead = 0;
        this.latencyHint = 0;
        this.isOffline = false;
    }
    //---------------------------
    // BASE AUDIO CONTEXT METHODS
    //---------------------------
    createAnalyser() {
        return {};
    }
    createOscillator() {
        return {};
    }
    createBufferSource() {
        return {};
    }
    createBiquadFilter() {
        return {};
    }
    createBuffer(_numberOfChannels, _length, _sampleRate) {
        return {};
    }
    createChannelMerger(_numberOfInputs) {
        return {};
    }
    createChannelSplitter(_numberOfOutputs) {
        return {};
    }
    createConstantSource() {
        return {};
    }
    createConvolver() {
        return {};
    }
    createDelay(_maxDelayTime) {
        return {};
    }
    createDynamicsCompressor() {
        return {};
    }
    createGain() {
        return {};
    }
    createIIRFilter(_feedForward, _feedback) {
        return {};
    }
    createPanner() {
        return {};
    }
    createPeriodicWave(_real, _imag, _constraints) {
        return {};
    }
    createStereoPanner() {
        return {};
    }
    createWaveShaper() {
        return {};
    }
    createMediaStreamSource(_stream) {
        return {};
    }
    createMediaElementSource(_element) {
        return {};
    }
    createMediaStreamDestination() {
        return {};
    }
    decodeAudioData(_audioData) {
        return Promise.resolve({});
    }
    //---------------------------
    // TONE AUDIO CONTEXT METHODS
    //---------------------------
    createAudioWorkletNode(_name, _options) {
        return {};
    }
    get rawContext() {
        return {};
    }
    addAudioWorkletModule(_url, _name) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return Promise.resolve();
        });
    }
    resume() {
        return Promise.resolve();
    }
    setTimeout(_fn, _timeout) {
        return 0;
    }
    clearTimeout(_id) {
        return this;
    }
    setInterval(_fn, _interval) {
        return 0;
    }
    clearInterval(_id) {
        return this;
    }
    getConstant(_val) {
        return {};
    }
    get currentTime() {
        return 0;
    }
    get state() {
        return {};
    }
    get sampleRate() {
        return 0;
    }
    get listener() {
        return {};
    }
    get transport() {
        return {};
    }
    get draw() {
        return {};
    }
    set draw(_d) {}
    get destination() {
        return {};
    }
    set destination(_d) {}
    now() {
        return 0;
    }
    immediate() {
        return 0;
    }
}












function $8cce0c9e2019bc8a$export$b2cbc93d4da94977(target, property) {
    if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(property)) property.forEach((str)=>$8cce0c9e2019bc8a$export$b2cbc93d4da94977(target, str));
    else Object.defineProperty(target, property, {
        enumerable: true,
        writable: false
    });
}
function $8cce0c9e2019bc8a$export$e6d3eada50a007b1(target, property) {
    if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(property)) property.forEach((str)=>$8cce0c9e2019bc8a$export$e6d3eada50a007b1(target, str));
    else Object.defineProperty(target, property, {
        writable: true
    });
}
const $8cce0c9e2019bc8a$export$b50b6e108474309b = ()=>{
// no operation here!
};




class $43da6dea502b5fe8$export$424a335715b38178 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super();
        this.name = "ToneAudioBuffer";
        /**
         * Callback when the buffer is loaded.
         */ this.onload = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($43da6dea502b5fe8$export$424a335715b38178.getDefaults(), arguments, [
            "url",
            "onload",
            "onerror"
        ]);
        this.reverse = options.reverse;
        this.onload = options.onload;
        if (options.url && (0, $1487bdec8f3de4a7$export$3cc2454c233bdc32)(options.url) || options.url instanceof $43da6dea502b5fe8$export$424a335715b38178) this.set(options.url);
        else if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(options.url)) // initiate the download
        this.load(options.url).catch(options.onerror);
    }
    static getDefaults() {
        return {
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            reverse: false
        };
    }
    /**
     * The sample rate of the AudioBuffer
     */ get sampleRate() {
        if (this._buffer) return this._buffer.sampleRate;
        else return (0, $b7b11709569bdbef$export$31553aaa555c1514)().sampleRate;
    }
    /**
     * Pass in an AudioBuffer or ToneAudioBuffer to set the value of this buffer.
     */ set(buffer) {
        if (buffer instanceof $43da6dea502b5fe8$export$424a335715b38178) {
            // if it's loaded, set it
            if (buffer.loaded) this._buffer = buffer.get();
            else // otherwise when it's loaded, invoke it's callback
            buffer.onload = ()=>{
                this.set(buffer);
                this.onload(this);
            };
        } else this._buffer = buffer;
        // reverse it initially
        if (this._reversed) this._reverse();
        return this;
    }
    /**
     * The audio buffer stored in the object.
     */ get() {
        return this._buffer;
    }
    /**
     * Makes an fetch request for the selected url then decodes the file as an audio buffer.
     * Invokes the callback once the audio buffer loads.
     * @param url The url of the buffer to load. filetype support depends on the browser.
     * @returns A Promise which resolves with this ToneAudioBuffer
     */ load(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const doneLoading = $43da6dea502b5fe8$export$424a335715b38178.load(url).then((audioBuffer)=>{
                this.set(audioBuffer);
                // invoke the onload method
                this.onload(this);
            });
            $43da6dea502b5fe8$export$424a335715b38178.downloads.push(doneLoading);
            try {
                yield doneLoading;
            } finally{
                // remove the downloaded file
                const index = $43da6dea502b5fe8$export$424a335715b38178.downloads.indexOf(doneLoading);
                $43da6dea502b5fe8$export$424a335715b38178.downloads.splice(index, 1);
            }
            return this;
        });
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._buffer = undefined;
        return this;
    }
    /**
     * Set the audio buffer from the array.
     * To create a multichannel AudioBuffer, pass in a multidimensional array.
     * @param array The array to fill the audio buffer
     */ fromArray(array) {
        const isMultidimensional = (0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(array) && array[0].length > 0;
        const channels = isMultidimensional ? array.length : 1;
        const len = isMultidimensional ? array[0].length : array.length;
        const context = (0, $b7b11709569bdbef$export$31553aaa555c1514)();
        const buffer = context.createBuffer(channels, len, context.sampleRate);
        const multiChannelArray = !isMultidimensional && channels === 1 ? [
            array
        ] : array;
        for(let c = 0; c < channels; c++)buffer.copyToChannel(multiChannelArray[c], c);
        this._buffer = buffer;
        return this;
    }
    /**
     * Sums multiple channels into 1 channel
     * @param chanNum Optionally only copy a single channel from the array.
     */ toMono(chanNum) {
        if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(chanNum)) this.fromArray(this.toArray(chanNum));
        else {
            let outputArray = new Float32Array(this.length);
            const numChannels = this.numberOfChannels;
            for(let channel = 0; channel < numChannels; channel++){
                const channelArray = this.toArray(channel);
                for(let i = 0; i < channelArray.length; i++)outputArray[i] += channelArray[i];
            }
            // divide by the number of channels
            outputArray = outputArray.map((sample)=>sample / numChannels);
            this.fromArray(outputArray);
        }
        return this;
    }
    /**
     * Get the buffer as an array. Single channel buffers will return a 1-dimensional
     * Float32Array, and multichannel buffers will return multidimensional arrays.
     * @param channel Optionally only copy a single channel from the array.
     */ toArray(channel) {
        if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(channel)) return this.getChannelData(channel);
        else if (this.numberOfChannels === 1) return this.toArray(0);
        else {
            const ret = [];
            for(let c = 0; c < this.numberOfChannels; c++)ret[c] = this.getChannelData(c);
            return ret;
        }
    }
    /**
     * Returns the Float32Array representing the PCM audio data for the specific channel.
     * @param  channel  The channel number to return
     * @return The audio as a TypedArray
     */ getChannelData(channel) {
        if (this._buffer) return this._buffer.getChannelData(channel);
        else return new Float32Array(0);
    }
    /**
     * Cut a subsection of the array and return a buffer of the
     * subsection. Does not modify the original buffer
     * @param start The time to start the slice
     * @param end The end time to slice. If none is given will default to the end of the buffer
     */ slice(start, end = this.duration) {
        const startSamples = Math.floor(start * this.sampleRate);
        const endSamples = Math.floor(end * this.sampleRate);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(startSamples < endSamples, "The start time must be less than the end time");
        const length = endSamples - startSamples;
        const retBuffer = (0, $b7b11709569bdbef$export$31553aaa555c1514)().createBuffer(this.numberOfChannels, length, this.sampleRate);
        for(let channel = 0; channel < this.numberOfChannels; channel++)retBuffer.copyToChannel(this.getChannelData(channel).subarray(startSamples, endSamples), channel);
        return new $43da6dea502b5fe8$export$424a335715b38178(retBuffer);
    }
    /**
     * Reverse the buffer.
     */ _reverse() {
        if (this.loaded) for(let i = 0; i < this.numberOfChannels; i++)this.getChannelData(i).reverse();
        return this;
    }
    /**
     * If the buffer is loaded or not
     */ get loaded() {
        return this.length > 0;
    }
    /**
     * The duration of the buffer in seconds.
     */ get duration() {
        if (this._buffer) return this._buffer.duration;
        else return 0;
    }
    /**
     * The length of the buffer in samples
     */ get length() {
        if (this._buffer) return this._buffer.length;
        else return 0;
    }
    /**
     * The number of discrete audio channels. Returns 0 if no buffer is loaded.
     */ get numberOfChannels() {
        if (this._buffer) return this._buffer.numberOfChannels;
        else return 0;
    }
    /**
     * Reverse the buffer.
     */ get reverse() {
        return this._reversed;
    }
    set reverse(rev) {
        if (this._reversed !== rev) {
            this._reversed = rev;
            this._reverse();
        }
    }
    /**
     * Create a ToneAudioBuffer from the array. To create a multichannel AudioBuffer,
     * pass in a multidimensional array.
     * @param array The array to fill the audio buffer
     * @return A ToneAudioBuffer created from the array
     */ static fromArray(array) {
        return new $43da6dea502b5fe8$export$424a335715b38178().fromArray(array);
    }
    /**
     * Creates a ToneAudioBuffer from a URL, returns a promise which resolves to a ToneAudioBuffer
     * @param  url The url to load.
     * @return A promise which resolves to a ToneAudioBuffer
     */ static fromUrl(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const buffer = new $43da6dea502b5fe8$export$424a335715b38178();
            return yield buffer.load(url);
        });
    }
    /**
     * Loads a url using fetch and returns the AudioBuffer.
     */ static load(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            // test if the url contains multiple extensions
            const matches = url.match(/\[([^\]\[]+\|.+)\]$/);
            if (matches) {
                const extensions = matches[1].split("|");
                let extension = extensions[0];
                for (const ext of extensions)if ($43da6dea502b5fe8$export$424a335715b38178.supportsType(ext)) {
                    extension = ext;
                    break;
                }
                url = url.replace(matches[0], extension);
            }
            // make sure there is a slash between the baseUrl and the url
            const baseUrl = $43da6dea502b5fe8$export$424a335715b38178.baseUrl === "" || $43da6dea502b5fe8$export$424a335715b38178.baseUrl.endsWith("/") ? $43da6dea502b5fe8$export$424a335715b38178.baseUrl : $43da6dea502b5fe8$export$424a335715b38178.baseUrl + "/";
            const response = yield fetch(baseUrl + url);
            if (!response.ok) throw new Error(`could not load url: ${url}`);
            const arrayBuffer = yield response.arrayBuffer();
            const audioBuffer = yield (0, $b7b11709569bdbef$export$31553aaa555c1514)().decodeAudioData(arrayBuffer);
            return audioBuffer;
        });
    }
    /**
     * Checks a url's extension to see if the current browser can play that file type.
     * @param url The url/extension to test
     * @return If the file extension can be played
     * @static
     * @example
     * Tone.ToneAudioBuffer.supportsType("wav"); // returns true
     * Tone.ToneAudioBuffer.supportsType("path/to/file.wav"); // returns true
     */ static supportsType(url) {
        const extensions = url.split(".");
        const extension = extensions[extensions.length - 1];
        const response = document.createElement("audio").canPlayType("audio/" + extension);
        return response !== "";
    }
    /**
     * Returns a Promise which resolves when all of the buffers have loaded
     */ static loaded() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            // this makes sure that the function is always async
            yield Promise.resolve();
            while($43da6dea502b5fe8$export$424a335715b38178.downloads.length)yield $43da6dea502b5fe8$export$424a335715b38178.downloads[0];
        });
    }
}
//-------------------------------------
// STATIC METHODS
//-------------------------------------
/**
 * A path which is prefixed before every url.
 */ $43da6dea502b5fe8$export$424a335715b38178.baseUrl = "";
/**
 * All of the downloads
 */ $43da6dea502b5fe8$export$424a335715b38178.downloads = [];


class $815e2eef5c5fc2a8$export$46814dd5412c611c extends (0, $97c32a9cce8e2f52$export$841858b892ce1f4c) {
    constructor(){
        super({
            clockSource: "offline",
            context: (0, $1487bdec8f3de4a7$export$539f87c8e5511243)(arguments[0]) ? arguments[0] : (0, $bed5511bac81cb8c$export$b7df220975ff4035)(arguments[0], arguments[1] * arguments[2], arguments[2]),
            lookAhead: 0,
            updateInterval: (0, $1487bdec8f3de4a7$export$539f87c8e5511243)(arguments[0]) ? 128 / arguments[0].sampleRate : 128 / arguments[2]
        });
        this.name = "OfflineContext";
        /**
         * An artificial clock source
         */ this._currentTime = 0;
        this.isOffline = true;
        this._duration = (0, $1487bdec8f3de4a7$export$539f87c8e5511243)(arguments[0]) ? arguments[0].length / arguments[0].sampleRate : arguments[1];
    }
    /**
     * Override the now method to point to the internal clock time
     */ now() {
        return this._currentTime;
    }
    /**
     * Same as this.now()
     */ get currentTime() {
        return this._currentTime;
    }
    /**
     * Render just the clock portion of the audio context.
     */ _renderClock(asynchronous) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            let index = 0;
            while(this._duration - this._currentTime >= 0){
                // invoke all the callbacks on that time
                this.emit("tick");
                // increment the clock in block-sized chunks
                this._currentTime += 128 / this.sampleRate;
                // yield once a second of audio
                index++;
                const yieldEvery = Math.floor(this.sampleRate / 128);
                if (asynchronous && index % yieldEvery === 0) yield new Promise((done)=>setTimeout(done, 1));
            }
        });
    }
    /**
     * Render the output of the OfflineContext
     * @param asynchronous If the clock should be rendered asynchronously, which will not block the main thread, but be slightly slower.
     */ render(asynchronous = true) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            yield this.workletsAreReady();
            yield this._renderClock(asynchronous);
            const buffer = yield this._context.startRendering();
            return new (0, $43da6dea502b5fe8$export$424a335715b38178)(buffer);
        });
    }
    /**
     * Close the context
     */ close() {
        return Promise.resolve();
    }
}



/**
 * This dummy context is used to avoid throwing immediate errors when importing in Node.js
 */ const $b7b11709569bdbef$var$dummyContext = new (0, $0ec515c97546cbe4$export$bc5f2fd86e1bc223)();
/**
 * The global audio context which is getable and assignable through
 * getContext and setContext
 */ let $b7b11709569bdbef$var$globalContext = $b7b11709569bdbef$var$dummyContext;
function $b7b11709569bdbef$export$31553aaa555c1514() {
    if ($b7b11709569bdbef$var$globalContext === $b7b11709569bdbef$var$dummyContext && (0, $bed5511bac81cb8c$export$50898d6dff7e65a3)) $b7b11709569bdbef$export$2f04de43fe27971a(new (0, $97c32a9cce8e2f52$export$841858b892ce1f4c)());
    return $b7b11709569bdbef$var$globalContext;
}
function $b7b11709569bdbef$export$2f04de43fe27971a(context) {
    if ((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(context)) $b7b11709569bdbef$var$globalContext = new (0, $97c32a9cce8e2f52$export$841858b892ce1f4c)(context);
    else if ((0, $1487bdec8f3de4a7$export$539f87c8e5511243)(context)) $b7b11709569bdbef$var$globalContext = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(context);
    else $b7b11709569bdbef$var$globalContext = context;
}
function $b7b11709569bdbef$export$b3571188c770cc5a() {
    return $b7b11709569bdbef$var$globalContext.resume();
}
/**
 * Log Tone.js + version in the console.
 */ if ((0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2) && !(0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2).TONE_SILENCE_LOGGING) {
    let prefix = "v";
    if ((0, $8087cb83ba2ea5ef$export$83d89fbfd8236492) === "dev") prefix = "";
    const printString = ` * Tone.js ${prefix}${(0, $8087cb83ba2ea5ef$export$83d89fbfd8236492)} * `;
    // eslint-disable-next-line no-console
    console.log(`%c${printString}`, "background: #000; color: #fff");
}





/**
 * Equal power gain scale. Good for cross-fading.
 * @param  percent (0-1)
 */ function $84c2af7dbf01a14d$export$bfc35d599238ec59(percent) {
    const piFactor = 0.5 * Math.PI;
    return Math.sin(percent * piFactor);
}
function $84c2af7dbf01a14d$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}
function $84c2af7dbf01a14d$export$6af3969727ca2a60(gain) {
    return 20 * (Math.log(gain) / Math.LN10);
}
function $84c2af7dbf01a14d$export$5d18fe46719f6008(interval) {
    return Math.pow(2, interval / 12);
}
/**
 * The Global [concert tuning pitch](https://en.wikipedia.org/wiki/Concert_pitch) which is used
 * to generate all the other pitch values from notes. A4's values in Hertz.
 */ let $84c2af7dbf01a14d$var$A4 = 440;
function $84c2af7dbf01a14d$export$9f4826388a169ebd() {
    return $84c2af7dbf01a14d$var$A4;
}
function $84c2af7dbf01a14d$export$2a0f2ad6a5f8e4fe(freq) {
    $84c2af7dbf01a14d$var$A4 = freq;
}
function $84c2af7dbf01a14d$export$5cf9d9f9506eec5(frequency) {
    return Math.round($84c2af7dbf01a14d$export$12513e46625518e4(frequency));
}
function $84c2af7dbf01a14d$export$12513e46625518e4(frequency) {
    return 69 + 12 * Math.log2(frequency / $84c2af7dbf01a14d$var$A4);
}
function $84c2af7dbf01a14d$export$45a6434f7c391dc(midi) {
    return $84c2af7dbf01a14d$var$A4 * Math.pow(2, (midi - 69) / 12);
}






class $2e85bb48c14caf35$export$23b5656976f56273 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    /**
     * @param context The context associated with the time value. Used to compute
     * Transport and context-relative timing.
     * @param  value  The time value as a number, string or object
     * @param  units  Unit values
     */ constructor(context, value, units){
        super();
        /**
         * The default units
         */ this.defaultUnits = "s";
        this._val = value;
        this._units = units;
        this.context = context;
        this._expressions = this._getExpressions();
    }
    /**
     * All of the time encoding expressions
     */ _getExpressions() {
        return {
            hz: {
                method: (value)=>{
                    return this._frequencyToUnits(parseFloat(value));
                },
                regexp: /^(\d+(?:\.\d+)?)hz$/i
            },
            i: {
                method: (value)=>{
                    return this._ticksToUnits(parseInt(value, 10));
                },
                regexp: /^(\d+)i$/i
            },
            m: {
                method: (value)=>{
                    return this._beatsToUnits(parseInt(value, 10) * this._getTimeSignature());
                },
                regexp: /^(\d+)m$/i
            },
            n: {
                method: (value, dot)=>{
                    const numericValue = parseInt(value, 10);
                    const scalar = dot === "." ? 1.5 : 1;
                    if (numericValue === 1) return this._beatsToUnits(this._getTimeSignature()) * scalar;
                    else return this._beatsToUnits(4 / numericValue) * scalar;
                },
                regexp: /^(\d+)n(\.?)$/i
            },
            number: {
                method: (value)=>{
                    return this._expressions[this.defaultUnits].method.call(this, value);
                },
                regexp: /^(\d+(?:\.\d+)?)$/
            },
            s: {
                method: (value)=>{
                    return this._secondsToUnits(parseFloat(value));
                },
                regexp: /^(\d+(?:\.\d+)?)s$/
            },
            samples: {
                method: (value)=>{
                    return parseInt(value, 10) / this.context.sampleRate;
                },
                regexp: /^(\d+)samples$/
            },
            t: {
                method: (value)=>{
                    const numericValue = parseInt(value, 10);
                    return this._beatsToUnits(8 / (Math.floor(numericValue) * 3));
                },
                regexp: /^(\d+)t$/i
            },
            tr: {
                method: (m, q, s)=>{
                    let total = 0;
                    if (m && m !== "0") total += this._beatsToUnits(this._getTimeSignature() * parseFloat(m));
                    if (q && q !== "0") total += this._beatsToUnits(parseFloat(q));
                    if (s && s !== "0") total += this._beatsToUnits(parseFloat(s) / 4);
                    return total;
                },
                regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?$/
            }
        };
    }
    //-------------------------------------
    // 	VALUE OF
    //-------------------------------------
    /**
     * Evaluate the time value. Returns the time in seconds.
     */ valueOf() {
        if (this._val instanceof $2e85bb48c14caf35$export$23b5656976f56273) this.fromType(this._val);
        if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(this._val)) return this._noArg();
        else if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(this._val) && (0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(this._units)) {
            for(const units in this._expressions)if (this._expressions[units].regexp.test(this._val.trim())) {
                this._units = units;
                break;
            }
        } else if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(this._val)) {
            let total = 0;
            for(const typeName in this._val)if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._val[typeName])) {
                const quantity = this._val[typeName];
                // @ts-ignore
                const time = new this.constructor(this.context, typeName).valueOf() * quantity;
                total += time;
            }
            return total;
        }
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._units)) {
            const expr = this._expressions[this._units];
            const matching = this._val.toString().trim().match(expr.regexp);
            if (matching) return expr.method.apply(this, matching.slice(1));
            else return expr.method.call(this, this._val);
        } else if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(this._val)) return parseFloat(this._val);
        else return this._val;
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS
    //-------------------------------------
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return 1 / freq;
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return 60 / this._getBpm() * beats;
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return seconds;
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return ticks * this._beatsToUnits(1) / this._getPPQ();
    }
    /**
     * With no arguments, return 'now'
     */ _noArg() {
        return this._now();
    }
    //-------------------------------------
    // 	TEMPO CONVERSIONS
    //-------------------------------------
    /**
     * Return the bpm
     */ _getBpm() {
        return this.context.transport.bpm.value;
    }
    /**
     * Return the timeSignature
     */ _getTimeSignature() {
        return this.context.transport.timeSignature;
    }
    /**
     * Return the PPQ or 192 if Transport is not available
     */ _getPPQ() {
        return this.context.transport.PPQ;
    }
    //-------------------------------------
    // 	CONVERSION INTERFACE
    //-------------------------------------
    /**
     * Coerce a time type into this units type.
     * @param type Any time type units
     */ fromType(type) {
        this._units = undefined;
        switch(this.defaultUnits){
            case "s":
                this._val = type.toSeconds();
                break;
            case "i":
                this._val = type.toTicks();
                break;
            case "hz":
                this._val = type.toFrequency();
                break;
            case "midi":
                this._val = type.toMidi();
                break;
        }
        return this;
    }
    /**
     * Return the value in hertz
     */ toFrequency() {
        return 1 / this.toSeconds();
    }
    /**
     * Return the time in samples
     */ toSamples() {
        return this.toSeconds() * this.context.sampleRate;
    }
    /**
     * Return the time in milliseconds.
     */ toMilliseconds() {
        return this.toSeconds() * 1000;
    }
}


class $3b2efe963ae63025$export$52b3039dca93a306 extends (0, $2e85bb48c14caf35$export$23b5656976f56273) {
    constructor(){
        super(...arguments);
        this.name = "TimeClass";
    }
    _getExpressions() {
        return Object.assign(super._getExpressions(), {
            now: {
                method: (capture)=>{
                    return this._now() + new this.constructor(this.context, capture).valueOf();
                },
                regexp: /^\+(.+)/
            },
            quantize: {
                method: (capture)=>{
                    const quantTo = new $3b2efe963ae63025$export$52b3039dca93a306(this.context, capture).valueOf();
                    return this._secondsToUnits(this.context.transport.nextSubdivision(quantTo));
                },
                regexp: /^@(.+)/
            }
        });
    }
    /**
     * Quantize the time by the given subdivision. Optionally add a
     * percentage which will move the time value towards the ideal
     * quantized value by that percentage.
     * @param  subdiv    The subdivision to quantize to
     * @param  percent  Move the time value towards the quantized value by a percentage.
     * @example
     * Tone.Time(21).quantize(2); // returns 22
     * Tone.Time(0.6).quantize("4n", 0.5); // returns 0.55
     */ quantize(subdiv, percent = 1) {
        const subdivision = new this.constructor(this.context, subdiv).valueOf();
        const value = this.valueOf();
        const multiple = Math.round(value / subdivision);
        const ideal = multiple * subdivision;
        const diff = ideal - value;
        return value + diff * percent;
    }
    //-------------------------------------
    // CONVERSIONS
    //-------------------------------------
    /**
     * Convert a Time to Notation. The notation values are will be the
     * closest representation between 1m to 128th note.
     * @return {Notation}
     * @example
     * // if the Transport is at 120bpm:
     * Tone.Time(2).toNotation(); // returns "1m"
     */ toNotation() {
        const time = this.toSeconds();
        const testNotations = [
            "1m"
        ];
        for(let power = 1; power < 9; power++){
            const subdiv = Math.pow(2, power);
            testNotations.push(subdiv + "n.");
            testNotations.push(subdiv + "n");
            testNotations.push(subdiv + "t");
        }
        testNotations.push("0");
        // find the closets notation representation
        let closest = testNotations[0];
        let closestSeconds = new $3b2efe963ae63025$export$52b3039dca93a306(this.context, testNotations[0]).toSeconds();
        testNotations.forEach((notation)=>{
            const notationSeconds = new $3b2efe963ae63025$export$52b3039dca93a306(this.context, notation).toSeconds();
            if (Math.abs(notationSeconds - time) < Math.abs(closestSeconds - time)) {
                closest = notation;
                closestSeconds = notationSeconds;
            }
        });
        return closest;
    }
    /**
     * Return the time encoded as Bars:Beats:Sixteenths.
     */ toBarsBeatsSixteenths() {
        const quarterTime = this._beatsToUnits(1);
        let quarters = this.valueOf() / quarterTime;
        quarters = parseFloat(quarters.toFixed(4));
        const measures = Math.floor(quarters / this._getTimeSignature());
        let sixteenths = quarters % 1 * 4;
        quarters = Math.floor(quarters) % this._getTimeSignature();
        const sixteenthString = sixteenths.toString();
        if (sixteenthString.length > 3) // the additional parseFloat removes insignificant trailing zeroes
        sixteenths = parseFloat(parseFloat(sixteenthString).toFixed(3));
        const progress = [
            measures,
            quarters,
            sixteenths
        ];
        return progress.join(":");
    }
    /**
     * Return the time in ticks.
     */ toTicks() {
        const quarterTime = this._beatsToUnits(1);
        const quarters = this.valueOf() / quarterTime;
        return Math.round(quarters * this._getPPQ());
    }
    /**
     * Return the time in seconds.
     */ toSeconds() {
        return this.valueOf();
    }
    /**
     * Return the value as a midi note.
     */ toMidi() {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(this.toFrequency());
    }
    _now() {
        return this.context.now();
    }
}
function $3b2efe963ae63025$export$680ea196effce5f(value, units) {
    return new $3b2efe963ae63025$export$52b3039dca93a306((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}


class $f4d7193118bd1d27$export$38b56155c8552868 extends (0, $3b2efe963ae63025$export$52b3039dca93a306) {
    constructor(){
        super(...arguments);
        this.name = "Frequency";
        this.defaultUnits = "hz";
    }
    /**
     * The [concert tuning pitch](https://en.wikipedia.org/wiki/Concert_pitch) which is used
     * to generate all the other pitch values from notes. A4's values in Hertz.
     */ static get A4() {
        return (0, $84c2af7dbf01a14d$export$9f4826388a169ebd)();
    }
    static set A4(freq) {
        (0, $84c2af7dbf01a14d$export$2a0f2ad6a5f8e4fe)(freq);
    }
    //-------------------------------------
    // 	AUGMENT BASE EXPRESSIONS
    //-------------------------------------
    _getExpressions() {
        return Object.assign({}, super._getExpressions(), {
            midi: {
                regexp: /^(\d+(?:\.\d+)?midi)/,
                method (value) {
                    if (this.defaultUnits === "midi") return value;
                    else return $f4d7193118bd1d27$export$38b56155c8552868.mtof(value);
                }
            },
            note: {
                regexp: /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i,
                method (pitch, octave) {
                    const index = $f4d7193118bd1d27$var$noteToScaleIndex[pitch.toLowerCase()];
                    const noteNumber = index + (parseInt(octave, 10) + 1) * 12;
                    if (this.defaultUnits === "midi") return noteNumber;
                    else return $f4d7193118bd1d27$export$38b56155c8552868.mtof(noteNumber);
                }
            },
            tr: {
                regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
                method (m, q, s) {
                    let total = 1;
                    if (m && m !== "0") total *= this._beatsToUnits(this._getTimeSignature() * parseFloat(m));
                    if (q && q !== "0") total *= this._beatsToUnits(parseFloat(q));
                    if (s && s !== "0") total *= this._beatsToUnits(parseFloat(s) / 4);
                    return total;
                }
            }
        });
    }
    //-------------------------------------
    // 	EXPRESSIONS
    //-------------------------------------
    /**
     * Transposes the frequency by the given number of semitones.
     * @return  A new transposed frequency
     * @example
     * Tone.Frequency("A4").transpose(3); // "C5"
     */ transpose(interval) {
        return new $f4d7193118bd1d27$export$38b56155c8552868(this.context, this.valueOf() * (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(interval));
    }
    /**
     * Takes an array of semitone intervals and returns
     * an array of frequencies transposed by those intervals.
     * @return  Returns an array of Frequencies
     * @example
     * Tone.Frequency("A4").harmonize([0, 3, 7]); // ["A4", "C5", "E5"]
     */ harmonize(intervals) {
        return intervals.map((interval)=>{
            return this.transpose(interval);
        });
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS
    //-------------------------------------
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Frequency("C4").toMidi(); // 60
     */ toMidi() {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(this.valueOf());
    }
    /**
     * Return the value of the frequency in Scientific Pitch Notation
     * @example
     * Tone.Frequency(69, "midi").toNote(); // "A4"
     */ toNote() {
        const freq = this.toFrequency();
        const log = Math.log2(freq / $f4d7193118bd1d27$export$38b56155c8552868.A4);
        let noteNumber = Math.round(12 * log) + 57;
        const octave = Math.floor(noteNumber / 12);
        if (octave < 0) noteNumber += -12 * octave;
        const noteName = $f4d7193118bd1d27$var$scaleIndexToNote[noteNumber % 12];
        return noteName + octave.toString();
    }
    /**
     * Return the duration of one cycle in seconds.
     */ toSeconds() {
        return 1 / super.toSeconds();
    }
    /**
     * Return the duration of one cycle in ticks
     */ toTicks() {
        const quarterTime = this._beatsToUnits(1);
        const quarters = this.valueOf() / quarterTime;
        return Math.floor(quarters * this._getPPQ());
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS HELPERS
    //-------------------------------------
    /**
     * With no arguments, return 0
     */ _noArg() {
        return 0;
    }
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return freq;
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return 1 / (ticks * 60 / (this._getBpm() * this._getPPQ()));
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return 1 / super._beatsToUnits(beats);
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return 1 / seconds;
    }
    /**
     * Convert a MIDI note to frequency value.
     * @param  midi The midi number to convert.
     * @return The corresponding frequency value
     */ static mtof(midi) {
        return (0, $84c2af7dbf01a14d$export$45a6434f7c391dc)(midi);
    }
    /**
     * Convert a frequency value to a MIDI note.
     * @param frequency The value to frequency value to convert.
     */ static ftom(frequency) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(frequency);
    }
}
//-------------------------------------
// 	FREQUENCY CONVERSIONS
//-------------------------------------
/**
 * Note to scale index.
 * @hidden
 */ const $f4d7193118bd1d27$var$noteToScaleIndex = {
    cbb: -2,
    cb: -1,
    c: 0,
    "c#": 1,
    cx: 2,
    dbb: 0,
    db: 1,
    d: 2,
    "d#": 3,
    dx: 4,
    ebb: 2,
    eb: 3,
    e: 4,
    "e#": 5,
    ex: 6,
    fbb: 3,
    fb: 4,
    f: 5,
    "f#": 6,
    fx: 7,
    gbb: 5,
    gb: 6,
    g: 7,
    "g#": 8,
    gx: 9,
    abb: 7,
    ab: 8,
    a: 9,
    "a#": 10,
    ax: 11,
    bbb: 9,
    bb: 10,
    b: 11,
    "b#": 12,
    bx: 13
};
/**
 * scale index to note (sharps)
 * @hidden
 */ const $f4d7193118bd1d27$var$scaleIndexToNote = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
];
function $f4d7193118bd1d27$export$44c95d3770756ed2(value, units) {
    return new $f4d7193118bd1d27$export$38b56155c8552868((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}





class $ef656febef4c2085$export$c824041178a9697 extends (0, $3b2efe963ae63025$export$52b3039dca93a306) {
    constructor(){
        super(...arguments);
        this.name = "TransportTime";
    }
    /**
     * Return the current time in whichever context is relevant
     */ _now() {
        return this.context.transport.seconds;
    }
}
function $ef656febef4c2085$export$c5a05eab537a3f95(value, units) {
    return new $ef656febef4c2085$export$c824041178a9697((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}




class $f4f7e4e5607dba1a$export$4eb0ca57400aa172 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f4f7e4e5607dba1a$export$4eb0ca57400aa172.getDefaults(), arguments, [
            "context"
        ]);
        if (this.defaultContext) this.context = this.defaultContext;
        else this.context = options.context;
    }
    static getDefaults() {
        return {
            context: (0, $b7b11709569bdbef$export$31553aaa555c1514)()
        };
    }
    /**
     * Return the current time of the Context clock plus the lookAhead.
     * @example
     * setInterval(() => {
     * 	console.log(Tone.now());
     * }, 100);
     */ now() {
        return this.context.currentTime + this.context.lookAhead;
    }
    /**
     * Return the current time of the Context clock without any lookAhead.
     * @example
     * setInterval(() => {
     * 	console.log(Tone.immediate());
     * }, 100);
     */ immediate() {
        return this.context.currentTime;
    }
    /**
     * The duration in seconds of one sample.
     * @example
     * console.log(Tone.Transport.sampleTime);
     */ get sampleTime() {
        return 1 / this.context.sampleRate;
    }
    /**
     * The number of seconds of 1 processing block (128 samples)
     * @example
     * console.log(Tone.Destination.blockTime);
     */ get blockTime() {
        return 128 / this.context.sampleRate;
    }
    /**
     * Convert the incoming time to seconds.
     * This is calculated against the current [[Tone.Transport]] bpm
     * @example
     * const gain = new Tone.Gain();
     * setInterval(() => console.log(gain.toSeconds("4n")), 100);
     * // ramp the tempo to 60 bpm over 30 seconds
     * Tone.getTransport().bpm.rampTo(60, 30);
     */ toSeconds(time) {
        return new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, time).toSeconds();
    }
    /**
     * Convert the input to a frequency number
     * @example
     * const gain = new Tone.Gain();
     * console.log(gain.toFrequency("4n"));
     */ toFrequency(freq) {
        return new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, freq).toFrequency();
    }
    /**
     * Convert the input time into ticks
     * @example
     * const gain = new Tone.Gain();
     * console.log(gain.toTicks("4n"));
     */ toTicks(time) {
        return new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toTicks();
    }
    //-------------------------------------
    // 	GET/SET
    //-------------------------------------
    /**
     * Get a subset of the properties which are in the partial props
     */ _getPartialProperties(props) {
        const options = this.get();
        // remove attributes from the prop that are not in the partial
        Object.keys(options).forEach((name)=>{
            if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(props[name])) delete options[name];
        });
        return options;
    }
    /**
     * Get the object's attributes.
     * @example
     * const osc = new Tone.Oscillator();
     * console.log(osc.get());
     */ get() {
        const defaults = (0, $07d9216a29f4e8bb$export$4b8c3341c9aef2b8)(this);
        Object.keys(defaults).forEach((attribute)=>{
            if (Reflect.has(this, attribute)) {
                const member = this[attribute];
                if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(member) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(member.value) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(member.setValueAtTime)) defaults[attribute] = member.value;
                else if (member instanceof $f4f7e4e5607dba1a$export$4eb0ca57400aa172) defaults[attribute] = member._getPartialProperties(defaults[attribute]);
                else if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(member) || (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(member) || (0, $4d7f709c9ffa5105$export$844ec244b1367d54)(member) || (0, $4d7f709c9ffa5105$export$f9ce7b637dfbe238)(member)) defaults[attribute] = member;
                else // remove all undefined and unserializable attributes
                delete defaults[attribute];
            }
        });
        return defaults;
    }
    /**
     * Set multiple properties at once with an object.
     * @example
     * const filter = new Tone.Filter().toDestination();
     * // set values using an object
     * filter.set({
     * 	frequency: "C6",
     * 	type: "highpass"
     * });
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/Analogsynth_octaves_highmid.mp3").connect(filter);
     * player.autostart = true;
     */ set(props) {
        Object.keys(props).forEach((attribute)=>{
            if (Reflect.has(this, attribute) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this[attribute])) {
                if (this[attribute] && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this[attribute].value) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this[attribute].setValueAtTime)) // small optimization
                {
                    if (this[attribute].value !== props[attribute]) this[attribute].value = props[attribute];
                } else if (this[attribute] instanceof $f4f7e4e5607dba1a$export$4eb0ca57400aa172) this[attribute].set(props[attribute]);
                else this[attribute] = props[attribute];
            }
        });
        return this;
    }
}







class $a30e69eba5ea5b5a$export$89221a927ffadcaf extends (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94) {
    constructor(initial = "stopped"){
        super();
        this.name = "StateTimeline";
        this._initial = initial;
        this.setStateAtTime(this._initial, 0);
    }
    /**
     * Returns the scheduled state scheduled before or at
     * the given time.
     * @param  time  The time to query.
     * @return  The name of the state input in setStateAtTime.
     */ getValueAtTime(time) {
        const event = this.get(time);
        if (event !== null) return event.state;
        else return this._initial;
    }
    /**
     * Add a state to the timeline.
     * @param  state The name of the state to set.
     * @param  time  The time to query.
     * @param options Any additional options that are needed in the timeline.
     */ setStateAtTime(state, time, options) {
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(time, 0);
        this.add(Object.assign({}, options, {
            state: state,
            time: time
        }));
        return this;
    }
    /**
     * Return the event before the time with the given state
     * @param  state The state to look for
     * @param  time  When to check before
     * @return  The event with the given state before the time
     */ getLastState(state, time) {
        // time = this.toSeconds(time);
        const index = this._search(time);
        for(let i = index; i >= 0; i--){
            const event = this._timeline[i];
            if (event.state === state) return event;
        }
    }
    /**
     * Return the event after the time with the given state
     * @param  state The state to look for
     * @param  time  When to check from
     * @return  The event with the given state after the time
     */ getNextState(state, time) {
        // time = this.toSeconds(time);
        const index = this._search(time);
        if (index !== -1) for(let i = index; i < this._timeline.length; i++){
            const event = this._timeline[i];
            if (event.state === state) return event;
        }
    }
}
















class $4e42d28fbc344697$export$1ca45c9a47aec42c extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4e42d28fbc344697$export$1ca45c9a47aec42c.getDefaults(), arguments, [
            "param",
            "units",
            "convert"
        ]));
        this.name = "Param";
        this.overridden = false;
        /**
         * The minimum output value
         */ this._minOutput = 1e-7;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4e42d28fbc344697$export$1ca45c9a47aec42c.getDefaults(), arguments, [
            "param",
            "units",
            "convert"
        ]);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(options.param) && ((0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(options.param) || options.param instanceof $4e42d28fbc344697$export$1ca45c9a47aec42c), "param must be an AudioParam");
        while(!(0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(options.param))options.param = options.param._param;
        this._swappable = (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(options.swappable) ? options.swappable : false;
        if (this._swappable) {
            this.input = this.context.createGain();
            // initialize
            this._param = options.param;
            this.input.connect(this._param);
        } else this._param = this.input = options.param;
        this._events = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)(1000);
        this._initialValue = this._param.defaultValue;
        this.units = options.units;
        this.convert = options.convert;
        this._minValue = options.minValue;
        this._maxValue = options.maxValue;
        // if the value is defined, set it immediately
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(options.value) && options.value !== this._toType(this._initialValue)) this.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            convert: true,
            units: "number"
        });
    }
    get value() {
        const now = this.now();
        return this.getValueAtTime(now);
    }
    set value(value) {
        this.cancelScheduledValues(this.now());
        this.setValueAtTime(value, this.now());
    }
    get minValue() {
        // if it's not the default minValue, return it
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._minValue)) return this._minValue;
        else if (this.units === "time" || this.units === "frequency" || this.units === "normalRange" || this.units === "positive" || this.units === "transportTime" || this.units === "ticks" || this.units === "bpm" || this.units === "hertz" || this.units === "samples") return 0;
        else if (this.units === "audioRange") return -1;
        else if (this.units === "decibels") return -Infinity;
        else return this._param.minValue;
    }
    get maxValue() {
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._maxValue)) return this._maxValue;
        else if (this.units === "normalRange" || this.units === "audioRange") return 1;
        else return this._param.maxValue;
    }
    /**
     * Type guard based on the unit name
     */ _is(arg, type) {
        return this.units === type;
    }
    /**
     * Make sure the value is always in the defined range
     */ _assertRange(value) {
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.maxValue) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.minValue)) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(value, this._fromType(this.minValue), this._fromType(this.maxValue));
        return value;
    }
    /**
     * Convert the given value from the type specified by Param.units
     * into the destination value (such as Gain or Frequency).
     */ _fromType(val) {
        if (this.convert && !this.overridden) {
            if (this._is(val, "time")) return this.toSeconds(val);
            else if (this._is(val, "decibels")) return (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(val);
            else if (this._is(val, "frequency")) return this.toFrequency(val);
            else return val;
        } else if (this.overridden) // if it's overridden, should only schedule 0s
        return 0;
        else return val;
    }
    /**
     * Convert the parameters value into the units specified by Param.units.
     */ _toType(val) {
        if (this.convert && this.units === "decibels") return (0, $84c2af7dbf01a14d$export$6af3969727ca2a60)(val);
        else return val;
    }
    //-------------------------------------
    // ABSTRACT PARAM INTERFACE
    // all docs are generated from ParamInterface.ts
    //-------------------------------------
    setValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        const numericValue = this._fromType(value);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to setValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(time)}`);
        this._assertRange(numericValue);
        this.log(this.units, "setValueAtTime", value, computedTime);
        this._events.add({
            time: computedTime,
            type: "setValueAtTime",
            value: numericValue
        });
        this._param.setValueAtTime(numericValue, computedTime);
        return this;
    }
    getValueAtTime(time) {
        const computedTime = Math.max(this.toSeconds(time), 0);
        const after = this._events.getAfter(computedTime);
        const before = this._events.get(computedTime);
        let value = this._initialValue;
        // if it was set by
        if (before === null) value = this._initialValue;
        else if (before.type === "setTargetAtTime" && (after === null || after.type === "setValueAtTime")) {
            const previous = this._events.getBefore(before.time);
            let previousVal;
            if (previous === null) previousVal = this._initialValue;
            else previousVal = previous.value;
            if (before.type === "setTargetAtTime") value = this._exponentialApproach(before.time, previousVal, before.value, before.constant, computedTime);
        } else if (after === null) value = before.value;
        else if (after.type === "linearRampToValueAtTime" || after.type === "exponentialRampToValueAtTime") {
            let beforeValue = before.value;
            if (before.type === "setTargetAtTime") {
                const previous = this._events.getBefore(before.time);
                if (previous === null) beforeValue = this._initialValue;
                else beforeValue = previous.value;
            }
            if (after.type === "linearRampToValueAtTime") value = this._linearInterpolate(before.time, beforeValue, after.time, after.value, computedTime);
            else value = this._exponentialInterpolate(before.time, beforeValue, after.time, after.value, computedTime);
        } else value = before.value;
        return this._toType(value);
    }
    setRampPoint(time) {
        time = this.toSeconds(time);
        let currentVal = this.getValueAtTime(time);
        this.cancelAndHoldAtTime(time);
        if (this._fromType(currentVal) === 0) currentVal = this._toType(this._minOutput);
        this.setValueAtTime(currentVal, time);
        return this;
    }
    linearRampToValueAtTime(value, endTime) {
        const numericValue = this._fromType(value);
        const computedTime = this.toSeconds(endTime);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to linearRampToValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(endTime)}`);
        this._assertRange(numericValue);
        this._events.add({
            time: computedTime,
            type: "linearRampToValueAtTime",
            value: numericValue
        });
        this.log(this.units, "linearRampToValueAtTime", value, computedTime);
        this._param.linearRampToValueAtTime(numericValue, computedTime);
        return this;
    }
    exponentialRampToValueAtTime(value, endTime) {
        let numericValue = this._fromType(value);
        // the value can't be 0
        numericValue = (0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(numericValue, 0) ? this._minOutput : numericValue;
        this._assertRange(numericValue);
        const computedTime = this.toSeconds(endTime);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to exponentialRampToValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(endTime)}`);
        // store the event
        this._events.add({
            time: computedTime,
            type: "exponentialRampToValueAtTime",
            value: numericValue
        });
        this.log(this.units, "exponentialRampToValueAtTime", value, computedTime);
        this._param.exponentialRampToValueAtTime(numericValue, computedTime);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.exponentialRampToValueAtTime(value, startTime + this.toSeconds(rampTime));
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.linearRampToValueAtTime(value, startTime + this.toSeconds(rampTime));
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.exponentialApproachValueAtTime(value, startTime, rampTime);
        return this;
    }
    exponentialApproachValueAtTime(value, time, rampTime) {
        time = this.toSeconds(time);
        rampTime = this.toSeconds(rampTime);
        const timeConstant = Math.log(rampTime + 1) / Math.log(200);
        this.setTargetAtTime(value, time, timeConstant);
        // at 90% start a linear ramp to the final value
        this.cancelAndHoldAtTime(time + rampTime * 0.9);
        this.linearRampToValueAtTime(value, time + rampTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        const numericValue = this._fromType(value);
        // The value will never be able to approach without timeConstant > 0.
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(timeConstant) && timeConstant > 0, "timeConstant must be a number greater than 0");
        const computedTime = this.toSeconds(startTime);
        this._assertRange(numericValue);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to setTargetAtTime: ${JSON.stringify(value)}, ${JSON.stringify(startTime)}`);
        this._events.add({
            constant: timeConstant,
            time: computedTime,
            type: "setTargetAtTime",
            value: numericValue
        });
        this.log(this.units, "setTargetAtTime", value, computedTime, timeConstant);
        this._param.setTargetAtTime(numericValue, computedTime, timeConstant);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling = 1) {
        duration = this.toSeconds(duration);
        startTime = this.toSeconds(startTime);
        const startingValue = this._fromType(values[0]) * scaling;
        this.setValueAtTime(this._toType(startingValue), startTime);
        const segTime = duration / (values.length - 1);
        for(let i = 1; i < values.length; i++){
            const numericValue = this._fromType(values[i]) * scaling;
            this.linearRampToValueAtTime(this._toType(numericValue), startTime + i * segTime);
        }
        return this;
    }
    cancelScheduledValues(time) {
        const computedTime = this.toSeconds(time);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(computedTime), `Invalid argument to cancelScheduledValues: ${JSON.stringify(time)}`);
        this._events.cancel(computedTime);
        this._param.cancelScheduledValues(computedTime);
        this.log(this.units, "cancelScheduledValues", computedTime);
        return this;
    }
    cancelAndHoldAtTime(time) {
        const computedTime = this.toSeconds(time);
        const valueAtTime = this._fromType(this.getValueAtTime(computedTime));
        // remove the schedule events
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(computedTime), `Invalid argument to cancelAndHoldAtTime: ${JSON.stringify(time)}`);
        this.log(this.units, "cancelAndHoldAtTime", computedTime, "value=" + valueAtTime);
        // if there is an event at the given computedTime
        // and that even is not a "set"
        const before = this._events.get(computedTime);
        const after = this._events.getAfter(computedTime);
        if (before && (0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(before.time, computedTime)) {
            // remove everything after
            if (after) {
                this._param.cancelScheduledValues(after.time);
                this._events.cancel(after.time);
            } else {
                this._param.cancelAndHoldAtTime(computedTime);
                this._events.cancel(computedTime + this.sampleTime);
            }
        } else if (after) {
            this._param.cancelScheduledValues(after.time);
            // cancel the next event(s)
            this._events.cancel(after.time);
            if (after.type === "linearRampToValueAtTime") this.linearRampToValueAtTime(this._toType(valueAtTime), computedTime);
            else if (after.type === "exponentialRampToValueAtTime") this.exponentialRampToValueAtTime(this._toType(valueAtTime), computedTime);
        }
        // set the value at the given time
        this._events.add({
            time: computedTime,
            type: "setValueAtTime",
            value: valueAtTime
        });
        this._param.setValueAtTime(valueAtTime, computedTime);
        return this;
    }
    rampTo(value, rampTime = 0.1, startTime) {
        if (this.units === "frequency" || this.units === "bpm" || this.units === "decibels") this.exponentialRampTo(value, rampTime, startTime);
        else this.linearRampTo(value, rampTime, startTime);
        return this;
    }
    /**
     * Apply all of the previously scheduled events to the passed in Param or AudioParam.
     * The applied values will start at the context's current time and schedule
     * all of the events which are scheduled on this Param onto the passed in param.
     */ apply(param) {
        const now = this.context.currentTime;
        // set the param's value at the current time and schedule everything else
        param.setValueAtTime(this.getValueAtTime(now), now);
        // if the previous event was a curve, then set the rest of it
        const previousEvent = this._events.get(now);
        if (previousEvent && previousEvent.type === "setTargetAtTime") {
            // approx it until the next event with linear ramps
            const nextEvent = this._events.getAfter(previousEvent.time);
            // or for 2 seconds if there is no event
            const endTime = nextEvent ? nextEvent.time : now + 2;
            const subdivisions = (endTime - now) / 10;
            for(let i = now; i < endTime; i += subdivisions)param.linearRampToValueAtTime(this.getValueAtTime(i), i);
        }
        this._events.forEachAfter(this.context.currentTime, (event)=>{
            if (event.type === "cancelScheduledValues") param.cancelScheduledValues(event.time);
            else if (event.type === "setTargetAtTime") param.setTargetAtTime(event.value, event.time, event.constant);
            else param[event.type](event.value, event.time);
        });
        return this;
    }
    /**
     * Replace the Param's internal AudioParam. Will apply scheduled curves
     * onto the parameter and replace the connections.
     */ setParam(param) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this._swappable, "The Param must be assigned as 'swappable' in the constructor");
        const input = this.input;
        input.disconnect(this._param);
        this.apply(param);
        this._param = param;
        input.connect(this._param);
        return this;
    }
    dispose() {
        super.dispose();
        this._events.dispose();
        return this;
    }
    get defaultValue() {
        return this._toType(this._param.defaultValue);
    }
    //-------------------------------------
    // 	AUTOMATION CURVE CALCULATIONS
    // 	MIT License, copyright (c) 2014 Jordan Santell
    //-------------------------------------
    // Calculates the the value along the curve produced by setTargetAtTime
    _exponentialApproach(t0, v0, v1, timeConstant, t) {
        return v1 + (v0 - v1) * Math.exp(-(t - t0) / timeConstant);
    }
    // Calculates the the value along the curve produced by linearRampToValueAtTime
    _linearInterpolate(t0, v0, t1, v1, t) {
        return v0 + (v1 - v0) * ((t - t0) / (t1 - t0));
    }
    // Calculates the the value along the curve produced by exponentialRampToValueAtTime
    _exponentialInterpolate(t0, v0, t1, v1, t) {
        return v0 * Math.pow(v1 / v0, (t - t0) / (t1 - t0));
    }
}







class $1dae52eee8c779dd$export$14a6d069f26d1d33 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super(...arguments);
        /**
         * The name of the class
         */ this.name = "ToneAudioNode";
        /**
         * List all of the node that must be set to match the ChannelProperties
         */ this._internalChannels = [];
    }
    /**
     * The number of inputs feeding into the AudioNode.
     * For source nodes, this will be 0.
     * @example
     * const node = new Tone.Gain();
     * console.log(node.numberOfInputs);
     */ get numberOfInputs() {
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.input)) {
            if ((0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(this.input) || this.input instanceof (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)) return 1;
            else return this.input.numberOfInputs;
        } else return 0;
    }
    /**
     * The number of outputs of the AudioNode.
     * @example
     * const node = new Tone.Gain();
     * console.log(node.numberOfOutputs);
     */ get numberOfOutputs() {
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.output)) return this.output.numberOfOutputs;
        else return 0;
    }
    //-------------------------------------
    // AUDIO PROPERTIES
    //-------------------------------------
    /**
     * Used to decide which nodes to get/set properties on
     */ _isAudioNode(node) {
        return (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(node) && (node instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33 || (0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(node));
    }
    /**
     * Get all of the audio nodes (either internal or input/output) which together
     * make up how the class node responds to channel input/output
     */ _getInternalNodes() {
        const nodeList = this._internalChannels.slice(0);
        if (this._isAudioNode(this.input)) nodeList.push(this.input);
        if (this._isAudioNode(this.output)) {
            if (this.input !== this.output) nodeList.push(this.output);
        }
        return nodeList;
    }
    /**
     * Set the audio options for this node such as channelInterpretation
     * channelCount, etc.
     * @param options
     */ _setChannelProperties(options) {
        const nodeList = this._getInternalNodes();
        nodeList.forEach((node)=>{
            node.channelCount = options.channelCount;
            node.channelCountMode = options.channelCountMode;
            node.channelInterpretation = options.channelInterpretation;
        });
    }
    /**
     * Get the current audio options for this node such as channelInterpretation
     * channelCount, etc.
     */ _getChannelProperties() {
        const nodeList = this._getInternalNodes();
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(nodeList.length > 0, "ToneAudioNode does not have any internal nodes");
        // use the first node to get properties
        // they should all be the same
        const node = nodeList[0];
        return {
            channelCount: node.channelCount,
            channelCountMode: node.channelCountMode,
            channelInterpretation: node.channelInterpretation
        };
    }
    /**
     * channelCount is the number of channels used when up-mixing and down-mixing
     * connections to any inputs to the node. The default value is 2 except for
     * specific nodes where its value is specially determined.
     */ get channelCount() {
        return this._getChannelProperties().channelCount;
    }
    set channelCount(channelCount) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelCount: channelCount
        }));
    }
    /**
     * channelCountMode determines how channels will be counted when up-mixing and
     * down-mixing connections to any inputs to the node.
     * The default value is "max". This attribute has no effect for nodes with no inputs.
     * * "max" - computedNumberOfChannels is the maximum of the number of channels of all connections to an input. In this mode channelCount is ignored.
     * * "clamped-max" - computedNumberOfChannels is determined as for "max" and then clamped to a maximum value of the given channelCount.
     * * "explicit" - computedNumberOfChannels is the exact value as specified by the channelCount.
     */ get channelCountMode() {
        return this._getChannelProperties().channelCountMode;
    }
    set channelCountMode(channelCountMode) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelCountMode: channelCountMode
        }));
    }
    /**
     * channelInterpretation determines how individual channels will be treated
     * when up-mixing and down-mixing connections to any inputs to the node.
     * The default value is "speakers".
     */ get channelInterpretation() {
        return this._getChannelProperties().channelInterpretation;
    }
    set channelInterpretation(channelInterpretation) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelInterpretation: channelInterpretation
        }));
    }
    //-------------------------------------
    // CONNECTIONS
    //-------------------------------------
    /**
     * connect the output of a ToneAudioNode to an AudioParam, AudioNode, or ToneAudioNode
     * @param destination The output to connect to
     * @param outputNum The output to connect from
     * @param inputNum The input to connect to
     */ connect(destination, outputNum = 0, inputNum = 0) {
        $1dae52eee8c779dd$export$64605811ab45167f(this, destination, outputNum, inputNum);
        return this;
    }
    /**
     * Connect the output to the context's destination node.
     * @example
     * const osc = new Tone.Oscillator("C2").start();
     * osc.toDestination();
     */ toDestination() {
        this.connect(this.context.destination);
        return this;
    }
    /**
     * Connect the output to the context's destination node.
     * See [[toDestination]]
     * @deprecated
     */ toMaster() {
        (0, $afc9146c77d080c2$export$c106dd0671a0fc2d)("toMaster() has been renamed toDestination()");
        return this.toDestination();
    }
    /**
     * disconnect the output
     */ disconnect(destination, outputNum = 0, inputNum = 0) {
        $1dae52eee8c779dd$export$37dfea93db2e14ed(this, destination, outputNum, inputNum);
        return this;
    }
    /**
     * Connect the output of this node to the rest of the nodes in series.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/handdrum-loop.mp3");
     * player.autostart = true;
     * const filter = new Tone.AutoFilter(4).start();
     * const distortion = new Tone.Distortion(0.5);
     * // connect the player to the filter, distortion and then to the master output
     * player.chain(filter, distortion, Tone.Destination);
     */ chain(...nodes) {
        $1dae52eee8c779dd$export$933c3b67552fb559(this, ...nodes);
        return this;
    }
    /**
     * connect the output of this node to the rest of the nodes in parallel.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/conga-rhythm.mp3");
     * player.autostart = true;
     * const pitchShift = new Tone.PitchShift(4).toDestination();
     * const filter = new Tone.Filter("G5").toDestination();
     * // connect a node to the pitch shift and filter in parallel
     * player.fan(pitchShift, filter);
     */ fan(...nodes) {
        nodes.forEach((node)=>this.connect(node));
        return this;
    }
    /**
     * Dispose and disconnect
     */ dispose() {
        super.dispose();
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.input)) {
            if (this.input instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33) this.input.dispose();
            else if ((0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(this.input)) this.input.disconnect();
        }
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.output)) {
            if (this.output instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33) this.output.dispose();
            else if ((0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(this.output)) this.output.disconnect();
        }
        this._internalChannels = [];
        return this;
    }
}
function $1dae52eee8c779dd$export$933c3b67552fb559(...nodes) {
    const first = nodes.shift();
    nodes.reduce((prev, current)=>{
        if (prev instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33) prev.connect(current);
        else if ((0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(prev)) $1dae52eee8c779dd$export$64605811ab45167f(prev, current);
        return current;
    }, first);
}
function $1dae52eee8c779dd$export$64605811ab45167f(srcNode, dstNode, outputNumber = 0, inputNumber = 0) {
    (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(srcNode), "Cannot connect from undefined node");
    (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(dstNode), "Cannot connect to undefined node");
    if (dstNode instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33 || (0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(dstNode)) (0, $afc9146c77d080c2$export$a7a9523472993e97)(dstNode.numberOfInputs > 0, "Cannot connect to node with no inputs");
    (0, $afc9146c77d080c2$export$a7a9523472993e97)(srcNode.numberOfOutputs > 0, "Cannot connect from node with no outputs");
    // resolve the input of the dstNode
    while(dstNode instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33 || dstNode instanceof (0, $4e42d28fbc344697$export$1ca45c9a47aec42c))if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(dstNode.input)) dstNode = dstNode.input;
    while(srcNode instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33)if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(srcNode.output)) srcNode = srcNode.output;
    // make the connection
    if ((0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(dstNode)) srcNode.connect(dstNode, outputNumber);
    else srcNode.connect(dstNode, outputNumber, inputNumber);
}
function $1dae52eee8c779dd$export$37dfea93db2e14ed(srcNode, dstNode, outputNumber = 0, inputNumber = 0) {
    // resolve the destination node
    if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(dstNode)) while(dstNode instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33)dstNode = dstNode.input;
    // resolve the src node
    while(!(0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(srcNode))if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(srcNode.output)) srcNode = srcNode.output;
    if ((0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(dstNode)) srcNode.disconnect(dstNode, outputNumber);
    else if ((0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(dstNode)) srcNode.disconnect(dstNode, outputNumber, inputNumber);
    else srcNode.disconnect();
}











class $10a186a98a559639$export$acd19d919666900d extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($10a186a98a559639$export$acd19d919666900d.getDefaults(), arguments, [
            "gain",
            "units"
        ]));
        this.name = "Gain";
        /**
         * The wrapped GainNode.
         */ this._gainNode = this.context.createGain();
        // input = output
        this.input = this._gainNode;
        this.output = this._gainNode;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($10a186a98a559639$export$acd19d919666900d.getDefaults(), arguments, [
            "gain",
            "units"
        ]);
        this.gain = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            convert: options.convert,
            param: this._gainNode.gain,
            units: options.units,
            value: options.gain,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "gain");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            convert: true,
            gain: 1,
            units: "gain"
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._gainNode.disconnect();
        this.gain.dispose();
        return this;
    }
}





class $e20d6aed0c7175de$export$27749f88ede4d2a3 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        /**
         * The callback to invoke after the
         * source is done playing.
         */ this.onended = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        /**
         * The start time
         */ this._startTime = -1;
        /**
         * The stop time
         */ this._stopTime = -1;
        /**
         * The id of the timeout
         */ this._timeout = -1;
        /**
         * The public output node
         */ this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        /**
         * The output gain node.
         */ this._gainNode = this.output;
        /**
         * Get the playback state at the given time
         */ this.getStateAtTime = function(time) {
            const computedTime = this.toSeconds(time);
            if (this._startTime !== -1 && computedTime >= this._startTime && (this._stopTime === -1 || computedTime <= this._stopTime)) return "started";
            else return "stopped";
        };
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
        this._curve = options.curve;
        this.onended = options.onended;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            curve: "linear",
            fadeIn: 0,
            fadeOut: 0,
            onended: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)
        });
    }
    /**
     * Start the source at the given time
     * @param  time When to start the source
     */ _startGain(time, gain = 1) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this._startTime === -1, "Source cannot be started more than once");
        // apply a fade in envelope
        const fadeInTime = this.toSeconds(this._fadeIn);
        // record the start time
        this._startTime = time + fadeInTime;
        this._startTime = Math.max(this._startTime, this.context.currentTime);
        // schedule the envelope
        if (fadeInTime > 0) {
            this._gainNode.gain.setValueAtTime(0, time);
            if (this._curve === "linear") this._gainNode.gain.linearRampToValueAtTime(gain, time + fadeInTime);
            else this._gainNode.gain.exponentialApproachValueAtTime(gain, time, fadeInTime);
        } else this._gainNode.gain.setValueAtTime(gain, time);
        return this;
    }
    /**
     * Stop the source node at the given time.
     * @param time When to stop the source
     */ stop(time) {
        this.log("stop", time);
        this._stopGain(this.toSeconds(time));
        return this;
    }
    /**
     * Stop the source at the given time
     * @param  time When to stop the source
     */ _stopGain(time) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this._startTime !== -1, "'start' must be called before 'stop'");
        // cancel the previous stop
        this.cancelStop();
        // the fadeOut time
        const fadeOutTime = this.toSeconds(this._fadeOut);
        // schedule the stop callback
        this._stopTime = this.toSeconds(time) + fadeOutTime;
        this._stopTime = Math.max(this._stopTime, this.context.currentTime);
        if (fadeOutTime > 0) {
            // start the fade out curve at the given time
            if (this._curve === "linear") this._gainNode.gain.linearRampTo(0, fadeOutTime, time);
            else this._gainNode.gain.targetRampTo(0, fadeOutTime, time);
        } else {
            // stop any ongoing ramps, and set the value to 0
            this._gainNode.gain.cancelAndHoldAtTime(time);
            this._gainNode.gain.setValueAtTime(0, time);
        }
        this.context.clearTimeout(this._timeout);
        this._timeout = this.context.setTimeout(()=>{
            // allow additional time for the exponential curve to fully decay
            const additionalTail = this._curve === "exponential" ? fadeOutTime * 2 : 0;
            this._stopSource(this.now() + additionalTail);
            this._onended();
        }, this._stopTime - this.context.currentTime);
        return this;
    }
    /**
     * Invoke the onended callback
     */ _onended() {
        if (this.onended !== (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)) {
            this.onended(this);
            // overwrite onended to make sure it only is called once
            this.onended = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
            // dispose when it's ended to free up for garbage collection only in the online context
            if (!this.context.isOffline) {
                const disposeCallback = ()=>this.dispose();
                // @ts-ignore
                if (typeof window.requestIdleCallback !== "undefined") // @ts-ignore
                window.requestIdleCallback(disposeCallback);
                else setTimeout(disposeCallback, 1000);
            }
        }
    }
    /**
     * Get the playback state at the current time
     */ get state() {
        return this.getStateAtTime(this.now());
    }
    /**
     * Cancel a scheduled stop event
     */ cancelStop() {
        this.log("cancelStop");
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this._startTime !== -1, "Source is not started");
        // cancel the stop envelope
        this._gainNode.gain.cancelScheduledValues(this._startTime + this.sampleTime);
        this.context.clearTimeout(this._timeout);
        this._stopTime = -1;
        return this;
    }
    dispose() {
        super.dispose();
        this._gainNode.disconnect();
        return this;
    }
}


class $07d091cc6b8a4926$export$717f1ef4ba8fd295 extends (0, $e20d6aed0c7175de$export$27749f88ede4d2a3) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($07d091cc6b8a4926$export$717f1ef4ba8fd295.getDefaults(), arguments, [
            "offset"
        ]));
        this.name = "ToneConstantSource";
        /**
         * The signal generator
         */ this._source = this.context.createConstantSource();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($07d091cc6b8a4926$export$717f1ef4ba8fd295.getDefaults(), arguments, [
            "offset"
        ]);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._source, this._gainNode);
        this.offset = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            convert: options.convert,
            param: this._source.offset,
            units: options.units,
            value: options.offset,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
    }
    static getDefaults() {
        return Object.assign((0, $e20d6aed0c7175de$export$27749f88ede4d2a3).getDefaults(), {
            convert: true,
            offset: 1,
            units: "number"
        });
    }
    /**
     * Start the source node at the given time
     * @param  time When to start the source
     */ start(time) {
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        this._startGain(computedTime);
        this._source.start(computedTime);
        return this;
    }
    _stopSource(time) {
        this._source.stop(time);
    }
    dispose() {
        super.dispose();
        if (this.state === "started") this.stop();
        this._source.disconnect();
        this.offset.dispose();
        return this;
    }
}


class $87a50297d6fa5f61$export$8210dfe1863c478 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($87a50297d6fa5f61$export$8210dfe1863c478.getDefaults(), arguments, [
            "value",
            "units"
        ]));
        this.name = "Signal";
        /**
         * Indicates if the value should be overridden on connection.
         */ this.override = true;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($87a50297d6fa5f61$export$8210dfe1863c478.getDefaults(), arguments, [
            "value",
            "units"
        ]);
        this.output = this._constantSource = new (0, $07d091cc6b8a4926$export$717f1ef4ba8fd295)({
            context: this.context,
            convert: options.convert,
            offset: options.value,
            units: options.units,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        this._constantSource.start(0);
        this.input = this._param = this._constantSource.offset;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            convert: true,
            units: "number",
            value: 0
        });
    }
    connect(destination, outputNum = 0, inputNum = 0) {
        // start it only when connected to something
        $87a50297d6fa5f61$export$c8174dc07173cff0(this, destination, outputNum, inputNum);
        return this;
    }
    dispose() {
        super.dispose();
        this._param.dispose();
        this._constantSource.dispose();
        return this;
    }
    //-------------------------------------
    // ABSTRACT PARAM INTERFACE
    // just a proxy for the ConstantSourceNode's offset AudioParam
    // all docs are generated from AbstractParam.ts
    //-------------------------------------
    setValueAtTime(value, time) {
        this._param.setValueAtTime(value, time);
        return this;
    }
    getValueAtTime(time) {
        return this._param.getValueAtTime(time);
    }
    setRampPoint(time) {
        this._param.setRampPoint(time);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        this._param.linearRampToValueAtTime(value, time);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        this._param.exponentialRampToValueAtTime(value, time);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        this._param.exponentialRampTo(value, rampTime, startTime);
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        this._param.linearRampTo(value, rampTime, startTime);
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        this._param.targetRampTo(value, rampTime, startTime);
        return this;
    }
    exponentialApproachValueAtTime(value, time, rampTime) {
        this._param.exponentialApproachValueAtTime(value, time, rampTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        this._param.setTargetAtTime(value, startTime, timeConstant);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling) {
        this._param.setValueCurveAtTime(values, startTime, duration, scaling);
        return this;
    }
    cancelScheduledValues(time) {
        this._param.cancelScheduledValues(time);
        return this;
    }
    cancelAndHoldAtTime(time) {
        this._param.cancelAndHoldAtTime(time);
        return this;
    }
    rampTo(value, rampTime, startTime) {
        this._param.rampTo(value, rampTime, startTime);
        return this;
    }
    get value() {
        return this._param.value;
    }
    set value(value) {
        this._param.value = value;
    }
    get convert() {
        return this._param.convert;
    }
    set convert(convert) {
        this._param.convert = convert;
    }
    get units() {
        return this._param.units;
    }
    get overridden() {
        return this._param.overridden;
    }
    set overridden(overridden) {
        this._param.overridden = overridden;
    }
    get maxValue() {
        return this._param.maxValue;
    }
    get minValue() {
        return this._param.minValue;
    }
    /**
     * See [[Param.apply]].
     */ apply(param) {
        this._param.apply(param);
        return this;
    }
}
function $87a50297d6fa5f61$export$c8174dc07173cff0(signal, destination, outputNum, inputNum) {
    if (destination instanceof (0, $4e42d28fbc344697$export$1ca45c9a47aec42c) || (0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(destination) || destination instanceof $87a50297d6fa5f61$export$8210dfe1863c478 && destination.override) {
        // cancel changes
        destination.cancelScheduledValues(0);
        // reset the value
        destination.setValueAtTime(0, 0);
        // mark the value as overridden
        if (destination instanceof $87a50297d6fa5f61$export$8210dfe1863c478) destination.overridden = true;
    }
    (0, $1dae52eee8c779dd$export$64605811ab45167f)(signal, destination, outputNum, inputNum);
}







class $11a86ae0932ee6d8$export$7d6cb743a95f18af extends (0, $4e42d28fbc344697$export$1ca45c9a47aec42c) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($11a86ae0932ee6d8$export$7d6cb743a95f18af.getDefaults(), arguments, [
            "value"
        ]));
        this.name = "TickParam";
        /**
         * The timeline which tracks all of the automations.
         */ this._events = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)(Infinity);
        /**
         * The internal holder for the multiplier value
         */ this._multiplier = 1;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($11a86ae0932ee6d8$export$7d6cb743a95f18af.getDefaults(), arguments, [
            "value"
        ]);
        // set the multiplier
        this._multiplier = options.multiplier;
        // clear the ticks from the beginning
        this._events.cancel(0);
        // set an initial event
        this._events.add({
            ticks: 0,
            time: 0,
            type: "setValueAtTime",
            value: this._fromType(options.value)
        });
        this.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $4e42d28fbc344697$export$1ca45c9a47aec42c).getDefaults(), {
            multiplier: 1,
            units: "hertz",
            value: 1
        });
    }
    setTargetAtTime(value, time, constant) {
        // approximate it with multiple linear ramps
        time = this.toSeconds(time);
        this.setRampPoint(time);
        const computedValue = this._fromType(value);
        // start from previously scheduled value
        const prevEvent = this._events.get(time);
        const segments = Math.round(Math.max(1 / constant, 1));
        for(let i = 0; i <= segments; i++){
            const segTime = constant * i + time;
            const rampVal = this._exponentialApproach(prevEvent.time, prevEvent.value, computedValue, constant, segTime);
            this.linearRampToValueAtTime(this._toType(rampVal), segTime);
        }
        return this;
    }
    setValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        super.setValueAtTime(value, time);
        const event = this._events.get(computedTime);
        const previousEvent = this._events.previousEvent(event);
        const ticksUntilTime = this._getTicksUntilEvent(previousEvent, computedTime);
        event.ticks = Math.max(ticksUntilTime, 0);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        super.linearRampToValueAtTime(value, time);
        const event = this._events.get(computedTime);
        const previousEvent = this._events.previousEvent(event);
        const ticksUntilTime = this._getTicksUntilEvent(previousEvent, computedTime);
        event.ticks = Math.max(ticksUntilTime, 0);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        // aproximate it with multiple linear ramps
        time = this.toSeconds(time);
        const computedVal = this._fromType(value);
        // start from previously scheduled value
        const prevEvent = this._events.get(time);
        // approx 10 segments per second
        const segments = Math.round(Math.max((time - prevEvent.time) * 10, 1));
        const segmentDur = (time - prevEvent.time) / segments;
        for(let i = 0; i <= segments; i++){
            const segTime = segmentDur * i + prevEvent.time;
            const rampVal = this._exponentialInterpolate(prevEvent.time, prevEvent.value, time, computedVal, segTime);
            this.linearRampToValueAtTime(this._toType(rampVal), segTime);
        }
        return this;
    }
    /**
     * Returns the tick value at the time. Takes into account
     * any automation curves scheduled on the signal.
     * @param  event The time to get the tick count at
     * @return The number of ticks which have elapsed at the time given any automations.
     */ _getTicksUntilEvent(event, time) {
        if (event === null) event = {
            ticks: 0,
            time: 0,
            type: "setValueAtTime",
            value: 0
        };
        else if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(event.ticks)) {
            const previousEvent = this._events.previousEvent(event);
            event.ticks = this._getTicksUntilEvent(previousEvent, event.time);
        }
        const val0 = this._fromType(this.getValueAtTime(event.time));
        let val1 = this._fromType(this.getValueAtTime(time));
        // if it's right on the line, take the previous value
        const onTheLineEvent = this._events.get(time);
        if (onTheLineEvent && onTheLineEvent.time === time && onTheLineEvent.type === "setValueAtTime") val1 = this._fromType(this.getValueAtTime(time - this.sampleTime));
        return 0.5 * (time - event.time) * (val0 + val1) + event.ticks;
    }
    /**
     * Returns the tick value at the time. Takes into account
     * any automation curves scheduled on the signal.
     * @param  time The time to get the tick count at
     * @return The number of ticks which have elapsed at the time given any automations.
     */ getTicksAtTime(time) {
        const computedTime = this.toSeconds(time);
        const event = this._events.get(computedTime);
        return Math.max(this._getTicksUntilEvent(event, computedTime), 0);
    }
    /**
     * Return the elapsed time of the number of ticks from the given time
     * @param ticks The number of ticks to calculate
     * @param  time The time to get the next tick from
     * @return The duration of the number of ticks from the given time in seconds
     */ getDurationOfTicks(ticks, time) {
        const computedTime = this.toSeconds(time);
        const currentTick = this.getTicksAtTime(time);
        return this.getTimeOfTick(currentTick + ticks) - computedTime;
    }
    /**
     * Given a tick, returns the time that tick occurs at.
     * @return The time that the tick occurs.
     */ getTimeOfTick(tick) {
        const before = this._events.get(tick, "ticks");
        const after = this._events.getAfter(tick, "ticks");
        if (before && before.ticks === tick) return before.time;
        else if (before && after && after.type === "linearRampToValueAtTime" && before.value !== after.value) {
            const val0 = this._fromType(this.getValueAtTime(before.time));
            const val1 = this._fromType(this.getValueAtTime(after.time));
            const delta = (val1 - val0) / (after.time - before.time);
            const k = Math.sqrt(Math.pow(val0, 2) - 2 * delta * (before.ticks - tick));
            const sol1 = (-val0 + k) / delta;
            const sol2 = (-val0 - k) / delta;
            return (sol1 > 0 ? sol1 : sol2) + before.time;
        } else if (before) {
            if (before.value === 0) return Infinity;
            else return before.time + (tick - before.ticks) / before.value;
        } else return tick / this._initialValue;
    }
    /**
     * Convert some number of ticks their the duration in seconds accounting
     * for any automation curves starting at the given time.
     * @param  ticks The number of ticks to convert to seconds.
     * @param  when  When along the automation timeline to convert the ticks.
     * @return The duration in seconds of the ticks.
     */ ticksToTime(ticks, when) {
        return this.getDurationOfTicks(ticks, when);
    }
    /**
     * The inverse of [[ticksToTime]]. Convert a duration in
     * seconds to the corresponding number of ticks accounting for any
     * automation curves starting at the given time.
     * @param  duration The time interval to convert to ticks.
     * @param  when When along the automation timeline to convert the ticks.
     * @return The duration in ticks.
     */ timeToTicks(duration, when) {
        const computedTime = this.toSeconds(when);
        const computedDuration = this.toSeconds(duration);
        const startTicks = this.getTicksAtTime(computedTime);
        const endTicks = this.getTicksAtTime(computedTime + computedDuration);
        return endTicks - startTicks;
    }
    /**
     * Convert from the type when the unit value is BPM
     */ _fromType(val) {
        if (this.units === "bpm" && this.multiplier) return 1 / (60 / val / this.multiplier);
        else return super._fromType(val);
    }
    /**
     * Special case of type conversion where the units === "bpm"
     */ _toType(val) {
        if (this.units === "bpm" && this.multiplier) return val / this.multiplier * 60;
        else return super._toType(val);
    }
    /**
     * A multiplier on the bpm value. Useful for setting a PPQ relative to the base frequency value.
     */ get multiplier() {
        return this._multiplier;
    }
    set multiplier(m) {
        // get and reset the current value with the new multiplier
        // might be necessary to clear all the previous values
        const currentVal = this.value;
        this._multiplier = m;
        this.cancelScheduledValues(0);
        this.setValueAtTime(currentVal, 0);
    }
}


class $0a0ea9c4476e6e0b$export$f1be63c3ef84bc34 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0a0ea9c4476e6e0b$export$f1be63c3ef84bc34.getDefaults(), arguments, [
            "value"
        ]));
        this.name = "TickSignal";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0a0ea9c4476e6e0b$export$f1be63c3ef84bc34.getDefaults(), arguments, [
            "value"
        ]);
        this.input = this._param = new (0, $11a86ae0932ee6d8$export$7d6cb743a95f18af)({
            context: this.context,
            convert: options.convert,
            multiplier: options.multiplier,
            param: this._constantSource.offset,
            units: options.units,
            value: options.value
        });
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            multiplier: 1,
            units: "hertz",
            value: 1
        });
    }
    ticksToTime(ticks, when) {
        return this._param.ticksToTime(ticks, when);
    }
    timeToTicks(duration, when) {
        return this._param.timeToTicks(duration, when);
    }
    getTimeOfTick(tick) {
        return this._param.getTimeOfTick(tick);
    }
    getDurationOfTicks(ticks, time) {
        return this._param.getDurationOfTicks(ticks, time);
    }
    getTicksAtTime(time) {
        return this._param.getTicksAtTime(time);
    }
    /**
     * A multiplier on the bpm value. Useful for setting a PPQ relative to the base frequency value.
     */ get multiplier() {
        return this._param.multiplier;
    }
    set multiplier(m) {
        this._param.multiplier = m;
    }
    dispose() {
        super.dispose();
        this._param.dispose();
        return this;
    }
}



class $75fb8f7356b6d0dc$export$617abaa845df50f1 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($75fb8f7356b6d0dc$export$617abaa845df50f1.getDefaults(), arguments, [
            "frequency"
        ]));
        this.name = "TickSource";
        /**
         * The state timeline
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)();
        /**
         * The offset values of the ticks
         */ this._tickOffset = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($75fb8f7356b6d0dc$export$617abaa845df50f1.getDefaults(), arguments, [
            "frequency"
        ]);
        this.frequency = new (0, $0a0ea9c4476e6e0b$export$f1be63c3ef84bc34)({
            context: this.context,
            units: options.units,
            value: options.frequency
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "frequency");
        // set the initial state
        this._state.setStateAtTime("stopped", 0);
        // add the first event
        this.setTicksAtTime(0, 0);
    }
    static getDefaults() {
        return Object.assign({
            frequency: 1,
            units: "hertz"
        }, (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults());
    }
    /**
     * Returns the playback state of the source, either "started", "stopped" or "paused".
     */ get state() {
        return this.getStateAtTime(this.now());
    }
    /**
     * Start the clock at the given time. Optionally pass in an offset
     * of where to start the tick counter from.
     * @param  time    The time the clock should start
     * @param offset The number of ticks to start the source at
     */ start(time, offset) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) !== "started") {
            this._state.setStateAtTime("started", computedTime);
            if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(offset)) this.setTicksAtTime(offset, computedTime);
        }
        return this;
    }
    /**
     * Stop the clock. Stopping the clock resets the tick counter to 0.
     * @param time The time when the clock should stop.
     */ stop(time) {
        const computedTime = this.toSeconds(time);
        // cancel the previous stop
        if (this._state.getValueAtTime(computedTime) === "stopped") {
            const event = this._state.get(computedTime);
            if (event && event.time > 0) {
                this._tickOffset.cancel(event.time);
                this._state.cancel(event.time);
            }
        }
        this._state.cancel(computedTime);
        this._state.setStateAtTime("stopped", computedTime);
        this.setTicksAtTime(0, computedTime);
        return this;
    }
    /**
     * Pause the clock. Pausing does not reset the tick counter.
     * @param time The time when the clock should stop.
     */ pause(time) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) === "started") this._state.setStateAtTime("paused", computedTime);
        return this;
    }
    /**
     * Cancel start/stop/pause and setTickAtTime events scheduled after the given time.
     * @param time When to clear the events after
     */ cancel(time) {
        time = this.toSeconds(time);
        this._state.cancel(time);
        this._tickOffset.cancel(time);
        return this;
    }
    /**
     * Get the elapsed ticks at the given time
     * @param  time  When to get the tick value
     * @return The number of ticks
     */ getTicksAtTime(time) {
        const computedTime = this.toSeconds(time);
        const stopEvent = this._state.getLastState("stopped", computedTime);
        // this event allows forEachBetween to iterate until the current time
        const tmpEvent = {
            state: "paused",
            time: computedTime
        };
        this._state.add(tmpEvent);
        // keep track of the previous offset event
        let lastState = stopEvent;
        let elapsedTicks = 0;
        // iterate through all the events since the last stop
        this._state.forEachBetween(stopEvent.time, computedTime + this.sampleTime, (e)=>{
            let periodStartTime = lastState.time;
            // if there is an offset event in this period use that
            const offsetEvent = this._tickOffset.get(e.time);
            if (offsetEvent && offsetEvent.time >= lastState.time) {
                elapsedTicks = offsetEvent.ticks;
                periodStartTime = offsetEvent.time;
            }
            if (lastState.state === "started" && e.state !== "started") elapsedTicks += this.frequency.getTicksAtTime(e.time) - this.frequency.getTicksAtTime(periodStartTime);
            lastState = e;
        });
        // remove the temporary event
        this._state.remove(tmpEvent);
        // return the ticks
        return elapsedTicks;
    }
    /**
     * The number of times the callback was invoked. Starts counting at 0
     * and increments after the callback was invoked. Returns -1 when stopped.
     */ get ticks() {
        return this.getTicksAtTime(this.now());
    }
    set ticks(t) {
        this.setTicksAtTime(t, this.now());
    }
    /**
     * The time since ticks=0 that the TickSource has been running. Accounts
     * for tempo curves
     */ get seconds() {
        return this.getSecondsAtTime(this.now());
    }
    set seconds(s) {
        const now = this.now();
        const ticks = this.frequency.timeToTicks(s, now);
        this.setTicksAtTime(ticks, now);
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        time = this.toSeconds(time);
        const stopEvent = this._state.getLastState("stopped", time);
        // this event allows forEachBetween to iterate until the current time
        const tmpEvent = {
            state: "paused",
            time: time
        };
        this._state.add(tmpEvent);
        // keep track of the previous offset event
        let lastState = stopEvent;
        let elapsedSeconds = 0;
        // iterate through all the events since the last stop
        this._state.forEachBetween(stopEvent.time, time + this.sampleTime, (e)=>{
            let periodStartTime = lastState.time;
            // if there is an offset event in this period use that
            const offsetEvent = this._tickOffset.get(e.time);
            if (offsetEvent && offsetEvent.time >= lastState.time) {
                elapsedSeconds = offsetEvent.seconds;
                periodStartTime = offsetEvent.time;
            }
            if (lastState.state === "started" && e.state !== "started") elapsedSeconds += e.time - periodStartTime;
            lastState = e;
        });
        // remove the temporary event
        this._state.remove(tmpEvent);
        // return the ticks
        return elapsedSeconds;
    }
    /**
     * Set the clock's ticks at the given time.
     * @param  ticks The tick value to set
     * @param  time  When to set the tick value
     */ setTicksAtTime(ticks, time) {
        time = this.toSeconds(time);
        this._tickOffset.cancel(time);
        this._tickOffset.add({
            seconds: this.frequency.getDurationOfTicks(ticks, time),
            ticks: ticks,
            time: time
        });
        return this;
    }
    /**
     * Returns the scheduled state at the given time.
     * @param  time  The time to query.
     */ getStateAtTime(time) {
        time = this.toSeconds(time);
        return this._state.getValueAtTime(time);
    }
    /**
     * Get the time of the given tick. The second argument
     * is when to test before. Since ticks can be set (with setTicksAtTime)
     * there may be multiple times for a given tick value.
     * @param  tick The tick number.
     * @param  before When to measure the tick value from.
     * @return The time of the tick
     */ getTimeOfTick(tick, before = this.now()) {
        const offset = this._tickOffset.get(before);
        const event = this._state.get(before);
        const startTime = Math.max(offset.time, event.time);
        const absoluteTicks = this.frequency.getTicksAtTime(startTime) + tick - offset.ticks;
        return this.frequency.getTimeOfTick(absoluteTicks);
    }
    /**
     * Invoke the callback event at all scheduled ticks between the
     * start time and the end time
     * @param  startTime  The beginning of the search range
     * @param  endTime    The end of the search range
     * @param  callback   The callback to invoke with each tick
     */ forEachTickBetween(startTime, endTime, callback) {
        // only iterate through the sections where it is "started"
        let lastStateEvent = this._state.get(startTime);
        this._state.forEachBetween(startTime, endTime, (event)=>{
            if (lastStateEvent && lastStateEvent.state === "started" && event.state !== "started") this.forEachTickBetween(Math.max(lastStateEvent.time, startTime), event.time - this.sampleTime, callback);
            lastStateEvent = event;
        });
        let error = null;
        if (lastStateEvent && lastStateEvent.state === "started") {
            const maxStartTime = Math.max(lastStateEvent.time, startTime);
            // figure out the difference between the frequency ticks and the
            const startTicks = this.frequency.getTicksAtTime(maxStartTime);
            const ticksAtStart = this.frequency.getTicksAtTime(lastStateEvent.time);
            const diff = startTicks - ticksAtStart;
            let offset = Math.ceil(diff) - diff;
            // guard against floating point issues
            offset = (0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(offset, 1) ? 0 : offset;
            let nextTickTime = this.frequency.getTimeOfTick(startTicks + offset);
            while(nextTickTime < endTime){
                try {
                    callback(nextTickTime, Math.round(this.getTicksAtTime(nextTickTime)));
                } catch (e) {
                    error = e;
                    break;
                }
                nextTickTime += this.frequency.getDurationOfTicks(1, nextTickTime);
            }
        }
        if (error) throw error;
        return this;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._state.dispose();
        this._tickOffset.dispose();
        this.frequency.dispose();
        return this;
    }
}



class $b0382ab9b2ce11b2$export$9735c82c4bae3302 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($b0382ab9b2ce11b2$export$9735c82c4bae3302.getDefaults(), arguments, [
            "callback",
            "frequency"
        ]));
        this.name = "Clock";
        /**
         * The callback function to invoke at the scheduled tick.
         */ this.callback = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        /**
         * The last time the loop callback was invoked
         */ this._lastUpdate = 0;
        /**
         * Keep track of the playback state
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)("stopped");
        /**
         * Context bound reference to the _loop method
         * This is necessary to remove the event in the end.
         */ this._boundLoop = this._loop.bind(this);
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($b0382ab9b2ce11b2$export$9735c82c4bae3302.getDefaults(), arguments, [
            "callback",
            "frequency"
        ]);
        this.callback = options.callback;
        this._tickSource = new (0, $75fb8f7356b6d0dc$export$617abaa845df50f1)({
            context: this.context,
            frequency: options.frequency,
            units: options.units
        });
        this._lastUpdate = 0;
        this.frequency = this._tickSource.frequency;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "frequency");
        // add an initial state
        this._state.setStateAtTime("stopped", 0);
        // bind a callback to the worker thread
        this.context.on("tick", this._boundLoop);
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            frequency: 1,
            units: "hertz"
        });
    }
    /**
     * Returns the playback state of the source, either "started", "stopped" or "paused".
     */ get state() {
        return this._state.getValueAtTime(this.now());
    }
    /**
     * Start the clock at the given time. Optionally pass in an offset
     * of where to start the tick counter from.
     * @param  time    The time the clock should start
     * @param offset  Where the tick counter starts counting from.
     */ start(time, offset) {
        // make sure the context is running
        (0, $afc9146c77d080c2$export$8ef1ce44f93c2687)(this.context);
        // start the loop
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        if (this._state.getValueAtTime(computedTime) !== "started") {
            this._state.setStateAtTime("started", computedTime);
            this._tickSource.start(computedTime, offset);
            if (computedTime < this._lastUpdate) this.emit("start", computedTime, offset);
        }
        return this;
    }
    /**
     * Stop the clock. Stopping the clock resets the tick counter to 0.
     * @param time The time when the clock should stop.
     * @example
     * const clock = new Tone.Clock(time => {
     * 	console.log(time);
     * }, 1);
     * clock.start();
     * // stop the clock after 10 seconds
     * clock.stop("+10");
     */ stop(time) {
        const computedTime = this.toSeconds(time);
        this.log("stop", computedTime);
        this._state.cancel(computedTime);
        this._state.setStateAtTime("stopped", computedTime);
        this._tickSource.stop(computedTime);
        if (computedTime < this._lastUpdate) this.emit("stop", computedTime);
        return this;
    }
    /**
     * Pause the clock. Pausing does not reset the tick counter.
     * @param time The time when the clock should stop.
     */ pause(time) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) === "started") {
            this._state.setStateAtTime("paused", computedTime);
            this._tickSource.pause(computedTime);
            if (computedTime < this._lastUpdate) this.emit("pause", computedTime);
        }
        return this;
    }
    /**
     * The number of times the callback was invoked. Starts counting at 0
     * and increments after the callback was invoked.
     */ get ticks() {
        return Math.ceil(this.getTicksAtTime(this.now()));
    }
    set ticks(t) {
        this._tickSource.ticks = t;
    }
    /**
     * The time since ticks=0 that the Clock has been running. Accounts for tempo curves
     */ get seconds() {
        return this._tickSource.seconds;
    }
    set seconds(s) {
        this._tickSource.seconds = s;
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        return this._tickSource.getSecondsAtTime(time);
    }
    /**
     * Set the clock's ticks at the given time.
     * @param  ticks The tick value to set
     * @param  time  When to set the tick value
     */ setTicksAtTime(ticks, time) {
        this._tickSource.setTicksAtTime(ticks, time);
        return this;
    }
    /**
     * Get the time of the given tick. The second argument
     * is when to test before. Since ticks can be set (with setTicksAtTime)
     * there may be multiple times for a given tick value.
     * @param  tick The tick number.
     * @param  before When to measure the tick value from.
     * @return The time of the tick
     */ getTimeOfTick(tick, before = this.now()) {
        return this._tickSource.getTimeOfTick(tick, before);
    }
    /**
     * Get the clock's ticks at the given time.
     * @param  time  When to get the tick value
     * @return The tick value at the given time.
     */ getTicksAtTime(time) {
        return this._tickSource.getTicksAtTime(time);
    }
    /**
     * Get the time of the next tick
     * @param  offset The tick number.
     */ nextTickTime(offset, when) {
        const computedTime = this.toSeconds(when);
        const currentTick = this.getTicksAtTime(computedTime);
        return this._tickSource.getTimeOfTick(currentTick + offset, computedTime);
    }
    /**
     * The scheduling loop.
     */ _loop() {
        const startTime = this._lastUpdate;
        const endTime = this.now();
        this._lastUpdate = endTime;
        this.log("loop", startTime, endTime);
        if (startTime !== endTime) {
            // the state change events
            this._state.forEachBetween(startTime, endTime, (e)=>{
                switch(e.state){
                    case "started":
                        const offset = this._tickSource.getTicksAtTime(e.time);
                        this.emit("start", e.time, offset);
                        break;
                    case "stopped":
                        if (e.time !== 0) this.emit("stop", e.time);
                        break;
                    case "paused":
                        this.emit("pause", e.time);
                        break;
                }
            });
            // the tick callbacks
            this._tickSource.forEachTickBetween(startTime, endTime, (time, ticks)=>{
                this.callback(time, ticks);
            });
        }
    }
    /**
     * Returns the scheduled state at the given time.
     * @param  time  The time to query.
     * @return  The name of the state input in setStateAtTime.
     * @example
     * const clock = new Tone.Clock();
     * clock.start("+0.1");
     * clock.getStateAtTime("+0.1"); // returns "started"
     */ getStateAtTime(time) {
        const computedTime = this.toSeconds(time);
        return this._state.getValueAtTime(computedTime);
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.context.off("tick", this._boundLoop);
        this._tickSource.dispose();
        this._state.dispose();
        return this;
    }
}
(0, $092748a42ac93843$export$4293555f241ae35a).mixin($b0382ab9b2ce11b2$export$9735c82c4bae3302);








class $89c598137ecf8dce$export$7419ff430885d61c extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($89c598137ecf8dce$export$7419ff430885d61c.getDefaults(), arguments, [
            "delayTime",
            "maxDelay"
        ]));
        this.name = "Delay";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($89c598137ecf8dce$export$7419ff430885d61c.getDefaults(), arguments, [
            "delayTime",
            "maxDelay"
        ]);
        const maxDelayInSeconds = this.toSeconds(options.maxDelay);
        this._maxDelay = Math.max(maxDelayInSeconds, this.toSeconds(options.delayTime));
        this._delayNode = this.input = this.output = this.context.createDelay(maxDelayInSeconds);
        this.delayTime = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._delayNode.delayTime,
            units: "time",
            value: options.delayTime,
            minValue: 0,
            maxValue: this.maxDelay
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "delayTime");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            delayTime: 0,
            maxDelay: 1
        });
    }
    /**
     * The maximum delay time. This cannot be changed after
     * the value is passed into the constructor.
     */ get maxDelay() {
        return this._maxDelay;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._delayNode.disconnect();
        this.delayTime.dispose();
        return this;
    }
}







function $b8b3069e267f9fe7$export$a273407dc53e3f0a(callback, duration, channels = 2, sampleRate = (0, $b7b11709569bdbef$export$31553aaa555c1514)().sampleRate) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        // set the OfflineAudioContext based on the current context
        const originalContext = (0, $b7b11709569bdbef$export$31553aaa555c1514)();
        const context = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(channels, duration, sampleRate);
        (0, $b7b11709569bdbef$export$2f04de43fe27971a)(context);
        // invoke the callback/scheduling
        yield callback(context);
        // then render the audio
        const bufferPromise = context.render();
        // return the original AudioContext
        (0, $b7b11709569bdbef$export$2f04de43fe27971a)(originalContext);
        // await the rendering
        const buffer = yield bufferPromise;
        // return the audio
        return new (0, $43da6dea502b5fe8$export$424a335715b38178)(buffer);
    });
}











class $d37bb61f6ec53d08$export$7232b969b571e570 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super();
        this.name = "ToneAudioBuffers";
        /**
         * All of the buffers
         */ this._buffers = new Map();
        /**
         * Keep track of the number of loaded buffers
         */ this._loadingCount = 0;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($d37bb61f6ec53d08$export$7232b969b571e570.getDefaults(), arguments, [
            "urls",
            "onload",
            "baseUrl"
        ], "urls");
        this.baseUrl = options.baseUrl;
        // add each one
        Object.keys(options.urls).forEach((name)=>{
            this._loadingCount++;
            const url = options.urls[name];
            this.add(name, url, this._bufferLoaded.bind(this, options.onload), options.onerror);
        });
    }
    static getDefaults() {
        return {
            baseUrl: "",
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            urls: {}
        };
    }
    /**
     * True if the buffers object has a buffer by that name.
     * @param  name  The key or index of the buffer.
     */ has(name) {
        return this._buffers.has(name.toString());
    }
    /**
     * Get a buffer by name. If an array was loaded,
     * then use the array index.
     * @param  name  The key or index of the buffer.
     */ get(name) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.has(name), `ToneAudioBuffers has no buffer named: ${name}`);
        return this._buffers.get(name.toString());
    }
    /**
     * A buffer was loaded. decrement the counter.
     */ _bufferLoaded(callback) {
        this._loadingCount--;
        if (this._loadingCount === 0 && callback) callback();
    }
    /**
     * If the buffers are loaded or not
     */ get loaded() {
        return Array.from(this._buffers).every(([_, buffer])=>buffer.loaded);
    }
    /**
     * Add a buffer by name and url to the Buffers
     * @param  name      A unique name to give the buffer
     * @param  url  Either the url of the bufer, or a buffer which will be added with the given name.
     * @param  callback  The callback to invoke when the url is loaded.
     * @param  onerror  Invoked if the buffer can't be loaded
     */ add(name, url, callback = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b), onerror = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)) {
        if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(url)) this._buffers.set(name.toString(), new (0, $43da6dea502b5fe8$export$424a335715b38178)(this.baseUrl + url, callback, onerror));
        else this._buffers.set(name.toString(), new (0, $43da6dea502b5fe8$export$424a335715b38178)(url, callback, onerror));
        return this;
    }
    dispose() {
        super.dispose();
        this._buffers.forEach((buffer)=>buffer.dispose());
        this._buffers.clear();
        return this;
    }
}







class $acb4e2b4a4f69a23$export$266cef4b055bf7de extends (0, $f4d7193118bd1d27$export$38b56155c8552868) {
    constructor(){
        super(...arguments);
        this.name = "MidiClass";
        this.defaultUnits = "midi";
    }
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(super._frequencyToUnits(freq));
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(super._ticksToUnits(ticks));
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(super._beatsToUnits(beats));
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(super._secondsToUnits(seconds));
    }
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Midi(60).toMidi(); // 60
     */ toMidi() {
        return this.valueOf();
    }
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Midi(60).toFrequency(); // 261.6255653005986
     */ toFrequency() {
        return (0, $84c2af7dbf01a14d$export$45a6434f7c391dc)(this.toMidi());
    }
    /**
     * Transposes the frequency by the given number of semitones.
     * @return A new transposed MidiClass
     * @example
     * Tone.Midi("A4").transpose(3); // "C5"
     */ transpose(interval) {
        return new $acb4e2b4a4f69a23$export$266cef4b055bf7de(this.context, this.toMidi() + interval);
    }
}
function $acb4e2b4a4f69a23$export$ed87582254f87fd5(value, units) {
    return new $acb4e2b4a4f69a23$export$266cef4b055bf7de((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}





class $1c1f4b05c313775e$export$fe3569694b9f5728 extends (0, $ef656febef4c2085$export$c824041178a9697) {
    constructor(){
        super(...arguments);
        this.name = "Ticks";
        this.defaultUnits = "i";
    }
    /**
     * Get the current time in the given units
     */ _now() {
        return this.context.transport.ticks;
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return this._getPPQ() * beats;
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return Math.floor(seconds / (60 / this._getBpm()) * this._getPPQ());
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return ticks;
    }
    /**
     * Return the time in ticks
     */ toTicks() {
        return this.valueOf();
    }
    /**
     * Return the time in seconds
     */ toSeconds() {
        return this.valueOf() / this._getPPQ() * (60 / this._getBpm());
    }
}
function $1c1f4b05c313775e$export$27c7467594ef87bd(value, units) {
    return new $1c1f4b05c313775e$export$fe3569694b9f5728((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}






class $86309483b65de2a8$export$dca20402ebea5ece extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super(...arguments);
        this.name = "Draw";
        /**
         * The duration after which events are not invoked.
         */ this.expiration = 0.25;
        /**
         * The amount of time before the scheduled time
         * that the callback can be invoked. Default is
         * half the time of an animation frame (0.008 seconds).
         */ this.anticipation = 0.008;
        /**
         * All of the events.
         */ this._events = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        /**
         * The draw loop
         */ this._boundDrawLoop = this._drawLoop.bind(this);
        /**
         * The animation frame id
         */ this._animationFrame = -1;
    }
    /**
     * Schedule a function at the given time to be invoked
     * on the nearest animation frame.
     * @param  callback  Callback is invoked at the given time.
     * @param  time      The time relative to the AudioContext time to invoke the callback.
     * @example
     * Tone.Transport.scheduleRepeat(time => {
     * 	Tone.Draw.schedule(() => console.log(time), time);
     * }, 1);
     * Tone.Transport.start();
     */ schedule(callback, time) {
        this._events.add({
            callback: callback,
            time: this.toSeconds(time)
        });
        // start the draw loop on the first event
        if (this._events.length === 1) this._animationFrame = requestAnimationFrame(this._boundDrawLoop);
        return this;
    }
    /**
     * Cancel events scheduled after the given time
     * @param  after  Time after which scheduled events will be removed from the scheduling timeline.
     */ cancel(after) {
        this._events.cancel(this.toSeconds(after));
        return this;
    }
    /**
     * The draw loop
     */ _drawLoop() {
        const now = this.context.currentTime;
        while(this._events.length && this._events.peek().time - this.anticipation <= now){
            const event = this._events.shift();
            if (event && now - event.time <= this.expiration) event.callback();
        }
        if (this._events.length > 0) this._animationFrame = requestAnimationFrame(this._boundDrawLoop);
    }
    dispose() {
        super.dispose();
        this._events.dispose();
        cancelAnimationFrame(this._animationFrame);
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $33268d33018da22a$export$cdd816203a02e74e)((context)=>{
    context.draw = new $86309483b65de2a8$export$dca20402ebea5ece({
        context: context
    });
});
(0, $33268d33018da22a$export$7e1ecadd06ae8222)((context)=>{
    context.draw.dispose();
});






class $0953b64e7eb19dcb$export$5a615b1a895bd9ec extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super(...arguments);
        this.name = "IntervalTimeline";
        /**
         * The root node of the inteval tree
         */ this._root = null;
        /**
         * Keep track of the length of the timeline.
         */ this._length = 0;
    }
    /**
     * The event to add to the timeline. All events must
     * have a time and duration value
     * @param  event  The event to add to the timeline
     */ add(event) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(event.time), "Events must have a time property");
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(event.duration), "Events must have a duration parameter");
        event.time = event.time.valueOf();
        let node = new $0953b64e7eb19dcb$var$IntervalNode(event.time, event.time + event.duration, event);
        if (this._root === null) this._root = node;
        else this._root.insert(node);
        this._length++;
        // Restructure tree to be balanced
        while(node !== null){
            node.updateHeight();
            node.updateMax();
            this._rebalance(node);
            node = node.parent;
        }
        return this;
    }
    /**
     * Remove an event from the timeline.
     * @param  event  The event to remove from the timeline
     */ remove(event) {
        if (this._root !== null) {
            const results = [];
            this._root.search(event.time, results);
            for (const node of results)if (node.event === event) {
                this._removeNode(node);
                this._length--;
                break;
            }
        }
        return this;
    }
    /**
     * The number of items in the timeline.
     * @readOnly
     */ get length() {
        return this._length;
    }
    /**
     * Remove events whose time time is after the given time
     * @param  after  The time to query.
     */ cancel(after) {
        this.forEachFrom(after, (event)=>this.remove(event));
        return this;
    }
    /**
     * Set the root node as the given node
     */ _setRoot(node) {
        this._root = node;
        if (this._root !== null) this._root.parent = null;
    }
    /**
     * Replace the references to the node in the node's parent
     * with the replacement node.
     */ _replaceNodeInParent(node, replacement) {
        if (node.parent !== null) {
            if (node.isLeftChild()) node.parent.left = replacement;
            else node.parent.right = replacement;
            this._rebalance(node.parent);
        } else this._setRoot(replacement);
    }
    /**
     * Remove the node from the tree and replace it with
     * a successor which follows the schema.
     */ _removeNode(node) {
        if (node.left === null && node.right === null) this._replaceNodeInParent(node, null);
        else if (node.right === null) this._replaceNodeInParent(node, node.left);
        else if (node.left === null) this._replaceNodeInParent(node, node.right);
        else {
            const balance = node.getBalance();
            let replacement;
            let temp = null;
            if (balance > 0) {
                if (node.left.right === null) {
                    replacement = node.left;
                    replacement.right = node.right;
                    temp = replacement;
                } else {
                    replacement = node.left.right;
                    while(replacement.right !== null)replacement = replacement.right;
                    if (replacement.parent) {
                        replacement.parent.right = replacement.left;
                        temp = replacement.parent;
                        replacement.left = node.left;
                        replacement.right = node.right;
                    }
                }
            } else if (node.right.left === null) {
                replacement = node.right;
                replacement.left = node.left;
                temp = replacement;
            } else {
                replacement = node.right.left;
                while(replacement.left !== null)replacement = replacement.left;
                if (replacement.parent) {
                    replacement.parent.left = replacement.right;
                    temp = replacement.parent;
                    replacement.left = node.left;
                    replacement.right = node.right;
                }
            }
            if (node.parent !== null) {
                if (node.isLeftChild()) node.parent.left = replacement;
                else node.parent.right = replacement;
            } else this._setRoot(replacement);
            if (temp) this._rebalance(temp);
        }
        node.dispose();
    }
    /**
     * Rotate the tree to the left
     */ _rotateLeft(node) {
        const parent = node.parent;
        const isLeftChild = node.isLeftChild();
        // Make node.right the new root of this sub tree (instead of node)
        const pivotNode = node.right;
        if (pivotNode) {
            node.right = pivotNode.left;
            pivotNode.left = node;
        }
        if (parent !== null) {
            if (isLeftChild) parent.left = pivotNode;
            else parent.right = pivotNode;
        } else this._setRoot(pivotNode);
    }
    /**
     * Rotate the tree to the right
     */ _rotateRight(node) {
        const parent = node.parent;
        const isLeftChild = node.isLeftChild();
        // Make node.left the new root of this sub tree (instead of node)
        const pivotNode = node.left;
        if (pivotNode) {
            node.left = pivotNode.right;
            pivotNode.right = node;
        }
        if (parent !== null) {
            if (isLeftChild) parent.left = pivotNode;
            else parent.right = pivotNode;
        } else this._setRoot(pivotNode);
    }
    /**
     * Balance the BST
     */ _rebalance(node) {
        const balance = node.getBalance();
        if (balance > 1 && node.left) {
            if (node.left.getBalance() < 0) this._rotateLeft(node.left);
            else this._rotateRight(node);
        } else if (balance < -1 && node.right) {
            if (node.right.getBalance() > 0) this._rotateRight(node.right);
            else this._rotateLeft(node);
        }
    }
    /**
     * Get an event whose time and duration span the give time. Will
     * return the match whose "time" value is closest to the given time.
     * @return  The event which spans the desired time
     */ get(time) {
        if (this._root !== null) {
            const results = [];
            this._root.search(time, results);
            if (results.length > 0) {
                let max = results[0];
                for(let i = 1; i < results.length; i++)if (results[i].low > max.low) max = results[i];
                return max.event;
            }
        }
        return null;
    }
    /**
     * Iterate over everything in the timeline.
     * @param  callback The callback to invoke with every item
     */ forEach(callback) {
        if (this._root !== null) {
            const allNodes = [];
            this._root.traverse((node)=>allNodes.push(node));
            allNodes.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Iterate over everything in the array in which the given time
     * overlaps with the time and duration time of the event.
     * @param  time The time to check if items are overlapping
     * @param  callback The callback to invoke with every item
     */ forEachAtTime(time, callback) {
        if (this._root !== null) {
            const results = [];
            this._root.search(time, results);
            results.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Iterate over everything in the array in which the time is greater
     * than or equal to the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachFrom(time, callback) {
        if (this._root !== null) {
            const results = [];
            this._root.searchAfter(time, results);
            results.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        if (this._root !== null) this._root.traverse((node)=>node.dispose());
        this._root = null;
        return this;
    }
}
//-------------------------------------
// 	INTERVAL NODE HELPER
//-------------------------------------
/**
 * Represents a node in the binary search tree, with the addition
 * of a "high" value which keeps track of the highest value of
 * its children.
 * References:
 * https://brooknovak.wordpress.com/2013/12/07/augmented-interval-tree-in-c/
 * http://www.mif.vu.lt/~valdas/ALGORITMAI/LITERATURA/Cormen/Cormen.pdf
 * @param low
 * @param high
 */ class $0953b64e7eb19dcb$var$IntervalNode {
    constructor(low, high, event){
        // the nodes to the left
        this._left = null;
        // the nodes to the right
        this._right = null;
        // the parent node
        this.parent = null;
        // the number of child nodes
        this.height = 0;
        this.event = event;
        // the low value
        this.low = low;
        // the high value
        this.high = high;
        // the high value for this and all child nodes
        this.max = this.high;
    }
    /**
     * Insert a node into the correct spot in the tree
     */ insert(node) {
        if (node.low <= this.low) {
            if (this.left === null) this.left = node;
            else this.left.insert(node);
        } else if (this.right === null) this.right = node;
        else this.right.insert(node);
    }
    /**
     * Search the tree for nodes which overlap
     * with the given point
     * @param  point  The point to query
     * @param  results  The array to put the results
     */ search(point, results) {
        // If p is to the right of the rightmost point of any interval
        // in this node and all children, there won't be any matches.
        if (point > this.max) return;
        // Search left children
        if (this.left !== null) this.left.search(point, results);
        // Check this node
        if (this.low <= point && this.high > point) results.push(this);
        // If p is to the left of the time of this interval,
        // then it can't be in any child to the right.
        if (this.low > point) return;
        // Search right children
        if (this.right !== null) this.right.search(point, results);
    }
    /**
     * Search the tree for nodes which are less
     * than the given point
     * @param  point  The point to query
     * @param  results  The array to put the results
     */ searchAfter(point, results) {
        // Check this node
        if (this.low >= point) {
            results.push(this);
            if (this.left !== null) this.left.searchAfter(point, results);
        }
        // search the right side
        if (this.right !== null) this.right.searchAfter(point, results);
    }
    /**
     * Invoke the callback on this element and both it's branches
     * @param  {Function}  callback
     */ traverse(callback) {
        callback(this);
        if (this.left !== null) this.left.traverse(callback);
        if (this.right !== null) this.right.traverse(callback);
    }
    /**
     * Update the height of the node
     */ updateHeight() {
        if (this.left !== null && this.right !== null) this.height = Math.max(this.left.height, this.right.height) + 1;
        else if (this.right !== null) this.height = this.right.height + 1;
        else if (this.left !== null) this.height = this.left.height + 1;
        else this.height = 0;
    }
    /**
     * Update the height of the node
     */ updateMax() {
        this.max = this.high;
        if (this.left !== null) this.max = Math.max(this.max, this.left.max);
        if (this.right !== null) this.max = Math.max(this.max, this.right.max);
    }
    /**
     * The balance is how the leafs are distributed on the node
     * @return  Negative numbers are balanced to the right
     */ getBalance() {
        let balance = 0;
        if (this.left !== null && this.right !== null) balance = this.left.height - this.right.height;
        else if (this.left !== null) balance = this.left.height + 1;
        else if (this.right !== null) balance = -(this.right.height + 1);
        return balance;
    }
    /**
     * @returns true if this node is the left child of its parent
     */ isLeftChild() {
        return this.parent !== null && this.parent.left === this;
    }
    /**
     * get/set the left node
     */ get left() {
        return this._left;
    }
    set left(node) {
        this._left = node;
        if (node !== null) node.parent = this;
        this.updateHeight();
        this.updateMax();
    }
    /**
     * get/set the right node
     */ get right() {
        return this._right;
    }
    set right(node) {
        this._right = node;
        if (node !== null) node.parent = this;
        this.updateHeight();
        this.updateMax();
    }
    /**
     * null out references.
     */ dispose() {
        this.parent = null;
        this._left = null;
        this._right = null;
        this.event = null;
    }
}







// this file contains all of the valid note names for all pitches between C-4 and C11














class $0515efee749e4f6d$export$dde279e52d625429 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0515efee749e4f6d$export$dde279e52d625429.getDefaults(), arguments, [
            "volume"
        ]));
        this.name = "Volume";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0515efee749e4f6d$export$dde279e52d625429.getDefaults(), arguments, [
            "volume"
        ]);
        this.input = this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.volume,
            units: "decibels"
        });
        this.volume = this.output.gain;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
        this._unmutedVolume = options.volume;
        // set the mute initially
        this.mute = options.mute;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Mute the output.
     * @example
     * const vol = new Tone.Volume(-12).toDestination();
     * const osc = new Tone.Oscillator().connect(vol).start();
     * // mute the output
     * vol.mute = true;
     */ get mute() {
        return this.volume.value === -Infinity;
    }
    set mute(mute) {
        if (!this.mute && mute) {
            this._unmutedVolume = this.volume.value;
            // maybe it should ramp here?
            this.volume.value = -Infinity;
        } else if (this.mute && !mute) this.volume.value = this._unmutedVolume;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this.input.dispose();
        this.volume.dispose();
        return this;
    }
}







class $2a339a17ddbbd1c5$export$5c4bdf44e1e9cea1 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2a339a17ddbbd1c5$export$5c4bdf44e1e9cea1.getDefaults(), arguments));
        this.name = "Destination";
        this.input = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The volume of the master output in decibels. -Infinity is silent, and 0 is no change.
         * @example
         * const osc = new Tone.Oscillator().toDestination();
         * osc.start();
         * // ramp the volume down to silent over 10 seconds
         * Tone.getDestination().volume.rampTo(-Infinity, 10);
         */ this.volume = this.input.volume;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2a339a17ddbbd1c5$export$5c4bdf44e1e9cea1.getDefaults(), arguments);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, this.output, this.context.rawContext.destination);
        this.mute = options.mute;
        this._internalChannels = [
            this.input,
            this.context.rawContext.destination,
            this.output
        ];
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Mute the output.
     * @example
     * const oscillator = new Tone.Oscillator().start().toDestination();
     * setTimeout(() => {
     * 	// mute the output
     * 	Tone.Destination.mute = true;
     * }, 1000);
     */ get mute() {
        return this.input.mute;
    }
    set mute(mute) {
        this.input.mute = mute;
    }
    /**
     * Add a master effects chain. NOTE: this will disconnect any nodes which were previously
     * chained in the master effects chain.
     * @param args All arguments will be connected in a row and the Master will be routed through it.
     * @example
     * // route all audio through a filter and compressor
     * const lowpass = new Tone.Filter(800, "lowpass");
     * const compressor = new Tone.Compressor(-18);
     * Tone.Destination.chain(lowpass, compressor);
     */ chain(...args) {
        this.input.disconnect();
        args.unshift(this.input);
        args.push(this.output);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(...args);
        return this;
    }
    /**
     * The maximum number of channels the system can output
     * @example
     * console.log(Tone.Destination.maxChannelCount);
     */ get maxChannelCount() {
        return this.context.rawContext.destination.maxChannelCount;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.volume.dispose();
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $33268d33018da22a$export$cdd816203a02e74e)((context)=>{
    context.destination = new $2a339a17ddbbd1c5$export$5c4bdf44e1e9cea1({
        context: context
    });
});
(0, $33268d33018da22a$export$7e1ecadd06ae8222)((context)=>{
    context.destination.dispose();
});





class $48a02da4a4a54e79$export$562790db7cca758d extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    /**
     * @param initialValue The value to return if there is no scheduled values
     */ constructor(initialValue){
        super();
        this.name = "TimelineValue";
        /**
         * The timeline which stores the values
         */ this._timeline = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)({
            memory: 10
        });
        this._initialValue = initialValue;
    }
    /**
     * Set the value at the given time
     */ set(value, time) {
        this._timeline.add({
            value: value,
            time: time
        });
        return this;
    }
    /**
     * Get the value at the given time
     */ get(time) {
        const event = this._timeline.get(time);
        if (event) return event.value;
        else return this._initialValue;
    }
}















class $06f551da73286e34$export$bbddcd8b4881600f {
    /**
     * @param transport The transport object which the event belongs to
     */ constructor(transport, opts){
        /**
         * The unique id of the event
         */ this.id = $06f551da73286e34$export$bbddcd8b4881600f._eventId++;
        const options = Object.assign($06f551da73286e34$export$bbddcd8b4881600f.getDefaults(), opts);
        this.transport = transport;
        this.callback = options.callback;
        this._once = options.once;
        this.time = options.time;
    }
    static getDefaults() {
        return {
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            once: false,
            time: 0
        };
    }
    /**
     * Invoke the event callback.
     * @param  time  The AudioContext time in seconds of the event
     */ invoke(time) {
        if (this.callback) {
            this.callback(time);
            if (this._once) this.transport.clear(this.id);
        }
    }
    /**
     * Clean up
     */ dispose() {
        this.callback = undefined;
        return this;
    }
}
/**
 * Current ID counter
 */ $06f551da73286e34$export$bbddcd8b4881600f._eventId = 0;




class $150b1e2b29109d9d$export$8473d2e877b20cae extends (0, $06f551da73286e34$export$bbddcd8b4881600f) {
    /**
     * @param transport The transport object which the event belongs to
     */ constructor(transport, opts){
        super(transport, opts);
        /**
         * The ID of the current timeline event
         */ this._currentId = -1;
        /**
         * The ID of the next timeline event
         */ this._nextId = -1;
        /**
         * The time of the next event
         */ this._nextTick = this.time;
        /**
         * a reference to the bound start method
         */ this._boundRestart = this._restart.bind(this);
        const options = Object.assign($150b1e2b29109d9d$export$8473d2e877b20cae.getDefaults(), opts);
        this.duration = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(transport.context, options.duration).valueOf();
        this._interval = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(transport.context, options.interval).valueOf();
        this._nextTick = options.time;
        this.transport.on("start", this._boundRestart);
        this.transport.on("loopStart", this._boundRestart);
        this.context = this.transport.context;
        this._restart();
    }
    static getDefaults() {
        return Object.assign({}, (0, $06f551da73286e34$export$bbddcd8b4881600f).getDefaults(), {
            duration: Infinity,
            interval: 1,
            once: false
        });
    }
    /**
     * Invoke the callback. Returns the tick time which
     * the next event should be scheduled at.
     * @param  time  The AudioContext time in seconds of the event
     */ invoke(time) {
        // create more events if necessary
        this._createEvents(time);
        // call the super class
        super.invoke(time);
    }
    /**
     * Push more events onto the timeline to keep up with the position of the timeline
     */ _createEvents(time) {
        // schedule the next event
        const ticks = this.transport.getTicksAtTime(time);
        if (ticks >= this.time && ticks >= this._nextTick && this._nextTick + this._interval < this.time + this.duration) {
            this._nextTick += this._interval;
            this._currentId = this._nextId;
            this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._nextTick).toSeconds());
        }
    }
    /**
     * Push more events onto the timeline to keep up with the position of the timeline
     */ _restart(time) {
        this.transport.clear(this._currentId);
        this.transport.clear(this._nextId);
        this._nextTick = this.time;
        const ticks = this.transport.getTicksAtTime(time);
        if (ticks > this.time) this._nextTick = this.time + Math.ceil((ticks - this.time) / this._interval) * this._interval;
        this._currentId = this.transport.scheduleOnce(this.invoke.bind(this), new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._nextTick).toSeconds());
        this._nextTick += this._interval;
        this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._nextTick).toSeconds());
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.transport.clear(this._currentId);
        this.transport.clear(this._nextId);
        this.transport.off("start", this._boundRestart);
        this.transport.off("loopStart", this._boundRestart);
        return this;
    }
}


class $a212afa9a967be50$export$86495b081fef8e52 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a212afa9a967be50$export$86495b081fef8e52.getDefaults(), arguments));
        this.name = "Transport";
        //-------------------------------------
        // 	LOOPING
        //-------------------------------------
        /**
         * If the transport loops or not.
         */ this._loop = new (0, $48a02da4a4a54e79$export$562790db7cca758d)(false);
        /**
         * The loop start position in ticks
         */ this._loopStart = 0;
        /**
         * The loop end position in ticks
         */ this._loopEnd = 0;
        //-------------------------------------
        // 	TIMELINE EVENTS
        //-------------------------------------
        /**
         * All the events in an object to keep track by ID
         */ this._scheduledEvents = {};
        /**
         * The scheduled events.
         */ this._timeline = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        /**
         * Repeated events
         */ this._repeatedEvents = new (0, $0953b64e7eb19dcb$export$5a615b1a895bd9ec)();
        /**
         * All of the synced Signals
         */ this._syncedSignals = [];
        /**
         * The swing amount
         */ this._swingAmount = 0;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a212afa9a967be50$export$86495b081fef8e52.getDefaults(), arguments);
        // CLOCK/TEMPO
        this._ppq = options.ppq;
        this._clock = new (0, $b0382ab9b2ce11b2$export$9735c82c4bae3302)({
            callback: this._processTick.bind(this),
            context: this.context,
            frequency: 0,
            units: "bpm"
        });
        this._bindClockEvents();
        this.bpm = this._clock.frequency;
        this._clock.frequency.multiplier = options.ppq;
        this.bpm.setValueAtTime(options.bpm, 0);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "bpm");
        this._timeSignature = options.timeSignature;
        // SWING
        this._swingTicks = options.ppq / 2; // 8n
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            bpm: 120,
            loopEnd: "4m",
            loopStart: 0,
            ppq: 192,
            swing: 0,
            swingSubdivision: "8n",
            timeSignature: 4
        });
    }
    //-------------------------------------
    // 	TICKS
    //-------------------------------------
    /**
     * called on every tick
     * @param  tickTime clock relative tick time
     */ _processTick(tickTime, ticks) {
        // do the loop test
        if (this._loop.get(tickTime)) {
            if (ticks >= this._loopEnd) {
                this.emit("loopEnd", tickTime);
                this._clock.setTicksAtTime(this._loopStart, tickTime);
                ticks = this._loopStart;
                this.emit("loopStart", tickTime, this._clock.getSecondsAtTime(tickTime));
                this.emit("loop", tickTime);
            }
        }
        // handle swing
        if (this._swingAmount > 0 && ticks % this._ppq !== 0 && // not on a downbeat
        ticks % (this._swingTicks * 2) !== 0) {
            // add some swing
            const progress = ticks % (this._swingTicks * 2) / (this._swingTicks * 2);
            const amount = Math.sin(progress * Math.PI) * this._swingAmount;
            tickTime += new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._swingTicks * 2 / 3).toSeconds() * amount;
        }
        // invoke the timeline events scheduled on this tick
        this._timeline.forEachAtTime(ticks, (event)=>event.invoke(tickTime));
    }
    //-------------------------------------
    // 	SCHEDULABLE EVENTS
    //-------------------------------------
    /**
     * Schedule an event along the timeline.
     * @param callback The callback to be invoked at the time.
     * @param time The time to invoke the callback at.
     * @return The id of the event which can be used for canceling the event.
     * @example
     * // schedule an event on the 16th measure
     * Tone.Transport.schedule((time) => {
     * 	// invoked on measure 16
     * 	console.log("measure 16!");
     * }, "16:0:0");
     */ schedule(callback, time) {
        const event = new (0, $06f551da73286e34$export$bbddcd8b4881600f)(this, {
            callback: callback,
            time: new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toTicks()
        });
        return this._addEvent(event, this._timeline);
    }
    /**
     * Schedule a repeated event along the timeline. The event will fire
     * at the `interval` starting at the `startTime` and for the specified
     * `duration`.
     * @param  callback   The callback to invoke.
     * @param  interval   The duration between successive callbacks. Must be a positive number.
     * @param  startTime  When along the timeline the events should start being invoked.
     * @param  duration How long the event should repeat.
     * @return  The ID of the scheduled event. Use this to cancel the event.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * // a callback invoked every eighth note after the first measure
     * Tone.Transport.scheduleRepeat((time) => {
     * 	osc.start(time).stop(time + 0.1);
     * }, "8n", "1m");
     */ scheduleRepeat(callback, interval, startTime, duration = Infinity) {
        const event = new (0, $150b1e2b29109d9d$export$8473d2e877b20cae)(this, {
            callback: callback,
            duration: new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, duration).toTicks(),
            interval: new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, interval).toTicks(),
            time: new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toTicks()
        });
        // kick it off if the Transport is started
        // @ts-ignore
        return this._addEvent(event, this._repeatedEvents);
    }
    /**
     * Schedule an event that will be removed after it is invoked.
     * @param callback The callback to invoke once.
     * @param time The time the callback should be invoked.
     * @returns The ID of the scheduled event.
     */ scheduleOnce(callback, time) {
        const event = new (0, $06f551da73286e34$export$bbddcd8b4881600f)(this, {
            callback: callback,
            once: true,
            time: new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toTicks()
        });
        return this._addEvent(event, this._timeline);
    }
    /**
     * Clear the passed in event id from the timeline
     * @param eventId The id of the event.
     */ clear(eventId) {
        if (this._scheduledEvents.hasOwnProperty(eventId)) {
            const item = this._scheduledEvents[eventId.toString()];
            item.timeline.remove(item.event);
            item.event.dispose();
            delete this._scheduledEvents[eventId.toString()];
        }
        return this;
    }
    /**
     * Add an event to the correct timeline. Keep track of the
     * timeline it was added to.
     * @returns the event id which was just added
     */ _addEvent(event, timeline) {
        this._scheduledEvents[event.id.toString()] = {
            event: event,
            timeline: timeline
        };
        timeline.add(event);
        return event.id;
    }
    /**
     * Remove scheduled events from the timeline after
     * the given time. Repeated events will be removed
     * if their startTime is after the given time
     * @param after Clear all events after this time.
     */ cancel(after = 0) {
        const computedAfter = this.toTicks(after);
        this._timeline.forEachFrom(computedAfter, (event)=>this.clear(event.id));
        this._repeatedEvents.forEachFrom(computedAfter, (event)=>this.clear(event.id));
        return this;
    }
    //-------------------------------------
    // 	START/STOP/PAUSE
    //-------------------------------------
    /**
     * Bind start/stop/pause events from the clock and emit them.
     */ _bindClockEvents() {
        this._clock.on("start", (time, offset)=>{
            offset = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, offset).toSeconds();
            this.emit("start", time, offset);
        });
        this._clock.on("stop", (time)=>{
            this.emit("stop", time);
        });
        this._clock.on("pause", (time)=>{
            this.emit("pause", time);
        });
    }
    /**
     * Returns the playback state of the source, either "started", "stopped", or "paused"
     */ get state() {
        return this._clock.getStateAtTime(this.now());
    }
    /**
     * Start the transport and all sources synced to the transport.
     * @param  time The time when the transport should start.
     * @param  offset The timeline offset to start the transport.
     * @example
     * // start the transport in one second starting at beginning of the 5th measure.
     * Tone.Transport.start("+1", "4:0:0");
     */ start(time, offset) {
        let offsetTicks;
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(offset)) offsetTicks = this.toTicks(offset);
        // start the clock
        this._clock.start(time, offsetTicks);
        return this;
    }
    /**
     * Stop the transport and all sources synced to the transport.
     * @param time The time when the transport should stop.
     * @example
     * Tone.Transport.stop();
     */ stop(time) {
        this._clock.stop(time);
        return this;
    }
    /**
     * Pause the transport and all sources synced to the transport.
     */ pause(time) {
        this._clock.pause(time);
        return this;
    }
    /**
     * Toggle the current state of the transport. If it is
     * started, it will stop it, otherwise it will start the Transport.
     * @param  time The time of the event
     */ toggle(time) {
        time = this.toSeconds(time);
        if (this._clock.getStateAtTime(time) !== "started") this.start(time);
        else this.stop(time);
        return this;
    }
    //-------------------------------------
    // 	SETTERS/GETTERS
    //-------------------------------------
    /**
     * The time signature as just the numerator over 4.
     * For example 4/4 would be just 4 and 6/8 would be 3.
     * @example
     * // common time
     * Tone.Transport.timeSignature = 4;
     * // 7/8
     * Tone.Transport.timeSignature = [7, 8];
     * // this will be reduced to a single number
     * Tone.Transport.timeSignature; // returns 3.5
     */ get timeSignature() {
        return this._timeSignature;
    }
    set timeSignature(timeSig) {
        if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(timeSig)) timeSig = timeSig[0] / timeSig[1] * 4;
        this._timeSignature = timeSig;
    }
    /**
     * When the Transport.loop = true, this is the starting position of the loop.
     */ get loopStart() {
        return new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, this._loopStart, "i").toSeconds();
    }
    set loopStart(startPosition) {
        this._loopStart = this.toTicks(startPosition);
    }
    /**
     * When the Transport.loop = true, this is the ending position of the loop.
     */ get loopEnd() {
        return new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, this._loopEnd, "i").toSeconds();
    }
    set loopEnd(endPosition) {
        this._loopEnd = this.toTicks(endPosition);
    }
    /**
     * If the transport loops or not.
     */ get loop() {
        return this._loop.get(this.now());
    }
    set loop(loop) {
        this._loop.set(loop, this.now());
    }
    /**
     * Set the loop start and stop at the same time.
     * @example
     * // loop over the first measure
     * Tone.Transport.setLoopPoints(0, "1m");
     * Tone.Transport.loop = true;
     */ setLoopPoints(startPosition, endPosition) {
        this.loopStart = startPosition;
        this.loopEnd = endPosition;
        return this;
    }
    /**
     * The swing value. Between 0-1 where 1 equal to the note + half the subdivision.
     */ get swing() {
        return this._swingAmount;
    }
    set swing(amount) {
        // scale the values to a normal range
        this._swingAmount = amount;
    }
    /**
     * Set the subdivision which the swing will be applied to.
     * The default value is an 8th note. Value must be less
     * than a quarter note.
     */ get swingSubdivision() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._swingTicks).toNotation();
    }
    set swingSubdivision(subdivision) {
        this._swingTicks = this.toTicks(subdivision);
    }
    /**
     * The Transport's position in Bars:Beats:Sixteenths.
     * Setting the value will jump to that position right away.
     */ get position() {
        const now = this.now();
        const ticks = this._clock.getTicksAtTime(now);
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, ticks).toBarsBeatsSixteenths();
    }
    set position(progress) {
        const ticks = this.toTicks(progress);
        this.ticks = ticks;
    }
    /**
     * The Transport's position in seconds
     * Setting the value will jump to that position right away.
     */ get seconds() {
        return this._clock.seconds;
    }
    set seconds(s) {
        const now = this.now();
        const ticks = this._clock.frequency.timeToTicks(s, now);
        this.ticks = ticks;
    }
    /**
     * The Transport's loop position as a normalized value. Always
     * returns 0 if the transport if loop is not true.
     */ get progress() {
        if (this.loop) {
            const now = this.now();
            const ticks = this._clock.getTicksAtTime(now);
            return (ticks - this._loopStart) / (this._loopEnd - this._loopStart);
        } else return 0;
    }
    /**
     * The transports current tick position.
     */ get ticks() {
        return this._clock.ticks;
    }
    set ticks(t) {
        if (this._clock.ticks !== t) {
            const now = this.now();
            // stop everything synced to the transport
            if (this.state === "started") {
                const ticks = this._clock.getTicksAtTime(now);
                // schedule to start on the next tick, #573
                const remainingTick = this._clock.frequency.getDurationOfTicks(Math.ceil(ticks) - ticks, now);
                const time = now + remainingTick;
                this.emit("stop", time);
                this._clock.setTicksAtTime(t, time);
                // restart it with the new time
                this.emit("start", time, this._clock.getSecondsAtTime(time));
            } else this._clock.setTicksAtTime(t, now);
        }
    }
    /**
     * Get the clock's ticks at the given time.
     * @param  time  When to get the tick value
     * @return The tick value at the given time.
     */ getTicksAtTime(time) {
        return Math.round(this._clock.getTicksAtTime(time));
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        return this._clock.getSecondsAtTime(time);
    }
    /**
     * Pulses Per Quarter note. This is the smallest resolution
     * the Transport timing supports. This should be set once
     * on initialization and not set again. Changing this value
     * after other objects have been created can cause problems.
     */ get PPQ() {
        return this._clock.frequency.multiplier;
    }
    set PPQ(ppq) {
        this._clock.frequency.multiplier = ppq;
    }
    //-------------------------------------
    // 	SYNCING
    //-------------------------------------
    /**
     * Returns the time aligned to the next subdivision
     * of the Transport. If the Transport is not started,
     * it will return 0.
     * Note: this will not work precisely during tempo ramps.
     * @param  subdivision  The subdivision to quantize to
     * @return  The context time of the next subdivision.
     * @example
     * // the transport must be started, otherwise returns 0
     * Tone.Transport.start();
     * Tone.Transport.nextSubdivision("4n");
     */ nextSubdivision(subdivision) {
        subdivision = this.toTicks(subdivision);
        if (this.state !== "started") // if the transport's not started, return 0
        return 0;
        else {
            const now = this.now();
            // the remainder of the current ticks and the subdivision
            const transportPos = this.getTicksAtTime(now);
            const remainingTicks = subdivision - transportPos % subdivision;
            return this._clock.nextTickTime(remainingTicks, now);
        }
    }
    /**
     * Attaches the signal to the tempo control signal so that
     * any changes in the tempo will change the signal in the same
     * ratio.
     *
     * @param signal
     * @param ratio Optionally pass in the ratio between the two signals.
     * 			Otherwise it will be computed based on their current values.
     */ syncSignal(signal, ratio) {
        if (!ratio) {
            // get the sync ratio
            const now = this.now();
            if (signal.getValueAtTime(now) !== 0) {
                const bpm = this.bpm.getValueAtTime(now);
                const computedFreq = 1 / (60 / bpm / this.PPQ);
                ratio = signal.getValueAtTime(now) / computedFreq;
            } else ratio = 0;
        }
        const ratioSignal = new (0, $10a186a98a559639$export$acd19d919666900d)(ratio);
        // @ts-ignore
        this.bpm.connect(ratioSignal);
        // @ts-ignore
        ratioSignal.connect(signal._param);
        this._syncedSignals.push({
            initial: signal.value,
            ratio: ratioSignal,
            signal: signal
        });
        signal.value = 0;
        return this;
    }
    /**
     * Unsyncs a previously synced signal from the transport's control.
     * See Transport.syncSignal.
     */ unsyncSignal(signal) {
        for(let i = this._syncedSignals.length - 1; i >= 0; i--){
            const syncedSignal = this._syncedSignals[i];
            if (syncedSignal.signal === signal) {
                syncedSignal.ratio.dispose();
                syncedSignal.signal.value = syncedSignal.initial;
                this._syncedSignals.splice(i, 1);
            }
        }
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._clock.dispose();
        (0, $8cce0c9e2019bc8a$export$e6d3eada50a007b1)(this, "bpm");
        this._timeline.dispose();
        this._repeatedEvents.dispose();
        return this;
    }
}
(0, $092748a42ac93843$export$4293555f241ae35a).mixin($a212afa9a967be50$export$86495b081fef8e52);
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $33268d33018da22a$export$cdd816203a02e74e)((context)=>{
    context.transport = new $a212afa9a967be50$export$86495b081fef8e52({
        context: context
    });
});
(0, $33268d33018da22a$export$7e1ecadd06ae8222)((context)=>{
    context.transport.dispose();
});









class $1a3cf1f57a33a53f$export$1d2df86270c81ecb extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        /**
         * Sources have no inputs
         */ this.input = undefined;
        /**
         * Keep track of the scheduled state.
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)("stopped");
        /**
         * The synced `start` callback function from the transport
         */ this._synced = false;
        /**
         * Keep track of all of the scheduled event ids
         */ this._scheduled = [];
        /**
         * Placeholder functions for syncing/unsyncing to transport
         */ this._syncedStart = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        this._syncedStop = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        this._state.memory = 100;
        this._state.increasing = true;
        this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            mute: options.mute,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
        this.onstop = options.onstop;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            onstop: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            volume: 0
        });
    }
    /**
     * Returns the playback state of the source, either "started" or "stopped".
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/ahntone_c3.mp3", () => {
     * 	player.start();
     * 	console.log(player.state);
     * }).toDestination();
     */ get state() {
        if (this._synced) {
            if (this.context.transport.state === "started") return this._state.getValueAtTime(this.context.transport.seconds);
            else return "stopped";
        } else return this._state.getValueAtTime(this.now());
    }
    /**
     * Mute the output.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * // mute the output
     * osc.mute = true;
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    /**
     * Ensure that the scheduled time is not before the current time.
     * Should only be used when scheduled unsynced.
     */ _clampToCurrentTime(time) {
        if (this._synced) return time;
        else return Math.max(time, this.context.currentTime);
    }
    /**
     * Start the source at the specified time. If no time is given,
     * start the source now.
     * @param  time When the source should be started.
     * @example
     * const source = new Tone.Oscillator().toDestination();
     * source.start("+0.5"); // starts the source 0.5 seconds from now
     */ start(time, offset, duration) {
        let computedTime = (0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(time) && this._synced ? this.context.transport.seconds : this.toSeconds(time);
        computedTime = this._clampToCurrentTime(computedTime);
        // if it's started, stop it and restart it
        if (!this._synced && this._state.getValueAtTime(computedTime) === "started") {
            // time should be strictly greater than the previous start time
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $0f7b0e628156f5de$export$b023c82b48e70453)(computedTime, this._state.get(computedTime).time), "Start time must be strictly greater than previous start time");
            this._state.cancel(computedTime);
            this._state.setStateAtTime("started", computedTime);
            this.log("restart", computedTime);
            this.restart(computedTime, offset, duration);
        } else {
            this.log("start", computedTime);
            this._state.setStateAtTime("started", computedTime);
            if (this._synced) {
                // add the offset time to the event
                const event = this._state.get(computedTime);
                if (event) {
                    event.offset = this.toSeconds((0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0));
                    event.duration = duration ? this.toSeconds(duration) : undefined;
                }
                const sched = this.context.transport.schedule((t)=>{
                    this._start(t, offset, duration);
                }, computedTime);
                this._scheduled.push(sched);
                // if the transport is already started
                // and the time is greater than where the transport is
                if (this.context.transport.state === "started" && this.context.transport.getSecondsAtTime(this.immediate()) > computedTime) this._syncedStart(this.now(), this.context.transport.seconds);
            } else {
                (0, $afc9146c77d080c2$export$8ef1ce44f93c2687)(this.context);
                this._start(computedTime, offset, duration);
            }
        }
        return this;
    }
    /**
     * Stop the source at the specified time. If no time is given,
     * stop the source now.
     * @param  time When the source should be stopped.
     * @example
     * const source = new Tone.Oscillator().toDestination();
     * source.start();
     * source.stop("+0.5"); // stops the source 0.5 seconds from now
     */ stop(time) {
        let computedTime = (0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(time) && this._synced ? this.context.transport.seconds : this.toSeconds(time);
        computedTime = this._clampToCurrentTime(computedTime);
        if (this._state.getValueAtTime(computedTime) === "started" || (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._state.getNextState("started", computedTime))) {
            this.log("stop", computedTime);
            if (!this._synced) this._stop(computedTime);
            else {
                const sched = this.context.transport.schedule(this._stop.bind(this), computedTime);
                this._scheduled.push(sched);
            }
            this._state.cancel(computedTime);
            this._state.setStateAtTime("stopped", computedTime);
        }
        return this;
    }
    /**
     * Restart the source.
     */ restart(time, offset, duration) {
        time = this.toSeconds(time);
        if (this._state.getValueAtTime(time) === "started") {
            this._state.cancel(time);
            this._restart(time, offset, duration);
        }
        return this;
    }
    /**
     * Sync the source to the Transport so that all subsequent
     * calls to `start` and `stop` are synced to the TransportTime
     * instead of the AudioContext time.
     *
     * @example
     * const osc = new Tone.Oscillator().toDestination();
     * // sync the source so that it plays between 0 and 0.3 on the Transport's timeline
     * osc.sync().start(0).stop(0.3);
     * // start the transport.
     * Tone.Transport.start();
     * // set it to loop once a second
     * Tone.Transport.loop = true;
     * Tone.Transport.loopEnd = 1;
     */ sync() {
        if (!this._synced) {
            this._synced = true;
            this._syncedStart = (time, offset)=>{
                if (offset > 0) {
                    // get the playback state at that time
                    const stateEvent = this._state.get(offset);
                    // listen for start events which may occur in the middle of the sync'ed time
                    if (stateEvent && stateEvent.state === "started" && stateEvent.time !== offset) {
                        // get the offset
                        const startOffset = offset - this.toSeconds(stateEvent.time);
                        let duration;
                        if (stateEvent.duration) duration = this.toSeconds(stateEvent.duration) - startOffset;
                        this._start(time, this.toSeconds(stateEvent.offset) + startOffset, duration);
                    }
                }
            };
            this._syncedStop = (time)=>{
                const seconds = this.context.transport.getSecondsAtTime(Math.max(time - this.sampleTime, 0));
                if (this._state.getValueAtTime(seconds) === "started") this._stop(time);
            };
            this.context.transport.on("start", this._syncedStart);
            this.context.transport.on("loopStart", this._syncedStart);
            this.context.transport.on("stop", this._syncedStop);
            this.context.transport.on("pause", this._syncedStop);
            this.context.transport.on("loopEnd", this._syncedStop);
        }
        return this;
    }
    /**
     * Unsync the source to the Transport. See Source.sync
     */ unsync() {
        if (this._synced) {
            this.context.transport.off("stop", this._syncedStop);
            this.context.transport.off("pause", this._syncedStop);
            this.context.transport.off("loopEnd", this._syncedStop);
            this.context.transport.off("start", this._syncedStart);
            this.context.transport.off("loopStart", this._syncedStart);
        }
        this._synced = false;
        // clear all of the scheduled ids
        this._scheduled.forEach((id)=>this.context.transport.clear(id));
        this._scheduled = [];
        this._state.cancel(0);
        // stop it also
        this._stop(0);
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.onstop = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        this.unsync();
        this._volume.dispose();
        this._state.dispose();
        return this;
    }
}











class $faf7c8e078303879$export$30cbf4ba14db4fdd extends (0, $e20d6aed0c7175de$export$27749f88ede4d2a3) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faf7c8e078303879$export$30cbf4ba14db4fdd.getDefaults(), arguments, [
            "url",
            "onload"
        ]));
        this.name = "ToneBufferSource";
        /**
         * The oscillator
         */ this._source = this.context.createBufferSource();
        this._internalChannels = [
            this._source
        ];
        /**
         * indicators if the source has started/stopped
         */ this._sourceStarted = false;
        this._sourceStopped = false;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faf7c8e078303879$export$30cbf4ba14db4fdd.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._source, this._gainNode);
        this._source.onended = ()=>this._stopSource();
        /**
         * The playbackRate of the buffer
         */ this.playbackRate = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._source.playbackRate,
            units: "positive",
            value: options.playbackRate
        });
        // set some values initially
        this.loop = options.loop;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this._buffer = new (0, $43da6dea502b5fe8$export$424a335715b38178)(options.url, options.onload, options.onerror);
        this._internalChannels.push(this._source);
    }
    static getDefaults() {
        return Object.assign((0, $e20d6aed0c7175de$export$27749f88ede4d2a3).getDefaults(), {
            url: new (0, $43da6dea502b5fe8$export$424a335715b38178)(),
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            playbackRate: 1
        });
    }
    /**
     * The fadeIn time of the amplitude envelope.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(t) {
        this._fadeIn = t;
    }
    /**
     * The fadeOut time of the amplitude envelope.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(t) {
        this._fadeOut = t;
    }
    /**
     * The curve applied to the fades, either "linear" or "exponential"
     */ get curve() {
        return this._curve;
    }
    set curve(t) {
        this._curve = t;
    }
    /**
     * Start the buffer
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given, it will default to the full length of the sample (minus any offset)
     * @param  gain  The gain to play the buffer back at.
     */ start(time, offset, duration, gain = 1) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.buffer.loaded, "buffer is either not set or not loaded");
        const computedTime = this.toSeconds(time);
        // apply the gain envelope
        this._startGain(computedTime, gain);
        // if it's a loop the default offset is the loopstart point
        if (this.loop) offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, this.loopStart);
        else // otherwise the default offset is 0
        offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0);
        // make sure the offset is not less than 0
        let computedOffset = Math.max(this.toSeconds(offset), 0);
        // start the buffer source
        if (this.loop) {
            // modify the offset if it's greater than the loop time
            const loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration;
            const loopStart = this.toSeconds(this.loopStart);
            const loopDuration = loopEnd - loopStart;
            // move the offset back
            if ((0, $0f7b0e628156f5de$export$c846515610eb2c50)(computedOffset, loopEnd)) computedOffset = (computedOffset - loopStart) % loopDuration + loopStart;
            // when the offset is very close to the duration, set it to 0
            if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(computedOffset, this.buffer.duration)) computedOffset = 0;
        }
        // this.buffer.loaded would have return false if the AudioBuffer was undefined
        this._source.buffer = this.buffer.get();
        this._source.loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration;
        if ((0, $0f7b0e628156f5de$export$7158f0ceb70f54c7)(computedOffset, this.buffer.duration)) {
            this._sourceStarted = true;
            this._source.start(computedTime, computedOffset);
        }
        // if a duration is given, schedule a stop
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(duration)) {
            let computedDur = this.toSeconds(duration);
            // make sure it's never negative
            computedDur = Math.max(computedDur, 0);
            this.stop(computedTime + computedDur);
        }
        return this;
    }
    _stopSource(time) {
        if (!this._sourceStopped && this._sourceStarted) {
            this._sourceStopped = true;
            this._source.stop(this.toSeconds(time));
            this._onended();
        }
    }
    /**
     * If loop is true, the loop will start at this position.
     */ get loopStart() {
        return this._source.loopStart;
    }
    set loopStart(loopStart) {
        this._source.loopStart = this.toSeconds(loopStart);
    }
    /**
     * If loop is true, the loop will end at this position.
     */ get loopEnd() {
        return this._source.loopEnd;
    }
    set loopEnd(loopEnd) {
        this._source.loopEnd = this.toSeconds(loopEnd);
    }
    /**
     * The audio buffer belonging to the player.
     */ get buffer() {
        return this._buffer;
    }
    set buffer(buffer) {
        this._buffer.set(buffer);
    }
    /**
     * If the buffer should loop once it's over.
     */ get loop() {
        return this._source.loop;
    }
    set loop(loop) {
        this._source.loop = loop;
        if (this._sourceStarted) this.cancelStop();
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._source.onended = null;
        this._source.disconnect();
        this._buffer.dispose();
        this.playbackRate.dispose();
        return this;
    }
}


class $93a0a7e8f19a773f$export$484d33a0500a4ce1 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($93a0a7e8f19a773f$export$484d33a0500a4ce1.getDefaults(), arguments, [
            "type"
        ]));
        this.name = "Noise";
        /**
         * Private reference to the source
         */ this._source = null;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($93a0a7e8f19a773f$export$484d33a0500a4ce1.getDefaults(), arguments, [
            "type"
        ]);
        this._playbackRate = options.playbackRate;
        this.type = options.type;
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            fadeIn: 0,
            fadeOut: 0,
            playbackRate: 1,
            type: "white"
        });
    }
    /**
     * The type of the noise. Can be "white", "brown", or "pink".
     * @example
     * const noise = new Tone.Noise().toDestination().start();
     * noise.type = "brown";
     */ get type() {
        return this._type;
    }
    set type(type) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(type in $93a0a7e8f19a773f$var$_noiseBuffers, "Noise: invalid type: " + type);
        if (this._type !== type) {
            this._type = type;
            // if it's playing, stop and restart it
            if (this.state === "started") {
                const now = this.now();
                this._stop(now);
                this._start(now);
            }
        }
    }
    /**
     * The playback rate of the noise. Affects
     * the "frequency" of the noise.
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        if (this._source) this._source.playbackRate.value = rate;
    }
    /**
     * internal start method
     */ _start(time) {
        const buffer = $93a0a7e8f19a773f$var$_noiseBuffers[this._type];
        this._source = new (0, $faf7c8e078303879$export$30cbf4ba14db4fdd)({
            url: buffer,
            context: this.context,
            fadeIn: this._fadeIn,
            fadeOut: this._fadeOut,
            loop: true,
            onended: ()=>this.onstop(this),
            playbackRate: this._playbackRate
        }).connect(this.output);
        this._source.start(this.toSeconds(time), Math.random() * (buffer.duration - 0.001));
    }
    /**
     * internal stop method
     */ _stop(time) {
        if (this._source) {
            this._source.stop(this.toSeconds(time));
            this._source = null;
        }
    }
    /**
     * The fadeIn time of the amplitude envelope.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(time) {
        this._fadeIn = time;
        if (this._source) this._source.fadeIn = this._fadeIn;
    }
    /**
     * The fadeOut time of the amplitude envelope.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(time) {
        this._fadeOut = time;
        if (this._source) this._source.fadeOut = this._fadeOut;
    }
    _restart(time) {
        // TODO could be optimized by cancelling the buffer source 'stop'
        this._stop(time);
        this._start(time);
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        if (this._source) this._source.disconnect();
        return this;
    }
}
//--------------------
// THE NOISE BUFFERS
//--------------------
// Noise buffer stats
const $93a0a7e8f19a773f$var$BUFFER_LENGTH = 220500;
const $93a0a7e8f19a773f$var$NUM_CHANNELS = 2;
/**
 * Cache the noise buffers
 */ const $93a0a7e8f19a773f$var$_noiseCache = {
    brown: null,
    pink: null,
    white: null
};
/**
 * The noise arrays. Generated on initialization.
 * borrowed heavily from https://github.com/zacharydenton/noise.js
 * (c) 2013 Zach Denton (MIT)
 */ const $93a0a7e8f19a773f$var$_noiseBuffers = {
    get brown () {
        if (!$93a0a7e8f19a773f$var$_noiseCache.brown) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $93a0a7e8f19a773f$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($93a0a7e8f19a773f$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                let lastOut = 0.0;
                for(let i = 0; i < $93a0a7e8f19a773f$var$BUFFER_LENGTH; i++){
                    const white = Math.random() * 2 - 1;
                    channel[i] = (lastOut + 0.02 * white) / 1.02;
                    lastOut = channel[i];
                    channel[i] *= 3.5; // (roughly) compensate for gain
                }
            }
            $93a0a7e8f19a773f$var$_noiseCache.brown = new (0, $43da6dea502b5fe8$export$424a335715b38178)().fromArray(buffer);
        }
        return $93a0a7e8f19a773f$var$_noiseCache.brown;
    },
    get pink () {
        if (!$93a0a7e8f19a773f$var$_noiseCache.pink) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $93a0a7e8f19a773f$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($93a0a7e8f19a773f$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                let b0, b1, b2, b3, b4, b5, b6;
                b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0.0;
                for(let i = 0; i < $93a0a7e8f19a773f$var$BUFFER_LENGTH; i++){
                    const white = Math.random() * 2 - 1;
                    b0 = 0.99886 * b0 + white * 0.0555179;
                    b1 = 0.99332 * b1 + white * 0.0750759;
                    b2 = 0.96900 * b2 + white * 0.1538520;
                    b3 = 0.86650 * b3 + white * 0.3104856;
                    b4 = 0.55000 * b4 + white * 0.5329522;
                    b5 = -0.7616 * b5 - white * 0.0168980;
                    channel[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362;
                    channel[i] *= 0.11; // (roughly) compensate for gain
                    b6 = white * 0.115926;
                }
            }
            $93a0a7e8f19a773f$var$_noiseCache.pink = new (0, $43da6dea502b5fe8$export$424a335715b38178)().fromArray(buffer);
        }
        return $93a0a7e8f19a773f$var$_noiseCache.pink;
    },
    get white () {
        if (!$93a0a7e8f19a773f$var$_noiseCache.white) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $93a0a7e8f19a773f$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($93a0a7e8f19a773f$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                for(let i = 0; i < $93a0a7e8f19a773f$var$BUFFER_LENGTH; i++)channel[i] = Math.random() * 2 - 1;
            }
            $93a0a7e8f19a773f$var$_noiseCache.white = new (0, $43da6dea502b5fe8$export$424a335715b38178)().fromArray(buffer);
        }
        return $93a0a7e8f19a773f$var$_noiseCache.white;
    }
};









class $c8800676c7f374c9$export$187d60d76727d102 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($c8800676c7f374c9$export$187d60d76727d102.getDefaults(), arguments, [
            "volume"
        ]));
        this.name = "UserMedia";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($c8800676c7f374c9$export$187d60d76727d102.getDefaults(), arguments, [
            "volume"
        ]);
        this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
        this.mute = options.mute;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Open the media stream. If a string is passed in, it is assumed
     * to be the label or id of the stream, if a number is passed in,
     * it is the input number of the stream.
     * @param  labelOrId The label or id of the audio input media device.
     *                   With no argument, the default stream is opened.
     * @return The promise is resolved when the stream is open.
     */ open(labelOrId) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)($c8800676c7f374c9$export$187d60d76727d102.supported, "UserMedia is not supported");
            // close the previous stream
            if (this.state === "started") this.close();
            const devices = yield $c8800676c7f374c9$export$187d60d76727d102.enumerateDevices();
            if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(labelOrId)) this._device = devices[labelOrId];
            else {
                this._device = devices.find((device)=>{
                    return device.label === labelOrId || device.deviceId === labelOrId;
                });
                // didn't find a matching device
                if (!this._device && devices.length > 0) this._device = devices[0];
                (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._device), `No matching device ${labelOrId}`);
            }
            // do getUserMedia
            const constraints = {
                audio: {
                    echoCancellation: false,
                    sampleRate: this.context.sampleRate,
                    noiseSuppression: false,
                    mozNoiseSuppression: false
                }
            };
            if (this._device) // @ts-ignore
            constraints.audio.deviceId = this._device.deviceId;
            const stream = yield navigator.mediaDevices.getUserMedia(constraints);
            // start a new source only if the previous one is closed
            if (!this._stream) {
                this._stream = stream;
                // Wrap a MediaStreamSourceNode around the live input stream.
                const mediaStreamNode = this.context.createMediaStreamSource(stream);
                // Connect the MediaStreamSourceNode to a gate gain node
                (0, $1dae52eee8c779dd$export$64605811ab45167f)(mediaStreamNode, this.output);
                this._mediaStream = mediaStreamNode;
            }
            return this;
        });
    }
    /**
     * Close the media stream
     */ close() {
        if (this._stream && this._mediaStream) {
            this._stream.getAudioTracks().forEach((track)=>{
                track.stop();
            });
            this._stream = undefined;
            // remove the old media stream
            this._mediaStream.disconnect();
            this._mediaStream = undefined;
        }
        this._device = undefined;
        return this;
    }
    /**
     * Returns a promise which resolves with the list of audio input devices available.
     * @return The promise that is resolved with the devices
     * @example
     * Tone.UserMedia.enumerateDevices().then((devices) => {
     * 	// print the device labels
     * 	console.log(devices.map(device => device.label));
     * });
     */ static enumerateDevices() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const allDevices = yield navigator.mediaDevices.enumerateDevices();
            return allDevices.filter((device)=>{
                return device.kind === "audioinput";
            });
        });
    }
    /**
     * Returns the playback state of the source, "started" when the microphone is open
     * and "stopped" when the mic is closed.
     */ get state() {
        return this._stream && this._stream.active ? "started" : "stopped";
    }
    /**
     * Returns an identifier for the represented device that is
     * persisted across sessions. It is un-guessable by other applications and
     * unique to the origin of the calling application. It is reset when the
     * user clears cookies (for Private Browsing, a different identifier is
     * used that is not persisted across sessions). Returns undefined when the
     * device is not open.
     */ get deviceId() {
        if (this._device) return this._device.deviceId;
        else return undefined;
    }
    /**
     * Returns a group identifier. Two devices have the
     * same group identifier if they belong to the same physical device.
     * Returns null  when the device is not open.
     */ get groupId() {
        if (this._device) return this._device.groupId;
        else return undefined;
    }
    /**
     * Returns a label describing this device (for example "Built-in Microphone").
     * Returns undefined when the device is not open or label is not available
     * because of permissions.
     */ get label() {
        if (this._device) return this._device.label;
        else return undefined;
    }
    /**
     * Mute the output.
     * @example
     * const mic = new Tone.UserMedia();
     * mic.open().then(() => {
     * 	// promise resolves when input is available
     * });
     * // mute the output
     * mic.mute = true;
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    dispose() {
        super.dispose();
        this.close();
        this._volume.dispose();
        this.volume.dispose();
        return this;
    }
    /**
     * If getUserMedia is supported by the browser.
     */ static get supported() {
        return (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(navigator.mediaDevices) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(navigator.mediaDevices.getUserMedia);
    }
}










function $e45997ed2518edd7$export$c5486db94e413392(instance, length) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const duration = length / instance.context.sampleRate;
        const context = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(1, duration, instance.context.sampleRate);
        const clone = new instance.constructor(Object.assign(instance.get(), {
            // should do 2 iterations
            frequency: 2 / duration,
            // zero out the detune
            detune: 0,
            context: context
        })).toDestination();
        clone.start(0);
        const buffer = yield context.render();
        return buffer.getChannelData(0);
    });
}







class $6dd36306779dbefc$export$284532b021137a4a extends (0, $e20d6aed0c7175de$export$27749f88ede4d2a3) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($6dd36306779dbefc$export$284532b021137a4a.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "ToneOscillatorNode";
        /**
         * The oscillator
         */ this._oscillator = this.context.createOscillator();
        this._internalChannels = [
            this._oscillator
        ];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($6dd36306779dbefc$export$284532b021137a4a.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._oscillator, this._gainNode);
        this.type = options.type;
        this.frequency = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._oscillator.frequency,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._oscillator.detune,
            units: "cents",
            value: options.detune
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $e20d6aed0c7175de$export$27749f88ede4d2a3).getDefaults(), {
            detune: 0,
            frequency: 440,
            type: "sine"
        });
    }
    /**
     * Start the oscillator node at the given time
     * @param  time When to start the oscillator
     */ start(time) {
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        this._startGain(computedTime);
        this._oscillator.start(computedTime);
        return this;
    }
    _stopSource(time) {
        this._oscillator.stop(time);
    }
    /**
     * Sets an arbitrary custom periodic waveform given a PeriodicWave.
     * @param  periodicWave PeriodicWave should be created with context.createPeriodicWave
     */ setPeriodicWave(periodicWave) {
        this._oscillator.setPeriodicWave(periodicWave);
        return this;
    }
    /**
     * The oscillator type. Either 'sine', 'sawtooth', 'square', or 'triangle'
     */ get type() {
        return this._oscillator.type;
    }
    set type(type) {
        this._oscillator.type = type;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        if (this.state === "started") this.stop();
        this._oscillator.disconnect();
        this.frequency.dispose();
        this.detune.dispose();
        return this;
    }
}




class $304d61465298e719$export$c01c5c7b81696d70 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($304d61465298e719$export$c01c5c7b81696d70.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "Oscillator";
        /**
         * the main oscillator
         */ this._oscillator = null;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($304d61465298e719$export$c01c5c7b81696d70.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "frequency");
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "detune");
        this._partials = options.partials;
        this._partialCount = options.partialCount;
        this._type = options.type;
        if (options.partialCount && options.type !== "custom") this._type = this.baseType + options.partialCount.toString();
        this.phase = options.phase;
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            detune: 0,
            frequency: 440,
            partialCount: 0,
            partials: [],
            phase: 0,
            type: "sine"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        const computedTime = this.toSeconds(time);
        // new oscillator with previous values
        const oscillator = new (0, $6dd36306779dbefc$export$284532b021137a4a)({
            context: this.context,
            onended: ()=>this.onstop(this)
        });
        this._oscillator = oscillator;
        if (this._wave) this._oscillator.setPeriodicWave(this._wave);
        else this._oscillator.type = this._type;
        // connect the control signal to the oscillator frequency & detune
        this._oscillator.connect(this.output);
        this.frequency.connect(this._oscillator.frequency);
        this.detune.connect(this._oscillator.detune);
        // start the oscillator
        this._oscillator.start(computedTime);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        const computedTime = this.toSeconds(time);
        if (this._oscillator) this._oscillator.stop(computedTime);
    }
    /**
     * Restart the oscillator. Does not stop the oscillator, but instead
     * just cancels any scheduled 'stop' from being invoked.
     */ _restart(time) {
        const computedTime = this.toSeconds(time);
        this.log("restart", computedTime);
        if (this._oscillator) this._oscillator.cancelStop();
        this._state.cancel(computedTime);
        return this;
    }
    /**
     * Sync the signal to the Transport's bpm. Any changes to the transports bpm,
     * will also affect the oscillators frequency.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * osc.frequency.value = 440;
     * // the ratio between the bpm and the frequency will be maintained
     * osc.syncFrequency();
     * // double the tempo
     * Tone.Transport.bpm.value *= 2;
     * // the frequency of the oscillator is doubled to 880
     */ syncFrequency() {
        this.context.transport.syncSignal(this.frequency);
        return this;
    }
    /**
     * Unsync the oscillator's frequency from the Transport.
     * See Oscillator.syncFrequency
     */ unsyncFrequency() {
        this.context.transport.unsyncSignal(this.frequency);
        return this;
    }
    /**
     * Get a cached periodic wave. Avoids having to recompute
     * the oscillator values when they have already been computed
     * with the same values.
     */ _getCachedPeriodicWave() {
        if (this._type === "custom") {
            const oscProps = $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.find((description)=>{
                return description.phase === this._phase && (0, $07d9216a29f4e8bb$export$73ce4178444047a5)(description.partials, this._partials);
            });
            return oscProps;
        } else {
            const oscProps = $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.find((description)=>{
                return description.type === this._type && description.phase === this._phase;
            });
            this._partialCount = oscProps ? oscProps.partialCount : this._partialCount;
            return oscProps;
        }
    }
    get type() {
        return this._type;
    }
    set type(type) {
        this._type = type;
        const isBasicType = [
            "sine",
            "square",
            "sawtooth",
            "triangle"
        ].indexOf(type) !== -1;
        if (this._phase === 0 && isBasicType) {
            this._wave = undefined;
            this._partialCount = 0;
            // just go with the basic approach
            if (this._oscillator !== null) // already tested that it's a basic type
            this._oscillator.type = type;
        } else {
            // first check if the value is cached
            const cache = this._getCachedPeriodicWave();
            if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(cache)) {
                const { partials: partials, wave: wave } = cache;
                this._wave = wave;
                this._partials = partials;
                if (this._oscillator !== null) this._oscillator.setPeriodicWave(this._wave);
            } else {
                const [real, imag] = this._getRealImaginary(type, this._phase);
                const periodicWave = this.context.createPeriodicWave(real, imag);
                this._wave = periodicWave;
                if (this._oscillator !== null) this._oscillator.setPeriodicWave(this._wave);
                // set the cache
                $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.push({
                    imag: imag,
                    partialCount: this._partialCount,
                    partials: this._partials,
                    phase: this._phase,
                    real: real,
                    type: this._type,
                    wave: this._wave
                });
                if ($304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.length > 100) $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.shift();
            }
        }
    }
    get baseType() {
        return this._type.replace(this.partialCount.toString(), "");
    }
    set baseType(baseType) {
        if (this.partialCount && this._type !== "custom" && baseType !== "custom") this.type = baseType + this.partialCount;
        else this.type = baseType;
    }
    get partialCount() {
        return this._partialCount;
    }
    set partialCount(p) {
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(p, 0);
        let type = this._type;
        const partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(this._type);
        if (partial) type = partial[1];
        if (this._type !== "custom") {
            if (p === 0) this.type = type;
            else this.type = type + p.toString();
        } else {
            // extend or shorten the partials array
            const fullPartials = new Float32Array(p);
            // copy over the partials array
            this._partials.forEach((v, i)=>fullPartials[i] = v);
            this._partials = Array.from(fullPartials);
            this.type = this._type;
        }
    }
    /**
     * Returns the real and imaginary components based
     * on the oscillator type.
     * @returns [real: Float32Array, imaginary: Float32Array]
     */ _getRealImaginary(type, phase) {
        const fftSize = 4096;
        let periodicWaveSize = fftSize / 2;
        const real = new Float32Array(periodicWaveSize);
        const imag = new Float32Array(periodicWaveSize);
        let partialCount = 1;
        if (type === "custom") {
            partialCount = this._partials.length + 1;
            this._partialCount = this._partials.length;
            periodicWaveSize = partialCount;
            // if the partial count is 0, don't bother doing any computation
            if (this._partials.length === 0) return [
                real,
                imag
            ];
        } else {
            const partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(type);
            if (partial) {
                partialCount = parseInt(partial[2], 10) + 1;
                this._partialCount = parseInt(partial[2], 10);
                type = partial[1];
                partialCount = Math.max(partialCount, 2);
                periodicWaveSize = partialCount;
            } else this._partialCount = 0;
            this._partials = [];
        }
        for(let n = 1; n < periodicWaveSize; ++n){
            const piFactor = 2 / (n * Math.PI);
            let b;
            switch(type){
                case "sine":
                    b = n <= partialCount ? 1 : 0;
                    this._partials[n - 1] = b;
                    break;
                case "square":
                    b = n & 1 ? 2 * piFactor : 0;
                    this._partials[n - 1] = b;
                    break;
                case "sawtooth":
                    b = piFactor * (n & 1 ? 1 : -1);
                    this._partials[n - 1] = b;
                    break;
                case "triangle":
                    if (n & 1) b = 2 * (piFactor * piFactor) * (n - 1 >> 1 & 1 ? -1 : 1);
                    else b = 0;
                    this._partials[n - 1] = b;
                    break;
                case "custom":
                    b = this._partials[n - 1];
                    break;
                default:
                    throw new TypeError("Oscillator: invalid type: " + type);
            }
            if (b !== 0) {
                real[n] = -b * Math.sin(phase * n);
                imag[n] = b * Math.cos(phase * n);
            } else {
                real[n] = 0;
                imag[n] = 0;
            }
        }
        return [
            real,
            imag
        ];
    }
    /**
     * Compute the inverse FFT for a given phase.
     */ _inverseFFT(real, imag, phase) {
        let sum = 0;
        const len = real.length;
        for(let i = 0; i < len; i++)sum += real[i] * Math.cos(i * phase) + imag[i] * Math.sin(i * phase);
        return sum;
    }
    /**
     * Returns the initial value of the oscillator when stopped.
     * E.g. a "sine" oscillator with phase = 90 would return an initial value of -1.
     */ getInitialValue() {
        const [real, imag] = this._getRealImaginary(this._type, 0);
        let maxValue = 0;
        const twoPi = Math.PI * 2;
        const testPositions = 32;
        // check for peaks in 16 places
        for(let i = 0; i < testPositions; i++)maxValue = Math.max(this._inverseFFT(real, imag, i / testPositions * twoPi), maxValue);
        return (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(-this._inverseFFT(real, imag, this._phase) / maxValue, -1, 1);
    }
    get partials() {
        return this._partials.slice(0, this.partialCount);
    }
    set partials(partials) {
        this._partials = partials;
        this._partialCount = this._partials.length;
        if (partials.length) this.type = "custom";
    }
    get phase() {
        return this._phase * (180 / Math.PI);
    }
    set phase(phase) {
        this._phase = phase * Math.PI / 180;
        // reset the type
        this.type = this._type;
    }
    asArray(length = 1024) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    dispose() {
        super.dispose();
        if (this._oscillator !== null) this._oscillator.dispose();
        this._wave = undefined;
        this.frequency.dispose();
        this.detune.dispose();
        return this;
    }
}
/**
 * Cache the periodic waves to avoid having to redo computations
 */ $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache = [];









class $1c8b308fac67a067$export$5d271ddbaaaa6dbe extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($1c8b308fac67a067$export$5d271ddbaaaa6dbe.getDefaults(), arguments, [
            "context"
        ])));
    }
    connect(destination, outputNum = 0, inputNum = 0) {
        (0, $87a50297d6fa5f61$export$c8174dc07173cff0)(this, destination, outputNum, inputNum);
        return this;
    }
}







class $5bf337bc64bc83a6$export$4d933d013693e78 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5bf337bc64bc83a6$export$4d933d013693e78.getDefaults(), arguments, [
            "mapping",
            "length"
        ])));
        this.name = "WaveShaper";
        /**
         * the waveshaper node
         */ this._shaper = this.context.createWaveShaper();
        /**
         * The input to the waveshaper node.
         */ this.input = this._shaper;
        /**
         * The output from the waveshaper node
         */ this.output = this._shaper;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5bf337bc64bc83a6$export$4d933d013693e78.getDefaults(), arguments, [
            "mapping",
            "length"
        ]);
        if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(options.mapping) || options.mapping instanceof Float32Array) this.curve = Float32Array.from(options.mapping);
        else if ((0, $4d7f709c9ffa5105$export$f6e2535fb5126e54)(options.mapping)) this.setMap(options.mapping, options.length);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            length: 1024
        });
    }
    /**
     * Uses a mapping function to set the value of the curve.
     * @param mapping The function used to define the values.
     *                The mapping function take two arguments:
     *                the first is the value at the current position
     *                which goes from -1 to 1 over the number of elements
     *                in the curve array. The second argument is the array position.
     * @example
     * const shaper = new Tone.WaveShaper();
     * // map the input signal from [-1, 1] to [0, 10]
     * shaper.setMap((val, index) => (val + 1) * 5);
     */ setMap(mapping, length = 1024) {
        const array = new Float32Array(length);
        for(let i = 0, len = length; i < len; i++){
            const normalized = i / (len - 1) * 2 - 1;
            array[i] = mapping(normalized, i);
        }
        this.curve = array;
        return this;
    }
    /**
     * The array to set as the waveshaper curve. For linear curves
     * array length does not make much difference, but for complex curves
     * longer arrays will provide smoother interpolation.
     */ get curve() {
        return this._shaper.curve;
    }
    set curve(mapping) {
        this._shaper.curve = mapping;
    }
    /**
     * Specifies what type of oversampling (if any) should be used when
     * applying the shaping curve. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        const isOverSampleType = [
            "none",
            "2x",
            "4x"
        ].some((str)=>str.includes(oversampling));
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isOverSampleType, "oversampling must be either 'none', '2x', or '4x'");
        this._shaper.oversample = oversampling;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._shaper.disconnect();
        return this;
    }
}


class $69552eca520acf8e$export$2e6ea0941c39f845 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(...arguments);
        this.name = "AudioToGain";
        /**
         * The node which converts the audio ranges
         */ this._norm = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: (x)=>(x + 1) / 2
        });
        /**
         * The AudioRange input [-1, 1]
         */ this.input = this._norm;
        /**
         * The GainRange output [0, 1]
         */ this.output = this._norm;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._norm.dispose();
        return this;
    }
}





class $3f90bb22f26a3ab2$export$f14f83b3b531d498 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3f90bb22f26a3ab2$export$f14f83b3b531d498.getDefaults(), arguments, [
            "value"
        ])));
        this.name = "Multiply";
        /**
         * Indicates if the value should be overridden on connection
         */ this.override = false;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3f90bb22f26a3ab2$export$f14f83b3b531d498.getDefaults(), arguments, [
            "value"
        ]);
        this._mult = this.input = this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        this.factor = this._param = this._mult.gain;
        this.factor.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._mult.dispose();
        return this;
    }
}





class $81277ef08515f70b$export$782fe1d3ba34f8d6 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($81277ef08515f70b$export$782fe1d3ba34f8d6.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]));
        this.name = "AMOscillator";
        /**
         * convert the -1,1 output to 0,1
         */ this._modulationScale = new (0, $69552eca520acf8e$export$2e6ea0941c39f845)({
            context: this.context
        });
        /**
         * the node where the modulation happens
         */ this._modulationNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($81277ef08515f70b$export$782fe1d3ba34f8d6.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]);
        this._carrier = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: options.type
        });
        this.frequency = this._carrier.frequency, this.detune = this._carrier.detune;
        this._modulator = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            phase: options.phase,
            type: options.modulationType
        });
        this.harmonicity = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        // connections
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this._modulator.chain(this._modulationScale, this._modulationNode.gain);
        this._carrier.chain(this._modulationNode, this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "detune",
            "harmonicity"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), {
            harmonicity: 1,
            modulationType: "square"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._modulator.start(time);
        this._carrier.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        this._modulator.stop(time);
        this._carrier.stop(time);
    }
    _restart(time) {
        this._modulator.restart(time);
        this._carrier.restart(time);
    }
    /**
     * The type of the carrier oscillator
     */ get type() {
        return this._carrier.type;
    }
    set type(type) {
        this._carrier.type = type;
    }
    get baseType() {
        return this._carrier.baseType;
    }
    set baseType(baseType) {
        this._carrier.baseType = baseType;
    }
    get partialCount() {
        return this._carrier.partialCount;
    }
    set partialCount(partialCount) {
        this._carrier.partialCount = partialCount;
    }
    /**
     * The type of the modulator oscillator
     */ get modulationType() {
        return this._modulator.type;
    }
    set modulationType(type) {
        this._modulator.type = type;
    }
    get phase() {
        return this._carrier.phase;
    }
    set phase(phase) {
        this._carrier.phase = phase;
        this._modulator.phase = phase;
    }
    get partials() {
        return this._carrier.partials;
    }
    set partials(partials) {
        this._carrier.partials = partials;
    }
    asArray(length = 1024) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this.harmonicity.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this._modulationNode.dispose();
        this._modulationScale.dispose();
        return this;
    }
}











class $87e8e716b583ad3c$export$3055866937a7451d extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($87e8e716b583ad3c$export$3055866937a7451d.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]));
        this.name = "FMOscillator";
        /**
         * the node where the modulation happens
         */ this._modulationNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($87e8e716b583ad3c$export$3055866937a7451d.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]);
        this._carrier = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            detune: options.detune,
            frequency: 0,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: options.type
        });
        this.detune = this._carrier.detune;
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this._modulator = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            phase: options.phase,
            type: options.modulationType
        });
        this.harmonicity = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        this.modulationIndex = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            units: "positive",
            value: options.modulationIndex
        });
        // connections
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.frequency.chain(this.modulationIndex, this._modulationNode);
        this._modulator.connect(this._modulationNode.gain);
        this._modulationNode.connect(this._carrier.frequency);
        this._carrier.connect(this.output);
        this.detune.connect(this._modulator.detune);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "modulationIndex",
            "frequency",
            "detune",
            "harmonicity"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), {
            harmonicity: 1,
            modulationIndex: 2,
            modulationType: "square"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._modulator.start(time);
        this._carrier.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        this._modulator.stop(time);
        this._carrier.stop(time);
    }
    _restart(time) {
        this._modulator.restart(time);
        this._carrier.restart(time);
        return this;
    }
    get type() {
        return this._carrier.type;
    }
    set type(type) {
        this._carrier.type = type;
    }
    get baseType() {
        return this._carrier.baseType;
    }
    set baseType(baseType) {
        this._carrier.baseType = baseType;
    }
    get partialCount() {
        return this._carrier.partialCount;
    }
    set partialCount(partialCount) {
        this._carrier.partialCount = partialCount;
    }
    /**
     * The type of the modulator oscillator
     */ get modulationType() {
        return this._modulator.type;
    }
    set modulationType(type) {
        this._modulator.type = type;
    }
    get phase() {
        return this._carrier.phase;
    }
    set phase(phase) {
        this._carrier.phase = phase;
        this._modulator.phase = phase;
    }
    get partials() {
        return this._carrier.partials;
    }
    set partials(partials) {
        this._carrier.partials = partials;
    }
    asArray(length = 1024) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.harmonicity.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this._modulationNode.dispose();
        this.modulationIndex.dispose();
        return this;
    }
}











class $fb1e1e5a6691f5f9$export$f134e81916b1e032 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($fb1e1e5a6691f5f9$export$f134e81916b1e032.getDefaults(), arguments, [
            "frequency",
            "width"
        ]));
        this.name = "PulseOscillator";
        /**
         * gate the width amount
         */ this._widthGate = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        /**
         * Threshold the signal to turn it into a square
         */ this._thresh = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: (val)=>val <= 0 ? -1 : 1
        });
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($fb1e1e5a6691f5f9$export$f134e81916b1e032.getDefaults(), arguments, [
            "frequency",
            "width"
        ]);
        this.width = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "audioRange",
            value: options.width
        });
        this._triangle = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: "triangle"
        });
        this.frequency = this._triangle.frequency;
        this.detune = this._triangle.detune;
        // connections
        this._triangle.chain(this._thresh, this.output);
        this.width.chain(this._widthGate, this._thresh);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "width",
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            detune: 0,
            frequency: 440,
            phase: 0,
            type: "pulse",
            width: 0.2
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._triangle.start(time);
        this._widthGate.gain.setValueAtTime(1, time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._triangle.stop(time);
        // the width is still connected to the output.
        // that needs to be stopped also
        this._widthGate.gain.cancelScheduledValues(time);
        this._widthGate.gain.setValueAtTime(0, time);
    }
    _restart(time) {
        this._triangle.restart(time);
        this._widthGate.gain.cancelScheduledValues(time);
        this._widthGate.gain.setValueAtTime(1, time);
    }
    /**
     * The phase of the oscillator in degrees.
     */ get phase() {
        return this._triangle.phase;
    }
    set phase(phase) {
        this._triangle.phase = phase;
    }
    /**
     * The type of the oscillator. Always returns "pulse".
     */ get type() {
        return "pulse";
    }
    /**
     * The baseType of the oscillator. Always returns "pulse".
     */ get baseType() {
        return "pulse";
    }
    /**
     * The partials of the waveform. Cannot set partials for this waveform type
     */ get partials() {
        return [];
    }
    /**
     * No partials for this waveform type.
     */ get partialCount() {
        return 0;
    }
    /**
     * *Internal use* The carrier oscillator type is fed through the
     * waveshaper node to create the pulse. Using different carrier oscillators
     * changes oscillator's behavior.
     */ set carrierType(type) {
        this._triangle.type = type;
    }
    asArray(length = 1024) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up method.
     */ dispose() {
        super.dispose();
        this._triangle.dispose();
        this.width.dispose();
        this._widthGate.dispose();
        this._thresh.dispose();
        return this;
    }
}










class $3736813a08473376$export$a7d0bd116bda6b00 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3736813a08473376$export$a7d0bd116bda6b00.getDefaults(), arguments, [
            "frequency",
            "type",
            "spread"
        ]));
        this.name = "FatOscillator";
        /**
         * The array of oscillators
         */ this._oscillators = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3736813a08473376$export$a7d0bd116bda6b00.getDefaults(), arguments, [
            "frequency",
            "type",
            "spread"
        ]);
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this._spread = options.spread;
        this._type = options.type;
        this._phase = options.phase;
        this._partials = options.partials;
        this._partialCount = options.partialCount;
        // set the count initially
        this.count = options.count;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), {
            count: 3,
            spread: 20,
            type: "sawtooth"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._forEach((osc)=>osc.start(time));
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._forEach((osc)=>osc.stop(time));
    }
    _restart(time) {
        this._forEach((osc)=>osc.restart(time));
    }
    /**
     * Iterate over all of the oscillators
     */ _forEach(iterator) {
        for(let i = 0; i < this._oscillators.length; i++)iterator(this._oscillators[i], i);
    }
    /**
     * The type of the oscillator
     */ get type() {
        return this._type;
    }
    set type(type) {
        this._type = type;
        this._forEach((osc)=>osc.type = type);
    }
    /**
     * The detune spread between the oscillators. If "count" is
     * set to 3 oscillators and the "spread" is set to 40,
     * the three oscillators would be detuned like this: [-20, 0, 20]
     * for a total detune spread of 40 cents.
     * @example
     * const fatOsc = new Tone.FatOscillator().toDestination().start();
     * fatOsc.spread = 70;
     */ get spread() {
        return this._spread;
    }
    set spread(spread) {
        this._spread = spread;
        if (this._oscillators.length > 1) {
            const start = -spread / 2;
            const step = spread / (this._oscillators.length - 1);
            this._forEach((osc, i)=>osc.detune.value = start + step * i);
        }
    }
    /**
     * The number of detuned oscillators. Must be an integer greater than 1.
     * @example
     * const fatOsc = new Tone.FatOscillator("C#3", "sawtooth").toDestination().start();
     * // use 4 sawtooth oscillators
     * fatOsc.count = 4;
     */ get count() {
        return this._oscillators.length;
    }
    set count(count) {
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(count, 1);
        if (this._oscillators.length !== count) {
            // dispose the previous oscillators
            this._forEach((osc)=>osc.dispose());
            this._oscillators = [];
            for(let i = 0; i < count; i++){
                const osc = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
                    context: this.context,
                    volume: -6 - count * 1.1,
                    type: this._type,
                    phase: this._phase + i / count * 360,
                    partialCount: this._partialCount,
                    onstop: i === 0 ? ()=>this.onstop(this) : (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)
                });
                if (this.type === "custom") osc.partials = this._partials;
                this.frequency.connect(osc.frequency);
                this.detune.connect(osc.detune);
                osc.detune.overridden = false;
                osc.connect(this.output);
                this._oscillators[i] = osc;
            }
            // set the spread
            this.spread = this._spread;
            if (this.state === "started") this._forEach((osc)=>osc.start());
        }
    }
    get phase() {
        return this._phase;
    }
    set phase(phase) {
        this._phase = phase;
        this._forEach((osc, i)=>osc.phase = this._phase + i / this.count * 360);
    }
    get baseType() {
        return this._oscillators[0].baseType;
    }
    set baseType(baseType) {
        this._forEach((osc)=>osc.baseType = baseType);
        this._type = this._oscillators[0].type;
    }
    get partials() {
        return this._oscillators[0].partials;
    }
    set partials(partials) {
        this._partials = partials;
        this._partialCount = this._partials.length;
        if (partials.length) {
            this._type = "custom";
            this._forEach((osc)=>osc.partials = partials);
        }
    }
    get partialCount() {
        return this._oscillators[0].partialCount;
    }
    set partialCount(partialCount) {
        this._partialCount = partialCount;
        this._forEach((osc)=>osc.partialCount = partialCount);
        this._type = this._oscillators[0].type;
    }
    asArray(length = 1024) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this._forEach((osc)=>osc.dispose());
        return this;
    }
}










class $2ecfafda5b1bef2d$export$baa28c9ecd0db52 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2ecfafda5b1bef2d$export$baa28c9ecd0db52.getDefaults(), arguments, [
            "frequency",
            "modulationFrequency"
        ]));
        this.name = "PWMOscillator";
        this.sourceType = "pwm";
        /**
         * Scale the oscillator so it doesn't go silent
         * at the extreme values.
         */ this._scale = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: 2
        });
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2ecfafda5b1bef2d$export$baa28c9ecd0db52.getDefaults(), arguments, [
            "frequency",
            "modulationFrequency"
        ]);
        this._pulse = new (0, $fb1e1e5a6691f5f9$export$f134e81916b1e032)({
            context: this.context,
            frequency: options.modulationFrequency
        });
        // change the pulse oscillator type
        this._pulse.carrierType = "sine";
        this.modulationFrequency = this._pulse.frequency;
        this._modulator = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase
        });
        this.frequency = this._modulator.frequency;
        this.detune = this._modulator.detune;
        // connections
        this._modulator.chain(this._scale, this._pulse.width);
        this._pulse.connect(this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "modulationFrequency",
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            detune: 0,
            frequency: 440,
            modulationFrequency: 0.4,
            phase: 0,
            type: "pwm"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._modulator.start(time);
        this._pulse.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._modulator.stop(time);
        this._pulse.stop(time);
    }
    /**
     * restart the oscillator
     */ _restart(time) {
        this._modulator.restart(time);
        this._pulse.restart(time);
    }
    /**
     * The type of the oscillator. Always returns "pwm".
     */ get type() {
        return "pwm";
    }
    /**
     * The baseType of the oscillator. Always returns "pwm".
     */ get baseType() {
        return "pwm";
    }
    /**
     * The partials of the waveform. Cannot set partials for this waveform type
     */ get partials() {
        return [];
    }
    /**
     * No partials for this waveform type.
     */ get partialCount() {
        return 0;
    }
    /**
     * The phase of the oscillator in degrees.
     */ get phase() {
        return this._modulator.phase;
    }
    set phase(phase) {
        this._modulator.phase = phase;
    }
    asArray(length = 1024) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._pulse.dispose();
        this._scale.dispose();
        this._modulator.dispose();
        return this;
    }
}















const $7fd076cd12a174f2$var$OmniOscillatorSourceMap = {
    am: (0, $81277ef08515f70b$export$782fe1d3ba34f8d6),
    fat: (0, $3736813a08473376$export$a7d0bd116bda6b00),
    fm: (0, $87e8e716b583ad3c$export$3055866937a7451d),
    oscillator: (0, $304d61465298e719$export$c01c5c7b81696d70),
    pulse: (0, $fb1e1e5a6691f5f9$export$f134e81916b1e032),
    pwm: (0, $2ecfafda5b1bef2d$export$baa28c9ecd0db52)
};
class $7fd076cd12a174f2$export$46c9f562e6d6ca6d extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7fd076cd12a174f2$export$46c9f562e6d6ca6d.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "OmniOscillator";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7fd076cd12a174f2$export$46c9f562e6d6ca6d.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "detune"
        ]);
        // set the options
        this.set(options);
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), (0, $87e8e716b583ad3c$export$3055866937a7451d).getDefaults(), (0, $81277ef08515f70b$export$782fe1d3ba34f8d6).getDefaults(), (0, $3736813a08473376$export$a7d0bd116bda6b00).getDefaults(), (0, $fb1e1e5a6691f5f9$export$f134e81916b1e032).getDefaults(), (0, $2ecfafda5b1bef2d$export$baa28c9ecd0db52).getDefaults());
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._oscillator.start(time);
    }
    /**
     * start the oscillator
     */ _stop(time) {
        this._oscillator.stop(time);
    }
    _restart(time) {
        this._oscillator.restart(time);
        return this;
    }
    /**
     * The type of the oscillator. Can be any of the basic types: sine, square, triangle, sawtooth. Or
     * prefix the basic types with "fm", "am", or "fat" to use the FMOscillator, AMOscillator or FatOscillator
     * types. The oscillator could also be set to "pwm" or "pulse". All of the parameters of the
     * oscillator's class are accessible when the oscillator is set to that type, but throws an error
     * when it's not.
     * @example
     * const omniOsc = new Tone.OmniOscillator().toDestination().start();
     * omniOsc.type = "pwm";
     * // modulationFrequency is parameter which is available
     * // only when the type is "pwm".
     * omniOsc.modulationFrequency.value = 0.5;
     */ get type() {
        let prefix = "";
        if ([
            "am",
            "fm",
            "fat"
        ].some((p)=>this._sourceType === p)) prefix = this._sourceType;
        return prefix + this._oscillator.type;
    }
    set type(type) {
        if (type.substr(0, 2) === "fm") {
            this._createNewOscillator("fm");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(2);
        } else if (type.substr(0, 2) === "am") {
            this._createNewOscillator("am");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(2);
        } else if (type.substr(0, 3) === "fat") {
            this._createNewOscillator("fat");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(3);
        } else if (type === "pwm") {
            this._createNewOscillator("pwm");
            this._oscillator = this._oscillator;
        } else if (type === "pulse") this._createNewOscillator("pulse");
        else {
            this._createNewOscillator("oscillator");
            this._oscillator = this._oscillator;
            this._oscillator.type = type;
        }
    }
    /**
     * The value is an empty array when the type is not "custom".
     * This is not available on "pwm" and "pulse" oscillator types.
     * See [[Oscillator.partials]]
     */ get partials() {
        return this._oscillator.partials;
    }
    set partials(partials) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm")) this._oscillator.partials = partials;
    }
    get partialCount() {
        return this._oscillator.partialCount;
    }
    set partialCount(partialCount) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm")) this._oscillator.partialCount = partialCount;
    }
    set(props) {
        // make sure the type is set first
        if (Reflect.has(props, "type") && props.type) this.type = props.type;
        // then set the rest
        super.set(props);
        return this;
    }
    /**
     * connect the oscillator to the frequency and detune signals
     */ _createNewOscillator(oscType) {
        if (oscType !== this._sourceType) {
            this._sourceType = oscType;
            const OscConstructor = $7fd076cd12a174f2$var$OmniOscillatorSourceMap[oscType];
            // short delay to avoid clicks on the change
            const now = this.now();
            if (this._oscillator) {
                const oldOsc = this._oscillator;
                oldOsc.stop(now);
                // dispose the old one
                this.context.setTimeout(()=>oldOsc.dispose(), this.blockTime);
            }
            this._oscillator = new OscConstructor({
                context: this.context
            });
            this.frequency.connect(this._oscillator.frequency);
            this.detune.connect(this._oscillator.detune);
            this._oscillator.connect(this.output);
            this._oscillator.onstop = ()=>this.onstop(this);
            if (this.state === "started") this._oscillator.start(now);
        }
    }
    get phase() {
        return this._oscillator.phase;
    }
    set phase(phase) {
        this._oscillator.phase = phase;
    }
    /**
     * The source type of the oscillator.
     * @example
     * const omniOsc = new Tone.OmniOscillator(440, "fmsquare");
     * console.log(omniOsc.sourceType); // 'fm'
     */ get sourceType() {
        return this._sourceType;
    }
    set sourceType(sType) {
        // the basetype defaults to sine
        let baseType = "sine";
        if (this._oscillator.type !== "pwm" && this._oscillator.type !== "pulse") baseType = this._oscillator.type;
        // set the type
        if (sType === "fm") this.type = "fm" + baseType;
        else if (sType === "am") this.type = "am" + baseType;
        else if (sType === "fat") this.type = "fat" + baseType;
        else if (sType === "oscillator") this.type = baseType;
        else if (sType === "pulse") this.type = "pulse";
        else if (sType === "pwm") this.type = "pwm";
    }
    _getOscType(osc, sourceType) {
        return osc instanceof $7fd076cd12a174f2$var$OmniOscillatorSourceMap[sourceType];
    }
    /**
     * The base type of the oscillator. See [[Oscillator.baseType]]
     * @example
     * const omniOsc = new Tone.OmniOscillator(440, "fmsquare4");
     * console.log(omniOsc.sourceType, omniOsc.baseType, omniOsc.partialCount);
     */ get baseType() {
        return this._oscillator.baseType;
    }
    set baseType(baseType) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm") && baseType !== "pulse" && baseType !== "pwm") this._oscillator.baseType = baseType;
    }
    /**
     * The width of the oscillator when sourceType === "pulse".
     * See [[PWMOscillator.width]]
     */ get width() {
        if (this._getOscType(this._oscillator, "pulse")) return this._oscillator.width;
        else return undefined;
    }
    /**
     * The number of detuned oscillators when sourceType === "fat".
     * See [[FatOscillator.count]]
     */ get count() {
        if (this._getOscType(this._oscillator, "fat")) return this._oscillator.count;
        else return undefined;
    }
    set count(count) {
        if (this._getOscType(this._oscillator, "fat") && (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(count)) this._oscillator.count = count;
    }
    /**
     * The detune spread between the oscillators when sourceType === "fat".
     * See [[FatOscillator.count]]
     */ get spread() {
        if (this._getOscType(this._oscillator, "fat")) return this._oscillator.spread;
        else return undefined;
    }
    set spread(spread) {
        if (this._getOscType(this._oscillator, "fat") && (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(spread)) this._oscillator.spread = spread;
    }
    /**
     * The type of the modulator oscillator. Only if the oscillator is set to "am" or "fm" types.
     * See [[AMOscillator]] or [[FMOscillator]]
     */ get modulationType() {
        if (this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) return this._oscillator.modulationType;
        else return undefined;
    }
    set modulationType(mType) {
        if ((this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) && (0, $4d7f709c9ffa5105$export$844ec244b1367d54)(mType)) this._oscillator.modulationType = mType;
    }
    /**
     * The modulation index when the sourceType === "fm"
     * See [[FMOscillator]].
     */ get modulationIndex() {
        if (this._getOscType(this._oscillator, "fm")) return this._oscillator.modulationIndex;
        else return undefined;
    }
    /**
     * Harmonicity is the frequency ratio between the carrier and the modulator oscillators.
     * See [[AMOscillator]] or [[FMOscillator]]
     */ get harmonicity() {
        if (this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) return this._oscillator.harmonicity;
        else return undefined;
    }
    /**
     * The modulationFrequency Signal of the oscillator when sourceType === "pwm"
     * see [[PWMOscillator]]
     * @min 0.1
     * @max 5
     */ get modulationFrequency() {
        if (this._getOscType(this._oscillator, "pwm")) return this._oscillator.modulationFrequency;
        else return undefined;
    }
    asArray(length = 1024) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    dispose() {
        super.dispose();
        this.detune.dispose();
        this.frequency.dispose();
        this._oscillator.dispose();
        return this;
    }
}














class $ad8862926b54eb7c$export$d0265b2c425512d6 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($ad8862926b54eb7c$export$d0265b2c425512d6.getDefaults(), arguments, [
            "value"
        ])));
        this.override = false;
        this.name = "Add";
        /**
         * the summing node
         */ this._sum = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.input = this._sum;
        this.output = this._sum;
        /**
         * The value which is added to the input signal
         */ this.addend = this._param;
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this._constantSource, this._sum);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._sum.dispose();
        return this;
    }
}




class $d4646d969ab22afc$export$d60cfc58d3c358b6 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($d4646d969ab22afc$export$d60cfc58d3c358b6.getDefaults(), arguments, [
            "min",
            "max"
        ])));
        this.name = "Scale";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($d4646d969ab22afc$export$d60cfc58d3c358b6.getDefaults(), arguments, [
            "min",
            "max"
        ]);
        this._mult = this.input = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: options.max - options.min
        });
        this._add = this.output = new (0, $ad8862926b54eb7c$export$d0265b2c425512d6)({
            context: this.context,
            value: options.min
        });
        this._min = options.min;
        this._max = options.max;
        this.input.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe).getDefaults(), {
            max: 1,
            min: 0
        });
    }
    /**
     * The minimum output value. This number is output when the value input value is 0.
     */ get min() {
        return this._min;
    }
    set min(min) {
        this._min = min;
        this._setRange();
    }
    /**
     * The maximum output value. This number is output when the value input value is 1.
     */ get max() {
        return this._max;
    }
    set max(max) {
        this._max = max;
        this._setRange();
    }
    /**
     * set the values
     */ _setRange() {
        this._add.value = this._min;
        this._mult.value = this._max - this._min;
    }
    dispose() {
        super.dispose();
        this._add.dispose();
        this._mult.dispose();
        return this;
    }
}







class $88073d0d401dc0e5$export$aaef8a3eae948f03 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($88073d0d401dc0e5$export$aaef8a3eae948f03.getDefaults(), arguments)));
        this.name = "Zero";
        /**
         * The gain node which connects the constant source to the output
         */ this._gain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * Only outputs 0
         */ this.output = this._gain;
        /**
         * no input node
         */ this.input = undefined;
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this.context.getConstant(0), this._gain);
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        (0, $1dae52eee8c779dd$export$37dfea93db2e14ed)(this.context.getConstant(0), this._gain);
        return this;
    }
}



class $e29fd7f03d7e26e3$export$603054d5ec296d77 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e29fd7f03d7e26e3$export$603054d5ec296d77.getDefaults(), arguments, [
            "frequency",
            "min",
            "max"
        ]));
        this.name = "LFO";
        /**
         * The value that the LFO outputs when it's stopped
         */ this._stoppedValue = 0;
        /**
         * A private placeholder for the units
         */ this._units = "number";
        /**
         * If the input value is converted using the [[units]]
         */ this.convert = true;
        /**
         * Private methods borrowed from Param
         */ // @ts-ignore
        this._fromType = (0, $4e42d28fbc344697$export$1ca45c9a47aec42c).prototype._fromType;
        // @ts-ignore
        this._toType = (0, $4e42d28fbc344697$export$1ca45c9a47aec42c).prototype._toType;
        // @ts-ignore
        this._is = (0, $4e42d28fbc344697$export$1ca45c9a47aec42c).prototype._is;
        // @ts-ignore
        this._clampValue = (0, $4e42d28fbc344697$export$1ca45c9a47aec42c).prototype._clampValue;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e29fd7f03d7e26e3$export$603054d5ec296d77.getDefaults(), arguments, [
            "frequency",
            "min",
            "max"
        ]);
        this._oscillator = new (0, $304d61465298e719$export$c01c5c7b81696d70)(options);
        this.frequency = this._oscillator.frequency;
        this._amplitudeGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.amplitude,
            units: "normalRange"
        });
        this.amplitude = this._amplitudeGain.gain;
        this._stoppedSignal = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "audioRange",
            value: 0
        });
        this._zeros = new (0, $88073d0d401dc0e5$export$aaef8a3eae948f03)({
            context: this.context
        });
        this._a2g = new (0, $69552eca520acf8e$export$2e6ea0941c39f845)({
            context: this.context
        });
        this._scaler = this.output = new (0, $d4646d969ab22afc$export$d60cfc58d3c358b6)({
            context: this.context,
            max: options.max,
            min: options.min
        });
        this.units = options.units;
        this.min = options.min;
        this.max = options.max;
        // connect it up
        this._oscillator.chain(this._amplitudeGain, this._a2g, this._scaler);
        this._zeros.connect(this._a2g);
        this._stoppedSignal.connect(this._a2g);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "amplitude",
            "frequency"
        ]);
        this.phase = options.phase;
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), {
            amplitude: 1,
            frequency: "4n",
            max: 1,
            min: 0,
            type: "sine",
            units: "number"
        });
    }
    /**
     * Start the LFO.
     * @param time The time the LFO will start
     */ start(time) {
        time = this.toSeconds(time);
        this._stoppedSignal.setValueAtTime(0, time);
        this._oscillator.start(time);
        return this;
    }
    /**
     * Stop the LFO.
     * @param  time The time the LFO will stop
     */ stop(time) {
        time = this.toSeconds(time);
        this._stoppedSignal.setValueAtTime(this._stoppedValue, time);
        this._oscillator.stop(time);
        return this;
    }
    /**
     * Sync the start/stop/pause to the transport
     * and the frequency to the bpm of the transport
     * @example
     * const lfo = new Tone.LFO("8n");
     * lfo.sync().start(0);
     * // the rate of the LFO will always be an eighth note, even as the tempo changes
     */ sync() {
        this._oscillator.sync();
        this._oscillator.syncFrequency();
        return this;
    }
    /**
     * unsync the LFO from transport control
     */ unsync() {
        this._oscillator.unsync();
        this._oscillator.unsyncFrequency();
        return this;
    }
    /**
     * After the oscillator waveform is updated, reset the `_stoppedSignal` value to match the updated waveform
     */ _setStoppedValue() {
        this._stoppedValue = this._oscillator.getInitialValue();
        this._stoppedSignal.value = this._stoppedValue;
    }
    /**
     * The minimum output of the LFO.
     */ get min() {
        return this._toType(this._scaler.min);
    }
    set min(min) {
        min = this._fromType(min);
        this._scaler.min = min;
    }
    /**
     * The maximum output of the LFO.
     */ get max() {
        return this._toType(this._scaler.max);
    }
    set max(max) {
        max = this._fromType(max);
        this._scaler.max = max;
    }
    /**
     * The type of the oscillator: See [[Oscillator.type]]
     */ get type() {
        return this._oscillator.type;
    }
    set type(type) {
        this._oscillator.type = type;
        this._setStoppedValue();
    }
    /**
     * The oscillator's partials array: See [[Oscillator.partials]]
     */ get partials() {
        return this._oscillator.partials;
    }
    set partials(partials) {
        this._oscillator.partials = partials;
        this._setStoppedValue();
    }
    /**
     * The phase of the LFO.
     */ get phase() {
        return this._oscillator.phase;
    }
    set phase(phase) {
        this._oscillator.phase = phase;
        this._setStoppedValue();
    }
    /**
     * The output units of the LFO.
     */ get units() {
        return this._units;
    }
    set units(val) {
        const currentMin = this.min;
        const currentMax = this.max;
        // convert the min and the max
        this._units = val;
        this.min = currentMin;
        this.max = currentMax;
    }
    /**
     * Returns the playback state of the source, either "started" or "stopped".
     */ get state() {
        return this._oscillator.state;
    }
    /**
     * @param node the destination to connect to
     * @param outputNum the optional output number
     * @param inputNum the input number
     */ connect(node, outputNum, inputNum) {
        if (node instanceof (0, $4e42d28fbc344697$export$1ca45c9a47aec42c) || node instanceof (0, $87a50297d6fa5f61$export$8210dfe1863c478)) {
            this.convert = node.convert;
            this.units = node.units;
        }
        (0, $87a50297d6fa5f61$export$c8174dc07173cff0)(this, node, outputNum, inputNum);
        return this;
    }
    dispose() {
        super.dispose();
        this._oscillator.dispose();
        this._stoppedSignal.dispose();
        this._zeros.dispose();
        this._scaler.dispose();
        this._a2g.dispose();
        this._amplitudeGain.dispose();
        this.amplitude.dispose();
        return this;
    }
}












function $56353399eaf2b0ec$export$d02631cccf789723(min, max = Infinity) {
    const valueMap = new WeakMap();
    return function(target, propertyKey) {
        Reflect.defineProperty(target, propertyKey, {
            configurable: true,
            enumerable: true,
            get: function() {
                return valueMap.get(this);
            },
            set: function(newValue) {
                (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(newValue, min, max);
                valueMap.set(this, newValue);
            }
        });
    };
}
function $56353399eaf2b0ec$export$4748a2e3a6d34ca5(min, max = Infinity) {
    const valueMap = new WeakMap();
    return function(target, propertyKey) {
        Reflect.defineProperty(target, propertyKey, {
            configurable: true,
            enumerable: true,
            get: function() {
                return valueMap.get(this);
            },
            set: function(newValue) {
                (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(newValue), min, max);
                valueMap.set(this, newValue);
            }
        });
    };
}


class $44209288688a0328$export$2616165974278734 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($44209288688a0328$export$2616165974278734.getDefaults(), arguments, [
            "url",
            "onload"
        ]));
        this.name = "Player";
        /**
         * All of the active buffer source nodes
         */ this._activeSources = new Set();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($44209288688a0328$export$2616165974278734.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        this._buffer = new (0, $43da6dea502b5fe8$export$424a335715b38178)({
            onload: this._onload.bind(this, options.onload),
            onerror: options.onerror,
            reverse: options.reverse,
            url: options.url
        });
        this.autostart = options.autostart;
        this._loop = options.loop;
        this._loopStart = options.loopStart;
        this._loopEnd = options.loopEnd;
        this._playbackRate = options.playbackRate;
        this.fadeIn = options.fadeIn;
        this.fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            autostart: false,
            fadeIn: 0,
            fadeOut: 0,
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            playbackRate: 1,
            reverse: false
        });
    }
    /**
     * Load the audio file as an audio buffer.
     * Decodes the audio asynchronously and invokes
     * the callback once the audio buffer loads.
     * Note: this does not need to be called if a url
     * was passed in to the constructor. Only use this
     * if you want to manually load a new url.
     * @param url The url of the buffer to load. Filetype support depends on the browser.
     */ load(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            yield this._buffer.load(url);
            this._onload();
            return this;
        });
    }
    /**
     * Internal callback when the buffer is loaded.
     */ _onload(callback = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)) {
        callback();
        if (this.autostart) this.start();
    }
    /**
     * Internal callback when the buffer is done playing.
     */ _onSourceEnd(source) {
        // invoke the onstop function
        this.onstop(this);
        // delete the source from the active sources
        this._activeSources.delete(source);
        if (this._activeSources.size === 0 && !this._synced && this._state.getValueAtTime(this.now()) === "started") {
            // remove the 'implicitEnd' event and replace with an explicit end
            this._state.cancel(this.now());
            this._state.setStateAtTime("stopped", this.now());
        }
    }
    /**
     * Play the buffer at the given startTime. Optionally add an offset
     * and/or duration which will play the buffer from a position
     * within the buffer for the given duration.
     *
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given, it will default to the full length of the sample (minus any offset)
     */ start(time, offset, duration) {
        super.start(time, offset, duration);
        return this;
    }
    /**
     * Internal start method
     */ _start(startTime, offset, duration) {
        // if it's a loop the default offset is the loopStart point
        if (this._loop) offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, this._loopStart);
        else // otherwise the default offset is 0
        offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0);
        // compute the values in seconds
        const computedOffset = this.toSeconds(offset);
        // compute the duration which is either the passed in duration of the buffer.duration - offset
        const origDuration = duration;
        duration = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(duration, Math.max(this._buffer.duration - computedOffset, 0));
        let computedDuration = this.toSeconds(duration);
        // scale it by the playback rate
        computedDuration = computedDuration / this._playbackRate;
        // get the start time
        startTime = this.toSeconds(startTime);
        // make the source
        const source = new (0, $faf7c8e078303879$export$30cbf4ba14db4fdd)({
            url: this._buffer,
            context: this.context,
            fadeIn: this.fadeIn,
            fadeOut: this.fadeOut,
            loop: this._loop,
            loopEnd: this._loopEnd,
            loopStart: this._loopStart,
            onended: this._onSourceEnd.bind(this),
            playbackRate: this._playbackRate
        }).connect(this.output);
        // set the looping properties
        if (!this._loop && !this._synced) {
            // cancel the previous stop
            this._state.cancel(startTime + computedDuration);
            // if it's not looping, set the state change at the end of the sample
            this._state.setStateAtTime("stopped", startTime + computedDuration, {
                implicitEnd: true
            });
        }
        // add it to the array of active sources
        this._activeSources.add(source);
        // start it
        if (this._loop && (0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(origDuration)) source.start(startTime, computedOffset);
        else // subtract the fade out time
        source.start(startTime, computedOffset, computedDuration - this.toSeconds(this.fadeOut));
    }
    /**
     * Stop playback.
     */ _stop(time) {
        const computedTime = this.toSeconds(time);
        this._activeSources.forEach((source)=>source.stop(computedTime));
    }
    /**
     * Stop and then restart the player from the beginning (or offset)
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given,
     * 					it will default to the full length of the sample (minus any offset)
     */ restart(time, offset, duration) {
        super.restart(time, offset, duration);
        return this;
    }
    _restart(time, offset, duration) {
        this._stop(time);
        this._start(time, offset, duration);
    }
    /**
     * Seek to a specific time in the player's buffer. If the
     * source is no longer playing at that time, it will stop.
     * @param offset The time to seek to.
     * @param when The time for the seek event to occur.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/gurgling_theremin_1.mp3", () => {
     * 	player.start();
     * 	// seek to the offset in 1 second from now
     * 	player.seek(0.4, "+1");
     * }).toDestination();
     */ seek(offset, when) {
        const computedTime = this.toSeconds(when);
        if (this._state.getValueAtTime(computedTime) === "started") {
            const computedOffset = this.toSeconds(offset);
            // if it's currently playing, stop it
            this._stop(computedTime);
            // restart it at the given time
            this._start(computedTime, computedOffset);
        }
        return this;
    }
    /**
     * Set the loop start and end. Will only loop if loop is set to true.
     * @param loopStart The loop start time
     * @param loopEnd The loop end time
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/malevoices_aa2_F3.mp3").toDestination();
     * // loop between the given points
     * player.setLoopPoints(0.2, 0.3);
     * player.loop = true;
     * player.autostart = true;
     */ setLoopPoints(loopStart, loopEnd) {
        this.loopStart = loopStart;
        this.loopEnd = loopEnd;
        return this;
    }
    /**
     * If loop is true, the loop will start at this position.
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(loopStart) {
        this._loopStart = loopStart;
        if (this.buffer.loaded) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(loopStart), 0, this.buffer.duration);
        // get the current source
        this._activeSources.forEach((source)=>{
            source.loopStart = loopStart;
        });
    }
    /**
     * If loop is true, the loop will end at this position.
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(loopEnd) {
        this._loopEnd = loopEnd;
        if (this.buffer.loaded) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(loopEnd), 0, this.buffer.duration);
        // get the current source
        this._activeSources.forEach((source)=>{
            source.loopEnd = loopEnd;
        });
    }
    /**
     * The audio buffer belonging to the player.
     */ get buffer() {
        return this._buffer;
    }
    set buffer(buffer) {
        this._buffer.set(buffer);
    }
    /**
     * If the buffer should loop once it's over.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/breakbeat.mp3").toDestination();
     * player.loop = true;
     * player.autostart = true;
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        // if no change, do nothing
        if (this._loop === loop) return;
        this._loop = loop;
        // set the loop of all of the sources
        this._activeSources.forEach((source)=>{
            source.loop = loop;
        });
        if (loop) {
            // remove the next stopEvent
            const stopEvent = this._state.getNextState("stopped", this.now());
            if (stopEvent) this._state.cancel(stopEvent.time);
        }
    }
    /**
     * Normal speed is 1. The pitch will change with the playback rate.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/femalevoices_aa2_A5.mp3").toDestination();
     * // play at 1/4 speed
     * player.playbackRate = 0.25;
     * // play as soon as the buffer is loaded
     * player.autostart = true;
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        const now = this.now();
        // cancel the stop event since it's at a different time now
        const stopEvent = this._state.getNextState("stopped", now);
        if (stopEvent && stopEvent.implicitEnd) {
            this._state.cancel(stopEvent.time);
            this._activeSources.forEach((source)=>source.cancelStop());
        }
        // set all the sources
        this._activeSources.forEach((source)=>{
            source.playbackRate.setValueAtTime(rate, now);
        });
    }
    /**
     * If the buffer should be reversed
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/chime_1.mp3").toDestination();
     * player.autostart = true;
     * player.reverse = true;
     */ get reverse() {
        return this._buffer.reverse;
    }
    set reverse(rev) {
        this._buffer.reverse = rev;
    }
    /**
     * If the buffer is loaded
     */ get loaded() {
        return this._buffer.loaded;
    }
    dispose() {
        super.dispose();
        // disconnect all of the players
        this._activeSources.forEach((source)=>source.dispose());
        this._activeSources.clear();
        this._buffer.dispose();
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $44209288688a0328$export$2616165974278734.prototype, "fadeIn", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $44209288688a0328$export$2616165974278734.prototype, "fadeOut", void 0);










class $a4c8f7c082f8cecc$export$1912c9d78e93a6ed extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a4c8f7c082f8cecc$export$1912c9d78e93a6ed.getDefaults(), arguments, [
            "urls",
            "onload"
        ], "urls"));
        this.name = "Players";
        /**
         * Players has no input.
         */ this.input = undefined;
        /**
         * The container of all of the players
         */ this._players = new Map();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a4c8f7c082f8cecc$export$1912c9d78e93a6ed.getDefaults(), arguments, [
            "urls",
            "onload"
        ], "urls");
        /**
         * The output volume node
         */ this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
        this._buffers = new (0, $d37bb61f6ec53d08$export$7232b969b571e570)({
            urls: options.urls,
            onload: options.onload,
            baseUrl: options.baseUrl,
            onerror: options.onerror
        });
        // mute initially
        this.mute = options.mute;
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            baseUrl: "",
            fadeIn: 0,
            fadeOut: 0,
            mute: false,
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            urls: {},
            volume: 0
        });
    }
    /**
     * Mute the output.
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    /**
     * The fadeIn time of the envelope applied to the source.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(fadeIn) {
        this._fadeIn = fadeIn;
        this._players.forEach((player)=>{
            player.fadeIn = fadeIn;
        });
    }
    /**
     * The fadeOut time of the each of the sources.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(fadeOut) {
        this._fadeOut = fadeOut;
        this._players.forEach((player)=>{
            player.fadeOut = fadeOut;
        });
    }
    /**
     * The state of the players object. Returns "started" if any of the players are playing.
     */ get state() {
        const playing = Array.from(this._players).some(([_, player])=>player.state === "started");
        return playing ? "started" : "stopped";
    }
    /**
     * True if the buffers object has a buffer by that name.
     * @param name  The key or index of the buffer.
     */ has(name) {
        return this._buffers.has(name);
    }
    /**
     * Get a player by name.
     * @param  name  The players name as defined in the constructor object or `add` method.
     */ player(name) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.has(name), `No Player with the name ${name} exists on this object`);
        if (!this._players.has(name)) {
            const player = new (0, $44209288688a0328$export$2616165974278734)({
                context: this.context,
                fadeIn: this._fadeIn,
                fadeOut: this._fadeOut,
                url: this._buffers.get(name)
            }).connect(this.output);
            this._players.set(name, player);
        }
        return this._players.get(name);
    }
    /**
     * If all the buffers are loaded or not
     */ get loaded() {
        return this._buffers.loaded;
    }
    /**
     * Add a player by name and url to the Players
     * @param  name A unique name to give the player
     * @param  url  Either the url of the bufer or a buffer which will be added with the given name.
     * @param callback  The callback to invoke when the url is loaded.
     */ add(name, url, callback) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._buffers.has(name), "A buffer with that name already exists on this object");
        this._buffers.add(name, url, callback);
        return this;
    }
    /**
     * Stop all of the players at the given time
     * @param time The time to stop all of the players.
     */ stopAll(time) {
        this._players.forEach((player)=>player.stop(time));
        return this;
    }
    dispose() {
        super.dispose();
        this._volume.dispose();
        this.volume.dispose();
        this._players.forEach((player)=>player.dispose());
        this._buffers.dispose();
        return this;
    }
}










class $c5cf1604473dbe8e$export$564c6bce96a1f8e extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($c5cf1604473dbe8e$export$564c6bce96a1f8e.getDefaults(), arguments, [
            "url",
            "onload"
        ]));
        this.name = "GrainPlayer";
        /**
         * Internal loopStart value
         */ this._loopStart = 0;
        /**
         * Internal loopStart value
         */ this._loopEnd = 0;
        /**
         * All of the currently playing BufferSources
         */ this._activeSources = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($c5cf1604473dbe8e$export$564c6bce96a1f8e.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        this.buffer = new (0, $43da6dea502b5fe8$export$424a335715b38178)({
            onload: options.onload,
            onerror: options.onerror,
            reverse: options.reverse,
            url: options.url
        });
        this._clock = new (0, $b0382ab9b2ce11b2$export$9735c82c4bae3302)({
            context: this.context,
            callback: this._tick.bind(this),
            frequency: 1 / options.grainSize
        });
        this._playbackRate = options.playbackRate;
        this._grainSize = options.grainSize;
        this._overlap = options.overlap;
        this.detune = options.detune;
        // setup
        this.overlap = options.overlap;
        this.loop = options.loop;
        this.playbackRate = options.playbackRate;
        this.grainSize = options.grainSize;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this.reverse = options.reverse;
        this._clock.on("stop", this._onstop.bind(this));
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            overlap: 0.1,
            grainSize: 0.2,
            playbackRate: 1,
            detune: 0,
            loop: false,
            loopStart: 0,
            loopEnd: 0,
            reverse: false
        });
    }
    /**
     * Internal start method
     */ _start(time, offset, duration) {
        offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0);
        offset = this.toSeconds(offset);
        time = this.toSeconds(time);
        const grainSize = 1 / this._clock.frequency.getValueAtTime(time);
        this._clock.start(time, offset / grainSize);
        if (duration) this.stop(time + this.toSeconds(duration));
    }
    /**
     * Stop and then restart the player from the beginning (or offset)
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given,
     * 					it will default to the full length of the sample (minus any offset)
     */ restart(time, offset, duration) {
        super.restart(time, offset, duration);
        return this;
    }
    _restart(time, offset, duration) {
        this._stop(time);
        this._start(time, offset, duration);
    }
    /**
     * Internal stop method
     */ _stop(time) {
        this._clock.stop(time);
    }
    /**
     * Invoked when the clock is stopped
     */ _onstop(time) {
        // stop the players
        this._activeSources.forEach((source)=>{
            source.fadeOut = 0;
            source.stop(time);
        });
        this.onstop(this);
    }
    /**
     * Invoked on each clock tick. scheduled a new grain at this time.
     */ _tick(time) {
        // check if it should stop looping
        const ticks = this._clock.getTicksAtTime(time);
        const offset = ticks * this._grainSize;
        this.log("offset", offset);
        if (!this.loop && offset > this.buffer.duration) {
            this.stop(time);
            return;
        }
        // at the beginning of the file, the fade in should be 0
        const fadeIn = offset < this._overlap ? 0 : this._overlap;
        // create a buffer source
        const source = new (0, $faf7c8e078303879$export$30cbf4ba14db4fdd)({
            context: this.context,
            url: this.buffer,
            fadeIn: fadeIn,
            fadeOut: this._overlap,
            loop: this.loop,
            loopStart: this._loopStart,
            loopEnd: this._loopEnd,
            // compute the playbackRate based on the detune
            playbackRate: (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(this.detune / 100)
        }).connect(this.output);
        source.start(time, this._grainSize * ticks);
        source.stop(time + this._grainSize / this.playbackRate);
        // add it to the active sources
        this._activeSources.push(source);
        // remove it when it's done
        source.onended = ()=>{
            const index = this._activeSources.indexOf(source);
            if (index !== -1) this._activeSources.splice(index, 1);
        };
    }
    /**
     * The playback rate of the sample
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(rate, 0.001);
        this._playbackRate = rate;
        this.grainSize = this._grainSize;
    }
    /**
     * The loop start time.
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(time) {
        if (this.buffer.loaded) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(time), 0, this.buffer.duration);
        this._loopStart = this.toSeconds(time);
    }
    /**
     * The loop end time.
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(time) {
        if (this.buffer.loaded) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(time), 0, this.buffer.duration);
        this._loopEnd = this.toSeconds(time);
    }
    /**
     * The direction the buffer should play in
     */ get reverse() {
        return this.buffer.reverse;
    }
    set reverse(rev) {
        this.buffer.reverse = rev;
    }
    /**
     * The size of each chunk of audio that the
     * buffer is chopped into and played back at.
     */ get grainSize() {
        return this._grainSize;
    }
    set grainSize(size) {
        this._grainSize = this.toSeconds(size);
        this._clock.frequency.setValueAtTime(this._playbackRate / this._grainSize, this.now());
    }
    /**
     * The duration of the cross-fade between successive grains.
     */ get overlap() {
        return this._overlap;
    }
    set overlap(time) {
        const computedTime = this.toSeconds(time);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(computedTime, 0);
        this._overlap = computedTime;
    }
    /**
     * If all the buffer is loaded
     */ get loaded() {
        return this.buffer.loaded;
    }
    dispose() {
        super.dispose();
        this.buffer.dispose();
        this._clock.dispose();
        this._activeSources.forEach((source)=>source.dispose());
        return this;
    }
}







class $bc6b6173dfd74460$export$b73c596ee8758a66 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(...arguments);
        this.name = "Abs";
        /**
         * The node which converts the audio ranges
         */ this._abs = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: (val)=>{
                if (Math.abs(val) < 0.001) return 0;
                else return Math.abs(val);
            }
        });
        /**
         * The AudioRange input [-1, 1]
         */ this.input = this._abs;
        /**
         * The output range [0, 1]
         */ this.output = this._abs;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._abs.dispose();
        return this;
    }
}





class $98f6ca22b8da8532$export$770438008a544d9b extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(...arguments);
        this.name = "GainToAudio";
        /**
         * The node which converts the audio ranges
         */ this._norm = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: (x)=>Math.abs(x) * 2 - 1
        });
        /**
         * The NormalRange input [0, 1]
         */ this.input = this._norm;
        /**
         * The AudioRange output [-1, 1]
         */ this.output = this._norm;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._norm.dispose();
        return this;
    }
}








class $12434edb56028935$export$a4e82151127277b0 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(...arguments);
        this.name = "Negate";
        /**
         * negation is done by multiplying by -1
         */ this._multiply = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: -1
        });
        /**
         * The input and output are equal to the multiply node
         */ this.input = this._multiply;
        this.output = this._multiply;
    }
    /**
     * clean up
     * @returns {Negate} this
     */ dispose() {
        super.dispose();
        this._multiply.dispose();
        return this;
    }
}



class $270e4189b1a75906$export$8bc67ae85ef4b74f extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($270e4189b1a75906$export$8bc67ae85ef4b74f.getDefaults(), arguments, [
            "value"
        ])));
        this.override = false;
        this.name = "Subtract";
        /**
         * the summing node
         */ this._sum = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.input = this._sum;
        this.output = this._sum;
        /**
         * Negate the input of the second input before connecting it to the summing node.
         */ this._neg = new (0, $12434edb56028935$export$a4e82151127277b0)({
            context: this.context
        });
        /**
         * The value which is subtracted from the main signal
         */ this.subtrahend = this._param;
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this._constantSource, this._neg, this._sum);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._neg.dispose();
        this._sum.dispose();
        return this;
    }
}







class $27732e051cf527d8$export$fe50ca7dd7da9c45 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($27732e051cf527d8$export$fe50ca7dd7da9c45.getDefaults(), arguments)));
        this.name = "GreaterThanZero";
        this._thresh = this.output = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            length: 127,
            mapping: (val)=>{
                if (val <= 0) return 0;
                else return 1;
            }
        });
        this._scale = this.input = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: 10000
        });
        // connections
        this._scale.connect(this._thresh);
    }
    dispose() {
        super.dispose();
        this._scale.dispose();
        this._thresh.dispose();
        return this;
    }
}



class $935df50545cf657e$export$fdac76ab71aa5db6 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($935df50545cf657e$export$fdac76ab71aa5db6.getDefaults(), arguments, [
            "value"
        ])));
        this.name = "GreaterThan";
        this.override = false;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($935df50545cf657e$export$fdac76ab71aa5db6.getDefaults(), arguments, [
            "value"
        ]);
        this._subtract = this.input = new (0, $270e4189b1a75906$export$8bc67ae85ef4b74f)({
            context: this.context,
            value: options.value
        });
        this._gtz = this.output = new (0, $27732e051cf527d8$export$fe50ca7dd7da9c45)({
            context: this.context
        });
        this.comparator = this._param = this._subtract.subtrahend;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "comparator");
        // connect
        this._subtract.connect(this._gtz);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._gtz.dispose();
        this._subtract.dispose();
        this.comparator.dispose();
        return this;
    }
}








class $4603e249f478b841$export$ce28d653ec559ee extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4603e249f478b841$export$ce28d653ec559ee.getDefaults(), arguments, [
            "value"
        ])));
        this.name = "Pow";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4603e249f478b841$export$ce28d653ec559ee.getDefaults(), arguments, [
            "value"
        ]);
        this._exponentScaler = this.input = this.output = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: this._expFunc(options.value),
            length: 8192
        });
        this._exponent = options.value;
    }
    static getDefaults() {
        return Object.assign((0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe).getDefaults(), {
            value: 1
        });
    }
    /**
     * the function which maps the waveshaper
     * @param exponent exponent value
     */ _expFunc(exponent) {
        return (val)=>{
            return Math.pow(Math.abs(val), exponent);
        };
    }
    /**
     * The value of the exponent.
     */ get value() {
        return this._exponent;
    }
    set value(exponent) {
        this._exponent = exponent;
        this._exponentScaler.setMap(this._expFunc(this._exponent));
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._exponentScaler.dispose();
        return this;
    }
}







class $75aaa92c69306be4$export$92c7140174c78083 extends (0, $d4646d969ab22afc$export$d60cfc58d3c358b6) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($75aaa92c69306be4$export$92c7140174c78083.getDefaults(), arguments, [
            "min",
            "max",
            "exponent"
        ])));
        this.name = "ScaleExp";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($75aaa92c69306be4$export$92c7140174c78083.getDefaults(), arguments, [
            "min",
            "max",
            "exponent"
        ]);
        this.input = this._exp = new (0, $4603e249f478b841$export$ce28d653ec559ee)({
            context: this.context,
            value: options.exponent
        });
        this._exp.connect(this._mult);
    }
    static getDefaults() {
        return Object.assign((0, $d4646d969ab22afc$export$d60cfc58d3c358b6).getDefaults(), {
            exponent: 1
        });
    }
    /**
     * Instead of interpolating linearly between the [[min]] and
     * [[max]] values, setting the exponent will interpolate between
     * the two values with an exponential curve.
     */ get exponent() {
        return this._exp.value;
    }
    set exponent(exp) {
        this._exp.value = exp;
    }
    dispose() {
        super.dispose();
        this._exp.dispose();
        return this;
    }
}







class $1a19093127c18aeb$export$35743999fcf7d6a4 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), arguments, [
            "value",
            "units"
        ]));
        this.name = "SyncedSignal";
        /**
         * Don't override when something is connected to the input
         */ this.override = false;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), arguments, [
            "value",
            "units"
        ]);
        this._lastVal = options.value;
        this._synced = this.context.transport.scheduleRepeat(this._onTick.bind(this), "1i");
        this._syncedCallback = this._anchorValue.bind(this);
        this.context.transport.on("start", this._syncedCallback);
        this.context.transport.on("pause", this._syncedCallback);
        this.context.transport.on("stop", this._syncedCallback);
        // disconnect the constant source from the output and replace it with another one
        this._constantSource.disconnect();
        this._constantSource.stop(0);
        // create a new one
        this._constantSource = this.output = new (0, $07d091cc6b8a4926$export$717f1ef4ba8fd295)({
            context: this.context,
            offset: options.value,
            units: options.units
        }).start(0);
        this.setValueAtTime(options.value, 0);
    }
    /**
     * Callback which is invoked every tick.
     */ _onTick(time) {
        const val = super.getValueAtTime(this.context.transport.seconds);
        // approximate ramp curves with linear ramps
        if (this._lastVal !== val) {
            this._lastVal = val;
            this._constantSource.offset.setValueAtTime(val, time);
        }
    }
    /**
     * Anchor the value at the start and stop of the Transport
     */ _anchorValue(time) {
        const val = super.getValueAtTime(this.context.transport.seconds);
        this._lastVal = val;
        this._constantSource.offset.cancelAndHoldAtTime(time);
        this._constantSource.offset.setValueAtTime(val, time);
    }
    getValueAtTime(time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        return super.getValueAtTime(computedTime);
    }
    setValueAtTime(value, time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.setValueAtTime(value, computedTime);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.linearRampToValueAtTime(value, computedTime);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.exponentialRampToValueAtTime(value, computedTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.setTargetAtTime(value, computedTime, timeConstant);
        return this;
    }
    cancelScheduledValues(startTime) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.cancelScheduledValues(computedTime);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        duration = this.toSeconds(duration);
        super.setValueCurveAtTime(values, computedTime, duration, scaling);
        return this;
    }
    cancelAndHoldAtTime(time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.cancelAndHoldAtTime(computedTime);
        return this;
    }
    setRampPoint(time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.setRampPoint(computedTime);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.exponentialRampTo(value, rampTime, computedTime);
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.linearRampTo(value, rampTime, computedTime);
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.targetRampTo(value, rampTime, computedTime);
        return this;
    }
    dispose() {
        super.dispose();
        this.context.transport.clear(this._synced);
        this.context.transport.off("start", this._syncedCallback);
        this.context.transport.off("pause", this._syncedCallback);
        this.context.transport.off("stop", this._syncedCallback);
        this._constantSource.dispose();
        return this;
    }
}



















class $213294b6acd7c6a9$export$4e2d65a9843399df extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($213294b6acd7c6a9$export$4e2d65a9843399df.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]));
        this.name = "Envelope";
        /**
         * the signal which is output.
         */ this._sig = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: 0
        });
        /**
         * The output signal of the envelope
         */ this.output = this._sig;
        /**
         * Envelope has no input
         */ this.input = undefined;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($213294b6acd7c6a9$export$4e2d65a9843399df.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]);
        this.attack = options.attack;
        this.decay = options.decay;
        this.sustain = options.sustain;
        this.release = options.release;
        this.attackCurve = options.attackCurve;
        this.releaseCurve = options.releaseCurve;
        this.decayCurve = options.decayCurve;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            attack: 0.01,
            attackCurve: "linear",
            decay: 0.1,
            decayCurve: "exponential",
            release: 1,
            releaseCurve: "exponential",
            sustain: 0.5
        });
    }
    /**
     * Read the current value of the envelope. Useful for
     * synchronizing visual output to the envelope.
     */ get value() {
        return this.getValueAtTime(this.now());
    }
    /**
     * Get the curve
     * @param  curve
     * @param  direction  In/Out
     * @return The curve name
     */ _getCurve(curve, direction) {
        if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(curve)) return curve;
        else {
            // look up the name in the curves array
            let curveName;
            for(curveName in $213294b6acd7c6a9$var$EnvelopeCurves){
                if ($213294b6acd7c6a9$var$EnvelopeCurves[curveName][direction] === curve) return curveName;
            }
            // return the custom curve
            return curve;
        }
    }
    /**
     * Assign a the curve to the given name using the direction
     * @param  name
     * @param  direction In/Out
     * @param  curve
     */ _setCurve(name, direction, curve) {
        // check if it's a valid type
        if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(curve) && Reflect.has($213294b6acd7c6a9$var$EnvelopeCurves, curve)) {
            const curveDef = $213294b6acd7c6a9$var$EnvelopeCurves[curve];
            if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(curveDef)) {
                if (name !== "_decayCurve") this[name] = curveDef[direction];
            } else this[name] = curveDef;
        } else if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(curve) && name !== "_decayCurve") this[name] = curve;
        else throw new Error("Envelope: invalid curve: " + curve);
    }
    /**
     * The shape of the attack.
     * Can be any of these strings:
     * * "linear"
     * * "exponential"
     * * "sine"
     * * "cosine"
     * * "bounce"
     * * "ripple"
     * * "step"
     *
     * Can also be an array which describes the curve. Values
     * in the array are evenly subdivided and linearly
     * interpolated over the duration of the attack.
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope(0.4).toDestination();
     * 	env.attackCurve = "linear";
     * 	env.triggerAttack();
     * }, 1, 1);
     */ get attackCurve() {
        return this._getCurve(this._attackCurve, "In");
    }
    set attackCurve(curve) {
        this._setCurve("_attackCurve", "In", curve);
    }
    /**
     * The shape of the release. See the attack curve types.
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope({
     * 		release: 0.8
     * 	}).toDestination();
     * 	env.triggerAttack();
     * 	// release curve could also be defined by an array
     * 	env.releaseCurve = [1, 0.3, 0.4, 0.2, 0.7, 0];
     * 	env.triggerRelease(0.2);
     * }, 1, 1);
     */ get releaseCurve() {
        return this._getCurve(this._releaseCurve, "Out");
    }
    set releaseCurve(curve) {
        this._setCurve("_releaseCurve", "Out", curve);
    }
    /**
     * The shape of the decay either "linear" or "exponential"
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope({
     * 		sustain: 0.1,
     * 		decay: 0.5
     * 	}).toDestination();
     * 	env.decayCurve = "linear";
     * 	env.triggerAttack();
     * }, 1, 1);
     */ get decayCurve() {
        return this._decayCurve;
    }
    set decayCurve(curve) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)([
            "linear",
            "exponential"
        ].some((c)=>c === curve), `Invalid envelope curve: ${curve}`);
        this._decayCurve = curve;
    }
    /**
     * Trigger the attack/decay portion of the ADSR envelope.
     * @param  time When the attack should start.
     * @param velocity The velocity of the envelope scales the vales.
     *                             number between 0-1
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator().connect(env).start();
     * // trigger the attack 0.5 seconds from now with a velocity of 0.2
     * env.triggerAttack("+0.5", 0.2);
     */ triggerAttack(time, velocity = 1) {
        this.log("triggerAttack", time, velocity);
        time = this.toSeconds(time);
        const originalAttack = this.toSeconds(this.attack);
        let attack = originalAttack;
        const decay = this.toSeconds(this.decay);
        // check if it's not a complete attack
        const currentValue = this.getValueAtTime(time);
        if (currentValue > 0) {
            // subtract the current value from the attack time
            const attackRate = 1 / attack;
            const remainingDistance = 1 - currentValue;
            // the attack is now the remaining time
            attack = remainingDistance / attackRate;
        }
        // attack
        if (attack < this.sampleTime) {
            this._sig.cancelScheduledValues(time);
            // case where the attack time is 0 should set instantly
            this._sig.setValueAtTime(velocity, time);
        } else if (this._attackCurve === "linear") this._sig.linearRampTo(velocity, attack, time);
        else if (this._attackCurve === "exponential") this._sig.targetRampTo(velocity, attack, time);
        else {
            this._sig.cancelAndHoldAtTime(time);
            let curve = this._attackCurve;
            // find the starting position in the curve
            for(let i = 1; i < curve.length; i++)// the starting index is between the two values
            if (curve[i - 1] <= currentValue && currentValue <= curve[i]) {
                curve = this._attackCurve.slice(i);
                // the first index is the current value
                curve[0] = currentValue;
                break;
            }
            this._sig.setValueCurveAtTime(curve, time, attack, velocity);
        }
        // decay
        if (decay && this.sustain < 1) {
            const decayValue = velocity * this.sustain;
            const decayStart = time + attack;
            this.log("decay", decayStart);
            if (this._decayCurve === "linear") this._sig.linearRampToValueAtTime(decayValue, decay + decayStart);
            else this._sig.exponentialApproachValueAtTime(decayValue, decayStart, decay);
        }
        return this;
    }
    /**
     * Triggers the release of the envelope.
     * @param  time When the release portion of the envelope should start.
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator({
     * 	type: "sawtooth"
     * }).connect(env).start();
     * env.triggerAttack();
     * // trigger the release half a second after the attack
     * env.triggerRelease("+0.5");
     */ triggerRelease(time) {
        this.log("triggerRelease", time);
        time = this.toSeconds(time);
        const currentValue = this.getValueAtTime(time);
        if (currentValue > 0) {
            const release = this.toSeconds(this.release);
            if (release < this.sampleTime) this._sig.setValueAtTime(0, time);
            else if (this._releaseCurve === "linear") this._sig.linearRampTo(0, release, time);
            else if (this._releaseCurve === "exponential") this._sig.targetRampTo(0, release, time);
            else {
                (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(this._releaseCurve), "releaseCurve must be either 'linear', 'exponential' or an array");
                this._sig.cancelAndHoldAtTime(time);
                this._sig.setValueCurveAtTime(this._releaseCurve, time, release, currentValue);
            }
        }
        return this;
    }
    /**
     * Get the scheduled value at the given time. This will
     * return the unconverted (raw) value.
     * @example
     * const env = new Tone.Envelope(0.5, 1, 0.4, 2);
     * env.triggerAttackRelease(2);
     * setInterval(() => console.log(env.getValueAtTime(Tone.now())), 100);
     */ getValueAtTime(time) {
        return this._sig.getValueAtTime(time);
    }
    /**
     * triggerAttackRelease is shorthand for triggerAttack, then waiting
     * some duration, then triggerRelease.
     * @param duration The duration of the sustain.
     * @param time When the attack should be triggered.
     * @param velocity The velocity of the envelope.
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator().connect(env).start();
     * // trigger the release 0.5 seconds after the attack
     * env.triggerAttackRelease(0.5);
     */ triggerAttackRelease(duration, time, velocity = 1) {
        time = this.toSeconds(time);
        this.triggerAttack(time, velocity);
        this.triggerRelease(time + this.toSeconds(duration));
        return this;
    }
    /**
     * Cancels all scheduled envelope changes after the given time.
     */ cancel(after) {
        this._sig.cancelScheduledValues(this.toSeconds(after));
        return this;
    }
    /**
     * Connect the envelope to a destination node.
     */ connect(destination, outputNumber = 0, inputNumber = 0) {
        (0, $87a50297d6fa5f61$export$c8174dc07173cff0)(this, destination, outputNumber, inputNumber);
        return this;
    }
    /**
     * Render the envelope curve to an array of the given length.
     * Good for visualizing the envelope curve. Rescales the duration of the
     * envelope to fit the length.
     */ asArray(length = 1024) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const duration = length / this.context.sampleRate;
            const context = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(1, duration, this.context.sampleRate);
            // normalize the ADSR for the given duration with 20% sustain time
            const attackPortion = this.toSeconds(this.attack) + this.toSeconds(this.decay);
            const envelopeDuration = attackPortion + this.toSeconds(this.release);
            const sustainTime = envelopeDuration * 0.1;
            const totalDuration = envelopeDuration + sustainTime;
            // @ts-ignore
            const clone = new this.constructor(Object.assign(this.get(), {
                attack: duration * this.toSeconds(this.attack) / totalDuration,
                decay: duration * this.toSeconds(this.decay) / totalDuration,
                release: duration * this.toSeconds(this.release) / totalDuration,
                context: context
            }));
            clone._sig.toDestination();
            clone.triggerAttackRelease(duration * (attackPortion + sustainTime) / totalDuration, 0);
            const buffer = yield context.render();
            return buffer.getChannelData(0);
        });
    }
    dispose() {
        super.dispose();
        this._sig.dispose();
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $213294b6acd7c6a9$export$4e2d65a9843399df.prototype, "attack", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $213294b6acd7c6a9$export$4e2d65a9843399df.prototype, "decay", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$d02631cccf789723)(0, 1)
], $213294b6acd7c6a9$export$4e2d65a9843399df.prototype, "sustain", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $213294b6acd7c6a9$export$4e2d65a9843399df.prototype, "release", void 0);
/**
 * Generate some complex envelope curves.
 */ const $213294b6acd7c6a9$var$EnvelopeCurves = (()=>{
    const curveLen = 128;
    let i;
    let k;
    // cosine curve
    const cosineCurve = [];
    for(i = 0; i < curveLen; i++)cosineCurve[i] = Math.sin(i / (curveLen - 1) * (Math.PI / 2));
    // ripple curve
    const rippleCurve = [];
    const rippleCurveFreq = 6.4;
    for(i = 0; i < curveLen - 1; i++){
        k = i / (curveLen - 1);
        const sineWave = Math.sin(k * (Math.PI * 2) * rippleCurveFreq - Math.PI / 2) + 1;
        rippleCurve[i] = sineWave / 10 + k * 0.83;
    }
    rippleCurve[curveLen - 1] = 1;
    // stairs curve
    const stairsCurve = [];
    const steps = 5;
    for(i = 0; i < curveLen; i++)stairsCurve[i] = Math.ceil(i / (curveLen - 1) * steps) / steps;
    // in-out easing curve
    const sineCurve = [];
    for(i = 0; i < curveLen; i++){
        k = i / (curveLen - 1);
        sineCurve[i] = 0.5 * (1 - Math.cos(Math.PI * k));
    }
    // a bounce curve
    const bounceCurve = [];
    for(i = 0; i < curveLen; i++){
        k = i / (curveLen - 1);
        const freq = Math.pow(k, 3) * 4 + 0.2;
        const val = Math.cos(freq * Math.PI * 2 * k);
        bounceCurve[i] = Math.abs(val * (1 - k));
    }
    /**
     * Invert a value curve to make it work for the release
     */ function invertCurve(curve) {
        const out = new Array(curve.length);
        for(let j = 0; j < curve.length; j++)out[j] = 1 - curve[j];
        return out;
    }
    /**
     * reverse the curve
     */ function reverseCurve(curve) {
        return curve.slice(0).reverse();
    }
    /**
     * attack and release curve arrays
     */ return {
        bounce: {
            In: invertCurve(bounceCurve),
            Out: bounceCurve
        },
        cosine: {
            In: cosineCurve,
            Out: reverseCurve(cosineCurve)
        },
        exponential: "exponential",
        linear: "linear",
        ripple: {
            In: rippleCurve,
            Out: invertCurve(rippleCurve)
        },
        sine: {
            In: sineCurve,
            Out: invertCurve(sineCurve)
        },
        step: {
            In: stairsCurve,
            Out: invertCurve(stairsCurve)
        }
    };
})();











class $604ec55036b64d8b$export$25ef33f358b07cf4 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($604ec55036b64d8b$export$25ef33f358b07cf4.getDefaults(), arguments));
        /**
         * Keep track of all events scheduled to the transport
         * when the instrument is 'synced'
         */ this._scheduledEvents = [];
        /**
         * If the instrument is currently synced
         */ this._synced = false;
        this._original_triggerAttack = this.triggerAttack;
        this._original_triggerRelease = this.triggerRelease;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($604ec55036b64d8b$export$25ef33f358b07cf4.getDefaults(), arguments);
        this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            volume: 0
        });
    }
    /**
     * Sync the instrument to the Transport. All subsequent calls of
     * [[triggerAttack]] and [[triggerRelease]] will be scheduled along the transport.
     * @example
     * const fmSynth = new Tone.FMSynth().toDestination();
     * fmSynth.volume.value = -6;
     * fmSynth.sync();
     * // schedule 3 notes when the transport first starts
     * fmSynth.triggerAttackRelease("C4", "8n", 0);
     * fmSynth.triggerAttackRelease("E4", "8n", "8n");
     * fmSynth.triggerAttackRelease("G4", "8n", "4n");
     * // start the transport to hear the notes
     * Tone.Transport.start();
     */ sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 0);
        }
        return this;
    }
    /**
     * set _sync
     */ _syncState() {
        let changed = false;
        if (!this._synced) {
            this._synced = true;
            changed = true;
        }
        return changed;
    }
    /**
     * Wrap the given method so that it can be synchronized
     * @param method Which method to wrap and sync
     * @param  timePosition What position the time argument appears in
     */ _syncMethod(method, timePosition) {
        const originalMethod = this["_original_" + method] = this[method];
        this[method] = (...args)=>{
            const time = args[timePosition];
            const id = this.context.transport.schedule((t)=>{
                args[timePosition] = t;
                originalMethod.apply(this, args);
            }, time);
            this._scheduledEvents.push(id);
        };
    }
    /**
     * Unsync the instrument from the Transport
     */ unsync() {
        this._scheduledEvents.forEach((id)=>this.context.transport.clear(id));
        this._scheduledEvents = [];
        if (this._synced) {
            this._synced = false;
            this.triggerAttack = this._original_triggerAttack;
            this.triggerRelease = this._original_triggerRelease;
        }
        return this;
    }
    /**
     * Trigger the attack and then the release after the duration.
     * @param  note     The note to trigger.
     * @param  duration How long the note should be held for before
     *                         triggering the release. This value must be greater than 0.
     * @param time  When the note should be triggered.
     * @param  velocity The velocity the note should be triggered at.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * // trigger "C4" for the duration of an 8th note
     * synth.triggerAttackRelease("C4", "8n");
     */ triggerAttackRelease(note, duration, time, velocity) {
        const computedTime = this.toSeconds(time);
        const computedDuration = this.toSeconds(duration);
        this.triggerAttack(note, computedTime, velocity);
        this.triggerRelease(computedTime + computedDuration);
        return this;
    }
    /**
     * clean up
     * @returns {Instrument} this
     */ dispose() {
        super.dispose();
        this._volume.dispose();
        this.unsync();
        this._scheduledEvents = [];
        return this;
    }
}



class $8a6857abebb22660$export$f16a08bc2d920a12 extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8a6857abebb22660$export$f16a08bc2d920a12.getDefaults(), arguments));
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8a6857abebb22660$export$f16a08bc2d920a12.getDefaults(), arguments);
        this.portamento = options.portamento;
        this.onsilence = options.onsilence;
    }
    static getDefaults() {
        return Object.assign((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            detune: 0,
            onsilence: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            portamento: 0
        });
    }
    /**
     * Trigger the attack of the note optionally with a given velocity.
     * @param  note The note to trigger.
     * @param  time When the note should start.
     * @param  velocity The velocity scaler determines how "loud" the note will be triggered.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * // trigger the note a half second from now at half velocity
     * synth.triggerAttack("C4", "+0.5", 0.5);
     */ triggerAttack(note, time, velocity = 1) {
        this.log("triggerAttack", note, time, velocity);
        const seconds = this.toSeconds(time);
        this._triggerEnvelopeAttack(seconds, velocity);
        this.setNote(note, seconds);
        return this;
    }
    /**
     * Trigger the release portion of the envelope
     * @param  time If no time is given, the release happens immediatly
     * @example
     * const synth = new Tone.Synth().toDestination();
     * synth.triggerAttack("C4");
     * // trigger the release a second from now
     * synth.triggerRelease("+1");
     */ triggerRelease(time) {
        this.log("triggerRelease", time);
        const seconds = this.toSeconds(time);
        this._triggerEnvelopeRelease(seconds);
        return this;
    }
    /**
     * Set the note at the given time. If no time is given, the note
     * will set immediately.
     * @param note The note to change to.
     * @param  time The time when the note should be set.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * synth.triggerAttack("C4");
     * // change to F#6 in one quarter note from now.
     * synth.setNote("F#6", "+4n");
     */ setNote(note, time) {
        const computedTime = this.toSeconds(time);
        const computedFrequency = note instanceof (0, $f4d7193118bd1d27$export$38b56155c8552868) ? note.toFrequency() : note;
        if (this.portamento > 0 && this.getLevelAtTime(computedTime) > 0.05) {
            const portTime = this.toSeconds(this.portamento);
            this.frequency.exponentialRampTo(computedFrequency, portTime, computedTime);
        } else this.frequency.setValueAtTime(computedFrequency, computedTime);
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $8a6857abebb22660$export$f16a08bc2d920a12.prototype, "portamento", void 0);







class $30aa93da9543c1e0$export$e04e0eedd8192587 extends (0, $213294b6acd7c6a9$export$4e2d65a9843399df) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($30aa93da9543c1e0$export$e04e0eedd8192587.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]));
        this.name = "AmplitudeEnvelope";
        this._gainNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        this.output = this._gainNode;
        this.input = this._gainNode;
        this._sig.connect(this._gainNode.gain);
        this.output = this._gainNode;
        this.input = this._gainNode;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._gainNode.dispose();
        return this;
    }
}









class $6489a0fb869a8c37$export$8ef26ca8e8d9bf70 extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($6489a0fb869a8c37$export$8ef26ca8e8d9bf70.getDefaults(), arguments));
        this.name = "Synth";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($6489a0fb869a8c37$export$8ef26ca8e8d9bf70.getDefaults(), arguments);
        this.oscillator = new (0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d)(Object.assign({
            context: this.context,
            detune: options.detune,
            onstop: ()=>this.onsilence(this)
        }, options.oscillator));
        this.frequency = this.oscillator.frequency;
        this.detune = this.oscillator.detune;
        this.envelope = new (0, $30aa93da9543c1e0$export$e04e0eedd8192587)(Object.assign({
            context: this.context
        }, options.envelope));
        // connect the oscillators to the output
        this.oscillator.chain(this.envelope, this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "oscillator",
            "frequency",
            "detune",
            "envelope"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.005,
                decay: 0.1,
                release: 1,
                sustain: 0.3
            }),
            oscillator: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d).getDefaults(), [
                ...Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "triangle"
            })
        });
    }
    /**
     * start the attack portion of the envelope
     * @param time the time the attack should start
     * @param velocity the velocity of the note (0-1)
     */ _triggerEnvelopeAttack(time, velocity) {
        // the envelopes
        this.envelope.triggerAttack(time, velocity);
        this.oscillator.start(time);
        // if there is no release portion, stop the oscillator
        if (this.envelope.sustain === 0) {
            const computedAttack = this.toSeconds(this.envelope.attack);
            const computedDecay = this.toSeconds(this.envelope.decay);
            this.oscillator.stop(time + computedAttack + computedDecay);
        }
    }
    /**
     * start the release portion of the envelope
     * @param time the time the release should start
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this.oscillator.stop(time + this.toSeconds(this.envelope.release));
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this.oscillator.dispose();
        this.envelope.dispose();
        return this;
    }
}




class $18ec96681065c3f1$export$aee9425caad4bd7e extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($18ec96681065c3f1$export$aee9425caad4bd7e.getDefaults(), arguments));
        this.name = "ModulationSynth";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($18ec96681065c3f1$export$aee9425caad4bd7e.getDefaults(), arguments);
        this._carrier = new (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70)({
            context: this.context,
            oscillator: options.oscillator,
            envelope: options.envelope,
            onsilence: ()=>this.onsilence(this),
            volume: -10
        });
        this._modulator = new (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70)({
            context: this.context,
            oscillator: options.modulation,
            envelope: options.modulationEnvelope,
            volume: -10
        });
        this.oscillator = this._carrier.oscillator;
        this.envelope = this._carrier.envelope;
        this.modulation = this._modulator.oscillator;
        this.modulationEnvelope = this._modulator.envelope;
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency"
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.detune,
            units: "cents"
        });
        this.harmonicity = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: options.harmonicity,
            minValue: 0
        });
        this._modulationNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "harmonicity",
            "oscillator",
            "envelope",
            "modulation",
            "modulationEnvelope",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            harmonicity: 3,
            oscillator: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d).getDefaults(), [
                ...Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "sine"
            }),
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.01,
                decay: 0.01,
                sustain: 1,
                release: 0.5
            }),
            modulation: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d).getDefaults(), [
                ...Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "square"
            }),
            modulationEnvelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.5,
                decay: 0.0,
                sustain: 1,
                release: 0.5
            })
        });
    }
    /**
     * Trigger the attack portion of the note
     */ _triggerEnvelopeAttack(time, velocity) {
        // @ts-ignore
        this._carrier._triggerEnvelopeAttack(time, velocity);
        // @ts-ignore
        this._modulator._triggerEnvelopeAttack(time, velocity);
    }
    /**
     * Trigger the release portion of the note
     */ _triggerEnvelopeRelease(time) {
        // @ts-ignore
        this._carrier._triggerEnvelopeRelease(time);
        // @ts-ignore
        this._modulator._triggerEnvelopeRelease(time);
        return this;
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    dispose() {
        super.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this.harmonicity.dispose();
        this._modulationNode.dispose();
        return this;
    }
}


class $06f7187fc6b08467$export$cd421a3dd25cf75d extends (0, $18ec96681065c3f1$export$aee9425caad4bd7e) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($06f7187fc6b08467$export$cd421a3dd25cf75d.getDefaults(), arguments));
        this.name = "AMSynth";
        this._modulationScale = new (0, $69552eca520acf8e$export$2e6ea0941c39f845)({
            context: this.context
        });
        // control the two voices frequency
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.detune.fan(this._carrier.detune, this._modulator.detune);
        this._modulator.chain(this._modulationScale, this._modulationNode.gain);
        this._carrier.chain(this._modulationNode, this.output);
    }
    dispose() {
        super.dispose();
        this._modulationScale.dispose();
        return this;
    }
}
















class $94fd137bb655066f$export$26bbc35c91a15e23 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($94fd137bb655066f$export$26bbc35c91a15e23.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "BiquadFilter";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($94fd137bb655066f$export$26bbc35c91a15e23.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        this._filter = this.context.createBiquadFilter();
        this.input = this.output = this._filter;
        this.Q = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            units: "number",
            value: options.Q,
            param: this._filter.Q
        });
        this.frequency = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            units: "frequency",
            value: options.frequency,
            param: this._filter.frequency
        });
        this.detune = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            units: "cents",
            value: options.detune,
            param: this._filter.detune
        });
        this.gain = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            units: "decibels",
            convert: false,
            value: options.gain,
            param: this._filter.gain
        });
        this.type = options.type;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            Q: 1,
            type: "lowpass",
            frequency: 350,
            detune: 0,
            gain: 0
        });
    }
    /**
     * The type of this BiquadFilterNode. For a complete list of types and their attributes, see the
     * [Web Audio API](https://webaudio.github.io/web-audio-api/#dom-biquadfiltertype-lowpass)
     */ get type() {
        return this._filter.type;
    }
    set type(type) {
        const types = [
            "lowpass",
            "highpass",
            "bandpass",
            "lowshelf",
            "highshelf",
            "notch",
            "allpass",
            "peaking"
        ];
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(types.indexOf(type) !== -1, `Invalid filter type: ${type}`);
        this._filter.type = type;
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        // start with all 1s
        const freqValues = new Float32Array(len);
        for(let i = 0; i < len; i++){
            const norm = Math.pow(i / len, 2);
            const freq = norm * 19980 + 20;
            freqValues[i] = freq;
        }
        const magValues = new Float32Array(len);
        const phaseValues = new Float32Array(len);
        // clone the filter to remove any connections which may be changing the value
        const filterClone = this.context.createBiquadFilter();
        filterClone.type = this.type;
        filterClone.Q.value = this.Q.value;
        filterClone.frequency.value = this.frequency.value;
        filterClone.gain.value = this.gain.value;
        filterClone.getFrequencyResponse(freqValues, magValues, phaseValues);
        return magValues;
    }
    dispose() {
        super.dispose();
        this._filter.disconnect();
        this.Q.dispose();
        this.frequency.dispose();
        this.gain.dispose();
        this.detune.dispose();
        return this;
    }
}


class $a487e4b525eb8039$export$ec91da630f36d5ea extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a487e4b525eb8039$export$ec91da630f36d5ea.getDefaults(), arguments, [
            "frequency",
            "type",
            "rolloff"
        ]));
        this.name = "Filter";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._filters = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a487e4b525eb8039$export$ec91da630f36d5ea.getDefaults(), arguments, [
            "frequency",
            "type",
            "rolloff"
        ]);
        this._filters = [];
        this.Q = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "positive",
            value: options.Q
        });
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this.gain = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "decibels",
            convert: false,
            value: options.gain
        });
        this._type = options.type;
        this.rolloff = options.rolloff;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "detune",
            "frequency",
            "gain",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            Q: 1,
            detune: 0,
            frequency: 350,
            gain: 0,
            rolloff: -12,
            type: "lowpass"
        });
    }
    /**
     * The type of the filter. Types: "lowpass", "highpass",
     * "bandpass", "lowshelf", "highshelf", "notch", "allpass", or "peaking".
     */ get type() {
        return this._type;
    }
    set type(type) {
        const types = [
            "lowpass",
            "highpass",
            "bandpass",
            "lowshelf",
            "highshelf",
            "notch",
            "allpass",
            "peaking"
        ];
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(types.indexOf(type) !== -1, `Invalid filter type: ${type}`);
        this._type = type;
        this._filters.forEach((filter)=>filter.type = type);
    }
    /**
     * The rolloff of the filter which is the drop in db
     * per octave. Implemented internally by cascading filters.
     * Only accepts the values -12, -24, -48 and -96.
     */ get rolloff() {
        return this._rolloff;
    }
    set rolloff(rolloff) {
        const rolloffNum = (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(rolloff) ? rolloff : parseInt(rolloff, 10);
        const possibilities = [
            -12,
            -24,
            -48,
            -96
        ];
        let cascadingCount = possibilities.indexOf(rolloffNum);
        // check the rolloff is valid
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(cascadingCount !== -1, `rolloff can only be ${possibilities.join(", ")}`);
        cascadingCount += 1;
        this._rolloff = rolloffNum;
        this.input.disconnect();
        this._filters.forEach((filter)=>filter.disconnect());
        this._filters = new Array(cascadingCount);
        for(let count = 0; count < cascadingCount; count++){
            const filter = new (0, $94fd137bb655066f$export$26bbc35c91a15e23)({
                context: this.context
            });
            filter.type = this._type;
            this.frequency.connect(filter.frequency);
            this.detune.connect(filter.detune);
            this.Q.connect(filter.Q);
            this.gain.connect(filter.gain);
            this._filters[count] = filter;
        }
        this._internalChannels = this._filters;
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, ...this._internalChannels, this.output);
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        const filterClone = new (0, $94fd137bb655066f$export$26bbc35c91a15e23)({
            frequency: this.frequency.value,
            gain: this.gain.value,
            Q: this.Q.value,
            type: this._type,
            detune: this.detune.value
        });
        // start with all 1s
        const totalResponse = new Float32Array(len).map(()=>1);
        this._filters.forEach(()=>{
            const response = filterClone.getFrequencyResponse(len);
            response.forEach((val, i)=>totalResponse[i] *= val);
        });
        filterClone.dispose();
        return totalResponse;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._filters.forEach((filter)=>{
            filter.dispose();
        });
        (0, $8cce0c9e2019bc8a$export$e6d3eada50a007b1)(this, [
            "detune",
            "frequency",
            "gain",
            "Q"
        ]);
        this.frequency.dispose();
        this.Q.dispose();
        this.detune.dispose();
        this.gain.dispose();
        return this;
    }
}












class $579c7c7246f4d95f$export$46ffd25e6533b005 extends (0, $213294b6acd7c6a9$export$4e2d65a9843399df) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($579c7c7246f4d95f$export$46ffd25e6533b005.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]));
        this.name = "FrequencyEnvelope";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($579c7c7246f4d95f$export$46ffd25e6533b005.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]);
        this._octaves = options.octaves;
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._exponent = this.input = new (0, $4603e249f478b841$export$ce28d653ec559ee)({
            context: this.context,
            value: options.exponent
        });
        this._scale = this.output = new (0, $d4646d969ab22afc$export$d60cfc58d3c358b6)({
            context: this.context,
            min: this._baseFrequency,
            max: this._baseFrequency * Math.pow(2, this._octaves)
        });
        this._sig.chain(this._exponent, this._scale);
    }
    static getDefaults() {
        return Object.assign((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), {
            baseFrequency: 200,
            exponent: 1,
            octaves: 4
        });
    }
    /**
     * The envelope's minimum output value. This is the value which it
     * starts at.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(min) {
        const freq = this.toFrequency(min);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(freq, 0);
        this._baseFrequency = freq;
        this._scale.min = this._baseFrequency;
        // update the max value when the min changes
        this.octaves = this._octaves;
    }
    /**
     * The number of octaves above the baseFrequency that the
     * envelope will scale to.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        this._scale.max = this._baseFrequency * Math.pow(2, octaves);
    }
    /**
     * The envelope's exponent value.
     */ get exponent() {
        return this._exponent.value;
    }
    set exponent(exponent) {
        this._exponent.value = exponent;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._exponent.dispose();
        this._scale.dispose();
        return this;
    }
}



class $e9a7ff7284664907$export$319ecdcd955e80a7 extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e9a7ff7284664907$export$319ecdcd955e80a7.getDefaults(), arguments));
        this.name = "MonoSynth";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e9a7ff7284664907$export$319ecdcd955e80a7.getDefaults(), arguments);
        this.oscillator = new (0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d)(Object.assign(options.oscillator, {
            context: this.context,
            detune: options.detune,
            onstop: ()=>this.onsilence(this)
        }));
        this.frequency = this.oscillator.frequency;
        this.detune = this.oscillator.detune;
        this.filter = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)(Object.assign(options.filter, {
            context: this.context
        }));
        this.filterEnvelope = new (0, $579c7c7246f4d95f$export$46ffd25e6533b005)(Object.assign(options.filterEnvelope, {
            context: this.context
        }));
        this.envelope = new (0, $30aa93da9543c1e0$export$e04e0eedd8192587)(Object.assign(options.envelope, {
            context: this.context
        }));
        // connect the oscillators to the output
        this.oscillator.chain(this.filter, this.envelope, this.output);
        // connect the filter envelope
        this.filterEnvelope.connect(this.filter.frequency);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "oscillator",
            "frequency",
            "detune",
            "filter",
            "filterEnvelope",
            "envelope"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.005,
                decay: 0.1,
                release: 1,
                sustain: 0.9
            }),
            filter: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $a487e4b525eb8039$export$ec91da630f36d5ea).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                Q: 1,
                rolloff: -12,
                type: "lowpass"
            }),
            filterEnvelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $579c7c7246f4d95f$export$46ffd25e6533b005).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.6,
                baseFrequency: 200,
                decay: 0.2,
                exponent: 2,
                octaves: 3,
                release: 2,
                sustain: 0.5
            }),
            oscillator: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d).getDefaults(), Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults())), {
                type: "sawtooth"
            })
        });
    }
    /**
     * start the attack portion of the envelope
     * @param time the time the attack should start
     * @param velocity the velocity of the note (0-1)
     */ _triggerEnvelopeAttack(time, velocity = 1) {
        this.envelope.triggerAttack(time, velocity);
        this.filterEnvelope.triggerAttack(time);
        this.oscillator.start(time);
        if (this.envelope.sustain === 0) {
            const computedAttack = this.toSeconds(this.envelope.attack);
            const computedDecay = this.toSeconds(this.envelope.decay);
            this.oscillator.stop(time + computedAttack + computedDecay);
        }
    }
    /**
     * start the release portion of the envelope
     * @param time the time the release should start
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this.filterEnvelope.triggerRelease(time);
        this.oscillator.stop(time + this.toSeconds(this.envelope.release));
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    dispose() {
        super.dispose();
        this.oscillator.dispose();
        this.envelope.dispose();
        this.filterEnvelope.dispose();
        this.filter.dispose();
        return this;
    }
}








class $4128ede587292e91$export$374aff340bb3ea08 extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4128ede587292e91$export$374aff340bb3ea08.getDefaults(), arguments));
        this.name = "DuoSynth";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4128ede587292e91$export$374aff340bb3ea08.getDefaults(), arguments);
        this.voice0 = new (0, $e9a7ff7284664907$export$319ecdcd955e80a7)(Object.assign(options.voice0, {
            context: this.context,
            onsilence: ()=>this.onsilence(this)
        }));
        this.voice1 = new (0, $e9a7ff7284664907$export$319ecdcd955e80a7)(Object.assign(options.voice1, {
            context: this.context
        }));
        this.harmonicity = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        this._vibrato = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            frequency: options.vibratoRate,
            context: this.context,
            min: -50,
            max: 50
        });
        // start the vibrato immediately
        this._vibrato.start();
        this.vibratoRate = this._vibrato.frequency;
        this._vibratoGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            units: "normalRange",
            gain: options.vibratoAmount
        });
        this.vibratoAmount = this._vibratoGain.gain;
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: 440
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        // control the two voices frequency
        this.frequency.connect(this.voice0.frequency);
        this.frequency.chain(this.harmonicity, this.voice1.frequency);
        this._vibrato.connect(this._vibratoGain);
        this._vibratoGain.fan(this.voice0.detune, this.voice1.detune);
        this.detune.fan(this.voice0.detune, this.voice1.detune);
        this.voice0.connect(this.output);
        this.voice1.connect(this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "voice0",
            "voice1",
            "frequency",
            "vibratoAmount",
            "vibratoRate"
        ]);
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.voice0.envelope.getValueAtTime(time) + this.voice1.envelope.getValueAtTime(time);
    }
    static getDefaults() {
        return (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            vibratoAmount: 0.5,
            vibratoRate: 5,
            harmonicity: 1.5,
            voice0: (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $e9a7ff7284664907$export$319ecdcd955e80a7).getDefaults(), Object.keys((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults())), {
                filterEnvelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                },
                envelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                }
            }),
            voice1: (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $e9a7ff7284664907$export$319ecdcd955e80a7).getDefaults(), Object.keys((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults())), {
                filterEnvelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                },
                envelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                }
            })
        });
    }
    /**
     * Trigger the attack portion of the note
     */ _triggerEnvelopeAttack(time, velocity) {
        // @ts-ignore
        this.voice0._triggerEnvelopeAttack(time, velocity);
        // @ts-ignore
        this.voice1._triggerEnvelopeAttack(time, velocity);
    }
    /**
     * Trigger the release portion of the note
     */ _triggerEnvelopeRelease(time) {
        // @ts-ignore
        this.voice0._triggerEnvelopeRelease(time);
        // @ts-ignore
        this.voice1._triggerEnvelopeRelease(time);
        return this;
    }
    dispose() {
        super.dispose();
        this.voice0.dispose();
        this.voice1.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this._vibrato.dispose();
        this.vibratoRate.dispose();
        this._vibratoGain.dispose();
        this.harmonicity.dispose();
        return this;
    }
}





class $f30c7049d881fb2b$export$45372df7fab1f04e extends (0, $18ec96681065c3f1$export$aee9425caad4bd7e) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f30c7049d881fb2b$export$45372df7fab1f04e.getDefaults(), arguments));
        this.name = "FMSynth";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f30c7049d881fb2b$export$45372df7fab1f04e.getDefaults(), arguments);
        this.modulationIndex = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: options.modulationIndex
        });
        // control the two voices frequency
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.frequency.chain(this.modulationIndex, this._modulationNode);
        this.detune.fan(this._carrier.detune, this._modulator.detune);
        this._modulator.connect(this._modulationNode.gain);
        this._modulationNode.connect(this._carrier.frequency);
        this._carrier.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $18ec96681065c3f1$export$aee9425caad4bd7e).getDefaults(), {
            modulationIndex: 10
        });
    }
    dispose() {
        super.dispose();
        this.modulationIndex.dispose();
        return this;
    }
}













/**
 * Inharmonic ratio of frequencies based on the Roland TR-808
 * Taken from https://ccrma.stanford.edu/papers/tr-808-cymbal-physically-informed-circuit-bendable-digital-model
 */ const $5f95d88511c29e38$var$inharmRatios = [
    1.0,
    1.483,
    1.932,
    2.546,
    2.630,
    3.897
];
class $5f95d88511c29e38$export$65cb3eae8bee686d extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5f95d88511c29e38$export$65cb3eae8bee686d.getDefaults(), arguments));
        this.name = "MetalSynth";
        /**
         * The array of FMOscillators
         */ this._oscillators = [];
        /**
         * The frequency multipliers
         */ this._freqMultipliers = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5f95d88511c29e38$export$65cb3eae8bee686d.getDefaults(), arguments);
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency"
        });
        this._amplitude = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        }).connect(this.output);
        this._highpass = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            // Q: -3.0102999566398125,
            Q: 0,
            context: this.context,
            type: "highpass"
        }).connect(this._amplitude);
        for(let i = 0; i < $5f95d88511c29e38$var$inharmRatios.length; i++){
            const osc = new (0, $87e8e716b583ad3c$export$3055866937a7451d)({
                context: this.context,
                harmonicity: options.harmonicity,
                modulationIndex: options.modulationIndex,
                modulationType: "square",
                onstop: i === 0 ? ()=>this.onsilence(this) : (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
                type: "square"
            });
            osc.connect(this._highpass);
            this._oscillators[i] = osc;
            const mult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
                context: this.context,
                value: $5f95d88511c29e38$var$inharmRatios[i]
            });
            this._freqMultipliers[i] = mult;
            this.frequency.chain(mult, osc.frequency);
            this.detune.connect(osc.detune);
        }
        this._filterFreqScaler = new (0, $d4646d969ab22afc$export$d60cfc58d3c358b6)({
            context: this.context,
            max: 7000,
            min: this.toFrequency(options.resonance)
        });
        this.envelope = new (0, $213294b6acd7c6a9$export$4e2d65a9843399df)({
            attack: options.envelope.attack,
            attackCurve: "linear",
            context: this.context,
            decay: options.envelope.decay,
            release: options.envelope.release,
            sustain: 0
        });
        this.envelope.chain(this._filterFreqScaler, this._highpass.frequency);
        this.envelope.connect(this._amplitude.gain);
        // set the octaves
        this._octaves = options.octaves;
        this.octaves = options.octaves;
    }
    static getDefaults() {
        return (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.001,
                decay: 1.4,
                release: 0.2
            }),
            harmonicity: 5.1,
            modulationIndex: 32,
            octaves: 1.5,
            resonance: 4000
        });
    }
    /**
     * Trigger the attack.
     * @param time When the attack should be triggered.
     * @param velocity The velocity that the envelope should be triggered at.
     */ _triggerEnvelopeAttack(time, velocity = 1) {
        this.envelope.triggerAttack(time, velocity);
        this._oscillators.forEach((osc)=>osc.start(time));
        if (this.envelope.sustain === 0) this._oscillators.forEach((osc)=>{
            osc.stop(time + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay));
        });
        return this;
    }
    /**
     * Trigger the release of the envelope.
     * @param time When the release should be triggered.
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this._oscillators.forEach((osc)=>osc.stop(time + this.toSeconds(this.envelope.release)));
        return this;
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    /**
     * The modulationIndex of the oscillators which make up the source.
     * see [[FMOscillator.modulationIndex]]
     * @min 1
     * @max 100
     */ get modulationIndex() {
        return this._oscillators[0].modulationIndex.value;
    }
    set modulationIndex(val) {
        this._oscillators.forEach((osc)=>osc.modulationIndex.value = val);
    }
    /**
     * The harmonicity of the oscillators which make up the source.
     * see Tone.FMOscillator.harmonicity
     * @min 0.1
     * @max 10
     */ get harmonicity() {
        return this._oscillators[0].harmonicity.value;
    }
    set harmonicity(val) {
        this._oscillators.forEach((osc)=>osc.harmonicity.value = val);
    }
    /**
     * The lower level of the highpass filter which is attached to the envelope.
     * This value should be between [0, 7000]
     * @min 0
     * @max 7000
     */ get resonance() {
        return this._filterFreqScaler.min;
    }
    set resonance(val) {
        this._filterFreqScaler.min = this.toFrequency(val);
        this.octaves = this._octaves;
    }
    /**
     * The number of octaves above the "resonance" frequency
     * that the filter ramps during the attack/decay envelope
     * @min 0
     * @max 8
     */ get octaves() {
        return this._octaves;
    }
    set octaves(val) {
        this._octaves = val;
        this._filterFreqScaler.max = this._filterFreqScaler.min * Math.pow(2, val);
    }
    dispose() {
        super.dispose();
        this._oscillators.forEach((osc)=>osc.dispose());
        this._freqMultipliers.forEach((freqMult)=>freqMult.dispose());
        this.frequency.dispose();
        this.detune.dispose();
        this._filterFreqScaler.dispose();
        this._amplitude.dispose();
        this.envelope.dispose();
        this._highpass.dispose();
        return this;
    }
}









class $faf53c8844563a8e$export$e4f4b32b2e74f0e2 extends (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faf53c8844563a8e$export$e4f4b32b2e74f0e2.getDefaults(), arguments));
        this.name = "MembraneSynth";
        /**
         * Portamento is ignored in this synth. use pitch decay instead.
         */ this.portamento = 0;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faf53c8844563a8e$export$e4f4b32b2e74f0e2.getDefaults(), arguments);
        this.pitchDecay = options.pitchDecay;
        this.octaves = options.octaves;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "oscillator",
            "envelope"
        ]);
    }
    static getDefaults() {
        return (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70).getDefaults(), {
            envelope: {
                attack: 0.001,
                attackCurve: "exponential",
                decay: 0.4,
                release: 1.4,
                sustain: 0.01
            },
            octaves: 10,
            oscillator: {
                type: "sine"
            },
            pitchDecay: 0.05
        });
    }
    setNote(note, time) {
        const seconds = this.toSeconds(time);
        const hertz = this.toFrequency(note instanceof (0, $f4d7193118bd1d27$export$38b56155c8552868) ? note.toFrequency() : note);
        const maxNote = hertz * this.octaves;
        this.oscillator.frequency.setValueAtTime(maxNote, seconds);
        this.oscillator.frequency.exponentialRampToValueAtTime(hertz, seconds + this.toSeconds(this.pitchDecay));
        return this;
    }
    dispose() {
        super.dispose();
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$d02631cccf789723)(0)
], $faf53c8844563a8e$export$e4f4b32b2e74f0e2.prototype, "octaves", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $faf53c8844563a8e$export$e4f4b32b2e74f0e2.prototype, "pitchDecay", void 0);










class $8d503f33efd2345b$export$a0d6f4d32fd5959 extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8d503f33efd2345b$export$a0d6f4d32fd5959.getDefaults(), arguments));
        this.name = "NoiseSynth";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8d503f33efd2345b$export$a0d6f4d32fd5959.getDefaults(), arguments);
        this.noise = new (0, $93a0a7e8f19a773f$export$484d33a0500a4ce1)(Object.assign({
            context: this.context
        }, options.noise));
        this.envelope = new (0, $30aa93da9543c1e0$export$e04e0eedd8192587)(Object.assign({
            context: this.context
        }, options.envelope));
        // connect the noise to the output
        this.noise.chain(this.envelope, this.output);
    }
    static getDefaults() {
        return Object.assign((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                decay: 0.1,
                sustain: 0.0
            }),
            noise: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $93a0a7e8f19a773f$export$484d33a0500a4ce1).getDefaults(), Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults())), {
                type: "white"
            })
        });
    }
    /**
     * Start the attack portion of the envelopes. Unlike other
     * instruments, Tone.NoiseSynth doesn't have a note.
     * @example
     * const noiseSynth = new Tone.NoiseSynth().toDestination();
     * noiseSynth.triggerAttack();
     */ triggerAttack(time, velocity = 1) {
        time = this.toSeconds(time);
        // the envelopes
        this.envelope.triggerAttack(time, velocity);
        // start the noise
        this.noise.start(time);
        if (this.envelope.sustain === 0) this.noise.stop(time + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay));
        return this;
    }
    /**
     * Start the release portion of the envelopes.
     */ triggerRelease(time) {
        time = this.toSeconds(time);
        this.envelope.triggerRelease(time);
        this.noise.stop(time + this.toSeconds(this.envelope.release));
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 0);
            this._syncMethod("triggerRelease", 0);
        }
        return this;
    }
    triggerAttackRelease(duration, time, velocity = 1) {
        time = this.toSeconds(time);
        duration = this.toSeconds(duration);
        this.triggerAttack(time, velocity);
        this.triggerRelease(time + duration);
        return this;
    }
    dispose() {
        super.dispose();
        this.noise.dispose();
        this.envelope.dispose();
        return this;
    }
}











/**
 * All of the classes or functions which are loaded into the AudioWorkletGlobalScope
 */ const $084f2c4e06bfb0e6$var$workletContext = new Set();
function $084f2c4e06bfb0e6$export$4332289150d1c155(classOrFunction) {
    $084f2c4e06bfb0e6$var$workletContext.add(classOrFunction);
}
function $084f2c4e06bfb0e6$export$d575e6557ac1729f(name, classDesc) {
    const processor = /* javascript */ `registerProcessor("${name}", ${classDesc})`;
    $084f2c4e06bfb0e6$var$workletContext.add(processor);
}
function $084f2c4e06bfb0e6$export$b2ba7b9987bb8e81() {
    return Array.from($084f2c4e06bfb0e6$var$workletContext).join("\n");
}


class $ab96f0673d65b5e9$export$212d912bd0512eff extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        this.name = "ToneAudioWorklet";
        /**
         * The constructor options for the node
         */ this.workletOptions = {};
        /**
         * Callback which is invoked when there is an error in the processing
         */ this.onprocessorerror = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        const blobUrl = URL.createObjectURL(new Blob([
            (0, $084f2c4e06bfb0e6$export$b2ba7b9987bb8e81)()
        ], {
            type: "text/javascript"
        }));
        const name = this._audioWorkletName();
        this._dummyGain = this.context.createGain();
        this._dummyParam = this._dummyGain.gain;
        // Register the processor
        this.context.addAudioWorkletModule(blobUrl, name).then(()=>{
            // create the worklet when it's read
            if (!this.disposed) {
                this._worklet = this.context.createAudioWorkletNode(name, this.workletOptions);
                this._worklet.onprocessorerror = this.onprocessorerror.bind(this);
                this.onReady(this._worklet);
            }
        });
    }
    dispose() {
        super.dispose();
        this._dummyGain.disconnect();
        if (this._worklet) {
            this._worklet.port.postMessage("dispose");
            this._worklet.disconnect();
        }
        return this;
    }
}



const $e1d40bd789b6f49f$var$toneAudioWorkletProcessor = /* javascript */ `
	/**
	 * The base AudioWorkletProcessor for use in Tone.js. Works with the [[ToneAudioWorklet]]. 
	 */
	class ToneAudioWorkletProcessor extends AudioWorkletProcessor {

		constructor(options) {
			
			super(options);
			/**
			 * If the processor was disposed or not. Keep alive until it's disposed.
			 */
			this.disposed = false;
		   	/** 
			 * The number of samples in the processing block
			 */
			this.blockSize = 128;
			/**
			 * the sample rate
			 */
			this.sampleRate = sampleRate;

			this.port.onmessage = (event) => {
				// when it receives a dispose 
				if (event.data === "dispose") {
					this.disposed = true;
				}
			};
		}
	}
`;
(0, $084f2c4e06bfb0e6$export$4332289150d1c155)($e1d40bd789b6f49f$var$toneAudioWorkletProcessor);



const $bc3c048ac4b8ecdc$export$3821b1427992e4a0 = /* javascript */ `
	/**
	 * Abstract class for a single input/output processor. 
	 * has a 'generate' function which processes one sample at a time
	 */
	class SingleIOProcessor extends ToneAudioWorkletProcessor {

		constructor(options) {
			super(Object.assign(options, {
				numberOfInputs: 1,
				numberOfOutputs: 1
			}));
			/**
			 * Holds the name of the parameter and a single value of that
			 * parameter at the current sample
			 * @type { [name: string]: number }
			 */
			this.params = {}
		}

		/**
		 * Generate an output sample from the input sample and parameters
		 * @abstract
		 * @param input number
		 * @param channel number
		 * @param parameters { [name: string]: number }
		 * @returns number
		 */
		generate(){}

		/**
		 * Update the private params object with the 
		 * values of the parameters at the given index
		 * @param parameters { [name: string]: Float32Array },
		 * @param index number
		 */
		updateParams(parameters, index) {
			for (const paramName in parameters) {
				const param = parameters[paramName];
				if (param.length > 1) {
					this.params[paramName] = parameters[paramName][index];
				} else {
					this.params[paramName] = parameters[paramName][0];
				}
			}
		}

		/**
		 * Process a single frame of the audio
		 * @param inputs Float32Array[][]
		 * @param outputs Float32Array[][]
		 */
		process(inputs, outputs, parameters) {
			const input = inputs[0];
			const output = outputs[0];
			// get the parameter values
			const channelCount = Math.max(input && input.length || 0, output.length);
			for (let sample = 0; sample < this.blockSize; sample++) {
				this.updateParams(parameters, sample);
				for (let channel = 0; channel < channelCount; channel++) {
					const inputSample = input && input.length ? input[channel][sample] : 0;
					output[channel][sample] = this.generate(inputSample, channel, this.params);
				}
			}
			return !this.disposed;
		}
	};
`;
(0, $084f2c4e06bfb0e6$export$4332289150d1c155)($bc3c048ac4b8ecdc$export$3821b1427992e4a0);



const $70e2730250c9764e$var$delayLine = /* javascript */ `
	/**
	 * A multichannel buffer for use within an AudioWorkletProcessor as a delay line
	 */
	class DelayLine {
		
		constructor(size, channels) {
			this.buffer = [];
			this.writeHead = []
			this.size = size;

			// create the empty channels
			for (let i = 0; i < channels; i++) {
				this.buffer[i] = new Float32Array(this.size);
				this.writeHead[i] = 0;
			}
		}

		/**
		 * Push a value onto the end
		 * @param channel number
		 * @param value number
		 */
		push(channel, value) {
			this.writeHead[channel] += 1;
			if (this.writeHead[channel] > this.size) {
				this.writeHead[channel] = 0;
			}
			this.buffer[channel][this.writeHead[channel]] = value;
		}

		/**
		 * Get the recorded value of the channel given the delay
		 * @param channel number
		 * @param delay number delay samples
		 */
		get(channel, delay) {
			let readHead = this.writeHead[channel] - Math.floor(delay);
			if (readHead < 0) {
				readHead += this.size;
			}
			return this.buffer[channel][readHead];
		}
	}
`;
(0, $084f2c4e06bfb0e6$export$4332289150d1c155)($70e2730250c9764e$var$delayLine);



const $ad03077e589cae9c$export$85343ada6050a795 = "feedback-comb-filter";
const $ad03077e589cae9c$var$feedbackCombFilter = /* javascript */ `
	class FeedbackCombFilterWorklet extends SingleIOProcessor {

		constructor(options) {
			super(options);
			this.delayLine = new DelayLine(this.sampleRate, options.channelCount || 2);
		}

		static get parameterDescriptors() {
			return [{
				name: "delayTime",
				defaultValue: 0.1,
				minValue: 0,
				maxValue: 1,
				automationRate: "k-rate"
			}, {
				name: "feedback",
				defaultValue: 0.5,
				minValue: 0,
				maxValue: 0.9999,
				automationRate: "k-rate"
			}];
		}

		generate(input, channel, parameters) {
			const delayedSample = this.delayLine.get(channel, parameters.delayTime * this.sampleRate);
			this.delayLine.push(channel, input + delayedSample * parameters.feedback);
			return delayedSample;
		}
	}
`;
(0, $084f2c4e06bfb0e6$export$d575e6557ac1729f)($ad03077e589cae9c$export$85343ada6050a795, $ad03077e589cae9c$var$feedbackCombFilter);


class $39e0d797402e4e21$export$e7a685a7e8ffb78a extends (0, $ab96f0673d65b5e9$export$212d912bd0512eff) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($39e0d797402e4e21$export$e7a685a7e8ffb78a.getDefaults(), arguments, [
            "delayTime",
            "resonance"
        ]));
        this.name = "FeedbackCombFilter";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($39e0d797402e4e21$export$e7a685a7e8ffb78a.getDefaults(), arguments, [
            "delayTime",
            "resonance"
        ]);
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.delayTime = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            value: options.delayTime,
            units: "time",
            minValue: 0,
            maxValue: 1,
            param: this._dummyParam,
            swappable: true
        });
        this.resonance = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            value: options.resonance,
            units: "normalRange",
            param: this._dummyParam,
            swappable: true
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "resonance",
            "delayTime"
        ]);
    }
    _audioWorkletName() {
        return 0, $ad03077e589cae9c$export$85343ada6050a795;
    }
    /**
     * The default parameters
     */ static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            delayTime: 0.1,
            resonance: 0.5
        });
    }
    onReady(node) {
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, node, this.output);
        const delayTime = node.parameters.get("delayTime");
        this.delayTime.setParam(delayTime);
        const feedback = node.parameters.get("feedback");
        this.resonance.setParam(feedback);
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.delayTime.dispose();
        this.resonance.dispose();
        return this;
    }
}





class $e96b9b836f8a5fb5$export$7961b18021b7c8c9 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e96b9b836f8a5fb5$export$7961b18021b7c8c9.getDefaults(), arguments, [
            "frequency",
            "type"
        ]));
        this.name = "OnePoleFilter";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e96b9b836f8a5fb5$export$7961b18021b7c8c9.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        this._frequency = options.frequency;
        this._type = options.type;
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._createFilter();
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            frequency: 880,
            type: "lowpass"
        });
    }
    /**
     * Create a filter and dispose the old one
     */ _createFilter() {
        const oldFilter = this._filter;
        const freq = this.toFrequency(this._frequency);
        const t = 1 / (2 * Math.PI * freq);
        if (this._type === "lowpass") {
            const a0 = 1 / (t * this.context.sampleRate);
            const b1 = a0 - 1;
            this._filter = this.context.createIIRFilter([
                a0,
                0
            ], [
                1,
                b1
            ]);
        } else {
            const b1 = 1 / (t * this.context.sampleRate) - 1;
            this._filter = this.context.createIIRFilter([
                1,
                -1
            ], [
                1,
                b1
            ]);
        }
        this.input.chain(this._filter, this.output);
        if (oldFilter) // dispose it on the next block
        this.context.setTimeout(()=>{
            if (!this.disposed) {
                this.input.disconnect(oldFilter);
                oldFilter.disconnect();
            }
        }, this.blockTime);
    }
    /**
     * The frequency value.
     */ get frequency() {
        return this._frequency;
    }
    set frequency(fq) {
        this._frequency = fq;
        this._createFilter();
    }
    /**
     * The OnePole Filter type, either "highpass" or "lowpass"
     */ get type() {
        return this._type;
    }
    set type(t) {
        this._type = t;
        this._createFilter();
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        const freqValues = new Float32Array(len);
        for(let i = 0; i < len; i++){
            const norm = Math.pow(i / len, 2);
            const freq = norm * 19980 + 20;
            freqValues[i] = freq;
        }
        const magValues = new Float32Array(len);
        const phaseValues = new Float32Array(len);
        this._filter.getFrequencyResponse(freqValues, magValues, phaseValues);
        return magValues;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this._filter.disconnect();
        return this;
    }
}


class $ef6d05ab4f866c0f$export$e83d2527589f5587 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($ef6d05ab4f866c0f$export$e83d2527589f5587.getDefaults(), arguments, [
            "delayTime",
            "resonance",
            "dampening"
        ]));
        this.name = "LowpassCombFilter";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($ef6d05ab4f866c0f$export$e83d2527589f5587.getDefaults(), arguments, [
            "delayTime",
            "resonance",
            "dampening"
        ]);
        this._combFilter = this.output = new (0, $39e0d797402e4e21$export$e7a685a7e8ffb78a)({
            context: this.context,
            delayTime: options.delayTime,
            resonance: options.resonance
        });
        this.delayTime = this._combFilter.delayTime;
        this.resonance = this._combFilter.resonance;
        this._lowpass = this.input = new (0, $e96b9b836f8a5fb5$export$7961b18021b7c8c9)({
            context: this.context,
            frequency: options.dampening,
            type: "lowpass"
        });
        // connections
        this._lowpass.connect(this._combFilter);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            dampening: 3000,
            delayTime: 0.1,
            resonance: 0.5
        });
    }
    /**
     * The dampening control of the feedback
     */ get dampening() {
        return this._lowpass.frequency;
    }
    set dampening(fq) {
        this._lowpass.frequency = fq;
    }
    dispose() {
        super.dispose();
        this._combFilter.dispose();
        this._lowpass.dispose();
        return this;
    }
}





class $0a4da90f1cd712fc$export$8334f51ae3f4c97e extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0a4da90f1cd712fc$export$8334f51ae3f4c97e.getDefaults(), arguments));
        this.name = "PluckSynth";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0a4da90f1cd712fc$export$8334f51ae3f4c97e.getDefaults(), arguments);
        this._noise = new (0, $93a0a7e8f19a773f$export$484d33a0500a4ce1)({
            context: this.context,
            type: "pink"
        });
        this.attackNoise = options.attackNoise;
        this._lfcf = new (0, $ef6d05ab4f866c0f$export$e83d2527589f5587)({
            context: this.context,
            dampening: options.dampening,
            resonance: options.resonance
        });
        this.resonance = options.resonance;
        this.release = options.release;
        this._noise.connect(this._lfcf);
        this._lfcf.connect(this.output);
    }
    static getDefaults() {
        return (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            attackNoise: 1,
            dampening: 4000,
            resonance: 0.7,
            release: 1
        });
    }
    /**
     * The dampening control. i.e. the lowpass filter frequency of the comb filter
     * @min 0
     * @max 7000
     */ get dampening() {
        return this._lfcf.dampening;
    }
    set dampening(fq) {
        this._lfcf.dampening = fq;
    }
    triggerAttack(note, time) {
        const freq = this.toFrequency(note);
        time = this.toSeconds(time);
        const delayAmount = 1 / freq;
        this._lfcf.delayTime.setValueAtTime(delayAmount, time);
        this._noise.start(time);
        this._noise.stop(time + delayAmount * this.attackNoise);
        this._lfcf.resonance.cancelScheduledValues(time);
        this._lfcf.resonance.setValueAtTime(this.resonance, time);
        return this;
    }
    /**
     * Ramp down the [[resonance]] to 0 over the duration of the release time.
     */ triggerRelease(time) {
        this._lfcf.resonance.linearRampTo(0, this.release, time);
        return this;
    }
    dispose() {
        super.dispose();
        this._noise.dispose();
        this._lfcf.dispose();
        return this;
    }
}








class $85ae9a076515912b$export$a7e98a317490a78b extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($85ae9a076515912b$export$a7e98a317490a78b.getDefaults(), arguments, [
            "voice",
            "options"
        ]));
        this.name = "PolySynth";
        /**
         * The voices which are not currently in use
         */ this._availableVoices = [];
        /**
         * The currently active voices
         */ this._activeVoices = [];
        /**
         * All of the allocated voices for this synth.
         */ this._voices = [];
        /**
         * The GC timeout. Held so that it could be cancelled when the node is disposed.
         */ this._gcTimeout = -1;
        /**
         * A moving average of the number of active voices
         */ this._averageActiveVoices = 0;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($85ae9a076515912b$export$a7e98a317490a78b.getDefaults(), arguments, [
            "voice",
            "options"
        ]);
        // check against the old API (pre 14.3.0)
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!(0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(options.voice), "DEPRECATED: The polyphony count is no longer the first argument.");
        const defaults = options.voice.getDefaults();
        this.options = Object.assign(defaults, options.options);
        this.voice = options.voice;
        this.maxPolyphony = options.maxPolyphony;
        // create the first voice
        this._dummyVoice = this._getNextAvailableVoice();
        // remove it from the voices list
        const index = this._voices.indexOf(this._dummyVoice);
        this._voices.splice(index, 1);
        // kick off the GC interval
        this._gcTimeout = this.context.setInterval(this._collectGarbage.bind(this), 1);
    }
    static getDefaults() {
        return Object.assign((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            maxPolyphony: 32,
            options: {},
            voice: (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70)
        });
    }
    /**
     * The number of active voices.
     */ get activeVoices() {
        return this._activeVoices.length;
    }
    /**
     * Invoked when the source is done making sound, so that it can be
     * readded to the pool of available voices
     */ _makeVoiceAvailable(voice) {
        this._availableVoices.push(voice);
        // remove the midi note from 'active voices'
        const activeVoiceIndex = this._activeVoices.findIndex((e)=>e.voice === voice);
        this._activeVoices.splice(activeVoiceIndex, 1);
    }
    /**
     * Get an available voice from the pool of available voices.
     * If one is not available and the maxPolyphony limit is reached,
     * steal a voice, otherwise return null.
     */ _getNextAvailableVoice() {
        // if there are available voices, return the first one
        if (this._availableVoices.length) return this._availableVoices.shift();
        else if (this._voices.length < this.maxPolyphony) {
            // otherwise if there is still more maxPolyphony, make a new voice
            const voice = new this.voice(Object.assign(this.options, {
                context: this.context,
                onsilence: this._makeVoiceAvailable.bind(this)
            }));
            voice.connect(this.output);
            this._voices.push(voice);
            return voice;
        } else (0, $afc9146c77d080c2$export$c106dd0671a0fc2d)("Max polyphony exceeded. Note dropped.");
    }
    /**
     * Occasionally check if there are any allocated voices which can be cleaned up.
     */ _collectGarbage() {
        this._averageActiveVoices = Math.max(this._averageActiveVoices * 0.95, this.activeVoices);
        if (this._availableVoices.length && this._voices.length > Math.ceil(this._averageActiveVoices + 1)) {
            // take off an available note
            const firstAvail = this._availableVoices.shift();
            const index = this._voices.indexOf(firstAvail);
            this._voices.splice(index, 1);
            if (!this.context.isOffline) firstAvail.dispose();
        }
    }
    /**
     * Internal method which triggers the attack
     */ _triggerAttack(notes, time, velocity) {
        notes.forEach((note)=>{
            const midiNote = new (0, $acb4e2b4a4f69a23$export$266cef4b055bf7de)(this.context, note).toMidi();
            const voice = this._getNextAvailableVoice();
            if (voice) {
                voice.triggerAttack(note, time, velocity);
                this._activeVoices.push({
                    midi: midiNote,
                    voice: voice,
                    released: false
                });
                this.log("triggerAttack", note, time);
            }
        });
    }
    /**
     * Internal method which triggers the release
     */ _triggerRelease(notes, time) {
        notes.forEach((note)=>{
            const midiNote = new (0, $acb4e2b4a4f69a23$export$266cef4b055bf7de)(this.context, note).toMidi();
            const event = this._activeVoices.find(({ midi: midi, released: released })=>midi === midiNote && !released);
            if (event) {
                // trigger release on that note
                event.voice.triggerRelease(time);
                // mark it as released
                event.released = true;
                this.log("triggerRelease", note, time);
            }
        });
    }
    /**
     * Schedule the attack/release events. If the time is in the future, then it should set a timeout
     * to wait for just-in-time scheduling
     */ _scheduleEvent(type, notes, time, velocity) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this.disposed, "Synth was already disposed");
        // if the notes are greater than this amount of time in the future, they should be scheduled with setTimeout
        if (time <= this.now()) {
            // do it immediately
            if (type === "attack") this._triggerAttack(notes, time, velocity);
            else this._triggerRelease(notes, time);
        } else // schedule it to start in the future
        this.context.setTimeout(()=>{
            this._scheduleEvent(type, notes, time, velocity);
        }, time - this.now());
    }
    /**
     * Trigger the attack portion of the note
     * @param  notes The notes to play. Accepts a single Frequency or an array of frequencies.
     * @param  time  The start time of the note.
     * @param velocity The velocity of the note.
     * @example
     * const synth = new Tone.PolySynth(Tone.FMSynth).toDestination();
     * // trigger a chord immediately with a velocity of 0.2
     * synth.triggerAttack(["Ab3", "C4", "F5"], Tone.now(), 0.2);
     */ triggerAttack(notes, time, velocity) {
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        const computedTime = this.toSeconds(time);
        this._scheduleEvent("attack", notes, computedTime, velocity);
        return this;
    }
    /**
     * Trigger the release of the note. Unlike monophonic instruments,
     * a note (or array of notes) needs to be passed in as the first argument.
     * @param  notes The notes to play. Accepts a single Frequency or an array of frequencies.
     * @param  time  When the release will be triggered.
     * @example
     * @example
     * const poly = new Tone.PolySynth(Tone.AMSynth).toDestination();
     * poly.triggerAttack(["Ab3", "C4", "F5"]);
     * // trigger the release of the given notes.
     * poly.triggerRelease(["Ab3", "C4"], "+1");
     * poly.triggerRelease("F5", "+3");
     */ triggerRelease(notes, time) {
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        const computedTime = this.toSeconds(time);
        this._scheduleEvent("release", notes, computedTime);
        return this;
    }
    /**
     * Trigger the attack and release after the specified duration
     * @param  notes The notes to play. Accepts a single  Frequency or an array of frequencies.
     * @param  duration the duration of the note
     * @param  time  if no time is given, defaults to now
     * @param  velocity the velocity of the attack (0-1)
     * @example
     * const poly = new Tone.PolySynth(Tone.AMSynth).toDestination();
     * // can pass in an array of durations as well
     * poly.triggerAttackRelease(["Eb3", "G4", "Bb4", "D5"], [4, 3, 2, 1]);
     */ triggerAttackRelease(notes, duration, time, velocity) {
        const computedTime = this.toSeconds(time);
        this.triggerAttack(notes, computedTime, velocity);
        if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(duration)) {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(notes), "If the duration is an array, the notes must also be an array");
            notes;
            for(let i = 0; i < notes.length; i++){
                const d = duration[Math.min(i, duration.length - 1)];
                const durationSeconds = this.toSeconds(d);
                (0, $afc9146c77d080c2$export$a7a9523472993e97)(durationSeconds > 0, "The duration must be greater than 0");
                this.triggerRelease(notes[i], computedTime + durationSeconds);
            }
        } else {
            const durationSeconds = this.toSeconds(duration);
            (0, $afc9146c77d080c2$export$a7a9523472993e97)(durationSeconds > 0, "The duration must be greater than 0");
            this.triggerRelease(notes, computedTime + durationSeconds);
        }
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 1);
        }
        return this;
    }
    /**
     * Set a member/attribute of the voices
     * @example
     * const poly = new Tone.PolySynth().toDestination();
     * // set all of the voices using an options object for the synth type
     * poly.set({
     * 	envelope: {
     * 		attack: 0.25
     * 	}
     * });
     * poly.triggerAttackRelease("Bb3", 0.2);
     */ set(options) {
        // remove options which are controlled by the PolySynth
        const sanitizedOptions = (0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)(options, [
            "onsilence",
            "context"
        ]);
        // store all of the options
        this.options = (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)(this.options, sanitizedOptions);
        this._voices.forEach((voice)=>voice.set(sanitizedOptions));
        this._dummyVoice.set(sanitizedOptions);
        return this;
    }
    get() {
        return this._dummyVoice.get();
    }
    /**
     * Trigger the release portion of all the currently active voices immediately.
     * Useful for silencing the synth.
     */ releaseAll(time) {
        const computedTime = this.toSeconds(time);
        this._activeVoices.forEach(({ voice: voice })=>{
            voice.triggerRelease(computedTime);
        });
        return this;
    }
    dispose() {
        super.dispose();
        this._dummyVoice.dispose();
        this._voices.forEach((v)=>v.dispose());
        this._activeVoices = [];
        this._availableVoices = [];
        this.context.clearInterval(this._gcTimeout);
        return this;
    }
}













class $f2139aa45d11abc9$export$322f102bec719b22 extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f2139aa45d11abc9$export$322f102bec719b22.getDefaults(), arguments, [
            "urls",
            "onload",
            "baseUrl"
        ], "urls"));
        this.name = "Sampler";
        /**
         * The object of all currently playing BufferSources
         */ this._activeSources = new Map();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f2139aa45d11abc9$export$322f102bec719b22.getDefaults(), arguments, [
            "urls",
            "onload",
            "baseUrl"
        ], "urls");
        const urlMap = {};
        Object.keys(options.urls).forEach((note)=>{
            const noteNumber = parseInt(note, 10);
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4dcca4501f2037f9)(note) || (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(noteNumber) && isFinite(noteNumber), `url key is neither a note or midi pitch: ${note}`);
            if ((0, $4d7f709c9ffa5105$export$4dcca4501f2037f9)(note)) {
                // convert the note name to MIDI
                const mid = new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, note).toMidi();
                urlMap[mid] = options.urls[note];
            } else if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(noteNumber) && isFinite(noteNumber)) // otherwise if it's numbers assume it's midi
            urlMap[noteNumber] = options.urls[noteNumber];
        });
        this._buffers = new (0, $d37bb61f6ec53d08$export$7232b969b571e570)({
            urls: urlMap,
            onload: options.onload,
            baseUrl: options.baseUrl,
            onerror: options.onerror
        });
        this.attack = options.attack;
        this.release = options.release;
        this.curve = options.curve;
        // invoke the callback if it's already loaded
        if (this._buffers.loaded) // invoke onload deferred
        Promise.resolve().then(options.onload);
    }
    static getDefaults() {
        return Object.assign((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            attack: 0,
            baseUrl: "",
            curve: "exponential",
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            release: 0.1,
            urls: {}
        });
    }
    /**
     * Returns the difference in steps between the given midi note at the closets sample.
     */ _findClosest(midi) {
        // searches within 8 octaves of the given midi note
        const MAX_INTERVAL = 96;
        let interval = 0;
        while(interval < MAX_INTERVAL){
            // check above and below
            if (this._buffers.has(midi + interval)) return -interval;
            else if (this._buffers.has(midi - interval)) return interval;
            interval++;
        }
        throw new Error(`No available buffers for note: ${midi}`);
    }
    /**
     * @param  notes	The note to play, or an array of notes.
     * @param  time     When to play the note
     * @param  velocity The velocity to play the sample back.
     */ triggerAttack(notes, time, velocity = 1) {
        this.log("triggerAttack", notes, time, velocity);
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        notes.forEach((note)=>{
            const midiFloat = (0, $84c2af7dbf01a14d$export$12513e46625518e4)(new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, note).toFrequency());
            const midi = Math.round(midiFloat);
            const remainder = midiFloat - midi;
            // find the closest note pitch
            const difference = this._findClosest(midi);
            const closestNote = midi - difference;
            const buffer = this._buffers.get(closestNote);
            const playbackRate = (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(difference + remainder);
            // play that note
            const source = new (0, $faf7c8e078303879$export$30cbf4ba14db4fdd)({
                url: buffer,
                context: this.context,
                curve: this.curve,
                fadeIn: this.attack,
                fadeOut: this.release,
                playbackRate: playbackRate
            }).connect(this.output);
            source.start(time, 0, buffer.duration / playbackRate, velocity);
            // add it to the active sources
            if (!(0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(this._activeSources.get(midi))) this._activeSources.set(midi, []);
            this._activeSources.get(midi).push(source);
            // remove it when it's done
            source.onended = ()=>{
                if (this._activeSources && this._activeSources.has(midi)) {
                    const sources = this._activeSources.get(midi);
                    const index = sources.indexOf(source);
                    if (index !== -1) sources.splice(index, 1);
                }
            };
        });
        return this;
    }
    /**
     * @param  notes	The note to release, or an array of notes.
     * @param  time     	When to release the note.
     */ triggerRelease(notes, time) {
        this.log("triggerRelease", notes, time);
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        notes.forEach((note)=>{
            const midi = new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, note).toMidi();
            // find the note
            if (this._activeSources.has(midi) && this._activeSources.get(midi).length) {
                const sources = this._activeSources.get(midi);
                time = this.toSeconds(time);
                sources.forEach((source)=>{
                    source.stop(time);
                });
                this._activeSources.set(midi, []);
            }
        });
        return this;
    }
    /**
     * Release all currently active notes.
     * @param  time     	When to release the notes.
     */ releaseAll(time) {
        const computedTime = this.toSeconds(time);
        this._activeSources.forEach((sources)=>{
            while(sources.length){
                const source = sources.shift();
                source.stop(computedTime);
            }
        });
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 1);
        }
        return this;
    }
    /**
     * Invoke the attack phase, then after the duration, invoke the release.
     * @param  notes	The note to play and release, or an array of notes.
     * @param  duration The time the note should be held
     * @param  time     When to start the attack
     * @param  velocity The velocity of the attack
     */ triggerAttackRelease(notes, duration, time, velocity = 1) {
        const computedTime = this.toSeconds(time);
        this.triggerAttack(notes, computedTime, velocity);
        if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(duration)) {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(notes), "notes must be an array when duration is array");
            notes.forEach((note, index)=>{
                const d = duration[Math.min(index, duration.length - 1)];
                this.triggerRelease(note, computedTime + this.toSeconds(d));
            });
        } else this.triggerRelease(notes, computedTime + this.toSeconds(duration));
        return this;
    }
    /**
     * Add a note to the sampler.
     * @param  note      The buffer's pitch.
     * @param  url  Either the url of the buffer, or a buffer which will be added with the given name.
     * @param  callback  The callback to invoke when the url is loaded.
     */ add(note, url, callback) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4dcca4501f2037f9)(note) || isFinite(note), `note must be a pitch or midi: ${note}`);
        if ((0, $4d7f709c9ffa5105$export$4dcca4501f2037f9)(note)) {
            // convert the note name to MIDI
            const mid = new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, note).toMidi();
            this._buffers.add(mid, url, callback);
        } else // otherwise if it's numbers assume it's midi
        this._buffers.add(note, url, callback);
        return this;
    }
    /**
     * If the buffers are loaded or not
     */ get loaded() {
        return this._buffers.loaded;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._buffers.dispose();
        this._activeSources.forEach((sources)=>{
            sources.forEach((source)=>source.dispose());
        });
        this._activeSources.clear();
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $f2139aa45d11abc9$export$322f102bec719b22.prototype, "attack", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $f2139aa45d11abc9$export$322f102bec719b22.prototype, "release", void 0);












class $2c5b4772ac8b2d19$export$f99f73502b006764 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2c5b4772ac8b2d19$export$f99f73502b006764.getDefaults(), arguments, [
            "callback",
            "value"
        ]));
        this.name = "ToneEvent";
        /**
         * Tracks the scheduled events
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)("stopped");
        /**
         * A delay time from when the event is scheduled to start
         */ this._startOffset = 0;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2c5b4772ac8b2d19$export$f99f73502b006764.getDefaults(), arguments, [
            "callback",
            "value"
        ]);
        this._loop = options.loop;
        this.callback = options.callback;
        this.value = options.value;
        this._loopStart = this.toTicks(options.loopStart);
        this._loopEnd = this.toTicks(options.loopEnd);
        this._playbackRate = options.playbackRate;
        this._probability = options.probability;
        this._humanize = options.humanize;
        this.mute = options.mute;
        this._playbackRate = options.playbackRate;
        this._state.increasing = true;
        // schedule the events for the first time
        this._rescheduleEvents();
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            humanize: false,
            loop: false,
            loopEnd: "1m",
            loopStart: 0,
            mute: false,
            playbackRate: 1,
            probability: 1,
            value: null
        });
    }
    /**
     * Reschedule all of the events along the timeline
     * with the updated values.
     * @param after Only reschedules events after the given time.
     */ _rescheduleEvents(after = -1) {
        // if no argument is given, schedules all of the events
        this._state.forEachFrom(after, (event)=>{
            let duration;
            if (event.state === "started") {
                if (event.id !== -1) this.context.transport.clear(event.id);
                const startTick = event.time + Math.round(this.startOffset / this._playbackRate);
                if (this._loop === true || (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(this._loop) && this._loop > 1) {
                    duration = Infinity;
                    if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(this._loop)) duration = this._loop * this._getLoopDuration();
                    const nextEvent = this._state.getAfter(startTick);
                    if (nextEvent !== null) duration = Math.min(duration, nextEvent.time - startTick);
                    if (duration !== Infinity) {
                        // schedule a stop since it's finite duration
                        this._state.setStateAtTime("stopped", startTick + duration + 1, {
                            id: -1
                        });
                        duration = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, duration);
                    }
                    const interval = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._getLoopDuration());
                    event.id = this.context.transport.scheduleRepeat(this._tick.bind(this), interval, new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, startTick), duration);
                } else event.id = this.context.transport.schedule(this._tick.bind(this), new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, startTick));
            }
        });
    }
    /**
     * Returns the playback state of the note, either "started" or "stopped".
     */ get state() {
        return this._state.getValueAtTime(this.context.transport.ticks);
    }
    /**
     * The start from the scheduled start time.
     */ get startOffset() {
        return this._startOffset;
    }
    set startOffset(offset) {
        this._startOffset = offset;
    }
    /**
     * The probability of the notes being triggered.
     */ get probability() {
        return this._probability;
    }
    set probability(prob) {
        this._probability = prob;
    }
    /**
     * If set to true, will apply small random variation
     * to the callback time. If the value is given as a time, it will randomize
     * by that amount.
     * @example
     * const event = new Tone.ToneEvent();
     * event.humanize = true;
     */ get humanize() {
        return this._humanize;
    }
    set humanize(variation) {
        this._humanize = variation;
    }
    /**
     * Start the note at the given time.
     * @param  time  When the event should start.
     */ start(time) {
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) === "stopped") {
            this._state.add({
                id: -1,
                state: "started",
                time: ticks
            });
            this._rescheduleEvents(ticks);
        }
        return this;
    }
    /**
     * Stop the Event at the given time.
     * @param  time  When the event should stop.
     */ stop(time) {
        this.cancel(time);
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) === "started") {
            this._state.setStateAtTime("stopped", ticks, {
                id: -1
            });
            const previousEvent = this._state.getBefore(ticks);
            let reschedulTime = ticks;
            if (previousEvent !== null) reschedulTime = previousEvent.time;
            this._rescheduleEvents(reschedulTime);
        }
        return this;
    }
    /**
     * Cancel all scheduled events greater than or equal to the given time
     * @param  time  The time after which events will be cancel.
     */ cancel(time) {
        time = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(time, -Infinity);
        const ticks = this.toTicks(time);
        this._state.forEachFrom(ticks, (event)=>{
            this.context.transport.clear(event.id);
        });
        this._state.cancel(ticks);
        return this;
    }
    /**
     * The callback function invoker. Also
     * checks if the Event is done playing
     * @param  time  The time of the event in seconds
     */ _tick(time) {
        const ticks = this.context.transport.getTicksAtTime(time);
        if (!this.mute && this._state.getValueAtTime(ticks) === "started") {
            if (this.probability < 1 && Math.random() > this.probability) return;
            if (this.humanize) {
                let variation = 0.02;
                if (!(0, $4d7f709c9ffa5105$export$f9ce7b637dfbe238)(this.humanize)) variation = this.toSeconds(this.humanize);
                time += (Math.random() * 2 - 1) * variation;
            }
            this.callback(time, this.value);
        }
    }
    /**
     * Get the duration of the loop.
     */ _getLoopDuration() {
        return Math.round((this._loopEnd - this._loopStart) / this._playbackRate);
    }
    /**
     * If the note should loop or not
     * between ToneEvent.loopStart and
     * ToneEvent.loopEnd. If set to true,
     * the event will loop indefinitely,
     * if set to a number greater than 1
     * it will play a specific number of
     * times, if set to false, 0 or 1, the
     * part will only play once.
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this._rescheduleEvents();
    }
    /**
     * The playback rate of the note. Defaults to 1.
     * @example
     * const note = new Tone.ToneEvent();
     * note.loop = true;
     * // repeat the note twice as fast
     * note.playbackRate = 2;
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        this._rescheduleEvents();
    }
    /**
     * The loopEnd point is the time the event will loop
     * if ToneEvent.loop is true.
     */ get loopEnd() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._loopEnd).toSeconds();
    }
    set loopEnd(loopEnd) {
        this._loopEnd = this.toTicks(loopEnd);
        if (this._loop) this._rescheduleEvents();
    }
    /**
     * The time when the loop should start.
     */ get loopStart() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._loopStart).toSeconds();
    }
    set loopStart(loopStart) {
        this._loopStart = this.toTicks(loopStart);
        if (this._loop) this._rescheduleEvents();
    }
    /**
     * The current progress of the loop interval.
     * Returns 0 if the event is not started yet or
     * it is not set to loop.
     */ get progress() {
        if (this._loop) {
            const ticks = this.context.transport.ticks;
            const lastEvent = this._state.get(ticks);
            if (lastEvent !== null && lastEvent.state === "started") {
                const loopDuration = this._getLoopDuration();
                const progress = (ticks - lastEvent.time) % loopDuration;
                return progress / loopDuration;
            } else return 0;
        } else return 0;
    }
    dispose() {
        super.dispose();
        this.cancel();
        this._state.dispose();
        return this;
    }
}





class $a002ed03681cb287$export$550acbd06a1f5a6a extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a002ed03681cb287$export$550acbd06a1f5a6a.getDefaults(), arguments, [
            "callback",
            "interval"
        ]));
        this.name = "Loop";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a002ed03681cb287$export$550acbd06a1f5a6a.getDefaults(), arguments, [
            "callback",
            "interval"
        ]);
        this._event = new (0, $2c5b4772ac8b2d19$export$f99f73502b006764)({
            context: this.context,
            callback: this._tick.bind(this),
            loop: true,
            loopEnd: options.interval,
            playbackRate: options.playbackRate,
            probability: options.probability
        });
        this.callback = options.callback;
        // set the iterations
        this.iterations = options.iterations;
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            interval: "4n",
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            playbackRate: 1,
            iterations: Infinity,
            probability: 1,
            mute: false,
            humanize: false
        });
    }
    /**
     * Start the loop at the specified time along the Transport's timeline.
     * @param  time  When to start the Loop.
     */ start(time) {
        this._event.start(time);
        return this;
    }
    /**
     * Stop the loop at the given time.
     * @param  time  When to stop the Loop.
     */ stop(time) {
        this._event.stop(time);
        return this;
    }
    /**
     * Cancel all scheduled events greater than or equal to the given time
     * @param  time  The time after which events will be cancel.
     */ cancel(time) {
        this._event.cancel(time);
        return this;
    }
    /**
     * Internal function called when the notes should be called
     * @param time  The time the event occurs
     */ _tick(time) {
        this.callback(time);
    }
    /**
     * The state of the Loop, either started or stopped.
     */ get state() {
        return this._event.state;
    }
    /**
     * The progress of the loop as a value between 0-1. 0, when the loop is stopped or done iterating.
     */ get progress() {
        return this._event.progress;
    }
    /**
     * The time between successive callbacks.
     * @example
     * const loop = new Tone.Loop();
     * loop.interval = "8n"; // loop every 8n
     */ get interval() {
        return this._event.loopEnd;
    }
    set interval(interval) {
        this._event.loopEnd = interval;
    }
    /**
     * The playback rate of the loop. The normal playback rate is 1 (no change).
     * A `playbackRate` of 2 would be twice as fast.
     */ get playbackRate() {
        return this._event.playbackRate;
    }
    set playbackRate(rate) {
        this._event.playbackRate = rate;
    }
    /**
     * Random variation +/-0.01s to the scheduled time.
     * Or give it a time value which it will randomize by.
     */ get humanize() {
        return this._event.humanize;
    }
    set humanize(variation) {
        this._event.humanize = variation;
    }
    /**
     * The probably of the callback being invoked.
     */ get probability() {
        return this._event.probability;
    }
    set probability(prob) {
        this._event.probability = prob;
    }
    /**
     * Muting the Loop means that no callbacks are invoked.
     */ get mute() {
        return this._event.mute;
    }
    set mute(mute) {
        this._event.mute = mute;
    }
    /**
     * The number of iterations of the loop. The default value is `Infinity` (loop forever).
     */ get iterations() {
        if (this._event.loop === true) return Infinity;
        else return this._event.loop;
    }
    set iterations(iters) {
        if (iters === Infinity) this._event.loop = true;
        else this._event.loop = iters;
    }
    dispose() {
        super.dispose();
        this._event.dispose();
        return this;
    }
}








class $36407f82d559e3b2$export$7b5bf7981d51054e extends (0, $2c5b4772ac8b2d19$export$f99f73502b006764) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($36407f82d559e3b2$export$7b5bf7981d51054e.getDefaults(), arguments, [
            "callback",
            "events"
        ]));
        this.name = "Part";
        /**
         * Tracks the scheduled events
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)("stopped");
        /**
         * The events that belong to this part
         */ this._events = new Set();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($36407f82d559e3b2$export$7b5bf7981d51054e.getDefaults(), arguments, [
            "callback",
            "events"
        ]);
        // make sure things are assigned in the right order
        this._state.increasing = true;
        // add the events
        options.events.forEach((event)=>{
            if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(event)) this.add(event[0], event[1]);
            else this.add(event);
        });
    }
    static getDefaults() {
        return Object.assign((0, $2c5b4772ac8b2d19$export$f99f73502b006764).getDefaults(), {
            events: []
        });
    }
    /**
     * Start the part at the given time.
     * @param  time    When to start the part.
     * @param  offset  The offset from the start of the part to begin playing at.
     */ start(time, offset) {
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) !== "started") {
            offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, this._loop ? this._loopStart : 0);
            if (this._loop) offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, this._loopStart);
            else offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0);
            const computedOffset = this.toTicks(offset);
            this._state.add({
                id: -1,
                offset: computedOffset,
                state: "started",
                time: ticks
            });
            this._forEach((event)=>{
                this._startNote(event, ticks, computedOffset);
            });
        }
        return this;
    }
    /**
     * Start the event in the given event at the correct time given
     * the ticks and offset and looping.
     * @param  event
     * @param  ticks
     * @param  offset
     */ _startNote(event, ticks, offset) {
        ticks -= offset;
        if (this._loop) {
            if (event.startOffset >= this._loopStart && event.startOffset < this._loopEnd) {
                if (event.startOffset < offset) // start it on the next loop
                ticks += this._getLoopDuration();
                event.start(new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, ticks));
            } else if (event.startOffset < this._loopStart && event.startOffset >= offset) {
                event.loop = false;
                event.start(new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, ticks));
            }
        } else if (event.startOffset >= offset) event.start(new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, ticks));
    }
    get startOffset() {
        return this._startOffset;
    }
    set startOffset(offset) {
        this._startOffset = offset;
        this._forEach((event)=>{
            event.startOffset += this._startOffset;
        });
    }
    /**
     * Stop the part at the given time.
     * @param  time  When to stop the part.
     */ stop(time) {
        const ticks = this.toTicks(time);
        this._state.cancel(ticks);
        this._state.setStateAtTime("stopped", ticks);
        this._forEach((event)=>{
            event.stop(time);
        });
        return this;
    }
    /**
     * Get/Set an Event's value at the given time.
     * If a value is passed in and no event exists at
     * the given time, one will be created with that value.
     * If two events are at the same time, the first one will
     * be returned.
     * @example
     * const part = new Tone.Part();
     * part.at("1m"); // returns the part at the first measure
     * part.at("2m", "C2"); // set the value at "2m" to C2.
     * // if an event didn't exist at that time, it will be created.
     * @param time The time of the event to get or set.
     * @param value If a value is passed in, the value of the event at the given time will be set to it.
     */ at(time, value) {
        const timeInTicks = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toTicks();
        const tickTime = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, 1).toSeconds();
        const iterator = this._events.values();
        let result = iterator.next();
        while(!result.done){
            const event = result.value;
            if (Math.abs(timeInTicks - event.startOffset) < tickTime) {
                if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(value)) event.value = value;
                return event;
            }
            result = iterator.next();
        }
        // if there was no event at that time, create one
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(value)) {
            this.add(time, value);
            // return the new event
            return this.at(time);
        } else return null;
    }
    add(time, value) {
        // extract the parameters
        if (time instanceof Object && Reflect.has(time, "time")) {
            value = time;
            time = value.time;
        }
        const ticks = this.toTicks(time);
        let event;
        if (value instanceof (0, $2c5b4772ac8b2d19$export$f99f73502b006764)) {
            event = value;
            event.callback = this._tick.bind(this);
        } else event = new (0, $2c5b4772ac8b2d19$export$f99f73502b006764)({
            callback: this._tick.bind(this),
            context: this.context,
            value: value
        });
        // the start offset
        event.startOffset = ticks;
        // initialize the values
        event.set({
            humanize: this.humanize,
            loop: this.loop,
            loopEnd: this.loopEnd,
            loopStart: this.loopStart,
            playbackRate: this.playbackRate,
            probability: this.probability
        });
        this._events.add(event);
        // start the note if it should be played right now
        this._restartEvent(event);
        return this;
    }
    /**
     * Restart the given event
     */ _restartEvent(event) {
        this._state.forEach((stateEvent)=>{
            if (stateEvent.state === "started") this._startNote(event, stateEvent.time, stateEvent.offset);
            else // stop the note
            event.stop(new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, stateEvent.time));
        });
    }
    remove(time, value) {
        // extract the parameters
        if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(time) && time.hasOwnProperty("time")) {
            value = time;
            time = value.time;
        }
        time = this.toTicks(time);
        this._events.forEach((event)=>{
            if (event.startOffset === time) {
                if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(value) || (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(value) && event.value === value) {
                    this._events.delete(event);
                    event.dispose();
                }
            }
        });
        return this;
    }
    /**
     * Remove all of the notes from the group.
     */ clear() {
        this._forEach((event)=>event.dispose());
        this._events.clear();
        return this;
    }
    /**
     * Cancel scheduled state change events: i.e. "start" and "stop".
     * @param after The time after which to cancel the scheduled events.
     */ cancel(after) {
        this._forEach((event)=>event.cancel(after));
        this._state.cancel(this.toTicks(after));
        return this;
    }
    /**
     * Iterate over all of the events
     */ _forEach(callback) {
        if (this._events) this._events.forEach((event)=>{
            if (event instanceof $36407f82d559e3b2$export$7b5bf7981d51054e) event._forEach(callback);
            else callback(event);
        });
        return this;
    }
    /**
     * Set the attribute of all of the events
     * @param  attr  the attribute to set
     * @param  value      The value to set it to
     */ _setAll(attr, value) {
        this._forEach((event)=>{
            event[attr] = value;
        });
    }
    /**
     * Internal tick method
     * @param  time  The time of the event in seconds
     */ _tick(time, value) {
        if (!this.mute) this.callback(time, value);
    }
    /**
     * Determine if the event should be currently looping
     * given the loop boundries of this Part.
     * @param  event  The event to test
     */ _testLoopBoundries(event) {
        if (this._loop && (event.startOffset < this._loopStart || event.startOffset >= this._loopEnd)) event.cancel(0);
        else if (event.state === "stopped") // reschedule it if it's stopped
        this._restartEvent(event);
    }
    get probability() {
        return this._probability;
    }
    set probability(prob) {
        this._probability = prob;
        this._setAll("probability", prob);
    }
    get humanize() {
        return this._humanize;
    }
    set humanize(variation) {
        this._humanize = variation;
        this._setAll("humanize", variation);
    }
    /**
     * If the part should loop or not
     * between Part.loopStart and
     * Part.loopEnd. If set to true,
     * the part will loop indefinitely,
     * if set to a number greater than 1
     * it will play a specific number of
     * times, if set to false, 0 or 1, the
     * part will only play once.
     * @example
     * const part = new Tone.Part();
     * // loop the part 8 times
     * part.loop = 8;
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this._forEach((event)=>{
            event.loopStart = this.loopStart;
            event.loopEnd = this.loopEnd;
            event.loop = loop;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The loopEnd point determines when it will
     * loop if Part.loop is true.
     */ get loopEnd() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._loopEnd).toSeconds();
    }
    set loopEnd(loopEnd) {
        this._loopEnd = this.toTicks(loopEnd);
        if (this._loop) this._forEach((event)=>{
            event.loopEnd = loopEnd;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The loopStart point determines when it will
     * loop if Part.loop is true.
     */ get loopStart() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._loopStart).toSeconds();
    }
    set loopStart(loopStart) {
        this._loopStart = this.toTicks(loopStart);
        if (this._loop) this._forEach((event)=>{
            event.loopStart = this.loopStart;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The playback rate of the part
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        this._setAll("playbackRate", rate);
    }
    /**
     * The number of scheduled notes in the part.
     */ get length() {
        return this._events.size;
    }
    dispose() {
        super.dispose();
        this.clear();
        return this;
    }
}





/**
 * Start at the first value and go up to the last
 */ function* $9cb4b246771af6b8$var$upPatternGen(values) {
    let index = 0;
    while(index < values.length){
        index = $9cb4b246771af6b8$var$clampToArraySize(index, values);
        yield values[index];
        index++;
    }
}
/**
 * Start at the last value and go down to 0
 */ function* $9cb4b246771af6b8$var$downPatternGen(values) {
    let index = values.length - 1;
    while(index >= 0){
        index = $9cb4b246771af6b8$var$clampToArraySize(index, values);
        yield values[index];
        index--;
    }
}
/**
 * Infinitely yield the generator
 */ function* $9cb4b246771af6b8$var$infiniteGen(values, gen) {
    while(true)yield* gen(values);
}
/**
 * Make sure that the index is in the given range
 */ function $9cb4b246771af6b8$var$clampToArraySize(index, values) {
    return (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(index, 0, values.length - 1);
}
/**
 * Alternate between two generators
 */ function* $9cb4b246771af6b8$var$alternatingGenerator(values, directionUp) {
    let index = directionUp ? 0 : values.length - 1;
    while(true){
        index = $9cb4b246771af6b8$var$clampToArraySize(index, values);
        yield values[index];
        if (directionUp) {
            index++;
            if (index >= values.length - 1) directionUp = false;
        } else {
            index--;
            if (index <= 0) directionUp = true;
        }
    }
}
/**
 * Starting from the bottom move up 2, down 1
 */ function* $9cb4b246771af6b8$var$jumpUp(values) {
    let index = 0;
    let stepIndex = 0;
    while(index < values.length){
        index = $9cb4b246771af6b8$var$clampToArraySize(index, values);
        yield values[index];
        stepIndex++;
        index += stepIndex % 2 ? 2 : -1;
    }
}
/**
 * Starting from the top move down 2, up 1
 */ function* $9cb4b246771af6b8$var$jumpDown(values) {
    let index = values.length - 1;
    let stepIndex = 0;
    while(index >= 0){
        index = $9cb4b246771af6b8$var$clampToArraySize(index, values);
        yield values[index];
        stepIndex++;
        index += stepIndex % 2 ? -2 : 1;
    }
}
/**
 * Choose a random index each time
 */ function* $9cb4b246771af6b8$var$randomGen(values) {
    while(true){
        const randomIndex = Math.floor(Math.random() * values.length);
        yield values[randomIndex];
    }
}
/**
 * Randomly go through all of the values once before choosing a new random order
 */ function* $9cb4b246771af6b8$var$randomOnce(values) {
    // create an array of indices
    const copy = [];
    for(let i = 0; i < values.length; i++)copy.push(i);
    while(copy.length > 0){
        // random choose an index, and then remove it so it's not chosen again
        const randVal = copy.splice(Math.floor(copy.length * Math.random()), 1);
        const index = $9cb4b246771af6b8$var$clampToArraySize(randVal[0], values);
        yield values[index];
    }
}
/**
 * Randomly choose to walk up or down 1 index in the values array
 */ function* $9cb4b246771af6b8$var$randomWalk(values) {
    // randomly choose a starting index in the values array
    let index = Math.floor(Math.random() * values.length);
    while(true){
        if (index === 0) index++; // at bottom of array, so force upward step
        else if (index === values.length - 1) index--; // at top of array, so force downward step
        else if (Math.random() < 0.5) index--;
        else index++;
        yield values[index];
    }
}
function* $9cb4b246771af6b8$export$891c3c0ea1af078a(values, pattern = "up", index = 0) {
    // safeguards
    (0, $afc9146c77d080c2$export$a7a9523472993e97)(values.length > 0, "The array must have more than one value in it");
    switch(pattern){
        case "up":
            yield* $9cb4b246771af6b8$var$infiniteGen(values, $9cb4b246771af6b8$var$upPatternGen);
        case "down":
            yield* $9cb4b246771af6b8$var$infiniteGen(values, $9cb4b246771af6b8$var$downPatternGen);
        case "upDown":
            yield* $9cb4b246771af6b8$var$alternatingGenerator(values, true);
        case "downUp":
            yield* $9cb4b246771af6b8$var$alternatingGenerator(values, false);
        case "alternateUp":
            yield* $9cb4b246771af6b8$var$infiniteGen(values, $9cb4b246771af6b8$var$jumpUp);
        case "alternateDown":
            yield* $9cb4b246771af6b8$var$infiniteGen(values, $9cb4b246771af6b8$var$jumpDown);
        case "random":
            yield* $9cb4b246771af6b8$var$randomGen(values);
        case "randomOnce":
            yield* $9cb4b246771af6b8$var$infiniteGen(values, $9cb4b246771af6b8$var$randomOnce);
        case "randomWalk":
            yield* $9cb4b246771af6b8$var$randomWalk(values);
    }
}




class $30778f25f10f0276$export$47606a6ae3eaed8e extends (0, $a002ed03681cb287$export$550acbd06a1f5a6a) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($30778f25f10f0276$export$47606a6ae3eaed8e.getDefaults(), arguments, [
            "callback",
            "values",
            "pattern"
        ]));
        this.name = "Pattern";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($30778f25f10f0276$export$47606a6ae3eaed8e.getDefaults(), arguments, [
            "callback",
            "values",
            "pattern"
        ]);
        this.callback = options.callback;
        this._values = options.values;
        this._pattern = (0, $9cb4b246771af6b8$export$891c3c0ea1af078a)(options.values, options.pattern);
        this._type = options.pattern;
    }
    static getDefaults() {
        return Object.assign((0, $a002ed03681cb287$export$550acbd06a1f5a6a).getDefaults(), {
            pattern: "up",
            values: [],
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)
        });
    }
    /**
     * Internal function called when the notes should be called
     */ _tick(time) {
        const value = this._pattern.next();
        this._value = value.value;
        this.callback(time, this._value);
    }
    /**
     * The array of events.
     */ get values() {
        return this._values;
    }
    set values(val) {
        this._values = val;
        // reset the pattern
        this.pattern = this._type;
    }
    /**
     * The current value of the pattern.
     */ get value() {
        return this._value;
    }
    /**
     * The pattern type. See Tone.CtrlPattern for the full list of patterns.
     */ get pattern() {
        return this._type;
    }
    set pattern(pattern) {
        this._type = pattern;
        this._pattern = (0, $9cb4b246771af6b8$export$891c3c0ea1af078a)(this._values, this._type);
    }
}







class $4634066a6fd96bab$export$edde1bcb1b2b310e extends (0, $2c5b4772ac8b2d19$export$f99f73502b006764) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4634066a6fd96bab$export$edde1bcb1b2b310e.getDefaults(), arguments, [
            "callback",
            "events",
            "subdivision"
        ]));
        this.name = "Sequence";
        /**
         * The object responsible for scheduling all of the events
         */ this._part = new (0, $36407f82d559e3b2$export$7b5bf7981d51054e)({
            callback: this._seqCallback.bind(this),
            context: this.context
        });
        /**
         * private reference to all of the sequence proxies
         */ this._events = [];
        /**
         * The proxied array
         */ this._eventsArray = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4634066a6fd96bab$export$edde1bcb1b2b310e.getDefaults(), arguments, [
            "callback",
            "events",
            "subdivision"
        ]);
        this._subdivision = this.toTicks(options.subdivision);
        this.events = options.events;
        // set all of the values
        this.loop = options.loop;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this.playbackRate = options.playbackRate;
        this.probability = options.probability;
        this.humanize = options.humanize;
        this.mute = options.mute;
        this.playbackRate = options.playbackRate;
    }
    static getDefaults() {
        return Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $2c5b4772ac8b2d19$export$f99f73502b006764).getDefaults(), [
            "value"
        ]), {
            events: [],
            loop: true,
            loopEnd: 0,
            loopStart: 0,
            subdivision: "8n"
        });
    }
    /**
     * The internal callback for when an event is invoked
     */ _seqCallback(time, value) {
        if (value !== null) this.callback(time, value);
    }
    /**
     * The sequence
     */ get events() {
        return this._events;
    }
    set events(s) {
        this.clear();
        this._eventsArray = s;
        this._events = this._createSequence(this._eventsArray);
        this._eventsUpdated();
    }
    /**
     * Start the part at the given time.
     * @param  time    When to start the part.
     * @param  offset  The offset index to start at
     */ start(time, offset) {
        this._part.start(time, offset ? this._indexTime(offset) : offset);
        return this;
    }
    /**
     * Stop the part at the given time.
     * @param  time  When to stop the part.
     */ stop(time) {
        this._part.stop(time);
        return this;
    }
    /**
     * The subdivision of the sequence. This can only be
     * set in the constructor. The subdivision is the
     * interval between successive steps.
     */ get subdivision() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._subdivision).toSeconds();
    }
    /**
     * Create a sequence proxy which can be monitored to create subsequences
     */ _createSequence(array) {
        return new Proxy(array, {
            get: (target, property)=>{
                // property is index in this case
                return target[property];
            },
            set: (target, property, value)=>{
                if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(property) && isFinite(parseInt(property, 10))) {
                    if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(value)) target[property] = this._createSequence(value);
                    else target[property] = value;
                } else target[property] = value;
                this._eventsUpdated();
                // return true to accept the changes
                return true;
            }
        });
    }
    /**
     * When the sequence has changed, all of the events need to be recreated
     */ _eventsUpdated() {
        this._part.clear();
        this._rescheduleSequence(this._eventsArray, this._subdivision, this.startOffset);
        // update the loopEnd
        this.loopEnd = this.loopEnd;
    }
    /**
     * reschedule all of the events that need to be rescheduled
     */ _rescheduleSequence(sequence, subdivision, startOffset) {
        sequence.forEach((value, index)=>{
            const eventOffset = index * subdivision + startOffset;
            if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(value)) this._rescheduleSequence(value, subdivision / value.length, eventOffset);
            else {
                const startTime = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, eventOffset, "i").toSeconds();
                this._part.add(startTime, value);
            }
        });
    }
    /**
     * Get the time of the index given the Sequence's subdivision
     * @param  index
     * @return The time of that index
     */ _indexTime(index) {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, index * this._subdivision + this.startOffset).toSeconds();
    }
    /**
     * Clear all of the events
     */ clear() {
        this._part.clear();
        return this;
    }
    dispose() {
        super.dispose();
        this._part.dispose();
        return this;
    }
    //-------------------------------------
    // PROXY CALLS
    //-------------------------------------
    get loop() {
        return this._part.loop;
    }
    set loop(l) {
        this._part.loop = l;
    }
    /**
     * The index at which the sequence should start looping
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(index) {
        this._loopStart = index;
        this._part.loopStart = this._indexTime(index);
    }
    /**
     * The index at which the sequence should end looping
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(index) {
        this._loopEnd = index;
        if (index === 0) this._part.loopEnd = this._indexTime(this._eventsArray.length);
        else this._part.loopEnd = this._indexTime(index);
    }
    get startOffset() {
        return this._part.startOffset;
    }
    set startOffset(start) {
        this._part.startOffset = start;
    }
    get playbackRate() {
        return this._part.playbackRate;
    }
    set playbackRate(rate) {
        this._part.playbackRate = rate;
    }
    get probability() {
        return this._part.probability;
    }
    set probability(prob) {
        this._part.probability = prob;
    }
    get progress() {
        return this._part.progress;
    }
    get humanize() {
        return this._part.humanize;
    }
    set humanize(variation) {
        this._part.humanize = variation;
    }
    /**
     * The number of scheduled events
     */ get length() {
        return this._part.length;
    }
}













class $edbbeae191c550fb$export$d78c8c6074541cf2 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($edbbeae191c550fb$export$d78c8c6074541cf2.getDefaults(), arguments, [
            "fade"
        ])));
        this.name = "CrossFade";
        /**
         * The crossfading is done by a StereoPannerNode
         */ this._panner = this.context.createStereoPanner();
        /**
         * Split the output of the panner node into two values used to control the gains.
         */ this._split = this.context.createChannelSplitter(2);
        /**
         * Convert the fade value into an audio range value so it can be connected
         * to the panner.pan AudioParam
         */ this._g2a = new (0, $98f6ca22b8da8532$export$770438008a544d9b)({
            context: this.context
        });
        /**
         * The input which is at full level when fade = 0
         */ this.a = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        /**
         * The input which is at full level when fade = 1
         */ this.b = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        /**
         * The output is a mix between `a` and `b` at the ratio of `fade`
         */ this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._internalChannels = [
            this.a,
            this.b
        ];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($edbbeae191c550fb$export$d78c8c6074541cf2.getDefaults(), arguments, [
            "fade"
        ]);
        this.fade = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "normalRange",
            value: options.fade
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "fade");
        this.context.getConstant(1).connect(this._panner);
        this._panner.connect(this._split);
        // this is necessary for standardized-audio-context
        // doesn't make any difference for the native AudioContext
        // https://github.com/chrisguttandin/standardized-audio-context/issues/647
        this._panner.channelCount = 1;
        this._panner.channelCountMode = "explicit";
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._split, this.a.gain, 0);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._split, this.b.gain, 1);
        this.fade.chain(this._g2a, this._panner.pan);
        this.a.connect(this.output);
        this.b.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            fade: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.a.dispose();
        this.b.dispose();
        this.output.dispose();
        this.fade.dispose();
        this._g2a.dispose();
        this._panner.disconnect();
        this._split.disconnect();
        return this;
    }
}





class $55a557a844190520$export$a32b0b1c1ac59d04 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        this.name = "Effect";
        /**
         * the drywet knob to control the amount of effect
         */ this._dryWet = new (0, $edbbeae191c550fb$export$d78c8c6074541cf2)({
            context: this.context
        });
        /**
         * The wet control is how much of the effected
         * will pass through to the output. 1 = 100% effected
         * signal, 0 = 100% dry signal.
         */ this.wet = this._dryWet.fade;
        /**
         * connect the effectSend to the input of hte effect
         */ this.effectSend = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * connect the output of the effect to the effectReturn
         */ this.effectReturn = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The effect input node
         */ this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The effect output
         */ this.output = this._dryWet;
        // connections
        this.input.fan(this._dryWet.a, this.effectSend);
        this.effectReturn.connect(this._dryWet.b);
        this.wet.setValueAtTime(options.wet, 0);
        this._internalChannels = [
            this.effectReturn,
            this.effectSend
        ];
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "wet");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            wet: 1
        });
    }
    /**
     * chains the effect in between the effectSend and effectReturn
     */ connectEffect(effect) {
        // add it to the internal channels
        this._internalChannels.push(effect);
        this.effectSend.chain(effect, this.effectReturn);
        return this;
    }
    dispose() {
        super.dispose();
        this._dryWet.dispose();
        this.effectSend.dispose();
        this.effectReturn.dispose();
        this.wet.dispose();
        return this;
    }
}




class $402599c7d88bac65$export$de224a2741e4b2f8 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(options){
        super(options);
        this.name = "LFOEffect";
        this._lfo = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            amplitude: options.depth
        });
        this.depth = this._lfo.amplitude;
        this.frequency = this._lfo.frequency;
        this.type = options.type;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "depth"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            frequency: 1,
            type: "sine",
            depth: 1
        });
    }
    /**
     * Start the effect.
     */ start(time) {
        this._lfo.start(time);
        return this;
    }
    /**
     * Stop the lfo
     */ stop(time) {
        this._lfo.stop(time);
        return this;
    }
    /**
     * Sync the filter to the transport. See [[LFO.sync]]
     */ sync() {
        this._lfo.sync();
        return this;
    }
    /**
     * Unsync the filter from the transport.
     */ unsync() {
        this._lfo.unsync();
        return this;
    }
    /**
     * The type of the LFO's oscillator: See [[Oscillator.type]]
     * @example
     * const autoFilter = new Tone.AutoFilter().start().toDestination();
     * const noise = new Tone.Noise().start().connect(autoFilter);
     * autoFilter.type = "square";
     */ get type() {
        return this._lfo.type;
    }
    set type(type) {
        this._lfo.type = type;
    }
    dispose() {
        super.dispose();
        this._lfo.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}


class $408e8dd19ecab46a$export$b80f807aa51d8d02 extends (0, $402599c7d88bac65$export$de224a2741e4b2f8) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($408e8dd19ecab46a$export$b80f807aa51d8d02.getDefaults(), arguments, [
            "frequency",
            "baseFrequency",
            "octaves"
        ]));
        this.name = "AutoFilter";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($408e8dd19ecab46a$export$b80f807aa51d8d02.getDefaults(), arguments, [
            "frequency",
            "baseFrequency",
            "octaves"
        ]);
        this.filter = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)(Object.assign(options.filter, {
            context: this.context
        }));
        // connections
        this.connectEffect(this.filter);
        this._lfo.connect(this.filter.frequency);
        this.octaves = options.octaves;
        this.baseFrequency = options.baseFrequency;
    }
    static getDefaults() {
        return Object.assign((0, $402599c7d88bac65$export$de224a2741e4b2f8).getDefaults(), {
            baseFrequency: 200,
            octaves: 2.6,
            filter: {
                type: "lowpass",
                rolloff: -12,
                Q: 1
            }
        });
    }
    /**
     * The minimum value of the filter's cutoff frequency.
     */ get baseFrequency() {
        return this._lfo.min;
    }
    set baseFrequency(freq) {
        this._lfo.min = this.toFrequency(freq);
        // and set the max
        this.octaves = this._octaves;
    }
    /**
     * The maximum value of the filter's cutoff frequency.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(oct) {
        this._octaves = oct;
        this._lfo.max = this._lfo.min * Math.pow(2, oct);
    }
    dispose() {
        super.dispose();
        this.filter.dispose();
        return this;
    }
}






class $3104cbf8d2a8337f$export$d6d7a1629e59823d extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3104cbf8d2a8337f$export$d6d7a1629e59823d.getDefaults(), arguments, [
            "pan"
        ])));
        this.name = "Panner";
        /**
         * the panner node
         */ this._panner = this.context.createStereoPanner();
        this.input = this._panner;
        this.output = this._panner;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3104cbf8d2a8337f$export$d6d7a1629e59823d.getDefaults(), arguments, [
            "pan"
        ]);
        this.pan = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.pan,
            value: options.pan,
            minValue: -1,
            maxValue: 1
        });
        // this is necessary for standardized-audio-context
        // doesn't make any difference for the native AudioContext
        // https://github.com/chrisguttandin/standardized-audio-context/issues/647
        this._panner.channelCount = options.channelCount;
        this._panner.channelCountMode = "explicit";
        // initial value
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "pan");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            pan: 0,
            channelCount: 1
        });
    }
    dispose() {
        super.dispose();
        this._panner.disconnect();
        this.pan.dispose();
        return this;
    }
}




class $7f0dcacdefc557fe$export$e9bd274ee70104df extends (0, $402599c7d88bac65$export$de224a2741e4b2f8) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7f0dcacdefc557fe$export$e9bd274ee70104df.getDefaults(), arguments, [
            "frequency"
        ]));
        this.name = "AutoPanner";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7f0dcacdefc557fe$export$e9bd274ee70104df.getDefaults(), arguments, [
            "frequency"
        ]);
        this._panner = new (0, $3104cbf8d2a8337f$export$d6d7a1629e59823d)({
            context: this.context,
            channelCount: options.channelCount
        });
        // connections
        this.connectEffect(this._panner);
        this._lfo.connect(this._panner.pan);
        this._lfo.min = -1;
        this._lfo.max = 1;
    }
    static getDefaults() {
        return Object.assign((0, $402599c7d88bac65$export$de224a2741e4b2f8).getDefaults(), {
            channelCount: 1
        });
    }
    dispose() {
        super.dispose();
        this._panner.dispose();
        return this;
    }
}








class $1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f.getDefaults(), arguments, [
            "smoothing"
        ]));
        this.name = "Follower";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f.getDefaults(), arguments, [
            "smoothing"
        ]);
        this._abs = this.input = new (0, $bc6b6173dfd74460$export$b73c596ee8758a66)({
            context: this.context
        });
        this._lowpass = this.output = new (0, $e96b9b836f8a5fb5$export$7961b18021b7c8c9)({
            context: this.context,
            frequency: 1 / this.toSeconds(options.smoothing),
            type: "lowpass"
        });
        this._abs.connect(this._lowpass);
        this._smoothing = options.smoothing;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            smoothing: 0.05
        });
    }
    /**
     * The amount of time it takes a value change to arrive at the updated value.
     */ get smoothing() {
        return this._smoothing;
    }
    set smoothing(smoothing) {
        this._smoothing = smoothing;
        this._lowpass.frequency = 1 / this.toSeconds(this.smoothing);
    }
    dispose() {
        super.dispose();
        this._abs.dispose();
        this._lowpass.dispose();
        return this;
    }
}







class $0fcf624e170bb973$export$7107ee8d8b759a00 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0fcf624e170bb973$export$7107ee8d8b759a00.getDefaults(), arguments, [
            "baseFrequency",
            "octaves",
            "sensitivity"
        ]));
        this.name = "AutoWah";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0fcf624e170bb973$export$7107ee8d8b759a00.getDefaults(), arguments, [
            "baseFrequency",
            "octaves",
            "sensitivity"
        ]);
        this._follower = new (0, $1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f)({
            context: this.context,
            smoothing: options.follower
        });
        this._sweepRange = new (0, $75aaa92c69306be4$export$92c7140174c78083)({
            context: this.context,
            min: 0,
            max: 1,
            exponent: 0.5
        });
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._octaves = options.octaves;
        this._inputBoost = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._bandpass = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            rolloff: -48,
            frequency: 0,
            Q: options.Q
        });
        this._peaking = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            type: "peaking"
        });
        this._peaking.gain.value = options.gain;
        this.gain = this._peaking.gain;
        this.Q = this._bandpass.Q;
        // the control signal path
        this.effectSend.chain(this._inputBoost, this._follower, this._sweepRange);
        this._sweepRange.connect(this._bandpass.frequency);
        this._sweepRange.connect(this._peaking.frequency);
        // the filtered path
        this.effectSend.chain(this._bandpass, this._peaking, this.effectReturn);
        // set the initial value
        this._setSweepRange();
        this.sensitivity = options.sensitivity;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "gain",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            baseFrequency: 100,
            octaves: 6,
            sensitivity: 0,
            Q: 2,
            gain: 2,
            follower: 0.2
        });
    }
    /**
     * The number of octaves that the filter will sweep above the baseFrequency.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        this._setSweepRange();
    }
    /**
     * The follower's smoothing time
     */ get follower() {
        return this._follower.smoothing;
    }
    set follower(follower) {
        this._follower.smoothing = follower;
    }
    /**
     * The base frequency from which the sweep will start from.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(baseFreq) {
        this._baseFrequency = this.toFrequency(baseFreq);
        this._setSweepRange();
    }
    /**
     * The sensitivity to control how responsive to the input signal the filter is.
     */ get sensitivity() {
        return (0, $84c2af7dbf01a14d$export$6af3969727ca2a60)(1 / this._inputBoost.gain.value);
    }
    set sensitivity(sensitivity) {
        this._inputBoost.gain.value = 1 / (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(sensitivity);
    }
    /**
     * sets the sweep range of the scaler
     */ _setSweepRange() {
        this._sweepRange.min = this._baseFrequency;
        this._sweepRange.max = Math.min(this._baseFrequency * Math.pow(2, this._octaves), this.context.sampleRate / 2);
    }
    dispose() {
        super.dispose();
        this._follower.dispose();
        this._sweepRange.dispose();
        this._bandpass.dispose();
        this._peaking.dispose();
        this._inputBoost.dispose();
        return this;
    }
}










const $8397ea99d103fd07$export$85343ada6050a795 = "bit-crusher";
const $8397ea99d103fd07$export$b0b3e57880d0a354 = /* javascript */ `
	class BitCrusherWorklet extends SingleIOProcessor {

		static get parameterDescriptors() {
			return [{
				name: "bits",
				defaultValue: 12,
				minValue: 1,
				maxValue: 16,
				automationRate: 'k-rate'
			}];
		}

		generate(input, _channel, parameters) {
			const step = Math.pow(0.5, parameters.bits - 1);
			const val = step * Math.floor(input / step + 0.5);
			return val;
		}
	}
`;
(0, $084f2c4e06bfb0e6$export$d575e6557ac1729f)($8397ea99d103fd07$export$85343ada6050a795, $8397ea99d103fd07$export$b0b3e57880d0a354);


class $f68d8caa4178701a$export$89e1fd5b393fbb6e extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f68d8caa4178701a$export$89e1fd5b393fbb6e.getDefaults(), arguments, [
            "bits"
        ]));
        this.name = "BitCrusher";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f68d8caa4178701a$export$89e1fd5b393fbb6e.getDefaults(), arguments, [
            "bits"
        ]);
        this._bitCrusherWorklet = new $f68d8caa4178701a$var$BitCrusherWorklet({
            context: this.context,
            bits: options.bits
        });
        // connect it up
        this.connectEffect(this._bitCrusherWorklet);
        this.bits = this._bitCrusherWorklet.bits;
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            bits: 4
        });
    }
    dispose() {
        super.dispose();
        this._bitCrusherWorklet.dispose();
        return this;
    }
}
/**
 * Internal class which creates an AudioWorklet to do the bit crushing
 */ class $f68d8caa4178701a$var$BitCrusherWorklet extends (0, $ab96f0673d65b5e9$export$212d912bd0512eff) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f68d8caa4178701a$var$BitCrusherWorklet.getDefaults(), arguments));
        this.name = "BitCrusherWorklet";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f68d8caa4178701a$var$BitCrusherWorklet.getDefaults(), arguments);
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.bits = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            value: options.bits,
            units: "positive",
            minValue: 1,
            maxValue: 16,
            param: this._dummyParam,
            swappable: true
        });
    }
    static getDefaults() {
        return Object.assign((0, $ab96f0673d65b5e9$export$212d912bd0512eff).getDefaults(), {
            bits: 12
        });
    }
    _audioWorkletName() {
        return 0, $8397ea99d103fd07$export$85343ada6050a795;
    }
    onReady(node) {
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, node, this.output);
        const bits = node.parameters.get("bits");
        this.bits.setParam(bits);
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.bits.dispose();
        return this;
    }
}





class $14520f372c07ba06$export$9e28f5c57e778427 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($14520f372c07ba06$export$9e28f5c57e778427.getDefaults(), arguments, [
            "order"
        ]));
        this.name = "Chebyshev";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($14520f372c07ba06$export$9e28f5c57e778427.getDefaults(), arguments, [
            "order"
        ]);
        this._shaper = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            length: 4096
        });
        this._order = options.order;
        this.connectEffect(this._shaper);
        this.order = options.order;
        this.oversample = options.oversample;
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            order: 1,
            oversample: "none"
        });
    }
    /**
     * get the coefficient for that degree
     * @param  x the x value
     * @param  degree
     * @param  memo memoize the computed value. this speeds up computation greatly.
     */ _getCoefficient(x, degree, memo) {
        if (memo.has(degree)) return memo.get(degree);
        else if (degree === 0) memo.set(degree, 0);
        else if (degree === 1) memo.set(degree, x);
        else memo.set(degree, 2 * x * this._getCoefficient(x, degree - 1, memo) - this._getCoefficient(x, degree - 2, memo));
        return memo.get(degree);
    }
    /**
     * The order of the Chebyshev polynomial which creates the equation which is applied to the incoming
     * signal through a Tone.WaveShaper. The equations are in the form:
     * ```
     * order 2: 2x^2 + 1
     * order 3: 4x^3 + 3x
     * ```
     * @min 1
     * @max 100
     */ get order() {
        return this._order;
    }
    set order(order) {
        this._order = order;
        this._shaper.setMap((x)=>{
            return this._getCoefficient(x, order, new Map());
        });
    }
    /**
     * The oversampling of the effect. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        this._shaper.oversample = oversampling;
    }
    dispose() {
        super.dispose();
        this._shaper.dispose();
        return this;
    }
}






class $41adc9bb2ea0d651$export$f836382419f64c98 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($41adc9bb2ea0d651$export$f836382419f64c98.getDefaults(), arguments, [
            "channels"
        ]));
        this.name = "Split";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($41adc9bb2ea0d651$export$f836382419f64c98.getDefaults(), arguments, [
            "channels"
        ]);
        this._splitter = this.input = this.output = this.context.createChannelSplitter(options.channels);
        this._internalChannels = [
            this._splitter
        ];
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            channels: 2
        });
    }
    dispose() {
        super.dispose();
        this._splitter.disconnect();
        return this;
    }
}





class $799c23fcce0ddd96$export$70ce1d34efd3b886 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($799c23fcce0ddd96$export$70ce1d34efd3b886.getDefaults(), arguments, [
            "channels"
        ]));
        this.name = "Merge";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($799c23fcce0ddd96$export$70ce1d34efd3b886.getDefaults(), arguments, [
            "channels"
        ]);
        this._merger = this.output = this.input = this.context.createChannelMerger(options.channels);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            channels: 2
        });
    }
    dispose() {
        super.dispose();
        this._merger.disconnect();
        return this;
    }
}



class $915a8f1363471442$export$f02761adf21def8a extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        this.name = "StereoEffect";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        // force mono sources to be stereo
        this.input.channelCount = 2;
        this.input.channelCountMode = "explicit";
        this._dryWet = this.output = new (0, $edbbeae191c550fb$export$d78c8c6074541cf2)({
            context: this.context,
            fade: options.wet
        });
        this.wet = this._dryWet.fade;
        this._split = new (0, $41adc9bb2ea0d651$export$f836382419f64c98)({
            context: this.context,
            channels: 2
        });
        this._merge = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
            context: this.context,
            channels: 2
        });
        // connections
        this.input.connect(this._split);
        // dry wet connections
        this.input.connect(this._dryWet.a);
        this._merge.connect(this._dryWet.b);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "wet"
        ]);
    }
    /**
     * Connect the left part of the effect
     */ connectEffectLeft(...nodes) {
        this._split.connect(nodes[0], 0, 0);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(...nodes);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(nodes[nodes.length - 1], this._merge, 0, 0);
    }
    /**
     * Connect the right part of the effect
     */ connectEffectRight(...nodes) {
        this._split.connect(nodes[0], 1, 0);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(...nodes);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(nodes[nodes.length - 1], this._merge, 0, 1);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            wet: 1
        });
    }
    dispose() {
        super.dispose();
        this._dryWet.dispose();
        this._split.dispose();
        this._merge.dispose();
        return this;
    }
}







class $ef3d96dfca708839$export$d911e987c738486e extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(options){
        super(options);
        this.feedback = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.feedback,
            units: "normalRange"
        });
        this._feedbackL = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._feedbackR = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._feedbackSplit = new (0, $41adc9bb2ea0d651$export$f836382419f64c98)({
            context: this.context,
            channels: 2
        });
        this._feedbackMerge = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
            context: this.context,
            channels: 2
        });
        this._merge.connect(this._feedbackSplit);
        this._feedbackMerge.connect(this._split);
        // the left output connected to the left input
        this._feedbackSplit.connect(this._feedbackL, 0, 0);
        this._feedbackL.connect(this._feedbackMerge, 0, 0);
        // the right output connected to the right input
        this._feedbackSplit.connect(this._feedbackR, 1, 0);
        this._feedbackR.connect(this._feedbackMerge, 0, 1);
        // the feedback control
        this.feedback.fan(this._feedbackL.gain, this._feedbackR.gain);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "feedback"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            feedback: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.feedback.dispose();
        this._feedbackL.dispose();
        this._feedbackR.dispose();
        this._feedbackSplit.dispose();
        this._feedbackMerge.dispose();
        return this;
    }
}






class $3a08fb57b6335478$export$e876320b09eb8124 extends (0, $ef3d96dfca708839$export$d911e987c738486e) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3a08fb57b6335478$export$e876320b09eb8124.getDefaults(), arguments, [
            "frequency",
            "delayTime",
            "depth"
        ]));
        this.name = "Chorus";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3a08fb57b6335478$export$e876320b09eb8124.getDefaults(), arguments, [
            "frequency",
            "delayTime",
            "depth"
        ]);
        this._depth = options.depth;
        this._delayTime = options.delayTime / 1000;
        this._lfoL = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1
        });
        this._lfoR = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1,
            phase: 180
        });
        this._delayNodeL = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context
        });
        this._delayNodeR = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context
        });
        this.frequency = this._lfoL.frequency;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency"
        ]);
        // have one LFO frequency control the other
        this._lfoL.frequency.connect(this._lfoR.frequency);
        // connections
        this.connectEffectLeft(this._delayNodeL);
        this.connectEffectRight(this._delayNodeR);
        // lfo setup
        this._lfoL.connect(this._delayNodeL.delayTime);
        this._lfoR.connect(this._delayNodeR.delayTime);
        // set the initial values
        this.depth = this._depth;
        this.type = options.type;
        this.spread = options.spread;
    }
    static getDefaults() {
        return Object.assign((0, $ef3d96dfca708839$export$d911e987c738486e).getDefaults(), {
            frequency: 1.5,
            delayTime: 3.5,
            depth: 0.7,
            type: "sine",
            spread: 180,
            feedback: 0,
            wet: 0.5
        });
    }
    /**
     * The depth of the effect. A depth of 1 makes the delayTime
     * modulate between 0 and 2*delayTime (centered around the delayTime).
     */ get depth() {
        return this._depth;
    }
    set depth(depth) {
        this._depth = depth;
        const deviation = this._delayTime * depth;
        this._lfoL.min = Math.max(this._delayTime - deviation, 0);
        this._lfoL.max = this._delayTime + deviation;
        this._lfoR.min = Math.max(this._delayTime - deviation, 0);
        this._lfoR.max = this._delayTime + deviation;
    }
    /**
     * The delayTime in milliseconds of the chorus. A larger delayTime
     * will give a more pronounced effect. Nominal range a delayTime
     * is between 2 and 20ms.
     */ get delayTime() {
        return this._delayTime * 1000;
    }
    set delayTime(delayTime) {
        this._delayTime = delayTime / 1000;
        this.depth = this._depth;
    }
    /**
     * The oscillator type of the LFO.
     */ get type() {
        return this._lfoL.type;
    }
    set type(type) {
        this._lfoL.type = type;
        this._lfoR.type = type;
    }
    /**
     * Amount of stereo spread. When set to 0, both LFO's will be panned centrally.
     * When set to 180, LFO's will be panned hard left and right respectively.
     */ get spread() {
        return this._lfoR.phase - this._lfoL.phase;
    }
    set spread(spread) {
        this._lfoL.phase = 90 - spread / 2;
        this._lfoR.phase = spread / 2 + 90;
    }
    /**
     * Start the effect.
     */ start(time) {
        this._lfoL.start(time);
        this._lfoR.start(time);
        return this;
    }
    /**
     * Stop the lfo
     */ stop(time) {
        this._lfoL.stop(time);
        this._lfoR.stop(time);
        return this;
    }
    /**
     * Sync the filter to the transport. See [[LFO.sync]]
     */ sync() {
        this._lfoL.sync();
        this._lfoR.sync();
        return this;
    }
    /**
     * Unsync the filter from the transport.
     */ unsync() {
        this._lfoL.unsync();
        this._lfoR.unsync();
        return this;
    }
    dispose() {
        super.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._delayNodeL.dispose();
        this._delayNodeR.dispose();
        this.frequency.dispose();
        return this;
    }
}





class $357c00e1e161ebb4$export$406bc4309a3e7a54 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($357c00e1e161ebb4$export$406bc4309a3e7a54.getDefaults(), arguments, [
            "distortion"
        ]));
        this.name = "Distortion";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($357c00e1e161ebb4$export$406bc4309a3e7a54.getDefaults(), arguments, [
            "distortion"
        ]);
        this._shaper = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            length: 4096
        });
        this._distortion = options.distortion;
        this.connectEffect(this._shaper);
        this.distortion = options.distortion;
        this.oversample = options.oversample;
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            distortion: 0.4,
            oversample: "none"
        });
    }
    /**
     * The amount of distortion. Nominal range is between 0 and 1.
     */ get distortion() {
        return this._distortion;
    }
    set distortion(amount) {
        this._distortion = amount;
        const k = amount * 100;
        const deg = Math.PI / 180;
        this._shaper.setMap((x)=>{
            if (Math.abs(x) < 0.001) // should output 0 when input is 0
            return 0;
            else return (3 + k) * x * 20 * deg / (Math.PI + k * Math.abs(x));
        });
    }
    /**
     * The oversampling of the effect. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        this._shaper.oversample = oversampling;
    }
    dispose() {
        super.dispose();
        this._shaper.dispose();
        return this;
    }
}








class $fcf44b813eed0eb7$export$125ce1b19cf7db0d extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(options){
        super(options);
        this.name = "FeedbackEffect";
        this._feedbackGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.feedback,
            units: "normalRange"
        });
        this.feedback = this._feedbackGain.gain;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "feedback");
        // the feedback loop
        this.effectReturn.chain(this._feedbackGain, this.effectSend);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            feedback: 0.125
        });
    }
    dispose() {
        super.dispose();
        this._feedbackGain.dispose();
        this.feedback.dispose();
        return this;
    }
}


class $7f2ffdf195e1ebb8$export$28e4d032ddc580fa extends (0, $fcf44b813eed0eb7$export$125ce1b19cf7db0d) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7f2ffdf195e1ebb8$export$28e4d032ddc580fa.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]));
        this.name = "FeedbackDelay";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7f2ffdf195e1ebb8$export$28e4d032ddc580fa.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]);
        this._delayNode = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            delayTime: options.delayTime,
            maxDelay: options.maxDelay
        });
        this.delayTime = this._delayNode.delayTime;
        // connect it up
        this.connectEffect(this._delayNode);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "delayTime");
    }
    static getDefaults() {
        return Object.assign((0, $fcf44b813eed0eb7$export$125ce1b19cf7db0d).getDefaults(), {
            delayTime: 0.25,
            maxDelay: 1
        });
    }
    dispose() {
        super.dispose();
        this._delayNode.dispose();
        this.delayTime.dispose();
        return this;
    }
}




class $8c6cd80796057282$export$fc0fd2e096a27936 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        this.name = "PhaseShiftAllpass";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The phase shifted output
         */ this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The PhaseShifted allpass output
         */ this.offset90 = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        const allpassBank1Values = [
            0.6923878,
            0.9360654322959,
            0.9882295226860,
            0.9987488452737
        ];
        const allpassBank2Values = [
            0.4021921162426,
            0.8561710882420,
            0.9722909545651,
            0.9952884791278
        ];
        this._bank0 = this._createAllPassFilterBank(allpassBank1Values);
        this._bank1 = this._createAllPassFilterBank(allpassBank2Values);
        this._oneSampleDelay = this.context.createIIRFilter([
            0.0,
            1.0
        ], [
            1.0,
            0.0
        ]);
        // connect Allpass filter banks
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, ...this._bank0, this._oneSampleDelay, this.output);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, ...this._bank1, this.offset90);
    }
    /**
     * Create all of the IIR filters from an array of values using the coefficient calculation.
     */ _createAllPassFilterBank(bankValues) {
        const nodes = bankValues.map((value)=>{
            const coefficients = [
                [
                    value * value,
                    0,
                    -1
                ],
                [
                    1,
                    0,
                    -(value * value)
                ]
            ];
            return this.context.createIIRFilter(coefficients[0], coefficients[1]);
        });
        return nodes;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.offset90.dispose();
        this._bank0.forEach((f)=>f.disconnect());
        this._bank1.forEach((f)=>f.disconnect());
        this._oneSampleDelay.disconnect();
        return this;
    }
}










class $51c25c5d47cea6a8$export$183131474cdbc063 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($51c25c5d47cea6a8$export$183131474cdbc063.getDefaults(), arguments, [
            "frequency"
        ]));
        this.name = "FrequencyShifter";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($51c25c5d47cea6a8$export$183131474cdbc063.getDefaults(), arguments, [
            "frequency"
        ]);
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency,
            minValue: -this.context.sampleRate / 2,
            maxValue: this.context.sampleRate / 2
        });
        this._sine = new (0, $6dd36306779dbefc$export$284532b021137a4a)({
            context: this.context,
            type: "sine"
        });
        this._cosine = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            phase: -90,
            type: "sine"
        });
        this._sineMultiply = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context
        });
        this._cosineMultiply = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context
        });
        this._negate = new (0, $12434edb56028935$export$a4e82151127277b0)({
            context: this.context
        });
        this._add = new (0, $ad8862926b54eb7c$export$d0265b2c425512d6)({
            context: this.context
        });
        this._phaseShifter = new (0, $8c6cd80796057282$export$fc0fd2e096a27936)({
            context: this.context
        });
        this.effectSend.connect(this._phaseShifter);
        // connect the carrier frequency signal to the two oscillators
        this.frequency.fan(this._sine.frequency, this._cosine.frequency);
        this._phaseShifter.offset90.connect(this._cosineMultiply);
        this._cosine.connect(this._cosineMultiply.factor);
        this._phaseShifter.connect(this._sineMultiply);
        this._sine.connect(this._sineMultiply.factor);
        this._sineMultiply.connect(this._negate);
        this._cosineMultiply.connect(this._add);
        this._negate.connect(this._add.addend);
        this._add.connect(this.effectReturn);
        // start the oscillators at the same time
        const now = this.immediate();
        this._sine.start(now);
        this._cosine.start(now);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            frequency: 0
        });
    }
    dispose() {
        super.dispose();
        this.frequency.dispose();
        this._add.dispose();
        this._cosine.dispose();
        this._cosineMultiply.dispose();
        this._negate.dispose();
        this._phaseShifter.dispose();
        this._sine.dispose();
        this._sineMultiply.dispose();
        return this;
    }
}







/**
 * An array of comb filter delay values from Freeverb implementation
 */ const $2aeaec223e48dd69$var$combFilterTunings = [
    1557 / 44100,
    1617 / 44100,
    1491 / 44100,
    1422 / 44100,
    1277 / 44100,
    1356 / 44100,
    1188 / 44100,
    1116 / 44100
];
/**
 * An array of allpass filter frequency values from Freeverb implementation
 */ const $2aeaec223e48dd69$var$allpassFilterFrequencies = [
    225,
    556,
    441,
    341
];
class $2aeaec223e48dd69$export$8f91cfa34e3c0ba extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2aeaec223e48dd69$export$8f91cfa34e3c0ba.getDefaults(), arguments, [
            "roomSize",
            "dampening"
        ]));
        this.name = "Freeverb";
        /**
         * the comb filters
         */ this._combFilters = [];
        /**
         * the allpass filters on the left
         */ this._allpassFiltersL = [];
        /**
         * the allpass filters on the right
         */ this._allpassFiltersR = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2aeaec223e48dd69$export$8f91cfa34e3c0ba.getDefaults(), arguments, [
            "roomSize",
            "dampening"
        ]);
        this.roomSize = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.roomSize,
            units: "normalRange"
        });
        // make the allpass filters on the right
        this._allpassFiltersL = $2aeaec223e48dd69$var$allpassFilterFrequencies.map((freq)=>{
            const allpassL = this.context.createBiquadFilter();
            allpassL.type = "allpass";
            allpassL.frequency.value = freq;
            return allpassL;
        });
        // make the allpass filters on the left
        this._allpassFiltersR = $2aeaec223e48dd69$var$allpassFilterFrequencies.map((freq)=>{
            const allpassR = this.context.createBiquadFilter();
            allpassR.type = "allpass";
            allpassR.frequency.value = freq;
            return allpassR;
        });
        // make the comb filters
        this._combFilters = $2aeaec223e48dd69$var$combFilterTunings.map((delayTime, index)=>{
            const lfpf = new (0, $ef6d05ab4f866c0f$export$e83d2527589f5587)({
                context: this.context,
                dampening: options.dampening,
                delayTime: delayTime
            });
            if (index < $2aeaec223e48dd69$var$combFilterTunings.length / 2) this.connectEffectLeft(lfpf, ...this._allpassFiltersL);
            else this.connectEffectRight(lfpf, ...this._allpassFiltersR);
            this.roomSize.connect(lfpf.resonance);
            return lfpf;
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "roomSize"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            roomSize: 0.7,
            dampening: 3000
        });
    }
    /**
     * The amount of dampening of the reverberant signal.
     */ get dampening() {
        return this._combFilters[0].dampening;
    }
    set dampening(d) {
        this._combFilters.forEach((c)=>c.dampening = d);
    }
    dispose() {
        super.dispose();
        this._allpassFiltersL.forEach((al)=>al.disconnect());
        this._allpassFiltersR.forEach((ar)=>ar.disconnect());
        this._combFilters.forEach((cf)=>cf.dispose());
        this.roomSize.dispose();
        return this;
    }
}








/**
 * an array of the comb filter delay time values
 */ const $8d68cf8c147e14db$var$combFilterDelayTimes = [
    0.06748,
    0.06404,
    0.08212,
    0.09004
];
/**
 * the resonances of each of the comb filters
 */ const $8d68cf8c147e14db$var$combFilterResonances = [
    0.773,
    0.802,
    0.753,
    0.733
];
/**
 * the allpass filter frequencies
 */ const $8d68cf8c147e14db$var$allpassFilterFreqs = [
    347,
    113,
    37
];
class $8d68cf8c147e14db$export$d0cb5d67c6f5133d extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8d68cf8c147e14db$export$d0cb5d67c6f5133d.getDefaults(), arguments, [
            "roomSize"
        ]));
        this.name = "JCReverb";
        /**
         * a series of allpass filters
         */ this._allpassFilters = [];
        /**
         * parallel feedback comb filters
         */ this._feedbackCombFilters = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8d68cf8c147e14db$export$d0cb5d67c6f5133d.getDefaults(), arguments, [
            "roomSize"
        ]);
        this.roomSize = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.roomSize,
            units: "normalRange"
        });
        this._scaleRoomSize = new (0, $d4646d969ab22afc$export$d60cfc58d3c358b6)({
            context: this.context,
            min: -0.733,
            max: 0.197
        });
        // make the allpass filters
        this._allpassFilters = $8d68cf8c147e14db$var$allpassFilterFreqs.map((freq)=>{
            const allpass = this.context.createBiquadFilter();
            allpass.type = "allpass";
            allpass.frequency.value = freq;
            return allpass;
        });
        // and the comb filters
        this._feedbackCombFilters = $8d68cf8c147e14db$var$combFilterDelayTimes.map((delayTime, index)=>{
            const fbcf = new (0, $39e0d797402e4e21$export$e7a685a7e8ffb78a)({
                context: this.context,
                delayTime: delayTime
            });
            this._scaleRoomSize.connect(fbcf.resonance);
            fbcf.resonance.value = $8d68cf8c147e14db$var$combFilterResonances[index];
            if (index < $8d68cf8c147e14db$var$combFilterDelayTimes.length / 2) this.connectEffectLeft(...this._allpassFilters, fbcf);
            else this.connectEffectRight(...this._allpassFilters, fbcf);
            return fbcf;
        });
        // chain the allpass filters together
        this.roomSize.connect(this._scaleRoomSize);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "roomSize"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            roomSize: 0.5
        });
    }
    dispose() {
        super.dispose();
        this._allpassFilters.forEach((apf)=>apf.disconnect());
        this._feedbackCombFilters.forEach((fbcf)=>fbcf.dispose());
        this.roomSize.dispose();
        this._scaleRoomSize.dispose();
        return this;
    }
}




class $b1f4f96c5094decb$export$a40db16ae36574f7 extends (0, $ef3d96dfca708839$export$d911e987c738486e) {
    constructor(options){
        super(options);
        // the left output connected to the right input
        this._feedbackL.disconnect();
        this._feedbackL.connect(this._feedbackMerge, 0, 1);
        // the left output connected to the right input
        this._feedbackR.disconnect();
        this._feedbackR.connect(this._feedbackMerge, 0, 0);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "feedback"
        ]);
    }
}






class $dc7e67c384875c83$export$7920b8962af65831 extends (0, $b1f4f96c5094decb$export$a40db16ae36574f7) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($dc7e67c384875c83$export$7920b8962af65831.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]));
        this.name = "PingPongDelay";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($dc7e67c384875c83$export$7920b8962af65831.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]);
        this._leftDelay = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this._rightDelay = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this._rightPreDelay = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this.delayTime = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "time",
            value: options.delayTime
        });
        // connect it up
        this.connectEffectLeft(this._leftDelay);
        this.connectEffectRight(this._rightPreDelay, this._rightDelay);
        this.delayTime.fan(this._leftDelay.delayTime, this._rightDelay.delayTime, this._rightPreDelay.delayTime);
        // rearranged the feedback to be after the rightPreDelay
        this._feedbackL.disconnect();
        this._feedbackL.connect(this._rightDelay);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "delayTime"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $b1f4f96c5094decb$export$a40db16ae36574f7).getDefaults(), {
            delayTime: 0.25,
            maxDelay: 1
        });
    }
    dispose() {
        super.dispose();
        this._leftDelay.dispose();
        this._rightDelay.dispose();
        this._rightPreDelay.dispose();
        this.delayTime.dispose();
        return this;
    }
}










class $cd6978095473e468$export$996a02cfaea06f8f extends (0, $fcf44b813eed0eb7$export$125ce1b19cf7db0d) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cd6978095473e468$export$996a02cfaea06f8f.getDefaults(), arguments, [
            "pitch"
        ]));
        this.name = "PitchShift";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cd6978095473e468$export$996a02cfaea06f8f.getDefaults(), arguments, [
            "pitch"
        ]);
        this._frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context
        });
        this._delayA = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            maxDelay: 1,
            context: this.context
        });
        this._lfoA = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            min: 0,
            max: 0.1,
            type: "sawtooth"
        }).connect(this._delayA.delayTime);
        this._delayB = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            maxDelay: 1,
            context: this.context
        });
        this._lfoB = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            min: 0,
            max: 0.1,
            type: "sawtooth",
            phase: 180
        }).connect(this._delayB.delayTime);
        this._crossFade = new (0, $edbbeae191c550fb$export$d78c8c6074541cf2)({
            context: this.context
        });
        this._crossFadeLFO = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            min: 0,
            max: 1,
            type: "triangle",
            phase: 90
        }).connect(this._crossFade.fade);
        this._feedbackDelay = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            delayTime: options.delayTime,
            context: this.context
        });
        this.delayTime = this._feedbackDelay.delayTime;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "delayTime");
        this._pitch = options.pitch;
        this._windowSize = options.windowSize;
        // connect the two delay lines up
        this._delayA.connect(this._crossFade.a);
        this._delayB.connect(this._crossFade.b);
        // connect the frequency
        this._frequency.fan(this._lfoA.frequency, this._lfoB.frequency, this._crossFadeLFO.frequency);
        // route the input
        this.effectSend.fan(this._delayA, this._delayB);
        this._crossFade.chain(this._feedbackDelay, this.effectReturn);
        // start the LFOs at the same time
        const now = this.now();
        this._lfoA.start(now);
        this._lfoB.start(now);
        this._crossFadeLFO.start(now);
        // set the initial value
        this.windowSize = this._windowSize;
    }
    static getDefaults() {
        return Object.assign((0, $fcf44b813eed0eb7$export$125ce1b19cf7db0d).getDefaults(), {
            pitch: 0,
            windowSize: 0.1,
            delayTime: 0,
            feedback: 0
        });
    }
    /**
     * Repitch the incoming signal by some interval (measured in semi-tones).
     * @example
     * const pitchShift = new Tone.PitchShift().toDestination();
     * const osc = new Tone.Oscillator().connect(pitchShift).start().toDestination();
     * pitchShift.pitch = -12; // down one octave
     * pitchShift.pitch = 7; // up a fifth
     */ get pitch() {
        return this._pitch;
    }
    set pitch(interval) {
        this._pitch = interval;
        let factor = 0;
        if (interval < 0) {
            this._lfoA.min = 0;
            this._lfoA.max = this._windowSize;
            this._lfoB.min = 0;
            this._lfoB.max = this._windowSize;
            factor = (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(interval - 1) + 1;
        } else {
            this._lfoA.min = this._windowSize;
            this._lfoA.max = 0;
            this._lfoB.min = this._windowSize;
            this._lfoB.max = 0;
            factor = (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(interval) - 1;
        }
        this._frequency.value = factor * (1.2 / this._windowSize);
    }
    /**
     * The window size corresponds roughly to the sample length in a looping sampler.
     * Smaller values are desirable for a less noticeable delay time of the pitch shifted
     * signal, but larger values will result in smoother pitch shifting for larger intervals.
     * A nominal range of 0.03 to 0.1 is recommended.
     */ get windowSize() {
        return this._windowSize;
    }
    set windowSize(size) {
        this._windowSize = this.toSeconds(size);
        this.pitch = this._pitch;
    }
    dispose() {
        super.dispose();
        this._frequency.dispose();
        this._delayA.dispose();
        this._delayB.dispose();
        this._lfoA.dispose();
        this._lfoB.dispose();
        this._crossFade.dispose();
        this._crossFadeLFO.dispose();
        this._feedbackDelay.dispose();
        return this;
    }
}







class $cea3b54a2bdd8e6c$export$1be4418d8537c3f5 extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cea3b54a2bdd8e6c$export$1be4418d8537c3f5.getDefaults(), arguments, [
            "frequency",
            "octaves",
            "baseFrequency"
        ]));
        this.name = "Phaser";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cea3b54a2bdd8e6c$export$1be4418d8537c3f5.getDefaults(), arguments, [
            "frequency",
            "octaves",
            "baseFrequency"
        ]);
        this._lfoL = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1
        });
        this._lfoR = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1,
            phase: 180
        });
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._octaves = options.octaves;
        this.Q = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.Q,
            units: "positive"
        });
        this._filtersL = this._makeFilters(options.stages, this._lfoL);
        this._filtersR = this._makeFilters(options.stages, this._lfoR);
        this.frequency = this._lfoL.frequency;
        this.frequency.value = options.frequency;
        // connect them up
        this.connectEffectLeft(...this._filtersL);
        this.connectEffectRight(...this._filtersR);
        // control the frequency with one LFO
        this._lfoL.frequency.connect(this._lfoR.frequency);
        // set the options
        this.baseFrequency = options.baseFrequency;
        this.octaves = options.octaves;
        // start the lfo
        this._lfoL.start();
        this._lfoR.start();
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            frequency: 0.5,
            octaves: 3,
            stages: 10,
            Q: 10,
            baseFrequency: 350
        });
    }
    _makeFilters(stages, connectToFreq) {
        const filters = [];
        // make all the filters
        for(let i = 0; i < stages; i++){
            const filter = this.context.createBiquadFilter();
            filter.type = "allpass";
            this.Q.connect(filter.Q);
            connectToFreq.connect(filter.frequency);
            filters.push(filter);
        }
        return filters;
    }
    /**
     * The number of octaves the phase goes above the baseFrequency
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        const max = this._baseFrequency * Math.pow(2, octaves);
        this._lfoL.max = max;
        this._lfoR.max = max;
    }
    /**
     * The the base frequency of the filters.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(freq) {
        this._baseFrequency = this.toFrequency(freq);
        this._lfoL.min = this._baseFrequency;
        this._lfoR.min = this._baseFrequency;
        this.octaves = this._octaves;
    }
    dispose() {
        super.dispose();
        this.Q.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._filtersL.forEach((f)=>f.disconnect());
        this._filtersR.forEach((f)=>f.disconnect());
        this.frequency.dispose();
        return this;
    }
}











class $e421cdcda956c3b5$export$6fb1520d4329a18d extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e421cdcda956c3b5$export$6fb1520d4329a18d.getDefaults(), arguments, [
            "decay"
        ]));
        this.name = "Reverb";
        /**
         * Convolver node
         */ this._convolver = this.context.createConvolver();
        /**
         * Resolves when the reverb buffer is generated. Whenever either [[decay]]
         * or [[preDelay]] are set, you have to wait until [[ready]] resolves
         * before the IR is generated with the latest values.
         */ this.ready = Promise.resolve();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e421cdcda956c3b5$export$6fb1520d4329a18d.getDefaults(), arguments, [
            "decay"
        ]);
        this._decay = options.decay;
        this._preDelay = options.preDelay;
        this.generate();
        this.connectEffect(this._convolver);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            decay: 1.5,
            preDelay: 0.01
        });
    }
    /**
     * The duration of the reverb.
     */ get decay() {
        return this._decay;
    }
    set decay(time) {
        time = this.toSeconds(time);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(time, 0.001);
        this._decay = time;
        this.generate();
    }
    /**
     * The amount of time before the reverb is fully ramped in.
     */ get preDelay() {
        return this._preDelay;
    }
    set preDelay(time) {
        time = this.toSeconds(time);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(time, 0);
        this._preDelay = time;
        this.generate();
    }
    /**
     * Generate the Impulse Response. Returns a promise while the IR is being generated.
     * @return Promise which returns this object.
     */ generate() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const previousReady = this.ready;
            // create a noise burst which decays over the duration in each channel
            const context = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(2, this._decay + this._preDelay, this.context.sampleRate);
            const noiseL = new (0, $93a0a7e8f19a773f$export$484d33a0500a4ce1)({
                context: context
            });
            const noiseR = new (0, $93a0a7e8f19a773f$export$484d33a0500a4ce1)({
                context: context
            });
            const merge = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
                context: context
            });
            noiseL.connect(merge, 0, 0);
            noiseR.connect(merge, 0, 1);
            const gainNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
                context: context
            }).toDestination();
            merge.connect(gainNode);
            noiseL.start(0);
            noiseR.start(0);
            // predelay
            gainNode.gain.setValueAtTime(0, 0);
            gainNode.gain.setValueAtTime(1, this._preDelay);
            // decay
            gainNode.gain.exponentialApproachValueAtTime(0, this._preDelay, this.decay);
            // render the buffer
            const renderPromise = context.render();
            this.ready = renderPromise.then((0, $8cce0c9e2019bc8a$export$b50b6e108474309b));
            // wait for the previous `ready` to resolve
            yield previousReady;
            // set the buffer
            this._convolver.buffer = (yield renderPromise).get();
            return this;
        });
    }
    dispose() {
        super.dispose();
        this._convolver.disconnect();
        return this;
    }
}









class $19a08d555cfc2bca$export$17b3caaa07b8690f extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($19a08d555cfc2bca$export$17b3caaa07b8690f.getDefaults(), arguments));
        this.name = "MidSideSplit";
        this._split = this.input = new (0, $41adc9bb2ea0d651$export$f836382419f64c98)({
            channels: 2,
            context: this.context
        });
        this._midAdd = new (0, $ad8862926b54eb7c$export$d0265b2c425512d6)({
            context: this.context
        });
        this.mid = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._sideSubtract = new (0, $270e4189b1a75906$export$8bc67ae85ef4b74f)({
            context: this.context
        });
        this.side = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._split.connect(this._midAdd, 0);
        this._split.connect(this._midAdd.addend, 1);
        this._split.connect(this._sideSubtract, 0);
        this._split.connect(this._sideSubtract.subtrahend, 1);
        this._midAdd.connect(this.mid);
        this._sideSubtract.connect(this.side);
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._midAdd.dispose();
        this._sideSubtract.dispose();
        this._split.dispose();
        return this;
    }
}









class $166d7e4e0737e4ca$export$be84ddbe7b4fbb5a extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($166d7e4e0737e4ca$export$be84ddbe7b4fbb5a.getDefaults(), arguments));
        this.name = "MidSideMerge";
        this.mid = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.side = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._left = new (0, $ad8862926b54eb7c$export$d0265b2c425512d6)({
            context: this.context
        });
        this._leftMult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._right = new (0, $270e4189b1a75906$export$8bc67ae85ef4b74f)({
            context: this.context
        });
        this._rightMult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._merge = this.output = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
            context: this.context
        });
        this.mid.fan(this._left);
        this.side.connect(this._left.addend);
        this.mid.connect(this._right);
        this.side.connect(this._right.subtrahend);
        this._left.connect(this._leftMult);
        this._right.connect(this._rightMult);
        this._leftMult.connect(this._merge, 0, 0);
        this._rightMult.connect(this._merge, 0, 1);
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._leftMult.dispose();
        this._rightMult.dispose();
        this._left.dispose();
        this._right.dispose();
        return this;
    }
}


class $bfbd5e906f28fdb9$export$67948bb93e06c2e extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(options){
        super(options);
        this.name = "MidSideEffect";
        this._midSideMerge = new (0, $166d7e4e0737e4ca$export$be84ddbe7b4fbb5a)({
            context: this.context
        });
        this._midSideSplit = new (0, $19a08d555cfc2bca$export$17b3caaa07b8690f)({
            context: this.context
        });
        this._midSend = this._midSideSplit.mid;
        this._sideSend = this._midSideSplit.side;
        this._midReturn = this._midSideMerge.mid;
        this._sideReturn = this._midSideMerge.side;
        // the connections
        this.effectSend.connect(this._midSideSplit);
        this._midSideMerge.connect(this.effectReturn);
    }
    /**
     * Connect the mid chain of the effect
     */ connectEffectMid(...nodes) {
        this._midSend.chain(...nodes, this._midReturn);
    }
    /**
     * Connect the side chain of the effect
     */ connectEffectSide(...nodes) {
        this._sideSend.chain(...nodes, this._sideReturn);
    }
    dispose() {
        super.dispose();
        this._midSideSplit.dispose();
        this._midSideMerge.dispose();
        this._midSend.dispose();
        this._sideSend.dispose();
        this._midReturn.dispose();
        this._sideReturn.dispose();
        return this;
    }
}








class $5e555b5fa19b4791$export$54593a5432d0d54c extends (0, $bfbd5e906f28fdb9$export$67948bb93e06c2e) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5e555b5fa19b4791$export$54593a5432d0d54c.getDefaults(), arguments, [
            "width"
        ]));
        this.name = "StereoWidener";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5e555b5fa19b4791$export$54593a5432d0d54c.getDefaults(), arguments, [
            "width"
        ]);
        this.width = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.width,
            units: "normalRange"
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "width"
        ]);
        this._twoTimesWidthMid = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: 2
        });
        this._twoTimesWidthSide = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: 2
        });
        this._midMult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context
        });
        this._twoTimesWidthMid.connect(this._midMult.factor);
        this.connectEffectMid(this._midMult);
        this._oneMinusWidth = new (0, $270e4189b1a75906$export$8bc67ae85ef4b74f)({
            context: this.context
        });
        this._oneMinusWidth.connect(this._twoTimesWidthMid);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this.context.getConstant(1), this._oneMinusWidth);
        this.width.connect(this._oneMinusWidth.subtrahend);
        this._sideMult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context
        });
        this.width.connect(this._twoTimesWidthSide);
        this._twoTimesWidthSide.connect(this._sideMult.factor);
        this.connectEffectSide(this._sideMult);
    }
    static getDefaults() {
        return Object.assign((0, $bfbd5e906f28fdb9$export$67948bb93e06c2e).getDefaults(), {
            width: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.width.dispose();
        this._midMult.dispose();
        this._sideMult.dispose();
        this._twoTimesWidthMid.dispose();
        this._twoTimesWidthSide.dispose();
        this._oneMinusWidth.dispose();
        return this;
    }
}








class $18ff96fe0a1aec28$export$74a4578e446afdc7 extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($18ff96fe0a1aec28$export$74a4578e446afdc7.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]));
        this.name = "Tremolo";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($18ff96fe0a1aec28$export$74a4578e446afdc7.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]);
        this._lfoL = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            type: options.type,
            min: 1,
            max: 0
        });
        this._lfoR = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            type: options.type,
            min: 1,
            max: 0
        });
        this._amplitudeL = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._amplitudeR = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.frequency,
            units: "frequency"
        });
        this.depth = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.depth,
            units: "normalRange"
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "depth"
        ]);
        this.connectEffectLeft(this._amplitudeL);
        this.connectEffectRight(this._amplitudeR);
        this._lfoL.connect(this._amplitudeL.gain);
        this._lfoR.connect(this._amplitudeR.gain);
        this.frequency.fan(this._lfoL.frequency, this._lfoR.frequency);
        this.depth.fan(this._lfoR.amplitude, this._lfoL.amplitude);
        this.spread = options.spread;
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            frequency: 10,
            type: "sine",
            depth: 0.5,
            spread: 180
        });
    }
    /**
     * Start the tremolo.
     */ start(time) {
        this._lfoL.start(time);
        this._lfoR.start(time);
        return this;
    }
    /**
     * Stop the tremolo.
     */ stop(time) {
        this._lfoL.stop(time);
        this._lfoR.stop(time);
        return this;
    }
    /**
     * Sync the effect to the transport.
     */ sync() {
        this._lfoL.sync();
        this._lfoR.sync();
        this.context.transport.syncSignal(this.frequency);
        return this;
    }
    /**
     * Unsync the filter from the transport
     */ unsync() {
        this._lfoL.unsync();
        this._lfoR.unsync();
        this.context.transport.unsyncSignal(this.frequency);
        return this;
    }
    /**
     * The oscillator type.
     */ get type() {
        return this._lfoL.type;
    }
    set type(type) {
        this._lfoL.type = type;
        this._lfoR.type = type;
    }
    /**
     * Amount of stereo spread. When set to 0, both LFO's will be panned centrally.
     * When set to 180, LFO's will be panned hard left and right respectively.
     */ get spread() {
        return this._lfoR.phase - this._lfoL.phase; // 180
    }
    set spread(spread) {
        this._lfoL.phase = 90 - spread / 2;
        this._lfoR.phase = spread / 2 + 90;
    }
    dispose() {
        super.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._amplitudeL.dispose();
        this._amplitudeR.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}







class $39c7f7b701ff2506$export$eb898fc31d087455 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($39c7f7b701ff2506$export$eb898fc31d087455.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]));
        this.name = "Vibrato";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($39c7f7b701ff2506$export$eb898fc31d087455.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]);
        this._delayNode = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            delayTime: 0,
            maxDelay: options.maxDelay
        });
        this._lfo = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            type: options.type,
            min: 0,
            max: options.maxDelay,
            frequency: options.frequency,
            phase: -90 // offse the phase so the resting position is in the center
        }).start().connect(this._delayNode.delayTime);
        this.frequency = this._lfo.frequency;
        this.depth = this._lfo.amplitude;
        this.depth.value = options.depth;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "depth"
        ]);
        this.effectSend.chain(this._delayNode, this.effectReturn);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            maxDelay: 0.005,
            frequency: 5,
            depth: 0.1,
            type: "sine"
        });
    }
    /**
     * Type of oscillator attached to the Vibrato.
     */ get type() {
        return this._lfo.type;
    }
    set type(type) {
        this._lfo.type = type;
    }
    dispose() {
        super.dispose();
        this._delayNode.dispose();
        this._lfo.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}









class $1f00f651da26f3c8$export$86a05438820989b0 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($1f00f651da26f3c8$export$86a05438820989b0.getDefaults(), arguments, [
            "type",
            "size"
        ]));
        this.name = "Analyser";
        /**
         * The analyser node.
         */ this._analysers = [];
        /**
         * The buffer that the FFT data is written to
         */ this._buffers = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($1f00f651da26f3c8$export$86a05438820989b0.getDefaults(), arguments, [
            "type",
            "size"
        ]);
        this.input = this.output = this._gain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._split = new (0, $41adc9bb2ea0d651$export$f836382419f64c98)({
            context: this.context,
            channels: options.channels
        });
        this.input.connect(this._split);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(options.channels, 1);
        // create the analysers
        for(let channel = 0; channel < options.channels; channel++){
            this._analysers[channel] = this.context.createAnalyser();
            this._split.connect(this._analysers[channel], channel, 0);
        }
        // set the values initially
        this.size = options.size;
        this.type = options.type;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            size: 1024,
            smoothing: 0.8,
            type: "fft",
            channels: 1
        });
    }
    /**
     * Run the analysis given the current settings. If [[channels]] = 1,
     * it will return a Float32Array. If [[channels]] > 1, it will
     * return an array of Float32Arrays where each index in the array
     * represents the analysis done on a channel.
     */ getValue() {
        this._analysers.forEach((analyser, index)=>{
            const buffer = this._buffers[index];
            if (this._type === "fft") analyser.getFloatFrequencyData(buffer);
            else if (this._type === "waveform") analyser.getFloatTimeDomainData(buffer);
        });
        if (this.channels === 1) return this._buffers[0];
        else return this._buffers;
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     */ get size() {
        return this._analysers[0].frequencyBinCount;
    }
    set size(size) {
        this._analysers.forEach((analyser, index)=>{
            analyser.fftSize = size * 2;
            this._buffers[index] = new Float32Array(size);
        });
    }
    /**
     * The number of channels the analyser does the analysis on. Channel
     * separation is done using [[Split]]
     */ get channels() {
        return this._analysers.length;
    }
    /**
     * The analysis function returned by analyser.getValue(), either "fft" or "waveform".
     */ get type() {
        return this._type;
    }
    set type(type) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(type === "waveform" || type === "fft", `Analyser: invalid type: ${type}`);
        this._type = type;
    }
    /**
     * 0 represents no time averaging with the last analysis frame.
     */ get smoothing() {
        return this._analysers[0].smoothingTimeConstant;
    }
    set smoothing(val) {
        this._analysers.forEach((a)=>a.smoothingTimeConstant = val);
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._analysers.forEach((a)=>a.disconnect());
        this._split.dispose();
        this._gain.dispose();
        return this;
    }
}







class $2310c477c62ba237$export$67f5eb90858fca69 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2310c477c62ba237$export$67f5eb90858fca69.getDefaults(), arguments));
        this.name = "MeterBase";
        this.input = this.output = this._analyser = new (0, $1f00f651da26f3c8$export$86a05438820989b0)({
            context: this.context,
            size: 256,
            type: "waveform"
        });
    }
    dispose() {
        super.dispose();
        this._analyser.dispose();
        return this;
    }
}




class $93ce187344e44f5e$export$62e3ae2a4090b879 extends (0, $2310c477c62ba237$export$67f5eb90858fca69) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($93ce187344e44f5e$export$62e3ae2a4090b879.getDefaults(), arguments, [
            "smoothing"
        ]));
        this.name = "Meter";
        /**
         * The previous frame's value
         */ this._rms = 0;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($93ce187344e44f5e$export$62e3ae2a4090b879.getDefaults(), arguments, [
            "smoothing"
        ]);
        this.input = this.output = this._analyser = new (0, $1f00f651da26f3c8$export$86a05438820989b0)({
            context: this.context,
            size: 256,
            type: "waveform",
            channels: options.channels
        });
        this.smoothing = options.smoothing, this.normalRange = options.normalRange;
    }
    static getDefaults() {
        return Object.assign((0, $2310c477c62ba237$export$67f5eb90858fca69).getDefaults(), {
            smoothing: 0.8,
            normalRange: false,
            channels: 1
        });
    }
    /**
     * Use [[getValue]] instead. For the previous getValue behavior, use DCMeter.
     * @deprecated
     */ getLevel() {
        (0, $afc9146c77d080c2$export$c106dd0671a0fc2d)("'getLevel' has been changed to 'getValue'");
        return this.getValue();
    }
    /**
     * Get the current value of the incoming signal.
     * Output is in decibels when [[normalRange]] is `false`.
     * If [[channels]] = 1, then the output is a single number
     * representing the value of the input signal. When [[channels]] > 1,
     * then each channel is returned as a value in a number array.
     */ getValue() {
        const aValues = this._analyser.getValue();
        const channelValues = this.channels === 1 ? [
            aValues
        ] : aValues;
        const vals = channelValues.map((values)=>{
            const totalSquared = values.reduce((total, current)=>total + current * current, 0);
            const rms = Math.sqrt(totalSquared / values.length);
            // the rms can only fall at the rate of the smoothing
            // but can jump up instantly
            this._rms = Math.max(rms, this._rms * this.smoothing);
            return this.normalRange ? this._rms : (0, $84c2af7dbf01a14d$export$6af3969727ca2a60)(this._rms);
        });
        if (this.channels === 1) return vals[0];
        else return vals;
    }
    /**
     * The number of channels of analysis.
     */ get channels() {
        return this._analyser.channels;
    }
    dispose() {
        super.dispose();
        this._analyser.dispose();
        return this;
    }
}







class $98236c1e3c0a17e3$export$677347237c014ba extends (0, $2310c477c62ba237$export$67f5eb90858fca69) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($98236c1e3c0a17e3$export$677347237c014ba.getDefaults(), arguments, [
            "size"
        ]));
        this.name = "FFT";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($98236c1e3c0a17e3$export$677347237c014ba.getDefaults(), arguments, [
            "size"
        ]);
        this.normalRange = options.normalRange;
        this._analyser.type = "fft";
        this.size = options.size;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            normalRange: false,
            size: 1024,
            smoothing: 0.8
        });
    }
    /**
     * Gets the current frequency data from the connected audio source.
     * Returns the frequency data of length [[size]] as a Float32Array of decibel values.
     */ getValue() {
        const values = this._analyser.getValue();
        return values.map((v)=>this.normalRange ? (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(v) : v);
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     * Determines the size of the array returned by [[getValue]] (i.e. the number of
     * frequency bins). Large FFT sizes may be costly to compute.
     */ get size() {
        return this._analyser.size;
    }
    set size(size) {
        this._analyser.size = size;
    }
    /**
     * 0 represents no time averaging with the last analysis frame.
     */ get smoothing() {
        return this._analyser.smoothing;
    }
    set smoothing(val) {
        this._analyser.smoothing = val;
    }
    /**
     * Returns the frequency value in hertz of each of the indices of the FFT's [[getValue]] response.
     * @example
     * const fft = new Tone.FFT(32);
     * console.log([0, 1, 2, 3, 4].map(index => fft.getFrequencyOfIndex(index)));
     */ getFrequencyOfIndex(index) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(0 <= index && index < this.size, `index must be greater than or equal to 0 and less than ${this.size}`);
        return index * this.context.sampleRate / (this.size * 2);
    }
}




class $873fd3dda72326af$export$29aa14d256c74cc6 extends (0, $2310c477c62ba237$export$67f5eb90858fca69) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($873fd3dda72326af$export$29aa14d256c74cc6.getDefaults(), arguments));
        this.name = "DCMeter";
        this._analyser.type = "waveform";
        this._analyser.size = 256;
    }
    /**
     * Get the signal value of the incoming signal
     */ getValue() {
        const value = this._analyser.getValue();
        return value[0];
    }
}




class $cc680edd8ffd9180$export$4c2f72a4f17a358e extends (0, $2310c477c62ba237$export$67f5eb90858fca69) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cc680edd8ffd9180$export$4c2f72a4f17a358e.getDefaults(), arguments, [
            "size"
        ]));
        this.name = "Waveform";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cc680edd8ffd9180$export$4c2f72a4f17a358e.getDefaults(), arguments, [
            "size"
        ]);
        this._analyser.type = "waveform";
        this.size = options.size;
    }
    static getDefaults() {
        return Object.assign((0, $2310c477c62ba237$export$67f5eb90858fca69).getDefaults(), {
            size: 1024
        });
    }
    /**
     * Return the waveform for the current time as a Float32Array where each value in the array
     * represents a sample in the waveform.
     */ getValue() {
        return this._analyser.getValue();
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     * Determines the size of the array returned by [[getValue]].
     */ get size() {
        return this._analyser.size;
    }
    set size(size) {
        this._analyser.size = size;
    }
}








class $029368b9c74b1b72$export$43343ff6c11f7ee5 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($029368b9c74b1b72$export$43343ff6c11f7ee5.getDefaults(), arguments, [
            "solo"
        ]));
        this.name = "Solo";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($029368b9c74b1b72$export$43343ff6c11f7ee5.getDefaults(), arguments, [
            "solo"
        ]);
        this.input = this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        if (!$029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.has(this.context)) $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.set(this.context, new Set());
        $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.get(this.context).add(this);
        // set initially
        this.solo = options.solo;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            solo: false
        });
    }
    /**
     * Isolates this instance and mutes all other instances of Solo.
     * Only one instance can be soloed at a time. A soloed
     * instance will report `solo=false` when another instance is soloed.
     */ get solo() {
        return this._isSoloed();
    }
    set solo(solo) {
        if (solo) this._addSolo();
        else this._removeSolo();
        $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.get(this.context).forEach((instance)=>instance._updateSolo());
    }
    /**
     * If the current instance is muted, i.e. another instance is soloed
     */ get muted() {
        return this.input.gain.value === 0;
    }
    /**
     * Add this to the soloed array
     */ _addSolo() {
        if (!$029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context)) $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.set(this.context, new Set());
        $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.get(this.context).add(this);
    }
    /**
     * Remove this from the soloed array
     */ _removeSolo() {
        if ($029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context)) $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.get(this.context).delete(this);
    }
    /**
     * Is this on the soloed array
     */ _isSoloed() {
        return $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context) && $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.get(this.context).has(this);
    }
    /**
     * Returns true if no one is soloed
     */ _noSolos() {
        // either does not have any soloed added
        return !$029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context) || // or has a solo set but doesn't include any items
        $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context) && $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.get(this.context).size === 0;
    }
    /**
     * Solo the current instance and unsolo all other instances.
     */ _updateSolo() {
        if (this._isSoloed()) this.input.gain.value = 1;
        else if (this._noSolos()) // no one is soloed
        this.input.gain.value = 1;
        else this.input.gain.value = 0;
    }
    dispose() {
        super.dispose();
        $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.get(this.context).delete(this);
        this._removeSolo();
        return this;
    }
}
/**
 * Hold all of the solo'ed tracks belonging to a specific context
 */ $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos = new Map();
/**
 * Hold the currently solo'ed instance(s)
 */ $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed = new Map();







class $35f89e90159c405d$export$e62efb0df83a5c7c extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($35f89e90159c405d$export$e62efb0df83a5c7c.getDefaults(), arguments, [
            "pan",
            "volume"
        ]));
        this.name = "PanVol";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($35f89e90159c405d$export$e62efb0df83a5c7c.getDefaults(), arguments, [
            "pan",
            "volume"
        ]);
        this._panner = this.input = new (0, $3104cbf8d2a8337f$export$d6d7a1629e59823d)({
            context: this.context,
            pan: options.pan,
            channelCount: options.channelCount
        });
        this.pan = this._panner.pan;
        this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        // connections
        this._panner.connect(this._volume);
        this.mute = options.mute;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "pan",
            "volume"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            pan: 0,
            volume: 0,
            channelCount: 1
        });
    }
    /**
     * Mute/unmute the volume
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    dispose() {
        super.dispose();
        this._panner.dispose();
        this.pan.dispose();
        this._volume.dispose();
        this.volume.dispose();
        return this;
    }
}




class $01b9d2d997527d24$export$cfdacaa37f9b4dd7 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($01b9d2d997527d24$export$cfdacaa37f9b4dd7.getDefaults(), arguments, [
            "volume",
            "pan"
        ]));
        this.name = "Channel";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($01b9d2d997527d24$export$cfdacaa37f9b4dd7.getDefaults(), arguments, [
            "volume",
            "pan"
        ]);
        this._solo = this.input = new (0, $029368b9c74b1b72$export$43343ff6c11f7ee5)({
            solo: options.solo,
            context: this.context
        });
        this._panVol = this.output = new (0, $35f89e90159c405d$export$e62efb0df83a5c7c)({
            context: this.context,
            pan: options.pan,
            volume: options.volume,
            mute: options.mute,
            channelCount: options.channelCount
        });
        this.pan = this._panVol.pan;
        this.volume = this._panVol.volume;
        this._solo.connect(this._panVol);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "pan",
            "volume"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            pan: 0,
            volume: 0,
            mute: false,
            solo: false,
            channelCount: 1
        });
    }
    /**
     * Solo/unsolo the channel. Soloing is only relative to other [[Channels]] and [[Solo]] instances
     */ get solo() {
        return this._solo.solo;
    }
    set solo(solo) {
        this._solo.solo = solo;
    }
    /**
     * If the current instance is muted, i.e. another instance is soloed,
     * or the channel is muted
     */ get muted() {
        return this._solo.muted || this.mute;
    }
    /**
     * Mute/unmute the volume
     */ get mute() {
        return this._panVol.mute;
    }
    set mute(mute) {
        this._panVol.mute = mute;
    }
    /**
     * Get the gain node belonging to the bus name. Create it if
     * it doesn't exist
     * @param name The bus name
     */ _getBus(name) {
        if (!$01b9d2d997527d24$export$cfdacaa37f9b4dd7.buses.has(name)) $01b9d2d997527d24$export$cfdacaa37f9b4dd7.buses.set(name, new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        }));
        return $01b9d2d997527d24$export$cfdacaa37f9b4dd7.buses.get(name);
    }
    /**
     * Send audio to another channel using a string. `send` is a lot like
     * [[connect]], except it uses a string instead of an object. This can
     * be useful in large applications to decouple sections since [[send]]
     * and [[receive]] can be invoked separately in order to connect an object
     * @param name The channel name to send the audio
     * @param volume The amount of the signal to send.
     * 	Defaults to 0db, i.e. send the entire signal
     * @returns Returns the gain node of this connection.
     */ send(name, volume = 0) {
        const bus = this._getBus(name);
        const sendKnob = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            units: "decibels",
            gain: volume
        });
        this.connect(sendKnob);
        sendKnob.connect(bus);
        return sendKnob;
    }
    /**
     * Receive audio from a channel which was connected with [[send]].
     * @param name The channel name to receive audio from.
     */ receive(name) {
        const bus = this._getBus(name);
        bus.connect(this);
        return this;
    }
    dispose() {
        super.dispose();
        this._panVol.dispose();
        this.pan.dispose();
        this.volume.dispose();
        this._solo.dispose();
        return this;
    }
}
/**
 * Store the send/receive channels by name.
 */ $01b9d2d997527d24$export$cfdacaa37f9b4dd7.buses = new Map();










class $af3c892bcfe05cf9$export$6a6cc05ddf64d43 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($af3c892bcfe05cf9$export$6a6cc05ddf64d43.getDefaults(), arguments));
        this.name = "Mono";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._merge = this.output = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
            channels: 2,
            context: this.context
        });
        this.input.connect(this._merge, 0, 0);
        this.input.connect(this._merge, 0, 1);
    }
    dispose() {
        super.dispose();
        this._merge.dispose();
        this.input.dispose();
        return this;
    }
}








class $595a0cee03b7d711$export$8243399b0243bc0b extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($595a0cee03b7d711$export$8243399b0243bc0b.getDefaults(), arguments, [
            "lowFrequency",
            "highFrequency"
        ]));
        this.name = "MultibandSplit";
        /**
         * the input
         */ this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * no output node, use either low, mid or high outputs
         */ this.output = undefined;
        /**
         * The low band.
         */ this.low = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            frequency: 0,
            type: "lowpass"
        });
        /**
         * the lower filter of the mid band
         */ this._lowMidFilter = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            frequency: 0,
            type: "highpass"
        });
        /**
         * The mid band output.
         */ this.mid = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            frequency: 0,
            type: "lowpass"
        });
        /**
         * The high band output.
         */ this.high = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            frequency: 0,
            type: "highpass"
        });
        this._internalChannels = [
            this.low,
            this.mid,
            this.high
        ];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($595a0cee03b7d711$export$8243399b0243bc0b.getDefaults(), arguments, [
            "lowFrequency",
            "highFrequency"
        ]);
        this.lowFrequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.lowFrequency
        });
        this.highFrequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.highFrequency
        });
        this.Q = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "positive",
            value: options.Q
        });
        this.input.fan(this.low, this.high);
        this.input.chain(this._lowMidFilter, this.mid);
        // the frequency control signal
        this.lowFrequency.fan(this.low.frequency, this._lowMidFilter.frequency);
        this.highFrequency.fan(this.mid.frequency, this.high.frequency);
        // the Q value
        this.Q.connect(this.low.Q);
        this.Q.connect(this._lowMidFilter.Q);
        this.Q.connect(this.mid.Q);
        this.Q.connect(this.high.Q);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            Q: 1,
            highFrequency: 2500,
            lowFrequency: 400
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        (0, $8cce0c9e2019bc8a$export$e6d3eada50a007b1)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
        this.low.dispose();
        this._lowMidFilter.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.lowFrequency.dispose();
        this.highFrequency.dispose();
        this.Q.dispose();
        return this;
    }
}









class $a325a8508d33c2c8$export$c92b1d5f43586026 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(...arguments);
        this.name = "Listener";
        this.positionX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.positionX
        });
        this.positionY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.positionY
        });
        this.positionZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.positionZ
        });
        this.forwardX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.forwardX
        });
        this.forwardY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.forwardY
        });
        this.forwardZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.forwardZ
        });
        this.upX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.upX
        });
        this.upY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.upY
        });
        this.upZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.upZ
        });
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            forwardX: 0,
            forwardY: 0,
            forwardZ: -1,
            upX: 0,
            upY: 1,
            upZ: 0
        });
    }
    dispose() {
        super.dispose();
        this.positionX.dispose();
        this.positionY.dispose();
        this.positionZ.dispose();
        this.forwardX.dispose();
        this.forwardY.dispose();
        this.forwardZ.dispose();
        this.upX.dispose();
        this.upY.dispose();
        this.upZ.dispose();
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $33268d33018da22a$export$cdd816203a02e74e)((context)=>{
    context.listener = new $a325a8508d33c2c8$export$c92b1d5f43586026({
        context: context
    });
});
(0, $33268d33018da22a$export$7e1ecadd06ae8222)((context)=>{
    context.listener.dispose();
});


class $25cdfed72df3ea98$export$40229b68a3be8579 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($25cdfed72df3ea98$export$40229b68a3be8579.getDefaults(), arguments, [
            "positionX",
            "positionY",
            "positionZ"
        ]));
        this.name = "Panner3D";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($25cdfed72df3ea98$export$40229b68a3be8579.getDefaults(), arguments, [
            "positionX",
            "positionY",
            "positionZ"
        ]);
        this._panner = this.input = this.output = this.context.createPanner();
        // set some values
        this.panningModel = options.panningModel;
        this.maxDistance = options.maxDistance;
        this.distanceModel = options.distanceModel;
        this.coneOuterGain = options.coneOuterGain;
        this.coneOuterAngle = options.coneOuterAngle;
        this.coneInnerAngle = options.coneInnerAngle;
        this.refDistance = options.refDistance;
        this.rolloffFactor = options.rolloffFactor;
        this.positionX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.positionX,
            value: options.positionX
        });
        this.positionY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.positionY,
            value: options.positionY
        });
        this.positionZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.positionZ,
            value: options.positionZ
        });
        this.orientationX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.orientationX,
            value: options.orientationX
        });
        this.orientationY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.orientationY,
            value: options.orientationY
        });
        this.orientationZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.orientationZ,
            value: options.orientationZ
        });
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            coneInnerAngle: 360,
            coneOuterAngle: 360,
            coneOuterGain: 0,
            distanceModel: "inverse",
            maxDistance: 10000,
            orientationX: 0,
            orientationY: 0,
            orientationZ: 0,
            panningModel: "equalpower",
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            refDistance: 1,
            rolloffFactor: 1
        });
    }
    /**
     * Sets the position of the source in 3d space.
     */ setPosition(x, y, z) {
        this.positionX.value = x;
        this.positionY.value = y;
        this.positionZ.value = z;
        return this;
    }
    /**
     * Sets the orientation of the source in 3d space.
     */ setOrientation(x, y, z) {
        this.orientationX.value = x;
        this.orientationY.value = y;
        this.orientationZ.value = z;
        return this;
    }
    /**
     * The panning model. Either "equalpower" or "HRTF".
     */ get panningModel() {
        return this._panner.panningModel;
    }
    set panningModel(val) {
        this._panner.panningModel = val;
    }
    /**
     * A reference distance for reducing volume as source move further from the listener
     */ get refDistance() {
        return this._panner.refDistance;
    }
    set refDistance(val) {
        this._panner.refDistance = val;
    }
    /**
     * Describes how quickly the volume is reduced as source moves away from listener.
     */ get rolloffFactor() {
        return this._panner.rolloffFactor;
    }
    set rolloffFactor(val) {
        this._panner.rolloffFactor = val;
    }
    /**
     * The distance model used by,  "linear", "inverse", or "exponential".
     */ get distanceModel() {
        return this._panner.distanceModel;
    }
    set distanceModel(val) {
        this._panner.distanceModel = val;
    }
    /**
     * The angle, in degrees, inside of which there will be no volume reduction
     */ get coneInnerAngle() {
        return this._panner.coneInnerAngle;
    }
    set coneInnerAngle(val) {
        this._panner.coneInnerAngle = val;
    }
    /**
     * The angle, in degrees, outside of which the volume will be reduced
     * to a constant value of coneOuterGain
     */ get coneOuterAngle() {
        return this._panner.coneOuterAngle;
    }
    set coneOuterAngle(val) {
        this._panner.coneOuterAngle = val;
    }
    /**
     * The gain outside of the coneOuterAngle
     */ get coneOuterGain() {
        return this._panner.coneOuterGain;
    }
    set coneOuterGain(val) {
        this._panner.coneOuterGain = val;
    }
    /**
     * The maximum distance between source and listener,
     * after which the volume will not be reduced any further.
     */ get maxDistance() {
        return this._panner.maxDistance;
    }
    set maxDistance(val) {
        this._panner.maxDistance = val;
    }
    dispose() {
        super.dispose();
        this._panner.disconnect();
        this.orientationX.dispose();
        this.orientationY.dispose();
        this.orientationZ.dispose();
        this.positionX.dispose();
        this.positionY.dispose();
        this.positionZ.dispose();
        return this;
    }
}









class $351b1d4f73bc2919$export$336a011955157f9a extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($351b1d4f73bc2919$export$336a011955157f9a.getDefaults(), arguments));
        this.name = "Recorder";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($351b1d4f73bc2919$export$336a011955157f9a.getDefaults(), arguments);
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        (0, $afc9146c77d080c2$export$a7a9523472993e97)($351b1d4f73bc2919$export$336a011955157f9a.supported, "Media Recorder API is not available");
        this._stream = this.context.createMediaStreamDestination();
        this.input.connect(this._stream);
        this._recorder = new MediaRecorder(this._stream.stream, {
            mimeType: options.mimeType
        });
    }
    static getDefaults() {
        return (0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults();
    }
    /**
     * The mime type is the format that the audio is encoded in. For Chrome
     * that is typically webm encoded as "vorbis".
     */ get mimeType() {
        return this._recorder.mimeType;
    }
    /**
     * Test if your platform supports the Media Recorder API. If it's not available,
     * try installing this (polyfill)[https://www.npmjs.com/package/audio-recorder-polyfill].
     */ static get supported() {
        return (0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2) !== null && Reflect.has((0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2), "MediaRecorder");
    }
    /**
     * Get the playback state of the Recorder, either "started", "stopped" or "paused"
     */ get state() {
        if (this._recorder.state === "inactive") return "stopped";
        else if (this._recorder.state === "paused") return "paused";
        else return "started";
    }
    /**
     * Start the Recorder. Returns a promise which resolves
     * when the recorder has started.
     */ start() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.state !== "started", "Recorder is already started");
            const startPromise = new Promise((done)=>{
                const handleStart = ()=>{
                    this._recorder.removeEventListener("start", handleStart, false);
                    done();
                };
                this._recorder.addEventListener("start", handleStart, false);
            });
            this._recorder.start();
            return yield startPromise;
        });
    }
    /**
     * Stop the recorder. Returns a promise with the recorded content until this point
     * encoded as [[mimeType]]
     */ stop() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.state !== "stopped", "Recorder is not started");
            const dataPromise = new Promise((done)=>{
                const handleData = (e)=>{
                    this._recorder.removeEventListener("dataavailable", handleData, false);
                    done(e.data);
                };
                this._recorder.addEventListener("dataavailable", handleData, false);
            });
            this._recorder.stop();
            return yield dataPromise;
        });
    }
    /**
     * Pause the recorder
     */ pause() {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.state === "started", "Recorder must be started");
        this._recorder.pause();
        return this;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this._stream.disconnect();
        return this;
    }
}









class $f3c1c7f69db8aec2$export$41ba31ea44cbf87a extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f3c1c7f69db8aec2$export$41ba31ea44cbf87a.getDefaults(), arguments, [
            "threshold",
            "ratio"
        ]));
        this.name = "Compressor";
        /**
         * the compressor node
         */ this._compressor = this.context.createDynamicsCompressor();
        this.input = this._compressor;
        this.output = this._compressor;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f3c1c7f69db8aec2$export$41ba31ea44cbf87a.getDefaults(), arguments, [
            "threshold",
            "ratio"
        ]);
        this.threshold = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.threshold.minValue,
            maxValue: this._compressor.threshold.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.threshold,
            units: "decibels",
            value: options.threshold
        });
        this.attack = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.attack.minValue,
            maxValue: this._compressor.attack.maxValue,
            context: this.context,
            param: this._compressor.attack,
            units: "time",
            value: options.attack
        });
        this.release = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.release.minValue,
            maxValue: this._compressor.release.maxValue,
            context: this.context,
            param: this._compressor.release,
            units: "time",
            value: options.release
        });
        this.knee = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.knee.minValue,
            maxValue: this._compressor.knee.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.knee,
            units: "decibels",
            value: options.knee
        });
        this.ratio = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.ratio.minValue,
            maxValue: this._compressor.ratio.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.ratio,
            units: "positive",
            value: options.ratio
        });
        // set the defaults
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "knee",
            "release",
            "attack",
            "ratio",
            "threshold"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            attack: 0.003,
            knee: 30,
            ratio: 12,
            release: 0.25,
            threshold: -24
        });
    }
    /**
     * A read-only decibel value for metering purposes, representing the current amount of gain
     * reduction that the compressor is applying to the signal. If fed no signal the value will be 0 (no gain reduction).
     */ get reduction() {
        return this._compressor.reduction;
    }
    dispose() {
        super.dispose();
        this._compressor.disconnect();
        this.attack.dispose();
        this.release.dispose();
        this.threshold.dispose();
        this.ratio.dispose();
        this.knee.dispose();
        return this;
    }
}








class $b1dc822c92d1cb83$export$b4bc28ee584f979c extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($b1dc822c92d1cb83$export$b4bc28ee584f979c.getDefaults(), arguments, [
            "threshold",
            "smoothing"
        ])));
        this.name = "Gate";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($b1dc822c92d1cb83$export$b4bc28ee584f979c.getDefaults(), arguments, [
            "threshold",
            "smoothing"
        ]);
        this._follower = new (0, $1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f)({
            context: this.context,
            smoothing: options.smoothing
        });
        this._gt = new (0, $935df50545cf657e$export$fdac76ab71aa5db6)({
            context: this.context,
            value: (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(options.threshold)
        });
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._gate = this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        // connections
        this.input.connect(this._gate);
        // the control signal
        this.input.chain(this._follower, this._gt, this._gate.gain);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            smoothing: 0.1,
            threshold: -40
        });
    }
    /**
     * The threshold of the gate in decibels
     */ get threshold() {
        return (0, $84c2af7dbf01a14d$export$6af3969727ca2a60)(this._gt.value);
    }
    set threshold(thresh) {
        this._gt.value = (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(thresh);
    }
    /**
     * The attack/decay speed of the gate. See [[Follower.smoothing]]
     */ get smoothing() {
        return this._follower.smoothing;
    }
    set smoothing(smoothingTime) {
        this._follower.smoothing = smoothingTime;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this._follower.dispose();
        this._gt.dispose();
        this._gate.dispose();
        return this;
    }
}






class $3acc0d741b04b4a9$export$18d8154f27ea9172 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3acc0d741b04b4a9$export$18d8154f27ea9172.getDefaults(), arguments, [
            "threshold"
        ])));
        this.name = "Limiter";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3acc0d741b04b4a9$export$18d8154f27ea9172.getDefaults(), arguments, [
            "threshold"
        ]);
        this._compressor = this.input = this.output = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)({
            context: this.context,
            ratio: 20,
            attack: 0.003,
            release: 0.01,
            threshold: options.threshold
        });
        this.threshold = this._compressor.threshold;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "threshold");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            threshold: -12
        });
    }
    /**
     * A read-only decibel value for metering purposes, representing the current amount of gain
     * reduction that the compressor is applying to the signal.
     */ get reduction() {
        return this._compressor.reduction;
    }
    dispose() {
        super.dispose();
        this._compressor.dispose();
        this.threshold.dispose();
        return this;
    }
}








class $3f1bdd788834c9c8$export$4fe244964f9889ae extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3f1bdd788834c9c8$export$4fe244964f9889ae.getDefaults(), arguments)));
        this.name = "MidSideCompressor";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3f1bdd788834c9c8$export$4fe244964f9889ae.getDefaults(), arguments);
        this._midSideSplit = this.input = new (0, $19a08d555cfc2bca$export$17b3caaa07b8690f)({
            context: this.context
        });
        this._midSideMerge = this.output = new (0, $166d7e4e0737e4ca$export$be84ddbe7b4fbb5a)({
            context: this.context
        });
        this.mid = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.mid, {
            context: this.context
        }));
        this.side = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.side, {
            context: this.context
        }));
        this._midSideSplit.mid.chain(this.mid, this._midSideMerge.mid);
        this._midSideSplit.side.chain(this.side, this._midSideMerge.side);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "mid",
            "side"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mid: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            },
            side: {
                ratio: 6,
                threshold: -30,
                release: 0.25,
                attack: 0.03,
                knee: 10
            }
        });
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._midSideSplit.dispose();
        this._midSideMerge.dispose();
        return this;
    }
}








class $faccc413e9e95c99$export$7cd9eb83d48f580b extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(Object.assign((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faccc413e9e95c99$export$7cd9eb83d48f580b.getDefaults(), arguments)));
        this.name = "MultibandCompressor";
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faccc413e9e95c99$export$7cd9eb83d48f580b.getDefaults(), arguments);
        this._splitter = this.input = new (0, $595a0cee03b7d711$export$8243399b0243bc0b)({
            context: this.context,
            lowFrequency: options.lowFrequency,
            highFrequency: options.highFrequency
        });
        this.lowFrequency = this._splitter.lowFrequency;
        this.highFrequency = this._splitter.highFrequency;
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.low = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.low, {
            context: this.context
        }));
        this.mid = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.mid, {
            context: this.context
        }));
        this.high = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.high, {
            context: this.context
        }));
        // connect the compressor
        this._splitter.low.chain(this.low, this.output);
        this._splitter.mid.chain(this.mid, this.output);
        this._splitter.high.chain(this.high, this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            lowFrequency: 250,
            highFrequency: 2000,
            low: {
                ratio: 6,
                threshold: -30,
                release: 0.25,
                attack: 0.03,
                knee: 10
            },
            mid: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            },
            high: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            }
        });
    }
    dispose() {
        super.dispose();
        this._splitter.dispose();
        this.low.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.output.dispose();
        return this;
    }
}










class $97dc6ad5209e914a$export$2adf407ed955ca5d extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($97dc6ad5209e914a$export$2adf407ed955ca5d.getDefaults(), arguments, [
            "low",
            "mid",
            "high"
        ]));
        this.name = "EQ3";
        /**
         * the output
         */ this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._internalChannels = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($97dc6ad5209e914a$export$2adf407ed955ca5d.getDefaults(), arguments, [
            "low",
            "mid",
            "high"
        ]);
        this.input = this._multibandSplit = new (0, $595a0cee03b7d711$export$8243399b0243bc0b)({
            context: this.context,
            highFrequency: options.highFrequency,
            lowFrequency: options.lowFrequency
        });
        this._lowGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.low,
            units: "decibels"
        });
        this._midGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.mid,
            units: "decibels"
        });
        this._highGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.high,
            units: "decibels"
        });
        this.low = this._lowGain.gain;
        this.mid = this._midGain.gain;
        this.high = this._highGain.gain;
        this.Q = this._multibandSplit.Q;
        this.lowFrequency = this._multibandSplit.lowFrequency;
        this.highFrequency = this._multibandSplit.highFrequency;
        // the frequency bands
        this._multibandSplit.low.chain(this._lowGain, this.output);
        this._multibandSplit.mid.chain(this._midGain, this.output);
        this._multibandSplit.high.chain(this._highGain, this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "low",
            "mid",
            "high",
            "lowFrequency",
            "highFrequency"
        ]);
        this._internalChannels = [
            this._multibandSplit
        ];
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            high: 0,
            highFrequency: 2500,
            low: 0,
            lowFrequency: 400,
            mid: 0
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        (0, $8cce0c9e2019bc8a$export$e6d3eada50a007b1)(this, [
            "low",
            "mid",
            "high",
            "lowFrequency",
            "highFrequency"
        ]);
        this._multibandSplit.dispose();
        this.lowFrequency.dispose();
        this.highFrequency.dispose();
        this._lowGain.dispose();
        this._midGain.dispose();
        this._highGain.dispose();
        this.low.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.Q.dispose();
        return this;
    }
}












class $277738816d5b8132$export$f48597cb240e2420 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($277738816d5b8132$export$f48597cb240e2420.getDefaults(), arguments, [
            "url",
            "onload"
        ]));
        this.name = "Convolver";
        /**
         * The native ConvolverNode
         */ this._convolver = this.context.createConvolver();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($277738816d5b8132$export$f48597cb240e2420.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        this._buffer = new (0, $43da6dea502b5fe8$export$424a335715b38178)(options.url, (buffer)=>{
            this.buffer = buffer;
            options.onload();
        });
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        // set if it's already loaded, set it immediately
        if (this._buffer.loaded) this.buffer = this._buffer;
        // initially set normalization
        this.normalize = options.normalize;
        // connect it up
        this.input.chain(this._convolver, this.output);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            normalize: true,
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)
        });
    }
    /**
     * Load an impulse response url as an audio buffer.
     * Decodes the audio asynchronously and invokes
     * the callback once the audio buffer loads.
     * @param url The url of the buffer to load. filetype support depends on the browser.
     */ load(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            this.buffer = yield this._buffer.load(url);
        });
    }
    /**
     * The convolver's buffer
     */ get buffer() {
        if (this._buffer.length) return this._buffer;
        else return null;
    }
    set buffer(buffer) {
        if (buffer) this._buffer.set(buffer);
        // if it's already got a buffer, create a new one
        if (this._convolver.buffer) {
            // disconnect the old one
            this.input.disconnect();
            this._convolver.disconnect();
            // create and connect a new one
            this._convolver = this.context.createConvolver();
            this.input.chain(this._convolver, this.output);
        }
        const buff = this._buffer.get();
        this._convolver.buffer = buff ? buff : null;
    }
    /**
     * The normalize property of the ConvolverNode interface is a boolean that
     * controls whether the impulse response from the buffer will be scaled by
     * an equal-power normalization when the buffer attribute is set, or not.
     */ get normalize() {
        return this._convolver.normalize;
    }
    set normalize(norm) {
        this._convolver.normalize = norm;
    }
    dispose() {
        super.dispose();
        this._buffer.dispose();
        this._convolver.disconnect();
        return this;
    }
}












function $e40393b998e22e0d$export$461939dd4422153() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().now();
}
function $e40393b998e22e0d$export$7aea7eb3d7f025ec() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().immediate();
}
const $e40393b998e22e0d$export$86495b081fef8e52 = (0, $b7b11709569bdbef$export$31553aaa555c1514)().transport;
function $e40393b998e22e0d$export$867d8b939ab7f43e() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().transport;
}
const $e40393b998e22e0d$export$5c4bdf44e1e9cea1 = (0, $b7b11709569bdbef$export$31553aaa555c1514)().destination;
const $e40393b998e22e0d$export$44fd2db2d162647d = (0, $b7b11709569bdbef$export$31553aaa555c1514)().destination;
function $e40393b998e22e0d$export$be071a6ef30bc5f7() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().destination;
}
const $e40393b998e22e0d$export$c92b1d5f43586026 = (0, $b7b11709569bdbef$export$31553aaa555c1514)().listener;
function $e40393b998e22e0d$export$12abb5141c6fdc9c() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().listener;
}
const $e40393b998e22e0d$export$dca20402ebea5ece = (0, $b7b11709569bdbef$export$31553aaa555c1514)().draw;
function $e40393b998e22e0d$export$dc345928c36e8deb() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().draw;
}
const $e40393b998e22e0d$export$a078c61943f9dbbe = (0, $b7b11709569bdbef$export$31553aaa555c1514)();
function $e40393b998e22e0d$export$b40fc69c4a2927a1() {
    return (0, $43da6dea502b5fe8$export$424a335715b38178).loaded();
}
const $e40393b998e22e0d$export$a143d493d941bafc = (0, $43da6dea502b5fe8$export$424a335715b38178);
const $e40393b998e22e0d$export$2a73594b5be3a068 = (0, $d37bb61f6ec53d08$export$7232b969b571e570);
const $e40393b998e22e0d$export$54a46af252275b4d = (0, $faf7c8e078303879$export$30cbf4ba14db4fdd);



var $4oKKP = parcelRequire("4oKKP");

// Author: Çağrı Erdem, 2023
// Description: Global audio EFX module for 2groove web app.

function $4b08d81a19be69db$var$scaleValue(value, from, to) {
    let scale = (to[1] - to[0]) / (from[1] - from[0]);
    let capped = Math.min(from[1], Math.max(from[0], value)) - from[0];
    return capped * scale + to[0];
}
// let amcike = 0.3;
// // Volume knob
// document.getElementById("metronomeVolume").addEventListener("input", function() {
//     const value = this.value;
//     amcike = value;
//     document.getElementById("knob2Value").textContent = value;
// });
//  console.log("metroVOL:", amcike);
//  let amcike2 = 0.3;
//  // Volume knob
//  document.getElementById("temp").addEventListener("input", function() {
//      const value = this.value;
//      amcike2 = value;
//      document.getElementById("knob3Value").textContent = value;
//  });
//   console.log("tempVOL:", amcike2);
// Compressor
const $4b08d81a19be69db$export$1af3c925c49f37a2 = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)({
    threshold: -18,
    ratio: 4,
    attack: 0.3,
    release: 0.1
}).toDestination();
// 3-band EQ
const $4b08d81a19be69db$export$9663ddc1cf085b32 = new (0, $97dc6ad5209e914a$export$2adf407ed955ca5d)({
    low: 0.3,
    mid: -0.1,
    high: 0.1
}).toDestination();
// Delay
const $4b08d81a19be69db$export$1391212d75b2ee65 = new (0, $dc7e67c384875c83$export$7920b8962af65831)({
    delayTime: "4n",
    feedback: 0.00001,
    wet: 0.05
}).toDestination(); // '.connect(eq);
// Reverb
const $4b08d81a19be69db$export$4a8425d4cc9c0e52 = new (0, $2aeaec223e48dd69$export$8f91cfa34e3c0ba)({
    roomSize: 0.75,
    dampening: 1000,
    wet: 0.5
}).toDestination(); //.connect(delay);


// Author: Çağrı Erdem, 2023
// Description: Defining a global state module to fetch MIDI (bytes) 
// data from the server and make it available to all modules of the 2groove web app.
const $affef116f20f7e03$export$3b6dd1a438fa9298 = {
    midiData: null,
    midiReadyForProcessing: false,
    setMidiData (data) {
        console.log("MIDI data received in bytes!", data);
        this.midiData = data;
        this.midiReadyForProcessing = true; // Open the gate
    },
    getMidiData () {
        return this.midiData;
    },
    isMidiReadyForProcessing () {
        return this.midiReadyForProcessing;
    },
    midiProcessed () {
        this.midiReadyForProcessing = false; // Close the gate
    }
};


// Author: Çağrı Erdem, 2024
// Description: User interface for dB study2.

// Function to create and display the popup with embedded AidaForm
// export function showPopup_duringQ() {
//     // Create popup elements
//     const popup = document.createElement('div');
//     popup.className = 'popup';
//     const popupContent = document.createElement('div');
//     popupContent.className = 'popup-content';
//     const closeButton = document.createElement('span');
//     closeButton.className = 'close';
//     closeButton.innerHTML = '&times;';
//     const message = document.createElement('p');
//     message.textContent = 'Please fill out the form below:';
//     // Create the AidaForm embed code
//     const formDiv = document.createElement('div');
//     formDiv.setAttribute('data-aidaform-app', 'form202405');
//     formDiv.setAttribute('data-url', 'https://cerdemo.aidaform.com/db-study2-during');
//     formDiv.setAttribute('data-width', '100%');
//     formDiv.setAttribute('data-height', '500px');
//     formDiv.setAttribute('data-do-resize', 'data-do-lazy');
//     // Append elements
//     popupContent.appendChild(closeButton);
//     popupContent.appendChild(message);
//     popupContent.appendChild(formDiv);
//     popup.appendChild(popupContent);
//     document.body.appendChild(popup);
//     // Show the popup
//     popup.style.display = 'block';
//     // Close the popup on click
//     closeButton.onclick = function() {
//         popup.style.display = 'none';
//         document.body.removeChild(popup); // Remove the popup from DOM
//     };
//     // Close the popup when clicking outside of it
//     window.onclick = function(event) {
//         if (event.target === popup) {
//             popup.style.display = 'none';
//             document.body.removeChild(popup); // Remove the popup from DOM
//         }
//     };
//     // Load the AidaForm script
//     const script = document.createElement('script');
//     script.innerHTML = `(function(){var r,d=document,gt=d.getElementById,cr=d.createElement,tg=d.getElementsByTagName,id="aidaform-app";if(!gt.call(d,id)){r=cr.call(d,"script");r.id=id;r.src="https://widget.aidaform.com/embed.js";(d.head || tg.call(d,"head")[0]).appendChild(r);}})()`;
//     document.body.appendChild(script);
// }
// Function to create and display the popup with embedded AidaForm
function $3356a88ed0307f2a$export$1b803dadff00b033() {
    // Create popup elements
    const popup = document.createElement("div");
    popup.className = "popup";
    const popupContent = document.createElement("div");
    popupContent.className = "popup-content";
    const closeButton = document.createElement("span");
    closeButton.className = "close";
    closeButton.innerHTML = "&times;";
    const message = document.createElement("p");
    message.textContent = "Please fill out the form below:";
    // Create an iframe for the embedded Google Form
    const iframe = document.createElement("iframe");
    iframe.src = "https://docs.google.com/forms/d/e/1FAIpQLScrYLIpMvkLrNA7QslbGmj8dFQFCTmkPxfhXBAGSbS21gJVYQ/viewform?embedded=true"; // Google Form URL
    iframe.width = "100%";
    iframe.height = "1000px"; // Adjust the height as needed
    iframe.style.border = "none"; // Optional: Remove iframe border
    iframe.style.overflowY = "scroll"; // Optional: Add scrollbars
    // Append elements
    popupContent.appendChild(closeButton);
    popupContent.appendChild(message);
    popupContent.appendChild(iframe);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);
    // Show the popup
    popup.style.display = "block";
    // Close the popup on click
    closeButton.onclick = function() {
        popup.style.display = "none";
        document.body.removeChild(popup); // Remove the popup from DOM
    };
    // Close the popup when clicking outside of it
    window.onclick = function(event) {
        if (event.target === popup) {
            popup.style.display = "none";
            document.body.removeChild(popup); // Remove the popup from DOM
        }
    };
}
function $3356a88ed0307f2a$export$9be54f9cded08e6a() {
    // Create popup elements
    const popup = document.createElement("div");
    popup.className = "popup";
    const popupContent = document.createElement("div");
    popupContent.className = "popup-content";
    const closeButton = document.createElement("span");
    closeButton.className = "close";
    closeButton.innerHTML = "&times;";
    const message = document.createElement("p");
    message.textContent = "Please fill out the form below:";
    // Create an iframe for the embedded Google Form
    const iframe = document.createElement("iframe");
    iframe.src = "https://docs.google.com/forms/d/e/1FAIpQLSf7w9AtVeV7Aes_Qo0WKII1g6dlyM2zHXUMHMFE6XaKOKF3Fg/viewform?embedded=true"; // Google Form URL
    iframe.width = "100%";
    iframe.height = "1000px"; // Adjust the height as needed
    iframe.style.border = "none"; // Optional: Remove iframe border
    // Append elements
    popupContent.appendChild(closeButton);
    popupContent.appendChild(message);
    popupContent.appendChild(iframe);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);
    // Show the popup
    popup.style.display = "block";
    // Close the popup on click
    closeButton.onclick = function() {
        popup.style.display = "none";
        document.body.removeChild(popup); // Remove the popup from DOM
    };
    // Close the popup when clicking outside of it
    window.onclick = function(event) {
        if (event.target === popup) {
            popup.style.display = "none";
            document.body.removeChild(popup); // Remove the popup from DOM
        }
    };
}
function $3356a88ed0307f2a$export$34929c0cf633a03e() {
    // Create popup elements
    const popup = document.createElement("div");
    popup.className = "popup";
    const popupContent = document.createElement("div");
    popupContent.className = "popup-content";
    const closeButton = document.createElement("span");
    closeButton.className = "close";
    closeButton.innerHTML = "&times;";
    const message = document.createElement("p");
    message.textContent = "Please fill out the form below:";
    // Create an iframe for the embedded Google Form
    const iframe = document.createElement("iframe");
    iframe.src = "https://docs.google.com/forms/d/e/1FAIpQLSdXhuoSfRprdpQYhCKxxm5RFC2lOzS7K1KfodAkxJkRZwkJsA/viewform?embedded=true"; // Google Form URL
    iframe.width = "100%";
    iframe.height = "1000px"; // Adjust the height as needed
    iframe.style.border = "none"; // Optional: Remove iframe border
    // Append elements
    popupContent.appendChild(closeButton);
    popupContent.appendChild(message);
    popupContent.appendChild(iframe);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);
    // Show the popup
    popup.style.display = "block";
    // Close the popup on click
    closeButton.onclick = function() {
        popup.style.display = "none";
        document.body.removeChild(popup); // Remove the popup from DOM
    };
    // Close the popup when clicking outside of it
    window.onclick = function(event) {
        if (event.target === popup) {
            popup.style.display = "none";
            document.body.removeChild(popup); // Remove the popup from DOM
        }
    };
}
function $3356a88ed0307f2a$export$1e000967d3847f4f(linkUrl) {
    // Create popup elements
    const popup = document.createElement("div");
    popup.className = "popup";
    const popupContent = document.createElement("div");
    popupContent.className = "popup-content";
    const closeButton = document.createElement("span");
    closeButton.className = "close";
    closeButton.innerHTML = "&times;";
    const message = document.createElement("p");
    message.textContent = "This is a custom popup message.";
    const link = document.createElement("p");
    link.innerHTML = `Click <a href="${linkUrl}" target="_blank">Please answer the questionnaire before proceeding to the next session.</a> for more information.`;
    // Append elements
    popupContent.appendChild(closeButton);
    popupContent.appendChild(message);
    popupContent.appendChild(link);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);
    // Show the popup
    popup.style.display = "block";
    // Close the popup on click
    closeButton.onclick = function() {
        popup.style.display = "none";
        document.body.removeChild(popup); // Remove the popup from DOM
    };
    // Close the popup when clicking outside of it
    window.onclick = function(event) {
        if (event.target === popup) {
            popup.style.display = "none";
            document.body.removeChild(popup); // Remove the popup from DOM
        }
    };
} // // Function to create and display the popup with a dynamic link
 // function showPopup(linkUrl) {
 //     // Create popup element with a custom form
 //     const popup = document.createElement('div');
 //     popup.className = 'popup';
 //     const popupContent = document.createElement('div');
 //     popupContent.className = 'popup-content';
 //     const closeButton = document.createElement('span');
 //     closeButton.className = 'close';
 //     closeButton.innerHTML = '&times;';
 //     const message = document.createElement('p');
 //     message.textContent = 'Please fill out the form below:';
 //     // Create the form
 //     const form = document.createElement('form');
 //     form.innerHTML = `
 //         <label for="name">Name:</label>
 //         <input type="text" id="name" name="name" required>
 //         <br><br>
 //         <label for="email">Email:</label>
 //         <input type="email" id="email" name="email" required>
 //         <br><br>
 //         <input type="submit" value="Submit">
 //     `;
 //     // Append elements
 //     popupContent.appendChild(closeButton);
 //     popupContent.appendChild(message);
 //     popupContent.appendChild(form);
 //     popup.appendChild(popupContent);
 //     document.body.appendChild(popup);
 //     // Show the popup
 //     popup.style.display = 'block';
 //     // Close the popup on click
 //     closeButton.onclick = function() {
 //         popup.style.display = 'none';
 //         document.body.removeChild(popup); // Remove the popup from DOM
 //     };
 //     // Close the popup when clicking outside of it
 //     window.onclick = function(event) {
 //         if (event.target === popup) {
 //             popup.style.display = 'none';
 //             document.body.removeChild(popup); // Remove the popup from DOM
 //         }
 //     };
 //     // Handle form submission
 //     form.onsubmit = function(event) {
 //         event.preventDefault(); // Prevent the default form submission
 //         const name = document.getElementById('name').value;
 //         const email = document.getElementById('email').value;
 //         console.log(`Name: ${name}, Email: ${email}`); // Process the form data as needed
 //         popup.style.display = 'none'; // Optionally close the popup after submission
 //         document.body.removeChild(popup); // Remove the popup from DOM
 //     };
 // }


var $02b8ee23885dde43$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $02b8ee23885dde43$var$url = new URL("tempoWorker.58c8f7a4.js", import.meta.url);
$02b8ee23885dde43$exports = $56b621a6dd25b2cb$exports($02b8ee23885dde43$var$url.toString(), $02b8ee23885dde43$var$url.origin, true);


//workers:
const $57d1b30337fe6afc$var$tempoWorker = new Worker($02b8ee23885dde43$exports); // for tempo estimation
var $763984d12099414d$exports = {};

let $763984d12099414d$var$url = new URL("workerAjax.1a9c4694.js", import.meta.url);
$763984d12099414d$exports = $56b621a6dd25b2cb$exports($763984d12099414d$var$url.toString(), $763984d12099414d$var$url.origin, true);


const $57d1b30337fe6afc$var$ajaxWorker = new Worker($763984d12099414d$exports); // for sending data to the server
// UI Elements
const $57d1b30337fe6afc$var$tempoSlider = document.getElementById("tempo");
const $57d1b30337fe6afc$var$recIndicator = document.getElementById("recIndicator");
const $57d1b30337fe6afc$var$arrayList = document.getElementById("arrayList");
const $57d1b30337fe6afc$var$recLight = document.getElementById("tapLight");
// Variables
let $57d1b30337fe6afc$var$beatsInput = 8; // 8 beats (2 bars)
let $57d1b30337fe6afc$var$quantizeSelect = 4; // 1/16
let $57d1b30337fe6afc$var$currentArray = [];
let $57d1b30337fe6afc$var$recording = false;
let $57d1b30337fe6afc$var$recordingStartedAt = 0;
let $57d1b30337fe6afc$var$isHttpConnected = true; // we keep it true with the new UI
let $57d1b30337fe6afc$var$tappedRhythms = [];
let $57d1b30337fe6afc$var$lockBPM = false;
// 0.8 temp ve 1.47 thresh B sampling icin iyi baslangic
let $57d1b30337fe6afc$var$autoReload = false; // Set to true to enable auto-reload after a certain duration
let $57d1b30337fe6afc$var$tapEvents = [];
let $57d1b30337fe6afc$var$firstTap = false;
let $57d1b30337fe6afc$var$estimatedBPM = 90;
let $57d1b30337fe6afc$export$5800f480eca98093 = true; // TODO: Set to true when deploying the study app
//pre-questionnaire
window.addEventListener("DOMContentLoaded", (event)=>{
    if ($57d1b30337fe6afc$export$5800f480eca98093) {
        setTimeout(function() {
            $57d1b30337fe6afc$var$promptIDs(); // Prompt for IDs in deployment mode
        }, 750);
        if ($57d1b30337fe6afc$var$currentSessionIndex === 0) setTimeout(function() {
            (0, $3356a88ed0307f2a$export$9be54f9cded08e6a)();
        }, 1500);
    }
});
document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("toggleCanvasTop");
    const canvas = document.getElementById("hiddenCanvasTop");
    // Set initial state based on the checkbox's checked state
    canvas.style.display = checkbox.checked ? "block" : "none";
    // Event listener for checkbox change
    checkbox.addEventListener("change", function() {
        canvas.style.display = this.checked ? "block" : "none";
    });
});
document.getElementById("toggleCanvasBottom").addEventListener("change", function() {
    const canvas = document.getElementById("hiddenCanvasBottom");
    canvas.style.display = this.checked ? "block" : "none";
});
let $57d1b30337fe6afc$export$3ee672b42e56aad7 = "";
let $57d1b30337fe6afc$export$39ee952be8b072ed = "";
let $57d1b30337fe6afc$var$previousSessionID = "";
// Function to prompt for conductor and participant IDs and display them in the UI
function $57d1b30337fe6afc$var$promptIDs() {
    if (!$57d1b30337fe6afc$export$3ee672b42e56aad7) {
        $57d1b30337fe6afc$export$3ee672b42e56aad7 = prompt("Please enter a Participant ID:");
        while(!$57d1b30337fe6afc$export$3ee672b42e56aad7)$57d1b30337fe6afc$export$3ee672b42e56aad7 = prompt("You must have a Participant ID, which will ensure the integrity of the recorded data and questionnaire responses:");
        // Display Participant ID on the top-right corner
        $57d1b30337fe6afc$var$displayIDs();
    }
}
// Function to display conductor and participant IDs in the UI
function $57d1b30337fe6afc$var$displayIDs() {
    // Create or update Participant ID display
    let participantIDDisplay = document.getElementById("participantIDDisplay");
    if (!participantIDDisplay) {
        participantIDDisplay = document.createElement("div");
        participantIDDisplay.id = "participantIDDisplay";
        document.body.appendChild(participantIDDisplay);
    }
    participantIDDisplay.style.position = "absolute";
    participantIDDisplay.style.top = "40px"; // Positioned below Conductor ID
    participantIDDisplay.style.right = "10px";
    participantIDDisplay.style.padding = "5px";
    participantIDDisplay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    participantIDDisplay.style.color = "white";
    participantIDDisplay.textContent = `Participant ID: ${$57d1b30337fe6afc$export$3ee672b42e56aad7}`;
}
////////////////////////////////////////
////////////////////////////////////////
// Set up an event listener for the first user interaction
function $57d1b30337fe6afc$var$setupFirstInteractionListener() {
    const firstInteractionHandler = ()=>{
        if ($57d1b30337fe6afc$export$5800f480eca98093) $57d1b30337fe6afc$var$promptIDs(); // Prompt for IDs in deployment mode
        // Remove event listeners once the IDs have been prompted
        document.removeEventListener("click", firstInteractionHandler);
        document.removeEventListener("keydown", firstInteractionHandler);
    };
    document.addEventListener("click", firstInteractionHandler);
    document.addEventListener("keydown", firstInteractionHandler);
}
// Call this function when the page loads or the study is reset
document.addEventListener("DOMContentLoaded", function() {
    $57d1b30337fe6afc$var$initializeSessions();
    $57d1b30337fe6afc$var$loadCurrentSession();
    $57d1b30337fe6afc$var$setupFirstInteractionListener(); // Set up the first interaction listener
    $57d1b30337fe6afc$var$setAutoReload($57d1b30337fe6afc$var$autoReloadDuration, $57d1b30337fe6afc$var$autoReload);
});
// Reset conductor and participant IDs and clear their display when resetStudy is called
function $57d1b30337fe6afc$var$resetStudyState() {
    localStorage.clear(); // Clear all localStorage data related to sessions
    $57d1b30337fe6afc$var$currentSessionIndex = 0;
    $57d1b30337fe6afc$export$3ee672b42e56aad7 = ""; // Reset participant ID
    const participantIDDisplay = document.getElementById("participantIDDisplay");
    if (participantIDDisplay) participantIDDisplay.remove();
    // Reload the page to start fresh
    location.reload();
}
// Study conditions (generative parameters)
let $57d1b30337fe6afc$var$temp = 0.1;
let $57d1b30337fe6afc$var$thresh = 0.09;
const $57d1b30337fe6afc$var$highTemp = 1.8;
const $57d1b30337fe6afc$var$lowTemp = 0.25;
const $57d1b30337fe6afc$var$highThresh = 0.135;
const $57d1b30337fe6afc$var$lowThresh = 0.099;
const $57d1b30337fe6afc$var$dBstudy2sessions = [
    {
        id: `Test`,
        tempo: $57d1b30337fe6afc$var$estimatedBPM,
        temp: 1.,
        threshold: 0.127
    },
    {
        id: `VOYAGER`,
        tempo: $57d1b30337fe6afc$var$estimatedBPM,
        temp: $57d1b30337fe6afc$var$highTemp,
        threshold: $57d1b30337fe6afc$var$highThresh
    },
    {
        id: `ALICE`,
        tempo: $57d1b30337fe6afc$var$estimatedBPM,
        temp: $57d1b30337fe6afc$var$lowTemp,
        threshold: $57d1b30337fe6afc$var$highThresh
    },
    {
        id: `ILLIAC`,
        tempo: $57d1b30337fe6afc$var$estimatedBPM,
        temp: $57d1b30337fe6afc$var$highTemp,
        threshold: $57d1b30337fe6afc$var$lowThresh
    },
    {
        id: `CYSP`,
        tempo: $57d1b30337fe6afc$var$estimatedBPM,
        temp: $57d1b30337fe6afc$var$lowTemp,
        threshold: $57d1b30337fe6afc$var$lowThresh
    }
];
// State variables
let $57d1b30337fe6afc$var$currentSessionIndex = 0;
let $57d1b30337fe6afc$var$sessionOrder = [];
let $57d1b30337fe6afc$var$autoReloadTimeout;
const $57d1b30337fe6afc$var$autoReloadDuration = 3000; // 2 * 60 * 1000; // Default 2 minutes
// Initialize session categories and order
function $57d1b30337fe6afc$var$initializeSessions() {
    const actualSessions = $57d1b30337fe6afc$var$dBstudy2sessions.slice(1);
    $57d1b30337fe6afc$var$shuffleSessions(actualSessions);
    // Create the session order: Test session followed by the actual sessions
    $57d1b30337fe6afc$var$sessionOrder = [
        $57d1b30337fe6afc$var$dBstudy2sessions[0],
        ...actualSessions
    ];
}
// Shuffle the session order
function $57d1b30337fe6afc$var$shuffleSessions(array) {
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
}
// Apply session parameters to the UI
function $57d1b30337fe6afc$var$applySession(session) {
    let sName = session.id.split(" ");
    document.getElementById("sessionName").textContent = `Session ID: ${sName[0]}`; // TODO: bu da shuffle ile gelsin
    document.getElementById("sessionProgress").textContent = `(${$57d1b30337fe6afc$var$currentSessionIndex} / ${$57d1b30337fe6afc$var$dBstudy2sessions.length - 1})`;
    if ($57d1b30337fe6afc$var$currentSessionIndex === 0) {
        document.getElementById("sessionName").style.color = "red";
        document.getElementById("sessionProgress").style.color = "red";
    } else {
        document.getElementById("sessionName").style.color = "green";
        document.getElementById("sessionProgress").style.color = "green";
    }
    $57d1b30337fe6afc$export$39ee952be8b072ed = session.id;
    // Find the corresponding session object
    const currentSession = $57d1b30337fe6afc$var$dBstudy2sessions.find((s)=>s.id === $57d1b30337fe6afc$export$39ee952be8b072ed);
    if (currentSession) {
        $57d1b30337fe6afc$var$thresh = currentSession.threshold;
        $57d1b30337fe6afc$var$temp = currentSession.temp;
    }
// console.log(`Applied Session ID: ${session.id}, Tempo: ${session.tempo}, Temp: ${temp}, Thresh: ${thresh}`); //debug
}
// Clear session state when all sessions are completed or reset
function $57d1b30337fe6afc$var$clearSessionState() {
    localStorage.removeItem("currentSessionIndex");
    $57d1b30337fe6afc$var$currentSessionIndex = 0;
}
// Set up event listeners for buttons
document.getElementById("nextSessionBtn").addEventListener("click", $57d1b30337fe6afc$var$nextSession);
document.getElementById("resetStudy").addEventListener("click", $57d1b30337fe6afc$var$resetStudyState);
// Function to move to the next session
function $57d1b30337fe6afc$var$nextSession() {
    $57d1b30337fe6afc$var$currentSessionIndex++;
    if ($57d1b30337fe6afc$var$currentSessionIndex < $57d1b30337fe6afc$var$sessionOrder.length) {
        $57d1b30337fe6afc$var$applySession($57d1b30337fe6afc$var$sessionOrder[$57d1b30337fe6afc$var$currentSessionIndex]);
        localStorage.setItem("currentSessionIndex", $57d1b30337fe6afc$var$currentSessionIndex);
    }
    if ($57d1b30337fe6afc$export$5800f480eca98093 && $57d1b30337fe6afc$var$currentSessionIndex >= 2 && $57d1b30337fe6afc$var$currentSessionIndex <= 5) (0, $3356a88ed0307f2a$export$1b803dadff00b033)();
    if ($57d1b30337fe6afc$export$5800f480eca98093 && $57d1b30337fe6afc$var$currentSessionIndex === 5) {
        // All sessions completed
        alert("All sessions are completed!");
        (0, $3356a88ed0307f2a$export$34929c0cf633a03e)();
    // resetStudyState();
    }
}
// Load the current session based on stored state
function $57d1b30337fe6afc$var$loadCurrentSession() {
    $57d1b30337fe6afc$var$currentSessionIndex = parseInt(localStorage.getItem("currentSessionIndex")) || 0;
    // If index is out of bounds, reset to 0
    if ($57d1b30337fe6afc$var$currentSessionIndex >= $57d1b30337fe6afc$var$sessionOrder.length) $57d1b30337fe6afc$var$currentSessionIndex = 0;
    $57d1b30337fe6afc$var$applySession($57d1b30337fe6afc$var$sessionOrder[$57d1b30337fe6afc$var$currentSessionIndex]);
}
function $57d1b30337fe6afc$var$setAutoReload(duration, autoReload) {
    if (autoReload === true) {
        clearTimeout($57d1b30337fe6afc$var$autoReloadTimeout);
        $57d1b30337fe6afc$var$autoReloadTimeout = setTimeout(function() {
            location.reload();
        }, duration);
    }
}
///////More (GUI) stuff
////
function $57d1b30337fe6afc$var$hideControls() {
    //TODO: zaman icerisinde netlesecek burasi
    document.getElementById("tempo").style.display = "none";
    document.getElementById("knob1Value").style.display = "none";
    document.getElementById("metronomeVolume").style.display = "none";
    document.getElementById("knob2Value").style.display = "none";
    document.getElementById("toggleMetronome").style.display = "none";
    // NOTE: comment out `startMetronome();` in playback.js
    // document.getElementById('temp').style.display = 'none';
    // document.getElementById('knob3Value').style.display = 'none';
    // document.getElementById('tolerance').style.display = 'none';
    // document.getElementById('knob4Value').style.display = 'none';
    document.getElementById("changeButton").style.display = "none";
    document.getElementById("download-btn").style.display = "none";
    document.getElementById("helpToggle").style.display = "none";
    document.getElementById("helpToggleText").style.display = "none";
    //TODO: togglePlaybackButton should also be enabled by default and hidden
    document.getElementById("themeToggleCheckbox").style.display = "none";
    document.getElementById("themeToggleText").style.display = "none";
    document.getElementById("themeSwitchSwitch").style.display = "none";
    document.body.classList.add("dark-theme");
    themeToggleCheckbox.checked = true; // set to dark
    // face-pose-track related:
    document.getElementById("blendShapesDisplay").style.visibility = "hidden";
// document.getElementById('bsColumn1').style.display = 'none'; //TODO: bunlari disable edince her sey siciyo. bi toparla burayi
// document.getElementById('bsColumn2').style.display = 'none';
// document.getElementById('poseColumn').style.display = 'none';
}
$57d1b30337fe6afc$var$hideControls();
//-------------------------------------
// Functions
//-------------------------------------
async function $57d1b30337fe6afc$var$initializeApp() {
    // Set default BPM or retrieve it from a saved setting or slider
    const defaultBPM = $57d1b30337fe6afc$var$tempoSlider.value;
    console.log("App initialized!");
// console.log("Default BPM:", defaultBPM);
}
/// UTILS ///
resetButton.addEventListener("click", ()=>{
    $57d1b30337fe6afc$var$arrayList.innerHTML = "";
});
// Initialize the app
$57d1b30337fe6afc$var$initializeApp();
///////////////////////
/////// tap2arr ///////
///////////////////////
// Listen to messages from the worker:
$57d1b30337fe6afc$var$ajaxWorker.addEventListener("message", function(event) {
    const data = event.data;
    console.log("Setting MIDI data, length:", data.length);
    switch(data.type){
        case "arrayProcessed":
            // process the MIDI data as needed
            (0, $affef116f20f7e03$export$3b6dd1a438fa9298).setMidiData(data.data);
            $57d1b30337fe6afc$var$resetTappedRhythms();
            break;
        case "error":
            console.error("Error from worker:", data.error);
            $57d1b30337fe6afc$var$showNotification("Ooops! I messed it up.\nModify some parameters a bit or just refresh the page to try again.");
            break;
    }
});
function $57d1b30337fe6afc$var$arrayToBinaryString(array) {
    return array.map((value)=>value !== 0 ? "1" : "0").join("");
}
function $57d1b30337fe6afc$var$storeAndDisplayArray(array) {
    const li = document.createElement("li");
    li.textContent = $57d1b30337fe6afc$var$arrayToBinaryString(array);
    // If the list has any items
    if ($57d1b30337fe6afc$var$arrayList.firstChild) // Insert 'li' before the first item, to the top of the list
    $57d1b30337fe6afc$var$arrayList.insertBefore(li, $57d1b30337fe6afc$var$arrayList.firstChild);
    else // If the list is empty, just append the 'li' as usual
    $57d1b30337fe6afc$var$arrayList.appendChild(li);
}
// Modify `sendArrayToServer` to post data to the worker:
function $57d1b30337fe6afc$var$sendArrayToServer(array, BPM) {
    // console.log("Sending data to server:", array, "Tempo: ", BPM, "Temp: ", temp, "Thresh: ", thresh, "Session ID: ", sessionID);
    $57d1b30337fe6afc$var$ajaxWorker.postMessage({
        cmd: "sendArray",
        array: array,
        bpm: BPM,
        temperatureValue: $57d1b30337fe6afc$var$temp,
        hitTolerance: $57d1b30337fe6afc$var$thresh,
        isHttpConnected: $57d1b30337fe6afc$var$isHttpConnected,
        samplingStrategy: "softmax_temp" //samplingStrategy['strategy'][samplingStrategyIndex]
    });
}
function $57d1b30337fe6afc$var$resetTappedRhythms() {
    // tappedRhythms = [];
    $57d1b30337fe6afc$var$tappedRhythms.length = 0; // This empties the array without re-declaring it
}
//-------------------------------------
// Event Listeners
//-------------------------------------
function $57d1b30337fe6afc$var$resetRecordingState() {
    $57d1b30337fe6afc$var$tapEvents = [];
    $57d1b30337fe6afc$var$recordingStartedAt = null;
    $57d1b30337fe6afc$var$firstTap = false;
    $57d1b30337fe6afc$var$recording = false;
    $57d1b30337fe6afc$var$tempoWorker.postMessage({
        cmd: "reset"
    }); // Reset the tempoWorker state
}
document.addEventListener("keydown", (e)=>{
    if (e.key === "a") {
        // Toggle recording
        if (!$57d1b30337fe6afc$var$recording) {
            $57d1b30337fe6afc$var$startRecording();
            e.preventDefault();
        } else $57d1b30337fe6afc$var$stopRecording();
    }
});
// Function to start recording
function $57d1b30337fe6afc$var$startRecording() {
    $57d1b30337fe6afc$var$resetRecordingState(); // Reset the state before recording
    $57d1b30337fe6afc$var$recordingStartedAt = Date.now(); // Set the starting point of the recording
    $57d1b30337fe6afc$var$recIndicator.innerText = "ON AIR!"; // Display "ON AIR"
    $57d1b30337fe6afc$var$recIndicator.classList.add("recording");
    $57d1b30337fe6afc$var$recording = true;
    $57d1b30337fe6afc$var$recLight.classList.add("light-on");
    console.log("Recording started...");
}
// Function to stop recording
function $57d1b30337fe6afc$var$stopRecording() {
    $57d1b30337fe6afc$var$recording = false;
    $57d1b30337fe6afc$var$recIndicator.innerText = ""; // Clear the "ON AIR" display
    $57d1b30337fe6afc$var$recIndicator.classList.remove("recording");
    $57d1b30337fe6afc$var$recLight.classList.remove("light-on");
    $57d1b30337fe6afc$var$recLight.classList.add("light-off");
    console.log("Recording completed!");
    // If no taps were recorded, send an array of zeros
    if ($57d1b30337fe6afc$var$tapEvents.length === 0) {
        const emptyArray = new Array(32).fill(0);
        console.log("No taps recorded. Sending an array of 0s:", emptyArray);
        $57d1b30337fe6afc$var$sendArrayToServer(emptyArray, $57d1b30337fe6afc$var$estimatedBPM);
    } else // Process the recorded taps
    $57d1b30337fe6afc$var$processTaps($57d1b30337fe6afc$var$tapEvents);
    $57d1b30337fe6afc$var$resetRecordingState();
}
// Function to record taps (spacebar key press)
document.addEventListener("keydown", (e)=>{
    if (e.key === " " && $57d1b30337fe6afc$var$recording) {
        e.preventDefault(); //To prevent the browser from scrolling when the spacebar is pressed
        $57d1b30337fe6afc$var$recordTapEvent(); // Record the tap
    }
});
// Function to record individual taps
function $57d1b30337fe6afc$var$recordTapEvent() {
    const elapsedMs = Date.now() - $57d1b30337fe6afc$var$recordingStartedAt;
    if (!$57d1b30337fe6afc$var$firstTap) {
        $57d1b30337fe6afc$var$recordingStartedAt = Date.now(); // Set the first tap as point 0
        $57d1b30337fe6afc$var$tapEvents.push(0); // First tap is always at time 0
        $57d1b30337fe6afc$var$firstTap = true;
    } else $57d1b30337fe6afc$var$tapEvents.push(elapsedMs); // Store the time difference from the first tap
    console.log(`Tap recorded: ${elapsedMs} ms`);
}
function $57d1b30337fe6afc$var$processTaps(tapEvents) {
    // Send tap events to worker for tempo estimation
    $57d1b30337fe6afc$var$tempoWorker.postMessage({
        cmd: "calculateTempo",
        tapTimes: tapEvents
    });
    $57d1b30337fe6afc$var$currentArray = $57d1b30337fe6afc$var$quantizeTaps(tapEvents, $57d1b30337fe6afc$var$estimatedBPM); // Quantize the taps into a fixed-length array
    $57d1b30337fe6afc$var$storeAndDisplayArray($57d1b30337fe6afc$var$currentArray);
}
$57d1b30337fe6afc$var$tempoWorker.addEventListener("message", function(event) {
    const data = event.data;
    if (data.type === "tempoCalculated") {
        let bpm = parseFloat(data.advancedTempo || data.tempo);
        // Adjust tempo: double time if < 50 BPM, half time if > 200 BPM
        if (bpm < 40) bpm *= 2; // Double time
        else if (bpm > 150) bpm /= 2; // Half time
        $57d1b30337fe6afc$var$estimatedBPM = bpm; // clampBPM(bpm);  // Ensure tempo stays within limits
        console.log(`Final estimated tempo: ${Math.round($57d1b30337fe6afc$var$estimatedBPM)} BPM`);
        let tempo2model = parseFloat($57d1b30337fe6afc$var$estimatedBPM); // Update the global tempo variables across other modules
        $57d1b30337fe6afc$var$sendArrayToServer($57d1b30337fe6afc$var$currentArray, tempo2model);
    }
});
function $57d1b30337fe6afc$export$5ae1f883da3924b0() {
    let temp;
    temp = $57d1b30337fe6afc$var$estimatedBPM;
    // console.log("Current BPM:", temp);
    return temp;
}
const $57d1b30337fe6afc$var$testBtn = document.getElementById("testBtn");
$57d1b30337fe6afc$var$testBtn.addEventListener("click", ()=>{
    $57d1b30337fe6afc$var$lockBPM = !$57d1b30337fe6afc$var$lockBPM;
    console.log("Lock BPM:", $57d1b30337fe6afc$var$lockBPM);
    if ($57d1b30337fe6afc$var$lockBPM) $57d1b30337fe6afc$var$testBtn.textContent = "Unlock the Tempo";
    else $57d1b30337fe6afc$var$testBtn.textContent = "Lock the Tempo";
});
// Function to quantize the taps into a fixed-length array
function $57d1b30337fe6afc$var$quantizeTaps(tapEvents, bpm) {
    const quantizeValue = parseInt($57d1b30337fe6afc$var$quantizeSelect);
    const totalSteps = parseInt($57d1b30337fe6afc$var$beatsInput) * parseInt($57d1b30337fe6afc$var$quantizeSelect); // Fixed length of the array
    const stepDuration = 60000 / (bpm * quantizeValue); // Step duration (16th notes)
    const quantizedArray = new Array(totalSteps).fill(0);
    for (let tap of tapEvents){
        const stepIndex = Math.floor(tap / stepDuration);
        if (stepIndex < totalSteps) quantizedArray[stepIndex] = 1; // Mark the step as a tap
    }
    return quantizedArray;
}
//tempo estimation related
function $57d1b30337fe6afc$var$removeOutliers(intervals) {
    const sortedIntervals = [
        ...intervals
    ].sort((a, b)=>a - b);
    const q1 = sortedIntervals[Math.floor(sortedIntervals.length / 4)];
    const q3 = sortedIntervals[Math.ceil(sortedIntervals.length * 3 / 4)];
    const iqr = q3 - q1; // Interquartile range
    // Filter out intervals that are too far outside the interquartile range (outliers)
    return intervals.filter((interval)=>interval >= q1 - 1.5 * iqr && interval <= q3 + 1.5 * iqr);
}
function $57d1b30337fe6afc$var$weightedAverage(intervals) {
    const totalWeight = intervals.reduce((acc, _, index)=>acc + (index + 1), 0); // Sum of weights
    const weightedSum = intervals.reduce((acc, interval, index)=>acc + interval * (index + 1), 0); // Weighted sum
    return weightedSum / totalWeight;
}
function $57d1b30337fe6afc$var$ignoreEarlyTaps(intervals) {
    return intervals.slice(2); // Ignore the first two intervals
}
function $57d1b30337fe6afc$var$calculateMedian(intervals) {
    const sorted = [
        ...intervals
    ].sort((a, b)=>a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 !== 0 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
}
function $57d1b30337fe6afc$var$windowedAverage(intervals, windowSize = 4) {
    const recentIntervals = intervals.slice(-windowSize); // Take the most recent n intervals
    return recentIntervals.reduce((a, b)=>a + b) / recentIntervals.length; // Average them
}
function $57d1b30337fe6afc$var$clampBPM(bpm, minBPM = 60, maxBPM = 180) {
    return Math.max(minBPM, Math.min(bpm, maxBPM));
}
function $57d1b30337fe6afc$export$985efb82b79fd00d() {
    return true;
}
function $57d1b30337fe6afc$export$ffd9cee7b4d9db2f() {
    return $57d1b30337fe6afc$var$currentArray;
}
///////////
///HELP///
///////////
// Functions to show notifications and help instructions
// Uyari sistemi
function $57d1b30337fe6afc$var$showNotification(message) {
    const container = document.getElementById("notificationContainer");
    const notification = document.createElement("div");
    notification.classList.add("error_notification"); // Add a class to style the notification
    notification.textContent = message;
    container.appendChild(notification);
    setTimeout(()=>{
        notification.remove();
    }, 3000); // Remove the notification after 3 seconds
}
// A map linking GUI element IDs to notification IDs
const $57d1b30337fe6afc$var$helpMap = {
    "db_app": "notificationForApp",
    "db_app2": "notificationForApp2",
    "playbackSubContainer": "notificationForplaybackSubContainer",
    "tempo": "notificationForTempo",
    "metronomeVolume": "notificationForVolume",
    "tapTempoLight": "notificationForTapTempoLight",
    "metroFeedback": "notificationForMetronomeToggle",
    "temp": "notificationForTempKnob",
    "tolerance": "notificationForToleranceKnob",
    "invisibleAnchor_pRoll": "notificationForPianoRoll",
    "changeButton": "notificationForChangeBtn",
    "togglePlaybackButton": "notificationForTogglePlaybackBtn",
    "tapLight": "notificationForTapLight",
    "recIndicator": "notificationForRecIndicator",
    "download-btn": "notificationForDownloadBtn",
    "helpToggle": "notificationForFinal"
};
let $57d1b30337fe6afc$var$currentStep = 0;
const $57d1b30337fe6afc$var$helpEntries = Object.entries($57d1b30337fe6afc$var$helpMap);
document.getElementById("helpToggle").addEventListener("change", function(event) {
    if (event.target.checked) {
        $57d1b30337fe6afc$var$currentStep = 0; // Start from the first help item
        $57d1b30337fe6afc$var$populateHelpDots();
        showHelpStep($57d1b30337fe6afc$var$currentStep);
    } else document.getElementById("helpOverlay").style.display = "none";
});
function $57d1b30337fe6afc$var$populateHelpDots() {
    const dotsContainer = document.getElementById("helpDotsContainer");
    dotsContainer.innerHTML = ""; // Clear existing dots
    $57d1b30337fe6afc$var$helpEntries.forEach((_, index)=>{
        const dot = document.createElement("span");
        dot.classList.add("help-dot");
        if (index === $57d1b30337fe6afc$var$currentStep) dot.classList.add("active"); // Mark the current step's dot as active
        dot.addEventListener("click", ()=>{
            $57d1b30337fe6afc$var$currentStep = index; // Update currentStep to the clicked dot's index
            showHelpStep($57d1b30337fe6afc$var$currentStep);
        });
        dotsContainer.appendChild(dot);
    });
}
document.addEventListener("keydown", function(event) {
    if (event.key === "ArrowLeft") // Simulate clicking the "Prev" button
    document.getElementById("prevHelp").click();
    else if (event.key === "ArrowRight") // Simulate clicking the "Next" button
    document.getElementById("nextHelp").click();
    else if (event.key === "Escape") // Simulate clicking the "Close" button
    document.getElementById("closeHelp").click();
});
// theme tests
document.getElementById("themeToggleCheckbox").addEventListener("change", function() {
    if (this.checked) // Apply dark theme
    document.body.classList.add("dark-theme");
    else // Revert to light theme
    document.body.classList.remove("dark-theme");
});


// Author: Çağrı Erdem, 2023
// Description: Interactive "piano roll" visualization for 2groove web app.




// import { generateDummyMidiArrayBuffer } from './utils/utils.js';
// Wrap entire sketch inside a function and use p5 instance mode to adapt it for module-based bundling 
// (functions become methods of the instance)
const $dfc31c5a77d3d4e0$var$sketch = (s)=>{
    // MIDI Handling
    s.loadMidiFile = function(event) {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader(); // Removed s. prefix
            reader.onload = function(e) {
                const arrayBuffer = e.target.result;
                s.parseMidi(arrayBuffer); // Removed s. prefix from arrayBuffer
            };
            reader.readAsArrayBuffer(file);
        }
    };
    // MIDI parse function without quantization
    s.parseMidi = function(arrayBuffer, verbose = false) {
        // Preliminary check for unexpected data format
        if (typeof arrayBuffer === "string" && arrayBuffer.startsWith("<!do")) {
            console.error("Received unexpected HTML data instead of MIDI");
            return; // exit function early
        }
        try {
            const midi = new (0, $28735cb37928c976$exports.Midi)(arrayBuffer); // Assuming that `new Midi` can handle the raw arrayBuffer
            // Adjust negative delta values
            midi.tracks.forEach((track)=>{
                let accumulatedDelta = 0;
                track.notes.forEach((note)=>{
                    if (note.ticks < 0) {
                        accumulatedDelta += note.ticks; // Accumulate the negative delta
                        note.ticks = 0; // Reset the current note's ticks to 0
                    } else if (accumulatedDelta < 0) {
                        const adjustment = Math.min(note.ticks, -accumulatedDelta); // Calculate the possible adjustment
                        note.ticks -= adjustment; // Deduct the adjustment from the current note's ticks
                        accumulatedDelta += adjustment; // Adjust the accumulated delta
                    }
                });
            });
            s.noteSequences = midi.tracks.map((track)=>{
                if (verbose) track.notes.forEach((note)=>{
                    console.log(note);
                });
                return {
                    notes: track.notes.map((note)=>{
                        return {
                            pitch: note.midi,
                            startTime: note.time,
                            endTime: note.time + note.duration,
                            velocity: note.velocity // Include velocity in the note object
                        };
                    })
                };
            });
        } catch (error) {
            console.error("Error processing MIDI data in pRoll.js:", error.message);
        }
    };
    // Constants and global variables
    s.NUM_STEPS = 32; // Number of quantized steps; this must be equal to the length of the array
    s.SUBDIVISIONS = 4; // quarter note = 1, eighth note = 2, etc.
    s.NUM_NOTES = 20; // total number of notes of the piano roll
    s.LOWEST_MIDI_NOTE = 34; // -1 worked better on the canvas
    s.noteSequences;
    s.resizingWidth = false;
    s.resizingHeight = false;
    s.WIDTH = 550;
    s.HEIGHT = 250;
    s.EDGE_THRESHOLD = 10; // Distance from edge to enable resizing
    s.offset_x = 1.3; // offset for the vertical lines and/or notes (if necessary)
    s.offset_y = 1.5;
    s.clearCanvas = false; // flag to clear the canvas
    s.isSpacePressed = false;
    s.modifyMidi = false;
    s.isApressed = false;
    s.pressCount = 0; // Track how many times "A" has been pressed
    s.aPressStartTime = null; // Record the time when "A" was first pressed
    const holdThreshold = 1000; // Time in milliseconds to consider a "held" press
    const multiplePressThreshold = 3; // Number of presses to consider "multiple"
    s.currentMidiData = null;
    s.nullMidiData = null;
    s.btnDraw = false;
    s.btnDummy = false;
    s.lastMidi = null; // Variable to store the last MIDI data
    s.midiGateOpened = false; // Track if the MIDI gate is opened
    s.drumMappings = {
        35: "acoustic bass drum",
        36: "kick",
        37: "side-stick",
        38: "snare",
        39: "clap",
        40: "electric snare",
        41: "floor-tom",
        42: "closed-hihat",
        43: "high-tom",
        44: "pedal-hihat",
        45: "low-tom",
        46: "open-hihat",
        47: "mid-tom",
        48: "hi-tom",
        49: "crash",
        50: "high-tom",
        51: "ride",
        52: "chinese cymbal"
    };
    // theme-related variables
    s.isDarkTheme = false;
    let backgroundColor = "#fae";
    // let textColor;
    // let accentColor;
    // check the theme switch state and update colors
    s.updateThemeColors = function() {
        s.isDarkTheme = document.getElementById("themeToggleCheckbox").checked;
        if (s.isDarkTheme) // Dark theme 
        backgroundColor = s.color("#B39DDB");
        else // Light theme 
        backgroundColor = s.color("#fae");
    };
    // Function to modify parsed MIDI based on condition
    s.modifyParsedMidi = function(midi) {
        if (!midi || !midi.tracks || midi.tracks.length === 0) {
            console.error("Error: No tracks found in the MIDI data.");
            return null; // Exit early if no valid tracks
        }
        // If modification is enabled, modify the notes
        if (s.modifyMidi) midi.tracks.forEach((track)=>{
            track.notes.forEach((note)=>{
                // Remap the MIDI note to something outside the display range
                note.midi = 60; // Example: remap all notes to an unused pitch
            });
        });
        return midi;
    };
    // main setup func
    s.setup = function() {
        s.createCanvas(s.WIDTH, s.HEIGHT).parent("pianoRollContainer");
        s.updateThemeColors(); // Initialize theme colors based on the switch state
    };
    s.draw = function() {
        s.clear(); //??
        s.background(backgroundColor); // Set the background color of the entire canvas
        // s.tappedRhythm = getTappedRhythms(); // Get the tapped rhythms from the interface module TODO: yeri bura mi asafisi mi??
        // Fetch and parse the MIDI data
        const midi = (0, $affef116f20f7e03$export$3b6dd1a438fa9298).getMidiData(); // Get the current MIDI data
        // Check if there is new MIDI data
        if (midi && midi !== s.lastMidi) {
            s.lastMidi = midi; // Update the last MIDI to the current one
            // console.log("New MIDI data received!", midi); // Log new MIDI data
            s.modifyMidi = false;
            try {
                const parsedMidi = new (0, $28735cb37928c976$exports.Midi)(midi); // Parse the MIDI data
                const processedMidi = s.modifyParsedMidi(parsedMidi);
                if (processedMidi) // Parse the processed MIDI for visualization
                s.parseMidi(processedMidi.toArray()); // Convert back to ArrayBuffer format if necessary
            } catch (error) {
                console.error("Error parsing MIDI data:", error.message);
            }
        }
        // Tapped rhythm visualization
        s.tappedRhythm = (0, $57d1b30337fe6afc$export$ffd9cee7b4d9db2f)(); // Get the tapped rhythms from the interface module
        var x = 0 + s.offset_x;
        var y = 0 + s.offset_y;
        // var y = s.HEIGHT - s.WIDTH;
        s.drawTappedRhythm(s.tappedRhythm, x, y, s.WIDTH, s.WIDTH);
        // Draw the notes on the canvas
        if (s.noteSequences) s.drawNotes(s.noteSequences[0].notes, x, y, s.WIDTH, s.WIDTH);
        s.fill(255, 64);
        // Draw vertical lines for subdivisions
        s.stroke("white"); // Set line color to black
        const lineInterval = s.WIDTH / (s.NUM_STEPS / 4 * s.SUBDIVISIONS);
        for(let i = 0; i < s.WIDTH; i += lineInterval)s.line(i + s.offset_x, 0, i + s.offset_x, s.HEIGHT);
        // Draw vertical lines for beats
        s.stroke("rgba(0,255,0,0.25)");
        s.strokeWeight(1.2);
        const beatInterval = s.WIDTH / (s.NUM_STEPS / 4);
        for(let i = 0; i < s.WIDTH; i += beatInterval)s.line(i + s.offset_x, 0, i + s.offset_x, s.HEIGHT);
        // Draw vertical lines for bars
        s.stroke("rgb(0,255,0)");
        s.strokeWeight(0.8);
        const barInterval = s.WIDTH / (s.NUM_STEPS / 16);
        for(let i = 0; i < s.WIDTH; i += barInterval)s.line(i + s.offset_x, 0, i + s.offset_x, s.HEIGHT);
        s.showPopup(); // Show popup when mouse is near the edge of the note cell-sections
    };
    // TODO: define a function to toggle the theme if needed
    s.toggleTheme = function() {
        // Toggle the checkbox state
        const themeSwitch = document.getElementById("themeToggleCheckbox");
        themeSwitch.checked = !themeSwitch.checked;
        // Update theme colors based on the new state
        s.updateThemeColors();
    };
    // Draw function for quantized tapped rhythm 
    s.drawTappedRhythm = function(tappedRhythm, x, y, width, height) {
        const totalDuration = tappedRhythm.length;
        s.push();
        s.translate(x, y);
        var cellWidth = width / totalDuration;
        var cellHeight = height / s.NUM_NOTES; // Assuming each tap corresponds to a note
        tappedRhythm.forEach(function(tap, index) {
            if (tap === 1) {
                var noteColor = s.color(219, 247, 19, 120); // Less opaque
                s.fill(noteColor);
                s.rect(cellWidth * index, 0, cellWidth, cellHeight);
            }
        });
        //////////////////////////
        if (s.clearCanvas) {
            s.clear();
            s.background(backgroundColor); // Set the background color of the entire canvas
            s.tappedRhythm.length = 0;
        }
        if (s.isApressed) s.clearCanvas = false;
        //////////////////////////
        s.pop();
    };
    // Draw function without quantization
    s.drawNotes = function(notes, x, y, width, height) {
        const totalDuration = s.noteSequences.reduce((max, seq)=>{
            const endTimes = seq.notes.map((note)=>note.endTime);
            return Math.max(max, ...endTimes);
        }, 0);
        s.push();
        s.translate(x, y);
        var cellWidth = s.WIDTH / totalDuration; // Update cellWidth based on the new width
        var cellHeight = s.HEIGHT / s.NUM_NOTES; // Update cellHeight based on the new height
        notes.forEach(function(note) {
            var emptyNoteSpacer = 10;
            var noteColor = s.color(255, 0, 191, note.velocity * 255);
            s.stroke("black"); // strokes for the notes
            s.strokeWeight(0.6);
            s.fill(noteColor);
            s.rect(emptyNoteSpacer + cellWidth * note.startTime, s.HEIGHT - cellHeight * (note.pitch - s.LOWEST_MIDI_NOTE), cellWidth * (note.endTime - note.startTime) - emptyNoteSpacer, cellHeight);
        });
        //////////////////////////
        // if (s.clearCanvas) { //clear the canvas
        //     s.clear(); 
        //     s.background(backgroundColor); // Set the background color of the entire canvas
        //     s.currentMidiData = null;
        //     s.parseMidi(s.currentMidiData);
        // }
        // if (s.isApressed) {
        //     s.clearCanvas = false;
        //     s.currentMidiData = null;
        //     s.parseMidi(s.currentMidiData);
        // }
        //////////////////////////
        s.pop();
    };
    // For example:
    s.mousePressed = function() {
        // Check if mouse is near the right edge of the canvas
        if (s.abs(s.mouseX - s.WIDTH) < s.EDGE_THRESHOLD) s.resizingWidth = true;
        // Check if mouse is near the bottom edge of the canvas
        if (s.abs(s.mouseY - s.HEIGHT) < s.EDGE_THRESHOLD) s.resizingHeight = true;
    };
    // s.mouseDragged = function() {
    //     // If resizing width, update WIDTH based on mouseX
    //     if (s.resizingWidth) {
    //         s.WIDTH = s.mouseX;
    //     }
    //     // If resizing height, update HEIGHT based on mouseY
    //     if (s.resizingHeight) {
    //         s.HEIGHT = s.mouseY;
    //     }
    //     // Apply the new width and height to the canvas
    //     s.resizeCanvas(s.WIDTH, s.HEIGHT);
    // }
    s.mouseReleased = function() {
        // Reset resizing flags
        s.resizingWidth = false;
        s.resizingHeight = false;
    };
    s.showPopup = function() {
        if (s.mouseX > s.offset_x && s.mouseX < s.WIDTH + s.offset_x && s.mouseY > 0 && s.mouseY < s.HEIGHT) {
            const cellHeight = s.HEIGHT / s.NUM_NOTES;
            const section = Math.floor((s.HEIGHT - s.mouseY) / cellHeight);
            const midiNote = parseInt(Object.keys(s.drumMappings)[section]);
            if (midiNote >= s.LOWEST_MIDI_NOTE && midiNote != 35) {
                const drumPart = s.drumMappings[midiNote];
                const popupWidth = s.textWidth(drumPart) + 10;
                // Decide the x position of the popup based on mouseX
                let popupX = s.mouseX + 5;
                if (s.mouseX > (s.WIDTH + s.offset_x) / 2) popupX = s.mouseX - popupWidth - 5;
                s.fill(255);
                s.rect(popupX, s.mouseY, popupWidth, 20);
                s.fill(0);
                s.text(drumPart, popupX + 5, s.mouseY + 15);
            }
        }
    };
    // Detect when the "A" key is pressed
    s.keyPressed = function() {
        if (s.key === "A" || s.key === "a") {
            if (!s.isApressed) {
                s.isApressed = true; // Flag: "A" key is pressed
                s.aPressStartTime = s.millis(); // Record the time of press
                s.pressCount++; // Increment the press count
                console.log(`"A" key pressed. Press count: ${s.pressCount}`);
                // Check if the MIDI gate is open
                if ((0, $affef116f20f7e03$export$3b6dd1a438fa9298).isMidiReadyForProcessing()) {
                    s.midiGateOpened = true; // Mark the gate as opened
                    console.log("MIDI gate opened.");
                }
            }
        }
        // If the spacebar is pressed
        if (s.key === " ") s.isSpacePressed = true;
    };
    // Detect when the "A" key is released
    s.keyReleased = function() {
        if (s.key === "A" || s.key === "a") {
            const pressDuration = s.millis() - s.aPressStartTime;
            // If "A" has been pressed and released multiple times
            if (s.pressCount >= multiplePressThreshold) // console.log(`"A" key pressed and released multiple times (${s.pressCount} presses).`);
            s.pressCount = 0; // Reset press count after handling
            s.isApressed = false; // Flag: "A" key is released
            console.log('"A" key released.');
        }
        // If the spacebar is released
        if (s.key === " ") s.isSpacePressed = false;
    };
};
// Run the sketch:
let $dfc31c5a77d3d4e0$var$myp5 = new (0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports)))($dfc31c5a77d3d4e0$var$sketch);
// If you want to update the theme based on an external event or interaction
document.getElementById("themeToggleCheckbox").addEventListener("change", function() {
    $dfc31c5a77d3d4e0$var$myp5.updateThemeColors();
});
document.getElementById("nextSessionBtn").addEventListener("click", function() {
    $dfc31c5a77d3d4e0$var$myp5.modifyMidi = true;
    $dfc31c5a77d3d4e0$var$myp5.noteSequences = null;
    $dfc31c5a77d3d4e0$var$myp5.currentMidiData = null; // Reset the data being used for visuals
    $dfc31c5a77d3d4e0$var$myp5.clearCanvas = true; // Ensure the canvas is cleared
});
document.getElementById("cleanCanvasBtn").addEventListener("click", function() {
    $dfc31c5a77d3d4e0$var$myp5.modifyMidi = true;
    $dfc31c5a77d3d4e0$var$myp5.noteSequences = null;
    $dfc31c5a77d3d4e0$var$myp5.currentMidiData = null;
    $dfc31c5a77d3d4e0$var$myp5.clearCanvas = true;
}); // document.getElementById('testBtn').addEventListener('click', function() {
 //     myp5.clearCanvas = true;
 // });
 // document.getElementById('test2Btn').addEventListener('click', function() {
 //     myp5.btnDraw = true;
 //     myp5.currentMidiData = getCurrentMidiForVisuals();
 // });
 // document.getElementById('test3Btn').addEventListener('click', function() {
 //     myp5.btnDummy = true;
 //     myp5.currentMidiData = myp5.nullMidiData;
 //     myp5.modifyMidi = !myp5.modifyMidi; // Toggle the hiding flag
 // });


// Author: Çağrı Erdem, 2023
// Description:  playback script for the 2groove web app.
// +-------------------------------+-----------------------------------+
// | playback.js                   | playbackWorker.js                 |
// +-------------------------------+-----------------------------------+
// | 1. Imports modules            | 1. Imports modules                |
// | 2. Set up worker              |                                   |
// | 3. Global setup (vars, etc.)  | 2. Global setup (vars, etc.)      |
// | 4. Event listeners for UI     |                                   |
// | 5. checkAndEnqueueMidi()      |                                   |
// |   - Fetch MIDI data           |                                   |
// |   - Add to midiQueue          |                                   |
// |   - Send LOAD_MIDI to worker  | 3. onmessage (LOAD_MIDI)          |
// |                               |    - parseAndEnqueueMidi()        |
// |                               |      (Parse MIDI, store in queue) |
// | 6. startPlayback()            | 4. onmessage (START_PLAYBACK)     |
// |   - Set isPlaying = true      |    - Set isPlaying = true         |
// |   - Send START_PLAYBACK to    |    - Set startTime                |
// |     worker                    |    - scheduleNextNote()           |
// |                               |      (Schedule next note)         |
// | 7. Worker sends PLAY_NOTE     | 5. scheduleNextNote()             |
// |   message to playback.js      |    - Post PLAY_NOTE to main       |
// |                               |      thread                       |
// | 8. playNote()                 |                                   |
// |   - Trigger sampler note      |                                   |
// | 9. Animation loop via draw()  |                                   |
// |   - Continue visual updates   |                                   |
// | 10. loopPlayback()            | 6. Worker clears MIDI queue       |
// |   - Send REPLAY_MIDI or       |    if STOP_PLAYBACK is called     |
// |     SCHEDULE_NEXT_MIDI to     |                                   |
// |     worker                    | 7. onmessage (REPLAY_MIDI)        |
// |                               |    - parseAndEnqueueMidi()        |
// |                               |    - scheduleNextNote()           |
// +-------------------------------+-----------------------------------+
// imports















































































































const $e2fd133faaf57a8f$export$5f20c3cdf3b5e8be = {
    "closed-hihat": [
        (parcelRequire("lw8Mu")),
        (parcelRequire("1NuFb")),
        (parcelRequire("e3CPn")),
        (parcelRequire("j8xcP")),
        (parcelRequire("dfk0E")),
        (parcelRequire("1WnZU")),
        (parcelRequire("1ITJB")),
        (parcelRequire("570Mo")),
        (parcelRequire("amPri")),
        (parcelRequire("fAaYz")),
        (parcelRequire("fPRLW")),
        (parcelRequire("kwhgF"))
    ],
    "open-hihat": [
        (parcelRequire("e0iWv")),
        (parcelRequire("l6Y43")),
        (parcelRequire("fBSj4")),
        (parcelRequire("ajKwd")),
        (parcelRequire("ck7JE")),
        (parcelRequire("hnHVd")),
        (parcelRequire("aA3m4")),
        (parcelRequire("8a69x")),
        (parcelRequire("dqHjm")),
        (parcelRequire("jnTsG")),
        (parcelRequire("c1zb3")),
        (parcelRequire("26IF6"))
    ],
    "crash": [
        (parcelRequire("lbiIu")),
        (parcelRequire("2NGyf")),
        (parcelRequire("lABIk")),
        (parcelRequire("3iUw5")),
        (parcelRequire("274PA")),
        (parcelRequire("7ehjG")),
        (parcelRequire("9N1z7")),
        (parcelRequire("71k2j")),
        (parcelRequire("5Pvi2")),
        (parcelRequire("2RFd4")),
        (parcelRequire("1eKy2")),
        (parcelRequire("8YECZ"))
    ],
    "ride": [
        (parcelRequire("5SxuK")),
        (parcelRequire("ldQTA")),
        (parcelRequire("f6Cx3")),
        (parcelRequire("dWpbb")),
        (parcelRequire("hhn9f")),
        (parcelRequire("ZdGiJ")),
        (parcelRequire("j9z4h")),
        (parcelRequire("kiJCK")),
        (parcelRequire("272cE")),
        (parcelRequire("bTlbG")),
        (parcelRequire("6CR9H")),
        (parcelRequire("1Ltew"))
    ],
    "kick": [
        (parcelRequire("6bXMG")),
        (parcelRequire("1v8uQ")),
        (parcelRequire("1gWYQ")),
        (parcelRequire("7GIzt")),
        (parcelRequire("46MCu")),
        (parcelRequire("56E5k")),
        (parcelRequire("2nfIT")),
        (parcelRequire("1vINS")),
        (parcelRequire("feiA7")),
        (parcelRequire("aQbil")),
        (parcelRequire("624Hq")),
        (parcelRequire("fYSwK"))
    ],
    "snare": [
        (parcelRequire("awcGy")),
        (parcelRequire("3sfcn")),
        (parcelRequire("9KbLN")),
        (parcelRequire("bSyUS")),
        (parcelRequire("8KIwk")),
        (parcelRequire("kdpRC")),
        (parcelRequire("hjY08")),
        (parcelRequire("eM6M7")),
        (parcelRequire("1SKcy")),
        (parcelRequire("j9hxR")),
        (parcelRequire("2NXPr")),
        (parcelRequire("gAz4G"))
    ],
    "hi-tom": [
        (parcelRequire("aD9Um")),
        (parcelRequire("7IHL8")),
        (parcelRequire("lhP3B")),
        (parcelRequire("kqdlv")),
        (parcelRequire("5YpTq")),
        (parcelRequire("9d0yB")),
        (parcelRequire("d38YH")),
        (parcelRequire("hF6rJ")),
        (parcelRequire("iQi5z")),
        (parcelRequire("ifCLN")),
        (parcelRequire("iRvZv")),
        (parcelRequire("75iiO"))
    ],
    "mid-tom": [
        (parcelRequire("6kBfN")),
        (parcelRequire("8hpbe")),
        (parcelRequire("iuitn")),
        (parcelRequire("ekqSg")),
        (parcelRequire("iULhj")),
        (parcelRequire("5iX8l")),
        (parcelRequire("8itDX")),
        (parcelRequire("2eaI0")),
        (parcelRequire("ls98q")),
        (parcelRequire("euiK4")),
        (parcelRequire("9HaM0")),
        (parcelRequire("ge5lW"))
    ],
    "floor-tom": [
        (parcelRequire("4OwOj")),
        (parcelRequire("c29E2")),
        (parcelRequire("aq3tN")),
        (parcelRequire("brntc")),
        (parcelRequire("gUGe5")),
        (parcelRequire("awWFT")),
        (parcelRequire("ftxH4")),
        (parcelRequire("3yq6D")),
        (parcelRequire("cwkqo")),
        (parcelRequire("7lfO5")),
        (parcelRequire("8ab0Q")),
        (parcelRequire("6sqLW"))
    ]
};


// A simple metronome written using Javascript and the Web Audio API.
// Source: https://github.com/grantjames/metronome
// Interpreted and modified by: Çağrı Erdem, 2023 
class $49a7f2e7d9294088$export$6724c80e614e277e {
    constructor(tempo = 120, volume = 0.5){
        this.audioContext = null;
        this.notesInQueue = []; // notes that have been put into the web audio and may or may not have been played yet {note, time}
        this.currentBeatInBar = 0;
        this.beatsPerBar = 4;
        this.tempo = tempo;
        this.lookahead = 25; // How frequently to call scheduling function (in milliseconds)
        this.scheduleAheadTime = 0.1; // How far ahead to schedule audio (sec)
        this.nextNoteTime = 0.0; // when the next note is due
        this.isRunning = false;
        this.intervalID = null;
        this.mute = false; // Add a mute property
        this.volume = 0.4; // Add a setVolume property
    }
    setAudioContext(newContext) {
        this.audioContext = newContext;
    //metronomu acip kapamak icin koyduk ama bakalim calisacak mi
    }
    nextNote() {
        // Advance current note and time by a quarter note (crotchet if you're posh)
        var secondsPerBeat = 60.0 / this.tempo; // Notice this picks up the CURRENT tempo value to calculate beat length.
        this.nextNoteTime += secondsPerBeat; // Add beat length to last beat time
        this.currentBeatInBar++; // Advance the beat number, wrap to zero
        if (this.currentBeatInBar == this.beatsPerBar) this.currentBeatInBar = 0;
    }
    //TODO: push it to the actual repo
    setVolume(newVolume) {
        this.volume = newVolume;
    }
    scheduleNote(beatNumber, time) {
        if (this.mute) return; // Don't play the sound if muted
        // push the note on the queue, even if we're not playing.
        this.notesInQueue.push({
            note: beatNumber,
            time: time
        });
        // create an oscillator
        const osc = this.audioContext.createOscillator();
        const envelope = this.audioContext.createGain();
        osc.frequency.value = beatNumber % this.beatsPerBar == 0 ? 1000 : 1000; //800 yerine 1000 yaptim ikincisini de 1/4 seklinde gelsin click'ler diye
        envelope.gain.value = this.volume;
        envelope.gain.exponentialRampToValueAtTime(this.volume, time + 0.001);
        envelope.gain.exponentialRampToValueAtTime(0.001, time + 0.05);
        osc.connect(envelope);
        envelope.connect(this.audioContext.destination);
        osc.start(time);
        osc.stop(time + 0.03);
    }
    scheduler() {
        // while there are notes that will need to play before the next interval, schedule them and advance the pointer.
        while(this.nextNoteTime < this.audioContext.currentTime + this.scheduleAheadTime){
            this.scheduleNote(this.currentBeatInBar, this.nextNoteTime);
            this.nextNote();
        }
    }
    start() {
        if (this.isRunning) return;
        if (this.audioContext == null) this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        this.isRunning = true;
        this.currentBeatInBar = 0;
        this.nextNoteTime = this.audioContext.currentTime + 0.02; //0.05
        this.intervalID = setInterval(()=>this.scheduler(), this.lookahead);
    }
    stop() {
        this.isRunning = false;
        clearInterval(this.intervalID);
    }
    startStop() {
        if (this.isRunning) this.stop();
        else this.start();
    }
    // Method to toggle the mute state
    //TODO: push it to the actual repo
    toggleMute() {
        this.mute = !this.mute;
    }
    // Modify the method responsible for playing the metronome tick
    playTick() {
        if (this.mute) // If muted, skip playing the sound
        return;
    // Otherwise, play the tick sound
    }
    // Resetting the Metronome's currentBeatInBar for Loop Synchronization
    //TODO: push it to the actual repo -- ALSO perhaps `reset()` would be a better name
    reset() {
        this.currentBeatInBar = 0;
    // Any additional logic needed to reset the metronome for a new loop
    }
    alignWithGrooveStart(startTime) {
        this.nextNoteTime = startTime; // Align the metronome's next note time with the groove start time
        this.currentBeatInBar = 0; // Optionally reset the beat counter if needed
    }
}


// glob var
let $e0ec19ee5925048a$var$audioContext = new (window.AudioContext || window.webkitAudioContext)();
let $e0ec19ee5925048a$var$startTime = null; // Start time for the MIDI playback
let $e0ec19ee5925048a$var$timeouts = []; // Store timeout IDs for scheduled notes
let $e0ec19ee5925048a$var$isPlaying = false; // to track the playback status
let $e0ec19ee5925048a$var$isFirstGroove = false;
let $e0ec19ee5925048a$var$processedMidiData; // Global variable to store the processed MIDI data for download
let $e0ec19ee5925048a$var$lookahead = 25; // Look-ahead interval in milliseconds for polling
let $e0ec19ee5925048a$var$mainVol = 0.8; // Main volume for sampler playback
let $e0ec19ee5925048a$var$elapsedTime = 0; // Initialize elapsedTime to track the elapsed time since playback started
let $e0ec19ee5925048a$var$notesInQueue = []; // Queue for notes to be drawn
let $e0ec19ee5925048a$var$lastNoteDrawn = null; // Track the last note drawn
let $e0ec19ee5925048a$var$totalTimeMs = 0; // Initialize totalTimeMs as a global variable
let $e0ec19ee5925048a$var$currentMidiForVisuals = null; // Track the current MIDI for visual playback
let $e0ec19ee5925048a$var$midiQueue = []; // Queue for MIDI files to be played back
let $e0ec19ee5925048a$var$currentPlaybackState = null; // for draw() to access the playback state within worker
// Initialize the metronome
let $e0ec19ee5925048a$var$globalBPM = 90; //TODO: Estimated bpm ilk playback'e ulasmiyo, bunu hallet!!!!
// Create a new Metronome instance with the initial tempo value
const $e0ec19ee5925048a$var$metronome = new (0, $49a7f2e7d9294088$export$6724c80e614e277e)($e0ec19ee5925048a$var$globalBPM, $e0ec19ee5925048a$var$uiCallback);
$e0ec19ee5925048a$var$metronome.audioContext = $e0ec19ee5925048a$var$audioContext; // Use the same AudioContext as the rest of the app
var $46877400ab1d62a1$exports = {};

let $46877400ab1d62a1$var$url = new URL("playbackWorker.2f42acaa.js", import.meta.url);
$46877400ab1d62a1$exports = $56b621a6dd25b2cb$exports($46877400ab1d62a1$var$url.toString(), $46877400ab1d62a1$var$url.origin, true);


// Web Worker setup for MIDI processing
const $e0ec19ee5925048a$var$playbackWorker = new Worker($46877400ab1d62a1$exports);
$e0ec19ee5925048a$var$playbackWorker.onmessage = (event)=>{
    const { type: type, data: data } = event.data;
    switch(type){
        case "PLAY_NOTE":
            $e0ec19ee5925048a$var$playNote(data); // Play the note received from the worker
            break;
        case "MIDI_LOADED":
            console.log("MIDI data successfully loaded in worker");
            break;
        case "PLAYBACK_COMPLETE":
            $e0ec19ee5925048a$var$isPlaying = false;
            // console.log('[Main] Playback complete.');
            // If there's new MIDI in the queue, initiate playback
            if ($e0ec19ee5925048a$var$midiQueue.length > 0) $e0ec19ee5925048a$var$startPlayback();
            else $e0ec19ee5925048a$var$loopPlayback(); // Loop the current MIDI if no new MIDI is available --bunu worker'da hallediyoruz sanirim
            break;
        case "PLAYBACK_STATE":
            // Handle the state information for synchronization ---deniyoruz bunu su an
            $e0ec19ee5925048a$var$currentPlaybackState = data; // Store the state for use in draw()
            break;
        default:
            console.error(`[Main] Unknown message type received from worker: ${type}`);
    }
};
// Check for new MIDI data and enqueue it
function $e0ec19ee5925048a$var$checkAndEnqueueMidi() {
    if ((0, $affef116f20f7e03$export$3b6dd1a438fa9298).isMidiReadyForProcessing()) {
        const midi = (0, $affef116f20f7e03$export$3b6dd1a438fa9298).getMidiData().buffer; // Convert to ArrayBuffer when fetching JSON
        $e0ec19ee5925048a$var$globalBPM = (0, $57d1b30337fe6afc$export$5ae1f883da3924b0)(); // Get the new tempo value from the UI
        $e0ec19ee5925048a$var$metronome.tempo = $e0ec19ee5925048a$var$globalBPM; // Update the metronome tempo
        console.log("Current tempo:", $e0ec19ee5925048a$var$globalBPM);
        if (!midi) {
            console.error("Failed to retrieve MIDI data.");
            return;
        }
        (0, $affef116f20f7e03$export$3b6dd1a438fa9298).midiProcessed(); // Mark the MIDI as processed
        // Add MIDI to the queue
        $e0ec19ee5925048a$var$midiQueue.push(midi);
        // Send MIDI data to the worker for processing
        $e0ec19ee5925048a$var$playbackWorker.postMessage({
            type: "LOAD_MIDI",
            data: midi,
            isReplay: false,
            bpm: $e0ec19ee5925048a$var$globalBPM
        });
        console.log("Sent LOAD_MIDI message to worker:", {
            type: "LOAD_MIDI",
            data: midi,
            bpm: $e0ec19ee5925048a$var$globalBPM
        });
        // If nothing is currently playing, start the next MIDI
        if (!$e0ec19ee5925048a$var$isPlaying) $e0ec19ee5925048a$var$startPlayback();
    }
}
// Start the playback
function $e0ec19ee5925048a$var$startPlayback() {
    if ($e0ec19ee5925048a$var$isPlaying || $e0ec19ee5925048a$var$midiQueue.length === 0) return; // Prevent multiple playback starts
    $e0ec19ee5925048a$var$isPlaying = true;
    $e0ec19ee5925048a$var$startTime = $e0ec19ee5925048a$var$audioContext.currentTime;
    $e0ec19ee5925048a$var$startMetronome(); // Start the metronome without waiting for the groove generation
    $e0ec19ee5925048a$var$forceMetronomeAlign(); // Align the metronome with the groove start time
    $e0ec19ee5925048a$var$metronome.mute = true;
    // Get the next MIDI from the queue for playback
    if ($e0ec19ee5925048a$var$midiQueue.length > 0) {
        $e0ec19ee5925048a$var$lastNoteDrawn = -1; // Reset lastNoteDrawn for the new MIDI playback
        $e0ec19ee5925048a$var$currentMidiForVisuals = $e0ec19ee5925048a$var$midiQueue.shift();
        $e0ec19ee5925048a$var$playbackWorker.postMessage({
            type: "START_PLAYBACK",
            data: $e0ec19ee5925048a$var$currentMidiForVisuals
        });
        console.log("Message sent to worker:", {
            type: "START_PLAYBACK"
        });
        requestAnimationFrame($e0ec19ee5925048a$var$draw); // Start the animation loop for visual updates
    } else console.error("MIDI queue is empty. Cannot start playback.");
}
// Stop the playback
function $e0ec19ee5925048a$var$stopPlayback() {
    if (!$e0ec19ee5925048a$var$isPlaying) return; // Prevent stopping if not playing
    $e0ec19ee5925048a$var$isPlaying = false;
    $e0ec19ee5925048a$var$playbackWorker.postMessage({
        type: "STOP_PLAYBACK"
    });
    console.log("Sent STOP_PLAYBACK message to worker:", {
        type: "STOP_PLAYBACK"
    });
    $e0ec19ee5925048a$var$resetPlayback();
}
// Reset playback system
function $e0ec19ee5925048a$var$resetPlayback() {
    $e0ec19ee5925048a$var$timeouts.forEach(clearTimeout);
    $e0ec19ee5925048a$var$timeouts = [];
    $e0ec19ee5925048a$var$startTime = null;
    $e0ec19ee5925048a$var$metronome.reset();
    $e0ec19ee5925048a$var$isPlaying = false;
    $e0ec19ee5925048a$var$elapsedTime = 0;
    $e0ec19ee5925048a$var$notesInQueue = [];
    $e0ec19ee5925048a$var$lastNoteDrawn = null;
}
// Play a note triggered by the worker
function $e0ec19ee5925048a$var$playNote(currentNote) {
    if (!currentNote || !currentNote.note) {
        console.error("Invalid note data received:", currentNote);
        return;
    }
    // console.log('Playing note:', currentNote); // Debugging statement
    const velocity = currentNote.velocity;
    const duration = currentNote.duration;
    const noteName = $f4d7193118bd1d27$export$44c95d3770756ed2(currentNote.note - 12, "midi").toNote();
    const drumType = $e0ec19ee5925048a$var$getDrumType(noteName);
    if (drumType) {
        if ($e0ec19ee5925048a$var$isListening) {
            const noteToTrigger = $e0ec19ee5925048a$var$mapVelocityToSample(velocity);
            const sampler = $e0ec19ee5925048a$var$samplers[drumType];
            sampler.volume.value = $e0ec19ee5925048a$var$scaleValue($e0ec19ee5925048a$var$mainVol, [
                0,
                1
            ], [
                -20,
                0
            ]);
            // sampler.connect(comp);
            // sampler.connect(eq);
            // sampler.connect(delay);
            // sampler.connect(reverb);
            sampler.triggerAttackRelease(noteToTrigger, duration);
        }
    }
}
// Function to get the drum type from a note name
function $e0ec19ee5925048a$var$getDrumType(noteName) {
    return $e0ec19ee5925048a$var$drumMappings[noteName] || null;
}
// Function to scale velocity
function $e0ec19ee5925048a$var$mapVelocityToSample(velocity) {
    const numberOfSamples = 12;
    const segment = Math.ceil(128 / numberOfSamples);
    const sampleIndex = Math.ceil(velocity / segment);
    const noteNumber = 60 + sampleIndex - 1;
    return $f4d7193118bd1d27$export$44c95d3770756ed2(noteNumber, "midi").toNote();
}
// Sampler setup using imported samples
const $e0ec19ee5925048a$var$drumParts = [
    "closed-hihat",
    "open-hihat",
    "crash",
    "ride",
    "kick",
    "snare",
    "hi-tom",
    "mid-tom",
    "floor-tom"
];
const $e0ec19ee5925048a$var$samplers = {};
$e0ec19ee5925048a$var$drumParts.forEach((drum)=>{
    const drumSamples = {};
    (0, $e2fd133faaf57a8f$export$5f20c3cdf3b5e8be)[drum].forEach((samplePath, index)=>{
        const noteName = $f4d7193118bd1d27$export$44c95d3770756ed2(60 + index, "midi").toNote();
        drumSamples[noteName] = samplePath;
    });
    $e0ec19ee5925048a$var$samplers[drum] = new $f2139aa45d11abc9$export$322f102bec719b22({
        urls: drumSamples
    }).toDestination();
});
// Drum mappings
const $e0ec19ee5925048a$var$drumMappings = {
    "C1": "kick",
    "D1": "snare",
    "F1": "floor-tom",
    "B1": "mid-tom",
    "C2": "hi-tom",
    "C#2": "crash",
    "D#2": "ride",
    "F#1": "closed-hihat",
    "A#1": "open-hihat"
};
function $e0ec19ee5925048a$var$draw() {
    if (!$e0ec19ee5925048a$var$isPlaying) return;
    let currentTime = $e0ec19ee5925048a$var$audioContext.currentTime;
    $e0ec19ee5925048a$var$elapsedTime = currentTime - $e0ec19ee5925048a$var$startTime; // Update elapsed time
    let newNoteToDraw = false;
    // Process notes in the queue to find the ones that need to be drawn
    while($e0ec19ee5925048a$var$notesInQueue.length > 0 && $e0ec19ee5925048a$var$notesInQueue[0].time <= currentTime){
        const currentNote = $e0ec19ee5925048a$var$notesInQueue.shift();
        $e0ec19ee5925048a$var$playNote(currentNote);
        // Check if this note is different from the last one drawn
        if (currentNote.note !== $e0ec19ee5925048a$var$lastNoteDrawn) {
            newNoteToDraw = true;
            $e0ec19ee5925048a$var$lastNoteDrawn = currentNote.note; // Update the lastNoteDrawn
        }
    }
    // Check if the total playback time has been reached
    if ($e0ec19ee5925048a$var$elapsedTime * 1000 >= $e0ec19ee5925048a$var$totalTimeMs) $e0ec19ee5925048a$var$loopPlayback(); // Transition to next MIDI or loop
    else // Continue the animation loop if playback is active
    requestAnimationFrame($e0ec19ee5925048a$var$draw);
}
// function loopPlayback() {
//     isPlaying = false; // Reset the flag once the playback finishes
//     if (midiQueue.length > 0) {
//         // If there's another MIDI in the queue, play it
//         metronome.reset(); // Reset the metronome's beat counter for the new loop
//         playbackWorker.postMessage({ type: 'LOAD_MIDI', data: midiQueue.shift(), isReplay: false }); // Load next MIDI in worker
//         playbackWorker.postMessage({ type: 'START_PLAYBACK' }); // Start playback after loading
//         isPlaying = true; // Set flag to indicate ongoing playback
//     } else if (currentMidiForVisuals) {
//         // If there's no new MIDI in the queue, reload and replay the current one
//         playbackWorker.postMessage({ type: 'LOAD_MIDI', data: currentMidiForVisuals, isReplay: true }); // Reload MIDI into worker for replay
//         playbackWorker.postMessage({ type: 'START_PLAYBACK' }); // Start playback after reloading
//         isPlaying = true; // Set flag to indicate ongoing playback
//     }
// }
// Loop the MIDI playback
function $e0ec19ee5925048a$var$loopPlayback() {
    $e0ec19ee5925048a$var$isPlaying = false; // Reset the flag once the playback finishes
    // Check if there's another MIDI in the queue and play it
    if ($e0ec19ee5925048a$var$midiQueue.length > 0) $e0ec19ee5925048a$var$startPlayback(); // Use startPlayback() to properly handle queue and playback state
    else // If there's no new MIDI in the queue, replay the current one
    $e0ec19ee5925048a$var$playbackWorker.postMessage({
        type: "REPLAY_MIDI",
        data: $e0ec19ee5925048a$var$currentMidiForVisuals
    });
}
// The polling mechanism in this main module is responsible for fetching new MIDI data and adding it to the queue.
setInterval(()=>{
    $e0ec19ee5925048a$var$checkAndEnqueueMidi(); // Check for new MIDI data and add it to the queue
    if (!$e0ec19ee5925048a$var$isPlaying && $e0ec19ee5925048a$var$midiQueue.length > 0) $e0ec19ee5925048a$var$startPlayback(); // Start playback if not already playing and there are MIDI files in the queue
}, $e0ec19ee5925048a$var$lookahead); // Adjusted to check every 25 milliseconds //TODO: Check if this is the correct value for the lookahead interval
//////////////////////////////////////////////////////////////
///////////////////// UI Callbacks ///////////////////////////
//////////////////////////////////////////////////////////////
// Variable to keep track of the playback state
let $e0ec19ee5925048a$var$isListening = false;
const $e0ec19ee5925048a$var$toggleListeningCheckbox = document.querySelector('#togglePlaybackButton input[type="checkbox"]');
$e0ec19ee5925048a$var$toggleListeningCheckbox.addEventListener("change", $e0ec19ee5925048a$var$toggleListening);
// Handle checkbox state change
function $e0ec19ee5925048a$var$toggleListening() {
    $e0ec19ee5925048a$var$isListening = $e0ec19ee5925048a$var$toggleListeningCheckbox.checked; // Update listening state based on checkbox
}
function $e0ec19ee5925048a$var$uiCallback() {
    const lightElement = document.getElementById("tapTempoLight"); // Your light element's ID
    lightElement.classList.add("light-on"); // Turn the light on
    setTimeout(()=>{
        lightElement.classList.remove("light-on"); // Turn the light off
    }, $e0ec19ee5925048a$var$lookahead); // Duration of the light being 'on' is also 25ms
}
let $e0ec19ee5925048a$var$lastTickTime = null;
function $e0ec19ee5925048a$var$syncLightWithMetronome() {
    if ($e0ec19ee5925048a$var$metronome.isRunning && $e0ec19ee5925048a$var$lastTickTime !== $e0ec19ee5925048a$var$metronome.nextNoteTime) {
        $e0ec19ee5925048a$var$uiCallback(); // Trigger the UI callback if the metronome ticked
        $e0ec19ee5925048a$var$lastTickTime = $e0ec19ee5925048a$var$metronome.nextNoteTime; // Update the last tick time
    }
    requestAnimationFrame($e0ec19ee5925048a$var$syncLightWithMetronome); // Continuously check for metronome ticks
}
$e0ec19ee5925048a$var$syncLightWithMetronome(); // Start syncing the light with the metronome
$e0ec19ee5925048a$var$metronome.tempo = $e0ec19ee5925048a$var$globalBPM; // Update the metronome tempo
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
function $e0ec19ee5925048a$var$resetPlaybackSystem() {
    console.log("Resetting playback system...");
    // 1. Stop all audio processes in the audio context
    if ($e0ec19ee5925048a$var$audioContext.state !== "closed") $e0ec19ee5925048a$var$audioContext.close().then(()=>{
        console.log("AudioContext closed.");
        // Reinitialize the audio context to start fresh
        $e0ec19ee5925048a$var$audioContext = new (window.AudioContext || window.webkitAudioContext)();
        $b7b11709569bdbef$export$2f04de43fe27971a($e0ec19ee5925048a$var$audioContext); // Ensure Tone.js uses the new context
        $e0ec19ee5925048a$var$playbackWorker.postMessage({
            type: "STOP_PLAYBACK"
        }); // Stop playback in the worker
        // Set the new audio context to the metronome
        $e0ec19ee5925048a$var$metronome.setAudioContext($e0ec19ee5925048a$var$audioContext);
        // Reset other components
        $e0ec19ee5925048a$var$resetMetronome();
        $e0ec19ee5925048a$var$resetMidiQueue();
        $e0ec19ee5925048a$var$resetSamplers();
    }).catch((error)=>{
        console.error("Error closing AudioContext:", error);
    });
    else {
        // If the context was already closed, create a new one directly
        $e0ec19ee5925048a$var$audioContext = new (window.AudioContext || window.webkitAudioContext)();
        $b7b11709569bdbef$export$2f04de43fe27971a($e0ec19ee5925048a$var$audioContext); // Ensure Tone.js uses the new context
        // Set the new audio context to the metronome
        $e0ec19ee5925048a$var$metronome.setAudioContext($e0ec19ee5925048a$var$audioContext);
        $e0ec19ee5925048a$var$resetMetronome();
        $e0ec19ee5925048a$var$resetMidiQueue();
        $e0ec19ee5925048a$var$resetSamplers();
    }
}
function $e0ec19ee5925048a$var$resetMetronome() {
    if ($e0ec19ee5925048a$var$metronome.isRunning) $e0ec19ee5925048a$var$metronome.stop();
    // Set the new audio context to the metronome
    $e0ec19ee5925048a$var$metronome.setAudioContext($e0ec19ee5925048a$var$audioContext);
    // Reset other parameters
    $e0ec19ee5925048a$var$metronome.reset();
    $e0ec19ee5925048a$var$metronome.tempo = $e0ec19ee5925048a$var$globalBPM; // Set the tempo slider value to metronome
    $e0ec19ee5925048a$var$metronome.mute = false; // Start unmuted for the new session
    console.log("Metronome reset.");
}
// Function to clear the MIDI queue and playback state
function $e0ec19ee5925048a$var$resetMidiQueue() {
    $e0ec19ee5925048a$var$midiQueue.length = 0;
    $e0ec19ee5925048a$var$notesInQueue.length = 0;
    $e0ec19ee5925048a$var$timeouts.forEach(clearTimeout);
    $e0ec19ee5925048a$var$timeouts = [];
    $e0ec19ee5925048a$var$isPlaying = false;
    $e0ec19ee5925048a$var$startTime = null;
    $e0ec19ee5925048a$var$lastNoteDrawn = -1;
    $e0ec19ee5925048a$var$isFirstGroove = true;
    console.log("MIDI queue and scheduled notes cleared.");
}
// Function to reset samplers
function $e0ec19ee5925048a$var$resetSamplers() {
    Object.values($e0ec19ee5925048a$var$samplers).forEach((sampler)=>{
        sampler.disconnect();
        sampler.toDestination();
    });
    console.log("Samplers reset.");
}
// Utility function to scale a value from one range to another
function $e0ec19ee5925048a$var$scaleValue(value, from, to) {
    let scale = (to[1] - to[0]) / (from[1] - from[0]);
    let capped = Math.min(from[1], Math.max(from[0], value)) - from[0];
    return capped * scale + to[0];
}
// Function to randomize value between a range
function $e0ec19ee5925048a$var$randomizeValue(min, max, isInteger) {
    const randomValue = Math.random() * (max - min) + min;
    return isInteger ? Math.floor(randomValue) : randomValue;
}
// Start the metronome
function $e0ec19ee5925048a$var$startMetronome() {
    if (!$e0ec19ee5925048a$var$metronome.isRunning) {
        $e0ec19ee5925048a$var$metronome.start();
        $e0ec19ee5925048a$var$metronome.reset();
    }
}
// Realign the metronome with the groove start time
function $e0ec19ee5925048a$var$forceMetronomeAlign() {
    const loopStartTime = $e0ec19ee5925048a$var$audioContext.currentTime;
    $e0ec19ee5925048a$var$metronome.alignWithGrooveStart(loopStartTime);
}
// Event listener for the reset button
document.getElementById("resetStudy").addEventListener("click", $e0ec19ee5925048a$var$resetPlaybackSystem);
document.getElementById("nextSessionBtn").addEventListener("click", $e0ec19ee5925048a$var$resetPlaybackSystem);
document.getElementById("cleanCanvasBtn").addEventListener("click", $e0ec19ee5925048a$var$resetPlaybackSystem);



// src/js/workers/facePoseWorker.js
// Use an OffscreenCanvas worker to handle all rendering tasks.
const $20921a4f0f2ce701$var$faceSmoothFactor = 0.2; // Adjust between 0 and 1 for smoother results
const $20921a4f0f2ce701$var$poseSmoothFactor = 0.2; // Adjust between 0 and 1 for smoother results
let $20921a4f0f2ce701$var$smoothedFaceLandmarks = null;
let $20921a4f0f2ce701$var$smoothedPoseLandmarks = null;
let $20921a4f0f2ce701$var$smoothedBlendShapes = null;
let $20921a4f0f2ce701$var$refine = true;
onmessage = (event)=>{
    try {
        if (event.data.type !== "PROCESS_FRAME") {
            console.warn("Unexpected message type received: ", event.data.type);
            return;
        }
        const { faceLandmarks: faceLandmarks, poseLandmarks: poseLandmarks, blendShapes: blendShapes } = event.data["results"];
        // TODO: Handle missing data gracefully--- the system should not crash if one of the data is missing!!!!
        if (!faceLandmarks || !Array.isArray(faceLandmarks)) {
            console.warn("Invalid or missing face landmarks data.");
            return;
        }
        if (!poseLandmarks || !Array.isArray(poseLandmarks)) {
            console.warn("Invalid or missing pose landmarks data.");
            return;
        }
        if (!blendShapes || typeof blendShapes !== "object") {
            console.warn("Invalid or missing blend shapes data.");
            return;
        }
        // Refine the landmarks if needed
        let selF = null;
        let selP = null;
        let selB = null;
        if (typeof $20921a4f0f2ce701$var$refine !== "undefined" && $20921a4f0f2ce701$var$refine) {
            selF = $20921a4f0f2ce701$var$refineFaceLandmarks(faceLandmarks);
            selP = $20921a4f0f2ce701$var$refinePoseLandmarks(poseLandmarks);
            selB = $20921a4f0f2ce701$var$refineBlendShapes(blendShapes);
        } else {
            selF = faceLandmarks;
            selP = poseLandmarks;
            selB = blendShapes;
        }
        // Apply smoothing
        $20921a4f0f2ce701$var$smoothedFaceLandmarks = $20921a4f0f2ce701$var$applyEMASmoothingToFaceLandmarks(selF, $20921a4f0f2ce701$var$smoothedFaceLandmarks, $20921a4f0f2ce701$var$faceSmoothFactor);
        $20921a4f0f2ce701$var$smoothedPoseLandmarks = $20921a4f0f2ce701$var$applyEMASmoothingToPoseLandmarks(selP, $20921a4f0f2ce701$var$smoothedPoseLandmarks, $20921a4f0f2ce701$var$poseSmoothFactor);
        $20921a4f0f2ce701$var$smoothedBlendShapes = $20921a4f0f2ce701$var$applyEMASmoothingToBlendShapes(selB, $20921a4f0f2ce701$var$smoothedBlendShapes, $20921a4f0f2ce701$var$faceSmoothFactor);
        // console.log("Processed frame with face landmarks: ", smoothedFaceLandmarks);
        // console.log("Processed frame with pose landmarks: ", smoothedPoseLandmarks);
        // Post the processed results back to the main thread
        postMessage({
            type: "PROCESSED_RESULTS",
            data: {
                faceLandmarks: $20921a4f0f2ce701$var$smoothedFaceLandmarks,
                poseLandmarks: $20921a4f0f2ce701$var$smoothedPoseLandmarks,
                blendShapes: $20921a4f0f2ce701$var$smoothedBlendShapes
            }
        });
    } catch (error) {
        console.error("Error processing frame: ", error);
    }
};
// Function to refine face landmarks by selecting certain areas (83 * 3)
function $20921a4f0f2ce701$var$refineFaceLandmarks(faceLandmarks) {
    if (!Array.isArray(faceLandmarks)) {
        console.warn("refineFaceLandmarks received invalid data.");
        return [];
    }
    try {
        // 'face_oval': [152, 176, 150, 172, 132, 234, 162, 54, 67, 10, 297, 284, 389, 454, 401, 435, 397, 379, 400],
        const refinedFsIndexes_r = {
            "forehead": [
                9,
                108,
                337,
                10
            ],
            "face_oval": [
                152,
                172,
                132,
                234,
                21,
                67,
                297,
                251,
                454,
                361,
                397
            ],
            "cheekbone_left": [
                280
            ],
            "cheekbone_right": [
                50
            ],
            "right_iris": [
                469,
                470,
                471,
                472
            ],
            "right_iris_mid": [
                468
            ],
            "right_eye_outer_corner": [
                33
            ],
            "right_eye_inner_corner": [
                133
            ],
            "right_eye_lower_lid": [
                145,
                144
            ],
            "right_eye_upper_lid": [
                159,
                160
            ],
            "right_eyebrow": [
                70,
                63,
                105,
                66,
                107
            ],
            "left_iris": [
                474,
                475,
                476,
                477
            ],
            "left_iris_mid": [
                473
            ],
            "left_eye_outer_corner": [
                362
            ],
            "left_eye_inner_corner": [
                263
            ],
            "left_eye_lower_lid": [
                374,
                380
            ],
            "left_eye_upper_lid": [
                386,
                385
            ],
            "left_eyebrow": [
                300,
                293,
                334,
                296,
                336
            ],
            "nose": [
                6,
                195,
                4,
                1,
                237,
                457
            ],
            "nose_left": [
                371,
                423,
                266
            ],
            "nose_right": [
                203,
                36,
                142
            ],
            "lip_top": [
                0,
                37,
                39,
                267,
                269,
                61
            ],
            "lip_bottom": [
                17,
                14,
                84,
                314,
                87,
                317,
                321,
                291,
                91
            ],
            "mouth": [
                425,
                427,
                434,
                205,
                207,
                214
            ]
        };
        let refinedLandmarks = [];
        for (let [part, indexes] of Object.entries(refinedFsIndexes_r))indexes.forEach((index, idx)=>{
            if (faceLandmarks[index]) refinedLandmarks.push({
                ...faceLandmarks[index],
                part: `${part}_${idx + 1}`
            });
        });
        return refinedLandmarks;
    } catch (error) {
        console.error("Error refining face landmarks: ", error);
        return [];
    }
}
// Function to refine pose landmarks by selecting specific indices (6 * 3)
function $20921a4f0f2ce701$var$refinePoseLandmarks(poseLandmarks) {
    if (!Array.isArray(poseLandmarks)) {
        console.warn("Invalid pose landmarks data. Expected an array.");
        return [];
    }
    const labeledLandmarks = [];
    try {
        const refinedIndexes = {
            "left_shoulder": 11,
            "right_shoulder": 12,
            "left_elbow": 13,
            "right_elbow": 14,
            "left_wrist": 15,
            "right_wrist": 16
        };
        for (const [part, index] of Object.entries(refinedIndexes)){
            if (index < 0 || index >= poseLandmarks.length) {
                console.warn(`Index out of bounds for pose landmark '${part}': ${index}`);
                continue; // Skip out-of-bounds index
            }
            const landmark = poseLandmarks[index];
            if (landmark && typeof landmark === "object") labeledLandmarks.push({
                ...landmark,
                part: part
            });
            else console.warn(`Invalid landmark at index ${index}. Expected an object.`);
        }
    } catch (error) {
        console.error("Error labeling pose landmarks: ", error);
    }
    return labeledLandmarks;
}
// Function to refine blend shapes (15 * 1)
function $20921a4f0f2ce701$var$refineBlendShapes(blendShapes) {
    if (!blendShapes || !blendShapes.categories || !Array.isArray(blendShapes.categories)) {
        console.warn("refineBlendShapes received invalid data.");
        return {};
    }
    try {
        const selectedBlendShapes = [
            "browOuterUpLeft",
            "browOuterUpRight",
            "eyeBlinkLeft",
            "eyeBlinkRight",
            "eyeLookDownLeft",
            "eyeLookDownRight",
            "eyeLookInLeft",
            "eyeLookInRight",
            "eyeSqintLeft",
            "eyeSqintRight",
            "mouthDimpleLeft",
            "mouthDimpleRight",
            "mouthShrugUpper",
            "mouthSmileLeft",
            "mouthSmileRight",
            "jawOpen"
        ];
        const refinedBlendShapes = {};
        blendShapes.categories.forEach((blendShape)=>{
            if (selectedBlendShapes.includes(blendShape.categoryName)) refinedBlendShapes[blendShape.categoryName] = blendShape.score;
        });
        return refinedBlendShapes;
    } catch (error) {
        console.error("Error refining blend shapes: ", error);
        return {};
    }
}
// Function to apply EMA smoothing to face landmarks
function $20921a4f0f2ce701$var$applyEMASmoothingToFaceLandmarks(currentLandmarks, previousLandmarks, smoothingFactor) {
    if (!Array.isArray(currentLandmarks)) {
        console.warn("Invalid current landmarks data. Expected an array.");
        return [];
    }
    if (!previousLandmarks) return currentLandmarks;
    try {
        return currentLandmarks.map((current, index)=>{
            const previous = previousLandmarks[index];
            // Check if the current or previous landmarks are undefined or invalid
            if (!current || !previous || typeof current.x !== "number" || typeof previous.x !== "number") {
                console.warn(`Invalid or missing landmarks at index ${index}. Skipping smoothing.`);
                return current; // Return the current value as it is if invalid
            }
            return {
                x: isNaN(previous.x) ? current.x : smoothingFactor * previous.x + (1 - smoothingFactor) * current.x,
                y: isNaN(previous.y) ? current.y : smoothingFactor * previous.y + (1 - smoothingFactor) * current.y,
                z: isNaN(previous.z) ? current.z : smoothingFactor * previous.z + (1 - smoothingFactor) * current.z,
                part: current.part // Preserve the 'part' key for labeled landmarks
            };
        });
    } catch (error) {
        console.error("Error applying EMA smoothing to face landmarks: ", error);
        return currentLandmarks;
    }
}
// Function to apply EMA smoothing to pose landmarks
function $20921a4f0f2ce701$var$applyEMASmoothingToPoseLandmarks(currentLandmarks, previousLandmarks, smoothingFactor) {
    if (!Array.isArray(currentLandmarks)) {
        console.warn("Invalid current landmarks data. Expected an array.");
        return [];
    }
    if (!previousLandmarks) return currentLandmarks;
    try {
        return currentLandmarks.map((current, index)=>{
            const previous = previousLandmarks[index];
            // Check if the current or previous landmarks are undefined or invalid
            if (!current || !previous || typeof current.x !== "number" || typeof previous.x !== "number") {
                console.warn(`Invalid or missing landmarks at index ${index}. Skipping smoothing.`);
                return current; // Return the current value as it is if invalid
            }
            return {
                x: isNaN(previous.x) ? current.x : smoothingFactor * previous.x + (1 - smoothingFactor) * current.x,
                y: isNaN(previous.y) ? current.y : smoothingFactor * previous.y + (1 - smoothingFactor) * current.y,
                z: isNaN(previous.z) ? current.z : smoothingFactor * previous.z + (1 - smoothingFactor) * current.z,
                part: current.part // Preserve the 'part' key for labeled landmarks
            };
        });
    } catch (error) {
        console.error("Error applying EMA smoothing to face landmarks: ", error);
        return currentLandmarks;
    }
}
// Function to apply EMA smoothing to blend shapes
function $20921a4f0f2ce701$var$applyEMASmoothingToBlendShapes(currentBlendShapes, previousBlendShapes, smoothingFactor) {
    if (!previousBlendShapes) return {
        ...currentBlendShapes
    };
    try {
        let smoothedBlendShapes = {};
        for(const key in currentBlendShapes)if (currentBlendShapes.hasOwnProperty(key)) {
            const currentValue = currentBlendShapes[key];
            const previousValue = previousBlendShapes[key];
            if (isNaN(currentValue)) smoothedBlendShapes[key] = currentValue;
            else if (previousValue === undefined || isNaN(previousValue)) smoothedBlendShapes[key] = currentValue;
            else smoothedBlendShapes[key] = smoothingFactor * previousValue + (1 - smoothingFactor) * currentValue;
        }
        return smoothedBlendShapes;
    } catch (error) {
        console.error("Error applying EMA smoothing to blend shapes: ", error);
        return currentBlendShapes;
    }
} //boredom related stuff
 // Inner brow raise
 // Outer brow raise
 // Inner and outer brow raised together
 // Dimpler
 // Brow lowerer
 // Lid tightener
 // Brow lowered with tightened lids
 // Tightened lids will lead to a lowered brow
 // Lip corner puller
 // Eye closure


// playbackWorker.js - MIDI processing and playback worker

// Data structures to store MIDI data and playback scheduling
let $e397ce44c86f5da4$var$midiQueue = []; // Stores the parsed MIDI events to be scheduled
let $e397ce44c86f5da4$var$notesInQueue = []; // Stores the notes to be played
let $e397ce44c86f5da4$var$isPlaying = false; // Playback state
let $e397ce44c86f5da4$var$tempo = 90; // Default tempo value to start with
let $e397ce44c86f5da4$var$startTime = 0; // Start time for playback
// Function to handle incoming messages from the main thread
onmessage = function(event) {
    const { type: type, data: data, isReplay: isReplay, bpm: bpm } = event.data;
    switch(type){
        case "LOAD_MIDI":
            $e397ce44c86f5da4$var$tempo = bpm || $e397ce44c86f5da4$var$tempo; // Set the tempo if provided
            console.log(`[Playback Worker] MIDI loaded at ${$e397ce44c86f5da4$var$tempo} BPM`);
            // Only load new MIDI if there are no notes currently being played
            if (!$e397ce44c86f5da4$var$isPlaying && $e397ce44c86f5da4$var$notesInQueue.length === 0) {
                $e397ce44c86f5da4$var$parseAndEnqueueMidi(data, isReplay || false);
                postMessage({
                    type: "MIDI_LOADED"
                });
            } else console.warn(`[Playback Worker] Attempted to load MIDI while notes are still in queue or already playing.`);
            break;
        case "START_PLAYBACK":
            // Start playback only if we have notes to play and are not currently playing
            if (!$e397ce44c86f5da4$var$isPlaying && $e397ce44c86f5da4$var$notesInQueue.length > 0) {
                $e397ce44c86f5da4$var$isPlaying = true;
                $e397ce44c86f5da4$var$startTime = performance.now(); // Set the start time for playback
                console.log(`[Playback Worker] Starting playback at ${$e397ce44c86f5da4$var$tempo} BPM`);
                $e397ce44c86f5da4$var$scheduleNextNote();
            } else console.warn(`[Playback Worker] Attempted to start playback but no notes available or already playing.`);
            break;
        case "REPLAY_MIDI":
            if (!$e397ce44c86f5da4$var$isPlaying && data) {
                $e397ce44c86f5da4$var$parseAndEnqueueMidi(data);
                $e397ce44c86f5da4$var$isPlaying = true;
                $e397ce44c86f5da4$var$startTime = performance.now(); // Set the start time for playback
                $e397ce44c86f5da4$var$scheduleNextNote();
            } else console.warn(`[Playback Worker] Attempted to replay MIDI but currently playing.`);
            break;
        case "STOP_PLAYBACK":
            $e397ce44c86f5da4$var$stopPlayback();
            break;
        default:
            console.error(`[Playback Worker] Unknown message type: ${type}`); //figure out what to do with this
    }
};
// Function to parse and enqueue MIDI data
function $e397ce44c86f5da4$var$parseAndEnqueueMidi(midiData, isReplay = false) {
    try {
        const midi = new (0, $28735cb37928c976$exports.Midi)(midiData);
        const track = midi.tracks[0];
        console.log("[Playback Worker] Parsed MIDI:", midi);
        const ticksPerBeat = midi.header.ppq;
        const msPerTick = 60000 / $e397ce44c86f5da4$var$tempo / ticksPerBeat;
        // Reset notesInQueue to ensure correct timing
        $e397ce44c86f5da4$var$notesInQueue = [];
        track.notes.forEach((note)=>{
            const note_velocity = $e397ce44c86f5da4$var$scaleValue(note.velocity, [
                0,
                1
            ], [
                0,
                127
            ]);
            let timeMs = note.ticks * msPerTick;
            const note_duration = note.durationTicks * msPerTick;
            if (isReplay) // Reset startTime for replay consistency
            $e397ce44c86f5da4$var$startTime = performance.now();
            $e397ce44c86f5da4$var$notesInQueue.push({
                note: note.midi,
                time: timeMs,
                duration: note_duration,
                velocity: note_velocity
            });
        });
        $e397ce44c86f5da4$var$midiQueue = [
            ...$e397ce44c86f5da4$var$notesInQueue
        ];
    } catch (error) {
        console.error("[Playback Worker] Error processing MIDI data:", error.message);
    }
}
// Schedule the next note to be played
function $e397ce44c86f5da4$var$scheduleNextNote() {
    if (!$e397ce44c86f5da4$var$isPlaying || $e397ce44c86f5da4$var$notesInQueue.length === 0) {
        $e397ce44c86f5da4$var$isPlaying = false;
        postMessage({
            type: "PLAYBACK_COMPLETE"
        });
        return;
    }
    const nextNote = $e397ce44c86f5da4$var$notesInQueue[0]; // Peek at the next note
    const currentTime = performance.now();
    const timeUntilNextNote = nextNote.time - (currentTime - $e397ce44c86f5da4$var$startTime);
    // Function to keep checking the timing for the next note
    function playNextFrame() {
        if (!$e397ce44c86f5da4$var$isPlaying) return; // Stop if playback is paused
        const currentFrameTime = performance.now();
        if (currentFrameTime - $e397ce44c86f5da4$var$startTime >= nextNote.time) {
            $e397ce44c86f5da4$var$notesInQueue.shift(); // Remove the note from the queue
            postMessage({
                type: "PLAY_NOTE",
                data: nextNote
            }); // Send note data to main thread for playback
            $e397ce44c86f5da4$var$scheduleNextNote(); // Schedule the next note after playing
        } else requestAnimationFrame(playNextFrame); // Keep checking until it is time to play the note
    }
    if (timeUntilNextNote <= 0) {
        // Immediately play the note if its time is already due
        $e397ce44c86f5da4$var$notesInQueue.shift();
        postMessage({
            type: "PLAY_NOTE",
            data: nextNote
        });
        $e397ce44c86f5da4$var$scheduleNextNote(); // Schedule the next note
    } else // Start polling to check when it’s time to play the note
    requestAnimationFrame(playNextFrame);
}
// Stop playback and clear queues
function $e397ce44c86f5da4$var$stopPlayback() {
    $e397ce44c86f5da4$var$isPlaying = false;
    $e397ce44c86f5da4$var$notesInQueue = [];
    console.log("[Playback Worker] Playback stopped and queue cleared.");
}
// Utility function to scale a value from one range to another
function $e397ce44c86f5da4$var$scaleValue(value, from, to) {
    let scale = (to[1] - to[0]) / (from[1] - from[0]);
    let capped = Math.min(from[1], Math.max(from[0], value)) - from[0];
    return capped * scale + to[0];
}


// tempoWorker.js
// adapted from:
// Copyright (c) 2023 Project Nayuki
// All rights reserved. Contact Nayuki for licensing.
// https://www.nayuki.io/page/tap-to-measure-tempo-javascript
"use strict";
let $b1c92e7de0b4c47d$var$beatTimes = [];
let $b1c92e7de0b4c47d$var$xSum = 0;
let $b1c92e7de0b4c47d$var$xxSum = 0;
let $b1c92e7de0b4c47d$var$ySum = 0;
let $b1c92e7de0b4c47d$var$yySum = 0;
let $b1c92e7de0b4c47d$var$xySum = 0;
let $b1c92e7de0b4c47d$var$periodPrev = NaN;
let $b1c92e7de0b4c47d$var$aPrev = NaN;
let $b1c92e7de0b4c47d$var$bPrev = NaN;
onmessage = function(event) {
    const { cmd: cmd, tapTimes: tapTimes } = event.data;
    if (cmd === "calculateTempo") {
        $b1c92e7de0b4c47d$var$beatTimes = tapTimes;
        if ($b1c92e7de0b4c47d$var$beatTimes.length >= 2) {
            const n = $b1c92e7de0b4c47d$var$beatTimes.length;
            const x = n - 1;
            const y = $b1c92e7de0b4c47d$var$beatTimes[n - 1] - $b1c92e7de0b4c47d$var$beatTimes[0];
            // Regression cumulative variables
            $b1c92e7de0b4c47d$var$xSum += x;
            $b1c92e7de0b4c47d$var$xxSum += x * x;
            $b1c92e7de0b4c47d$var$ySum += y;
            $b1c92e7de0b4c47d$var$yySum += y * y;
            $b1c92e7de0b4c47d$var$xySum += x * y;
            // Calculate tempo
            const period = y / x;
            const tempo = 60000 * x / y;
            let advancedTempo = null;
            if (n >= 2) {
                const xx = n * $b1c92e7de0b4c47d$var$xxSum - $b1c92e7de0b4c47d$var$xSum * $b1c92e7de0b4c47d$var$xSum;
                const a = (n * $b1c92e7de0b4c47d$var$xySum - $b1c92e7de0b4c47d$var$xSum * $b1c92e7de0b4c47d$var$ySum) / xx;
                advancedTempo = 60000 / a;
                $b1c92e7de0b4c47d$var$periodPrev = period;
                $b1c92e7de0b4c47d$var$aPrev = a;
            }
            console.log(`Tempo: ${tempo.toFixed(2)} BPM`);
            // Send tempo estimate back to main thread
            postMessage({
                type: "tempoCalculated",
                tempo: tempo.toFixed(2),
                advancedTempo: advancedTempo ? advancedTempo.toFixed(3) : null
            });
        }
    } else if (cmd === "reset") $b1c92e7de0b4c47d$var$resetState();
};
// Reset internal state
function $b1c92e7de0b4c47d$var$resetState() {
    $b1c92e7de0b4c47d$var$beatTimes = [];
    $b1c92e7de0b4c47d$var$xSum = 0;
    $b1c92e7de0b4c47d$var$xxSum = 0;
    $b1c92e7de0b4c47d$var$ySum = 0;
    $b1c92e7de0b4c47d$var$yySum = 0;
    $b1c92e7de0b4c47d$var$xySum = 0;
    $b1c92e7de0b4c47d$var$periodPrev = NaN;
    $b1c92e7de0b4c47d$var$aPrev = NaN;
    $b1c92e7de0b4c47d$var$bPrev = NaN;
}


// worker for client-side ajax requests
//   //TODO: modify this
//   // Function to collect and structure the tapping data and metadata
//   export async function collectTappingData(participantId, grooveId, takeNumber, rhythmArray, rating) {
//     const timestamp = new Date().toISOString();
//     const geoData = await getUserGeoData(); // Fetch user's geo-data
//     // Structure the collected data and metadata into a JSON object
//     const data = {
//       filename: `${participantId}_${grooveId}_t${takeNumber}_r${rating}_${timestamp}`, // Structured identifier
//       participantId,
//       grooveId,
//       takeNumber,
//       timestamp,
//       rhythmArray,
//       rating,
//       geoData
//     };
//     console.log('Collected Data:', data); // For debugging purposes
//     return data; // Return the structured JSON object
//   }
// let httpIp = `127.0.0.1`;
// let httpPort = `5002`;
// // TODO: modify this
//   async function sendDataToServer(array, stepId, participantId, rating) {
//     const user_data = await collectTappingData(participantId, stepId, takeNumber, array, rating);
//     const data_url = `http://${httpIp}:${httpPort}/send_data`; //comment out when deploying
//     // const data_url =`https://tapthegroove.com/send_data`; //comment out when testing locally
//     console.log("Sending request to:", data_url);
//     try {
//       const response = await fetch(data_url, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(user_data)
//       });
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }     
//       const responseData = await response.json();
//       console.log('Server response:', responseData);
//     } catch (error) {
//       console.error('Error sending data to server:', error);
//     }
//   }
self.addEventListener("message", function(event) {
    const data = event.data;
    if (data.cmd === "sendArray") $e4758edede27b98a$var$sendArrayToServer(data.array, data.bpm, data.temperatureValue, data.hitTolerance, data.isHttpConnected, data.httpIp, data.portInput, data.samplingStrategy);
});
function $e4758edede27b98a$var$sendArrayToServer(array, bpm, temperatureValue, hitTolerance, isHttpConnected, samplingStrategy) {
    if (!isHttpConnected) return;
    // const data_url = `http://${httpIp}:${portInput}/send_array`;
    // const data_url = `http://127.0.0.1:5002/send_array`;
    const data_url = `https://2groove.live/send_array`;
    console.log("Sending request to:", data_url);
    const payload = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            array: array,
            bpm: bpm,
            temp: temperatureValue,
            thresh: hitTolerance,
            samplingStrategy: samplingStrategy
        })
    };
    fetch(data_url, payload).then((response)=>response.json()) // Process as JSON first
    // checking the success field of the response, and if it's true, you're converting the data field (base64 encoded string of the MIDI binary) 
    // back to a byte array, and then you're posting this byte array back to the main thread:
    .then((data)=>{
        if (data.success) {
            console.log("Processing tapped rhythms...");
            // const midiData = new Uint8Array(data.data);  // Convert base64 string to byte array
            const base64decoded = atob(data.data);
            const midiData = new Uint8Array(base64decoded.length).map((_, i)=>base64decoded.charCodeAt(i));
            console.log("Received MIDI data length:", midiData.length);
            self.postMessage({
                type: "arrayProcessed",
                data: midiData
            });
        } else {
            console.warn(data.message);
            self.postMessage({
                type: "error",
                error: new Error(data.message)
            });
        }
    }).catch((error)=>{
        console.error("Error:", error);
        self.postMessage({
            type: "error",
            error: error
        });
    });
}


// dedicated thread for queueing up rhythms
let $55223a1de456471a$var$midiEvents = []; // This will hold the queued MIDI events
self.addEventListener("message", function(event) {
    const data = event.data;
    switch(data.cmd){
        case "enqueue":
            $55223a1de456471a$var$midiEvents.push(data.event);
            break;
        case "dequeue":
            // Logic to decide which event(s) should be sent next
            const nextEvent = $55223a1de456471a$var$midiEvents.shift(); // Simplified example
            self.postMessage({
                cmd: "broadcast",
                event: nextEvent
            });
            break;
    }
});


// Author: Çağrı Erdem, 2024
// Description: main script for the new dB study
////////////////////////////////////////////////////////////////////////////////////////    
// NOTES:
// Typical Frequency Bands Filtered in Eye-Tracking Interfaces:
// In eye-tracking systems, noise usually comes from external factors like head movement, environmental vibrations, or sensor imperfections. The signal of interest typically lies within certain frequency bands,
// such as
// Fixations: When the eyes are relatively still (e.g., focusing on a target), the signal is generally below 5 Hz.
// Saccades: Rapid eye movements between fixations, which typically occur at frequencies between 2 Hz and 10 Hz.
// Tremors/Noise: High-frequency noise from sensor vibrations or other sources may occur above 10 Hz.
// Thus, most filtering for eye-tracking is done using low-pass filters with a cutoff frequency typically set between 5 Hz and 10 Hz, depending on the specific application and level of noise in the system.
////////////////////////////////////////////////////////////////////////////////////////    
//TODO: Use an OffscreenCanvas worker to handle all rendering tasks.

// Author: Çağrı Erdem, 2024
// Description: data recording script for the dB study
// TODO: add tapping and generated groove arrays to the recorded data


let $09f012c82826b8a2$var$isRecording = false;
let $09f012c82826b8a2$var$recordedData = []; // To store all recorded data
let $09f012c82826b8a2$var$batchData = []; // To store data in batches
let $09f012c82826b8a2$var$keyboardData = []; // To capture keyboard events
const $09f012c82826b8a2$var$batchSize = 100; // Number of frames per batch
let $09f012c82826b8a2$var$frameCounter = 0;
const $09f012c82826b8a2$var$sampleRate = 3; // 3 iste 10fps'ye denk geliyor (30'u bolecen) --5'e kadar yolu var 
const $09f012c82826b8a2$var$decPts = 5; // Number of decimal points to round the data
//TODO: eger ana capture'da dusuk fps kullanirsak, kayitta ne kullancagimizi test etmek lazim.
let $09f012c82826b8a2$var$lastRecordedTempo = null;
let $09f012c82826b8a2$var$lastTapData = null;
let $09f012c82826b8a2$var$lastMidiData = null;
//////////////////////////
////////////////////////// Keyboard Interaction 
////////////////////////// 
// Capture 'keydown' events
window.addEventListener("keydown", (event)=>{
    const keyInteraction = {
        key: event.key,
        eventType: "keydown",
        timestamp: Date.now()
    };
    $09f012c82826b8a2$var$keyboardData.push(keyInteraction);
// console.log('Key down:', keyInteraction); // TODO: Comment out when needed
});
// Capture 'keyup' events
window.addEventListener("keyup", (event)=>{
    const keyInteraction = {
        key: event.key,
        eventType: "keyup",
        timestamp: Date.now()
    };
    $09f012c82826b8a2$var$keyboardData.push(keyInteraction);
// console.log('Key up:', keyInteraction); 
});
// Request file permission when starting the recording
async function $09f012c82826b8a2$var$requestFilePermission() {
    //TODO: implement it.
    const options = {
        types: [
            {
                description: "JSON Files",
                accept: {
                    "application/json": [
                        ".json"
                    ]
                }
            }
        ]
    };
    try {
        // Request the file handle (this will trigger a prompt)
        fileHandle = await window.showSaveFilePicker(options);
        writableStream = await fileHandle.createWritable();
        console.log("Permission granted for file saving.");
    } catch (err) {
        console.error("Error requesting file permission:", err);
    }
}
function $09f012c82826b8a2$export$e4938b640f150633(faceLandmarks, poseLandmarks, blendShapes, orientation) {
    if ($09f012c82826b8a2$var$isRecording) {
        // // Uncomment to skip frames based on sample rate but not needed since we reduced the landmarks
        // frameCounter++;
        // if (frameCounter % sampleRate !== 0) {
        //     // Skip this frame
        //     return;
        // }
        // // Reset frame counter if it gets too large
        // if (frameCounter >= 10000) {
        //     frameCounter = 0;
        // }
        const timestamp = performance.now();
        // Capture face landmarks if they exist, otherwise return an empty array
        const processedFaceLandmarks = faceLandmarks ? faceLandmarks.map((landmark)=>({
                x: landmark.x ? landmark.x.toFixed($09f012c82826b8a2$var$decPts) : 0,
                y: landmark.y ? landmark.y.toFixed($09f012c82826b8a2$var$decPts) : 0,
                z: landmark.z ? landmark.z.toFixed($09f012c82826b8a2$var$decPts) : 0,
                part: landmark.part || "unknown" // Use the actual 'part' value from each landmark
            })) : [];
        // Capture pose landmarks if they exist, otherwise return an empty array
        const processedPoseLandmarks = poseLandmarks ? poseLandmarks.map((landmark)=>({
                x: landmark.x ? landmark.x.toFixed($09f012c82826b8a2$var$decPts) : 0,
                y: landmark.y ? landmark.y.toFixed($09f012c82826b8a2$var$decPts) : 0,
                z: landmark.z ? landmark.z.toFixed($09f012c82826b8a2$var$decPts) : 0,
                part: landmark.part || "unknown" // Use the actual 'part' value from each landmark
            })) : [];
        const currentBpm = (0, $57d1b30337fe6afc$export$5ae1f883da3924b0)(); // Get the current BPM value
        const currentTapData = (0, $57d1b30337fe6afc$export$ffd9cee7b4d9db2f)(); // Get the current tapping data
        const currentMidiData = (0, $affef116f20f7e03$export$3b6dd1a438fa9298).getMidiData(); // Get the current MIDI data
        // Capture blend shapes if they exist, otherwise return an empty array
        let processedBlendShapes = [];
        if (blendShapes && typeof blendShapes === "object") try {
            for (const [categoryName, score] of Object.entries(blendShapes))if (typeof score === "number") processedBlendShapes.push({
                categoryName: categoryName,
                score: parseFloat(score.toFixed($09f012c82826b8a2$var$decPts))
            });
            else {
                console.warn(`Invalid score value for blend shape ${categoryName}. Expected a number, got:`, score);
                processedBlendShapes.push({
                    categoryName: categoryName,
                    score: 0.0 // Default to 0.0 if score is not a number
                });
            }
        } catch (error) {
            console.error("Error processing blend shapes:", error);
        }
        else console.warn("Blend shapes are missing or empty.");
        // Capture the keyboard interactions and reset the keyboard data
        const processedKeyboardInteractions = [
            ...$09f012c82826b8a2$var$keyboardData
        ];
        $09f012c82826b8a2$var$keyboardData = []; // Clear keyboard data after processing
        // Capture tempo (BPM) only if it has changed since the last recorded value
        let processedTempo = null;
        if (currentBpm !== $09f012c82826b8a2$var$lastRecordedTempo) {
            processedTempo = currentBpm;
            $09f012c82826b8a2$var$lastRecordedTempo = currentBpm; // Update last recorded tempo
        }
        // Capture tapping data if it has changed since the last recorded value
        let tapData = null;
        if (currentTapData !== $09f012c82826b8a2$var$lastTapData) {
            tapData = currentTapData;
            $09f012c82826b8a2$var$lastTapData = currentTapData; // Update last recorded tapping data
        }
        // Capture MIDI data if it has changed since the last recorded value
        let midiData = null;
        if (currentMidiData !== $09f012c82826b8a2$var$lastMidiData) {
            midiData = currentMidiData;
            $09f012c82826b8a2$var$lastMidiData = currentMidiData; // Update last recorded MIDI data  
        }
        // Collect all the data into a frame
        const frameData = {
            participantID: $57d1b30337fe6afc$export$3ee672b42e56aad7,
            sessionID: $57d1b30337fe6afc$export$39ee952be8b072ed,
            timestamp: timestamp,
            faceLandmarks: processedFaceLandmarks,
            poseLandmarks: processedPoseLandmarks,
            blendShapes: processedBlendShapes,
            headOrientation: orientation,
            keyboardInteractions: processedKeyboardInteractions
        };
        // Add tempo to the frame data only if it's been changed
        if (processedTempo !== null) {
            console.log(`[Recording] Tempo changed to ${processedTempo} BPM`);
            frameData.tempo = processedTempo;
        }
        // Add tapping data to the frame data only if it's been changed
        if (tapData !== null) {
            console.log(`[Recording] Tapping data updated:`, tapData);
            frameData.tapping = tapData;
        }
        // Add MIDI data to the frame data only if it's been changed
        if (midiData !== null) {
            console.log(`[Recording] MIDI data updated:`, midiData);
            frameData.groove = midiData;
        }
        // Add the frame data to the current batch and the overall recorded data
        $09f012c82826b8a2$var$batchData.push(frameData);
        $09f012c82826b8a2$var$recordedData.push(frameData); // Ensure data is added to recordedData as well
        // If batch size is reached, save the batch and clear batchData
        if ($09f012c82826b8a2$var$batchData.length >= $09f012c82826b8a2$var$batchSize) {
            $09f012c82826b8a2$var$saveBatch($09f012c82826b8a2$var$batchData);
            $09f012c82826b8a2$var$batchData = []; // Reset batch after saving
        }
    }
}
// Function to save a batch of data (local file download as example)
function $09f012c82826b8a2$var$saveBatch(data) {
    const jsonData = JSON.stringify(data, null, 2);
    const blob = new Blob([
        jsonData
    ], {
        type: "application/json"
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `batch_${Date.now()}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.log("Batch saved:", data);
}
function $09f012c82826b8a2$export$5277130cac3e825() {
    $09f012c82826b8a2$var$isRecording = !$09f012c82826b8a2$var$isRecording;
    if (!$09f012c82826b8a2$var$isRecording) // Save any remaining unsaved data in batch
    {
        if ($09f012c82826b8a2$var$batchData.length > 0) {
            $09f012c82826b8a2$var$saveBatch($09f012c82826b8a2$var$batchData);
            $09f012c82826b8a2$var$batchData = []; // Reset batch data after saving
        }
    }
    return $09f012c82826b8a2$var$isRecording;
}
async function $09f012c82826b8a2$export$868deebd7ec3c9ea() {
    const options = {
        types: [
            {
                description: "JSON Files",
                accept: {
                    "application/json": [
                        ".json"
                    ]
                }
            }
        ]
    };
    try {
        // Open a file picker to save the file
        const fileHandle1 = await window.showSaveFilePicker(options);
        const writableStream1 = await fileHandle1.createWritable();
        // Write all recorded data including remaining batch
        const allData = $09f012c82826b8a2$var$recordedData.concat($09f012c82826b8a2$var$batchData); // Combine recorded data and any remaining batch
        await writableStream1.write(JSON.stringify(allData, null, 2));
        await writableStream1.close();
        // Clear recordedData and batchData after saving
        $09f012c82826b8a2$var$recordedData = [];
        $09f012c82826b8a2$var$batchData = [];
        console.log("All recorded data saved successfully.");
    } catch (err) {
        console.error("Error saving file:", err);
    }
}
function $09f012c82826b8a2$var$generateFileName(participantID, sessionID) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Add 1 because getMonth() is 0-based
    const day = String(currentDate.getDate()).padStart(2, "0");
    const dateString = `${year}${month}${day}`;
    return `IN5060_${participantID}_${sessionID}_${dateString}.json`;
}
function $09f012c82826b8a2$var$getCurrentTime() {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0"); // Get hours and pad with leading zeros
    const minutes = String(now.getMinutes()).padStart(2, "0"); // Get minutes and pad
    const seconds = String(now.getSeconds()).padStart(2, "0"); // Get seconds and pad
    return `${hours}${minutes}${seconds}`; // Format as HHMMSS
}
const $09f012c82826b8a2$var$dateString = new Date().toISOString().split("T")[0]; // Get the current date as YYYY-MM-DD
async function $09f012c82826b8a2$export$9b908b4647579eb5(participantID, sessionID) {
    try {
        // Generate the filename
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Add 1 because getMonth() is 0-based
        const day = String(currentDate.getDate()).padStart(2, "0");
        const dateString = `${year}${month}${day}`;
        const fileName = `IN5060_${participantID}_${sessionID}_${dateString}_${$09f012c82826b8a2$var$getCurrentTime()}.json`;
        // Combine recorded data and any remaining batch
        const allData = $09f012c82826b8a2$var$recordedData.concat($09f012c82826b8a2$var$batchData);
        // Create a JSON Blob
        const jsonString = JSON.stringify(allData, null, 2);
        const blob = new Blob([
            jsonString
        ], {
            type: "application/json"
        });
        // Create a link element to trigger download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        // Programmatically click the link to trigger the download
        document.body.appendChild(link);
        link.click();
        // Clean up
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        // Clear recordedData and batchData after saving
        $09f012c82826b8a2$var$recordedData = [];
        $09f012c82826b8a2$var$batchData = [];
        console.log("All recorded data saved successfully.");
    } catch (err) {
        console.error("Error saving file:", err);
    }
}



var $6Yrql = parcelRequire("6Yrql");
// Author: Çağrı Erdem, 2024
// Description: Utils for dB study2
////////////////
// dB-related //
////////////////
function $cc90258846af473c$export$6eedb1e843bbd727(numNotes = 3, deltaTime = 480) {
    const dummyMidi = {
        type: "track",
        events: []
    };
    // Add meta event for setting tempo (optional)
    dummyMidi.events.push({
        deltaTime: 0,
        meta: true,
        type: "setTempo",
        microsecondsPerBeat: 500000 // Tempo: 120 BPM
    });
    // Generate noteOn and noteOff events
    for(let i = 0; i < numNotes; i++){
        // Note On: channel 1, note number 0, velocity 0
        dummyMidi.events.push({
            deltaTime: deltaTime,
            channel: 0,
            type: "noteOn",
            noteNumber: 0,
            velocity: 0 // Dummy velocity
        });
        // Note Off: channel 1, note number 0, velocity 0
        dummyMidi.events.push({
            deltaTime: deltaTime,
            channel: 0,
            type: "noteOff",
            noteNumber: 0,
            velocity: 0 // Dummy velocity
        });
    }
    // End of track event
    dummyMidi.events.push({
        deltaTime: 0,
        meta: true,
        type: "endOfTrack"
    });
    return dummyMidi;
}
function $cc90258846af473c$export$a3a8344b413db357(numNotes = 3, deltaTime = 480) {
    // MIDI header chunk
    const headerChunk = [
        0x4D,
        0x54,
        0x68,
        0x64,
        0x00,
        0x00,
        0x00,
        0x06,
        0x00,
        0x01,
        0x00,
        0x01,
        0x01,
        0xE0 // Time division (480 ticks per quarter note)
    ];
    // Track events
    const trackEvents = [];
    // Tempo meta event (set to 120 BPM)
    trackEvents.push(0x00, 0xFF, 0x51, 0x03, 0x07, 0xA1, 0x20); // Tempo: 120 BPM
    // Generate noteOn and noteOff events
    for(let i = 0; i < numNotes; i++){
        // Note On: Channel 1, Note C4 (60), Velocity 64
        trackEvents.push(deltaTime, 0x90, 0x3C, 0x40); // deltaTime, noteOn, noteNumber, velocity
        // Note Off: Channel 1, Note C4 (60), Velocity 0
        trackEvents.push(deltaTime, 0x80, 0x3C, 0x00); // deltaTime, noteOff, noteNumber, velocity
    }
    // End of Track event
    trackEvents.push(0x00, 0xFF, 0x2F, 0x00); // End of track
    // Calculate the length of the track chunk
    const trackChunkLength = trackEvents.length;
    // Create track chunk header
    const trackChunkHeader = [
        0x4D,
        0x54,
        0x72,
        0x6B,
        trackChunkLength >> 24 & 0xFF,
        trackChunkLength >> 16 & 0xFF,
        trackChunkLength >> 8 & 0xFF,
        trackChunkLength & 0xFF // Length byte 4
    ];
    // Combine header and track chunk into one array
    const midiData = Uint8Array.from([
        ...headerChunk,
        ...trackChunkHeader,
        ...trackEvents
    ]);
    // Return the MIDI data as an ArrayBuffer
    return midiData.buffer;
}
const $cc90258846af473c$export$56a56d1727e8fba = {
    neutral: document.getElementById("neutral"),
    browDownLeft: document.getElementById("browDownLeft"),
    browDownRight: document.getElementById("browDownRight"),
    browInnerUp: document.getElementById("browInnerUp"),
    browOuterUpLeft: document.getElementById("browOuterUpLeft"),
    browOuterUpRight: document.getElementById("browOuterUpRight"),
    cheekPuff: document.getElementById("cheekPuff"),
    cheekSquintLeft: document.getElementById("cheekSquintLeft"),
    cheekSquintRight: document.getElementById("cheekSquintRight"),
    eyeBlinkLeft: document.getElementById("eyeBlinkLeft"),
    eyeBlinkRight: document.getElementById("eyeBlinkRight"),
    eyeLookDownLeft: document.getElementById("eyeLookDownLeft"),
    eyeLookDownRight: document.getElementById("eyeLookDownRight"),
    eyeLookInLeft: document.getElementById("eyeLookInLeft"),
    eyeLookInRight: document.getElementById("eyeLookInRight"),
    eyeLookOutLeft: document.getElementById("eyeLookOutLeft"),
    eyeLookOutRight: document.getElementById("eyeLookOutRight"),
    eyeLookUpLeft: document.getElementById("eyeLookUpLeft"),
    eyeLookUpRight: document.getElementById("eyeLookUpRight"),
    eyeSquintLeft: document.getElementById("eyeSquintLeft"),
    eyeSquintRight: document.getElementById("eyeSquintRight"),
    eyeWideLeft: document.getElementById("eyeWideLeft"),
    eyeWideRight: document.getElementById("eyeWideRight"),
    jawForward: document.getElementById("jawForward"),
    jawLeft: document.getElementById("jawLeft"),
    jawOpen: document.getElementById("jawOpen"),
    jawRight: document.getElementById("jawRight"),
    mouthClose: document.getElementById("mouthClose"),
    mouthDimpleLeft: document.getElementById("mouthDimpleLeft"),
    mouthDimpleRight: document.getElementById("mouthDimpleRight"),
    mouthFrownLeft: document.getElementById("mouthFrownLeft"),
    mouthFrownRight: document.getElementById("mouthFrownRight"),
    mouthFunnel: document.getElementById("mouthFunnel"),
    mouthLeft: document.getElementById("mouthLeft"),
    mouthLowerDownLeft: document.getElementById("mouthLowerDownLeft"),
    mouthLowerDownRight: document.getElementById("mouthLowerDownRight"),
    mouthPressLeft: document.getElementById("mouthPressLeft"),
    mouthPressRight: document.getElementById("mouthPressRight"),
    mouthPucker: document.getElementById("mouthPucker"),
    mouthRight: document.getElementById("mouthRight"),
    mouthRollLower: document.getElementById("mouthRollLower"),
    mouthRollUpper: document.getElementById("mouthRollUpper"),
    mouthShrugLower: document.getElementById("mouthShrugLower"),
    mouthShrugUpper: document.getElementById("mouthShrugUpper"),
    mouthSmileLeft: document.getElementById("mouthSmileLeft"),
    mouthSmileRight: document.getElementById("mouthSmileRight"),
    mouthStretchLeft: document.getElementById("mouthStretchLeft"),
    mouthStretchRight: document.getElementById("mouthStretchRight"),
    mouthUpperUpLeft: document.getElementById("mouthUpperUpLeft"),
    mouthUpperUpRight: document.getElementById("mouthUpperUpRight"),
    noseSneerLeft: document.getElementById("noseSneerLeft"),
    noseSneerRight: document.getElementById("noseSneerRight")
};
function $cc90258846af473c$export$e26b8115faba4b58(blendShapes) {
    Object.keys($cc90258846af473c$export$56a56d1727e8fba).forEach((categoryName)=>{
        const score = $cc90258846af473c$export$a0afd5ca523cf1d1(blendShapes, categoryName);
        const displayElement = $cc90258846af473c$export$56a56d1727e8fba[categoryName];
        if (displayElement) displayElement.textContent = `${categoryName}: ${score ? score.toFixed(4) : "0.0000"}`;
    });
}
function $cc90258846af473c$export$a0afd5ca523cf1d1(data, categoryName, type = "blendShape") {
    //TODO: Simplify the function and add comments to explain the purpose of the function.
    if (type === "blendShape") // Handle blend shapes
    for (const element of data){
        const category = element.categories.find((category)=>category.categoryName === categoryName);
        if (category) return category.score;
    }
    else if (type === "pose") // Handle pose data based on the provided category name
    // Assuming the categoryName is the name of the landmark or related to the landmark index
    switch(categoryName){
        case "leftShoulder":
            return data[11]?.visibility || 0; // Assuming 11 is left shoulder
        case "rightShoulder":
            return data[12]?.visibility || 0; // Assuming 12 is right shoulder
        case "leftElbow":
            return data[13]?.visibility || 0; // Assuming 13 is left elbow
        case "rightElbow":
            return data[14]?.visibility || 0; // Assuming 14 is right elbow
        case "leftHand":
            return data[15]?.visibility || 0; // Assuming 15 is left wrist
        case "rightHand":
            return data[16]?.visibility || 0; // Assuming 16 is right wrist
        // Add more cases if needed
        default:
            return 0;
    }
    return 0;
}


const $ebe3bd935c906b87$var$video = document.getElementById("webcam");
const $ebe3bd935c906b87$var$canvasElement = document.getElementById("output_canvas");
const $ebe3bd935c906b87$var$canvasCtx = $ebe3bd935c906b87$var$canvasElement.getContext("2d");
const $ebe3bd935c906b87$var$cameraSelect = document.getElementById("cameraSelect"); // Dropdown for camera selection
const $ebe3bd935c906b87$var$startTrackingCheckbox = document.getElementById("startTracking"); // Checkbox for start tracking
const $ebe3bd935c906b87$var$enableDrawingCheckbox = document.getElementById("showTracking");
const $ebe3bd935c906b87$var$showWebcamCheckbox = document.getElementById("showWebcam"); // Checkbox for show/hide webcam
const $ebe3bd935c906b87$var$zoomSlider = document.getElementById("zoomSlider");
const $ebe3bd935c906b87$var$calibrationButton = document.getElementById("calibrationButton"); // Calibration button to reset the val
let $ebe3bd935c906b87$var$faceLandmarker;
let $ebe3bd935c906b87$var$pose;
let $ebe3bd935c906b87$var$runningMode = "IMAGE";
let $ebe3bd935c906b87$var$webcamRunning = false;
let $ebe3bd935c906b87$var$currentStream = null; // To store the current camera stream
const $ebe3bd935c906b87$var$videoWidth = 480;
let $ebe3bd935c906b87$var$zoomFactor = 1.0;
// Calibration variables
let $ebe3bd935c906b87$var$latestPoseResults = null;
// Unified calibration data
let $ebe3bd935c906b87$var$calibrationData = {
    poseLandmarks: null,
    gazeCenter: null,
    roll: 0,
    faceLandmarks: null,
    faceBlendshapes: null // Store calibrated blendshapes
};
// Fixed position for the static plus symbol (in the center of the canvas)
const $ebe3bd935c906b87$var$fixedPlusPosition = {
    x: $ebe3bd935c906b87$var$canvasElement.width / 0.9,
    y: $ebe3bd935c906b87$var$canvasElement.height / 1.25
};
// Define the dynamic plus symbol position
let $ebe3bd935c906b87$var$dynamicPlusPosition = {
    x: 0,
    y: 0
};
var $2bdeffe07a1ee846$exports = {};

let $2bdeffe07a1ee846$var$url = new URL("facePoseWorker.212cdc24.js", import.meta.url);
$2bdeffe07a1ee846$exports = $56b621a6dd25b2cb$exports($2bdeffe07a1ee846$var$url.toString(), $2bdeffe07a1ee846$var$url.origin, true);


///////////////////////////////////////////////
///////////////////////////////////////////////
// Worker Initialization
const $ebe3bd935c906b87$var$facePoseWorker = new Worker($2bdeffe07a1ee846$exports);
let $ebe3bd935c906b87$var$isWorkerReady = false; // Tracks worker readiness
// Initialize FaceLandmarker and Pose Detection in the main thread
async function $ebe3bd935c906b87$var$preLoadAssets() {
    const filesetResolver = await (0, $6Yrql.FilesetResolver).forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm");
    $ebe3bd935c906b87$var$faceLandmarker = await (0, $6Yrql.FaceLandmarker).createFromOptions(filesetResolver, {
        baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`,
            delegate: "GPU"
        },
        outputFaceBlendshapes: true,
        runningMode: $ebe3bd935c906b87$var$runningMode,
        numFaces: 1
    });
    // Initialize Pose using the traditional MediaPipe API
    $ebe3bd935c906b87$var$pose = new Pose({
        locateFile: (file)=>`https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`
    });
    $ebe3bd935c906b87$var$pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
    });
    // Set up pose.onResults to handle results and update latestPoseResults
    $ebe3bd935c906b87$var$pose.onResults($ebe3bd935c906b87$var$onPoseResults);
    // Mark assets as ready
    $ebe3bd935c906b87$var$isWorkerReady = true; // Set this flag to indicate assets are ready
    console.log("Assets preloaded and ready.");
}
$ebe3bd935c906b87$var$preLoadAssets();
///////////////////////////////////////////////
///////////////////////////////////////////////
// Camera and tracking functions
///////////////////////////////////////////////
// Check if webcam access is supported
function $ebe3bd935c906b87$var$hasGetUserMedia() {
    return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
}
// Function to list all available cameras
async function $ebe3bd935c906b87$var$getCameraDevices() {
    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter((device)=>device.kind === "videoinput");
        if (videoDevices.length === 0) {
            alert("No camera devices found.");
            return;
        }
        $ebe3bd935c906b87$var$cameraSelect.innerHTML = "";
        videoDevices.forEach((device, index)=>{
            const option = document.createElement("option");
            option.value = device.deviceId;
            option.text = device.label || `Camera ${index + 1}`;
            $ebe3bd935c906b87$var$cameraSelect.appendChild(option);
        });
    } catch (error) {
        console.error("Error fetching camera devices:", error);
        alert("Unable to access camera devices. Please check your browser settings.");
    }
}
// Enable or disable the webcam view and start detection based on checkbox
function $ebe3bd935c906b87$var$toggleTracking(event) {
    if (!$ebe3bd935c906b87$var$faceLandmarker) {
        console.log("Wait! faceLandmarker not loaded yet.");
        return;
    }
    if (event.target.checked) {
        $ebe3bd935c906b87$var$webcamRunning = true;
        $ebe3bd935c906b87$var$startCamera($ebe3bd935c906b87$var$cameraSelect.value);
        $ebe3bd935c906b87$var$video.style.display = "none"; // Ensure the webcam is hidden by default
        $ebe3bd935c906b87$var$showWebcamCheckbox.checked = false; // Reset the webcam visibility checkbox
    } else {
        $ebe3bd935c906b87$var$webcamRunning = false;
        $ebe3bd935c906b87$var$stopCamera(); // Stop the camera stream and clear video
    }
}
// Start camera with selected device
async function $ebe3bd935c906b87$var$startCamera(deviceId) {
    const constraints = {
        video: {
            deviceId: deviceId ? {
                exact: deviceId
            } : undefined,
            width: {
                ideal: 640
            },
            height: {
                ideal: 480
            }
        }
    };
    try {
        $ebe3bd935c906b87$var$currentStream = await navigator.mediaDevices.getUserMedia(constraints);
        $ebe3bd935c906b87$var$video.srcObject = $ebe3bd935c906b87$var$currentStream;
        $ebe3bd935c906b87$var$video.addEventListener("loadeddata", $ebe3bd935c906b87$var$predictWebcam);
    } catch (error) {
        console.error("Error accessing webcam:", error);
        alert("Camera access denied or unavailable. Please check your permissions and try again.");
    }
}
// Stop the camera and clear the video element
function $ebe3bd935c906b87$var$stopCamera() {
    if ($ebe3bd935c906b87$var$currentStream) {
        $ebe3bd935c906b87$var$currentStream.getTracks().forEach((track)=>track.stop());
        $ebe3bd935c906b87$var$currentStream = null;
    }
    $ebe3bd935c906b87$var$video.srcObject = null;
    $ebe3bd935c906b87$var$canvasCtx.clearRect(0, 0, $ebe3bd935c906b87$var$canvasElement.width, $ebe3bd935c906b87$var$canvasElement.height); // Clear the canvas
}
///////////////////////////////////////////////
///////////////////////////////////////////////
////////////////////////////////
////////////////////////////////
////////////////////////////////
// Prediction and drawing loop//
////////////////////////////////
////////////////////////////////
////////////////////////////////
let $ebe3bd935c906b87$var$lastVideoTime = -1;
let $ebe3bd935c906b87$var$results = undefined;
const $ebe3bd935c906b87$var$drawingUtils = new (0, $6Yrql.DrawingUtils)($ebe3bd935c906b87$var$canvasCtx);
// frame rate related
let $ebe3bd935c906b87$var$lastProcessedTime = 0;
const $ebe3bd935c906b87$var$frameInterval = 100; // e.g., process every 100ms (10 fps)
let $ebe3bd935c906b87$var$frameCounter = 0;
// // Frame Skipping to reduce load
// frameCounter++;
// if (frameCounter % 3 !== 0) {  // Process every 3rd frame
//     requestAnimationFrame(predictWebcam);
//     return;
// }
//Without throttling, predictWebcam runs on every single frame, which is very demanding. 
//If the webcam capture, landmark detection, worker processing, and drawing are all happening without any regulation, 
//it can overwhelm the CPU/GPU, leading to missed frames or timing issues where the worker doesn't receive/process data quickly enough.
async function $ebe3bd935c906b87$var$predictWebcam() {
    if (!$ebe3bd935c906b87$var$webcamRunning) return;
    // Frame throttling to reduce load
    const now = Date.now();
    if (now - $ebe3bd935c906b87$var$lastProcessedTime < $ebe3bd935c906b87$var$frameInterval) {
        requestAnimationFrame($ebe3bd935c906b87$var$predictWebcam);
        return;
    }
    $ebe3bd935c906b87$var$lastProcessedTime = now;
    // Resize the video and canvas elements based on the video feed's aspect ratio and zoom factor
    const ratio = $ebe3bd935c906b87$var$video.videoHeight / $ebe3bd935c906b87$var$video.videoWidth;
    $ebe3bd935c906b87$var$video.style.width = $ebe3bd935c906b87$var$videoWidth * $ebe3bd935c906b87$var$zoomFactor + "px";
    $ebe3bd935c906b87$var$video.style.height = $ebe3bd935c906b87$var$videoWidth * ratio * $ebe3bd935c906b87$var$zoomFactor + "px";
    $ebe3bd935c906b87$var$canvasElement.style.width = $ebe3bd935c906b87$var$videoWidth * $ebe3bd935c906b87$var$zoomFactor + "px";
    $ebe3bd935c906b87$var$canvasElement.style.height = $ebe3bd935c906b87$var$videoWidth * ratio * $ebe3bd935c906b87$var$zoomFactor + "px";
    $ebe3bd935c906b87$var$canvasElement.width = $ebe3bd935c906b87$var$video.videoWidth;
    $ebe3bd935c906b87$var$canvasElement.height = $ebe3bd935c906b87$var$video.videoHeight;
    if ($ebe3bd935c906b87$var$runningMode === "IMAGE") {
        $ebe3bd935c906b87$var$runningMode = "VIDEO";
        await $ebe3bd935c906b87$var$faceLandmarker.setOptions({
            runningMode: $ebe3bd935c906b87$var$runningMode,
            outputFaceBlendshapes: true
        });
    }
    let nowInMs = Date.now();
    if ($ebe3bd935c906b87$var$lastVideoTime !== $ebe3bd935c906b87$var$video.currentTime) {
        $ebe3bd935c906b87$var$lastVideoTime = $ebe3bd935c906b87$var$video.currentTime;
        $ebe3bd935c906b87$var$results = $ebe3bd935c906b87$var$faceLandmarker.detectForVideo($ebe3bd935c906b87$var$video, nowInMs); // Detect face landmarks on the current video frame
        await $ebe3bd935c906b87$var$pose.send({
            image: $ebe3bd935c906b87$var$video
        }); // Send the video frame for pose landmarks detection
    }
    // Clear canvas for fresh drawing
    $ebe3bd935c906b87$var$canvasCtx.clearRect(0, 0, $ebe3bd935c906b87$var$canvasElement.width, $ebe3bd935c906b87$var$canvasElement.height);
    // Send landmarks to worker for smoothing and further processing
    if ($ebe3bd935c906b87$var$results.faceLandmarks || $ebe3bd935c906b87$var$latestPoseResults?.poseLandmarks || $ebe3bd935c906b87$var$results.faceBlendshapes) $ebe3bd935c906b87$var$facePoseWorker.postMessage({
        type: "PROCESS_FRAME",
        results: {
            faceLandmarks: $ebe3bd935c906b87$var$results.faceLandmarks?.[0] || [],
            poseLandmarks: $ebe3bd935c906b87$var$latestPoseResults?.poseLandmarks || [],
            blendShapes: $ebe3bd935c906b87$var$results.faceBlendshapes[0] || []
        }
    });
    // Continue running prediction if the webcam is still running
    if ($ebe3bd935c906b87$var$webcamRunning) window.requestAnimationFrame($ebe3bd935c906b87$var$predictWebcam);
}
let $ebe3bd935c906b87$var$updateQueue = []; // Queue for managing drawing updates
let $ebe3bd935c906b87$var$headOrientation = {
    pitch: 0,
    roll: 0,
    yaw: 0
};
// Handle worker messages to draw refined results on the canvas
$ebe3bd935c906b87$var$facePoseWorker.onmessage = (event)=>{
    if (event.data.type === "PROCESSED_RESULTS") {
        const { faceLandmarks: faceLandmarks, poseLandmarks: poseLandmarks, blendShapes: blendShapes } = event.data.data;
        // Handle missing or empty data gracefully
        if ((!faceLandmarks || faceLandmarks.length === 0) && (!poseLandmarks || poseLandmarks.length === 0)) {
            console.warn("No valid face or pose landmarks received, skipping draw.");
            return;
        }
        // Add the received data to the update queue
        $ebe3bd935c906b87$var$updateQueue.push({
            faceLandmarks: faceLandmarks,
            poseLandmarks: poseLandmarks,
            blendShapes: blendShapes
        });
        for (const landmarks of $ebe3bd935c906b87$var$results.faceLandmarks){
            // just for calibration purposes
            // const roll = calculateRoll(landmarks);
            // updateRollSlider(roll);
            $ebe3bd935c906b87$var$headOrientation = $ebe3bd935c906b87$export$39a67bddc6eb29e6(landmarks);
            $ebe3bd935c906b87$var$updateHeadMotionSliders($ebe3bd935c906b87$var$headOrientation.pitch, $ebe3bd935c906b87$var$headOrientation.roll, $ebe3bd935c906b87$var$headOrientation.yaw);
        }
    //     if (enableDrawingCheckbox.checked) {
    //         drawPlus(fixedPlusPosition.x, fixedPlusPosition.y, 'pink'); //TODO: adjust it according to the expected sitting positinon
    //         drawFace(faceLandmarks);
    //         updateRollSlider(roll);
    //         updateFaceLandmarks(faceLandmarks);
    //         // Calculate the position of the dynamic plus symbol based on nose tip (landmark 1) for calibration
    //         const noseTip = faceLandmarks[1]; 
    //         if (noseTip) {
    //             dynamicPlusPosition.x = noseTip.x * canvasElement.width;
    //             dynamicPlusPosition.y = noseTip.y * canvasElement.height;
    //             drawPlus(dynamicPlusPosition.x, dynamicPlusPosition.y, 'red'); 
    //         }
    //     }
    //     // Draw pose landmarks if available
    //     if (!poseLandmarks || poseLandmarks.length === 0) {
    //         console.warn("No valid pose landmarks received, skipping draw.");
    //     } else if (enableDrawingCheckbox.checked) {
    //         drawPoseLandmarks(poseLandmarks);
    //     }
    //     if (blendShapes && Object.keys(blendShapes).length > 0) {
    //         calibrateEyeGaze(blendShapes);
    //         // updateBlendShapeDisplay(blendShapes);
    //     } else {
    //         console.warn("No valid blend shapes received, skipping update.");
    //     }
    //     // Check for poor lighting conditions in real-time
    //     if (detectRealTimePoorLighting(faceLandmarks, jitterThreshold = 0.005)) { //0.001 dene
    //         showLightingWarning();
    //         console.warn("Poor lighting detected. Adjust lighting conditions for better tracking.");
    //     }
    //     // Record face landmarks and other data (pose landmarks and blendshapes)
    //     captureAndProcessData(
    //         faceLandmarks || [],
    //         poseLandmarks || [],
    //         blendShapes || [], 
    //         roll
    //     );
    //     if (verbose) {
    //         console.log('Face: ', faceLandmarks);
    //         console.log('Pose: ', poseLandmarks);
    //         console.log('Blendshapes: ', blendShapes);
    //     }
    //     // Check alignment and roll conditions for calibration
    //     const rollValue = parseFloat(document.getElementById('rollSlider').value);
    //     const shouldersAligned = areShouldersAligned(poseLandmarks);
    //     if (isAligned() && rollValue >= -0.2 && rollValue <= 0.2 && shouldersAligned) {
    //         displayCalibrationPrompt();
    //         console.log("Hit the Calibrate button");
    //         // TODO: Adapt the calibration approach to the new 'refined' landmarks
    //     }
    }
};
// Drawing function to handle rendering from the queue
function $ebe3bd935c906b87$var$drawFromQueue() {
    if ($ebe3bd935c906b87$var$updateQueue.length > 0) {
        let verbose = false;
        // Use the latest data from the queue
        const { faceLandmarks: faceLandmarks, poseLandmarks: poseLandmarks, blendShapes: blendShapes } = $ebe3bd935c906b87$var$updateQueue.shift();
        if (verbose) {
            console.log("Face: ", faceLandmarks);
            console.log("Pose: ", poseLandmarks);
            console.log("Blendshapes: ", blendShapes);
        }
        // Clear canvas for fresh drawing
        $ebe3bd935c906b87$var$canvasCtx.clearRect(0, 0, $ebe3bd935c906b87$var$canvasElement.width, $ebe3bd935c906b87$var$canvasElement.height);
        if ($ebe3bd935c906b87$var$enableDrawingCheckbox.checked) {
            // Draw fixed reference point
            $ebe3bd935c906b87$var$drawPlus($ebe3bd935c906b87$var$fixedPlusPosition.x, $ebe3bd935c906b87$var$fixedPlusPosition.y, "pink"); // TODO: adjust according to expected sitting position
            // Draw face landmarks if available
            if (faceLandmarks && faceLandmarks.length > 0) {
                $ebe3bd935c906b87$var$updateFaceLandmarks(faceLandmarks);
                $ebe3bd935c906b87$var$drawFace(faceLandmarks);
                // const noseTip = faceLandmarks[1]; //simdi artik part ismine gore buluyoruz
                const noseTip = faceLandmarks.find((landmark)=>landmark.part === "nose_1");
                if (noseTip) {
                    $ebe3bd935c906b87$var$dynamicPlusPosition.x = noseTip.x * $ebe3bd935c906b87$var$canvasElement.width;
                    $ebe3bd935c906b87$var$dynamicPlusPosition.y = noseTip.y * $ebe3bd935c906b87$var$canvasElement.height;
                    $ebe3bd935c906b87$var$drawPlus($ebe3bd935c906b87$var$dynamicPlusPosition.x, $ebe3bd935c906b87$var$dynamicPlusPosition.y, "red");
                }
            }
            // Draw pose landmarks if available
            if (poseLandmarks && poseLandmarks.length > 0) $ebe3bd935c906b87$var$drawPoseLandmarks(poseLandmarks);
            // Handle blend shapes if available
            if (blendShapes && Object.keys(blendShapes).length > 0) $ebe3bd935c906b87$var$calibrateEyeGaze(blendShapes);
        }
        // Check for poor lighting conditions in real-time
        if (faceLandmarks && $ebe3bd935c906b87$var$detectRealTimePoorLighting(faceLandmarks)) {
            $ebe3bd935c906b87$var$showLightingWarning();
            console.warn("Poor lighting detected. Adjust lighting conditions for better tracking.");
        }
        // Record face landmarks and other data (pose landmarks and blendshapes)
        if (faceLandmarks || poseLandmarks || blendShapes) // console.log("Recording data: ", faceLandmarks, poseLandmarks, blendShapes);
        (0, $09f012c82826b8a2$export$e4938b640f150633)(faceLandmarks || [], poseLandmarks || [], blendShapes || [], $ebe3bd935c906b87$var$headOrientation || []);
        // Check alignment and roll conditions for calibration
        const rollValue = parseFloat(document.getElementById("rollSlider").value);
        const shouldersAligned = $ebe3bd935c906b87$var$areShouldersAligned(poseLandmarks);
        if ($ebe3bd935c906b87$var$isAligned() && rollValue >= -0.2 && rollValue <= 0.2 && shouldersAligned) {
            if ($ebe3bd935c906b87$var$enableDrawingCheckbox.checked && !$ebe3bd935c906b87$var$isCalibrated) {
                $ebe3bd935c906b87$var$displayCalibrationPrompt();
                console.log("Hit the Calibrate button");
            }
        }
    }
    // Request the next frame for drawing
    window.requestAnimationFrame($ebe3bd935c906b87$var$drawFromQueue);
}
// Start the drawing loop
window.requestAnimationFrame($ebe3bd935c906b87$var$drawFromQueue);
///////////////////////////////////////////////
///////////////////////////////////////////////
$ebe3bd935c906b87$var$zoomSlider.addEventListener("input", (event)=>{
    $ebe3bd935c906b87$var$zoomFactor = event.target.value;
});
///////////////////////////////////////////////
///////////////////////////////////////////////
/////////////////////
// DRAWing helpers //
/////////////////////
// Pose display elements
const $ebe3bd935c906b87$var$noseTipDisplay = document.getElementById("noseTip");
const $ebe3bd935c906b87$var$leftShoulderDisplay = document.getElementById("leftShoulder");
const $ebe3bd935c906b87$var$rightShoulderDisplay = document.getElementById("rightShoulder");
const $ebe3bd935c906b87$var$leftElbowDisplay = document.getElementById("leftElbow");
const $ebe3bd935c906b87$var$rightElbowDisplay = document.getElementById("rightElbow");
const $ebe3bd935c906b87$var$leftHandDisplay = document.getElementById("leftHand");
const $ebe3bd935c906b87$var$rightHandDisplay = document.getElementById("rightHand");
// Function to draw selected face landmarks on the canvas
function $ebe3bd935c906b87$var$drawFace(selectedLandmarks) {
    if (!selectedLandmarks || selectedLandmarks.length === 0) return;
    // Draw facial landmarks as points (hot pink with black stroke)
    $ebe3bd935c906b87$var$canvasCtx.fillStyle = "rgba(255, 105, 180, 0.9)"; // Hot pink with high opacity
    $ebe3bd935c906b87$var$canvasCtx.lineWidth = 1.5;
    $ebe3bd935c906b87$var$canvasCtx.strokeStyle = "rgba(0, 0, 0, 0.6)"; // Black stroke for better contrast
    selectedLandmarks.forEach((point)=>{
        if (point && !isNaN(point.x) && !isNaN(point.y)) {
            const x = point.x * $ebe3bd935c906b87$var$canvasElement.width;
            const y = point.y * $ebe3bd935c906b87$var$canvasElement.height;
            // Draw a filled circle with a stroke
            $ebe3bd935c906b87$var$canvasCtx.beginPath();
            $ebe3bd935c906b87$var$canvasCtx.arc(x, y, 3, 0, 2 * Math.PI);
            $ebe3bd935c906b87$var$canvasCtx.fill();
            $ebe3bd935c906b87$var$canvasCtx.stroke();
        }
    });
    // Draw face oval connections using quadratic curves
    const faceOvalLabels = [
        "face_oval_1",
        "face_oval_2",
        "face_oval_3",
        "face_oval_4",
        "face_oval_5",
        "face_oval_6",
        "face_oval_7",
        "face_oval_8",
        "face_oval_9",
        "face_oval_10",
        "face_oval_11"
    ];
    const faceOvalPoints = faceOvalLabels.map((label)=>selectedLandmarks.find((landmark)=>landmark.part === label));
    $ebe3bd935c906b87$var$drawFeatureConnections(faceOvalPoints, "rgba(255, 20, 147, 0.6)"); // Deep pink for the connections
    // Draw left eye connections using quadratic curves
    const leftEyeLabels = [
        "left_iris_1",
        "left_iris_2",
        "left_iris_3",
        "left_iris_4"
    ];
    const leftEyePoints = leftEyeLabels.map((label)=>selectedLandmarks.find((landmark)=>landmark.part === label));
    $ebe3bd935c906b87$var$drawFeatureConnections(leftEyePoints, "rgba(0, 255, 0, 0.8)"); // Green for the left eye
    // Draw right eye connections using quadratic curves
    const rightEyeLabels = [
        "right_iris_1",
        "right_iris_2",
        "right_iris_3",
        "right_iris_4"
    ];
    const rightEyePoints = rightEyeLabels.map((label)=>selectedLandmarks.find((landmark)=>landmark.part === label));
    $ebe3bd935c906b87$var$drawFeatureConnections(rightEyePoints, "rgba(0, 0, 255, 0.8)"); // Blue for the right eye
//TODO: Add more later
// // Draw nose connections using quadratic curves
// const noseLabels = ['nose_1', 'nose_2', 'nose_3', 'nose_4', 'nose_5', 'nose_6'];
// const nosePoints = noseLabels.map(label => selectedLandmarks.find(landmark => landmark.part === label));
// drawFeatureConnections(nosePoints, 'rgba(255, 255, 0, 0.8)'); // Yellow for the nose
// // Draw mouth connections using quadratic curves
// const mouthLabels = ['lip_bottom_1', 'lip_bottom_2', 'lip_bottom_3', 'lip_bottom_4', 'lip_bottom_5', 'lip_bottom_6', 'lip_bottom_7', 'lip_bottom_8', 'lip_bottom_9'];
// const mouthPoints = mouthLabels.map(label => selectedLandmarks.find(landmark => landmark.part === label));
// drawFeatureConnections(mouthPoints, 'rgba(255, 69, 0, 0.8)'); // Orange for the mouth
}
function $ebe3bd935c906b87$var$drawFeatureConnections(landmarks, color) {
    if (!landmarks || landmarks.length < 2) return; // Need at least two points to draw connections
    // Set line style for drawing the feature connections
    $ebe3bd935c906b87$var$canvasCtx.strokeStyle = color; // Color for the feature connections
    $ebe3bd935c906b87$var$canvasCtx.lineWidth = 2;
    // Begin drawing the feature connections
    $ebe3bd935c906b87$var$canvasCtx.beginPath();
    // Start from the first point
    const firstPoint = landmarks[0];
    if (firstPoint && !isNaN(firstPoint.x) && !isNaN(firstPoint.y)) $ebe3bd935c906b87$var$canvasCtx.moveTo(firstPoint.x * $ebe3bd935c906b87$var$canvasElement.width, firstPoint.y * $ebe3bd935c906b87$var$canvasElement.height);
    // Draw quadratic curves between each point for smoother transitions
    for(let i = 0; i < landmarks.length - 1; i++){
        const currentPoint = landmarks[i];
        const nextPoint = landmarks[i + 1];
        if (currentPoint && nextPoint && !isNaN(currentPoint.x) && !isNaN(currentPoint.y) && !isNaN(nextPoint.x) && !isNaN(nextPoint.y)) {
            // Calculate a control point for the curve - midpoint between current and next points
            const controlPointX = (currentPoint.x + nextPoint.x) / 2;
            const controlPointY = (currentPoint.y + nextPoint.y) / 2;
            $ebe3bd935c906b87$var$canvasCtx.quadraticCurveTo(currentPoint.x * $ebe3bd935c906b87$var$canvasElement.width, currentPoint.y * $ebe3bd935c906b87$var$canvasElement.height, controlPointX * $ebe3bd935c906b87$var$canvasElement.width, controlPointY * $ebe3bd935c906b87$var$canvasElement.height);
        }
    }
    // Close the path to complete the feature shape with a smooth curve
    const lastPoint = landmarks[landmarks.length - 1];
    if (lastPoint && !isNaN(lastPoint.x) && !isNaN(lastPoint.y) && firstPoint && !isNaN(firstPoint.x) && !isNaN(firstPoint.y)) {
        // Calculate a control point between the last and first points
        const controlPointX = (lastPoint.x + firstPoint.x) / 2;
        const controlPointY = (lastPoint.y + firstPoint.y) / 2;
        // Draw a curve from the last point to the first point to close the loop
        $ebe3bd935c906b87$var$canvasCtx.quadraticCurveTo(lastPoint.x * $ebe3bd935c906b87$var$canvasElement.width, lastPoint.y * $ebe3bd935c906b87$var$canvasElement.height, controlPointX * $ebe3bd935c906b87$var$canvasElement.width, controlPointY * $ebe3bd935c906b87$var$canvasElement.height);
        // Move to the first point to properly close the path
        $ebe3bd935c906b87$var$canvasCtx.lineTo(firstPoint.x * $ebe3bd935c906b87$var$canvasElement.width, firstPoint.y * $ebe3bd935c906b87$var$canvasElement.height);
    }
    // Draw the completed feature connections
    $ebe3bd935c906b87$var$canvasCtx.stroke();
}
// Draw pose landmarks on the canvas
let $ebe3bd935c906b87$var$filterPoseLandmarks = false;
// Draw pose landmarks on the canvas
function $ebe3bd935c906b87$var$drawPoseLandmarks(poseLandmarks, toFilter = false) {
    if (!poseLandmarks || poseLandmarks.length === 0) return;
    let procLandmarks = [];
    if (toFilter) {
        // Filter landmarks to exclude 0-10 and 17-22
        for(let index = 0; index < poseLandmarks.length; index++)if (index >= 11 && index <= 24 && ![
            17,
            18,
            19,
            20,
            21,
            22
        ].includes(index)) procLandmarks.push(poseLandmarks[index]);
        // Draw each visible landmark as a small circle
        procLandmarks.forEach((landmark)=>{
            $ebe3bd935c906b87$var$canvasCtx.fillStyle = "rgba(0, 255, 127, 0.8)"; // Spring green with slight transparency
            $ebe3bd935c906b87$var$canvasCtx.lineWidth = 1.5;
            $ebe3bd935c906b87$var$canvasCtx.strokeStyle = "rgba(0, 0, 0, 0.6)"; // Black stroke for contrast
            $ebe3bd935c906b87$var$canvasCtx.beginPath();
            $ebe3bd935c906b87$var$canvasCtx.arc(landmark.x * $ebe3bd935c906b87$var$canvasElement.width, landmark.y * $ebe3bd935c906b87$var$canvasElement.height, 4, 0, 2 * Math.PI);
            $ebe3bd935c906b87$var$canvasCtx.fill();
            $ebe3bd935c906b87$var$canvasCtx.stroke();
        });
        // Draw pose connections for filtered landmarks
        $ebe3bd935c906b87$var$drawPoseConnections(procLandmarks, toFilter, true);
    } else {
        // Draw specified landmarks: 11, 12, 13, 14, 15, 16 (given in order starting at index 0)
        procLandmarks = poseLandmarks;
        // Draw each visible landmark as a small circle
        procLandmarks.forEach((landmark)=>{
            $ebe3bd935c906b87$var$canvasCtx.fillStyle = "rgba(0, 255, 127, 0.8)"; // Spring green with slight transparency
            $ebe3bd935c906b87$var$canvasCtx.lineWidth = 1.5;
            $ebe3bd935c906b87$var$canvasCtx.strokeStyle = "rgba(0, 0, 0, 0.6)"; // Black stroke for contrast
            $ebe3bd935c906b87$var$canvasCtx.beginPath();
            $ebe3bd935c906b87$var$canvasCtx.arc(landmark.x * $ebe3bd935c906b87$var$canvasElement.width, landmark.y * $ebe3bd935c906b87$var$canvasElement.height, 4, 0, 2 * Math.PI);
            $ebe3bd935c906b87$var$canvasCtx.fill();
            $ebe3bd935c906b87$var$canvasCtx.stroke();
        });
        // Draw pose connections for specified landmarks
        $ebe3bd935c906b87$var$drawPoseConnections(procLandmarks, toFilter, false);
    }
}
// Update the drawPoseConnections function to only draw connections for the visible landmarks
function $ebe3bd935c906b87$var$drawPoseConnections(landmarks, toFilter = false, neck = false) {
    if (!landmarks || landmarks.length === 0) return;
    let connections = [];
    if (toFilter) // Connections specific to the filtered landmarks (11 to 24 excluding 17-22)
    connections = [
        [
            11,
            12
        ],
        [
            11,
            23
        ],
        [
            12,
            24
        ],
        [
            23,
            24
        ],
        [
            11,
            13
        ],
        [
            13,
            15
        ],
        [
            12,
            14
        ],
        [
            14,
            16
        ],
        [
            23,
            25
        ],
        [
            25,
            27
        ],
        [
            24,
            26
        ],
        [
            26,
            28
        ] // Right leg
    ];
    else // Connections for the specified landmarks: 11, 12, 13, 14, 15, 16
    connections = [
        [
            0,
            1
        ],
        [
            0,
            2
        ],
        [
            2,
            4
        ],
        [
            1,
            3
        ],
        [
            3,
            5
        ] // Right arm
    ];
    $ebe3bd935c906b87$var$canvasCtx.lineWidth = 2.5;
    $ebe3bd935c906b87$var$canvasCtx.strokeStyle = "rgba(30, 144, 255, 0.7)"; // Dodger blue with slight transparency
    // Draw each connection
    connections.forEach(([start, end])=>{
        if (landmarks[start] && landmarks[end]) {
            $ebe3bd935c906b87$var$canvasCtx.beginPath();
            $ebe3bd935c906b87$var$canvasCtx.moveTo(landmarks[start].x * $ebe3bd935c906b87$var$canvasElement.width, landmarks[start].y * $ebe3bd935c906b87$var$canvasElement.height);
            $ebe3bd935c906b87$var$canvasCtx.lineTo(landmarks[end].x * $ebe3bd935c906b87$var$canvasElement.width, landmarks[end].y * $ebe3bd935c906b87$var$canvasElement.height);
            $ebe3bd935c906b87$var$canvasCtx.stroke();
        }
    });
    if (neck) {
        // Draw neck connection if needed
        const neckPoint = {
            x: (landmarks[0].x + landmarks[1].x) / 2,
            y: (landmarks[0].y + landmarks[1].y) / 2 - 0.11 // Decreased offset moves neck up
        };
        const spineBase = {
            x: (landmarks[0].x + landmarks[1].x) / 2,
            y: (landmarks[0].y + landmarks[1].y) / 2
        };
        $ebe3bd935c906b87$var$canvasCtx.strokeStyle = "#FF00FF"; // Color for the neck/spine line
        $ebe3bd935c906b87$var$canvasCtx.beginPath();
        $ebe3bd935c906b87$var$canvasCtx.moveTo(neckPoint.x * $ebe3bd935c906b87$var$canvasElement.width, neckPoint.y * $ebe3bd935c906b87$var$canvasElement.height);
        $ebe3bd935c906b87$var$canvasCtx.lineTo(spineBase.x * $ebe3bd935c906b87$var$canvasElement.width, spineBase.y * $ebe3bd935c906b87$var$canvasElement.height);
        $ebe3bd935c906b87$var$canvasCtx.stroke();
    }
}
// Function to calculate distance between two points
function $ebe3bd935c906b87$var$calculateDistance(point1, point2) {
    const dx = point1.x - point2.x;
    const dy = point1.y - point2.y;
    return Math.sqrt(dx * dx + dy * dy);
}
// Function to handle pose results
function $ebe3bd935c906b87$var$onPoseResults(results) {
    $ebe3bd935c906b87$var$latestPoseResults = results;
}
// Function to draw the point on the canvas
function $ebe3bd935c906b87$var$drawPoint(x, y) {
    // Ensure the canvas and context are valid
    if (!ctx) {
        console.error("Canvas context not initialized");
        return;
    }
    // Debug: Check the mapped coordinates
    console.log(`Drawing point at X: ${x}, Y: ${y}`);
    // Clear the canvas for the new frame
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    // Draw the point on the canvas
    ctx.beginPath();
    ctx.arc(x, y, 10, 0, 2 * Math.PI); // Draw a circle with radius 10 at (x, y)
    ctx.fillStyle = "red"; // Set fill color
    ctx.fill(); // Fill the circle
}
// Function to draw a plus symbol at a given position
function $ebe3bd935c906b87$var$drawPlus(x, y, color) {
    const size = 10; // Size of the plus symbol
    $ebe3bd935c906b87$var$canvasCtx.strokeStyle = color;
    $ebe3bd935c906b87$var$canvasCtx.lineWidth = 2;
    // Draw horizontal line
    $ebe3bd935c906b87$var$canvasCtx.beginPath();
    $ebe3bd935c906b87$var$canvasCtx.moveTo(x - size, y);
    $ebe3bd935c906b87$var$canvasCtx.lineTo(x + size, y);
    $ebe3bd935c906b87$var$canvasCtx.stroke();
    // Draw vertical line
    $ebe3bd935c906b87$var$canvasCtx.beginPath();
    $ebe3bd935c906b87$var$canvasCtx.moveTo(x, y - size);
    $ebe3bd935c906b87$var$canvasCtx.lineTo(x, y + size);
    $ebe3bd935c906b87$var$canvasCtx.stroke();
}
////////////////////////////
//////////////////////////// Draggable canvas
////////////////////////////
document.addEventListener("DOMContentLoaded", ()=>{
    const draggableContainer = document.getElementById("draggableContainer");
    const dragHandle = document.getElementById("dragHandle");
    let isDragging = false;
    let offsetX, offsetY;
    // Start dragging when the handle is clicked
    dragHandle.addEventListener("mousedown", (e)=>{
        isDragging = true;
        offsetX = e.clientX - draggableContainer.getBoundingClientRect().left;
        offsetY = e.clientY - draggableContainer.getBoundingClientRect().top;
        dragHandle.style.cursor = "grabbing";
    });
    // Drag the container on mouse move
    document.addEventListener("mousemove", (e)=>{
        if (!isDragging) return;
        const x = e.clientX - offsetX;
        const y = e.clientY - offsetY;
        // Update the container's position
        draggableContainer.style.left = `${x}px`;
        draggableContainer.style.top = `${y}px`;
    });
    // Stop dragging on mouse up
    document.addEventListener("mouseup", ()=>{
        if (isDragging) {
            isDragging = false;
            dragHandle.style.cursor = "grab";
        }
    });
});
////////////////////
///Calibration and data recording Helpers/////
//////////////////
// Function to update face landmarks relative to the calibrated position
function $ebe3bd935c906b87$var$updateFaceLandmarks(faceLandmarks, verbose = false) {
    if (!$ebe3bd935c906b87$var$calibrationData.faceLandmarks) return;
    // Calculate differences from calibrated landmarks
    const differences = faceLandmarks.map((landmark, index)=>({
            x: landmark.x - $ebe3bd935c906b87$var$calibrationData.faceLandmarks[index].x,
            y: landmark.y - $ebe3bd935c906b87$var$calibrationData.faceLandmarks[index].y,
            z: landmark.z - $ebe3bd935c906b87$var$calibrationData.faceLandmarks[index].z
        }));
    if (verbose) console.log("Face landmarks differences:", differences);
}
// Function to update pose metrics relative to the calibrated position
function $ebe3bd935c906b87$var$updatePoseMetrics(results) {
    const landmarks = results.poseLandmarks;
    // Calculate distances or angles for each landmark group relative to the calibrated position
    const calibratedLandmarks = $ebe3bd935c906b87$var$calibrationData.poseLandmarks;
    const leftShoulder = $ebe3bd935c906b87$var$calculateDistance(landmarks[11], calibratedLandmarks ? calibratedLandmarks[11] : landmarks[11]);
    const rightShoulder = $ebe3bd935c906b87$var$calculateDistance(landmarks[12], calibratedLandmarks ? calibratedLandmarks[12] : landmarks[12]);
    const leftElbow = $ebe3bd935c906b87$var$calculateDistance(landmarks[13], calibratedLandmarks ? calibratedLandmarks[13] : landmarks[13]);
    const rightElbow = $ebe3bd935c906b87$var$calculateDistance(landmarks[14], calibratedLandmarks ? calibratedLandmarks[14] : landmarks[14]);
    const leftHand = $ebe3bd935c906b87$var$calculateDistance(landmarks[15], calibratedLandmarks ? calibratedLandmarks[15] : landmarks[15]);
    const rightHand = $ebe3bd935c906b87$var$calculateDistance(landmarks[16], calibratedLandmarks ? calibratedLandmarks[16] : landmarks[16]);
    // Update display elements
    if ($ebe3bd935c906b87$var$leftShoulderDisplay) $ebe3bd935c906b87$var$leftShoulderDisplay.textContent = `Left Shoulder: ${leftShoulder.toFixed(4)}`;
    if ($ebe3bd935c906b87$var$rightShoulderDisplay) $ebe3bd935c906b87$var$rightShoulderDisplay.textContent = `Right Shoulder: ${rightShoulder.toFixed(4)}`;
    if ($ebe3bd935c906b87$var$leftElbowDisplay) $ebe3bd935c906b87$var$leftElbowDisplay.textContent = `Left Elbow: ${leftElbow.toFixed(4)}`;
    if ($ebe3bd935c906b87$var$rightElbowDisplay) $ebe3bd935c906b87$var$rightElbowDisplay.textContent = `Right Elbow: ${rightElbow.toFixed(4)}`;
    if ($ebe3bd935c906b87$var$leftHandDisplay) $ebe3bd935c906b87$var$leftHandDisplay.textContent = `Left Hand: ${leftHand.toFixed(4)}`;
    if ($ebe3bd935c906b87$var$rightHandDisplay) $ebe3bd935c906b87$var$rightHandDisplay.textContent = `Right Hand: ${rightHand.toFixed(4)}`;
}
function $ebe3bd935c906b87$var$showLightingWarning() {
    const warningOverlay = document.getElementById("lightingWarning");
    warningOverlay.classList.add("show");
    // Auto-hide after 5 seconds
    setTimeout(()=>{
        warningOverlay.classList.remove("show");
    }, 5000);
}
// Function to check if the plus symbols are aligned
function $ebe3bd935c906b87$var$isAligned() {
    const alignmentThreshold = 15; // Pixel threshold to consider symbols as aligned
    const deltaX = Math.abs($ebe3bd935c906b87$var$fixedPlusPosition.x - $ebe3bd935c906b87$var$dynamicPlusPosition.x);
    const deltaY = Math.abs($ebe3bd935c906b87$var$fixedPlusPosition.y - $ebe3bd935c906b87$var$dynamicPlusPosition.y);
    return deltaX <= alignmentThreshold && deltaY <= alignmentThreshold;
}
// Function to check if the shoulders are aligned
function $ebe3bd935c906b87$var$areShouldersAligned(poseLandmarks, isReduced = true) {
    if (poseLandmarks && poseLandmarks.length > 0) {
        const leftShoulder = poseLandmarks[11] ? poseLandmarks[11] : (isReduced = true, poseLandmarks[0]);
        const rightShoulder = poseLandmarks[12] ? poseLandmarks[12] : (isReduced = true, poseLandmarks[1]);
        // console.log('Left shoulder:', leftShoulder);
        const yDifference = Math.abs(leftShoulder.y - rightShoulder.y);
        // console.log('Shoulder Y-axis difference:', yDifference);
        const alignmentThreshold = 0.05; // Y-axis threshold for shoulder alignment
        // Check if the shoulders are within the acceptable Y-axis range
        return yDifference <= alignmentThreshold;
    }
    return false; // Shoulders are not aligned if landmarks are unavailable
}
// Function to display a prompt on the canvas
function $ebe3bd935c906b87$var$displayCalibrationPrompt() {
    // TODO: Work on the style and positioning of the text
    $ebe3bd935c906b87$var$canvasCtx.font = "20px Arial";
    $ebe3bd935c906b87$var$canvasCtx.fillStyle = "green";
    $ebe3bd935c906b87$var$canvasCtx.textAlign = "center";
    $ebe3bd935c906b87$var$canvasCtx.fillText("Hit the Calibrate button", $ebe3bd935c906b87$var$canvasElement.width / 2, $ebe3bd935c906b87$var$canvasElement.height / 2 + 50);
}
// Function to update eye gaze relative to the calibrated gaze center
function $ebe3bd935c906b87$var$calibrateEyeGaze(blendShapes, verbose = false) {
    if (!$ebe3bd935c906b87$var$calibrationData.gazeCenter) return;
    const leftLookOutDiff = (0, $cc90258846af473c$export$a0afd5ca523cf1d1)(blendShapes, "eyeLookOutLeft") - $ebe3bd935c906b87$var$calibrationData.gazeCenter.leftLookOut;
    const rightLookOutDiff = (0, $cc90258846af473c$export$a0afd5ca523cf1d1)(blendShapes, "eyeLookOutRight") - $ebe3bd935c906b87$var$calibrationData.gazeCenter.rightLookOut;
    const leftLookInDiff = (0, $cc90258846af473c$export$a0afd5ca523cf1d1)(blendShapes, "eyeLookInLeft") - $ebe3bd935c906b87$var$calibrationData.gazeCenter.leftLookIn;
    const rightLookInDiff = (0, $cc90258846af473c$export$a0afd5ca523cf1d1)(blendShapes, "eyeLookInRight") - $ebe3bd935c906b87$var$calibrationData.gazeCenter.rightLookIn;
    if (verbose) console.log("Eye gaze differences:", {
        leftLookOutDiff: leftLookOutDiff,
        rightLookOutDiff: rightLookOutDiff,
        leftLookInDiff: leftLookInDiff,
        rightLookInDiff: rightLookInDiff
    });
}
// // Function to calculate the roll based on the left and right eye positions
// function calculateRoll(faceLandmarks) {
//     const leftEye = faceLandmarks[33];  // Left eye outer corner
//     const rightEye = faceLandmarks[263];  // Right eye outer corner
//     // console.log('Left eye:', leftEye, 'Right eye:', rightEye);
//     // Calculate the roll as the difference in the vertical positions of the eyes
//     const roll = Math.atan2(rightEye.y - leftEye.y, rightEye.x - leftEye.x) * (180 / Math.PI);
//     let rollInvert = 1 - roll; // Invert the roll for the slider
//     let mappedRoll = mapRange(rollInvert, -0.4, 0.4, -1, 1); //TODO: check the range and whether it's needed
//     return mappedRoll;
// }
// // Function to normalize roll and update the slider
// function updateRollSlider(roll) {
//     const rollSlider = document.getElementById('rollSlider');
//     // Assuming roll ranges from -90 to 90 degrees (left tilt to right tilt)
//     const normalizedRoll = normalizeAngle(roll, -90, 90);
//     // Set the slider value to the normalized roll
//     rollSlider.value = normalizedRoll;
// }
// Helper function to normalize angles to the slider range (-1 to 1)
function $ebe3bd935c906b87$var$normalizeAngle(angle, minAngle, maxAngle) {
    return (angle - minAngle) / (maxAngle - minAngle) * 2 - 1;
}
function $ebe3bd935c906b87$var$mapRange(value, inMin, inMax, outMin, outMax) {
    return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
function $ebe3bd935c906b87$export$39a67bddc6eb29e6(faceLandmarks) {
    // Check if the face landmarks are valid and non-empty
    if (!Array.isArray(faceLandmarks) || faceLandmarks.length === 0) {
        console.warn("Insufficient face landmarks for head orientation calculation.");
        return {
            pitch: 0,
            roll: 0,
            yaw: 0
        };
    }
    // Extract key landmarks for calculations
    const leftEye = faceLandmarks[33];
    const rightEye = faceLandmarks[263];
    const noseTip = faceLandmarks[1]; // e.g., a central point on the nose
    const foreheadCenter = faceLandmarks[151];
    // Check if key landmarks are valid
    if (!leftEye || !rightEye || !noseTip || !foreheadCenter) {
        console.warn("Missing required landmarks for head orientation calculation.");
        return {
            pitch: 0,
            roll: 0,
            yaw: 0
        };
    }
    // Validate x, y, z values for each key landmark
    if ([
        leftEye,
        rightEye,
        noseTip,
        foreheadCenter
    ].some((landmark)=>isNaN(landmark.x) || isNaN(landmark.y) || isNaN(landmark.z))) {
        console.warn("Invalid landmark coordinates detected.");
        return {
            pitch: 0,
            roll: 0,
            yaw: 0
        };
    }
    // Calculate roll (rotation around the Z-axis)
    const roll = Math.atan2(rightEye.y - leftEye.y, rightEye.x - leftEye.x) * (180 / Math.PI);
    let rollInvert = 1 - roll; // Invert the roll for the slider
    // Calculate pitch (rotation around the X-axis)
    const pitch = Math.atan2(foreheadCenter.y - noseTip.y, foreheadCenter.z - noseTip.z) * (180 / Math.PI);
    let pitchInvert = 1 - pitch; // Invert the pitch for the slider
    // Calculate yaw (rotation around the Y-axis)
    const yaw = Math.atan2(rightEye.x - leftEye.x, noseTip.z - foreheadCenter.z) * (180 / Math.PI);
    let yawInvert = 1 - yaw; // Invert the yaw for the slider
    // console.log('Head Orientation -> Pitch:', pitch, 'Roll:', roll, 'Yaw:', yaw);
    return {
        pitch: pitch.toFixed(5),
        roll: roll.toFixed(5),
        yaw: yaw.toFixed(5)
    };
}
function $ebe3bd935c906b87$var$updateHeadMotionSliders(pitch, roll, yaw) {
    // Map the values to the sliders, scaling to the range of -1 to 1
    const mappedRoll = $ebe3bd935c906b87$var$mapRange(roll, -90, 90, -1, 1); // Assuming head tilt ranges from -45 to 45 degrees
    const mappedPitch = $ebe3bd935c906b87$var$mapRange(pitch, -90, 90, -1, 1); // Assuming nodding ranges from -45 to 45 degrees
    const mappedYaw = $ebe3bd935c906b87$var$mapRange(yaw, -90, 90, -1, 1); // Assuming head turning ranges from -45 to 45 degrees
    // Output the calculated orientation
    // console.log(`Mapped Head Orientation -> Pitch: ${mappedPitch}, Roll: ${mappedRoll}, Yaw: ${mappedYaw}`);
    const rollSlider = document.getElementById("rollSlider");
    const pitchSlider = document.getElementById("pitchSlider");
    // const yawSlider = document.getElementById('yawSlider');
    rollSlider.value = mappedRoll;
    pitchSlider.value = mappedPitch;
// yawSlider.value = mappedYaw;
}
// Unified calibration function with conditions check
function $ebe3bd935c906b87$var$performCalibration() {
    // Check all alignment conditions before calibrating
    const rollValue = parseFloat(document.getElementById("rollSlider").value);
    const shouldersAligned = $ebe3bd935c906b87$var$areShouldersAligned($ebe3bd935c906b87$var$latestPoseResults?.poseLandmarks);
    if ($ebe3bd935c906b87$var$isAligned() && rollValue >= -0.2 && rollValue <= 0.2 && shouldersAligned) {
        if ($ebe3bd935c906b87$var$results && $ebe3bd935c906b87$var$results.faceLandmarks && $ebe3bd935c906b87$var$latestPoseResults && $ebe3bd935c906b87$var$latestPoseResults.poseLandmarks) {
            // Calibrate pose landmarks
            $ebe3bd935c906b87$var$calibrationData.poseLandmarks = $ebe3bd935c906b87$var$latestPoseResults.poseLandmarks.map((landmark)=>({
                    ...landmark
                }));
            // Calibrate face landmarks (store all detected facial landmarks)
            $ebe3bd935c906b87$var$calibrationData.faceLandmarks = $ebe3bd935c906b87$var$results.faceLandmarks[0].map((landmark)=>({
                    ...landmark
                }));
            // Calibrate blendshapes
            if ($ebe3bd935c906b87$var$results.faceBlendshapes) $ebe3bd935c906b87$var$calibrationData.faceBlendshapes = $ebe3bd935c906b87$var$results.faceBlendshapes.map((blendshape)=>({
                    ...blendshape
                }));
            // Calibrate roll
            $ebe3bd935c906b87$var$calibrationData.roll = rollValue;
            console.log("Calibration completed:", $ebe3bd935c906b87$var$calibrationData);
            $ebe3bd935c906b87$var$recordToggle.disabled = false; // Enable recording after calibration
        } else console.log("Calibration failed: Required data not available.");
    } else console.log("Calibration failed: Alignment conditions not met.");
}
// Update the existing calibration button event listener to use the new unified function
// calibrationButton.addEventListener('click', performCalibration);
let $ebe3bd935c906b87$var$isCalibrated = false;
document.getElementById("calibrationButton").addEventListener("click", function() {
    $ebe3bd935c906b87$var$performCalibration();
    $ebe3bd935c906b87$var$isCalibrated = true;
// console.log('Calibration button clicked');
});
// Rec helpers
const $ebe3bd935c906b87$var$recordToggle = document.getElementById("recordToggle");
// Disable the recordToggle button initially (enable after calibration)
// recordToggle.disabled = true; //TODO: uncomment when deploying
// Attach an event listener to the record button
$ebe3bd935c906b87$var$recordToggle.addEventListener("click", ()=>{
    const recording = (0, $09f012c82826b8a2$export$5277130cac3e825)();
    $ebe3bd935c906b87$var$recordToggle.textContent = recording ? "Stop Recording" : "Start Recording";
    $ebe3bd935c906b87$var$recordToggle.style.backgroundColor = recording ? "#fae" : "#f0f0f0";
    if (!recording) {
        console.log("Recording stopped, saving data...");
        // saveRecordedData();  // Save data when recording stops
        (0, $09f012c82826b8a2$export$9b908b4647579eb5)((0, $57d1b30337fe6afc$export$3ee672b42e56aad7), (0, $57d1b30337fe6afc$export$39ee952be8b072ed));
    } else console.log("Recording started...");
});
///////////////////////////////////////////////
///////////////////////////////////////////////
let $ebe3bd935c906b87$var$previousLandmarks = null;
let $ebe3bd935c906b87$var$previousVelocity = null;
let $ebe3bd935c906b87$var$jitterSum = 0;
let $ebe3bd935c906b87$var$frameCount = 0;
const $ebe3bd935c906b87$var$maxFrames = 10; // A smaller window to detect short-term jittery motion
function $ebe3bd935c906b87$var$detectRealTimePoorLighting(currentLandmarks, jitterThreshold = 0.2, velocityThreshold = 0.05) {
    // Validate input landmarks
    if (!Array.isArray(currentLandmarks) || currentLandmarks.length === 0) {
        console.warn("Invalid current landmarks data for lighting detection, skipping frame.");
        return false;
    }
    // Initialize previousLandmarks and velocity if not already set
    if (!$ebe3bd935c906b87$var$previousLandmarks) {
        $ebe3bd935c906b87$var$previousLandmarks = currentLandmarks.map((landmark)=>({
                ...landmark
            }));
        $ebe3bd935c906b87$var$previousVelocity = Array(currentLandmarks.length).fill(0);
        return false;
    }
    let totalVelocity = 0;
    let totalJitter = 0;
    let validLandmarkCount = 0;
    for(let i = 0; i < currentLandmarks.length; i++){
        const current = currentLandmarks[i];
        const previous = $ebe3bd935c906b87$var$previousLandmarks[i];
        // Check for valid landmark data
        if (!current || !previous || isNaN(current.x) || isNaN(current.y) || isNaN(previous.x) || isNaN(previous.y)) {
            console.warn(`Invalid landmark detected at index ${i}, skipping.`);
            continue;
        }
        // Calculate Euclidean distance between current and previous positions for each landmark
        const dx = current.x - previous.x;
        const dy = current.y - previous.y;
        const dz = (current.z || 0) - (previous.z || 0); // Use z if available, default to 0 if not
        const distance = Math.sqrt(dx * dx + dy * dy + dz * dz);
        // Accumulate velocity
        totalVelocity += distance;
        validLandmarkCount++;
        // Detect rapid changes in velocity as jitter
        if (distance > velocityThreshold && distance < jitterThreshold) totalJitter += distance;
    }
    // If no valid landmarks are found, skip this frame
    if (validLandmarkCount === 0) {
        console.warn("No valid landmarks detected for lighting detection, skipping frame.");
        return false;
    }
    // Calculate average velocity and average jitter for the current frame
    const averageVelocity = totalVelocity / validLandmarkCount;
    const averageJitter = totalJitter / validLandmarkCount;
    // Update running jitter sum and frame count
    $ebe3bd935c906b87$var$jitterSum += averageJitter;
    $ebe3bd935c906b87$var$frameCount++;
    // Calculate the running average jitter over the last `maxFrames` frames
    if ($ebe3bd935c906b87$var$frameCount >= $ebe3bd935c906b87$var$maxFrames) {
        const runningAverageJitter = $ebe3bd935c906b87$var$jitterSum / $ebe3bd935c906b87$var$frameCount;
        // Reset counters to calculate a new running average
        $ebe3bd935c906b87$var$jitterSum = 0;
        $ebe3bd935c906b87$var$frameCount = 0;
        // Update previous landmarks for the next frame
        $ebe3bd935c906b87$var$previousLandmarks = currentLandmarks.map((landmark)=>({
                ...landmark
            }));
        // Compare running average jitter to threshold
        return runningAverageJitter > jitterThreshold;
    }
    // Update previous landmarks for the next frame
    $ebe3bd935c906b87$var$previousLandmarks = currentLandmarks.map((landmark)=>({
            ...landmark
        }));
    // If not enough frames collected yet, don't flag poor lighting
    return false;
}
///////////////////////////////////////////////
/////////// Initialization ////////////////////
///////////////////////////////////////////////
if ($ebe3bd935c906b87$var$hasGetUserMedia()) {
    $ebe3bd935c906b87$var$getCameraDevices(); // Populate camera dropdown on load
    $ebe3bd935c906b87$var$startTrackingCheckbox.addEventListener("change", $ebe3bd935c906b87$var$toggleTracking); // Add event listener to tracking checkbox
    $ebe3bd935c906b87$var$showWebcamCheckbox.addEventListener("change", $ebe3bd935c906b87$var$toggleWebcamVisibility); // Add event listener to show webcam checkbox
} else console.warn("getUserMedia() is not supported by your browser");
// Show or hide the webcam video element based on checkbox state
function $ebe3bd935c906b87$var$toggleWebcamVisibility(event) {
    $ebe3bd935c906b87$var$video.style.display = event.target.checked ? "block" : "none";
}
///////////////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////////////
document.addEventListener("keydown", (event)=>{
    const parenthesisShapeLeft = document.getElementById("parenthesisShapeLeft");
    const parenthesisShapeRight = document.getElementById("parenthesisShapeRight");
    if (event.key === "ArrowLeft") {
        // Show the left parenthesis-like shape
        parenthesisShapeLeft.style.opacity = "1";
        parenthesisShapeLeft.style.border = "5px solid rgba(44, 106, 253)"; // Blue for left
        parenthesisShapeLeft.style.borderRadius = "75px 0 0 75px"; // Left-facing parenthesis
        parenthesisShapeLeft.style.borderRight = "none"; // Hide right border
        // Hide right parenthesis
        parenthesisShapeRight.style.opacity = "0"; // Hide the right shape
    } else if (event.key === "ArrowRight") {
        // Show the right parenthesis-like shape
        parenthesisShapeRight.style.opacity = "1";
        parenthesisShapeRight.style.border = "5px solid yellow"; // Yellow for right
        parenthesisShapeRight.style.borderRadius = "0 75px 75px 0"; // Right-facing parenthesis
        parenthesisShapeRight.style.borderLeft = "none"; // Hide left border
        // Hide left parenthesis
        parenthesisShapeLeft.style.opacity = "0"; // Hide the left shape
    }
    // Hide the visual feedback after a delay (e.g., 500ms)
    clearTimeout(parenthesisShapeLeft.hideTimeout); // Clear any existing hide timer
    clearTimeout(parenthesisShapeRight.hideTimeout); // Clear existing hide timer for right
    parenthesisShapeLeft.hideTimeout = setTimeout(()=>{
        parenthesisShapeLeft.style.opacity = "0"; // Hide left shape again
    }, 125); // Delay before hiding again (in milliseconds)
    parenthesisShapeRight.hideTimeout = setTimeout(()=>{
        parenthesisShapeRight.style.opacity = "0"; // Hide right shape again
    }, 125); // Delay before hiding again (in milliseconds)
});
///////////////////////////////////////////////
///////////////////////////////////////////////
// Event listener for startTracking to auto-check showTracking
$ebe3bd935c906b87$var$startTrackingCheckbox.addEventListener("change", (event)=>{
    if (event.target.checked) $ebe3bd935c906b87$var$enableDrawingCheckbox.checked = true;
    else if (!event.target.checked) {
        $ebe3bd935c906b87$var$enableDrawingCheckbox.checked = false;
        $ebe3bd935c906b87$var$showWebcamCheckbox.checked = false;
    }
});




// init them
$b7b11709569bdbef$export$b3571188c770cc5a();
console.log(`p5.js ${(0, (/*@__PURE__*/$parcel$interopDefault($5b38727783012434$exports))).VERSION}`);
const $54b47fc030b7b21e$var$midi = new (0, $28735cb37928c976$exports.Midi)();
console.log((0, $4oKKP.WebMidi).inputs);
// ----------------------------
////////////////////////
// Main script helpers
////////////////////////
function $54b47fc030b7b21e$var$openInNewWindow(url) {
    window.open(url, "_blank", "width=800,height=700");
}
function $54b47fc030b7b21e$var$handlePlaybackClick(url) {
    // console.log('Opening URL:', url);
    $54b47fc030b7b21e$var$openInNewWindow(url);
}
// Attach event listener when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", ()=>{
    document.getElementById("playButton").addEventListener("click", function() {
        $54b47fc030b7b21e$var$handlePlaybackClick("./playback.html");
    });
    document.getElementById("infoButton").addEventListener("click", function() {
        $54b47fc030b7b21e$var$handlePlaybackClick("./info.html");
    });
}); // IN5060/src/playback.html
 // IN5060/src/js/main.js


//# sourceMappingURL=index.529b9c04.js.map
